module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 274);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.initData = exports.HeaderContext = void 0;
var react_1 = __webpack_require__(0);
var storage_1 = __webpack_require__(58);
exports.HeaderContext = (0, react_1.createContext)({});
var lang_config_1 = __webpack_require__(40);
var langList_1 = __webpack_require__(68);
var lang = (0, storage_1.getLocalStorage)('lang');
var noDisplayLocales = lang_config_1.excludeLangList;
// 折算货币展示内容
// const localRate = '' || getLocalStorage('exchangeRate')?.split('/')[0];
exports.initData = {
    active: 'exchange',
    localRate: '',
    hostname: 'www.huobi.com',
    platform: 'global',
    locale: lang || 'zh-cn',
    locales: langList_1.localList,
    // conversionCurrency?: string[];
    noDisplayLocales: noDisplayLocales,
    // 是否已经初始化pro-token
    hasProToken: false,
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(69);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(155)();
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(378)["default"];

var assertThisInitialized = __webpack_require__(2);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(379);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/*! js-cookie v3.0.1 | MIT */
;
(function (global, factory) {
   true ? module.exports = factory() :
  undefined;
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = void 0;
var react_1 = __webpack_require__(0);
var i18n_js_1 = __importDefault(__webpack_require__(38));
var context_1 = __webpack_require__(7);
function useTranslation() {
    var _a = (0, react_1.useContext)(context_1.HeaderContext), globalState = _a.globalState, dispatch = _a.dispatch;
    var locale = globalState.locale;
    var tt = function (key) {
        return (0, i18n_js_1.default)(key, locale, 'en-us');
    };
    return {
        t: tt,
        i18n: {
            changeLanguage: function (lang, callback) {
                dispatch({
                    type: 'update:locale',
                    locale: lang,
                });
                callback(null, tt);
            },
        },
    };
}
exports.useTranslation = useTranslation;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/
(function () {
	'use strict';

	var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
	var isCommonjs =  true && module.exports;

	var fn = (function () {
		var val;

		var fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// New WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// Old WebKit
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];

		var i = 0;
		var l = fnMap.length;
		var ret = {};

		for (; i < l; i++) {
			val = fnMap[i];
			if (val && val[1] in document) {
				for (i = 0; i < val.length; i++) {
					ret[fnMap[0][i]] = val[i];
				}
				return ret;
			}
		}

		return false;
	})();

	var eventNameMap = {
		change: fn.fullscreenchange,
		error: fn.fullscreenerror
	};

	var screenfull = {
		request: function (element, options) {
			return new Promise(function (resolve, reject) {
				var onFullScreenEntered = function () {
					this.off('change', onFullScreenEntered);
					resolve();
				}.bind(this);

				this.on('change', onFullScreenEntered);

				element = element || document.documentElement;

				var returnPromise = element[fn.requestFullscreen](options);

				if (returnPromise instanceof Promise) {
					returnPromise.then(onFullScreenEntered).catch(reject);
				}
			}.bind(this));
		},
		exit: function () {
			return new Promise(function (resolve, reject) {
				if (!this.isFullscreen) {
					resolve();
					return;
				}

				var onFullScreenExit = function () {
					this.off('change', onFullScreenExit);
					resolve();
				}.bind(this);

				this.on('change', onFullScreenExit);

				var returnPromise = document[fn.exitFullscreen]();

				if (returnPromise instanceof Promise) {
					returnPromise.then(onFullScreenExit).catch(reject);
				}
			}.bind(this));
		},
		toggle: function (element, options) {
			return this.isFullscreen ? this.exit() : this.request(element, options);
		},
		onchange: function (callback) {
			this.on('change', callback);
		},
		onerror: function (callback) {
			this.on('error', callback);
		},
		on: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.addEventListener(eventName, callback, false);
			}
		},
		off: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.removeEventListener(eventName, callback, false);
			}
		},
		raw: fn
	};

	if (!fn) {
		if (isCommonjs) {
			module.exports = {isEnabled: false};
		} else {
			window.screenfull = {isEnabled: false};
		}

		return;
	}

	Object.defineProperties(screenfull, {
		isFullscreen: {
			get: function () {
				return Boolean(document[fn.fullscreenElement]);
			}
		},
		element: {
			enumerable: true,
			get: function () {
				return document[fn.fullscreenElement];
			}
		},
		isEnabled: {
			enumerable: true,
			get: function () {
				// Coerce to boolean in case of old WebKit
				return Boolean(document[fn.fullscreenEnabled]);
			}
		}
	});

	if (isCommonjs) {
		module.exports = screenfull;
	} else {
		window.screenfull = screenfull;
	}
})();


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(80);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "getHost", function() { return /* binding */ getHost; });
__webpack_require__.d(__webpack_exports__, "getLocale", function() { return /* binding */ getLocale; });
__webpack_require__.d(__webpack_exports__, "getUrl", function() { return /* binding */ getUrl; });

// CONCATENATED MODULE: ../config/urlRules.js
/* harmony default export */ var urlRules = ({
    // 矿池账户
    pow({path, host, locale}) {
        return `//${host}/${path.replace(/^\//, '')}${path.indexOf('?') != -1 ? '&' : '?'}lang=${locale}`;
    },
    // support公告
    support({path, host, locale}) {
        return `//${host}/support/${locale}/${path.replace(/^\//, '')}`;
    },
    // itoken({locale}) {
    //     if (locale === "zh") {
    //         return "https://api.huobiwalletapi.com/shence_api/t/5o";
    //     } else if (locale === "tw") {
    //         return "https://api.huobiwalletapi.com/shence_api/t/Yo";
    //     } else {
    //         return "https://api.huobiwalletapi.com/shence_api/t/go";
    //     }
    // },
    twitter({locale, path}) {
        if (locale === 'zh-hk' || locale === 'zh-tc' || locale === 'zh-tw') {
            return 'https://twitter.com/HuobiGlobalzh'
        } else {
            return path
        }
    },
    facebook({locale, path}) {
        if (locale === 'zh-hk' || locale === 'zh-tc' || locale === 'zh-tw') {
            return 'https://www.facebook.com/HuobiChinese'
        } else {
            return path
        }
    },
    telegram({locale, path}) {
        if (locale === 'zh-hk' || locale === 'zh-tc' || locale === 'zh-tw') {
            return 'https://t.me/HuobiGlobal_zw'
        } else {
            return path
        }
    },
    // 漏洞赏金
    hackenproof({ path}) {
        return 'https://hackenproof.com' + path
    }
});
// EXTERNAL MODULE: ../config/locales.json
var locales = __webpack_require__(21);

// EXTERNAL MODULE: ../config/domain.json
var domain = __webpack_require__(56);

// CONCATENATED MODULE: ../utils/url.js
/**
 * 设计目标
 * 通过平台进行地址拼接
 * 配置平台路由domain白名单
 * 通过 平台/子路径 配置语言包，防止跳转到404
 */

/**
 * 平台配置项
 * 1. domain替换规则
 * 2. 默认语言包
 * 3. 路径扩展语言包
 * 4. 语言包映射
 */

// 语言包配置




/**
 * 根据 hostname 获取对应的域名列表
 *
 * @param {string} [hostname=location.hostname] 域名，SSR 时必须配置 hostname 属性值
 * @return {Object} {globa, otc, account, dm}
 */
const getHostname = (hostname) => {
    // if (!hostname && location) {
    //     hostname = location.hostname;
    // }
    if (!hostname) {
        try {
            hostname = (location && location.hostname) || 'www.huobi.com'
        }catch(e) {
            hostname = 'www.huobi.com'
        }
    }

    let target = domain[0];

    domain.some((item) => {
        if (
            Object.keys(item)
                .map((key) => item[key])
                .indexOf(hostname) > -1
        ) {
            target = item;
            return true;
        }

        return false;
    });

    if (/^localhost/.test(hostname)) {
        return {
            global: hostname,
            support: hostname,
            otc: hostname,
            institution: hostname,
            account: hostname,
            eco: hostname,
            dm: hostname,
            futures: hostname,
            pool: hostname,
            broker: hostname,
            m: hostname,
            kyc: hostname,
            // 火币Defi Labs
            defilabs: 'www.huobidefilabs.io',
            // 火币生态链
            chain: 'www.hecochain.com',
            // OTC交易系统
            brokerage: `www.huobi-brokerage.com`,
            // 火币云
            cloud: 'www.huobicloud.com',
            // itoken
            itoken: 'www.itoken.com',
            // 集团
            group: 'www.huobigroup.com',
            nft: 'apenft.io',
            custody: hostname,
            // htxdao
            htxdao: 'www.htxdao.com',
            square: 'square.htx.com'
        }
    }

    const topDomain = hostname.split(".").slice(1).join(".");
    const m = hostname.replace(
        /pro-web|www|c2c|otc|dm|account|broker|futures|pool|kyc/,
        "m"
    );
    if (topDomain) {
        return {
            global: `www.${topDomain}`,
            support: `www.${topDomain}`,
            otc: `www.${topDomain}`,
            institution: `www.${topDomain}`,
            account: `www.${topDomain}`,
            eco: `eco.${topDomain}`,
            dm: `dm.${topDomain}`,
            futures: `futures.${topDomain}`,
            pool: `pool.${topDomain}`,
            broker: `broker.${topDomain}`,
            m,
            kyc: `www.${topDomain}`,
            defilabs: 'www.huobidefilabs.io',
            chain: 'www.hecochain.com',
            brokerage: `www.huobi-brokerage.com`,
            cloud: 'www.huobicloud.com',
            itoken: 'www.itoken.com',
            group: 'www.huobigroup.com',
            nft: 'apenft.io',
            custody: `custody.${topDomain}`,
            htxdao: 'www.htxdao.com',
            square: 'square.htx.com',
        };
    }

    return {
        global: target.global,
        support: target.global,
        otc: target.otc,
        institution: target.institution,
        account: target.account || target.uc,
        eco: target.eco,
        dm: target.dm,
        futures: target.futures,
        pool: target.pool,
        broker: target.broker,
        m,
        kyc: target.kyc,
        defilabs: 'www.huobidefilabs.io',
        chain: 'www.hecochain.com',
        brokerage: target.brokerage,
        cloud: 'www.huobicloud.com',
        itoken: 'www.itoken.com',
        group: 'www.huobigroup.com',
        nft: 'www.apenft.io',
        custody: target.custody,
        htxdao: 'www.htxdao.com',
        square: 'square.htx.com',
    };
};

/**
 * 获取平台地址
 * @param {*} platform 业务线名称，用于获取业务线支持的域名列表
 */
function getHost({platform, hostname}) {
    return getHostname(hostname)[platform]
}

/**
 * 根据业务线获取语言，主要处理业务线之间的语言兼容别名问题
 *
 * @param {Object} opts 配置参数
 * @param {string} opts.locale 目标语言
 * @param {string} opts.platform 业务线名称
 * @return {string} 如果没有配置 alias 字段，则返回 locale
 */
const getLocaleAlias = ({ locale = "", platform = "" } = {}) => {
    // 处理语言别名
    if (
        locales.alias[platform] &&
        locales.alias[platform].hasOwnProperty(locale)
    ) {
        locale = locales.alias[platform][locale];
    }else if (platform === 'nft' || platform === 'square') {
        locale = '';
    }

    return locale;
};

/**
 * 获取业务线支持的语言，主要处理跳外链的一些语言兼容问题，如果没有配置，则返回空字符
 *
 * @param {Object} opts 配置参数
 * @param {string} opts.locale 目标语言
 * @param {string} opts.platform 业务线名称
 * @return {string} 尝试读取 locales.support 配置字段，如果不存在该列表里时优先使用 support[0]
 */
const getSupportLocale = ({ locale = "", platform = "" } = {}) => {
    if (
        Array.isArray(locales.support[platform]) &&
        locales.support[platform].length &&
        locales.support[platform].indexOf(locale) === -1
    ) {
        locale = locales.support[platform][0];
    }
    return locale;
};

// 获取平台对应的语言包name
function getLocale({platform, locale}) {
    // 获取支持的语种
    let support = getSupportLocale({platform, locale});

    // 获取语言包别名
    support = getLocaleAlias({platform, locale: support});
    return support
}

/**
 * 使用场景受限，域名仅支持huobi.xx下使用
 * 需要支持本地开发模式，非huobi.com给出默认地址
 */
function getUrl({path = '/', platform = 'global', locale = 'en-us', hostname = location.hostname}) {
    // get domain
    let finalHost = getHost({platform, hostname});

    // futures host
    if(platform === 'global' && finalHost !== 'www.huobi.com' && finalHost !== 'www.htx.com' && /^\/futures/.test(path)){
        try{
            // let _host = location ? location.hostname : hostname
            finalHost = finalHost.replace('www', 'futures')
        }catch(err){
            console.error(err)
        }
    }
    // get locale
    const finalLocale = getLocale({platform, locale});

    // 配置了对应平台的拼接规范
    if (urlRules[platform]) {
        return urlRules[platform]({
            path,
            host: finalHost,
            locale: finalLocale
        })
    }
    return `//${finalHost}${finalLocale ? ('/' + finalLocale) : '' }/${path.replace(/^\//, '')}`;
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(127)
var ieee754 = __webpack_require__(128)
var isArray = __webpack_require__(94)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90);
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(ua_parser_js__WEBPACK_IMPORTED_MODULE_1__);



/**
 * @description utils帮助类
 * @author luzhaojian
 * @date 2023-09-02
 * @class Utils
 */
class Utils {
    /**
     * @description 判断一个对象是否为空对象
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} object
     * @memberof Utils
     */
    isEmptyObject(obj) {
        return Object.keys(obj).length === 0;
    }

    /**
     * @description 类型校验
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @param {*} type
     * @returns {boolean}
     * @memberof Utils
     */
    isType(obj, type) {
        let typeName = this.toPascalCase(type);
        return this.getTypeName(obj) === typeName;
    }

    /**
     * @description 校验是否object类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isObject(obj) {
        return this.isType(obj, "Object");
    }

    /**
     * @description 校验是否String类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isString(obj) {
        return this.isType(obj, "String");
    }

    /**
     * @description 校验是否Function类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isFunction(obj) {
        return this.isType(obj, "Function");
    }

    /**
     * @description 校验是否Array类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isArray(obj) {
        return this.isType(obj, "Array");
    }

    /**
     * @description 校验是否Null类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isNull(obj) {
        return this.isType(obj, "Null");
    }

    /**
     * @description 校验是否Undefined类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isUndefined(obj) {
        return this.isType(obj, "Undefined");
    }

    /**
     * @description 校验是否Number类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isNumber(obj) {
        return this.isType(obj, "Number");
    }

    /**
     * @description 校验是否Date类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isDate(obj) {
        return this.isType(obj, "Date");
    }

    /**
     * @description 校验是否Boolean类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns {boolean}
     * @memberof Utils
     */
    isBoolean(obj) {
        return this.isType(obj, "Boolean");
    }

    /**
     * @description 获取具体类型
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} obj
     * @returns
     * @memberof Utils
     */
    getTypeName(obj) {
        let typeName = Object.prototype.toString.call(obj).toString();
        typeName = typeName.substring(8).replace("]", "");
        return typeName;
    }

    /**
     * @description 处理大小写
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} str
     * @returns
     * @memberof Utils
     */
    toPascalCase(str) {
        if (str === undefined || str === null) {
            return "";
        } else {
            let strValue = str.toString();
            if (strValue.length > 1) {
                return `${strValue[0].toUpperCase()}${strValue.substring(1)}`;
            } else {
                return strValue.toUpperCase();
            }
        }
    }

    /**
     * @description 获取hostname
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} origin
     * @returns {*}
     * @memberof Utils
     */
    getHost(origin) {
        let hostName = "huobi.com";
        if (typeof window !== "undefined") {
            hostName = location.hostname;
            const isTest = !!location.hostname.match(/(global-test|global-base|localhost)-?/);
            // 非测试环境
            if (origin && !isTest) {
                const hostArr = hostName.split(".");
                hostArr.shift();
                return hostArr.join(".");
            }
        }
        return hostName;
    }

    /**
     * @description 依据key设置Cookie
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} key Cookie键
     * @param {*} val 值
     * @param {*} options 其他配置
     * @memberof Utils
     */
    setCookie(key, val, options) {
        if (options) {
            js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(key, val, options);
        } else {
            js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(key, val);
        }
    }

    /**
     * @description 依据key获取Cookie值
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} key Cookie键
     * @returns {*}
     * @memberof Utils
     */
    getCookie(key) {
        return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(key) || "";
    }

    /**
     * @description 删除cookie数据
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} [cks=[]] 要删除的cookie列表
     * @memberof Utils
     */
    removeCookies(cks = []) {
        if (typeof window !== "undefined") {
            const mydomain = location.hostname.replace(/(localhost|www)/, "");
            if (typeof cks === "string") {
                cks = [cks];
            }
            cks.forEach((item) => {
                js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(item);
                js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(item, { domain: this.getHost() });
                js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(item, { domain: this.getHost(1) });
                js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(item, { domain: mydomain, path: "/" });
                js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(item, { domain: `localhost${mydomain}` });
            });
        }
    }

    /**
     * @description 依据key移除localStorage中的值
     * @author luzhaojian
     * @date 2024-09-10
     * @param {*} list
     * @memberof Utils
     */
    removeStorageList(list) {
        if (typeof list === "string") {
            list = [list];
        }
        list.forEach((item) => {
            localStorage.removeItem(item);
        });
    }

    /**
     * @description 用户默认头像
     * @author luzhaojian
     * @date 2024-08-28
     * @memberof Utils
     */
    getUserIcon() {
        return "https://app-static-1306115679.file.myqcloud.com/nuwa/static/prod/1f6e2d36-e665-4447-b8fb-390fc7bcd243.png";
    }

    /**
     * @description 处理各个浏览器最低兼容版本
     * @author luzhaojian
     * @date 2024-11-28
     * @memberof Utils
     */
    getBrowser() {
        if (typeof window !== "undefined") {
            const { browser } = Object(ua_parser_js__WEBPACK_IMPORTED_MODULE_1__["UAParser"])();
            if (browser.name.toLowerCase() === "Safari".toLowerCase()) {
                return Number(browser.major) >= 16;
            } else if (browser.name.toLowerCase() === "Chrome".toLowerCase()) {
                return Number(browser.major) >= 108;
            }
            return true;
        }
        return true;
    }

    /**
     * @description 是否小域名
     * @author luzhaojian
     * @date 2024-11-28
     * @memberof Utils
     */
    getDomainName() {
        if (typeof window !== "undefined") {
            const { hostname } = location;
            if (hostname !== "www.htx.com" && hostname !== "localhost" && !hostname.includes("jp1.huobiapps.com")) {
                return true;
            }
            return false;
        }
        return false;
    }

    /**
     * @description 是否PC
     * @author luzhaojian
     * @date 2024-12-25
     * @returns {*}  {boolean}
     * @memberof Utils
     */
    isPC() {
        const userAgentInfo = navigator.userAgent;
        // pad算pc尺寸
        const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'rv:1.2.3.4', 'windows mobile', 'midp'];
        let flag = true;
        for (let v = 0; v < Agents.length; v += 1) {
            if (userAgentInfo.indexOf(Agents[v]) >= 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }
}

/* harmony default export */ __webpack_exports__["default"] = (new Utils());


/***/ }),
/* 21 */
/***/ (function(module) {

module.exports = JSON.parse("{\"alias\":{\"global\":{\"zh-tw\":\"zh-tc\"},\"dm\":{\"zh-tw\":\"zh-tc\"},\"account\":{\"zh-tw\":\"zh-tc\"},\"otc\":{\"zh-tc\":\"zh-tw\"},\"kr\":{\"zh-cn\":\"zh-CN\",\"en-us\":\"en-US\",\"ko-kr\":\"ko-KR\"},\"pow\":{\"zh-cn\":\"cn\",\"en-us\":\"en\"},\"itoken\":{\"zh-cn\":\"zh\",\"en-us\":\"en\",\"zh-tc\":\"tw\",\"zh-tw\":\"tw\",\"es-es\":\"es\",\"ru-ru\":\"ru\",\"vi-vi\":\"vi\",\"id-id\":\"id\"},\"wallet\":{\"en-us\":\"en\",\"zh-cn\":\"zh\",\"ko-kr\":\"ko\",\"ja-jp\":\"ja\",\"ru-ru\":\"ru\"},\"zendesk\":{\"zh-tc\":\"zh-tw\",\"ko-kr\":\"ko\",\"ja-jp\":\"ja\",\"ru-ru\":\"ru\",\"uk-ua\":\"uk\",\"de-de\":\"de\",\"es-es\":\"es\",\"fr-fr\":\"fr\",\"th-th\":\"th\",\"tr-tr\":\"tr\",\"vi-vi\":\"vi\",\"pt-pt\":\"pt\",\"pt-br\":\"pt\"},\"group\":{\"en-us\":\"\",\"zh-tc\":\"zh-cn\",\"zh-tw\":\"zh-cn\"},\"coinmarketcap\":{\"en-us\":\"\",\"zh-cn\":\"zh\",\"zh-tc\":\"zh-tw\",\"ko-kr\":\"ko\",\"ru-ru\":\"ru\",\"de-de\":\"de\",\"fr-fr\":\"fr\",\"es-es\":\"es\",\"tr-tr\":\"tr\",\"vi-vi\":\"vi\",\"pt-pt\":\"pt-br\",\"th-th\":\"\"},\"clingecko\":{\"en-us\":\"en/exchanges\",\"zh-cn\":\"zh/exchanges\",\"zh-tc\":\"zh-tw/交易平台\",\"zh-tw\":\"zh-tw/交易平台\",\"ko-kr\":\"ko/거래소\",\"ru-ru\":\"ru/обмен\",\"de-de\":\"de/börsen\",\"fr-fr\":\"fr/platesformes\",\"es-es\":\"es/intercambios\",\"tr-tr\":\"tr/borsalar\",\"vi-vi\":\"vi/san_giao_dich\",\"pt-pt\":\"pt/câmbios\",\"pt-br\":\"pt/câmbios\"},\"apidoc\":{\"en-us\":\"en\",\"zh-cn\":\"cn\"},\"eco\":{\"zh-cn\":\"\",\"en-us\":\"en-index.html\",\"zh-tc\":\"en-index.html\",\"zh-tw\":\"en-index.html\",\"ko-kr\":\"en-index.html\",\"ru-ru\":\"en-index.html\",\"de-de\":\"en-index.html\",\"fr-fr\":\"en-index.html\",\"es-es\":\"en-index.html\",\"tr-tr\":\"en-index.html\",\"vi-vi\":\"en-index.html\",\"pt-pt\":\"en-index.html\",\"pt-br\":\"en-index.html\"},\"mena\":{\"zh-tc\":\"zh-tw\"},\"defilabs\":{\"en-us\":\"en\",\"zh-cn\":\"zh\"},\"brokerage\":{\"zh-cn\":\"zh-tc\",\"zh-tw\":\"en-us\",\"ko-kr\":\"en-us\",\"ru-ru\":\"en-us\",\"de-de\":\"en-us\",\"fr-fr\":\"en-us\",\"es-es\":\"en-us\",\"es-la\":\"en-us\",\"tr-tr\":\"en-us\",\"vi-vi\":\"en-us\",\"pt-br\":\"en-us\",\"pt-pt\":\"en-us\",\"it-it\":\"en-us\",\"nl-nl\":\"en-us\",\"ms-my\":\"en-us\",\"en-in\":\"en-us\",\"uk-ua\":\"en-us\",\"hi-in\":\"en-us\",\"id-id\":\"en-us\",\"th-th\":\"en-us\"},\"chain\":{\"en-us\":\"en-us\",\"zh-tc\":\"tc\",\"zh-tw\":\"tc\",\"ko-kr\":\"KR\",\"ru-ru\":\"RU\",\"vi-vi\":\"VN\",\"tr-tr\":\"TR\"}},\"support\":{\"itoken\":[\"zh-cn\",\"en-us\",\"zh-tc\",\"zh-tw\",\"es-es\",\"ru-ru\",\"vi-vi\",\"id-id\"],\"kr\":[\"ko-kr\",\"zh-cn\",\"en-us\"],\"pow\":[\"en-us\",\"zh-cn\"],\"chat\":[\"en-us\",\"zh-cn\"],\"wallet\":[\"en-us\",\"zh-cn\",\"ko-kr\",\"ja-jp\",\"ru-ru\"],\"cloud\":[\"en-us\",\"zh-cn\"],\"chain\":[\"en-us\",\"zh-tc\",\"zh-tw\",\"ko-kr\",\"ru-ru\",\"vi-vi\",\"tr-tr\"],\"defilabs\":[\"en-us\",\"zh-cn\"],\"group\":[\"en-us\",\"zh-cn\",\"zh-tw\",\"zh-tc\"],\"coinmarketcap\":[\"en-us\",\"zh-cn\",\"zh-tc\",\"zh-tw\",\"ko-kr\",\"ru-ru\",\"de-de\",\"fr-fr\",\"es-es\",\"tr-tr\",\"vi-vi\",\"pt-pt\",\"th-th\"],\"clingecko\":[\"en-us\",\"zh-cn\",\"zh-tc\",\"zh-tw\",\"ko-kr\",\"ru-ru\",\"de-de\",\"fr-fr\",\"es-es\",\"tr-tr\",\"vi-vi\",\"pt-pt\",\"pt-br\"],\"apidoc\":[\"en-us\",\"zh-cn\"],\"eco\":[\"en-us\",\"zh-cn\"],\"mena\":[\"en-us\",\"zh-tc\",\"zh-tw\",\"zh-cn\",\"ko-kr\"]}}");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useBaseURL = void 0;
var react_1 = __webpack_require__(0);
var url_js_1 = __webpack_require__(18);
function useBaseURL(hostname) {
    var url = (0, react_1.useMemo)(function () {
        var isBrowser = typeof window !== 'undefined';
        if (hostname && isBrowser) {
            var host = (0, url_js_1.getHost)({
                platform: 'global',
                hostname: hostname,
            });
            var tmpUrl = "".concat(location.protocol, "//").concat(host);
            if (location.hostname === 'localhost' || 'development' === "production") {
                tmpUrl = location.origin;
            }
            return tmpUrl;
        }
    }, [hostname]);
    return [url];
}
exports.useBaseURL = useBaseURL;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ../node_modules/js-cookie/dist/js.cookie.js
var js_cookie = __webpack_require__(13);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ../utils/rest.alias.js


class rest_alias_RestAlias {
    constructor(baseUrl = "", locale = "en-us") {
        this._baseUrl = baseUrl.replace(/c2c|otc|dm|account|broker|futures|pool|kyc/, "www");
        this._lang = locale; // 当前语言
    }

    /**
     * @description 获取cookie值
     * @author luzhaojian
     * @date 2023-09-02
     * @param {*} strKey key
     * @memberof RestAlias
     */
    getCookie(strKey) {
        return js_cookie_default.a.get(strKey) || "";
    }

    getLang(lang) {
        return lang.replace(/\-\w{2}/, (key) => key.toUpperCase());
    }

    handleAe(url) {
        if (typeof window !== "undefined") {
            url = location.origin.includes("futures") ? `${url.replace("www", "futures")}` : `${url}`;
        }
        return `${url}/-/x/ae`;
    }

    /**
     * @description 处理U本位合约请求域名
     * @author luzhaojian
     * @date 2024-05-20
     * @param {*} url
     * @memberof RestAlias
     */
    handleLinear(url) {
        if (typeof window !== "undefined") {
            const origin = location.origin;
            if (origin.includes("futures")) {
                url = `${url.replace("www.", "futures.")}/linear-swap-order/x`;
            } else if (
                origin.includes("localhost") ||
                origin.includes("huobiapps.com") ||
                origin === "https://www.htx.com"
            ) {
                url = `${url.replace("futures.", "www.")}/futures/api/linear-swap-order/x`;
            } else {
                // 国内域名
                url = `${url}/-/x/linear-swap-order/x`;
            }
        }
        return `${url}`;
    }

    /**
     * @description 处理币本位交割请求域名
     * @author luzhaojian
     * @date 2024-05-20
     * @param {*} url
     * @memberof RestAlias
     */
    handleContract(url) {
        if (typeof window !== "undefined") {
            const origin = location.origin;
            if (origin.includes("futures")) {
                url = `${url.replace("www.", "futures.")}/contract-order/x/`;
            } else if (
                origin.includes("localhost") ||
                origin.includes("huobiapps.com") ||
                origin === "https://www.htx.com"
            ) {
                url = `${url.replace("futures.", "www.")}/futures/api/contract-order/x/`;
            } else {
                // 国内域名
                url = `${url}/-/x/dm`;
            }
        }
        return `${url}`;
    }

    /**
     * @description 处理币本位永续交割请求域名
     * @author luzhaojian
     * @date 2024-05-20
     * @param {*} url
     * @memberof RestAlias
     */
    handleSwap(url) {
        if (typeof window !== "undefined") {
            const origin = location.origin;
            if (origin.includes("futures")) {
                url = `${url.replace("www.", "futures.")}/swap-order/x`;
            } else if (
                origin.includes("localhost") ||
                origin.includes("huobiapps.com") ||
                origin === "https://www.htx.com"
            ) {
                url = `${url.replace("futures.", "www.")}/futures/api/swap-order/x`;
            } else {
                // 国内域名
                url = `${url}/-/x/dm/swap`;
            }
        }
        return `${url}`;
    }

    /**
     * @description 处理合约其他api请求域名
     * @author luzhaojian
     * @date 2024-05-20
     * @param {*} url
     * @memberof RestAlias
     */
    handleFutures(url) {
        if (typeof window !== "undefined") {
            const origin = location.origin;
            if (origin.includes("futures")) {
                url = `${url.replace("www.", "futures.")}`;
            } else if (
                origin.includes("localhost") ||
                origin.includes("huobiapps.com") ||
                origin === "https://www.htx.com"
            ) {
                url = `${url.replace("futures.", "www.")}/futures/api`;
            } else {
                // 国内域名
                url = `${url}/contract-api`;
            }
        }
        return `${url}`;
    }

    /**
     * @description 获取初始化数据
     * @author luzhaojian
     * @date 2023-09-02
     * @memberof RestAlias
     */
    getInit() {
        const that = this;
        const defaultConf = {
            "@uc/": {
                url: `${that._baseUrl}/-/x/uc/`,
                headers() {
                    let obj = {
                        'Huobi-App-Client': 3,
                        "HUOBI-BUSINESS": "PRO",
                        "Accept-Language": that._lang,
                    };
                    const HBUcToken = that.getCookie("HB-UC-TOKEN");
                    if (HBUcToken) {
                        obj["HB-UC-TOKEN"] = HBUcToken;
                    }
                    return obj;
                },
            },
            "@pro": {
                url: `${that._baseUrl}/-/x/pro`,
                headers() {
                    let obj = {
                        "HB-API-VERSION": "1.7",
                        "Accept-Language": that._lang,
                    };
                    const HBProToken = that.getCookie("HB-PRO-TOKEN");
                    if (HBProToken) {
                        obj["HB-PRO-TOKEN"] = HBProToken;
                    }
                    return obj;
                },
            },
            "@general/": {
                url: `${that._baseUrl}/-/x/general`,
                headers() {
                    const obj = {
                        "Accept-Language": that._lang,
                    };
                    return obj;
                },
            },
            "@hbg/": {
                url: `${that._baseUrl}/-/x/hbg`,
                headers() {
                    let obj = {
                        "HB-API-VERSION": "1.7",
                        "Accept-Language": that._lang,
                    };
                    const HBProToken = that.getCookie("HB-PRO-TOKEN");
                    if (HBProToken) {
                        obj["HB-PRO-TOKEN"] = HBProToken;
                    }
                    return obj;
                },
            },
            "@ae/": {
                url: that.handleAe(that._baseUrl),
                headers() {
                    let obj = {
                        "Accept-Language": that.getLang(that._lang),
                        "huobi-app-version": "web",
                    };
                    const HBProToken = that.getCookie("HB-PRO-TOKEN");
                    if (HBProToken) {
                        obj["HB-PRO-TOKEN"] = HBProToken;
                    }
                    return obj;
                },
            },
            "@market/": {
                url: `${that._baseUrl}/-/x/pro/market`,
                headers() {
                    return {
                        "Accept-Language": that.getLang(that._lang),
                    };
                },
            }, // U本位合约
            "@linear/": {
                url: that.handleLinear(that._baseUrl),
                headers() {
                    return {
                        "Accept-Language": that.getLang(that._lang),
                        source: "web",
                    };
                },
            }, // 币本位交割基础数据
            "@contract/": {
                url: that.handleContract(that._baseUrl),
                headers() {
                    return {
                        "Accept-Language": that.getLang(that._lang),
                        source: "web",
                    };
                },
            }, // 币本位永续
            "@swap/": {
                url: that.handleSwap(that._baseUrl),
                headers() {
                    return {
                        "Accept-Language": that.getLang(that._lang),
                        source: "web",
                    };
                },
            },
            "@futures/": {
                url: that.handleFutures(that._baseUrl),
                headers() {
                    return {
                        "Accept-Language": that.getLang(that._lang),
                        source: "web",
                    };
                },
            },
        };
        return defaultConf;
    }
}

/* harmony default export */ var rest_alias = (rest_alias_RestAlias);

// EXTERNAL MODULE: ../utils/utils.js
var utils = __webpack_require__(20);

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__(53);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../node_modules/@huobi-fed-global/fed-rest/dist/index.js
var dist = __webpack_require__(54);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ../utils/rest.js



const rest_axios = axios_default.a.create({
    timeout: 30000,
    headers: {
        post: {
            "Content-Type": "application/json;charset=UTF-8",
        },
    },
    emulateJSON: true,
    withCredentials: true,
});

/* harmony default export */ var rest = (new dist_default.a(rest_axios, {
    errMsg: "error",
    error(e, op) {
        console.log("error:", e, op);
    },
}));



// EXTERNAL MODULE: ../utils/tokens.js
var tokens = __webpack_require__(66);

// CONCATENATED MODULE: ../utils/rest.granting.js




/* 应用服务token*/
const baseToken = {
    uc(params) {
        return rest.get("@uc/uc/open/token/get", {
            params,
            restOptions: {
                reqInterceptorsIgnore: true,
                resInterceptorsIgnore: true,
            },
        });
    },
    pro(data) {
        return rest.post("@pro/v1/users/login", {
            ...data,
            restOptions: {
                reqInterceptorsIgnore: true,
                resInterceptorsIgnore: true,
            },
        });
    },
    getTicket() {
        return rest.get("@uc/uc/open/ticket/get", {
            restOptions: {
                resInterceptorsIgnore: true,
            },
        });
    },
};

const grantingOption = {
    ticketApi: baseToken.getTicket,
    cookieHost: utils["default"].getHost(1),
    afterGetTicket: (res) => {
        if (!res.success) {
            if ([512, 403].includes(res.code)) {
                utils["default"].removeCookies(tokens["removeList"]);
                localStorage.removeItem("UC_IS_LOGIN");
                setTimeout(() => {
                    location.reload();
                }, Math.floor(Math.random() * 3 * 1000));
            }
        }
    },
};

/* harmony default export */ var rest_granting = ({
    "@uc": () => {
        return { "HB-UC-TOKEN": utils["default"].getCookie("HB-UC-TOKEN") };
    },
    "@pro": (force) =>
        Object(dist["granting"])({
            ...grantingOption,
            cookieName: "HB-PRO-TOKEN",
            grantingApi: baseToken.pro,
            force,
        }),
    "@hbg": (force) =>
        Object(dist["granting"])({
            ...grantingOption,
            cookieName: "HB-PRO-TOKEN",
            grantingApi: baseToken.pro,
            force,
        }),
});

const beforeGranting = function () {
    if (typeof window !== 'undefined') {
        return !!+localStorage.getItem("UC_IS_LOGIN");
    }
};

// CONCATENATED MODULE: ../utils/httpReq.js




class httpReq_HttpRequest {
    constructor(baseUrl, locale) {
        // 构造实例
        if (!httpReq_HttpRequest.singletonInstance) {
            this._mainCode = [555, 10001];
            this._proCode = ["token-not-valid", "login-required", 1003, 1002];
            this._ucCode = [512, 403];
            this._otcCode = [401];
            this._dmCode = [1011];
            this._kycCode = [200013];

            this._baseUrl = baseUrl; // baseUrl
            this._lang = locale === "zh-tc" ? "zh-hk" : locale; // 当前语言
            // 初始化alias
            const alias = new rest_alias(baseUrl, this._lang).getInit();
            // fed-rest初始化配置
            rest.config({
                alias,
                granting: rest_granting,
                beforeGranting: beforeGranting,
                resInterceptorsCode: [
                    ...this._mainCode,
                    ...this._proCode,
                    ...this._ucCode,
                    ...this._otcCode,
                    ...this._dmCode,
                    ...this._kycCode,
                ],
            });

            // 将this挂载到HttpRequest类的singletonInstance属性上
            httpReq_HttpRequest.singletonInstance = this;
        }
        return httpReq_HttpRequest.singletonInstance;
    }

    /**
     * @description 检查uc登录态
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    checkLogin() {
        return rest.get("@uc/uc/open/login/check", {
            restOptions: {
                resInterceptorsIgnore: true,
            },
        });
    }

    /**
     * @description 获取安全策略
     * @author luzhaojian
     * @date 2024-11-29
     * @memberof HttpRequest
     */
    getSecurity() {
        return rest.get(`@uc/uc/open/security/get`);
    }

    /**
     * @description 退出
     * @author luzhaojian
     * @date 2023-09-02
     * @returns {*}
     * @memberof HttpRequest
     */
    ucLogout() {
        return rest.get("@uc/uc/open/logout", {
            restOptions: {
                reqInterceptorsIgnore: true,
            },
        });
    }

    /**
     * @description 查询现货收藏列表
     * @author luzhaojian
     * @date 2024-04-21
     * @memberof HttpRequest
     */
    getPairList(params) {
        return rest.get("@uc/uc/open/trading_pair/list", {
            params,
        });
    }

    /**
     * @description 查询合约收藏列表
     * @author luzhaojian
     * @date 2024-04-22
     * @memberof HttpRequest
     */
    getSwapPairList() {
        return rest.get(
            "@uc/uc/open/trading_pair/multiple/new_list?websites=CONTRACT&websites=CONTRACT_SWAP&websites=LINEAR_SWAP"
        );
    }

    /**
     * @description 添加收藏
     * @author luzhaojian
     * @date 2024-04-21
     * @param {*} data
     * @memberof HttpRequest
     */
    addPair(data) {
        return rest.post("@uc/uc/open/trading_pair/add", data);
    }

    /**
     * @description 取消收藏
     * @author luzhaojian
     * @date 2024-04-21
     * @param {*} data
     * @memberof HttpRequest
     */
    delPair(data) {
        return rest.post("@uc/uc/open/trading_pair/cancel", data);
    }

    /**
     * @description 获取菜单信息
     * @author luzhaojian
     * @date 2023-09-01
     * @param {*} params
     * @returns {*}
     * @memberof HttpRequest
     */
    getNavigationInfo(params) {
        return rest.get("@hbg/v1/hbg/myhome/navigation/infos", {
            params,
            headers: {
                "Accept-Language": this._lang,
            },
        });
    }

    /**
     * @description 获取ticket
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    getTicket() {
        return rest.get("@uc/uc/open/ticket/get", {
            options: {
                resInterceptorsIgnore: true,
            },
        });
    }

    /**
     * @description 通过ticket获取token
     * @author luzhaojian
     * @date 2023-09-01
     * @param {*} data
     * @returns {*}
     * @memberof HttpRequest
     */
    proLogin(data) {
        return rest.post("@pro/v1/users/login", data, {
            options: {
                interceptorsIgnore: true,
            },
        });
    }

    kvSet(data) {
        return rest.post("@uc/uc/open/kv_store/put", {
            ...data,
            website: "PRO",
        });
    }

    /**
     * @description 获取用户信息
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    getUserInfo() {
        return rest.get("@uc/uc/open/user/get");
    }

    /**
     * @description 获取账号切换入口，是否开启
     * @author luzhaojian
     * @date 2024-08-29
     * @returns {*}
     * @memberof HttpRequest
     */
    getSwitchAccountState() {
        return rest.get("@uc/uc/open/sub_account/switch_account_abtest");
    }

    /**
     * @description 获取账号切换的账号列表
     * @author luzhaojian
     * @date 2024-08-28
     * @memberof HttpRequest
     */
    getSwitchAccountList(data) {
        return rest.post("@uc/uc/open/switch_account_list", data);
    }

    /**
     * @description 删除账户
     * @author luzhaojian
     * @date 2024-11-05
     * @param {*} data
     * @memberof HttpRequest
     */
    clearAccount(data) {
        return rest.post("@uc/uc/open/switch_account_clear", data);
    }

    /**
     * @description 账号切换
     * @author luzhaojian
     * @date 2024-08-28
     * @memberof HttpRequest
     */
    switchAccount(data) {
        return rest.post("@uc/uc/open/switch_account", data);
    }

    /**
     * @description 检索子账号
     * @author luzhaojian
     * @date 2024-08-29
     * @param {*} params
     * @memberof HttpRequest
     */
    getSubAccountList(params) {
        return rest.get("@uc/uc/open/sub_account/list", { params });
    }

    /**
     * @description 获取货币单位
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    getCurrencyList() {
        return rest.get("@hbg/v1/hbg/open/biz/control/valuation-currency/list");
    }

    /**
     * @description 获取用户中心信息
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    getPersonalCenter() {
        return rest.get("@hbg/v1/hbg/myhome/personalCenter");
    }

    /**
     * @description 获取equity用户信息
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    getWebUserInfo() {
        return rest.get("@hbg/v1/equity/web/user/info");
    }

    /**
     * @description 关注用户
     * @author luzhaojian
     * @date 2024-04-23
     * @param {*} data
     * @memberof HttpRequest
     */
    followUser(data) {
        return rest.post("@hbg/v1/content/community/focus/save", data);
    }

    /**
     * @description 获取用户资产
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    getBalanceAssets() {
        return rest.get("@hbg/v1/open/profit/balance-profit-assets");
    }

    /**
     * @description 获取footer图标配置信息
     * @author luzhaojian
     * @date 2023-09-02
     * @returns {*}
     * @memberof HttpRequest
     */
    getDefaultCof() {
        return rest.get("@hbg/v1/mgt/config/default/list");
    }

    /**
     * @description 获取汇率
     * @author luzhaojian
     * @date 2023-09-01
     * @returns {*}
     * @memberof HttpRequest
     */
    getExchangeRate() {
        return rest.get("@general/exchange_rate/list");
    }
    /**
     * @description 理财开关是否开启查询
     * @author tyl
     * @date 2023-12-27
     * @returns {*}
     * @memberof HttpRequest
     */
    getTradeSwitch() {
        return rest.get("@hbg/v4/saving/mining/user/config/allowTradeRedeem/query");
    }

    /**
     * @description 理财开关设置
     * @author tyl
     * @date 2023-12-27
     * @returns {*}
     * @memberof HttpRequest
     */
    setTradeSwitch(data) {
        let url = `@hbg/v4/saving/mining/user/config/allowTradeRedeem/switch?status=${data}`;
        return rest.post(url);
    }

    /**
     * @description 关注
     * @author luzhaojian
     * @date 2024-04-16
     * @param {*} data
     * @memberof HttpRequest
     */
    setAppoint(data) {
        return rest.post("@hbg/v1/content/live/live-appoint/appoint", data);
    }

    /**
     * @description 取消关注
     * @author luzhaojian
     * @date 2024-05-09
     * @param {*} data
     * @memberof HttpRequest
     */
    cancelAppoint(data) {
        return rest.post("@hbg/v1/content/live/live-appoint/appoint-cancel", data);
    }

    /**
     * @description 热搜词
     * @author luzhaojian
     * @date 2024-04-16
     * @memberof HttpRequest
     */
    getHotWordList() {
        return rest.get("@ae/v1/search/app/search/hotWordList");
    }

    /**
     * @description 搜索推荐
     * @author luzhaojian
     * @date 2024-04-16
     * @memberof HttpRequest
     */
    getSearchList() {
        return rest.get("@ae/v1/search/app/search/searchHomePage");
    }

    /**
     * @description 查询推荐词
     * @author luzhaojian
     * @date 2024-04-16
     * @param {*} data
     * @memberof HttpRequest
     */
    getSuggestList(data) {
        return rest.post("@ae/v1/search/suggest/getSuggestList", data);
    }

    /**
     * @description 搜索结果页
     * @author luzhaojian
     * @date 2024-04-17
     * @param {*} params
     * @memberof HttpRequest
     */
    getSearchResultList(params) {
        return rest.get("@ae/v1/search/app/search/searchPage", { params });
    }

    /**
     * @description K线周期以新加坡时间为基准开始计算，例如日K线的起始周期为新加坡时间0时至新加坡时间次日0时。
     * @author luzhaojian
     * @date 2024-04-21
     * @param {*} params
     * @memberof HttpRequest
     */
    historyKline(params) {
        return rest.get("@market/history/kline", { params });
    }

    /**
     * @description U本位合约基础数据
     * @author luzhaojian
     * @date 2024-04-22
     * @param {*} params
     * @memberof HttpRequest
     */
    getLinearContractInfo(params) {
        return rest.get("@linear/v1/linear_swap_contract_info", { params });
    }

    /**
     * @description 币本位交割基础数据
     * @author luzhaojian
     * @date 2024-05-16
     * @memberof HttpRequest
     */
    getContractInfo() {
        return rest.get("@contract/v1/contract_contract_info");
    }

    /**
     * @description 币本位永续基础数据
     * @author luzhaojian
     * @date 2024-05-20
     * @returns {*}
     * @memberof HttpRequest
     */
    getSwapContractInfo() {
        return rest.get("@swap/v1/swap_contract_info");
    }

    /**
     * @description 查询U本位行情数据
     * @author luzhaojian
     * @date 2024-04-22
     * @param {*} params
     * @memberof HttpRequest
     */
    getLinearSwapKline(params) {
        return rest.get("@futures/linear-swap-ex/market/history/kline", { params });
    }

    /**
     * @description 查询币本位交割行情数据
     * @author luzhaojian
     * @date 2024-05-14
     * @param {*} params
     * @memberof HttpRequest
     */
    getCurrencyKline(params) {
        return rest.get("@futures/market/history/kline", { params });
    }

    /**
     * @description 查询币本位永续行情数据
     * @author luzhaojian
     * @date 2024-05-14
     * @param {*} params
     * @returns {*}
     * @memberof HttpRequest
     */
    getSwapKline(params) {
        return rest.get("@futures/swap-ex/market/history/kline", { params });
    }
}

/* harmony default export */ var httpReq = __webpack_exports__["default"] = (httpReq_HttpRequest);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackHeader", function() { return trackHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackFooter", function() { return trackFooter; });
// 数据埋点，通过神策埋点
function trackHeader(obj = {}) {
    window && window.sensors && window.sensors.track("webclick_nav", obj);
}

function trackFooter(name) {
    window && window.sensors && window.sensors.track(name);
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(183),
    getValue = __webpack_require__(186);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(255);
var isBuffer = __webpack_require__(389);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */
;(function (globalScope) {
  'use strict';


  /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */


  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //


    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
  var MAX_DIGITS = 1e9,                        // 0 to 1e9


    // The initial configuration properties of the Decimal constructor.
    Decimal = {

      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed during run-time using `Decimal.config`.

      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,                         // 1 to MAX_DIGITS

      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
      // `toFixed`, `toPrecision` and `toSignificantDigits`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,                           // 0 to 8

      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,                          // 0 to -MAX_E

      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos:  21,                         // 0 to MAX_E

      // The natural logarithm of 10.
      // 115 digits
      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    },


  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //


    external = true,

    decimalError = '[DecimalError] ',
    invalidArgument = decimalError + 'Invalid argument: ',
    exponentOutOfRange = decimalError + 'Exponent out of range: ',

    mathfloor = Math.floor,
    mathpow = Math.pow,

    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

    ONE,
    BASE = 1e7,
    LOG_BASE = 7,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284

    // Decimal.prototype object
    P = {};


  // Decimal prototype methods


  /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */


  /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */
  P.absoluteValue = P.abs = function () {
    var x = new this.constructor(this);
    if (x.s) x.s = 1;
    return x;
  };


  /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */
  P.comparedTo = P.cmp = function (y) {
    var i, j, xdL, ydL,
      x = this;

    y = new x.constructor(y);

    // Signs differ?
    if (x.s !== y.s) return x.s || -y.s;

    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;

    xdL = x.d.length;
    ydL = y.d.length;

    // Compare digit by digit.
    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
    }

    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
  };


  /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */
  P.decimalPlaces = P.dp = function () {
    var x = this,
      w = x.d.length - 1,
      dp = (w - x.e) * LOG_BASE;

    // Subtract the number of trailing zeros of the last word.
    w = x.d[w];
    if (w) for (; w % 10 == 0; w /= 10) dp--;

    return dp < 0 ? 0 : dp;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.dividedBy = P.div = function (y) {
    return divide(this, new this.constructor(y));
  };


  /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */
  P.dividedToIntegerBy = P.idiv = function (y) {
    var x = this,
      Ctor = x.constructor;
    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
  };


  /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */
  P.equals = P.eq = function (y) {
    return !this.cmp(y);
  };


  /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */
  P.exponent = function () {
    return getBase10Exponent(this);
  };


  /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */
  P.greaterThan = P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */
  P.greaterThanOrEqualTo = P.gte = function (y) {
    return this.cmp(y) >= 0;
  };


  /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */
  P.isInteger = P.isint = function () {
    return this.e > this.d.length - 2;
  };


  /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */
  P.isNegative = P.isneg = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */
  P.isPositive = P.ispos = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */
  P.isZero = function () {
    return this.s === 0;
  };


  /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */
  P.lessThan = P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */
  P.lessThanOrEqualTo = P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */
  P.logarithm = P.log = function (base) {
    var r,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision,
      wpr = pr + 5;

    // Default base is 10.
    if (base === void 0) {
      base = new Ctor(10);
    } else {
      base = new Ctor(base);

      // log[-b](x) = NaN
      // log[0](x)  = NaN
      // log[1](x)  = NaN
      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
    }

    // log[b](-x) = NaN
    // log[b](0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // log[b](1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    external = false;
    r = divide(ln(x, wpr), ln(base, wpr), wpr);
    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.minus = P.sub = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.modulo = P.mod = function (y) {
    var q,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision;

    y = new Ctor(y);

    // x % 0 = NaN
    if (!y.s) throw Error(decimalError + 'NaN');

    // Return x if x is 0.
    if (!x.s) return round(new Ctor(x), pr);

    // Prevent rounding of intermediate calculations.
    external = false;
    q = divide(x, y, 0, 1).times(y);
    external = true;

    return x.minus(q);
  };


  /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.naturalExponential = P.exp = function () {
    return exp(this);
  };


  /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */
  P.naturalLogarithm = P.ln = function () {
    return ln(this);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */
  P.negated = P.neg = function () {
    var x = new this.constructor(this);
    x.s = -x.s || 0;
    return x;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.plus = P.add = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
  };


  /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */
  P.precision = P.sd = function (z) {
    var e, sd, w,
      x = this;

    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

    e = getBase10Exponent(x) + 1;
    w = x.d.length - 1;
    sd = w * LOG_BASE + 1;
    w = x.d[w];

    // If non-zero...
    if (w) {

      // Subtract the number of trailing zeros of the last word.
      for (; w % 10 == 0; w /= 10) sd--;

      // Add the number of digits of the first word.
      for (w = x.d[0]; w >= 10; w /= 10) sd++;
    }

    return z && e > sd ? e : sd;
  };


  /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.squareRoot = P.sqrt = function () {
    var e, n, pr, r, s, t, wpr,
      x = this,
      Ctor = x.constructor;

    // Negative or zero?
    if (x.s < 1) {
      if (!x.s) return new Ctor(0);

      // sqrt(-x) = NaN
      throw Error(decimalError + 'NaN');
    }

    e = getBase10Exponent(x);
    external = false;

    // Initial estimate.
    s = Math.sqrt(+x);

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = digitsToString(x.d);
      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(n);
      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new Ctor(n);
    } else {
      r = new Ctor(s.toString());
    }

    pr = Ctor.precision;
    s = wpr = pr + 3;

    // Newton-Raphson iteration.
    for (;;) {
      t = r;
      r = t.plus(divide(x, t, wpr + 2)).times(0.5);

      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
        n = n.slice(wpr - 3, wpr + 1);

        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
        // 4999, i.e. approaching a rounding boundary, continue the iteration.
        if (s == wpr && n == '4999') {

          // On the first iteration only, check to see if rounding up gives the exact result as the
          // nines may infinitely repeat.
          round(t, pr + 1, 0);

          if (t.times(t).eq(x)) {
            r = t;
            break;
          }
        } else if (n != '9999') {
          break;
        }

        wpr += 4;
      }
    }

    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.times = P.mul = function (y) {
    var carry, e, i, k, r, rL, t, xdL, ydL,
      x = this,
      Ctor = x.constructor,
      xd = x.d,
      yd = (y = new Ctor(y)).d;

    // Return 0 if either is 0.
    if (!x.s || !y.s) return new Ctor(0);

    y.s *= x.s;
    e = x.e + y.e;
    xdL = xd.length;
    ydL = yd.length;

    // Ensure xd points to the longer array.
    if (xdL < ydL) {
      r = xd;
      xd = yd;
      yd = r;
      rL = xdL;
      xdL = ydL;
      ydL = rL;
    }

    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for (i = rL; i--;) r.push(0);

    // Multiply!
    for (i = ydL; --i >= 0;) {
      carry = 0;
      for (k = xdL + i; k > i;) {
        t = r[k] + yd[i] * xd[k - i - 1] + carry;
        r[k--] = t % BASE | 0;
        carry = t / BASE | 0;
      }

      r[k] = (r[k] + carry) % BASE | 0;
    }

    // Remove trailing zeros.
    for (; !r[--rL];) r.pop();

    if (carry) ++e;
    else r.shift();

    y.d = r;
    y.e = e;

    return external ? round(y, Ctor.precision) : y;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toDecimalPlaces = P.todp = function (dp, rm) {
    var x = this,
      Ctor = x.constructor;

    x = new Ctor(x);
    if (dp === void 0) return x;

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    return round(x, dp + getBase10Exponent(x) + 1, rm);
  };


  /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toExponential = function (dp, rm) {
    var str,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) {
      str = toString(x, true);
    } else {
      checkInt32(dp, 0, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), dp + 1, rm);
      str = toString(x, true, dp + 1);
    }

    return str;
  };


  /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */
  P.toFixed = function (dp, rm) {
    var str, y,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) return toString(x);

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);

    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isneg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */
  P.toInteger = P.toint = function () {
    var x = this,
      Ctor = x.constructor;
    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
  };


  /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */
  P.toNumber = function () {
    return +this;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */
  P.toPower = P.pow = function (y) {
    var e, k, pr, r, sign, yIsInt,
      x = this,
      Ctor = x.constructor,
      guard = 12,
      yn = +(y = new Ctor(y));

    // pow(x, 0) = 1
    if (!y.s) return new Ctor(ONE);

    x = new Ctor(x);

    // pow(0, y > 0) = 0
    // pow(0, y < 0) = Infinity
    if (!x.s) {
      if (y.s < 1) throw Error(decimalError + 'Infinity');
      return x;
    }

    // pow(1, y) = 1
    if (x.eq(ONE)) return x;

    pr = Ctor.precision;

    // pow(x, 1) = x
    if (y.eq(ONE)) return round(x, pr);

    e = y.e;
    k = y.d.length - 1;
    yIsInt = e >= k;
    sign = x.s;

    if (!yIsInt) {

      // pow(x < 0, y non-integer) = NaN
      if (sign < 0) throw Error(decimalError + 'NaN');

    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
      r = new Ctor(ONE);

      // Max k of 9007199254740991 takes 53 loop iterations.
      // Maximum digits array length; leaves [28, 34] guard digits.
      e = Math.ceil(pr / LOG_BASE + 4);

      external = false;

      for (;;) {
        if (k % 2) {
          r = r.times(x);
          truncate(r.d, e);
        }

        k = mathfloor(k / 2);
        if (k === 0) break;

        x = x.times(x);
        truncate(x.d, e);
      }

      external = true;

      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
    }

    // Result is negative if x is negative and the last digit of integer y is odd.
    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

    x.s = 1;
    external = false;
    r = y.times(ln(x, pr + guard));
    external = true;
    r = exp(r);
    r.s = sign;

    return r;
  };


  /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toPrecision = function (sd, rm) {
    var e, str,
      x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      e = getBase10Exponent(x);
      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), sd, rm);
      e = getBase10Exponent(x);
      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
    }

    return str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toSignificantDigits = P.tosd = function (sd, rm) {
    var x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      sd = Ctor.precision;
      rm = Ctor.rounding;
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);
    }

    return round(new Ctor(x), sd, rm);
  };


  /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */
  P.toString = P.valueOf = P.val = P.toJSON = function () {
    var x = this,
      e = getBase10Exponent(x),
      Ctor = x.constructor;

    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  };


  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


  /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */


  function add(x, y) {
    var carry, d, e, i, k, len, xd, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // If either is zero...
    if (!x.s || !y.s) {

      // Return x if y is zero.
      // Return y if y is non-zero.
      if (!y.s) y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are finite, non-zero numbers with the same sign.

    k = x.e;
    e = y.e;
    xd = xd.slice();
    i = k - e;

    // If base 1e7 exponents differ...
    if (i) {
      if (i < 0) {
        d = xd;
        i = -i;
        len = yd.length;
      } else {
        d = yd;
        e = k;
        len = xd.length;
      }

      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
      k = Math.ceil(pr / LOG_BASE);
      len = k > len ? k + 1 : len + 1;

      if (i > len) {
        i = len;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
      d.reverse();
      for (; i--;) d.push(0);
      d.reverse();
    }

    len = xd.length;
    i = yd.length;

    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
      i = len;
      d = yd;
      yd = xd;
      xd = d;
    }

    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for (carry = 0; i;) {
      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
      xd[i] %= BASE;
    }

    if (carry) {
      xd.unshift(carry);
      ++e;
    }

    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for (len = xd.length; xd[--len] == 0;) xd.pop();

    y.d = xd;
    y.e = e;

    return external ? round(y, pr) : y;
  }


  function checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) {
      throw Error(invalidArgument + i);
    }
  }


  function digitsToString(d) {
    var i, k, ws,
      indexOfLastWord = d.length - 1,
      str = '',
      w = d[0];

    if (indexOfLastWord > 0) {
      str += w;
      for (i = 1; i < indexOfLastWord; i++) {
        ws = d[i] + '';
        k = LOG_BASE - ws.length;
        if (k) str += getZeroString(k);
        str += ws;
      }

      w = d[i];
      ws = w + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
    } else if (w === 0) {
      return '0';
    }

    // Remove trailing zeros of last w.
    for (; w % 10 === 0;) w /= 10;

    return str + w;
  }


  var divide = (function () {

    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k) {
      var temp,
        carry = 0,
        i = x.length;

      for (x = x.slice(); i--;) {
        temp = x[i] * k + carry;
        x[i] = temp % BASE | 0;
        carry = temp / BASE | 0;
      }

      if (carry) x.unshift(carry);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, r;

      if (aL != bL) {
        r = aL > bL ? 1 : -1;
      } else {
        for (i = r = 0; i < aL; i++) {
          if (a[i] != b[i]) {
            r = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return r;
    }

    function subtract(a, b, aL) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * BASE + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1;) a.shift();
    }

    return function (x, y, pr, dp) {
      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
        Ctor = x.constructor,
        sign = x.s == y.s ? 1 : -1,
        xd = x.d,
        yd = y.d;

      // Either 0?
      if (!x.s) return new Ctor(x);
      if (!y.s) throw Error(decimalError + 'Division by zero');

      e = x.e - y.e;
      yL = yd.length;
      xL = xd.length;
      q = new Ctor(sign);
      qd = q.d = [];

      // Result exponent may be one less than e.
      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
      if (yd[i] > (xd[i] || 0)) --e;

      if (pr == null) {
        sd = pr = Ctor.precision;
      } else if (dp) {
        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
      } else {
        sd = pr;
      }

      if (sd < 0) return new Ctor(0);

      // Convert precision in number of base 10 digits to base 1e7 digits.
      sd = sd / LOG_BASE + 2 | 0;
      i = 0;

      // divisor < 1e7
      if (yL == 1) {
        k = 0;
        yd = yd[0];
        sd++;

        // k is the carry.
        for (; (i < xL || k) && sd--; i++) {
          t = k * BASE + (xd[i] || 0);
          qd[i] = t / yd | 0;
          k = t % yd | 0;
        }

      // divisor >= 1e7
      } else {

        // Normalise xd and yd so highest order digit of yd is >= BASE/2
        k = BASE / (yd[0] + 1) | 0;

        if (k > 1) {
          yd = multiplyInteger(yd, k);
          xd = multiplyInteger(xd, k);
          yL = yd.length;
          xL = xd.length;
        }

        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL;) rem[remL++] = 0;

        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];

        if (yd[1] >= BASE / 2) ++yd0;

        do {
          k = 0;

          // Compare divisor and remainder.
          cmp = compare(yd, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, k.
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);

            // k will be how many times the divisor goes into the current remainder.
            k = rem0 / yd0 | 0;

            //  Algorithm:
            //  1. product = divisor * trial digit (k)
            //  2. if product > remainder: product -= divisor, k--
            //  3. remainder -= product
            //  4. if product was < remainder at 2:
            //    5. compare new remainder and divisor
            //    6. If remainder > divisor: remainder -= divisor, k++

            if (k > 1) {
              if (k >= BASE) k = BASE - 1;

              // product = divisor * trial digit.
              prod = multiplyInteger(yd, k);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              cmp = compare(prod, rem, prodL, remL);

              // product > remainder.
              if (cmp == 1) {
                k--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yd, prodL);
              }
            } else {

              // cmp is -1.
              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
              if (k == 0) cmp = k = 1;
              prod = yd.slice();
            }

            prodL = prod.length;
            if (prodL < remL) prod.unshift(0);

            // Subtract product from remainder.
            subtract(rem, prod, remL);

            // If product was < previous remainder.
            if (cmp == -1) {
              remL = rem.length;

              // Compare divisor and new remainder.
              cmp = compare(yd, rem, yL, remL);

              // If divisor < new remainder, subtract divisor from remainder.
              if (cmp < 1) {
                k++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yd, remL);
              }
            }

            remL = rem.length;
          } else if (cmp === 0) {
            k++;
            rem = [0];
          }    // if cmp === 1, k will be 0

          // Add the next digit, k, to the result array.
          qd[i++] = k;

          // Update the remainder.
          if (cmp && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }

        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
      }

      // Leading zero?
      if (!qd[0]) qd.shift();

      q.e = e;

      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
    };
  })();


  /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */
  function exp(x, sd) {
    var denominator, guard, pow, sum, t, wpr,
      i = 0,
      k = 0,
      Ctor = x.constructor,
      pr = Ctor.precision;

    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));

    // exp(0) = 1
    if (!x.s) return new Ctor(ONE);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    t = new Ctor(0.03125);

    while (x.abs().gte(0.1)) {
      x = x.times(t);    // x = x / 2^5
      k += 5;
    }

    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor(ONE);
    Ctor.precision = wpr;

    for (;;) {
      pow = round(pow.times(x), wpr);
      denominator = denominator.times(++i);
      t = sum.plus(divide(pow, denominator, wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        while (k--) sum = round(sum.times(sum), wpr);
        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
    }
  }


  // Calculate the base 10 exponent from the base 1e7 exponent.
  function getBase10Exponent(x) {
    var e = x.e * LOG_BASE,
      w = x.d[0];

    // Add the number of digits of the first word of the digits array.
    for (; w >= 10; w /= 10) e++;
    return e;
  }


  function getLn10(Ctor, sd, pr) {

    if (sd > Ctor.LN10.sd()) {


      // Reset global state in case the exception is caught.
      external = true;
      if (pr) Ctor.precision = pr;
      throw Error(decimalError + 'LN10 precision limit exceeded');
    }

    return round(new Ctor(Ctor.LN10), sd);
  }


  function getZeroString(k) {
    var zs = '';
    for (; k--;) zs += '0';
    return zs;
  }


  /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */
  function ln(y, sd) {
    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
      n = 1,
      guard = 10,
      x = y,
      xd = x.d,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // ln(-x) = NaN
    // ln(0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // ln(1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    if (x.eq(10)) {
      if (sd == null) external = true;
      return getLn10(Ctor, wpr);
    }

    wpr += guard;
    Ctor.precision = wpr;
    c = digitsToString(xd);
    c0 = c.charAt(0);
    e = getBase10Exponent(x);

    if (Math.abs(e) < 1.5e15) {

      // Argument reduction.
      // The series converges faster the closer the argument is to 1, so using
      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
      // later be divided by this number, then separate out the power of 10 using
      // ln(a*10^b) = ln(a) + b*ln(10).

      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
      // max n is 6 (gives 0.7 - 1.3)
      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
        x = x.times(y);
        c = digitsToString(x.d);
        c0 = c.charAt(0);
        n++;
      }

      e = getBase10Exponent(x);

      if (c0 > 1) {
        x = new Ctor('0.' + c);
        e++;
      } else {
        x = new Ctor(c0 + '.' + c.slice(1));
      }
    } else {

      // The argument reduction method above may result in overflow if the argument y is a massive
      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
      // function using ln(x*10^e) = ln(x) + e*ln(10).
      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);

      Ctor.precision = pr;
      return sd == null ? (external = true, round(x, pr)) : x;
    }

    // x is reduced to a value near 1.

    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
    x2 = round(x.times(x), wpr);
    denominator = 3;

    for (;;) {
      numerator = round(numerator.times(x2), wpr);
      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        sum = sum.times(2);

        // Reverse the argument reduction.
        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
        sum = divide(sum, new Ctor(n), wpr);

        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
      denominator += 2;
    }
  }


  /*
   * Parse the value of a new Decimal `x` from string `str`.
   */
  function parseDecimal(x, str) {
    var e, i, len;

    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +str.slice(i + 1);
      str = str.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48;) ++i;

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
    str = str.slice(i, len);

    if (str) {
      len -= i;
      e = e - i - 1;
      x.e = mathfloor(e / LOG_BASE);
      x.d = [];

      // Transform base

      // e is the base 10 exponent.
      // i is where to slice str to get the first word of the digits array.
      i = (e + 1) % LOG_BASE;
      if (e < 0) i += LOG_BASE;

      if (i < len) {
        if (i) x.d.push(+str.slice(0, i));
        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
        str = str.slice(i);
        i = LOG_BASE - str.length;
      } else {
        i -= len;
      }

      for (; i--;) str += '0';
      x.d.push(+str);

      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
    } else {

      // Zero.
      x.s = 0;
      x.e = 0;
      x.d = [0];
    }

    return x;
  }


  /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */
   function round(x, sd, rm) {
    var i, j, k, n, rd, doRound, w, xdi,
      xd = x.d;

    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd which contains the rounding digit, a base 1e7 number.
    // xdi: the index of w within xd.
    // n: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

    // Get the length of the first word of the digits array xd.
    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
    i = sd - n;

    // Is the rounding digit in the first word of xd?
    if (i < 0) {
      i += LOG_BASE;
      j = sd;
      w = xd[xdi = 0];
    } else {
      xdi = Math.ceil((i + 1) / LOG_BASE);
      k = xd.length;
      if (xdi >= k) return x;
      w = k = xd[xdi];

      // Get the number of digits of w.
      for (n = 1; k >= 10; k /= 10) n++;

      // Get the index of rd within w.
      i %= LOG_BASE;

      // Get the index of rd within w, adjusted for leading zeros.
      // The number of leading zeros of w is given by LOG_BASE - n.
      j = i - LOG_BASE + n;
    }

    if (rm !== void 0) {
      k = mathpow(10, n - j - 1);

      // Get the rounding digit at index j of w.
      rd = w / k % 10 | 0;

      // Are there any non-zero digits after the rounding digit?
      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;

      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
      // 714.

      doRound = rm < 4
        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
            rm == (x.s < 0 ? 8 : 7));
    }

    if (sd < 1 || !xd[0]) {
      if (doRound) {
        k = getBase10Exponent(x);
        xd.length = 1;

        // Convert sd to decimal places.
        sd = sd - k - 1;

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
        x.e = mathfloor(-sd / LOG_BASE) || 0;
      } else {
        xd.length = 1;

        // Zero.
        xd[0] = x.e = x.s = 0;
      }

      return x;
    }

    // Remove excess digits.
    if (i == 0) {
      xd.length = xdi;
      k = 1;
      xdi--;
    } else {
      xd.length = xdi + 1;
      k = mathpow(10, LOG_BASE - i);

      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
      // j > 0 means i > number of leading zeros of w.
      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
    }

    if (doRound) {
      for (;;) {

        // Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {
          if ((xd[0] += k) == BASE) {
            xd[0] = 1;
            ++x.e;
          }

          break;
        } else {
          xd[xdi] += k;
          if (xd[xdi] != BASE) break;
          xd[xdi--] = 0;
          k = 1;
        }
      }
    }

    // Remove trailing zeros.
    for (i = xd.length; xd[--i] === 0;) xd.pop();

    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
      throw Error(exponentOutOfRange + getBase10Exponent(x));
    }

    return x;
  }


  function subtract(x, y) {
    var d, e, i, j, k, len, xd, xe, xLTy, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // Return y negated if x is zero.
    // Return x if y is zero and x is non-zero.
    if (!x.s || !y.s) {
      if (y.s) y.s = -y.s;
      else y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are non-zero numbers with the same sign.

    e = y.e;
    xe = x.e;
    xd = xd.slice();
    k = xe - e;

    // If exponents differ...
    if (k) {
      xLTy = k < 0;

      if (xLTy) {
        d = xd;
        k = -k;
        len = yd.length;
      } else {
        d = yd;
        e = xe;
        len = xd.length;
      }

      // Numbers with massively different exponents would result in a very high number of zeros
      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

      if (k > i) {
        k = i;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents.
      d.reverse();
      for (i = k; i--;) d.push(0);
      d.reverse();

    // Base 1e7 exponents equal.
    } else {

      // Check digits to determine which is the bigger number.

      i = xd.length;
      len = yd.length;
      xLTy = i < len;
      if (xLTy) len = i;

      for (i = 0; i < len; i++) {
        if (xd[i] != yd[i]) {
          xLTy = xd[i] < yd[i];
          break;
        }
      }

      k = 0;
    }

    if (xLTy) {
      d = xd;
      xd = yd;
      yd = d;
      y.s = -y.s;
    }

    len = xd.length;

    // Append zeros to xd if shorter.
    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

    // Subtract yd from xd.
    for (i = yd.length; i > k;) {
      if (xd[--i] < yd[i]) {
        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
        --xd[j];
        xd[i] += BASE;
      }

      xd[i] -= yd[i];
    }

    // Remove trailing zeros.
    for (; xd[--len] === 0;) xd.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xd[0] === 0; xd.shift()) --e;

    // Zero?
    if (!xd[0]) return new Ctor(0);

    y.d = xd;
    y.e = e;

    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
    return external ? round(y, pr) : y;
  }


  function toString(x, isExp, sd) {
    var k,
      e = getBase10Exponent(x),
      str = digitsToString(x.d),
      len = str.length;

    if (isExp) {
      if (sd && (k = sd - len) > 0) {
        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
      } else if (len > 1) {
        str = str.charAt(0) + '.' + str.slice(1);
      }

      str = str + (e < 0 ? 'e' : 'e+') + e;
    } else if (e < 0) {
      str = '0.' + getZeroString(-e - 1) + str;
      if (sd && (k = sd - len) > 0) str += getZeroString(k);
    } else if (e >= len) {
      str += getZeroString(e + 1 - len);
      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
    } else {
      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
      if (sd && (k = sd - len) > 0) {
        if (e + 1 === len) str += '.';
        str += getZeroString(k);
      }
    }

    return x.s < 0 ? '-' + str : str;
  }


  // Does not strip trailing zeros.
  function truncate(arr, len) {
    if (arr.length > len) {
      arr.length = len;
      return true;
    }
  }


  // Decimal methods


  /*
   *  clone
   *  config/set
   */


  /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */
  function clone(obj) {
    var i, p, ps;

    /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */
    function Decimal(value) {
      var x = this;

      // Decimal called without new.
      if (!(x instanceof Decimal)) return new Decimal(value);

      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
      // which points to Object.
      x.constructor = Decimal;

      // Duplicate.
      if (value instanceof Decimal) {
        x.s = value.s;
        x.e = value.e;
        x.d = (value = value.d) ? value.slice() : value;
        return;
      }

      if (typeof value === 'number') {

        // Reject Infinity/NaN.
        if (value * 0 !== 0) {
          throw Error(invalidArgument + value);
        }

        if (value > 0) {
          x.s = 1;
        } else if (value < 0) {
          value = -value;
          x.s = -1;
        } else {
          x.s = 0;
          x.e = 0;
          x.d = [0];
          return;
        }

        // Fast path for small integers.
        if (value === ~~value && value < 1e7) {
          x.e = 0;
          x.d = [value];
          return;
        }

        return parseDecimal(x, value.toString());
      } else if (typeof value !== 'string') {
        throw Error(invalidArgument + value);
      }

      // Minus sign?
      if (value.charCodeAt(0) === 45) {
        value = value.slice(1);
        x.s = -1;
      } else {
        x.s = 1;
      }

      if (isDecimal.test(value)) parseDecimal(x, value);
      else throw Error(invalidArgument + value);
    }

    Decimal.prototype = P;

    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;

    Decimal.clone = clone;
    Decimal.config = Decimal.set = config;

    if (obj === void 0) obj = {};
    if (obj) {
      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }

    Decimal.config(obj);

    return Decimal;
  }


  /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */
  function config(obj) {
    if (!obj || typeof obj !== 'object') {
      throw Error(decimalError + 'Object expected');
    }
    var i, p, v,
      ps = [
        'precision', 1, MAX_DIGITS,
        'rounding', 0, 8,
        'toExpNeg', -1 / 0, 0,
        'toExpPos', 0, 1 / 0
      ];

    for (i = 0; i < ps.length; i += 3) {
      if ((v = obj[p = ps[i]]) !== void 0) {
        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error(invalidArgument + p + ': ' + v);
      }
    }

    if ((v = obj[p = 'LN10']) !== void 0) {
        if (v == Math.LN10) this[p] = new this(v);
        else throw Error(invalidArgument + p + ': ' + v);
    }

    return this;
  }


  // Create and configure initial Decimal constructor.
  Decimal = clone(Decimal);

  Decimal['default'] = Decimal.Decimal = Decimal;

  // Internal constant.
  ONE = new Decimal(1);


  // Export.


  // AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return Decimal;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node and other environments that support module.exports.
  } else {}
})(this);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    getRawTag = __webpack_require__(167),
    objectToString = __webpack_require__(168);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32),
    now = __webpack_require__(162),
    toNumber = __webpack_require__(163);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var i18n_1 = __webpack_require__(14);
var NoContent = function () {
    var t = (0, i18n_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "no-content" },
            react_1.default.createElement("div", { className: "no-img" }),
            react_1.default.createElement("span", null, t('暂无内容')))));
};
exports.default = NoContent;


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i18n", function() { return i18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleText", function() { return getLocaleText; });
/* harmony import */ var _config_function__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64);


const { localList } = __webpack_require__(68);

let langObj = {};
localList.forEach(item => {
	langObj[item] = __webpack_require__(105)(`./${item}.json`);
});

const i18n = langObj;

/**
 * 获取语言对应显示的文本
 *
 * @param {string} locale 语言名称
 * @return {string}
 */
const getLocaleText = locale => {
    const lang = _config_function__WEBPACK_IMPORTED_MODULE_0__["localList"].find(item => item.key === locale);
    if (lang) {
        return lang.value;
    }
    return '';
};

/* harmony default export */ __webpack_exports__["default"] = (function (key, locale = 'en-us', fallbackLang = 'en-us') {
	let value = '';

	if (!key || typeof key !== 'string') {
		return value;
	}

	// 没有 zh-tw ，直接使用 zh-tc
	if (locale === 'zh-tw') {
		locale = 'zh-tc';
	}

	let cacheENUS = i18n[fallbackLang];
	let cache = i18n[locale] || cacheENUS;

	value = cache[key] || cacheENUS[key];

	return typeof value === 'string' ? value.replace(/[\r\n]/g, '<br>') : key;
});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// 下架的语言
const excludeLangList = ['ko-kr', 'de-de', 'pt-br', 'nl-nl', 'ms-my', 'hi-in', 'ja-jp'];

// 为了匹配浏览器语言，同语言不同国家需前置语言；
// 例: pt-pt 和 pt-br 需要将 pt-pt 放在 pt-br 前面；
const langList = [
    {
        key: 'en-us',
        value: 'English',
        zk: 'en-us',
        note: 'ENHANCED',
    },
    {
        key: 'zh-cn',
        value: '简体中文',
        zk: 'zh-cn',
    },
    {
        key: 'zh-hk',
        value: '繁體中文',
        zk: 'zh-tw',
    },
    {
        key: 'zh-tc',
        value: '繁體中文',
        zk: 'zh-tw',
    },
    {
        key: 'ko-kr',
        value: '한국어',
        zk: 'ko',
    },
    {
        key: 'ja-jp',
        value: '日本語',
        zk: 'ja',
    },
    {
        key: 'ru-ru',
        value: 'Русский',
        zk: 'ru',
    },
    {
        key: 'de-de',
        value: 'Deutsch',
        zk: 'de',
    },
    {
        key: 'fr-fr',
        value: 'Français',
        zk: 'fr',
    },
    {
        key: 'es-es',
        value: 'Español-ES',
        zk: 'es',
    },
    {
        key: 'es-la',
        value: 'Español-LA',
        zk: 'es',
    },
    {
        key: 'tr-tr',
        value: 'Türkçe',
        zk: 'tr',
    },
    {
        key: 'vi-vi',
        value: 'Tiếng Việt',
        zk: 'vi',
    },
    {
        key: 'pt-pt',
        value: 'Português-PT',
        zk: 'pt',
    },
    {
        key: 'pt-br',
        value: 'Português-BR',
        zk: 'pt',
    },
    {
        key: 'it-it',
        value: 'Italiano',
        zk: 'it',
    },
    {
        key: 'nl-nl',
        value: 'Nederlands',
        zk: 'nl',
    },
    {
        key: 'ms-my',
        value: 'Bahasa Malaysia',
        zk: 'ms',
    },
    {
        key: 'en-in',
        value: 'English (India)',
        zk: 'en',
    },
    {
        key: 'uk-ua',
        value: 'Українська',
        zk: 'uk',
    },
    {
        key: 'hi-in',
        value: 'हिन्दी',
        zk: 'hi',
    },
    {
        key: 'id-id',
        value: 'Bahasa Indonesia',
        zk: 'id',
    },
];

module.exports = {
    excludeLangList,
    langList,
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(26);
var utils = __webpack_require__(8);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(173),
    listCacheDelete = __webpack_require__(174),
    listCacheGet = __webpack_require__(175),
    listCacheHas = __webpack_require__(176),
    listCacheSet = __webpack_require__(177);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(81);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(195);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(35),
    isObject = __webpack_require__(32);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(170);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(8);
var normalizeHeaderName = __webpack_require__(126);
var AxiosError = __webpack_require__(26);
var transitionalDefaults = __webpack_require__(71);
var toFormData = __webpack_require__(72);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(73);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(73);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(136)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(98);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(78));
util.inherits = __webpack_require__(61);
/*</replacement>*/

var Readable = __webpack_require__(240);
var Writable = __webpack_require__(148);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(121);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(53),__webpack_require__(13)):undefined}(this,(function(t,e){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var i=e[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)r.d(n,i,function(e){return t[e]}.bind(null,i));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=10)}([function(t,e){function r(e){return t.exports=r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,r(e)}t.exports=r,t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(11)();t.exports=n;try{regeneratorRuntime=n}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}},function(t,e,r){var n=r(7);t.exports=function(t,e,r){return(e=n(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){function r(t,e,r,n,i,o,a){try{var s=t[o](a),u=s.value}catch(t){return void r(t)}s.done?e(u):Promise.resolve(u).then(n,i)}t.exports=function(t){return function(){var e=this,n=arguments;return new Promise((function(i,o){var a=t.apply(e,n);function s(t){r(a,i,o,s,u,"next",t)}function u(t){r(a,i,o,s,u,"throw",t)}s(void 0)}))}},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(7);function i(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,n(i.key),i)}}t.exports=function(t,e,r){return e&&i(t.prototype,e),r&&i(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(t){return t&&t.__esModule?t:{default:t}},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(0).default,i=r(12);t.exports=function(t){var e=i(t,"string");return"symbol"==n(e)?e:e+""},t.exports.__esModule=!0,t.exports.default=t.exports},function(e,r){e.exports=t},function(t,e){t.exports=function(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=Array(e);r<e;r++)n[r]=t[r];return n},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i,o,a=r(0);"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[e,r(1),r(2),r(3),r(4),r(5),r(13),r(15),r(16),r(8),r(18),r(27)],void 0===(o="function"==typeof(n=function(t,e,n,i,o,s,u,c,f,l,h,p){"use strict";var d=r(6);function g(t){if("function"!=typeof WeakMap)return null;var e=new WeakMap,r=new WeakMap;return(g=function(t){return t?r:e})(t)}function v(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function y(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?v(Object(r),!0).forEach((function(e){(0,n.default)(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):v(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}function m(t,e,r){return e=(0,c.default)(e),(0,u.default)(t,function(){try{var t=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(t){}return!!t}()?Reflect.construct(e,r||[],(0,c.default)(t).constructor):e.apply(t,r))}Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"Queue",{enumerable:!0,get:function(){return p.Queue}}),t.default=void 0,Object.defineProperty(t,"granting",{enumerable:!0,get:function(){return p.default}}),e=d(e),n=d(n),i=d(i),o=d(o),s=d(s),u=d(u),c=d(c),f=d(f),l=d(l),p=function(t,e){if(!e&&t&&t.__esModule)return t;if(null===t||"object"!=a(t)&&"function"!=typeof t)return{default:t};var r=g(e);if(r&&r.has(t))return r.get(t);var n={__proto__:null},i=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in t)if("default"!==o&&{}.hasOwnProperty.call(t,o)){var s=i?Object.getOwnPropertyDescriptor(t,o):null;s&&(s.get||s.set)?Object.defineProperty(n,o,s):n[o]=t[o]}return n.default=t,r&&r.set(t,n),n}(p),t.default=function(t){function r(t){var e,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,o.default)(this,r);var i=t||l.default.create({timeout:3e4,headers:{post:{"Content-Type":"application/json;charset=UTF-8"}},emulateJSON:!0,withCredentials:!0});return(e=m(this,r,[{axios:i}]))._service=i,e.errMsg=n.errMsg||"Sorry, the request failed. Please try again later.",e._error=n.error,e}return(0,f.default)(r,t),(0,s.default)(r,[{key:"get",value:(a=(0,i.default)(e.default.mark((function t(){var r,n,i,o,a=arguments;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:for(r=a.length,n=new Array(r),i=0;i<r;i++)n[i]=a[i];return t.prev=1,n[1]=n[1]||{},n[1].params=n[1].params||{},n[1].params.r=n[1].params.r||Math.random().toString(36).substr(7),t.next=7,(o=this._service).get.apply(o,n);case 7:return t.abrupt("return",t.sent);case 10:return t.prev=10,t.t0=t.catch(1),this._error&&this._error(t.t0,n),t.abrupt("return",Promise.resolve({success:!1,status:"error",code:500,message:this.errMsg,"err-msg":this.errMsg}));case 14:case"end":return t.stop()}}),t,this,[[1,10]])}))),function(){return a.apply(this,arguments)})},{key:"post",value:(n=(0,i.default)(e.default.mark((function t(){var r,n,i,o,a,s,u=arguments;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:for(r=u.length,n=new Array(r),i=0;i<r;i++)n[i]=u[i];return o=n[1]||{},(a=o.restOptions)&&delete n[1].restOptions,n[2]=y({restOptions:a},n[2]||{}),t.prev=4,t.next=7,(s=this._service).post.apply(s,n);case 7:return t.abrupt("return",t.sent);case 10:return t.prev=10,t.t0=t.catch(4),this._error&&this._error(t.t0,n),t.abrupt("return",Promise.resolve({success:!1,status:"error",code:500,message:this.errMsg,"err-msg":this.errMsg}));case 14:case"end":return t.stop()}}),t,this,[[4,10]])}))),function(){return n.apply(this,arguments)})}]);var n,a}(h.RestConfig)})?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n=r(0).default;function i(){"use strict";
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */t.exports=i=function(){return r},t.exports.__esModule=!0,t.exports.default=t.exports;var e,r={},o=Object.prototype,a=o.hasOwnProperty,s=Object.defineProperty||function(t,e,r){t[e]=r.value},u="function"==typeof Symbol?Symbol:{},c=u.iterator||"@@iterator",f=u.asyncIterator||"@@asyncIterator",l=u.toStringTag||"@@toStringTag";function h(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{h({},"")}catch(e){h=function(t,e,r){return t[e]=r}}function p(t,e,r,n){var i=e&&e.prototype instanceof b?e:b,o=Object.create(i.prototype),a=new P(n||[]);return s(o,"_invoke",{value:A(t,r,a)}),o}function d(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}r.wrap=p;var g="suspendedStart",v="executing",y="completed",m={};function b(){}function x(){}function w(){}var T={};h(T,c,(function(){return this}));var S=Object.getPrototypeOf,E=S&&S(S(M([])));E&&E!==o&&a.call(E,c)&&(T=E);var O=w.prototype=b.prototype=Object.create(T);function _(t){["next","throw","return"].forEach((function(e){h(t,e,(function(t){return this._invoke(e,t)}))}))}function B(t,e){function r(i,o,s,u){var c=d(t[i],t,o);if("throw"!==c.type){var f=c.arg,l=f.value;return l&&"object"==n(l)&&a.call(l,"__await")?e.resolve(l.__await).then((function(t){r("next",t,s,u)}),(function(t){r("throw",t,s,u)})):e.resolve(l).then((function(t){f.value=t,s(f)}),(function(t){return r("throw",t,s,u)}))}u(c.arg)}var i;s(this,"_invoke",{value:function(t,n){function o(){return new e((function(e,i){r(t,n,e,i)}))}return i=i?i.then(o,o):o()}})}function A(t,r,n){var i=g;return function(o,a){if(i===v)throw Error("Generator is already running");if(i===y){if("throw"===o)throw a;return{value:e,done:!0}}for(n.method=o,n.arg=a;;){var s=n.delegate;if(s){var u=D(s,n);if(u){if(u===m)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(i===g)throw i=y,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);i=v;var c=d(t,r,n);if("normal"===c.type){if(i=n.done?y:"suspendedYield",c.arg===m)continue;return{value:c.arg,done:n.done}}"throw"===c.type&&(i=y,n.method="throw",n.arg=c.arg)}}}function D(t,r){var n=r.method,i=t.iterator[n];if(i===e)return r.delegate=null,"throw"===n&&t.iterator.return&&(r.method="return",r.arg=e,D(t,r),"throw"===r.method)||"return"!==n&&(r.method="throw",r.arg=new TypeError("The iterator does not provide a '"+n+"' method")),m;var o=d(i,t.iterator,r.arg);if("throw"===o.type)return r.method="throw",r.arg=o.arg,r.delegate=null,m;var a=o.arg;return a?a.done?(r[t.resultName]=a.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,m):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,m)}function C(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function k(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function P(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(C,this),this.reset(!0)}function M(t){if(t||""===t){var r=t[c];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var i=-1,o=function r(){for(;++i<t.length;)if(a.call(t,i))return r.value=t[i],r.done=!1,r;return r.value=e,r.done=!0,r};return o.next=o}}throw new TypeError(n(t)+" is not iterable")}return x.prototype=w,s(O,"constructor",{value:w,configurable:!0}),s(w,"constructor",{value:x,configurable:!0}),x.displayName=h(w,l,"GeneratorFunction"),r.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===x||"GeneratorFunction"===(e.displayName||e.name))},r.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,w):(t.__proto__=w,h(t,l,"GeneratorFunction")),t.prototype=Object.create(O),t},r.awrap=function(t){return{__await:t}},_(B.prototype),h(B.prototype,f,(function(){return this})),r.AsyncIterator=B,r.async=function(t,e,n,i,o){void 0===o&&(o=Promise);var a=new B(p(t,e,n,i),o);return r.isGeneratorFunction(e)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},_(O),h(O,l,"Generator"),h(O,c,(function(){return this})),h(O,"toString",(function(){return"[object Generator]"})),r.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},r.values=M,P.prototype={constructor:P,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(k),!t)for(var r in this)"t"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function n(n,i){return s.type="throw",s.arg=t,r.next=n,i&&(r.method="next",r.arg=e),!!i}for(var i=this.tryEntries.length-1;i>=0;--i){var o=this.tryEntries[i],s=o.completion;if("root"===o.tryLoc)return n("end");if(o.tryLoc<=this.prev){var u=a.call(o,"catchLoc"),c=a.call(o,"finallyLoc");if(u&&c){if(this.prev<o.catchLoc)return n(o.catchLoc,!0);if(this.prev<o.finallyLoc)return n(o.finallyLoc)}else if(u){if(this.prev<o.catchLoc)return n(o.catchLoc,!0)}else{if(!c)throw Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return n(o.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var i=n;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var o=i?i.completion:{};return o.type=t,o.arg=e,i?(this.method="next",this.next=i.finallyLoc,m):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),m},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),k(r),m}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;k(r)}return i}}throw Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:M(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),m}},r}t.exports=i,t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(0).default;t.exports=function(t,e){if("object"!=n(t)||!t)return t;var r=t[Symbol.toPrimitive];if(void 0!==r){var i=r.call(t,e||"default");if("object"!=n(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===e?String:Number)(t)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(0).default,i=r(14);t.exports=function(t,e){if(e&&("object"==n(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return i(t)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){function r(e){return t.exports=r=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)},t.exports.__esModule=!0,t.exports.default=t.exports,r(e)}t.exports=r,t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(17);t.exports=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&n(t,e)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){function r(e,n){return t.exports=r=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},t.exports.__esModule=!0,t.exports.default=t.exports,r(e,n)}t.exports=r,t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[e,r(1),r(19),r(0),r(3),r(2),r(4),r(5)],void 0===(o="function"==typeof(n=function(t,e,n,i,o,a,s,u){"use strict";var c=r(6);function f(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function l(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?f(Object(r),!0).forEach((function(e){(0,a.default)(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}Object.defineProperty(t,"__esModule",{value:!0}),t.RestConfig=void 0,e=c(e),n=c(n),i=c(i),o=c(o),a=c(a),s=c(s),u=c(u),t.RestConfig=function(){function t(e){(0,s.default)(this,t),e.axios&&this._installAxios(e.axios)}return(0,u.default)(t,[{key:"config",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.option=l({maxRetry:3},t),t.alias||console.warn("fed-rest: alias is undefined"),this._interceptors()}},{key:"_installAxios",value:function(t){this._service=t,this._service||console.warn("fed-rest: axios is undefined")}},{key:"_interceptors",value:function(){var n=this;this._service.interceptors.request.use((0,o.default)(e.default.mark((function t(){var i,o,a,s,u,c,f,h,p,d,g=arguments;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return i=g.length>0&&void 0!==g[0]?g[0]:{},o=r(24),t.next=4,o.vulcanVtoken();case 4:if(a=t.sent,s=a.vToken,u=a.version,n.option.alias&&Object.keys(n.option.alias).forEach((function(t){i.url.includes(t)&&(c=n.option.alias[t],f=t.replace(/\/$/,""),h=c.url.replace(/\/$/,""),p=n.option.granting[f],i.url=i.url.replace(f,h),"function"==typeof c.headers&&(i.headers=l(l({},i.headers),c.headers(i))),i.restOptions=l(l({},i.restOptions||{}),{},{aliasKey:f}),"function"==typeof c.restOptions&&(i.restOptions=l(l({},c.restOptions(i)),i.restOptions)))})),n.requestInterceptors&&n.requestInterceptors(i),i.restOptions&&i.restOptions.reqInterceptorsIgnore||!p){t.next=27;break}if(t.t0=n.option.beforeGranting,!t.t0){t.next=15;break}return t.next=14,n.option.beforeGranting(i);case 14:t.t0=t.sent;case 15:if(t.t0){t.next=20;break}return i.headers.vToken=s,i.headers.Webmark="v1".concat(u),t.abrupt("return",i);case 20:return t.next=22,p();case 22:return(d=t.sent)&&Object.assign(i.headers,l({},d)),i.headers.vToken=s,i.headers.Webmark="v1".concat(u),t.abrupt("return",i);case 27:return i.headers.vToken=s,i.headers.Webmark="v1".concat(u),t.abrupt("return",i);case 30:case"end":return t.stop()}}),t)})))),this._service.interceptors.response.use(function(){var r=(0,o.default)(e.default.mark((function r(i){var o,a,s,u,c,f,h,p,d,g;return e.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=i.config,a=i.config,u=(s=void 0===a?{}:a).restOptions,c=void 0===u?{}:u,f=s.restOptions,h=(void 0===f?{}:f).aliasKey,p=t.responseNormalization(i),d=n.option.granting[h],n.responseInterceptors&&n.responseInterceptors(i),o._requestCount=o._requestCount||0,!(!c.resInterceptorsIgnore&&n.option.resInterceptorsCode.includes(p.code)&&o._requestCount<n.option.maxRetry)){e.next=20;break}if(e.t0=n.option.beforeGranting,!e.t0){e.next=11;break}return e.next=10,n.option.beforeGranting(i);case 10:e.t0=e.sent;case 11:if(e.t0){e.next=14;break}return e.abrupt("return",p);case 14:return e.next=16,d(1);case 16:return(g=e.sent)&&Object.assign(o.headers,l({},g)),o._requestCount++,e.abrupt("return",n._service.request(o));case 20:return e.abrupt("return",p);case 21:case"end":return e.stop()}}),r)})));return function(t){return r.apply(this,arguments)}}())}}],[{key:"reformat",value:function(t,e,r){if("function"==typeof e)return e(t);var n={toHump:function(t){return t.replace(/[_-](\w)/g,(function(t,e){return e.toUpperCase()}))},toLine:function(t){return t.replace(/([A-Z])/g,"_$1").toLowerCase()},toMiddleLine:function(t){return t.replace(/([A-Z])/g,"-$1").toLowerCase()}}[e];return function t(e){if(!n)return e;for(var o in e)e.hasOwnProperty(o)&&("object"===(0,i.default)(e[o])&&t(e[o]),o!==n(o)&&(e[n(o)]=e[o],r&&delete e[o]));return e}(t)}},{key:"responseNormalization",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.request&&e.config?e.data:e,n=e.config,i=void 0===n?{}:n,o=i.restOptions,a=void 0===o?{}:o;return"string"==typeof r?r:(r.success=r.success||"ok"===r.status||200==+r.code,r.code=r.code||r["err-code"]||r.err_code||200,r.message=r.message||r["err-msg"]||r.err_msg||"",a.format?t.reformat(r,a.format,a.formatCleanup):r)}},{key:"setStorage",value:function(t,e,r){var i=[e],o=localStorage.getItem(t)||"";o&&(o=JSON.parse(o),Date.now()-o.time>o.expired?localStorage.removeItem(t):i=[].concat((0,n.default)(o.data),(0,n.default)(i)));var a={data:i,time:Date.now(),expired:r};localStorage.setItem(t,JSON.stringify(a))}}])}()})?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n=r(20),i=r(21),o=r(22),a=r(23);t.exports=function(t){return n(t)||i(t)||o(t)||a()},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(9);t.exports=function(t){if(Array.isArray(t))return n(t)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(9);t.exports=function(t,e){if(t){if("string"==typeof t)return n(t,e);var r={}.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(t,e):void 0}},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i;t.exports=(n=r(8),i=r(25),function(t){var e={};function r(n){if(e[n])return e[n].exports;var i=e[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)r.d(n,i,function(e){return t[e]}.bind(null,i));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=24)}([function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s=r(2);a=s(a),function(r,s){"object"===(0,a.default)(e)?t.exports=e=s():(i=[],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))}(0,(function(){var t=t||function(t,e){var r={},n=r.lib={},i=n.Base=function(){function t(){}return{extend:function(e){t.prototype=this;var r=new t;return e&&r.mixIn(e),r.hasOwnProperty("init")||(r.init=function(){r.$super.init.apply(this,arguments)}),r.init.prototype=r,r.$super=this,r},create:function(){var t=this.extend();return t.init.apply(t,arguments),t},init:function(){},mixIn:function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e]);t.hasOwnProperty("toString")&&(this.toString=t.toString)},clone:function(){return this.init.prototype.extend(this)}}}(),o=n.WordArray=i.extend({init:function(t,e){t=this.words=t||[],this.sigBytes=null!=e?e:4*t.length},toString:function(t){return(t||s).stringify(this)},concat:function(t){var e=this.words,r=t.words,n=this.sigBytes,i=t.sigBytes;if(this.clamp(),n%4)for(var o=0;o<i;o++){var a=r[o>>>2]>>>24-o%4*8&255;e[n+o>>>2]|=a<<24-(n+o)%4*8}else if(r.length>65535)for(o=0;o<i;o+=4)e[n+o>>>2]=r[o>>>2];else e.push.apply(e,r);return this.sigBytes+=i,this},clamp:function(){var e=this.words,r=this.sigBytes;e[r>>>2]&=4294967295<<32-r%4*8,e.length=t.ceil(r/4)},clone:function(){var t=i.clone.call(this);return t.words=this.words.slice(0),t},random:function(e){for(var r=[],n=0;n<e;n+=4)r.push(4294967296*t.random()|0);return new o.init(r,e)}}),a=r.enc={},s=a.Hex={stringify:function(t){for(var e=t.words,r=t.sigBytes,n=[],i=0;i<r;i++){var o=e[i>>>2]>>>24-i%4*8&255;n.push((o>>>4).toString(16)),n.push((15&o).toString(16))}return n.join("")},parse:function(t){for(var e=t.length,r=[],n=0;n<e;n+=2)r[n>>>3]|=parseInt(t.substr(n,2),16)<<24-n%8*4;return new o.init(r,e/2)}},u=a.Latin1={stringify:function(t){for(var e=t.words,r=t.sigBytes,n=[],i=0;i<r;i++){var o=e[i>>>2]>>>24-i%4*8&255;n.push(String.fromCharCode(o))}return n.join("")},parse:function(t){for(var e=t.length,r=[],n=0;n<e;n++)r[n>>>2]|=(255&t.charCodeAt(n))<<24-n%4*8;return new o.init(r,e)}},c=a.Utf8={stringify:function(t){try{return decodeURIComponent(escape(u.stringify(t)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function(t){return u.parse(unescape(encodeURIComponent(t)))}},f=n.BufferedBlockAlgorithm=i.extend({reset:function(){this._data=new o.init,this._nDataBytes=0},_append:function(t){"string"==typeof t&&(t=c.parse(t)),this._data.concat(t),this._nDataBytes+=t.sigBytes},_process:function(e){var r=this._data,n=r.words,i=r.sigBytes,a=this.blockSize,s=i/(4*a),u=(s=e?t.ceil(s):t.max((0|s)-this._minBufferSize,0))*a,c=t.min(4*u,i);if(u){for(var f=0;f<u;f+=a)this._doProcessBlock(n,f);var l=n.splice(0,u);r.sigBytes-=c}return new o.init(l,c)},clone:function(){var t=i.clone.call(this);return t._data=this._data.clone(),t},_minBufferSize:0}),l=(n.Hasher=f.extend({cfg:i.extend(),init:function(t){this.cfg=this.cfg.extend(t),this.reset()},reset:function(){f.reset.call(this),this._doReset()},update:function(t){return this._append(t),this._process(),this},finalize:function(t){return t&&this._append(t),this._doFinalize()},blockSize:16,_createHelper:function(t){return function(e,r){return new t.init(r).finalize(e)}},_createHmacHelper:function(t){return function(e,r){return new l.HMAC.init(t,r).finalize(e)}}}),r.algo={});return r}(Math);return t}))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e){function r(e){return t.exports=r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,r(e)}t.exports=r,t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(t){return t&&t.__esModule?t:{default:t}},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,void 0===(i="function"==typeof(n=function(){"use strict";t.exports={system:{IOS:/(iphone|ipad)/,windows:/(windows)/,android:/(android)/,linux:/(linux|cros)/,windowPhone:/(windows phone)/,macOS:/(mac)/},browser:{qqBrowser:/(qqbrowser)\/([\w.-]+)/,baiduBrowser:/M?(baidubrowser)\/([0-9.]*)/,maxthon:/(maxthon)\/([\w.-]+)/,opera:/(opr)\/([\w.-]+)/,edge:/(edge)\/([\w.-]+)/,internetExplorer:/(trident).+rv[:\s]([\w.]+).+like\sgecko/,canure:/(canure)\/([\w.-]+)/,camino:/(camino)\/([\w.-]+)/,cometBird:/(cometbird)\/([\w.-]+)/,comodoDragon:/(comododragon)\/([\w.-]+)/,chrome:/(chrome)\/([\w.-]+)/,safari:/(safari|version)\/([\w.-]+)/,common:/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox|firefox)\/([\w.-]+)/},browserKernel:{Gecko:/(); rv:([^)]+)\)/,Trident:/(); rv:([^)]+)\)/,common:/(webkit|khtml|presto|trident)\/([\w.-]+)/},apiUrl:{send:"/-/x/cr/v1/external/vulcan/data/send",config:"/-/x/cr/v1/external/vulcan/config",sdklog:"/-/x/cr/v1/external/vulcan/log/send_sdk_log"},aes:{key:"r&qsvWlCpc*PErEyB2B^wh9ftY7ploCI",iv:"r&qsvWlCpc*PErEy"},aes1:{key:"tIIiaGC#A7w)-sw$^Tj#&$Sq(kP@|pK5",iv:"I0)g)_F0Y4@z(t|F"},publicKey:"-----BEGIN PUBLIC KEY-----\n    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCkAd/cmlHNkcpMs3if5XJmDNhY\n    Q/+MCebM7kEv6t7t/6WSV1kwQEZJZjmKDaN6dHBahUjVNGXTDkaNdRBPDYBpeZDT\n    ULYE9hJxLFlFDSUHzofdvT618fakHVQg9geP46i2Lud13UVP/ehsZblV9NjpeIJW\n    C3UDjux6tt2FXjRPLwIDAQAB\n    -----END PUBLIC KEY-----",apiData:{type:null,platformType:3,businessLine:1,appVersion:"1.4.0",sdkVersion:"0.4.0",vToken:"0000000"},bridgeUrl:"https://www.hbabit.com",baseParameters:["hostname"],defaultScenesConfig:{cHash:"ffffffffffffffffffffffffffffffff",overdue:null,dataUpload:0,parameters:["sys","sys_ver","browser_name","browser_ver","kernel_name","kernel_ver","gpu_type","language","display_resolution","color_depth","total_memory","pixel_ratio","time_zone","session_enable","storage_enable","indexeddb_enable","websql_enable","do_not_track","is_alphago","canvas_crc","fonts","e_devices","audio_hash","webgl_hash","uid","uuid","env_info","hostname"]},vTokenParameters:["audio_hash","canvas_crc","gpu_type","uuid","webgl_hash"],vTokenPm:["uuid","time_zone"]}})?n.apply(e,[]):n)||(t.exports=i)},function(t,e,r){var n,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,void 0===(i="function"==typeof(n=function(){"use strict";t.exports={getStore:function(t){if("undefined"!=typeof window&&window.localStorage){var e=window.localStorage.getItem(t);try{return JSON.parse(e)}catch(t){return e}}},setStore:function(t,e){if("undefined"!=typeof window&&window.localStorage)try{window.localStorage.setItem(t,"string"==typeof e?e:JSON.stringify(e))}catch(t){console.log(t)}},removeStore:function(t){try{window.localStorage.removeItem(t)}catch(t){console.log(t)}},debug:function(){var t=Array.prototype.slice.call(arguments);this.getStore("HB-VULCAN-DEBUG")&&console.log("VULCAN-JS-SDK:",t)},isBrowser:function(){return"undefined"!=typeof window},domReady:function(t){function e(){t&&t()}"loading"===document.readyState?document.addEventListener("DOMContentLoaded",e):e()},generateUUID:function(){var t=(new Date).getTime();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var r=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"===e?r:3&r|8).toString(16)}))},getHost:function(){if("undefined"!=typeof window){var t=location.hostname.split(".");return t.shift(),t.join(".")}return""}}})?n.apply(e,[]):n)||(t.exports=i)},function(t,e,r){var n=r(25)();t.exports=n;try{regeneratorRuntime=n}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}},function(t,e){function r(t,e,r,n,i,o,a){try{var s=t[o](a),u=s.value}catch(t){return void r(t)}s.done?e(u):Promise.resolve(u).then(n,i)}t.exports=function(t){return function(){var e=this,n=arguments;return new Promise((function(i,o){var a=t.apply(e,n);function s(t){r(a,i,o,s,u,"next",t)}function u(t){r(a,i,o,s,u,"throw",t)}s(void 0)}))}},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){var e,r;return r=(e=t).lib.WordArray,e.enc.Base64={stringify:function(t){var e=t.words,r=t.sigBytes,n=this._map;t.clamp();for(var i=[],o=0;o<r;o+=3)for(var a=(e[o>>>2]>>>24-o%4*8&255)<<16|(e[o+1>>>2]>>>24-(o+1)%4*8&255)<<8|e[o+2>>>2]>>>24-(o+2)%4*8&255,s=0;s<4&&o+.75*s<r;s++)i.push(n.charAt(a>>>6*(3-s)&63));var u=n.charAt(64);if(u)for(;i.length%4;)i.push(u);return i.join("")},parse:function(t){var e=t.length,n=this._map,i=n.charAt(64);if(i){var o=t.indexOf(i);-1!=o&&(e=o)}for(var a=[],s=0,u=0;u<e;u++)if(u%4){var c=n.indexOf(t.charAt(u-1))<<u%4*2,f=n.indexOf(t.charAt(u))>>>6-u%4*2;a[s>>>2]|=(c|f)<<24-s%4*8,s++}return r.create(a,s)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},t.enc.Base64},"object"===(0,a.default)(e)?t.exports=e=s(r(0)):(i=[r(0)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){return function(e){var r=t,n=r.lib,i=n.WordArray,o=n.Hasher,a=r.algo,s=[];!function(){for(var t=0;t<64;t++)s[t]=4294967296*e.abs(e.sin(t+1))|0}();var u=a.MD5=o.extend({_doReset:function(){this._hash=new i.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(t,e){for(var r=0;r<16;r++){var n=e+r,i=t[n];t[n]=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8)}var o=this._hash.words,a=t[e+0],u=t[e+1],p=t[e+2],d=t[e+3],g=t[e+4],v=t[e+5],y=t[e+6],m=t[e+7],b=t[e+8],x=t[e+9],w=t[e+10],T=t[e+11],S=t[e+12],E=t[e+13],O=t[e+14],_=t[e+15],B=o[0],A=o[1],D=o[2],C=o[3];B=c(B,A,D,C,a,7,s[0]),C=c(C,B,A,D,u,12,s[1]),D=c(D,C,B,A,p,17,s[2]),A=c(A,D,C,B,d,22,s[3]),B=c(B,A,D,C,g,7,s[4]),C=c(C,B,A,D,v,12,s[5]),D=c(D,C,B,A,y,17,s[6]),A=c(A,D,C,B,m,22,s[7]),B=c(B,A,D,C,b,7,s[8]),C=c(C,B,A,D,x,12,s[9]),D=c(D,C,B,A,w,17,s[10]),A=c(A,D,C,B,T,22,s[11]),B=c(B,A,D,C,S,7,s[12]),C=c(C,B,A,D,E,12,s[13]),D=c(D,C,B,A,O,17,s[14]),B=f(B,A=c(A,D,C,B,_,22,s[15]),D,C,u,5,s[16]),C=f(C,B,A,D,y,9,s[17]),D=f(D,C,B,A,T,14,s[18]),A=f(A,D,C,B,a,20,s[19]),B=f(B,A,D,C,v,5,s[20]),C=f(C,B,A,D,w,9,s[21]),D=f(D,C,B,A,_,14,s[22]),A=f(A,D,C,B,g,20,s[23]),B=f(B,A,D,C,x,5,s[24]),C=f(C,B,A,D,O,9,s[25]),D=f(D,C,B,A,d,14,s[26]),A=f(A,D,C,B,b,20,s[27]),B=f(B,A,D,C,E,5,s[28]),C=f(C,B,A,D,p,9,s[29]),D=f(D,C,B,A,m,14,s[30]),B=l(B,A=f(A,D,C,B,S,20,s[31]),D,C,v,4,s[32]),C=l(C,B,A,D,b,11,s[33]),D=l(D,C,B,A,T,16,s[34]),A=l(A,D,C,B,O,23,s[35]),B=l(B,A,D,C,u,4,s[36]),C=l(C,B,A,D,g,11,s[37]),D=l(D,C,B,A,m,16,s[38]),A=l(A,D,C,B,w,23,s[39]),B=l(B,A,D,C,E,4,s[40]),C=l(C,B,A,D,a,11,s[41]),D=l(D,C,B,A,d,16,s[42]),A=l(A,D,C,B,y,23,s[43]),B=l(B,A,D,C,x,4,s[44]),C=l(C,B,A,D,S,11,s[45]),D=l(D,C,B,A,_,16,s[46]),B=h(B,A=l(A,D,C,B,p,23,s[47]),D,C,a,6,s[48]),C=h(C,B,A,D,m,10,s[49]),D=h(D,C,B,A,O,15,s[50]),A=h(A,D,C,B,v,21,s[51]),B=h(B,A,D,C,S,6,s[52]),C=h(C,B,A,D,d,10,s[53]),D=h(D,C,B,A,w,15,s[54]),A=h(A,D,C,B,u,21,s[55]),B=h(B,A,D,C,b,6,s[56]),C=h(C,B,A,D,_,10,s[57]),D=h(D,C,B,A,y,15,s[58]),A=h(A,D,C,B,E,21,s[59]),B=h(B,A,D,C,g,6,s[60]),C=h(C,B,A,D,T,10,s[61]),D=h(D,C,B,A,p,15,s[62]),A=h(A,D,C,B,x,21,s[63]),o[0]=o[0]+B|0,o[1]=o[1]+A|0,o[2]=o[2]+D|0,o[3]=o[3]+C|0},_doFinalize:function(){var t=this._data,r=t.words,n=8*this._nDataBytes,i=8*t.sigBytes;r[i>>>5]|=128<<24-i%32;var o=e.floor(n/4294967296),a=n;r[15+(i+64>>>9<<4)]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),r[14+(i+64>>>9<<4)]=16711935&(a<<8|a>>>24)|4278255360&(a<<24|a>>>8),t.sigBytes=4*(r.length+1),this._process();for(var s=this._hash,u=s.words,c=0;c<4;c++){var f=u[c];u[c]=16711935&(f<<8|f>>>24)|4278255360&(f<<24|f>>>8)}return s},clone:function(){var t=o.clone.call(this);return t._hash=this._hash.clone(),t}});function c(t,e,r,n,i,o,a){var s=t+(e&r|~e&n)+i+a;return(s<<o|s>>>32-o)+e}function f(t,e,r,n,i,o,a){var s=t+(e&n|r&~n)+i+a;return(s<<o|s>>>32-o)+e}function l(t,e,r,n,i,o,a){var s=t+(e^r^n)+i+a;return(s<<o|s>>>32-o)+e}function h(t,e,r,n,i,o,a){var s=t+(r^(e|~n))+i+a;return(s<<o|s>>>32-o)+e}r.MD5=o._createHelper(u),r.HmacMD5=o._createHmacHelper(u)}(Math),t.MD5},"object"===(0,a.default)(e)?t.exports=e=s(r(0)):(i=[r(0)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){var e,r,n,i,o,a,s;return n=(r=(e=t).lib).Base,i=r.WordArray,a=(o=e.algo).MD5,s=o.EvpKDF=n.extend({cfg:n.extend({keySize:4,hasher:a,iterations:1}),init:function(t){this.cfg=this.cfg.extend(t)},compute:function(t,e){for(var r=this.cfg,n=r.hasher.create(),o=i.create(),a=o.words,s=r.keySize,u=r.iterations;a.length<s;){c&&n.update(c);var c=n.update(t).finalize(e);n.reset();for(var f=1;f<u;f++)c=n.finalize(c),n.reset();o.concat(c)}return o.sigBytes=4*s,o}}),e.EvpKDF=function(t,e,r){return s.create(r).compute(t,e)},t.EvpKDF},"object"===(0,a.default)(e)?t.exports=e=s(r(0),r(16),r(17)):(i=[r(0),r(16),r(17)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,void 0===(i="function"==typeof(n=function(){"use strict";var e=r(13),n=r(28),i=r(3),o=i.aes,a=i.publicKey,s={random:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:2;return e.lib.WordArray.random(t/2).toString()},strToBase64:function(t){return window&&window.btoa?window.btoa(t):e.enc.Base64.stringify(e.enc.Utf8.parse(t))},Base64ToStr:function(t){return window&&window.atob?window.atob(t):e.enc.Utf8.stringify(e.enc.Base64.parse(t))},rsaEncrypt:function(t){var e=s.rsa||new n;return e.setPublicKey(a),s.rsa=e,e.encrypt(t)},aesEncrypt:function(t,r,n){var i=e.enc.Utf8.parse(t),o=e.enc.Utf8.parse(r),a=e.AES.encrypt(i,o,{iv:e.enc.Utf8.parse(n)});return e.enc.Base64.stringify(a.ciphertext)},aesDecrypt:function(t,r,n){var i=e.AES.decrypt(t,e.enc.Utf8.parse(r),{iv:e.enc.Utf8.parse(n)});return e.enc.Utf8.stringify(i)},encrypt:function(t){var r=e.SHA256(s.random(32)).toString(e.enc.Hex),n=r.slice(0,r.length/2),i=r.slice(-16),o=t||"";return{p0:s.aesEncrypt(o,n,i),k0:s.rsaEncrypt("".concat(s.strToBase64(n),"\n").concat(s.strToBase64(i)))}},decrypt:function(t){return s.aesDecrypt(t,o.key,o.iv)}};t.exports=s})?n.apply(e,[]):n)||(t.exports=i)},function(t,e,r){var n=r(12);t.exports=function(t,e,r){return(e=n(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(1).default,i=r(26);t.exports=function(t){var e=i(t,"string");return"symbol"===n(e)?e:String(e)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){return t},"object"===(0,a.default)(e)?t.exports=e=s(r(0),r(7),r(8),r(14),r(15)):(i=[r(0),r(7),r(8),r(14),r(15)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){return function(e){var r=t,n=r.lib,i=n.WordArray,o=n.Hasher,a=r.algo,s=[],u=[];!function(){function t(t){for(var r=e.sqrt(t),n=2;n<=r;n++)if(!(t%n))return!1;return!0}function r(t){return 4294967296*(t-(0|t))|0}for(var n=2,i=0;i<64;)t(n)&&(i<8&&(s[i]=r(e.pow(n,.5))),u[i]=r(e.pow(n,1/3)),i++),n++}();var c=[],f=a.SHA256=o.extend({_doReset:function(){this._hash=new i.init(s.slice(0))},_doProcessBlock:function(t,e){for(var r=this._hash.words,n=r[0],i=r[1],o=r[2],a=r[3],s=r[4],f=r[5],l=r[6],h=r[7],p=0;p<64;p++){if(p<16)c[p]=0|t[e+p];else{var d=c[p-15],g=(d<<25|d>>>7)^(d<<14|d>>>18)^d>>>3,v=c[p-2],y=(v<<15|v>>>17)^(v<<13|v>>>19)^v>>>10;c[p]=g+c[p-7]+y+c[p-16]}var m=n&i^n&o^i&o,b=(n<<30|n>>>2)^(n<<19|n>>>13)^(n<<10|n>>>22),x=h+((s<<26|s>>>6)^(s<<21|s>>>11)^(s<<7|s>>>25))+(s&f^~s&l)+u[p]+c[p];h=l,l=f,f=s,s=a+x|0,a=o,o=i,i=n,n=x+(b+m)|0}r[0]=r[0]+n|0,r[1]=r[1]+i|0,r[2]=r[2]+o|0,r[3]=r[3]+a|0,r[4]=r[4]+s|0,r[5]=r[5]+f|0,r[6]=r[6]+l|0,r[7]=r[7]+h|0},_doFinalize:function(){var t=this._data,r=t.words,n=8*this._nDataBytes,i=8*t.sigBytes;return r[i>>>5]|=128<<24-i%32,r[14+(i+64>>>9<<4)]=e.floor(n/4294967296),r[15+(i+64>>>9<<4)]=n,t.sigBytes=4*r.length,this._process(),this._hash},clone:function(){var t=o.clone.call(this);return t._hash=this._hash.clone(),t}});r.SHA256=o._createHelper(f),r.HmacSHA256=o._createHmacHelper(f)}(Math),t.SHA256},"object"===(0,a.default)(e)?t.exports=e=s(r(0)):(i=[r(0)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){return function(){var e=t,r=e.lib.BlockCipher,n=e.algo,i=[],o=[],a=[],s=[],u=[],c=[],f=[],l=[],h=[],p=[];!function(){for(var t=[],e=0;e<256;e++)t[e]=e<128?e<<1:e<<1^283;var r=0,n=0;for(e=0;e<256;e++){var d=n^n<<1^n<<2^n<<3^n<<4;d=d>>>8^255&d^99,i[r]=d,o[d]=r;var g=t[r],v=t[g],y=t[v],m=257*t[d]^16843008*d;a[r]=m<<24|m>>>8,s[r]=m<<16|m>>>16,u[r]=m<<8|m>>>24,c[r]=m,m=16843009*y^65537*v^257*g^16843008*r,f[d]=m<<24|m>>>8,l[d]=m<<16|m>>>16,h[d]=m<<8|m>>>24,p[d]=m,r?(r=g^t[t[t[y^g]]],n^=t[t[n]]):r=n=1}}();var d=[0,1,2,4,8,16,32,64,128,27,54],g=n.AES=r.extend({_doReset:function(){for(var t=this._key,e=t.words,r=t.sigBytes/4,n=4*((this._nRounds=r+6)+1),o=this._keySchedule=[],a=0;a<n;a++)if(a<r)o[a]=e[a];else{var s=o[a-1];a%r?r>6&&a%r==4&&(s=i[s>>>24]<<24|i[s>>>16&255]<<16|i[s>>>8&255]<<8|i[255&s]):(s=i[(s=s<<8|s>>>24)>>>24]<<24|i[s>>>16&255]<<16|i[s>>>8&255]<<8|i[255&s],s^=d[a/r|0]<<24),o[a]=o[a-r]^s}for(var u=this._invKeySchedule=[],c=0;c<n;c++)a=n-c,s=c%4?o[a]:o[a-4],u[c]=c<4||a<=4?s:f[i[s>>>24]]^l[i[s>>>16&255]]^h[i[s>>>8&255]]^p[i[255&s]]},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._keySchedule,a,s,u,c,i)},decryptBlock:function(t,e){var r=t[e+1];t[e+1]=t[e+3],t[e+3]=r,this._doCryptBlock(t,e,this._invKeySchedule,f,l,h,p,o),r=t[e+1],t[e+1]=t[e+3],t[e+3]=r},_doCryptBlock:function(t,e,r,n,i,o,a,s){for(var u=this._nRounds,c=t[e]^r[0],f=t[e+1]^r[1],l=t[e+2]^r[2],h=t[e+3]^r[3],p=4,d=1;d<u;d++){var g=n[c>>>24]^i[f>>>16&255]^o[l>>>8&255]^a[255&h]^r[p++],v=n[f>>>24]^i[l>>>16&255]^o[h>>>8&255]^a[255&c]^r[p++],y=n[l>>>24]^i[h>>>16&255]^o[c>>>8&255]^a[255&f]^r[p++],m=n[h>>>24]^i[c>>>16&255]^o[f>>>8&255]^a[255&l]^r[p++];c=g,f=v,l=y,h=m}g=(s[c>>>24]<<24|s[f>>>16&255]<<16|s[l>>>8&255]<<8|s[255&h])^r[p++],v=(s[f>>>24]<<24|s[l>>>16&255]<<16|s[h>>>8&255]<<8|s[255&c])^r[p++],y=(s[l>>>24]<<24|s[h>>>16&255]<<16|s[c>>>8&255]<<8|s[255&f])^r[p++],m=(s[h>>>24]<<24|s[c>>>16&255]<<16|s[f>>>8&255]<<8|s[255&l])^r[p++],t[e]=g,t[e+1]=v,t[e+2]=y,t[e+3]=m},keySize:8});e.AES=r._createHelper(g)}(),t.AES},"object"===(0,a.default)(e)?t.exports=e=s(r(0),r(7),r(8),r(9),r(18)):(i=[r(0),r(7),r(8),r(9),r(18)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){var e,r,n,i,o,a,s;return r=(e=t).lib,n=r.WordArray,i=r.Hasher,o=e.algo,a=[],s=o.SHA1=i.extend({_doReset:function(){this._hash=new n.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(t,e){for(var r=this._hash.words,n=r[0],i=r[1],o=r[2],s=r[3],u=r[4],c=0;c<80;c++){if(c<16)a[c]=0|t[e+c];else{var f=a[c-3]^a[c-8]^a[c-14]^a[c-16];a[c]=f<<1|f>>>31}var l=(n<<5|n>>>27)+u+a[c];l+=c<20?1518500249+(i&o|~i&s):c<40?1859775393+(i^o^s):c<60?(i&o|i&s|o&s)-1894007588:(i^o^s)-899497514,u=s,s=o,o=i<<30|i>>>2,i=n,n=l}r[0]=r[0]+n|0,r[1]=r[1]+i|0,r[2]=r[2]+o|0,r[3]=r[3]+s|0,r[4]=r[4]+u|0},_doFinalize:function(){var t=this._data,e=t.words,r=8*this._nDataBytes,n=8*t.sigBytes;return e[n>>>5]|=128<<24-n%32,e[14+(n+64>>>9<<4)]=Math.floor(r/4294967296),e[15+(n+64>>>9<<4)]=r,t.sigBytes=4*e.length,this._process(),this._hash},clone:function(){var t=i.clone.call(this);return t._hash=this._hash.clone(),t}}),e.SHA1=i._createHelper(s),e.HmacSHA1=i._createHmacHelper(s),t.SHA1},"object"===(0,a.default)(e)?t.exports=e=s(r(0)):(i=[r(0)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s,u=r(2);a=u(a),s=function(t){var e,r,n;r=(e=t).lib.Base,n=e.enc.Utf8,e.algo.HMAC=r.extend({init:function(t,e){t=this._hasher=new t.init,"string"==typeof e&&(e=n.parse(e));var r=t.blockSize,i=4*r;e.sigBytes>i&&(e=t.finalize(e)),e.clamp();for(var o=this._oKey=e.clone(),a=this._iKey=e.clone(),s=o.words,u=a.words,c=0;c<r;c++)s[c]^=1549556828,u[c]^=909522486;o.sigBytes=a.sigBytes=i,this.reset()},reset:function(){var t=this._hasher;t.reset(),t.update(this._iKey)},update:function(t){return this._hasher.update(t),this},finalize:function(t){var e=this._hasher,r=e.finalize(t);return e.reset(),e.finalize(this._oKey.clone().concat(r))}})},"object"===(0,a.default)(e)?t.exports=e=s(r(0)):(i=[r(0)],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s=r(2);a=s(a),function(s,u,c){"object"===(0,a.default)(e)?t.exports=e=u(r(0),r(9)):(i=[r(0),r(9)],void 0===(o="function"==typeof(n=u)?n.apply(e,i):n)||(t.exports=o))}(0,(function(t){var e,r,n,i,o,a,s,u,c,f,l,h,p,d,g,v,y,m;t.lib.Cipher||(n=(r=(e=t).lib).Base,i=r.WordArray,o=r.BufferedBlockAlgorithm,(a=e.enc).Utf8,s=a.Base64,u=e.algo.EvpKDF,c=r.Cipher=o.extend({cfg:n.extend(),createEncryptor:function(t,e){return this.create(this._ENC_XFORM_MODE,t,e)},createDecryptor:function(t,e){return this.create(this._DEC_XFORM_MODE,t,e)},init:function(t,e,r){this.cfg=this.cfg.extend(r),this._xformMode=t,this._key=e,this.reset()},reset:function(){o.reset.call(this),this._doReset()},process:function(t){return this._append(t),this._process()},finalize:function(t){return t&&this._append(t),this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(){function t(t){return"string"==typeof t?m:v}return function(e){return{encrypt:function(r,n,i){return t(n).encrypt(e,r,n,i)},decrypt:function(r,n,i){return t(n).decrypt(e,r,n,i)}}}}()}),r.StreamCipher=c.extend({_doFinalize:function(){return this._process(!0)},blockSize:1}),f=e.mode={},l=r.BlockCipherMode=n.extend({createEncryptor:function(t,e){return this.Encryptor.create(t,e)},createDecryptor:function(t,e){return this.Decryptor.create(t,e)},init:function(t,e){this._cipher=t,this._iv=e}}),h=f.CBC=function(){var t=l.extend();function e(t,e,r){var n=this._iv;if(n){var i=n;this._iv=void 0}else i=this._prevBlock;for(var o=0;o<r;o++)t[e+o]^=i[o]}return t.Encryptor=t.extend({processBlock:function(t,r){var n=this._cipher,i=n.blockSize;e.call(this,t,r,i),n.encryptBlock(t,r),this._prevBlock=t.slice(r,r+i)}}),t.Decryptor=t.extend({processBlock:function(t,r){var n=this._cipher,i=n.blockSize,o=t.slice(r,r+i);n.decryptBlock(t,r),e.call(this,t,r,i),this._prevBlock=o}}),t}(),p=(e.pad={}).Pkcs7={pad:function(t,e){for(var r=4*e,n=r-t.sigBytes%r,o=n<<24|n<<16|n<<8|n,a=[],s=0;s<n;s+=4)a.push(o);var u=i.create(a,n);t.concat(u)},unpad:function(t){var e=255&t.words[t.sigBytes-1>>>2];t.sigBytes-=e}},r.BlockCipher=c.extend({cfg:c.cfg.extend({mode:h,padding:p}),reset:function(){c.reset.call(this);var t=this.cfg,e=t.iv,r=t.mode;if(this._xformMode==this._ENC_XFORM_MODE)var n=r.createEncryptor;else n=r.createDecryptor,this._minBufferSize=1;this._mode=n.call(r,this,e&&e.words)},_doProcessBlock:function(t,e){this._mode.processBlock(t,e)},_doFinalize:function(){var t=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){t.pad(this._data,this.blockSize);var e=this._process(!0)}else e=this._process(!0),t.unpad(e);return e},blockSize:4}),d=r.CipherParams=n.extend({init:function(t){this.mixIn(t)},toString:function(t){return(t||this.formatter).stringify(this)}}),g=(e.format={}).OpenSSL={stringify:function(t){var e=t.ciphertext,r=t.salt;if(r)var n=i.create([1398893684,1701076831]).concat(r).concat(e);else n=e;return n.toString(s)},parse:function(t){var e=s.parse(t),r=e.words;if(1398893684==r[0]&&1701076831==r[1]){var n=i.create(r.slice(2,4));r.splice(0,4),e.sigBytes-=16}return d.create({ciphertext:e,salt:n})}},v=r.SerializableCipher=n.extend({cfg:n.extend({format:g}),encrypt:function(t,e,r,n){n=this.cfg.extend(n);var i=t.createEncryptor(r,n),o=i.finalize(e),a=i.cfg;return d.create({ciphertext:o,key:r,iv:a.iv,algorithm:t,mode:a.mode,padding:a.padding,blockSize:t.blockSize,formatter:n.format})},decrypt:function(t,e,r,n){return n=this.cfg.extend(n),e=this._parse(e,n.format),t.createDecryptor(r,n).finalize(e.ciphertext)},_parse:function(t,e){return"string"==typeof t?e.parse(t,this):t}}),y=(e.kdf={}).OpenSSL={execute:function(t,e,r,n){n||(n=i.random(8));var o=u.create({keySize:e+r}).compute(t,n),a=i.create(o.words.slice(e),4*r);return o.sigBytes=4*e,d.create({key:o,iv:a,salt:n})}},m=r.PasswordBasedCipher=v.extend({cfg:v.cfg.extend({kdf:y}),encrypt:function(t,e,r,n){var i=(n=this.cfg.extend(n)).kdf.execute(r,t.keySize,t.ivSize);n.iv=i.iv;var o=v.encrypt.call(this,t,e,i.key,n);return o.mixIn(i),o},decrypt:function(t,e,r,n){n=this.cfg.extend(n),e=this._parse(e,n.format);var i=n.kdf.execute(r,t.keySize,t.ivSize,e.salt);return n.iv=i.iv,v.decrypt.call(this,t,e,i.key,n)}}))}))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e){t.exports=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(12);function i(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,n(i.key),i)}}t.exports=function(t,e,r){return e&&i(t.prototype,e),r&&i(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){t.exports=function(){"use strict";function t(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var n in r)t[n]=r[n]}return t}return function e(r,n){function i(e,i,o){if("undefined"!=typeof document){"number"==typeof(o=t({},n,o)).expires&&(o.expires=new Date(Date.now()+864e5*o.expires)),o.expires&&(o.expires=o.expires.toUTCString()),e=encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var a="";for(var s in o)o[s]&&(a+="; "+s,!0!==o[s]&&(a+="="+o[s].split(";")[0]));return document.cookie=e+"="+r.write(i,e)+a}}return Object.create({set:i,get:function(t){if("undefined"!=typeof document&&(!arguments.length||t)){for(var e=document.cookie?document.cookie.split("; "):[],n={},i=0;i<e.length;i++){var o=e[i].split("="),a=o.slice(1).join("=");try{var s=decodeURIComponent(o[0]);if(n[s]=r.read(a,s),t===s)break}catch(t){}}return t?n[t]:n}},remove:function(e,r){i(e,"",t({},r,{expires:-1}))},withAttributes:function(r){return e(this.converter,t({},this.attributes,r))},withConverter:function(r){return e(t({},this.converter,r),this.attributes)}},{attributes:{value:Object.freeze(n)},converter:{value:Object.freeze(r)}})}({read:function(t){return'"'===t[0]&&(t=t.slice(1,-1)),t.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(t){return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"})}()},function(t,e){t.exports=function(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=new Array(e);r<e;r++)n[r]=t[r];return n},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(5),r(6),r(11),r(19),r(20)],void 0===(o="function"==typeof(n=function(e,n,i,o,a){"use strict";var s=r(2);function u(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function c(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?u(Object(r),!0).forEach((function(e){(0,i.default)(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):u(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}e=s(e),n=s(n),i=s(i),o=s(o),a=s(a);var f=r(35),l=r(3),h=l.apiUrl,p=l.apiData,d=l.defaultScenesConfig,g=r(10).decrypt,v=r(4),y=(r(10).aesEncrypt,"function"==typeof f.create?f:f.default),m=y.create({timeout:3e3,headers:{post:{"Content-Type":"application/json;charset=UTF-8"}},emulateJSON:!0,withCredentials:!1}),b=(y.create({timeout:3e3,headers:{post:{"Content-Type":"text/plain"}},emulateJSON:!0,withCredentials:!1}),function(){function t(){(0,o.default)(this,t),this.options={offline:!1},this.configsCache={}}var r,i;return(0,a.default)(t,[{key:"apiUrlHandler",value:function(t){return function(t,e,r){return r&&"/"===e.slice(0,1)&&(e=e.slice(1)),t?"".concat(t).concat(e):e}(this.options.origin,t,this.options.offline)}},{key:"sendApi",value:function(t,e){var r=this.apiUrlHandler(h.send),n=c({},t),i=c({},e);return m.post(r,n,{params:i})}},{key:"configApi",value:function(t,e){var r=this.apiUrlHandler(h.config),n=this.options,i=n.platformType,o=n.businessLine,a=c(c({},p),t);a.platformType=i||a.platformType,a.businessLine=o||a.businessLine,a.type=a.type?a.type:a.scenes?1:0;var s=c({},e);return m.post(r,a,{params:s})}},{key:"setting",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.keys(t).length&&(this.options=t)}},{key:"getScenesConfig",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments.length>1?arguments[1]:void 0,r=t.filter((function(t){return t.scenes===e}))[0]||{parameters:[]};return e||(r.parameters=d.parameters.reduce((function(t,e){return r.parameters.includes(e)||t.push(e),t}),[])),r}},{key:"isValid",value:function(t,e){var r=this.getScenesConfig(t,e).overdue;return+new Date<r}},{key:"getConfig",value:(i=(0,n.default)(e.default.mark((function r(n){var i,o,a,s,u,f,l,h;return e.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(i=+n||0,o=v.getStore("HB-VULCAN-CONFIG-".concat(i)),a=!1,!this.configsCache[i]&&o&&(this.configsCache[i]=t.parseConfig(o)),!this.configsCache[i]||!this.isValid(this.configsCache[i],i)){e.next=9;break}s=this.configsCache[i],a=!1,e.next=27;break;case 9:return e.prev=9,e.next=12,this.configApi({scenes:i});case 12:if(u=e.sent,f=u.data,l=f.data,200===f.code){e.next=18;break}return e.abrupt("return",d);case 18:s=t.parseConfig(l),this.configsCache[i]=s,v.setStore("HB-VULCAN-CONFIG-".concat(i),l),a=!0,e.next=27;break;case 24:return e.prev=24,e.t0=e.catch(9),e.abrupt("return",d);case 27:return h=this.getScenesConfig(s,i)||d,v.debug("getConfig","scenes:".concat(i),h),e.abrupt("return",c(c({},h),{},{isUpdate:a}));case 30:case"end":return e.stop()}}),r,this,[[9,24]])}))),function(t){return i.apply(this,arguments)})},{key:"send",value:(r=(0,n.default)(e.default.mark((function t(r){var n,i;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return v.debug("send",r),t.next=3,this.sendApi(c({},r));case 3:return n=t.sent,200!==(i=n.data).code?v.setStore("HB-VULCAN-SEND-".concat(r.cHash),0):v.setStore("HB-VULCAN-SEND-".concat(r.cHash),1),t.abrupt("return",i);case 8:case"end":return t.stop()}}),t,this)}))),function(t){return r.apply(this,arguments)})}],[{key:"parseConfig",value:function(t){var e=null;try{e=JSON.parse(g(t)||"[]")}catch(t){e=[]}return e}}]),t}());t.exports=b})?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(5),r(11),r(6)],void 0===(o="function"==typeof(n=function(e,n,i){"use strict";var o=r(2);function a(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function s(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?a(Object(r),!0).forEach((function(e){(0,n.default)(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):a(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}e=o(e),n=o(n),i=o(i);var u=r(13),c=r(27),f=r(23),l=r(10),h=l.encrypt,p=l.strToBase64,d=l.aesEncrypt,g=l.aesDecrypt,v=l.Base64ToStr,y=r(4),m=r(3),b=m.baseParameters,x=m.vTokenParameters,w=m.apiData,T=m.vTokenPm,S=new f,E=new c,O={vulcanInfo:null,options:{platformType:w.platformType,businessLine:w.businessLine}},_={initialize:function(){var t=arguments;return(0,i.default)(e.default.mark((function r(){var n,i,o;return e.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.length>0&&void 0!==t[0]?t[0]:{},i=t.length>1&&void 0!==t[1]?t[1]:{},o=n.debug,O.options=s({},n),S.setting(O.options),_.extendData=i,_.scenes(0),o?y.setStore("HB-VULCAN-DEBUG",1):y.removeStore("HB-VULCAN-DEBUG"),e.abrupt("return",{code:200,message:"success",data:n});case 9:case"end":return e.stop()}}),r)})))()},scenes:function(t){var r=arguments;return(0,i.default)(e.default.mark((function n(){var i,o,a,c,f,l,d,g,v,m,T,B,A,D,C,k,P;return e.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(i=r.length>1&&void 0!==r[1]?r[1]:{},!isNaN(+t)){e.next=3;break}return e.abrupt("return",console.warn('VULCAN-JS-SDK: scenes code "'.concat(t,'" is invalid, must be a number')));case 3:return e.next=5,S.getConfig(t);case 5:return o=e.sent,a=o.cHash,c=void 0===a?null:a,f=o.dataUpload,l=o.parameters,d=o.isUpdate,e.next=13,E.getInfo(l.concat(b));case 13:return g=e.sent,v=g.info,m=g.fpToken,e.next=18,E.getInfo(x);case 18:return T=e.sent,B=T.token,A=s(s({},_.extendData),i),v=s(s({},v),{},{vtoken:B,chash:c}),O.vulcanInfo={token:B,fpToken:m},Object.keys(A).forEach((function(t){l.includes(t)&&(v[t]=A[t])})),Object.assign(v,{platform_type:O.options.platformType,product_type:O.options.businessLine,sdk_v:w.sdkVersion}),D=[],Object.keys(v).sort((function(t,e){return t>e?1:-1})).forEach((function(t){D.push("".concat(t,"--").concat(p(encodeURI(v[t]))))})),C=D.join("||"),k=h(C),P=!y.getStore("HB-VULCAN-SEND-".concat(c)),(d||P)&&f&&S.send(s({cHash:c},k)),e.abrupt("return",s(s({ts:+new Date},k),{},{vToken:B,cHash:c,vHash:u.MD5(B).toString()}));case 33:case"end":return e.stop()}}),n)})))()},get:function(){return(0,i.default)(e.default.mark((function t(){var r,n,i;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,E.getInfo(x);case 2:return r=t.sent,n=r.token,i=r.fpToken,t.abrupt("return",{vToken:n,fpToken:i,vHash:u.MD5(n).toString()});case 6:case"end":return t.stop()}}),t)})))()},vulcanVtoken:function(){return(0,i.default)(e.default.mark((function t(){var r,n;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,E.getInfoVtoken(T);case 2:return r=t.sent,n=r.token,t.abrupt("return",{vToken:n,version:"0003"});case 5:case"end":return t.stop()}}),t)})))()},v:w.sdkVersion};y.isBrowser()&&(window.$vulcan=_),t.exports=_,t.exports.FP=E,t.exports.CP={strToBase64:p,aesEncrypt:d,aesDecrypt:g,Base64ToStr:v}})?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n=r(1).default;function i(){"use strict";
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */t.exports=i=function(){return e},t.exports.__esModule=!0,t.exports.default=t.exports;var e={},r=Object.prototype,o=r.hasOwnProperty,a=Object.defineProperty||function(t,e,r){t[e]=r.value},s="function"==typeof Symbol?Symbol:{},u=s.iterator||"@@iterator",c=s.asyncIterator||"@@asyncIterator",f=s.toStringTag||"@@toStringTag";function l(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{l({},"")}catch(t){l=function(t,e,r){return t[e]=r}}function h(t,e,r,n){var i=e&&e.prototype instanceof g?e:g,o=Object.create(i.prototype),s=new A(n||[]);return a(o,"_invoke",{value:E(t,r,s)}),o}function p(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=h;var d={};function g(){}function v(){}function y(){}var m={};l(m,u,(function(){return this}));var b=Object.getPrototypeOf,x=b&&b(b(D([])));x&&x!==r&&o.call(x,u)&&(m=x);var w=y.prototype=g.prototype=Object.create(m);function T(t){["next","throw","return"].forEach((function(e){l(t,e,(function(t){return this._invoke(e,t)}))}))}function S(t,e){var r;a(this,"_invoke",{value:function(i,a){function s(){return new e((function(r,s){!function r(i,a,s,u){var c=p(t[i],t,a);if("throw"!==c.type){var f=c.arg,l=f.value;return l&&"object"==n(l)&&o.call(l,"__await")?e.resolve(l.__await).then((function(t){r("next",t,s,u)}),(function(t){r("throw",t,s,u)})):e.resolve(l).then((function(t){f.value=t,s(f)}),(function(t){return r("throw",t,s,u)}))}u(c.arg)}(i,a,r,s)}))}return r=r?r.then(s,s):s()}})}function E(t,e,r){var n="suspendedStart";return function(i,o){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw o;return{value:void 0,done:!0}}for(r.method=i,r.arg=o;;){var a=r.delegate;if(a){var s=O(a,r);if(s){if(s===d)continue;return s}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var u=p(t,e,r);if("normal"===u.type){if(n=r.done?"completed":"suspendedYield",u.arg===d)continue;return{value:u.arg,done:r.done}}"throw"===u.type&&(n="completed",r.method="throw",r.arg=u.arg)}}}function O(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,O(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a '"+r+"' method")),d;var i=p(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,d;var o=i.arg;return o?o.done?(e[t.resultName]=o.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,d):o:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,d)}function _(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function B(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function A(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(_,this),this.reset(!0)}function D(t){if(t){var e=t[u];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,n=function e(){for(;++r<t.length;)if(o.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return n.next=n}}return{next:C}}function C(){return{value:void 0,done:!0}}return v.prototype=y,a(w,"constructor",{value:y,configurable:!0}),a(y,"constructor",{value:v,configurable:!0}),v.displayName=l(y,f,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===v||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,y):(t.__proto__=y,l(t,f,"GeneratorFunction")),t.prototype=Object.create(w),t},e.awrap=function(t){return{__await:t}},T(S.prototype),l(S.prototype,c,(function(){return this})),e.AsyncIterator=S,e.async=function(t,r,n,i,o){void 0===o&&(o=Promise);var a=new S(h(t,r,n,i),o);return e.isGeneratorFunction(r)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},T(w),l(w,f,"Generator"),l(w,u,(function(){return this})),l(w,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=D,A.prototype={constructor:A,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(B),!t)for(var e in this)"t"===e.charAt(0)&&o.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return a.type="throw",a.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var n=this.tryEntries.length-1;n>=0;--n){var i=this.tryEntries[n],a=i.completion;if("root"===i.tryLoc)return r("end");if(i.tryLoc<=this.prev){var s=o.call(i,"catchLoc"),u=o.call(i,"finallyLoc");if(s&&u){if(this.prev<i.catchLoc)return r(i.catchLoc,!0);if(this.prev<i.finallyLoc)return r(i.finallyLoc)}else if(s){if(this.prev<i.catchLoc)return r(i.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return r(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&o.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var i=n;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=t,a.arg=e,i?(this.method="next",this.next=i.finallyLoc,d):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),d},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),B(r),d}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;B(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:D(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),d}},e}t.exports=i,t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(1).default;t.exports=function(t,e){if("object"!==n(t)||null===t)return t;var r=t[Symbol.toPrimitive];if(void 0!==r){var i=r.call(t,e||"default");if("object"!==n(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===e?String:Number)(t)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(5),r(6),r(19),r(20),r(21)],void 0===(o="function"==typeof(n=function(e,n,i,o,a){"use strict";var s=r(2);e=s(e),n=s(n),i=s(i),o=s(o),a=s(a);var u=r(3).aes1,c=r(10).aesEncrypt,f=r(4),l=r(29),h=r(36),p=r(4).isBrowser,d={sys:"systemName",sys_ver:"systemVersion",browser_name:"browserName",browser_ver:"browserVersion",kernel_name:"browserKernelName",kernel_ver:"browserKernelVersion",gpu_type:"gpuType",language:"language",display_resolution:"screenResolution",color_depth:"colorDepth",total_memory:"deviceMemory",pixel_ratio:"pixelRatio",time_zone:"timezone",session_enable:"sessionStorage",storage_enable:"localStorage",indexeddb_enable:"indexedDb",websql_enable:"webSQLEnable",do_not_track:"doNotTrack",canvas_crc:"canvas",fonts:"fonts",e_devices:"enumerateDevices",audio_hash:"audio",webgl_hash:"webgl",env_info:"getEnvInfo",uuid:"UUID",hostname:"hostname"},g=["canvas_crc","fonts","webgl_hash","env_info"],v=function(){function t(){(0,i.default)(this,t)}var r,s,v;return(0,o.default)(t,[{key:"FP2",value:(v=(0,n.default)(e.default.mark((function t(){var r=this;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.fpInfo||new Promise((function(t){h.getPromise().then((function(e){r.fpInfo=e,t(e)}))})));case 1:case"end":return t.stop()}}),t,this)}))),function(){return v.apply(this,arguments)})},{key:"getInfo",value:(s=(0,n.default)(e.default.mark((function t(r){var n,i,o,a,s,u,c,f,v,y;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(a=function(t){var e=n.filter((function(e){return e.key===t}));return e[0]?e[0].value:null},o=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:31,r=t instanceof Array?t.join(""):t;return h.x64hash128(r,e)},"string"!=typeof r){t.next=4;break}return t.abrupt("return",{});case 4:if(p()){t.next=6;break}return t.abrupt("return",{});case 6:return t.next=8,this.FP2();case 8:n=t.sent,i={},r=r||Object.keys(d),t.t0=e.default.keys(r);case 12:if((t.t1=t.t0()).done){t.next=31;break}if(s=t.t1.value,u=r[s],c=d[u],f=!!g.includes(u),t.t2=a(c),t.t2){t.next=27;break}if(!l[c]){t.next=25;break}return t.next=22,l[c]();case 22:t.t3=t.sent,t.next=26;break;case 25:t.t3="";case 26:t.t2=t.t3;case 27:i[u]=t.t2,f&&(i[u]=o(i[u])),t.next=12;break;case 31:return v=o(Object.values(i)),y=o(n.map((function(t){return t.value}))),t.abrupt("return",{info:i,token:v,fpToken:y});case 34:case"end":return t.stop()}}),t,this)}))),function(t){return s.apply(this,arguments)})},{key:"getInfoVtoken",value:(r=(0,n.default)(e.default.mark((function t(r){var n,i,o,s,v,y,m,b,x,w,T;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(o=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:31,r=t instanceof Array?t.join(""):t,n=h.x64hash128(r,e);if(3===t.length){var i=1,o=t.join("=>")+"=>"+n,s=c(o,u.key,u.iv);a.default.get("WEBK")&&a.default.get("WEBK")===s||a.default.set("WEBK",s,{domain:f.getHost(),path:"/",expires:i})}return n},"string"!=typeof r){t.next=3;break}return t.abrupt("return",{});case 3:if(p()){t.next=5;break}return t.abrupt("return",{});case 5:i={},t.t0=e.default.keys(r);case 7:if((t.t1=t.t0()).done){t.next=23;break}if(s=t.t1.value,v=r[s],y=d[v],m=!!g.includes(v),!l[y]){t.next=18;break}return t.next=15,l[y]();case 15:t.t2=t.sent,t.next=19;break;case 18:t.t2="";case 19:i[v]=t.t2,m&&(i[v]=o(i[v])),t.next=7;break;case 23:return b=navigator.userAgent,x=b.split(" "),w=b.split("/"),x[x.length-1].indexOf(".")<0||(null===(n=x[x.length-1].match(/\./g))||void 0===n?void 0:n.length)>1?(x.pop(),i.user=x.join(" ")):w[w.length-1].indexOf(".")<0?(w.pop(),i.user=w.join("/")):i.user=b,T=o(Object.values(i)),t.abrupt("return",{token:T});case 29:case"end":return t.stop()}}),t)}))),function(t){return r.apply(this,arguments)})}]),t}();t.exports=v})?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(1)],n=function(a){"use strict";var s=r(2);a=s(a),function(r,s){"object"===(0,a.default)(e)&&void 0!==t?s(e):(i=[e],void 0===(o="function"==typeof(n=s)?n.apply(e,i):n)||(t.exports=o))}(0,(function(e){function r(t){return"0123456789abcdefghijklmnopqrstuvwxyz".charAt(t)}function n(t,e){return t&e}function i(t,e){return t|e}function o(t,e){return t^e}function a(t,e){return t&~e}function s(t){if(0==t)return-1;var e=0;return 0==(65535&t)&&(t>>=16,e+=16),0==(255&t)&&(t>>=8,e+=8),0==(15&t)&&(t>>=4,e+=4),0==(3&t)&&(t>>=2,e+=2),0==(1&t)&&++e,e}function u(t){for(var e=0;0!=t;)t&=t-1,++e;return e}var c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";function f(t){var e,r,n="";for(e=0;e+3<=t.length;e+=3)r=parseInt(t.substring(e,e+3),16),n+=c.charAt(r>>6)+c.charAt(63&r);for(e+1==t.length?(r=parseInt(t.substring(e,e+1),16),n+=c.charAt(r<<2)):e+2==t.length&&(r=parseInt(t.substring(e,e+2),16),n+=c.charAt(r>>2)+c.charAt((3&r)<<4));(3&n.length)>0;)n+="=";return n}function l(t){var e,n="",i=0,o=0;for(e=0;e<t.length&&"="!=t.charAt(e);++e){var a=c.indexOf(t.charAt(e));a<0||(0==i?(n+=r(a>>2),o=3&a,i=1):1==i?(n+=r(o<<2|a>>4),o=15&a,i=2):2==i?(n+=r(o),n+=r(a>>2),o=3&a,i=3):(n+=r(o<<2|a>>4),n+=r(15&a),i=0))}return 1==i&&(n+=r(o<<2)),n
/*! *****************************************************************************
             Copyright (c) Microsoft Corporation. All rights reserved.
             Licensed under the Apache License, Version 2.0 (the "License"); you may not use
             this file except in compliance with the License. You may obtain a copy of the
             License at http://www.apache.org/licenses/LICENSE-2.0
             
             THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
             KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
             WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
             MERCHANTABLITY OR NON-INFRINGEMENT.
             
             See the Apache Version 2.0 License for specific language governing permissions
             and limitations under the License.
             ***************************************************************************** */}var h,p,d=function(t,e){return(d=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])})(t,e)},g={decode:function(t){var e;if(void 0===p){for(p=Object.create(null),e=0;e<64;++e)p["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e)]=e;for(e=0;e<"= \f\n\r\t \u2028\u2029".length;++e)p["= \f\n\r\t \u2028\u2029".charAt(e)]=-1}var r=[],n=0,i=0;for(e=0;e<t.length;++e){var o=t.charAt(e);if("="==o)break;if(-1!=(o=p[o])){if(void 0===o)throw new Error("Illegal character at offset "+e);n|=o,++i>=4?(r[r.length]=n>>16,r[r.length]=n>>8&255,r[r.length]=255&n,n=0,i=0):n<<=6}}switch(i){case 1:throw new Error("Base64 encoding incomplete: at least 2 bits missing");case 2:r[r.length]=n>>10;break;case 3:r[r.length]=n>>16,r[r.length]=n>>8&255}return r},re:/-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,unarmor:function(t){var e=g.re.exec(t);if(e)if(e[1])t=e[1];else{if(!e[2])throw new Error("RegExp out of sync");t=e[2]}return g.decode(t)}},v=1e13,y=function(){function t(t){this.buf=[+t||0]}return t.prototype.mulAdd=function(t,e){var r,n,i=this.buf,o=i.length;for(r=0;r<o;++r)(n=i[r]*t+e)<v?e=0:n-=(e=0|n/v)*v,i[r]=n;e>0&&(i[r]=e)},t.prototype.sub=function(t){var e,r,n=this.buf,i=n.length;for(e=0;e<i;++e)(r=n[e]-t)<0?(r+=v,t=1):t=0,n[e]=r;for(;0===n[n.length-1];)n.pop()},t.prototype.toString=function(t){if(10!=(t||10))throw new Error("only base 10 is supported");for(var e=this.buf,r=e[e.length-1].toString(),n=e.length-2;n>=0;--n)r+=(v+e[n]).toString().substring(1);return r},t.prototype.valueOf=function(){for(var t=this.buf,e=0,r=t.length-1;r>=0;--r)e=e*v+t[r];return e},t.prototype.simplify=function(){var t=this.buf;return 1==t.length?t[0]:this},t}(),m=/^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/,b=/^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;function x(t,e){return t.length>e&&(t=t.substring(0,e)+"…"),t}var w,T=function(){function t(e,r){this.hexDigits="0123456789ABCDEF",e instanceof t?(this.enc=e.enc,this.pos=e.pos):(this.enc=e,this.pos=r)}return t.prototype.get=function(t){if(void 0===t&&(t=this.pos++),t>=this.enc.length)throw new Error("Requesting byte offset "+t+" on a stream of length "+this.enc.length);return"string"==typeof this.enc?this.enc.charCodeAt(t):this.enc[t]},t.prototype.hexByte=function(t){return this.hexDigits.charAt(t>>4&15)+this.hexDigits.charAt(15&t)},t.prototype.hexDump=function(t,e,r){for(var n="",i=t;i<e;++i)if(n+=this.hexByte(this.get(i)),!0!==r)switch(15&i){case 7:n+="  ";break;case 15:n+="\n";break;default:n+=" "}return n},t.prototype.isASCII=function(t,e){for(var r=t;r<e;++r){var n=this.get(r);if(n<32||n>176)return!1}return!0},t.prototype.parseStringISO=function(t,e){for(var r="",n=t;n<e;++n)r+=String.fromCharCode(this.get(n));return r},t.prototype.parseStringUTF=function(t,e){for(var r="",n=t;n<e;){var i=this.get(n++);r+=i<128?String.fromCharCode(i):i>191&&i<224?String.fromCharCode((31&i)<<6|63&this.get(n++)):String.fromCharCode((15&i)<<12|(63&this.get(n++))<<6|63&this.get(n++))}return r},t.prototype.parseStringBMP=function(t,e){for(var r,n,i="",o=t;o<e;)r=this.get(o++),n=this.get(o++),i+=String.fromCharCode(r<<8|n);return i},t.prototype.parseTime=function(t,e,r){var n=this.parseStringISO(t,e),i=(r?m:b).exec(n);return i?(r&&(i[1]=+i[1],i[1]+=+i[1]<70?2e3:1900),n=i[1]+"-"+i[2]+"-"+i[3]+" "+i[4],i[5]&&(n+=":"+i[5],i[6]&&(n+=":"+i[6],i[7]&&(n+="."+i[7]))),i[8]&&(n+=" UTC","Z"!=i[8]&&(n+=i[8],i[9]&&(n+=":"+i[9]))),n):"Unrecognized time: "+n},t.prototype.parseInteger=function(t,e){for(var r,n=this.get(t),i=n>127,o=i?255:0,a="";n==o&&++t<e;)n=this.get(t);if(0==(r=e-t))return i?-1:0;if(r>4){for(a=n,r<<=3;0==(128&(+a^o));)a=+a<<1,--r;a="("+r+" bit)\n"}i&&(n-=256);for(var s=new y(n),u=t+1;u<e;++u)s.mulAdd(256,this.get(u));return a+s.toString()},t.prototype.parseBitString=function(t,e,r){for(var n=this.get(t),i="("+((e-t-1<<3)-n)+" bit)\n",o="",a=t+1;a<e;++a){for(var s=this.get(a),u=a==e-1?n:0,c=7;c>=u;--c)o+=s>>c&1?"1":"0";if(o.length>r)return i+x(o,r)}return i+o},t.prototype.parseOctetString=function(t,e,r){if(this.isASCII(t,e))return x(this.parseStringISO(t,e),r);var n=e-t,i="("+n+" byte)\n";n>(r/=2)&&(e=t+r);for(var o=t;o<e;++o)i+=this.hexByte(this.get(o));return n>r&&(i+="…"),i},t.prototype.parseOID=function(t,e,r){for(var n="",i=new y,o=0,a=t;a<e;++a){var s=this.get(a);if(i.mulAdd(128,127&s),o+=7,!(128&s)){if(""===n)if((i=i.simplify())instanceof y)i.sub(80),n="2."+i.toString();else{var u=i<80?i<40?0:1:2;n=u+"."+(i-40*u)}else n+="."+i.toString();if(n.length>r)return x(n,r);i=new y,o=0}}return o>0&&(n+=".incomplete"),n},t}(),S=function(){function t(t,e,r,n,i){if(!(n instanceof E))throw new Error("Invalid tag value.");this.stream=t,this.header=e,this.length=r,this.tag=n,this.sub=i}return t.prototype.typeName=function(){switch(this.tag.tagClass){case 0:switch(this.tag.tagNumber){case 0:return"EOC";case 1:return"BOOLEAN";case 2:return"INTEGER";case 3:return"BIT_STRING";case 4:return"OCTET_STRING";case 5:return"NULL";case 6:return"OBJECT_IDENTIFIER";case 7:return"ObjectDescriptor";case 8:return"EXTERNAL";case 9:return"REAL";case 10:return"ENUMERATED";case 11:return"EMBEDDED_PDV";case 12:return"UTF8String";case 16:return"SEQUENCE";case 17:return"SET";case 18:return"NumericString";case 19:return"PrintableString";case 20:return"TeletexString";case 21:return"VideotexString";case 22:return"IA5String";case 23:return"UTCTime";case 24:return"GeneralizedTime";case 25:return"GraphicString";case 26:return"VisibleString";case 27:return"GeneralString";case 28:return"UniversalString";case 30:return"BMPString"}return"Universal_"+this.tag.tagNumber.toString();case 1:return"Application_"+this.tag.tagNumber.toString();case 2:return"["+this.tag.tagNumber.toString()+"]";case 3:return"Private_"+this.tag.tagNumber.toString()}},t.prototype.content=function(t){if(void 0===this.tag)return null;void 0===t&&(t=1/0);var e=this.posContent(),r=Math.abs(this.length);if(!this.tag.isUniversal())return null!==this.sub?"("+this.sub.length+" elem)":this.stream.parseOctetString(e,e+r,t);switch(this.tag.tagNumber){case 1:return 0===this.stream.get(e)?"false":"true";case 2:return this.stream.parseInteger(e,e+r);case 3:return this.sub?"("+this.sub.length+" elem)":this.stream.parseBitString(e,e+r,t);case 4:return this.sub?"("+this.sub.length+" elem)":this.stream.parseOctetString(e,e+r,t);case 6:return this.stream.parseOID(e,e+r,t);case 16:case 17:return null!==this.sub?"("+this.sub.length+" elem)":"(no elem)";case 12:return x(this.stream.parseStringUTF(e,e+r),t);case 18:case 19:case 20:case 21:case 22:case 26:return x(this.stream.parseStringISO(e,e+r),t);case 30:return x(this.stream.parseStringBMP(e,e+r),t);case 23:case 24:return this.stream.parseTime(e,e+r,23==this.tag.tagNumber)}return null},t.prototype.toString=function(){return this.typeName()+"@"+this.stream.pos+"[header:"+this.header+",length:"+this.length+",sub:"+(null===this.sub?"null":this.sub.length)+"]"},t.prototype.toPrettyString=function(t){void 0===t&&(t="");var e=t+this.typeName()+" @"+this.stream.pos;if(this.length>=0&&(e+="+"),e+=this.length,this.tag.tagConstructed?e+=" (constructed)":!this.tag.isUniversal()||3!=this.tag.tagNumber&&4!=this.tag.tagNumber||null===this.sub||(e+=" (encapsulates)"),e+="\n",null!==this.sub){t+="  ";for(var r=0,n=this.sub.length;r<n;++r)e+=this.sub[r].toPrettyString(t)}return e},t.prototype.posStart=function(){return this.stream.pos},t.prototype.posContent=function(){return this.stream.pos+this.header},t.prototype.posEnd=function(){return this.stream.pos+this.header+Math.abs(this.length)},t.prototype.toHexString=function(){return this.stream.hexDump(this.posStart(),this.posEnd(),!0)},t.decodeLength=function(t){var e=t.get(),r=127&e;if(r==e)return r;if(r>6)throw new Error("Length over 48 bits not supported at position "+(t.pos-1));if(0===r)return null;e=0;for(var n=0;n<r;++n)e=256*e+t.get();return e},t.prototype.getHexStringValue=function(){var t=this.toHexString(),e=2*this.header,r=2*this.length;return t.substr(e,r)},t.decode=function(e){var r;r=e instanceof T?e:new T(e,0);var n=new T(r),i=new E(r),o=t.decodeLength(r),a=r.pos,s=a-n.pos,u=null,c=function(){var e=[];if(null!==o){for(var n=a+o;r.pos<n;)e[e.length]=t.decode(r);if(r.pos!=n)throw new Error("Content size is not correct for container starting at offset "+a)}else try{for(;;){var i=t.decode(r);if(i.tag.isEOC())break;e[e.length]=i}o=a-r.pos}catch(t){throw new Error("Exception while decoding undefined length content: "+t)}return e};if(i.tagConstructed)u=c();else if(i.isUniversal()&&(3==i.tagNumber||4==i.tagNumber))try{if(3==i.tagNumber&&0!=r.get())throw new Error("BIT STRINGs with unused bits cannot encapsulate.");u=c();for(var f=0;f<u.length;++f)if(u[f].tag.isEOC())throw new Error("EOC is not supposed to be actual content.")}catch(t){u=null}if(null===u){if(null===o)throw new Error("We can't skip over an invalid tag with undefined length at offset "+a);r.pos=a+Math.abs(o)}return new t(n,s,o,i,u)},t}(),E=function(){function t(t){var e=t.get();if(this.tagClass=e>>6,this.tagConstructed=0!=(32&e),this.tagNumber=31&e,31==this.tagNumber){var r=new y;do{e=t.get(),r.mulAdd(128,127&e)}while(128&e);this.tagNumber=r.simplify()}}return t.prototype.isUniversal=function(){return 0===this.tagClass},t.prototype.isEOC=function(){return 0===this.tagClass&&0===this.tagNumber},t}(),O=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],_=(1<<26)/O[O.length-1],B=function(){function t(t,e,r){null!=t&&("number"==typeof t?this.fromNumber(t,e,r):null==e&&"string"!=typeof t?this.fromString(t,256):this.fromString(t,e))}return t.prototype.toString=function(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var n,i=(1<<e)-1,o=!1,a="",s=this.t,u=this.DB-s*this.DB%e;if(s-- >0)for(u<this.DB&&(n=this[s]>>u)>0&&(o=!0,a=r(n));s>=0;)u<e?(n=(this[s]&(1<<u)-1)<<e-u,n|=this[--s]>>(u+=this.DB-e)):(n=this[s]>>(u-=e)&i,u<=0&&(u+=this.DB,--s)),n>0&&(o=!0),o&&(a+=r(n));return o?a:"0"},t.prototype.negate=function(){var e=P();return t.ZERO.subTo(this,e),e},t.prototype.abs=function(){return this.s<0?this.negate():this},t.prototype.compareTo=function(t){var e=this.s-t.s;if(0!=e)return e;var r=this.t;if(0!=(e=r-t.t))return this.s<0?-e:e;for(;--r>=0;)if(0!=(e=this[r]-t[r]))return e;return 0},t.prototype.bitLength=function(){return this.t<=0?0:this.DB*(this.t-1)+V(this[this.t-1]^this.s&this.DM)},t.prototype.mod=function(e){var r=P();return this.abs().divRemTo(e,null,r),this.s<0&&r.compareTo(t.ZERO)>0&&e.subTo(r,r),r},t.prototype.modPowInt=function(t,e){var r;return r=t<256||e.isEven()?new D(e):new C(e),this.exp(t,r)},t.prototype.clone=function(){var t=P();return this.copyTo(t),t},t.prototype.intValue=function(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},t.prototype.byteValue=function(){return 0==this.t?this.s:this[0]<<24>>24},t.prototype.shortValue=function(){return 0==this.t?this.s:this[0]<<16>>16},t.prototype.signum=function(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},t.prototype.toByteArray=function(){var t=this.t,e=[];e[0]=this.s;var r,n=this.DB-t*this.DB%8,i=0;if(t-- >0)for(n<this.DB&&(r=this[t]>>n)!=(this.s&this.DM)>>n&&(e[i++]=r|this.s<<this.DB-n);t>=0;)n<8?(r=(this[t]&(1<<n)-1)<<8-n,r|=this[--t]>>(n+=this.DB-8)):(r=this[t]>>(n-=8)&255,n<=0&&(n+=this.DB,--t)),0!=(128&r)&&(r|=-256),0==i&&(128&this.s)!=(128&r)&&++i,(i>0||r!=this.s)&&(e[i++]=r);return e},t.prototype.equals=function(t){return 0==this.compareTo(t)},t.prototype.min=function(t){return this.compareTo(t)<0?this:t},t.prototype.max=function(t){return this.compareTo(t)>0?this:t},t.prototype.and=function(t){var e=P();return this.bitwiseTo(t,n,e),e},t.prototype.or=function(t){var e=P();return this.bitwiseTo(t,i,e),e},t.prototype.xor=function(t){var e=P();return this.bitwiseTo(t,o,e),e},t.prototype.andNot=function(t){var e=P();return this.bitwiseTo(t,a,e),e},t.prototype.not=function(){for(var t=P(),e=0;e<this.t;++e)t[e]=this.DM&~this[e];return t.t=this.t,t.s=~this.s,t},t.prototype.shiftLeft=function(t){var e=P();return t<0?this.rShiftTo(-t,e):this.lShiftTo(t,e),e},t.prototype.shiftRight=function(t){var e=P();return t<0?this.lShiftTo(-t,e):this.rShiftTo(t,e),e},t.prototype.getLowestSetBit=function(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+s(this[t]);return this.s<0?this.t*this.DB:-1},t.prototype.bitCount=function(){for(var t=0,e=this.s&this.DM,r=0;r<this.t;++r)t+=u(this[r]^e);return t},t.prototype.testBit=function(t){var e=Math.floor(t/this.DB);return e>=this.t?0!=this.s:0!=(this[e]&1<<t%this.DB)},t.prototype.setBit=function(t){return this.changeBit(t,i)},t.prototype.clearBit=function(t){return this.changeBit(t,a)},t.prototype.flipBit=function(t){return this.changeBit(t,o)},t.prototype.add=function(t){var e=P();return this.addTo(t,e),e},t.prototype.subtract=function(t){var e=P();return this.subTo(t,e),e},t.prototype.multiply=function(t){var e=P();return this.multiplyTo(t,e),e},t.prototype.divide=function(t){var e=P();return this.divRemTo(t,e,null),e},t.prototype.remainder=function(t){var e=P();return this.divRemTo(t,null,e),e},t.prototype.divideAndRemainder=function(t){var e=P(),r=P();return this.divRemTo(t,e,r),[e,r]},t.prototype.modPow=function(t,e){var r,n,i=t.bitLength(),o=j(1);if(i<=0)return o;r=i<18?1:i<48?3:i<144?4:i<768?5:6,n=i<8?new D(e):e.isEven()?new k(e):new C(e);var a=[],s=3,u=r-1,c=(1<<r)-1;if(a[1]=n.convert(this),r>1){var f=P();for(n.sqrTo(a[1],f);s<=c;)a[s]=P(),n.mulTo(f,a[s-2],a[s]),s+=2}var l,h,p=t.t-1,d=!0,g=P();for(i=V(t[p])-1;p>=0;){for(i>=u?l=t[p]>>i-u&c:(l=(t[p]&(1<<i+1)-1)<<u-i,p>0&&(l|=t[p-1]>>this.DB+i-u)),s=r;0==(1&l);)l>>=1,--s;if((i-=s)<0&&(i+=this.DB,--p),d)a[l].copyTo(o),d=!1;else{for(;s>1;)n.sqrTo(o,g),n.sqrTo(g,o),s-=2;s>0?n.sqrTo(o,g):(h=o,o=g,g=h),n.mulTo(g,a[l],o)}for(;p>=0&&0==(t[p]&1<<i);)n.sqrTo(o,g),h=o,o=g,g=h,--i<0&&(i=this.DB-1,--p)}return n.revert(o)},t.prototype.modInverse=function(e){var r=e.isEven();if(this.isEven()&&r||0==e.signum())return t.ZERO;for(var n=e.clone(),i=this.clone(),o=j(1),a=j(0),s=j(0),u=j(1);0!=n.signum();){for(;n.isEven();)n.rShiftTo(1,n),r?(o.isEven()&&a.isEven()||(o.addTo(this,o),a.subTo(e,a)),o.rShiftTo(1,o)):a.isEven()||a.subTo(e,a),a.rShiftTo(1,a);for(;i.isEven();)i.rShiftTo(1,i),r?(s.isEven()&&u.isEven()||(s.addTo(this,s),u.subTo(e,u)),s.rShiftTo(1,s)):u.isEven()||u.subTo(e,u),u.rShiftTo(1,u);n.compareTo(i)>=0?(n.subTo(i,n),r&&o.subTo(s,o),a.subTo(u,a)):(i.subTo(n,i),r&&s.subTo(o,s),u.subTo(a,u))}return 0!=i.compareTo(t.ONE)?t.ZERO:u.compareTo(e)>=0?u.subtract(e):u.signum()<0?(u.addTo(e,u),u.signum()<0?u.add(e):u):u},t.prototype.pow=function(t){return this.exp(t,new A)},t.prototype.gcd=function(t){var e=this.s<0?this.negate():this.clone(),r=t.s<0?t.negate():t.clone();if(e.compareTo(r)<0){var n=e;e=r,r=n}var i=e.getLowestSetBit(),o=r.getLowestSetBit();if(o<0)return e;for(i<o&&(o=i),o>0&&(e.rShiftTo(o,e),r.rShiftTo(o,r));e.signum()>0;)(i=e.getLowestSetBit())>0&&e.rShiftTo(i,e),(i=r.getLowestSetBit())>0&&r.rShiftTo(i,r),e.compareTo(r)>=0?(e.subTo(r,e),e.rShiftTo(1,e)):(r.subTo(e,r),r.rShiftTo(1,r));return o>0&&r.lShiftTo(o,r),r},t.prototype.isProbablePrime=function(t){var e,r=this.abs();if(1==r.t&&r[0]<=O[O.length-1]){for(e=0;e<O.length;++e)if(r[0]==O[e])return!0;return!1}if(r.isEven())return!1;for(e=1;e<O.length;){for(var n=O[e],i=e+1;i<O.length&&n<_;)n*=O[i++];for(n=r.modInt(n);e<i;)if(n%O[e++]==0)return!1}return r.millerRabin(t)},t.prototype.copyTo=function(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s},t.prototype.fromInt=function(t){this.t=1,this.s=t<0?-1:0,t>0?this[0]=t:t<-1?this[0]=t+this.DV:this.t=0},t.prototype.fromString=function(e,r){var n;if(16==r)n=4;else if(8==r)n=3;else if(256==r)n=8;else if(2==r)n=1;else if(32==r)n=5;else{if(4!=r)return void this.fromRadix(e,r);n=2}this.t=0,this.s=0;for(var i=e.length,o=!1,a=0;--i>=0;){var s=8==n?255&+e[i]:N(e,i);s<0?"-"==e.charAt(i)&&(o=!0):(o=!1,0==a?this[this.t++]=s:a+n>this.DB?(this[this.t-1]|=(s&(1<<this.DB-a)-1)<<a,this[this.t++]=s>>this.DB-a):this[this.t-1]|=s<<a,(a+=n)>=this.DB&&(a-=this.DB))}8==n&&0!=(128&+e[0])&&(this.s=-1,a>0&&(this[this.t-1]|=(1<<this.DB-a)-1<<a)),this.clamp(),o&&t.ZERO.subTo(this,this)},t.prototype.clamp=function(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t},t.prototype.dlShiftTo=function(t,e){var r;for(r=this.t-1;r>=0;--r)e[r+t]=this[r];for(r=t-1;r>=0;--r)e[r]=0;e.t=this.t+t,e.s=this.s},t.prototype.drShiftTo=function(t,e){for(var r=t;r<this.t;++r)e[r-t]=this[r];e.t=Math.max(this.t-t,0),e.s=this.s},t.prototype.lShiftTo=function(t,e){for(var r=t%this.DB,n=this.DB-r,i=(1<<n)-1,o=Math.floor(t/this.DB),a=this.s<<r&this.DM,s=this.t-1;s>=0;--s)e[s+o+1]=this[s]>>n|a,a=(this[s]&i)<<r;for(s=o-1;s>=0;--s)e[s]=0;e[o]=a,e.t=this.t+o+1,e.s=this.s,e.clamp()},t.prototype.rShiftTo=function(t,e){e.s=this.s;var r=Math.floor(t/this.DB);if(r>=this.t)e.t=0;else{var n=t%this.DB,i=this.DB-n,o=(1<<n)-1;e[0]=this[r]>>n;for(var a=r+1;a<this.t;++a)e[a-r-1]|=(this[a]&o)<<i,e[a-r]=this[a]>>n;n>0&&(e[this.t-r-1]|=(this.s&o)<<i),e.t=this.t-r,e.clamp()}},t.prototype.subTo=function(t,e){for(var r=0,n=0,i=Math.min(t.t,this.t);r<i;)n+=this[r]-t[r],e[r++]=n&this.DM,n>>=this.DB;if(t.t<this.t){for(n-=t.s;r<this.t;)n+=this[r],e[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<t.t;)n-=t[r],e[r++]=n&this.DM,n>>=this.DB;n-=t.s}e.s=n<0?-1:0,n<-1?e[r++]=this.DV+n:n>0&&(e[r++]=n),e.t=r,e.clamp()},t.prototype.multiplyTo=function(e,r){var n=this.abs(),i=e.abs(),o=n.t;for(r.t=o+i.t;--o>=0;)r[o]=0;for(o=0;o<i.t;++o)r[o+n.t]=n.am(0,i[o],r,o,0,n.t);r.s=0,r.clamp(),this.s!=e.s&&t.ZERO.subTo(r,r)},t.prototype.squareTo=function(t){for(var e=this.abs(),r=t.t=2*e.t;--r>=0;)t[r]=0;for(r=0;r<e.t-1;++r){var n=e.am(r,e[r],t,2*r,0,1);(t[r+e.t]+=e.am(r+1,2*e[r],t,2*r+1,n,e.t-r-1))>=e.DV&&(t[r+e.t]-=e.DV,t[r+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(r,e[r],t,2*r,0,1)),t.s=0,t.clamp()},t.prototype.divRemTo=function(e,r,n){var i=e.abs();if(!(i.t<=0)){var o=this.abs();if(o.t<i.t)return null!=r&&r.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=P());var a=P(),s=this.s,u=e.s,c=this.DB-V(i[i.t-1]);c>0?(i.lShiftTo(c,a),o.lShiftTo(c,n)):(i.copyTo(a),o.copyTo(n));var f=a.t,l=a[f-1];if(0!=l){var h=l*(1<<this.F1)+(f>1?a[f-2]>>this.F2:0),p=this.FV/h,d=(1<<this.F1)/h,g=1<<this.F2,v=n.t,y=v-f,m=null==r?P():r;for(a.dlShiftTo(y,m),n.compareTo(m)>=0&&(n[n.t++]=1,n.subTo(m,n)),t.ONE.dlShiftTo(f,m),m.subTo(a,a);a.t<f;)a[a.t++]=0;for(;--y>=0;){var b=n[--v]==l?this.DM:Math.floor(n[v]*p+(n[v-1]+g)*d);if((n[v]+=a.am(0,b,n,y,0,f))<b)for(a.dlShiftTo(y,m),n.subTo(m,n);n[v]<--b;)n.subTo(m,n)}null!=r&&(n.drShiftTo(f,r),s!=u&&t.ZERO.subTo(r,r)),n.t=f,n.clamp(),c>0&&n.rShiftTo(c,n),s<0&&t.ZERO.subTo(n,n)}}},t.prototype.invDigit=function(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return(e=(e=(e=(e=e*(2-(15&t)*e)&15)*(2-(255&t)*e)&255)*(2-((65535&t)*e&65535))&65535)*(2-t*e%this.DV)%this.DV)>0?this.DV-e:-e},t.prototype.isEven=function(){return 0==(this.t>0?1&this[0]:this.s)},t.prototype.exp=function(e,r){if(e>4294967295||e<1)return t.ONE;var n=P(),i=P(),o=r.convert(this),a=V(e)-1;for(o.copyTo(n);--a>=0;)if(r.sqrTo(n,i),(e&1<<a)>0)r.mulTo(i,o,n);else{var s=n;n=i,i=s}return r.revert(n)},t.prototype.chunkSize=function(t){return Math.floor(Math.LN2*this.DB/Math.log(t))},t.prototype.toRadix=function(t){if(null==t&&(t=10),0==this.signum()||t<2||t>36)return"0";var e=this.chunkSize(t),r=Math.pow(t,e),n=j(r),i=P(),o=P(),a="";for(this.divRemTo(n,i,o);i.signum()>0;)a=(r+o.intValue()).toString(t).substr(1)+a,i.divRemTo(n,i,o);return o.intValue().toString(t)+a},t.prototype.fromRadix=function(e,r){this.fromInt(0),null==r&&(r=10);for(var n=this.chunkSize(r),i=Math.pow(r,n),o=!1,a=0,s=0,u=0;u<e.length;++u){var c=N(e,u);c<0?"-"==e.charAt(u)&&0==this.signum()&&(o=!0):(s=r*s+c,++a>=n&&(this.dMultiply(i),this.dAddOffset(s,0),a=0,s=0))}a>0&&(this.dMultiply(Math.pow(r,a)),this.dAddOffset(s,0)),o&&t.ZERO.subTo(this,this)},t.prototype.fromNumber=function(e,r,n){if("number"==typeof r)if(e<2)this.fromInt(1);else for(this.fromNumber(e,n),this.testBit(e-1)||this.bitwiseTo(t.ONE.shiftLeft(e-1),i,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(r);)this.dAddOffset(2,0),this.bitLength()>e&&this.subTo(t.ONE.shiftLeft(e-1),this);else{var o=[],a=7&e;o.length=1+(e>>3),r.nextBytes(o),a>0?o[0]&=(1<<a)-1:o[0]=0,this.fromString(o,256)}},t.prototype.bitwiseTo=function(t,e,r){var n,i,o=Math.min(t.t,this.t);for(n=0;n<o;++n)r[n]=e(this[n],t[n]);if(t.t<this.t){for(i=t.s&this.DM,n=o;n<this.t;++n)r[n]=e(this[n],i);r.t=this.t}else{for(i=this.s&this.DM,n=o;n<t.t;++n)r[n]=e(i,t[n]);r.t=t.t}r.s=e(this.s,t.s),r.clamp()},t.prototype.changeBit=function(e,r){var n=t.ONE.shiftLeft(e);return this.bitwiseTo(n,r,n),n},t.prototype.addTo=function(t,e){for(var r=0,n=0,i=Math.min(t.t,this.t);r<i;)n+=this[r]+t[r],e[r++]=n&this.DM,n>>=this.DB;if(t.t<this.t){for(n+=t.s;r<this.t;)n+=this[r],e[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<t.t;)n+=t[r],e[r++]=n&this.DM,n>>=this.DB;n+=t.s}e.s=n<0?-1:0,n>0?e[r++]=n:n<-1&&(e[r++]=this.DV+n),e.t=r,e.clamp()},t.prototype.dMultiply=function(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()},t.prototype.dAddOffset=function(t,e){if(0!=t){for(;this.t<=e;)this[this.t++]=0;for(this[e]+=t;this[e]>=this.DV;)this[e]-=this.DV,++e>=this.t&&(this[this.t++]=0),++this[e]}},t.prototype.multiplyLowerTo=function(t,e,r){var n=Math.min(this.t+t.t,e);for(r.s=0,r.t=n;n>0;)r[--n]=0;for(var i=r.t-this.t;n<i;++n)r[n+this.t]=this.am(0,t[n],r,n,0,this.t);for(i=Math.min(t.t,e);n<i;++n)this.am(0,t[n],r,n,0,e-n);r.clamp()},t.prototype.multiplyUpperTo=function(t,e,r){--e;var n=r.t=this.t+t.t-e;for(r.s=0;--n>=0;)r[n]=0;for(n=Math.max(e-this.t,0);n<t.t;++n)r[this.t+n-e]=this.am(e-n,t[n],r,0,0,this.t+n-e);r.clamp(),r.drShiftTo(1,r)},t.prototype.modInt=function(t){if(t<=0)return 0;var e=this.DV%t,r=this.s<0?t-1:0;if(this.t>0)if(0==e)r=this[0]%t;else for(var n=this.t-1;n>=0;--n)r=(e*r+this[n])%t;return r},t.prototype.millerRabin=function(e){var r=this.subtract(t.ONE),n=r.getLowestSetBit();if(n<=0)return!1;var i=r.shiftRight(n);(e=e+1>>1)>O.length&&(e=O.length);for(var o=P(),a=0;a<e;++a){o.fromInt(O[Math.floor(Math.random()*O.length)]);var s=o.modPow(i,this);if(0!=s.compareTo(t.ONE)&&0!=s.compareTo(r)){for(var u=1;u++<n&&0!=s.compareTo(r);)if(0==(s=s.modPowInt(2,this)).compareTo(t.ONE))return!1;if(0!=s.compareTo(r))return!1}}return!0},t.prototype.square=function(){var t=P();return this.squareTo(t),t},t.prototype.gcda=function(t,e){var r=this.s<0?this.negate():this.clone(),n=t.s<0?t.negate():t.clone();if(r.compareTo(n)<0){var i=r;r=n,n=i}var o=r.getLowestSetBit(),a=n.getLowestSetBit();a<0?e(r):(o<a&&(a=o),a>0&&(r.rShiftTo(a,r),n.rShiftTo(a,n)),setTimeout((function t(){(o=r.getLowestSetBit())>0&&r.rShiftTo(o,r),(o=n.getLowestSetBit())>0&&n.rShiftTo(o,n),r.compareTo(n)>=0?(r.subTo(n,r),r.rShiftTo(1,r)):(n.subTo(r,n),n.rShiftTo(1,n)),r.signum()>0?setTimeout(t,0):(a>0&&n.lShiftTo(a,n),setTimeout((function(){e(n)}),0))}),10))},t.prototype.fromNumberAsync=function(e,r,n,o){if("number"==typeof r)if(e<2)this.fromInt(1);else{this.fromNumber(e,n),this.testBit(e-1)||this.bitwiseTo(t.ONE.shiftLeft(e-1),i,this),this.isEven()&&this.dAddOffset(1,0);var a=this;setTimeout((function n(){a.dAddOffset(2,0),a.bitLength()>e&&a.subTo(t.ONE.shiftLeft(e-1),a),a.isProbablePrime(r)?setTimeout((function(){o()}),0):setTimeout(n,0)}),0)}else{var s=[],u=7&e;s.length=1+(e>>3),r.nextBytes(s),u>0?s[0]&=(1<<u)-1:s[0]=0,this.fromString(s,256)}},t}(),A=function(){function t(){}return t.prototype.convert=function(t){return t},t.prototype.revert=function(t){return t},t.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r)},t.prototype.sqrTo=function(t,e){t.squareTo(e)},t}(),D=function(){function t(t){this.m=t}return t.prototype.convert=function(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t},t.prototype.revert=function(t){return t},t.prototype.reduce=function(t){t.divRemTo(this.m,null,t)},t.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r),this.reduce(r)},t.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},t}(),C=function(){function t(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}return t.prototype.convert=function(t){var e=P();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(B.ZERO)>0&&this.m.subTo(e,e),e},t.prototype.revert=function(t){var e=P();return t.copyTo(e),this.reduce(e),e},t.prototype.reduce=function(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var r=32767&t[e],n=r*this.mpl+((r*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(t[r=e+this.m.t]+=this.m.am(0,n,t,e,0,this.m.t);t[r]>=t.DV;)t[r]-=t.DV,t[++r]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)},t.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r),this.reduce(r)},t.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},t}(),k=function(){function t(t){this.m=t,this.r2=P(),this.q3=P(),B.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t)}return t.prototype.convert=function(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var e=P();return t.copyTo(e),this.reduce(e),e},t.prototype.revert=function(t){return t},t.prototype.reduce=function(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)},t.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r),this.reduce(r)},t.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},t}();function P(){return new B(null)}function M(t,e){return new B(t,e)}"Microsoft Internet Explorer"==navigator.appName?(B.prototype.am=function(t,e,r,n,i,o){for(var a=32767&e,s=e>>15;--o>=0;){var u=32767&this[t],c=this[t++]>>15,f=s*u+c*a;i=((u=a*u+((32767&f)<<15)+r[n]+(1073741823&i))>>>30)+(f>>>15)+s*c+(i>>>30),r[n++]=1073741823&u}return i},w=30):"Netscape"!=navigator.appName?(B.prototype.am=function(t,e,r,n,i,o){for(;--o>=0;){var a=e*this[t++]+r[n]+i;i=Math.floor(a/67108864),r[n++]=67108863&a}return i},w=26):(B.prototype.am=function(t,e,r,n,i,o){for(var a=16383&e,s=e>>14;--o>=0;){var u=16383&this[t],c=this[t++]>>14,f=s*u+c*a;i=((u=a*u+((16383&f)<<14)+r[n]+i)>>28)+(f>>14)+s*c,r[n++]=268435455&u}return i},w=28),B.prototype.DB=w,B.prototype.DM=(1<<w)-1,B.prototype.DV=1<<w,B.prototype.FV=Math.pow(2,52),B.prototype.F1=52-w,B.prototype.F2=2*w-52;var I,R,L=[];for(I="0".charCodeAt(0),R=0;R<=9;++R)L[I++]=R;for(I="a".charCodeAt(0),R=10;R<36;++R)L[I++]=R;for(I="A".charCodeAt(0),R=10;R<36;++R)L[I++]=R;function N(t,e){var r=L[t.charCodeAt(e)];return null==r?-1:r}function j(t){var e=P();return e.fromInt(t),e}function V(t){var e,r=1;return 0!=(e=t>>>16)&&(t=e,r+=16),0!=(e=t>>8)&&(t=e,r+=8),0!=(e=t>>4)&&(t=e,r+=4),0!=(e=t>>2)&&(t=e,r+=2),0!=(e=t>>1)&&(t=e,r+=1),r}B.ZERO=j(0),B.ONE=j(1);var U,H,F=function(){function t(){this.i=0,this.j=0,this.S=[]}return t.prototype.init=function(t){var e,r,n;for(e=0;e<256;++e)this.S[e]=e;for(r=0,e=0;e<256;++e)r=r+this.S[e]+t[e%t.length]&255,n=this.S[e],this.S[e]=this.S[r],this.S[r]=n;this.i=0,this.j=0},t.prototype.next=function(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]},t}(),G=null;if(null==G){G=[],H=0;var q=void 0;if(window.crypto&&window.crypto.getRandomValues){var K=new Uint32Array(256);for(window.crypto.getRandomValues(K),q=0;q<K.length;++q)G[H++]=255&K[q]}var z=function t(e){if(this.count=this.count||0,this.count>=256||H>=256)window.removeEventListener?window.removeEventListener("mousemove",t,!1):window.detachEvent&&window.detachEvent("onmousemove",t);else try{var r=e.x+e.y;G[H++]=255&r,this.count+=1}catch(t){}};window.addEventListener?window.addEventListener("mousemove",z,!1):window.attachEvent&&window.attachEvent("onmousemove",z)}function W(){if(null==U){for(U=new F;H<256;){var t=Math.floor(65536*Math.random());G[H++]=255&t}for(U.init(G),H=0;H<G.length;++H)G[H]=0;H=0}return U.next()}var X=function(){function t(){}return t.prototype.nextBytes=function(t){for(var e=0;e<t.length;++e)t[e]=W()},t}(),Z=function(){function t(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}return t.prototype.doPublic=function(t){return t.modPowInt(this.e,this.n)},t.prototype.doPrivate=function(t){if(null==this.p||null==this.q)return t.modPow(this.d,this.n);for(var e=t.mod(this.p).modPow(this.dmp1,this.p),r=t.mod(this.q).modPow(this.dmq1,this.q);e.compareTo(r)<0;)e=e.add(this.p);return e.subtract(r).multiply(this.coeff).mod(this.p).multiply(this.q).add(r)},t.prototype.setPublic=function(t,e){null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=M(t,16),this.e=parseInt(e,16)):console.error("Invalid RSA public key")},t.prototype.encrypt=function(t){var e=function(t,e){if(e<t.length+11)return console.error("Message too long for RSA"),null;for(var r=[],n=t.length-1;n>=0&&e>0;){var i=t.charCodeAt(n--);i<128?r[--e]=i:i>127&&i<2048?(r[--e]=63&i|128,r[--e]=i>>6|192):(r[--e]=63&i|128,r[--e]=i>>6&63|128,r[--e]=i>>12|224)}r[--e]=0;for(var o=new X,a=[];e>2;){for(a[0]=0;0==a[0];)o.nextBytes(a);r[--e]=a[0]}return r[--e]=2,r[--e]=0,new B(r)}(t,this.n.bitLength()+7>>3);if(null==e)return null;var r=this.doPublic(e);if(null==r)return null;var n=r.toString(16);return 0==(1&n.length)?n:"0"+n},t.prototype.setPrivate=function(t,e,r){null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=M(t,16),this.e=parseInt(e,16),this.d=M(r,16)):console.error("Invalid RSA private key")},t.prototype.setPrivateEx=function(t,e,r,n,i,o,a,s){null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=M(t,16),this.e=parseInt(e,16),this.d=M(r,16),this.p=M(n,16),this.q=M(i,16),this.dmp1=M(o,16),this.dmq1=M(a,16),this.coeff=M(s,16)):console.error("Invalid RSA private key")},t.prototype.generate=function(t,e){var r=new X,n=t>>1;this.e=parseInt(e,16);for(var i=new B(e,16);;){for(;this.p=new B(t-n,1,r),0!=this.p.subtract(B.ONE).gcd(i).compareTo(B.ONE)||!this.p.isProbablePrime(10););for(;this.q=new B(n,1,r),0!=this.q.subtract(B.ONE).gcd(i).compareTo(B.ONE)||!this.q.isProbablePrime(10););if(this.p.compareTo(this.q)<=0){var o=this.p;this.p=this.q,this.q=o}var a=this.p.subtract(B.ONE),s=this.q.subtract(B.ONE),u=a.multiply(s);if(0==u.gcd(i).compareTo(B.ONE)){this.n=this.p.multiply(this.q),this.d=i.modInverse(u),this.dmp1=this.d.mod(a),this.dmq1=this.d.mod(s),this.coeff=this.q.modInverse(this.p);break}}},t.prototype.decrypt=function(t){var e=M(t,16),r=this.doPrivate(e);return null==r?null:function(t,e){for(var r=t.toByteArray(),n=0;n<r.length&&0==r[n];)++n;if(r.length-n!=e-1||2!=r[n])return null;for(++n;0!=r[n];)if(++n>=r.length)return null;for(var i="";++n<r.length;){var o=255&r[n];o<128?i+=String.fromCharCode(o):o>191&&o<224?(i+=String.fromCharCode((31&o)<<6|63&r[n+1]),++n):(i+=String.fromCharCode((15&o)<<12|(63&r[n+1])<<6|63&r[n+2]),n+=2)}return i}(r,this.n.bitLength()+7>>3)},t.prototype.generateAsync=function(t,e,r){var n=new X,i=t>>1;this.e=parseInt(e,16);var o=new B(e,16),a=this;setTimeout((function e(){var s=function(){if(a.p.compareTo(a.q)<=0){var t=a.p;a.p=a.q,a.q=t}var n=a.p.subtract(B.ONE),i=a.q.subtract(B.ONE),s=n.multiply(i);0==s.gcd(o).compareTo(B.ONE)?(a.n=a.p.multiply(a.q),a.d=o.modInverse(s),a.dmp1=a.d.mod(n),a.dmq1=a.d.mod(i),a.coeff=a.q.modInverse(a.p),setTimeout((function(){r()}),0)):setTimeout(e,0)},u=function t(){a.q=P(),a.q.fromNumberAsync(i,1,n,(function(){a.q.subtract(B.ONE).gcda(o,(function(e){0==e.compareTo(B.ONE)&&a.q.isProbablePrime(10)?setTimeout(s,0):setTimeout(t,0)}))}))};setTimeout((function e(){a.p=P(),a.p.fromNumberAsync(t-i,1,n,(function(){a.p.subtract(B.ONE).gcda(o,(function(t){0==t.compareTo(B.ONE)&&a.p.isProbablePrime(10)?setTimeout(u,0):setTimeout(e,0)}))}))}),0)}),0)},t.prototype.sign=function(t,e,r){var n=function(t,e){if(e<t.length+22)return console.error("Message too long for RSA"),null;for(var r=e-t.length-6,n="",i=0;i<r;i+=2)n+="ff";return M("0001"+n+"00"+t,16)}((J[r]||"")+e(t).toString(),this.n.bitLength()/4);if(null==n)return null;var i=this.doPrivate(n);if(null==i)return null;var o=i.toString(16);return 0==(1&o.length)?o:"0"+o},t.prototype.verify=function(t,e,r){var n=M(e,16),i=this.doPublic(n);return null==i?null:function(t){for(var e in J)if(J.hasOwnProperty(e)){var r=J[e],n=r.length;if(t.substr(0,n)==r)return t.substr(n)}return t}
/*!
                   Copyright (c) 2011, Yahoo! Inc. All rights reserved.
                   Code licensed under the BSD License:
                   http://developer.yahoo.com/yui/license.html
                   version: 2.9.0
                   */(i.toString(16).replace(/^1f+00/,""))==r(t).toString()},t}(),J={md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",ripemd160:"3021300906052b2403020105000414"},Y={};Y.lang={extend:function(t,e,r){if(!e||!t)throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");var n=function(){};if(n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t,t.superclass=e.prototype,e.prototype.constructor==Object.prototype.constructor&&(e.prototype.constructor=e),r){var i;for(i in r)t.prototype[i]=r[i];var o=function(){},a=["toString","valueOf"];try{/MSIE/.test(navigator.userAgent)&&(o=function(t,e){for(i=0;i<a.length;i+=1){var r=a[i],n=e[r];"function"==typeof n&&n!=Object.prototype[r]&&(t[r]=n)}})}catch(t){}o(t.prototype,r)}}};
/**
             * @fileOverview
             * @name asn1-1.0.js
             * @author Kenji Urushima kenji.urushima@gmail.com
             * @version asn1 1.0.13 (2017-Jun-02)
             * @since jsrsasign 2.1
             * @license <a href="https://kjur.github.io/jsrsasign/license/">MIT License</a>
             */
var Q={};void 0!==Q.asn1&&Q.asn1||(Q.asn1={}),Q.asn1.ASN1Util=new function(){this.integerToByteHex=function(t){var e=t.toString(16);return e.length%2==1&&(e="0"+e),e},this.bigIntToMinTwosComplementsHex=function(t){var e=t.toString(16);if("-"!=e.substr(0,1))e.length%2==1?e="0"+e:e.match(/^[0-7]/)||(e="00"+e);else{var r=e.substr(1).length;r%2==1?r+=1:e.match(/^[0-7]/)||(r+=2);for(var n="",i=0;i<r;i++)n+="f";e=new B(n,16).xor(t).add(B.ONE).toString(16).replace(/^-/,"")}return e},this.getPEMStringFromHex=function(t,e){return hextopem(t,e)},this.newObject=function(t){var e=Q.asn1,r=e.DERBoolean,n=e.DERInteger,i=e.DERBitString,o=e.DEROctetString,a=e.DERNull,s=e.DERObjectIdentifier,u=e.DEREnumerated,c=e.DERUTF8String,f=e.DERNumericString,l=e.DERPrintableString,h=e.DERTeletexString,p=e.DERIA5String,d=e.DERUTCTime,g=e.DERGeneralizedTime,v=e.DERSequence,y=e.DERSet,m=e.DERTaggedObject,b=e.ASN1Util.newObject,x=Object.keys(t);if(1!=x.length)throw"key of param shall be only one.";var w=x[0];if(-1==":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":"+w+":"))throw"undefined key: "+w;if("bool"==w)return new r(t[w]);if("int"==w)return new n(t[w]);if("bitstr"==w)return new i(t[w]);if("octstr"==w)return new o(t[w]);if("null"==w)return new a(t[w]);if("oid"==w)return new s(t[w]);if("enum"==w)return new u(t[w]);if("utf8str"==w)return new c(t[w]);if("numstr"==w)return new f(t[w]);if("prnstr"==w)return new l(t[w]);if("telstr"==w)return new h(t[w]);if("ia5str"==w)return new p(t[w]);if("utctime"==w)return new d(t[w]);if("gentime"==w)return new g(t[w]);if("seq"==w){for(var T=t[w],S=[],E=0;E<T.length;E++){var O=b(T[E]);S.push(O)}return new v({array:S})}if("set"==w){for(T=t[w],S=[],E=0;E<T.length;E++)O=b(T[E]),S.push(O);return new y({array:S})}if("tag"==w){var _=t[w];if("[object Array]"===Object.prototype.toString.call(_)&&3==_.length){var B=b(_[2]);return new m({tag:_[0],explicit:_[1],obj:B})}var A={};if(void 0!==_.explicit&&(A.explicit=_.explicit),void 0!==_.tag&&(A.tag=_.tag),void 0===_.obj)throw"obj shall be specified for 'tag'.";return A.obj=b(_.obj),new m(A)}},this.jsonToASN1HEX=function(t){return this.newObject(t).getEncodedHex()}},Q.asn1.ASN1Util.oidHexToInt=function(t){for(var e="",r=parseInt(t.substr(0,2),16),n=(e=Math.floor(r/40)+"."+r%40,""),i=2;i<t.length;i+=2){var o=("00000000"+parseInt(t.substr(i,2),16).toString(2)).slice(-8);n+=o.substr(1,7),"0"==o.substr(0,1)&&(e=e+"."+new B(n,2).toString(10),n="")}return e},Q.asn1.ASN1Util.oidIntToHex=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},r=function(t){var r="",n=new B(t,10).toString(2),i=7-n.length%7;7==i&&(i=0);for(var o="",a=0;a<i;a++)o+="0";for(n=o+n,a=0;a<n.length-1;a+=7){var s=n.substr(a,7);a!=n.length-7&&(s="1"+s),r+=e(parseInt(s,2))}return r};if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var n="",i=t.split("."),o=40*parseInt(i[0])+parseInt(i[1]);n+=e(o),i.splice(0,2);for(var a=0;a<i.length;a++)n+=r(i[a]);return n},Q.asn1.ASN1Object=function(){this.getLengthHexFromValue=function(){if(void 0===this.hV||null==this.hV)throw"this.hV is null or undefined.";if(this.hV.length%2==1)throw"value hex must be even length: n="+"".length+",v="+this.hV;var t=this.hV.length/2,e=t.toString(16);if(e.length%2==1&&(e="0"+e),t<128)return e;var r=e.length/2;if(r>15)throw"ASN.1 length too long to represent by 8x: n = "+t.toString(16);return(128+r).toString(16)+e},this.getEncodedHex=function(){return(null==this.hTLV||this.isModified)&&(this.hV=this.getFreshValueHex(),this.hL=this.getLengthHexFromValue(),this.hTLV=this.hT+this.hL+this.hV,this.isModified=!1),this.hTLV},this.getValueHex=function(){return this.getEncodedHex(),this.hV},this.getFreshValueHex=function(){return""}},Q.asn1.DERAbstractString=function(t){Q.asn1.DERAbstractString.superclass.constructor.call(this),this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=stohex(this.s)},this.setStringHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t?this.setString(t):void 0!==t.str?this.setString(t.str):void 0!==t.hex&&this.setStringHex(t.hex))},Y.lang.extend(Q.asn1.DERAbstractString,Q.asn1.ASN1Object),Q.asn1.DERAbstractTime=function(t){Q.asn1.DERAbstractTime.superclass.constructor.call(this),this.localDateToUTC=function(t){return utc=t.getTime()+6e4*t.getTimezoneOffset(),new Date(utc)},this.formatDate=function(t,e,r){var n=this.zeroPadding,i=this.localDateToUTC(t),o=String(i.getFullYear());"utc"==e&&(o=o.substr(2,2));var a=o+n(String(i.getMonth()+1),2)+n(String(i.getDate()),2)+n(String(i.getHours()),2)+n(String(i.getMinutes()),2)+n(String(i.getSeconds()),2);if(!0===r){var s=i.getMilliseconds();if(0!=s){var u=n(String(s),3);a=a+"."+(u=u.replace(/[0]+$/,""))}}return a+"Z"},this.zeroPadding=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=stohex(t)},this.setByDateValue=function(t,e,r,n,i,o){var a=new Date(Date.UTC(t,e-1,r,n,i,o,0));this.setByDate(a)},this.getFreshValueHex=function(){return this.hV}},Y.lang.extend(Q.asn1.DERAbstractTime,Q.asn1.ASN1Object),Q.asn1.DERAbstractStructured=function(t){Q.asn1.DERAbstractString.superclass.constructor.call(this),this.setByASN1ObjectArray=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array=t},this.appendASN1Object=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array.push(t)},this.asn1Array=new Array,void 0!==t&&void 0!==t.array&&(this.asn1Array=t.array)},Y.lang.extend(Q.asn1.DERAbstractStructured,Q.asn1.ASN1Object),Q.asn1.DERBoolean=function(){Q.asn1.DERBoolean.superclass.constructor.call(this),this.hT="01",this.hTLV="0101ff"},Y.lang.extend(Q.asn1.DERBoolean,Q.asn1.ASN1Object),Q.asn1.DERInteger=function(t){Q.asn1.DERInteger.superclass.constructor.call(this),this.hT="02",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=Q.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new B(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.bigint?this.setByBigInteger(t.bigint):void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},Y.lang.extend(Q.asn1.DERInteger,Q.asn1.ASN1Object),Q.asn1.DERBitString=function(t){if(void 0!==t&&void 0!==t.obj){var e=Q.asn1.ASN1Util.newObject(t.obj);t.hex="00"+e.getEncodedHex()}Q.asn1.DERBitString.superclass.constructor.call(this),this.hT="03",this.setHexValueIncludingUnusedBits=function(t){this.hTLV=null,this.isModified=!0,this.hV=t},this.setUnusedBitsAndHexValue=function(t,e){if(t<0||7<t)throw"unused bits shall be from 0 to 7: u = "+t;var r="0"+t;this.hTLV=null,this.isModified=!0,this.hV=r+e},this.setByBinaryString=function(t){var e=8-(t=t.replace(/0+$/,"")).length%8;8==e&&(e=0);for(var r=0;r<=e;r++)t+="0";var n="";for(r=0;r<t.length-1;r+=8){var i=t.substr(r,8),o=parseInt(i,2).toString(16);1==o.length&&(o="0"+o),n+=o}this.hTLV=null,this.isModified=!0,this.hV="0"+e+n},this.setByBooleanArray=function(t){for(var e="",r=0;r<t.length;r++)1==t[r]?e+="1":e+="0";this.setByBinaryString(e)},this.newFalseArray=function(t){for(var e=new Array(t),r=0;r<t;r++)e[r]=!1;return e},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t&&t.toLowerCase().match(/^[0-9a-f]+$/)?this.setHexValueIncludingUnusedBits(t):void 0!==t.hex?this.setHexValueIncludingUnusedBits(t.hex):void 0!==t.bin?this.setByBinaryString(t.bin):void 0!==t.array&&this.setByBooleanArray(t.array))},Y.lang.extend(Q.asn1.DERBitString,Q.asn1.ASN1Object),Q.asn1.DEROctetString=function(t){if(void 0!==t&&void 0!==t.obj){var e=Q.asn1.ASN1Util.newObject(t.obj);t.hex=e.getEncodedHex()}Q.asn1.DEROctetString.superclass.constructor.call(this,t),this.hT="04"},Y.lang.extend(Q.asn1.DEROctetString,Q.asn1.DERAbstractString),Q.asn1.DERNull=function(){Q.asn1.DERNull.superclass.constructor.call(this),this.hT="05",this.hTLV="0500"},Y.lang.extend(Q.asn1.DERNull,Q.asn1.ASN1Object),Q.asn1.DERObjectIdentifier=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},r=function(t){var r="",n=new B(t,10).toString(2),i=7-n.length%7;7==i&&(i=0);for(var o="",a=0;a<i;a++)o+="0";for(n=o+n,a=0;a<n.length-1;a+=7){var s=n.substr(a,7);a!=n.length-7&&(s="1"+s),r+=e(parseInt(s,2))}return r};Q.asn1.DERObjectIdentifier.superclass.constructor.call(this),this.hT="06",this.setValueHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.setValueOidString=function(t){if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var n="",i=t.split("."),o=40*parseInt(i[0])+parseInt(i[1]);n+=e(o),i.splice(0,2);for(var a=0;a<i.length;a++)n+=r(i[a]);this.hTLV=null,this.isModified=!0,this.s=null,this.hV=n},this.setValueName=function(t){var e=Q.asn1.x509.OID.name2oid(t);if(""===e)throw"DERObjectIdentifier oidName undefined: "+t;this.setValueOidString(e)},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t?t.match(/^[0-2].[0-9.]+$/)?this.setValueOidString(t):this.setValueName(t):void 0!==t.oid?this.setValueOidString(t.oid):void 0!==t.hex?this.setValueHex(t.hex):void 0!==t.name&&this.setValueName(t.name))},Y.lang.extend(Q.asn1.DERObjectIdentifier,Q.asn1.ASN1Object),Q.asn1.DEREnumerated=function(t){Q.asn1.DEREnumerated.superclass.constructor.call(this),this.hT="0a",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=Q.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new B(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},Y.lang.extend(Q.asn1.DEREnumerated,Q.asn1.ASN1Object),Q.asn1.DERUTF8String=function(t){Q.asn1.DERUTF8String.superclass.constructor.call(this,t),this.hT="0c"},Y.lang.extend(Q.asn1.DERUTF8String,Q.asn1.DERAbstractString),Q.asn1.DERNumericString=function(t){Q.asn1.DERNumericString.superclass.constructor.call(this,t),this.hT="12"},Y.lang.extend(Q.asn1.DERNumericString,Q.asn1.DERAbstractString),Q.asn1.DERPrintableString=function(t){Q.asn1.DERPrintableString.superclass.constructor.call(this,t),this.hT="13"},Y.lang.extend(Q.asn1.DERPrintableString,Q.asn1.DERAbstractString),Q.asn1.DERTeletexString=function(t){Q.asn1.DERTeletexString.superclass.constructor.call(this,t),this.hT="14"},Y.lang.extend(Q.asn1.DERTeletexString,Q.asn1.DERAbstractString),Q.asn1.DERIA5String=function(t){Q.asn1.DERIA5String.superclass.constructor.call(this,t),this.hT="16"},Y.lang.extend(Q.asn1.DERIA5String,Q.asn1.DERAbstractString),Q.asn1.DERUTCTime=function(t){Q.asn1.DERUTCTime.superclass.constructor.call(this,t),this.hT="17",this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"utc"),this.hV=stohex(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"utc"),this.hV=stohex(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{12}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date))},Y.lang.extend(Q.asn1.DERUTCTime,Q.asn1.DERAbstractTime),Q.asn1.DERGeneralizedTime=function(t){Q.asn1.DERGeneralizedTime.superclass.constructor.call(this,t),this.hT="18",this.withMillis=!1,this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=stohex(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=stohex(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{14}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date),!0===t.millis&&(this.withMillis=!0))},Y.lang.extend(Q.asn1.DERGeneralizedTime,Q.asn1.DERAbstractTime),Q.asn1.DERSequence=function(t){Q.asn1.DERSequence.superclass.constructor.call(this,t),this.hT="30",this.getFreshValueHex=function(){for(var t="",e=0;e<this.asn1Array.length;e++)t+=this.asn1Array[e].getEncodedHex();return this.hV=t,this.hV}},Y.lang.extend(Q.asn1.DERSequence,Q.asn1.DERAbstractStructured),Q.asn1.DERSet=function(t){Q.asn1.DERSet.superclass.constructor.call(this,t),this.hT="31",this.sortFlag=!0,this.getFreshValueHex=function(){for(var t=new Array,e=0;e<this.asn1Array.length;e++){var r=this.asn1Array[e];t.push(r.getEncodedHex())}return 1==this.sortFlag&&t.sort(),this.hV=t.join(""),this.hV},void 0!==t&&void 0!==t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},Y.lang.extend(Q.asn1.DERSet,Q.asn1.DERAbstractStructured),Q.asn1.DERTaggedObject=function(t){Q.asn1.DERTaggedObject.superclass.constructor.call(this),this.hT="a0",this.hV="",this.isExplicit=!0,this.asn1Object=null,this.setASN1Object=function(t,e,r){this.hT=e,this.isExplicit=t,this.asn1Object=r,this.isExplicit?(this.hV=this.asn1Object.getEncodedHex(),this.hTLV=null,this.isModified=!0):(this.hV=null,this.hTLV=r.getEncodedHex(),this.hTLV=this.hTLV.replace(/^../,e),this.isModified=!1)},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.tag&&(this.hT=t.tag),void 0!==t.explicit&&(this.isExplicit=t.explicit),void 0!==t.obj&&(this.asn1Object=t.obj,this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)))},Y.lang.extend(Q.asn1.DERTaggedObject,Q.asn1.ASN1Object);var $=function(t){function e(r){var n=t.call(this)||this;return r&&("string"==typeof r?n.parseKey(r):(e.hasPrivateKeyProperty(r)||e.hasPublicKeyProperty(r))&&n.parsePropertiesFrom(r)),n}return function(t,e){function r(){this.constructor=t}d(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}(e,t),e.prototype.parseKey=function(t){try{var e=0,r=0,n=/^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/.test(t)?function(t){var e;if(void 0===h){var r="0123456789ABCDEF";for(h={},e=0;e<16;++e)h[r.charAt(e)]=e;for(r=r.toLowerCase(),e=10;e<16;++e)h[r.charAt(e)]=e;for(e=0;e<" \f\n\r\t \u2028\u2029".length;++e)h[" \f\n\r\t \u2028\u2029".charAt(e)]=-1}var n=[],i=0,o=0;for(e=0;e<t.length;++e){var a=t.charAt(e);if("="==a)break;if(-1!=(a=h[a])){if(void 0===a)throw new Error("Illegal character at offset "+e);i|=a,++o>=2?(n[n.length]=i,i=0,o=0):i<<=4}}if(o)throw new Error("Hex encoding incomplete: 4 bits missing");return n}(t):g.unarmor(t),i=S.decode(n);if(3===i.sub.length&&(i=i.sub[2].sub[0]),9===i.sub.length){e=i.sub[1].getHexStringValue(),this.n=M(e,16),r=i.sub[2].getHexStringValue(),this.e=parseInt(r,16);var o=i.sub[3].getHexStringValue();this.d=M(o,16);var a=i.sub[4].getHexStringValue();this.p=M(a,16);var s=i.sub[5].getHexStringValue();this.q=M(s,16);var u=i.sub[6].getHexStringValue();this.dmp1=M(u,16);var c=i.sub[7].getHexStringValue();this.dmq1=M(c,16);var f=i.sub[8].getHexStringValue();this.coeff=M(f,16)}else{if(2!==i.sub.length)return!1;var l=i.sub[1].sub[0];e=l.sub[0].getHexStringValue(),this.n=M(e,16),r=l.sub[1].getHexStringValue(),this.e=parseInt(r,16)}return!0}catch(t){return!1}},e.prototype.getPrivateBaseKey=function(){var t={array:[new Q.asn1.DERInteger({int:0}),new Q.asn1.DERInteger({bigint:this.n}),new Q.asn1.DERInteger({int:this.e}),new Q.asn1.DERInteger({bigint:this.d}),new Q.asn1.DERInteger({bigint:this.p}),new Q.asn1.DERInteger({bigint:this.q}),new Q.asn1.DERInteger({bigint:this.dmp1}),new Q.asn1.DERInteger({bigint:this.dmq1}),new Q.asn1.DERInteger({bigint:this.coeff})]};return new Q.asn1.DERSequence(t).getEncodedHex()},e.prototype.getPrivateBaseKeyB64=function(){return f(this.getPrivateBaseKey())},e.prototype.getPublicBaseKey=function(){var t=new Q.asn1.DERSequence({array:[new Q.asn1.DERObjectIdentifier({oid:"1.2.840.113549.1.1.1"}),new Q.asn1.DERNull]}),e=new Q.asn1.DERSequence({array:[new Q.asn1.DERInteger({bigint:this.n}),new Q.asn1.DERInteger({int:this.e})]}),r=new Q.asn1.DERBitString({hex:"00"+e.getEncodedHex()});return new Q.asn1.DERSequence({array:[t,r]}).getEncodedHex()},e.prototype.getPublicBaseKeyB64=function(){return f(this.getPublicBaseKey())},e.wordwrap=function(t,e){if(!t)return t;var r="(.{1,"+(e=e||64)+"})( +|$\n?)|(.{1,"+e+"})";return t.match(RegExp(r,"g")).join("\n")},e.prototype.getPrivateKey=function(){var t="-----BEGIN RSA PRIVATE KEY-----\n";return(t+=e.wordwrap(this.getPrivateBaseKeyB64())+"\n")+"-----END RSA PRIVATE KEY-----"},e.prototype.getPublicKey=function(){var t="-----BEGIN PUBLIC KEY-----\n";return(t+=e.wordwrap(this.getPublicBaseKeyB64())+"\n")+"-----END PUBLIC KEY-----"},e.hasPublicKeyProperty=function(t){return(t=t||{}).hasOwnProperty("n")&&t.hasOwnProperty("e")},e.hasPrivateKeyProperty=function(t){return(t=t||{}).hasOwnProperty("n")&&t.hasOwnProperty("e")&&t.hasOwnProperty("d")&&t.hasOwnProperty("p")&&t.hasOwnProperty("q")&&t.hasOwnProperty("dmp1")&&t.hasOwnProperty("dmq1")&&t.hasOwnProperty("coeff")},e.prototype.parsePropertiesFrom=function(t){this.n=t.n,this.e=t.e,t.hasOwnProperty("d")&&(this.d=t.d,this.p=t.p,this.q=t.q,this.dmp1=t.dmp1,this.dmq1=t.dmq1,this.coeff=t.coeff)},e}(Z),tt=function(){function t(t){t=t||{},this.default_key_size=parseInt(t.default_key_size,10)||1024,this.default_public_exponent=t.default_public_exponent||"010001",this.log=t.log||!1,this.key=null}return t.prototype.setKey=function(t){this.log&&this.key&&console.warn("A key was already set, overriding existing."),this.key=new $(t)},t.prototype.setPrivateKey=function(t){this.setKey(t)},t.prototype.setPublicKey=function(t){this.setKey(t)},t.prototype.decrypt=function(t){try{return this.getKey().decrypt(l(t))}catch(t){return!1}},t.prototype.encrypt=function(t){try{return f(this.getKey().encrypt(t))}catch(t){return!1}},t.prototype.sign=function(t,e,r){try{return f(this.getKey().sign(t,e,r))}catch(t){return!1}},t.prototype.verify=function(t,e,r){try{return this.getKey().verify(t,l(e),r)}catch(t){return!1}},t.prototype.getKey=function(t){if(!this.key){if(this.key=new $,t&&"[object Function]"==={}.toString.call(t))return void this.key.generateAsync(this.default_key_size,this.default_public_exponent,t);this.key.generate(this.default_key_size,this.default_public_exponent)}return this.key},t.prototype.getPrivateKey=function(){return this.getKey().getPrivateKey()},t.prototype.getPrivateKeyB64=function(){return this.getKey().getPrivateBaseKeyB64()},t.prototype.getPublicKey=function(){return this.getKey().getPublicKey()},t.prototype.getPublicKeyB64=function(){return this.getKey().getPublicBaseKeyB64()},t.version="3.0.0-rc.1",t}();window.JSEncrypt=tt,t.exports=tt,Object.defineProperty(e,"__esModule",{value:!0})}))},void 0===(o="function"==typeof n?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[r(5),r(30),r(6),r(1),r(21)],void 0===(o="function"==typeof(n=function(e,n,i,o,a){"use strict";var s=r(2);e=s(e),n=s(n),i=s(i),o=s(o),a=s(a);var u=r(3)||{},c=r(4),f=(new(r(23)),{userAgent:function(t,e){var r=(e||navigator.userAgent).toLowerCase();if(t&&"object"===(0,o.default)(t)){for(var n in t){var i=t[n],a=i&&i.exec(r)||[];if(3===a.length&&a[2])return{key:"common"!==n?n:a[1],info:a};if(2===a.length&&a[1])return{key:"common"!==n?n:a[1],info:a}}return{key:null,info:r}}return r},systemName:function(){var t=u.system;return f.userAgent(t).key||"Other"},systemVersion:function(){var t=f.userAgent({wp:/(windows\sphone)\s?([\w\s.]*)/,mac:/(mac\sos\sx)\s?([\w\s.]*)/,win:/(windows\smobile|windows)[\s/a-zA-Z]+([\d.\s]+\w)/,android:/(android)[\s_\-i686]?[\s_\-/](\d+[.\-_]?\d+[.\-_]?\d*)/,ios:/(os) (.*) like mac os x/}).info[2]||"",e=t.replace(/[-|_|.]/g,"");return isNaN(1*e)?null:t.replace(/[-|_]/g,".")},browserName:function(){var t=u.browser;return f.userAgent(t).key||"Other"},browserVersion:function(){var t=u.browser;return(f.userAgent(t).info[2]||"").replace(/[-|_]/g,".")},browserKernelName:function(){var t=u.browserKernel;return f.userAgent(t).key},browserKernelVersion:function(){var t=u.browserKernel;return f.userAgent(t).info[2]},webSQLEnable:function(){return!!window.openDatabase},doNotTrack:function(){return navigator.doNotTrack||navigator.msDoNotTrack||window.doNotTrack},isAlphaGo:function(t){var e=!1;return"isTrusted"in t&&!t.isTrusted&&(e=!0,Math.random()>.1)||e},gpuType:function(){var t;try{var e=document.createElement("canvas").getContext("webgl"),r=e.getExtension("WEBGL_debug_renderer_info");t=e.getParameter(r.UNMASKED_RENDERER_WEBGL)}catch(e){t="Not supported"}return t},UUID:function(){return(0,i.default)(e.default.mark((function t(){var r;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r="",a.default.get("HB-VULCAN-UUID")?(r=a.default.get("HB-VULCAN-UUID"),a.default.get("HB-VULCAN-UUID")!==c.getStore("HB-VULCAN-UUID")&&c.setStore("HB-VULCAN-UUID",r)):c.getStore("HB-VULCAN-UUID")?(r=c.getStore("HB-VULCAN-UUID"),a.default.set("HB-VULCAN-UUID",r,{domain:c.getHost(),path:"/",expires:1095})):(r=c.generateUUID(),a.default.set("HB-VULCAN-UUID",r,{domain:c.getHost(),path:"/",expires:1095}),c.setStore("HB-VULCAN-UUID",r)),t.abrupt("return",r);case 4:case"end":return t.stop()}}),t)})))()},getEnvInfo:function(){return(0,n.default)(navigator.plugins).map((function(t){return t.name}))||[]},hostname:function(){return window.location.hostname},pixelRatio:function(){return window.devicePixelRatio},timezone:function(){var t=(new Date).getTimezoneOffset()/60;return"UTC".concat(t>0?"-":"+").concat(Math.abs(t),":00")}});t.exports=f})?n.apply(e,i):n)||(t.exports=o)},function(t,e,r){var n=r(31),i=r(32),o=r(33),a=r(34);t.exports=function(t){return n(t)||i(t)||o(t)||a()},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(22);t.exports=function(t){if(Array.isArray(t))return n(t)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e,r){var n=r(22);t.exports=function(t,e){if(t){if("string"==typeof t)return n(t,e);var r=Object.prototype.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(t,e):void 0}},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},t.exports.__esModule=!0,t.exports.default=t.exports},function(t,e){t.exports=n},function(t,e){t.exports=i}]))},function(t,e,r){var n,i;!function(o,a,s){"use strict";"undefined"!=typeof window&&r(26)?void 0===(i="function"==typeof(n=s)?n.call(e,r,e,t):n)||(t.exports=i):t.exports?t.exports=s():a.exports?a.exports=s():a.Fingerprint2=s()}(0,this,(function(){"use strict";void 0===Array.isArray&&(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)});var t=function(t,e){t=[t[0]>>>16,65535&t[0],t[1]>>>16,65535&t[1]],e=[e[0]>>>16,65535&e[0],e[1]>>>16,65535&e[1]];var r=[0,0,0,0];return r[3]+=t[3]+e[3],r[2]+=r[3]>>>16,r[3]&=65535,r[2]+=t[2]+e[2],r[1]+=r[2]>>>16,r[2]&=65535,r[1]+=t[1]+e[1],r[0]+=r[1]>>>16,r[1]&=65535,r[0]+=t[0]+e[0],r[0]&=65535,[r[0]<<16|r[1],r[2]<<16|r[3]]},e=function(t,e){t=[t[0]>>>16,65535&t[0],t[1]>>>16,65535&t[1]],e=[e[0]>>>16,65535&e[0],e[1]>>>16,65535&e[1]];var r=[0,0,0,0];return r[3]+=t[3]*e[3],r[2]+=r[3]>>>16,r[3]&=65535,r[2]+=t[2]*e[3],r[1]+=r[2]>>>16,r[2]&=65535,r[2]+=t[3]*e[2],r[1]+=r[2]>>>16,r[2]&=65535,r[1]+=t[1]*e[3],r[0]+=r[1]>>>16,r[1]&=65535,r[1]+=t[2]*e[2],r[0]+=r[1]>>>16,r[1]&=65535,r[1]+=t[3]*e[1],r[0]+=r[1]>>>16,r[1]&=65535,r[0]+=t[0]*e[3]+t[1]*e[2]+t[2]*e[1]+t[3]*e[0],r[0]&=65535,[r[0]<<16|r[1],r[2]<<16|r[3]]},r=function(t,e){return 32===(e%=64)?[t[1],t[0]]:e<32?[t[0]<<e|t[1]>>>32-e,t[1]<<e|t[0]>>>32-e]:(e-=32,[t[1]<<e|t[0]>>>32-e,t[0]<<e|t[1]>>>32-e])},n=function(t,e){return 0===(e%=64)?t:e<32?[t[0]<<e|t[1]>>>32-e,t[1]<<e]:[t[1]<<e-32,0]},i=function(t,e){return[t[0]^e[0],t[1]^e[1]]},o=function(t){return t=i(t,[0,t[0]>>>1]),t=e(t,[4283543511,3981806797]),t=i(t,[0,t[0]>>>1]),t=e(t,[3301882366,444984403]),t=i(t,[0,t[0]>>>1])},a=function(a,s){s=s||0;for(var u=(a=a||"").length%16,c=a.length-u,f=[0,s],l=[0,s],h=[0,0],p=[0,0],d=[2277735313,289559509],g=[1291169091,658871167],v=0;v<c;v+=16)h=[255&a.charCodeAt(v+4)|(255&a.charCodeAt(v+5))<<8|(255&a.charCodeAt(v+6))<<16|(255&a.charCodeAt(v+7))<<24,255&a.charCodeAt(v)|(255&a.charCodeAt(v+1))<<8|(255&a.charCodeAt(v+2))<<16|(255&a.charCodeAt(v+3))<<24],p=[255&a.charCodeAt(v+12)|(255&a.charCodeAt(v+13))<<8|(255&a.charCodeAt(v+14))<<16|(255&a.charCodeAt(v+15))<<24,255&a.charCodeAt(v+8)|(255&a.charCodeAt(v+9))<<8|(255&a.charCodeAt(v+10))<<16|(255&a.charCodeAt(v+11))<<24],h=e(h,d),h=r(h,31),h=e(h,g),f=i(f,h),f=r(f,27),f=t(f,l),f=t(e(f,[0,5]),[0,1390208809]),p=e(p,g),p=r(p,33),p=e(p,d),l=i(l,p),l=r(l,31),l=t(l,f),l=t(e(l,[0,5]),[0,944331445]);switch(h=[0,0],p=[0,0],u){case 15:p=i(p,n([0,a.charCodeAt(v+14)],48));case 14:p=i(p,n([0,a.charCodeAt(v+13)],40));case 13:p=i(p,n([0,a.charCodeAt(v+12)],32));case 12:p=i(p,n([0,a.charCodeAt(v+11)],24));case 11:p=i(p,n([0,a.charCodeAt(v+10)],16));case 10:p=i(p,n([0,a.charCodeAt(v+9)],8));case 9:p=i(p,[0,a.charCodeAt(v+8)]),p=e(p,g),p=r(p,33),p=e(p,d),l=i(l,p);case 8:h=i(h,n([0,a.charCodeAt(v+7)],56));case 7:h=i(h,n([0,a.charCodeAt(v+6)],48));case 6:h=i(h,n([0,a.charCodeAt(v+5)],40));case 5:h=i(h,n([0,a.charCodeAt(v+4)],32));case 4:h=i(h,n([0,a.charCodeAt(v+3)],24));case 3:h=i(h,n([0,a.charCodeAt(v+2)],16));case 2:h=i(h,n([0,a.charCodeAt(v+1)],8));case 1:h=i(h,[0,a.charCodeAt(v)]),h=e(h,d),h=r(h,31),h=e(h,g),f=i(f,h)}return f=i(f,[0,a.length]),l=i(l,[0,a.length]),f=t(f,l),l=t(l,f),f=o(f),l=o(l),f=t(f,l),l=t(l,f),("00000000"+(f[0]>>>0).toString(16)).slice(-8)+("00000000"+(f[1]>>>0).toString(16)).slice(-8)+("00000000"+(l[0]>>>0).toString(16)).slice(-8)+("00000000"+(l[1]>>>0).toString(16)).slice(-8)},s={preprocessor:null,audio:{timeout:1e3,excludeIOS11:!0},fonts:{swfContainerId:"fingerprintjs2",swfPath:"flash/compiled/FontList.swf",userDefinedFonts:[],extendedJsFonts:!1},screen:{detectScreenOrientation:!0},plugins:{sortPluginsFor:[/palemoon/i],excludeIE:!1},extraComponents:[],excludes:{enumerateDevices:!0,pixelRatio:!0,doNotTrack:!0,fontsFlash:!0,adBlock:!0},NOT_AVAILABLE:"not available",ERROR:"error",EXCLUDED:"excluded"},u=function(t,e){if(Array.prototype.forEach&&t.forEach===Array.prototype.forEach)t.forEach(e);else if(t.length===+t.length)for(var r=0,n=t.length;r<n;r++)e(t[r],r,t);else for(var i in t)t.hasOwnProperty(i)&&e(t[i],i,t)},c=function(t,e){var r=[];return null==t?r:Array.prototype.map&&t.map===Array.prototype.map?t.map(e):(u(t,(function(t,n,i){r.push(e(t,n,i))})),r)},f=function(){return navigator.mediaDevices&&navigator.mediaDevices.enumerateDevices},l=function(t){var e=[window.screen.width,window.screen.height];return t.screen.detectScreenOrientation&&e.sort().reverse(),e},h=function(t){if(window.screen.availWidth&&window.screen.availHeight){var e=[window.screen.availHeight,window.screen.availWidth];return t.screen.detectScreenOrientation&&e.sort().reverse(),e}return t.NOT_AVAILABLE},p=function(t){if(null==navigator.plugins)return t.NOT_AVAILABLE;for(var e=[],r=0,n=navigator.plugins.length;r<n;r++)navigator.plugins[r]&&e.push(navigator.plugins[r]);return g(t)&&(e=e.sort((function(t,e){return t.name>e.name?1:t.name<e.name?-1:0}))),c(e,(function(t){var e=c(t,(function(t){return[t.type,t.suffixes]}));return[t.name,t.description,e]}))},d=function(t){var e=[];if(Object.getOwnPropertyDescriptor&&Object.getOwnPropertyDescriptor(window,"ActiveXObject")||"ActiveXObject"in window){e=c(["AcroPDF.PDF","Adodb.Stream","AgControl.AgControl","DevalVRXCtrl.DevalVRXCtrl.1","MacromediaFlashPaper.MacromediaFlashPaper","Msxml2.DOMDocument","Msxml2.XMLHTTP","PDF.PdfCtrl","QuickTime.QuickTime","QuickTimeCheckObject.QuickTimeCheck.1","RealPlayer","RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)","RealVideo.RealVideo(tm) ActiveX Control (32-bit)","Scripting.Dictionary","SWCtl.SWCtl","Shell.UIHelper","ShockwaveFlash.ShockwaveFlash","Skype.Detection","TDCCtl.TDCCtl","WMPlayer.OCX","rmocx.RealPlayer G2 Control","rmocx.RealPlayer G2 Control.1"],(function(e){try{return new window.ActiveXObject(e),e}catch(e){return t.ERROR}}))}else e.push(t.NOT_AVAILABLE);return navigator.plugins&&(e=e.concat(p(t))),e},g=function(t){for(var e=!1,r=0,n=t.plugins.sortPluginsFor.length;r<n;r++){var i=t.plugins.sortPluginsFor[r];if(navigator.userAgent.match(i)){e=!0;break}}return e},v=function(t){try{return!!window.sessionStorage}catch(e){return t.ERROR}},y=function(t){try{return!!window.localStorage}catch(e){return t.ERROR}},m=function(t){if(R())return t.EXCLUDED;try{return!!window.indexedDB}catch(e){return t.ERROR}},b=function(t){return navigator.hardwareConcurrency?navigator.hardwareConcurrency:t.NOT_AVAILABLE},x=function(t){return navigator.cpuClass||t.NOT_AVAILABLE},w=function(t){return navigator.platform?navigator.platform:t.NOT_AVAILABLE},T=function(t){return navigator.doNotTrack?navigator.doNotTrack:navigator.msDoNotTrack?navigator.msDoNotTrack:window.doNotTrack?window.doNotTrack:t.NOT_AVAILABLE},S=function(){var t,e=0;void 0!==navigator.maxTouchPoints?e=navigator.maxTouchPoints:void 0!==navigator.msMaxTouchPoints&&(e=navigator.msMaxTouchPoints);try{document.createEvent("TouchEvent"),t=!0}catch(e){t=!1}return[e,t,"ontouchstart"in window]},E=function(t){var e=[],r=document.createElement("canvas");r.width=2e3,r.height=200,r.style.display="inline";var n=r.getContext("2d");return n.rect(0,0,10,10),n.rect(2,2,6,6),e.push("canvas winding:"+(!1===n.isPointInPath(5,5,"evenodd")?"yes":"no")),n.textBaseline="alphabetic",n.fillStyle="#f60",n.fillRect(125,1,62,20),n.fillStyle="#069",t.dontUseFakeFontInCanvas?n.font="11pt Arial":n.font="11pt no-real-font-123",n.fillText("Cwm fjordbank glyphs vext quiz, 😃",2,15),n.fillStyle="rgba(102, 204, 0, 0.2)",n.font="18pt Arial",n.fillText("Cwm fjordbank glyphs vext quiz, 😃",4,45),n.globalCompositeOperation="multiply",n.fillStyle="rgb(255,0,255)",n.beginPath(),n.arc(50,50,50,0,2*Math.PI,!0),n.closePath(),n.fill(),n.fillStyle="rgb(0,255,255)",n.beginPath(),n.arc(100,50,50,0,2*Math.PI,!0),n.closePath(),n.fill(),n.fillStyle="rgb(255,255,0)",n.beginPath(),n.arc(75,100,50,0,2*Math.PI,!0),n.closePath(),n.fill(),n.fillStyle="rgb(255,0,255)",n.arc(75,75,75,0,2*Math.PI,!0),n.arc(75,75,25,0,2*Math.PI,!0),n.fill("evenodd"),r.toDataURL&&e.push("canvas fp:"+r.toDataURL()),e},O=function(){var t,e=function(e){return t.clearColor(0,0,0,1),t.enable(t.DEPTH_TEST),t.depthFunc(t.LEQUAL),t.clear(t.COLOR_BUFFER_BIT|t.DEPTH_BUFFER_BIT),"["+e[0]+", "+e[1]+"]"};if(!(t=V()))return null;var r=[],n=t.createBuffer();t.bindBuffer(t.ARRAY_BUFFER,n);var i=new Float32Array([-.2,-.9,0,.4,-.26,0,0,.732134444,0]);t.bufferData(t.ARRAY_BUFFER,i,t.STATIC_DRAW),n.itemSize=3,n.numItems=3;var o=t.createProgram(),a=t.createShader(t.VERTEX_SHADER);t.shaderSource(a,"attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}"),t.compileShader(a);var s=t.createShader(t.FRAGMENT_SHADER);t.shaderSource(s,"precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}"),t.compileShader(s),t.attachShader(o,a),t.attachShader(o,s),t.linkProgram(o),t.useProgram(o),o.vertexPosAttrib=t.getAttribLocation(o,"attrVertex"),o.offsetUniform=t.getUniformLocation(o,"uniformOffset"),t.enableVertexAttribArray(o.vertexPosArray),t.vertexAttribPointer(o.vertexPosAttrib,n.itemSize,t.FLOAT,!1,0,0),t.uniform2f(o.offsetUniform,1,1),t.drawArrays(t.TRIANGLE_STRIP,0,n.numItems);try{r.push(t.canvas.toDataURL())}catch(t){}r.push("extensions:"+(t.getSupportedExtensions()||[]).join(";")),r.push("webgl aliased line width range:"+e(t.getParameter(t.ALIASED_LINE_WIDTH_RANGE))),r.push("webgl aliased point size range:"+e(t.getParameter(t.ALIASED_POINT_SIZE_RANGE))),r.push("webgl alpha bits:"+t.getParameter(t.ALPHA_BITS)),r.push("webgl antialiasing:"+(t.getContextAttributes().antialias?"yes":"no")),r.push("webgl blue bits:"+t.getParameter(t.BLUE_BITS)),r.push("webgl depth bits:"+t.getParameter(t.DEPTH_BITS)),r.push("webgl green bits:"+t.getParameter(t.GREEN_BITS)),r.push("webgl max anisotropy:"+function(t){var e=t.getExtension("EXT_texture_filter_anisotropic")||t.getExtension("WEBKIT_EXT_texture_filter_anisotropic")||t.getExtension("MOZ_EXT_texture_filter_anisotropic");if(e){var r=t.getParameter(e.MAX_TEXTURE_MAX_ANISOTROPY_EXT);return 0===r&&(r=2),r}return null}(t)),r.push("webgl max combined texture image units:"+t.getParameter(t.MAX_COMBINED_TEXTURE_IMAGE_UNITS)),r.push("webgl max cube map texture size:"+t.getParameter(t.MAX_CUBE_MAP_TEXTURE_SIZE)),r.push("webgl max fragment uniform vectors:"+t.getParameter(t.MAX_FRAGMENT_UNIFORM_VECTORS)),r.push("webgl max render buffer size:"+t.getParameter(t.MAX_RENDERBUFFER_SIZE)),r.push("webgl max texture image units:"+t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS)),r.push("webgl max texture size:"+t.getParameter(t.MAX_TEXTURE_SIZE)),r.push("webgl max varying vectors:"+t.getParameter(t.MAX_VARYING_VECTORS)),r.push("webgl max vertex attribs:"+t.getParameter(t.MAX_VERTEX_ATTRIBS)),r.push("webgl max vertex texture image units:"+t.getParameter(t.MAX_VERTEX_TEXTURE_IMAGE_UNITS)),r.push("webgl max vertex uniform vectors:"+t.getParameter(t.MAX_VERTEX_UNIFORM_VECTORS)),r.push("webgl max viewport dims:"+e(t.getParameter(t.MAX_VIEWPORT_DIMS))),r.push("webgl red bits:"+t.getParameter(t.RED_BITS)),r.push("webgl renderer:"+t.getParameter(t.RENDERER)),r.push("webgl shading language version:"+t.getParameter(t.SHADING_LANGUAGE_VERSION)),r.push("webgl stencil bits:"+t.getParameter(t.STENCIL_BITS)),r.push("webgl vendor:"+t.getParameter(t.VENDOR)),r.push("webgl version:"+t.getParameter(t.VERSION));try{var c=t.getExtension("WEBGL_debug_renderer_info");c&&(r.push("webgl unmasked vendor:"+t.getParameter(c.UNMASKED_VENDOR_WEBGL)),r.push("webgl unmasked renderer:"+t.getParameter(c.UNMASKED_RENDERER_WEBGL)))}catch(t){}return t.getShaderPrecisionFormat?(u(["FLOAT","INT"],(function(e){u(["VERTEX","FRAGMENT"],(function(n){u(["HIGH","MEDIUM","LOW"],(function(i){u(["precision","rangeMin","rangeMax"],(function(o){var a=t.getShaderPrecisionFormat(t[n+"_SHADER"],t[i+"_"+e])[o];"precision"!==o&&(o="precision "+o);var s=["webgl ",n.toLowerCase()," shader ",i.toLowerCase()," ",e.toLowerCase()," ",o,":",a].join("");r.push(s)}))}))}))})),U(t),r):(U(t),r)},_=function(){try{var t=V(),e=t.getExtension("WEBGL_debug_renderer_info"),r=t.getParameter(e.UNMASKED_VENDOR_WEBGL)+"~"+t.getParameter(e.UNMASKED_RENDERER_WEBGL);return U(t),r}catch(t){return null}},B=function(){var t=document.createElement("div");t.innerHTML="&nbsp;",t.className="adsbox";var e=!1;try{document.body.appendChild(t),e=0===document.getElementsByClassName("adsbox")[0].offsetHeight,document.body.removeChild(t)}catch(t){e=!1}return e},A=function(){if(void 0!==navigator.languages)try{if(navigator.languages[0].substr(0,2)!==navigator.language.substr(0,2))return!0}catch(t){return!0}return!1},D=function(){return window.screen.width<window.screen.availWidth||window.screen.height<window.screen.availHeight},C=function(){var t,e=navigator.userAgent.toLowerCase(),r=navigator.oscpu,n=navigator.platform.toLowerCase();if(t=e.indexOf("windows phone")>=0?"Windows Phone":e.indexOf("windows")>=0||e.indexOf("win16")>=0||e.indexOf("win32")>=0||e.indexOf("win64")>=0||e.indexOf("win95")>=0||e.indexOf("win98")>=0||e.indexOf("winnt")>=0||e.indexOf("wow64")>=0?"Windows":e.indexOf("android")>=0?"Android":e.indexOf("linux")>=0||e.indexOf("cros")>=0||e.indexOf("x11")>=0?"Linux":e.indexOf("iphone")>=0||e.indexOf("ipad")>=0||e.indexOf("ipod")>=0||e.indexOf("crios")>=0||e.indexOf("fxios")>=0?"iOS":e.indexOf("macintosh")>=0||e.indexOf("mac_powerpc)")>=0?"Mac":"Other",("ontouchstart"in window||navigator.maxTouchPoints>0||navigator.msMaxTouchPoints>0)&&"Windows"!==t&&"Windows Phone"!==t&&"Android"!==t&&"iOS"!==t&&"Other"!==t&&-1===e.indexOf("cros"))return!0;if(void 0!==r){if((r=r.toLowerCase()).indexOf("win")>=0&&"Windows"!==t&&"Windows Phone"!==t)return!0;if(r.indexOf("linux")>=0&&"Linux"!==t&&"Android"!==t)return!0;if(r.indexOf("mac")>=0&&"Mac"!==t&&"iOS"!==t)return!0;if((-1===r.indexOf("win")&&-1===r.indexOf("linux")&&-1===r.indexOf("mac"))!=("Other"===t))return!0}return n.indexOf("win")>=0&&"Windows"!==t&&"Windows Phone"!==t||((n.indexOf("linux")>=0||n.indexOf("android")>=0||n.indexOf("pike")>=0)&&"Linux"!==t&&"Android"!==t||((n.indexOf("mac")>=0||n.indexOf("ipad")>=0||n.indexOf("ipod")>=0||n.indexOf("iphone")>=0)&&"Mac"!==t&&"iOS"!==t||!(n.indexOf("arm")>=0&&"Windows Phone"===t)&&(!(n.indexOf("pike")>=0&&e.indexOf("opera mini")>=0)&&((n.indexOf("win")<0&&n.indexOf("linux")<0&&n.indexOf("mac")<0&&n.indexOf("iphone")<0&&n.indexOf("ipad")<0&&n.indexOf("ipod")<0)!==("Other"===t)||void 0===navigator.plugins&&"Windows"!==t&&"Windows Phone"!==t))))},k=function(){var t,e=navigator.userAgent.toLowerCase(),r=navigator.productSub;if(e.indexOf("edge/")>=0||e.indexOf("iemobile/")>=0)return!1;if(e.indexOf("opera mini")>=0)return!1;if(("Chrome"===(t=e.indexOf("firefox/")>=0?"Firefox":e.indexOf("opera/")>=0||e.indexOf(" opr/")>=0?"Opera":e.indexOf("chrome/")>=0?"Chrome":e.indexOf("safari/")>=0?e.indexOf("android 1.")>=0||e.indexOf("android 2.")>=0||e.indexOf("android 3.")>=0||e.indexOf("android 4.")>=0?"AOSP":"Safari":e.indexOf("trident/")>=0?"Internet Explorer":"Other")||"Safari"===t||"Opera"===t)&&"20030107"!==r)return!0;var n,i=eval.toString().length;if(37===i&&"Safari"!==t&&"Firefox"!==t&&"Other"!==t)return!0;if(39===i&&"Internet Explorer"!==t&&"Other"!==t)return!0;if(33===i&&"Chrome"!==t&&"AOSP"!==t&&"Opera"!==t&&"Other"!==t)return!0;try{throw"a"}catch(t){try{t.toSource(),n=!0}catch(t){n=!1}}return n&&"Firefox"!==t&&"Other"!==t},P=function(){var t=document.createElement("canvas");return!(!t.getContext||!t.getContext("2d"))},M=function(){if(!P())return!1;var t=V(),e=!!window.WebGLRenderingContext&&!!t;return U(t),e},I=function(){return"Microsoft Internet Explorer"===navigator.appName||!("Netscape"!==navigator.appName||!/Trident/.test(navigator.userAgent))},R=function(){return("msWriteProfilerMark"in window)+("msLaunchUri"in navigator)+("msSaveBlob"in navigator)>=2},L=function(){return void 0!==window.swfobject},N=function(){return window.swfobject.hasFlashPlayerVersion("9.0.0")},j=function(t,e){window.___fp_swf_loaded=function(e){t(e)};var r=e.fonts.swfContainerId;!function(t){var e=document.createElement("div");e.setAttribute("id",t.fonts.swfContainerId),document.body.appendChild(e)}();var n={onReady:"___fp_swf_loaded"};window.swfobject.embedSWF(e.fonts.swfPath,r,"1","1","9.0.0",!1,n,{allowScriptAccess:"always",menu:"false"},{})},V=function(){var t=document.createElement("canvas"),e=null;try{e=t.getContext("webgl")||t.getContext("experimental-webgl")}catch(t){}return e||(e=null),e},U=function(t){var e=t.getExtension("WEBGL_lose_context");null!=e&&e.loseContext()},H=[{key:"userAgent",getData:function(t){t(navigator.userAgent)}},{key:"webdriver",getData:function(t,e){t(null==navigator.webdriver?e.NOT_AVAILABLE:navigator.webdriver)}},{key:"language",getData:function(t,e){t(navigator.language||navigator.userLanguage||navigator.browserLanguage||navigator.systemLanguage||e.NOT_AVAILABLE)}},{key:"colorDepth",getData:function(t,e){t(window.screen.colorDepth||e.NOT_AVAILABLE)}},{key:"deviceMemory",getData:function(t,e){t(navigator.deviceMemory||e.NOT_AVAILABLE)}},{key:"pixelRatio",getData:function(t,e){t(window.devicePixelRatio||e.NOT_AVAILABLE)}},{key:"hardwareConcurrency",getData:function(t,e){t(b(e))}},{key:"screenResolution",getData:function(t,e){t(l(e))}},{key:"availableScreenResolution",getData:function(t,e){t(h(e))}},{key:"timezoneOffset",getData:function(t){t((new Date).getTimezoneOffset())}},{key:"timezone",getData:function(t,e){window.Intl&&window.Intl.DateTimeFormat?t((new window.Intl.DateTimeFormat).resolvedOptions().timeZone||e.NOT_AVAILABLE):t(e.NOT_AVAILABLE)}},{key:"sessionStorage",getData:function(t,e){t(v(e))}},{key:"localStorage",getData:function(t,e){t(y(e))}},{key:"indexedDb",getData:function(t,e){t(m(e))}},{key:"addBehavior",getData:function(t){t(!!window.HTMLElement.prototype.addBehavior)}},{key:"openDatabase",getData:function(t){t(!!window.openDatabase)}},{key:"cpuClass",getData:function(t,e){t(x(e))}},{key:"platform",getData:function(t,e){t(w(e))}},{key:"doNotTrack",getData:function(t,e){t(T(e))}},{key:"plugins",getData:function(t,e){I()?e.plugins.excludeIE?t(e.EXCLUDED):t(d(e)):t(p(e))}},{key:"canvas",getData:function(t,e){P()?t(E(e)):t(e.NOT_AVAILABLE)}},{key:"webgl",getData:function(t,e){M()?t(O()):t(e.NOT_AVAILABLE)}},{key:"webglVendorAndRenderer",getData:function(t){M()?t(_()):t()}},{key:"adBlock",getData:function(t){t(B())}},{key:"hasLiedLanguages",getData:function(t){t(A())}},{key:"hasLiedResolution",getData:function(t){t(D())}},{key:"hasLiedOs",getData:function(t){t(C())}},{key:"hasLiedBrowser",getData:function(t){t(k())}},{key:"touchSupport",getData:function(t){t(S())}},{key:"fonts",getData:function(t,e){var r=["monospace","sans-serif","serif"],n=["Andale Mono","Arial","Arial Black","Arial Hebrew","Arial MT","Arial Narrow","Arial Rounded MT Bold","Arial Unicode MS","Bitstream Vera Sans Mono","Book Antiqua","Bookman Old Style","Calibri","Cambria","Cambria Math","Century","Century Gothic","Century Schoolbook","Comic Sans","Comic Sans MS","Consolas","Courier","Courier New","Geneva","Georgia","Helvetica","Helvetica Neue","Impact","Lucida Bright","Lucida Calligraphy","Lucida Console","Lucida Fax","LUCIDA GRANDE","Lucida Handwriting","Lucida Sans","Lucida Sans Typewriter","Lucida Sans Unicode","Microsoft Sans Serif","Monaco","Monotype Corsiva","MS Gothic","MS Outlook","MS PGothic","MS Reference Sans Serif","MS Sans Serif","MS Serif","MYRIAD","MYRIAD PRO","Palatino","Palatino Linotype","Segoe Print","Segoe Script","Segoe UI","Segoe UI Light","Segoe UI Semibold","Segoe UI Symbol","Tahoma","Times","Times New Roman","Times New Roman PS","Trebuchet MS","Verdana","Wingdings","Wingdings 2","Wingdings 3"];if(e.fonts.extendedJsFonts){n=n.concat(["Abadi MT Condensed Light","Academy Engraved LET","ADOBE CASLON PRO","Adobe Garamond","ADOBE GARAMOND PRO","Agency FB","Aharoni","Albertus Extra Bold","Albertus Medium","Algerian","Amazone BT","American Typewriter","American Typewriter Condensed","AmerType Md BT","Andalus","Angsana New","AngsanaUPC","Antique Olive","Aparajita","Apple Chancery","Apple Color Emoji","Apple SD Gothic Neo","Arabic Typesetting","ARCHER","ARNO PRO","Arrus BT","Aurora Cn BT","AvantGarde Bk BT","AvantGarde Md BT","AVENIR","Ayuthaya","Bandy","Bangla Sangam MN","Bank Gothic","BankGothic Md BT","Baskerville","Baskerville Old Face","Batang","BatangChe","Bauer Bodoni","Bauhaus 93","Bazooka","Bell MT","Bembo","Benguiat Bk BT","Berlin Sans FB","Berlin Sans FB Demi","Bernard MT Condensed","BernhardFashion BT","BernhardMod BT","Big Caslon","BinnerD","Blackadder ITC","BlairMdITC TT","Bodoni 72","Bodoni 72 Oldstyle","Bodoni 72 Smallcaps","Bodoni MT","Bodoni MT Black","Bodoni MT Condensed","Bodoni MT Poster Compressed","Bookshelf Symbol 7","Boulder","Bradley Hand","Bradley Hand ITC","Bremen Bd BT","Britannic Bold","Broadway","Browallia New","BrowalliaUPC","Brush Script MT","Californian FB","Calisto MT","Calligrapher","Candara","CaslonOpnface BT","Castellar","Centaur","Cezanne","CG Omega","CG Times","Chalkboard","Chalkboard SE","Chalkduster","Charlesworth","Charter Bd BT","Charter BT","Chaucer","ChelthmITC Bk BT","Chiller","Clarendon","Clarendon Condensed","CloisterBlack BT","Cochin","Colonna MT","Constantia","Cooper Black","Copperplate","Copperplate Gothic","Copperplate Gothic Bold","Copperplate Gothic Light","CopperplGoth Bd BT","Corbel","Cordia New","CordiaUPC","Cornerstone","Coronet","Cuckoo","Curlz MT","DaunPenh","Dauphin","David","DB LCD Temp","DELICIOUS","Denmark","DFKai-SB","Didot","DilleniaUPC","DIN","DokChampa","Dotum","DotumChe","Ebrima","Edwardian Script ITC","Elephant","English 111 Vivace BT","Engravers MT","EngraversGothic BT","Eras Bold ITC","Eras Demi ITC","Eras Light ITC","Eras Medium ITC","EucrosiaUPC","Euphemia","Euphemia UCAS","EUROSTILE","Exotc350 Bd BT","FangSong","Felix Titling","Fixedsys","FONTIN","Footlight MT Light","Forte","FrankRuehl","Fransiscan","Freefrm721 Blk BT","FreesiaUPC","Freestyle Script","French Script MT","FrnkGothITC Bk BT","Fruitger","FRUTIGER","Futura","Futura Bk BT","Futura Lt BT","Futura Md BT","Futura ZBlk BT","FuturaBlack BT","Gabriola","Galliard BT","Gautami","Geeza Pro","Geometr231 BT","Geometr231 Hv BT","Geometr231 Lt BT","GeoSlab 703 Lt BT","GeoSlab 703 XBd BT","Gigi","Gill Sans","Gill Sans MT","Gill Sans MT Condensed","Gill Sans MT Ext Condensed Bold","Gill Sans Ultra Bold","Gill Sans Ultra Bold Condensed","Gisha","Gloucester MT Extra Condensed","GOTHAM","GOTHAM BOLD","Goudy Old Style","Goudy Stout","GoudyHandtooled BT","GoudyOLSt BT","Gujarati Sangam MN","Gulim","GulimChe","Gungsuh","GungsuhChe","Gurmukhi MN","Haettenschweiler","Harlow Solid Italic","Harrington","Heather","Heiti SC","Heiti TC","HELV","Herald","High Tower Text","Hiragino Kaku Gothic ProN","Hiragino Mincho ProN","Hoefler Text","Humanst 521 Cn BT","Humanst521 BT","Humanst521 Lt BT","Imprint MT Shadow","Incised901 Bd BT","Incised901 BT","Incised901 Lt BT","INCONSOLATA","Informal Roman","Informal011 BT","INTERSTATE","IrisUPC","Iskoola Pota","JasmineUPC","Jazz LET","Jenson","Jester","Jokerman","Juice ITC","Kabel Bk BT","Kabel Ult BT","Kailasa","KaiTi","Kalinga","Kannada Sangam MN","Kartika","Kaufmann Bd BT","Kaufmann BT","Khmer UI","KodchiangUPC","Kokila","Korinna BT","Kristen ITC","Krungthep","Kunstler Script","Lao UI","Latha","Leelawadee","Letter Gothic","Levenim MT","LilyUPC","Lithograph","Lithograph Light","Long Island","Lydian BT","Magneto","Maiandra GD","Malayalam Sangam MN","Malgun Gothic","Mangal","Marigold","Marion","Marker Felt","Market","Marlett","Matisse ITC","Matura MT Script Capitals","Meiryo","Meiryo UI","Microsoft Himalaya","Microsoft JhengHei","Microsoft New Tai Lue","Microsoft PhagsPa","Microsoft Tai Le","Microsoft Uighur","Microsoft YaHei","Microsoft Yi Baiti","MingLiU","MingLiU_HKSCS","MingLiU_HKSCS-ExtB","MingLiU-ExtB","Minion","Minion Pro","Miriam","Miriam Fixed","Mistral","Modern","Modern No. 20","Mona Lisa Solid ITC TT","Mongolian Baiti","MONO","MoolBoran","Mrs Eaves","MS LineDraw","MS Mincho","MS PMincho","MS Reference Specialty","MS UI Gothic","MT Extra","MUSEO","MV Boli","Nadeem","Narkisim","NEVIS","News Gothic","News GothicMT","NewsGoth BT","Niagara Engraved","Niagara Solid","Noteworthy","NSimSun","Nyala","OCR A Extended","Old Century","Old English Text MT","Onyx","Onyx BT","OPTIMA","Oriya Sangam MN","OSAKA","OzHandicraft BT","Palace Script MT","Papyrus","Parchment","Party LET","Pegasus","Perpetua","Perpetua Titling MT","PetitaBold","Pickwick","Plantagenet Cherokee","Playbill","PMingLiU","PMingLiU-ExtB","Poor Richard","Poster","PosterBodoni BT","PRINCETOWN LET","Pristina","PTBarnum BT","Pythagoras","Raavi","Rage Italic","Ravie","Ribbon131 Bd BT","Rockwell","Rockwell Condensed","Rockwell Extra Bold","Rod","Roman","Sakkal Majalla","Santa Fe LET","Savoye LET","Sceptre","Script","Script MT Bold","SCRIPTINA","Serifa","Serifa BT","Serifa Th BT","ShelleyVolante BT","Sherwood","Shonar Bangla","Showcard Gothic","Shruti","Signboard","SILKSCREEN","SimHei","Simplified Arabic","Simplified Arabic Fixed","SimSun","SimSun-ExtB","Sinhala Sangam MN","Sketch Rockwell","Skia","Small Fonts","Snap ITC","Snell Roundhand","Socket","Souvenir Lt BT","Staccato222 BT","Steamer","Stencil","Storybook","Styllo","Subway","Swis721 BlkEx BT","Swiss911 XCm BT","Sylfaen","Synchro LET","System","Tamil Sangam MN","Technical","Teletype","Telugu Sangam MN","Tempus Sans ITC","Terminal","Thonburi","Traditional Arabic","Trajan","TRAJAN PRO","Tristan","Tubular","Tunga","Tw Cen MT","Tw Cen MT Condensed","Tw Cen MT Condensed Extra Bold","TypoUpright BT","Unicorn","Univers","Univers CE 55 Medium","Univers Condensed","Utsaah","Vagabond","Vani","Vijaya","Viner Hand ITC","VisualUI","Vivaldi","Vladimir Script","Vrinda","Westminster","WHITNEY","Wide Latin","ZapfEllipt BT","ZapfHumnst BT","ZapfHumnst Dm BT","Zapfino","Zurich BlkEx BT","Zurich Ex BT","ZWAdobeF"])}n=(n=n.concat(e.fonts.userDefinedFonts)).filter((function(t,e){return n.indexOf(t)===e}));var i=document.getElementsByTagName("body")[0],o=document.createElement("div"),a=document.createElement("div"),s={},u={},c=function(){var t=document.createElement("span");return t.style.position="absolute",t.style.left="-9999px",t.style.fontSize="72px",t.style.fontStyle="normal",t.style.fontWeight="normal",t.style.letterSpacing="normal",t.style.lineBreak="auto",t.style.lineHeight="normal",t.style.textTransform="none",t.style.textAlign="left",t.style.textDecoration="none",t.style.textShadow="none",t.style.whiteSpace="normal",t.style.wordBreak="normal",t.style.wordSpacing="normal",t.innerHTML="mmmmmmmmmmlli",t},f=function(t,e){var r=c();return r.style.fontFamily="'"+t+"',"+e,r},l=function(t){for(var e=!1,n=0;n<r.length;n++)if(e=t[n].offsetWidth!==s[r[n]]||t[n].offsetHeight!==u[r[n]])return e;return e},h=function(){for(var t=[],e=0,n=r.length;e<n;e++){var i=c();i.style.fontFamily=r[e],o.appendChild(i),t.push(i)}return t}();i.appendChild(o);for(var p=0,d=r.length;p<d;p++)s[r[p]]=h[p].offsetWidth,u[r[p]]=h[p].offsetHeight;var g=function(){for(var t={},e=0,i=n.length;e<i;e++){for(var o=[],s=0,u=r.length;s<u;s++){var c=f(n[e],r[s]);a.appendChild(c),o.push(c)}t[n[e]]=o}return t}();i.appendChild(a);for(var v=[],y=0,m=n.length;y<m;y++)l(g[n[y]])&&v.push(n[y]);i.removeChild(a),i.removeChild(o),t(v)},pauseBefore:!0},{key:"fontsFlash",getData:function(t,e){return L()?N()?e.fonts.swfPath?void j((function(e){t(e)}),e):t("missing options.fonts.swfPath"):t("flash not installed"):t("swf object not loaded")},pauseBefore:!0},{key:"audio",getData:function(t,e){var r=e.audio;if(r.excludeIOS11&&navigator.userAgent.match(/OS 11.+Version\/11.+Safari/))return t(e.EXCLUDED);var n=window.OfflineAudioContext||window.webkitOfflineAudioContext;if(null==n)return t(e.NOT_AVAILABLE);var i=new n(1,44100,44100),o=i.createOscillator();o.type="triangle",o.frequency.setValueAtTime(1e4,i.currentTime);var a=i.createDynamicsCompressor();u([["threshold",-50],["knee",40],["ratio",12],["reduction",-20],["attack",0],["release",.25]],(function(t){void 0!==a[t[0]]&&"function"==typeof a[t[0]].setValueAtTime&&a[t[0]].setValueAtTime(t[1],i.currentTime)})),o.connect(a),a.connect(i.destination),o.start(0),i.startRendering();var s=setTimeout((function(){return console.warn('Audio fingerprint timed out. Please report bug at https://github.com/fingerprintjs/fingerprintjs with your user agent: "'+navigator.userAgent+'".'),i.oncomplete=function(){},i=null,t("audioTimeout")}),r.timeout);i.oncomplete=function(e){var r;try{clearTimeout(s),r=e.renderedBuffer.getChannelData(0).slice(4500,5e3).reduce((function(t,e){return t+Math.abs(e)}),0).toString(),o.disconnect(),a.disconnect()}catch(e){return void t(e)}t(r)}}},{key:"enumerateDevices",getData:function(t,e){if(!f())return t(e.NOT_AVAILABLE);navigator.mediaDevices.enumerateDevices().then((function(e){t(e.map((function(t){return"id="+t.deviceId+";gid="+t.groupId+";"+t.kind+";"+t.label})))})).catch((function(e){t(e)}))}}],F=function(t){throw new Error("'new Fingerprint()' is deprecated, see https://github.com/fingerprintjs/fingerprintjs#upgrade-guide-from-182-to-200")};return F.get=function(t,e){e?t||(t={}):(e=t,t={}),function(t,e){if(null==e)return t;var r,n;for(n in e)null==(r=e[n])||Object.prototype.hasOwnProperty.call(t,n)||(t[n]=r)}(t,s),t.components=t.extraComponents.concat(H);var r={data:[],addPreprocessedComponent:function(e,n){"function"==typeof t.preprocessor&&(n=t.preprocessor(e,n)),r.data.push({key:e,value:n})}},n=-1,i=function(o){if((n+=1)>=t.components.length)e(r.data);else{var a=t.components[n];if(t.excludes[a.key])i(!1);else{if(!o&&a.pauseBefore)return n-=1,void setTimeout((function(){i(!0)}),1);try{a.getData((function(t){r.addPreprocessedComponent(a.key,t),i(!1)}),t)}catch(t){r.addPreprocessedComponent(a.key,String(t)),i(!1)}}}};i(!1)},F.getPromise=function(t){return new Promise((function(e,r){F.get(t,e)}))},F.getV18=function(t,e){return null==e&&(e=t,t={}),F.get(t,(function(r){for(var n=[],i=0;i<r.length;i++){var o=r[i];if(o.value===(t.NOT_AVAILABLE||"not available"))n.push({key:o.key,value:"unknown"});else if("plugins"===o.key)n.push({key:"plugins",value:c(o.value,(function(t){var e=c(t[2],(function(t){return t.join?t.join("~"):t})).join(",");return[t[0],t[1],e].join("::")}))});else if(-1!==["canvas","webgl"].indexOf(o.key)&&Array.isArray(o.value))n.push({key:o.key,value:o.value.join("~")});else if(-1!==["sessionStorage","localStorage","indexedDb","addBehavior","openDatabase"].indexOf(o.key)){if(!o.value)continue;n.push({key:o.key,value:1})}else o.value?n.push(o.value.join?{key:o.key,value:o.value.join(";")}:o):n.push({key:o.key,value:o.value})}var s=a(c(n,(function(t){return t.value})).join("~~~"),31);e(s,n)}))},F.x64hash128=a,F.VERSION="2.1.4",F}))},function(t,e){(function(e){t.exports=e}).call(this,{})},function(t,e,r){var n,i,o;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,i=[e,r(1),r(2),r(3),r(4),r(5),r(28)],void 0===(o="function"==typeof(n=function(t,e,n,i,o,a,s){"use strict";var u=r(6);function c(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function f(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?c(Object(r),!0).forEach((function(e){(0,n.default)(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):c(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}Object.defineProperty(t,"__esModule",{value:!0}),t.Queue=void 0,t.default=function(t){return d.apply(this,arguments)},e=u(e),n=u(n),i=u(i),o=u(o),a=u(a),s=u(s);var l=t.Queue=function(){return(0,a.default)((function t(e){(0,o.default)(this,t);var r=(e||{}).cacheTime,n=void 0===r?2e3:r;this._queue=[],this._marched=null,this._recordCache=null,this._clearCache=null,this._cacheTime=n}),[{key:"fallIn",value:function(t,e){var r=this,n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];return new Promise((function(i,o){r._queue.push({resolve:i,reject:o,soldier:t,arms:e,eliminate:n}),1!==r._queue.length||r._marched||(r.fallOut(),r._marched=1)}))}},{key:"fallOut",value:(t=(0,i.default)(e.default.mark((function t(){var r,n,i=this;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(r=this._queue.shift(),!this._recordCache){t.next=7;break}return t.next=4,new Promise((function(t){return t(i._recordCache)}));case 4:t.t0=t.sent,t.next=10;break;case 7:return t.next=9,r.soldier(r.arms);case 9:t.t0=t.sent;case 10:n=t.t0,r.eliminate?n.success?this._recordCache=n:(this._recordCache=null,this._marched=null):this._recordCache=n,r.resolve(n),this._queue.length?this.fallOut():this._marched=null,this._recordCache&&!this._clearCache&&(this._clearCache=setTimeout((function(){i._recordCache=null,i._marched=null,i._clearCache=null}),this._cacheTime));case 15:case"end":return t.stop()}}),t,this)}))),function(){return t.apply(this,arguments)})}]);var t}(),h={},p={};function d(){return(d=(0,i.default)(e.default.mark((function t(r){var i,o,a,u,c,d,g,v,y,m,b,x,w;return e.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i=r.ticketApi,o=r.grantingApi,a=r.grantingApiOption,u=void 0===a?{}:a,c=r.cookieName,d=r.tokenName,g=void 0===d?c:d,v=r.cookieHost,y=r.afterGetTicket,m=r.force,p[c]=p[c]||new l,h[c]=h[c]||new l,b=s.default.get(c),i){t.next=6;break}return t.abrupt("return",console.error("ticketApi is undefined"));case 6:if(!b||m){t.next=8;break}return t.abrupt("return",(0,n.default)({},g,b));case 8:return m&&s.default.remove(c,"/",v),t.next=11,h[c].fallIn(i,{});case 11:if(x=t.sent,y&&y(x),x.success&&o){t.next=15;break}return t.abrupt("return",!1);case 15:return t.next=17,p[c].fallIn(o,f((0,n.default)({},u.ticketKey||"ticket",x.data.ticket),u));case 17:if((w=t.sent).success){t.next=21;break}return console.warn("granting ".concat(c||""," failed")),t.abrupt("return",!1);case 21:return s.default.set(c,w.data.token||w.data,{domain:v,path:"/"}),t.abrupt("return",(0,n.default)({},g,w.data.token||w.data));case 23:case"end":return t.stop()}}),t)})))).apply(this,arguments)}})?n.apply(e,i):n)||(t.exports=o)},function(t,r){t.exports=e}])}));

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 56 */
/***/ (function(module) {

module.exports = JSON.parse("[{\"global\":\"www.huobi.com\",\"otc\":\"www.huobi.com\",\"dm\":\"dm.huobi.com\",\"eco\":\"eco.huobi.com\",\"uc\":\"www.huobi.com\",\"institution\":\"www.huobi.com\",\"futures\":\"futures.huobi.com\",\"brokerage\":\"www.huobi-brokerage.com\",\"pool\":\"pool.huobi.com\",\"broker\":\"broker.huobi.com\",\"kyc\":\"www.huobi.com\",\"custody\":\"custody.huobi.com\"}]");

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(380);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLocalStorage = exports.getLocalStorage = exports.setLocalStorage = void 0;
var localStorage_1 = __importDefault(__webpack_require__(67));
/**
 * 存储localStorage
 */
var setLocalStorage = function (name, content) {
    if (!name)
        return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    localStorage_1.default.setItem(name, content);
};
exports.setLocalStorage = setLocalStorage;
/**
 * 获取localStorage
 */
var getLocalStorage = function (name) {
    if (!name)
        return;
    return localStorage_1.default.getItem(name) || '';
};
exports.getLocalStorage = getLocalStorage;
/**
 * 删除localStorage
 */
var removeLocalStorage = function (name) {
    if (!name)
        return;
    localStorage_1.default.removeItem(name);
};
exports.removeLocalStorage = removeLocalStorage;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.UPDATE_IS_LOGIN = exports.UPDATE_LOCALES = exports.UPDATE_COLOR = void 0;
exports.UPDATE_COLOR = 'UPDATE_COLOR';
exports.UPDATE_LOCALES = 'UPDATE_LOCALES';
exports.UPDATE_IS_LOGIN = 'UPDATE_IS_LOGIN';
var reducer = function (state, action) {
    var _a;
    if (/^update:/.test(action.type)) {
        var name_1 = action.type.replace(/^update:/, '');
        return __assign(__assign({}, state), (_a = {}, _a[name_1] = action[name_1], _a));
    }
    switch (action.type) {
        case 'all':
            return __assign(__assign({}, state), action.data);
        case exports.UPDATE_LOCALES:
            return __assign(__assign({}, state), { locale: action.lang });
        case exports.UPDATE_IS_LOGIN:
            return __assign(__assign({}, state), { isLogin: action.isLogin });
        default:
            return state;
    }
};
exports.reducer = reducer;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return once; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasClass", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addClass", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeClass", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStyle", function() { return getStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStyle", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isScroll", function() { return isScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getScrollContainer", function() { return getScrollContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInContainer", function() { return isInContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return getScrollBarWidth; });
/* istanbul ignore next */


const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;
const ieVersion = typeof document === 'undefined' ? 0 : Number(document.documentMode);

/* istanbul ignore next */
const trim = function(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
const camelCase = function(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
const on = (function() {
  if (typeof document !== 'undefined' && document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
const off = (function() {
  if (typeof document !== 'undefined' && document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
const once = function(el, event, fn) {
  var listener = function() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
  return () => {
    off(el, event, listener);
  }
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass);
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass));
  }
};

/* istanbul ignore next */
const getStyle = ieVersion < 9 ? function(element, styleName) {
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null);
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function(element, styleName) {
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    if (typeof document === 'undefined') {
      return;
    }
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if (typeof styleName === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

const isScroll = (el, vertical) => {
  const determinedDirection = vertical !== null && vertical !== undefined;
  const overflow = determinedDirection
    ? vertical
      ? getStyle(el, 'overflow-y')
      : getStyle(el, 'overflow-x')
    : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto|overlay)/);
};

const getScrollContainer = (el, vertical) => {
  if (typeof document === 'undefined') {
    return;
  }
  let parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

const isInContainer = (el, container) => {
  if (!el || !container) return false;
  if (typeof document === 'undefined') {
    return;
  }

  const elRect = el.getBoundingClientRect();
  let containerRect;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom &&
    elRect.bottom > containerRect.top &&
    elRect.right > containerRect.left &&
    elRect.left < containerRect.right;
};


let scrollBarWidth;

function getScrollBarWidth() {
  if (typeof document === 'undefined') {
    return;
  }
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  const outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  const widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var LoadingComponent = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "loading-container" },
            react_1.default.createElement("div", { className: "img-container" }))));
};
exports.default = LoadingComponent;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var no_image_png_1 = __importDefault(__webpack_require__(405));
var CoinIconComponent = function (props) {
    var _a = (0, react_1.useState)({}), styleObj = _a[0], setStyleObj = _a[1]; // 样式
    var _b = (0, react_1.useState)({}), imageStyle = _b[0], setImageStyle = _b[1]; // image样式
    var _c = (0, react_1.useState)(false), opacity = _c[0], setOpacity = _c[1]; // 是否显示成功
    var width = props.size || 40; // image宽度
    (0, react_1.useEffect)(function () {
        setStyleObj({
            width: "".concat(width, "px"),
            height: "".concat(width, "px"),
            backgroundColor: opacity ? '' : '#ecf1f8',
            backgroundImage: opacity ? '' : "url(".concat(bgImg(), ")"),
        });
        setImageStyle({
            borderRadius: '50%',
            verticalAlign: 'middle',
            opacity: opacity ? 1 : 0,
        });
    }, [opacity]);
    var bgImg = function () {
        if (props.defaultImg) {
            return props.defaultImg;
        }
        return no_image_png_1.default;
    };
    var imgSrc = function () {
        if (props.img) {
            return props.img;
        }
        return "/-/x/hb/p/api/contents/currency/icon_png/".concat(props.name, ".png?").concat(new Date().setHours(0, 0, 0, 0));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("i", { className: "coin_box", style: __assign({}, styleObj) },
            react_1.default.createElement("img", { className: "coin_icon", src: imgSrc(), alt: props.name || 'img', style: imageStyle, onLoad: function () { return setOpacity(true); }, onError: function () { return setOpacity(false); } }))));
};
exports.default = CoinIconComponent;


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "localList", function() { return localList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCAL_CURRENCYS", function() { return LOCAL_CURRENCYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIAT", function() { return FIAT; });
const { langList, excludeLangList } = __webpack_require__(40);

const localList = langList.filter(item => !excludeLangList.includes(item.key));

const LOCAL_CURRENCYS = [
    {
      "abbr": "USD",
      "fiatName": "USD_USD",
      "symbol": "$"
    },
    {
      "abbr": "CNY",
      "fiatName": "usd_cny",
      "symbol": "¥"
    },
    {
      "abbr": "ARS",
      "fiatName": "usd_ars",
      "symbol": "ARS$"
    },
    {
      "abbr": "BRL",
      "fiatName": "usd_brl",
      "symbol": "R$"
    },
    {
      "abbr": "EUR",
      "fiatName": "usd_eur",
      "symbol": "€"
    },
    {
      "abbr": "GBP",
      "fiatName": "usd_gbp",
      "symbol": "£"
    },
    {
      "abbr": "HKD",
      "fiatName": "usd_hkd",
      "symbol": "HK$"
    },
    {
      "abbr": "IDR",
      "fiatName": "usd_idr",
      "symbol": "Rp"
    },
    {
      "abbr": "INR",
      "fiatName": "usd_inr",
      "symbol": "₹"
    },
    {
      "abbr": "JPY",
      "fiatName": "usd_jpy",
      "symbol": "¥"
    },
    {
      "abbr": "KRW",
      "fiatName": "usd_krw",
      "symbol": "₩"
    },
    {
      "abbr": "MYR",
      "fiatName": "usd_myr",
      "symbol": "RM"
    },
    {
      "abbr": "NGN",
      "fiatName": "usd_ngn",
      "symbol": "₦"
    },
    {
      "abbr": "TRY",
      "fiatName": "usd_try",
      "symbol": "₺"
    },
    {
      "abbr": "RUB",
      "fiatName": "usd_rub",
      "symbol": "₽"
    },
    {
      "abbr": "TWD",
      "fiatName": "usd_twd",
      "symbol": "NT$"
    },
    {
      "abbr": "UAH",
      "fiatName": "usd_uah",
      "symbol": "₴"
    },
    {
      "abbr": "VND",
      "fiatName": "usd_vnd",
      "symbol": "₫"
    },
    {
      "abbr": "ZAR",
      "fiatName": "usd_zar",
      "symbol": "R"
    }
  ];

const FIAT = {
    usd: "$",
    ars: "ARS$",
    brl: "R$",
    cny: "¥",
    eur: "€",
    gbp: "£",
    hkd: "HK$",
    idr: "Rp",
    inr: "₹",
    jpy: "¥",
    krw: "₩",
    myr: "RM",
    ngn: "₦",
    try: "₺",
    rub: "₽",
    sgd: "S$",
    twd: "NT$",
    uah: "₴",
    vnd: "₫",
    zar: "R",
};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "raf", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doubleRaf", function() { return doubleRaf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelRaf", function() { return cancelRaf; });
/**
 * requestAnimationFrame polyfill
 */

 let prev = Date.now();
 
 /* istanbul ignore next */
 function fallback(fn) {
   const curr = Date.now();
   const ms = Math.max(0, 16 - (curr - prev));
   const id = setTimeout(fn, ms);
   prev = curr + ms;
   return id;
 }
 
 /* istanbul ignore next */
 let root = {}
 if (global) {
    root = global
 } else if (window != undefined) {
    root = window
 }
 
 /* istanbul ignore next */
 const iRaf = root.requestAnimationFrame || fallback;
 
 /* istanbul ignore next */
 const iCancel = root.cancelAnimationFrame || root.clearTimeout;
 
 function raf(fn) {
   return iRaf.call(root, fn);
 }
 
 // double raf for animation
 function doubleRaf(fn) {
   raf(() => {
     raf(fn);
   });
 }
 
 function cancelRaf(id) {
   iCancel.call(root, id);
 }
 
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeList", function() { return removeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTokenList", function() { return removeTokenList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reStorageList", function() { return reStorageList; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);


const tokens = {
    otc: "token",
    hadaxv2: "HB-HADAXV2-TOKEN",
    dm: "hbsession",
    mgt: "HB-MP-TOKEN",
    inst: "HB-INST-TOKEN",
    broker: "HB-TICKET-TOKEN",
};

const commonTokens = () => {
    const cookieToken = js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get() || {};
    // HB-XX-TOKEN
    return Object.keys(cookieToken).filter((i) => i.match(/HB-(.*?)-TOKEN/));
};

const removeList = [...commonTokens(), ...Object.values(tokens), "HBP_AGREE", "AUTHTOKEN"];

const removeTokenList = [
    ...Object.values(tokens),
    "HB-PRO-TOKEN",
    "HB-PRO-TOKEN-BFF",
    "HB-UC-TOKEN",
    "HB-UC-TOKEN-BFF",
    "hb-otc-token",
    "HB-OTC-TOKEN",
    "HB-KYC-TOKEN",
    "HB-OLD-TOKEN",
];

const reStorageList = ["contract-session"];


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {let localStorage = null

const root = global || window

if (root.localStorage) {
    localStorage = root.localStorage
} else {
    localStorage = {
        setItem() {

        },
        getItem() {

        }
    }
}
/* harmony default export */ __webpack_exports__["default"] = (localStorage);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "localList", function() { return localList; });
const { langList, excludeLangList } = __webpack_require__(40);
// 去掉已经下线的语言
const localList = langList.filter(item => !excludeLangList.includes(item.key)).map(lang => lang.key);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var utils = __webpack_require__(8);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var settle = __webpack_require__(129);
var cookies = __webpack_require__(130);
var buildURL = __webpack_require__(70);
var buildFullPath = __webpack_require__(74);
var parseHeaders = __webpack_require__(133);
var isURLSameOrigin = __webpack_require__(134);
var transitionalDefaults = __webpack_require__(71);
var AxiosError = __webpack_require__(26);
var CanceledError = __webpack_require__(41);
var parseProtocol = __webpack_require__(135);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(131);
var combineURLs = __webpack_require__(132);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(19).Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sub", function() { return sub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mul", function() { return mul; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "div", function() { return div; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fix", function() { return fix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatNum", function() { return formatNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numHandle", function() { return numHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "split2Local", function() { return split2Local; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numFormat", function() { return numFormat; });
/* harmony import */ var decimal_js_light__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30);
/* harmony import */ var decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(decimal_js_light__WEBPACK_IMPORTED_MODULE_0__);


decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a.set({
    precision: 50,
    rounding: decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a.ROUND_DOWN,
});

const add = (a, b) => {
    if (isNaN(a * 1) || isNaN(b * 1)) {
        return NaN;
    }
    const aa = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(a || 0);
    const bb = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(b || 0);
    return aa.add(bb);
};
const sub = (a, b) => {
    if (isNaN(a * 1) || isNaN(b * 1)) {
        return NaN;
    }
    const aa = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(a || 0);
    const bb = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(b || 0);
    return aa.sub(bb);
};
const mul = (a, b) => {
    if (isNaN(a * 1) || isNaN(b * 1)) {
        return NaN;
    }
    const aa = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(a || 0);
    const bb = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(b || 0);
    return aa.mul(bb);
};
const div = (a, b) => {
    if (isNaN(a * 1) || isNaN(b * 1)) {
        return NaN;
    }
    if (!+b) {
        return "---";
    }
    const aa = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(a || 0);
    const bb = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(b);
    return aa.div(bb);
};

const fix = (a, n = 0, rounding, notSlice) => {
    if (isNaN(a)) {
        return a;
    }
    const aa = new decimal_js_light__WEBPACK_IMPORTED_MODULE_0___default.a(a || 0);
    const aboutRes = aa.toFixed(parseInt(n), rounding);
    if (aboutRes.length > 18 && !notSlice) {
        return aboutRes.slice(0, 18);
    }
    return aboutRes;
};

/**
 * 数字增加千分位
 * @param val
 * @returns {string}
 */
const formatNum = (val) => {
    if ((typeof val === "number" || typeof val === "string") && !isNaN(Number(val))) {
        val =
            val &&
            val.toString().replace(/\d+/, function (s) {
                return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
            });
    }

    return val;
};

function numHandle(num, prefix) {
    if (num === undefined || num === null) {
        return "--";
    }
    return `${prefix}${formatNum(num)}`;
}

function split2Local(n, locale) {
    if (process.server) {
        return n;
    }
    if (isNaN(n * 1)) {
        return n;
    }
    const [, float] = (n + "").split(".");
    const precision = float ? float.length : undefined;
    locale = locale || navigator.language || "en-us";
    try {
        const { format } = new Intl.NumberFormat(locale, { minimumFractionDigits: precision });
        if (format) {
            return format(n);
        }
    } catch (e) {
        return n;
    }
    return n;
}

const numFormat = (num, locale, sp = 2) => {
    if (!num) {
        return "";
    }
    const v = num * 1;
    let newNum = fix(num, sp);
    if (sp === 0) {
        newNum = Math.ceil(v);
    }
    if (["zh-cn", "zh-hk", "zh-tc"].includes(locale)) {
        if (v >= 1e4 && v < 1e8) {
            newNum = formatNum(fix(num / 1e4, 2)) + `${locale === "zh-hk" || locale === "zh-tc" ? "萬" : "万"}`;
        } else if (v >= 1e8 && v < 1e12) {
            newNum = formatNum(fix(num / 1e8, 2)) + `${locale === "zh-hk" || locale === "zh-tc" ? "億" : "亿"}`;
        } else if (v >= 1e12) {
            newNum = formatNum(fix(num / 1e12, 2)) + `${locale === "zh-hk" || locale === "zh-tc" ? "萬億" : "万亿"}`;
        }
    } else {
        if (v >= 1e3 && v < 1e6) {
            newNum = formatNum(fix(num / 1e3, 2)) + "K";
        } else if (v >= 1e6 && v < 1e9) {
            newNum = formatNum(fix(num / 1e6, 2)) + "M";
        } else if (v >= 1e9 && v < 1e12) {
            newNum = formatNum(fix(num / 1e9, 2)) + "B";
        } else if (v >= 1e12) {
            newNum = formatNum(fix(num / 1e12, 2)) + "T";
        }
    }
    return newNum;
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isObject = __webpack_require__(32);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(187),
    mapCacheDelete = __webpack_require__(194),
    mapCacheGet = __webpack_require__(196),
    mapCacheHas = __webpack_require__(197),
    mapCacheSet = __webpack_require__(198);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(199),
    arraySome = __webpack_require__(202),
    cacheHas = __webpack_require__(203);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(17),
    stubFalse = __webpack_require__(220);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(87)(module)))

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(222),
    baseUnary = __webpack_require__(223),
    nodeUtil = __webpack_require__(224);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v2.0.0
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   AGPLv3 License */
!function(i,d){"use strict";function e(i){for(var e={},t=0;t<i.length;t++)e[i[t].toUpperCase()]=i[t];return e}function n(i,e){if(!(typeof i===l&&0<i.length))return!!gi(i)&&-1!==ki(e).indexOf(ki(i));for(var t in i)if(ki(i[t])==ki(e))return 1}var w="",u="function",b="undefined",l="object",c="string",p="major",h="model",m="name",f="type",g="vendor",v="version",k="architecture",x="console",y="mobile",r="tablet",t="smarttv",o="wearable",a="xr",s="embedded",S="inapp",_="user-agent",C=500,T="brands",q="formFactors",O="fullVersionList",z="platform",A="platformVersion",N="bitness",P="sec-ch-ua",H=P+"-full-version-list",I=P+"-arch",U=P+"-"+N,j=P+"-form-factors",E=P+"-"+y,M=P+"-"+h,R=P+"-"+z,B=R+"-version",V=[T,O,y,h,z,A,k,q,N],F="browser",G="cpu",L="device",D="engine",X="os",$="result",W="Amazon",K="Apple",Q="ASUS",Z="BlackBerry",Y="Google",J="Huawei",ii="Microsoft",ei="Motorola",ti="Samsung",oi="Sony",ri="Xiaomi",ai="Zebra",si="Mobile ",ni=" Browser",wi="Chromecast",bi="Firefox",ci="Opera",di="Facebook",ui="Windows",li=typeof i!==b,pi=li&&i.navigator?i.navigator:d,hi=pi&&pi.userAgentData?pi.userAgentData:d,mi=function(i,e){var t,o={},r=e;if(!fi(e))for(var a in r={},e)for(var s in e[a])r[s]=e[a][s].concat(r[s]||[]);for(t in i)o[t]=r[t]&&r[t].length%2==0?r[t].concat(i[t]):i[t];return o},fi=function(i,e){for(var t in i)return/^(browser|cpu|device|engine|os)$/.test(t)||!!e&&fi(i[t])},gi=function(i){return typeof i===c},vi=function(i){if(!i)return d;for(var e,t=[],o=Si(/\\?\"/g,i).split(","),r=0;r<o.length;r++)-1<o[r].indexOf(";")?(e=Ci(o[r]).split(";v="),t[r]={brand:e[0],version:e[1]}):t[r]=Ci(o[r]);return t},ki=function(i){return gi(i)?i.toLowerCase():i},xi=function(i){return gi(i)?Si(/[^\d\.]/g,i).split(".")[0]:d},yi=function(i){for(var e in i){e=i[e];typeof e==l&&2==e.length?this[e[0]]=e[1]:this[e]=d}return this},Si=function(i,e){return gi(e)?e.replace(i,w):e},_i=function(i){return Si(/\\?\"/g,i)},Ci=function(i,e){if(gi(i))return i=Si(/^\s\s*/,i),typeof e===b?i:i.substring(0,C)},Ti=function(i,e){if(i&&e)for(var t,o,r,a,s,n=0;n<e.length&&!a;){for(var w=e[n],b=e[n+1],c=t=0;c<w.length&&!a&&w[c];)if(a=w[c++].exec(i))for(o=0;o<b.length;o++)s=a[++t],typeof(r=b[o])===l&&0<r.length?2===r.length?typeof r[1]==u?this[r[0]]=r[1].call(this,s):this[r[0]]=r[1]:3===r.length?typeof r[1]!==u||r[1].exec&&r[1].test?this[r[0]]=s?s.replace(r[1],r[2]):d:this[r[0]]=s?r[1].call(this,s,r[2]):d:4===r.length&&(this[r[0]]=s?r[3].call(this,s.replace(r[1],r[2])):d):this[r]=s||d;n+=2}},qi=function(i,e){for(var t in e)if(typeof e[t]===l&&0<e[t].length){for(var o=0;o<e[t].length;o++)if(n(e[t][o],i))return"?"===t?d:t}else if(n(e[t],i))return"?"===t?d:t;return e.hasOwnProperty("*")?e["*"]:i},Oi={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"},zi={embedded:"Automotive",mobile:"Mobile",tablet:["Tablet","EInk"],smarttv:"TV",wearable:"Watch",xr:["VR","XR"],"?":["Desktop","Unknown"],"*":d},Ai={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[v,[m,si+"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[v,[m,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[m,v],[/opios[\/ ]+([\w\.]+)/i],[v,[m,ci+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[v,[m,ci+" GX"]],[/\bopr\/([\w\.]+)/i],[v,[m,ci]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[v,[m,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[v,[m,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[m,v],[/quark(?:pc)?\/([-\w\.]+)/i],[v,[m,"Quark"]],[/\bddg\/([\w\.]+)/i],[v,[m,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[v,[m,"UCBrowser"]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[v,[m,"WeChat"]],[/konqueror\/([\w\.]+)/i],[v,[m,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[v,[m,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[v,[m,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[v,[m,"Smart Lenovo"+ni]],[/(avast|avg)\/([\w\.]+)/i],[[m,/(.+)/,"$1 Secure"+ni],v],[/\bfocus\/([\w\.]+)/i],[v,[m,bi+" Focus"]],[/\bopt\/([\w\.]+)/i],[v,[m,ci+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[v,[m,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[v,[m,"Dolphin"]],[/coast\/([\w\.]+)/i],[v,[m,ci+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[v,[m,"MIUI"+ni]],[/fxios\/([\w\.-]+)/i],[v,[m,si+bi]],[/\bqihoobrowser\/?([\w\.]*)/i],[v,[m,"360"]],[/\b(qq)\/([\w\.]+)/i],[[m,/(.+)/,"$1Browser"],v],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[m,/(.+)/,"$1"+ni],v],[/samsungbrowser\/([\w\.]+)/i],[v,[m,ti+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[v,[m,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[m,"Sogou Mobile"],v],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[m,v],[/(lbbrowser|rekonq)/i],[m],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[v,m],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[m,di],v,[f,S]],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(instagram|snapchat)[\/ ]([-\w\.]+)/i],[m,v,[f,S]],[/\bgsa\/([\w\.]+) .*safari\//i],[v,[m,"GSA"],[f,S]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[v,[m,"TikTok"],[f,S]],[/\[(linkedin)app\]/i],[m,[f,S]],[/(chromium)[\/ ]([-\w\.]+)/i],[m,v],[/headlesschrome(?:\/([\w\.]+)| )/i],[v,[m,"Chrome Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[m,"Chrome WebView"],v],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[v,[m,"Android"+ni]],[/chrome\/([\w\.]+) mobile/i],[v,[m,si+"Chrome"]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[m,v],[/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i],[v,[m,si+"Safari"]],[/iphone .*mobile(?:\/\w+ | ?)safari/i],[[m,si+"Safari"]],[/version\/([\w\.\,]+) .*(safari)/i],[v,m],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[m,[v,"1"]],[/(webkit|khtml)\/([\w\.]+)/i],[m,v],[/(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i],[[m,si+bi],v],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[m,"Netscape"],v],[/(wolvic|librewolf)\/([\w\.]+)/i],[m,v],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[v,[m,bi+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/\b(links) \(([\w\.]+)/i],[m,[v,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[m,[v,/[^\d\.]+./,w]]],cpu:[[/\b(?:(amd|x|x86[-_]?|wow|win)64)\b/i],[[k,"amd64"]],[/(ia32(?=;))/i,/((?:i[346]|x)86)[;\)]/i],[[k,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[k,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[k,"armhf"]],[/windows (ce|mobile); ppc;/i],[[k,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[k,/ower/,w,ki]],[/(sun4\w)[;\)]/i],[[k,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[k,ki]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[h,[g,ti],[f,r]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[h,[g,ti],[f,y]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[h,[g,K],[f,y]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[h,[g,K],[f,r]],[/(macintosh);/i],[h,[g,K]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[h,[g,"Sharp"],[f,y]],[/(?:honor)([-\w ]+)[;\)]/i],[h,[g,"Honor"],[f,y]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[h,[g,J],[f,r]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[h,[g,J],[f,y]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i],[[h,/_/g," "],[g,ri],[f,y]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[h,/_/g," "],[g,ri],[f,r]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[h,[g,"OPPO"],[f,y]],[/\b(opd2\d{3}a?) bui/i],[h,[g,"OPPO"],[f,r]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[h,[g,"Vivo"],[f,y]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[h,[g,"Realme"],[f,y]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[h,[g,ei],[f,y]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[h,[g,ei],[f,r]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[h,[g,"LG"],[f,r]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[h,[g,"LG"],[f,y]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[h,[g,"Lenovo"],[f,r]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[h,/_/g," "],[g,"Nokia"],[f,y]],[/(pixel c)\b/i],[h,[g,Y],[f,r]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[h,[g,Y],[f,y]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[h,[g,oi],[f,y]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[h,"Xperia Tablet"],[g,oi],[f,r]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[h,[g,"OnePlus"],[f,y]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[h,[g,W],[f,r]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[h,/(.+)/g,"Fire Phone $1"],[g,W],[f,y]],[/(playbook);[-\w\),; ]+(rim)/i],[h,g,[f,r]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[h,[g,Z],[f,y]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[h,[g,Q],[f,r]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[h,[g,Q],[f,y]],[/(nexus 9)/i],[h,[g,"HTC"],[f,r]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[g,[h,/_/g," "],[f,y]],[/tcl (xess p17aa)/i,/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i],[h,[g,"TCL"],[f,r]],[/droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i],[h,[g,"TCL"],[f,y]],[/(itel) ((\w+))/i],[[g,ki],h,[f,qi,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[h,[g,"Acer"],[f,r]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[h,[g,"Meizu"],[f,y]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[h,[g,"Ulefone"],[f,y]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[h,[g,"Energizer"],[f,y]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[h,[g,"Cat"],[f,y]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[h,[g,"Smartfren"],[f,y]],[/droid.+; (a(?:015|06[35]|142p?))/i],[h,[g,"Nothing"],[f,y]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[g,h,[f,y]],[/(imo) (tab \w+)/i,/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i],[g,h,[f,r]],[/(surface duo)/i],[h,[g,ii],[f,r]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[h,[g,"Fairphone"],[f,y]],[/(shield[\w ]+) b/i],[h,[g,"Nvidia"],[f,r]],[/(sprint) (\w+)/i],[g,h,[f,y]],[/(kin\.[onetw]{3})/i],[[h,/\./g," "],[g,ii],[f,y]],[/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[h,[g,ai],[f,r]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[h,[g,ai],[f,y]],[/smart-tv.+(samsung)/i],[g,[f,t]],[/hbbtv.+maple;(\d+)/i],[[h,/^/,"SmartTV"],[g,ti],[f,t]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[g,"LG"],[f,t]],[/(apple) ?tv/i],[g,[h,K+" TV"],[f,t]],[/crkey.*devicetype\/chromecast/i],[[h,wi+" Third Generation"],[g,Y],[f,t]],[/crkey.*devicetype\/([^/]*)/i],[[h,/^/,"Chromecast "],[g,Y],[f,t]],[/fuchsia.*crkey/i],[[h,wi+" Nest Hub"],[g,Y],[f,t]],[/crkey/i],[[h,wi],[g,Y],[f,t]],[/droid.+aft(\w+)( bui|\))/i],[h,[g,W],[f,t]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[h,[g,"Sharp"],[f,t]],[/(bravia[\w ]+)( bui|\))/i],[h,[g,oi],[f,t]],[/(mitv-\w{5}) bui/i],[h,[g,ri],[f,t]],[/Hbbtv.*(technisat) (.*);/i],[g,h,[f,t]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[g,Ci],[h,Ci],[f,t]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[f,t]],[/(ouya)/i,/(nintendo) (\w+)/i],[g,h,[f,x]],[/droid.+; (shield) bui/i],[h,[g,"Nvidia"],[f,x]],[/(playstation \w+)/i],[h,[g,oi],[f,x]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[h,[g,ii],[f,x]],[/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i],[h,[g,ti],[f,o]],[/((pebble))app/i],[g,h,[f,o]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[h,[g,K],[f,o]],[/droid.+; (wt63?0{2,3})\)/i],[h,[g,ai],[f,o]],[/droid.+; (glass) \d/i],[h,[g,Y],[f,a]],[/(pico) (4|neo3(?: link|pro)?)/i],[g,h,[f,a]],[/; (quest( \d| pro)?)/i],[h,[g,di],[f,a]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[g,[f,s]],[/(aeobc)\b/i],[h,[g,W],[f,s]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[h,[f,y]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[h,[f,r]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[f,r]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[f,y]],[/(android[-\w\. ]{0,9});.+buil/i],[h,[g,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[v,[m,"EdgeHTML"]],[/(arkweb)\/([\w\.]+)/i],[m,v],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[v,[m,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[m,v],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[v,m]],os:[[/microsoft (windows) (vista|xp)/i],[m,v],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[m,[v,qi,Oi]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[v,qi,Oi],[m,ui]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[v,/_/g,"."],[m,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[m,"macOS"],[v,/_/g,"."]],[/android ([\d\.]+).*crkey/i],[v,[m,wi+" Android"]],[/fuchsia.*crkey\/([\d\.]+)/i],[v,[m,wi+" Fuchsia"]],[/crkey\/([\d\.]+).*devicetype\/smartspeaker/i],[v,[m,wi+" SmartSpeaker"]],[/linux.*crkey\/([\d\.]+)/i],[v,[m,wi+" Linux"]],[/crkey\/([\d\.]+)/i],[v,[m,wi]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[v,m],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[m,v],[/\(bb(10);/i],[v,[m,Z]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[v,[m,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[v,[m,bi+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[v,[m,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[v,[m,"watchOS"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[m,"Chrome OS"],v],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) (\w+)/i,/(xbox); +xbox ([^\);]+)/i,/(pico) .+os([\w\.]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[m,v],[/(sunos) ?([\w\.\d]*)/i],[[m,"Solaris"],v],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[m,v]]},Ni=(bi={init:{},isIgnore:{},isIgnoreRgx:{},toString:{}},yi.call(bi.init,[[F,[m,v,p,f]],[G,[k]],[L,[f,h,g]],[D,[m,v]],[X,[m,v]]]),yi.call(bi.isIgnore,[[F,[v,p]],[D,[v]],[X,[v]]]),yi.call(bi.isIgnoreRgx,[[F,/ ?browser$/i],[X,/ ?os$/i]]),yi.call(bi.toString,[[F,[m,v]],[G,[k]],[L,[g,h]],[D,[m,v]],[X,[m,v]]]),bi),Pi=function(e,i){var t=Ni.init[i],o=Ni.isIgnore[i]||0,r=Ni.isIgnoreRgx[i]||0,a=Ni.toString[i]||0;function s(){yi.call(this,t)}return s.prototype.getItem=function(){return e},s.prototype.withClientHints=function(){return hi?hi.getHighEntropyValues(V).then(function(i){return e.setCH(new Hi(i,!1)).parseCH().get()}):e.parseCH().get()},s.prototype.withFeatureCheck=function(){return e.detectFeature().get()},i!=$&&(s.prototype.is=function(i){var e,t=!1;for(e in this)if(this.hasOwnProperty(e)&&!n(o,e)&&ki(r?Si(r,this[e]):this[e])==ki(r?Si(r,i):i)){if(t=!0,i!=b)break}else if(i==b&&t){t=!t;break}return t},s.prototype.toString=function(){var i,e=w;for(i in a)typeof this[a[i]]!==b&&(e+=(e?" ":w)+this[a[i]]);return e||b}),hi||(s.prototype.then=function(i){var e=this,t=function(){for(var i in e)e.hasOwnProperty(i)&&(this[i]=e[i])};t.prototype={is:s.prototype.is,toString:s.prototype.toString};t=new t;return i(t),t}),new s};function Hi(i,e){if(i=i||{},yi.call(this,V),e)yi.call(this,[[T,vi(i[P])],[O,vi(i[H])],[y,/\?1/.test(i[E])],[h,_i(i[M])],[z,_i(i[R])],[A,_i(i[B])],[k,_i(i[I])],[q,vi(i[j])],[N,_i(i[U])]]);else for(var t in i)this.hasOwnProperty(t)&&typeof i[t]!==b&&(this[t]=i[t])}function Ii(i,e,t,o){return this.get=function(i){return i?this.data.hasOwnProperty(i)?this.data[i]:d:this.data},this.set=function(i,e){return this.data[i]=e,this},this.setCH=function(i){return this.uaCH=i,this},this.detectFeature=function(){if(pi&&pi.userAgent==this.ua)switch(this.itemType){case F:pi.brave&&typeof pi.brave.isBrave==u&&this.set(m,"Brave");break;case L:!this.get(f)&&hi&&hi[y]&&this.set(f,y),"Macintosh"==this.get(h)&&pi&&typeof pi.standalone!==b&&pi.maxTouchPoints&&2<pi.maxTouchPoints&&this.set(h,"iPad").set(f,r);break;case X:!this.get(m)&&hi&&hi[z]&&this.set(m,hi[z]);break;case $:var e=this.data,i=function(i){return e[i].getItem().detectFeature().get()};this.set(F,i(F)).set(G,i(G)).set(L,i(L)).set(D,i(D)).set(X,i(X))}return this},this.parseUA=function(){return this.itemType!=$&&Ti.call(this.data,this.ua,this.rgxMap),this.itemType==F&&this.set(p,xi(this.get(v))),this},this.parseCH=function(){var i,e=this.uaCH,t=this.rgxMap;switch(this.itemType){case F:var o,r=e[O]||e[T];if(r)for(var a in r){var s=Si(/(Google|Microsoft) /,r[a].brand||r[a]),a=r[a].version;/not.a.brand/i.test(s)||o&&(!/chrom/i.test(o)||/chromi/i.test(s))||(this.set(m,s).set(v,a).set(p,xi(a)),o=s)}break;case G:var n=e[k];n&&(n&&"64"==e[N]&&(n+="64"),Ti.call(this.data,n+";",t));break;case L:if(e[y]&&this.set(f,y),e[h]&&this.set(h,e[h]),"Xbox"==e[h]&&this.set(f,x).set(g,ii),e[q]){if("string"!=typeof e[q])for(var w=0;!i&&w<e[q].length;)i=qi(e[q][w++],zi);else i=qi(e[q],zi);this.set(f,i)}break;case X:n=e[z];n&&(c=e[A],n==ui&&(c=13<=parseInt(xi(c),10)?"11":"10"),this.set(m,n).set(v,c)),this.get(m)==ui&&"Xbox"==e[h]&&this.set(m,"Xbox").set(v,d);break;case $:var b=this.data,c=function(i){return b[i].getItem().setCH(e).parseCH().get()};this.set(F,c(F)).set(G,c(G)).set(L,c(L)).set(D,c(D)).set(X,c(X))}return this},yi.call(this,[["itemType",i],["ua",e],["uaCH",o],["rgxMap",t],["data",Pi(this,i)]]),this}function Ui(i,e,t){var o;if(typeof i===l?(e=fi(i,!0)?(typeof e===l&&(t=e),i):(t=i,d),i=d):typeof i!==c||fi(e,!0)||(t=e,e=d),t&&typeof t.append===u&&(o={},t.forEach(function(i,e){o[e]=i}),t=o),!(this instanceof Ui))return new Ui(i,e,t).getResult();var r=typeof i===c?i:t&&t[_]?t[_]:pi&&pi.userAgent?pi.userAgent:w,a=new Hi(t,!0),s=e?mi(Ai,e):Ai,e=function(i){return i==$?function(){return new Ii(i,r,s,a).set("ua",r).set(F,this.getBrowser()).set(G,this.getCPU()).set(L,this.getDevice()).set(D,this.getEngine()).set(X,this.getOS()).get()}:function(){return new Ii(i,r,s[i],a).parseUA().get()}};return yi.call(this,[["getBrowser",e(F)],["getCPU",e(G)],["getDevice",e(L)],["getEngine",e(D)],["getOS",e(X)],["getResult",e($)],["getUA",function(){return r}],["setUA",function(i){return gi(i)&&(r=i.length>C?Ci(i,C):i),this}]]).setUA(r),this}Ui.VERSION="2.0.0",Ui.BROWSER=e([m,v,p,f]),Ui.CPU=e([k]),Ui.DEVICE=e([h,g,f,x,y,t,r,o,s]),Ui.ENGINE=Ui.OS=e([m,v]),typeof exports!==b?(typeof module!==b&&module.exports&&(exports=module.exports=Ui),exports.UAParser=Ui):"function"===u&&__webpack_require__(93)?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Ui}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):li&&(i.UAParser=Ui);var ji,Ei=li&&(i.jQuery||i.Zepto);Ei&&!Ei.ua&&(ji=new Ui,Ei.ua=ji.getResult(),Ei.ua.get=function(){return ji.getUA()},Ei.ua.set=function(i){ji.setUA(i);var e,t=ji.getResult();for(e in t)Ei.ua[e]=t[e]})}("object"==typeof window?window:this);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));

/***/ }),
/* 93 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(this, {}))

/***/ }),
/* 94 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAV_MENU_V2", function() { return NAV_MENU_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAV_MENU", function() { return NAV_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "welfare", function() { return welfare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ORDER_MENU", function() { return ORDER_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_SHORT", function() { return USER_SHORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_FUNCTION", function() { return USER_FUNCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_SETTINGS", function() { return USER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FinanceItem", function() { return FinanceItem; });
const NAV_MENU_V2 = [
    {
        title: "买币",
        floatImg: "",
        buriedPoint: "c2c",
        children: [
            {
                title: "快捷买币",
                floatImg: "",
                icon: __webpack_require__(277),
                nightIcon: __webpack_require__(278),
                buriedPoint: "quick",
                locationId: "quickTrade",
                description: "支持visa/master等多种银行卡快速购买虚拟资产",
                urlData: {
                    platform: "global",
                    path: "/fiat-crypto/one-trade",
                },
                jumpUrl: "",
            },
            {
                title: "法币充值",
                floatImg: "",
                icon: __webpack_require__(279),
                nightIcon: __webpack_require__(280),
                buriedPoint: "flat",
                locationId: "LANG-fiat-deposit",
                description: "满足低手续费多种法币的充值",
                urlData: {
                    platform: "global",
                    path: "/fiat/usd/deposit/?currency=usd01",
                },
                jumpUrl: "",
            },
            {
                title: "P2P",
                floatImg: "",
                icon: __webpack_require__(281),
                nightIcon: __webpack_require__(282),
                buriedPoint: "p2p",
                locationId: "otc",
                description: "多种法币0手续费最优价格",
                urlData: {
                    platform: "global",
                    path: "/fiat-crypto/trade/buy-usdt",
                },
                jumpUrl: "",
            },
        ],
    },
    {
        title: "行情资讯",
        floatImg: "",
        buriedPoint: "markets",
        children: [
            {
                title: "自选",
                floatImg: "",
                icon: __webpack_require__(283),
                nightIcon: __webpack_require__(284),
                buriedPoint: "fav",
                locationId: "markets-fav",
                description: "自选交易对，行情尽在掌握",
                urlData: {
                    platform: "global",
                    path: "/markets/?tab=fav",
                },
                jumpUrl: "",
            },
            {
                title: "现货",
                floatImg: "",
                icon: __webpack_require__(285),
                nightIcon: __webpack_require__(286),
                buriedPoint: "exchange",
                locationId: "markets-exchange",
                description: "直达现货市场，抓住交易机会",
                urlData: {
                    platform: "global",
                    path: "/markets/?tab=exchange",
                },
                jumpUrl: "",
            },
            {
                title: "合约",
                floatImg: "",
                icon: __webpack_require__(287),
                nightIcon: __webpack_require__(288),
                buriedPoint: "dm",
                locationId: "markets-dm",
                description: "了解合约行情动态，获取超额收益",
                urlData: {
                    platform: "global",
                    path: "/markets/?tab=dm",
                },
                jumpUrl: "",
            },
        ],
    },
    {
        title: "交易",
        floatImg: "",
        buriedPoint: "trade",
        children: [
            {
                title: "币币交易",
                floatImg: "",
                icon: __webpack_require__(289),
                nightIcon: __webpack_require__(290),
                buriedPoint: "coinexchange",
                locationId: "exchange",
                description: "使用完整的交易功能，买卖虚拟资产",
                urlData: {
                    platform: "global",
                    path: "/exchange/",
                },
                jumpUrl: "",
            },
            {
                title: "杠杆ETP",
                floatImg: "",
                icon: __webpack_require__(291),
                nightIcon: __webpack_require__(292),
                buriedPoint: "etp",
                locationId: "exchange",
                description: "无爆仓享受杠杆收益",
                urlData: {
                    platform: "global",
                    path: "/exchange/btc3l_usdt",
                },
                jumpUrl: "",
            },
            {
                title: "杠杆交易",
                floatImg: "",
                icon: __webpack_require__(293),
                nightIcon: __webpack_require__(294),
                buriedPoint: "crossmargin",
                locationId: "crossmargin",
                description: "借币交易，放大现货收益",
                urlData: {
                    platform: "global",
                    path: "/cross-margin/",
                },
                jumpUrl: "",
            },
            {
                title: "交易机器人",
                floatImg: "",
                icon: __webpack_require__(295),
                nightIcon: __webpack_require__(296),
                buriedPoint: "grid",
                locationId: "grid",
                description: "丰富的量化交易策略，自动跟单，自动交易",
                urlData: {
                    platform: "global",
                    path: "/grid-exchange/",
                },
                jumpUrl: "",
            },
            {
                title: "火币闪兑",
                floatImg: "",
                icon: __webpack_require__(297),
                nightIcon: __webpack_require__(298),
                buriedPoint: "convert",
                locationId: "",
                description: "币币兑换，零费率无滑点",
                urlData: {
                    platform: "global",
                    path: "/fiat-crypto/one-trade-convert",
                },
                jumpUrl: "",
            },
        ],
    },
    {
        title: "衍生品",
        floatImg: "",
        buriedPoint: "futures",
        children: [
            {
                title: "U本位合约",
                floatImg: "",
                icon: __webpack_require__(299),
                nightIcon: __webpack_require__(300),
                buriedPoint: "linearswap",
                locationId: "futures-linear-swap",
                description: "以USDT结算的合约交易",
                urlData: {
                    platform: "global",
                    path: "/futures/linear_swap/exchange/",
                },
                jumpUrl: "",
            },
            {
                title: "币本位合约",
                floatImg: "",
                icon: __webpack_require__(301),
                nightIcon: __webpack_require__(302),
                buriedPoint: "swap",
                locationId: "futures-swap",
                description: "以加密货币结算的合约交易",
                urlData: {
                    platform: "global",
                    path: "/futures/swap/exchange/",
                },
                jumpUrl: "",
            },
            {
                title: "期权交易",
                floatImg: "",
                icon: __webpack_require__(303),
                nightIcon: __webpack_require__(304),
                buriedPoint: "option",
                locationId: "otc-option",
                description: "欧式美式期权随心选择，财富稳定增值",
                urlData: {
                    platform: "global",
                    path: "/otc-option/exchange/#btc_usdt",
                },
                jumpUrl: "",
            },
            {
                title: "合约跟单",
                floatImg: "",
                icon: __webpack_require__(305),
                nightIcon: __webpack_require__(306),
                buriedPoint: "copy",
                locationId: "futures-order",
                description: "自动跟随专业交易员下单，轻松盈利",
                urlData: {
                    platform: "global",
                    path: "/futures/copy_trading/home/",
                },
                jumpUrl: "",
            },
            {
                title: "Huobi合约嘉年华",
                floatImg: "",
                icon: __webpack_require__(307),
                nightIcon: __webpack_require__(308),
                buriedPoint: "",
                locationId: "",
                description: "参加交易 iPhone14Pro Max等你拿",
                urlData: {
                    platform: "",
                    path: "",
                },
                jumpUrl: "",
            },
        ],
    },
    {
        title: "赚币_menu",
        floatImg: "",
        buriedPoint: "Earn",
        children: [
            {
                title: "Huobi Earn",
                floatImg: "",
                icon: __webpack_require__(309),
                nightIcon: __webpack_require__(310),
                buriedPoint: "huobiearn",
                locationId: "wealth-earnings",
                description: "稳健的虚拟资产配置工具",
                urlData: {
                    platform: "global",
                    path: "/financial/earn/",
                },
                jumpUrl: "",
            },
            {
                title: "双币投资",
                floatImg: "",
                icon: __webpack_require__(311),
                nightIcon: __webpack_require__(312),
                buriedPoint: "twocoin",
                locationId: "finance-otc-option",
                description: "非保本高额收益结构型理财",
                urlData: {
                    platform: "global",
                    path: "/otc-option/exchange/#btc_usdt",
                },
                jumpUrl: "",
            },
            {
                title: "质押借币",
                floatImg: "",
                icon: __webpack_require__(313),
                nightIcon: __webpack_require__(314),
                buriedPoint: "pledge",
                locationId: "financial-pledge",
                description: "便捷抵押，安全交易",
                urlData: {
                    platform: "global",
                    path: "/financial/pledge/",
                },
                jumpUrl: "",
            },
            {
                title: "场外借贷",
                floatImg: "",
                icon: __webpack_require__(315),
                nightIcon: __webpack_require__(316),
                buriedPoint: "landing",
                locationId: "otc-loan",
                description: "扩大交易规模和种类，实现多倍收益",
                urlData: {
                    platform: "global",
                    path: "/financial/otc-loan/landing",
                },
                jumpUrl: "",
            },
        ],
    },
    {
        title: "借币",
        floatImg: "",
        buriedPoint: "finace",
        children: [
            {
                title: "节点投票",
                floatImg: "",
                icon: __webpack_require__(317),
                nightIcon: __webpack_require__(318),
                buriedPoint: "vote",
                locationId: "staking-vote",
                description: "享受高奖励的节点投票",
                urlData: {
                    platform: "global",
                    path: "/staking/vote/",
                },
                jumpUrl: "",
            },
            {
                title: "ETH 2.0",
                floatImg: "",
                icon: __webpack_require__(319),
                nightIcon: __webpack_require__(320),
                buriedPoint: "eht2",
                locationId: "staking-eth",
                description: "迎接以太坊2.0",
                urlData: {
                    platform: "global",
                    path: "/staking/eth2/",
                },
                jumpUrl: "",
            },
            {
                title: "借贷业务系统",
                floatImg: "",
                icon: __webpack_require__(321),
                nightIcon: __webpack_require__(322),
                buriedPoint: "flending",
                locationId: "brokerage-lending",
                description: "随借随还实时到账",
                urlData: {
                    platform: "brokerage",
                    path: "/lending/order",
                },
                jumpUrl: "",
            },
            {
                title: "OTC交易系统",
                floatImg: "",
                icon: __webpack_require__(323),
                nightIcon: __webpack_require__(324),
                buriedPoint: "otctrade",
                locationId: "brokerage",
                description: "尊享大宗交易零手续费",
                urlData: {
                    platform: "brokerage",
                    path: "/trade",
                },
                jumpUrl: "",
            },
        ],
    },
    {
        title: "活动",
        floatImg: "",
        buriedPoint: "activity",
        children: [
            {
                title: "福利中心",
                floatImg: "",
                icon: __webpack_require__(325),
                nightIcon: __webpack_require__(326),
                buriedPoint: "reward",
                locationId: "welfare",
                description: "轻松赚币，天天领奖",
                urlData: {
                    platform: "global",
                    path: "/welfare/web/",
                },
                jumpUrl: "",
            },
            {
                title: "Newlisting",
                floatImg: "",
                icon: __webpack_require__(327),
                nightIcon: __webpack_require__(328),
                buriedPoint: "Newlisting",
                locationId: "",
                description: "新币福利营带你发现最佳资产",
                urlData: {
                    platform: "global",
                    path: "/assetactivity/web",
                },
                jumpUrl: "",
            },
            {
                title: "Primebox",
                floatImg: "",
                icon: __webpack_require__(329),
                nightIcon: __webpack_require__(330),
                buriedPoint: "Primebox",
                locationId: "",
                description: "虚拟资产财富之旅的记忆凭证",
                urlData: {
                    platform: "global",
                    path: "/primebox/web",
                },
                jumpUrl: "",
            },
            {
                title: "交易赛",
                floatImg: "",
                icon: __webpack_require__(331),
                nightIcon: __webpack_require__(332),
                buriedPoint: "tradinggame",
                locationId: "",
                description: "牛人大师都爱的大赛",
                urlData: {
                    platform: "global",
                    path: "/trading-game",
                },
                jumpUrl: "",
            },
        ],
    },
    {
        title: "HTX专区",
        floatImg: "",
        buriedPoint: "htx",
        children: [
            {
                title: "一键收取HTX",
                floatImg: "",
                icon: __webpack_require__(333),
                nightIcon: __webpack_require__(334),
                buriedPoint: "receivehtx",
                locationId: "receivehtx",
                description: "任务奖励日日解锁",
                urlData: {
                    platform: "global",
                    path: "/htx/convert/receive/?utm_source=webbar",
                },
                jumpUrl: "",
            },

            // {
            //     "title": "云钱包",
            //     "floatImg": "",
            //     "icon": require("../assets/images/conf/light/CloudWallet.svg"),
            //     "nightIcon": require("../assets/images/conf/dark/CloudWallet.svg"),
            //     "buriedPoint": "cloud",
            //     "locationId": "defilabs",
            //     "description": "无需自己保管私钥，一键参与 DeFi 项目",
            //     "urlData": {
            //         platform: 'itoken',
            //         path: '/cloud-wallet',
            //     },
            //     "jumpUrl": ""
            // }
        ],
    },
    {
        title: "Launchpool",
        floatImg: "",
        icon: "",
        nightIcon: "",
        buriedPoint: "",
        locationId: "",
        description: "",
        urlData: {
            platform: "global",
            path: "/assetactivity/web/launchpool?activityId=5",
        },
        jumpUrl: "",
    }
];

//保留 社区

const NAV_MENU = [
    {
        name: "买币",
        platform: "global",
        path: "/fiat-crypto/one-trade",
        icon: "icon-menu-trade",
        track: "c2c",
        children: [
            {
                name: "快捷一键买卖",
                platform: "global",
                path: "/fiat-crypto/one-trade",
                icon: "icon-one-trade",
                activeId: "quickTrade",
                track: "quick",
            },
            {
                name: "法币充值",
                platform: "global",
                path: "/fiat/usd/deposit/?currency=usd01",
                icon: "icon-fiat-deposit",
                activeId: "LANG-fiat-deposit", // TODO: 未添加
                track: "flat",
            },
            {
                name: "P2P自选交易",
                platform: "global",
                path: "/fiat-crypto/trade/buy-usdt",
                icon: "icon-p2p-buy",
                activeId: "otc",
                track: "p2p",
            },
            // {
            //     name: '第三方交易',
            //     platform: 'global',
            //     path: '/fiat-crypto/one-trade',
            //     icon: 'icon-third-trade',
            //     activeId: 'quickTrade1',   // TODO: 页面与一键买卖一样，待定
            //     track: 'third'
            // },
        ],
    },
    {
        name: "行情",
        platform: "global",
        path: "/markets/",
        icon: "icon-menu-markets",
        track: "markets",
        children: [
            {
                name: "自选",
                platform: "global",
                path: "/markets/?tab=fav",
                icon: "icon-fav",
                activeId: "markets-fav", // TODO: 页面一致，无法标记，需要改造en
                track: "fav",
            },
            {
                name: "现货",
                platform: "global",
                path: "/markets/?tab=exchange",
                icon: "icon-market-exchange",
                activeId: "markets-exchange", // TODO: 页面一致，无法标记，需要改造en
                track: "exchange",
            },
            {
                name: "合约",
                platform: "global",
                path: "/markets/?tab=dm",
                icon: "icon-market-dm",
                activeId: "markets-dm", // TODO: 页面一致，无法标记，需要改造en
                track: "dm",
            },
        ],
    },
    {
        name: "现货交易",
        platform: "global",
        path: "/exchange/",
        icon: "icon-menu-exchange",
        track: "trade",
        children: [
            {
                name: "币币交易",
                platform: "global",
                path: "/exchange/",
                icon: "icon-exchange",
                activeId: "exchange",
                track: "coinexchange",
            },
            {
                name: "全仓杠杆",
                platform: "global",
                path: "/cross-margin/",
                icon: "icon-margin",
                activeId: "cross-margin", // TODO: 重复了，需要改造en
                track: "crossmargin",
            },
            {
                name: "逐仓杠杆",
                platform: "global",
                path: "/margin/",
                icon: "icon-margin",
                activeId: "margin",
                track: "margin",
            },
            {
                name: "交易机器人",
                platform: "global",
                path: "/grid-exchange/",
                icon: "icon-tradingbot",
                activeId: "grid",
                track: "grid",
            },
        ],
    },
    {
        name: "合约交易",
        platform: "global",
        path: "/",
        icon: "icon-menu-contract",
        track: "futures",
        children: [
            {
                name: "U本位合约",
                platform: "global",
                path: "/futures/linear_swap/exchange/",
                icon: "icon-usdt-contracts",
                activeId: "futures-linear-swap", // TODO: 待定
                track: "linearswap",
            },
            {
                name: "币本位交割",
                platform: "global",
                path: "/futures/contract/exchange/",
                icon: "icon-futures-contract",
                activeId: "futures-contract-exchange", // TODO: 待定
                track: "contract",
            },
            {
                name: "币本位永续",
                platform: "global",
                path: "/futures/swap/exchange/",
                icon: "icon-futures-swap",
                activeId: "futures-swap", // TODO: 待定
                track: "swap",
            },
            {
                name: "期权交易",
                platform: "global",
                path: "/otc-option/exchange/#btc_usdt",
                icon: "icon-otc-option",
                activeId: "otc-option", // TODO: 未实现
                track: "option",
            },
            {
                name: "合约跟单",
                platform: "global",
                path: "/futures/copy_trading/home/",
                icon: "icon-futures-order",
                activeId: "futures-order", // TODO: 未实现
                track: "futuresorder",
            },
        ],
    },
    {
        name: "金融业务",
        platform: "global",
        path: "/financial/earn/",
        icon: "icon-menu-finance",
        track: "finace",
        groups: [
            {
                name: "理财相关",
                children: [
                    {
                        name: "Huobi Earn 理财",
                        platform: "global",
                        path: "/financial/earn/",
                        icon: "icon-hb-earn",
                        activeId: "wealth-earnings", // TODO: 未实现
                        track: "earn",
                    },
                    {
                        name: "双币投资",
                        platform: "global",
                        path: "/otc-option/exchange/#btc_usdt",
                        icon: "icon-exchange",
                        activeId: "finance-otc-option", // TODO: 未实现
                        track: "twocoin",
                    },
                    {
                        name: "质押借币",
                        platform: "global",
                        path: "/financial/pledge/",
                        icon: "icon-pledge",
                        activeId: "financial-pledge",
                        track: "pledge",
                    },
                    {
                        name: "场外借贷",
                        platform: "global",
                        path: "/financial/otc-loan/landing",
                        icon: "icon-landing",
                        activeId: "otc-loan",
                        track: "landing",
                    },
                ],
            },
            {
                name: "其他",
                children: [
                    {
                        name: "节点质押投票",
                        platform: "global",
                        path: "/staking/vote/",
                        icon: "icon-staking",
                        activeId: "staking-vote", // TODO: 节点投票
                        track: "vote",
                    },
                    {
                        name: "ETH2.0",
                        platform: "global",
                        path: "/staking/eth2/",
                        icon: "icon-eth2.0",
                        activeId: "staking-eth",
                        track: "eht2",
                    },
                    {
                        name: "借贷业务系统",
                        platform: "brokerage",
                        path: "/lending/order",
                        icon: "icon-brokerage-lending",
                        activeId: "brokerage-lending",
                        track: "flending",
                    },
                    {
                        name: "OTC交易系统",
                        platform: "brokerage",
                        path: "/trade",
                        icon: "icon-otc",
                        activeId: "brokerage",
                        track: "otctrade",
                    },
                    // {
                    //     name: 'iToken',
                    //     platform: 'itoken',
                    //     path: '/',
                    //     icon: 'icon-itoken',
                    //     activeId: 'itoken',
                    //     track: 'itoken'
                    // },
                ],
            },
        ],
    },
    {
        name: "成长学院",
        platform: "global",
        path: "/views/learn",
        icon: "icon-menu-learn",
        activeId: "learn",
        track: "grow",
    },
];

const welfare = {
    name: "福利中心",
    platform: "global",
    path: "/welfare/web/",
    icon: "icon-welfare",
    activeId: "welfare",
    track: "welfare",
};

// 订单列表
const ORDER_MENU = [
    {
        name: "现货&杠杆订单",
        platform: "global",
        path: "/transac/",
        activeId: "order-transac",
    },
    {
        name: "法币订单",
        platform: "global",
        path: "/fiat-crypto/user-center/orders/",
        activeId: "order-otc",
    },
    {
        name: "合约订单",
        platform: "global",
        path: "/futures/linear_swap/current_orders/",
        activeId: "order-contract",
    },
    {
        name: "赚币订单",
        platform: "global",
        path: "/financial/earn/order",
        activeId: "order-earn",
    },
    {
        name: "策略订单",
        platform: "global",
        path: "/grid-exchange/orders/",
        activeId: "order-grid",
    },
    {
        name: "质押借币订单",
        platform: "global",
        path: "/financial/pledge/orders/",
        activeId: "order-pledge",
    },
];

const USER_SHORT = [
    {
        name: "我的资产",
        platform: "global",
        path: "/finance/account",
    },
    {
        name: "我的订单",
        platform: "global",
        path: "/transac/",
    },
    {
        name: "消息",
        platform: "global",
        path: "/inmail/",
    },
];

// 用户功能
const USER_FUNCTION = [
    // {
    //     name: "多米尼克数字公民",
    //     platform: 'global',
    //     path: '/user_center/uc_auth/digital',
    // },
    {
        name: "我的费率",
        platform: "global",
        path: "/fee/",
    },
    {
        name: "我的福利",
        platform: "global",
        path: "/welfare/web/rewards",
    },
    // {
    //     name: "我的优惠券",
    //     platform: 'global',
    //     path: '/coupon/',
    // },
    // {
    //     name: "我的点卡",
    //     platform: 'global',
    //     path: '/points/my-points/',
    // },
    {
        name: "我的邀请奖励",
        platform: "global",
        path: "/statistics/invite-statistics/",
    },
];

// 用户设置
const USER_SETTINGS = [
    {
        name: "账户安全",
        platform: "account",
        path: "/user-center/security/",
    },
    {
        name: "法币设置",
        platform: "global",
        path: "/fiat-crypto/user-center/",
    },
    {
        name: "子账号管理",
        platform: "account",
        path: "/subaccount/manage/",
    },
    {
        name: "API管理",
        platform: "global",
        path: "/apikey/",
    },
    {
        name: "经纪商看板",
        platform: "global",
        path: "/broker/",
    },
];

const DistributionTypes = {
    1: "现货",
    2: "合约",
    3: "杠杆",
    4: "赚币",
    5: "法币",
    6: "期权",
    8: "交易机器人",
    100: "其他",
};

// 资产账户
const FinanceItem = {
    1: {
        name: "现货",
        platform: "global",
        path: "/finance/account/spot/",
    },
    2: {
        name: "合约",
        platform: "global",
        path: "/futures/contract/assets",
    },
    3: {
        name: "杠杆",
        platform: "global",
        path: "/finance/account/margin?tab=super-margin",
    },
    4: {
        name: "赚币",
        platform: "global",
        path: "/finance/account/earn",
    },
    5: {
        name: "法币",
        platform: "global",
        path: "/finance/account/otc",
    },
    6: {
        name: "期权",
        platform: "global",
        path: "/finance/account/otc-options",
    },
    8: {
        name: "交易机器人",
        platform: "global",
        path: "/finance/account/grid-trading",
    },
    100: {
        name: "其他",
    },
};

//
/* harmony default export */ __webpack_exports__["default"] = ([]);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var core_1 = __webpack_require__(103);
var classnames_1 = __importDefault(__webpack_require__(31));
var hbsDropdown_1 = __importDefault(__webpack_require__(97));
var react_dom_1 = __webpack_require__(60);
var Dropdown = function (_a) {
    var children = _a.children, _b = _a.handleClick, handleClick = _b === void 0 ? function () { } : _b, _c = _a.handleMouseEnter, handleMouseEnter = _c === void 0 ? function () { } : _c, title = _a.title, _d = _a.showExpand, showExpand = _d === void 0 ? true : _d, className = _a.className, style = _a.style, isActive = _a.isActive, _e = _a.placement, placement = _e === void 0 ? 'bottom-end' : _e, isShowFlag = _a.isShowFlag, _f = _a.offset, offset = _f === void 0 ? [] : _f, withBottomMargin = _a.withBottomMargin;
    var _g = (0, react_1.useState)(false), isShow = _g[0], setIsShow = _g[1];
    var _h = (0, react_1.useState)(false), isHide = _h[0], setIsHide = _h[1];
    var _j = (0, react_1.useState)(isShowFlag), isShowFlagPrev = _j[0], setShowFlagPrev = _j[1];
    (0, react_1.useEffect)(function () {
        setShowFlagPrev(isShowFlag);
        // 当前值有变化
        if (isShowFlag !== isShowFlagPrev && isShow) {
            hide();
        }
    }, [isShowFlag]);
    var onMouseEnter = function () {
        show();
    };
    var onMouseLeave = function () {
        hide();
    };
    var show = function () {
        unbindAni();
        setIsHide(false);
        setIsShow(true);
    };
    var hide = function () {
        unbindAni();
        bindAni();
        // 动画启动
        setIsHide(true);
    };
    // 移除动画绑定
    var unbindAni = function () {
        if (popperElement) {
            var content = popperElement.querySelector('.hb-menu-dropdown__body');
            if (content && content.$ffFun) {
                content.$ffFun();
            }
        }
    };
    var bindAni = function () {
        if (popperElement) {
            var content = popperElement.querySelector('.hb-menu-dropdown__body');
            // 绑定动画事件
            var off = (0, react_dom_1.once)(content, 'animationend', function () {
                setIsHide(false);
                setIsShow(false);
            });
            if (content) {
                content.$ffFun = off;
            }
        }
    };
    var onTriggerMouseEnter = function () { };
    var triStyle = isShow ? 'toggle__triangle toggle__triangle--expend' : 'toggle__triangle';
    var _k = (0, react_1.useState)(null), popperIns = _k[0], setPopperIns = _k[1];
    var _l = (0, react_1.useState)(null), referenceElement = _l[0], setReferenceElement = _l[1];
    var _m = (0, react_1.useState)(null), popperElement = _m[0], setPopperElement = _m[1];
    var _o = (0, react_1.useState)(null), mainEl = _o[0], setEl = _o[1];
    (0, react_1.useEffect)(function () {
        if (mainEl) {
            new hbsDropdown_1.default(mainEl, { withBottomMargin: withBottomMargin });
        }
    }, [mainEl]);
    // 监听两个对象初始化
    (0, react_1.useEffect)(function () {
        if (referenceElement && popperElement) {
            var offsetFn = function (_a) {
                var placement = _a.placement, reference = _a.reference, popper = _a.popper;
                if (placement === 'bottom-start') {
                    return [0, 0];
                }
                else if (placement === 'bottom-end') {
                    return [0, 0];
                }
                return [];
            };
            var offsetOption = {
                name: 'offset',
                options: {
                    offset: offset || offsetFn,
                },
            };
            var popperInstance = (0, core_1.createPopper)(referenceElement, popperElement, {
                placement: placement,
                modifiers: [
                    offsetOption,
                    {
                        name: 'flip',
                        enabled: false,
                    },
                ],
            });
            setPopperIns(popperInstance);
        }
    }, [referenceElement, popperElement]);
    // 监听显示和poper 实例
    (0, react_1.useEffect)(function () {
        if (isShow && popperIns) {
            popperIns.update();
        }
    }, [isShow, popperIns]);
    // 监听显示和poper 实例
    (0, react_1.useEffect)(function () {
        // 除了点击自己，点击其他地方将自身隐藏
        document.addEventListener('click', function (e) {
            // @ts-ignore
            var id = e.target.id;
            if (['switch_txt', 'switch_img'].includes(id)) {
                setIsShow(false);
                setIsHide(true);
                hide();
                return;
            }
        });
    }, []);
    var renderTrigger = function () {
        return title({ setReferenceElement: setReferenceElement, handleClick: handleClick, handleMouseEnter: handleMouseEnter });
    };
    var renderContent = function () {
        var displayStyles = {
            display: isShow ? 'block' : 'none',
        };
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('hb-dropdown__content', 'js-hbs-dropdowns', {
                show: isShow,
            }), ref: setPopperElement }, children));
    };
    return (react_1.default.createElement("div", { className: "".concat(className, " hb-dropdown-wrap hb-menu-dropdown ").concat((0, classnames_1.default)({
            'hb-dropdown--open': isShow,
            'hb-dropdown--hide': isHide,
        })), style: style, ref: setEl, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        renderTrigger(),
        renderContent()));
};
exports.default = Dropdown;


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _raf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
/**
 * 简单下拉菜单，下拉通过css hover 显示
 * 计算思路：
 * 1. 第一次显示时进行重新计算
 * 2. window resize后显示时重新计算
 * 3. dom变化时重新计算
 *
 * 使用规范：
 * 指令：v-hbs-dropdown
 *
 * 下拉显示的dom必须有样式js-hbs-dropdowns才会响应
 * <div class="fedui-header-info-dropdowns js-hbs-dropdowns"></div>
 */

let id = 1;


 class HBSimpleDropdown {
    constructor(el, options = {}) {
        const { withBottomMargin = true } = options

        this.id = ++id

        this.el = el;

        this.content = el.querySelector(".js-hbs-dropdowns");

        this.computedSize = false;
        this.resize = false;

        this._resize = this.onWindowResize.bind(this);
        this._mouseenter = this.onMouseEnter.bind(this);
        this.withBottomMargin = withBottomMargin

        if (this.content) {
            this.bindEvents();
        }
    }

    bindEvents() {
        window.addEventListener("resize", this._resize);

        this.el.addEventListener("mouseenter", this._mouseenter, false);

        // 监听dom是否变更，针对数据延时导致的dom增减问题
        var mutationObserver = new MutationObserver(() => {
            this.dynamicComput()
        });

        // options：监听的属性
        var options = {
            childList: true,
            subtree: true,
            attributes: false,
            attributeOldValue: false,
        };
        mutationObserver.observe(this.content, options);

        this.mutationObserver = mutationObserver
    }

    dynamicComput() {
        const rect = this.content.getBoundingClientRect();

        // 如果当前内容没有显示，那么，下次打开时重新计算
        if (rect.height === 0) {
            this.computedSize = false
        } else {
            this.computSize()
        }
    }

    computSize() {
        const styleHeight = this.content.style.height;
        // 如果设置了高度，那么取消设置的高度再对比
        if (styleHeight != "") {
            this.content.style.height = "auto";
        }
        const rect = this.content.getBoundingClientRect();
        const windowHeight = window.innerHeight;


        // 下边距设置
        const offsetMargin = rect.top + (this.withBottomMargin ? 30 : 0);

        if (windowHeight - offsetMargin < rect.height) {
            this.content.style.height = Math.max(150, windowHeight - offsetMargin) + "px";
            if ('visible' === window.getComputedStyle(this.content)['overflowY']) {
            }
            this.content.style["overflowY"] = "auto";
        }
    }

    onMouseEnter() {
        if (this.computedSize && !this.resize) {
            return false;
        }
        Object(_raf__WEBPACK_IMPORTED_MODULE_0__["doubleRaf"])(() => {
            this.computSize()
            this.computedSize = true;
            this.resize = false;
        })
    }

    onWindowResize() {
        this.resize = true;
        this.dynamicComput()
    }

    destroy() {
        window.removeEventListener("resize", this._resize);
        this.el.removeEventListener("mouseenter", this._mouseenter);
        // 关闭监听
        this.mutationObserver && this.mutationObserver.disconnect()
    }
}

/* harmony default export */ __webpack_exports__["default"] = (HBSimpleDropdown);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var CellItem = function (_a) {
    var title = _a.title, value = _a.value, isLink = _a.isLink, icon = _a.icon, href = _a.href, children = _a.children, _b = _a.target, target = _b === void 0 ? '' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.handleClick, handleClick = _d === void 0 ? function () { } : _d;
    var renderContent = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "hbg-cell__title ".concat(className) },
                react_1.default.createElement("p", null, title)),
            children ? children : value ? react_1.default.createElement("div", { className: "hbg-cell__content" }, value) : '',
            isLink ? react_1.default.createElement("i", { className: "fed-icon__arrow--right" }) : ''));
    };
    return href ? (react_1.default.createElement("a", { className: "hbg-cell".concat(isLink ? ' is-link' : '', " ").concat(className), target: target, href: href }, renderContent())) : (react_1.default.createElement("div", { className: "hbg-cell".concat(isLink ? ' is-link' : '', " ").concat(className), onClick: handleClick }, renderContent()));
};
exports.default = CellItem;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function fadeOut(element, cb) {
    element.classList.remove(SLILDE_IN);
    element.classList.add(SLILDE_OUT);
    if (element.style.opacity && element.style.opacity > 0.05) {
        element.style.opacity = element.style.opacity - 0.05;
    } else if (element.style.opacity && element.style.opacity <= 0.1) {
        if (element.parentNode) {
            element.parentNode.removeChild(element);
            if (cb) cb(1);
        }
    } else {
        element.style.opacity = 0.9;
    }
    setTimeout(() => fadeOut.apply(this, [element, cb]), 1000 / 30);
}

const LIB_NAME = "mini-toastr";

const ERROR = "error";
const WARN = "warn";
const SUCCESS = "success";
const INFO = "info";
const CONTAINER_CLASS = LIB_NAME;
const NOTIFICATION_CLASS = `${LIB_NAME}__notification`;
const TITLE_CLASS = `${LIB_NAME}-notification__title`;
const ICON_CLASS = `${LIB_NAME}-notification__icon`;
const MESSAGE_CLASS = `${LIB_NAME}-notification__message`;
const SLILDE_IN = `${LIB_NAME}-in`;
const SLILDE_OUT = `${LIB_NAME}-out`;
const ERROR_CLASS = `-${ERROR}`;
const WARN_CLASS = `-${WARN}`;
const SUCCESS_CLASS = `-${SUCCESS}`;
const INFO_CLASS = `-${INFO}`;
const DEFAULT_TIMEOUT = 8000;

const EMPTY_STRING = "";

function flatten(obj, into, prefix) {
    into = into || {};
    prefix = prefix || EMPTY_STRING;

    for (const k in obj) {
        if (obj.hasOwnProperty(k)) {
            const prop = obj[k];
            if (prop && typeof prop === "object" && !(prop instanceof Date || prop instanceof RegExp)) {
                flatten(prop, into, prefix + k + " ");
            } else {
                if (into[prefix] && typeof into[prefix] === "object") {
                    into[prefix][k] = prop;
                } else {
                    into[prefix] = {};
                    into[prefix][k] = prop;
                }
            }
        }
    }

    return into;
}

function makeCss(obj) {
    const flat = flatten(obj);
    let str = JSON.stringify(flat, null, 2);
    str = str
        .replace(/"([^"]*)": {/g, "$1 {")
        .replace(/"([^"]*)"/g, "$1")
        .replace(/(\w*-?\w*): ([\w\d .#]*),?/g, "$1: $2;")
        .replace(/},/g, "}\n")
        .replace(/ &([.:])/g, "$1");

    str = str.substr(1, str.lastIndexOf("}") - 1);

    return str;
}

function appendStyles(css) {
    let head = document.head || document.getElementsByTagName("head")[0];
    let styleElem = makeNode("style");
    styleElem.id = `${LIB_NAME}-styles`;
    styleElem.type = "text/css";

    if (styleElem.styleSheet) {
        styleElem.styleSheet.cssText = css;
    } else {
        styleElem.appendChild(document.createTextNode(css));
    }

    head.appendChild(styleElem);
}

const config = {
    types: {
        ERROR,
        WARN,
        SUCCESS,
        INFO,
    },
    animation: fadeOut,
    timeout: DEFAULT_TIMEOUT,
    icons: {},
    appendTarget: document.body,
    node: makeNode(),
    allowHtml: false,
    style: {
        [`.${CONTAINER_CLASS}`]: {
            position: "fixed",
            "z-index": 2000000001,
            right: "12px",
            top: "12px",
        },
        [`.${NOTIFICATION_CLASS}`]: {
            cursor: "pointer",
            padding: "12px 18px",
            margin: "0 0 6px 0",
            "background-color": "#000",
            opacity: 0.8,
            color: "#fff",
            "border-radius": "3px",
            "box-shadow": "#3c3b3b 0 0 12px",
            width: "300px",
            [`&.${ERROR_CLASS}`]: {
                "background-color": "#D5122B",
            },
            [`&.${WARN_CLASS}`]: {
                "background-color": "#F5AA1E",
            },
            [`&.${SUCCESS_CLASS}`]: {
                "background-color": "#7AC13E",
            },
            [`&.${INFO_CLASS}`]: {
                "background-color": "#4196E1",
            },
            "&:hover": {
                opacity: 1,
                "box-shadow": "#000 0 0 12px",
            },
        },
        [`.${TITLE_CLASS}`]: {
            "font-weight": "500",
        },
        [`.${MESSAGE_CLASS}`]: {
            display: "inline-block",
            "vertical-align": "middle",
            width: "240px",
            padding: "0 12px",
        },
    },
};

function makeNode(type = "div") {
    return document.createElement(type);
}

function createIcon(node, type, config) {
    const iconNode = makeNode(config.icons[type].nodeType);
    const attrs = config.icons[type].attrs;

    for (const k in attrs) {
        if (attrs.hasOwnProperty(k)) {
            iconNode.setAttribute(k, attrs[k]);
        }
    }

    node.appendChild(iconNode);
}

function addElem(node, text, className, config) {
    const elem = makeNode();
    elem.className = className;
    if (config.allowHtml) {
        elem.innerHTML = text;
    } else {
        elem.appendChild(document.createTextNode(text));
    }
    node.appendChild(elem);
}

function getTypeClass(type) {
    if (type === SUCCESS) return SUCCESS_CLASS;
    if (type === WARN) return WARN_CLASS;
    if (type === ERROR) return ERROR_CLASS;
    if (type === INFO) return INFO_CLASS;

    return EMPTY_STRING;
}

const messageList = {};

const miniToastr = {
    config,
    isInitialised: false,
    showMessage(message, title, type, timeout, cb, overrideConf) {
        const config = {};
        const hash = `${message}${title}${type}`;

        messageList[hash] = messageList[hash] || {};

        if (messageList[hash].id) {
            clearTimeout(messageList[hash].id);
        }

        Object.assign(config, this.config);
        Object.assign(config, overrideConf);

        let notificationElem = messageList[hash].node;
        if (!notificationElem) {
            notificationElem = messageList[hash].node = makeNode();
            notificationElem.className = `${NOTIFICATION_CLASS} ${SLILDE_IN} ${getTypeClass(type)}`;
            if (overrideConf && overrideConf.className) {
                notificationElem.className = `${notificationElem.className} ${overrideConf.className}`;
            }

            notificationElem.onclick = () => {
                config.animation(notificationElem, null);
                messageList[hash].node = null;
            };

            if (title) addElem(notificationElem, title, TITLE_CLASS, config);
            if (config.icons[type]) createIcon(notificationElem, type, config);
            if (message) addElem(notificationElem, message, MESSAGE_CLASS, config);

            config.node.insertBefore(notificationElem, config.node.firstChild);
        }
        messageList[hash].id = setTimeout(() => {
            config.animation(notificationElem, cb);
            messageList[hash].node = null;
        }, timeout || config.timeout);

        if (cb) cb();
        return this;
    },
    init(aConfig) {
        const newConfig = {};
        Object.assign(newConfig, config);
        Object.assign(newConfig, aConfig);
        this.config = newConfig;

        const cssStr = makeCss(newConfig.style);
        appendStyles(cssStr);

        newConfig.node.id = CONTAINER_CLASS;
        newConfig.node.className = CONTAINER_CLASS;
        newConfig.appendTarget.appendChild(newConfig.node);

        Object.keys(newConfig.types).forEach((v) => {
            this[newConfig.types[v]] = function (message, title, timeout, cb, config) {
                this.showMessage(message, title, newConfig.types[v], timeout, cb, config);
                return this;
            }.bind(this);
        });

        this.isInitialised = true;

        return this;
    },
    setIcon(type, nodeType = "i", attrs = []) {
        attrs.class = attrs.class ? attrs.class + " " + ICON_CLASS : ICON_CLASS;

        this.config.icons[type] = {
            nodeType,
            attrs,
        };
    },
};

const defaultConfig = {
    timeout: 3000,
    style: {},
};

miniToastr.setIcon("error", "i", { class: "hb_icon_toast_failed color-down" });
miniToastr.setIcon("success", "i", { class: "hb_icon_toast_success color-up" });
miniToastr.setIcon("info", "i", { class: "hb_icon_info_normal" });
const toast = miniToastr.init(defaultConfig);
/* harmony default export */ __webpack_exports__["default"] = (toast);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
function CellGroup(_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    return react_1.default.createElement("div", { className: "hbg-cell-group ".concat(className) }, children);
}
exports.default = (0, react_1.memo)(CellGroup);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "top", function() { return /* reexport */ enums_top; });
__webpack_require__.d(__webpack_exports__, "bottom", function() { return /* reexport */ bottom; });
__webpack_require__.d(__webpack_exports__, "right", function() { return /* reexport */ right; });
__webpack_require__.d(__webpack_exports__, "left", function() { return /* reexport */ left; });
__webpack_require__.d(__webpack_exports__, "auto", function() { return /* reexport */ auto; });
__webpack_require__.d(__webpack_exports__, "basePlacements", function() { return /* reexport */ basePlacements; });
__webpack_require__.d(__webpack_exports__, "start", function() { return /* reexport */ start; });
__webpack_require__.d(__webpack_exports__, "end", function() { return /* reexport */ end; });
__webpack_require__.d(__webpack_exports__, "clippingParents", function() { return /* reexport */ enums_clippingParents; });
__webpack_require__.d(__webpack_exports__, "viewport", function() { return /* reexport */ viewport; });
__webpack_require__.d(__webpack_exports__, "popper", function() { return /* reexport */ enums_popper; });
__webpack_require__.d(__webpack_exports__, "reference", function() { return /* reexport */ enums_reference; });
__webpack_require__.d(__webpack_exports__, "variationPlacements", function() { return /* reexport */ variationPlacements; });
__webpack_require__.d(__webpack_exports__, "placements", function() { return /* reexport */ enums_placements; });
__webpack_require__.d(__webpack_exports__, "beforeRead", function() { return /* reexport */ beforeRead; });
__webpack_require__.d(__webpack_exports__, "read", function() { return /* reexport */ read; });
__webpack_require__.d(__webpack_exports__, "afterRead", function() { return /* reexport */ afterRead; });
__webpack_require__.d(__webpack_exports__, "beforeMain", function() { return /* reexport */ beforeMain; });
__webpack_require__.d(__webpack_exports__, "main", function() { return /* reexport */ main; });
__webpack_require__.d(__webpack_exports__, "afterMain", function() { return /* reexport */ afterMain; });
__webpack_require__.d(__webpack_exports__, "beforeWrite", function() { return /* reexport */ beforeWrite; });
__webpack_require__.d(__webpack_exports__, "write", function() { return /* reexport */ write; });
__webpack_require__.d(__webpack_exports__, "afterWrite", function() { return /* reexport */ afterWrite; });
__webpack_require__.d(__webpack_exports__, "modifierPhases", function() { return /* reexport */ modifierPhases; });
__webpack_require__.d(__webpack_exports__, "applyStyles", function() { return /* reexport */ modifiers_applyStyles; });
__webpack_require__.d(__webpack_exports__, "arrow", function() { return /* reexport */ modifiers_arrow; });
__webpack_require__.d(__webpack_exports__, "computeStyles", function() { return /* reexport */ modifiers_computeStyles; });
__webpack_require__.d(__webpack_exports__, "eventListeners", function() { return /* reexport */ eventListeners; });
__webpack_require__.d(__webpack_exports__, "flip", function() { return /* reexport */ modifiers_flip; });
__webpack_require__.d(__webpack_exports__, "hide", function() { return /* reexport */ modifiers_hide; });
__webpack_require__.d(__webpack_exports__, "offset", function() { return /* reexport */ modifiers_offset; });
__webpack_require__.d(__webpack_exports__, "popperOffsets", function() { return /* reexport */ modifiers_popperOffsets; });
__webpack_require__.d(__webpack_exports__, "preventOverflow", function() { return /* reexport */ modifiers_preventOverflow; });
__webpack_require__.d(__webpack_exports__, "popperGenerator", function() { return /* reexport */ popperGenerator; });
__webpack_require__.d(__webpack_exports__, "detectOverflow", function() { return /* reexport */ detectOverflow; });
__webpack_require__.d(__webpack_exports__, "createPopperBase", function() { return /* reexport */ createPopper_createPopper; });
__webpack_require__.d(__webpack_exports__, "createPopper", function() { return /* reexport */ popper_createPopper; });
__webpack_require__.d(__webpack_exports__, "createPopperLite", function() { return /* reexport */ popper_lite_createPopper; });

// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var enums_clippingParents = 'clippingParents';
var viewport = 'viewport';
var enums_popper = 'popper';
var enums_reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var arrow_toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = arrow_toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function eventListeners_effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: eventListeners_effect,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums_clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums_popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === enums_popper ? enums_reference : enums_popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === enums_popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums_popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset_offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset_offset
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets_popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets_popperOffsets,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/index.js









// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper_createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var popper_defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: popper_defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper-lite.js





var popper_lite_defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles];
var popper_lite_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: popper_lite_defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/index.js

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createDetectElementResize; });
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-in.json": 106,
	"./en-us.json": 107,
	"./es-es.json": 108,
	"./es-la.json": 109,
	"./fr-fr.json": 110,
	"./id-id.json": 111,
	"./it-it.json": 112,
	"./pt-pt.json": 113,
	"./ru-ru.json": 114,
	"./tr-tr.json": 115,
	"./uk-ua.json": 116,
	"./vi-vi.json": 117,
	"./zh-cn.json": 118,
	"./zh-hk.json": 119,
	"./zh-tc.json": 120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;

/***/ }),
/* 106 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Crypto FAQ\",\"做市商申请\":\"Market Maker Application\",\"火币网-领先的比特币交易平台\":\"HTX - Leading Bitcoin Exchange\",\"工具\":\"Tools\",\"客户端下载\":\"Download App\",\"API文档\":\"API Docs\",\"数字资产介绍\":\"Introduction to Cryptocurrencies\",\"官方验证通道\":\"Official Media Authenticator\",\"Huobi Blog\":\"HTX Blog\",\"历史数据下载\":\"Download Data History\",\"邀请奖励\":\"Referral\",\"服务\":\"Services\",\"费率\":\"Fee Rate\",\"交易规则介绍\":\"Trading Rules\",\"借币额度\":\"Coin Loan Limit\",\"帮助中心\":\"Support\",\"Global CEO 信箱\":\"Contact Global CEO\",\"新手指南\":\"Guide\",\"合约课堂\":\"Futures Academy\",\"法币XXX\":\"FiatXXX\",\"杠杆介绍\":\"Introduction of Margin\",\"HT介绍\":\"Introduction of HT\",\"支持\":\"Support\",\"上币申请\":\"Token Listing\",\"机构服务\":\"Institutional Services\",\"大客户权益\":\"Key Client Privileges\",\"经纪商\":\"Broker Program\",\"广告方加V认证申请\":\"P2P V-Advertiser Application\",\"火币集团\":\"HTX\",\"超级返佣\":\"Affiliate\",\"条款说明\":\"Terms of Service\",\"用户协议\":\"User Agreement\",\"隐私条款\":\"Privacy Policy\",\"执法和监管查询\":\"Enforcement and Regulatory Enquiry\",\"法币交易规则\":\"Fiat Rules\",\"关于反洗钱\":\"Anti-Money Laundering\",\"加密介绍\":\"Crypto Introduction\",\"首页\":\"Home\",\"火币合约\":\"HTX Futures\",\"买币\":\"Buy Crypto\",\"行情\":\"Markets\",\"币币交易\":\"Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Log in\",\"注册\":\"Sign up\",\"资产\":\"Assets\",\"现货账户（充币&提币）\":\"Spot Account (deposit & withdraw)\",\"币币账户\":\"Exchange Account\",\"杠杆账户\":\"Margin Account\",\"法币账户\":\"Fiat Account\",\"合约账户\":\"Futures Account\",\"矿池账户\":\"Pool\",\"我的点卡\":\"My Point Cards\",\"信用卡买币\":\"Buy With Credit Card\",\"订单\":\"Orders\",\"现货&杠杆订单\":\"Spot & Margin\",\"法币订单\":\"Fiat\",\"合约订单\":\"Futures\",\"账户&安全\":\"Account & Security\",\"身份认证\":\"Identification\",\"提高账户安全\":\"Improve account security\",\"法币设置\":\"Fiat Settings\",\"费率设置\":\"Fee Settings\",\"专业费率重磅升级\":\"Fee promotion\",\"我的优惠券\":\"My Coupons\",\"积分中心\":\"Loyalty Club\",\"邀请返佣\":\"Referral\",\"API管理\":\"API Management\",\"子账号\":\"Sub-account\",\"退出\":\"Sign Out\",\"交易所\":\"Exchange\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Korea\",\"火币日本\":\"HTX Japan\",\"集团生态服务\":\"HTX ecosystem services\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"HTX Ecosystem Fund\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX Fiat\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Select the seller with the best offers\",\"一键买卖\":\"Quick Buy/Sell\",\"快捷安全的数字资产交易\":\"Fast and safe cryptocurrency transactions\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Token-to-token exchange, zero fees, no slippage\",\"杠杆交易\":\"Margin\",\"借币增加本金，放大收益\":\"Multiply your profits with leverage\",\"策略交易\":\"Trading Bot\",\"7×24小时自动低买高卖\":\"Automatically buy low and sell high 24/7\",\"场外大宗交易\":\"Brokerage (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Leading platform for OTC block trades and lending services\",\"合约交易\":\"Futures\",\"合约总览\":\"Futures Overview\",\"查看全部数字货币衍生产品\":\"View all crypto derivatives at a glance\",\"币本位交割\":\"Coin-M Delivery\",\"每日结算，强大的风控实力支持\":\"Intraday settlement, supported by our strong risk control framework\",\"币本位永续\":\"Coin-M Perpetual\",\"担保资产价值稳定，减少持仓风险\":\"Stable asset valuation with less risks\",\"U本位合约\":\"USDT-M Futures\",\"返佣高达60%\":\"Up to 60% commissions\",\"期权\":\"Options\",\"多种玩法，自由做多做空\":\"Go long or short, trade as you see fit\",\"金融业务\":\"Finance\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Vote and enjoy high rewards\",\"锁仓更简单，免费领空投\":\"Lock your tokens easily and enjoy free airdrops\",\"波卡平行链插槽竞拍\":\"Polkadot parachain slot auction\",\"一键挖矿，日日增收\":\"Deposit with just one click and earn interests every day\",\"ETH2.0，一键换币\":\"Convert tokens with just one click\",\"质押借币\":\"Crypto Loans\",\"数字资产，尊享急速到账体验\":\"Enjoy swift transfer of your cryptocurrency\",\"双币投资\":\"Dual Investment\",\"掌握价格波动，财富稳定增值\":\"Appreciate your assets amid volatile markets\",\"资产总览\":\"Assets Overview\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Crypto Loans\",\"期权账户\":\"Options Account\",\"限量优惠\":\"Limited privileges\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Strategy\",\"存币宝订单\":\"Savings Order\",\"质押借币订单\":\"Crypto Loans\",\"返佣收益看板\":\"Referral Dashboard\",\"站内信\":\"Message\",\"查看全部\":\"View all\",\"暂无最新消息\":\"No updates\",\"隐藏已读\":\"Hide read\",\"全部标为已读\":\"All marked as read\",\"扫码下载 APP\":\"Scan to Download App\",\"更多客户端\":\"More options\",\"语言\":\"Language\",\"折算货币\":\"Currency\",\"提示\":\"Reminder\",\"确认将全部未读消息标记为已读？\":\"Are you sure to mark all unread messages as read?\",\"了解VIP\":\"Know more about VIP\",\"精英会员\":\"Advanced\",\"银卡VIP\":\"Insider\",\"金卡VIP\":\"Premier\",\"白金卡VIP\":\"Ambassador\",\"黑卡VIP\":\"Partner\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Welcome to HTX. You're enjoying the HTX %s privileges.\",\"取消\":\"Cancel\",\"确定\":\"Confirm\",\"快捷一键买卖\":\"Quick Buy/Sell\",\"法币充值\":\"Fiat Deposit\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Third Party\",\"自选\":\"Favorites\",\"现货\":\"Spot\",\"合约\":\"Futures\",\"全仓杠杆\":\"Cross Margin\",\"逐仓杠杆\":\"Isolated Margin\",\"Tradingbot 策略交易\":\"Trading Bot\",\"期权交易\":\"Options\",\"理财相关\":\"Investment-related\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Others\",\"节点质押投票\":\"Staking & Voting\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Brokerage (Lending)\",\"OTC交易系统\":\"Brokerage (OTC)\",\"我的资产\":\"My Assets\",\"我的订单\":\"My Orders\",\"消息\":\"Message\",\"我的福利\":\"My Rewards\",\"邀请返佣看板\":\"Referral Dashboard\",\"账户安全\":\"Security\",\"子账号管理\":\"Sub-Account Management\",\"扫码下载 huobi App\":\"Scan to download App\",\"更多方式\":\"More methods\",\"升级还需要现货交易<span>#num#U</span>\":\"Trade <span>#num# USDT</span> more in Spot Trading to level up\",\"升级还需要合约交易<span>#num#U</span>\":\"Trade <span>#num# USDT</span> more in Futures to level up\",\"升级还需要资沉<span>#num#U</span>\":\"Deposit <span>#num# USDT</span> more to level up\",\"手续费#num#折\":\"#num# off in trading fee\",\"HT抵扣#num#%\":\"#num#% off with HT\",\"生日好礼\":\"Birthday Gift\",\"杠杆\":\"Margin\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Welcome to HTX\",\"There will be more exciting after login\":\"More surprises await you after logging in!\",\"全部资产\":\"Total Assets\",\"Today’s P/L\":\"Today's P/L\",\"点击查看\":\"Click to view\",\"下载App\":\"Download App\",\"退出登录\":\"Log out\",\"关于火币\":\"About HTX\",\"关于我们\":\"About Us\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Cryptocurrencies\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Contact CEO\",\"官网验证通道\":\"Media Verifier\",\"产品功能\":\"Products\",\"一键买币\":\"Quick Buy/Sell\",\"TradingBot\":\"Trading Bot\",\"金融服务\":\"Finance\",\"火币社区\":\"HTX Community\",\"服务介绍\":\"Services\",\"认证服务\":\"Identity Verification\",\"费率介绍\":\"Tiered Fee\",\"币币交易规则\":\"Spot Trading Rules\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Affiliate Program\",\"经纪商申请\":\"Broker Program\",\"广告方认证服务\":\"P2P V-Advertiser Application\",\"开放平台\":\"Open Platform\",\"API介绍\":\"API Documentation\",\"活动福利\":\"Events & Benefits\",\"新用户奖励\":\"Welcome Bonus\",\"入金奖励\":\"Deposit Rewards\",\"交易奖励\":\"Trading Rewards\",\"免费领空投\":\"Get Airdrops\",\"月度大促\":\"Monthly Promotions\",\"购买加密货币\":\"Buy Cryptos\",\"未认证\":\"Unverified\",\"合约跟单\":\"Copy Trading\",\"福利中心\":\"Rewards Hub\",\"机构\":\"Institution\",\"快捷买币\":\"Quick Trade\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Buy virtual assets with Visa, Mastercard, and more\",\"满足低手续费多种法币的充值\":\"Deposit fiat currencies at a low fee\",\"多种法币0手续费最优价格\":\"Match the best price with zero fees\",\"自选交易对，行情尽在掌握\":\"Monitor your favorite trading pairs in real time\",\"直达现货市场，抓住交易机会\":\"Seize trading opportunities with Spot Markets\",\"了解合约行情动态，获取超额收益\":\"Earn oversized returns with Futures Markets\",\"交易\":\"Trade\",\"使用完整的交易功能，买卖虚拟资产\":\"Trade virtual assets with our advanced tools\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Increase your leverage with no liquidation risks\",\"借币交易，放大现货收益\":\"Use leverage to amplify your profits\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Trade automatically with quant strategies\",\"火币闪兑\":\"Convert\",\"币币兑换，零费率无滑点\":\"Crypto-to-crypto swap, zero fees, no slippage\",\"衍生品\":\"Derivatives\",\"以USDT结算的合约交易\":\"Futures products settled in USDT\",\"币本位合约\":\"Coin-M Futures\",\"以加密货币结算的合约交易\":\"Futures products settled in cryptocurrencies\",\"欧式美式期权随心选择，财富稳定增值\":\"European and American-style options to multiply your assets\",\"自动跟随专业交易员下单，轻松盈利\":\"Trade like an expert by following their trades\",\"Huobi合约嘉年华\":\"Futures Carnival\",\"参加交易 iPhone14Pro Max等你拿\":\"Trade to win iPhone 14 Pro Max and more\",\"理财_menu\":\"Earn\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Earn passive income on your virtual assets\",\"非保本高额收益结构型理财\":\"Structured product with enhanced yields\",\"便捷抵押，安全交易\":\"Quick crypto loans to satisfy your trading needs\",\"扩大交易规模和种类，实现多倍收益\":\"Borrow to scale up your trades and profits\",\"金融服务_menu\":\"Finance\",\"迎接以太坊2.0\":\"A new era for Ethereum\",\"随借随还实时到账\":\"Borrow and repay easily anytime\",\"尊享大宗交易零手续费\":\"Make block trades with zero fees\",\"社区\":\"Community\",\"Huobi社区\":\"HTX Community\",\"在这里发现币圈财富机会\":\"Explore and uncover wealth opportunities\",\"快讯\":\"News\",\"7*24最全币圈资讯\":\"Latest crypto news at your fingertips\",\"长文\":\"Article\",\"深入了解最新行业动态\":\"Dive deep for crypto insights\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Tune in to all things crypto\",\"从入门到精通一站式学习平台\":\"Learn, trade, and earn\",\"博客\":\"HTX Blog\",\"Huobi最新资讯和业务报道\":\"Get updated with the latest stories and reports\",\"活动\":\"Activities\",\"轻松赚币，天天领奖\":\"Win cryptos and other rewards every day\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Discover the next big crypto project\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Unbox fun and great prizes\",\"交易赛\":\"Trading Competition\",\"牛人大师都爱的大赛\":\"Trade your way up to the leaderboard\",\"通往Web 3.0的虚拟资产钱包\":\"A global virtual asset wallet and gateway to Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi made easy with cloud storage of private keys\",\"场外借贷\":\"OTC Loan\",\"我的费率\":\"My Fee Rates\",\"我的邀请返佣\":\"My Referrals\",\"合约社群\":\"HTX Futures Community\",\"经纪商看板\":\"Broker Dashboard\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Content\",\"多米尼克数字公民\":\"Dominica Digital Citizenship\",\"体验\":\"Trial\",\"正式\":\"Formal\",\"高级\":\"Advanced\",\"Prime会员权益\":\"Prime Membership Benefits\",\"体验卡\":\"Trial\",\"查看权益\":\"View Benefits\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Appearance\",\"专业版\":\"Pro\",\"经典版\":\"Classic\",\"颜色偏好\":\"Color Preference\",\"绿涨红跌\":\"Green up/Red down\",\"红涨绿跌\":\"Red up/Green down\",\"储备金证明\":\"Proof of Reserves\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Use balances in Earn to trade\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"By enabling this feature, your available assets for spot trading will be displayed as a sum of the available balance of the quote currency in your Spot account with no borrowings and that of the quote currency in the Earn - Flexible product. The balance of the current crypto in the Flexible product will only be auto-redeemed when necessary for spot trading.\",\"行情资讯\":\"Markets\",\"HTX专区\":\"$HTX Zone\",\"一键收取HTX\":\"Claim $HTX\",\"任务奖励日日解锁\":\"Unlock task rewards daily\",\"加密货币价格\":\"Cryptocurrency Prices\",\"搜索\":\"Search\",\"热门资产\":\"Popular Assets\",\"热门话题\":\"Trending\",\"热门赚币\":\"Hot Yields\",\"全部\":\"All\",\"功能\":\"Features\",\"资讯\":\"News\",\"公告\":\"Announcements\",\"用户\":\"Users\",\"#num#预约\":\"#num# subscribed\",\"#num#观看\":\"#num# watching\",\"#num#回放\":\"#num# replayed\",\"预约\":\"Subscribe\",\"看直播\":\"Watch Live\",\"看回放\":\"Replay\",\"暂无内容\":\"No content available\",\"永续\":\"Perpetual\",\"当周\":\"Weekly\",\"次周\":\"Bi-weekly\",\"当季\":\"Quarterly\",\"次季\":\"Bi-Quarterly\",\"#num#粉丝\":\"#num# Followers\",\"关注\":\"Follow\",\"已关注\":\"Following\",\"站点地图\":\"Cryptocurrency Sitemap\",\"相机扫码下载<p>火币App</p>\":\"Point your camera at QR code <p>to get HTX App</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Deposit\",\"提币\":\"Withdraw\",\"划转\":\"Transfer\",\"储备金证明报告\":\"PoR Reports\",\"切换账号\":\"Switch\",\"提醒\":\"Note\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"After deleting the account along with its login records, you will need to enter the password the next time you log in to this account.\",\"确认\":\"Confirm\",\"其他账号\":\"Other Main Accounts\",\"管理\":\"Manage\",\"完成\":\"Done\",\"搜索子账号\":\"Search\",\"暂无数据\":\"No sub-accounts yet\",\"创建子账号\":\"Create\",\"清除\":\"Delete\",\"添加其他账号\":\"Add\",\"主账号\":\"Main Account\",\"最多添加10个其他账号，请清除后再添加\":\"Up to 10 accounts can be added here. Please delete an account before adding one.\",\"我知道了\":\"Got it\",\"我的邀请奖励\":\"My Referrals\",\"复制成功\":\"Copied\",\"交易机器人\":\"Trading Bots\",\"借币\":\"Loans\",\"充值&提现状态\":\"Deposit & Withdrawal Status\"}");

/***/ }),
/* 107 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Crypto FAQ\",\"做市商申请\":\"Market Maker Application\",\"火币网-领先的比特币交易平台\":\"HTX - Leading Bitcoin Exchange\",\"工具\":\"Tools\",\"客户端下载\":\"Download App\",\"API文档\":\"API Docs\",\"数字资产介绍\":\"Introduction to Cryptocurrencies\",\"官方验证通道\":\"Official Media Authenticator\",\"Huobi Blog\":\"HTX Blog\",\"历史数据下载\":\"Download Data History\",\"邀请奖励\":\"Referral\",\"服务\":\"Services\",\"Buy HUSD\":\"Buy HUSD\",\"费率\":\"Fee Rate\",\"交易规则介绍\":\"Trading Rules\",\"借币额度\":\"Coin Loan Limit\",\"帮助中心\":\"Support\",\"Global CEO 信箱\":\"Contact Global CEO\",\"新手指南\":\"Guide\",\"合约课堂\":\"Futures Academy\",\"iToken\":\"iToken\",\"法币XXX\":\"FiatXXX\",\"杠杆介绍\":\"Introduction of Margin\",\"HT介绍\":\"Introduction of HT\",\"支持\":\"Support\",\"上币申请\":\"Token Listing\",\"机构服务\":\"Institutional Services\",\"大客户权益\":\"Key Client Privileges\",\"经纪商\":\"Broker Program\",\"广告方加V认证申请\":\"P2P V-Advertiser Application\",\"火币集团\":\"HTX\",\"Web3 Scholarship\":\"Web3 Scholarship\",\"超级返佣\":\"Affiliate\",\"条款说明\":\"Terms of Service\",\"用户协议\":\"User Agreement\",\"隐私条款\":\"Privacy Policy\",\"执法和监管查询\":\"Enforcement and Regulatory Enquiry\",\"法币交易规则\":\"Fiat Rules\",\"关于反洗钱\":\"Anti-Money Laundering\",\"加密介绍\":\"Crypto Introduction\",\"首页\":\"Home\",\"火币合约\":\"HTX Futures\",\"OTC Market\":\"OTC Market\",\"买币\":\"Buy Crypto\",\"行情\":\"Markets\",\"币币交易\":\"Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Log in\",\"注册\":\"Sign up\",\"资产\":\"Assets\",\"现货账户（充币&提币）\":\"Spot Account (deposit & withdraw)\",\"币币账户\":\"Exchange Account\",\"杠杆账户\":\"Margin Account\",\"法币账户\":\"Fiat Account\",\"合约账户\":\"Futures Account\",\"矿池账户\":\"Pool\",\"我的点卡\":\"My Point Cards\",\"信用卡买币\":\"Buy With Credit Card\",\"订单\":\"Orders\",\"现货&杠杆订单\":\"Spot & Margin\",\"法币订单\":\"Fiat\",\"合约订单\":\"Futures\",\"Buy&Sell History\":\"Buy&Sell History\",\"账户&安全\":\"Account & Security\",\"身份认证\":\"Identification\",\"提高账户安全\":\"Improve account security\",\"法币设置\":\"Fiat Settings\",\"费率设置\":\"Fee Settings\",\"专业费率重磅升级\":\"Fee promotion\",\"我的优惠券\":\"My Coupons\",\"积分中心\":\"Loyalty Club\",\"邀请返佣\":\"Referral\",\"API管理\":\"API Management\",\"子账号\":\"Sub-account\",\"退出\":\"Sign Out\",\"交易所\":\"Exchange\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Korea\",\"火币日本\":\"HTX Japan\",\"集团生态服务\":\"HTX ecosystem services\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"HTX Ecosystem Fund\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX Fiat\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Select the seller with the best offers\",\"一键买卖\":\"Quick Buy/Sell\",\"快捷安全的数字资产交易\":\"Fast and safe cryptocurrency transactions\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Token-to-token exchange, zero fees, no slippage\",\"杠杆交易\":\"Margin\",\"借币增加本金，放大收益\":\"Multiply your profits with leverage\",\"策略交易\":\"Trading Bot\",\"7×24小时自动低买高卖\":\"Automatically buy low and sell high 24/7\",\"场外大宗交易\":\"Brokerage (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Leading platform for OTC block trades and lending services\",\"合约交易\":\"Futures\",\"合约总览\":\"Futures Overview\",\"查看全部数字货币衍生产品\":\"View all crypto derivatives at a glance\",\"币本位交割\":\"Coin-M Delivery\",\"每日结算，强大的风控实力支持\":\"Intraday settlement, supported by our strong risk control framework\",\"币本位永续\":\"Coin-M Perpetual\",\"担保资产价值稳定，减少持仓风险\":\"Stable asset valuation with less risks\",\"U本位合约\":\"USDT-M Futures\",\"返佣高达60%\":\"Up to 60% commissions\",\"期权\":\"Options\",\"多种玩法，自由做多做空\":\"Go long or short, trade as you see fit\",\"金融业务\":\"Finance\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Vote and enjoy high rewards\",\"锁仓更简单，免费领空投\":\"Lock your tokens easily and enjoy free airdrops\",\"Polkadot Slot Auction\":\"Polkadot Slot Auction\",\"波卡平行链插槽竞拍\":\"Polkadot parachain slot auction\",\"一键挖矿，日日增收\":\"Deposit with just one click and earn interests every day\",\"ETH 2.0\":\"ETH 2.0\",\"ETH2.0，一键换币\":\"Convert tokens with just one click\",\"质押借币\":\"Crypto Loans\",\"数字资产，尊享急速到账体验\":\"Enjoy swift transfer of your cryptocurrency\",\"双币投资\":\"Dual Investment\",\"掌握价格波动，财富稳定增值\":\"Appreciate your assets amid volatile markets\",\"The Gateway to Web 3.0\":\"The Gateway to Web 3.0\",\"Learn\":\"Learn\",\"Rewards Hub\":\"Rewards Hub\",\"资产总览\":\"Assets Overview\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Crypto Loans\",\"期权账户\":\"Options Account\",\"限量优惠\":\"Limited privileges\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Strategy\",\"存币宝订单\":\"Savings Order\",\"质押借币订单\":\"Crypto Loans\",\"返佣收益看板\":\"Referral Dashboard\",\"站内信\":\"Message\",\"查看全部\":\"View all\",\"暂无最新消息\":\"No updates\",\"隐藏已读\":\"Hide read\",\"全部标为已读\":\"All marked as read\",\"扫码下载 APP\":\"Scan to Download App\",\"更多客户端\":\"More options\",\"语言\":\"Language\",\"折算货币\":\"Currency\",\"提示\":\"Reminder\",\"确认将全部未读消息标记为已读？\":\"Are you sure to mark all unread messages as read?\",\"了解VIP\":\"Know more about VIP\",\"精英会员\":\"Advanced\",\"银卡VIP\":\"Insider\",\"金卡VIP\":\"Premier\",\"白金卡VIP\":\"Ambassador\",\"黑卡VIP\":\"Partner\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Welcome to HTX. You're enjoying the HTX %s privileges.\",\"取消\":\"Cancel\",\"确定\":\"Confirm\",\"快捷一键买卖\":\"Quick Buy/Sell\",\"法币充值\":\"Fiat Deposit\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Third Party\",\"自选\":\"Favorites\",\"现货\":\"Spot\",\"合约\":\"Futures\",\"全仓杠杆\":\"Cross Margin\",\"逐仓杠杆\":\"Isolated Margin\",\"Tradingbot 策略交易\":\"Trading Bot\",\"期权交易\":\"Options\",\"理财相关\":\"Investment-related\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Others\",\"节点质押投票\":\"Staking & Voting\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Brokerage (Lending)\",\"OTC交易系统\":\"Brokerage (OTC)\",\"我的资产\":\"My Assets\",\"我的订单\":\"My Orders\",\"消息\":\"Message\",\"我的福利\":\"My Rewards\",\"邀请返佣看板\":\"Referral Dashboard\",\"账户安全\":\"Security\",\"子账号管理\":\"Sub-Account Management\",\"扫码下载 huobi App\":\"Scan to download App\",\"更多方式\":\"More methods\",\"升级还需要现货交易<span>#num#U</span>\":\"Trade <span>#num# USDT</span> more in Spot Trading to level up\",\"升级还需要合约交易<span>#num#U</span>\":\"Trade <span>#num# USDT</span> more in Futures to level up\",\"升级还需要资沉<span>#num#U</span>\":\"Deposit <span>#num# USDT</span> more to level up\",\"手续费#num#折\":\"#num# off in trading fee\",\"HT抵扣#num#%\":\"#num#% off with HT\",\"生日好礼\":\"Birthday Gift\",\"杠杆\":\"Margin\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Welcome to HTX\",\"There will be more exciting after login\":\"More surprises await you after logging in!\",\"全部资产\":\"Total Assets\",\"Today’s P/L\":\"Today's P/L\",\"P/L\":\"P/L\",\"点击查看\":\"Click to view\",\"下载App\":\"Download App\",\"退出登录\":\"Log out\",\"关于火币\":\"About HTX\",\"关于我们\":\"About Us\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Cryptocurrencies\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Contact CEO\",\"官网验证通道\":\"Media Verifier\",\"产品功能\":\"Products\",\"一键买币\":\"Quick Buy/Sell\",\"TradingBot\":\"Trading Bot\",\"金融服务\":\"Finance\",\"火币社区\":\"HTX Community\",\"NFT\":\"NFT\",\"服务介绍\":\"Services\",\"认证服务\":\"Identity Verification\",\"费率介绍\":\"Tiered Fee\",\"币币交易规则\":\"Spot Trading Rules\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Affiliate Program\",\"经纪商申请\":\"Broker Program\",\"广告方认证服务\":\"P2P V-Advertiser Application\",\"开放平台\":\"Open Platform\",\"API介绍\":\"API Documentation\",\"活动福利\":\"Events & Benefits\",\"新用户奖励\":\"Welcome Bonus\",\"入金奖励\":\"Deposit Rewards\",\"交易奖励\":\"Trading Rewards\",\"免费领空投\":\"Get Airdrops\",\"月度大促\":\"Monthly Promotions\",\"购买加密货币\":\"Buy Cryptos\",\"矿池\":\"矿池\",\"未认证\":\"Unverified\",\"合约跟单\":\"Copy Trading\",\"福利中心\":\"Rewards Hub\",\"机构\":\"Institution\",\"快捷买币\":\"Quick Trade\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Buy virtual assets with Visa, Mastercard, and more\",\"满足低手续费多种法币的充值\":\"Deposit fiat currencies at a low fee\",\"P2P\":\"P2P\",\"多种法币0手续费最优价格\":\"Match the best price with zero fees\",\"自选交易对，行情尽在掌握\":\"Monitor your favorite trading pairs in real time\",\"直达现货市场，抓住交易机会\":\"Seize trading opportunities with Spot Markets\",\"了解合约行情动态，获取超额收益\":\"Earn oversized returns with Futures Markets\",\"交易\":\"Trade\",\"使用完整的交易功能，买卖虚拟资产\":\"Trade virtual assets with our advanced tools\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Increase your leverage with no liquidation risks\",\"借币交易，放大现货收益\":\"Use leverage to amplify your profits\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Trade automatically with quant strategies\",\"火币闪兑\":\"Convert\",\"币币兑换，零费率无滑点\":\"Crypto-to-crypto swap, zero fees, no slippage\",\"衍生品\":\"Derivatives\",\"以USDT结算的合约交易\":\"Futures products settled in USDT\",\"币本位合约\":\"Coin-M Futures\",\"以加密货币结算的合约交易\":\"Futures products settled in cryptocurrencies\",\"欧式美式期权随心选择，财富稳定增值\":\"European and American-style options to multiply your assets\",\"自动跟随专业交易员下单，轻松盈利\":\"Trade like an expert by following their trades\",\"Huobi合约嘉年华\":\"Futures Carnival\",\"参加交易 iPhone14Pro Max等你拿\":\"Trade to win iPhone 14 Pro Max and more\",\"理财_menu\":\"Earn\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Earn passive income on your virtual assets\",\"非保本高额收益结构型理财\":\"Structured product with enhanced yields\",\"便捷抵押，安全交易\":\"Quick crypto loans to satisfy your trading needs\",\"扩大交易规模和种类，实现多倍收益\":\"Borrow to scale up your trades and profits\",\"金融服务_menu\":\"Finance\",\"迎接以太坊2.0\":\"A new era for Ethereum\",\"随借随还实时到账\":\"Borrow and repay easily anytime\",\"尊享大宗交易零手续费\":\"Make block trades with zero fees\",\"社区\":\"Community\",\"Huobi社区\":\"HTX Community\",\"在这里发现币圈财富机会\":\"Explore and uncover wealth opportunities\",\"快讯\":\"News\",\"7*24最全币圈资讯\":\"Latest crypto news at your fingertips\",\"长文\":\"Article\",\"深入了解最新行业动态\":\"Dive deep for crypto insights\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Tune in to all things crypto\",\"从入门到精通一站式学习平台\":\"Learn, trade, and earn\",\"博客\":\"HTX Blog\",\"Huobi最新资讯和业务报道\":\"Get updated with the latest stories and reports\",\"活动\":\"Activities\",\"轻松赚币，天天领奖\":\"Win cryptos and other rewards every day\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Discover the next big crypto project\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Unbox fun and great prizes\",\"交易赛\":\"Trading Competition\",\"牛人大师都爱的大赛\":\"Trade your way up to the leaderboard\",\"Web 3.0\":\"Web 3.0\",\"通往Web 3.0的虚拟资产钱包\":\"A global virtual asset wallet and gateway to Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi made easy with cloud storage of private keys\",\"场外借贷\":\"OTC Loan\",\"NewListing\":\"NewListing\",\"我的费率\":\"My Fee Rates\",\"我的邀请返佣\":\"My Referrals\",\"合约社群\":\"HTX Futures Community\",\"经纪商看板\":\"Broker Dashboard\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Content\",\"多米尼克数字公民\":\"Dominica Digital Citizenship\",\"体验\":\"Trial\",\"正式\":\"Formal\",\"高级\":\"Advanced\",\"Prime会员权益\":\"Prime Membership Benefits\",\"体验卡\":\"Trial\",\"查看权益\":\"View Benefits\",\"Global Licensed Businesses\":\"Global Licensed Businesses\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Appearance\",\"专业版\":\"Pro\",\"经典版\":\"Classic\",\"颜色偏好\":\"Color Preference\",\"绿涨红跌\":\"Green up/Red down\",\"红涨绿跌\":\"Red up/Green down\",\"扫码添加\":\"扫码添加\",\"官方微信：\":\"官方微信：\",\"官方QQ：\":\"官方QQ：\",\"储备金证明\":\"Proof of Reserves\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Use balances in Earn to trade\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"By enabling this feature, your available assets for spot trading will be displayed as a sum of the available balance of the quote currency in your Spot account with no borrowings and that of the quote currency in the Earn - Flexible product. The balance of the current crypto in the Flexible product will only be auto-redeemed when necessary for spot trading.\",\"行情资讯\":\"Markets\",\"HTX专区\":\"$HTX Zone\",\"一键收取HTX\":\"Claim $HTX\",\"任务奖励日日解锁\":\"Unlock task rewards daily\",\"加密货币价格\":\"Cryptocurrency Prices\",\"搜索\":\"Search\",\"热门资产\":\"Popular Assets\",\"热门话题\":\"Trending\",\"热门赚币\":\"Hot Yields\",\"全部\":\"All\",\"功能\":\"Features\",\"资讯\":\"News\",\"公告\":\"Announcements\",\"用户\":\"Users\",\"#num#预约\":\"#num# subscribed\",\"#num#观看\":\"#num# watching\",\"#num#回放\":\"#num# replayed\",\"预约\":\"Subscribe\",\"看直播\":\"Watch Live\",\"看回放\":\"Replay\",\"暂无内容\":\"No content available\",\"永续\":\"Perpetual\",\"当周\":\"Weekly\",\"次周\":\"Bi-weekly\",\"当季\":\"Quarterly\",\"次季\":\"Bi-Quarterly\",\"#num#粉丝\":\"#num# Followers\",\"关注\":\"Follow\",\"已关注\":\"Following\",\"站点地图\":\"Cryptocurrency Sitemap\",\"相机扫码下载<p>火币App</p>\":\"Point your camera at QR code <p>to get HTX App</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Deposit\",\"提币\":\"Withdraw\",\"划转\":\"Transfer\",\"储备金证明报告\":\"PoR Reports\",\"切换账号\":\"Switch\",\"提醒\":\"Note\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"After deleting the account along with its login records, you will need to enter the password the next time you log in to this account.\",\"确认\":\"Confirm\",\"其他账号\":\"Other Main Accounts\",\"管理\":\"Manage\",\"完成\":\"Done\",\"搜索子账号\":\"Search\",\"暂无数据\":\"No sub-accounts yet\",\"创建子账号\":\"Create\",\"清除\":\"Delete\",\"添加其他账号\":\"Add\",\"主账号\":\"Main Account\",\"最多添加10个其他账号，请清除后再添加\":\"Up to 10 accounts can be added here. Please delete an account before adding one.\",\"我知道了\":\"Got it\",\"我的邀请奖励\":\"My Referrals\",\"复制成功\":\"Copied\",\"交易机器人\":\"Trading Bots\",\"借币\":\"Loans\",\"充值&提现状态\":\"Deposit & Withdrawal Status\"}");

/***/ }),
/* 108 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Cripto FAQ\",\"做市商申请\":\"Solicitud de market maker\",\"火币网-领先的比特币交易平台\":\"HTX - Principal plataforma de comercio de bitcoins del mundo\",\"工具\":\"Herramientas\",\"客户端下载\":\"Descargar APP\",\"API文档\":\"Documentación APIs\",\"数字资产介绍\":\"Introducción a activos digitales\",\"官方验证通道\":\"Canal oficial de verificación\",\"历史数据下载\":\"Descargar historial de datos\",\"邀请奖励\":\"Recompensa por recomendación\",\"服务\":\"Servicios\",\"费率\":\"Comisiones\",\"交易规则介绍\":\"Normas de trading\",\"借币额度\":\"Límites de préstamos\",\"帮助中心\":\"Centro de ayuda\",\"Global CEO 信箱\":\"Contactar con CEO Global\",\"新手指南\":\"Guía para principiantes\",\"合约课堂\":\"Tutorial de Contratos\",\"法币XXX\":\"Fiat XXX\",\"杠杆介绍\":\"Introducción a Margen\",\"HT介绍\":\"Introducción a HT\",\"支持\":\"Soporte\",\"上币申请\":\"Formulario de solicitud\",\"机构服务\":\"Servicios institucionales\",\"大客户权益\":\"Privilegios de clientes VIP\",\"经纪商\":\"Agente de bolsa\",\"广告方加V认证申请\":\"Aplicación de verificación V del anunciante\",\"火币集团\":\"HTX\",\"超级返佣\":\"Afiliado\",\"条款说明\":\"Condiciones del Servicio\",\"用户协议\":\"Acuerdo de Usuario\",\"隐私条款\":\"Política de Privacidad\",\"执法和监管查询\":\"Consulta de aplicación de ley y reglamentación\",\"法币交易规则\":\"Reglas de comercio fiat\",\"关于反洗钱\":\"Sobre KYC y AML\",\"加密介绍\":\"Introducción a las Cripto\",\"首页\":\"Inicio\",\"火币合约\":\"Contratos de HTX\",\"买币\":\"Comprar cripto\",\"行情\":\"Mercado\",\"币币交易\":\"Trading Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Iniciar sesión\",\"注册\":\"Registrarse\",\"资产\":\"Activos\",\"现货账户（充币&提币）\":\"Cuenta Exchange (depósito y retiro)\",\"币币账户\":\"Cuenta de Exchange\",\"杠杆账户\":\"Cuenta de Margen\",\"法币账户\":\"Cuenta Fiat\",\"合约账户\":\"Cuenta de Contratos\",\"矿池账户\":\"Pool\",\"我的点卡\":\"Mi tarjeta de puntos\",\"信用卡买币\":\"Comprar con tarjeta de crédito\",\"订单\":\"Órdenes\",\"现货&杠杆订单\":\"Órdenes Exchange y Margen\",\"法币订单\":\"Órdenes Fiat\",\"合约订单\":\"Órdenes de Contratos\",\"账户&安全\":\"Cuenta & Seguridad\",\"身份认证\":\"Identificación\",\"法币设置\":\"Ajustes de Fiat\",\"费率设置\":\"Ajustes de comisión\",\"专业费率重磅升级\":\"Promoción en comisiones\",\"我的优惠券\":\"Mis cupones\",\"积分中心\":\"Centro de puntos\",\"邀请返佣\":\"Invitar amigos\",\"API管理\":\"Gestión de API\",\"子账号\":\"Subcuenta\",\"退出\":\"Cerrar sesión\",\"交易所\":\"Exchange\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Corea\",\"火币日本\":\"HTX Japón\",\"集团生态服务\":\"Eco Servicios de HTX\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"Fondo Ecológico HTX\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Seleccione el vendedor con las mejores ofertas\",\"一键买卖\":\"Compra/venta rápida\",\"快捷安全的数字资产交易\":\"Transacciones rápidas y seguras de activos digitales\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Intercambio de token a token, sin comisiones ni deslizamientos\",\"杠杆交易\":\"Margen\",\"借币增加本金，放大收益\":\"Multiplique sus beneficios con el apalancamiento\",\"策略交易\":\"Trading Bot\",\"7×24小时自动低买高卖\":\"Compre automáticamente a bajo precio y venda a alto precio 24/7\",\"场外大宗交易\":\"Brokerage (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Plataforma líder en tradea de bloques OTC y servicios de préstamo\",\"合约交易\":\"Contratos\",\"合约总览\":\"Resumen del contrato\",\"查看全部数字货币衍生产品\":\"Vea todos los criptoderivados de un vistazo\",\"币本位交割\":\"Coin-M Futuros\",\"每日结算，强大的风控实力支持\":\"Liquidación intradía, respaldada por nuestro sólido marco de control de riesgos\",\"币本位永续\":\"Coin-Margen Swap\",\"担保资产价值稳定，减少持仓风险\":\"Valoración estable de los activos con menos riesgos\",\"U本位合约\":\"USDT-M Contratos\",\"返佣高达60%\":\"Comisiones de hasta el 60%.\",\"期权\":\"Opciones\",\"多种玩法，自由做多做空\":\"Compre o venda, tradee como mejor le parezca\",\"金融业务\":\"Finanzas\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Vota y disfruta de grandes recompensas\",\"锁仓更简单，免费领空投\":\"Bloquea tus tokens fácilmente y disfruta de airdrops gratuitos\",\"波卡平行链插槽竞拍\":\"Subasta de tragamonedas Polkadot parachain\",\"一键挖矿，日日增收\":\"Deposita con un solo clic y gana intereses cada día\",\"ETH2.0，一键换币\":\"Convierta tokens con un solo clic\",\"质押借币\":\"Préstamos Cripto\",\"数字资产，尊享急速到账体验\":\"Disfrute de una rápida transferencia de sus activos digitales\",\"双币投资\":\"Inversión dual\",\"掌握价格波动，财富稳定增值\":\"Aprecie sus activos en medio de los mercados volátiles\",\"Learn\":\"Aprende\",\"Rewards Hub\":\"Centro de Recompensas\",\"资产总览\":\"Resumen de activos\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Préstamos de cripto\",\"期权账户\":\"Cuenta Opciones\",\"限量优惠\":\"Por tiempo limitado\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Estrategia\",\"存币宝订单\":\"Órdenes de Ahorros\",\"质押借币订单\":\"Crypto Loans\",\"返佣收益看板\":\"Panel de referencia\",\"站内信\":\"Avisos\",\"查看全部\":\"Ver todo\",\"暂无最新消息\":\"No hay nuevos avisos\",\"隐藏已读\":\"Ocultar leídos\",\"全部标为已读\":\"Marcar todo como leído\",\"扫码下载 APP\":\"Escanear QR para descargar APP\",\"更多客户端\":\"Más opciones\",\"语言\":\"Idioma\",\"折算货币\":\"Divisa\",\"提示\":\"Alerta\",\"确认将全部未读消息标记为已读？\":\"¿Confirma que marcará todos los avisos sin leer como leídos?\",\"了解VIP\":\"Sobre VIP\",\"精英会员\":\"Elite\",\"银卡VIP\":\"Insider\",\"金卡VIP\":\"Premier\",\"白金卡VIP\":\"Ambassador\",\"黑卡VIP\":\"Partner\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Bienvenido a HTX, está disfrutando de los privilegios % de HTX.\",\"取消\":\"Cancelar\",\"确定\":\"Confirmar\",\"快捷一键买卖\":\"Compra/Venta rápida\",\"法币充值\":\"Depósito Fiat\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Terceras partes\",\"自选\":\"Favoritos\",\"现货\":\"Spot\",\"合约\":\"Futuros\",\"全仓杠杆\":\"Margen cruzado\",\"逐仓杠杆\":\"Margen aislado\",\"Tradingbot 策略交易\":\"Trading Bot\",\"期权交易\":\"Opciones\",\"理财相关\":\"Relacionados con la inversión\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Otros\",\"节点质押投票\":\"Staking y Votación\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Brokerage (Préstamo)\",\"OTC交易系统\":\"Brokerage (OTC)\",\"我的资产\":\"Mis Activos\",\"我的订单\":\"Mis órdenes\",\"消息\":\"Mensaje\",\"我的福利\":\"Mis recompensas\",\"邀请返佣看板\":\"Referral Dashboard\",\"账户安全\":\"Seguridad\",\"子账号管理\":\"Gestión de subcuenta\",\"扫码下载 huobi App\":\"Escanear para descargar la aplicación\",\"更多方式\":\"Más métodos\",\"升级还需要现货交易<span>#num#U</span>\":\"Tradea <span>#num# USDT</span> más en Spot para subir de nivel\",\"升级还需要合约交易<span>#num#U</span>\":\"Tradea <span>#num# USDT</span> más en Futuros para subir de nivel\",\"升级还需要资沉<span>#num#U</span>\":\"Deposita <span>#num# USDT</span> más para subir de nivel\",\"手续费#num#折\":\"#num#menos en la tasa de tradeo\",\"HT抵扣#num#%\":\"#num#% menos con HT\",\"生日好礼\":\"Regalo de cumpleaños\",\"杠杆\":\"Margen\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Biernvenido a HTX\",\"There will be more exciting after login\":\"Te esperan más sorpresas después de iniciar la sesión.\",\"全部资产\":\"Activos totales\",\"Today’s P/L\":\"P/L de hoy\",\"点击查看\":\"Haga clic para ver\",\"下载App\":\"Descargar App\",\"退出登录\":\"Cerrar sesión\",\"关于火币\":\"Sobre HTX\",\"关于我们\":\"Sobre Nosotros\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Activo digital\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Contactar con el CEO\",\"官网验证通道\":\"Verificador de medios\",\"产品功能\":\"Productos\",\"一键买币\":\"Compra/Venta rápida\",\"TradingBot\":\"Trading Bot\",\"金融服务\":\"Finanzas\",\"火币社区\":\"Comunidad HTX\",\"服务介绍\":\"Servicios\",\"认证服务\":\"Verificación de la identidad\",\"费率介绍\":\"Tasa escalonada\",\"币币交易规则\":\"Reglas del trading spot\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Programa de afiliados\",\"经纪商申请\":\"Programa Broker\",\"广告方认证服务\":\"Aplicación P2P V-Advertiser\",\"开放平台\":\"Plataforma abierta\",\"API介绍\":\"Documentación de la API\",\"活动福利\":\"Eventos y beneficios\",\"新用户奖励\":\"Bono de bienvenida\",\"入金奖励\":\"Recompensas por depósito\",\"交易奖励\":\"Recompensas por trading\",\"免费领空投\":\"Consigue Airdrops\",\"月度大促\":\"Promociones mensuales\",\"购买加密货币\":\"Comprar criptos\",\"未认证\":\"No verificado\",\"合约跟单\":\"Copy Trading\",\"福利中心\":\"Centro de Recompensas\",\"机构\":\"Institución\",\"快捷买币\":\"Trading rápido\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Compra activos digitales con Visa, Mastercard y más\",\"满足低手续费多种法币的充值\":\"Deposite monedas fiat a una comisión baja\",\"多种法币0手续费最优价格\":\"Iguala el mejor precio sin comisiones\",\"自选交易对，行情尽在掌握\":\"Supervisa tus pares de trading favoritos en tiempo real\",\"直达现货市场，抓住交易机会\":\"Aprovecha las oportunidades de trading con los mercados spot\",\"了解合约行情动态，获取超额收益\":\"Gana rendimientos elevados con los mercados de futuros\",\"交易\":\"Trading\",\"使用完整的交易功能，买卖虚拟资产\":\"Haz trading con activos digitales con nuestras herramientas avanzadas\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Aumenta tu apalancamiento sin riesgos de liquidación\",\"借币交易，放大现货收益\":\"Utiliza el apalancamiento para amplificar tus beneficios\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Haz trading automáticamente con estrategias cuánticas\",\"火币闪兑\":\"Convertir\",\"币币兑换，零费率无滑点\":\"Intercambio de cripto a cripto, sin comisiones, sin slippage\",\"衍生品\":\"Derivados\",\"以USDT结算的合约交易\":\"Productos de futuros liquidados en USDT\",\"币本位合约\":\"Futuros Coin-M\",\"以加密货币结算的合约交易\":\"Productos de futuros liquidados en criptodivisas\",\"欧式美式期权随心选择，财富稳定增值\":\"Opções ao estilo europeu e americano para multiplicar seus ativos\",\"自动跟随专业交易员下单，轻松盈利\":\"Haz trading como un experto siguiendo sus tradings\",\"Huobi合约嘉年华\":\"Carnaval de Futuros\",\"参加交易 iPhone14Pro Max等你拿\":\"Haz trading para ganar un iPhone 14 Pro Max y mucho más\",\"理财_menu\":\"Gana\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Obtén ingresos pasivos con tus activos digitales\",\"非保本高额收益结构型理财\":\"Producto estructurado con mayor rendimiento\",\"便捷抵押，安全交易\":\"Préstamos rápidos de criptomonedas para satisfacer tus necesidades de trading\",\"扩大交易规模和种类，实现多倍收益\":\"Pide prestado para aumentar tus tradings y tus beneficios\",\"金融服务_menu\":\"Finanzas\",\"迎接以太坊2.0\":\"Una nueva era para Ethereum\",\"随借随还实时到账\":\"Pide prestado y devuelve fácilmente en cualquier momento\",\"尊享大宗交易零手续费\":\"Realiza tradings en bloque sin comisiones\",\"社区\":\"Comunidad\",\"Huobi社区\":\"Comunidad de HTX\",\"在这里发现币圈财富机会\":\"Explora y descubre oportunidades para obtener riqueza\",\"快讯\":\"Noticias\",\"7*24最全币圈资讯\":\"Las últimas noticias sobre cripto al alcance de tu mano\",\"长文\":\"Artículo\",\"深入了解最新行业动态\":\"Profundiza en los conocimientos sobre criptomonedas\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Sintoniza con todo lo relacionado con las criptomonedas\",\"从入门到精通一站式学习平台\":\"Aprende, haz trading y gana\",\"博客\":\"Blog de HTX\",\"Huobi最新资讯和业务报道\":\"Mantente al día con las últimas noticias e informes\",\"活动\":\"Actividad\",\"轻松赚币，天天领奖\":\"Gana criptomonedas y otras recompensas cada día\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Descubre el próximo gran proyecto de cripto\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Descubre la diversión y los grandes premios\",\"交易赛\":\"Competencia de Trading\",\"牛人大师都爱的大赛\":\"Tradea para ascender en la tabla de clasificación\",\"通往Web 3.0的虚拟资产钱包\":\"Un wallet global de activos digitales y una puerta de entrada a la Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi simplificado con almacenamiento en la nube de claves privadas\",\"场外借贷\":\"Préstamo OTC\",\"我的费率\":\"Mis tarifas\",\"我的邀请返佣\":\"Mis referidos\",\"合约社群\":\"Comunidad de HTX Futures\",\"经纪商看板\":\"Panel del Broker\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Contenido\",\"多米尼克数字公民\":\"Ciudadanía digital Dominica\",\"体验\":\"Prueba\",\"正式\":\"Formal\",\"高级\":\"Avanzada\",\"Prime会员权益\":\"Privilegios de la Membresía Prime\",\"体验卡\":\"Prueba\",\"查看权益\":\"Ver los privilegios\",\"Global Licensed Businesses\":\"Empresas con licencia global\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Apariencia\",\"专业版\":\"Pro\",\"经典版\":\"Clásico\",\"颜色偏好\":\"Preferencia de color\",\"绿涨红跌\":\"Verde arriba/Rojo abajo\",\"红涨绿跌\":\"Rojo arriba/Verde abajo\",\"储备金证明\":\"Prueba de Reservas\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Usa saldos de Earn para tradear\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Al activar esta función, tus activos disponibles para el trading spot se mostrarán como una suma del saldo disponible de la divisa cotizada en tu cuenta Spot sin préstamos y el de la divisa cotizada en el producto Earn - Flexible. El saldo de la criptomoneda actual en el producto Flexible sólo se amortizará automáticamente cuando sea necesario para el spot trading.\",\"行情资讯\":\"Mercado\",\"HTX专区\":\"Zona $HTX\",\"一键收取HTX\":\"Reclama $HTX\",\"任务奖励日日解锁\":\"Desbloquea recompensas de tareas diariamente\",\"加密货币价格\":\"Precios de las Criptomonedas\",\"搜索\":\"Buscar\",\"热门资产\":\"Activos Populares\",\"热门话题\":\"Tendencias\",\"热门赚币\":\"Rendimentos populares\",\"全部\":\"Todo\",\"功能\":\"Funciones\",\"资讯\":\"Noticias\",\"公告\":\"Anuncios\",\"用户\":\"Usuario\",\"#num#预约\":\"#num# suscritos\",\"#num#观看\":\"#num# viendo\",\"#num#回放\":\"#num# reproducido\",\"预约\":\"Suscribirse\",\"看直播\":\"Ver en directo\",\"看回放\":\"Reproducir\",\"暂无内容\":\"No hay contenido disponible\",\"永续\":\"Perpetuo\",\"当周\":\"Semanal\",\"次周\":\"Próxima semana\",\"当季\":\"Trimestral\",\"次季\":\"Bimestral\",\"#num#粉丝\":\"#num# Seguidores\",\"关注\":\"Seguir\",\"已关注\":\"Seguidos\",\"站点地图\":\"Mapa del sitio de criptomonedas\",\"相机扫码下载<p>火币App</p>\":\"Apunta con tu cámara al código QR <p>para obtener la App HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Depositar\",\"提币\":\"Retirar\",\"划转\":\"Transferir\",\"储备金证明报告\":\"Informes de PdR\",\"切换账号\":\"Cambiar\",\"提醒\":\"Nota\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Después de eliminar la cuenta junto con sus registros de inicio de sesión, necesitarás ingresar la contraseña la próxima vez que inicies sesión en esta cuenta.\",\"确认\":\"Confirmar\",\"其他账号\":\"Otras cuentas principales\",\"管理\":\"Gestionar\",\"完成\":\"Hecho\",\"搜索子账号\":\"Buscar\",\"暂无数据\":\"Aún no hay subcuentas\",\"创建子账号\":\"Crear\",\"清除\":\"Eliminar\",\"添加其他账号\":\"Agregar\",\"主账号\":\"Cuenta principal\",\"最多添加10个其他账号，请清除后再添加\":\"Se pueden agregar hasta 10 cuentas aquí. Por favor, elimina una cuenta antes de agregar otra.\",\"我知道了\":\"Entendido\",\"我的邀请奖励\":\"Mis Referencias\",\"复制成功\":\"Copiado\",\"交易机器人\":\"Bots de Trading\",\"借币\":\"Préstamos\",\"充值&提现状态\":\"Estado de depósito & retiro\"}");

/***/ }),
/* 109 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Cripto FAQ\",\"做市商申请\":\"Solicitud de market maker\",\"火币网-领先的比特币交易平台\":\"HTX - Principal plataforma de comercio de bitcoins del mundo\",\"工具\":\"Herramientas\",\"客户端下载\":\"Descargar APP\",\"API文档\":\"Documentación APIs\",\"数字资产介绍\":\"Introducción a activos digitales\",\"官方验证通道\":\"Canal oficial de verificación\",\"历史数据下载\":\"Descargar historial de datos\",\"邀请奖励\":\"Recompensa por recomendación\",\"服务\":\"Servicios\",\"费率\":\"Comisiones\",\"交易规则介绍\":\"Normas de trading\",\"借币额度\":\"Límites de préstamos\",\"帮助中心\":\"Centro de ayuda\",\"Global CEO 信箱\":\"Contactar con CEO Global\",\"新手指南\":\"Guía para principiantes\",\"合约课堂\":\"Tutorial de Contratos\",\"法币XXX\":\"Fiat XXX\",\"杠杆介绍\":\"Introducción a Margen\",\"HT介绍\":\"Introducción a HT\",\"支持\":\"Soporte\",\"上币申请\":\"Formulario de solicitud\",\"机构服务\":\"Servicios institucionales\",\"大客户权益\":\"Privilegios de clientes VIP\",\"经纪商\":\"Agente de bolsa\",\"广告方加V认证申请\":\"Aplicación de verificación V del anunciante\",\"火币集团\":\"HTX\",\"超级返佣\":\"Afiliado\",\"条款说明\":\"Condiciones del Servicio\",\"用户协议\":\"Acuerdo de Usuario\",\"隐私条款\":\"Política de Privacidad\",\"执法和监管查询\":\"Consulta de aplicación de ley y reglamentación\",\"法币交易规则\":\"Reglas de comercio fiat\",\"关于反洗钱\":\"Sobre KYC y AML\",\"加密介绍\":\"Introducción a las Cripto\",\"首页\":\"Inicio\",\"火币合约\":\"Contratos de HTX\",\"买币\":\"Comprar cripto\",\"行情\":\"Mercado\",\"币币交易\":\"Trading Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Iniciar sesión\",\"注册\":\"Registrarse\",\"资产\":\"Activos\",\"现货账户（充币&提币）\":\"Cuenta Exchange (depósito y retiro)\",\"币币账户\":\"Cuenta de Exchange\",\"杠杆账户\":\"Cuenta de Margen\",\"法币账户\":\"Cuenta Fiat\",\"合约账户\":\"Cuenta de Contratos\",\"矿池账户\":\"Pool\",\"我的点卡\":\"Mi tarjeta de puntos\",\"信用卡买币\":\"Comprar con tarjeta de crédito\",\"订单\":\"Órdenes\",\"现货&杠杆订单\":\"Órdenes Exchange y Margen\",\"法币订单\":\"Órdenes Fiat\",\"合约订单\":\"Órdenes de Contratos\",\"账户&安全\":\"Cuenta & Seguridad\",\"身份认证\":\"Identificación\",\"法币设置\":\"Ajustes de Fiat\",\"费率设置\":\"Ajustes de comisión\",\"专业费率重磅升级\":\"Promoción en comisiones\",\"我的优惠券\":\"Mis cupones\",\"积分中心\":\"Centro de puntos\",\"邀请返佣\":\"Invitar amigos\",\"API管理\":\"Gestión de API\",\"子账号\":\"Subcuenta\",\"退出\":\"Cerrar sesión\",\"交易所\":\"Exchange\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Corea\",\"火币日本\":\"HTX Japón\",\"集团生态服务\":\"Eco Servicios de HTX\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"Fondo Ecológico HTX\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Seleccione el vendedor con las mejores ofertas\",\"一键买卖\":\"Compra/venta rápida\",\"快捷安全的数字资产交易\":\"Transacciones rápidas y seguras de activos digitales\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Intercambio de token a token, sin comisiones ni deslizamientos\",\"杠杆交易\":\"Margen\",\"借币增加本金，放大收益\":\"Multiplique sus beneficios con el apalancamiento\",\"策略交易\":\"Trading Bot\",\"7×24小时自动低买高卖\":\"Compre automáticamente a bajo precio y venda a alto precio 24/7\",\"场外大宗交易\":\"Brokerage (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Plataforma líder en tradea de bloques OTC y servicios de préstamo\",\"合约交易\":\"Contratos\",\"合约总览\":\"Resumen del contrato\",\"查看全部数字货币衍生产品\":\"Vea todos los criptoderivados de un vistazo\",\"币本位交割\":\"Coin-M Futuros\",\"每日结算，强大的风控实力支持\":\"Liquidación intradía, respaldada por nuestro sólido marco de control de riesgos\",\"币本位永续\":\"Coin-Margen Swap\",\"担保资产价值稳定，减少持仓风险\":\"Valoración estable de los activos con menos riesgos\",\"U本位合约\":\"USDT-M Contratos\",\"返佣高达60%\":\"Comisiones de hasta el 60%.\",\"期权\":\"Opciones\",\"多种玩法，自由做多做空\":\"Compre o venda, tradee como mejor le parezca\",\"金融业务\":\"Finanzas\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Vota y disfruta de grandes recompensas\",\"锁仓更简单，免费领空投\":\"Bloquea tus tokens fácilmente y disfruta de airdrops gratuitos\",\"波卡平行链插槽竞拍\":\"Subasta de tragamonedas Polkadot parachain\",\"一键挖矿，日日增收\":\"Deposita con un solo clic y gana intereses cada día\",\"ETH2.0，一键换币\":\"Convierta tokens con un solo clic\",\"质押借币\":\"Préstamos Cripto\",\"数字资产，尊享急速到账体验\":\"Disfrute de una rápida transferencia de sus activos digitales\",\"双币投资\":\"Inversión dual\",\"掌握价格波动，财富稳定增值\":\"Aprecie sus activos en medio de los mercados volátiles\",\"Learn\":\"Aprende\",\"Rewards Hub\":\"Centro de Recompensas\",\"资产总览\":\"Resumen de activos\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Préstamos de cripto\",\"期权账户\":\"Cuenta Opciones\",\"限量优惠\":\"Por tiempo limitado\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Estrategia\",\"存币宝订单\":\"Órdenes de Ahorros\",\"质押借币订单\":\"Crypto Loans\",\"返佣收益看板\":\"Panel de referencia\",\"站内信\":\"Avisos\",\"查看全部\":\"Ver todo\",\"暂无最新消息\":\"No hay nuevos avisos\",\"隐藏已读\":\"Ocultar leídos\",\"全部标为已读\":\"Marcar todo como leído\",\"扫码下载 APP\":\"Escanear QR para descargar APP\",\"更多客户端\":\"Más opciones\",\"语言\":\"Idioma\",\"折算货币\":\"Divisa\",\"提示\":\"Alerta\",\"确认将全部未读消息标记为已读？\":\"¿Confirma que marcará todos los avisos sin leer como leídos?\",\"了解VIP\":\"Sobre VIP\",\"精英会员\":\"Elite\",\"银卡VIP\":\"Insider\",\"金卡VIP\":\"Premier\",\"白金卡VIP\":\"Ambassador\",\"黑卡VIP\":\"Partner\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Bienvenido a HTX, está disfrutando de los privilegios % de HTX.\",\"取消\":\"Cancelar\",\"确定\":\"Confirmar\",\"快捷一键买卖\":\"Compra/Venta rápida\",\"法币充值\":\"Depósito Fiat\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Terceras partes\",\"自选\":\"Favoritos\",\"现货\":\"Spot\",\"合约\":\"Futuros\",\"全仓杠杆\":\"Margen cruzado\",\"逐仓杠杆\":\"Margen aislado\",\"Tradingbot 策略交易\":\"Trading Bot\",\"期权交易\":\"Opciones\",\"理财相关\":\"Relacionados con la inversión\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Otros\",\"节点质押投票\":\"Staking y Votación\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Brokerage (Préstamo)\",\"OTC交易系统\":\"Brokerage (OTC)\",\"我的资产\":\"Mis Activos\",\"我的订单\":\"Mis órdenes\",\"消息\":\"Mensaje\",\"我的福利\":\"Mis recompensas\",\"邀请返佣看板\":\"Referral Dashboard\",\"账户安全\":\"Seguridad\",\"子账号管理\":\"Gestión de subcuenta\",\"扫码下载 huobi App\":\"Escanear para descargar la aplicación\",\"更多方式\":\"Más métodos\",\"升级还需要现货交易<span>#num#U</span>\":\"Tradea <span>#num# USDT</span> más en Spot para subir de nivel\",\"升级还需要合约交易<span>#num#U</span>\":\"Tradea <span>#num# USDT</span> más en Futuros para subir de nivel\",\"升级还需要资沉<span>#num#U</span>\":\"Deposita <span>#num# USDT</span> más para subir de nivel\",\"手续费#num#折\":\"#num#menos en la tasa de tradeo\",\"HT抵扣#num#%\":\"#num#% menos con HT\",\"生日好礼\":\"Regalo de cumpleaños\",\"杠杆\":\"Margen\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Biernvenido a HTX\",\"There will be more exciting after login\":\"Te esperan más sorpresas después de iniciar la sesión.\",\"全部资产\":\"Activos totales\",\"Today’s P/L\":\"P/L de hoy\",\"点击查看\":\"Haga clic para ver\",\"下载App\":\"Descargar App\",\"退出登录\":\"Cerrar sesión\",\"关于火币\":\"Sobre HTX\",\"关于我们\":\"Sobre Nosotros\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Activo digital\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Contactar con el CEO\",\"官网验证通道\":\"Verificador de medios\",\"产品功能\":\"Productos\",\"一键买币\":\"Compra/Venta rápida\",\"TradingBot\":\"Trading Bot\",\"金融服务\":\"Finanzas\",\"火币社区\":\"Comunidad HTX\",\"服务介绍\":\"Servicios\",\"认证服务\":\"Verificación de la identidad\",\"费率介绍\":\"Tasa escalonada\",\"币币交易规则\":\"Reglas del trading spot\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Programa de afiliados\",\"经纪商申请\":\"Programa Broker\",\"广告方认证服务\":\"Aplicación P2P V-Advertiser\",\"开放平台\":\"Plataforma abierta\",\"API介绍\":\"Documentación de la API\",\"活动福利\":\"Eventos y beneficios\",\"新用户奖励\":\"Bono de bienvenida\",\"入金奖励\":\"Recompensas por depósito\",\"交易奖励\":\"Recompensas por trading\",\"免费领空投\":\"Consigue Airdrops\",\"月度大促\":\"Promociones mensuales\",\"购买加密货币\":\"Comprar criptos\",\"未认证\":\"No verificado\",\"合约跟单\":\"Copy Trading\",\"福利中心\":\"Centro de Recompensas\",\"机构\":\"Institución\",\"快捷买币\":\"Trading rápido\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Compra activos digitales con Visa, Mastercard y más\",\"满足低手续费多种法币的充值\":\"Deposite monedas fiat a una comisión baja\",\"多种法币0手续费最优价格\":\"Iguala el mejor precio sin comisiones\",\"自选交易对，行情尽在掌握\":\"Supervisa tus pares de trading favoritos en tiempo real\",\"直达现货市场，抓住交易机会\":\"Aprovecha las oportunidades de trading con los mercados spot\",\"了解合约行情动态，获取超额收益\":\"Gana rendimientos elevados con los mercados de futuros\",\"交易\":\"Trading\",\"使用完整的交易功能，买卖虚拟资产\":\"Haz trading con activos digitales con nuestras herramientas avanzadas\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Aumenta tu apalancamiento sin riesgos de liquidación\",\"借币交易，放大现货收益\":\"Utiliza el apalancamiento para amplificar tus beneficios\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Haz trading automáticamente con estrategias cuánticas\",\"火币闪兑\":\"Convertir\",\"币币兑换，零费率无滑点\":\"Intercambio de cripto a cripto, sin comisiones, sin slippage\",\"衍生品\":\"Derivados\",\"以USDT结算的合约交易\":\"Productos de futuros liquidados en USDT\",\"币本位合约\":\"Futuros Coin-M\",\"以加密货币结算的合约交易\":\"Productos de futuros liquidados en criptodivisas\",\"欧式美式期权随心选择，财富稳定增值\":\"Opções ao estilo europeu e americano para multiplicar seus ativos\",\"自动跟随专业交易员下单，轻松盈利\":\"Haz trading como un experto siguiendo sus tradings\",\"Huobi合约嘉年华\":\"Carnaval de Futuros\",\"参加交易 iPhone14Pro Max等你拿\":\"Haz trading para ganar un iPhone 14 Pro Max y mucho más\",\"理财_menu\":\"Gana\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Obtén ingresos pasivos con tus activos digitales\",\"非保本高额收益结构型理财\":\"Producto estructurado con mayor rendimiento\",\"便捷抵押，安全交易\":\"Préstamos rápidos de criptomonedas para satisfacer tus necesidades de trading\",\"扩大交易规模和种类，实现多倍收益\":\"Pide prestado para aumentar tus tradings y tus beneficios\",\"金融服务_menu\":\"Finanzas\",\"迎接以太坊2.0\":\"Una nueva era para Ethereum\",\"随借随还实时到账\":\"Pide prestado y devuelve fácilmente en cualquier momento\",\"尊享大宗交易零手续费\":\"Realiza tradings en bloque sin comisiones\",\"社区\":\"Comunidad\",\"Huobi社区\":\"Comunidad de HTX\",\"在这里发现币圈财富机会\":\"Explora y descubre oportunidades para obtener riqueza\",\"快讯\":\"Noticias\",\"7*24最全币圈资讯\":\"Las últimas noticias sobre cripto al alcance de tu mano\",\"长文\":\"Artículo\",\"深入了解最新行业动态\":\"Profundiza en los conocimientos sobre criptomonedas\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Sintoniza con todo lo relacionado con las criptomonedas\",\"从入门到精通一站式学习平台\":\"Aprende, haz trading y gana\",\"博客\":\"Blog de HTX\",\"Huobi最新资讯和业务报道\":\"Mantente al día con las últimas noticias e informes\",\"活动\":\"Actividad\",\"轻松赚币，天天领奖\":\"Gana criptomonedas y otras recompensas cada día\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Descubre el próximo gran proyecto de cripto\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Descubre la diversión y los grandes premios\",\"交易赛\":\"Competencia de Trading\",\"牛人大师都爱的大赛\":\"Tradea para ascender en la tabla de clasificación\",\"通往Web 3.0的虚拟资产钱包\":\"Un wallet global de activos digitales y una puerta de entrada a la Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi simplificado con almacenamiento en la nube de claves privadas\",\"场外借贷\":\"Préstamo OTC\",\"我的费率\":\"Mis tarifas\",\"我的邀请返佣\":\"Mis referidos\",\"合约社群\":\"Comunidad de HTX Futures\",\"经纪商看板\":\"Panel del Broker\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Contenido\",\"多米尼克数字公民\":\"Ciudadanía digital Dominica\",\"体验\":\"Prueba\",\"正式\":\"Formal\",\"高级\":\"Avanzada\",\"Prime会员权益\":\"Privilegios de la Membresía Prime\",\"体验卡\":\"Prueba\",\"查看权益\":\"Ver los privilegios\",\"Global Licensed Businesses\":\"Empresas con licencia global\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Apariencia\",\"专业版\":\"Pro\",\"经典版\":\"Clásico\",\"颜色偏好\":\"Preferencia de color\",\"绿涨红跌\":\"Verde arriba/Rojo abajo\",\"红涨绿跌\":\"Rojo arriba/Verde abajo\",\"储备金证明\":\"Prueba de Reservas\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Usa saldos de Earn para tradear\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Al activar esta función, tus activos disponibles para el trading spot se mostrarán como una suma del saldo disponible de la divisa cotizada en tu cuenta Spot sin préstamos y el de la divisa cotizada en el producto Earn - Flexible. El saldo de la criptomoneda actual en el producto Flexible sólo se amortizará automáticamente cuando sea necesario para el spot trading.\",\"行情资讯\":\"Mercado\",\"HTX专区\":\"Zona $HTX\",\"一键收取HTX\":\"Reclama $HTX\",\"任务奖励日日解锁\":\"Desbloquea recompensas de tareas diariamente\",\"加密货币价格\":\"Precios de las Criptomonedas\",\"搜索\":\"Buscar\",\"热门资产\":\"Activos Populares\",\"热门话题\":\"Tendencias\",\"热门赚币\":\"Rendimentos populares\",\"全部\":\"Todo\",\"功能\":\"Funciones\",\"资讯\":\"Noticias\",\"公告\":\"Anuncios\",\"用户\":\"Usuario\",\"#num#预约\":\"#num# suscritos\",\"#num#观看\":\"#num# viendo\",\"#num#回放\":\"#num# reproducido\",\"预约\":\"Suscribirse\",\"看直播\":\"Ver en directo\",\"看回放\":\"Reproducir\",\"暂无内容\":\"No hay contenido disponible\",\"永续\":\"Perpetuo\",\"当周\":\"Semanal\",\"次周\":\"Próxima semana\",\"当季\":\"Trimestral\",\"次季\":\"Bimestral\",\"#num#粉丝\":\"#num# Seguidores\",\"关注\":\"Seguir\",\"已关注\":\"Seguidos\",\"站点地图\":\"Mapa del sitio de criptomonedas\",\"相机扫码下载<p>火币App</p>\":\"Apunta con tu cámara al código QR <p>para obtener la App HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Depositar\",\"提币\":\"Retirar\",\"划转\":\"Transferir\",\"储备金证明报告\":\"Informes de PdR\",\"切换账号\":\"Cambiar\",\"提醒\":\"Nota\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Después de eliminar la cuenta junto con sus registros de inicio de sesión, necesitarás ingresar la contraseña la próxima vez que inicies sesión en esta cuenta.\",\"确认\":\"Confirmar\",\"其他账号\":\"Otras cuentas principales\",\"管理\":\"Gestionar\",\"完成\":\"Hecho\",\"搜索子账号\":\"Buscar\",\"暂无数据\":\"Aún no hay subcuentas\",\"创建子账号\":\"Crear\",\"清除\":\"Eliminar\",\"添加其他账号\":\"Agregar\",\"主账号\":\"Cuenta principal\",\"最多添加10个其他账号，请清除后再添加\":\"Se pueden agregar hasta 10 cuentas aquí. Por favor, elimina una cuenta antes de agregar otra.\",\"我知道了\":\"Entendido\",\"我的邀请奖励\":\"Mis Referencias\",\"复制成功\":\"Copiado\",\"交易机器人\":\"Bots de Trading\",\"借币\":\"Préstamos\",\"充值&提现状态\":\"Estado de depósito & retiro\"}");

/***/ }),
/* 110 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"FAQ crypto\",\"做市商申请\":\"Demande des teneurs de marché\",\"火币网-领先的比特币交易平台\":\"HTX-Leader d'échange de Bitcoin\",\"工具\":\"Outil\",\"客户端下载\":\"Télécharger Applications\",\"API文档\":\"Docs API\",\"数字资产介绍\":\"Introduction d'Actifs Numériques\",\"官方验证通道\":\"Moyens Officiels d'Authentification\",\"历史数据下载\":\"Télécharger Historique de Données\",\"邀请奖励\":\"Récompense d'invitation\",\"服务\":\"Services\",\"费率\":\"Tarif des Frais\",\"交易规则介绍\":\"Règles de Trading\",\"借币额度\":\"Limite de Prêt\",\"帮助中心\":\"Aide\",\"Global CEO 信箱\":\"Contacter le CEO\",\"新手指南\":\"Guide\",\"合约课堂\":\"Académie des Dérivés\",\"法币XXX\":\"Fiat XXX\",\"杠杆介绍\":\"Présentation de Marge\",\"HT介绍\":\"Présentation de HT\",\"支持\":\"Accompagnement\",\"上币申请\":\"Demande de Cotation\",\"机构服务\":\"Services aux Institutions\",\"大客户权益\":\"Avantage aux clients VIP\",\"经纪商\":\"Courtier\",\"广告方加V认证申请\":\"Application P2P V-Adverter\",\"火币集团\":\"HTX\",\"超级返佣\":\"Affilié\",\"条款说明\":\"Termes de Service\",\"用户协议\":\"Accord Utilisateur\",\"隐私条款\":\"Politique de Confidentialité\",\"执法和监管查询\":\"Autorités d'apllication de la loi et Organismes de Régulation\",\"法币交易规则\":\"Règles Fiat\",\"关于反洗钱\":\"A propos d'Anti-Blanchiment\",\"加密介绍\":\"Présentation de Crypto\",\"首页\":\"Page d'Accueil\",\"火币合约\":\"HTX Futures\",\"买币\":\"Acheter Crypto\",\"行情\":\"Marchés\",\"币币交易\":\"Trading Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Se Connecter\",\"注册\":\"S'inscrire\",\"资产\":\"Actifs\",\"现货账户（充币&提币）\":\"Compte Spot (Dépôt & Retrait)\",\"币币账户\":\"Sous-Compte Echange\",\"杠杆账户\":\"Compte Marge\",\"法币账户\":\"Compte OTC\",\"合约账户\":\"Compte Futures\",\"矿池账户\":\"Pool\",\"我的点卡\":\"Ma Carte Point\",\"信用卡买币\":\"Simplex\",\"订单\":\"Commande\",\"现货&杠杆订单\":\"Ordres au Comptant & Marge\",\"法币订单\":\"OTC\",\"合约订单\":\"Futures\",\"账户&安全\":\"Compte&Sécurité\",\"身份认证\":\"Authentification d'Identité\",\"提高账户安全\":\"Améliorez la sécurité du compte\",\"法币设置\":\"Paramétrage de Fiat\",\"费率设置\":\"Frais\",\"专业费率重磅升级\":\"Mise à Jour du Tarif de Frais\",\"我的优惠券\":\"Coupon\",\"积分中心\":\"Score\",\"邀请返佣\":\"Récompenses\",\"API管理\":\"API\",\"子账号\":\"Sous-compte\",\"退出\":\"Se Déconnecter\",\"交易所\":\"Echange\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Corée du Sud\",\"火币日本\":\"HTX Japon\",\"集团生态服务\":\"Services Ecologiques du Groupe\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"HTX Fonds Ecosystème\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chaine\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Sélectionnez le vendeur avec les meilleures offres\",\"一键买卖\":\"Achat/Vente Rapide\",\"快捷安全的数字资产交易\":\"Transactions d'actifs numériques rapides et sûres\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Échange de token à token, zéro frais, pas de glissement\",\"杠杆交易\":\"Marge\",\"借币增加本金，放大收益\":\"Multipliez vos profits grâce à l'effet de levier\",\"策略交易\":\"Bot de Trading en Grille\",\"7×24小时自动低买高卖\":\"Achetez automatiquement en bas et vendez en haut 24/7\",\"场外大宗交易\":\"Courtage\",\"行业领先的场外大宗交易和借贷服务\":\"Plate-forme leader pour les transactions de blocs OTC et les services de prêt\",\"合约交易\":\"Dérivés\",\"合约总览\":\"Aperçu du contrat\",\"查看全部数字货币衍生产品\":\"Voir tous les dérivés cryptographiques en un coup d'œil\",\"币本位交割\":\"Livraison Coin\",\"每日结算，强大的风控实力支持\":\"Règlement intrajournalier, soutenu par notre solide cadre de contrôle des risques\",\"币本位永续\":\"Swaps à marge Crypto\",\"担保资产价值稳定，减少持仓风险\":\"Valorisation stable des actifs avec moins de risques\",\"U本位合约\":\"Contrats USDT-M\",\"返佣高达60%\":\"Jusqu'à 60% de commissions\",\"期权\":\"Option\",\"多种玩法，自由做多做空\":\"Optez pour une position longue ou courte, tradez comme bon vous semble\",\"金融业务\":\"Finance\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Votez et profitez de récompenses élevées\",\"锁仓更简单，免费领空投\":\"Verrouillez facilement vos tokens et profitez d'Airdrops gratuits\",\"波卡平行链插槽竞拍\":\"Vente aux enchères de crénaux Parachain Polkadot\",\"一键挖矿，日日增收\":\"Déposez en un seul clic et gagnez des intérêts chaque jour\",\"ETH2.0，一键换币\":\"Convertissez des tokens en un l clic\",\"质押借币\":\"Prêts Crypto\",\"数字资产，尊享急速到账体验\":\"Profitez d'un transfert rapide de vos actifs numériques\",\"双币投资\":\"Double investissement\",\"掌握价格波动，财富稳定增值\":\"Appréciez vos actifs sur des marchés volatils\",\"Learn\":\"Apprendre\",\"Rewards Hub\":\"Centre des récompenses\",\"资产总览\":\"Aperçu des Comptes\",\"策略账户\":\"Compte Trading Bot\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Prêts crypto\",\"期权账户\":\"Compte d'Options\",\"限量优惠\":\"Offre Limitée\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Stratégie\",\"存币宝订单\":\"Savings\",\"质押借币订单\":\"Prêts Crypto\",\"返佣收益看板\":\"Tableau de bord de Parrainage\",\"站内信\":\"Message\",\"查看全部\":\"Voir Davantage\",\"暂无最新消息\":\"Vide\",\"隐藏已读\":\"Masquer Messages Lus\",\"全部标为已读\":\"Marquer Tout Lu\",\"扫码下载 APP\":\"Scanner et Télécharger APP\",\"更多客户端\":\"Plus d'options\",\"语言\":\"Langues\",\"折算货币\":\"Devises\",\"提示\":\"Notice\",\"确认将全部未读消息标记为已读？\":\"Etes-vous sûr de marquer tous les messages non lus comme lus?\",\"了解VIP\":\"Mécanisme VIP\",\"精英会员\":\"VIP Elite\",\"银卡VIP\":\"VIP Argent\",\"金卡VIP\":\"VIP Or\",\"白金卡VIP\":\"VIP Platine\",\"黑卡VIP\":\"VIP Noir\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Bienvenue à HTX, vous bénéficiez de %s de priorité à HTX.\",\"取消\":\"Annuler\",\"确定\":\"Envoyer\",\"快捷一键买卖\":\"Achat/Vente Rapide\",\"法币充值\":\"Dépôt Fiat\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Partie Tierce\",\"自选\":\"Favoris\",\"现货\":\"Spot\",\"合约\":\"Futures\",\"全仓杠杆\":\"Marge croisée\",\"逐仓杠杆\":\"Marge Isolée\",\"Tradingbot 策略交易\":\"Bot de Trading\",\"期权交易\":\"Options\",\"理财相关\":\"Liés à l'investissement\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Autres\",\"节点质押投票\":\"Staking & Vote\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Courtage (Prêts)\",\"OTC交易系统\":\"Courtage (OTC)\",\"我的资产\":\"Mes Actifs\",\"我的订单\":\"Mes Ordres\",\"消息\":\"Message\",\"我的福利\":\"Mes Récompenses\",\"邀请返佣看板\":\"Tableau de Bord de Parrainage\",\"账户安全\":\"Sécurité\",\"子账号管理\":\"Gestion de sous-compte\",\"扫码下载 huobi App\":\"Scannez pour télécharger l'App\",\"更多方式\":\"Plus de méthodes\",\"升级还需要现货交易<span>#num#U</span>\":\"Tradez <span>#num# USDT</span> de plus au Comptant pour passer au niveau supérieur\",\"升级还需要合约交易<span>#num#U</span>\":\"Tradez <span>#num# USDT</span> de plus en Futures pour passer au niveau supérieur\",\"升级还需要资沉<span>#num#U</span>\":\"Déposez <span>#num# USDT</span> de plus pour passer au niveau supérieur\",\"手续费#num#折\":\"#num# de réduction sur les frais de trading\",\"HT抵扣#num#%\":\"#num# % de réduction avec HT\",\"生日好礼\":\"Cadeau d'Anniversaire\",\"杠杆\":\"Marge\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Bienvenue sur HTX\",\"There will be more exciting after login\":\"D'autres surprises vous attendent une fois connecté !\",\"全部资产\":\"Total des actifs\",\"Today’s P/L\":\"P/L d'aujourd'hui\",\"点击查看\":\"Cliquez pour voir\",\"下载App\":\"Télécharger l'App\",\"退出登录\":\"Se déconnecter\",\"关于火币\":\"À propos de HTX\",\"关于我们\":\"À propos de Nous\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Actifs numériques\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Contacter le PDG\",\"官网验证通道\":\"Vérificateur de Média\",\"产品功能\":\"Produits\",\"一键买币\":\"Achat/Vente Rapide\",\"TradingBot\":\"Bot de Trading\",\"金融服务\":\"Finance\",\"火币社区\":\"Communauté HTX\",\"服务介绍\":\"Services\",\"认证服务\":\"Vérification d'identité\",\"费率介绍\":\"Frais par niveaux\",\"币币交易规则\":\"Régles du Trading Spot\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Programme d'Affiliation\",\"经纪商申请\":\"Programme de Courtage\",\"广告方认证服务\":\"Application Annonceur-V P2P\",\"开放平台\":\"Open Platform\",\"API介绍\":\"Documentation API\",\"活动福利\":\"Events & Benefits\",\"新用户奖励\":\"Bonus de Bienvenue\",\"入金奖励\":\"Récompenses de Dépôt\",\"交易奖励\":\"Récompenses de Trading\",\"免费领空投\":\"Obtenir des Airdrops\",\"月度大促\":\"Offres Mensuelles\",\"购买加密货币\":\"Acheter des Cryptos\",\"未认证\":\"Non vérifié\",\"合约跟单\":\"Copy Trading\",\"福利中心\":\"Centre de récompenses\",\"机构\":\"Institution\",\"快捷买币\":\"Trade Rapide\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Achetez des actifs numériques avec Visa, Mastercard, et plus encore\",\"满足低手续费多种法币的充值\":\"Déposez des devises à faible coût\",\"多种法币0手续费最优价格\":\"Trouvez le meilleur prix sans frais\",\"自选交易对，行情尽在掌握\":\"Suivez vos paires de trading préférées en temps réel\",\"直达现货市场，抓住交易机会\":\"Saisissez des opportunités de trading avec les marchés Spot\",\"了解合约行情动态，获取超额收益\":\"Obtenez des rendements supérieurs grâce aux marchés Futures\",\"交易\":\"Trading\",\"使用完整的交易功能，买卖虚拟资产\":\"Tradez des actifs numériques avec nos outils avancés\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Augmentez votre effet de levier sans risques de liquidation\",\"借币交易，放大现货收益\":\"Utilisez l'effet de levier pour amplifier vos profits\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Tradez automatiquement avec des stratégies quantitatives\",\"火币闪兑\":\"Conversion\",\"币币兑换，零费率无滑点\":\"Swap de crypto à crypto, sans frais ni glissement\",\"衍生品\":\"Dérivés\",\"以USDT结算的合约交易\":\"Produits futures réglés en USDT\",\"币本位合约\":\"Futures Coin-M\",\"以加密货币结算的合约交易\":\"Produits futures réglés en cryptomonnaies\",\"欧式美式期权随心选择，财富稳定增值\":\"Des options de type européen ou américain afin de multiplier vos actifs\",\"自动跟随专业交易员下单，轻松盈利\":\"Tradez comme un expert en suivant leurs positions\",\"Huobi合约嘉年华\":\"Carnaval Futures\",\"参加交易 iPhone14Pro Max等你拿\":\"Tradez pour gagner un iPhone 14 Pro Max et plus\",\"理财_menu\":\"Earn\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Générez des revenus passifs sur vos actifs numériques\",\"非保本高额收益结构型理财\":\"Produit structuré avec des rendements supérieurs\",\"便捷抵押，安全交易\":\"Des prêts crypto rapides pour répondre à vos besoins de trading\",\"扩大交易规模和种类，实现多倍收益\":\"Empruntez pour accroître vos trades et vos profits\",\"金融服务_menu\":\"Finance\",\"迎接以太坊2.0\":\"Une nouvelle ère pour Ethereum.\",\"随借随还实时到账\":\"Empruntez et remboursez facilement à tout moment\",\"尊享大宗交易零手续费\":\"Effectuez des trades de bloc sans frais\",\"社区\":\"Communauté\",\"Huobi社区\":\"Communauté HTX\",\"在这里发现币圈财富机会\":\"Découvrez de nouvelles opportunités de croissance\",\"快讯\":\"Nouvelles\",\"7*24最全币圈资讯\":\"Les dernières nouvelles crypto à portée de main\",\"长文\":\"Article\",\"深入了解最新行业动态\":\"Plongez dans l'univers des cryptos\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Soyez à l'écoute de toutes les nouvelles crypto\",\"从入门到精通一站式学习平台\":\"Apprenez, tradez et progressez\",\"博客\":\"Blog HTX\",\"Huobi最新资讯和业务报道\":\"Soyez au courant des dernières actualités et des derniers rapports\",\"活动\":\"Événement\",\"轻松赚币，天天领奖\":\"Obtenez des cryptos et d'autres récompenses chaque jour\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Découvrez le prochain grand projet crypto\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Déballez du fun et de grands prix\",\"交易赛\":\"Concours de Trading\",\"牛人大师都爱的大赛\":\"Tradez jusqu'au sommet du classement\",\"通往Web 3.0的虚拟资产钱包\":\"Un portefeuille global d'actifs numériques et une passerelle vers le Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"La DéFi rendue facile avec le stockage cloud des clés privées\",\"场外借贷\":\"Prêt OTC\",\"我的费率\":\"Mon taux de frais\",\"我的邀请返佣\":\"Mes parrainages\",\"合约社群\":\"Communauté HTX Futures\",\"经纪商看板\":\"Tableau de bord Courtier\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Contenu\",\"多米尼克数字公民\":\"Citoyenneté digitale de la Dominique\",\"体验\":\"Essai\",\"正式\":\"Formel\",\"高级\":\"Avancé\",\"Prime会员权益\":\"Avantages de l'abonnement Prime\",\"体验卡\":\"Essai\",\"查看权益\":\"Afficher les avantages\",\"Global Licensed Businesses\":\"Activités mondiales sous licence\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Apparence\",\"专业版\":\"Pro\",\"经典版\":\"Classique\",\"颜色偏好\":\"Préférence de couleur\",\"绿涨红跌\":\"Hausse en vert, baisse en rouge\",\"红涨绿跌\":\"Hausse en rouge, baisse en vert\",\"储备金证明\":\"Preuve de réserves\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Trader avec les soldes Earn\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"En activant cette fonction, vos actifs disponibles pour le trading Spot seront affichés comme un solde disponible de la devise de cotation sur votre compte Spot sans emprunt et celui de la devise de cotation dans le produit Earn - Flexible. Le solde actuel de cryptos dans le produit Flexible ne sera racheté automatiquement pour le trading Spot que lorsque cela sera nécessaire.\",\"行情资讯\":\"Marchés\",\"HTX专区\":\"Zone $HTX\",\"一键收取HTX\":\"Récupérer des $HTX\",\"任务奖励日日解锁\":\"Débloquez des récompenses quotidiennes\",\"加密货币价格\":\"Prix des cryptos\",\"搜索\":\"Rechercher\",\"热门资产\":\"Actifs populaires\",\"热门话题\":\"Tendances\",\"热门赚币\":\"Super rendements\",\"全部\":\"Tout\",\"功能\":\"Fonctions\",\"资讯\":\"Actualités\",\"公告\":\"Annonces\",\"用户\":\"Utilisateurs\",\"#num#预约\":\"#num# abonnés\",\"#num#观看\":\"#num# regardent\",\"#num#回放\":\"#num# replays\",\"预约\":\"S'abonner\",\"看直播\":\"Regarder\",\"看回放\":\"Relecture\",\"暂无内容\":\"Aucun contenu disponible\",\"永续\":\"Perpétuel\",\"当周\":\"Hebdomadaire\",\"次周\":\"Bihebdomadaire\",\"当季\":\"Trimestriel\",\"次季\":\"Bitrimestriel\",\"#num#粉丝\":\"#num# abonnés\",\"关注\":\"Suivre\",\"已关注\":\"Abonné\",\"站点地图\":\"Plan de site – Crypto\",\"相机扫码下载<p>火币App</p>\":\"Dirigez votre appareil photo vers le QR code <p>pour obtenir l'appli HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Dépôt\",\"提币\":\"Retrait\",\"划转\":\"Transfert\",\"储备金证明报告\":\"Rapports PoR\",\"切换账号\":\"Changer\",\"提醒\":\"Rappel\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Après avoir supprimé le compte et ses historiques de connexion, vous devrez saisir le mot de passe la prochaine fois que vous vous connecterez à ce compte.\",\"确认\":\"Confirmer\",\"其他账号\":\"Autres comptes principaux\",\"管理\":\"Gérer\",\"完成\":\"Terminé\",\"搜索子账号\":\"Rechercher\",\"暂无数据\":\"Pas encore de sous-comptes\",\"创建子账号\":\"Créer\",\"清除\":\"Effacer\",\"添加其他账号\":\"Ajouter\",\"主账号\":\"Compte principal\",\"最多添加10个其他账号，请清除后再添加\":\"Jusqu'à 10 comptes peuvent être ajoutés ici. Veuillez supprimer un compte avant d'en ajouter un nouveau.\",\"我知道了\":\"J'ai compris\",\"我的邀请奖励\":\"Mes parrainages\",\"复制成功\":\"Copié\",\"交易机器人\":\"Bots de Trading\",\"借币\":\"Prêts\",\"充值&提现状态\":\"Statut des dépôts et des retraits\"}");

/***/ }),
/* 111 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"FAQ Kripto\",\"做市商申请\":\"Aplikasi Pembuat Pasar\",\"火币网-领先的比特币交易平台\":\"HTX - Pertukaran Bitcoin Terkemuka\",\"工具\":\"Alat\",\"客户端下载\":\"Unduh APP\",\"API文档\":\"Dokumen API\",\"数字资产介绍\":\"Pengenalan Aset Digital\",\"官方验证通道\":\"Otentikator Media Resmi\",\"历史数据下载\":\"Unduh Riwayat Data\",\"邀请奖励\":\"Referral\",\"服务\":\"Layanan\",\"Buy HUSD\":\"Beli HUSD\",\"费率\":\"Tingkat Biaya\",\"交易规则介绍\":\"Aturan Perdagangan\",\"借币额度\":\"Batas pinjaman koin\",\"帮助中心\":\"Bantuan\",\"Global CEO 信箱\":\"Hubungi CEO Global\",\"新手指南\":\"Petunjuk\",\"合约课堂\":\"Akademi derivatif\",\"法币XXX\":\"FiatXXX\",\"杠杆介绍\":\"Pengenalan Margin\",\"HT介绍\":\"Pengenalan HT\",\"支持\":\"Bantuan\",\"上币申请\":\"Terapkan ke list\",\"机构服务\":\"Layanan Institusi\",\"大客户权益\":\"Hak Istimewa Klien Utama\",\"经纪商\":\"Progam broker\",\"广告方加V认证申请\":\"Aplikasi Pengiklan V P2P\",\"火币集团\":\"HTX\",\"超级返佣\":\"Afiliasi\",\"条款说明\":\"Persyaratan Layanan\",\"用户协议\":\"Perjanjian pengguna\",\"隐私条款\":\"Kebijakan privasi\",\"执法和监管查询\":\"Penyelidikan Penegakan dan Peraturan\",\"法币交易规则\":\"Peraturan Fiat\",\"关于反洗钱\":\"Anti Pencucian Uang\",\"加密介绍\":\"Pengenalan Kripto\",\"首页\":\"Halaman Depan\",\"火币合约\":\"HTX Contract\",\"OTC Market\":\"Pasar OTC\",\"买币\":\"Beli Kripto\",\"行情\":\"Pasar\",\"币币交易\":\"Perdagangan Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Masuk\",\"注册\":\"Daftar\",\"资产\":\"Aset\",\"现货账户（充币&提币）\":\"Akun Spot (deposit & penarikan)\",\"币币账户\":\"Akun Exchange\",\"杠杆账户\":\"Akun Margin\",\"法币账户\":\"Akun Fiat\",\"合约账户\":\"Akun Derivatives\",\"矿池账户\":\"Pool\",\"我的点卡\":\"Kartu Poin Saya\",\"信用卡买币\":\"Beli dengan kartu kredit\",\"订单\":\"Pesanan\",\"现货&杠杆订单\":\"Pesanan Spot & Margin\",\"法币订单\":\"Pesanan Fiat\",\"合约订单\":\"Pesanan Derivatives\",\"Buy&Sell History\":\"Riwayat Jual&Beli\",\"账户&安全\":\"Akun & Keamanan\",\"身份认证\":\"Identifikasi\",\"法币设置\":\"Pengaturan Fiat\",\"费率设置\":\"Pengaturan biaya\",\"专业费率重磅升级\":\"Promosi biaya\",\"我的优惠券\":\"Kupon saya\",\"积分中心\":\"Klub loyalitas\",\"邀请返佣\":\"Undang teman\",\"API管理\":\"Pengaturan API\",\"子账号\":\"Sub-Akun\",\"退出\":\"Keluar\",\"交易所\":\"Pertukaran\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Korea\",\"火币日本\":\"HTX Jepang\",\"集团生态服务\":\"Layanan Ekologi Group HTX\",\"火币矿池\":\"HTX Pool\",\"火信\":\"Perpesanan HTX\",\"火币资本\":\"HTX Modal\",\"火币全球生态基金\":\"Dana Ekosistem Global HTX\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"Rantai Eco HTX\",\"火币DeFi Labs\":\"Lab HTX DeFi\",\"火币OTC\":\"HTX Fiat\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Pilih penjual dengan penawaran terbaik\",\"一键买卖\":\"Beli/Jual Cepat\",\"快捷安全的数字资产交易\":\"Transaksi aset digital yang cepat dan aman\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Pertukaran antar-token, tanpa biaya, tanpa slippage\",\"杠杆交易\":\"Margin\",\"借币增加本金，放大收益\":\"Lipat gandakan keuntungan Anda dengan leverage\",\"策略交易\":\"Bot Perdagangan\",\"7×24小时自动低买高卖\":\"Beli dengan harga rendah dan jual dengan harga tinggi secara otomatis dalam waktu 24/7\",\"场外大宗交易\":\"Brokerage (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Platform terkemuka untuk OTC block trading dan layanan pinjaman\",\"合约交易\":\"Derivatif\",\"合约总览\":\"Ikhtisar Derivatif\",\"查看全部数字货币衍生产品\":\"Lihat sekilas semua derivatif kripto\",\"币本位交割\":\"Coin Delivery\",\"每日结算，强大的风控实力支持\":\"Intraday settlement, yang didukung oleh kerangka pengendalian risiko kami yang kuat\",\"币本位永续\":\"Coin Perpetual\",\"担保资产价值稳定，减少持仓风险\":\"Valuasi aset yang stabil dengan risiko lebih kecil\",\"U本位合约\":\"Kontrak USDT-M\",\"返佣高达60%\":\"Komisi hingga 60%\",\"期权\":\"Pilihan\",\"多种玩法，自由做多做空\":\"Mau jual atau beli, lakukanlah trading sesuai keinginan Anda\",\"金融业务\":\"Keuangan\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Pilih dan nikmati imbalan yang tinggi\",\"锁仓更简单，免费领空投\":\"Kunci token Anda dengan mudah dan nikmati airdrop gratis\",\"Polkadot Slot Auction\":\"Slot Lelang Polkadot\",\"波卡平行链插槽竞拍\":\"Polkadot parachain slot auction\",\"一键挖矿，日日增收\":\"Deposit hanya dengan satu klik dan dapatkan bunga setiap hari\",\"ETH2.0，一键换币\":\"Konversikan token hanya dengan satu klik\",\"质押借币\":\"Pinjaman Kripto\",\"数字资产，尊享急速到账体验\":\"Nikmati transfer cepat aset digital Anda\",\"双币投资\":\"Investasi Ganda\",\"掌握价格波动，财富稳定增值\":\"Hargai aset Anda di tengah pasar yang bergejolak\",\"资产总览\":\"Tinjauan aset\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Pinjaman Kripto\",\"期权账户\":\"Akun Opsi\",\"限量优惠\":\"Hak istimewa terbatas\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Daftar Bot\",\"存币宝订单\":\"Pesanan simpanan\",\"质押借币订单\":\"Pinjaman Kripto\",\"返佣收益看板\":\"Dasbor Rujukan\",\"站内信\":\"Pesan\",\"查看全部\":\"Lihat semua\",\"暂无最新消息\":\"Tidak ada  pembaruan\",\"隐藏已读\":\"Sembunyikan yang sudah dibaca\",\"全部标为已读\":\"Tandai semua telah dibaca\",\"扫码下载 APP\":\"Scan untuk Unduh\",\"更多客户端\":\"Opsi lainnya\",\"语言\":\"Bahasa\",\"折算货币\":\"Mata Uang\",\"提示\":\"Pengingat\",\"确认将全部未读消息标记为已读？\":\"Apakah Anda yakin untuk menandai semua pesan yang belum dibaca menjadi telah dibaca??\",\"了解VIP\":\"Ketahui lebih banyak tentang VIP\",\"精英会员\":\"Advanced\",\"银卡VIP\":\"Insider\",\"金卡VIP\":\"Premier\",\"白金卡VIP\":\"Ambassador\",\"黑卡VIP\":\"Partner\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Selamat datang di HTX. Anda menikmati hak istimewa %s HTX.\",\"取消\":\"Batalkan\",\"确定\":\"Konfirmasi\",\"快捷一键买卖\":\"Beli/Jual Cepat\",\"法币充值\":\"Deposit Fiat\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Pihak Ketiga\",\"自选\":\"Favorit\",\"现货\":\"Spot\",\"合约\":\"Futures\",\"全仓杠杆\":\"Cross Margin\",\"逐仓杠杆\":\"Isolated Margin\",\"Tradingbot 策略交易\":\"Bot Trading\",\"期权交易\":\"Options\",\"理财相关\":\"Terkait investasi\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Lainnya\",\"节点质押投票\":\"Staking & Voting\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Pialang (Lending)\",\"OTC交易系统\":\"Pialang (OTC)\",\"我的资产\":\"Aset Saya\",\"我的订单\":\"Order Saya\",\"消息\":\"Pesan\",\"我的福利\":\"Hadiah Saya\",\"邀请返佣看板\":\"Dasbor Referral\",\"账户安全\":\"Keamanan\",\"子账号管理\":\"Pengelolaan Sub-Akun\",\"扫码下载 huobi App\":\"Pindai untuk mengunduh Aplikasi\",\"更多方式\":\"Metode lainnya\",\"升级还需要现货交易<span>#num#U</span>\":\"Lakukan trading sebesar <span>#num# USDT</span> lagi di Spot untuk naik level\",\"升级还需要合约交易<span>#num#U</span>\":\"Lakukan trading sebesar <span>#num# USDT</span> lagi di Futures untuk naik level\",\"升级还需要资沉<span>#num#U</span>\":\"Deposit <span>#num# USDT</span> lagi untuk naik level\",\"手续费#num#折\":\"Diskon biaya trading sebesar #num#\",\"HT抵扣#num#%\":\"Diskon #num#% dengan HT\",\"生日好礼\":\"Hadiah Ulang Tahun\",\"杠杆\":\"Margin\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Selamat Datang di HTX\",\"There will be more exciting after login\":\"Banyak kejutan menanti Anda setelah login!\",\"全部资产\":\"Total Aset\",\"Today’s P/L\":\"P/L Hari Ini\",\"点击查看\":\"Klik untuk melihat\",\"下载App\":\"Unduh Aplikasi\",\"退出登录\":\"Keluar\",\"关于火币\":\"Tentang HTX\",\"关于我们\":\"Tentang Kami\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Aset Digital\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Hubungi CEO\",\"官网验证通道\":\"Pemverifikasi Media\",\"产品功能\":\"Produk\",\"一键买币\":\"Beli/Jual Cepat\",\"TradingBot\":\"Bot Trading\",\"金融服务\":\"Keuangan\",\"火币社区\":\"Komunitas HTX\",\"服务介绍\":\"Layanan\",\"认证服务\":\"Verifikasi Identitas\",\"费率介绍\":\"Biaya Berjenjang\",\"币币交易规则\":\"Peraturan Spot Trading\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Program Afiliasi\",\"经纪商申请\":\"Program Broker\",\"广告方认证服务\":\"Permohonan Pengiklan V P2P\",\"开放平台\":\"Open Platform\",\"API介绍\":\"Dokumentasi API\",\"活动福利\":\"Acara & Manfaat\",\"新用户奖励\":\"Bonus Selamat Datang\",\"入金奖励\":\"Hadiah Deposit\",\"交易奖励\":\"Hadiah Trading\",\"免费领空投\":\"Dapatkan Airdrop\",\"月度大促\":\"Promosi Bulanan\",\"购买加密货币\":\"Beli Kripto\",\"未认证\":\"Tidak terverifikasi\",\"合约跟单\":\"Copy Trading\",\"福利中心\":\"Rewards Hub\",\"机构\":\"Institusi\",\"快捷买币\":\"Trading Cepat\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Beli aset virtual dengan Visa, Mastercard, dan lainnya\",\"满足低手续费多种法币的充值\":\"Deposit mata uang fiat dengan biaya rendah\",\"多种法币0手续费最优价格\":\"Dapatkan harga terbaik tanpa biaya\",\"自选交易对，行情尽在掌握\":\"Pantau pasangan perdagangan favorit Anda secara real time\",\"直达现货市场，抓住交易机会\":\"Raih peluang trading dengan Pasar Spot\",\"了解合约行情动态，获取超额收益\":\"Dapatkan return tinggi dengan Pasar Futures\",\"交易\":\"Trading\",\"使用完整的交易功能，买卖虚拟资产\":\"Lakukan trading aset virtual dengan alat canggih kami\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Tingkatkan leverage Anda tanpa risiko likuidasi\",\"借币交易，放大现货收益\":\"Gunakan leverage untuk meningkatkan keuntungan Anda\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Lakukan trading secara otomatis dengan strategi kuantitatif\",\"火币闪兑\":\"Konversi\",\"币币兑换，零费率无滑点\":\"Swap kripto-ke-kripto, tanpa biaya, tanpa slippage\",\"衍生品\":\"Derivatif\",\"以USDT结算的合约交易\":\"Produk futures diselesaikan dalam USDT\",\"币本位合约\":\"Coin-M Futures\",\"以加密货币结算的合约交易\":\"Produk futures diselesaikan dalam mata uang kripto\",\"欧式美式期权随心选择，财富稳定增值\":\"European-style option dan American-style option untuk melipatgandakan aset Anda\",\"自动跟随专业交易员下单，轻松盈利\":\"Lakukan trading seperti seorang ahli dengan mengikuti trading mereka\",\"Huobi合约嘉年华\":\"Futures Carnival\",\"参加交易 iPhone14Pro Max等你拿\":\"Lakukan trading untuk memenangkan iPhone 14 Pro Max dan lebih banyak lagi\",\"理财_menu\":\"Earn\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Dapatkan penghasilan pasif dari aset virtual Anda\",\"非保本高额收益结构型理财\":\"Produk terstruktur dengan peningkatan yield\",\"便捷抵押，安全交易\":\"Pinjaman kripto cepat untuk memenuhi kebutuhan trading Anda\",\"扩大交易规模和种类，实现多倍收益\":\"Pinjam untuk meningkatkan trading dan keuntungan Anda\",\"金融服务_menu\":\"Keuangan\",\"迎接以太坊2.0\":\"Era baru untuk Ethereum\",\"随借随还实时到账\":\"Pinjam dan bayar pinjaman dengan mudah kapan saja\",\"尊享大宗交易零手续费\":\"Lakukan block trading tanpa biaya\",\"社区\":\"Komunitas\",\"Huobi社区\":\"Komunitas HTX\",\"在这里发现币圈财富机会\":\"Jelajahi dan temukan peluang meraih kekayaan\",\"快讯\":\"Berita\",\"7*24最全币圈资讯\":\"Berita kripto terbaru di ujung jari Anda\",\"长文\":\"Artikel\",\"深入了解最新行业动态\":\"Selami lebih dalam untuk menambah wawasan mengenai kripto\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Ikuti semua hal tentang kripto\",\"从入门到精通一站式学习平台\":\"Pelajari, trading, dan hasilkan\",\"博客\":\"Blog HTX\",\"Huobi最新资讯和业务报道\":\"Dapatkan cerita dan laporan terbaru\",\"活动\":\"Aktivitas\",\"轻松赚币，天天领奖\":\"Menangkan kripto dan hadiah lainnya setiap hari\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Temukan proyek kripto besar berikutnya\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Buka hadiah yang seru dan menarik\",\"交易赛\":\"Kompetisi Trading\",\"牛人大师都爱的大赛\":\"Lakukan trading untuk naik papan peringkat\",\"通往Web 3.0的虚拟资产钱包\":\"Wallet aset virtual global dan gerbang menuju Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi menjadi mudah dengan penyimpanan private key di cloud\",\"场外借贷\":\"Pinjaman OTC\",\"我的费率\":\"Tingkat Komisi Saya\",\"我的邀请返佣\":\"Referral Saya\",\"合约社群\":\"Komunitas HTX Futures\",\"经纪商看板\":\"Dasbor Broker\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Konten\",\"多米尼克数字公民\":\"Kewarganegaraan Digital Dominika\",\"体验\":\"Uji coba\",\"正式\":\"Resmi\",\"高级\":\"Lanjutan\",\"Prime会员权益\":\"Manfaat Keanggotaan Prime\",\"体验卡\":\"Uji Coba\",\"查看权益\":\"Lihat Manfaat\",\"Global Licensed Businesses\":\"Bisnis Berlisensi Global\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Tampilan\",\"专业版\":\"Pro\",\"经典版\":\"Klasik\",\"颜色偏好\":\"Preferensi Warna\",\"绿涨红跌\":\"Hijau naik/Merah turun\",\"红涨绿跌\":\"Merah naik/Hijau turun\",\"储备金证明\":\"Proof of Reserves\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Gunakan saldo di Earn untuk trading\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Dengan mengaktifkan fitur ini, aset Anda yang tersedia untuk spot trading akan ditampilkan sebagai jumlah saldo quote currency yang tersedia di akun Spot Anda tanpa pinjaman dan saldo quote currency di Earn - produk Flexible. Saldo kripto saat ini dalam produk Flexible hanya akan dicairkan secara otomatis bila diperlukan untuk spot trading.\",\"行情资讯\":\"Pasar\",\"HTX专区\":\"Zona $HTX\",\"一键收取HTX\":\"Klaim $HTX\",\"任务奖励日日解锁\":\"Buka hadiah tugas setiap hari\",\"加密货币价格\":\"Harga Mata Uang Kripto\",\"搜索\":\"Cari\",\"热门资产\":\"Aset Populer\",\"热门话题\":\"Trending\",\"热门赚币\":\"Imbal Hasil Populer\",\"全部\":\"Semua\",\"功能\":\"Fitur\",\"资讯\":\"Berita\",\"公告\":\"Pengumuman\",\"用户\":\"Pengguna\",\"#num#预约\":\"#num# berlangganan\",\"#num#观看\":\"#num# menonton\",\"#num#回放\":\"#num# memutar ulang\",\"预约\":\"Berlangganan\",\"看直播\":\"Tonton Siaran Langsung\",\"看回放\":\"Putar Ulang\",\"暂无内容\":\"Tidak ada konten yang tersedia\",\"永续\":\"Perpetual\",\"当周\":\"Mingguan\",\"次周\":\"Dua-mingguan\",\"当季\":\"Kuartal\",\"次季\":\"Dua Kuartal\",\"#num#粉丝\":\"#num# Pengikut\",\"关注\":\"Ikuti\",\"已关注\":\"Mengikuti\",\"站点地图\":\"Peta Situs Harga Mata Uang Kripto\",\"相机扫码下载<p>火币App</p>\":\"Arahkan kamera Anda ke kode QR <p>untuk mendapatkan Aplikasi HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Deposit\",\"提币\":\"Tarik\",\"划转\":\"Transfer\",\"储备金证明报告\":\"Laporan PoR\",\"切换账号\":\"Beralih\",\"提醒\":\"Catatan\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Setelah menghapus akun beserta catatan login-nya, Anda harus memasukkan kata sandi saat berikutnya Anda masuk ke akun ini.\",\"确认\":\"Konfirmasi\",\"其他账号\":\"Akun Utama Lainnya\",\"管理\":\"Kelola\",\"完成\":\"Selesai\",\"搜索子账号\":\"Cari\",\"暂无数据\":\"Belum ada sub-akun\",\"创建子账号\":\"Buat\",\"清除\":\"Hapus\",\"添加其他账号\":\"Tambahkan\",\"主账号\":\"Akun Utama\",\"最多添加10个其他账号，请清除后再添加\":\"Maksimal 10 akun dapat ditambahkan di sini. Silakan hapus satu akun sebelum menambahkannya.\",\"我知道了\":\"Mengerti\",\"我的邀请奖励\":\"Referral Saya\",\"复制成功\":\"Disalin\",\"交易机器人\":\"Bot Trading\",\"借币\":\"Pinjaman\",\"充值&提现状态\":\"Status Deposit dan Penarikan\"}");

/***/ }),
/* 112 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"FAQ crypto\",\"做市商申请\":\"Domanda di Market Maker\",\"火币网-领先的比特币交易平台\":\"HTX la principale piattaforma di trading di Bitcoin\",\"工具\":\"Strumenti\",\"客户端下载\":\"Download Clienti\",\"API文档\":\"API Docs\",\"数字资产介绍\":\"Introduzioni al Digital Assets\",\"官方验证通道\":\"Canale di verifica ufficiale\",\"历史数据下载\":\"Scarica cronologia dati\",\"邀请奖励\":\"Bonus benvenuto\",\"服务\":\"Servizio\",\"费率\":\"Tasso di costo\",\"交易规则介绍\":\"Regole di Trading\",\"借币额度\":\"Limite prestito\",\"帮助中心\":\"Centro supporto\",\"Global CEO 信箱\":\"Casella di posta del CEO Globale\",\"新手指南\":\"Guida\",\"合约课堂\":\"Accademia dei derivati\",\"法币XXX\":\"FIAT XXX\",\"杠杆介绍\":\"Presentazione del margine\",\"HT介绍\":\"Presentazione di HT\",\"支持\":\"Supporto\",\"上币申请\":\"Applica alla lista\",\"机构服务\":\"Servizio struttura\",\"大客户权益\":\"Privilegi del cliente chiave\",\"经纪商\":\"Broker\",\"广告方加V认证申请\":\"Richiesta P2P V-Advertiser\",\"火币集团\":\"HTX\",\"超级返佣\":\"Affiliato\",\"条款说明\":\"Termini di servizio\",\"用户协议\":\"Contratto utente\",\"隐私条款\":\"Politica sulla privacy\",\"执法和监管查询\":\"Controlli sull'applicazione e sulla regolamentazione\",\"法币交易规则\":\"Regole Fiat\",\"关于反洗钱\":\"Informazioni antiriciclaggio\",\"加密介绍\":\"Introduzione alla crittografia\",\"首页\":\"Home Page\",\"火币合约\":\"Contratto HTX\",\"买币\":\"Compra cripto\",\"行情\":\"Mercato\",\"币币交易\":\"Trading Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Accedere\",\"注册\":\"Iscriviti\",\"资产\":\"Asset\",\"现货账户（充币&提币）\":\"Account Spot (deposito & prelievo)\",\"币币账户\":\"Conto in valuta\",\"杠杆账户\":\"Conto margine\",\"法币账户\":\"FIAT\",\"合约账户\":\"Futures\",\"矿池账户\":\"Pool\",\"我的点卡\":\"La mia carta punti\",\"信用卡买币\":\"Carta di credito\",\"订单\":\"Ordine\",\"现货&杠杆订单\":\"Ordini Spot e Margin\",\"法币订单\":\"Ordine FIAT\",\"合约订单\":\"Ordine contrattuale\",\"账户&安全\":\"Conto & Sicurezza\",\"身份认证\":\"Carta di identità\",\"提高账户安全\":\"Migliora la sicurezza dell'account\",\"法币设置\":\"Impostazione di valuta FIAT\",\"费率设置\":\"Impostazione del tasso di costo\",\"专业费率重磅升级\":\"Promozione delle tariffe\",\"我的优惠券\":\"I miei Coupon\",\"积分中心\":\"Club fedeltà\",\"邀请返佣\":\"I miei premi\",\"API管理\":\"API Gestione\",\"子账号\":\"Sotto-conto\",\"退出\":\"Indietro\",\"交易所\":\"Scambio\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Korea\",\"火币日本\":\"HTX Giappone\",\"集团生态服务\":\"Servizi Eco\",\"火币矿池\":\"HTX Mining Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"Fondo Ecosistema HTX\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Catena\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Seleziona il venditore con le migliori offerte\",\"一键买卖\":\"Buy/Sell Veloce\",\"快捷安全的数字资产交易\":\"Transazioni in asset digitali veloci e sicuri\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Exchange token-to-toke, zero commissioni, nessun slittamento\",\"杠杆交易\":\"Margine\",\"借币增加本金，放大收益\":\"Moltiplica i tuoi profitti con le leve\",\"策略交易\":\"Trading Bot\",\"7×24小时自动低买高卖\":\"Compra a poco e rivendi a tanto automaticamente 24/7\",\"场外大宗交易\":\"Scambio fuori mercato\",\"行业领先的场外大宗交易和借贷服务\":\"Piattaforma leader per i servizi di block e lending OTC\",\"合约交易\":\"Transazione contrattuale\",\"合约总览\":\"Panoramica contratto\",\"查看全部数字货币衍生产品\":\"Guarda a colpo d'occhio tutti i derivati in cripto\",\"币本位交割\":\"Consegna Coin\",\"每日结算，强大的风控实力支持\":\"Regolamento infragiornaliero, supportato dal nostro forte controllo sul rischio\",\"币本位永续\":\"Coin-M Swaps\",\"担保资产价值稳定，减少持仓风险\":\"Valutazione degli asset stabili con minori rischi\",\"U本位合约\":\"USDT-M\",\"返佣高达60%\":\"Fino al 60% di commissioni\",\"期权\":\"Option\",\"多种玩法，自由做多做空\":\"Vai long o short, fai trading come preferisci\",\"金融业务\":\"Finanza\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Vota e goditi molte ricompense\",\"锁仓更简单，免费领空投\":\"Blocca i tuoi token facilmente e goditi regali gratis\",\"波卡平行链插槽竞拍\":\"Asta slot Polkadot parachain\",\"一键挖矿，日日增收\":\"Deposita con noi con un solo lick e guadagna interessi ogni giorno\",\"ETH2.0，一键换币\":\"Converti i token in un solo click\",\"质押借币\":\"Cripto Prestiti\",\"数字资产，尊享急速到账体验\":\"Goditi il trasferimento rapido delle tue risorse digitali\",\"双币投资\":\"Doppio Investimento\",\"掌握价格波动，财富稳定增值\":\"Valuta i tuoi asset nel mezzo dei mercati volatili\",\"Learn\":\"Impara\",\"资产总览\":\"Panoramica beni\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Cripto Prestiti\",\"期权账户\":\"Conto opzioni\",\"限量优惠\":\"Privilegi limitati\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Strategia\",\"存币宝订单\":\"Ordine di deposito di valuta\",\"质押借币订单\":\"Cripto Prestiti\",\"返佣收益看板\":\"Dashboard Inviti\",\"站内信\":\"Messaggio\",\"查看全部\":\"Vedi tutto\",\"暂无最新消息\":\"Nessun aggiornamento\",\"隐藏已读\":\"Nascondi letti\",\"全部标为已读\":\"Segna tutti come letti\",\"扫码下载 APP\":\"Scansiona il codice per scaricare l'app\",\"更多客户端\":\"Più opzioni\",\"语言\":\"Lingua\",\"折算货币\":\"Valuta\",\"提示\":\"Suggerimenti\",\"确认将全部未读消息标记为已读？\":\"Conferma di voler contrassegnare tutti i messaggi non letti come letti?\",\"了解VIP\":\"Conoscere VIP\",\"精英会员\":\"Avanzato\",\"银卡VIP\":\"Insider\",\"金卡VIP\":\"Premier\",\"白金卡VIP\":\"Ambassador\",\"黑卡VIP\":\"Partner\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Benvenuti su HTX, sta godendo dei %s privilegi di HTX.\",\"取消\":\"Cancella\",\"确定\":\"Conferma\",\"快捷一键买卖\":\"Acquisto/Vendita Veloce\",\"法币充值\":\"Deposito fiat\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Terze Parti\",\"自选\":\"Preferiti\",\"现货\":\"Spot\",\"合约\":\"Futures\",\"全仓杠杆\":\"Margin Cross\",\"逐仓杠杆\":\"Margin Isolato\",\"Tradingbot 策略交易\":\"Bot Trading\",\"期权交易\":\"Opzioni\",\"理财相关\":\"Relativo agli investimenti\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Altri\",\"节点质押投票\":\"Staking & Voting\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Brokerage (Prestito)\",\"OTC交易系统\":\"Brokerage (OTC)\",\"我的资产\":\"Il mio saldo\",\"我的订单\":\"I miei ordini\",\"消息\":\"Messaggio\",\"我的福利\":\"I miei premi\",\"邀请返佣看板\":\"Dashboard Inviti\",\"账户安全\":\"Sicurezza\",\"子账号管理\":\"Gestione Sub-Account\",\"扫码下载 huobi App\":\"Scansiona per scaricare l'App\",\"更多方式\":\"Più metodi\",\"升级还需要现货交易<span>#num#U</span>\":\"Scambia <span>#num# USDT</span> di più nello Spot per salire di livello\",\"升级还需要合约交易<span>#num#U</span>\":\"Scambia <span>#num# USDT</span> di più nei Futures per salire di livello\",\"升级还需要资沉<span>#num#U</span>\":\"Deposita <span>#num# USDT</span> in più per salire di livello\",\"手续费#num#折\":\"#num# di sconto sulla commissione di trading\",\"HT抵扣#num#%\":\"#num#% di sconto con HT\",\"生日好礼\":\"Regalo di Compleanno\",\"杠杆\":\"Margin\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Benvenuto su HTX\",\"There will be more exciting after login\":\"Altre sorprese di aspettano dopo aver fatto il log in!\",\"全部资产\":\"Totale Asset\",\"Today’s P/L\":\"P/L di oggi\",\"点击查看\":\"Clicca qui per visualizzare\",\"下载App\":\"Download App\",\"退出登录\":\"Esci\",\"关于火币\":\"A proposito di HTX\",\"关于我们\":\"Chi siamo\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Asset digitale\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Contatto CEO\",\"官网验证通道\":\"Autenticazione Media\",\"产品功能\":\"Prodotti\",\"一键买币\":\"Acquisto/Vendita Veloce\",\"TradingBot\":\"Bot Trading\",\"金融服务\":\"Finanza\",\"火币社区\":\"Community HTX\",\"服务介绍\":\"Servizi\",\"认证服务\":\"Verifica Identità\",\"费率介绍\":\"Livello Commissioni\",\"币币交易规则\":\"Regole Trading Spot\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Programma Affiliati\",\"经纪商申请\":\"Programma Broker\",\"广告方认证服务\":\"P2P V-Modulo Pubblicità\",\"开放平台\":\"Open Platform\",\"API介绍\":\"Documentazione API\",\"活动福利\":\"Eventi & Benefici\",\"新用户奖励\":\"Bonus di Benvenuto\",\"入金奖励\":\"Ricompense Deposito\",\"交易奖励\":\"Ricompense Trading\",\"免费领空投\":\"Ottenere Airdrops\",\"月度大促\":\"Promozioni Mensili\",\"购买加密货币\":\"Acquista Cripto\",\"未认证\":\"Non verificato\",\"合约跟单\":\"Copy trading\",\"福利中心\":\"Centro premi\",\"机构\":\"Istituzione\",\"快捷买币\":\"Trading Veloce\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Acquista asset digitali con Visa, Mastercard e altro\",\"满足低手续费多种法币的充值\":\"Deposita valute fiat a tariffe ridotte\",\"多种法币0手续费最优价格\":\"Negozia crypto per fiat al prezzo migliore e senza spese\",\"自选交易对，行情尽在掌握\":\"Controlla l'andamento delle tue coppie di trading preferite in tempo reale\",\"直达现货市场，抓住交易机会\":\"Cogli le opportunità di trading offerte dai mercati spot\",\"了解合约行情动态，获取超额收益\":\"Ottieni rendimenti elevati dai mercati futures\",\"交易\":\"Trading\",\"使用完整的交易功能，买卖虚拟资产\":\"Fai trading di asset digitali con i nostri strumenti avanzati\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Aumenta la leva finanziaria senza rischio di liquidazione\",\"借币交易，放大现货收益\":\"Utilizza la leva finanziaria per aumentare i tuoi profitti\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Fai trading in automatico con il calcolo quantistico\",\"火币闪兑\":\"Convertire\",\"币币兑换，零费率无滑点\":\"Swap da crypto a crypto, zero commissioni, nessuno slippage\",\"衍生品\":\"Derivati\",\"以USDT结算的合约交易\":\"Prodotti futures regolati in USDT\",\"币本位合约\":\"Coin-M\",\"以加密货币结算的合约交易\":\"Prodotti futures regolati in criptovaluta\",\"欧式美式期权随心选择，财富稳定增值\":\"Opzioni di tipo europeo e americano per aumentare il tuo capitale\",\"自动跟随专业交易员下单，轻松盈利\":\"Fai trading come un pro seguendo i migliori trader\",\"Huobi合约嘉年华\":\"Carnevale dei Futures\",\"参加交易 iPhone14Pro Max等你拿\":\"Fai trading per vincere iPhone 14 Pro Max e molto altro\",\"理财_menu\":\"Guadagnare\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Genera un reddito passivo con i tuoi asset digitali\",\"非保本高额收益结构型理财\":\"Prodotti strutturati con rendimenti elevati\",\"便捷抵押，安全交易\":\"Prestiti crypto rapidi per soddisfare le tue esigenze di trading\",\"扩大交易规模和种类，实现多倍收益\":\"Prendi crypto in prestito per incrementare volumi di trading e profitti\",\"金融服务_menu\":\"Finanza\",\"迎接以太坊2.0\":\"La nuova era di Ethereum\",\"随借随还实时到账\":\"Prendi in prestito e restituisci in qualunque momento\",\"尊享大宗交易零手续费\":\"Effettua compravendite per blocchi senza commissioni\",\"社区\":\"Community\",\"Huobi社区\":\"Community di HTX\",\"在这里发现币圈财富机会\":\"Esplora e scopri le opportunità di guadagno\",\"快讯\":\"Notizie\",\"7*24最全币圈资讯\":\"Le ultime notizie sulle crypto a portata di clic\",\"长文\":\"Articoli\",\"深入了解最新行业动态\":\"Notizie e approfondienti sulle crypto\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Sintonizzati su tutto ciò che riguarda le crypto\",\"从入门到精通一站式学习平台\":\"Impara, fai trading e guadagna\",\"博客\":\"Blog di HTX\",\"Huobi最新资讯和业务报道\":\"Segui le ultime notizie e pubblicazioni\",\"活动\":\"Eventi\",\"轻松赚币，天天领奖\":\"Vinci crypto e altri premi ogni giorno\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Scopri i progetti crypto emergenti più interessanti\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Divertimento e grandi premi in palio\",\"交易赛\":\"Competizioni di trading\",\"牛人大师都爱的大赛\":\"Fai trading e scala la classifica\",\"通往Web 3.0的虚拟资产钱包\":\"Portafoglio globale di asset digitali e porta d'accesso al Web 3.0\",\"云钱包\":\"Wallet in cloud\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi semplificata con l'archiviazione in cloud delle chiavi private\",\"场外借贷\":\"Prestiti OTC\",\"我的费率\":\"Miei Tassi di Commissione\",\"我的邀请返佣\":\"Miei Inviti\",\"合约社群\":\"Community HTX Futures\",\"经纪商看板\":\"Pannello dei broker\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Contenuti\",\"多米尼克数字公民\":\"Cittadinanza digitale della Dominica\",\"体验\":\"Prova\",\"正式\":\"Regolare\",\"高级\":\"Avanzata\",\"Prime会员权益\":\"Benefici Abbonamento Prime\",\"体验卡\":\"Prova\",\"查看权益\":\"Visualizzare Privilegi\",\"Global Licensed Businesses\":\"Aziende con Licenza Globale\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Tema\",\"专业版\":\"Pro\",\"经典版\":\"Classico\",\"颜色偏好\":\"Preferenza di colore\",\"绿涨红跌\":\"Verde su/Rosso giù\",\"红涨绿跌\":\"Rosso su/Verde giù\",\"储备金证明\":\"Proof of Reserves\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Usa i fondi in Earn per fare trading\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Abilitando questa funzione, i tuoi fondi disponibili per il trading spot verranno visualizzati come somma dei fondi disponibile per questa crypto nel tuo account spot senza prestiti e di quello di questa crypto nel prodotto Earn - Flexible. Il bilancio della crypto corrente prodotto Flexible verrà riscattato automaticamente solo quando necessario per il trading spot.\",\"行情资讯\":\"Mercato\",\"HTX专区\":\"Zona $HTX\",\"一键收取HTX\":\"Richiedi $HTX\",\"任务奖励日日解锁\":\"Sblocca le ricompense sulle task ogni giorno\",\"加密货币价格\":\"Prezzi delle Criptovalute\",\"搜索\":\"Cerca\",\"热门资产\":\"Asset Popolari\",\"热门话题\":\"Di Tendenza\",\"热门赚币\":\"Super Rendimenti\",\"全部\":\"Tutto\",\"功能\":\"Funzioni\",\"资讯\":\"News\",\"公告\":\"Annunci\",\"用户\":\"Utenti\",\"#num#预约\":\"#num# sottoscritto\",\"#num#观看\":\"#num# guardano\",\"#num#回放\":\"#num# riproduzioni\",\"预约\":\"Registrati\",\"看直播\":\"Guarda live\",\"看回放\":\"Replay\",\"暂无内容\":\"Nessun contenuto disponibile\",\"永续\":\"Perpetui\",\"当周\":\"Settimanale\",\"次周\":\"Bi-settimanale\",\"当季\":\"Trimestre\",\"次季\":\"Bi-Trimestrale\",\"#num#粉丝\":\"#num# Followers\",\"关注\":\"Segui\",\"已关注\":\"Seguito\",\"站点地图\":\"Criptovalute Mappa del sito\",\"相机扫码下载<p>火币App</p>\":\"Inquadra il QR nella tua camera <p>per ottenere l'App HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Deposita\",\"提币\":\"Preleva\",\"划转\":\"Trasferisci\",\"储备金证明报告\":\"Rapporto PoR\",\"切换账号\":\"Cambia\",\"提醒\":\"Promemoria\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Dopo aver eliminato l'account e i relativi dati di accesso, la prossima volta che accederai a questo account dovrai inserire la password.\",\"确认\":\"Confermare\",\"其他账号\":\"Altri account principali\",\"管理\":\"Gestione\",\"完成\":\"Completato\",\"搜索子账号\":\"Cercare\",\"暂无数据\":\"No sub-account ancora\",\"创建子账号\":\"Creare\",\"清除\":\"Cancellare\",\"添加其他账号\":\"Aggiungere\",\"主账号\":\"Conto principale\",\"最多添加10个其他账号，请清除后再添加\":\"Possono essere aggiunti fino a 10 account qui. Per favore, elimina un account prima di aggiungerne un altro.\",\"我知道了\":\"Ho capito\",\"我的邀请奖励\":\"Miei Inviti\",\"复制成功\":\"Copiato\",\"交易机器人\":\"Trading Bots\",\"借币\":\"Prestiti\",\"充值&提现状态\":\"Stato Deposito & Prelievo\"}");

/***/ }),
/* 113 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Cripto FAQ\",\"做市商申请\":\"Candidatura de Market Maker\",\"火币网-领先的比特币交易平台\":\"HTX - Plataforma líder de comércio de Bitcoin\",\"工具\":\"Ferramentas\",\"客户端下载\":\"Descarregar aplicação\",\"API文档\":\"Documentos API\",\"数字资产介绍\":\"Introdução aos Ativos Digitais\",\"官方验证通道\":\"Autenticador de Mídia Oficial\",\"历史数据下载\":\"Descarregar dados do Histórico\",\"邀请奖励\":\"Recompensas de convite\",\"服务\":\"Serviços\",\"Buy HUSD\":\"Comprar HUSD\",\"费率\":\"Taxas\",\"交易规则介绍\":\"Regras de negociação\",\"借币额度\":\"Limite de Empréstimo de Moeda\",\"帮助中心\":\"Suporte\",\"Global CEO 信箱\":\"Contate o CEO Global\",\"新手指南\":\"Guia para principiantes\",\"合约课堂\":\"Academia de Derivativos\",\"法币XXX\":\"Fiat XXX\",\"杠杆介绍\":\"O que é Margem\",\"HT介绍\":\"Introdução da HT\",\"支持\":\"Suporte\",\"上币申请\":\"Listagem de Token\",\"机构服务\":\"Serviços Institucionais\",\"大客户权益\":\"Privilégios dos Clientes Principais\",\"经纪商\":\"Programa Corretor HTX\",\"广告方加V认证申请\":\"Aplicação P2P Anunciante-V\",\"火币集团\":\"HTX\",\"Web3 Scholarship\":\"Bolsa Web3\",\"超级返佣\":\"Afiliado\",\"条款说明\":\"Termos de Serviço\",\"用户协议\":\"Termo de Uso\",\"隐私条款\":\"Política de Privacidade\",\"执法和监管查询\":\"Aplicação da lei e inquéritos regulamentares\",\"法币交易规则\":\"Regras da Negociação de Fiat\",\"关于反洗钱\":\"Contra Lavagem de Dinheiro\",\"加密介绍\":\"Introdução à Cripto\",\"首页\":\"Página inicial\",\"火币合约\":\"Contratos HTX\",\"买币\":\"Comprar Cripto\",\"行情\":\"Mercados\",\"币币交易\":\"Negociação Spot\",\"成长学院\":\"HTX Learn\",\"登录\":\"Iniciar sessão\",\"注册\":\"Inscreva-se\",\"资产\":\"Ativos\",\"现货账户（充币&提币）\":\"Conta Spot (depósito e retiradas)\",\"币币账户\":\"Conta de Exchange\",\"杠杆账户\":\"Conta de Margem\",\"法币账户\":\"Conta de Fiat\",\"合约账户\":\"Conta de Contratos\",\"矿池账户\":\"Pool\",\"我的点卡\":\"Meu Cartão de Pontos\",\"信用卡买币\":\"Compre com Cartão de Crédito\",\"订单\":\"Pedidos\",\"现货&杠杆订单\":\"Spot & Margem\",\"法币订单\":\"Pedidos de Fiat\",\"合约订单\":\"Pedidos de Contrato\",\"账户&安全\":\"Conta & Segurança\",\"身份认证\":\"Verificação de ID\",\"提高账户安全\":\"Aumentar a segurança da conta\",\"法币设置\":\"Configuração de Fiat\",\"费率设置\":\"Configuração de Taxas\",\"专业费率重磅升级\":\"Promoção de taxas\",\"我的优惠券\":\"Meu Cupão\",\"积分中心\":\"Clube de créditos\",\"邀请返佣\":\"Recompensas\",\"API管理\":\"Gestão de API\",\"子账号\":\"Sub-conta\",\"退出\":\"Sair\",\"交易所\":\"Negociar\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Coreia do Sul\",\"火币日本\":\"HTX Japão\",\"集团生态服务\":\"Eco Serviços\",\"火币矿池\":\"HTX Pool\",\"火信\":\"Converse com a HTX\",\"火币资本\":\"Ventures HTX\",\"火币全球生态基金\":\"HTX Ecosystem Fund\",\"火币云\":\"Nuvem HTX\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Selecione o vendedor com as melhores ofertas\",\"一键买卖\":\"Compra/Venda rápida\",\"快捷安全的数字资产交易\":\"Transações de ativos digitais rápidas e seguras\",\"现货交易\":\"Spot\",\"币币兑换，零费率，无滑点\":\"Câmbio token-to-token, taxa zero e sem slippage\",\"杠杆交易\":\"Margem\",\"借币增加本金，放大收益\":\"Multiplique seus lucros com a alavancagem\",\"策略交易\":\"Bot\",\"7×24小时自动低买高卖\":\"Compre na baixa e venda na alta automaticamente 24h por dia, 7 dias por semana\",\"场外大宗交易\":\"Em bloco OTC\",\"行业领先的场外大宗交易和借贷服务\":\"Maior plataforma de negociações de bloco de OTC e serviços de empréstimo\",\"合约交易\":\"Derivativos\",\"合约总览\":\"Resumo do contrato\",\"查看全部数字货币衍生产品\":\"Visualize todos os derivativos cripto s+o com uma olhadela\",\"币本位交割\":\"Coin-M Futuros\",\"每日结算，强大的风控实力支持\":\"Liquidação intradiária, suportada por nossa forte estrutura de controle de riscos\",\"币本位永续\":\"Swaps de moeda\",\"担保资产价值稳定，减少持仓风险\":\"Valorização de ativos estáveis com menos risco\",\"U本位合约\":\"USDT-M Contratos\",\"返佣高达60%\":\"Comissões de até 60%\",\"期权\":\"Opções\",\"多种玩法，自由做多做空\":\"Long ou short, negocie da forma que você preferir\",\"金融业务\":\"Serviços financeiros\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Vote e aproveite grandes recompensas\",\"锁仓更简单，免费领空投\":\"Bloqueie seus tokens de forma fácil e aproveite os airdrops gratuitos\",\"波卡平行链插槽竞拍\":\"Leilão de slots da parachain Polkadot\",\"一键挖矿，日日增收\":\"Deposite com apenas um clique e ganhe juros todos os dias\",\"ETH2.0，一键换币\":\"Converta tokens com apenas um clique\",\"质押借币\":\"Empréstimos cripto\",\"数字资产，尊享急速到账体验\":\"Aproveite as transferências swift dos seus ativos digitais\",\"掌握价格波动，财富稳定增值\":\"Aprecie seus ativos em mercados voláteis\",\"Learn\":\"Mais\",\"资产总览\":\"Visão geral dos ativos\",\"策略账户\":\"Conta de Bot\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Empréstimos cripto\",\"期权账户\":\"Conta de opções\",\"限量优惠\":\"Privilégios limitados\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Estratégia\",\"存币宝订单\":\"Pedidos de Depósito\",\"质押借币订单\":\"Empréstimos cripto\",\"返佣收益看板\":\"Painel de referência\",\"站内信\":\"Mensagem interna\",\"查看全部\":\"Ler tudo\",\"暂无最新消息\":\"Sem atualizações\",\"隐藏已读\":\"Ocultar lidas\",\"全部标为已读\":\"Marcar todas como lidas\",\"扫码下载 APP\":\"Digitalize o código para descarregar a app\",\"更多客户端\":\"Mais opções\",\"语言\":\"Língua\",\"折算货币\":\"Moeda\",\"提示\":\"Aviso\",\"确认将全部未读消息标记为已读？\":\"Tem a certeza de que deseja marcar todas as mensagens não lidas como lidas?\",\"了解VIP\":\"Saiba mais sobre VIP\",\"精英会员\":\"Avançado\",\"银卡VIP\":\"Insider\",\"金卡VIP\":\"Premier\",\"白金卡VIP\":\"Embaixador\",\"黑卡VIP\":\"Parceiro\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Bem-vindo a HTX. Está a aproveitar os seguintes privilégios da HTX %s.\",\"取消\":\"Cancelar\",\"确定\":\"Confirmar\",\"快捷一键买卖\":\"Compra/Venda rápida\",\"法币充值\":\"Depósito Fiat\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Terceira Parte\",\"自选\":\"Favoritos\",\"现货\":\"Spot\",\"合约\":\"Futuros\",\"全仓杠杆\":\"Margem cruzada\",\"逐仓杠杆\":\"Margem isolada\",\"Tradingbot 策略交易\":\"Trading Bot\",\"期权交易\":\"Opções\",\"理财相关\":\"Relacionado com o investimento\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Outros\",\"节点质押投票\":\"Staking e Votação\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Corretagem (Empréstimos)\",\"OTC交易系统\":\"Corretagem (OTC)\",\"我的资产\":\"Meus Ativos\",\"我的订单\":\"Meus Pedidos\",\"消息\":\"Mensagem\",\"我的福利\":\"Minhas recompensas\",\"邀请返佣看板\":\"Painel de Referência\",\"账户安全\":\"Segurança\",\"子账号管理\":\"Gestão da subconta\",\"扫码下载 huobi App\":\"Digitalize para descarregar a App\",\"更多方式\":\"Mais métodos\",\"升级还需要现货交易<span>#num#U</span>\":\"Negocie <span>#num# USDT</span> mais em Spot para subir de nível\",\"升级还需要合约交易<span>#num#U</span>\":\"Negocie <span>#num# USDT</span> mais em Futuros para subir de nível\",\"升级还需要资沉<span>#num#U</span>\":\"Deposite <span>#num# USDT</span> mais para subir de nível\",\"手续费#num#折\":\"#num# de desconto na taxa de negociação\",\"HT抵扣#num#%\":\"#num#% de desconto com HT\",\"生日好礼\":\"Prenda de aniversário\",\"杠杆\":\"Margem\",\"理财\":\"Earn\",\"法币\":\"Fiat\",\"Welcome to Huobi\":\"Bem vindo à HTX\",\"There will be more exciting after login\":\"Mais surpresas esperam por si depois de iniciar sessão!\",\"全部资产\":\"Total de Ativos\",\"Today’s P/L\":\"L/P de hoje\",\"P/L\":\"L/P\",\"点击查看\":\"Clique para visualizar\",\"下载App\":\"Descarregar app\",\"退出登录\":\"Sair\",\"关于火币\":\"Sobre HTX\",\"关于我们\":\"Sobre nós\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Ativos digitais\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Entrar em contato com o CEO\",\"官网验证通道\":\"Verificador de Mídias\",\"产品功能\":\"Produtos\",\"一键买币\":\"Compra/Venda Rápida\",\"TradingBot\":\"Trading Bot\",\"金融服务\":\"Finanças\",\"火币社区\":\"Comunidade HTX\",\"服务介绍\":\"Serviços\",\"认证服务\":\"Verificação de ID\",\"费率介绍\":\"Taxas por nível\",\"币币交易规则\":\"Regras de negociação spot\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Programa de Afiliados\",\"经纪商申请\":\"Programa de Corretores\",\"广告方认证服务\":\"Inscrição para Anunciante P2P\",\"开放平台\":\"Plataforma aberta\",\"API介绍\":\"Documentação API\",\"活动福利\":\"Eventos e Benefícios\",\"新用户奖励\":\"Bónus de Boas-Vindas\",\"入金奖励\":\"Recompensas de Depósitos\",\"交易奖励\":\"Recompensas de Negociações\",\"免费领空投\":\"Ganhe Airdrops\",\"月度大促\":\"Promoções Mensais\",\"购买加密货币\":\"Comprar Criptos\",\"未认证\":\"Não verificado\",\"合约跟单\":\"Copiar transação\",\"福利中心\":\"Centro de recompensas\",\"机构\":\"Instituição\",\"快捷买币\":\"Trading Rápido\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Comprar ativos digitais com Visa, Mastercard e mais\",\"满足低手续费多种法币的充值\":\"Deposite moedas fiat com uma taxa baixa\",\"多种法币0手续费最优价格\":\"Cubra o melhor preço com taxas zero\",\"自选交易对，行情尽在掌握\":\"Monitore os seus pares de negociação favoritos em tempo real\",\"直达现货市场，抓住交易机会\":\"Aproveite oportunidades de negociação com Mercados Spot\",\"了解合约行情动态，获取超额收益\":\"Ganhe grandes retornos com Mercados de Futuros\",\"交易\":\"Transação\",\"使用完整的交易功能，买卖虚拟资产\":\"Negocie ativos virtuais com ferramentas avançadas\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Aumente a sua alavancagem sem risco de liquidação\",\"借币交易，放大现货收益\":\"Use a alavancagem para ampliar os seus lucros\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Negocie automaticamente com estratégias quant\",\"火币闪兑\":\"Converter\",\"币币兑换，零费率无滑点\":\"Swap cripto-para-cripto, sem taxas, sem derrapagem\",\"衍生品\":\"Derivativos\",\"以USDT结算的合约交易\":\"Produtos futuros mantidos em USDT\",\"币本位合约\":\"Futuros Coin-M\",\"以加密货币结算的合约交易\":\"Produtos futuros mantidos em criptomoedas\",\"欧式美式期权随心选择，财富稳定增值\":\"Opções ao estilo europeu e americano para multiplicar seus ativos\",\"自动跟随专业交易员下单，轻松盈利\":\"Negocie como um especialista ao seguir suas negociações\",\"Huobi合约嘉年华\":\"Carnaval de Futuros\",\"参加交易 iPhone14Pro Max等你拿\":\"Negocie para ganhar um iPhone 14 Pro Max e mais\",\"理财_menu\":\"Ganhar\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Ganhe um rendimento passivo nos seus ativos virtuais\",\"非保本高额收益结构型理财\":\"Produto estruturado com rendimentos aumentados\",\"便捷抵押，安全交易\":\"Empréstimos rápidos de cripto para satisfazer as suas necessidades de negociação\",\"扩大交易规模和种类，实现多倍收益\":\"Pegue emprestado para intensificar as suas negociações e lucros\",\"金融服务_menu\":\"Finança\",\"迎接以太坊2.0\":\"Uma nova era para Ethereum\",\"随借随还实时到账\":\"Pegue emprestado e pague de volta facilmente a qualquer momento\",\"尊享大宗交易零手续费\":\"Faça  negociações em bloco com taxas zero\",\"社区\":\"Comunidade\",\"Huobi社区\":\"Comunidade HTX\",\"在这里发现币圈财富机会\":\"Explore e descubra oportunidades de riqueza\",\"快讯\":\"Novidades\",\"7*24最全币圈资讯\":\"Últimas novidades cripto na ponta dos seus dedos\",\"长文\":\"Artigo\",\"深入了解最新行业动态\":\"Mergulhe fundo para insights cripto\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Sintonize em todas as coisas de cripto\",\"从入门到精通一站式学习平台\":\"Aprenda, negocie, e ganhe\",\"博客\":\"HTX Blog\",\"Huobi最新资讯和业务报道\":\"Seja atualizado com as últimas histórias e relatórios\",\"活动\":\"Atividade\",\"轻松赚币，天天领奖\":\"Ganhe criptos e outras recompensas todos os dias\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Descubra o próximo grande projeto de cripto\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Desempacote diversão e ótimos prémios\",\"交易赛\":\"Competição de Negociação\",\"牛人大师都爱的大赛\":\"Negocie a seu caminho a subir para a tabela de liderança\",\"通往Web 3.0的虚拟资产钱包\":\"Uma Carteira virtual de ativo global e porta para a Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi de maneira fácil com armazenamento em nuvem e chaves privadas\",\"场外借贷\":\"Empréstimo OTC\",\"我的费率\":\"Minha taxa\",\"我的邀请返佣\":\"Minhas referências\",\"合约社群\":\"Comunidade HTX Futures\",\"经纪商看板\":\"Painel do Corretor\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Conteúdo\",\"多米尼克数字公民\":\"Cidadania Digital Dominica\",\"体验\":\"Teste\",\"正式\":\"Formal\",\"高级\":\"Avançado\",\"Prime会员权益\":\"Benefícios da Assinatura Prime\",\"体验卡\":\"Teste\",\"查看权益\":\"Ver Benefícios\",\"Global Licensed Businesses\":\"Negócios Licenciados Globais\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Aparência\",\"专业版\":\"Pro\",\"经典版\":\"Clássico\",\"颜色偏好\":\"Preferência de cor\",\"绿涨红跌\":\"Verde para cima/ Vermelho para baixo\",\"红涨绿跌\":\"Vermelho para cima/Verde para baixo\",\"储备金证明\":\"Prova de reservas\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Usar saldos em Earn para transacionar\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Ao ativar esta funcionalidade, os teus ativos disponíveis para trading à vista serão exibidos como a soma do saldo disponível da moeda de cotação na tua conta à vista, sem empréstimos, e o saldo da moeda de cotação no produto Earn - Flexible. O saldo da criptomoeda atual no produto Flexible será resgatado automaticamente apenas quando necessário para trading à vista.\",\"行情资讯\":\"Mercados\",\"HTX专区\":\"Zona $HTX\",\"一键收取HTX\":\"Reclamar $HTX\",\"任务奖励日日解锁\":\"Desbloqueia recompensas diariamente\",\"加密货币价格\":\"Preços das criptomoedas\",\"搜索\":\"Buscar\",\"热门资产\":\"Ativos populares\",\"热门话题\":\"Tendências\",\"热门赚币\":\"Rendimentos populares\",\"全部\":\"Tudo\",\"功能\":\"Características\",\"资讯\":\"Notícias\",\"公告\":\"Anúncios\",\"用户\":\"Utilizadores\",\"#num#预约\":\"#número# de subscritores\",\"#num#观看\":\"#num# assistindo\",\"#num#回放\":\"#num# reproduzidos\",\"预约\":\"Subscrever\",\"看直播\":\"Assiste em direto\",\"看回放\":\"Reprodução\",\"暂无内容\":\"Nenhum conteúdo disponível\",\"永续\":\"Perpétuo\",\"当周\":\"Esta semana\",\"次周\":\"Próxima semana\",\"当季\":\"Trimestral\",\"次季\":\"Semestral\",\"#num#粉丝\":\"#num# seguidores\",\"关注\":\"Seguir\",\"已关注\":\"Seguindo\",\"站点地图\":\"Mapa do site de criptomoeda\",\"相机扫码下载<p>火币App</p>\":\"Aponta a tua câmara para o código QR <p>para obter a aplicação HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Depositar\",\"提币\":\"Levantar\",\"划转\":\"Transferir\",\"储备金证明报告\":\"Relatórios PoR\",\"切换账号\":\"Alternar\",\"提醒\":\"Nota\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Depois de eliminares a conta e os respetivos registos de início de sessão, terás de introduzir a palavra-passe da próxima vez que iniciares sessão nesta conta.\",\"确认\":\"Confirmar\",\"其他账号\":\"Outras contas principais\",\"管理\":\"Gestão\",\"完成\":\"Completado\",\"搜索子账号\":\"Buscar\",\"暂无数据\":\"Ainda não existem subcontas\",\"创建子账号\":\"Criar\",\"清除\":\"Eliminar\",\"添加其他账号\":\"Adicionar\",\"主账号\":\"Conta principal\",\"最多添加10个其他账号，请清除后再添加\":\"Podes adicionar até 10 contas aqui. Elimina uma conta antes de adicionares outra.\",\"我知道了\":\"Percebi\",\"我的邀请奖励\":\"Minhas referências\",\"复制成功\":\"Copiado\",\"交易机器人\":\"Trading Bots\",\"借币\":\"Empréstimos\",\"充值&提现状态\":\"Estado do depósito e levantamento\"}");

/***/ }),
/* 114 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Crypto FAQ\",\"做市商申请\":\"Заявка для маркет-мейкеров\",\"火币网-领先的比特币交易平台\":\"HTX - Leading Bitcoin Exchange\",\"工具\":\"Инструменты\",\"客户端下载\":\"Загрузка приложения\",\"API文档\":\"API Doc\",\"数字资产介绍\":\"Цифровые активы\",\"官方验证通道\":\"Официальный Канал Проверки\",\"Huobi Blog\":\"HTX Блог\",\"历史数据下载\":\"Скачать историю данных\",\"邀请奖励\":\"Награды\",\"服务\":\"Услуги\",\"Buy HUSD\":\"Купить HUSD\",\"费率\":\"Комиссия\",\"交易规则介绍\":\"Торговые правила\",\"借币额度\":\"Лимит заимствования\",\"帮助中心\":\"Помощь\",\"Global CEO 信箱\":\"Связь с Global CEO\",\"新手指南\":\"Руководство для начинающих\",\"合约课堂\":\"Контрактный класс\",\"法币XXX\":\"OTC XXX\",\"杠杆介绍\":\"Что такое маржинальная торговля\",\"HT介绍\":\"Обзор HT\",\"支持\":\"Поддержка\",\"上币申请\":\"Заявка на листинг\",\"机构服务\":\"Институциональные Услуги\",\"大客户权益\":\"Привилегии ключевых клиентов\",\"经纪商\":\"Брокерская программа\",\"广告方加V认证申请\":\"P2P заявка V-Рекламодателя\",\"火币集团\":\"HTX\",\"Web3 Scholarship\":\"Web3 Поддержка\",\"超级返佣\":\"Партнер\",\"条款说明\":\"Наша политика\",\"用户协议\":\"Пользовательское соглашение\",\"隐私条款\":\"Политика конфиденциальности\",\"法币交易规则\":\"Торговые правила OTC\",\"关于反洗钱\":\"О борьбе с отмыванием денег\",\"加密介绍\":\"О криптовалюте\",\"首页\":\"Главная\",\"火币合约\":\"HTX DM\",\"买币\":\"Купить криптовалюту\",\"行情\":\"Рынки\",\"币币交易\":\"Спотовая Торговля\",\"成长学院\":\"HTX Learn\",\"登录\":\"ВОЙТИ\",\"注册\":\"Регистрация\",\"资产\":\"Активы\",\"现货账户（充币&提币）\":\"Спотовый счет (депозит и вывод)\",\"币币账户\":\"Валютный счет\",\"杠杆账户\":\"Маржинальный счет\",\"法币账户\":\"Фиатный счет\",\"合约账户\":\"Контрактный счет\",\"矿池账户\":\"Пул\",\"我的点卡\":\"Мои поинт карты\",\"信用卡买币\":\"Кредитная Карта\",\"订单\":\"ОРДЕРА\",\"现货&杠杆订单\":\"Спотовые и Маржинальные ордера\",\"法币订单\":\"Купить криптовалюту\",\"合约订单\":\"Контракты\",\"账户&安全\":\"Аккаунт & Безопасность\",\"身份认证\":\"Верификация\",\"法币设置\":\"Настройки OTC\",\"费率设置\":\"Настройка комиссии\",\"专业费率重磅升级\":\"Обновление комиссии\",\"我的优惠券\":\"мой купон\",\"积分中心\":\"Loyalty Club\",\"邀请返佣\":\"Приглашение\",\"API管理\":\"Управление API\",\"子账号\":\"Суб-аккаунт\",\"退出\":\"Выйти\",\"交易所\":\"Биржи\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Korea\",\"火币日本\":\"HTX Japan\",\"集团生态服务\":\"Сервисы экосистемы HTX\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"HTX Ecosystem Fund\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Выберите продавца с лучшими предложениями\",\"一键买卖\":\"Быстрая покупка/продажа\",\"快捷安全的数字资产交易\":\"Быстрые и безопасные операции с цифровыми активами\",\"现货交易\":\"Спот\",\"币币兑换，零费率，无滑点\":\"Обмен токена на токен, нулевая комиссия, отсутствие проскальзывания\",\"杠杆交易\":\"Маржа\",\"借币增加本金，放大收益\":\"Умножьте свою прибыль с кредитным плечом\",\"策略交易\":\"Торговый бот\",\"7×24小时自动低买高卖\":\"Автоматически покупайте дешево и продавайте дорого 24/7\",\"场外大宗交易\":\"Брокеридж(OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Ведущая платформа для ОТС сделок и кредитных услуг\",\"合约交易\":\"Фьючерсы\",\"合约总览\":\"Обзор деривативов\",\"查看全部数字货币衍生产品\":\"Краткий обзор всех крипто-деривативов\",\"币本位交割\":\"Доставка Монет\",\"每日结算，强大的风控实力支持\":\"Внутридневные расчеты, поддерживаемые нашей надежной системой контроля рисков\",\"币本位永续\":\"Коин-маржинальные Свопы\",\"担保资产价值稳定，减少持仓风险\":\"Надежная оценка стоимости активов с наименьшими рисками\",\"U本位合约\":\"USDT-маржинальные Контракты\",\"返佣高达60%\":\"До 60% комиссионных\",\"期权\":\"Опционы\",\"多种玩法，自由做多做空\":\"Открывайте лонг или шорт позицию, торгуйте так, как считаете нужным\",\"金融业务\":\"Финансы\",\"节点投票\":\"Стейкинг\",\"享受高奖励的节点投票\":\"Голосуйте и наслаждайтесь высокими наградами\",\"锁仓更简单，免费领空投\":\"Легко заблокируйте свои токены и наслаждайтесь бесплатными аирдропами\",\"波卡平行链插槽竞拍\":\"Аукцион слотов Polkadot parachain\",\"一键挖矿，日日增收\":\"Вносите депозит одним щелчком мыши и зарабатывайте проценты каждый день\",\"ETH2.0，一键换币\":\"Конвертируйте токены одним щелчком мыши\",\"质押借币\":\"Крипто-Займы\",\"数字资产，尊享急速到账体验\":\"Получайте быстрый доход от ваших цифровых активов\",\"双币投资\":\"Бивалютные инвестиции\",\"掌握价格波动，财富稳定增值\":\"Цените свои активы на волатильных рынках\",\"Learn\":\"Обучение\",\"Rewards Hub\":\"Центр Наград\",\"资产总览\":\"Обзор активов\",\"策略账户\":\"Стратегия\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Крипто-займы\",\"期权账户\":\"Счёт Опционов\",\"限量优惠\":\"Ограниченные привилегии\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Список ботов\",\"存币宝订单\":\"Финансовый Заказы\",\"质押借币订单\":\"Крипто-Займы\",\"返佣收益看板\":\"Панель рефералов\",\"站内信\":\"Сообщение\",\"查看全部\":\"Посмотреть все\",\"暂无最新消息\":\"Нет последних сообщений\",\"隐藏已读\":\"Скрыть прочитанные\",\"全部标为已读\":\"Все помечены как прочитанные\",\"扫码下载 APP\":\"Сканировать и скачать App\",\"更多客户端\":\"Больше вариантов\",\"语言\":\"Язык\",\"折算货币\":\"Валюта\",\"提示\":\"Напоминание\",\"确认将全部未读消息标记为已读？\":\"Вы уверены, что отметите все непрочитанные сообщения как прочитанные??\",\"了解VIP\":\"О VIP\",\"精英会员\":\"Элитный VIP\",\"银卡VIP\":\"Серебряная Карта VIP\",\"金卡VIP\":\"Золотая Карта VIP\",\"白金卡VIP\":\"Платиновая Карта VIP\",\"黑卡VIP\":\"Чёрная Карта VIP\",\"取消\":\"Отменить\",\"确定\":\"Подтвердить\",\"快捷一键买卖\":\"Быстрая Покупка/Продажа\",\"法币充值\":\"Фиатный Депозит\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Сторонний сервис\",\"自选\":\"Избранное\",\"现货\":\"Спот\",\"合约\":\"Фьючерсы\",\"全仓杠杆\":\"Кросс маржа\",\"逐仓杠杆\":\"Изолированная маржа\",\"Tradingbot 策略交易\":\"Торговый Бот\",\"期权交易\":\"Опционы\",\"理财相关\":\"Инвестиционные\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Прочие\",\"节点质押投票\":\"Стейкинг и голосование\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Брокеридж (Лендинг)\",\"OTC交易系统\":\"Брокеридж (ОТС)\",\"我的资产\":\"Мои активы\",\"我的订单\":\"Мои ордера\",\"消息\":\"Сообщение\",\"我的福利\":\"Мои награды\",\"邀请返佣看板\":\"Панель рефералов\",\"账户安全\":\"Защита\",\"子账号管理\":\"Управление суб-аккаунтом\",\"扫码下载 huobi App\":\"Отсканируйте, чтобы скачать приложение\",\"更多方式\":\"Больше способов\",\"升级还需要现货交易<span>#num#U</span>\":\"Торгуйте еще на <span>#num# USDT</span> на Споте, чтобы увеличить уровень\",\"升级还需要合约交易<span>#num#U</span>\":\"Торгуйте еще на <span>#num# USDT</span> на Фьючерсах, чтобы увеличить уровень\",\"升级还需要资沉<span>#num#U</span>\":\"Внесите еще <span>#num# USDT</span>, чтобы увеличить уровень\",\"手续费#num#折\":\"#num# скидка на торговые комиссии\",\"HT抵扣#num#%\":\"#num#% скидка при использовании HT\",\"生日好礼\":\"Подарок на День Рождения\",\"杠杆\":\"Маржинальный\",\"理财\":\"Earn\",\"法币\":\"Фиатный\",\"Welcome to Huobi\":\"Добро пожаловать в HTX\",\"There will be more exciting after login\":\"Еще больше сюрпризов ждет вас после входа в систему!\",\"全部资产\":\"Всего активов\",\"Today’s P/L\":\"P/L сегодня\",\"点击查看\":\"Просмотреть\",\"下载App\":\"Скачать приложение\",\"退出登录\":\"Выйти\",\"关于火币\":\"О HTX\",\"关于我们\":\"О нас\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Цифровые активы\",\"火币云服务\":\"Облако HTX\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Связь с CEO\",\"官网验证通道\":\"Проверка Медиа\",\"产品功能\":\"Продукты\",\"一键买币\":\"Покупка/Продажа Быстро\",\"TradingBot\":\"Торговый Бот\",\"金融服务\":\"Финансы\",\"火币社区\":\"Сообщество HTX\",\"服务介绍\":\"Услуги\",\"认证服务\":\"Верификация Личности\",\"费率介绍\":\"Многоуровневые Комиссии\",\"币币交易规则\":\"Правила Спотовой Торговли\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Партнерская Программа\",\"经纪商申请\":\"Брокерская Программа\",\"广告方认证服务\":\"Заявка V-Рекламодателя P2P\",\"开放平台\":\"Открытая Платформа\",\"API介绍\":\"API Документация\",\"活动福利\":\"Мероприятия и Привилегии\",\"新用户奖励\":\"Приветственный Бонус\",\"入金奖励\":\"Награды за Депозит\",\"交易奖励\":\"Награды за Торговлю\",\"免费领空投\":\"Аирдропы\",\"月度大促\":\"Ежемесячные Промо-акции\",\"购买加密货币\":\"Купить Криптовалюты\",\"未认证\":\"Не подтверждено\",\"合约跟单\":\"Копи-трейдинг\",\"福利中心\":\"Центр наград\",\"机构\":\"Институты\",\"快捷买币\":\"Быстрая торговля\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Покупайте виртуальные активы с помощью Visa, Mastercard и т. д.\",\"满足低手续费多种法币的充值\":\"Внесите депозит фиатной валюты с низкой комиссией\",\"多种法币0手续费最优价格\":\"Лучшая цена с нулевой комиссией\",\"自选交易对，行情尽在掌握\":\"Следите за любимыми торговыми парами в реальном времени\",\"直达现货市场，抓住交易机会\":\"Воспользуйтесь возможностями торговли на спотовых рынках\",\"了解合约行情动态，获取超额收益\":\"Зарабатывайте огромную прибыль на фьючерсных рынках\",\"交易\":\"Торговля\",\"使用完整的交易功能，买卖虚拟资产\":\"Торгуйте виртуальными активами с помощью наших передовых инструментов\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Увеличьте кредитное плечо без риска ликвидации\",\"借币交易，放大现货收益\":\"Используйте кредитное плечо, чтобы увеличить свою прибыль\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Торгуйте автоматически с помощью количественных стратегий\",\"火币闪兑\":\"Конвертация\",\"币币兑换，零费率无滑点\":\"Обмен крипто-крипто, нулевая комиссия, без проскальзывания\",\"衍生品\":\"Деривативы\",\"以USDT结算的合约交易\":\"Фьючерсные продукты с расчетом в USDT\",\"币本位合约\":\"Coin-M Фьючерсы\",\"以加密货币结算的合约交易\":\"Фьючерсные продукты с расчетом в криптовалютах\",\"欧式美式期权随心选择，财富稳定增值\":\"Опционы в европейском и американском стиле для приумножения ваших активов\",\"自动跟随专业交易员下单，轻松盈利\":\"Торгуйте как эксперты, следуя за их сделками\",\"Huobi合约嘉年华\":\"Праздник фьючерсов\",\"参加交易 iPhone14Pro Max等你拿\":\"Торгуйте, чтобы выиграть iPhone 14 Pro Max и многое другое\",\"理财_menu\":\"Заработок\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Зарабатывайте пассивный доход на своих виртуальных активах\",\"非保本高额收益结构型理财\":\"Структурированный продукт с повышенной доходностью\",\"便捷抵押，安全交易\":\"Быстрые криптозаймы для удовлетворения ваших торговых потребностей\",\"扩大交易规模和种类，实现多倍收益\":\"Возьмите в долг, чтобы увеличить объём торговли и прибыли\",\"金融服务_menu\":\"Финансы\",\"迎接以太坊2.0\":\"Новая эра для Ethereum\",\"随借随还实时到账\":\"Берите в долг и погашайте легко в любое время\",\"尊享大宗交易零手续费\":\"Совершайте блоковые сделки с нулевой комиссией\",\"社区\":\"Сообщество\",\"Huobi社区\":\"Сообщество HTX\",\"在这里发现币圈财富机会\":\"Исследуйте и раскрывайте возможности богатства\",\"快讯\":\"Новости\",\"7*24最全币圈资讯\":\"Последние крипто новости у вас под рукой\",\"长文\":\"Статья\",\"深入了解最新行业动态\":\"Погрузитесь глубоко в крипто информацию\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Настройтесь на все, что связано с криптой\",\"从入门到精通一站式学习平台\":\"Учитесь, торгуйте и зарабатывайте\",\"博客\":\"Blog HTX\",\"Huobi最新资讯和业务报道\":\"Будьте в курсе последних историй и отчетов\",\"活动\":\"Активности\",\"轻松赚币，天天领奖\":\"Выигрывайте криптовалюты и другие награды каждый день\",\"新币福利营带你发现最佳资产\":\"Откройте для себя следующий крупный криптопроект\",\"虚拟资产财富之旅的记忆凭证\":\"Получите веселье и отличные призы\",\"交易赛\":\"Торговый конкурс\",\"牛人大师都爱的大赛\":\"Проложите свой путь к таблице лидеров\",\"通往Web 3.0的虚拟资产钱包\":\"Глобальный кошелек виртуальных активов и шлюз в Web 3.0\",\"云钱包\":\"Облачный кошелёк\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi стало проще благодаря облачному хранилищу закрытых ключей\",\"场外借贷\":\"OTC Займ\",\"我的费率\":\"Моя ставка комиссии\",\"我的邀请返佣\":\"Мои рефералы\",\"合约社群\":\"Сообщество HTX Futures\",\"经纪商看板\":\"Панель инструментов Брокера\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Контент\",\"多米尼克数字公民\":\"Цифровое Гражданство Доминики\",\"体验\":\"Пробный\",\"正式\":\"Формальный\",\"高级\":\"Расширенный\",\"Prime会员权益\":\"Преимущества Prime\",\"体验卡\":\"Пробный период\",\"查看权益\":\"Просмотр преимуществ\",\"Global Licensed Businesses\":\"Глобальный лицензированный бизнес\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Внешний вид\",\"专业版\":\"Профессиональный\",\"经典版\":\"Классический\",\"颜色偏好\":\"Цветовые предпочтения\",\"绿涨红跌\":\"Зеленый вверх/Красный вниз\",\"红涨绿跌\":\"Красный вверх/Зеленый вниз\",\"储备金证明\":\"Сведения о Резервах\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Использовать балансы в Earn для торговли\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"При включении этой функции ваши доступные активы для спотовой торговли будут отображаться как сумма доступного баланса котируемой валюты на вашем Спотовом аккаунте без заимствований и баланса котируемой валюты в продукте Earn - Гибкий. Баланс текущей криптовалюты в Гибком продукте будет автоматически погашаться только в случае необходимости для спотовой торговли.\",\"行情资讯\":\"Рынки\",\"HTX专区\":\"Зона $HTX\",\"一键收取HTX\":\"Получить $HTX\",\"任务奖励日日解锁\":\"Ежедневные задания\",\"加密货币价格\":\"Цены криптовалют\",\"搜索\":\"Поиск\",\"热门资产\":\"Популярные активы\",\"热门话题\":\"Популярные\",\"热门赚币\":\"Высокая доходность\",\"全部\":\"Все\",\"功能\":\"Фьючерсы\",\"资讯\":\"Новости\",\"公告\":\"Объявления\",\"用户\":\"Пользователи\",\"#num#预约\":\"#num# подписавшихся\",\"#num#观看\":\"#num# смотрят\",\"#num#回放\":\"#num# просмотров\",\"预约\":\"Подписаться\",\"看直播\":\"Смотреть трансляцию\",\"看回放\":\"Смотреть запись\",\"暂无内容\":\"Нет доступного контента\",\"永续\":\"Бессрочный\",\"当周\":\"Еженед.\",\"次周\":\"Двухнед.\",\"当季\":\"Квартальн.\",\"次季\":\"Двухквартал.\",\"#num#粉丝\":\"#num# Подписчиков\",\"关注\":\"Следовать\",\"已关注\":\"Отслеживаемые\",\"站点地图\":\"Криптовалютная карта\",\"相机扫码下载<p>火币App</p>\":\"Наведите камеру на QR-код <p>для загрузки приложения HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Депозит\",\"提币\":\"Вывод\",\"划转\":\"Перевод\",\"储备金证明报告\":\"Отчеты о Резервах\",\"切换账号\":\"Сменить\",\"提醒\":\"Внимание\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"После удаления аккаунта вместе с записями входа в него вам нужно будет ввести пароль при следующем входе в этот аккаунт.\",\"确认\":\"Подтвердить\",\"其他账号\":\"Другие основные аккаунты\",\"管理\":\"Управление\",\"完成\":\"Готово\",\"搜索子账号\":\"Поиск\",\"暂无数据\":\"Субсчетов пока нет\",\"创建子账号\":\"Создать\",\"清除\":\"Удалить\",\"添加其他账号\":\"Добавить\",\"主账号\":\"Основной аккаунт\",\"最多添加10个其他账号，请清除后再添加\":\"Вы можете добавить до 10 учетных записей. Пожалуйста, удалите старый аккаунт, прежде чем добавлять новый.\",\"我知道了\":\"Понятно\",\"我的邀请奖励\":\"Мои Рефералы\",\"复制成功\":\"Скопировано\",\"交易机器人\":\"Торговые Боты\",\"借币\":\"Займы\",\"充值&提现状态\":\"Статус Депозита и Вывода\"}");

/***/ }),
/* 115 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Kripto SSS\",\"做市商申请\":\"Piyasa Satıcısı Başvurusu\",\"火币网-领先的比特币交易平台\":\"HTX - Leading Bitcoin Exchange\",\"工具\":\"Araçlar\",\"客户端下载\":\"Uygulamayı İndir\",\"API文档\":\"API Dokümantasyonu\",\"数字资产介绍\":\"Dijital Varlıkların Tanıtımı\",\"官方验证通道\":\"Resmi Medya Doğrulayıcısı\",\"历史数据下载\":\"Veri Geçmişini İndir\",\"邀请奖励\":\"Davet Ödülü\",\"服务\":\"Hizmetler\",\"费率\":\"Komisyon Oranları\",\"交易规则介绍\":\"İşlem Kuralları\",\"借币额度\":\"Coin loan limit\",\"帮助中心\":\"Yardım Merkezi\",\"Global CEO 信箱\":\"Contact Global CEO\",\"新手指南\":\"Rehberler\",\"合约课堂\":\"Kontrat Akademisi\",\"法币XXX\":\"FiatXXX\",\"杠杆介绍\":\"Margin Tanıtımı\",\"HT介绍\":\"HT Tanıtımı\",\"支持\":\"Destek\",\"上币申请\":\"Listeleme Başvuruları\",\"机构服务\":\"Kurumsal Hizmetler\",\"大客户权益\":\"Özel Kullanıcı Ayrıcalıkları\",\"经纪商\":\"HTX Broker Programı\",\"广告方加V认证申请\":\"OTC Onaylı İlan Sahibi Başvurusu\",\"火币集团\":\"HTX\",\"超级返佣\":\"Ortaklık\",\"条款说明\":\"Hizmet Koşulları\",\"用户协议\":\"Kullanıcı Sözleşmesi\",\"隐私条款\":\"Gizlilik Politikası\",\"法币交易规则\":\"OTC Kuralları\",\"关于反洗钱\":\"Kara Para Aklamayı Önleme\",\"加密介绍\":\"Kripto Tanıtımı\",\"首页\":\"Ana Sayfa\",\"火币合约\":\"HTX Contract\",\"买币\":\"Kripto Al\",\"行情\":\"Piyasalar\",\"币币交易\":\"Spot İşlemler\",\"成长学院\":\"HTX Learn\",\"登录\":\"Giriş\",\"注册\":\"Kaydol\",\"资产\":\"Varlıklar\",\"现货账户（充币&提币）\":\"Spot Hesabı (yatırma & çekme)\",\"币币账户\":\"İşlem Hesabı\",\"杠杆账户\":\"Margin Hesabı\",\"法币账户\":\"OTC Hesabı\",\"合约账户\":\"Kontrat Hesabı\",\"矿池账户\":\"Pool\",\"我的点卡\":\"Point Kartlarım\",\"信用卡买币\":\"Kredi Kartı ile Satın Al\",\"订单\":\"Emirler\",\"现货&杠杆订单\":\"Spot ve Marjin Emirleri\",\"法币订单\":\"OTC Emirleri\",\"合约订单\":\"Kontrat Emirleri\",\"Buy&Sell History\":\"Alım-Satım geçmişi\",\"账户&安全\":\"Hesap ve Güvenlik\",\"身份认证\":\"Kimlik Doğrulama\",\"法币设置\":\"OTC Ayarları\",\"费率设置\":\"Komisyon Ayarları\",\"专业费率重磅升级\":\"Ücret Promosyonu\",\"我的优惠券\":\"My coupon\",\"积分中心\":\"Sadakat Klübü\",\"邀请返佣\":\"Arkadaşlarını Davet Et\",\"API管理\":\"API Ayarları\",\"子账号\":\"Alt Hesap Ayarları\",\"退出\":\"Çıkış Yap\",\"交易所\":\"Borsa\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Kore\",\"火币日本\":\"HTX Japonya\",\"集团生态服务\":\"HTX Grubu'nun ekolojik servisleri\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"HTX Küresel Ekosistem Fonu\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"En iyi teklifleri veren satıcıyı seçin\",\"一键买卖\":\"Hızlı Satın Al/Sat\",\"快捷安全的数字资产交易\":\"Hızlı ve güvenli dijital varlık işlemleri\",\"现货交易\":\"İşlem Yap\",\"币币兑换，零费率，无滑点\":\"Tokenler arası işlemler, sıfır ücret, alış satış farkı yok\",\"杠杆交易\":\"Margin\",\"借币增加本金，放大收益\":\"Kaldıraç ile kârınızı katlayın\",\"策略交易\":\"Trading Bot\",\"7×24小时自动低买高卖\":\"7/24 Otomatik olarak düşükten al ve yüksekten sat\",\"场外大宗交易\":\"Aracılık (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"OTC blok işlemleri ve kredi hizmetleri için lider platform\",\"合约交易\":\"Vadeli İşlemler\",\"合约总览\":\"Türevlere Genel Bakış\",\"查看全部数字货币衍生产品\":\"Tüm kripto türevlerini anında görüntüleyin\",\"币本位交割\":\"Coin Teslimat\",\"每日结算，强大的风控实力支持\":\"Gün içi mahsuplaşma, güçlü risk kontrol sistemimiz tarafından desteklenmektedir\",\"币本位永续\":\"Coin Perpetual\",\"担保资产价值稳定，减少持仓风险\":\"Daha az risk ile istikrarlı varlık değerlenmesi\",\"U本位合约\":\"USDT Teminatlı Kontrat\",\"返佣高达60%\":\"%60'a varan komisyonlar\",\"期权\":\"Options\",\"多种玩法，自由做多做空\":\"Uzun veya kısa, istediğiniz gibi işlem yapın\",\"金融业务\":\"Finans Hizmeti\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Oy verin ve yüksek ödüllerin tadını çıkarın\",\"锁仓更简单，免费领空投\":\"Tokenlerinizi kolayca kilitleyin ve ücretsiz airdropların keyfini çıkarın\",\"波卡平行链插槽竞拍\":\"Polkadot parachain slot müzayedesi\",\"一键挖矿，日日增收\":\"Tek tıkla yatırın ve her gün getiri kazanın\",\"ETH2.0，一键换币\":\"Tek tıkla tokenleri dönüştürün\",\"质押借币\":\"Crypto Loans\",\"数字资产，尊享急速到账体验\":\"Dijital varlıklarınızın hızlı transferinin keyfini çıkarın\",\"双币投资\":\"İkili Yatırım\",\"掌握价格波动，财富稳定增值\":\"Değişken piyasalar arasında varlıklarınızın değerini artırın\",\"Learn\":\"Akademi\",\"资产总览\":\"Varlıklara Genel Bakış\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Crypto Loans\",\"期权账户\":\"Opsyion Hesabı\",\"限量优惠\":\"Sınırlı İndirim\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Strateji\",\"存币宝订单\":\"Birikim Emri\",\"质押借币订单\":\"Crypto Loans\",\"返佣收益看板\":\"Davet Panosu\",\"站内信\":\"İleti\",\"查看全部\":\"Hepsini gör\",\"暂无最新消息\":\"Güncelleme yok\",\"隐藏已读\":\"Okumayı gizle\",\"全部标为已读\":\"Tümü okundu olarak işaretlendi\",\"扫码下载 APP\":\"App indirmek için QR kodunu tarayın!\",\"更多客户端\":\"Daha Fazla Seçenek\",\"语言\":\"Dil\",\"折算货币\":\"Para Birimi\",\"提示\":\"Hatırlatma\",\"确认将全部未读消息标记为已读？\":\"Okunmamış tüm mesajları okundu olarak işaretlediğinizden emin misiniz?\",\"了解VIP\":\"VIP Hakkında Bilgi\",\"精英会员\":\"Elite VIP\",\"银卡VIP\":\"Silver card VIP\",\"金卡VIP\":\"Gold card VIP\",\"白金卡VIP\":\"Platinum card VIP\",\"黑卡VIP\":\"Black card VIP\",\"取消\":\"İptal et\",\"确定\":\"Onayla\",\"快捷一键买卖\":\"Hızlı Al/Sat\",\"法币充值\":\"İtibari Para Yatırma\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Üçüncü Taraf\",\"自选\":\"Favoriler\",\"现货\":\"Spot\",\"合约\":\"Futures\",\"全仓杠杆\":\"Çapraz Marjin\",\"逐仓杠杆\":\"İzole Marjin\",\"Tradingbot 策略交易\":\"İşlem Botu\",\"期权交易\":\"Options\",\"理财相关\":\"Yatırımla ilgili\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Diğerleri\",\"节点质押投票\":\"Staking ve Oylama\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Brokerlik (Borç Verme)\",\"OTC交易系统\":\"Brokerlik (OTC)\",\"我的资产\":\"Varlıklarım\",\"我的订单\":\"Emirlerim\",\"消息\":\"Mesaj\",\"我的福利\":\"Ödüllerim\",\"邀请返佣看板\":\"Davet Panosu\",\"账户安全\":\"Güvenlik\",\"子账号管理\":\"Alt Hesap Yönetimi\",\"扫码下载 huobi App\":\"Uygulamayı indirmek için tarayın\",\"更多方式\":\"Diğer yöntemler\",\"升级还需要现货交易<span>#num#U</span>\":\"Seviye atlamak için <span>#nNum# USDT</span>daha spot işlem yapın\",\"升级还需要合约交易<span>#num#U</span>\":\"Seviye atlamak için <span>#nNum# USDT</span>daha Futures işlemi yapın\",\"升级还需要资沉<span>#num#U</span>\":\"Seviye atlamak için <span>#nNum# USDT</span>daha yatırma işlemi yapın\",\"手续费#num#折\":\"İşlem ücretlerinde #num# indirim\",\"HT抵扣#num#%\":\"HT ile %#num# indirim\",\"生日好礼\":\"Doğum Günü Hediyesi\",\"杠杆\":\"Marjin\",\"理财\":\"Earn\",\"法币\":\"İtibari para\",\"Welcome to Huobi\":\"HTX'e Hoş Geldiniz\",\"There will be more exciting after login\":\"Giriş yaptıktan sonra sürprizler sizi bekliyor!\",\"全部资产\":\"Toplam Varlıklar\",\"Today’s P/L\":\"Bugünkü K/Z\",\"P/L\":\"K/Z\",\"点击查看\":\"Görüntülemek için tıklayın\",\"下载App\":\"Uygulamayı İndir\",\"退出登录\":\"Çıkış Yap\",\"关于火币\":\"HTX Hakkında\",\"关于我们\":\"Hakkımızda\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Dijital Varlık\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"CEO ile İletişim\",\"官网验证通道\":\"Medya Doğrulayıcı\",\"产品功能\":\"Ürünler\",\"一键买币\":\"Hızlı Al/Sat\",\"TradingBot\":\"İşlem Botu\",\"金融服务\":\"Finans Hizmeti\",\"火币社区\":\"HTX Topluluğu\",\"服务介绍\":\"Hizmetler\",\"认证服务\":\"Kimlik Doğrulama\",\"费率介绍\":\"Katmanlı Ücret\",\"币币交易规则\":\"Spot İşlem Kuralları\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Ortaklık Programı\",\"经纪商申请\":\"Broker Programı\",\"广告方认证服务\":\"P2P Onaylı İlan Sahibi Başvurusu\",\"开放平台\":\"Açık Platform\",\"API介绍\":\"API Dökümantasyonu\",\"活动福利\":\"Etkinlik ve Ayrıcalıklar\",\"新用户奖励\":\"Hoş Geldin Ödülü\",\"入金奖励\":\"Yatırma Ödülleri\",\"交易奖励\":\"İşlem Ödülleri\",\"免费领空投\":\"Airdrop Kazanın\",\"月度大促\":\"Aylık Kampanyalar\",\"购买加密货币\":\"Kripto Satın Al\",\"未认证\":\"Doğrulanmamış\",\"合约跟单\":\"Kopyalamalı İşlem\",\"福利中心\":\"Ödül Merkezi\",\"机构\":\"Kurum\",\"快捷买币\":\"Hızlı İşlem\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Visa, Mastercard ve daha fazla yöntemle sanal varlık satın alın\",\"满足低手续费多种法币的充值\":\"Düşük ücretle itibari para yatırın\",\"P2P\":\"OTC\",\"多种法币0手续费最优价格\":\"En iyi fiyatlardan ücretsiz faydalanın\",\"自选交易对，行情尽在掌握\":\"En sevdiğiniz işlem çiftini gerçek zamanlı takip edin\",\"直达现货市场，抓住交易机会\":\"Spot Piyasadaki alım satım fırsatlarını değerlendirin\",\"了解合约行情动态，获取超额收益\":\"Futures Piyasa ile getirilerinizi katlayın\",\"交易\":\"İşlem\",\"使用完整的交易功能，买卖虚拟资产\":\"Gelişmiş araçlarımızla sanal varlıkları alın ve satın\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Likidasyon riski olmadan kaldıraç kullanın\",\"借币交易，放大现货收益\":\"Kaldıraç kullanarak getirinizi artırın\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Bot stratejileriyle otomatik alım satım yapın\",\"火币闪兑\":\"Dönüştür\",\"币币兑换，零费率无滑点\":\"Tokenler arası işlemlerde sıfır ücret, alış satış farkı yok\",\"衍生品\":\"Futures\",\"以USDT结算的合约交易\":\"Futures ürünleri USDT cinsinden mahsuplaşır\",\"币本位合约\":\"Coin Futures\",\"以加密货币结算的合约交易\":\"Futures ürünleri kripto cinsinden mahsuplaşır\",\"欧式美式期权随心选择，财富稳定增值\":\"Varlıklarınızı katlamak için Avrupa ve Amerikan opsiyonları\",\"自动跟随专业交易员下单，轻松盈利\":\"Yatırımlarını takip ederek uzmanlar gibi işlem yapın\",\"Huobi合约嘉年华\":\"Futures Kutlaması\",\"参加交易 iPhone14Pro Max等你拿\":\"iPhone 14 Pro Max ve daha fazlasını kazanmak için işlem yapın\",\"理财_menu\":\"Earn\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Sanal varlıklarınızla pasif gelir elde edin\",\"非保本高额收益结构型理财\":\"Daha iyi getiri sağlayan çeşitli ürünler\",\"便捷抵押，安全交易\":\"Yatırım ihtiyaçlarınızı karşılayacak hızlı kripto krediler\",\"扩大交易规模和种类，实现多倍收益\":\"Yatırımlarınızın ve getirilerinizin miktarını artırmak için ödünç alın\",\"金融服务_menu\":\"Finans\",\"迎接以太坊2.0\":\"Ethereum'da yeni bir çağ\",\"随借随还实时到账\":\"İstediğiniz zaman ödünç alın ve geri ödeyin\",\"尊享大宗交易零手续费\":\"Sıfır ücretle blok işlemler yapın\",\"社区\":\"Topluluk\",\"Huobi社区\":\"HTX Topluluğu\",\"在这里发现币圈财富机会\":\"Kazanç fırsatlarını keşfedin\",\"快讯\":\"Haberler\",\"7*24最全币圈资讯\":\"Kripto ile ilgili en son haberler parmaklarınızın ucunda\",\"长文\":\"Makale\",\"深入了解最新行业动态\":\"Derin analizleri inceleyin\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Kripto ile ilgili her şeyde takipte kalın\",\"从入门到精通一站式学习平台\":\"Öğren, işlem yap ve kazan\",\"博客\":\"HTX Blog\",\"Huobi最新资讯和业务报道\":\"En son hikayelerden ve raporlardan haberdar olun\",\"活动\":\"Etkinlik\",\"轻松赚币，天天领奖\":\"Her gün kripto ve diğer ödülleri kazanın\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Bir sonraki büyük kripto projesini keşfedin\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Eğlenceyi ve harika ödülleri yakalayın\",\"交易赛\":\"İşlem Yarışması\",\"牛人大师都爱的大赛\":\"Liderlik sıralamasında birinciliğe oynayın\",\"通往Web 3.0的虚拟资产钱包\":\"Küresel bir sanal varlık cüzdanı ve Web 3.0'a açılan kapınız\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"Özel anahtarların bulutta depolanması sayesinde DeFi kullanışlı hale gelir\",\"场外借贷\":\"OTC Loan\",\"我的费率\":\"Ücret Oranlarım\",\"我的邀请返佣\":\"Davetlilerim\",\"合约社群\":\"HTX Futures Topluluğu\",\"经纪商看板\":\"Broker Paneli\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"İçerik\",\"多米尼克数字公民\":\"Dominika Dijital Vatandaşlığı\",\"体验\":\"Deneme\",\"正式\":\"Resmi\",\"高级\":\"Gelişmiş Doğrulama\",\"Prime会员权益\":\"Prime Üyeliği Ayrıcalıkları\",\"体验卡\":\"Deneme\",\"查看权益\":\"Ayrıcalıkları Gör\",\"Global Licensed Businesses\":\"Küresel Lisanslı İşletmeler\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Görünüm\",\"专业版\":\"Pro\",\"经典版\":\"Klasik\",\"颜色偏好\":\"Renk Tercihi\",\"绿涨红跌\":\"Yeşil yukarı/Kırmızı aşağı\",\"红涨绿跌\":\"Kırmızı yukarı/Yeşil aşağı\",\"储备金证明\":\"Rezerv Kanıtı\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Earn'deki bakiyeyle işlem yap\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Bu özelliği etkinleştirdiğinizde, spot işlem için kullanılabilir varlıklarınız, Spot hesabınızdaki borçlanma olmadan mevcut teklif edilen para birimi bakiyesinin ve Earn - Esnek üründeki teklif edilen para biriminin toplamı olarak görüntülenecektir. Esnek üründeki mevcut kripto bakiyesi yalnızca spot işlem için gerekli olduğunda otomatik olarak geri alınacaktır.\",\"行情资讯\":\"Piyasalar\",\"HTX专区\":\"$HTX Zone\",\"一键收取HTX\":\"$HTX Al\",\"任务奖励日日解锁\":\"Günlük görev ödüllerinin kilidini açın\",\"加密货币价格\":\"Kripto Fiyatları\",\"搜索\":\"Ara\",\"热门资产\":\"Popüler Varlıklar\",\"热门话题\":\"Trend Konular\",\"热门赚币\":\"Popüler Getiriler\",\"全部\":\"Tümü\",\"功能\":\"Özellikler\",\"资讯\":\"Haberler\",\"公告\":\"Duyurular\",\"用户\":\"Kullanıcılar\",\"#num#预约\":\"#num# abone\",\"#num#观看\":\"#num# izleyici\",\"#num#回放\":\"#num# oynatma\",\"预约\":\"Abone ol\",\"看直播\":\"Canlı İzle\",\"看回放\":\"Kaydı İzle\",\"暂无内容\":\"Henüz içerik yok\",\"永续\":\"Swap\",\"当周\":\"Haftalık\",\"次周\":\"İki Haftalık\",\"当季\":\"Üç Aylık\",\"次季\":\"Altı Aylık\",\"#num#粉丝\":\"#num# Takipçi\",\"关注\":\"Takip et\",\"已关注\":\"Takip edildi\",\"站点地图\":\"Kriptolar Site Haritası\",\"相机扫码下载<p>火币App</p>\":\"<p>HTX Uygulamasını</p> indirmek için QR kodu kameraya okutun\",\"漏洞赏金\":\"Bug Ödülü\",\"充币\":\"Yatır\",\"提币\":\"Çek\",\"划转\":\"Transfer\",\"储备金证明报告\":\"Rezerv Kanıtları\",\"切换账号\":\"Değiştir\",\"提醒\":\"Not\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Hesabı giriş kayıtlarıyla birlikte sildikten sonra, bu hesaba bir sonraki girişinizde şifreyi girmeniz gerekecektir.\",\"确认\":\"Onayla\",\"其他账号\":\"Diğer Ana Hesaplar\",\"管理\":\"Yönet\",\"完成\":\"Tamam\",\"搜索子账号\":\"Ara\",\"暂无数据\":\"Henüz alt hesap yok\",\"创建子账号\":\"Oluştur\",\"清除\":\"Sil\",\"添加其他账号\":\"Ekle\",\"主账号\":\"Ana Hesap\",\"最多添加10个其他账号，请清除后再添加\":\"Buraya en fazla 10 hesap eklenebilir. Lütfen hesap eklemeden önce bir hesabı silin.\",\"我知道了\":\"Anladım\",\"我的邀请奖励\":\"Davetlilerim\",\"复制成功\":\"Kopyalandı\",\"交易机器人\":\"İşlem Botları\",\"借币\":\"Loans\",\"充值&提现状态\":\"Yatırma ve Çekme Durumu\"}");

/***/ }),
/* 116 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Crypto FAQ\",\"做市商申请\":\"Заявка для маркет-мейкерів\",\"火币网-领先的比特币交易平台\":\"HTX — провідна біржа\",\"工具\":\"Інструменти\",\"客户端下载\":\"Завантажити додаток\",\"API文档\":\"Документи API\",\"数字资产介绍\":\"Введення цифрових активів\",\"官方验证通道\":\"Офіційний аутентифікатор носіїв інформації\",\"Huobi Blog\":\"Блог HTX\",\"历史数据下载\":\"Історія завантаження даних\",\"邀请奖励\":\"Посилання\",\"服务\":\"Послуги\",\"Buy HUSD\":\"Купити HUSD\",\"费率\":\"Ставка комісійної винагороди\",\"交易规则介绍\":\"Правила торгівлі\",\"借币额度\":\"Ліміт кредиту на монети\",\"帮助中心\":\"Підтримка\",\"Global CEO 信箱\":\"Зв'язатися з генеральним директором\",\"新手指南\":\"Керівництво\",\"合约课堂\":\"Академія деривативів\",\"法币XXX\":\"FiatXXX\",\"杠杆介绍\":\"Введення маржі\",\"HT介绍\":\"Введення HT\",\"支持\":\"Підтримка\",\"上币申请\":\"Подати заявку на включення в список\",\"机构服务\":\"Інституційні послуги\",\"大客户权益\":\"Ключові привілеї клієнтів\",\"经纪商\":\"Програма брокера\",\"广告方加V认证申请\":\"P2P заявка V-рекламодавця\",\"火币集团\":\"HTX\",\"超级返佣\":\"Партнер\",\"条款说明\":\"Умови надання послуг\",\"用户协议\":\"Угода користувача\",\"隐私条款\":\"Політика конфіденційності\",\"执法和监管查询\":\"Правозастосування та регуляторні запити\",\"法币交易规则\":\"Фіатні правила\",\"关于反洗钱\":\"Боротьба з відмиванням грошей\",\"加密介绍\":\"Введення в криптовалюти\",\"首页\":\"Головна\",\"火币合约\":\"Контракт HTX\",\"OTC Market\":\"Ринок OTC\",\"买币\":\"Купити\",\"行情\":\"Ринки\",\"币币交易\":\"Спотова торгівля\",\"成长学院\":\"HTX Learn\",\"登录\":\"Увійти\",\"注册\":\"Зареєструватися\",\"资产\":\"Активи\",\"现货账户（充币&提币）\":\"Спотовий рахунок (депозит і зняття)\",\"币币账户\":\"Біржовий рахунок\",\"杠杆账户\":\"Маржинальний рахунок\",\"法币账户\":\"Фіатний рахунок\",\"合约账户\":\"Рахунок деривативів\",\"矿池账户\":\"Пул\",\"我的点卡\":\"Мої Point Cards\",\"信用卡买币\":\"Купити з кредитної картки\",\"订单\":\"Ордери\",\"现货&杠杆订单\":\"Спотові та Маржинальні ордери\",\"法币订单\":\"Фіатні ордери\",\"合约订单\":\"Ордери на деривативи\",\"Buy&Sell History\":\"Історія покупок і продажів\",\"账户&安全\":\"Аккаунт і безпека\",\"身份认证\":\"Ідентифікація\",\"法币设置\":\"Налаштування фіата\",\"费率设置\":\"Налаштування фіата\",\"专业费率重磅升级\":\"Підвищення плати\",\"我的优惠券\":\"Мій купон\",\"积分中心\":\"Клуб лояльності\",\"邀请返佣\":\"Запросити друзів\",\"API管理\":\"Управління API\",\"子账号\":\"Субаккаунт\",\"退出\":\"Виписка\",\"交易所\":\"Біржа\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Корея\",\"火币日本\":\"HTX Японія\",\"集团生态服务\":\"Еко-послуги HTX\",\"火币矿池\":\"Пул HTX\",\"火信\":\"Чат HTX\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"Еко-фонд HTX\",\"火币云\":\"Хмара HTX\",\"火币生态链\":\"Еколанцюг HTX\",\"火币DeFi Labs\":\"Лабораторії HTX DeFi\",\"火币OTC\":\"Фіат HTX\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Виберіть продавця з найкращими пропозиціями\",\"一键买卖\":\"Швидка покупка/продаж\",\"快捷安全的数字资产交易\":\"Швидкі та безпечні операції з цифровими активами\",\"现货交易\":\"Торгівля\",\"币币兑换，零费率，无滑点\":\"Обмін токена на токен, нульова комісія, відсутність прослизання\",\"杠杆交易\":\"Маржа\",\"借币增加本金，放大收益\":\"Помножте свій прибуток із кредитним плечем\",\"策略交易\":\"Торговий бот\",\"7×24小时自动低买高卖\":\"Автоматично купуйте дешево та продавайте дорого 24/7\",\"场外大宗交易\":\"Брокерські послуги (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Провідна платформа для ОТС угод та кредитних послуг\",\"合约交易\":\"Похідні\",\"合约总览\":\"Огляд деривативів\",\"查看全部数字货币衍生产品\":\"Короткий огляд усіх крипто-деривативів\",\"币本位交割\":\"Доставка монет\",\"每日结算，强大的风控实力支持\":\"Внутрішньоденні розрахунки, які підтримує наша надійна система контролю ризиків\",\"币本位永续\":\"Свопи Coin-margined\",\"担保资产价值稳定，减少持仓风险\":\"Стабільна оцінка активів із меншими ризиками\",\"U本位合约\":\"Контракти USDT-M\",\"返佣高达60%\":\"До 60% комісійних\",\"期权\":\"Опціони\",\"多种玩法，自由做多做空\":\"Відкривайте лонг або шорт позицію, торгуйте так, як вважаєте за потрібне\",\"金融业务\":\"Фінанси\",\"节点投票\":\"Стейкінг\",\"享受高奖励的节点投票\":\"Голосуйте та насолоджуйтесь високими нагородами\",\"锁仓更简单，免费领空投\":\"Легко заблокуйте свої токени та насолоджуйтесь безкоштовними еірдропами\",\"波卡平行链插槽竞拍\":\"Аукціон слотів Polkadot parachain\",\"一键挖矿，日日增收\":\"Вносите депозит одним клацанням миші та заробляйте відсотки щодня\",\"ETH2.0，一键换币\":\"Конвертуйте токени одним клацанням миші\",\"质押借币\":\"Криптопозики\",\"数字资产，尊享急速到账体验\":\"Насолоджуйтесь швидким переведенням ваших цифрових активів\",\"双币投资\":\"Бівалютні інвестиції\",\"掌握价格波动，财富稳定增值\":\"Цінуйте свої активи на волатильних ринках\",\"Learn\":\"Вивчіть\",\"Rewards Hub\":\"Хаб винагород\",\"资产总览\":\"Огляд активів\",\"策略账户\":\"Quant\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Криптопозики\",\"期权账户\":\"Рахунок опціонів\",\"限量优惠\":\"Обмежені привілеї\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Стратегія\",\"存币宝订单\":\"Ощадний ордер\",\"质押借币订单\":\"Криптопозики\",\"返佣收益看板\":\"Панель запрошень\",\"站内信\":\"Повідомлення\",\"查看全部\":\"Переглянути все\",\"暂无最新消息\":\"Немає оновлень\",\"隐藏已读\":\"Приховати прочитане\",\"全部标为已读\":\"Помітити все як прочитане\",\"扫码下载 APP\":\"Скануйте, щоб завантажити\",\"更多客户端\":\"Більше варіантів\",\"语言\":\"Мова\",\"折算货币\":\"Валюта\",\"提示\":\"Нагадування\",\"确认将全部未读消息标记为已读？\":\"Ви відмітили всі повідомлення як прочитані?\",\"了解VIP\":\"Дізнайтеся більше про VIP\",\"精英会员\":\"Розширений\",\"银卡VIP\":\"Інсайдер\",\"金卡VIP\":\"Прем'єр\",\"白金卡VIP\":\"Посол\",\"黑卡VIP\":\"Партнер\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"Ласкаво просимо в HTX. У вас є привілеї HTX %s\",\"取消\":\"Скасувати\",\"确定\":\"Підтвердити\",\"快捷一键买卖\":\"Швидка Купівля/Продаж\",\"法币充值\":\"Фіатний депозит\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Третя сторона\",\"自选\":\"Уподобання\",\"现货\":\"Спот\",\"合约\":\"Ф'ючерси\",\"全仓杠杆\":\"Крос-маржа\",\"逐仓杠杆\":\"Ізольована маржа\",\"Tradingbot 策略交易\":\"Торговий Бот\",\"期权交易\":\"Опціони\",\"理财相关\":\"Інвестиційні\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Інші\",\"节点质押投票\":\"Стейкінг та голосування\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Брокеридж (Кредитування)\",\"OTC交易系统\":\"Брокеридж (OTC)\",\"我的资产\":\"Мої активи\",\"我的订单\":\"Мої ордери\",\"消息\":\"Повідомлення\",\"我的福利\":\"Мої винагороди\",\"邀请返佣看板\":\"Панель рефералів\",\"账户安全\":\"Безпека\",\"子账号管理\":\"Управління субрахунком\",\"扫码下载 huobi App\":\"Скануйте, щоб завантажити додаток\",\"更多方式\":\"Більше методів\",\"升级还需要现货交易<span>#num#U</span>\":\"Торгуйте <span>#num# USDT</span> більше на Споті для підвищення рівня\",\"升级还需要合约交易<span>#num#U</span>\":\"Торгуйте <span>#num# USDT</span> більше на Ф'ючерсах для підвищення рівня\",\"升级还需要资沉<span>#num#U</span>\":\"Внесіть ще <span>#num# USDT</span> для підвищення рівня\",\"手续费#num#折\":\"#num# знижка на торгову комісію\",\"HT抵扣#num#%\":\"#num#% знижка при використанні HT\",\"生日好礼\":\"Подарунок на День Народження\",\"杠杆\":\"Маржинальний\",\"理财\":\"Earn\",\"法币\":\"Фіатний\",\"Welcome to Huobi\":\"Ласкаво просимо до HTX\",\"There will be more exciting after login\":\"Після входу в систему на вас чекає ще більше сюрпризів!\",\"全部资产\":\"Загальні активи\",\"Today’s P/L\":\"P/L сьогодні\",\"点击查看\":\"Переглянути\",\"下载App\":\"Завантажити додаток\",\"退出登录\":\"Вийти\",\"关于火币\":\"Про HTX\",\"关于我们\":\"Про нас\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Цифрові активи\",\"火币云服务\":\"HTX Хмара\",\"火币Defi Labs\":\"Лабораторії HTX DeFi\",\"CEO信箱\":\"Зв'язатися з CEO\",\"官网验证通道\":\"Медіа верифікатор\",\"产品功能\":\"Продукти\",\"一键买币\":\"Швидка покупка/продаж\",\"TradingBot\":\"Торговий бот\",\"金融服务\":\"Фінанси\",\"火币社区\":\"Спільнота HTX\",\"服务介绍\":\"Послуги\",\"认证服务\":\"Підтвердження особи\",\"费率介绍\":\"Багаторівнева комісія\",\"币币交易规则\":\"Правила спотової торгівлі\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Партнерська Програма\",\"经纪商申请\":\"Брокерська програма\",\"广告方认证服务\":\"Заявка V-рекламодавця P2P\",\"开放平台\":\"Відкрита платформа\",\"API介绍\":\"Документація API\",\"活动福利\":\"Події та переваги\",\"新用户奖励\":\"Вітальний бонус\",\"入金奖励\":\"Винагороди за депозит\",\"交易奖励\":\"Торгові винагороди\",\"免费领空投\":\"Отримати Ейдропи\",\"月度大促\":\"Щомісячні акції\",\"购买加密货币\":\"Купити криптовалюти\",\"未认证\":\"Не підтверджено\",\"合约跟单\":\"Копі-трейдинг\",\"福利中心\":\"Центр нагород\",\"机构\":\"Інституції\",\"快捷买币\":\"Швидка торгівля\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Купуйте віртуальні активи за допомогою Visa, Mastercard тощо\",\"满足低手续费多种法币的充值\":\"Внесіть фіатні валюти за низькою комісією\",\"多种法币0手续费最优价格\":\"Отримайте найкращу ціну з нульовою комісією\",\"自选交易对，行情尽在掌握\":\"Слідкуйте за улюбленими торговими парами в реальному часі\",\"直达现货市场，抓住交易机会\":\"Скористайтеся можливостями торгівлі на спотових ринках\",\"了解合约行情动态，获取超额收益\":\"Отримуйте величезні прибутки з ф'ючерсними ринками\",\"交易\":\"Торгівля\",\"使用完整的交易功能，买卖虚拟资产\":\"Торгуйте віртуальними активами за допомогою наших передових інструментів\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Збільште кредитне плече без ризику ліквідації\",\"借币交易，放大现货收益\":\"Використовуйте кредитне плече, щоб збільшити свої прибутки\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Торгуйте автоматично за допомогою кількісних стратегій\",\"火币闪兑\":\"Конвертувати\",\"币币兑换，零费率无滑点\":\"Обмін токена на токен, нульова комісія, відсутність прослизання\",\"衍生品\":\"Деривативи\",\"以USDT结算的合约交易\":\"Ф'ючерсні продукти з розрахунком у USDT\",\"币本位合约\":\"Coin-M Ф'ючерси\",\"以加密货币结算的合约交易\":\"Ф'ючерсні продукти з розрахунком у криптовалютах\",\"欧式美式期权随心选择，财富稳定增值\":\"Опціони в європейському та американському стилі, щоб примножити свої активи\",\"自动跟随专业交易员下单，轻松盈利\":\"Торгуйте як експерт, стежачи за їх торгами\",\"Huobi合约嘉年华\":\"Карнавал ф'ючерсів\",\"参加交易 iPhone14Pro Max等你拿\":\"Торгуйте, щоб виграти iPhone 14 Pro Max і багато іншого\",\"理财_menu\":\"Заробити\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Отримуйте пасивний дохід на своїх віртуальних активах\",\"非保本高额收益结构型理财\":\"Структурований продукт із підвищеною прибутковістю\",\"便捷抵押，安全交易\":\"Швидкі криптокредити для задоволення ваших торгових потреб\",\"扩大交易规模和种类，实现多倍收益\":\"Позичайте, щоб збільшити обсяг торгівлі та прибутків\",\"金融服务_menu\":\"Фінанси\",\"迎接以太坊2.0\":\"Нова ера для Ethereum\",\"随借随还实时到账\":\"Позичайте та легко повертайте в будь-який час\",\"尊享大宗交易零手续费\":\"Здійснюйте блокові операції з нульовою комісією\",\"社区\":\"Спільнота\",\"Huobi社区\":\"Спільнота HTX\",\"在这里发现币圈财富机会\":\"Досліджуйте та відкривайте можливості багатства\",\"快讯\":\"Новини\",\"7*24最全币圈资讯\":\"Останні криптовалютні новини у вас під рукою\",\"长文\":\"Стаття\",\"深入了解最新行业动态\":\"Пориньте глибоко в крипто інформацію\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Налаштуйтеся на все, що стосується криптовалюти\",\"从入门到精通一站式学习平台\":\"Навчайтеся, торгуйте та заробляйте\",\"博客\":\"Блог HTX\",\"Huobi最新资讯和业务报道\":\"Отримуйте останні новини та звіти\",\"活动\":\"Діяльність\",\"轻松赚币，天天领奖\":\"Щодня вигравайте криптовалюти та інші нагороди\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Відкрийте для себе наступний великий криптопроєкт\",\"虚拟资产财富之旅的记忆凭证\":\"Розпакуйте розваги та чудові призи\",\"交易赛\":\"Трейдинговий конкурс\",\"牛人大师都爱的大赛\":\"Прокладайте свій шлях до таблиці лідерів\",\"通往Web 3.0的虚拟资产钱包\":\"Глобальний гаманець віртуальних активів і шлюз до Web 3.0\",\"云钱包\":\"Cloud Wallet\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi стало простіше завдяки хмарному сховищу приватних ключів\",\"场外借贷\":\"OTC позика\",\"我的费率\":\"Моя ставка комісії\",\"我的邀请返佣\":\"Мої реферали\",\"合约社群\":\"Спільнота HTX Futures\",\"经纪商看板\":\"Брокерський кабінет\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Контент\",\"多米尼克数字公民\":\"Цифрове громадянство Домініки\",\"体验\":\"Пробний\",\"正式\":\"Формальний\",\"高级\":\"Розширений\",\"Prime会员权益\":\"Переваги участі у програмі Prime\",\"体验卡\":\"Пробний період\",\"查看权益\":\"Переглянути переваги\",\"Global Licensed Businesses\":\"Глобальний ліцензований бізнес\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Тема\",\"专业版\":\"Професійний\",\"经典版\":\"Класика\",\"颜色偏好\":\"Параметри кольорів\",\"绿涨红跌\":\"Зелений верх/Червоний низ\",\"红涨绿跌\":\"Червоний верх/Зелений низ\",\"储备金证明\":\"Доказ резервів\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Баланси в Earn для торгівлі\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Увімкнувши цю функцію, ваші доступні активи для спотової торгівлі будуть показані як сума доступного балансу валюти котирування на вашому спотовому рахунку без позик і валюти котирування в продукті &quot;Earn - Гнучкий&quot;. Баланс поточної криптовалюти в Гнучкому продукті буде автоматично погашатися тільки тоді, коли це необхідно для спотової торгівлі.\",\"行情资讯\":\"Ринки\",\"HTX专区\":\"Зона $HTX\",\"一键收取HTX\":\"Отримати $HTX\",\"任务奖励日日解锁\":\"Щодня розблоковуйте винагороди за завдання\",\"加密货币价格\":\"Ціни на криптовалюти\",\"搜索\":\"Пошук\",\"热门资产\":\"Популярні активи\",\"热门话题\":\"Популярні\",\"热门赚币\":\"Висока прибутковість\",\"全部\":\"Всі\",\"功能\":\"Ф'ючерси\",\"资讯\":\"Новини\",\"公告\":\"Оголошення\",\"用户\":\"Користувачі\",\"#num#预约\":\"#num# підписників\",\"#num#观看\":\"#num# переглядів\",\"#num#回放\":\"#num# повторів\",\"预约\":\"Підписатися\",\"看直播\":\"Дивитися\",\"看回放\":\"Повторити\",\"暂无内容\":\"Контент недоступний\",\"永续\":\"Безстроковий\",\"当周\":\"Щотижня\",\"次周\":\"Двотижн.\",\"当季\":\"Щоквартально\",\"次季\":\"Двокварт.\",\"#num#粉丝\":\"#num# Підписників\",\"关注\":\"Слідкувати\",\"已关注\":\"Відстежувані\",\"站点地图\":\"Криптовалютна карта\",\"相机扫码下载<p>火币App</p>\":\"Наведіть камеру на QR-код, <p>щоб завантажити додаток HTX</p>\",\"漏洞赏金\":\"Bug Bounty\",\"充币\":\"Внести\",\"提币\":\"Вивести\",\"划转\":\"Переказати\",\"储备金证明报告\":\"Звіти про резерви\",\"切换账号\":\"Змінити\",\"提醒\":\"Нагадування\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Після видалення облікового запису разом із записами входу вам потрібно буде ввести пароль під час наступного входу в цей обліковий запис.\",\"确认\":\"Підтвердити\",\"其他账号\":\"Інші основні рахунки\",\"管理\":\"Управління\",\"完成\":\"Готово\",\"搜索子账号\":\"Пошук\",\"暂无数据\":\"Ще немає субрахунків\",\"创建子账号\":\"Створити\",\"清除\":\"Видалити\",\"添加其他账号\":\"Додати\",\"主账号\":\"Основний рахунок\",\"最多添加10个其他账号，请清除后再添加\":\"Тут можна додати до 10 акаунтів. Будь ласка, видаліть обліковий запис перед додаванням.\",\"我知道了\":\"Зрозуміло\",\"我的邀请奖励\":\"Мої реферали\",\"复制成功\":\"Скопійовано\",\"交易机器人\":\"Торгові боти\",\"借币\":\"Позики\",\"充值&提现状态\":\"Статус внесення і виведення\"}");

/***/ }),
/* 117 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"Crypto FAQ\",\"做市商申请\":\"Ứng dụng cho nhà tạo lập thị trường\",\"火币网-领先的比特币交易平台\":\"HTX - Leading Bitcoin Exchange\",\"工具\":\"Công cụ\",\"客户端下载\":\"Tải về\",\"API文档\":\"Tập tin API\",\"数字资产介绍\":\"Giới thiệu tài sản kỹ thuật số\",\"官方验证通道\":\"Kênh xác thực chính thống\",\"历史数据下载\":\"Tải Lịch sử Dữ liệu xuống\",\"邀请奖励\":\"Giới thiệu\",\"服务\":\"Dịch vụ\",\"Buy HUSD\":\"Mua HUSD\",\"费率\":\"Tỷ lệ phí\",\"交易规则介绍\":\"Quy tắc giao dịch\",\"借币额度\":\"Hạn mức vay coin\",\"帮助中心\":\"Trung tâm trợ giúp\",\"Global CEO 信箱\":\"Liên hệ CEO toàn cầu\",\"新手指南\":\"Hướng dẫn người mới\",\"合约课堂\":\"Lớp học hợp đồng\",\"法币XXX\":\"FiatXXX\",\"杠杆介绍\":\"Giới thiệu ký quỹ\",\"HT介绍\":\"Giới thiệu HT\",\"支持\":\"Hỗ trợ\",\"上币申请\":\"Đăng ký lên sàn\",\"机构服务\":\"Tài khoản của tổ chức\",\"大客户权益\":\"Lợi ích của khách hàng lớn\",\"经纪商\":\"Chương trình Broker\",\"广告方加V认证申请\":\"Đăng ký P2P V-Advertiser\",\"火币集团\":\"HTX\",\"超级返佣\":\"Tiếp thị liên kết\",\"条款说明\":\"Điều kiện\",\"用户协议\":\"Thỏa thuận của người dùng\",\"隐私条款\":\"Chính sách bảo mật\",\"法币交易规则\":\"Quy tắc giao dịch tiền pháp định\",\"关于反洗钱\":\"Về quy định chống rửa tiền\",\"加密介绍\":\"Giới thiệu Crypto\",\"首页\":\"Trang chủ\",\"火币合约\":\"Hợp đồng HTX\",\"买币\":\"Mua Crypto\",\"行情\":\"Thị trường\",\"币币交易\":\"Giao dịch Giao ngay\",\"成长学院\":\"HTX Learn\",\"登录\":\"Đăng nhập\",\"注册\":\"Đăng ký\",\"资产\":\"Tài sản\",\"现货账户（充币&提币）\":\"Tài khoản Spot (gửi và rút)\",\"币币账户\":\"Tài khoản tiền tệ\",\"杠杆账户\":\"Tài khoản ký quỹ\",\"法币账户\":\"Tài khoản OTC\",\"合约账户\":\"Tài khoản hợp đồng\",\"矿池账户\":\"Pool\",\"我的点卡\":\"Thẻ điểm của tôi\",\"信用卡买币\":\"Mua bằng thẻ tín dụng\",\"订单\":\"Lệnh\",\"现货&杠杆订单\":\"Lệnh Giao dịch  Spot & Margin\",\"法币订单\":\"Đơn hàng OTC\",\"合约订单\":\"Đơn hàng hợp đồng\",\"账户&安全\":\"Tài khoản & bảo mật\",\"身份认证\":\"Xác minh danh tính\",\"法币设置\":\"Cài đặt OTC\",\"费率设置\":\"Cài đặt tỷ lệ phí\",\"专业费率重磅升级\":\"Nâng cấp phí chuyên nghiệp\",\"我的优惠券\":\"My coupon\",\"积分中心\":\"Loyalty Club\",\"邀请返佣\":\"Mời bạn bè\",\"API管理\":\"Quản lý API\",\"子账号\":\"Tài khoản phụ\",\"退出\":\"Thoát ra\",\"交易所\":\"Sàn giao dịch\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX Korea\",\"火币日本\":\"HTX Nhật Bản\",\"集团生态服务\":\"các dịch vụ sinh thái của HTX\",\"火币矿池\":\"HTX Pool\",\"火信\":\"HTX Chat\",\"火币资本\":\"HTX Ventures\",\"火币全球生态基金\":\"Quỹ sinh thái toàn cầu HTX\",\"火币云\":\"HTX Cloud\",\"火币生态链\":\"HTX Eco Chain\",\"火币DeFi Labs\":\"HTX DeFi Labs\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"Chọn người bán có mức giá tốt nhất\",\"一键买卖\":\"Mua/Bán nhanh chóng\",\"快捷安全的数字资产交易\":\"Giao dịch tài sản kỹ thuật số nhanh chóng và an toàn\",\"现货交易\":\"Giao dịch\",\"币币兑换，零费率，无滑点\":\"Giao dịch giữa các token, không mất phí, không trượt giá.\",\"杠杆交易\":\"Ký quỹ\",\"借币增加本金，放大收益\":\"Tăng lợi nhuận với đòn bẩy\",\"策略交易\":\"Bot giao dịch\",\"7×24小时自动低买高卖\":\"Tự động mua thấp và bán cao 24/7\",\"场外大宗交易\":\"Môi giới (OTC)\",\"行业领先的场外大宗交易和借贷服务\":\"Nền tảng hàng đầu cho giao dịch OTC và dịch vụ cho vay\",\"合约交易\":\"Phái sinh\",\"合约总览\":\"Tổng quan phái sinh\",\"查看全部数字货币衍生产品\":\"Xem nhanh tất cả tiền kỹ thuật số\",\"币本位交割\":\"Giao nhận Coin\",\"每日结算，强大的风控实力支持\":\"Thanh toán trong ngày, được hỗ trợ bởi mô hình kiểm soát rủi ro của chúng tôi\",\"币本位永续\":\"Coin-M Swaps\",\"担保资产价值稳定，减少持仓风险\":\"Định giá tài sản ổn định với ít rủi ro hơn\",\"U本位合约\":\"Hợp đồng USDT-M\",\"返佣高达60%\":\"Nhận đến 60% hoa hồng\",\"期权\":\"Quyền chọn\",\"多种玩法，自由做多做空\":\"Mua Long hoặc Bán Short, giao dịch khi bạn thấy phù hợp\",\"金融业务\":\"Tài chính\",\"节点投票\":\"Staking\",\"享受高奖励的节点投票\":\"Bình chọn và nhận phần thưởng lớn\",\"锁仓更简单，免费领空投\":\"Khóa token của bạn dễ dàng và tận hưởng airdrop miễn phí\",\"波卡平行链插槽竞拍\":\"Đấu giá vị thế Polkadot parachain\",\"一键挖矿，日日增收\":\"Nạp tiền chỉ với một cú nhấp chuột và kiếm lãi suất mỗi ngày\",\"ETH2.0，一键换币\":\"Chuyển đổi token chỉ với một cú nhấp chuột\",\"质押借币\":\"Cho vay Tiền kỹ thuật số\",\"数字资产，尊享急速到账体验\":\"Tận hưởng giao dịch nhanh chóng các tài sản kỹ thuật số của bạn\",\"双币投资\":\"Đầu tư kép\",\"掌握价格波动，财富稳定增值\":\"Tăng trưởng tài sản của bạn trong bối cảnh thị trường biến động\",\"Learn\":\"Học viện\",\"Rewards Hub\":\"Phần thưởng\",\"资产总览\":\"Tổng quan về tài sản\",\"策略账户\":\"Tài khoản định lượng\",\"Huobi Earn账户\":\"Earn\",\"质押账户\":\"Cho vay Tiền kỹ thuật số\",\"期权账户\":\"Tài khoản Quyền chọn\",\"限量优惠\":\"Ưu đãi giới hạn\",\"Huobi Earn订单\":\"Earn\",\"策略订单\":\"Chiến lược\",\"存币宝订单\":\"Đơn gửi tiết kiệm\",\"质押借币订单\":\"Cho vay Tiền kỹ thuật số\",\"返佣收益看板\":\"Referral Dashboard\",\"站内信\":\"Thư nội bộ\",\"查看全部\":\"Xem toàn bộ\",\"暂无最新消息\":\"Không có tin mới\",\"隐藏已读\":\"Ẩn đã đọc\",\"全部标为已读\":\"Toàn bộ đánh dấu đã đọc\",\"扫码下载 APP\":\"Quét mã tải APP\",\"更多客户端\":\"Thêm tùy chọn\",\"语言\":\"Ngôn ngữ\",\"折算货币\":\"Tiền tệ\",\"提示\":\"Nhắc nhở\",\"确认将全部未读消息标记为已读？\":\"Xác nhận đánh dấu chưa đọc thành đã đọc？\",\"了解VIP\":\"Tìm hiểu VIP\",\"精英会员\":\"Hội viên Tinh Anh\",\"银卡VIP\":\"Thẻ Bạc VIP\",\"金卡VIP\":\"THẻ Vang VIP\",\"白金卡VIP\":\"Thẻ Bạch Kim VIP\",\"黑卡VIP\":\"THẻ Hắc VIP\",\"取消\":\"Hủy bỏ\",\"确定\":\"Xác nhận\",\"快捷一键买卖\":\"Mua/Bán Nhanh\",\"法币充值\":\"Nạp Tiền Pháp Định\",\"P2P自选交易\":\"P2P\",\"第三方交易\":\"Qua Bên T3\",\"自选\":\"Yêu thích\",\"现货\":\"Giao Ngay\",\"合约\":\"Hợp Đồng Tương Lai\",\"全仓杠杆\":\"Ký Quỹ Chéo\",\"逐仓杠杆\":\"Ký Quỹ Độc Lập\",\"Tradingbot 策略交易\":\"Giao Dịch Bot\",\"期权交易\":\"Quyền Chọn\",\"理财相关\":\"Liên quan đến đầu tư\",\"Huobi Earn 理财\":\"Earn\",\"其他\":\"Khác\",\"节点质押投票\":\"Staking & Voting\",\"ETH2.0\":\"ETH 2.0\",\"借贷业务系统\":\"Môi Giới (Cho Vay)\",\"OTC交易系统\":\"Môi Giới (OTC)\",\"我的资产\":\"Tài Sản Của Tôi\",\"我的订单\":\"Đơn Lệnh Của Tôi\",\"消息\":\"Thông Tin\",\"我的福利\":\"Phần Thưởng Của Tôi\",\"邀请返佣看板\":\"Tổng Quan Giới Thiệu\",\"账户安全\":\"Bảo Mật\",\"子账号管理\":\"Quản Lý Tài Khoản Phụ\",\"扫码下载 huobi App\":\"Quét để tải Ứng dụng\",\"更多方式\":\"Thêm phương thức\",\"升级还需要现货交易<span>#num#U</span>\":\"Giao dịch thêm <span>#num# USDT</span> trong Giao ngay để tăng cấp\",\"升级还需要合约交易<span>#num#U</span>\":\"Giao dịch thêm <span>#num# USDT</span> trong Hợp đồng Tương lai để tăng cấp\",\"升级还需要资沉<span>#num#U</span>\":\"Nạp thêm <span>#num# USDT</span> để tăng cấp\",\"手续费#num#折\":\"Giảm #num# phí giao dịch\",\"HT抵扣#num#%\":\"Giảm #num#% với HT\",\"生日好礼\":\"Quà Sinh Nhật\",\"杠杆\":\"Ký Quỹ\",\"理财\":\"Earn\",\"法币\":\"Tiền Pháp Định\",\"Welcome to Huobi\":\"Chào mừng đến với HTX\",\"There will be more exciting after login\":\"Nhiều điều bất ngờ đang chờ bạn sau khi đăng nhập!\",\"全部资产\":\"Tổng Tài Sản\",\"Today’s P/L\":\"P/L Hôm Nay\",\"点击查看\":\"Bấm vào để xem\",\"下载App\":\"Tải Ứng Dụng\",\"退出登录\":\"Đăng xuất\",\"关于火币\":\"Về HTX\",\"关于我们\":\"Về chúng tôi\",\"火币集团介绍\":\"HTX\",\"数字资产\":\"Tài sản Kỹ thuật số\",\"火币云服务\":\"HTX Cloud\",\"火币Defi Labs\":\"HTX DeFi Labs\",\"CEO信箱\":\"Liên hệ CEO\",\"官网验证通道\":\"Kênh chính thống\",\"产品功能\":\"Sản phẩm\",\"一键买币\":\"Mua/Bán nhanh\",\"TradingBot\":\"Giao dịch Bot\",\"金融服务\":\"Tài Chính\",\"火币社区\":\"Cộng đồng HTX\",\"服务介绍\":\"Dịch vụ\",\"认证服务\":\"Xác minh Danh tính\",\"费率介绍\":\"Phí theo Cấp bậc\",\"币币交易规则\":\"Quy tắc Giao dịch Giao ngay\",\"新手成长学院\":\"HTX Learn\",\"KOL招募\":\"Chương trình Tiếp thị Liên kết\",\"经纪商申请\":\"Chương trình Môi giới\",\"广告方认证服务\":\"Ứng dụng P2P V-Advertiser\",\"开放平台\":\"Nền Tảng Mở\",\"API介绍\":\"Tài liệu API\",\"活动福利\":\"Sự kiện & Quyền lợi\",\"新用户奖励\":\"Phần thưởng Chào mừng\",\"入金奖励\":\"Phần thưởng Nạp tiền\",\"交易奖励\":\"Phần thưởng Giao dịch\",\"免费领空投\":\"Nhận Airdrop\",\"月度大促\":\"Khuyến mãi Hàng tháng\",\"购买加密货币\":\"Mua Tiền Số\",\"未认证\":\"Chưa xác minh\",\"合约跟单\":\"Sao chép Giao dịch\",\"福利中心\":\"Trung tâm phần thưởng\",\"机构\":\"Tổ chức\",\"快捷买币\":\"Giao dịch Nhanh\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"Mua tài sản kỹ thuật số bằng Visa, Mastercard và hơn thế nữa\",\"满足低手续费多种法币的充值\":\"Nạp tiền pháp định với mức phí thấp\",\"多种法币0手续费最优价格\":\"Khớp với mức giá tốt nhất không tính phí\",\"自选交易对，行情尽在掌握\":\"Theo dõi cặp giao dịch yêu thích của bạn trong thời gian thực\",\"直达现货市场，抓住交易机会\":\"Nắm bắt cơ hội giao dịch với Thị trường Giao ngay\",\"了解合约行情动态，获取超额收益\":\"Kiếm lợi nhuận khủng với Thị trường Hợp đồng Tương lai\",\"交易\":\"Giao dịch\",\"使用完整的交易功能，买卖虚拟资产\":\"Giao dịch tài sản kỹ thuật số bằng những công cụ nâng cao của chúng tôi\",\"杠杆ETP\":\"ETP\",\"无爆仓享受杠杆收益\":\"Tăng đòn bẩy của bạn mà không có rủi ro thanh lý\",\"借币交易，放大现货收益\":\"Sử dụng đòn bẩy để tăng lợi nhuận của bạn\",\"丰富的量化交易策略，自动跟单，自动交易\":\"Giao dịch tự động với những chiến lược quant\",\"火币闪兑\":\"Chuyển đổi\",\"币币兑换，零费率无滑点\":\"Hoán đổi tiền kỹ thuật số sang tiền kỹ thuật số, không tính phí, không trượt giá\",\"衍生品\":\"Phái sinh\",\"以USDT结算的合约交易\":\"Sản phẩm hợp đồng tương lai thanh toán bằng USDT\",\"币本位合约\":\"Hợp đồng Tương lai Coin-M\",\"以加密货币结算的合约交易\":\"Những sản phẩm hợp đồng tương lai thanh toán bằng tiền kỹ thuật số\",\"欧式美式期权随心选择，财富稳定增值\":\"Quyền chọn kiểu châu Âu và Mỹ để nhân tài sản của bạn lên\",\"自动跟随专业交易员下单，轻松盈利\":\"Giao dịch như chuyên gia bằng cách theo dõi những giao dịch của họ\",\"Huobi合约嘉年华\":\"Futures Carnival\",\"参加交易 iPhone14Pro Max等你拿\":\"Giao dịch để giành iPhone 14 Pro Max và hơn thế nữa\",\"理财_menu\":\"Earn\",\"Huobi Earn\":\"Earn\",\"稳健的虚拟资产配置工具\":\"Kiếm thu nhập thụ động từ tài sản kỹ thuật số của bạn\",\"非保本高额收益结构型理财\":\"Cấu trúc sản phẩm với năng suất nâng cao\",\"便捷抵押，安全交易\":\"Vay tiền kỹ thuật số nhanh chóng để đáp ứng nhu cầu giao dịch của bạn\",\"扩大交易规模和种类，实现多倍收益\":\"Vay để mở rộng quy mô giao dịch và lợi nhuận\",\"金融服务_menu\":\"Tài chính\",\"迎接以太坊2.0\":\"Kỷ nguyên mới Ethereum\",\"随借随还实时到账\":\"Vay trả dễ dàng bất kỳ lúc nào\",\"尊享大宗交易零手续费\":\"Thực hiện giao dịch khối không tính phí\",\"社区\":\"Cộng đồng\",\"Huobi社区\":\"Cộng đồng HTX\",\"在这里发现币圈财富机会\":\"Khám phá và phát hiện ra cơ hội làm giàu\",\"快讯\":\"Tin tức\",\"7*24最全币圈资讯\":\"Tin tức tiền kỹ thuật số mới nhất trong tầm tay bạn\",\"长文\":\"Bài viết\",\"深入了解最新行业动态\":\"Tìm hiểu sâu thông tin chi tiết tiền kỹ thuật số\",\"直播\":\"HTX Live\",\"财富密码，实操教学\":\"Điều chỉnh tất cả mọi thứ về tiền kỹ thuật số\",\"从入门到精通一站式学习平台\":\"Tìm hiểu, giao dịch và kiếm tiền\",\"博客\":\"HTX Blog\",\"Huobi最新资讯和业务报道\":\"Cập nhật những câu chuyện và báo cáo mới nhất\",\"活动\":\"Hoạt động\",\"轻松赚币，天天领奖\":\"Giành được tiền kỹ thuật số và những phần thưởng khác mỗi ngày\",\"Newlisting\":\"NewListing\",\"新币福利营带你发现最佳资产\":\"Khám phá tiếp dự án lớn tiền kỹ thuật số\",\"Primebox\":\"PrimeBox\",\"虚拟资产财富之旅的记忆凭证\":\"Mở hộp đầy thú vị cùng giải thưởng lớn\",\"交易赛\":\"Cuộc thi Giao dịch\",\"牛人大师都爱的大赛\":\"Giao dịch theo cách riêng của bạn để vào bảng xếp hạng\",\"通往Web 3.0的虚拟资产钱包\":\"Ví tài sản kỹ thuật số toàn cầu cùng cổng đến với Web 3.0\",\"云钱包\":\"Ví Cloud\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"DeFi trở nên dễ dàng với lưu trữ đám mây khóa cá nhân\",\"场外借贷\":\"Vay OTC\",\"我的费率\":\"Mức phí của tôi\",\"我的邀请返佣\":\"Giới thiệu của tôi\",\"合约社群\":\"Cộng đồng HTX Futures\",\"经纪商看板\":\"Trang Tổng quan Nhà môi giới\",\"iToken钱包\":\"iToken Wallet\",\"内容\":\"Nội dung\",\"多米尼克数字公民\":\"Công dân Kỹ thuật số Dominica\",\"体验\":\"Dùng thử\",\"正式\":\"Chính thức\",\"高级\":\"Nâng cao\",\"Prime会员权益\":\"Quyền lợi Thành viên Prime\",\"体验卡\":\"Dùng thử\",\"查看权益\":\"Xem quyền lợi\",\"Global Licensed Businesses\":\"Doanh nghiệp được Cấp phép Toàn cầu\",\"资产托管\":\"HTX Custody\",\"主题背景\":\"Hình thức\",\"专业版\":\"Chuyên nghiệp\",\"经典版\":\"Cổ điển\",\"颜色偏好\":\"Màu yêu thích\",\"绿涨红跌\":\"Xanh lên/Đỏ xuống\",\"红涨绿跌\":\"Đỏ lên/Xanh xuống\",\"储备金证明\":\"Bằng chứng Dự trữ\",\"赚币_menu\":\"Earn\",\"赚币订单\":\"Earn\",\"赚币\":\"Earn\",\"交易赎回活期赚币余额\":\"Sử dụng số dư trong Earn để giao dịch\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"Bằng cách kích hoạt tính năng này, tài sản khả dụng của bạn để giao dịch giao ngay sẽ hiển thị dưới dạng tổng số dư khả dụng của tiền định giá trong tài khoản Giao ngay của bạn mà không có khoản vay và số dư của tiền định giá trong sản phẩm Earn - Linh hoạt. Số dư tiền kỹ thuật số hiện tại trong sản phẩm Linh hoạt sẽ chỉ được tự động quy đổi khi cần thiết cho giao dịch giao ngay.\",\"行情资讯\":\"Thị trường\",\"HTX专区\":\"Khu $HTX\",\"一键收取HTX\":\"Thu thập $HTX\",\"任务奖励日日解锁\":\"Mở khóa phần thưởng nhiệm vụ hàng ngày\",\"加密货币价格\":\"Giá Tiền kỹ thuật số\",\"搜索\":\"Tìm kiếm\",\"热门资产\":\"Tài sản Phổ biến\",\"热门话题\":\"Xu hướng\",\"热门赚币\":\"Lợi suất Hấp dẫn\",\"全部\":\"Tất cả\",\"功能\":\"Tính năng\",\"资讯\":\"Tin tức\",\"公告\":\"Thông báo\",\"用户\":\"Người dùng\",\"#num#预约\":\"#num# đã đăng ký\",\"#num#观看\":\"#num# đang xem\",\"#num#回放\":\"#num# đã phát lại\",\"预约\":\"Đăng ký\",\"看直播\":\"Xem Live\",\"看回放\":\"Phát lại\",\"暂无内容\":\"Không có nội dung khả dụng\",\"永续\":\"Vĩnh cửu\",\"当周\":\"Hàng tuần\",\"次周\":\"Hai Tuần\",\"当季\":\"Hàng quý\",\"次季\":\"2 Quý\",\"#num#粉丝\":\"#num# Người theo dõi\",\"关注\":\"Theo dõi\",\"已关注\":\"Đang theo dõi\",\"站点地图\":\"Sơ đồ Tiền kỹ thuật số\",\"相机扫码下载<p>火币App</p>\":\"Hướng máy ảnh của bạn vào mã QR <p>để tải Ứng dụng HTX</p>\",\"漏洞赏金\":\"Săn lỗi nhận thưởng\",\"充币\":\"Nạp\",\"提币\":\"Rút\",\"划转\":\"Chuyển\",\"储备金证明报告\":\"Báo cáo PoR\",\"切换账号\":\"Chuyển đổi\",\"提醒\":\"Lưu ý\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"Sau khi xóa tài khoản cùng với hồ sơ đăng nhập, bạn sẽ cần nhập mật khẩu cho lần đăng nhập tiếp theo vào tài khoản này.\",\"确认\":\"Xác nhận\",\"其他账号\":\"Tài khoản Chính Khác\",\"管理\":\"Quản lý\",\"完成\":\"Hoàn thành\",\"搜索子账号\":\"Tìm kiếm\",\"暂无数据\":\"Chưa có tài khoản phụ\",\"创建子账号\":\"Tạo\",\"清除\":\"Xóa\",\"添加其他账号\":\"Thêm\",\"主账号\":\"Tài khoản Chính\",\"最多添加10个其他账号，请清除后再添加\":\"Có thể thêm tối đa 10 tài khoản tại đây. Vui lòng xóa một tài khoản trước khi thêm một tài khoản.\",\"我知道了\":\"Đã hiểu\",\"我的邀请奖励\":\"Giới thiệu của tôi\",\"复制成功\":\"Đã sao chép\",\"交易机器人\":\"Giao dịch Bot\",\"借币\":\"Cho vay\",\"充值&提现状态\":\"Trạng thái Nạp & Rút\"}");

/***/ }),
/* 118 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"币圈问答百科\",\"做市商申请\":\"做市商申请\",\"火币网-领先的比特币交易平台\":\"火币网-领先的比特币交易平台\",\"工具\":\"工具\",\"客户端下载\":\"客户端下载\",\"API文档\":\"API文档\",\"数字资产介绍\":\"数字资产介绍\",\"官方验证通道\":\"官方验证通道\",\"Huobi Blog\":\"火币博客\",\"历史数据下载\":\"历史数据下载\",\"邀请奖励\":\"邀请奖励\",\"服务\":\"服务\",\"Buy HUSD\":\"Buy HUSD\",\"费率\":\"费率\",\"交易规则介绍\":\"交易规则介绍\",\"借币额度\":\"借币额度\",\"帮助中心\":\"帮助中心\",\"Global CEO 信箱\":\"Global CEO 信箱\",\"新手指南\":\"新手指南\",\"合约课堂\":\"合约课堂\",\"iToken\":\"iToken\",\"法币XXX\":\"法币XXX\",\"杠杆介绍\":\"杠杆介绍\",\"HT介绍\":\"HT介绍\",\"支持\":\"支持\",\"上币申请\":\"上币申请\",\"机构服务\":\"机构服务\",\"大客户权益\":\"大客户权益\",\"经纪商\":\"经纪商\",\"广告方加V认证申请\":\"广告方加V认证申请\",\"火币集团\":\"火币\",\"Web3 Scholarship\":\"Web3 Scholarship\",\"超级返佣\":\"超级返佣\",\"条款说明\":\"条款说明\",\"用户协议\":\"用户协议\",\"隐私条款\":\"隐私条款\",\"执法和监管查询\":\"执法和监管查询\",\"法币交易规则\":\"法币交易规则\",\"关于反洗钱\":\"关于反洗钱\",\"加密介绍\":\"加密介绍\",\"首页\":\"首页\",\"火币合约\":\"火币合约\",\"OTC Market\":\"OTC Market\",\"买币\":\"买币\",\"行情\":\"行情\",\"币币交易\":\"现货交易\",\"成长学院\":\"成长学院\",\"登录\":\"登录\",\"注册\":\"注册\",\"资产\":\"资产\",\"现货账户（充币&提币）\":\"现货账户（充币&提币）\",\"币币账户\":\"币币账户\",\"杠杆账户\":\"杠杆账户\",\"法币账户\":\"法币账户\",\"合约账户\":\"合约账户\",\"矿池账户\":\"矿池账户\",\"我的点卡\":\"我的点卡\",\"信用卡买币\":\"信用卡买币\",\"订单\":\"订单\",\"现货&杠杆订单\":\"现货&杠杆订单\",\"法币订单\":\"法币订单\",\"合约订单\":\"合约订单\",\"Buy&Sell History\":\"Buy&Sell History\",\"账户&安全\":\"账户&安全\",\"身份认证\":\"身份认证\",\"提高账户安全\":\"提高账户安全\",\"法币设置\":\"法币设置\",\"费率设置\":\"费率设置\",\"专业费率重磅升级\":\"专业费率重磅升级\",\"我的优惠券\":\"我的优惠券\",\"积分中心\":\"积分中心\",\"邀请返佣\":\"邀请返佣\",\"API管理\":\"API管理\",\"子账号\":\"子账号\",\"退出\":\"退出\",\"交易所\":\"交易所\",\"火币全球站\":\"火币\",\"火币韩国\":\"火币韩国\",\"火币日本\":\"火币日本\",\"集团生态服务\":\"集团生态服务\",\"火币矿池\":\"火币矿池\",\"火信\":\"火信\",\"火币资本\":\"火币资本\",\"火币全球生态基金\":\"火币生态基金\",\"火币云\":\"火币云\",\"火币生态链\":\"火币生态链\",\"火币DeFi Labs\":\"火币DeFi Labs\",\"火币OTC\":\"火币OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"选择最合算的卖家进行交易\",\"一键买卖\":\"一键买卖\",\"快捷安全的数字资产交易\":\"快捷安全的数字资产交易\",\"现货交易\":\"现货交易\",\"币币兑换，零费率，无滑点\":\"币币兑换，零费率，无滑点\",\"杠杆交易\":\"杠杆交易\",\"借币增加本金，放大收益\":\"借币增加本金，放大收益\",\"策略交易\":\"策略交易\",\"7×24小时自动低买高卖\":\"7×24小时自动低买高卖\",\"场外大宗交易\":\"场外大宗交易\",\"行业领先的场外大宗交易和借贷服务\":\"行业领先的场外大宗交易和借贷服务\",\"合约交易\":\"合约交易\",\"合约总览\":\"合约总览\",\"查看全部数字货币衍生产品\":\"查看全部数字货币衍生产品\",\"币本位交割\":\"币本位交割\",\"每日结算，强大的风控实力支持\":\"每日结算，强大的风控实力支持\",\"币本位永续\":\"币本位永续\",\"担保资产价值稳定，减少持仓风险\":\"担保资产价值稳定，减少持仓风险\",\"U本位合约\":\"U本位合约\",\"返佣高达60%\":\"返佣高达60%\",\"期权\":\"期权\",\"多种玩法，自由做多做空\":\"多种玩法，自由做多做空\",\"金融业务\":\"金融业务\",\"节点投票\":\"节点质押\",\"享受高奖励的节点投票\":\"享受高奖励的节点质押\",\"锁仓更简单，免费领空投\":\"锁仓更简单，免费领空投\",\"Polkadot Slot Auction\":\"Polkadot Slot Auction\",\"波卡平行链插槽竞拍\":\"波卡平行链插槽竞拍\",\"一键挖矿，日日增收\":\"一键挖矿，日日增收\",\"ETH 2.0\":\"ETH 2.0\",\"ETH2.0，一键换币\":\"ETH2.0，一键换币\",\"质押借币\":\"质押借币\",\"数字资产，尊享急速到账体验\":\"数字资产，尊享急速到账体验\",\"双币投资\":\"双币投资\",\"掌握价格波动，财富稳定增值\":\"掌握价格波动，财富稳定增值\",\"The Gateway to Web 3.0\":\"The Gateway to Web 3.0\",\"Learn\":\"Learn\",\"Rewards Hub\":\"Rewards Hub\",\"资产总览\":\"资产总览\",\"策略账户\":\"策略账户\",\"Huobi Earn账户\":\"火币理财账户\",\"质押账户\":\"质押账户\",\"期权账户\":\"期权账户\",\"限量优惠\":\"限量优惠\",\"Huobi Earn订单\":\"理财订单\",\"策略订单\":\"策略订单\",\"存币宝订单\":\"存币宝订单\",\"质押借币订单\":\"质押借币订单\",\"返佣收益看板\":\"返佣收益看板\",\"站内信\":\"站内信\",\"查看全部\":\"查看全部\",\"暂无最新消息\":\"暂无最新消息\",\"隐藏已读\":\"隐藏已读\",\"全部标为已读\":\"全部标为已读\",\"扫码下载 APP\":\"扫码下载 APP\",\"更多客户端\":\"更多客户端\",\"语言\":\"语言\",\"折算货币\":\"折算货币\",\"提示\":\"提示\",\"确认将全部未读消息标记为已读？\":\"确认将全部未读消息标记为已读？\",\"了解VIP\":\"了解VIP\",\"精英会员\":\"精英会员\",\"银卡VIP\":\"银卡VIP\",\"金卡VIP\":\"金卡VIP\",\"白金卡VIP\":\"白金卡VIP\",\"黑卡VIP\":\"黑卡VIP\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"欢迎来到火币，您正在享受火币%s特权。\",\"取消\":\"取消\",\"确定\":\"确定\",\"快捷一键买卖\":\"快捷一键买卖\",\"法币充值\":\"法币充值\",\"P2P自选交易\":\"P2P自选交易\",\"第三方交易\":\"第三方交易\",\"自选\":\"自选\",\"现货\":\"现货\",\"合约\":\"合约\",\"全仓杠杆\":\"全仓杠杆\",\"逐仓杠杆\":\"逐仓杠杆\",\"Tradingbot 策略交易\":\"网格策略交易\",\"期权交易\":\"期权交易\",\"理财相关\":\"理财相关\",\"Huobi Earn 理财\":\"火币理财\",\"其他\":\"其他\",\"节点质押投票\":\"节点质押投票\",\"ETH2.0\":\"ETH2.0\",\"借贷业务系统\":\"借贷业务系统\",\"OTC交易系统\":\"OTC交易系统\",\"我的资产\":\"我的资产\",\"我的订单\":\"我的订单\",\"消息\":\"消息\",\"我的福利\":\"我的福利\",\"邀请返佣看板\":\"邀请返佣看板\",\"账户安全\":\"账户安全\",\"子账号管理\":\"子账号管理\",\"扫码下载 huobi App\":\"扫码下载火币App\",\"更多方式\":\"更多方式\",\"升级还需要现货交易<span>#num#U</span>\":\"升级还需要现货交易<span>#num#U</span>\",\"升级还需要合约交易<span>#num#U</span>\":\"升级还需要合约交易<span>#num#U</span>\",\"升级还需要资沉<span>#num#U</span>\":\"升级还需要资沉<span>#num#U</span>\",\"手续费#num#折\":\"手续费#num#折\",\"HT抵扣#num#%\":\"HT抵扣#num#%\",\"生日好礼\":\"生日好礼\",\"杠杆\":\"杠杆\",\"理财\":\"理财\",\"法币\":\"法币\",\"Welcome to Huobi\":\"欢迎来到火币\",\"There will be more exciting after login\":\"登录后享受更多服务\",\"全部资产\":\"全部资产\",\"Today’s P/L\":\"今日盈亏\",\"P/L\":\"盈亏分析\",\"点击查看\":\"点击查看\",\"下载App\":\"下载App\",\"退出登录\":\"退出登录\",\"关于火币\":\"关于火币\",\"关于我们\":\"关于我们\",\"火币集团介绍\":\"火币介绍\",\"数字资产\":\"数字资产\",\"火币云服务\":\"火币云服务\",\"火币Defi Labs\":\"火币Defi Labs\",\"CEO信箱\":\"CEO信箱\",\"官网验证通道\":\"官网验证通道\",\"产品功能\":\"产品功能\",\"一键买币\":\"一键买币\",\"TradingBot\":\"网格策略\",\"金融服务\":\"金融服务\",\"火币社区\":\"火币社区\",\"NFT\":\"NFT\",\"服务介绍\":\"服务介绍\",\"认证服务\":\"认证服务\",\"费率介绍\":\"费率介绍\",\"币币交易规则\":\"现货交易规则\",\"新手成长学院\":\"新手成长学院\",\"KOL招募\":\"KOL招募\",\"经纪商申请\":\"经纪商申请\",\"广告方认证服务\":\"广告方认证服务\",\"开放平台\":\"开放平台\",\"API介绍\":\"API介绍\",\"活动福利\":\"活动福利\",\"新用户奖励\":\"新用户奖励\",\"入金奖励\":\"入金奖励\",\"交易奖励\":\"交易奖励\",\"免费领空投\":\"免费领空投\",\"月度大促\":\"月度大促\",\"购买加密货币\":\"购买加密货币\",\"矿池\":\"矿池\",\"未认证\":\"未认证\",\"合约跟单\":\"合约跟单\",\"福利中心\":\"福利中心\",\"机构\":\"机构\",\"快捷买币\":\"快捷交易\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"支持visa/master等多种银行卡快速购买虚拟资产\",\"满足低手续费多种法币的充值\":\"满足低手续费多种法币的充值\",\"P2P\":\"P2P\",\"多种法币0手续费最优价格\":\"多种法币0手续费最优价格\",\"自选交易对，行情尽在掌握\":\"自选交易对，行情尽在掌握\",\"直达现货市场，抓住交易机会\":\"直达现货市场，抓住交易机会\",\"了解合约行情动态，获取超额收益\":\"了解合约行情动态，获取超额收益\",\"交易\":\"交易\",\"使用完整的交易功能，买卖虚拟资产\":\"使用完整的交易功能，买卖虚拟资产\",\"杠杆ETP\":\"杠杆ETP\",\"无爆仓享受杠杆收益\":\"无爆仓享受杠杆收益\",\"借币交易，放大现货收益\":\"借币交易，放大现货收益\",\"丰富的量化交易策略，自动跟单，自动交易\":\"丰富的量化交易策略，自动跟单，自动交易\",\"火币闪兑\":\"火币闪兑\",\"币币兑换，零费率无滑点\":\"币币兑换，零费率无滑点\",\"衍生品\":\"衍生品\",\"以USDT结算的合约交易\":\"以USDT结算的合约交易\",\"币本位合约\":\"币本位合约\",\"以加密货币结算的合约交易\":\"以加密货币结算的合约交易\",\"欧式美式期权随心选择，财富稳定增值\":\"欧式美式期权随心选择，财富稳定增值\",\"自动跟随专业交易员下单，轻松盈利\":\"自动跟随专业交易员下单，轻松盈利\",\"Huobi合约嘉年华\":\"火币合约嘉年华\",\"参加交易 iPhone14Pro Max等你拿\":\"参加交易 iPhone14Pro Max等你拿\",\"理财_menu\":\"理财\",\"Huobi Earn\":\"火币理财\",\"稳健的虚拟资产配置工具\":\"稳健的虚拟资产配置工具\",\"非保本高额收益结构型理财\":\"非保本高额收益结构型理财\",\"便捷抵押，安全交易\":\"便捷抵押，安全交易\",\"扩大交易规模和种类，实现多倍收益\":\"扩大交易规模和种类，实现多倍收益\",\"金融服务_menu\":\"金融服务\",\"迎接以太坊2.0\":\"迎接以太坊2.0\",\"随借随还实时到账\":\"随借随还实时到账\",\"尊享大宗交易零手续费\":\"尊享大宗交易零手续费\",\"社区\":\"社区\",\"Huobi社区\":\"火币社区\",\"在这里发现币圈财富机会\":\"在这里发现币圈财富机会\",\"快讯\":\"快讯\",\"7*24最全币圈资讯\":\"7*24最全币圈资讯\",\"长文\":\"长文\",\"深入了解最新行业动态\":\"深入了解最新行业动态\",\"直播\":\"直播\",\"财富密码，实操教学\":\"财富密码，实操教学\",\"从入门到精通一站式学习平台\":\"从入门到精通一站式学习平台\",\"博客\":\"博客\",\"Huobi最新资讯和业务报道\":\"火币最新资讯和业务报道\",\"活动\":\"活动\",\"轻松赚币，天天领奖\":\"轻松赚币，天天领奖\",\"Newlisting\":\"新币专区\",\"新币福利营带你发现最佳资产\":\"新币福利营带你发现最佳资产\",\"Primebox\":\"Primebox\",\"虚拟资产财富之旅的记忆凭证\":\"虚拟资产财富之旅的记忆凭证\",\"交易赛\":\"交易赛\",\"牛人大师都爱的大赛\":\"牛人大师都爱的大赛\",\"Web 3.0\":\"Web 3.0\",\"通往Web 3.0的虚拟资产钱包\":\"通往Web 3.0的虚拟资产钱包\",\"云钱包\":\"云钱包\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"无需自己保管私钥，一键参与 DeFi 项目\",\"场外借贷\":\"场外借贷\",\"NewListing\":\"新币专区\",\"我的费率\":\"我的费率\",\"我的邀请返佣\":\"我的邀请返佣\",\"合约社群\":\"合约社群\",\"经纪商看板\":\"经纪商看板\",\"iToken钱包\":\"iToken钱包\",\"内容\":\"内容\",\"多米尼克数字公民\":\"多米尼克数字公民\",\"体验\":\"体验\",\"正式\":\"正式\",\"高级\":\"高级\",\"Prime会员权益\":\"Prime会员权益\",\"体验卡\":\"体验卡\",\"查看权益\":\"查看权益\",\"Global Licensed Businesses\":\"环球牌照业务\",\"资产托管\":\"资产托管\",\"主题背景\":\"主题背景\",\"专业版\":\"专业版\",\"经典版\":\"经典版\",\"颜色偏好\":\"颜色偏好\",\"绿涨红跌\":\"绿涨红跌\",\"红涨绿跌\":\"红涨绿跌\",\"扫码添加\":\"扫码添加\",\"官方微信：\":\"官方微信：\",\"官方QQ：\":\"官方QQ：\",\"储备金证明\":\"储备金证明\",\"赚币_menu\":\"赚币\",\"赚币订单\":\"赚币订单\",\"赚币\":\"赚币\",\"交易赎回活期赚币余额\":\"交易赎回活期赚币余额\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\",\"行情资讯\":\"行情资讯\",\"HTX专区\":\"HTX专区\",\"一键收取HTX\":\"一键收取HTX\",\"任务奖励日日解锁\":\"任务奖励日日解锁\",\"加密货币价格\":\"加密货币价格\",\"搜索\":\"搜索\",\"热门资产\":\"热门资产\",\"热门话题\":\"热门话题\",\"热门赚币\":\"热门赚币\",\"全部\":\"全部\",\"功能\":\"功能\",\"资讯\":\"资讯\",\"公告\":\"公告\",\"用户\":\"用户\",\"#num#预约\":\"#num#预约\",\"#num#观看\":\"#num#观看\",\"#num#回放\":\"#num#回放\",\"预约\":\"预约\",\"看直播\":\"看直播\",\"看回放\":\"看回放\",\"暂无内容\":\"暂无内容\",\"永续\":\"永续\",\"当周\":\"当周\",\"次周\":\"次周\",\"当季\":\"当季\",\"次季\":\"次季\",\"#num#粉丝\":\"#num#粉丝\",\"关注\":\"关注\",\"已关注\":\"已关注\",\"站点地图\":\"站点地图\",\"相机扫码下载<p>火币App</p>\":\"相机扫码下载<p>火币App</p>\",\"漏洞赏金\":\"漏洞赏金\",\"充币\":\"充币\",\"提币\":\"提币\",\"划转\":\"划转\",\"储备金证明报告\":\"储备金证明报告\",\"切换账号\":\"切换账号\",\"提醒\":\"提醒\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\",\"确认\":\"确认\",\"其他账号\":\"其他账号\",\"管理\":\"管理\",\"完成\":\"完成\",\"搜索子账号\":\"搜索子账号\",\"暂无数据\":\"暂无数据\",\"创建子账号\":\"创建子账号\",\"清除\":\"清除\",\"添加其他账号\":\"添加其他账号\",\"主账号\":\"主账号\",\"最多添加10个其他账号，请清除后再添加\":\"最多添加10个其他账号，请清除后再添加\",\"我知道了\":\"我知道了\",\"我的邀请奖励\":\"我的邀请奖励\",\"复制成功\":\"复制成功\",\"交易机器人\":\"交易机器人\",\"借币\":\"借币\",\"充值&提现状态\":\"充值&提现状态\"}");

/***/ }),
/* 119 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"幣圈問答百科\",\"做市商申请\":\"造市商申請\",\"火币网-领先的比特币交易平台\":\"火币网-领先的比特币交易平台\",\"工具\":\"工具\",\"客户端下载\":\"客户端下载\",\"API文档\":\"API文檔\",\"数字资产介绍\":\"數位資產介紹\",\"官方验证通道\":\"官方驗證通道\",\"Huobi Blog\":\"Huobi Blog\",\"历史数据下载\":\"歷史數據下載\",\"邀请奖励\":\"推薦反佣獎勵\",\"服务\":\"服務支持\",\"Buy HUSD\":\"Buy HUSD\",\"费率\":\"費率\",\"交易规则介绍\":\"交易規則簡介\",\"借币额度\":\"借幣額度\",\"帮助中心\":\"幫助中心\",\"Global CEO 信箱\":\"Global CEO 信箱\",\"新手指南\":\"新手指南\",\"合约课堂\":\"合約課堂\",\"iToken\":\"iToken\",\"法币XXX\":\"法幣XXX\",\"杠杆介绍\":\"槓桿介紹\",\"HT介绍\":\"HT介紹\",\"支持\":\"支持\",\"上币申请\":\"上幣申請\",\"机构服务\":\"機構服務\",\"大客户权益\":\"大客戶權益\",\"经纪商\":\"經紀商\",\"广告方加V认证申请\":\"C2C廣告主驗證申請\",\"火币集团\":\"HTX\",\"Web3 Scholarship\":\"Web3 Scholarship\",\"超级返佣\":\"聯盟\",\"条款说明\":\"條款說明\",\"用户协议\":\"使用條款\",\"隐私条款\":\"隱私條款\",\"执法和监管查询\":\"执法和监管查询\",\"法币交易规则\":\"法幣交易規則\",\"关于反洗钱\":\"關於反洗錢\",\"加密介绍\":\"加密貨幣介紹\",\"首页\":\"首頁\",\"火币合约\":\"HTX 合約\",\"OTC Market\":\"OTC Market\",\"买币\":\"法幣交易\",\"行情\":\"行情\",\"币币交易\":\"現貨交易\",\"成长学院\":\"成長學院\",\"登录\":\"登錄\",\"注册\":\"註冊\",\"资产\":\"資產\",\"现货账户（充币&提币）\":\"現貨帳戶（充幣&提幣）\",\"币币账户\":\"幣幣帳戶\",\"杠杆账户\":\"槓桿帳戶\",\"法币账户\":\"法幣帳戶\",\"合约账户\":\"合約帳戶\",\"矿池账户\":\"礦池帳戶\",\"我的点卡\":\"我的點數卡\",\"信用卡买币\":\"信用卡買幣\",\"订单\":\"訂單\",\"现货&杠杆订单\":\"現貨&槓桿訂單\",\"法币订单\":\"法幣訂單\",\"合约订单\":\"合約訂單\",\"Buy&Sell History\":\"Buy&Sell History\",\"账户&安全\":\"帳戶&安全\",\"身份认证\":\"身分驗證\",\"提高账户安全\":\"提高账户安全\",\"法币设置\":\"法幣設置\",\"费率设置\":\"費率設定\",\"专业费率重磅升级\":\"專業費率重磅陞級\",\"我的优惠券\":\"我的優惠券\",\"积分中心\":\"積分中心\",\"邀请返佣\":\"邀請好友\",\"API管理\":\"API管理\",\"子账号\":\"子帳號\",\"退出\":\"登出\",\"交易所\":\"交易所\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX 韓國\",\"火币日本\":\"HTX 日本\",\"集团生态服务\":\"集团生态服务\",\"火币矿池\":\"HTX 礦池\",\"火信\":\"火信\",\"火币资本\":\"HTX 資本\",\"火币全球生态基金\":\"HTX 生態系統基金\",\"火币云\":\"HTX 雲\",\"火币生态链\":\"HTX 生態鏈\",\"火币DeFi Labs\":\"HTX DeFi實驗室\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"選擇有最佳報價的賣家\",\"一键买卖\":\"快速購買/售出\",\"快捷安全的数字资产交易\":\"快速且安全的數位資產交易\",\"现货交易\":\"現貨交易\",\"币币兑换，零费率，无滑点\":\"代幣對代幣的交換，零費率，無滑點。\",\"杠杆交易\":\"槓桿交易\",\"借币增加本金，放大收益\":\"借幣增加本金使你的利潤倍增\",\"策略交易\":\"策略交易\",\"7×24小时自动低买高卖\":\"7×24自動買低賣高\",\"场外大宗交易\":\"場外大宗交易\",\"行业领先的场外大宗交易和借贷服务\":\"領先平台的OTC block 交易和借貸服務\",\"合约交易\":\"合約交易\",\"合约总览\":\"合約概覽\",\"查看全部数字货币衍生产品\":\"查看全部數位貨幣衍生品\",\"币本位交割\":\"幣本位交割合約\",\"每日结算，强大的风控实力支持\":\"每日結算，由強大的風險控制實力支持。\",\"币本位永续\":\"幣本位永續\",\"担保资产价值稳定，减少持仓风险\":\"穩定的資產價值，減少風險。\",\"U本位合约\":\"USDT本位合約\",\"返佣高达60%\":\"高達60%的佣金\",\"期权\":\"期權\",\"多种玩法，自由做多做空\":\"多種玩法，自由做多做空。\",\"金融业务\":\"金融業務\",\"节点投票\":\"節點質押\",\"享受高奖励的节点投票\":\"享受高額獎勵的節點質押\",\"锁仓更简单，免费领空投\":\"輕鬆鎖倉，免費領空投。\",\"Polkadot Slot Auction\":\"Polkadot Slot Auction\",\"波卡平行链插槽竞拍\":\"Polkadot parachain 插槽拍賣\",\"一键挖矿，日日增收\":\"點擊一下挖礦，每天都能賺取利息。\",\"ETH 2.0\":\"ETH 2.0\",\"ETH2.0，一键换币\":\"ETH 2.0點擊一下換幣\",\"质押借币\":\"質押借幣\",\"数字资产，尊享急速到账体验\":\"享受你的數位資產快速入帳\",\"双币投资\":\"雙幣投資\",\"掌握价格波动，财富稳定增值\":\"掌握價格波動，財富穩定增值。\",\"The Gateway to Web 3.0\":\"The Gateway to Web 3.0\",\"Learn\":\"成長學院\",\"Rewards Hub\":\"獎勵中心\",\"资产总览\":\"資產總覽\",\"策略账户\":\"策略帳戶\",\"Huobi Earn账户\":\"理財帳戶\",\"质押账户\":\"質押帳戶\",\"期权账户\":\"期權帳戶\",\"限量优惠\":\"限量優惠\",\"Huobi Earn订单\":\"理財訂單\",\"策略订单\":\"策略\",\"存币宝订单\":\"存幣寶訂單\",\"质押借币订单\":\"質押借幣訂單\",\"返佣收益看板\":\"邀請儀表板\",\"站内信\":\"站內信\",\"查看全部\":\"查看全部\",\"暂无最新消息\":\"暫無最新消息\",\"隐藏已读\":\"隱藏已讀\",\"全部标为已读\":\"全部標爲已讀\",\"扫码下载 APP\":\"掃碼下載APP\",\"更多客户端\":\"更多客戶端\",\"语言\":\"語言\",\"折算货币\":\"換算貨幣\",\"提示\":\"提示\",\"确认将全部未读消息标记为已读？\":\"確認將全部未讀消息標記爲已讀？\",\"了解VIP\":\"了解VIP\",\"精英会员\":\"精英會員\",\"银卡VIP\":\"銀卡VIP\",\"金卡VIP\":\"金卡VIP\",\"白金卡VIP\":\"白金卡VIP\",\"黑卡VIP\":\"黑卡VIP\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"欢迎来到火币Global，您正在享受火币%s特权。\",\"取消\":\"取消\",\"确定\":\"確定\",\"快捷一键买卖\":\"快速一鍵買賣\",\"法币充值\":\"法幣充值\",\"P2P自选交易\":\"C2C 交易\",\"第三方交易\":\"第三方交易\",\"自选\":\"自訂\",\"现货\":\"現貨\",\"合约\":\"合約\",\"全仓杠杆\":\"全倉槓桿\",\"逐仓杠杆\":\"逐倉槓桿\",\"Tradingbot 策略交易\":\"網格策略交易\",\"期权交易\":\"期權交易\",\"理财相关\":\"理財相關\",\"Huobi Earn 理财\":\"HTX 理財\",\"其他\":\"其他\",\"节点质押投票\":\"節點質押投票\",\"ETH2.0\":\"ETH2.0\",\"借贷业务系统\":\"借貸業務\",\"OTC交易系统\":\"OTC 交易\",\"我的资产\":\"我的資產\",\"我的订单\":\"我的訂單\",\"消息\":\"訊息\",\"我的福利\":\"我的獎勵\",\"邀请返佣看板\":\"邀請回饋看板\",\"账户安全\":\"帳戶安全性\",\"子账号管理\":\"子帳號管理\",\"扫码下载 huobi App\":\"掃 QR CODE 下載 HTX App\",\"更多方式\":\"更多方式\",\"升级还需要现货交易<span>#num#U</span>\":\"現貨交易尚需 <span>#num#U</span> 才能升級\",\"升级还需要合约交易<span>#num#U</span>\":\"合約交易尚需 <span>#num#U</span> 才能升級\",\"升级还需要资沉<span>#num#U</span>\":\"資產餘額尚需 <span>#num#U</span> 才能升級\",\"手续费#num#折\":\"手續費 #num# 折\",\"HT抵扣#num#%\":\"HT 抵扣 #num#%\",\"生日好礼\":\"生日好禮\",\"杠杆\":\"槓桿\",\"理财\":\"理財\",\"法币\":\"法幣\",\"Welcome to Huobi\":\"歡迎來到 HTX\",\"There will be more exciting after login\":\"登入後享受更多服務\",\"全部资产\":\"全部資產\",\"Today’s P/L\":\"今日盈虧\",\"P/L\":\"盈虧\",\"点击查看\":\"點此檢視\",\"下载App\":\"下載 App\",\"退出登录\":\"登出\",\"关于火币\":\"關於 HTX\",\"关于我们\":\"關於我們\",\"火币集团介绍\":\"HTX 介紹\",\"数字资产\":\"數位資產\",\"火币云服务\":\"HTX 雲端服務\",\"火币Defi Labs\":\"HTX DeFi 實驗室\",\"CEO信箱\":\"CEO 信箱\",\"官网验证通道\":\"官網驗證器\",\"产品功能\":\"產品功能\",\"一键买币\":\"一鍵買幣\",\"TradingBot\":\"網格策略\",\"金融服务\":\"金融服務\",\"火币社区\":\"HTX 社群\",\"NFT\":\"NFT\",\"服务介绍\":\"服務介紹\",\"认证服务\":\"驗證服務\",\"费率介绍\":\"費率介紹\",\"币币交易规则\":\"現貨交易規則\",\"新手成长学院\":\"新手成長學院\",\"KOL招募\":\"KOL 招募\",\"经纪商申请\":\"經紀商申請\",\"广告方认证服务\":\"廣告方驗證服務\",\"开放平台\":\"開放平台\",\"API介绍\":\"API 介紹\",\"活动福利\":\"活動福利\",\"新用户奖励\":\"新會員獎勵\",\"入金奖励\":\"入金獎勵\",\"交易奖励\":\"交易獎勵\",\"免费领空投\":\"免費領空投\",\"月度大促\":\"每月促銷\",\"购买加密货币\":\"購買加密貨幣\",\"矿池\":\"矿池\",\"未认证\":\"未認證\",\"合约跟单\":\"合約跟單\",\"福利中心\":\"獎勵中心\",\"机构\":\"機構\",\"快捷买币\":\"快捷交易\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"支援 VISA/MASTER 等多種金融卡快速購買虛擬資產\",\"满足低手续费多种法币的充值\":\"以法幣加值再享低廉手續費\",\"P2P\":\"C2C\",\"多种法币0手续费最优价格\":\"免手續費為您媒合最佳價格\",\"自选交易对，行情尽在掌握\":\"自選交易對，即時掌握行情\",\"直达现货市场，抓住交易机会\":\"直達現貨市場，抓住交易機會\",\"了解合约行情动态，获取超额收益\":\"瞭解合約行情動態，獲得超額收益\",\"交易\":\"交易\",\"使用完整的交易功能，买卖虚拟资产\":\"使用完整的交易功能，買賣虛擬資產\",\"杠杆ETP\":\"槓桿 ETP\",\"无爆仓享受杠杆收益\":\"無爆倉享受槓桿收益\",\"借币交易，放大现货收益\":\"借幣交易，放大現貨收益\",\"丰富的量化交易策略，自动跟单，自动交易\":\"豐富的量化交易策略，自動跟單，自動交易\",\"火币闪兑\":\"HTX 閃兌\",\"币币兑换，零费率无滑点\":\"幣幣兌換，零費率無滑點。\",\"衍生品\":\"衍生品\",\"以USDT结算的合约交易\":\"以 USDT 結算的合約交易\",\"币本位合约\":\"幣本位合約\",\"以加密货币结算的合约交易\":\"以加密貨幣結算的合約交易\",\"欧式美式期权随心选择，财富稳定增值\":\"歐式美式期權隨心選擇，財富穩定增值\",\"自动跟随专业交易员下单，轻松盈利\":\"自動跟隨專業交易員下單，輕鬆盈利\",\"Huobi合约嘉年华\":\"HTX 合約嘉年華\",\"参加交易 iPhone14Pro Max等你拿\":\"參加交易 iPhone14 Pro Max 等你拿\",\"理财_menu\":\"理財\",\"Huobi Earn\":\"HTX 理財\",\"稳健的虚拟资产配置工具\":\"穩健的虛擬資產組態工具\",\"非保本高额收益结构型理财\":\"非保本高額收益結構型理財\",\"便捷抵押，安全交易\":\"便捷抵押，安全交易\",\"扩大交易规模和种类，实现多倍收益\":\"擴大交易規模和種類，實現多倍收益\",\"金融服务_menu\":\"金融服務\",\"迎接以太坊2.0\":\"迎接以太坊 2.0\",\"随借随还实时到账\":\"隨借隨還即時入帳\",\"尊享大宗交易零手续费\":\"尊享大宗交易零手續費\",\"社区\":\"社群\",\"Huobi社区\":\"HTX 社群\",\"在这里发现币圈财富机会\":\"發現幣圈財富機會\",\"快讯\":\"快訊\",\"7*24最全币圈资讯\":\"快速掌握最新幣圈資訊\",\"长文\":\"深度文章\",\"深入了解最新行业动态\":\"深入瞭解最新業界動態\",\"直播\":\"直播\",\"财富密码，实操教学\":\"財富密碼，實際操作教學\",\"从入门到精通一站式学习平台\":\"從入門到精通一站式學習平台\",\"博客\":\"HTX 部落格\",\"Huobi最新资讯和业务报道\":\"HTX 最新資訊和時事報導\",\"活动\":\"活動\",\"轻松赚币，天天领奖\":\"輕鬆賺幣，天天領獎\",\"Newlisting\":\"新幣專區\",\"新币福利营带你发现最佳资产\":\"新幣福利帶您發現最佳資產\",\"Primebox\":\"集卡拼禮\",\"虚拟资产财富之旅的记忆凭证\":\"開啟財富之旅\",\"交易赛\":\"交易賽\",\"牛人大师都爱的大赛\":\"達人大師都愛的大賽\",\"Web 3.0\":\"Web 3.0\",\"通往Web 3.0的虚拟资产钱包\":\"通往 Web 3.0 的虛擬資產錢包\",\"云钱包\":\"雲端錢包\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"無需自行保管私鑰，一鍵參與 DeFi 項目\",\"场外借贷\":\"OTC 借貸\",\"NewListing\":\"新幣專區\",\"我的费率\":\"我的費率\",\"我的邀请返佣\":\"我的邀請返佣\",\"合约社群\":\"合約社群\",\"经纪商看板\":\"經紀商面板\",\"iToken钱包\":\"iToken錢包\",\"内容\":\"內容\",\"多米尼克数字公民\":\"多米尼克數位公民\",\"体验\":\"體驗\",\"正式\":\"正式\",\"高级\":\"高級\",\"Prime会员权益\":\"Prime 會員權益\",\"体验卡\":\"體驗卡\",\"查看权益\":\"查看權益\",\"Global Licensed Businesses\":\"環球牌照業務\",\"资产托管\":\"資產託管\",\"主题背景\":\"外觀\",\"专业版\":\"專業版\",\"经典版\":\"經典版\",\"颜色偏好\":\"顏色偏好\",\"绿涨红跌\":\"綠漲紅跌\",\"红涨绿跌\":\"紅漲綠跌\",\"扫码添加\":\"掃碼加入\",\"官方微信：\":\"官方微信：\",\"官方QQ：\":\"官方 QQ：\",\"储备金证明\":\"儲備金證明\",\"赚币_menu\":\"賺幣\",\"赚币订单\":\"賺幣訂單\",\"赚币\":\"賺幣\",\"交易赎回活期赚币余额\":\"交易贖回活期賺幣餘額\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"開啟開關後，現貨可用中包含現貨帳戶當前幣種不借款時的可用餘額和活期賺幣餘額。現貨交易時，可以贖回活期賺幣餘額進行現貨交易\",\"行情资讯\":\"行情資訊\",\"HTX专区\":\"$HTX 專區\",\"一键收取HTX\":\"一鍵收取 $HTX\",\"任务奖励日日解锁\":\"每天解鎖任務獎勵\",\"加密货币价格\":\"加密貨幣價格\",\"搜索\":\"搜尋\",\"热门资产\":\"熱門資產\",\"热门话题\":\"熱門話題\",\"热门赚币\":\"熱門賺幣\",\"全部\":\"全部\",\"功能\":\"功能\",\"资讯\":\"資訊\",\"公告\":\"公告\",\"用户\":\"用戶\",\"#num#预约\":\"#num# 預約\",\"#num#观看\":\"#num# 觀看\",\"#num#回放\":\"#num# 回放\",\"预约\":\"預約\",\"看直播\":\"觀看直播\",\"看回放\":\"觀看重播\",\"暂无内容\":\"暫無內容\",\"永续\":\"永續\",\"当周\":\"當週\",\"次周\":\"次週\",\"当季\":\"當季\",\"次季\":\"次季\",\"#num#粉丝\":\"#num# 粉絲\",\"关注\":\"追蹤\",\"已关注\":\"已追蹤\",\"站点地图\":\"站點地圖\",\"相机扫码下载<p>火币App</p>\":\"相機掃碼下載 <p>HTX App</p>\",\"漏洞赏金\":\"漏洞賞金\",\"充币\":\"充幣\",\"提币\":\"提幣\",\"划转\":\"劃轉\",\"储备金证明报告\":\"儲備金證明報告\",\"切换账号\":\"切換帳號\",\"提醒\":\"提醒\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"清除帳號登入記錄後，該帳號再次登入時，需重新輸入密碼\",\"确认\":\"確認\",\"其他账号\":\"其他帳號\",\"管理\":\"管理\",\"完成\":\"完成\",\"搜索子账号\":\"搜索子賬號\",\"暂无数据\":\"暫無資料\",\"创建子账号\":\"創建子帳號\",\"清除\":\"清除\",\"添加其他账号\":\"添加其他帳號\",\"主账号\":\"主賬號\",\"最多添加10个其他账号，请清除后再添加\":\"最多添加 10 個其他帳號，請清除後再添加\",\"我知道了\":\"我知道了\",\"我的邀请奖励\":\"我的邀請獎勵\",\"复制成功\":\"複製成功\",\"交易机器人\":\"交易機器人\",\"借币\":\"借幣\",\"充值&提现状态\":\"充值&提現狀態\"}");

/***/ }),
/* 120 */
/***/ (function(module) {

module.exports = JSON.parse("{\"币圈问答百科\":\"幣圈問答百科\",\"做市商申请\":\"造市商申請\",\"火币网-领先的比特币交易平台\":\"火币网-领先的比特币交易平台\",\"工具\":\"工具\",\"客户端下载\":\"客户端下载\",\"API文档\":\"API文檔\",\"数字资产介绍\":\"數位資產介紹\",\"官方验证通道\":\"官方驗證通道\",\"Huobi Blog\":\"Huobi Blog\",\"历史数据下载\":\"歷史數據下載\",\"邀请奖励\":\"推薦反佣獎勵\",\"服务\":\"服務支持\",\"Buy HUSD\":\"Buy HUSD\",\"费率\":\"費率\",\"交易规则介绍\":\"交易規則簡介\",\"借币额度\":\"借幣額度\",\"帮助中心\":\"幫助中心\",\"Global CEO 信箱\":\"Global CEO 信箱\",\"新手指南\":\"新手指南\",\"合约课堂\":\"合約課堂\",\"iToken\":\"iToken\",\"法币XXX\":\"法幣XXX\",\"杠杆介绍\":\"槓桿介紹\",\"HT介绍\":\"HT介紹\",\"支持\":\"支持\",\"上币申请\":\"上幣申請\",\"机构服务\":\"機構服務\",\"大客户权益\":\"大客戶權益\",\"经纪商\":\"經紀商\",\"广告方加V认证申请\":\"C2C廣告主驗證申請\",\"火币集团\":\"HTX\",\"Web3 Scholarship\":\"Web3 Scholarship\",\"超级返佣\":\"聯盟\",\"条款说明\":\"條款說明\",\"用户协议\":\"使用條款\",\"隐私条款\":\"隱私條款\",\"执法和监管查询\":\"执法和监管查询\",\"法币交易规则\":\"法幣交易規則\",\"关于反洗钱\":\"關於反洗錢\",\"加密介绍\":\"加密貨幣介紹\",\"首页\":\"首頁\",\"火币合约\":\"HTX 合約\",\"OTC Market\":\"OTC Market\",\"买币\":\"法幣交易\",\"行情\":\"行情\",\"币币交易\":\"現貨交易\",\"成长学院\":\"成長學院\",\"登录\":\"登錄\",\"注册\":\"註冊\",\"资产\":\"資產\",\"现货账户（充币&提币）\":\"現貨帳戶（充幣&提幣）\",\"币币账户\":\"幣幣帳戶\",\"杠杆账户\":\"槓桿帳戶\",\"法币账户\":\"法幣帳戶\",\"合约账户\":\"合約帳戶\",\"矿池账户\":\"礦池帳戶\",\"我的点卡\":\"我的點數卡\",\"信用卡买币\":\"信用卡買幣\",\"订单\":\"訂單\",\"现货&杠杆订单\":\"現貨&槓桿訂單\",\"法币订单\":\"法幣訂單\",\"合约订单\":\"合約訂單\",\"Buy&Sell History\":\"Buy&Sell History\",\"账户&安全\":\"帳戶&安全\",\"身份认证\":\"身分驗證\",\"提高账户安全\":\"提高账户安全\",\"法币设置\":\"法幣設置\",\"费率设置\":\"費率設定\",\"专业费率重磅升级\":\"專業費率重磅陞級\",\"我的优惠券\":\"我的優惠券\",\"积分中心\":\"積分中心\",\"邀请返佣\":\"邀請好友\",\"API管理\":\"API管理\",\"子账号\":\"子帳號\",\"退出\":\"登出\",\"交易所\":\"交易所\",\"火币全球站\":\"HTX\",\"火币韩国\":\"HTX 韓國\",\"火币日本\":\"HTX 日本\",\"集团生态服务\":\"集团生态服务\",\"火币矿池\":\"HTX 礦池\",\"火信\":\"火信\",\"火币资本\":\"HTX 資本\",\"火币全球生态基金\":\"HTX 生態系統基金\",\"火币云\":\"HTX 雲\",\"火币生态链\":\"HTX 生態鏈\",\"火币DeFi Labs\":\"HTX DeFi實驗室\",\"火币OTC\":\"HTX OTC\",\"自选交易\":\"P2P\",\"选择最合算的卖家进行交易\":\"選擇有最佳報價的賣家\",\"一键买卖\":\"快速購買/售出\",\"快捷安全的数字资产交易\":\"快速且安全的數位資產交易\",\"现货交易\":\"現貨交易\",\"币币兑换，零费率，无滑点\":\"代幣對代幣的交換，零費率，無滑點。\",\"杠杆交易\":\"槓桿交易\",\"借币增加本金，放大收益\":\"借幣增加本金使你的利潤倍增\",\"策略交易\":\"策略交易\",\"7×24小时自动低买高卖\":\"7×24自動買低賣高\",\"场外大宗交易\":\"場外大宗交易\",\"行业领先的场外大宗交易和借贷服务\":\"領先平台的OTC block 交易和借貸服務\",\"合约交易\":\"合約交易\",\"合约总览\":\"合約概覽\",\"查看全部数字货币衍生产品\":\"查看全部數位貨幣衍生品\",\"币本位交割\":\"幣本位交割合約\",\"每日结算，强大的风控实力支持\":\"每日結算，由強大的風險控制實力支持。\",\"币本位永续\":\"幣本位永續\",\"担保资产价值稳定，减少持仓风险\":\"穩定的資產價值，減少風險。\",\"U本位合约\":\"USDT本位合約\",\"返佣高达60%\":\"高達60%的佣金\",\"期权\":\"期權\",\"多种玩法，自由做多做空\":\"多種玩法，自由做多做空。\",\"金融业务\":\"金融業務\",\"节点投票\":\"節點質押\",\"享受高奖励的节点投票\":\"享受高額獎勵的節點質押\",\"锁仓更简单，免费领空投\":\"輕鬆鎖倉，免費領空投。\",\"Polkadot Slot Auction\":\"Polkadot Slot Auction\",\"波卡平行链插槽竞拍\":\"Polkadot parachain 插槽拍賣\",\"一键挖矿，日日增收\":\"點擊一下挖礦，每天都能賺取利息。\",\"ETH 2.0\":\"ETH 2.0\",\"ETH2.0，一键换币\":\"ETH 2.0點擊一下換幣\",\"质押借币\":\"質押借幣\",\"数字资产，尊享急速到账体验\":\"享受你的數位資產快速入帳\",\"双币投资\":\"雙幣投資\",\"掌握价格波动，财富稳定增值\":\"掌握價格波動，財富穩定增值。\",\"The Gateway to Web 3.0\":\"The Gateway to Web 3.0\",\"Learn\":\"成長學院\",\"Rewards Hub\":\"獎勵中心\",\"资产总览\":\"資產總覽\",\"策略账户\":\"策略帳戶\",\"Huobi Earn账户\":\"理財帳戶\",\"质押账户\":\"質押帳戶\",\"期权账户\":\"期權帳戶\",\"限量优惠\":\"限量優惠\",\"Huobi Earn订单\":\"理財訂單\",\"策略订单\":\"策略\",\"存币宝订单\":\"存幣寶訂單\",\"质押借币订单\":\"質押借幣訂單\",\"返佣收益看板\":\"邀請儀表板\",\"站内信\":\"站內信\",\"查看全部\":\"查看全部\",\"暂无最新消息\":\"暫無最新消息\",\"隐藏已读\":\"隱藏已讀\",\"全部标为已读\":\"全部標爲已讀\",\"扫码下载 APP\":\"掃碼下載APP\",\"更多客户端\":\"更多客戶端\",\"语言\":\"語言\",\"折算货币\":\"換算貨幣\",\"提示\":\"提示\",\"确认将全部未读消息标记为已读？\":\"確認將全部未讀消息標記爲已讀？\",\"了解VIP\":\"了解VIP\",\"精英会员\":\"精英會員\",\"银卡VIP\":\"銀卡VIP\",\"金卡VIP\":\"金卡VIP\",\"白金卡VIP\":\"白金卡VIP\",\"黑卡VIP\":\"黑卡VIP\",\"欢迎来到火币Global，您正在享受火币%s特权。\":\"欢迎来到火币Global，您正在享受火币%s特权。\",\"取消\":\"取消\",\"确定\":\"確定\",\"快捷一键买卖\":\"快速一鍵買賣\",\"法币充值\":\"法幣充值\",\"P2P自选交易\":\"C2C 交易\",\"第三方交易\":\"第三方交易\",\"自选\":\"自訂\",\"现货\":\"現貨\",\"合约\":\"合約\",\"全仓杠杆\":\"全倉槓桿\",\"逐仓杠杆\":\"逐倉槓桿\",\"Tradingbot 策略交易\":\"網格策略交易\",\"期权交易\":\"期權交易\",\"理财相关\":\"理財相關\",\"Huobi Earn 理财\":\"HTX 理財\",\"其他\":\"其他\",\"节点质押投票\":\"節點質押投票\",\"ETH2.0\":\"ETH2.0\",\"借贷业务系统\":\"借貸業務\",\"OTC交易系统\":\"OTC 交易\",\"我的资产\":\"我的資產\",\"我的订单\":\"我的訂單\",\"消息\":\"訊息\",\"我的福利\":\"我的獎勵\",\"邀请返佣看板\":\"邀請回饋看板\",\"账户安全\":\"帳戶安全性\",\"子账号管理\":\"子帳號管理\",\"扫码下载 huobi App\":\"掃 QR CODE 下載 HTX App\",\"更多方式\":\"更多方式\",\"升级还需要现货交易<span>#num#U</span>\":\"現貨交易尚需 <span>#num#U</span> 才能升級\",\"升级还需要合约交易<span>#num#U</span>\":\"合約交易尚需 <span>#num#U</span> 才能升級\",\"升级还需要资沉<span>#num#U</span>\":\"資產餘額尚需 <span>#num#U</span> 才能升級\",\"手续费#num#折\":\"手續費 #num# 折\",\"HT抵扣#num#%\":\"HT 抵扣 #num#%\",\"生日好礼\":\"生日好禮\",\"杠杆\":\"槓桿\",\"理财\":\"理財\",\"法币\":\"法幣\",\"Welcome to Huobi\":\"歡迎來到 HTX\",\"There will be more exciting after login\":\"登入後享受更多服務\",\"全部资产\":\"全部資產\",\"Today’s P/L\":\"今日盈虧\",\"P/L\":\"盈虧\",\"点击查看\":\"點此檢視\",\"下载App\":\"下載 App\",\"退出登录\":\"登出\",\"关于火币\":\"關於 HTX\",\"关于我们\":\"關於我們\",\"火币集团介绍\":\"HTX 介紹\",\"数字资产\":\"數位資產\",\"火币云服务\":\"HTX 雲端服務\",\"火币Defi Labs\":\"HTX DeFi 實驗室\",\"CEO信箱\":\"CEO 信箱\",\"官网验证通道\":\"官網驗證器\",\"产品功能\":\"產品功能\",\"一键买币\":\"一鍵買幣\",\"TradingBot\":\"網格策略\",\"金融服务\":\"金融服務\",\"火币社区\":\"HTX 社群\",\"NFT\":\"NFT\",\"服务介绍\":\"服務介紹\",\"认证服务\":\"驗證服務\",\"费率介绍\":\"費率介紹\",\"币币交易规则\":\"現貨交易規則\",\"新手成长学院\":\"新手成長學院\",\"KOL招募\":\"KOL 招募\",\"经纪商申请\":\"經紀商申請\",\"广告方认证服务\":\"廣告方驗證服務\",\"开放平台\":\"開放平台\",\"API介绍\":\"API 介紹\",\"活动福利\":\"活動福利\",\"新用户奖励\":\"新會員獎勵\",\"入金奖励\":\"入金獎勵\",\"交易奖励\":\"交易獎勵\",\"免费领空投\":\"免費領空投\",\"月度大促\":\"每月促銷\",\"购买加密货币\":\"購買加密貨幣\",\"矿池\":\"矿池\",\"未认证\":\"未認證\",\"合约跟单\":\"合約跟單\",\"福利中心\":\"獎勵中心\",\"机构\":\"機構\",\"快捷买币\":\"快捷交易\",\"支持visa/master等多种银行卡快速购买虚拟资产\":\"支援 VISA/MASTER 等多種金融卡快速購買虛擬資產\",\"满足低手续费多种法币的充值\":\"以法幣加值再享低廉手續費\",\"P2P\":\"C2C\",\"多种法币0手续费最优价格\":\"免手續費為您媒合最佳價格\",\"自选交易对，行情尽在掌握\":\"自選交易對，即時掌握行情\",\"直达现货市场，抓住交易机会\":\"直達現貨市場，抓住交易機會\",\"了解合约行情动态，获取超额收益\":\"瞭解合約行情動態，獲得超額收益\",\"交易\":\"交易\",\"使用完整的交易功能，买卖虚拟资产\":\"使用完整的交易功能，買賣虛擬資產\",\"杠杆ETP\":\"槓桿 ETP\",\"无爆仓享受杠杆收益\":\"無爆倉享受槓桿收益\",\"借币交易，放大现货收益\":\"借幣交易，放大現貨收益\",\"丰富的量化交易策略，自动跟单，自动交易\":\"豐富的量化交易策略，自動跟單，自動交易\",\"火币闪兑\":\"HTX 閃兌\",\"币币兑换，零费率无滑点\":\"幣幣兌換，零費率無滑點。\",\"衍生品\":\"衍生品\",\"以USDT结算的合约交易\":\"以 USDT 結算的合約交易\",\"币本位合约\":\"幣本位合約\",\"以加密货币结算的合约交易\":\"以加密貨幣結算的合約交易\",\"欧式美式期权随心选择，财富稳定增值\":\"歐式美式期權隨心選擇，財富穩定增值\",\"自动跟随专业交易员下单，轻松盈利\":\"自動跟隨專業交易員下單，輕鬆盈利\",\"Huobi合约嘉年华\":\"HTX 合約嘉年華\",\"参加交易 iPhone14Pro Max等你拿\":\"參加交易 iPhone14 Pro Max 等你拿\",\"理财_menu\":\"理財\",\"Huobi Earn\":\"HTX 理財\",\"稳健的虚拟资产配置工具\":\"穩健的虛擬資產組態工具\",\"非保本高额收益结构型理财\":\"非保本高額收益結構型理財\",\"便捷抵押，安全交易\":\"便捷抵押，安全交易\",\"扩大交易规模和种类，实现多倍收益\":\"擴大交易規模和種類，實現多倍收益\",\"金融服务_menu\":\"金融服務\",\"迎接以太坊2.0\":\"迎接以太坊 2.0\",\"随借随还实时到账\":\"隨借隨還即時入帳\",\"尊享大宗交易零手续费\":\"尊享大宗交易零手續費\",\"社区\":\"社群\",\"Huobi社区\":\"HTX 社群\",\"在这里发现币圈财富机会\":\"發現幣圈財富機會\",\"快讯\":\"快訊\",\"7*24最全币圈资讯\":\"快速掌握最新幣圈資訊\",\"长文\":\"深度文章\",\"深入了解最新行业动态\":\"深入瞭解最新業界動態\",\"直播\":\"直播\",\"财富密码，实操教学\":\"財富密碼，實際操作教學\",\"从入门到精通一站式学习平台\":\"從入門到精通一站式學習平台\",\"博客\":\"HTX 部落格\",\"Huobi最新资讯和业务报道\":\"HTX 最新資訊和時事報導\",\"活动\":\"活動\",\"轻松赚币，天天领奖\":\"輕鬆賺幣，天天領獎\",\"Newlisting\":\"新幣專區\",\"新币福利营带你发现最佳资产\":\"新幣福利帶您發現最佳資產\",\"Primebox\":\"集卡拼禮\",\"虚拟资产财富之旅的记忆凭证\":\"開啟財富之旅\",\"交易赛\":\"交易賽\",\"牛人大师都爱的大赛\":\"達人大師都愛的大賽\",\"Web 3.0\":\"Web 3.0\",\"通往Web 3.0的虚拟资产钱包\":\"通往 Web 3.0 的虛擬資產錢包\",\"云钱包\":\"雲端錢包\",\"无需自己保管私钥，一键参与 DeFi 项目\":\"無需自行保管私鑰，一鍵參與 DeFi 項目\",\"场外借贷\":\"OTC 借貸\",\"NewListing\":\"新幣專區\",\"我的费率\":\"我的費率\",\"我的邀请返佣\":\"我的邀請返佣\",\"合约社群\":\"合約社群\",\"经纪商看板\":\"經紀商面板\",\"iToken钱包\":\"iToken錢包\",\"内容\":\"內容\",\"多米尼克数字公民\":\"多米尼克數位公民\",\"体验\":\"體驗\",\"正式\":\"正式\",\"高级\":\"高級\",\"Prime会员权益\":\"Prime 會員權益\",\"体验卡\":\"體驗卡\",\"查看权益\":\"查看權益\",\"Global Licensed Businesses\":\"環球牌照業務\",\"资产托管\":\"資產託管\",\"主题背景\":\"外觀\",\"专业版\":\"專業版\",\"经典版\":\"經典版\",\"颜色偏好\":\"顏色偏好\",\"绿涨红跌\":\"綠漲紅跌\",\"红涨绿跌\":\"紅漲綠跌\",\"扫码添加\":\"掃碼加入\",\"官方微信：\":\"官方微信：\",\"官方QQ：\":\"官方 QQ：\",\"储备金证明\":\"儲備金證明\",\"赚币_menu\":\"賺幣\",\"赚币订单\":\"賺幣訂單\",\"赚币\":\"賺幣\",\"交易赎回活期赚币余额\":\"交易贖回活期賺幣餘額\",\"开启开关后，现货可用中包含现货账户当前币种不借款时的可用余额和活期赚币余额，现货交易时，可赎回活期赚币余额进行现货交易\":\"開啟開關後，現貨可用中包含現貨帳戶當前幣種不借款時的可用餘額和活期賺幣餘額。現貨交易時，可以贖回活期賺幣餘額進行現貨交易\",\"行情资讯\":\"行情資訊\",\"HTX专区\":\"$HTX 專區\",\"一键收取HTX\":\"一鍵收取 $HTX\",\"任务奖励日日解锁\":\"每天解鎖任務獎勵\",\"加密货币价格\":\"加密貨幣價格\",\"搜索\":\"搜尋\",\"热门资产\":\"熱門資產\",\"热门话题\":\"熱門話題\",\"热门赚币\":\"熱門賺幣\",\"全部\":\"全部\",\"功能\":\"功能\",\"资讯\":\"資訊\",\"公告\":\"公告\",\"用户\":\"用戶\",\"#num#预约\":\"#num# 預約\",\"#num#观看\":\"#num# 觀看\",\"#num#回放\":\"#num# 回放\",\"预约\":\"預約\",\"看直播\":\"觀看直播\",\"看回放\":\"觀看重播\",\"暂无内容\":\"暫無內容\",\"永续\":\"永續\",\"当周\":\"當週\",\"次周\":\"次週\",\"当季\":\"當季\",\"次季\":\"次季\",\"#num#粉丝\":\"#num# 粉絲\",\"关注\":\"追蹤\",\"已关注\":\"已追蹤\",\"站点地图\":\"站點地圖\",\"相机扫码下载<p>火币App</p>\":\"相機掃碼下載 <p>HTX App</p>\",\"漏洞赏金\":\"漏洞賞金\",\"充币\":\"充幣\",\"提币\":\"提幣\",\"划转\":\"劃轉\",\"储备金证明报告\":\"儲備金證明報告\",\"切换账号\":\"切換帳號\",\"提醒\":\"提醒\",\"清除账号登录记录后，该账号再次登录时，需要重新输入密码\":\"清除帳號登入記錄後，該帳號再次登入時，需重新輸入密碼\",\"确认\":\"確認\",\"其他账号\":\"其他帳號\",\"管理\":\"管理\",\"完成\":\"完成\",\"搜索子账号\":\"搜索子賬號\",\"暂无数据\":\"暫無資料\",\"创建子账号\":\"創建子帳號\",\"清除\":\"清除\",\"添加其他账号\":\"添加其他帳號\",\"主账号\":\"主賬號\",\"最多添加10个其他账号，请清除后再添加\":\"最多添加 10 個其他帳號，請清除後再添加\",\"我知道了\":\"我知道了\",\"我的邀请奖励\":\"我的邀請獎勵\",\"复制成功\":\"複製成功\",\"交易机器人\":\"交易機器人\",\"借币\":\"借幣\",\"充值&提现状态\":\"充值&提現狀態\"}");

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var bind = __webpack_require__(69);
var Axios = __webpack_require__(122);
var mergeConfig = __webpack_require__(76);
var defaults = __webpack_require__(48);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(41);
axios.CancelToken = __webpack_require__(138);
axios.isCancel = __webpack_require__(75);
axios.VERSION = __webpack_require__(77).version;
axios.toFormData = __webpack_require__(72);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(26);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(139);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(140);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var buildURL = __webpack_require__(70);
var InterceptorManager = __webpack_require__(123);
var dispatchRequest = __webpack_require__(124);
var mergeConfig = __webpack_require__(76);
var buildFullPath = __webpack_require__(74);
var validator = __webpack_require__(137);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var transformData = __webpack_require__(125);
var isCancel = __webpack_require__(75);
var defaults = __webpack_require__(48);
var CanceledError = __webpack_require__(41);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var defaults = __webpack_require__(48);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(26);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__(77).version;
var AxiosError = __webpack_require__(26);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(41);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(31));
var context_1 = __webpack_require__(7);
var i18n_1 = __webpack_require__(14);
var url_1 = __webpack_require__(18);
var sensors_1 = __webpack_require__(27);
var base_dropdown_1 = __importDefault(__webpack_require__(96));
var index_1 = __importDefault(__webpack_require__(144));
var MenuDropDown = function (_a) {
    var className = _a.className, active = _a.active, data = _a.data, _b = _a.onSelect, onSelect = _b === void 0 ? function (event, item) { } : _b, placement = _a.placement, isShowFlag = _a.isShowFlag;
    var t = (0, i18n_1.useTranslation)().t;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale;
    var icon = data.icon, name = data.name, children = data.children, groups = data.groups;
    var _c = (0, react_1.useState)(false), isActive = _c[0], setActive = _c[1];
    var jumbTo = function (_a) {
        var path = _a.path, platform = _a.platform, track = _a.track;
        if (track) {
            (0, sensors_1.trackHeader)({
                button_name: track,
                type: 'click',
            });
        }
        if (path === undefined) {
            return false;
        }
        window.location.href = (0, url_1.getUrl)({ path: path, platform: platform, locale: locale, hostname: hostname });
    };
    // 选择
    var selectItem = function (item) {
        // @ts-ignore
        onSelect(null, item);
        jumbTo(item);
    };
    // 鼠标滑过事件
    var handleMouseEnter = function (_a) {
        var track = _a.track;
        if (track) {
            (0, sensors_1.trackHeader)({
                button_name: track,
                type: 'hover',
            });
        }
    };
    // 渲染tag
    var renderTags = function (item) {
        return item.tags
            ? item.tags.map(function (tag) {
                return react_1.default.createElement(index_1.default, { key: item.name, tag: tag });
            })
            : '';
    };
    var renderContent = function () {
        if (children && children.length) {
            return (react_1.default.createElement("div", { className: "hb-menu-dropdown__body hb-menu-dropdown__body--single" },
                react_1.default.createElement("section", { className: "hb-menu-dropdown__body__item--single" }, children.map(function (item, index) { return (react_1.default.createElement("div", { className: "hb-menu-dropdown__body__item ".concat((0, classnames_1.default)({
                        active: item.activeId != undefined && item.activeId === active,
                    })), key: index, onClick: function () { return selectItem(item); } },
                    react_1.default.createElement("div", { className: "body__item__txt" }, t(item.name)))); }))));
        }
        else if (groups && groups.length) {
            return (react_1.default.createElement("div", { className: "hb-menu-dropdown__body hb-menu-dropdown__body--multi" }, groups.map(function (item, ind) { return (react_1.default.createElement("section", { className: "hb-menu-dropdown__body__item--multi", key: ind },
                react_1.default.createElement("div", { className: "hb-menu-dropdown__body__item__sub" }, t(item.name)),
                item.children &&
                    item.children.map(function (obj, index) { return (react_1.default.createElement("div", { className: "hb-menu-dropdown__body__item ".concat((0, classnames_1.default)({
                            active: item.activeId != undefined && item.activeId === active,
                        })), key: index, onClick: function () { return selectItem(obj); } },
                        react_1.default.createElement("div", { className: "body__item__txt" }, t(obj.name)))); }))); })));
        }
        return '';
    };
    (0, react_1.useEffect)(function () {
        var ac = (children || groups || []).some(function (item) {
            if (item.children) {
                return item.children.some(function (c) { return c.activeId !== undefined && c.activeId === active; });
            }
            return item.activeId !== undefined && item.activeId === active;
        });
        // 处理没有子节点的数据
        if (data.activeId && (children || groups || []).length === 0) {
            ac = data.activeId === active;
        }
        setActive(ac);
    }, [active]);
    var renderTitle = function (_a) {
        var setReferenceElement = _a.setReferenceElement, handleClick = _a.handleClick, handleMouseEnter = _a.handleMouseEnter;
        return (react_1.default.createElement("div", { className: "toggle ".concat(isActive ? 'active' : ''), onMouseEnter: handleMouseEnter, onClick: handleClick, "data-ani": "linkage", ref: setReferenceElement },
            react_1.default.createElement("div", { className: "toggle__title" }, t(name)),
            react_1.default.createElement("i", { className: "toggle__triangle" })));
    };
    return (react_1.default.createElement(base_dropdown_1.default, { title: renderTitle, className: "header__menu__item hb-menu-dropdown ".concat(className), isActive: isActive, handleClick: function () { return jumbTo(data); }, handleMouseEnter: function () { return handleMouseEnter(data); }, placement: placement, isShowFlag: isShowFlag }, renderContent()));
};
exports.default = MenuDropDown;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var react_1 = __importDefault(__webpack_require__(0));
exports.default = (function (_a) {
    // if (tag.type === 'welfare') {
    //     return (
    //         <div className='hbg-title-tag1'><span>{tag.value + 'U'}</span></div>
    //     )
    // } else {
    //     return (<></>)
    // }
    var tag = _a.tag;
    switch (tag.type) {
        case 'welfare':
            return tag.value > 0 ? (react_1.default.createElement("div", { className: "hbg-title-tag1" },
                react_1.default.createElement("span", null, tag.value + 'U'))) : (react_1.default.createElement(react_1.default.Fragment, null));
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(240);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(148);
exports.Duplex = __webpack_require__(49);
exports.Transform = __webpack_require__(245);
exports.PassThrough = __webpack_require__(351);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(19)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(98);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(78));
util.inherits = __webpack_require__(61);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(349)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(241);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(147).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(242);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(49);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(49);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25), __webpack_require__(243).setImmediate, __webpack_require__(16)))

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle (delay, callback, options) {
  var _ref = options || {},
      _ref$noTrailing = _ref.noTrailing,
      noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
      _ref$noLeading = _ref.noLeading,
      noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
      _ref$debounceMode = _ref.debounceMode,
      debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */


  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel(options) {
    var _ref2 = options || {},
        _ref2$upcomingOnly = _ref2.upcomingOnly,
        upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;

    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();

        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, callback, options) {
  var _ref = options || {},
      _ref$atBegin = _ref.atBegin,
      atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;

  return throttle(delay, callback, {
    debounceMode: atBegin !== false
  });
}


//# sourceMappingURL=index.js.map


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(29);
var normalizeHeaderName = __webpack_require__(391);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(256);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(256);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var reducer_1 = __webpack_require__(59);
var storage_1 = __webpack_require__(58);
var utils_1 = __importDefault(__webpack_require__(20));
var i18n_2 = __webpack_require__(38);
var sensors_1 = __webpack_require__(27);
exports.default = (function (_a) {
    var active = _a.active, onSetLang = _a.onSetLang, _b = _a.handleLangs, handleLangs = _b === void 0 ? function () { } : _b;
    var _c = (0, i18n_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    var _d = (0, react_1.useContext)(context_1.HeaderContext), globalState = _d.globalState, dispatch = _d.dispatch;
    var locales = globalState.locales, noDisplayLocales = globalState.noDisplayLocales;
    var _e = (0, react_1.useState)([]), filterLocales = _e[0], setFilterLocales = _e[1];
    // 根据语言数组计算最终语言列表
    (0, react_1.useEffect)(function () {
        setFilterLocales(__spreadArray([], locales.filter(function (locale) { return !noDisplayLocales.includes(locale) && locale !== 'zh-hk'; }), true));
    }, [noDisplayLocales]);
    /**
     * 切换语言事件
     *
     * @param {Object} $event 触发事件对象
     * @param {string} locale 点击的语言名称
     */
    var gotoLocale = function ($event, locale) {
        if (typeof $event.preventDefault === 'function') {
            $event.preventDefault();
        }
        i18n.changeLanguage(locale, function (err, t) {
            if (err)
                return console.log('something went wrong loading', err);
            t('key'); // -> same as i18next.t
        });
        (0, storage_1.setLocalStorage)('lang', locale);
        utils_1.default.setCookie('local', locale, {
            domain: utils_1.default.getHost(1),
            path: '/',
            expires: 31536000,
        });
        dispatch({
            type: reducer_1.UPDATE_LOCALES,
            lang: locale,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'language',
            type: 'click',
        });
        onSetLang && onSetLang($event, locale);
    };
    return (react_1.default.createElement("div", { className: "hb-menu-dropdown__body__item--multi hbg-languages", style: { overflow: 'auto' } },
        react_1.default.createElement("div", { className: "hb-menu-dropdown__body__item__sub" }, t('语言')),
        react_1.default.createElement("div", { className: "hb-menu-dropdown__body__items" }, filterLocales.map(function (item, index) {
            return (react_1.default.createElement("div", { key: index, className: "hb-menu-dropdown__body__item ".concat(active === item ? 'active' : ''), onClick: function (event) {
                    gotoLocale(event, item);
                    handleLangs && handleLangs(item);
                } },
                react_1.default.createElement("div", { className: "body__item__txt" }, (0, i18n_2.getLocaleText)(item))));
        }))));
});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clipboard; }
});

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(279);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
var listen = __webpack_require__(370);
var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
// EXTERNAL MODULE: ./node_modules/select/src/select.js
var src_select = __webpack_require__(817);
var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
;// CONCATENATED MODULE: ./src/common/command.js
/**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */
function command(type) {
  try {
    return document.execCommand(type);
  } catch (err) {
    return false;
  }
}
;// CONCATENATED MODULE: ./src/actions/cut.js


/**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */

var ClipboardActionCut = function ClipboardActionCut(target) {
  var selectedText = select_default()(target);
  command('cut');
  return selectedText;
};

/* harmony default export */ var actions_cut = (ClipboardActionCut);
;// CONCATENATED MODULE: ./src/common/create-fake-element.js
/**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */
function createFakeElement(value) {
  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS

  fakeElement.style.fontSize = '12pt'; // Reset box model

  fakeElement.style.border = '0';
  fakeElement.style.padding = '0';
  fakeElement.style.margin = '0'; // Move element out of screen horizontally

  fakeElement.style.position = 'absolute';
  fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

  var yPosition = window.pageYOffset || document.documentElement.scrollTop;
  fakeElement.style.top = "".concat(yPosition, "px");
  fakeElement.setAttribute('readonly', '');
  fakeElement.value = value;
  return fakeElement;
}
;// CONCATENATED MODULE: ./src/actions/copy.js



/**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */

var fakeCopyAction = function fakeCopyAction(value, options) {
  var fakeElement = createFakeElement(value);
  options.container.appendChild(fakeElement);
  var selectedText = select_default()(fakeElement);
  command('copy');
  fakeElement.remove();
  return selectedText;
};
/**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */


var ClipboardActionCopy = function ClipboardActionCopy(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    container: document.body
  };
  var selectedText = '';

  if (typeof target === 'string') {
    selectedText = fakeCopyAction(target, options);
  } else if (target instanceof HTMLInputElement && !['text', 'search', 'url', 'tel', 'password'].includes(target === null || target === void 0 ? void 0 : target.type)) {
    // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
    selectedText = fakeCopyAction(target.value, options);
  } else {
    selectedText = select_default()(target);
    command('copy');
  }

  return selectedText;
};

/* harmony default export */ var actions_copy = (ClipboardActionCopy);
;// CONCATENATED MODULE: ./src/actions/default.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */

var ClipboardActionDefault = function ClipboardActionDefault() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Defines base properties passed from constructor.
  var _options$action = options.action,
      action = _options$action === void 0 ? 'copy' : _options$action,
      container = options.container,
      target = options.target,
      text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.

  if (action !== 'copy' && action !== 'cut') {
    throw new Error('Invalid "action" value, use either "copy" or "cut"');
  } // Sets the `target` property using an element that will be have its content copied.


  if (target !== undefined) {
    if (target && _typeof(target) === 'object' && target.nodeType === 1) {
      if (action === 'copy' && target.hasAttribute('disabled')) {
        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
      }

      if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
      }
    } else {
      throw new Error('Invalid "target" value, use a valid Element');
    }
  } // Define selection strategy based on `text` property.


  if (text) {
    return actions_copy(text, {
      container: container
    });
  } // Defines which selection strategy based on `target` property.


  if (target) {
    return action === 'cut' ? actions_cut(target) : actions_copy(target, {
      container: container
    });
  }
};

/* harmony default export */ var actions_default = (ClipboardActionDefault);
;// CONCATENATED MODULE: ./src/clipboard.js
function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }






/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */

function getAttributeValue(suffix, element) {
  var attribute = "data-clipboard-".concat(suffix);

  if (!element.hasAttribute(attribute)) {
    return;
  }

  return element.getAttribute(attribute);
}
/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */


var Clipboard = /*#__PURE__*/function (_Emitter) {
  _inherits(Clipboard, _Emitter);

  var _super = _createSuper(Clipboard);

  /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */
  function Clipboard(trigger, options) {
    var _this;

    _classCallCheck(this, Clipboard);

    _this = _super.call(this);

    _this.resolveOptions(options);

    _this.listenClick(trigger);

    return _this;
  }
  /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */


  _createClass(Clipboard, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
    }
    /**
     * Adds a click event listener to the passed trigger.
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     */

  }, {
    key: "listenClick",
    value: function listenClick(trigger) {
      var _this2 = this;

      this.listener = listen_default()(trigger, 'click', function (e) {
        return _this2.onClick(e);
      });
    }
    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var trigger = e.delegateTarget || e.currentTarget;
      var action = this.action(trigger) || 'copy';
      var text = actions_default({
        action: action,
        container: this.container,
        target: this.target(trigger),
        text: this.text(trigger)
      }); // Fires an event based on the copy operation result.

      this.emit(text ? 'success' : 'error', {
        action: action,
        text: text,
        trigger: trigger,
        clearSelection: function clearSelection() {
          if (trigger) {
            trigger.focus();
          }

          window.getSelection().removeAllRanges();
        }
      });
    }
    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultAction",
    value: function defaultAction(trigger) {
      return getAttributeValue('action', trigger);
    }
    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultTarget",
    value: function defaultTarget(trigger) {
      var selector = getAttributeValue('target', trigger);

      if (selector) {
        return document.querySelector(selector);
      }
    }
    /**
     * Allow fire programmatically a copy action
     * @param {String|HTMLElement} target
     * @param {Object} options
     * @returns Text copied.
     */

  }, {
    key: "defaultText",

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */
    value: function defaultText(trigger) {
      return getAttributeValue('text', trigger);
    }
    /**
     * Destroy lifecycle.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listener.destroy();
    }
  }], [{
    key: "copy",
    value: function copy(target) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        container: document.body
      };
      return actions_copy(target, options);
    }
    /**
     * Allow fire programmatically a cut action
     * @param {String|HTMLElement} target
     * @returns Text cutted.
     */

  }, {
    key: "cut",
    value: function cut(target) {
      return actions_cut(target);
    }
    /**
     * Returns the support of the given action, or all actions if no action is
     * given.
     * @param {String} [action]
     */

  }, {
    key: "isSupported",
    value: function isSupported() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
      var actions = typeof action === 'string' ? [action] : action;
      var support = !!document.queryCommandSupported;
      actions.forEach(function (action) {
        support = support && !!document.queryCommandSupported(action);
      });
      return support;
    }
  }]);

  return Clipboard;
}((tiny_emitter_default()));

/* harmony default export */ var clipboard = (Clipboard);

/***/ }),

/***/ 828:
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(828);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 879:
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(879);
var delegate = __webpack_require__(438);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 817:
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(686);
/******/ })()
.default;
});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(427);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(156);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(432);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var collapes_1 = __webpack_require__(160);
var FedCollapse = function (_a) {
    var title = _a.title, children = _a.children;
    var _b = (0, react_1.useState)(false), isOpened = _b[0], setIsOpened = _b[1];
    var toggle = function () {
        setIsOpened(function (prev) { return !prev; });
    };
    return (react_1.default.createElement("div", { className: "fed-collapes-item" },
        react_1.default.createElement("div", { className: "fed-collapes-item__title", "aria-expanded": String(isOpened), onClick: toggle },
            react_1.default.createElement("span", { className: "fed-collapes-item__title-text" }, title),
            react_1.default.createElement("i", { className: "fed-icon__arrow" })),
        react_1.default.createElement(collapes_1.Collapse, { isOpened: isOpened, theme: {
                collapse: 'fed-collapes-item__content-wrapper',
                content: 'fed-collapes-item__content',
            } }, children)));
};
exports.default = FedCollapse;
// Default export
// module.exports = UnmountClosed;
// Extra "named exports"
// UnmountClosed.Collapse = Collapse;
// UnmountClosed.UnmountClosed = UnmountClosed;
// export default UnmountClosed;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
// @ts-nocheck
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(9));
var Collapse = /** @class */ (function (_super) {
    __extends(Collapse, _super);
    function Collapse(props) {
        var _this = _super.call(this, props) || this;
        _this.timeout = undefined;
        _this.container = undefined;
        _this.content = undefined;
        _this.onResize = function () {
            clearTimeout(_this.timeout);
            if (!_this.container || !_this.content) {
                return;
            }
            var _a = _this.props, isOpened = _a.isOpened, checkTimeout = _a.checkTimeout;
            var containerHeight = Math.floor(_this.container.clientHeight);
            var contentHeight = Math.floor(_this.content.clientHeight);
            var isFullyOpened = isOpened && Math.abs(contentHeight - containerHeight) <= 1;
            var isFullyClosed = !isOpened && Math.abs(containerHeight) <= 1;
            if (isFullyOpened || isFullyClosed) {
                _this.onRest({ isFullyOpened: isFullyOpened, isFullyClosed: isFullyClosed, isOpened: isOpened, containerHeight: containerHeight, contentHeight: contentHeight });
            }
            else {
                _this.onWork({ isFullyOpened: isFullyOpened, isFullyClosed: isFullyClosed, isOpened: isOpened, containerHeight: containerHeight, contentHeight: contentHeight });
                _this.timeout = setTimeout(function () { return _this.onResize(); }, checkTimeout);
            }
        };
        _this.onRest = function (_a) {
            var isFullyOpened = _a.isFullyOpened, isFullyClosed = _a.isFullyClosed, isOpened = _a.isOpened, containerHeight = _a.containerHeight, contentHeight = _a.contentHeight;
            if (!_this.container || !_this.content) {
                return;
            }
            var hasOpened = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
            var hasClosed = !isOpened && _this.container.style.height === '0px';
            if (hasOpened || hasClosed) {
                _this.container.style.overflow = isOpened ? 'initial' : 'hidden';
                _this.container.style.height = isOpened ? 'auto' : '0px';
                var onRest = _this.props.onRest;
                if (onRest) {
                    onRest({ isFullyOpened: isFullyOpened, isFullyClosed: isFullyClosed, isOpened: isOpened, containerHeight: containerHeight, contentHeight: contentHeight });
                }
            }
        };
        _this.onWork = function (_a) {
            var isFullyOpened = _a.isFullyOpened, isFullyClosed = _a.isFullyClosed, isOpened = _a.isOpened, containerHeight = _a.containerHeight, contentHeight = _a.contentHeight;
            if (!_this.container || !_this.content) {
                return;
            }
            var isOpenining = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
            var isClosing = !isOpened && _this.container.style.height === '0px';
            if (isOpenining || isClosing) {
                // No need to do any work
                return;
            }
            _this.container.style.overflow = 'hidden';
            _this.container.style.height = isOpened ? "".concat(contentHeight, "px") : '0px';
            var onWork = _this.props.onWork;
            if (onWork) {
                onWork({ isFullyOpened: isFullyOpened, isFullyClosed: isFullyClosed, isOpened: isOpened, containerHeight: containerHeight, contentHeight: contentHeight });
            }
        };
        _this.onRefContainer = function (container) {
            _this.container = container;
        };
        _this.onRefContent = function (content) {
            _this.content = content;
        };
        if (props.initialStyle) {
            _this.initialStyle = props.initialStyle;
        }
        else {
            _this.initialStyle = props.isOpened
                ? { height: 'auto', overflow: 'initial' }
                : { height: '0px', overflow: 'hidden' };
        }
        return _this;
    }
    Collapse.prototype.componentDidMount = function () {
        this.onResize();
    };
    Collapse.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, theme = _a.theme, isOpened = _a.isOpened, children = _a.children;
        return (children !== nextProps.children ||
            isOpened !== nextProps.isOpened ||
            Object.keys(theme).some(function (c) { return theme[c] !== nextProps.theme[c]; }));
    };
    Collapse.prototype.getSnapshotBeforeUpdate = function () {
        if (!this.container || !this.content) {
            return null;
        }
        if (this.container.style.height === 'auto') {
            var contentHeight = this.content.clientHeight;
            this.container.style.height = "".concat(contentHeight, "px");
        }
        return null;
    };
    Collapse.prototype.componentDidUpdate = function () {
        this.onResize();
    };
    Collapse.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeout);
    };
    Collapse.prototype.render = function () {
        var _a = this.props, theme = _a.theme, children = _a.children, isOpened = _a.isOpened;
        return (react_1.default.createElement("div", { ref: this.onRefContainer, className: theme.collapse, style: this.initialStyle, "aria-hidden": !isOpened },
            react_1.default.createElement("div", { ref: this.onRefContent, className: theme.content }, children)));
    };
    Collapse.propTypes = {
        theme: prop_types_1.default.shape({
            collapse: prop_types_1.default.string,
            content: prop_types_1.default.string,
        }),
        isOpened: prop_types_1.default.bool.isRequired,
        initialStyle: prop_types_1.default.shape({
            height: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
            overflow: prop_types_1.default.string,
        }),
        onRest: prop_types_1.default.func,
        onWork: prop_types_1.default.func,
        checkTimeout: prop_types_1.default.number,
        children: prop_types_1.default.node.isRequired,
    };
    Collapse.defaultProps = {
        theme: {
            collapse: 'ReactCollapse--collapse',
            content: 'ReactCollapse--content',
        },
        initialStyle: undefined,
        onRest: undefined,
        onWork: undefined,
        checkTimeout: 50,
    };
    return Collapse;
}(react_1.default.Component));
exports.Collapse = Collapse;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var React = __importStar(__webpack_require__(0));
var ahooks_1 = __webpack_require__(236);
var hooks_1 = __webpack_require__(235);
var getDirectionStyle = function (dir, width) {
    switch (dir) {
        case 'left':
            return {
                top: 0,
                left: 0,
                transform: 'translate3d(-100%, 0, 0)',
                width: width,
                height: '100vh',
            };
        case 'right':
            return {
                top: 0,
                right: 0,
                transform: 'translate3d(100%, 0, 0)',
                width: width,
                height: '100vh',
            };
        case 'bottom':
            return {
                left: 0,
                right: 0,
                bottom: 0,
                transform: 'translate3d(0, 100%, 0)',
                width: '100%',
                height: width,
            };
        case 'top':
            return {
                left: 0,
                right: 0,
                top: 0,
                transform: 'translate3d(0, -100%, 0)',
                width: '100%',
                height: width,
            };
        default:
            return {};
    }
};
var Drawer = function (_a) {
    var open = _a.open, handleChange = _a.handleChange, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, children = _a.children, style = _a.style, _c = _a.enableOverlay, enableOverlay = _c === void 0 ? true : _c, _d = _a.overlayColor, overlayColor = _d === void 0 ? '#000' : _d, _e = _a.overlayOpacity, overlayOpacity = _e === void 0 ? 0.6 : _e, _f = _a.zIndex, zIndex = _f === void 0 ? 1002 : _f, _g = _a.duration, duration = _g === void 0 ? 300 : _g, direction = _a.direction, _h = _a.width, width = _h === void 0 ? null : _h, _j = _a.className, className = _j === void 0 ? '' : _j;
    var overlayStyles = {
        backgroundColor: "".concat(overlayColor),
        opacity: "".concat(overlayOpacity),
        zIndex: zIndex,
    };
    var drawerStyles = __assign(__assign({ zIndex: zIndex + 1, transitionDuration: "".concat(duration, "ms") }, getDirectionStyle(direction, width)), style);
    var closeDrawer = function () {
        if (handleChange) {
            handleChange(false);
        }
        else {
            console.warn('请传入控制状态函数');
        }
        onClose();
    };
    var windownSize = (0, hooks_1.useWindowSize)();
    var _k = React.useState('dark'), closeSrc = _k[0], setCloseSrc = _k[1];
    (0, ahooks_1.useDebounceEffect)(function () {
        if (windownSize.width !== undefined && windownSize.width <= 1027) {
            setCloseSrc('light');
        }
        else {
            setCloseSrc('dark');
        }
    }, [windownSize.width], {
        wait: 300,
    });
    return (React.createElement("div", { className: "HBDrawer ".concat(open ? 'HBDrawer--open' : '') },
        React.createElement("div", { id: 'HBDrawer__container', style: drawerStyles, className: 'HBDrawer__container ' + className },
            React.createElement("div", { className: "HBDrawer__header" },
                React.createElement("div", { className: "HBDrawer__title", onClick: closeDrawer },
                    React.createElement("i", { className: "hbg-drawer__icon-back" }))),
            React.createElement("div", { className: "hbg-drawer__content" }, children)),
        enableOverlay && React.createElement("div", { className: "HBDrawer__overlay", style: overlayStyles, onClick: closeDrawer })));
};
exports.default = Drawer;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(164),
    isObject = __webpack_require__(32),
    isSymbol = __webpack_require__(166);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(165);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detachEvent == 'function') {
    node.detachEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(171),
    isObjectLike = __webpack_require__(34);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(172),
    equalArrays = __webpack_require__(85),
    equalByTag = __webpack_require__(204),
    equalObjects = __webpack_require__(208),
    getTag = __webpack_require__(230),
    isArray = __webpack_require__(52),
    isBuffer = __webpack_require__(86),
    isTypedArray = __webpack_require__(88);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42),
    stackClear = __webpack_require__(178),
    stackDelete = __webpack_require__(179),
    stackGet = __webpack_require__(180),
    stackHas = __webpack_require__(181),
    stackSet = __webpack_require__(182);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42),
    Map = __webpack_require__(51),
    MapCache = __webpack_require__(84);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(82),
    isMasked = __webpack_require__(184),
    isObject = __webpack_require__(32),
    toSource = __webpack_require__(83);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(185);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(188),
    ListCache = __webpack_require__(42),
    Map = __webpack_require__(51);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(189),
    hashDelete = __webpack_require__(190),
    hashGet = __webpack_require__(191),
    hashHas = __webpack_require__(192),
    hashSet = __webpack_require__(193);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(44);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(44);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(44);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(44);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(45);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(45);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(45);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(45);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(84),
    setCacheAdd = __webpack_require__(200),
    setCacheHas = __webpack_require__(201);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    Uint8Array = __webpack_require__(205),
    eq = __webpack_require__(81),
    equalArrays = __webpack_require__(85),
    mapToArray = __webpack_require__(206),
    setToArray = __webpack_require__(207);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(209);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(210),
    getSymbols = __webpack_require__(212),
    keys = __webpack_require__(215);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(211),
    isArray = __webpack_require__(52);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(213),
    stubArray = __webpack_require__(214);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(216),
    baseKeys = __webpack_require__(225),
    isArrayLike = __webpack_require__(229);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(217),
    isArguments = __webpack_require__(218),
    isArray = __webpack_require__(52),
    isBuffer = __webpack_require__(86),
    isIndex = __webpack_require__(221),
    isTypedArray = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(219),
    isObjectLike = __webpack_require__(34);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33),
    isLength = __webpack_require__(89),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(80);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(87)(module)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(226),
    nativeKeys = __webpack_require__(227);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 226 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(228);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 228 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(82),
    isLength = __webpack_require__(89);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(231),
    Map = __webpack_require__(51),
    Promise = __webpack_require__(232),
    Set = __webpack_require__(233),
    WeakMap = __webpack_require__(234),
    baseGetTag = __webpack_require__(33),
    toSource = __webpack_require__(83);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
var react_1 = __webpack_require__(0);
// Hook
function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var _a = (0, react_1.useState)({
        width: undefined,
        height: undefined,
    }), windowSize = _a[0], setWindowSize = _a[1];
    (0, react_1.useEffect)(function () {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}
exports.useWindowSize = useWindowSize;


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "useRequest", function() { return /* reexport */ es_useRequest; });
__webpack_require__.d(__webpack_exports__, "useControllableValue", function() { return /* reexport */ es_useControllableValue; });
__webpack_require__.d(__webpack_exports__, "useDynamicList", function() { return /* reexport */ es_useDynamicList; });
__webpack_require__.d(__webpack_exports__, "useVirtualList", function() { return /* reexport */ es_useVirtualList; });
__webpack_require__.d(__webpack_exports__, "useResponsive", function() { return /* reexport */ useResponsive; });
__webpack_require__.d(__webpack_exports__, "useEventEmitter", function() { return /* reexport */ useEventEmitter; });
__webpack_require__.d(__webpack_exports__, "useLocalStorageState", function() { return /* reexport */ es_useLocalStorageState; });
__webpack_require__.d(__webpack_exports__, "useSessionStorageState", function() { return /* reexport */ es_useSessionStorageState; });
__webpack_require__.d(__webpack_exports__, "useSize", function() { return /* reexport */ es_useSize; });
__webpack_require__.d(__webpack_exports__, "configResponsive", function() { return /* reexport */ configResponsive; });
__webpack_require__.d(__webpack_exports__, "useUpdateEffect", function() { return /* reexport */ useUpdateEffect; });
__webpack_require__.d(__webpack_exports__, "useUpdateLayoutEffect", function() { return /* reexport */ useUpdateLayoutEffect; });
__webpack_require__.d(__webpack_exports__, "useBoolean", function() { return /* reexport */ useBoolean; });
__webpack_require__.d(__webpack_exports__, "useToggle", function() { return /* reexport */ es_useToggle; });
__webpack_require__.d(__webpack_exports__, "useDocumentVisibility", function() { return /* reexport */ es_useDocumentVisibility; });
__webpack_require__.d(__webpack_exports__, "useSelections", function() { return /* reexport */ useSelections; });
__webpack_require__.d(__webpack_exports__, "useThrottle", function() { return /* reexport */ es_useThrottle; });
__webpack_require__.d(__webpack_exports__, "useThrottleFn", function() { return /* reexport */ es_useThrottleFn; });
__webpack_require__.d(__webpack_exports__, "useThrottleEffect", function() { return /* reexport */ es_useThrottleEffect; });
__webpack_require__.d(__webpack_exports__, "useDebounce", function() { return /* reexport */ es_useDebounce; });
__webpack_require__.d(__webpack_exports__, "useDebounceFn", function() { return /* reexport */ es_useDebounceFn; });
__webpack_require__.d(__webpack_exports__, "useDebounceEffect", function() { return /* reexport */ es_useDebounceEffect; });
__webpack_require__.d(__webpack_exports__, "usePrevious", function() { return /* reexport */ es_usePrevious; });
__webpack_require__.d(__webpack_exports__, "useMouse", function() { return /* reexport */ useMouse; });
__webpack_require__.d(__webpack_exports__, "useScroll", function() { return /* reexport */ es_useScroll; });
__webpack_require__.d(__webpack_exports__, "useClickAway", function() { return /* reexport */ useClickAway; });
__webpack_require__.d(__webpack_exports__, "useFullscreen", function() { return /* reexport */ es_useFullscreen; });
__webpack_require__.d(__webpack_exports__, "useInViewport", function() { return /* reexport */ es_useInViewport; });
__webpack_require__.d(__webpack_exports__, "useKeyPress", function() { return /* reexport */ es_useKeyPress; });
__webpack_require__.d(__webpack_exports__, "useEventListener", function() { return /* reexport */ es_useEventListener; });
__webpack_require__.d(__webpack_exports__, "useHover", function() { return /* reexport */ useHover; });
__webpack_require__.d(__webpack_exports__, "useUnmount", function() { return /* reexport */ es_useUnmount; });
__webpack_require__.d(__webpack_exports__, "useSet", function() { return /* reexport */ es_useSet; });
__webpack_require__.d(__webpack_exports__, "useMemoizedFn", function() { return /* reexport */ es_useMemoizedFn; });
__webpack_require__.d(__webpack_exports__, "useMap", function() { return /* reexport */ es_useMap; });
__webpack_require__.d(__webpack_exports__, "useCreation", function() { return /* reexport */ useCreation; });
__webpack_require__.d(__webpack_exports__, "useDrag", function() { return /* reexport */ es_useDrag; });
__webpack_require__.d(__webpack_exports__, "useDrop", function() { return /* reexport */ es_useDrop; });
__webpack_require__.d(__webpack_exports__, "useMount", function() { return /* reexport */ es_useMount; });
__webpack_require__.d(__webpack_exports__, "useCounter", function() { return /* reexport */ es_useCounter; });
__webpack_require__.d(__webpack_exports__, "useUpdate", function() { return /* reexport */ es_useUpdate; });
__webpack_require__.d(__webpack_exports__, "useTextSelection", function() { return /* reexport */ es_useTextSelection; });
__webpack_require__.d(__webpack_exports__, "useEventTarget", function() { return /* reexport */ es_useEventTarget; });
__webpack_require__.d(__webpack_exports__, "useHistoryTravel", function() { return /* reexport */ useHistoryTravel; });
__webpack_require__.d(__webpack_exports__, "useCookieState", function() { return /* reexport */ es_useCookieState; });
__webpack_require__.d(__webpack_exports__, "useSetState", function() { return /* reexport */ es_useSetState; });
__webpack_require__.d(__webpack_exports__, "useInterval", function() { return /* reexport */ es_useInterval; });
__webpack_require__.d(__webpack_exports__, "useWhyDidYouUpdate", function() { return /* reexport */ useWhyDidYouUpdate; });
__webpack_require__.d(__webpack_exports__, "useTitle", function() { return /* reexport */ es_useTitle; });
__webpack_require__.d(__webpack_exports__, "useNetwork", function() { return /* reexport */ es_useNetwork; });
__webpack_require__.d(__webpack_exports__, "useTimeout", function() { return /* reexport */ es_useTimeout; });
__webpack_require__.d(__webpack_exports__, "useReactive", function() { return /* reexport */ es_useReactive; });
__webpack_require__.d(__webpack_exports__, "useFavicon", function() { return /* reexport */ es_useFavicon; });
__webpack_require__.d(__webpack_exports__, "useCountDown", function() { return /* reexport */ useCountDown; });
__webpack_require__.d(__webpack_exports__, "useWebSocket", function() { return /* reexport */ useWebSocket; });
__webpack_require__.d(__webpack_exports__, "useLockFn", function() { return /* reexport */ es_useLockFn; });
__webpack_require__.d(__webpack_exports__, "useUnmountedRef", function() { return /* reexport */ es_useUnmountedRef; });
__webpack_require__.d(__webpack_exports__, "useExternal", function() { return /* reexport */ es_useExternal; });
__webpack_require__.d(__webpack_exports__, "useSafeState", function() { return /* reexport */ es_useSafeState; });
__webpack_require__.d(__webpack_exports__, "useLatest", function() { return /* reexport */ es_useLatest; });
__webpack_require__.d(__webpack_exports__, "useIsomorphicLayoutEffect", function() { return /* reexport */ es_useIsomorphicLayoutEffect; });
__webpack_require__.d(__webpack_exports__, "useDeepCompareEffect", function() { return /* reexport */ useDeepCompareEffect; });
__webpack_require__.d(__webpack_exports__, "useDeepCompareLayoutEffect", function() { return /* reexport */ useDeepCompareLayoutEffect; });
__webpack_require__.d(__webpack_exports__, "useAsyncEffect", function() { return /* reexport */ es_useAsyncEffect; });
__webpack_require__.d(__webpack_exports__, "useLongPress", function() { return /* reexport */ es_useLongPress; });
__webpack_require__.d(__webpack_exports__, "useRafState", function() { return /* reexport */ es_useRafState; });
__webpack_require__.d(__webpack_exports__, "useTrackedEffect", function() { return /* reexport */ es_useTrackedEffect; });
__webpack_require__.d(__webpack_exports__, "usePagination", function() { return /* reexport */ es_usePagination; });
__webpack_require__.d(__webpack_exports__, "useAntdTable", function() { return /* reexport */ es_useAntdTable; });
__webpack_require__.d(__webpack_exports__, "useFusionTable", function() { return /* reexport */ es_useFusionTable; });
__webpack_require__.d(__webpack_exports__, "useInfiniteScroll", function() { return /* reexport */ es_useInfiniteScroll; });
__webpack_require__.d(__webpack_exports__, "useGetState", function() { return /* reexport */ es_useGetState; });
__webpack_require__.d(__webpack_exports__, "clearCache", function() { return /* reexport */ clearCache; });
__webpack_require__.d(__webpack_exports__, "useFocusWithin", function() { return /* reexport */ useFocusWithin; });
__webpack_require__.d(__webpack_exports__, "createUpdateEffect", function() { return /* reexport */ createUpdateEffect_createUpdateEffect; });
__webpack_require__.d(__webpack_exports__, "useRafInterval", function() { return /* reexport */ es_useRafInterval; });
__webpack_require__.d(__webpack_exports__, "useRafTimeout", function() { return /* reexport */ es_useRafTimeout; });
__webpack_require__.d(__webpack_exports__, "useResetState", function() { return /* reexport */ es_useResetState; });
__webpack_require__.d(__webpack_exports__, "useMutationObserver", function() { return /* reexport */ es_useMutationObserver; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(0);

// CONCATENATED MODULE: ./node_modules/ahooks/es/createUpdateEffect/index.js

var createUpdateEffect_createUpdateEffect = function createUpdateEffect(hook) {
  return function (effect, deps) {
    var isMounted = Object(external_react_["useRef"])(false); // for react-refresh

    hook(function () {
      return function () {
        isMounted.current = false;
      };
    }, []);
    hook(function () {
      if (!isMounted.current) {
        isMounted.current = true;
      } else {
        return effect();
      }
    }, deps);
  };
};
/* harmony default export */ var es_createUpdateEffect = (createUpdateEffect_createUpdateEffect);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useMemoizedFn/index.js



function useMemoizedFn(fn) {
  if (false) {}

  var fnRef = Object(external_react_["useRef"])(fn); // why not write `fnRef.current = fn`?
  // https://github.com/alibaba/hooks/issues/728

  fnRef.current = Object(external_react_["useMemo"])(function () {
    return fn;
  }, [fn]);
  var memoizedFn = Object(external_react_["useRef"])();

  if (!memoizedFn.current) {
    memoizedFn.current = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return fnRef.current.apply(this, args);
    };
  }

  return memoizedFn.current;
}

/* harmony default export */ var es_useMemoizedFn = (useMemoizedFn);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useUpdateEffect/index.js


/* harmony default export */ var useUpdateEffect = (createUpdateEffect_createUpdateEffect(external_react_["useEffect"]));
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/useAutoRunPlugin.js
var __read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};


 // support refreshDeps & ready

var useAutoRunPlugin_useAutoRunPlugin = function useAutoRunPlugin(fetchInstance, _a) {
  var manual = _a.manual,
      _b = _a.ready,
      ready = _b === void 0 ? true : _b,
      _c = _a.defaultParams,
      defaultParams = _c === void 0 ? [] : _c,
      _d = _a.refreshDeps,
      refreshDeps = _d === void 0 ? [] : _d,
      refreshDepsAction = _a.refreshDepsAction;
  var hasAutoRun = Object(external_react_["useRef"])(false);
  hasAutoRun.current = false;
  useUpdateEffect(function () {
    if (!manual && ready) {
      hasAutoRun.current = true;
      fetchInstance.run.apply(fetchInstance, __spread(defaultParams));
    }
  }, [ready]);
  useUpdateEffect(function () {
    if (hasAutoRun.current) {
      return;
    }

    if (!manual) {
      hasAutoRun.current = true;

      if (refreshDepsAction) {
        refreshDepsAction();
      } else {
        fetchInstance.refresh();
      }
    }
  }, __spread(refreshDeps));
  return {
    onBefore: function onBefore() {
      if (!ready) {
        return {
          stopNow: true
        };
      }
    }
  };
};

useAutoRunPlugin_useAutoRunPlugin.onInit = function (_a) {
  var _b = _a.ready,
      ready = _b === void 0 ? true : _b,
      manual = _a.manual;
  return {
    loading: !manual && ready
  };
};

/* harmony default export */ var plugins_useAutoRunPlugin = (useAutoRunPlugin_useAutoRunPlugin);
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/depsAreSame.js
function depsAreSame(oldDeps, deps) {
  if (oldDeps === deps) return true;

  for (var i = 0; i < oldDeps.length; i++) {
    if (!Object.is(oldDeps[i], deps[i])) return false;
  }

  return true;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useCreation/index.js


function useCreation(factory, deps) {
  var current = Object(external_react_["useRef"])({
    deps: deps,
    obj: undefined,
    initialized: false
  }).current;

  if (current.initialized === false || !depsAreSame(current.deps, deps)) {
    current.deps = deps;
    current.obj = factory();
    current.initialized = true;
  }

  return current.obj;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useLatest/index.js


function useLatest(value) {
  var ref = Object(external_react_["useRef"])(value);
  ref.current = value;
  return ref;
}

/* harmony default export */ var es_useLatest = (useLatest);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useUnmount/index.js




var useUnmount_useUnmount = function useUnmount(fn) {
  if (false) {}

  var fnRef = es_useLatest(fn);
  Object(external_react_["useEffect"])(function () {
    return function () {
      fnRef.current();
    };
  }, []);
};

/* harmony default export */ var es_useUnmount = (useUnmount_useUnmount);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/cache.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var cache = new Map();

var setCache = function setCache(key, cacheTime, cachedData) {
  var currentCache = cache.get(key);

  if (currentCache === null || currentCache === void 0 ? void 0 : currentCache.timer) {
    clearTimeout(currentCache.timer);
  }

  var timer = undefined;

  if (cacheTime > -1) {
    // if cache out, clear it
    timer = setTimeout(function () {
      cache["delete"](key);
    }, cacheTime);
  }

  cache.set(key, __assign(__assign({}, cachedData), {
    timer: timer
  }));
};

var getCache = function getCache(key) {
  return cache.get(key);
};

var clearCache = function clearCache(key) {
  if (key) {
    var cacheKeys = Array.isArray(key) ? key : [key];
    cacheKeys.forEach(function (cacheKey) {
      return cache["delete"](cacheKey);
    });
  } else {
    cache.clear();
  }
};


// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/cachePromise.js
var cachePromise = new Map();

var getCachePromise = function getCachePromise(cacheKey) {
  return cachePromise.get(cacheKey);
};

var setCachePromise = function setCachePromise(cacheKey, promise) {
  // Should cache the same promise, cannot be promise.finally
  // Because the promise.finally will change the reference of the promise
  cachePromise.set(cacheKey, promise); // no use promise.finally for compatibility

  promise.then(function (res) {
    cachePromise["delete"](cacheKey);
    return res;
  })["catch"](function () {
    cachePromise["delete"](cacheKey);
  });
};


// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/cacheSubscribe.js
var listeners = {};

var cacheSubscribe_trigger = function trigger(key, data) {
  if (listeners[key]) {
    listeners[key].forEach(function (item) {
      return item(data);
    });
  }
};

var subscribe = function subscribe(key, listener) {
  if (!listeners[key]) {
    listeners[key] = [];
  }

  listeners[key].push(listener);
  return function unsubscribe() {
    var index = listeners[key].indexOf(listener);
    listeners[key].splice(index, 1);
  };
};


// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/useCachePlugin.js
var useCachePlugin_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useCachePlugin_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useCachePlugin_read(arguments[i]));
  }

  return ar;
};








var useCachePlugin_useCachePlugin = function useCachePlugin(fetchInstance, _a) {
  var cacheKey = _a.cacheKey,
      _b = _a.cacheTime,
      cacheTime = _b === void 0 ? 5 * 60 * 1000 : _b,
      _c = _a.staleTime,
      staleTime = _c === void 0 ? 0 : _c,
      customSetCache = _a.setCache,
      customGetCache = _a.getCache;
  var unSubscribeRef = Object(external_react_["useRef"])();
  var currentPromiseRef = Object(external_react_["useRef"])();

  var _setCache = function _setCache(key, cachedData) {
    if (customSetCache) {
      customSetCache(cachedData);
    } else {
      setCache(key, cacheTime, cachedData);
    }

    cacheSubscribe_trigger(key, cachedData.data);
  };

  var _getCache = function _getCache(key, params) {
    if (params === void 0) {
      params = [];
    }

    if (customGetCache) {
      return customGetCache(params);
    }

    return getCache(key);
  };

  useCreation(function () {
    if (!cacheKey) {
      return;
    } // get data from cache when init


    var cacheData = _getCache(cacheKey);

    if (cacheData && Object.hasOwnProperty.call(cacheData, 'data')) {
      fetchInstance.state.data = cacheData.data;
      fetchInstance.state.params = cacheData.params;

      if (staleTime === -1 || new Date().getTime() - cacheData.time <= staleTime) {
        fetchInstance.state.loading = false;
      }
    } // subscribe same cachekey update, trigger update


    unSubscribeRef.current = subscribe(cacheKey, function (data) {
      fetchInstance.setState({
        data: data
      });
    });
  }, []);
  es_useUnmount(function () {
    var _a;

    (_a = unSubscribeRef.current) === null || _a === void 0 ? void 0 : _a.call(unSubscribeRef);
  });

  if (!cacheKey) {
    return {};
  }

  return {
    onBefore: function onBefore(params) {
      var cacheData = _getCache(cacheKey, params);

      if (!cacheData || !Object.hasOwnProperty.call(cacheData, 'data')) {
        return {};
      } // If the data is fresh, stop request


      if (staleTime === -1 || new Date().getTime() - cacheData.time <= staleTime) {
        return {
          loading: false,
          data: cacheData === null || cacheData === void 0 ? void 0 : cacheData.data,
          returnNow: true
        };
      } else {
        // If the data is stale, return data, and request continue
        return {
          data: cacheData === null || cacheData === void 0 ? void 0 : cacheData.data
        };
      }
    },
    onRequest: function onRequest(service, args) {
      var servicePromise = getCachePromise(cacheKey); // If has servicePromise, and is not trigger by self, then use it

      if (servicePromise && servicePromise !== currentPromiseRef.current) {
        return {
          servicePromise: servicePromise
        };
      }

      servicePromise = service.apply(void 0, useCachePlugin_spread(args));
      currentPromiseRef.current = servicePromise;
      setCachePromise(cacheKey, servicePromise);
      return {
        servicePromise: servicePromise
      };
    },
    onSuccess: function onSuccess(data, params) {
      var _a;

      if (cacheKey) {
        // cancel subscribe, avoid trgger self
        (_a = unSubscribeRef.current) === null || _a === void 0 ? void 0 : _a.call(unSubscribeRef);

        _setCache(cacheKey, {
          data: data,
          params: params,
          time: new Date().getTime()
        }); // resubscribe


        unSubscribeRef.current = subscribe(cacheKey, function (d) {
          fetchInstance.setState({
            data: d
          });
        });
      }
    },
    onMutate: function onMutate(data) {
      var _a;

      if (cacheKey) {
        // cancel subscribe, avoid trgger self
        (_a = unSubscribeRef.current) === null || _a === void 0 ? void 0 : _a.call(unSubscribeRef);

        _setCache(cacheKey, {
          data: data,
          params: fetchInstance.state.params,
          time: new Date().getTime()
        }); // resubscribe


        unSubscribeRef.current = subscribe(cacheKey, function (d) {
          fetchInstance.setState({
            data: d
          });
        });
      }
    }
  };
};

/* harmony default export */ var plugins_useCachePlugin = (useCachePlugin_useCachePlugin);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(35);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/useDebouncePlugin.js
var useDebouncePlugin_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useDebouncePlugin_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useDebouncePlugin_read(arguments[i]));
  }

  return ar;
};




var useDebouncePlugin_useDebouncePlugin = function useDebouncePlugin(fetchInstance, _a) {
  var debounceWait = _a.debounceWait,
      debounceLeading = _a.debounceLeading,
      debounceTrailing = _a.debounceTrailing,
      debounceMaxWait = _a.debounceMaxWait;
  var debouncedRef = Object(external_react_["useRef"])();
  var options = Object(external_react_["useMemo"])(function () {
    var ret = {};

    if (debounceLeading !== undefined) {
      ret.leading = debounceLeading;
    }

    if (debounceTrailing !== undefined) {
      ret.trailing = debounceTrailing;
    }

    if (debounceMaxWait !== undefined) {
      ret.maxWait = debounceMaxWait;
    }

    return ret;
  }, [debounceLeading, debounceTrailing, debounceMaxWait]);
  Object(external_react_["useEffect"])(function () {
    if (debounceWait) {
      var _originRunAsync_1 = fetchInstance.runAsync.bind(fetchInstance);

      debouncedRef.current = debounce_default()(function (callback) {
        callback();
      }, debounceWait, options); // debounce runAsync should be promise
      // https://github.com/lodash/lodash/issues/4400#issuecomment-834800398

      fetchInstance.runAsync = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return new Promise(function (resolve, reject) {
          var _a;

          (_a = debouncedRef.current) === null || _a === void 0 ? void 0 : _a.call(debouncedRef, function () {
            _originRunAsync_1.apply(void 0, useDebouncePlugin_spread(args)).then(resolve)["catch"](reject);
          });
        });
      };

      return function () {
        var _a;

        (_a = debouncedRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        fetchInstance.runAsync = _originRunAsync_1;
      };
    }
  }, [debounceWait, options]);

  if (!debounceWait) {
    return {};
  }

  return {
    onCancel: function onCancel() {
      var _a;

      (_a = debouncedRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
    }
  };
};

/* harmony default export */ var plugins_useDebouncePlugin = (useDebouncePlugin_useDebouncePlugin);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/useLoadingDelayPlugin.js


var useLoadingDelayPlugin_useLoadingDelayPlugin = function useLoadingDelayPlugin(fetchInstance, _a) {
  var loadingDelay = _a.loadingDelay;
  var timerRef = Object(external_react_["useRef"])();

  if (!loadingDelay) {
    return {};
  }

  var cancelTimeout = function cancelTimeout() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  return {
    onBefore: function onBefore() {
      cancelTimeout();
      timerRef.current = setTimeout(function () {
        fetchInstance.setState({
          loading: true
        });
      }, loadingDelay);
      return {
        loading: false
      };
    },
    onFinally: function onFinally() {
      cancelTimeout();
    },
    onCancel: function onCancel() {
      cancelTimeout();
    }
  };
};

/* harmony default export */ var plugins_useLoadingDelayPlugin = (useLoadingDelayPlugin_useLoadingDelayPlugin);
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/isBrowser.js
var isBrowser = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/* harmony default export */ var utils_isBrowser = (isBrowser);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/isDocumentVisible.js

function isDocumentVisible() {
  if (utils_isBrowser) {
    return document.visibilityState !== 'hidden';
  }

  return true;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/subscribeReVisible.js


var subscribeReVisible_listeners = [];

function subscribeReVisible_subscribe(listener) {
  subscribeReVisible_listeners.push(listener);
  return function unsubscribe() {
    var index = subscribeReVisible_listeners.indexOf(listener);
    subscribeReVisible_listeners.splice(index, 1);
  };
}

if (utils_isBrowser) {
  var subscribeReVisible_revalidate = function revalidate() {
    if (!isDocumentVisible()) return;

    for (var i = 0; i < subscribeReVisible_listeners.length; i++) {
      var listener = subscribeReVisible_listeners[i];
      listener();
    }
  };

  window.addEventListener('visibilitychange', subscribeReVisible_revalidate, false);
}

/* harmony default export */ var subscribeReVisible = (subscribeReVisible_subscribe);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/usePollingPlugin.js





var usePollingPlugin_usePollingPlugin = function usePollingPlugin(fetchInstance, _a) {
  var pollingInterval = _a.pollingInterval,
      _b = _a.pollingWhenHidden,
      pollingWhenHidden = _b === void 0 ? true : _b,
      _c = _a.pollingErrorRetryCount,
      pollingErrorRetryCount = _c === void 0 ? -1 : _c;
  var timerRef = Object(external_react_["useRef"])();
  var unsubscribeRef = Object(external_react_["useRef"])();
  var countRef = Object(external_react_["useRef"])(0);

  var stopPolling = function stopPolling() {
    var _a;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    (_a = unsubscribeRef.current) === null || _a === void 0 ? void 0 : _a.call(unsubscribeRef);
  };

  useUpdateEffect(function () {
    if (!pollingInterval) {
      stopPolling();
    }
  }, [pollingInterval]);

  if (!pollingInterval) {
    return {};
  }

  return {
    onBefore: function onBefore() {
      stopPolling();
    },
    onError: function onError() {
      countRef.current += 1;
    },
    onSuccess: function onSuccess() {
      countRef.current = 0;
    },
    onFinally: function onFinally() {
      if (pollingErrorRetryCount === -1 || // When an error occurs, the request is not repeated after pollingErrorRetryCount retries
      pollingErrorRetryCount !== -1 && countRef.current <= pollingErrorRetryCount) {
        timerRef.current = setTimeout(function () {
          // if pollingWhenHidden = false && document is hidden, then stop polling and subscribe revisible
          if (!pollingWhenHidden && !isDocumentVisible()) {
            unsubscribeRef.current = subscribeReVisible(function () {
              fetchInstance.refresh();
            });
          } else {
            fetchInstance.refresh();
          }
        }, pollingInterval);
      } else {
        countRef.current = 0;
      }
    },
    onCancel: function onCancel() {
      stopPolling();
    }
  };
};

/* harmony default export */ var plugins_usePollingPlugin = (usePollingPlugin_usePollingPlugin);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/limit.js
var limit_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var limit_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(limit_read(arguments[i]));
  }

  return ar;
};

function limit(fn, timespan) {
  var pending = false;
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (pending) return;
    pending = true;
    fn.apply(void 0, limit_spread(args));
    setTimeout(function () {
      pending = false;
    }, timespan);
  };
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/isOnline.js

function isOnline() {
  if (utils_isBrowser && typeof navigator.onLine !== 'undefined') {
    return navigator.onLine;
  }

  return true;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/utils/subscribeFocus.js
// from swr



var subscribeFocus_listeners = [];

function subscribeFocus_subscribe(listener) {
  subscribeFocus_listeners.push(listener);
  return function unsubscribe() {
    var index = subscribeFocus_listeners.indexOf(listener);
    subscribeFocus_listeners.splice(index, 1);
  };
}

if (utils_isBrowser) {
  var subscribeFocus_revalidate = function revalidate() {
    if (!isDocumentVisible() || !isOnline()) return;

    for (var i = 0; i < subscribeFocus_listeners.length; i++) {
      var listener = subscribeFocus_listeners[i];
      listener();
    }
  };

  window.addEventListener('visibilitychange', subscribeFocus_revalidate, false);
  window.addEventListener('focus', subscribeFocus_revalidate, false);
}

/* harmony default export */ var subscribeFocus = (subscribeFocus_subscribe);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/useRefreshOnWindowFocusPlugin.js





var useRefreshOnWindowFocusPlugin_useRefreshOnWindowFocusPlugin = function useRefreshOnWindowFocusPlugin(fetchInstance, _a) {
  var refreshOnWindowFocus = _a.refreshOnWindowFocus,
      _b = _a.focusTimespan,
      focusTimespan = _b === void 0 ? 5000 : _b;
  var unsubscribeRef = Object(external_react_["useRef"])();

  var stopSubscribe = function stopSubscribe() {
    var _a;

    (_a = unsubscribeRef.current) === null || _a === void 0 ? void 0 : _a.call(unsubscribeRef);
  };

  Object(external_react_["useEffect"])(function () {
    if (refreshOnWindowFocus) {
      var limitRefresh_1 = limit(fetchInstance.refresh.bind(fetchInstance), focusTimespan);
      unsubscribeRef.current = subscribeFocus(function () {
        limitRefresh_1();
      });
    }

    return function () {
      stopSubscribe();
    };
  }, [refreshOnWindowFocus, focusTimespan]);
  es_useUnmount(function () {
    stopSubscribe();
  });
  return {};
};

/* harmony default export */ var plugins_useRefreshOnWindowFocusPlugin = (useRefreshOnWindowFocusPlugin_useRefreshOnWindowFocusPlugin);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/useRetryPlugin.js


var useRetryPlugin_useRetryPlugin = function useRetryPlugin(fetchInstance, _a) {
  var retryInterval = _a.retryInterval,
      retryCount = _a.retryCount;
  var timerRef = Object(external_react_["useRef"])();
  var countRef = Object(external_react_["useRef"])(0);
  var triggerByRetry = Object(external_react_["useRef"])(false);

  if (!retryCount) {
    return {};
  }

  return {
    onBefore: function onBefore() {
      if (!triggerByRetry.current) {
        countRef.current = 0;
      }

      triggerByRetry.current = false;

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    },
    onSuccess: function onSuccess() {
      countRef.current = 0;
    },
    onError: function onError() {
      countRef.current += 1;

      if (retryCount === -1 || countRef.current <= retryCount) {
        // Exponential backoff
        var timeout = retryInterval !== null && retryInterval !== void 0 ? retryInterval : Math.min(1000 * Math.pow(2, countRef.current), 30000);
        timerRef.current = setTimeout(function () {
          triggerByRetry.current = true;
          fetchInstance.refresh();
        }, timeout);
      } else {
        countRef.current = 0;
      }
    },
    onCancel: function onCancel() {
      countRef.current = 0;

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    }
  };
};

/* harmony default export */ var plugins_useRetryPlugin = (useRetryPlugin_useRetryPlugin);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(46);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/plugins/useThrottlePlugin.js
var useThrottlePlugin_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useThrottlePlugin_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useThrottlePlugin_read(arguments[i]));
  }

  return ar;
};




var useThrottlePlugin_useThrottlePlugin = function useThrottlePlugin(fetchInstance, _a) {
  var throttleWait = _a.throttleWait,
      throttleLeading = _a.throttleLeading,
      throttleTrailing = _a.throttleTrailing;
  var throttledRef = Object(external_react_["useRef"])();
  var options = {};

  if (throttleLeading !== undefined) {
    options.leading = throttleLeading;
  }

  if (throttleTrailing !== undefined) {
    options.trailing = throttleTrailing;
  }

  Object(external_react_["useEffect"])(function () {
    if (throttleWait) {
      var _originRunAsync_1 = fetchInstance.runAsync.bind(fetchInstance);

      throttledRef.current = throttle_default()(function (callback) {
        callback();
      }, throttleWait, options); // throttle runAsync should be promise
      // https://github.com/lodash/lodash/issues/4400#issuecomment-834800398

      fetchInstance.runAsync = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return new Promise(function (resolve, reject) {
          var _a;

          (_a = throttledRef.current) === null || _a === void 0 ? void 0 : _a.call(throttledRef, function () {
            _originRunAsync_1.apply(void 0, useThrottlePlugin_spread(args)).then(resolve)["catch"](reject);
          });
        });
      };

      return function () {
        var _a;

        fetchInstance.runAsync = _originRunAsync_1;
        (_a = throttledRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
      };
    }
  }, [throttleWait, throttleLeading, throttleTrailing]);

  if (!throttleWait) {
    return {};
  }

  return {
    onCancel: function onCancel() {
      var _a;

      (_a = throttledRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
    }
  };
};

/* harmony default export */ var plugins_useThrottlePlugin = (useThrottlePlugin_useThrottlePlugin);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useMount/index.js



var useMount_useMount = function useMount(fn) {
  if (false) {}

  Object(external_react_["useEffect"])(function () {
    fn === null || fn === void 0 ? void 0 : fn();
  }, []);
};

/* harmony default export */ var es_useMount = (useMount_useMount);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useUpdate/index.js
var useUpdate_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



var useUpdate_useUpdate = function useUpdate() {
  var _a = useUpdate_read(Object(external_react_["useState"])({}), 2),
      setState = _a[1];

  return Object(external_react_["useCallback"])(function () {
    return setState({});
  }, []);
};

/* harmony default export */ var es_useUpdate = (useUpdate_useUpdate);
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/index.js
var isObject = function isObject(value) {
  return value !== null && typeof value === 'object';
};
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
var isString = function isString(value) {
  return typeof value === 'string';
};
var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
var isNumber = function isNumber(value) {
  return typeof value === 'number';
};
var isUndef = function isUndef(value) {
  return typeof value === 'undefined';
};
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/Fetch.js
var Fetch_assign = undefined && undefined.__assign || function () {
  Fetch_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return Fetch_assign.apply(this, arguments);
};

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Fetch_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var Fetch_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(Fetch_read(arguments[i]));
  }

  return ar;
};
/* eslint-disable @typescript-eslint/no-parameter-properties */




var Fetch_Fetch =
/** @class */
function () {
  function Fetch(serviceRef, options, subscribe, initState) {
    if (initState === void 0) {
      initState = {};
    }

    this.serviceRef = serviceRef;
    this.options = options;
    this.subscribe = subscribe;
    this.initState = initState;
    this.count = 0;
    this.state = {
      loading: false,
      params: undefined,
      data: undefined,
      error: undefined
    };
    this.state = Fetch_assign(Fetch_assign(Fetch_assign({}, this.state), {
      loading: !options.manual
    }), initState);
  }

  Fetch.prototype.setState = function (s) {
    if (s === void 0) {
      s = {};
    }

    this.state = Fetch_assign(Fetch_assign({}, this.state), s);
    this.subscribe();
  };

  Fetch.prototype.runPluginHandler = function (event) {
    var rest = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    } // @ts-ignore


    var r = this.pluginImpls.map(function (i) {
      var _a;

      return (_a = i[event]) === null || _a === void 0 ? void 0 : _a.call.apply(_a, Fetch_spread([i], rest));
    }).filter(Boolean);
    return Object.assign.apply(Object, Fetch_spread([{}], r));
  };

  Fetch.prototype.runAsync = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;

    var params = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      params[_i] = arguments[_i];
    }

    return __awaiter(this, void 0, void 0, function () {
      var currentCount, _l, _m, stopNow, _o, returnNow, state, servicePromise, res, error_1;

      var _p;

      return __generator(this, function (_q) {
        switch (_q.label) {
          case 0:
            this.count += 1;
            currentCount = this.count;
            _l = this.runPluginHandler('onBefore', params), _m = _l.stopNow, stopNow = _m === void 0 ? false : _m, _o = _l.returnNow, returnNow = _o === void 0 ? false : _o, state = __rest(_l, ["stopNow", "returnNow"]); // stop request

            if (stopNow) {
              return [2
              /*return*/
              , new Promise(function () {})];
            }

            this.setState(Fetch_assign({
              loading: true,
              params: params
            }, state)); // return now

            if (returnNow) {
              return [2
              /*return*/
              , Promise.resolve(state.data)];
            }

            (_b = (_a = this.options).onBefore) === null || _b === void 0 ? void 0 : _b.call(_a, params);
            _q.label = 1;

          case 1:
            _q.trys.push([1, 3,, 4]);

            servicePromise = this.runPluginHandler('onRequest', this.serviceRef.current, params).servicePromise;

            if (!servicePromise) {
              servicePromise = (_p = this.serviceRef).current.apply(_p, Fetch_spread(params));
            }

            return [4
            /*yield*/
            , servicePromise];

          case 2:
            res = _q.sent();

            if (currentCount !== this.count) {
              // prevent run.then when request is canceled
              return [2
              /*return*/
              , new Promise(function () {})];
            } // const formattedResult = this.options.formatResultRef.current ? this.options.formatResultRef.current(res) : res;


            this.setState({
              data: res,
              error: undefined,
              loading: false
            });
            (_d = (_c = this.options).onSuccess) === null || _d === void 0 ? void 0 : _d.call(_c, res, params);
            this.runPluginHandler('onSuccess', res, params);
            (_f = (_e = this.options).onFinally) === null || _f === void 0 ? void 0 : _f.call(_e, params, res, undefined);

            if (currentCount === this.count) {
              this.runPluginHandler('onFinally', params, res, undefined);
            }

            return [2
            /*return*/
            , res];

          case 3:
            error_1 = _q.sent();

            if (currentCount !== this.count) {
              // prevent run.then when request is canceled
              return [2
              /*return*/
              , new Promise(function () {})];
            }

            this.setState({
              error: error_1,
              loading: false
            });
            (_h = (_g = this.options).onError) === null || _h === void 0 ? void 0 : _h.call(_g, error_1, params);
            this.runPluginHandler('onError', error_1, params);
            (_k = (_j = this.options).onFinally) === null || _k === void 0 ? void 0 : _k.call(_j, params, undefined, error_1);

            if (currentCount === this.count) {
              this.runPluginHandler('onFinally', params, undefined, error_1);
            }

            throw error_1;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Fetch.prototype.run = function () {
    var _this = this;

    var params = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      params[_i] = arguments[_i];
    }

    this.runAsync.apply(this, Fetch_spread(params))["catch"](function (error) {
      if (!_this.options.onError) {
        console.error(error);
      }
    });
  };

  Fetch.prototype.cancel = function () {
    this.count += 1;
    this.setState({
      loading: false
    });
    this.runPluginHandler('onCancel');
  };

  Fetch.prototype.refresh = function () {
    // @ts-ignore
    this.run.apply(this, Fetch_spread(this.state.params || []));
  };

  Fetch.prototype.refreshAsync = function () {
    // @ts-ignore
    return this.runAsync.apply(this, Fetch_spread(this.state.params || []));
  };

  Fetch.prototype.mutate = function (data) {
    var targetData;

    if (isFunction(data)) {
      // @ts-ignore
      targetData = data(this.state.data);
    } else {
      targetData = data;
    }

    this.runPluginHandler('onMutate', targetData);
    this.setState({
      data: targetData
    });
  };

  return Fetch;
}();

/* harmony default export */ var src_Fetch = (Fetch_Fetch);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/useRequestImplement.js
var useRequestImplement_assign = undefined && undefined.__assign || function () {
  useRequestImplement_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useRequestImplement_assign.apply(this, arguments);
};

var useRequestImplement_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var useRequestImplement_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useRequestImplement_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useRequestImplement_read(arguments[i]));
  }

  return ar;
};









function useRequestImplement(service, options, plugins) {
  if (options === void 0) {
    options = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var _a = options.manual,
      manual = _a === void 0 ? false : _a,
      rest = useRequestImplement_rest(options, ["manual"]);

  var fetchOptions = useRequestImplement_assign({
    manual: manual
  }, rest);

  var serviceRef = es_useLatest(service);
  var update = es_useUpdate();
  var fetchInstance = useCreation(function () {
    var initState = plugins.map(function (p) {
      var _a;

      return (_a = p === null || p === void 0 ? void 0 : p.onInit) === null || _a === void 0 ? void 0 : _a.call(p, fetchOptions);
    }).filter(Boolean);
    return new src_Fetch(serviceRef, fetchOptions, update, Object.assign.apply(Object, useRequestImplement_spread([{}], initState)));
  }, []);
  fetchInstance.options = fetchOptions; // run all plugins hooks

  fetchInstance.pluginImpls = plugins.map(function (p) {
    return p(fetchInstance, fetchOptions);
  });
  es_useMount(function () {
    if (!manual) {
      // useCachePlugin can set fetchInstance.state.params from cache when init
      var params = fetchInstance.state.params || options.defaultParams || []; // @ts-ignore

      fetchInstance.run.apply(fetchInstance, useRequestImplement_spread(params));
    }
  });
  es_useUnmount(function () {
    fetchInstance.cancel();
  });
  return {
    loading: fetchInstance.state.loading,
    data: fetchInstance.state.data,
    error: fetchInstance.state.error,
    params: fetchInstance.state.params || [],
    cancel: es_useMemoizedFn(fetchInstance.cancel.bind(fetchInstance)),
    refresh: es_useMemoizedFn(fetchInstance.refresh.bind(fetchInstance)),
    refreshAsync: es_useMemoizedFn(fetchInstance.refreshAsync.bind(fetchInstance)),
    run: es_useMemoizedFn(fetchInstance.run.bind(fetchInstance)),
    runAsync: es_useMemoizedFn(fetchInstance.runAsync.bind(fetchInstance)),
    mutate: es_useMemoizedFn(fetchInstance.mutate.bind(fetchInstance))
  };
}

/* harmony default export */ var src_useRequestImplement = (useRequestImplement);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/src/useRequest.js
var useRequest_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useRequest_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useRequest_read(arguments[i]));
  }

  return ar;
};









 // function useRequest<TData, TParams extends any[], TFormated, TTFormated extends TFormated = any>(
//   service: Service<TData, TParams>,
//   options: OptionsWithFormat<TData, TParams, TFormated, TTFormated>,
//   plugins?: Plugin<TData, TParams>[],
// ): Result<TFormated, TParams>
// function useRequest<TData, TParams extends any[]>(
//   service: Service<TData, TParams>,
//   options?: OptionsWithoutFormat<TData, TParams>,
//   plugins?: Plugin<TData, TParams>[],
// ): Result<TData, TParams>

function useRequest(service, options, plugins) {
  return src_useRequestImplement(service, options, useRequest_spread(plugins || [], [plugins_useDebouncePlugin, plugins_useLoadingDelayPlugin, plugins_usePollingPlugin, plugins_useRefreshOnWindowFocusPlugin, plugins_useThrottlePlugin, plugins_useAutoRunPlugin, plugins_useCachePlugin, plugins_useRetryPlugin]));
}

/* harmony default export */ var src_useRequest = (useRequest);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRequest/index.js



/* harmony default export */ var es_useRequest = (src_useRequest);
// CONCATENATED MODULE: ./node_modules/ahooks/es/usePagination/index.js
var usePagination_assign = undefined && undefined.__assign || function () {
  usePagination_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return usePagination_assign.apply(this, arguments);
};

var usePagination_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var usePagination_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var usePagination_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(usePagination_read(arguments[i]));
  }

  return ar;
};





var usePagination_usePagination = function usePagination(service, options) {
  var _a;

  if (options === void 0) {
    options = {};
  }

  var _b = options.defaultPageSize,
      defaultPageSize = _b === void 0 ? 10 : _b,
      _c = options.defaultCurrent,
      defaultCurrent = _c === void 0 ? 1 : _c,
      rest = usePagination_rest(options, ["defaultPageSize", "defaultCurrent"]);

  var result = es_useRequest(service, usePagination_assign({
    defaultParams: [{
      current: defaultCurrent,
      pageSize: defaultPageSize
    }],
    refreshDepsAction: function refreshDepsAction() {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      changeCurrent(1);
    }
  }, rest));

  var _d = result.params[0] || {},
      _e = _d.current,
      current = _e === void 0 ? 1 : _e,
      _f = _d.pageSize,
      pageSize = _f === void 0 ? defaultPageSize : _f;

  var total = ((_a = result.data) === null || _a === void 0 ? void 0 : _a.total) || 0;
  var totalPage = Object(external_react_["useMemo"])(function () {
    return Math.ceil(total / pageSize);
  }, [pageSize, total]);

  var onChange = function onChange(c, p) {
    var toCurrent = c <= 0 ? 1 : c;
    var toPageSize = p <= 0 ? 1 : p;
    var tempTotalPage = Math.ceil(total / toPageSize);

    if (toCurrent > tempTotalPage) {
      toCurrent = Math.max(1, tempTotalPage);
    }

    var _a = usePagination_read(result.params || []),
        _b = _a[0],
        oldPaginationParams = _b === void 0 ? {} : _b,
        restParams = _a.slice(1);

    result.run.apply(result, usePagination_spread([usePagination_assign(usePagination_assign({}, oldPaginationParams), {
      current: toCurrent,
      pageSize: toPageSize
    })], restParams));
  };

  var changeCurrent = function changeCurrent(c) {
    onChange(c, pageSize);
  };

  var changePageSize = function changePageSize(p) {
    onChange(current, p);
  };

  return usePagination_assign(usePagination_assign({}, result), {
    pagination: {
      current: current,
      pageSize: pageSize,
      total: total,
      totalPage: totalPage,
      onChange: es_useMemoizedFn(onChange),
      changeCurrent: es_useMemoizedFn(changeCurrent),
      changePageSize: es_useMemoizedFn(changePageSize)
    }
  });
};

/* harmony default export */ var es_usePagination = (usePagination_usePagination);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useAntdTable/index.js
var useAntdTable_assign = undefined && undefined.__assign || function () {
  useAntdTable_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useAntdTable_assign.apply(this, arguments);
};

var useAntdTable_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var useAntdTable_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useAntdTable_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useAntdTable_read(arguments[i]));
  }

  return ar;
};






var useAntdTable_useAntdTable = function useAntdTable(service, options) {
  var _a;

  if (options === void 0) {
    options = {};
  }

  var form = options.form,
      _b = options.defaultType,
      defaultType = _b === void 0 ? 'simple' : _b,
      defaultParams = options.defaultParams,
      _c = options.manual,
      manual = _c === void 0 ? false : _c,
      _d = options.refreshDeps,
      refreshDeps = _d === void 0 ? [] : _d,
      _e = options.ready,
      ready = _e === void 0 ? true : _e,
      rest = useAntdTable_rest(options, ["form", "defaultType", "defaultParams", "manual", "refreshDeps", "ready"]);

  var result = es_usePagination(service, useAntdTable_assign({
    manual: true
  }, rest));
  var _f = result.params,
      params = _f === void 0 ? [] : _f,
      run = result.run;
  var cacheFormTableData = params[2] || {};

  var _g = useAntdTable_read(Object(external_react_["useState"])((cacheFormTableData === null || cacheFormTableData === void 0 ? void 0 : cacheFormTableData.type) || defaultType), 2),
      type = _g[0],
      setType = _g[1];

  var allFormDataRef = Object(external_react_["useRef"])({});
  var defaultDataSourceRef = Object(external_react_["useRef"])([]);
  var isAntdV4 = !!(form === null || form === void 0 ? void 0 : form.getInternalHooks); // get current active field values

  var getActivetFieldValues = function getActivetFieldValues() {
    if (!form) {
      return {};
    } // antd 4


    if (isAntdV4) {
      return form.getFieldsValue(null, function () {
        return true;
      });
    } // antd 3


    var allFieldsValue = form.getFieldsValue();
    var activeFieldsValue = {};
    Object.keys(allFieldsValue).forEach(function (key) {
      if (form.getFieldInstance ? form.getFieldInstance(key) : true) {
        activeFieldsValue[key] = allFieldsValue[key];
      }
    });
    return activeFieldsValue;
  };

  var validateFields = function validateFields() {
    if (!form) {
      return Promise.resolve({});
    }

    var activeFieldsValue = getActivetFieldValues();
    var fields = Object.keys(activeFieldsValue); // antd 4

    if (isAntdV4) {
      return form.validateFields(fields);
    } // antd 3


    return new Promise(function (resolve, reject) {
      form.validateFields(fields, function (errors, values) {
        if (errors) {
          reject(errors);
        } else {
          resolve(values);
        }
      });
    });
  };

  var restoreForm = function restoreForm() {
    if (!form) {
      return;
    } // antd v4


    if (isAntdV4) {
      return form.setFieldsValue(allFormDataRef.current);
    } // antd v3


    var activeFieldsValue = {};
    Object.keys(allFormDataRef.current).forEach(function (key) {
      if (form.getFieldInstance ? form.getFieldInstance(key) : true) {
        activeFieldsValue[key] = allFormDataRef.current[key];
      }
    });
    form.setFieldsValue(activeFieldsValue);
  };

  var changeType = function changeType() {
    var activeFieldsValue = getActivetFieldValues();
    allFormDataRef.current = useAntdTable_assign(useAntdTable_assign({}, allFormDataRef.current), activeFieldsValue);
    setType(function (t) {
      return t === 'simple' ? 'advance' : 'simple';
    });
  };

  var _submit = function _submit(initPagination) {
    if (!ready) {
      return;
    }

    setTimeout(function () {
      validateFields().then(function (values) {
        if (values === void 0) {
          values = {};
        }

        var pagination = initPagination || useAntdTable_assign(useAntdTable_assign({
          pageSize: options.defaultPageSize || 10
        }, (params === null || params === void 0 ? void 0 : params[0]) || {}), {
          current: 1
        });

        if (!form) {
          // @ts-ignore
          run(pagination);
          return;
        } // record all form data


        allFormDataRef.current = useAntdTable_assign(useAntdTable_assign({}, allFormDataRef.current), values); // @ts-ignore

        run(pagination, values, {
          allFormData: allFormDataRef.current,
          type: type
        });
      })["catch"](function (err) {
        return err;
      });
    });
  };

  var reset = function reset() {
    if (form) {
      form.resetFields();
    }

    _submit();
  };

  var submit = function submit(e) {
    var _a;

    (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);

    _submit();
  };

  var onTableChange = function onTableChange(pagination, filters, sorter) {
    var _a = useAntdTable_read(params || []),
        oldPaginationParams = _a[0],
        restParams = _a.slice(1);

    run.apply(void 0, useAntdTable_spread([useAntdTable_assign(useAntdTable_assign({}, oldPaginationParams), {
      current: pagination.current,
      pageSize: pagination.pageSize,
      filters: filters,
      sorter: sorter
    })], restParams));
  }; // init


  Object(external_react_["useEffect"])(function () {
    // if has cache, use cached params. ignore manual and ready.
    if (params.length > 0) {
      allFormDataRef.current = (cacheFormTableData === null || cacheFormTableData === void 0 ? void 0 : cacheFormTableData.allFormData) || {};
      restoreForm(); // @ts-ignore

      run.apply(void 0, useAntdTable_spread(params));
      return;
    }

    if (!manual && ready) {
      allFormDataRef.current = (defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams[1]) || {};
      restoreForm();

      _submit(defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams[0]);
    }
  }, []); // change search type, restore form data

  useUpdateEffect(function () {
    if (!ready) {
      return;
    }

    restoreForm();
  }, [type]); // refresh & ready change on the same time

  var hasAutoRun = Object(external_react_["useRef"])(false);
  hasAutoRun.current = false;
  useUpdateEffect(function () {
    if (!manual && ready) {
      hasAutoRun.current = true;

      if (form) {
        form.resetFields();
      }

      allFormDataRef.current = (defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams[1]) || {};
      restoreForm();

      _submit(defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams[0]);
    }
  }, [ready]);
  useUpdateEffect(function () {
    if (hasAutoRun.current) {
      return;
    }

    if (!ready) {
      return;
    }

    if (!manual) {
      hasAutoRun.current = true;
      result.pagination.changeCurrent(1);
    }
  }, useAntdTable_spread(refreshDeps));
  return useAntdTable_assign(useAntdTable_assign({}, result), {
    tableProps: {
      dataSource: ((_a = result.data) === null || _a === void 0 ? void 0 : _a.list) || defaultDataSourceRef.current,
      loading: result.loading,
      onChange: es_useMemoizedFn(onTableChange),
      pagination: {
        current: result.pagination.current,
        pageSize: result.pagination.pageSize,
        total: result.pagination.total
      }
    },
    search: {
      submit: es_useMemoizedFn(submit),
      type: type,
      changeType: es_useMemoizedFn(changeType),
      reset: es_useMemoizedFn(reset)
    }
  });
};

/* harmony default export */ var es_useAntdTable = (useAntdTable_useAntdTable);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useAsyncEffect/index.js
var useAsyncEffect_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var useAsyncEffect_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};




function useAsyncEffect(effect, deps) {
  function isAsyncGenerator(val) {
    return isFunction(val[Symbol.asyncIterator]);
  }

  Object(external_react_["useEffect"])(function () {
    var e = effect();
    var cancelled = false;

    function execute() {
      return useAsyncEffect_awaiter(this, void 0, void 0, function () {
        var result;
        return useAsyncEffect_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!isAsyncGenerator(e)) return [3
              /*break*/
              , 4];
              _a.label = 1;

            case 1:
              if (false) {}
              return [4
              /*yield*/
              , e.next()];

            case 2:
              result = _a.sent();

              if (result.done || cancelled) {
                return [3
                /*break*/
                , 3];
              }

              return [3
              /*break*/
              , 1];

            case 3:
              return [3
              /*break*/
              , 6];

            case 4:
              return [4
              /*yield*/
              , e];

            case 5:
              _a.sent();

              _a.label = 6;

            case 6:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    execute();
    return function () {
      cancelled = true;
    };
  }, deps);
}

/* harmony default export */ var es_useAsyncEffect = (useAsyncEffect);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useToggle/index.js
var useToggle_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



function useToggle(defaultValue, reverseValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  var _a = useToggle_read(Object(external_react_["useState"])(defaultValue), 2),
      state = _a[0],
      setState = _a[1];

  var actions = Object(external_react_["useMemo"])(function () {
    var reverseValueOrigin = reverseValue === undefined ? !defaultValue : reverseValue;

    var toggle = function toggle() {
      return setState(function (s) {
        return s === defaultValue ? reverseValueOrigin : defaultValue;
      });
    };

    var set = function set(value) {
      return setState(value);
    };

    var setLeft = function setLeft() {
      return setState(defaultValue);
    };

    var setRight = function setRight() {
      return setState(reverseValueOrigin);
    };

    return {
      toggle: toggle,
      set: set,
      setLeft: setLeft,
      setRight: setRight
    }; // useToggle ignore value change
    // }, [defaultValue, reverseValue]);
  }, []);
  return [state, actions];
}

/* harmony default export */ var es_useToggle = (useToggle);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useBoolean/index.js
var useBoolean_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



function useBoolean(defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  var _a = useBoolean_read(es_useToggle(defaultValue), 2),
      state = _a[0],
      _b = _a[1],
      toggle = _b.toggle,
      _set = _b.set;

  var actions = Object(external_react_["useMemo"])(function () {
    var setTrue = function setTrue() {
      return _set(true);
    };

    var setFalse = function setFalse() {
      return _set(false);
    };

    return {
      toggle: toggle,
      set: function set(v) {
        return _set(!!v);
      },
      setTrue: setTrue,
      setFalse: setFalse
    };
  }, []);
  return [state, actions];
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/domTarget.js


function getTargetElement(target, defaultElement) {
  if (!utils_isBrowser) {
    return undefined;
  }

  if (!target) {
    return defaultElement;
  }

  var targetElement;

  if (isFunction(target)) {
    targetElement = target();
  } else if ('current' in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }

  return targetElement;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/getDocumentOrShadow.js


var getDocumentOrShadow_checkIfAllInShadow = function checkIfAllInShadow(targets) {
  return targets.every(function (item) {
    var targetElement = getTargetElement(item);
    if (!targetElement) return false;
    if (targetElement.getRootNode() instanceof ShadowRoot) return true;
  });
};

var getShadow = function getShadow(node) {
  if (!node) {
    return document;
  }

  return node.getRootNode();
};

var getDocumentOrShadow_getDocumentOrShadow = function getDocumentOrShadow(target) {
  if (!target || !document.getRootNode) {
    return document;
  }

  var targets = Array.isArray(target) ? target : [target];

  if (getDocumentOrShadow_checkIfAllInShadow(targets)) {
    return getShadow(getTargetElement(targets[0]));
  }

  return document;
};

/* harmony default export */ var utils_getDocumentOrShadow = (getDocumentOrShadow_getDocumentOrShadow);
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/createEffectWithTarget.js





var createEffectWithTarget_createEffectWithTarget = function createEffectWithTarget(useEffectType) {
  /**
   *
   * @param effect
   * @param deps
   * @param target target should compare ref.current vs ref.current, dom vs dom, ()=>dom vs ()=>dom
   */
  var useEffectWithTarget = function useEffectWithTarget(effect, deps, target) {
    var hasInitRef = Object(external_react_["useRef"])(false);
    var lastElementRef = Object(external_react_["useRef"])([]);
    var lastDepsRef = Object(external_react_["useRef"])([]);
    var unLoadRef = Object(external_react_["useRef"])();
    useEffectType(function () {
      var _a;

      var targets = Array.isArray(target) ? target : [target];
      var els = targets.map(function (item) {
        return getTargetElement(item);
      }); // init run

      if (!hasInitRef.current) {
        hasInitRef.current = true;
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
        return;
      }

      if (els.length !== lastElementRef.current.length || !depsAreSame(els, lastElementRef.current) || !depsAreSame(deps, lastDepsRef.current)) {
        (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
      }
    });
    es_useUnmount(function () {
      var _a;

      (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef); // for react-refresh

      hasInitRef.current = false;
    });
  };

  return useEffectWithTarget;
};

/* harmony default export */ var utils_createEffectWithTarget = (createEffectWithTarget_createEffectWithTarget);
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/useEffectWithTarget.js


var useEffectWithTarget_useEffectWithTarget = utils_createEffectWithTarget(external_react_["useEffect"]);
/* harmony default export */ var utils_useEffectWithTarget = (useEffectWithTarget_useEffectWithTarget);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useClickAway/index.js




function useClickAway(onClickAway, target, eventName) {
  if (eventName === void 0) {
    eventName = 'click';
  }

  var onClickAwayRef = es_useLatest(onClickAway);
  utils_useEffectWithTarget(function () {
    var handler = function handler(event) {
      var targets = Array.isArray(target) ? target : [target];

      if (targets.some(function (item) {
        var targetElement = getTargetElement(item);
        return !targetElement || targetElement.contains(event.target);
      })) {
        return;
      }

      onClickAwayRef.current(event);
    };

    var documentOrShadow = utils_getDocumentOrShadow(target);
    var eventNames = Array.isArray(eventName) ? eventName : [eventName];
    eventNames.forEach(function (event) {
      return documentOrShadow.addEventListener(event, handler);
    });
    return function () {
      eventNames.forEach(function (event) {
        return documentOrShadow.removeEventListener(event, handler);
      });
    };
  }, Array.isArray(eventName) ? eventName : [eventName], target);
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useControllableValue/index.js
var useControllableValue_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useControllableValue_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useControllableValue_read(arguments[i]));
  }

  return ar;
};






function useControllableValue(props, options) {
  if (props === void 0) {
    props = {};
  }

  if (options === void 0) {
    options = {};
  }

  var defaultValue = options.defaultValue,
      _a = options.defaultValuePropName,
      defaultValuePropName = _a === void 0 ? 'defaultValue' : _a,
      _b = options.valuePropName,
      valuePropName = _b === void 0 ? 'value' : _b,
      _c = options.trigger,
      trigger = _c === void 0 ? 'onChange' : _c;
  var value = props[valuePropName];
  var isControlled = props.hasOwnProperty(valuePropName);
  var initialValue = Object(external_react_["useMemo"])(function () {
    if (isControlled) {
      return value;
    }

    if (props.hasOwnProperty(defaultValuePropName)) {
      return props[defaultValuePropName];
    }

    return defaultValue;
  }, []);
  var stateRef = Object(external_react_["useRef"])(initialValue);

  if (isControlled) {
    stateRef.current = value;
  }

  var update = es_useUpdate();

  function setState(v) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    var r = isFunction(v) ? v(stateRef.current) : v;

    if (!isControlled) {
      stateRef.current = r;
      update();
    }

    if (props[trigger]) {
      props[trigger].apply(props, useControllableValue_spread([r], args));
    }
  }

  return [stateRef.current, es_useMemoizedFn(setState)];
}

/* harmony default export */ var es_useControllableValue = (useControllableValue);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(39);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./node_modules/ahooks/es/useCookieState/index.js
var useCookieState_assign = undefined && undefined.__assign || function () {
  useCookieState_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useCookieState_assign.apply(this, arguments);
};

var useCookieState_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var useCookieState_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};






function useCookieState(cookieKey, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = useCookieState_read(Object(external_react_["useState"])(function () {
    var cookieValue = js_cookie_default.a.get(cookieKey);
    if (isString(cookieValue)) return cookieValue;

    if (isFunction(options.defaultValue)) {
      return options.defaultValue();
    }

    return options.defaultValue;
  }), 2),
      state = _a[0],
      setState = _a[1];

  var updateState = es_useMemoizedFn(function (newValue, newOptions) {
    if (newOptions === void 0) {
      newOptions = {};
    }

    var _a = useCookieState_assign(useCookieState_assign({}, options), newOptions),
        defaultValue = _a.defaultValue,
        restOptions = useCookieState_rest(_a, ["defaultValue"]);

    setState(function (prevState) {
      var value = isFunction(newValue) ? newValue(prevState) : newValue;

      if (value === undefined) {
        js_cookie_default.a.remove(cookieKey);
      } else {
        js_cookie_default.a.set(cookieKey, value, restOptions);
      }

      return value;
    });
  });
  return [state, updateState];
}

/* harmony default export */ var es_useCookieState = (useCookieState);
// EXTERNAL MODULE: ./node_modules/ahooks/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(92);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);

// CONCATENATED MODULE: ./node_modules/ahooks/es/useCountDown/index.js
var useCountDown_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};






var useCountDown_calcLeft = function calcLeft(target) {
  if (!target) {
    return 0;
  } // https://stackoverflow.com/questions/4310953/invalid-date-in-safari


  var left = dayjs_min_default()(target).valueOf() - Date.now();
  return left < 0 ? 0 : left;
};

var parseMs = function parseMs(milliseconds) {
  return {
    days: Math.floor(milliseconds / 86400000),
    hours: Math.floor(milliseconds / 3600000) % 24,
    minutes: Math.floor(milliseconds / 60000) % 60,
    seconds: Math.floor(milliseconds / 1000) % 60,
    milliseconds: Math.floor(milliseconds) % 1000
  };
};

var useCountDown_useCountdown = function useCountdown(options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options || {},
      leftTime = _a.leftTime,
      targetDate = _a.targetDate,
      _b = _a.interval,
      interval = _b === void 0 ? 1000 : _b,
      onEnd = _a.onEnd;

  var target = Object(external_react_["useMemo"])(function () {
    if ('leftTime' in options) {
      return isNumber(leftTime) && leftTime > 0 ? Date.now() + leftTime : undefined;
    } else {
      return targetDate;
    }
  }, [leftTime, targetDate]);

  var _c = useCountDown_read(Object(external_react_["useState"])(function () {
    return useCountDown_calcLeft(target);
  }), 2),
      timeLeft = _c[0],
      setTimeLeft = _c[1];

  var onEndRef = es_useLatest(onEnd);
  Object(external_react_["useEffect"])(function () {
    if (!target) {
      // for stop
      setTimeLeft(0);
      return;
    } // 立即执行一次


    setTimeLeft(useCountDown_calcLeft(target));
    var timer = setInterval(function () {
      var _a;

      var targetLeft = useCountDown_calcLeft(target);
      setTimeLeft(targetLeft);

      if (targetLeft === 0) {
        clearInterval(timer);
        (_a = onEndRef.current) === null || _a === void 0 ? void 0 : _a.call(onEndRef);
      }
    }, interval);
    return function () {
      return clearInterval(timer);
    };
  }, [target, interval]);
  var formattedRes = Object(external_react_["useMemo"])(function () {
    return parseMs(timeLeft);
  }, [timeLeft]);
  return [timeLeft, formattedRes];
};

/* harmony default export */ var useCountDown = (useCountDown_useCountdown);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useCounter/index.js
var useCounter_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};





function getTargetValue(val, options) {
  if (options === void 0) {
    options = {};
  }

  var min = options.min,
      max = options.max;
  var target = val;

  if (isNumber(max)) {
    target = Math.min(max, target);
  }

  if (isNumber(min)) {
    target = Math.max(min, target);
  }

  return target;
}

function useCounter(initialValue, options) {
  if (initialValue === void 0) {
    initialValue = 0;
  }

  if (options === void 0) {
    options = {};
  }

  var min = options.min,
      max = options.max;

  var _a = useCounter_read(Object(external_react_["useState"])(function () {
    return getTargetValue(initialValue, {
      min: min,
      max: max
    });
  }), 2),
      current = _a[0],
      setCurrent = _a[1];

  var setValue = function setValue(value) {
    setCurrent(function (c) {
      var target = isNumber(value) ? value : value(c);
      return getTargetValue(target, {
        max: max,
        min: min
      });
    });
  };

  var inc = function inc(delta) {
    if (delta === void 0) {
      delta = 1;
    }

    setValue(function (c) {
      return c + delta;
    });
  };

  var dec = function dec(delta) {
    if (delta === void 0) {
      delta = 1;
    }

    setValue(function (c) {
      return c - delta;
    });
  };

  var set = function set(value) {
    setValue(value);
  };

  var reset = function reset() {
    setValue(initialValue);
  };

  return [current, {
    inc: es_useMemoizedFn(inc),
    dec: es_useMemoizedFn(dec),
    set: es_useMemoizedFn(set),
    reset: es_useMemoizedFn(reset)
  }];
}

/* harmony default export */ var es_useCounter = (useCounter);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDebounceFn/index.js
var useDebounceFn_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useDebounceFn_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useDebounceFn_read(arguments[i]));
  }

  return ar;
};







function useDebounceFn(fn, options) {
  var _a;

  if (false) {}

  var fnRef = es_useLatest(fn);
  var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
  var debounced = Object(external_react_["useMemo"])(function () {
    return debounce_default()(function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return fnRef.current.apply(fnRef, useDebounceFn_spread(args));
    }, wait, options);
  }, []);
  es_useUnmount(function () {
    debounced.cancel();
  });
  return {
    run: debounced,
    cancel: debounced.cancel,
    flush: debounced.flush
  };
}

/* harmony default export */ var es_useDebounceFn = (useDebounceFn);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDebounce/index.js
var useDebounce_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




function useDebounce(value, options) {
  var _a = useDebounce_read(Object(external_react_["useState"])(value), 2),
      debounced = _a[0],
      setDebounced = _a[1];

  var run = es_useDebounceFn(function () {
    setDebounced(value);
  }, options).run;
  Object(external_react_["useEffect"])(function () {
    run();
  }, [value]);
  return debounced;
}

/* harmony default export */ var es_useDebounce = (useDebounce);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDebounceEffect/index.js
var useDebounceEffect_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};





function useDebounceEffect(effect, deps, options) {
  var _a = useDebounceEffect_read(Object(external_react_["useState"])({}), 2),
      flag = _a[0],
      setFlag = _a[1];

  var run = es_useDebounceFn(function () {
    setFlag({});
  }, options).run;
  Object(external_react_["useEffect"])(function () {
    return run();
  }, deps);
  useUpdateEffect(effect, [flag]);
}

/* harmony default export */ var es_useDebounceEffect = (useDebounceEffect);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(47);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// CONCATENATED MODULE: ./node_modules/ahooks/es/createDeepCompareEffect/index.js



var createDeepCompareEffect_depsEqual = function depsEqual(aDeps, bDeps) {
  if (aDeps === void 0) {
    aDeps = [];
  }

  if (bDeps === void 0) {
    bDeps = [];
  }

  return isEqual_default()(aDeps, bDeps);
};

var createDeepCompareEffect_createDeepCompareEffect = function createDeepCompareEffect(hook) {
  return function (effect, deps) {
    var ref = Object(external_react_["useRef"])();
    var signalRef = Object(external_react_["useRef"])(0);

    if (deps === undefined || !createDeepCompareEffect_depsEqual(deps, ref.current)) {
      ref.current = deps;
      signalRef.current += 1;
    }

    hook(effect, [signalRef.current]);
  };
};
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDeepCompareEffect/index.js


/* harmony default export */ var useDeepCompareEffect = (createDeepCompareEffect_createDeepCompareEffect(external_react_["useEffect"]));
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDeepCompareLayoutEffect/index.js


/* harmony default export */ var useDeepCompareLayoutEffect = (createDeepCompareEffect_createDeepCompareEffect(external_react_["useLayoutEffect"]));
// CONCATENATED MODULE: ./node_modules/ahooks/es/useEventListener/index.js




function useEventListener(eventName, handler, options) {
  if (options === void 0) {
    options = {};
  }

  var handlerRef = es_useLatest(handler);
  utils_useEffectWithTarget(function () {
    var targetElement = getTargetElement(options.target, window);

    if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) {
      return;
    }

    var eventListener = function eventListener(event) {
      return handlerRef.current(event);
    };

    targetElement.addEventListener(eventName, eventListener, {
      capture: options.capture,
      once: options.once,
      passive: options.passive
    });
    return function () {
      targetElement.removeEventListener(eventName, eventListener, {
        capture: options.capture
      });
    };
  }, [eventName, options.capture, options.once, options.passive], options.target);
}

/* harmony default export */ var es_useEventListener = (useEventListener);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDocumentVisibility/index.js
var useDocumentVisibility_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};





var useDocumentVisibility_getVisibility = function getVisibility() {
  if (!utils_isBrowser) {
    return 'visible';
  }

  return document.visibilityState;
};

function useDocumentVisibility() {
  var _a = useDocumentVisibility_read(Object(external_react_["useState"])(function () {
    return useDocumentVisibility_getVisibility();
  }), 2),
      documentVisibility = _a[0],
      setDocumentVisibility = _a[1];

  es_useEventListener('visibilitychange', function () {
    setDocumentVisibility(useDocumentVisibility_getVisibility());
  }, {
    target: function target() {
      return document;
    }
  });
  return documentVisibility;
}

/* harmony default export */ var es_useDocumentVisibility = (useDocumentVisibility);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDrag/index.js




var useDrag_useDrag = function useDrag(data, target, options) {
  if (options === void 0) {
    options = {};
  }

  var optionsRef = es_useLatest(options);
  utils_useEffectWithTarget(function () {
    var targetElement = getTargetElement(target);

    if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) {
      return;
    }

    var onDragStart = function onDragStart(event) {
      var _a, _b;

      (_b = (_a = optionsRef.current).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, event);
      event.dataTransfer.setData('custom', JSON.stringify(data));
    };

    var onDragEnd = function onDragEnd(event) {
      var _a, _b;

      (_b = (_a = optionsRef.current).onDragEnd) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };

    targetElement.setAttribute('draggable', 'true');
    targetElement.addEventListener('dragstart', onDragStart);
    targetElement.addEventListener('dragend', onDragEnd);
    return function () {
      targetElement.removeEventListener('dragstart', onDragStart);
      targetElement.removeEventListener('dragend', onDragEnd);
    };
  }, [], target);
};

/* harmony default export */ var es_useDrag = (useDrag_useDrag);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDrop/index.js





var useDrop_useDrop = function useDrop(target, options) {
  if (options === void 0) {
    options = {};
  }

  var optionsRef = es_useLatest(options); // https://stackoverflow.com/a/26459269

  var dragEnterTarget = Object(external_react_["useRef"])();
  utils_useEffectWithTarget(function () {
    var targetElement = getTargetElement(target);

    if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) {
      return;
    }

    var onData = function onData(dataTransfer, event) {
      var uri = dataTransfer.getData('text/uri-list');
      var dom = dataTransfer.getData('custom');

      if (dom && optionsRef.current.onDom) {
        var data = dom;

        try {
          data = JSON.parse(dom);
        } catch (e) {
          data = dom;
        }

        optionsRef.current.onDom(data, event);
        return;
      }

      if (uri && optionsRef.current.onUri) {
        optionsRef.current.onUri(uri, event);
        return;
      }

      if (dataTransfer.files && dataTransfer.files.length && optionsRef.current.onFiles) {
        optionsRef.current.onFiles(Array.from(dataTransfer.files), event);
        return;
      }

      if (dataTransfer.items && dataTransfer.items.length && optionsRef.current.onText) {
        dataTransfer.items[0].getAsString(function (text) {
          optionsRef.current.onText(text, event);
        });
      }
    };

    var onDragEnter = function onDragEnter(event) {
      var _a, _b;

      event.preventDefault();
      event.stopPropagation();
      dragEnterTarget.current = event.target;
      (_b = (_a = optionsRef.current).onDragEnter) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };

    var onDragOver = function onDragOver(event) {
      var _a, _b;

      event.preventDefault();
      (_b = (_a = optionsRef.current).onDragOver) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };

    var onDragLeave = function onDragLeave(event) {
      var _a, _b;

      if (event.target === dragEnterTarget.current) {
        (_b = (_a = optionsRef.current).onDragLeave) === null || _b === void 0 ? void 0 : _b.call(_a, event);
      }
    };

    var onDrop = function onDrop(event) {
      var _a, _b;

      event.preventDefault();
      onData(event.dataTransfer, event);
      (_b = (_a = optionsRef.current).onDrop) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };

    var onPaste = function onPaste(event) {
      var _a, _b;

      onData(event.clipboardData, event);
      (_b = (_a = optionsRef.current).onPaste) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };

    targetElement.addEventListener('dragenter', onDragEnter);
    targetElement.addEventListener('dragover', onDragOver);
    targetElement.addEventListener('dragleave', onDragLeave);
    targetElement.addEventListener('drop', onDrop);
    targetElement.addEventListener('paste', onPaste);
    return function () {
      targetElement.removeEventListener('dragenter', onDragEnter);
      targetElement.removeEventListener('dragover', onDragOver);
      targetElement.removeEventListener('dragleave', onDragLeave);
      targetElement.removeEventListener('drop', onDrop);
      targetElement.removeEventListener('paste', onPaste);
    };
  }, [], target);
};

/* harmony default export */ var es_useDrop = (useDrop_useDrop);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useDynamicList/index.js
var useDynamicList_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useDynamicList_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useDynamicList_read(arguments[i]));
  }

  return ar;
};



var useDynamicList_useDynamicList = function useDynamicList(initialList) {
  if (initialList === void 0) {
    initialList = [];
  }

  var counterRef = Object(external_react_["useRef"])(-1);
  var keyList = Object(external_react_["useRef"])([]);
  var setKey = Object(external_react_["useCallback"])(function (index) {
    counterRef.current += 1;
    keyList.current.splice(index, 0, counterRef.current);
  }, []);

  var _a = useDynamicList_read(Object(external_react_["useState"])(function () {
    initialList.forEach(function (_, index) {
      setKey(index);
    });
    return initialList;
  }), 2),
      list = _a[0],
      setList = _a[1];

  var resetList = Object(external_react_["useCallback"])(function (newList) {
    keyList.current = [];
    setList(function () {
      newList.forEach(function (_, index) {
        setKey(index);
      });
      return newList;
    });
  }, []);
  var insert = Object(external_react_["useCallback"])(function (index, item) {
    setList(function (l) {
      var temp = useDynamicList_spread(l);

      temp.splice(index, 0, item);
      setKey(index);
      return temp;
    });
  }, []);
  var getKey = Object(external_react_["useCallback"])(function (index) {
    return keyList.current[index];
  }, []);
  var getIndex = Object(external_react_["useCallback"])(function (key) {
    return keyList.current.findIndex(function (ele) {
      return ele === key;
    });
  }, []);
  var merge = Object(external_react_["useCallback"])(function (index, items) {
    setList(function (l) {
      var temp = useDynamicList_spread(l);

      items.forEach(function (_, i) {
        setKey(index + i);
      });
      temp.splice.apply(temp, useDynamicList_spread([index, 0], items));
      return temp;
    });
  }, []);
  var replace = Object(external_react_["useCallback"])(function (index, item) {
    setList(function (l) {
      var temp = useDynamicList_spread(l);

      temp[index] = item;
      return temp;
    });
  }, []);
  var remove = Object(external_react_["useCallback"])(function (index) {
    setList(function (l) {
      var temp = useDynamicList_spread(l);

      temp.splice(index, 1); // remove keys if necessary

      try {
        keyList.current.splice(index, 1);
      } catch (e) {
        console.error(e);
      }

      return temp;
    });
  }, []);
  var move = Object(external_react_["useCallback"])(function (oldIndex, newIndex) {
    if (oldIndex === newIndex) {
      return;
    }

    setList(function (l) {
      var newList = useDynamicList_spread(l);

      var temp = newList.filter(function (_, index) {
        return index !== oldIndex;
      });
      temp.splice(newIndex, 0, newList[oldIndex]); // move keys if necessary

      try {
        var keyTemp = keyList.current.filter(function (_, index) {
          return index !== oldIndex;
        });
        keyTemp.splice(newIndex, 0, keyList.current[oldIndex]);
        keyList.current = keyTemp;
      } catch (e) {
        console.error(e);
      }

      return temp;
    });
  }, []);
  var push = Object(external_react_["useCallback"])(function (item) {
    setList(function (l) {
      setKey(l.length);
      return l.concat([item]);
    });
  }, []);
  var pop = Object(external_react_["useCallback"])(function () {
    // remove keys if necessary
    try {
      keyList.current = keyList.current.slice(0, keyList.current.length - 1);
    } catch (e) {
      console.error(e);
    }

    setList(function (l) {
      return l.slice(0, l.length - 1);
    });
  }, []);
  var unshift = Object(external_react_["useCallback"])(function (item) {
    setList(function (l) {
      setKey(0);
      return [item].concat(l);
    });
  }, []);
  var shift = Object(external_react_["useCallback"])(function () {
    // remove keys if necessary
    try {
      keyList.current = keyList.current.slice(1, keyList.current.length);
    } catch (e) {
      console.error(e);
    }

    setList(function (l) {
      return l.slice(1, l.length);
    });
  }, []);
  var sortList = Object(external_react_["useCallback"])(function (result) {
    return result.map(function (item, index) {
      return {
        key: index,
        item: item
      };
    }) // add index into obj
    .sort(function (a, b) {
      return getIndex(a.key) - getIndex(b.key);
    }) // sort based on the index of table
    .filter(function (item) {
      return !!item.item;
    }) // remove undefined(s)
    .map(function (item) {
      return item.item;
    });
  }, // retrive the data
  []);
  return {
    list: list,
    insert: insert,
    merge: merge,
    replace: replace,
    remove: remove,
    getKey: getKey,
    getIndex: getIndex,
    move: move,
    push: push,
    pop: pop,
    unshift: unshift,
    shift: shift,
    sortList: sortList,
    resetList: resetList
  };
};

/* harmony default export */ var es_useDynamicList = (useDynamicList_useDynamicList);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useEventEmitter/index.js
var __values = undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};



var useEventEmitter_EventEmitter =
/** @class */
function () {
  function EventEmitter() {
    var _this = this;

    this.subscriptions = new Set();

    this.emit = function (val) {
      var e_1, _a;

      try {
        for (var _b = __values(_this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
          var subscription = _c.value;
          subscription(val);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    };

    this.useSubscription = function (callback) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var callbackRef = Object(external_react_["useRef"])();
      callbackRef.current = callback; // eslint-disable-next-line react-hooks/rules-of-hooks

      Object(external_react_["useEffect"])(function () {
        function subscription(val) {
          if (callbackRef.current) {
            callbackRef.current(val);
          }
        }

        _this.subscriptions.add(subscription);

        return function () {
          _this.subscriptions["delete"](subscription);
        };
      }, []);
    };
  }

  return EventEmitter;
}();


function useEventEmitter() {
  var ref = Object(external_react_["useRef"])();

  if (!ref.current) {
    ref.current = new useEventEmitter_EventEmitter();
  }

  return ref.current;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useEventTarget/index.js
var useEventTarget_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};





function useEventTarget(options) {
  var _a = options || {},
      initialValue = _a.initialValue,
      transformer = _a.transformer;

  var _b = useEventTarget_read(Object(external_react_["useState"])(initialValue), 2),
      value = _b[0],
      setValue = _b[1];

  var transformerRef = es_useLatest(transformer);
  var reset = Object(external_react_["useCallback"])(function () {
    return setValue(initialValue);
  }, []);
  var onChange = Object(external_react_["useCallback"])(function (e) {
    var _value = e.target.value;

    if (isFunction(transformerRef.current)) {
      return setValue(transformerRef.current(_value));
    } // no transformer => U and T should be the same


    return setValue(_value);
  }, []);
  return [value, {
    onChange: onChange,
    reset: reset
  }];
}

/* harmony default export */ var es_useEventTarget = (useEventTarget);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useExternal/index.js
var useExternal_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

 // {[path]: count}
// remove external when no used

var EXTERNAL_USED_COUNT = {};

var loadScript = function loadScript(path, props) {
  if (props === void 0) {
    props = {};
  }

  var script = document.querySelector("script[src=\"" + path + "\"]");

  if (!script) {
    var newScript_1 = document.createElement('script');
    newScript_1.src = path;
    Object.keys(props).forEach(function (key) {
      newScript_1[key] = props[key];
    });
    newScript_1.setAttribute('data-status', 'loading');
    document.body.appendChild(newScript_1);
    return {
      ref: newScript_1,
      status: 'loading'
    };
  }

  return {
    ref: script,
    status: script.getAttribute('data-status') || 'ready'
  };
};

var loadCss = function loadCss(path, props) {
  if (props === void 0) {
    props = {};
  }

  var css = document.querySelector("link[href=\"" + path + "\"]");

  if (!css) {
    var newCss_1 = document.createElement('link');
    newCss_1.rel = 'stylesheet';
    newCss_1.href = path;
    Object.keys(props).forEach(function (key) {
      newCss_1[key] = props[key];
    }); // IE9+

    var isLegacyIECss = ('hideFocus' in newCss_1); // use preload in IE Edge (to detect load errors)

    if (isLegacyIECss && newCss_1.relList) {
      newCss_1.rel = 'preload';
      newCss_1.as = 'style';
    }

    newCss_1.setAttribute('data-status', 'loading');
    document.head.appendChild(newCss_1);
    return {
      ref: newCss_1,
      status: 'loading'
    };
  }

  return {
    ref: css,
    status: css.getAttribute('data-status') || 'ready'
  };
};

var useExternal_useExternal = function useExternal(path, options) {
  var _a = useExternal_read(Object(external_react_["useState"])(path ? 'loading' : 'unset'), 2),
      status = _a[0],
      setStatus = _a[1];

  var ref = Object(external_react_["useRef"])();
  Object(external_react_["useEffect"])(function () {
    if (!path) {
      setStatus('unset');
      return;
    }

    var pathname = path.replace(/[|#].*$/, '');

    if ((options === null || options === void 0 ? void 0 : options.type) === 'css' || !(options === null || options === void 0 ? void 0 : options.type) && /(^css!|\.css$)/.test(pathname)) {
      var result = loadCss(path, options === null || options === void 0 ? void 0 : options.css);
      ref.current = result.ref;
      setStatus(result.status);
    } else if ((options === null || options === void 0 ? void 0 : options.type) === 'js' || !(options === null || options === void 0 ? void 0 : options.type) && /(^js!|\.js$)/.test(pathname)) {
      var result = loadScript(path, options === null || options === void 0 ? void 0 : options.js);
      ref.current = result.ref;
      setStatus(result.status);
    } else {
      // do nothing
      console.error("Cannot infer the type of external resource, and please provide a type ('js' | 'css'). " + 'Refer to the https://ahooks.js.org/hooks/dom/use-external/#options');
    }

    if (!ref.current) {
      return;
    }

    if (EXTERNAL_USED_COUNT[path] === undefined) {
      EXTERNAL_USED_COUNT[path] = 1;
    } else {
      EXTERNAL_USED_COUNT[path] += 1;
    }

    var handler = function handler(event) {
      var _a;

      var targetStatus = event.type === 'load' ? 'ready' : 'error';
      (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setAttribute('data-status', targetStatus);
      setStatus(targetStatus);
    };

    ref.current.addEventListener('load', handler);
    ref.current.addEventListener('error', handler);
    return function () {
      var _a, _b, _c;

      (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('load', handler);
      (_b = ref.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('error', handler);
      EXTERNAL_USED_COUNT[path] -= 1;

      if (EXTERNAL_USED_COUNT[path] === 0) {
        (_c = ref.current) === null || _c === void 0 ? void 0 : _c.remove();
      }

      ref.current = undefined;
    };
  }, [path]);
  return status;
};

/* harmony default export */ var es_useExternal = (useExternal_useExternal);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useFavicon/index.js

var ImgTypeMap = {
  SVG: 'image/svg+xml',
  ICO: 'image/x-icon',
  GIF: 'image/gif',
  PNG: 'image/png'
};

var useFavicon_useFavicon = function useFavicon(href) {
  Object(external_react_["useEffect"])(function () {
    if (!href) return;
    var cutUrl = href.split('.');
    var imgSuffix = cutUrl[cutUrl.length - 1].toLocaleUpperCase();
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = ImgTypeMap[imgSuffix];
    link.href = href;
    link.rel = 'shortcut icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }, [href]);
};

/* harmony default export */ var es_useFavicon = (useFavicon_useFavicon);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useFocusWithin/index.js
var useFocusWithin_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



function useFocusWithin(target, options) {
  var _a = useFocusWithin_read(Object(external_react_["useState"])(false), 2),
      isFocusWithin = _a[0],
      setIsFocusWithin = _a[1];

  var _b = options || {},
      onFocus = _b.onFocus,
      onBlur = _b.onBlur,
      onChange = _b.onChange;

  es_useEventListener('focusin', function (e) {
    if (!isFocusWithin) {
      onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
      onChange === null || onChange === void 0 ? void 0 : onChange(true);
      setIsFocusWithin(true);
    }
  }, {
    target: target
  });
  es_useEventListener('focusout', function (e) {
    var _a, _b;

    if (isFocusWithin && !((_b = (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, e.relatedTarget))) {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
      onChange === null || onChange === void 0 ? void 0 : onChange(false);
      setIsFocusWithin(false);
    }
  }, {
    target: target
  });
  return isFocusWithin;
}
// EXTERNAL MODULE: ./node_modules/screenfull/dist/screenfull.js
var screenfull = __webpack_require__(15);
var screenfull_default = /*#__PURE__*/__webpack_require__.n(screenfull);

// CONCATENATED MODULE: ./node_modules/ahooks/es/useFullscreen/index.js
var useFullscreen_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};








var useFullscreen_useFullscreen = function useFullscreen(target, options) {
  var _a = options || {},
      onExit = _a.onExit,
      onEnter = _a.onEnter;

  var onExitRef = es_useLatest(onExit);
  var onEnterRef = es_useLatest(onEnter);

  var _b = useFullscreen_read(Object(external_react_["useState"])(false), 2),
      state = _b[0],
      setState = _b[1];

  var onChange = function onChange() {
    var _a, _b;

    if (screenfull_default.a.isEnabled) {
      var isFullscreen = screenfull_default.a.isFullscreen;

      if (isFullscreen) {
        (_a = onEnterRef.current) === null || _a === void 0 ? void 0 : _a.call(onEnterRef);
      } else {
        screenfull_default.a.off('change', onChange);
        (_b = onExitRef.current) === null || _b === void 0 ? void 0 : _b.call(onExitRef);
      }

      setState(isFullscreen);
    }
  };

  var enterFullscreen = function enterFullscreen() {
    var el = getTargetElement(target);

    if (!el) {
      return;
    }

    if (screenfull_default.a.isEnabled) {
      try {
        screenfull_default.a.request(el);
        screenfull_default.a.on('change', onChange);
      } catch (error) {
        console.error(error);
      }
    }
  };

  var exitFullscreen = function exitFullscreen() {
    if (screenfull_default.a.isEnabled) {
      screenfull_default.a.exit();
    }
  };

  var toggleFullscreen = function toggleFullscreen() {
    if (state) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }
  };

  es_useUnmount(function () {
    if (screenfull_default.a.isEnabled) {
      screenfull_default.a.off('change', onChange);
    }
  });
  return [state, {
    enterFullscreen: es_useMemoizedFn(enterFullscreen),
    exitFullscreen: es_useMemoizedFn(exitFullscreen),
    toggleFullscreen: es_useMemoizedFn(toggleFullscreen),
    isEnabled: screenfull_default.a.isEnabled
  }];
};

/* harmony default export */ var es_useFullscreen = (useFullscreen_useFullscreen);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useFusionTable/fusionAdapter.js
var fusionAdapter_assign = undefined && undefined.__assign || function () {
  fusionAdapter_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return fusionAdapter_assign.apply(this, arguments);
};

var fieldAdapter = function fieldAdapter(field) {
  return {
    getFieldInstance: function getFieldInstance(name) {
      return field.getNames().includes(name);
    },
    setFieldsValue: field.setValues,
    getFieldsValue: field.getValues,
    resetFields: field.resetToDefault,
    validateFields: function validateFields(fields, callback) {
      field.validate(fields, callback);
    }
  };
};
var resultAdapter = function resultAdapter(result) {
  var tableProps = {
    dataSource: result.tableProps.dataSource,
    loading: result.tableProps.loading,
    onSort: function onSort(dataIndex, order) {
      var _a;

      result.tableProps.onChange({
        current: result.pagination.current,
        pageSize: result.pagination.pageSize
      }, (_a = result.params[0]) === null || _a === void 0 ? void 0 : _a.filters, {
        field: dataIndex,
        order: order
      });
    },
    onFilter: function onFilter(filterParams) {
      var _a;

      result.tableProps.onChange({
        current: result.pagination.current,
        pageSize: result.pagination.pageSize
      }, filterParams, (_a = result.params[0]) === null || _a === void 0 ? void 0 : _a.sorter);
    }
  };
  var paginationProps = {
    onChange: result.pagination.changeCurrent,
    onPageSizeChange: result.pagination.changePageSize,
    current: result.pagination.current,
    pageSize: result.pagination.pageSize,
    total: result.pagination.total
  };
  return fusionAdapter_assign(fusionAdapter_assign({}, result), {
    tableProps: tableProps,
    paginationProps: paginationProps
  });
};
// CONCATENATED MODULE: ./node_modules/ahooks/es/useFusionTable/index.js
var useFusionTable_assign = undefined && undefined.__assign || function () {
  useFusionTable_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useFusionTable_assign.apply(this, arguments);
};




var useFusionTable_useFusionTable = function useFusionTable(service, options) {
  if (options === void 0) {
    options = {};
  }

  var ret = es_useAntdTable(service, useFusionTable_assign(useFusionTable_assign({}, options), {
    form: options.field ? fieldAdapter(options.field) : undefined
  }));
  return resultAdapter(ret);
};

/* harmony default export */ var es_useFusionTable = (useFusionTable_useFusionTable);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useGetState/index.js
var useGetState_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



function useGetState(initialState) {
  var _a = useGetState_read(Object(external_react_["useState"])(initialState), 2),
      state = _a[0],
      setState = _a[1];

  var stateRef = Object(external_react_["useRef"])(state);
  stateRef.current = state;
  var getState = Object(external_react_["useCallback"])(function () {
    return stateRef.current;
  }, []);
  return [state, setState, getState];
}

/* harmony default export */ var es_useGetState = (useGetState);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useHistoryTravel/index.js
var useHistoryTravel_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useHistoryTravel_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useHistoryTravel_read(arguments[i]));
  }

  return ar;
};





var dumpIndex = function dumpIndex(step, arr) {
  var index = step > 0 ? step - 1 // move forward
  : arr.length + step; // move backward

  if (index >= arr.length - 1) {
    index = arr.length - 1;
  }

  if (index < 0) {
    index = 0;
  }

  return index;
};

var split = function split(step, targetArr) {
  var index = dumpIndex(step, targetArr);
  return {
    _current: targetArr[index],
    _before: targetArr.slice(0, index),
    _after: targetArr.slice(index + 1)
  };
};

function useHistoryTravel(initialValue) {
  var _a = useHistoryTravel_read(Object(external_react_["useState"])({
    present: initialValue,
    past: [],
    future: []
  }), 2),
      history = _a[0],
      setHistory = _a[1];

  var present = history.present,
      past = history.past,
      future = history.future;
  var initialValueRef = Object(external_react_["useRef"])(initialValue);

  var reset = function reset() {
    var params = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      params[_i] = arguments[_i];
    }

    var _initial = params.length > 0 ? params[0] : initialValueRef.current;

    initialValueRef.current = _initial;
    setHistory({
      present: _initial,
      future: [],
      past: []
    });
  };

  var updateValue = function updateValue(val) {
    setHistory({
      present: val,
      future: [],
      past: useHistoryTravel_spread(past, [present])
    });
  };

  var _forward = function _forward(step) {
    if (step === void 0) {
      step = 1;
    }

    if (future.length === 0) {
      return;
    }

    var _a = split(step, future),
        _before = _a._before,
        _current = _a._current,
        _after = _a._after;

    setHistory({
      past: useHistoryTravel_spread(past, [present], _before),
      present: _current,
      future: _after
    });
  };

  var _backward = function _backward(step) {
    if (step === void 0) {
      step = -1;
    }

    if (past.length === 0) {
      return;
    }

    var _a = split(step, past),
        _before = _a._before,
        _current = _a._current,
        _after = _a._after;

    setHistory({
      past: _before,
      present: _current,
      future: useHistoryTravel_spread(_after, [present], future)
    });
  };

  var go = function go(step) {
    var stepNum = isNumber(step) ? step : Number(step);

    if (stepNum === 0) {
      return;
    }

    if (stepNum > 0) {
      return _forward(stepNum);
    }

    _backward(stepNum);
  };

  return {
    value: present,
    backLength: past.length,
    forwardLength: future.length,
    setValue: es_useMemoizedFn(updateValue),
    go: es_useMemoizedFn(go),
    back: es_useMemoizedFn(function () {
      go(-1);
    }),
    forward: es_useMemoizedFn(function () {
      go(1);
    }),
    reset: es_useMemoizedFn(reset)
  };
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useHover/index.js
var useHover_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



/* harmony default export */ var useHover = (function (target, options) {
  var _a = options || {},
      onEnter = _a.onEnter,
      onLeave = _a.onLeave,
      onChange = _a.onChange;

  var _b = useHover_read(useBoolean(false), 2),
      state = _b[0],
      _c = _b[1],
      setTrue = _c.setTrue,
      setFalse = _c.setFalse;

  es_useEventListener('mouseenter', function () {
    onEnter === null || onEnter === void 0 ? void 0 : onEnter();
    setTrue();
    onChange === null || onChange === void 0 ? void 0 : onChange(true);
  }, {
    target: target
  });
  es_useEventListener('mouseleave', function () {
    onLeave === null || onLeave === void 0 ? void 0 : onLeave();
    setFalse();
    onChange === null || onChange === void 0 ? void 0 : onChange(false);
  }, {
    target: target
  });
  return state;
});
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/rect.js
var getScrollTop = function getScrollTop(el) {
  if (el === document || el === document.body) {
    return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
  }

  return el.scrollTop;
};

var getScrollHeight = function getScrollHeight(el) {
  return el.scrollHeight || Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
};

var getClientHeight = function getClientHeight(el) {
  return el.clientHeight || Math.max(document.documentElement.clientHeight, document.body.clientHeight);
};


// CONCATENATED MODULE: ./node_modules/ahooks/es/useInfiniteScroll/index.js
var useInfiniteScroll_assign = undefined && undefined.__assign || function () {
  useInfiniteScroll_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useInfiniteScroll_assign.apply(this, arguments);
};

var useInfiniteScroll_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var useInfiniteScroll_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var useInfiniteScroll_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useInfiniteScroll_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useInfiniteScroll_read(arguments[i]));
  }

  return ar;
};









var useInfiniteScroll_useInfiniteScroll = function useInfiniteScroll(service, options) {
  if (options === void 0) {
    options = {};
  }

  var target = options.target,
      isNoMore = options.isNoMore,
      _a = options.threshold,
      threshold = _a === void 0 ? 100 : _a,
      _b = options.reloadDeps,
      reloadDeps = _b === void 0 ? [] : _b,
      manual = options.manual,
      _onBefore = options.onBefore,
      _onSuccess = options.onSuccess,
      _onError = options.onError,
      _onFinally = options.onFinally;

  var _c = useInfiniteScroll_read(Object(external_react_["useState"])(), 2),
      finalData = _c[0],
      setFinalData = _c[1];

  var _d = useInfiniteScroll_read(Object(external_react_["useState"])(false), 2),
      loadingMore = _d[0],
      setLoadingMore = _d[1];

  var noMore = Object(external_react_["useMemo"])(function () {
    if (!isNoMore) return false;
    return isNoMore(finalData);
  }, [finalData]);

  var _e = es_useRequest(function (lastData) {
    return useInfiniteScroll_awaiter(void 0, void 0, void 0, function () {
      var currentData;
      return useInfiniteScroll_generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , service(lastData)];

          case 1:
            currentData = _a.sent();

            if (!lastData) {
              setFinalData(currentData);
            } else {
              setFinalData(useInfiniteScroll_assign(useInfiniteScroll_assign({}, currentData), {
                // @ts-ignore
                list: useInfiniteScroll_spread(lastData.list, currentData.list)
              }));
            }

            return [2
            /*return*/
            , currentData];
        }
      });
    });
  }, {
    manual: manual,
    onFinally: function onFinally(_, d, e) {
      setLoadingMore(false);
      _onFinally === null || _onFinally === void 0 ? void 0 : _onFinally(d, e);
    },
    onBefore: function onBefore() {
      return _onBefore === null || _onBefore === void 0 ? void 0 : _onBefore();
    },
    onSuccess: function onSuccess(d) {
      setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        scrollMethod();
      });
      _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess(d);
    },
    onError: function onError(e) {
      return _onError === null || _onError === void 0 ? void 0 : _onError(e);
    }
  }),
      loading = _e.loading,
      run = _e.run,
      runAsync = _e.runAsync,
      cancel = _e.cancel;

  var loadMore = function loadMore() {
    if (noMore) return;
    setLoadingMore(true);
    run(finalData);
  };

  var loadMoreAsync = function loadMoreAsync() {
    if (noMore) return Promise.reject();
    setLoadingMore(true);
    return runAsync(finalData);
  };

  var reload = function reload() {
    return run();
  };

  var reloadAsync = function reloadAsync() {
    return runAsync();
  };

  var scrollMethod = function scrollMethod() {
    var el = getTargetElement(target);

    if (!el) {
      return;
    }

    var scrollTop = getScrollTop(el);
    var scrollHeight = getScrollHeight(el);
    var clientHeight = getClientHeight(el);

    if (scrollHeight - scrollTop <= clientHeight + threshold) {
      loadMore();
    }
  };

  es_useEventListener('scroll', function () {
    if (loading || loadingMore) {
      return;
    }

    scrollMethod();
  }, {
    target: target
  });
  useUpdateEffect(function () {
    run();
  }, useInfiniteScroll_spread(reloadDeps));
  return {
    data: finalData,
    loading: !loadingMore && loading,
    loadingMore: loadingMore,
    noMore: noMore,
    loadMore: es_useMemoizedFn(loadMore),
    loadMoreAsync: es_useMemoizedFn(loadMoreAsync),
    reload: es_useMemoizedFn(reload),
    reloadAsync: es_useMemoizedFn(reloadAsync),
    mutate: setFinalData,
    cancel: cancel
  };
};

/* harmony default export */ var es_useInfiniteScroll = (useInfiniteScroll_useInfiniteScroll);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useInterval/index.js




function useInterval(fn, delay, options) {
  var immediate = options === null || options === void 0 ? void 0 : options.immediate;
  var fnRef = es_useLatest(fn);
  var timerRef = Object(external_react_["useRef"])();
  Object(external_react_["useEffect"])(function () {
    if (!isNumber(delay) || delay < 0) return;

    if (immediate) {
      fnRef.current();
    }

    timerRef.current = setInterval(function () {
      fnRef.current();
    }, delay);
    return function () {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [delay]);
  var clear = Object(external_react_["useCallback"])(function () {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);
  return clear;
}

/* harmony default export */ var es_useInterval = (useInterval);
// EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(169);

// CONCATENATED MODULE: ./node_modules/ahooks/es/useInViewport/index.js
var useInViewport_assign = undefined && undefined.__assign || function () {
  useInViewport_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useInViewport_assign.apply(this, arguments);
};

var useInViewport_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useInViewport_values = undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};






function useInViewport(target, options) {
  var _a = useInViewport_read(Object(external_react_["useState"])(), 2),
      state = _a[0],
      setState = _a[1];

  var _b = useInViewport_read(Object(external_react_["useState"])(), 2),
      ratio = _b[0],
      setRatio = _b[1];

  utils_useEffectWithTarget(function () {
    var el = getTargetElement(target);

    if (!el) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      var e_1, _a;

      try {
        for (var entries_1 = useInViewport_values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
          var entry = entries_1_1.value;
          setRatio(entry.intersectionRatio);
          setState(entry.isIntersecting);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (entries_1_1 && !entries_1_1.done && (_a = entries_1["return"])) _a.call(entries_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }, useInViewport_assign(useInViewport_assign({}, options), {
      root: getTargetElement(options === null || options === void 0 ? void 0 : options.root)
    }));
    observer.observe(el);
    return function () {
      observer.disconnect();
    };
  }, [], target);
  return [state, ratio];
}

/* harmony default export */ var es_useInViewport = (useInViewport);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useIsomorphicLayoutEffect/index.js


var useIsomorphicLayoutEffect = utils_isBrowser ? external_react_["useLayoutEffect"] : external_react_["useEffect"];
/* harmony default export */ var es_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/useDeepCompareWithTarget.js




var useDeepCompareWithTarget_depsEqual = function depsEqual(aDeps, bDeps) {
  if (bDeps === void 0) {
    bDeps = [];
  }

  return isEqual_default()(aDeps, bDeps);
};

var useDeepCompareWithTarget_useDeepCompareEffectWithTarget = function useDeepCompareEffectWithTarget(effect, deps, target) {
  var ref = Object(external_react_["useRef"])();
  var signalRef = Object(external_react_["useRef"])(0);

  if (!useDeepCompareWithTarget_depsEqual(deps, ref.current)) {
    ref.current = deps;
    signalRef.current += 1;
  }

  utils_useEffectWithTarget(effect, [signalRef.current], target);
};

/* harmony default export */ var useDeepCompareWithTarget = (useDeepCompareWithTarget_useDeepCompareEffectWithTarget);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useKeyPress/index.js
var useKeyPress_values = undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};




 // 键盘事件 keyCode 别名

var aliasKeyCodeMap = {
  '0': 48,
  '1': 49,
  '2': 50,
  '3': 51,
  '4': 52,
  '5': 53,
  '6': 54,
  '7': 55,
  '8': 56,
  '9': 57,
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pausebreak: 19,
  capslock: 20,
  esc: 27,
  space: 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  leftarrow: 37,
  uparrow: 38,
  rightarrow: 39,
  downarrow: 40,
  insert: 45,
  "delete": 46,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  leftwindowkey: 91,
  rightwindowkey: 92,
  selectkey: 93,
  numpad0: 96,
  numpad1: 97,
  numpad2: 98,
  numpad3: 99,
  numpad4: 100,
  numpad5: 101,
  numpad6: 102,
  numpad7: 103,
  numpad8: 104,
  numpad9: 105,
  multiply: 106,
  add: 107,
  subtract: 109,
  decimalpoint: 110,
  divide: 111,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numlock: 144,
  scrolllock: 145,
  semicolon: 186,
  equalsign: 187,
  comma: 188,
  dash: 189,
  period: 190,
  forwardslash: 191,
  graveaccent: 192,
  openbracket: 219,
  backslash: 220,
  closebracket: 221,
  singlequote: 222
}; // 修饰键

var modifierKey = {
  ctrl: function ctrl(event) {
    return event.ctrlKey;
  },
  shift: function shift(event) {
    return event.shiftKey;
  },
  alt: function alt(event) {
    return event.altKey;
  },
  meta: function meta(event) {
    return event.metaKey;
  }
}; // 根据 event 计算激活键数量

function countKeyByEvent(event) {
  var countOfModifier = Object.keys(modifierKey).reduce(function (total, key) {
    if (modifierKey[key](event)) {
      return total + 1;
    }

    return total;
  }, 0); // 16 17 18 91 92 是修饰键的 keyCode，如果 keyCode 是修饰键，那么激活数量就是修饰键的数量，如果不是，那么就需要 +1

  return [16, 17, 18, 91, 92].includes(event.keyCode) ? countOfModifier : countOfModifier + 1;
}
/**
 * 判断按键是否激活
 * @param [event: KeyboardEvent]键盘事件
 * @param [keyFilter: any] 当前键
 * @returns Boolean
 */


function genFilterKey(event, keyFilter, exactMatch) {
  var e_1, _a; // 浏览器自动补全 input 的时候，会触发 keyDown、keyUp 事件，但此时 event.key 等为空


  if (!event.key) {
    return false;
  } // 数字类型直接匹配事件的 keyCode


  if (isNumber(keyFilter)) {
    return event.keyCode === keyFilter;
  } // 字符串依次判断是否有组合键


  var genArr = keyFilter.split('.');
  var genLen = 0;

  try {
    for (var genArr_1 = useKeyPress_values(genArr), genArr_1_1 = genArr_1.next(); !genArr_1_1.done; genArr_1_1 = genArr_1.next()) {
      var key = genArr_1_1.value; // 组合键

      var genModifier = modifierKey[key]; // keyCode 别名

      var aliasKeyCode = aliasKeyCodeMap[key.toLowerCase()];

      if (genModifier && genModifier(event) || aliasKeyCode && aliasKeyCode === event.keyCode) {
        genLen++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (genArr_1_1 && !genArr_1_1.done && (_a = genArr_1["return"])) _a.call(genArr_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  /**
   * 需要判断触发的键位和监听的键位完全一致，判断方法就是触发的键位里有且等于监听的键位
   * genLen === genArr.length 能判断出来触发的键位里有监听的键位
   * countKeyByEvent(event) === genArr.length 判断出来触发的键位数量里有且等于监听的键位数量
   * 主要用来防止按组合键其子集也会触发的情况，例如监听 ctrl+a 会触发监听 ctrl 和 a 两个键的事件。
   */


  if (exactMatch) {
    return genLen === genArr.length && countKeyByEvent(event) === genArr.length;
  }

  return genLen === genArr.length;
}
/**
 * 键盘输入预处理方法
 * @param [keyFilter: any] 当前键
 * @returns () => Boolean
 */


function genKeyFormatter(keyFilter, exactMatch) {
  if (isFunction(keyFilter)) {
    return keyFilter;
  }

  if (isString(keyFilter) || isNumber(keyFilter)) {
    return function (event) {
      return genFilterKey(event, keyFilter, exactMatch);
    };
  }

  if (Array.isArray(keyFilter)) {
    return function (event) {
      return keyFilter.some(function (item) {
        return genFilterKey(event, item, exactMatch);
      });
    };
  }

  return keyFilter ? function () {
    return true;
  } : function () {
    return false;
  };
}

var defaultEvents = ['keydown'];

function useKeyPress(keyFilter, eventHandler, option) {
  var _a = option || {},
      _b = _a.events,
      events = _b === void 0 ? defaultEvents : _b,
      target = _a.target,
      _c = _a.exactMatch,
      exactMatch = _c === void 0 ? false : _c;

  var eventHandlerRef = es_useLatest(eventHandler);
  var keyFilterRef = es_useLatest(keyFilter);
  useDeepCompareWithTarget(function () {
    var e_2, _a;

    var _b;

    var el = getTargetElement(target, window);

    if (!el) {
      return;
    }

    var callbackHandler = function callbackHandler(event) {
      var _a;

      var genGuard = genKeyFormatter(keyFilterRef.current, exactMatch);

      if (genGuard(event)) {
        return (_a = eventHandlerRef.current) === null || _a === void 0 ? void 0 : _a.call(eventHandlerRef, event);
      }
    };

    try {
      for (var events_1 = useKeyPress_values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
        var eventName = events_1_1.value;
        (_b = el === null || el === void 0 ? void 0 : el.addEventListener) === null || _b === void 0 ? void 0 : _b.call(el, eventName, callbackHandler);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (events_1_1 && !events_1_1.done && (_a = events_1["return"])) _a.call(events_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return function () {
      var e_3, _a;

      var _b;

      try {
        for (var events_2 = useKeyPress_values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
          var eventName = events_2_1.value;
          (_b = el === null || el === void 0 ? void 0 : el.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(el, eventName, callbackHandler);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (events_2_1 && !events_2_1.done && (_a = events_2["return"])) _a.call(events_2);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    };
  }, [events], target);
}

/* harmony default export */ var es_useKeyPress = (useKeyPress);
// CONCATENATED MODULE: ./node_modules/ahooks/es/createUseStorageState/index.js
var createUseStorageState_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};
/* eslint-disable no-empty */






function createUseStorageState(getStorage) {
  function useStorageState(key, options) {
    var storage; // https://github.com/alibaba/hooks/issues/800

    try {
      storage = getStorage();
    } catch (err) {
      console.error(err);
    }

    var serializer = function serializer(value) {
      if (options === null || options === void 0 ? void 0 : options.serializer) {
        return options === null || options === void 0 ? void 0 : options.serializer(value);
      }

      return JSON.stringify(value);
    };

    var deserializer = function deserializer(value) {
      if (options === null || options === void 0 ? void 0 : options.deserializer) {
        return options === null || options === void 0 ? void 0 : options.deserializer(value);
      }

      return JSON.parse(value);
    };

    function getStoredValue() {
      try {
        var raw = storage === null || storage === void 0 ? void 0 : storage.getItem(key);

        if (raw) {
          return deserializer(raw);
        }
      } catch (e) {
        console.error(e);
      }

      if (isFunction(options === null || options === void 0 ? void 0 : options.defaultValue)) {
        return options === null || options === void 0 ? void 0 : options.defaultValue();
      }

      return options === null || options === void 0 ? void 0 : options.defaultValue;
    }

    var _a = createUseStorageState_read(Object(external_react_["useState"])(function () {
      return getStoredValue();
    }), 2),
        state = _a[0],
        setState = _a[1];

    useUpdateEffect(function () {
      setState(getStoredValue());
    }, [key]);

    var updateState = function updateState(value) {
      var currentState = isFunction(value) ? value(state) : value;
      setState(currentState);

      if (isUndef(currentState)) {
        storage === null || storage === void 0 ? void 0 : storage.removeItem(key);
      } else {
        try {
          storage === null || storage === void 0 ? void 0 : storage.setItem(key, serializer(currentState));
        } catch (e) {
          console.error(e);
        }
      }
    };

    return [state, es_useMemoizedFn(updateState)];
  }

  return useStorageState;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useLocalStorageState/index.js


var useLocalStorageState = createUseStorageState(function () {
  return utils_isBrowser ? localStorage : undefined;
});
/* harmony default export */ var es_useLocalStorageState = (useLocalStorageState);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useLockFn/index.js
var useLockFn_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var useLockFn_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var useLockFn_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useLockFn_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useLockFn_read(arguments[i]));
  }

  return ar;
};



function useLockFn(fn) {
  var _this = this;

  var lockRef = Object(external_react_["useRef"])(false);
  return Object(external_react_["useCallback"])(function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return useLockFn_awaiter(_this, void 0, void 0, function () {
      var ret, e_1;
      return useLockFn_generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (lockRef.current) return [2
            /*return*/
            ];
            lockRef.current = true;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , fn.apply(void 0, useLockFn_spread(args))];

          case 2:
            ret = _a.sent();
            lockRef.current = false;
            return [2
            /*return*/
            , ret];

          case 3:
            e_1 = _a.sent();
            lockRef.current = false;
            throw e_1;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }, [fn]);
}

/* harmony default export */ var es_useLockFn = (useLockFn);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useLongPress/index.js





var touchSupported = utils_isBrowser && ( // @ts-ignore
'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch);

function useLongPress(onLongPress, target, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.delay,
      delay = _c === void 0 ? 300 : _c,
      moveThreshold = _b.moveThreshold,
      onClick = _b.onClick,
      onLongPressEnd = _b.onLongPressEnd;

  var onLongPressRef = es_useLatest(onLongPress);
  var onClickRef = es_useLatest(onClick);
  var onLongPressEndRef = es_useLatest(onLongPressEnd);
  var timerRef = Object(external_react_["useRef"])();
  var isTriggeredRef = Object(external_react_["useRef"])(false);
  var pervPositionRef = Object(external_react_["useRef"])({
    x: 0,
    y: 0
  });
  var hasMoveThreshold = !!((moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.x) && moveThreshold.x > 0 || (moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.y) && moveThreshold.y > 0);
  utils_useEffectWithTarget(function () {
    var targetElement = getTargetElement(target);

    if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) {
      return;
    }

    var overThreshold = function overThreshold(event) {
      var _a = getClientPosition(event),
          clientX = _a.clientX,
          clientY = _a.clientY;

      var offsetX = Math.abs(clientX - pervPositionRef.current.x);
      var offsetY = Math.abs(clientY - pervPositionRef.current.y);
      return !!((moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.x) && offsetX > moveThreshold.x || (moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.y) && offsetY > moveThreshold.y);
    };

    function getClientPosition(event) {
      if (event instanceof TouchEvent) {
        return {
          clientX: event.touches[0].clientX,
          clientY: event.touches[0].clientY
        };
      }

      if (event instanceof MouseEvent) {
        return {
          clientX: event.clientX,
          clientY: event.clientY
        };
      }

      console.warn('Unsupported event type');
      return {
        clientX: 0,
        clientY: 0
      };
    }

    var onStart = function onStart(event) {
      if (hasMoveThreshold) {
        var _a = getClientPosition(event),
            clientX = _a.clientX,
            clientY = _a.clientY;

        pervPositionRef.current.x = clientX;
        pervPositionRef.current.y = clientY;
      }

      timerRef.current = setTimeout(function () {
        onLongPressRef.current(event);
        isTriggeredRef.current = true;
      }, delay);
    };

    var onMove = function onMove(event) {
      if (timerRef.current && overThreshold(event)) {
        clearInterval(timerRef.current);
        timerRef.current = undefined;
      }
    };

    var onEnd = function onEnd(event, shouldTriggerClick) {
      var _a;

      if (shouldTriggerClick === void 0) {
        shouldTriggerClick = false;
      }

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      if (isTriggeredRef.current) {
        (_a = onLongPressEndRef.current) === null || _a === void 0 ? void 0 : _a.call(onLongPressEndRef, event);
      }

      if (shouldTriggerClick && !isTriggeredRef.current && onClickRef.current) {
        onClickRef.current(event);
      }

      isTriggeredRef.current = false;
    };

    var onEndWithClick = function onEndWithClick(event) {
      return onEnd(event, true);
    };

    if (!touchSupported) {
      targetElement.addEventListener('mousedown', onStart);
      targetElement.addEventListener('mouseup', onEndWithClick);
      targetElement.addEventListener('mouseleave', onEnd);
      if (hasMoveThreshold) targetElement.addEventListener('mousemove', onMove);
    } else {
      targetElement.addEventListener('touchstart', onStart);
      targetElement.addEventListener('touchend', onEndWithClick);
      if (hasMoveThreshold) targetElement.addEventListener('touchmove', onMove);
    }

    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        isTriggeredRef.current = false;
      }

      if (!touchSupported) {
        targetElement.removeEventListener('mousedown', onStart);
        targetElement.removeEventListener('mouseup', onEndWithClick);
        targetElement.removeEventListener('mouseleave', onEnd);
        if (hasMoveThreshold) targetElement.removeEventListener('mousemove', onMove);
      } else {
        targetElement.removeEventListener('touchstart', onStart);
        targetElement.removeEventListener('touchend', onEndWithClick);
        if (hasMoveThreshold) targetElement.removeEventListener('touchmove', onMove);
      }
    };
  }, [], target);
}

/* harmony default export */ var es_useLongPress = (useLongPress);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useMap/index.js
var useMap_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




function useMap(initialValue) {
  var getInitValue = function getInitValue() {
    return initialValue === undefined ? new Map() : new Map(initialValue);
  };

  var _a = useMap_read(Object(external_react_["useState"])(function () {
    return getInitValue();
  }), 2),
      map = _a[0],
      setMap = _a[1];

  var set = function set(key, entry) {
    setMap(function (prev) {
      var temp = new Map(prev);
      temp.set(key, entry);
      return temp;
    });
  };

  var setAll = function setAll(newMap) {
    setMap(new Map(newMap));
  };

  var remove = function remove(key) {
    setMap(function (prev) {
      var temp = new Map(prev);
      temp["delete"](key);
      return temp;
    });
  };

  var reset = function reset() {
    return setMap(getInitValue());
  };

  var get = function get(key) {
    return map.get(key);
  };

  return [map, {
    set: es_useMemoizedFn(set),
    setAll: es_useMemoizedFn(setAll),
    remove: es_useMemoizedFn(remove),
    reset: es_useMemoizedFn(reset),
    get: es_useMemoizedFn(get)
  }];
}

/* harmony default export */ var es_useMap = (useMap);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRafState/index.js
var useRafState_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




function useRafState(initialState) {
  var ref = Object(external_react_["useRef"])(0);

  var _a = useRafState_read(Object(external_react_["useState"])(initialState), 2),
      state = _a[0],
      setState = _a[1];

  var setRafState = Object(external_react_["useCallback"])(function (value) {
    cancelAnimationFrame(ref.current);
    ref.current = requestAnimationFrame(function () {
      setState(value);
    });
  }, []);
  es_useUnmount(function () {
    cancelAnimationFrame(ref.current);
  });
  return [state, setRafState];
}

/* harmony default export */ var es_useRafState = (useRafState);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useMouse/index.js
var useMouse_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




var useMouse_initState = {
  screenX: NaN,
  screenY: NaN,
  clientX: NaN,
  clientY: NaN,
  pageX: NaN,
  pageY: NaN,
  elementX: NaN,
  elementY: NaN,
  elementH: NaN,
  elementW: NaN,
  elementPosX: NaN,
  elementPosY: NaN
};
/* harmony default export */ var useMouse = (function (target) {
  var _a = useMouse_read(es_useRafState(useMouse_initState), 2),
      state = _a[0],
      setState = _a[1];

  es_useEventListener('mousemove', function (event) {
    var screenX = event.screenX,
        screenY = event.screenY,
        clientX = event.clientX,
        clientY = event.clientY,
        pageX = event.pageX,
        pageY = event.pageY;
    var newState = {
      screenX: screenX,
      screenY: screenY,
      clientX: clientX,
      clientY: clientY,
      pageX: pageX,
      pageY: pageY,
      elementX: NaN,
      elementY: NaN,
      elementH: NaN,
      elementW: NaN,
      elementPosX: NaN,
      elementPosY: NaN
    };
    var targetElement = getTargetElement(target);

    if (targetElement) {
      var _a = targetElement.getBoundingClientRect(),
          left = _a.left,
          top_1 = _a.top,
          width = _a.width,
          height = _a.height;

      newState.elementPosX = left + window.pageXOffset;
      newState.elementPosY = top_1 + window.pageYOffset;
      newState.elementX = pageX - newState.elementPosX;
      newState.elementY = pageY - newState.elementPosY;
      newState.elementW = width;
      newState.elementH = height;
    }

    setState(newState);
  }, {
    target: function target() {
      return document;
    }
  });
  return state;
});
// CONCATENATED MODULE: ./node_modules/ahooks/es/useNetwork/index.js
var useNetwork_assign = undefined && undefined.__assign || function () {
  useNetwork_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useNetwork_assign.apply(this, arguments);
};

var useNetwork_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



var NetworkEventType;

(function (NetworkEventType) {
  NetworkEventType["ONLINE"] = "online";
  NetworkEventType["OFFLINE"] = "offline";
  NetworkEventType["CHANGE"] = "change";
})(NetworkEventType || (NetworkEventType = {}));

function getConnection() {
  var nav = navigator;
  if (!isObject(nav)) return null;
  return nav.connection || nav.mozConnection || nav.webkitConnection;
}

function getConnectionProperty() {
  var c = getConnection();
  if (!c) return {};
  return {
    rtt: c.rtt,
    type: c.type,
    saveData: c.saveData,
    downlink: c.downlink,
    downlinkMax: c.downlinkMax,
    effectiveType: c.effectiveType
  };
}

function useNetwork() {
  var _a = useNetwork_read(Object(external_react_["useState"])(function () {
    return useNetwork_assign({
      since: undefined,
      online: navigator === null || navigator === void 0 ? void 0 : navigator.onLine
    }, getConnectionProperty());
  }), 2),
      state = _a[0],
      setState = _a[1];

  Object(external_react_["useEffect"])(function () {
    var onOnline = function onOnline() {
      setState(function (prevState) {
        return useNetwork_assign(useNetwork_assign({}, prevState), {
          online: true,
          since: new Date()
        });
      });
    };

    var onOffline = function onOffline() {
      setState(function (prevState) {
        return useNetwork_assign(useNetwork_assign({}, prevState), {
          online: false,
          since: new Date()
        });
      });
    };

    var onConnectionChange = function onConnectionChange() {
      setState(function (prevState) {
        return useNetwork_assign(useNetwork_assign({}, prevState), getConnectionProperty());
      });
    };

    window.addEventListener(NetworkEventType.ONLINE, onOnline);
    window.addEventListener(NetworkEventType.OFFLINE, onOffline);
    var connection = getConnection();
    connection === null || connection === void 0 ? void 0 : connection.addEventListener(NetworkEventType.CHANGE, onConnectionChange);
    return function () {
      window.removeEventListener(NetworkEventType.ONLINE, onOnline);
      window.removeEventListener(NetworkEventType.OFFLINE, onOffline);
      connection === null || connection === void 0 ? void 0 : connection.removeEventListener(NetworkEventType.CHANGE, onConnectionChange);
    };
  }, []);
  return state;
}

/* harmony default export */ var es_useNetwork = (useNetwork);
// CONCATENATED MODULE: ./node_modules/ahooks/es/usePrevious/index.js


var defaultShouldUpdate = function defaultShouldUpdate(a, b) {
  return !Object.is(a, b);
};

function usePrevious(state, shouldUpdate) {
  if (shouldUpdate === void 0) {
    shouldUpdate = defaultShouldUpdate;
  }

  var prevRef = Object(external_react_["useRef"])();
  var curRef = Object(external_react_["useRef"])();

  if (shouldUpdate(curRef.current, state)) {
    prevRef.current = curRef.current;
    curRef.current = state;
  }

  return prevRef.current;
}

/* harmony default export */ var es_usePrevious = (usePrevious);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRafInterval/index.js




var setRafInterval = function setRafInterval(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  if (typeof requestAnimationFrame === typeof undefined) {
    return {
      id: setInterval(callback, delay)
    };
  }

  var start = new Date().getTime();
  var handle = {
    id: 0
  };

  var loop = function loop() {
    var current = new Date().getTime();

    if (current - start >= delay) {
      callback();
      start = new Date().getTime();
    }

    handle.id = requestAnimationFrame(loop);
  };

  handle.id = requestAnimationFrame(loop);
  return handle;
};

function cancelAnimationFrameIsNotDefined(t) {
  return typeof cancelAnimationFrame === typeof undefined;
}

var clearRafInterval = function clearRafInterval(handle) {
  if (cancelAnimationFrameIsNotDefined(handle.id)) {
    return clearInterval(handle.id);
  }

  cancelAnimationFrame(handle.id);
};

function useRafInterval(fn, delay, options) {
  var immediate = options === null || options === void 0 ? void 0 : options.immediate;
  var fnRef = es_useLatest(fn);
  var timerRef = Object(external_react_["useRef"])();
  Object(external_react_["useEffect"])(function () {
    if (!isNumber(delay) || delay < 0) return;

    if (immediate) {
      fnRef.current();
    }

    timerRef.current = setRafInterval(function () {
      fnRef.current();
    }, delay);
    return function () {
      if (timerRef.current) {
        clearRafInterval(timerRef.current);
      }
    };
  }, [delay]);
  var clear = Object(external_react_["useCallback"])(function () {
    if (timerRef.current) {
      clearRafInterval(timerRef.current);
    }
  }, []);
  return clear;
}

/* harmony default export */ var es_useRafInterval = (useRafInterval);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useRafTimeout/index.js




var setRafTimeout = function setRafTimeout(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  if (typeof requestAnimationFrame === typeof undefined) {
    return {
      id: setTimeout(callback, delay)
    };
  }

  var handle = {
    id: 0
  };
  var startTime = new Date().getTime();

  var loop = function loop() {
    var current = new Date().getTime();

    if (current - startTime >= delay) {
      callback();
    } else {
      handle.id = requestAnimationFrame(loop);
    }
  };

  handle.id = requestAnimationFrame(loop);
  return handle;
};

function useRafTimeout_cancelAnimationFrameIsNotDefined(t) {
  return typeof cancelAnimationFrame === typeof undefined;
}

var clearRafTimeout = function clearRafTimeout(handle) {
  if (useRafTimeout_cancelAnimationFrameIsNotDefined(handle.id)) {
    return clearTimeout(handle.id);
  }

  cancelAnimationFrame(handle.id);
};

function useRafTimeout(fn, delay) {
  var fnRef = es_useLatest(fn);
  var timerRef = Object(external_react_["useRef"])();
  Object(external_react_["useEffect"])(function () {
    if (!isNumber(delay) || delay < 0) return;
    timerRef.current = setRafTimeout(function () {
      fnRef.current();
    }, delay);
    return function () {
      if (timerRef.current) {
        clearRafTimeout(timerRef.current);
      }
    };
  }, [delay]);
  var clear = Object(external_react_["useCallback"])(function () {
    if (timerRef.current) {
      clearRafTimeout(timerRef.current);
    }
  }, []);
  return clear;
}

/* harmony default export */ var es_useRafTimeout = (useRafTimeout);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useReactive/index.js



 // k:v 原对象:代理过的对象

var proxyMap = new WeakMap(); // k:v 代理过的对象:原对象

var rawMap = new WeakMap();

function useReactive_observer(initialVal, cb) {
  var existingProxy = proxyMap.get(initialVal); // 添加缓存 防止重新构建proxy

  if (existingProxy) {
    return existingProxy;
  } // 防止代理已经代理过的对象
  // https://github.com/alibaba/hooks/issues/839


  if (rawMap.has(initialVal)) {
    return initialVal;
  }

  var proxy = new Proxy(initialVal, {
    get: function get(target, key, receiver) {
      var res = Reflect.get(target, key, receiver);
      return isObject(res) ? useReactive_observer(res, cb) : Reflect.get(target, key);
    },
    set: function set(target, key, val) {
      var ret = Reflect.set(target, key, val);
      cb();
      return ret;
    },
    deleteProperty: function deleteProperty(target, key) {
      var ret = Reflect.deleteProperty(target, key);
      cb();
      return ret;
    }
  });
  proxyMap.set(initialVal, proxy);
  rawMap.set(proxy, initialVal);
  return proxy;
}

function useReactive(initialState) {
  var update = es_useUpdate();
  var stateRef = Object(external_react_["useRef"])(initialState);
  var state = useCreation(function () {
    return useReactive_observer(stateRef.current, function () {
      update();
    });
  }, []);
  return state;
}

/* harmony default export */ var es_useReactive = (useReactive);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useResetState/index.js
var useResetState_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




var useResetState_useResetState = function useResetState(initialState) {
  var _a = useResetState_read(Object(external_react_["useState"])(initialState), 2),
      state = _a[0],
      setState = _a[1];

  var resetState = es_useMemoizedFn(function () {
    setState(initialState);
  });
  return [state, setState, resetState];
};

/* harmony default export */ var es_useResetState = (useResetState_useResetState);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useResponsive/index.js
var useResponsive_values = undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var useResponsive_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



var subscribers = new Set();
var info;
var responsiveConfig = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};

function handleResize() {
  var e_1, _a;

  var oldInfo = info;
  calculate();
  if (oldInfo === info) return;

  try {
    for (var subscribers_1 = useResponsive_values(subscribers), subscribers_1_1 = subscribers_1.next(); !subscribers_1_1.done; subscribers_1_1 = subscribers_1.next()) {
      var subscriber = subscribers_1_1.value;
      subscriber();
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (subscribers_1_1 && !subscribers_1_1.done && (_a = subscribers_1["return"])) _a.call(subscribers_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}

var listening = false;

function calculate() {
  var e_2, _a;

  var width = window.innerWidth;
  var newInfo = {};
  var shouldUpdate = false;

  try {
    for (var _b = useResponsive_values(Object.keys(responsiveConfig)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      newInfo[key] = width >= responsiveConfig[key];

      if (newInfo[key] !== info[key]) {
        shouldUpdate = true;
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  if (shouldUpdate) {
    info = newInfo;
  }
}

function configResponsive(config) {
  responsiveConfig = config;
  if (info) calculate();
}
function useResponsive() {
  if (utils_isBrowser && !listening) {
    info = {};
    calculate();
    window.addEventListener('resize', handleResize);
    listening = true;
  }

  var _a = useResponsive_read(Object(external_react_["useState"])(info), 2),
      state = _a[0],
      setState = _a[1];

  Object(external_react_["useEffect"])(function () {
    if (!utils_isBrowser) return;

    var subscriber = function subscriber() {
      setState(info);
    };

    subscribers.add(subscriber);
    return function () {
      subscribers["delete"](subscriber);

      if (subscribers.size === 0) {
        window.removeEventListener('resize', handleResize);
        listening = false;
      }
    };
  }, []);
  return state;
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useUnmountedRef/index.js


var useUnmountedRef_useUnmountedRef = function useUnmountedRef() {
  var unmountedRef = Object(external_react_["useRef"])(false);
  Object(external_react_["useEffect"])(function () {
    unmountedRef.current = false;
    return function () {
      unmountedRef.current = true;
    };
  }, []);
  return unmountedRef;
};

/* harmony default export */ var es_useUnmountedRef = (useUnmountedRef_useUnmountedRef);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useSafeState/index.js
var useSafeState_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




function useSafeState(initialState) {
  var unmountedRef = es_useUnmountedRef();

  var _a = useSafeState_read(Object(external_react_["useState"])(initialState), 2),
      state = _a[0],
      setState = _a[1];

  var setCurrentState = Object(external_react_["useCallback"])(function (currentState) {
    /** if component is unmounted, stop update */
    if (unmountedRef.current) return;
    setState(currentState);
  }, []);
  return [state, setCurrentState];
}

/* harmony default export */ var es_useSafeState = (useSafeState);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useScroll/index.js
var useScroll_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};






function useScroll(target, shouldUpdate) {
  if (shouldUpdate === void 0) {
    shouldUpdate = function shouldUpdate() {
      return true;
    };
  }

  var _a = useScroll_read(es_useRafState(), 2),
      position = _a[0],
      setPosition = _a[1];

  var shouldUpdateRef = es_useLatest(shouldUpdate);
  utils_useEffectWithTarget(function () {
    var el = getTargetElement(target, document);

    if (!el) {
      return;
    }

    var updatePosition = function updatePosition() {
      var newPosition;

      if (el === document) {
        if (document.scrollingElement) {
          newPosition = {
            left: document.scrollingElement.scrollLeft,
            top: document.scrollingElement.scrollTop
          };
        } else {
          // When in quirks mode, the scrollingElement attribute returns the HTML body element if it exists and is potentially scrollable, otherwise it returns null.
          // https://developer.mozilla.org/zh-CN/docs/Web/API/Document/scrollingElement
          // https://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
          newPosition = {
            left: Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
            top: Math.max(window.pageXOffset, document.documentElement.scrollLeft, document.body.scrollLeft)
          };
        }
      } else {
        newPosition = {
          left: el.scrollLeft,
          top: el.scrollTop
        };
      }

      if (shouldUpdateRef.current(newPosition)) {
        setPosition(newPosition);
      }
    };

    updatePosition();
    el.addEventListener('scroll', updatePosition);
    return function () {
      el.removeEventListener('scroll', updatePosition);
    };
  }, [], target);
  return position;
}

/* harmony default export */ var es_useScroll = (useScroll);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useSelections/index.js
var useSelections_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};



function useSelections(items, defaultSelected) {
  if (defaultSelected === void 0) {
    defaultSelected = [];
  }

  var _a = useSelections_read(Object(external_react_["useState"])(defaultSelected), 2),
      selected = _a[0],
      setSelected = _a[1];

  var selectedSet = Object(external_react_["useMemo"])(function () {
    return new Set(selected);
  }, [selected]);

  var isSelected = function isSelected(item) {
    return selectedSet.has(item);
  };

  var select = function select(item) {
    selectedSet.add(item);
    return setSelected(Array.from(selectedSet));
  };

  var unSelect = function unSelect(item) {
    selectedSet["delete"](item);
    return setSelected(Array.from(selectedSet));
  };

  var toggle = function toggle(item) {
    if (isSelected(item)) {
      unSelect(item);
    } else {
      select(item);
    }
  };

  var selectAll = function selectAll() {
    items.forEach(function (o) {
      selectedSet.add(o);
    });
    setSelected(Array.from(selectedSet));
  };

  var unSelectAll = function unSelectAll() {
    items.forEach(function (o) {
      selectedSet["delete"](o);
    });
    setSelected(Array.from(selectedSet));
  };

  var noneSelected = Object(external_react_["useMemo"])(function () {
    return items.every(function (o) {
      return !selectedSet.has(o);
    });
  }, [items, selectedSet]);
  var allSelected = Object(external_react_["useMemo"])(function () {
    return items.every(function (o) {
      return selectedSet.has(o);
    }) && !noneSelected;
  }, [items, selectedSet, noneSelected]);
  var partiallySelected = Object(external_react_["useMemo"])(function () {
    return !noneSelected && !allSelected;
  }, [noneSelected, allSelected]);

  var toggleAll = function toggleAll() {
    return allSelected ? unSelectAll() : selectAll();
  };

  return {
    selected: selected,
    noneSelected: noneSelected,
    allSelected: allSelected,
    partiallySelected: partiallySelected,
    setSelected: setSelected,
    isSelected: isSelected,
    select: es_useMemoizedFn(select),
    unSelect: es_useMemoizedFn(unSelect),
    toggle: es_useMemoizedFn(toggle),
    selectAll: es_useMemoizedFn(selectAll),
    unSelectAll: es_useMemoizedFn(unSelectAll),
    toggleAll: es_useMemoizedFn(toggleAll)
  };
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useSessionStorageState/index.js


var useSessionStorageState = createUseStorageState(function () {
  return utils_isBrowser ? sessionStorage : undefined;
});
/* harmony default export */ var es_useSessionStorageState = (useSessionStorageState);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useSet/index.js
var useSet_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




function useSet(initialValue) {
  var getInitValue = function getInitValue() {
    return initialValue === undefined ? new Set() : new Set(initialValue);
  };

  var _a = useSet_read(Object(external_react_["useState"])(function () {
    return getInitValue();
  }), 2),
      set = _a[0],
      setSet = _a[1];

  var add = function add(key) {
    if (set.has(key)) {
      return;
    }

    setSet(function (prevSet) {
      var temp = new Set(prevSet);
      temp.add(key);
      return temp;
    });
  };

  var remove = function remove(key) {
    if (!set.has(key)) {
      return;
    }

    setSet(function (prevSet) {
      var temp = new Set(prevSet);
      temp["delete"](key);
      return temp;
    });
  };

  var reset = function reset() {
    return setSet(getInitValue());
  };

  return [set, {
    add: es_useMemoizedFn(add),
    remove: es_useMemoizedFn(remove),
    reset: es_useMemoizedFn(reset)
  }];
}

/* harmony default export */ var es_useSet = (useSet);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useSetState/index.js
var useSetState_assign = undefined && undefined.__assign || function () {
  useSetState_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useSetState_assign.apply(this, arguments);
};

var useSetState_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




var useSetState_useSetState = function useSetState(initialState) {
  var _a = useSetState_read(Object(external_react_["useState"])(initialState), 2),
      state = _a[0],
      setState = _a[1];

  var setMergeState = Object(external_react_["useCallback"])(function (patch) {
    setState(function (prevState) {
      var newState = isFunction(patch) ? patch(prevState) : patch;
      return newState ? useSetState_assign(useSetState_assign({}, prevState), newState) : prevState;
    });
  }, []);
  return [state, setMergeState];
};

/* harmony default export */ var es_useSetState = (useSetState_useSetState);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(91);

// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/useLayoutEffectWithTarget.js


var useLayoutEffectWithTarget_useEffectWithTarget = utils_createEffectWithTarget(external_react_["useLayoutEffect"]);
/* harmony default export */ var useLayoutEffectWithTarget = (useLayoutEffectWithTarget_useEffectWithTarget);
// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/useIsomorphicLayoutEffectWithTarget.js



var useIsomorphicLayoutEffectWithTarget = utils_isBrowser ? useLayoutEffectWithTarget : utils_useEffectWithTarget;
/* harmony default export */ var utils_useIsomorphicLayoutEffectWithTarget = (useIsomorphicLayoutEffectWithTarget);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useSize/index.js
var useSize_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};






function useSize(target) {
  var _a = useSize_read(es_useRafState(), 2),
      state = _a[0],
      setState = _a[1];

  utils_useIsomorphicLayoutEffectWithTarget(function () {
    var el = getTargetElement(target);

    if (!el) {
      return;
    }

    var resizeObserver = new ResizeObserver_es["a" /* default */](function (entries) {
      entries.forEach(function (entry) {
        var _a = entry.target,
            clientWidth = _a.clientWidth,
            clientHeight = _a.clientHeight;
        setState({
          width: clientWidth,
          height: clientHeight
        });
      });
    });
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
    };
  }, [], target);
  return state;
}

/* harmony default export */ var es_useSize = (useSize);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useTextSelection/index.js
var useTextSelection_assign = undefined && undefined.__assign || function () {
  useTextSelection_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useTextSelection_assign.apply(this, arguments);
};

var useTextSelection_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




var initRect = {
  top: NaN,
  left: NaN,
  bottom: NaN,
  right: NaN,
  height: NaN,
  width: NaN
};

var useTextSelection_initState = useTextSelection_assign({
  text: ''
}, initRect);

function getRectFromSelection(selection) {
  if (!selection) {
    return initRect;
  }

  if (selection.rangeCount < 1) {
    return initRect;
  }

  var range = selection.getRangeAt(0);

  var _a = range.getBoundingClientRect(),
      height = _a.height,
      width = _a.width,
      top = _a.top,
      left = _a.left,
      right = _a.right,
      bottom = _a.bottom;

  return {
    height: height,
    width: width,
    top: top,
    left: left,
    right: right,
    bottom: bottom
  };
}

function useTextSelection(target) {
  var _a = useTextSelection_read(Object(external_react_["useState"])(useTextSelection_initState), 2),
      state = _a[0],
      setState = _a[1];

  var stateRef = Object(external_react_["useRef"])(state);
  stateRef.current = state;
  utils_useEffectWithTarget(function () {
    var el = getTargetElement(target, document);

    if (!el) {
      return;
    }

    var mouseupHandler = function mouseupHandler() {
      var selObj = null;
      var text = '';
      var rect = initRect;
      if (!window.getSelection) return;
      selObj = window.getSelection();
      text = selObj ? selObj.toString() : '';

      if (text) {
        rect = getRectFromSelection(selObj);
        setState(useTextSelection_assign(useTextSelection_assign(useTextSelection_assign({}, state), {
          text: text
        }), rect));
      }
    }; // 任意点击都需要清空之前的 range


    var mousedownHandler = function mousedownHandler() {
      if (!window.getSelection) return;

      if (stateRef.current.text) {
        setState(useTextSelection_assign({}, useTextSelection_initState));
      }

      var selObj = window.getSelection();
      if (!selObj) return;
      selObj.removeAllRanges();
    };

    el.addEventListener('mouseup', mouseupHandler);
    document.addEventListener('mousedown', mousedownHandler);
    return function () {
      el.removeEventListener('mouseup', mouseupHandler);
      document.removeEventListener('mousedown', mousedownHandler);
    };
  }, [], target);
  return state;
}

/* harmony default export */ var es_useTextSelection = (useTextSelection);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useThrottleFn/index.js
var useThrottleFn_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var useThrottleFn_spread = undefined && undefined.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(useThrottleFn_read(arguments[i]));
  }

  return ar;
};







function useThrottleFn(fn, options) {
  var _a;

  if (false) {}

  var fnRef = es_useLatest(fn);
  var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
  var throttled = Object(external_react_["useMemo"])(function () {
    return throttle_default()(function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return fnRef.current.apply(fnRef, useThrottleFn_spread(args));
    }, wait, options);
  }, []);
  es_useUnmount(function () {
    throttled.cancel();
  });
  return {
    run: throttled,
    cancel: throttled.cancel,
    flush: throttled.flush
  };
}

/* harmony default export */ var es_useThrottleFn = (useThrottleFn);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useThrottle/index.js
var useThrottle_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};




function useThrottle(value, options) {
  var _a = useThrottle_read(Object(external_react_["useState"])(value), 2),
      throttled = _a[0],
      setThrottled = _a[1];

  var run = es_useThrottleFn(function () {
    setThrottled(value);
  }, options).run;
  Object(external_react_["useEffect"])(function () {
    run();
  }, [value]);
  return throttled;
}

/* harmony default export */ var es_useThrottle = (useThrottle);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useThrottleEffect/index.js
var useThrottleEffect_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};





function useThrottleEffect(effect, deps, options) {
  var _a = useThrottleEffect_read(Object(external_react_["useState"])({}), 2),
      flag = _a[0],
      setFlag = _a[1];

  var run = es_useThrottleFn(function () {
    setFlag({});
  }, options).run;
  Object(external_react_["useEffect"])(function () {
    return run();
  }, deps);
  useUpdateEffect(effect, [flag]);
}

/* harmony default export */ var es_useThrottleEffect = (useThrottleEffect);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useTimeout/index.js




function useTimeout(fn, delay) {
  var fnRef = es_useLatest(fn);
  var timerRef = Object(external_react_["useRef"])();
  Object(external_react_["useEffect"])(function () {
    if (!isNumber(delay) || delay < 0) return;
    timerRef.current = setTimeout(function () {
      fnRef.current();
    }, delay);
    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [delay]);
  var clear = Object(external_react_["useCallback"])(function () {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);
  return clear;
}

/* harmony default export */ var es_useTimeout = (useTimeout);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useTitle/index.js



var DEFAULT_OPTIONS = {
  restoreOnUnmount: false
};

function useTitle(title, options) {
  if (options === void 0) {
    options = DEFAULT_OPTIONS;
  }

  var titleRef = Object(external_react_["useRef"])(utils_isBrowser ? document.title : '');
  Object(external_react_["useEffect"])(function () {
    document.title = title;
  }, [title]);
  es_useUnmount(function () {
    if (options.restoreOnUnmount) {
      document.title = titleRef.current;
    }
  });
}

/* harmony default export */ var es_useTitle = (useTitle);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useTrackedEffect/index.js


var diffTwoDeps = function diffTwoDeps(deps1, deps2) {
  //Let's do a reference equality check on 2 dependency list.
  //If deps1 is defined, we iterate over deps1 and do comparison on each element with equivalent element from deps2
  //As this func is used only in this hook, we assume 2 deps always have same length.
  return deps1 ? deps1.map(function (_ele, idx) {
    return !Object.is(deps1[idx], deps2 === null || deps2 === void 0 ? void 0 : deps2[idx]) ? idx : -1;
  }).filter(function (ele) {
    return ele >= 0;
  }) : deps2 ? deps2.map(function (_ele, idx) {
    return idx;
  }) : [];
};

var useTrackedEffect_useTrackedEffect = function useTrackedEffect(effect, deps) {
  var previousDepsRef = Object(external_react_["useRef"])();
  Object(external_react_["useEffect"])(function () {
    var changes = diffTwoDeps(previousDepsRef.current, deps);
    var previousDeps = previousDepsRef.current;
    previousDepsRef.current = deps;
    return effect(changes, previousDeps, deps);
  }, deps);
};

/* harmony default export */ var es_useTrackedEffect = (useTrackedEffect_useTrackedEffect);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useUpdateLayoutEffect/index.js


/* harmony default export */ var useUpdateLayoutEffect = (createUpdateEffect_createUpdateEffect(external_react_["useLayoutEffect"]));
// CONCATENATED MODULE: ./node_modules/ahooks/es/useVirtualList/index.js
var useVirtualList_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};









var useVirtualList_useVirtualList = function useVirtualList(list, options) {
  var containerTarget = options.containerTarget,
      wrapperTarget = options.wrapperTarget,
      itemHeight = options.itemHeight,
      _a = options.overscan,
      overscan = _a === void 0 ? 5 : _a;
  var itemHeightRef = es_useLatest(itemHeight);
  var size = es_useSize(containerTarget);
  var scrollTriggerByScrollToFunc = Object(external_react_["useRef"])(false);

  var _b = useVirtualList_read(Object(external_react_["useState"])([]), 2),
      targetList = _b[0],
      setTargetList = _b[1];

  var getVisibleCount = function getVisibleCount(containerHeight, fromIndex) {
    if (isNumber(itemHeightRef.current)) {
      return Math.ceil(containerHeight / itemHeightRef.current);
    }

    var sum = 0;
    var endIndex = 0;

    for (var i = fromIndex; i < list.length; i++) {
      var height = itemHeightRef.current(i, list[i]);
      sum += height;
      endIndex = i;

      if (sum >= containerHeight) {
        break;
      }
    }

    return endIndex - fromIndex;
  };

  var getOffset = function getOffset(scrollTop) {
    if (isNumber(itemHeightRef.current)) {
      return Math.floor(scrollTop / itemHeightRef.current) + 1;
    }

    var sum = 0;
    var offset = 0;

    for (var i = 0; i < list.length; i++) {
      var height = itemHeightRef.current(i, list[i]);
      sum += height;

      if (sum >= scrollTop) {
        offset = i;
        break;
      }
    }

    return offset + 1;
  }; // 获取上部高度


  var getDistanceTop = function getDistanceTop(index) {
    if (isNumber(itemHeightRef.current)) {
      var height_1 = index * itemHeightRef.current;
      return height_1;
    }

    var height = list.slice(0, index).reduce(function (sum, _, i) {
      return sum + itemHeightRef.current(i, list[i]);
    }, 0);
    return height;
  };

  var totalHeight = Object(external_react_["useMemo"])(function () {
    if (isNumber(itemHeightRef.current)) {
      return list.length * itemHeightRef.current;
    }

    return list.reduce(function (sum, _, index) {
      return sum + itemHeightRef.current(index, list[index]);
    }, 0);
  }, [list]);

  var calculateRange = function calculateRange() {
    var container = getTargetElement(containerTarget);
    var wrapper = getTargetElement(wrapperTarget);

    if (container && wrapper) {
      var scrollTop = container.scrollTop,
          clientHeight = container.clientHeight;
      var offset = getOffset(scrollTop);
      var visibleCount = getVisibleCount(clientHeight, offset);
      var start_1 = Math.max(0, offset - overscan);
      var end = Math.min(list.length, offset + visibleCount + overscan);
      var offsetTop = getDistanceTop(start_1);
      wrapper.style.height = totalHeight - offsetTop + 'px';
      wrapper.style.marginTop = offsetTop + 'px';
      setTargetList(list.slice(start_1, end).map(function (ele, index) {
        return {
          data: ele,
          index: index + start_1
        };
      }));
    }
  };

  Object(external_react_["useEffect"])(function () {
    if (!(size === null || size === void 0 ? void 0 : size.width) || !(size === null || size === void 0 ? void 0 : size.height)) {
      return;
    }

    calculateRange();
  }, [size === null || size === void 0 ? void 0 : size.width, size === null || size === void 0 ? void 0 : size.height, list]);
  es_useEventListener('scroll', function (e) {
    if (scrollTriggerByScrollToFunc.current) {
      scrollTriggerByScrollToFunc.current = false;
      return;
    }

    e.preventDefault();
    calculateRange();
  }, {
    target: containerTarget
  });

  var scrollTo = function scrollTo(index) {
    var container = getTargetElement(containerTarget);

    if (container) {
      scrollTriggerByScrollToFunc.current = true;
      container.scrollTop = getDistanceTop(index);
      calculateRange();
    }
  };

  return [targetList, es_useMemoizedFn(scrollTo)];
};

/* harmony default export */ var es_useVirtualList = (useVirtualList_useVirtualList);
// CONCATENATED MODULE: ./node_modules/ahooks/es/useWebSocket/index.js
var useWebSocket_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};





var ReadyState;

(function (ReadyState) {
  ReadyState[ReadyState["Connecting"] = 0] = "Connecting";
  ReadyState[ReadyState["Open"] = 1] = "Open";
  ReadyState[ReadyState["Closing"] = 2] = "Closing";
  ReadyState[ReadyState["Closed"] = 3] = "Closed";
})(ReadyState || (ReadyState = {}));

function useWebSocket(socketUrl, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.reconnectLimit,
      reconnectLimit = _a === void 0 ? 3 : _a,
      _b = options.reconnectInterval,
      reconnectInterval = _b === void 0 ? 3 * 1000 : _b,
      _c = options.manual,
      manual = _c === void 0 ? false : _c,
      onOpen = options.onOpen,
      onClose = options.onClose,
      onMessage = options.onMessage,
      onError = options.onError,
      protocols = options.protocols;
  var onOpenRef = es_useLatest(onOpen);
  var onCloseRef = es_useLatest(onClose);
  var onMessageRef = es_useLatest(onMessage);
  var onErrorRef = es_useLatest(onError);
  var reconnectTimesRef = Object(external_react_["useRef"])(0);
  var reconnectTimerRef = Object(external_react_["useRef"])();
  var websocketRef = Object(external_react_["useRef"])();
  var unmountedRef = Object(external_react_["useRef"])(false);

  var _d = useWebSocket_read(Object(external_react_["useState"])(), 2),
      latestMessage = _d[0],
      setLatestMessage = _d[1];

  var _e = useWebSocket_read(Object(external_react_["useState"])(ReadyState.Closed), 2),
      readyState = _e[0],
      setReadyState = _e[1];

  var reconnect = function reconnect() {
    var _a;

    if (reconnectTimesRef.current < reconnectLimit && ((_a = websocketRef.current) === null || _a === void 0 ? void 0 : _a.readyState) !== ReadyState.Open) {
      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
      }

      reconnectTimerRef.current = setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        connectWs();
        reconnectTimesRef.current++;
      }, reconnectInterval);
    }
  };

  var connectWs = function connectWs() {
    if (reconnectTimerRef.current) {
      clearTimeout(reconnectTimerRef.current);
    }

    if (websocketRef.current) {
      websocketRef.current.close();
    }

    var ws = new WebSocket(socketUrl, protocols);
    setReadyState(ReadyState.Connecting);

    ws.onerror = function (event) {
      var _a;

      if (unmountedRef.current) {
        return;
      }

      reconnect();
      (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, event, ws);
      setReadyState(ws.readyState || ReadyState.Closed);
    };

    ws.onopen = function (event) {
      var _a;

      if (unmountedRef.current) {
        return;
      }

      (_a = onOpenRef.current) === null || _a === void 0 ? void 0 : _a.call(onOpenRef, event, ws);
      reconnectTimesRef.current = 0;
      setReadyState(ws.readyState || ReadyState.Open);
    };

    ws.onmessage = function (message) {
      var _a;

      if (unmountedRef.current) {
        return;
      }

      (_a = onMessageRef.current) === null || _a === void 0 ? void 0 : _a.call(onMessageRef, message, ws);
      setLatestMessage(message);
    };

    ws.onclose = function (event) {
      var _a;

      if (unmountedRef.current) {
        return;
      }

      reconnect();
      (_a = onCloseRef.current) === null || _a === void 0 ? void 0 : _a.call(onCloseRef, event, ws);
      setReadyState(ws.readyState || ReadyState.Closed);
    };

    websocketRef.current = ws;
  };

  var sendMessage = function sendMessage(message) {
    var _a;

    if (readyState === ReadyState.Open) {
      (_a = websocketRef.current) === null || _a === void 0 ? void 0 : _a.send(message);
    } else {
      throw new Error('WebSocket disconnected');
    }
  };

  var connect = function connect() {
    reconnectTimesRef.current = 0;
    connectWs();
  };

  var disconnect = function disconnect() {
    var _a;

    if (reconnectTimerRef.current) {
      clearTimeout(reconnectTimerRef.current);
    }

    reconnectTimesRef.current = reconnectLimit;
    (_a = websocketRef.current) === null || _a === void 0 ? void 0 : _a.close();
  };

  Object(external_react_["useEffect"])(function () {
    if (!manual) {
      connect();
    }
  }, [socketUrl, manual]);
  es_useUnmount(function () {
    unmountedRef.current = true;
    disconnect();
  });
  return {
    latestMessage: latestMessage,
    sendMessage: es_useMemoizedFn(sendMessage),
    connect: es_useMemoizedFn(connect),
    disconnect: es_useMemoizedFn(disconnect),
    readyState: readyState,
    webSocketIns: websocketRef.current
  };
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useWhyDidYouUpdate/index.js
var useWhyDidYouUpdate_assign = undefined && undefined.__assign || function () {
  useWhyDidYouUpdate_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return useWhyDidYouUpdate_assign.apply(this, arguments);
};


function useWhyDidYouUpdate(componentName, props) {
  var prevProps = Object(external_react_["useRef"])({});
  Object(external_react_["useEffect"])(function () {
    if (prevProps.current) {
      var allKeys = Object.keys(useWhyDidYouUpdate_assign(useWhyDidYouUpdate_assign({}, prevProps.current), props));
      var changedProps_1 = {};
      allKeys.forEach(function (key) {
        if (!Object.is(prevProps.current[key], props[key])) {
          changedProps_1[key] = {
            from: prevProps.current[key],
            to: props[key]
          };
        }
      });

      if (Object.keys(changedProps_1).length) {
        console.log('[why-did-you-update]', componentName, changedProps_1);
      }
    }

    prevProps.current = props;
  });
}
// CONCATENATED MODULE: ./node_modules/ahooks/es/useMutationObserver/index.js




var useMutationObserver_useMutationObserver = function useMutationObserver(callback, target, options) {
  if (options === void 0) {
    options = {};
  }

  var callbackRef = es_useLatest(callback);
  useDeepCompareWithTarget(function () {
    var element = getTargetElement(target);

    if (!element) {
      return;
    }

    var observer = new MutationObserver(callbackRef.current);
    observer.observe(element, options);
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [options], target);
};

/* harmony default export */ var es_useMutationObserver = (useMutationObserver_useMutationObserver);
// CONCATENATED MODULE: ./node_modules/ahooks/es/index.js















































































/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAniNav = void 0;
var react_1 = __webpack_require__(0);
var throttle_1 = __importDefault(__webpack_require__(238));
var raf_1 = __webpack_require__(65);
// 绑定一次事件
function bindOnce(el, name, callback) {
    var rCallback = function (event) {
        unbind();
        callback(event);
    };
    var unbind = function () {
        el.removeEventListener(name, rCallback);
    };
    el.addEventListener(name, rCallback, false);
    return unbind;
}
function useAniNav() {
    // activebar 样式
    var _a = (0, react_1.useState)(0), barLeft = _a[0], setBarLeft = _a[1];
    var _b = (0, react_1.useState)(0), barWidth = _b[0], setBarWidth = _b[1];
    // activebar 动画执行
    var _c = (0, react_1.useState)(false), isAni = _c[0], setIsAni = _c[1];
    // 导航状态
    var _d = (0, react_1.useState)(false), isHover = _d[0], setIsHover = _d[1];
    // 导航hover状态，下拉动画禁止
    var _e = (0, react_1.useState)(false), disableContentInAni = _e[0], setdisableContentInAni = _e[1];
    var _f = (0, react_1.useState)(null), el = _f[0], setEl = _f[1];
    var _g = (0, react_1.useState)(null), bar = _g[0], setBar = _g[1];
    function mouseenter() {
        if (el.canMove) {
            return;
        }
        el.canMove = true;
        // 设置hover状态
        setIsHover(true);
        // 第一次展开动画后，开启禁用动画状态
        bindContentAnimationEnd(function () {
            setdisableContentInAni(true);
        });
    }
    function mouseleave() {
        if (!el.canMove) {
            return;
        }
        el.canMove = false;
        bar &&
            bindOnce(bar, 'transitionend', function () {
                setIsAni(false);
                bar.barAni = false;
            });
        setBarWidth(0);
        // 关闭禁用动画状态
        setdisableContentInAni(false);
        // 关闭hover状态
        setIsHover(false);
    }
    // 查找对应target
    var findTarget = function (el) {
        var target = null;
        var tmp = el;
        while (tmp) {
            if (tmp && !tmp.getAttribute) {
                console.log(tmp);
            }
            if ((tmp.dataset && tmp.dataset['ani'] === 'linkage') ||
                (tmp && tmp.getAttribute('data-ani') === 'linkage')) {
                target = tmp;
                break;
            }
            else {
                if (tmp.parentNode === document.body) {
                    break;
                }
                tmp = tmp.parentNode;
            }
        }
        return target;
    };
    var mousemove = (0, throttle_1.default)(100, function (event) {
        if (el.canMove) {
            // 获取鼠标当前位置是否在目标target上
            var target = findTarget(event.target);
            if (target) {
                // 计算相对位置
                var targetInfo = target.getBoundingClientRect();
                var elInfo = el.getBoundingClientRect();
                var left = targetInfo.left - elInfo.left;
                var width_1 = targetInfo.width;
                if (!bar.barAni) {
                    setBarLeft(left);
                    (0, raf_1.raf)(function () {
                        setIsAni(true);
                        bar.barAni = true;
                        setBarWidth(width_1);
                    });
                }
                else {
                    setBarLeft(left);
                    setBarWidth(width_1);
                }
            }
            else if (!el.contains(event.target)) {
                mouseleave();
            }
        }
    });
    var aniArr = null;
    // 绑定下拉内容动画回调
    function bindContentAnimationEnd(callback) {
        destroyBindContentAnimationEnd();
        var arr = el.querySelectorAll('.hbg-dropdown-v2__content > div, .hb-dropdown__content > div');
        aniArr = Array.prototype.slice.call(arr).map(function (item) {
            return bindOnce(item, 'animationend', function () {
                destroyBindContentAnimationEnd();
                callback();
            });
        });
    }
    // 删除下拉内容动画回调
    function destroyBindContentAnimationEnd() {
        aniArr &&
            aniArr.forEach(function (item) {
                item();
            });
        aniArr = null;
    }
    var destroy = function () {
        if (el) {
            el.removeEventListener('mouseenter', mouseenter, false);
            el.removeEventListener('mouseleave', mouseleave, false);
            document.body.removeEventListener('mousemove', mousemove);
        }
    };
    (0, react_1.useEffect)(function () {
        if (el) {
            destroy();
            el.addEventListener('mouseenter', mouseenter, false);
            el.addEventListener('mouseleave', mouseleave, false);
            document.body.addEventListener('mousemove', mousemove);
        }
    }, [el]);
    return { isHover: isHover, isAni: isAni, barLeft: barLeft, barWidth: barWidth, disableContentInAni: disableContentInAni, setEl: setEl, setBar: setBar, destroy: destroy };
}
exports.useAniNav = useAniNav;


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
 /* harmony default export */ __webpack_exports__["default"] = (function (delay, callback, options) {
	const {
		noTrailing = false,
		noLeading = false,
		debounceMode = undefined
	} = options || {};
	/*
	 * After wrapper has stopped being called, this timeout ensures that
	 * `callback` is executed at the proper times in `throttle` and `end`
	 * debounce modes.
	 */
	let timeoutID;
	let cancelled = false;

	// Keep track of the last time `callback` was executed.
	let lastExec = 0;

	// Function to clear existing timeout
	function clearExistingTimeout() {
		if (timeoutID) {
			clearTimeout(timeoutID);
		}
	}

	// Function to cancel next exec
	function cancel(options) {
		const { upcomingOnly = false } = options || {};
		clearExistingTimeout();
		cancelled = !upcomingOnly;
	}

	/*
	 * The `wrapper` function encapsulates all of the throttling / debouncing
	 * functionality and when executed will limit the rate at which `callback`
	 * is executed.
	 */
	function wrapper(...arguments_) {
		let self = this;
		let elapsed = Date.now() - lastExec;

		if (cancelled) {
			return;
		}

		// Execute `callback` and update the `lastExec` timestamp.
		function exec() {
			lastExec = Date.now();
			callback.apply(self, arguments_);
		}

		/*
		 * If `debounceMode` is true (at begin) this is used to clear the flag
		 * to allow future `callback` executions.
		 */
		function clear() {
			timeoutID = undefined;
		}

		if (!noLeading && debounceMode && !timeoutID) {
			/*
			 * Since `wrapper` is being called for the first time and
			 * `debounceMode` is true (at begin), execute `callback`
			 * and noLeading != true.
			 */
			exec();
		}

		clearExistingTimeout();

		if (debounceMode === undefined && elapsed > delay) {
			if (noLeading) {
				/*
				 * In throttle mode with noLeading, if `delay` time has
				 * been exceeded, update `lastExec` and schedule `callback`
				 * to execute after `delay` ms.
				 */
				lastExec = Date.now();
				if (!noTrailing) {
					timeoutID = setTimeout(debounceMode ? clear : exec, delay);
				}
			} else {
				/*
				 * In throttle mode without noLeading, if `delay` time has been exceeded, execute
				 * `callback`.
				 */
				exec();
			}
		} else if (noTrailing !== true) {
			/*
			 * In trailing throttle mode, since `delay` time has not been
			 * exceeded, schedule `callback` to execute `delay` ms after most
			 * recent execution.
			 *
			 * If `debounceMode` is true (at begin), schedule `clear` to execute
			 * after `delay` ms.
			 *
			 * If `debounceMode` is false (at end), schedule `callback` to
			 * execute after `delay` ms.
			 */
			timeoutID = setTimeout(
				debounceMode ? clear : exec,
				debounceMode === undefined ? delay - elapsed : delay
			);
		}
	}

	wrapper.cancel = cancel;

	// Return the wrapper function.
	return wrapper;
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(145).EventEmitter;
var inherits = __webpack_require__(61);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(146);
Stream.Writable = __webpack_require__(352);
Stream.Duplex = __webpack_require__(353);
Stream.Transform = __webpack_require__(354);
Stream.PassThrough = __webpack_require__(355);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(98);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(94);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(145).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(241);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(147).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(78));
util.inherits = __webpack_require__(61);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(345);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(346);
var destroyImpl = __webpack_require__(242);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(49);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(244).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(49);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(244).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16), __webpack_require__(25)))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(145).EventEmitter;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(98);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(348);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(350).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(49);

/*<replacement>*/
var util = Object.create(__webpack_require__(78));
util.inherits = __webpack_require__(61);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var objectAssign = __webpack_require__(363);

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(247);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(364);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(365);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25)))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var i18n_1 = __webpack_require__(14);
var loading_1 = __importDefault(__webpack_require__(62));
var no_content_1 = __importDefault(__webpack_require__(37));
var spot_1 = __importDefault(__webpack_require__(251));
var swap_1 = __importDefault(__webpack_require__(406));
var fun_1 = __importDefault(__webpack_require__(407));
var earn_1 = __importDefault(__webpack_require__(408));
var news_1 = __importDefault(__webpack_require__(409));
var notice_1 = __importDefault(__webpack_require__(410));
var live_1 = __importDefault(__webpack_require__(411));
var user_1 = __importDefault(__webpack_require__(412));
var poloniex_1 = __importDefault(__webpack_require__(413));
var next = false; // 是否存在下一页
var ListComponent = function (_a) {
    var _b = _a.searchVal, searchVal = _b === void 0 ? '' : _b;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var t = (0, i18n_1.useTranslation)().t;
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var serviceRef = (0, react_1.useRef)();
    var serviceListRef = (0, react_1.useRef)();
    var _c = (0, react_1.useState)(true), loading = _c[0], setLoading = _c[1];
    var stepWidth = 70; // 每个的宽度
    var _d = (0, react_1.useState)(null), step = _d[0], setStep = _d[1]; // 页码，从0开始
    var originaTabList = [
        {
            value: 0,
            label: t('全部'),
        },
        {
            value: 5,
            label: t('现货'),
        },
        {
            value: 4,
            label: t('合约'),
        },
        {
            value: 1,
            label: t('赚币'),
        },
        {
            value: 8,
            label: t('功能'),
        },
        {
            value: 3,
            label: t('直播'),
        },
        {
            value: 2,
            label: t('资讯'),
        },
        {
            value: 6,
            label: t('公告'),
        },
        {
            value: 7,
            label: t('用户'),
        },
    ];
    var _e = (0, react_1.useState)([]), tabList = _e[0], setTabList = _e[1];
    var _f = (0, react_1.useState)([]), searchList = _f[0], setSearchList = _f[1];
    var _g = (0, react_1.useState)(0), curTabVal = _g[0], setCurTabVal = _g[1];
    var _h = (0, react_1.useState)({}), searchObj = _h[0], setSearchObj = _h[1];
    var _j = (0, react_1.useState)(0), navDomWidth = _j[0], setNavDomWidth = _j[1];
    (0, react_1.useEffect)(function () {
        if (window.sensors) {
            window.sensors.track('webshow_search_result', { keyword: searchVal });
        }
        setStep(0);
        // 初始化tab
        handleTab();
        // 查询搜索结果页
        getSearchResult();
        // 获取tab宽度，用于显示翻页按钮
        setTimeout(function () {
            var element = document.getElementsByClassName('nav_list-container');
            if (element.length) {
                var offsetWidth = element[0].offsetWidth;
                setNavDomWidth(offsetWidth);
            }
        }, 1000);
    }, [searchVal]);
    (0, react_1.useEffect)(function () {
        if (curTabVal === 0 && Object.keys(searchObj).length) {
            // 初始化tab
            handleTab();
            handleList();
        }
    }, [curTabVal, searchObj]);
    // 初始化tab
    var handleTab = function () {
        var list = [];
        // 处理第一个数据
        var tab = originaTabList.find(function (item) { return item.value == 0; });
        if (tab) {
            list.push(tab);
        }
        setTabList(list);
    };
    // 切换tab
    var tabClick = function (val) {
        var tab = tabList.find(function (item) { return item.value == val; });
        if (tab) {
            setCurTabVal(tab.value);
        }
    };
    var handleList = function () {
        var oldTabList = JSON.parse(JSON.stringify(originaTabList));
        // 删除第一个
        oldTabList.shift();
        //  添加P网
        oldTabList.push({
            value: 'poloniex',
            label: 'Poloniex',
        });
        var detailList = [];
        var newList = tabList.length > 1 ? [tabList[0]] : __spreadArray([], tabList, true);
        oldTabList.forEach(function (item) {
            var list = [];
            // 0：全部，1：理财，2：内容，3：直播，4：合约，5：现货，6：杠杆，7：用户
            // 现货
            if (item.value === 5) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.symbolList) || [];
            }
            // 合约
            if (item.value === 4) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.contractList) || [];
            }
            // 理财
            if (item.value === 1) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.financingList) || [];
            }
            // 功能
            if (item.value === 8) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.funList) || [];
            }
            // 直播
            if (item.value === 3) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.liveDataResList) || [];
            }
            // 资讯
            if (item.value === 2) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.contentList) || [];
            }
            // 公告
            if (item.value === 6) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.proclamationList) || [];
            }
            // 用户
            if (item.value === 7) {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.userInfoList) || [];
            }
            // P网
            if (item.value === 'poloniex') {
                list = (searchObj === null || searchObj === void 0 ? void 0 : searchObj.externalList) || [];
            }
            if (list.length > 0) {
                if (item.value !== 'poloniex') {
                    newList.push(item);
                }
                detailList.push({
                    header: item,
                    list: list,
                });
            }
        });
        setTabList(newList);
        setSearchList(detailList);
    };
    // 查询搜索结果页
    var getSearchResult = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data, dataObj, symbolList, contractList, contentList, financingList, funList, liveDataResList, userInfoList, externalList, proclamationList, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, httpService.getSearchResultList({ type: 0, searchName: searchVal })];
                case 1:
                    _a = _c.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        dataObj = data || {};
                        symbolList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.symbolList) || [];
                        contractList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.contractList) || [];
                        contentList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.contentList) || [];
                        financingList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.financingList) || [];
                        funList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.featureDtoList) || [];
                        liveDataResList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.liveDataResList) || [];
                        userInfoList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.userInfoList) || [];
                        externalList = ((_b = dataObj === null || dataObj === void 0 ? void 0 : dataObj.externalData) === null || _b === void 0 ? void 0 : _b.symbolList) || [];
                        proclamationList = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.proclamationList) || [];
                        if (symbolList.length === 0 &&
                            contractList.length === 0 &&
                            contentList.length === 0 &&
                            financingList.length === 0 &&
                            funList.length === 0 &&
                            liveDataResList.length === 0 &&
                            userInfoList.length === 0 &&
                            externalList.length === 0 &&
                            proclamationList.length === 0) {
                            setSearchObj({});
                        }
                        else {
                            setSearchObj({
                                symbolList: symbolList,
                                contractList: contractList,
                                contentList: contentList,
                                financingList: financingList,
                                funList: funList,
                                liveDataResList: liveDataResList,
                                userInfoList: userInfoList,
                                externalList: externalList,
                                proclamationList: proclamationList,
                            });
                        }
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // 上一页
    var prevClick = function () {
        var prevStep = step - 1;
        // 平移
        setStep(prevStep);
        var translateX = stepWidth * prevStep;
        if (translateX === 0) {
            next = false;
        }
        var serviceListDom = serviceListRef === null || serviceListRef === void 0 ? void 0 : serviceListRef.current;
        serviceListDom.style.transform = "translateX(-".concat(translateX, "px)");
    };
    // 下一页
    var nextClick = function () {
        if (next) {
            return;
        }
        var nextStep = step + 1;
        // 平移
        setStep(nextStep);
        var _a = serviceRef === null || serviceRef === void 0 ? void 0 : serviceRef.current, scrollWidth = _a.scrollWidth, offsetWidth = _a.offsetWidth;
        var translateX = stepWidth * nextStep;
        if (scrollWidth === offsetWidth) {
            next = true;
        }
        var serviceListDom = serviceListRef === null || serviceListRef === void 0 ? void 0 : serviceListRef.current;
        serviceListDom.style.transform = "translateX(-".concat(translateX, "px)");
    };
    var searchHeaderClick = function (val) {
        // P网不跳转
        if (['poloniex'].includes(val.value)) {
            return;
        }
        setCurTabVal(val.value);
    };
    // // 上一页
    var isPrev = function () {
        return step > 0;
    };
    // 下一页
    var isNext = function () {
        return navDomWidth > 300 && !next;
    };
    var allDom = function (item) {
        // 1：理财，2：内容，3：直播，4：合约，5：现货，6：杠杆，7：用户
        if (item.header.value === 5) {
            var list = item.list.slice(0, 3);
            return react_1.default.createElement(spot_1.default, { list: list, tabType: 'all', searchVal: searchVal, isFixedHeight: true });
        }
        else if (item.header.value === 4) {
            var list = item.list.slice(0, 3);
            return react_1.default.createElement(swap_1.default, { list: list, tabType: 'all', searchVal: searchVal });
        }
        else if (item.header.value === 1) {
            var list = item.list.slice(0, 2);
            return react_1.default.createElement(earn_1.default, { list: list, searchVal: searchVal });
        }
        else if (item.header.value === 8) {
            var list = item.list.slice(0, 3);
            return react_1.default.createElement(fun_1.default, { list: list, searchVal: searchVal });
        }
        else if (item.header.value === 3) {
            var list = item.list.slice(0, 2);
            return react_1.default.createElement(live_1.default, { list: list, searchVal: searchVal });
        }
        else if (item.header.value === 2) {
            var list = item.list.slice(0, 3);
            return react_1.default.createElement(news_1.default, { list: list, searchVal: searchVal });
        }
        else if (item.header.value === 6) {
            var list = item.list.slice(0, 3);
            return react_1.default.createElement(notice_1.default, { list: list, searchVal: searchVal });
        }
        else if (item.header.value === 7) {
            var list = item.list.slice(0, 3);
            return react_1.default.createElement(user_1.default, { list: list, searchVal: searchVal });
        }
        else if (item.header.value === 'poloniex') {
            return react_1.default.createElement(poloniex_1.default, { list: item.list, searchVal: searchVal });
        }
    };
    var detailDom = function () {
        // 现货
        if (curTabVal === 5) {
            return react_1.default.createElement(spot_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.symbolList, searchVal: searchVal });
        }
        // 合约
        if (curTabVal === 4) {
            return react_1.default.createElement(swap_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.contractList, searchVal: searchVal });
        }
        // 理财
        if (curTabVal === 1) {
            return react_1.default.createElement(earn_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.financingList, searchVal: searchVal });
        }
        // 功能
        if (curTabVal === 8) {
            return react_1.default.createElement(fun_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.funList, searchVal: searchVal });
        }
        // 直播
        if (curTabVal === 3) {
            return react_1.default.createElement(live_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.liveDataResList, searchVal: searchVal });
        }
        // 资讯
        if (curTabVal === 2) {
            return react_1.default.createElement(news_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.contentList, searchVal: searchVal });
        }
        // 公告
        if (curTabVal === 6) {
            return react_1.default.createElement(notice_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.proclamationList, searchVal: searchVal });
        }
        // 用户
        if (curTabVal === 7) {
            return react_1.default.createElement(user_1.default, { list: searchObj === null || searchObj === void 0 ? void 0 : searchObj.userInfoList, searchVal: searchVal });
        }
    };
    var renderDom = function () {
        if (loading) {
            return (react_1.default.createElement("div", { className: "loading-wrapper" },
                react_1.default.createElement(loading_1.default, null)));
        }
        if (Object.keys(searchObj).length === 0) {
            return react_1.default.createElement(no_content_1.default, null);
        }
        // 查询类型：0：全部，1：理财，2：内容，3：直播，4：合约，5：现货，6：杠杆，7：用户
        if (curTabVal === 0) {
            return (react_1.default.createElement("div", { className: "search-list" }, searchList.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "search-item" },
                react_1.default.createElement("div", { className: "search-header", onClick: function (e) {
                        e.nativeEvent.stopImmediatePropagation();
                        e.stopPropagation();
                        searchHeaderClick(item.header);
                    } },
                    react_1.default.createElement("span", { className: "name" }, item.header.label),
                    react_1.default.createElement("div", { className: "arrow-img" })),
                react_1.default.createElement("div", { className: "search-content" }, allDom(item)))); })));
        }
        else {
            return detailDom();
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "search__result-container" },
            react_1.default.createElement("div", { className: "nav-container ".concat(isPrev() ? 'nav_padding-left' : '', " ").concat(isNext() ? 'nav_padding-right' : '') },
                react_1.default.createElement("div", { className: "pre-container", onClick: function () {
                        prevClick();
                    } }, isPrev() && react_1.default.createElement("div", { className: "icon-img", id: "pre_page" })),
                react_1.default.createElement("div", { className: "nav_list-container", ref: serviceRef },
                    react_1.default.createElement("div", { className: "nav-list", ref: serviceListRef }, tabList.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "nav-item ".concat(item.value === curTabVal ? 'active-nav-item' : ''), onClick: function () {
                            tabClick(item.value);
                        } }, item.label)); }))),
                react_1.default.createElement("div", { className: "next-container", onClick: function () {
                        nextClick();
                    } }, isNext() && react_1.default.createElement("div", { className: "icon-img", id: "next_page" }))),
            react_1.default.createElement("div", { className: "search__list-container" }, renderDom()))));
};
exports.default = (0, react_1.memo)(ListComponent);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var react_virtualized_1 = __webpack_require__(269);
var htx_trade_symbol_1 = __importDefault(__webpack_require__(387));
var loading_1 = __importDefault(__webpack_require__(62));
var coin_icon_1 = __importDefault(__webpack_require__(63));
var no_content_1 = __importDefault(__webpack_require__(37));
var math_1 = __webpack_require__(79);
var loadedSpotArr = [];
var SpotComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.tabType, tabType = _c === void 0 ? '' : _c, _d = _a.searchVal, searchVal = _d === void 0 ? '' : _d, _e = _a.isFixedHeight, isFixedHeight = _e === void 0 ? false : _e;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var isLogin = globalState.isLogin, hostname = globalState.hostname, locale = globalState.locale, bodyWidth = globalState.bodyWidth;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var _f = (0, react_1.useState)(true), loading = _f[0], setLoading = _f[1];
    var _g = (0, react_1.useState)([]), spotList = _g[0], setSpotList = _g[1];
    var _h = (0, react_1.useState)({}), symbolObj = _h[0], setSymbolObj = _h[1]; // 交易对
    var _j = (0, react_1.useState)([]), newList = _j[0], setNewList = _j[1];
    (0, react_1.useEffect)(function () {
        // 获取交易对
        getSymbol();
    }, []);
    (0, react_1.useEffect)(function () {
        getKline();
        var intervalId = setInterval(function () {
            getKline();
        }, 3000);
        return function () { return clearInterval(intervalId); };
    }, [newList]);
    // 获取交易对
    var getSymbol = function () { return __awaiter(void 0, void 0, void 0, function () {
        var symbolsObj, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, htx_trade_symbol_1.default.getSymbols()];
                case 1:
                    symbolsObj = (_a.sent()).symbolsObj;
                    setSymbolObj(symbolsObj || {});
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log('获取交易对error :>> ', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (list.length && Object.keys(symbolObj).length) {
            initData();
        }
    }, [list, symbolObj]);
    var initData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var favList, _a, success, data, error_2, fav, oldList, spotArr;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    favList = [];
                    if (!isLogin) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.getPairList({ website: 'PRO' })];
                case 2:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        favList = data || [];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    console.log('获取收藏error :>> ', error_2);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    fav = localStorage.getItem('HBG-favList');
                    if (fav) {
                        favList = JSON.parse(fav);
                    }
                    _b.label = 6;
                case 6:
                    oldList = JSON.parse(JSON.stringify(list));
                    spotArr = [];
                    oldList.forEach(function (item) {
                        var curSymbol = (item === null || item === void 0 ? void 0 : item.symbol) || (item === null || item === void 0 ? void 0 : item.symbolCode);
                        var symbol = symbolObj[curSymbol] || {};
                        item.symbol = curSymbol;
                        item.baseCurrency = (symbol === null || symbol === void 0 ? void 0 : symbol.base_currency) || '';
                        item.quoteCurrency = (symbol === null || symbol === void 0 ? void 0 : symbol.quote_currency) || '';
                        item.crossRatio = (symbol === null || symbol === void 0 ? void 0 : symbol.super_margin_leverage_ratio) || ''; // 全仓杠杆
                        item.isolatedRatio = (symbol === null || symbol === void 0 ? void 0 : symbol.leverage_ratio) || ''; // 逐仓杠杆
                        item.fav = favList.includes(curSymbol);
                        spotArr.push(item);
                    });
                    setNewList(spotArr);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var getKline = function () { return __awaiter(void 0, void 0, void 0, function () {
        var pList_1, resList, sList_1, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (newList.length === 0) {
                        return [2 /*return*/];
                    }
                    pList_1 = [];
                    // 查询行情数据
                    loadedSpotArr.forEach(function (item) {
                        pList_1.push(getHistoryKline(item));
                    });
                    return [4 /*yield*/, Promise.all(pList_1)];
                case 1:
                    resList = _a.sent();
                    sList_1 = __spreadArray([], newList, true);
                    resList.forEach(function (item) {
                        var _a, _b;
                        // 更新当前价格和涨幅
                        var curSymbol = sList_1.find(function (i) { return i.symbol === item.symbolCode; });
                        if (curSymbol) {
                            curSymbol.close = ((_a = item.symbolInfo) === null || _a === void 0 ? void 0 : _a.close) || ''; // 当前价格
                            curSymbol.range = ((_b = item.symbolInfo) === null || _b === void 0 ? void 0 : _b.range) || ''; // 涨幅
                        }
                    });
                    setSpotList(sList_1);
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.log('error :>> ', error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // 查询依据交易对情数据，用于计算涨幅
    var getHistoryKline = function (symbolCode) { return __awaiter(void 0, void 0, void 0, function () {
        var param, searchObj, _a, status_1, data, list_1, _b, close_1, _c, open_1, range, error_4;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    param = {
                        period: '1day',
                        size: 1,
                        symbol: symbolCode,
                    };
                    searchObj = {};
                    return [4 /*yield*/, httpService.historyKline(param)];
                case 1:
                    _a = _d.sent(), status_1 = _a.status, data = _a.data;
                    if (status_1 === 'ok' && data) {
                        list_1 = data || [];
                        if (list_1.length > 0) {
                            searchObj = data[0] || {};
                            _b = searchObj.close, close_1 = _b === void 0 ? 0 : _b, _c = searchObj.open, open_1 = _c === void 0 ? 1 : _c;
                            range = 0;
                            if (Object.keys(searchObj).length > 0) {
                                range = close_1 / open_1 - 1;
                                range = (0, math_1.fix)(range * 100, 2);
                            }
                            searchObj = {
                                close: close_1,
                                range: range,
                            };
                        }
                    }
                    return [2 /*return*/, {
                            symbolCode: symbolCode,
                            symbolInfo: searchObj,
                        }];
                case 2:
                    error_4 = _d.sent();
                    console.log('error :>> ', error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var goClick = function (val) {
        var _a = val.symbol, symbol = _a === void 0 ? '' : _a, _b = val.baseCurrency, baseCurrency = _b === void 0 ? '' : _b, _c = val.quoteCurrency, quoteCurrency = _c === void 0 ? '' : _c, crossRatio = val.crossRatio, isolatedRatio = val.isolatedRatio;
        if (window.sensors) {
            if (tabType === 'all') {
                window.sensors.track('webclick_search_result', {
                    keyword: searchVal,
                    type: 'click',
                    tab: '',
                    card: '现货',
                    name: symbol,
                });
            }
            else {
                window.sensors.track('webclick_search_rec', {
                    type: 'click',
                    tab: '资产',
                    name: symbol,
                });
            }
        }
        var symbolCode = "".concat(baseCurrency, "_").concat(quoteCurrency);
        var type = 'spot';
        // 全仓
        if (crossRatio) {
            type = 'cross';
        }
        else if (isolatedRatio) {
            // 逐仓
            type = 'isolated';
        }
        location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale, "/trade/").concat(symbolCode, "?type=").concat(type);
    };
    // 收藏
    var favClick = function (val) { return __awaiter(void 0, void 0, void 0, function () {
        var newSpotArr, spotObj, success, error_5, success, error_6, fav, favList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window.sensors) {
                        if (tabType === 'all') {
                            window.sensors.track('webclick_search_result', {
                                keyword: searchVal,
                                type: 'fav',
                                tab: '',
                                card: '现货',
                                name: val.symbol,
                            });
                        }
                        else {
                            window.sensors.track('webclick_search_rec', {
                                type: 'fav',
                                tab: '资产',
                                name: val.symbol,
                            });
                        }
                    }
                    newSpotArr = __spreadArray([], spotList, true);
                    spotObj = newSpotArr.find(function (k) { return k.symbol === val.symbol; });
                    if (!spotObj) {
                        return [2 /*return*/];
                    }
                    if (!isLogin) return [3 /*break*/, 9];
                    if (!val.fav) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.delPair({
                            website: 'PRO',
                            trading_pair: val.symbol,
                        })];
                case 2:
                    success = (_a.sent()).success;
                    if (success) {
                        spotObj.fav = false;
                        // console.log('取消收藏success :>> ');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    console.log('取消收藏error :>> ', error_5);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 8];
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, httpService.addPair({
                            website: 'PRO',
                            trading_pair: val.symbol,
                        })];
                case 6:
                    success = (_a.sent()).success;
                    if (success) {
                        spotObj.fav = true;
                        // console.log('添加收藏success :>> ');
                    }
                    return [3 /*break*/, 8];
                case 7:
                    error_6 = _a.sent();
                    console.log('添加收藏error :>> ', error_6);
                    return [3 /*break*/, 8];
                case 8: return [3 /*break*/, 10];
                case 9:
                    fav = localStorage.getItem('HBG-favList');
                    favList = [];
                    if (fav) {
                        favList = JSON.parse(fav);
                    }
                    if (val.fav) {
                        // 取消收藏
                        favList.splice(favList.indexOf(val.symbol), 1);
                        spotObj.fav = false;
                    }
                    else {
                        // 添加收藏
                        favList.push(val.symbol);
                        spotObj.fav = true;
                    }
                    localStorage.setItem('HBG-favList', JSON.stringify(favList));
                    _a.label = 10;
                case 10:
                    setSpotList(newSpotArr);
                    return [2 /*return*/];
            }
        });
    }); };
    var ratioShow = function (val) {
        return tabType === 'all' && (val.crossRatio || val.isolatedRatio);
    };
    var imgUrl = function (currency) {
        if (currency === void 0) { currency = ''; }
        return "https://huobicfg.s3.amazonaws.com/currency_icon/".concat(currency.toLowerCase(), ".png");
    };
    var rateCss = function (item) {
        if (!(item === null || item === void 0 ? void 0 : item.range)) {
            return '';
        }
        if (Number(item.range) >= 0) {
            return 'up';
        }
        return 'down';
    };
    var listStyle = function () {
        if (bodyWidth < 1024) {
            if (isFixedHeight) {
                return { height: "".concat(spotList.length * 60, "px") };
            }
            return { height: '100%' };
        }
        if (spotList.length > 8) {
            // ui设计稿默认高度
            return { height: '480px' };
        }
        return { height: "".concat(spotList.length * 60, "px") };
    };
    var searchDom = function () {
        loadedSpotArr = [];
        if (tabType !== 'all' && loading) {
            return (react_1.default.createElement("div", { className: "loading-wrapper" },
                react_1.default.createElement(loading_1.default, null)));
        }
        if (spotList.length === 0) {
            return react_1.default.createElement(no_content_1.default, null);
        }
        return (react_1.default.createElement("div", { className: "spot-list", style: listStyle() },
            react_1.default.createElement(react_virtualized_1.AutoSizer, { defaultHeight: 60 }, function (_a) {
                var width = _a.width, height = _a.height;
                return (react_1.default.createElement(react_virtualized_1.List, { height: height, width: width, rowCount: spotList.length, rowHeight: 60, rowRenderer: function (_a) {
                        var index = _a.index, style = _a.style;
                        var item = spotList[index];
                        if (item) {
                            if (!loadedSpotArr.includes(item.symbol)) {
                                loadedSpotArr.push(item.symbol);
                            }
                        }
                        return (react_1.default.createElement("div", { key: index, className: "spot-item", style: style },
                            react_1.default.createElement("div", { className: "icon-symbol", onClick: function () {
                                    goClick(item);
                                } },
                                react_1.default.createElement(coin_icon_1.default, { name: item.baseCurrency, size: 20, img: imgUrl(item.baseCurrency) })),
                            react_1.default.createElement("div", { className: "content", onClick: function () {
                                    goClick(item);
                                } },
                                react_1.default.createElement("div", { className: "info" },
                                    react_1.default.createElement("div", { className: "symbol-info" },
                                        react_1.default.createElement("span", { className: "symbol" }, ((item === null || item === void 0 ? void 0 : item.baseCurrency) || '').toUpperCase()),
                                        react_1.default.createElement("span", { className: "currency" },
                                            "/",
                                            ((item === null || item === void 0 ? void 0 : item.quoteCurrency) || '').toUpperCase())),
                                    ratioShow(item) && (react_1.default.createElement("div", { className: "ratio" },
                                        item.crossRatio ? item.crossRatio : item.isolatedRatio,
                                        "X"))),
                                react_1.default.createElement("div", { className: "price-box" },
                                    react_1.default.createElement("span", { className: "price" }, (item === null || item === void 0 ? void 0 : item.close) || '--'),
                                    react_1.default.createElement("span", { className: "rate ".concat(rateCss(item)) }, (item === null || item === void 0 ? void 0 : item.range) ? "".concat(item.range, "%") : '--'))),
                            react_1.default.createElement("div", { className: "action ".concat(item.fav ? 'action-active' : ''), onClick: function () {
                                    favClick(item);
                                } })));
                    } }));
            })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "spot-content" }, searchDom())));
};
exports.default = (0, react_1.memo)(SpotComponent);


/***/ }),
/* 252 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(252);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(388);

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var settle = __webpack_require__(392);
var buildURL = __webpack_require__(394);
var parseHeaders = __webpack_require__(395);
var isURLSameOrigin = __webpack_require__(396);
var createError = __webpack_require__(257);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(397);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(393);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var loading_1 = __importDefault(__webpack_require__(62));
var no_content_1 = __importDefault(__webpack_require__(37));
var PromptComponent = function (_a) {
    var searchVal = _a.searchVal, onInputText = _a.onInputText;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var _b = (0, react_1.useState)([]), list = _b[0], setList = _b[1];
    var _c = (0, react_1.useState)(true), loading = _c[0], setLoading = _c[1];
    (0, react_1.useEffect)(function () {
        if (searchVal) {
            getSuggest();
        }
        else {
            setList([]);
        }
    }, [searchVal]);
    // 搜索
    var promptClick = function (val) {
        onInputText(val.suggest);
    };
    // 查询推荐词
    var getSuggest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, httpService.getSuggestList({ word: searchVal })];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setList((data === null || data === void 0 ? void 0 : data.list) || []);
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    setLoading(false);
                    console.log('查询推荐词error :>> ', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var renderDom = function () {
        if (loading) {
            return (react_1.default.createElement("div", { className: "loading-wrapper" },
                react_1.default.createElement(loading_1.default, null)));
        }
        if (list.length === 0) {
            return react_1.default.createElement(no_content_1.default, null);
        }
        return (react_1.default.createElement("div", { className: "prompt-list" }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "prompt-item", id: "search__prompt", onClick: function (e) {
                e.nativeEvent.stopImmediatePropagation();
                e.stopPropagation();
                promptClick(item);
            } },
            react_1.default.createElement("div", { className: "prompt-icon", id: "prompt__icon" }),
            react_1.default.createElement("div", { className: "prompt-content", id: "prompt__content" }, item.suggest))); })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "search__prompt-container" }, renderDom())));
};
exports.default = (0, react_1.memo)(PromptComponent);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var spot_1 = __importDefault(__webpack_require__(251));
var i18n_1 = __webpack_require__(14);
var loading_1 = __importDefault(__webpack_require__(62));
var hot_svg_1 = __importDefault(__webpack_require__(414));
var gift_svg_1 = __importDefault(__webpack_require__(415));
var n_svg_1 = __importDefault(__webpack_require__(416));
var HotComponent = function (_a) {
    var _b = _a.searchVal, searchVal = _b === void 0 ? '' : _b;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale, bodyWidth = globalState.bodyWidth;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var t = (0, i18n_1.useTranslation)().t;
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var _c = (0, react_1.useState)(true), loading = _c[0], setLoading = _c[1];
    var tabList = [
        {
            value: 'asset',
            label: t('热门资产'),
        },
        {
            value: 'topic',
            label: t('热门话题'),
        },
        {
            value: 'finance',
            label: t('热门赚币'),
        },
    ];
    var _d = (0, react_1.useState)('asset'), curHotVal = _d[0], setCurHotVal = _d[1];
    var _e = (0, react_1.useState)([]), list = _e[0], setList = _e[1];
    var _f = (0, react_1.useState)({}), hotObj = _f[0], setHotObj = _f[1];
    (0, react_1.useEffect)(function () {
        getSearch();
    }, []);
    // 查询搜索推荐列表
    var getSearch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, httpService.getSearchList()];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setHotObj((data === null || data === void 0 ? void 0 : data.hotList) || {});
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (Object.keys(hotObj).length) {
            switch (curHotVal) {
                case 'topic':
                    // @ts-ignore
                    setList((hotObj === null || hotObj === void 0 ? void 0 : hotObj.topicList) || []);
                    break;
                case 'finance':
                    // @ts-ignore
                    setList((hotObj === null || hotObj === void 0 ? void 0 : hotObj.financeList) || []);
                    break;
                default:
                    // @ts-ignore
                    setList((hotObj === null || hotObj === void 0 ? void 0 : hotObj.symbolList) || []);
                    break;
            }
        }
    }, [curHotVal, hotObj]);
    var tabClick = function (val) {
        if (val === void 0) { val = ''; }
        var tab = tabList.find(function (item) { return item.value == val; });
        if (tab) {
            setCurHotVal(tab.value);
        }
    };
    // 理财跳转
    var goClick = function (item) {
        var currency = item.currency;
        if (window.sensors) {
            window.sensors.track('webclick_search_rec', {
                type: 'click',
                tab: '赚币',
                name: currency,
            });
        }
        var url = '';
        // PC
        if (bodyWidth > 1024) {
            url = "/financial/earn?currency=".concat(currency);
        }
        else {
            // h5
            url = "/financial/earn/h5?currency=".concat(currency);
        }
        location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale).concat(url);
    };
    // 热门话题跳转
    var goTopicClick = function (item) {
        var title = item.title, _a = item.topicId, topicId = _a === void 0 ? '' : _a;
        if (window.sensors) {
            window.sensors.track('webclick_search_rec', {
                type: 'click',
                tab: '话题',
                name: title,
            });
        }
        if (topicId) {
            location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale, "/feed/topic/").concat(topicId, "/");
        }
    };
    var renderHotDom = function () {
        if (loading) {
            return (react_1.default.createElement("div", { className: "loading-wrapper" },
                react_1.default.createElement(loading_1.default, null)));
        }
        if (curHotVal === 'topic') {
            return (react_1.default.createElement("div", { className: "hot-list" }, list.map(function (item, index) {
                var imgUrl = '';
                // identification：1最新2最热3有奖
                switch (item.identification) {
                    case 1:
                        imgUrl = n_svg_1.default;
                        break;
                    case 2:
                        imgUrl = hot_svg_1.default;
                        break;
                    case 3:
                        imgUrl = gift_svg_1.default;
                        break;
                    default:
                        imgUrl = '';
                        break;
                }
                return (react_1.default.createElement("div", { key: index, className: "hot-item hot-topic", onClick: function () {
                        goTopicClick(item);
                    } },
                    react_1.default.createElement("div", { className: "num" }, index + 1),
                    react_1.default.createElement("div", { className: "content" }, item.title),
                    imgUrl ? react_1.default.createElement("img", { src: imgUrl, className: "hot-img", alt: "img" }) : ''));
            })));
        }
        else if (curHotVal === 'finance') {
            return (react_1.default.createElement("div", { className: "hot-list" }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "hot-item hot-finance", onClick: function () {
                    goClick(item);
                } },
                react_1.default.createElement("div", { className: "num" }, index + 1),
                react_1.default.createElement("div", { className: "content" },
                    react_1.default.createElement("div", { className: "info" },
                        react_1.default.createElement("span", { className: "name" }, ((item === null || item === void 0 ? void 0 : item.currency) || '').toUpperCase()),
                        react_1.default.createElement("span", { className: "tag" }, "APY")),
                    react_1.default.createElement("div", { className: "rate" }, "".concat((item === null || item === void 0 ? void 0 : item.minYearRate) || '-', "%~").concat((item === null || item === void 0 ? void 0 : item.maxYearRate) || '-', "%"))))); })));
        }
        else {
            return react_1.default.createElement(spot_1.default, { list: list, searchVal: searchVal });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "search__hot-container" },
            react_1.default.createElement("div", { className: "hot-tab-list" }, tabList.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "tab-item ".concat(item.value === curHotVal ? 'active-tab-item' : ''), onClick: function () {
                    if (window.sensors) {
                        window.sensors.track('webclick_search_rec', {
                            type: 'click',
                            tab: item.label,
                        });
                    }
                    tabClick(item.value);
                } }, item.label)); })),
            react_1.default.createElement("div", { className: "search-container" }, renderHotDom()))));
};
exports.default = (0, react_1.memo)(HotComponent);


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var nftImg_1 = __importDefault(__webpack_require__(263));
var nft_avatar_1 = __importDefault(__webpack_require__(264));
var utils_1 = __importDefault(__webpack_require__(20));
var UserAvatar = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.uc, uc = _b === void 0 ? {} : _b, size = _a.size, _c = _a.general, general = _c === void 0 ? false : _c, _d = _a.flag, flag = _d === void 0 ? false : _d, handleClick = _a.handleClick;
    var _e = uc.imgUrl, imgUrl = _e === void 0 ? utils_1.default.getUserIcon() : _e, isNFT = uc.isNFT, frameUrl = uc.frameUrl;
    var _f = (0, react_1.useState)(), img = _f[0], setImg = _f[1];
    (0, react_1.useEffect)(function () {
        if (isNFT) {
            (0, nftImg_1.default)(imgUrl, size * 3).then(function (src) {
                setImg(src);
            });
        }
        else {
            setImg(imgUrl);
        }
    }, [imgUrl, isNFT]);
    var renderAvatar = function () {
        return (react_1.default.createElement("div", { className: general ? 'hbg-user-avatar__border-general' : 'hbg-user-avatar__border' },
            react_1.default.createElement("img", { className: "hbg-user-avatar__is-not-nft", src: img })));
    };
    var renderNft = function () {
        return (react_1.default.createElement(nft_avatar_1.default, { size: size, frame: frameUrl },
            react_1.default.createElement("img", { src: img, style: { width: "".concat(size, "px"), height: "".concat(size, "px") } })));
    };
    return (react_1.default.createElement("div", { ref: ref, className: "hbg-user-avatar", style: { width: "".concat(size, "px"), height: "".concat(size, "px") }, onClick: handleClick },
        isNFT ? renderNft() : renderAvatar(),
        (uc === null || uc === void 0 ? void 0 : uc.communityStatus) ? (react_1.default.createElement("i", { className: "".concat(flag ? 'hbg-user-avatar__big' : '', " ").concat((uc === null || uc === void 0 ? void 0 : uc.communityStatus) === 'LIVE' ? 'hbg-user-avatar__live' : 'hbg-user-avatar__v') })) : ('')));
});
exports.default = UserAvatar;


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// 如果需要裁剪
/* 
    图片裁剪尺寸对照表(腾讯云图片裁剪服务)
    阿里              尺寸                    腾讯
?style=st6        1000 * 1000     ?imageMogr2/thumbnail/!100p
?style=st5         800 * 800      ?imageMogr2/thumbnail/!80p
?style=st4         500 * 500      ?imageMogr2/thumbnail/!50p
?style=st3         400 * 400      ?imageMogr2/thumbnail/!40p
?style=st2         200 * 200      ?imageMogr2/thumbnail/!20p
?style=st1         100 * 100      ?imageMogr2/thumbnail/!10p

*/

const supportWebp = () => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
            resolve(true)
        };
        img.onerror = function () {
            resolve(false)
        };
        img.src = `data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA`;
    });
};


function getStaticHost(isChinese) {
    return isChinese
        ? 'https://app-static-1306115679.file.myqcloud.com/ibox-nft-file'
        : 'https://nft-static.hbfile.net/ibox-nft-file';
}

/* harmony default export */ __webpack_exports__["default"] = (function (img, size, isChinese) {
    return new Promise(async (resolve, reject) => {
        const isWebp = await supportWebp()
        const imgUrl = img.replace(/https:\/\/(\w|-|\.)+(\/ibox-nft-file)?/, getStaticHost(isChinese))
        resolve(`${imgUrl}${imgUrl.includes('?') ? '&' : '?'}imageMogr2${isWebp? '/format/webp': ''}/thumbnail/!${Math.ceil(size/10)}p`)
    })
});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsCSS = void 0;
//@ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var lottie_web_1 = __importDefault(__webpack_require__(424));
var axios_1 = __importDefault(__webpack_require__(254));
var nfg_mask_1 = __importDefault(__webpack_require__(425));
/**
 * 检查浏览器是否支持CSS
 * @param attribute
 * @param value
 * @return {Boolean}
 */
var supportsCSS = function (attribute, value) {
    if (window.CSS && window.CSS.supports) {
        if (typeof value === 'undefined')
            return window.CSS.supports(attribute);
        return window.CSS.supports(attribute, value);
    }
    var elem = document.createElement('div');
    if (attribute in elem.style) {
        elem.style[attribute] = value;
        return elem.style[attribute] === value;
    }
    return false;
};
exports.supportsCSS = supportsCSS;
var UserAvatar = function (_a) {
    var frame = _a.frame, size = _a.size, children = _a.children;
    var _b = (0, react_1.useState)(false), supportMask = _b[0], setSupportMask = _b[1];
    var lottieRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        // 判断浏览器是否支持css mask image
        var maskVal = 'url(test)';
        setSupportMask((0, exports.supportsCSS)('mask-image', maskVal) || (0, exports.supportsCSS)('-webkit-mask-image', maskVal));
        initAni();
        return function () {
            // animation.removeEventListener('DOMLoaded');
            // animation?.destroy()
        };
    }, []);
    var initAni = function () { return __awaiter(void 0, void 0, void 0, function () {
        var animationData, animation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1.default
                        .get(frame)
                        .then(function (_a) {
                        var data = _a.data;
                        return data;
                    })
                        .catch(function () {
                        return null;
                    })];
                case 1:
                    animationData = _a.sent();
                    if (!animationData || !lottieRef.current) {
                        return [2 /*return*/, false];
                    }
                    animation = lottie_web_1.default.loadAnimation({
                        wrapper: lottieRef.current,
                        animType: 'svg',
                        loop: true,
                        prerender: true,
                        autoplay: false,
                        animationData: animationData,
                    });
                    animation.addEventListener('DOMLoaded', function () { return animation.play(); });
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * 首选css mask image处理
     * 如果不支持mask属性，进行css变换处理
     */
    return (react_1.default.createElement("div", { className: 'fed-nft-avatar', style: { width: "".concat(size, "px"), height: "".concat(size, "px") } },
        react_1.default.createElement("div", { className: "fed-nft-avatar--mask" }, supportMask ? children : react_1.default.createElement(nfg_mask_1.default, { size: size - 6 }, children))));
};
exports.default = UserAvatar;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(431);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports.default = portalOpenInstances;

/***/ }),
/* 268 */,
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ArrowKeyStepper", function() { return /* reexport */ es_ArrowKeyStepper_ArrowKeyStepper; });
__webpack_require__.d(__webpack_exports__, "AutoSizer", function() { return /* reexport */ AutoSizer_AutoSizer; });
__webpack_require__.d(__webpack_exports__, "CellMeasurer", function() { return /* reexport */ CellMeasurer_CellMeasurer; });
__webpack_require__.d(__webpack_exports__, "CellMeasurerCache", function() { return /* reexport */ CellMeasurerCache_CellMeasurerCache; });
__webpack_require__.d(__webpack_exports__, "Collection", function() { return /* reexport */ Collection_Collection; });
__webpack_require__.d(__webpack_exports__, "ColumnSizer", function() { return /* reexport */ ColumnSizer_ColumnSizer; });
__webpack_require__.d(__webpack_exports__, "accessibilityOverscanIndicesGetter", function() { return /* reexport */ accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter; });
__webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return /* reexport */ defaultCellRangeRenderer; });
__webpack_require__.d(__webpack_exports__, "defaultOverscanIndicesGetter", function() { return /* reexport */ defaultOverscanIndicesGetter; });
__webpack_require__.d(__webpack_exports__, "Grid", function() { return /* reexport */ es_Grid_Grid; });
__webpack_require__.d(__webpack_exports__, "InfiniteLoader", function() { return /* reexport */ InfiniteLoader_InfiniteLoader; });
__webpack_require__.d(__webpack_exports__, "List", function() { return /* reexport */ List_List; });
__webpack_require__.d(__webpack_exports__, "createMasonryCellPositioner", function() { return /* reexport */ createCellPositioner; });
__webpack_require__.d(__webpack_exports__, "Masonry", function() { return /* reexport */ es_Masonry_Masonry; });
__webpack_require__.d(__webpack_exports__, "MultiGrid", function() { return /* reexport */ es_MultiGrid_MultiGrid; });
__webpack_require__.d(__webpack_exports__, "ScrollSync", function() { return /* reexport */ ScrollSync_ScrollSync; });
__webpack_require__.d(__webpack_exports__, "createTableMultiSort", function() { return /* reexport */ createMultiSort; });
__webpack_require__.d(__webpack_exports__, "defaultTableCellDataGetter", function() { return /* reexport */ defaultCellDataGetter; });
__webpack_require__.d(__webpack_exports__, "defaultTableCellRenderer", function() { return /* reexport */ defaultCellRenderer; });
__webpack_require__.d(__webpack_exports__, "defaultTableHeaderRenderer", function() { return /* reexport */ defaultHeaderRenderer; });
__webpack_require__.d(__webpack_exports__, "defaultTableHeaderRowRenderer", function() { return /* reexport */ defaultHeaderRowRenderer; });
__webpack_require__.d(__webpack_exports__, "defaultTableRowRenderer", function() { return /* reexport */ defaultRowRenderer; });
__webpack_require__.d(__webpack_exports__, "Table", function() { return /* reexport */ Table_Table; });
__webpack_require__.d(__webpack_exports__, "Column", function() { return /* reexport */ Column_Column; });
__webpack_require__.d(__webpack_exports__, "SortDirection", function() { return /* reexport */ Table_SortDirection; });
__webpack_require__.d(__webpack_exports__, "SortIndicator", function() { return /* reexport */ SortIndicator; });
__webpack_require__.d(__webpack_exports__, "WindowScroller", function() { return /* reexport */ WindowScroller_WindowScroller; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(5);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js
var createClass = __webpack_require__(6);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(10);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(11);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(2);
var assertThisInitialized_default = /*#__PURE__*/__webpack_require__.n(assertThisInitialized);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inherits.js
var inherits = __webpack_require__(12);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
var react_lifecycles_compat_es = __webpack_require__(36);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js
var helpers_extends = __webpack_require__(24);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/clsx/dist/clsx.m.js
function clsx_m_r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=clsx_m_r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=clsx_m_r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/utils/calculateSizeAndPositionDataAndUpdateScrollOffset.js
/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(57);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/types.js


var bpfrpt_proptype_CellPosition =  true ? null : undefined;
var bpfrpt_proptype_CellRendererParams =  true ? null : undefined;
var bpfrpt_proptype_CellRenderer =  true ? null : undefined;
var bpfrpt_proptype_CellCache =  true ? null : undefined;
var bpfrpt_proptype_StyleCache =  true ? null : undefined;
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : undefined;
var bpfrpt_proptype_CellRangeRenderer =  true ? null : undefined;
var bpfrpt_proptype_CellSizeGetter =  true ? null : undefined;
var bpfrpt_proptype_CellSize =  true ? null : undefined;
var bpfrpt_proptype_NoContentRenderer =  true ? null : undefined;
var bpfrpt_proptype_Scroll =  true ? null : undefined;
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : undefined;
var bpfrpt_proptype_RenderedSection =  true ? null : undefined;
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : undefined;
var bpfrpt_proptype_OverscanIndices =  true ? null : undefined;
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : undefined;
var bpfrpt_proptype_Alignment =  true ? null : undefined;
var bpfrpt_proptype_VisibleCellRange =  true ? null : undefined;



















// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/utils/CellSizeAndPositionManager.js




/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager_CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    classCallCheck_default()(this, CellSizeAndPositionManager);

    defineProperty_default()(this, "_cellSizeAndPositionData", {});

    defineProperty_default()(this, "_lastMeasuredIndex", -1);

    defineProperty_default()(this, "_lastBatchedIndex", -1);

    defineProperty_default()(this, "_cellCount", void 0);

    defineProperty_default()(this, "_cellSizeGetter", void 0);

    defineProperty_default()(this, "_estimatedCellSize", void 0);

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  createClass_default()(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();





// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/utils/maxElementSize.js
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/utils/ScalingCellSizeAndPositionManager.js







/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager_ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? getMaxElementSize() : _ref$maxScrollSize,
        params = objectWithoutProperties_default()(_ref, ["maxScrollSize"]);

    classCallCheck_default()(this, ScalingCellSizeAndPositionManager);

    defineProperty_default()(this, "_cellSizeAndPositionManager", void 0);

    defineProperty_default()(this, "_maxScrollSize", void 0);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new CellSizeAndPositionManager_CellSizeAndPositionManager(params);
    this._maxScrollSize = maxScrollSize;
  }

  createClass_default()(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();





// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/utils/createCallbackMemoizer.js
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/defaultOverscanIndicesGetter.js
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/utils/updateScrollIndexHelper.js

/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/defaultCellRangeRenderer.js
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {}

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {}
}


// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ var canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize_scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/utils/animationFrame.js
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/utils/requestAnimationTimeout.js

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : undefined;
var requestAnimationTimeout_cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return caf(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */

var requestAnimationTimeout_requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = raf(timeout);
    }
  };

  var frame = {
    id: raf(timeout)
  };
  return frame;
};


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/Grid.js









var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid_Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    classCallCheck_default()(this, Grid);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(Grid).call(this, props));

    defineProperty_default()(assertThisInitialized_default()(_this), "_onGridRenderedMemoizer", createCallbackMemoizer());

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    defineProperty_default()(assertThisInitialized_default()(_this), "_deferredInvalidateColumnIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_deferredInvalidateRowIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_recomputeScrollLeftFlag", false);

    defineProperty_default()(assertThisInitialized_default()(_this), "_recomputeScrollTopFlag", false);

    defineProperty_default()(assertThisInitialized_default()(_this), "_horizontalScrollBarSize", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_verticalScrollBarSize", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_scrollbarPresenceChanged", false);

    defineProperty_default()(assertThisInitialized_default()(_this), "_scrollingContainer", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_childrenToDisplay", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_columnStartIndex", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_columnStopIndex", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_rowStartIndex", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_rowStopIndex", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_renderedColumnStartIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_renderedColumnStopIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_renderedRowStartIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_renderedRowStopIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_initialScrollTop", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_initialScrollLeft", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_disablePointerEventsTimeoutId", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_styleCache", {});

    defineProperty_default()(assertThisInitialized_default()(_this), "_cellCache", {});

    defineProperty_default()(assertThisInitialized_default()(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });

    var columnSizeAndPositionManager = new ScalingCellSizeAndPositionManager_ScalingCellSizeAndPositionManager({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new ScalingCellSizeAndPositionManager_ScalingCellSizeAndPositionManager({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  createClass_default()(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        requestAnimationTimeout_cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return external_react_["createElement"]("div", extends_default()({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: clsx_m('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && external_react_["createElement"]("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        requestAnimationTimeout_cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = requestAnimationTimeout_requestAnimationTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);

  return Grid;
}(external_react_["PureComponent"]), defineProperty_default()(_class, "propTypes",  true ? null : undefined), _temp);

defineProperty_default()(Grid_Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: defaultCellRangeRenderer,
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: scrollbarSize_scrollbarSize,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});

Object(react_lifecycles_compat_es["polyfill"])(Grid_Grid);
/* harmony default export */ var es_Grid_Grid = (Grid_Grid);















// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/accessibilityOverscanIndicesGetter.js
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_BACKWARD = -1;
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD = 1;
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Grid/index.js





















// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/ArrowKeyStepper/types.js
var bpfrpt_proptype_ScrollIndices =  true ? null : undefined;


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/ArrowKeyStepper/ArrowKeyStepper.js








var ArrowKeyStepper_class, ArrowKeyStepper_temp;

function ArrowKeyStepper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ArrowKeyStepper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ArrowKeyStepper_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ArrowKeyStepper_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper_ArrowKeyStepper = (ArrowKeyStepper_temp = ArrowKeyStepper_class =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(ArrowKeyStepper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_columnStartIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_columnStopIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_rowStartIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_rowStopIndex", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_onKeyDown", function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;

      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow; // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;

        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;

        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;

        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onSectionRendered", function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });

    return _this;
  }

  createClass_default()(ArrowKeyStepper, [{
    key: "setScrollIndexes",
    value: function setScrollIndexes(_ref2) {
      var scrollToColumn = _ref2.scrollToColumn,
          scrollToRow = _ref2.scrollToRow;
      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children;

      var _this$_getScrollState3 = this._getScrollState(),
          scrollToColumn = _this$_getScrollState3.scrollToColumn,
          scrollToRow = _this$_getScrollState3.scrollToRow;

      return external_react_["createElement"]("div", {
        className: className,
        onKeyDown: this._onKeyDown
      }, children({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow
      }));
    }
  }, {
    key: "_getScrollState",
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function _updateScrollState(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;
      var _this$props3 = this.props,
          isControlled = _this$props3.isControlled,
          onScrollToChange = _this$props3.onScrollToChange;

      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }

      if (!isControlled) {
        this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return {};
      }

      if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
        return ArrowKeyStepper_objectSpread({}, prevState, {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow,
          instanceProps: {
            prevScrollToColumn: nextProps.scrollToColumn,
            prevScrollToRow: nextProps.scrollToRow
          }
        });
      }

      return {};
    }
  }]);

  return ArrowKeyStepper;
}(external_react_["PureComponent"]), defineProperty_default()(ArrowKeyStepper_class, "propTypes",  true ? null : undefined), ArrowKeyStepper_temp);

defineProperty_default()(ArrowKeyStepper_ArrowKeyStepper, "defaultProps", {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
});

Object(react_lifecycles_compat_es["polyfill"])(ArrowKeyStepper_ArrowKeyStepper);
/* harmony default export */ var es_ArrowKeyStepper_ArrowKeyStepper = (ArrowKeyStepper_ArrowKeyStepper);



// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/ArrowKeyStepper/index.js




// EXTERNAL MODULE: ./node_modules/react-virtualized/dist/es/vendor/detectElementResize.js
var detectElementResize = __webpack_require__(104);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/AutoSizer/AutoSizer.js








var AutoSizer_class, AutoSizer_temp;

function AutoSizer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AutoSizer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AutoSizer_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AutoSizer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var AutoSizer_AutoSizer = (AutoSizer_temp = AutoSizer_class =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_parentNode", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_autoSizer", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_window", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_detectElementResize", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });

    return _this;
  }

  createClass_default()(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = Object(detectElementResize["a" /* default */])(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return external_react_["createElement"]("div", {
        className: className,
        ref: this._setRef,
        style: AutoSizer_objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);

  return AutoSizer;
}(external_react_["Component"]), defineProperty_default()(AutoSizer_class, "propTypes",  true ? null : undefined), AutoSizer_temp);

defineProperty_default()(AutoSizer_AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});



// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/AutoSizer/index.js


// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(55);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/CellMeasurer/types.js
var bpfrpt_proptype_CellMeasureCache =  true ? null : undefined;


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurer.js








var CellMeasurer_class, CellMeasurer_temp;




/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer_CellMeasurer = (CellMeasurer_temp = CellMeasurer_class =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, CellMeasurer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(CellMeasurer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "_child", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_measure", function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('CellMeasurer registerChild expects to be passed Element or null');
      }

      _this._child = element;

      if (element) {
        _this._maybeMeasureCell();
      }
    });

    return _this;
  }

  createClass_default()(CellMeasurer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? children({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children;
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache = this.props.cache;
      var node = this._child || Object(external_react_dom_["findDOMNode"])(this); // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height; // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.

        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }

        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth); // Reset after measuring to avoid breaking styles; see #660

        if (styleWidth) {
          node.style.width = styleWidth;
        }

        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return {
          height: height,
          width: width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props,
          cache = _this$props2.cache,
          _this$props2$columnIn = _this$props2.columnIndex,
          columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn,
          parent = _this$props2.parent,
          _this$props2$rowIndex = _this$props2.rowIndex,
          rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;

      if (!cache.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(),
            height = _this$_getCellMeasure2.height,
            width = _this$_getCellMeasure2.width;

        cache.set(rowIndex, columnIndex, width, height); // If size has changed, let Grid know to re-render.

        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(external_react_["PureComponent"]), defineProperty_default()(CellMeasurer_class, "propTypes",  true ? null : undefined), CellMeasurer_temp); // Used for DEV mode warning check

defineProperty_default()(CellMeasurer_CellMeasurer, "__internalCellMeasurerFlag", false);



if (false) {}



// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurerCache.js



var DEFAULT_HEIGHT = 30;
var DEFAULT_WIDTH = 100; // Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache_CellMeasurerCache =
/*#__PURE__*/
function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck_default()(this, CellMeasurerCache);

    defineProperty_default()(this, "_cellHeightCache", {});

    defineProperty_default()(this, "_cellWidthCache", {});

    defineProperty_default()(this, "_columnWidthCache", {});

    defineProperty_default()(this, "_rowHeightCache", {});

    defineProperty_default()(this, "_defaultHeight", void 0);

    defineProperty_default()(this, "_defaultWidth", void 0);

    defineProperty_default()(this, "_minHeight", void 0);

    defineProperty_default()(this, "_minWidth", void 0);

    defineProperty_default()(this, "_keyMapper", void 0);

    defineProperty_default()(this, "_hasFixedHeight", void 0);

    defineProperty_default()(this, "_hasFixedWidth", void 0);

    defineProperty_default()(this, "_columnCount", 0);

    defineProperty_default()(this, "_rowCount", 0);

    defineProperty_default()(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
    });

    defineProperty_default()(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
    });

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;
    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;
    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {}
  }

  createClass_default()(CellMeasurerCache, [{
    key: "clear",
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }

      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      } // Size is cached per cell so we don't have to re-measure if cells are re-ordered.


      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;

        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }

        var columnKey = this._keyMapper(0, columnIndex);

        this._columnWidthCache[columnKey] = columnWidth;
      }

      if (!this._hasFixedHeight) {
        var rowHeight = 0;

        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }

        var rowKey = this._keyMapper(rowIndex, 0);

        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();



function defaultKeyMapper(rowIndex, columnIndex) {
  return "".concat(rowIndex, "-").concat(columnIndex);
}


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/CellMeasurer/index.js


/* harmony default export */ var es_CellMeasurer = (CellMeasurer_CellMeasurer);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Collection/CollectionView.js








function CollectionView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CollectionView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CollectionView_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CollectionView_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var IS_SCROLLING_TIMEOUT = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var CollectionView_SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};
/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView_CollectionView =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, CollectionView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(CollectionView)).call.apply(_getPrototypeOf2, [this].concat(args))); // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_calculateSizeAndPositionDataOnNextUpdate", false);

    defineProperty_default()(assertThisInitialized_default()(_this), "_onSectionRenderedMemoizer", createCallbackMemoizer());

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    defineProperty_default()(assertThisInitialized_default()(_this), "_invokeOnSectionRenderedHelper", function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;

      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_updateScrollPositionForScrollToCell", function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;

      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._enablePointerEventsAfterDelay(); // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.


      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;
      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop)); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? CollectionView_SCROLL_POSITION_CHANGE_REASONS.OBSERVED : CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED; // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)

        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    });

    _this._scrollbarSize = scrollbarSize_scrollbarSize();

    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }

    return _this;
  }
  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  createClass_default()(CollectionView, [{
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          cellLayoutManager = _this$props4.cellLayoutManager,
          scrollLeft = _this$props4.scrollLeft,
          scrollToCell = _this$props4.scrollToCell,
          scrollTop = _this$props4.scrollTop; // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = scrollbarSize_scrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      } // Update onSectionRendered callback.


      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width; // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props,
          height = _this$props5.height,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToCell = _this$props5.scrollToCell,
          width = _this$props5.width;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollPositionChangeReason = _this$state2.scrollPositionChangeReason,
          scrollTop = _this$state2.scrollTop; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Update scroll offsets if the current :scrollToCell values requires it


      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoHeight = _this$props6.autoHeight,
          cellCount = _this$props6.cellCount,
          cellLayoutManager = _this$props6.cellLayoutManager,
          className = _this$props6.className,
          height = _this$props6.height,
          horizontalOverscanSize = _this$props6.horizontalOverscanSize,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          style = _this$props6.style,
          verticalOverscanSize = _this$props6.verticalOverscanSize,
          width = _this$props6.width;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollLeft = _this$state3.scrollLeft,
          scrollTop = _this$state3.scrollTop; // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;
        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width; // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];
      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      }; // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0; // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23

      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      return external_react_["createElement"]("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Collection', className),
        id: id,
        onScroll: this._onScroll,
        role: "grid",
        style: CollectionView_objectSpread({}, collectionStyle, {}, style),
        tabIndex: 0
      }, cellCount > 0 && external_react_["createElement"]("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: totalHeight,
          maxHeight: totalHeight,
          maxWidth: totalWidth,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          width: totalWidth
        }
      }, childrenToDisplay), cellCount === 0 && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;
        isScrollingChange(false);
        _this2._disablePointerEventsTimeoutId = null;

        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;

      var scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          totalHeight = _ref.totalHeight,
          totalWidth = _ref.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft = _ref2.scrollLeft,
              scrollTop = _ref2.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;
      var newState = {
        scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(external_react_["PureComponent"]);

defineProperty_default()(CollectionView_CollectionView, "defaultProps", {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});

CollectionView_CollectionView.propTypes =  false ? undefined : {};
Object(react_lifecycles_compat_es["polyfill"])(CollectionView_CollectionView);
/* harmony default export */ var Collection_CollectionView = (CollectionView_CollectionView);
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Collection/types.js
var bpfrpt_proptype_Index =  true ? null : undefined;
var bpfrpt_proptype_PositionInfo =  true ? null : undefined;
var bpfrpt_proptype_ScrollPosition =  true ? null : undefined;
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : undefined;
var bpfrpt_proptype_SizeInfo =  true ? null : undefined;






// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Collection/Section.js



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section_Section =
/*#__PURE__*/
function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    classCallCheck_default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;
    this._indexMap = {};
    this._indices = [];
  }
  /** Add a cell to this section. */


  createClass_default()(Section, [{
    key: "addCellIndex",
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;

        this._indices.push(index);
      }
    }
    /** Get all cell indices that have been added to this section. */

  }, {
    key: "getCellIndices",
    value: function getCellIndices() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);

  return Section;
}();




// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Collection/SectionManager.js



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */

var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager_SectionManager =
/*#__PURE__*/
function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    classCallCheck_default()(this, SectionManager);

    this._sectionSize = sectionSize;
    this._cellMetadata = [];
    this._sections = {};
  }
  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  createClass_default()(SectionManager, [{
    key: "getCellIndices",
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;
      var indices = {};
      this.getSections({
        height: height,
        width: width,
        x: x,
        y: y
      }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      }); // Object keys are strings; this function returns numbers

      return Object.keys(indices).map(function (index) {
        return indices[index];
      });
    }
    /** Get size and position information for the cell specified. */

  }, {
    key: "getCellMetadata",
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;
      return this._cellMetadata[index];
    }
    /** Get all Sections overlapping the specified region. */

  }, {
    key: "getSections",
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;
      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = "".concat(sectionX, ".").concat(sectionY);

          if (!this._sections[key]) {
            this._sections[key] = new Section_Section({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }
    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: "getTotalSectionCount",
    value: function getTotalSectionCount() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      var _this = this;

      return Object.keys(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: "registerCell",
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;
      this._cellMetadata[index] = cellMetadatum;
      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({
          index: index
        });
      });
    }
  }]);

  return SectionManager;
}();




// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Collection/utils/calculateSizeAndPositionData.js

function calculateSizeAndPositionData_calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;
  var cellMetadata = [];
  var sectionManager = new SectionManager_SectionManager(sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({
      index: index
    });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/utils/getUpdatedOffsetForIndex.js
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;
  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;

    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Collection/Collection.js














/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection_Collection =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(Collection, _React$PureComponent);

  function Collection(props, context) {
    var _this;

    classCallCheck_default()(this, Collection);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(Collection).call(this, props, context));
    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = []; // Cell cache during scroll (for performance)

    _this._cellCache = [];
    _this._isScrollingChange = _this._isScrollingChange.bind(assertThisInitialized_default()(_this));
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(assertThisInitialized_default()(_this));
    return _this;
  }

  createClass_default()(Collection, [{
    key: "forceUpdate",
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }
    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];

      this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */

  }, {
    key: "render",
    value: function render() {
      var props = extends_default()({}, this.props);

      return external_react_["createElement"](Collection_CollectionView, extends_default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }
    /** CellLayoutManager interface */

  }, {
    key: "calculateSizeAndPositionData",
    value: function calculateSizeAndPositionData() {
      var _this$props = this.props,
          cellCount = _this$props.cellCount,
          cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter,
          sectionSize = _this$props.sectionSize;

      var data = calculateSizeAndPositionData_calculateSizeAndPositionData({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: "getLastRenderedIndices",
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: "getScrollPositionForCell",
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;

      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];
        scrollLeft = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });
        scrollTop = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _this$props2 = this.props,
          cellGroupRenderer = _this$props2.cellGroupRenderer,
          cellRenderer = _this$props2.cellRenderer; // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });
      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({
            index: index
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: "_setCollectionViewRef",
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(external_react_["PureComponent"]);

defineProperty_default()(Collection_Collection, "defaultProps", {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
});


Collection_Collection.propTypes =  false ? undefined : {};

function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;
  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({
      index: index
    });
    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    }; // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.

    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Collection/index.js

/* harmony default export */ var es_Collection = (Collection_Collection);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/ColumnSizer/ColumnSizer.js








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer_ColumnSizer =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    var _this;

    classCallCheck_default()(this, ColumnSizer);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(ColumnSizer).call(this, props, context));
    _this._registerChild = _this._registerChild.bind(assertThisInitialized_default()(_this));
    return _this;
  }

  createClass_default()(ColumnSizer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          columnMaxWidth = _this$props.columnMaxWidth,
          columnMinWidth = _this$props.columnMinWidth,
          columnCount = _this$props.columnCount,
          width = _this$props.width;

      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          columnMaxWidth = _this$props2.columnMaxWidth,
          columnMinWidth = _this$props2.columnMinWidth,
          columnCount = _this$props2.columnCount,
          width = _this$props2.width;
      var safeColumnMinWidth = columnMinWidth || 1;
      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);
      var adjustedWidth = Math.min(width, columnWidth * columnCount);
      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(external_react_["PureComponent"]);


ColumnSizer_ColumnSizer.propTypes =  false ? undefined : {};
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/ColumnSizer/index.js

/* harmony default export */ var es_ColumnSizer = (ColumnSizer_ColumnSizer);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(270);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/InfiniteLoader/InfiniteLoader.js











/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader_InfiniteLoader =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    var _this;

    classCallCheck_default()(this, InfiniteLoader);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(InfiniteLoader).call(this, props, context));
    _this._loadMoreRowsMemoizer = createCallbackMemoizer();
    _this._onRowsRendered = _this._onRowsRendered.bind(assertThisInitialized_default()(_this));
    _this._registerChild = _this._registerChild.bind(assertThisInitialized_default()(_this));
    return _this;
  }

  createClass_default()(InfiniteLoader, [{
    key: "resetLoadMoreRowsCache",
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = createCallbackMemoizer();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;
      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);

        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;
      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: "_doStuff",
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
          _this3 = this;

      var _this$props = this.props,
          isRowLoaded = _this$props.isRowLoaded,
          minimumBatchSize = _this$props.minimumBatchSize,
          rowCount = _this$props.rowCount,
          threshold = _this$props.threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      }); // For memoize comparison

      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, toConsumableArray_default()(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
            stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: {
          squashedUnloadedRanges: squashedUnloadedRanges
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(external_react_["PureComponent"]);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


defineProperty_default()(InfiniteLoader_InfiniteLoader, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});


InfiniteLoader_InfiniteLoader.propTypes =  false ? undefined : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
      startIndex = _ref4.startIndex,
      stopIndex = _ref4.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */

function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
      minimumBatchSize = _ref5.minimumBatchSize,
      rowCount = _ref5.rowCount,
      startIndex = _ref5.startIndex,
      stopIndex = _ref5.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({
      index: index
    });

    if (!loaded) {
      rangeStopIndex = index;

      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });
      rangeStartIndex = rangeStopIndex = null;
    }
  } // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.


  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({
        index: _index
      })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  } // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.


  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({
        index: _index2
      })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}
/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */

function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/InfiniteLoader/index.js

/* harmony default export */ var es_InfiniteLoader = (InfiniteLoader_InfiniteLoader);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/List/types.js

var bpfrpt_proptype_RowRendererParams =  true ? null : undefined;
var bpfrpt_proptype_RowRenderer =  true ? null : undefined;
var bpfrpt_proptype_RenderedRows =  true ? null : undefined;
var types_bpfrpt_proptype_Scroll =  true ? null : undefined;





// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/List/List.js









var List_class, List_temp;




/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List_List = (List_temp = List_class =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "Grid", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });

    return _this;
  }

  createClass_default()(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = clsx_m('ReactVirtualized__List', className);
      return external_react_["createElement"](es_Grid_Grid, extends_default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(external_react_["PureComponent"]), defineProperty_default()(List_class, "propTypes",  true ? null : undefined), List_temp);

defineProperty_default()(List_List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});














// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/List/index.js




// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__(271);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/vendor/binarySearchBounds.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/
function _GEA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GEP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GTP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LTP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LEP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function _EQP(a, l, h, y, c) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);

    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ var binarySearchBounds = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/vendor/intervalTree.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);

  if (idx < 0) {
    return NOT_FOUND;
  }

  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);

  if (this.left) {
    this.left.intervals(result);
  }

  if (this.right) {
    this.right.intervals(result);
  }

  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;

  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin);
    var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;

  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }

    var rw = this.right ? this.right.count : 0;

    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.left.remove(interval);

    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }

    var lw = this.left ? this.left.count : 0;

    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.right.remove(interval);

    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }

    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;

        while (n.right) {
          p = n;
          n = n.right;
        }

        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }

        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }

      return SUCCESS;
    }

    for (var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }

      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);

        for (var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }

    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];

  if (d) {
    return d;
  }

  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];

  if (d) {
    return d;
  }

  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }

  var pts = [];

  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }

  pts.sort(compareNumbers);
  var mid = pts[pts.length >> 1];
  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];

  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];

    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  } //Split center intervals


  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);
  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
} //User friendly wrapper that makes it possible to support empty trees


function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);

    if (r === EMPTY) {
      this.root = null;
    }

    return r !== NOT_FOUND;
  }

  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }

    return 0;
  }
});
Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }

    return [];
  }
});
function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }

  return new IntervalTree(createIntervalTree(intervals));
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Masonry/PositionCache.js






// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache_PositionCache =
/*#__PURE__*/
function () {
  function PositionCache() {
    classCallCheck_default()(this, PositionCache);

    defineProperty_default()(this, "_columnSizeMap", {});

    defineProperty_default()(this, "_intervalTree", createWrapper());

    defineProperty_default()(this, "_leftMap", {});
  }

  createClass_default()(PositionCache, [{
    key: "estimateTotalHeight",
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    } // Render all cells visible within the viewport range defined.

  }, {
    key: "range",
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);

      this._leftMap[index] = left;
      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];

      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: "count",
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: "tallestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Masonry/Masonry.js








var Masonry_class, Masonry_temp;

function Masonry_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Masonry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Masonry_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Masonry_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var emptyObject = {};
/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry_Masonry = (Masonry_temp = Masonry_class =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(Masonry, _React$PureComponent);

  function Masonry() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, Masonry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(Masonry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      isScrolling: false,
      scrollTop: 0
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_debounceResetIsScrollingId", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_invalidateOnUpdateStartIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_invalidateOnUpdateStopIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_positionCache", new PositionCache_PositionCache());

    defineProperty_default()(assertThisInitialized_default()(_this), "_startIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_startIndexMemoized", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_stopIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_stopIndexMemoized", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_debounceResetIsScrollingCallback", function () {
      _this.setState({
        isScrolling: false
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScroll", function (event) {
      var height = _this.props.height;
      var eventScrollTop = event.currentTarget.scrollTop; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop); // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.

      if (eventScrollTop !== scrollTop) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._debounceResetIsScrolling(); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.


      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    });

    return _this;
  }

  createClass_default()(Masonry, [{
    key: "clearCellPositions",
    value: function clearCellPositions() {
      this._positionCache = new PositionCache_PositionCache();
      this.forceUpdate();
    } // HACK This method signature was intended for Grid

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref) {
      var index = _ref.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: "recomputeCellPositions",
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;
      this._positionCache = new PositionCache_PositionCache();

      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        requestAnimationTimeout_cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          cellCount = _this$props.cellCount,
          cellMeasurerCache = _this$props.cellMeasurerCache,
          cellRenderer = _this$props.cellRenderer,
          className = _this$props.className,
          height = _this$props.height,
          id = _this$props.id,
          keyMapper = _this$props.keyMapper,
          overscanByPixels = _this$props.overscanByPixels,
          role = _this$props.role,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex,
          width = _this$props.width,
          rowDirection = _this$props.rowDirection;
      var _this$state = this.state,
          isScrolling = _this$state.isScrolling,
          scrollTop = _this$state.scrollTop;
      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;
      var startIndex = 0;
      var stopIndex;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, defineProperty_default()(_style, rowDirection === 'ltr' ? 'left' : 'right', left), defineProperty_default()(_style, "position", 'absolute'), defineProperty_default()(_style, "top", top), defineProperty_default()(_style, "width", cellMeasurerCache.getWidth(index)), _style)
        }));
      }); // We need to measure additional cells for this layout


      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;
          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;
      return external_react_["createElement"]("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Masonry', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: Masonry_objectSpread({
          boxSizing: 'border-box',
          direction: 'ltr',
          height: autoHeight ? 'auto' : height,
          overflowX: 'hidden',
          overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
          position: 'relative',
          width: width,
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform'
        }, style),
        tabIndex: tabIndex
      }, external_react_["createElement"]("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: '100%',
          height: estimateTotalHeight,
          maxWidth: '100%',
          maxHeight: estimateTotalHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }
      }, children));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var startIndex = this._invalidateOnUpdateStartIndex;
        var stopIndex = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null; // Query external layout logic for position of newly-measured cells

        this._populatePositionCache(startIndex, stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._debounceResetIsScrollingId) {
        requestAnimationTimeout_cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = requestAnimationTimeout_requestAnimationTimeout(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function _getEstimatedTotalHeight() {
      var _this$props2 = this.props,
          cellCount = _this$props2.cellCount,
          cellMeasurerCache = _this$props2.cellMeasurerCache,
          width = _this$props2.width;
      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function _invokeOnScrollCallback() {
      var _this$props3 = this.props,
          height = _this$props3.height,
          onScroll = _this$props3.onScroll;
      var scrollTop = this.state.scrollTop;

      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });
        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var onCellsRendered = this.props.onCellsRendered;
        onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });
        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _this$props4 = this.props,
          cellMeasurerCache = _this$props4.cellMeasurerCache,
          cellPositioner = _this$props4.cellPositioner;

      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            left = _cellPositioner.left,
            top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(external_react_["PureComponent"]), defineProperty_default()(Masonry_class, "propTypes",  true ? null : undefined), Masonry_temp);

defineProperty_default()(Masonry_Masonry, "defaultProps", {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
});

function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : undefined;
Object(react_lifecycles_compat_es["polyfill"])(Masonry_Masonry);
/* harmony default export */ var es_Masonry_Masonry = (Masonry_Masonry);
var bpfrpt_proptype_Positioner =  true ? null : undefined;




// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Masonry/createCellPositioner.js
function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === void 0 ? 0 : _ref$spacer;
  var columnHeights;
  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;

    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;
    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];

    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;
    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;
  return cellPositioner;
}


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Masonry/index.js


/* harmony default export */ var es_Masonry = (es_Masonry_Masonry);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/MultiGrid/CellMeasurerCacheDecorator.js





/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator_CellMeasurerCacheDecorator =
/*#__PURE__*/
function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck_default()(this, CellMeasurerCacheDecorator);

    defineProperty_default()(this, "_cellMeasurerCache", void 0);

    defineProperty_default()(this, "_columnIndexOffset", void 0);

    defineProperty_default()(this, "_rowIndexOffset", void 0);

    defineProperty_default()(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    });

    defineProperty_default()(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    });

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  createClass_default()(CellMeasurerCacheDecorator, [{
    key: "clear",
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/MultiGrid/MultiGrid.js










function MultiGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MultiGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MultiGrid_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MultiGrid_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var SCROLLBAR_SIZE_BUFFER = 20;
/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid_MultiGrid =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    var _this;

    classCallCheck_default()(this, MultiGrid);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(MultiGrid).call(this, props, context));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_deferredInvalidateColumnIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_deferredInvalidateRowIndex", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "_bottomLeftGridRef", function (ref) {
      _this._bottomLeftGrid = ref;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_bottomRightGridRef", function (ref) {
      _this._bottomRightGrid = ref;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_cellRendererBottomLeftGrid", function (_ref) {
      var rowIndex = _ref.rowIndex,
          rest = objectWithoutProperties_default()(_ref, ["rowIndex"]);

      var _this$props = _this.props,
          cellRenderer = _this$props.cellRenderer,
          fixedRowCount = _this$props.fixedRowCount,
          rowCount = _this$props.rowCount;

      if (rowIndex === rowCount - fixedRowCount) {
        return external_react_["createElement"]("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          parent: assertThisInitialized_default()(_this),
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_cellRendererBottomRightGrid", function (_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex,
          rest = objectWithoutProperties_default()(_ref2, ["columnIndex", "rowIndex"]);

      var _this$props2 = _this.props,
          cellRenderer = _this$props2.cellRenderer,
          fixedColumnCount = _this$props2.fixedColumnCount,
          fixedRowCount = _this$props2.fixedRowCount;
      return cellRenderer(MultiGrid_objectSpread({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: assertThisInitialized_default()(_this),
        rowIndex: rowIndex + fixedRowCount
      }));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_cellRendererTopRightGrid", function (_ref3) {
      var columnIndex = _ref3.columnIndex,
          rest = objectWithoutProperties_default()(_ref3, ["columnIndex"]);

      var _this$props3 = _this.props,
          cellRenderer = _this$props3.cellRenderer,
          columnCount = _this$props3.columnCount,
          fixedColumnCount = _this$props3.fixedColumnCount;

      if (columnIndex === columnCount - fixedColumnCount) {
        return external_react_["createElement"]("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: assertThisInitialized_default()(_this)
        }));
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_columnWidthRightGrid", function (_ref4) {
      var index = _ref4.index;
      var _this$props4 = _this.props,
          columnCount = _this$props4.columnCount,
          fixedColumnCount = _this$props4.fixedColumnCount,
          columnWidth = _this$props4.columnWidth;
      var _this$state = _this.state,
          scrollbarSize = _this$state.scrollbarSize,
          showHorizontalScrollbar = _this$state.showHorizontalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
        return scrollbarSize;
      }

      return typeof columnWidth === 'function' ? columnWidth({
        index: index + fixedColumnCount
      }) : columnWidth;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScroll", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft,
          scrollTop = scrollInfo.scrollTop;

      _this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      var onScroll = _this.props.onScroll;

      if (onScroll) {
        onScroll(scrollInfo);
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScrollbarPresenceChange", function (_ref5) {
      var horizontal = _ref5.horizontal,
          size = _ref5.size,
          vertical = _ref5.vertical;
      var _this$state2 = _this.state,
          showHorizontalScrollbar = _this$state2.showHorizontalScrollbar,
          showVerticalScrollbar = _this$state2.showVerticalScrollbar;

      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
        _this.setState({
          scrollbarSize: size,
          showHorizontalScrollbar: horizontal,
          showVerticalScrollbar: vertical
        });

        var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;

        if (typeof onScrollbarPresenceChange === 'function') {
          onScrollbarPresenceChange({
            horizontal: horizontal,
            size: size,
            vertical: vertical
          });
        }
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScrollLeft", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;

      _this._onScroll({
        scrollLeft: scrollLeft,
        scrollTop: _this.state.scrollTop
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onScrollTop", function (scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;

      _this._onScroll({
        scrollTop: scrollTop,
        scrollLeft: _this.state.scrollLeft
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_rowHeightBottomGrid", function (_ref6) {
      var index = _ref6.index;
      var _this$props5 = _this.props,
          fixedRowCount = _this$props5.fixedRowCount,
          rowCount = _this$props5.rowCount,
          rowHeight = _this$props5.rowHeight;
      var _this$state3 = _this.state,
          scrollbarSize = _this$state3.scrollbarSize,
          showVerticalScrollbar = _this$state3.showVerticalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
        return scrollbarSize;
      }

      return typeof rowHeight === 'function' ? rowHeight({
        index: index + fixedRowCount
      }) : rowHeight;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_topLeftGridRef", function (ref) {
      _this._topLeftGrid = ref;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_topRightGridRef", function (ref) {
      _this._topRightGrid = ref;
    });

    var deferredMeasurementCache = props.deferredMeasurementCache,
        _fixedColumnCount = props.fixedColumnCount,
        _fixedRowCount = props.fixedRowCount;

    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new CellMeasurerCacheDecorator_CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new CellMeasurerCacheDecorator_CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new CellMeasurerCacheDecorator_CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }

    return _this;
  }

  createClass_default()(MultiGrid, [{
    key: "forceUpdateGrids",
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$columnIndex = _ref8.columnIndex,
          columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex,
          _ref8$rowIndex = _ref8.rowIndex,
          rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;

      var _this$props6 = this.props,
          fixedColumnCount = _this$props6.fixedColumnCount,
          fixedRowCount = _this$props6.fixedRowCount;
      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });
      this._leftGridWidth = null;
      this._topGridHeight = null;

      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          scrollLeft = _this$props7.scrollLeft,
          scrollTop = _this$props7.scrollTop;

      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }

      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          onScroll = _this$props8.onScroll,
          onSectionRendered = _this$props8.onSectionRendered,
          onScrollbarPresenceChange = _this$props8.onScrollbarPresenceChange,
          scrollLeftProp = _this$props8.scrollLeft,
          scrollToColumn = _this$props8.scrollToColumn,
          scrollTopProp = _this$props8.scrollTop,
          scrollToRow = _this$props8.scrollToRow,
          rest = objectWithoutProperties_default()(_this$props8, ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"]);

      this._prepareForRender(); // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.


      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      } // scrollTop and scrollLeft props are explicitly filtered out and ignored


      var _this$state4 = this.state,
          scrollLeft = _this$state4.scrollLeft,
          scrollTop = _this$state4.scrollTop;
      return external_react_["createElement"]("div", {
        style: this._containerOuterStyle
      }, external_react_["createElement"]("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(rest), this._renderTopRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollLeft: scrollLeft
      }))), external_react_["createElement"]("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollTop: scrollTop
      })), this._renderBottomRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        onSectionRendered: onSectionRendered,
        scrollLeft: scrollLeft,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow,
        scrollTop: scrollTop
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function _getBottomGridHeight(props) {
      var height = props.height;

      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;

      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({
              index: index
            });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function _getRightGridWidth(props) {
      var width = props.width;

      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: "_getTopGridHeight",
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;

      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({
              index: index
            });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: "_maybeCalculateCachedStyles",
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _this$props9 = this.props,
          columnWidth = _this$props9.columnWidth,
          enableFixedColumnScroll = _this$props9.enableFixedColumnScroll,
          enableFixedRowScroll = _this$props9.enableFixedRowScroll,
          height = _this$props9.height,
          fixedColumnCount = _this$props9.fixedColumnCount,
          fixedRowCount = _this$props9.fixedRowCount,
          rowHeight = _this$props9.rowHeight,
          style = _this$props9.style,
          styleBottomLeftGrid = _this$props9.styleBottomLeftGrid,
          styleBottomRightGrid = _this$props9.styleBottomRightGrid,
          styleTopLeftGrid = _this$props9.styleTopLeftGrid,
          styleTopRightGrid = _this$props9.styleTopRightGrid,
          width = _this$props9.width;
      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = MultiGrid_objectSpread({
          height: height,
          overflow: 'visible',
          // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };
        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible',
          // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: "_prepareForRender",
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;

      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = external_react_["createElement"](es_Grid_Grid, extends_default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return external_react_["createElement"]("div", {
          className: "BottomLeftGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._bottomLeftGridStyle, {
            height: height,
            width: width,
            overflowY: 'hidden'
          })
        }, bottomLeftGrid);
      }

      return bottomLeftGrid;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;
      return external_react_["createElement"](es_Grid_Grid, extends_default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;

      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return external_react_["createElement"](es_Grid_Grid, extends_default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _this$state5 = this.state,
          showHorizontalScrollbar = _this$state5.showHorizontalScrollbar,
          scrollbarSize = _this$state5.scrollbarSize;

      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = MultiGrid_objectSpread({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = external_react_["createElement"](es_Grid_Grid, extends_default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return external_react_["createElement"]("div", {
          className: "TopRightGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._topRightGridStyle, {
            height: height,
            width: width,
            overflowX: 'hidden'
          })
        }, topRightGrid);
      }

      return topRightGrid;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(external_react_["PureComponent"]);

defineProperty_default()(MultiGrid_MultiGrid, "defaultProps", {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
});

MultiGrid_MultiGrid.propTypes =  false ? undefined : {};
Object(react_lifecycles_compat_es["polyfill"])(MultiGrid_MultiGrid);
/* harmony default export */ var es_MultiGrid_MultiGrid = (MultiGrid_MultiGrid);
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/MultiGrid/index.js

/* harmony default export */ var es_MultiGrid = (es_MultiGrid_MultiGrid);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/ScrollSync/ScrollSync.js








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync_ScrollSync =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    var _this;

    classCallCheck_default()(this, ScrollSync);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(ScrollSync).call(this, props, context));
    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };
    _this._onScroll = _this._onScroll.bind(assertThisInitialized_default()(_this));
    return _this;
  }

  createClass_default()(ScrollSync, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          clientHeight = _this$state.clientHeight,
          clientWidth = _this$state.clientWidth,
          scrollHeight = _this$state.scrollHeight,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop,
          scrollWidth = _this$state.scrollWidth;
      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;
      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(external_react_["PureComponent"]);


ScrollSync_ScrollSync.propTypes =  false ? undefined : {};
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/ScrollSync/index.js

/* harmony default export */ var es_ScrollSync = (ScrollSync_ScrollSync);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/createMultiSort.js
function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === void 0 ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error("Required parameter \"sortCallback\" not specified");
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};
  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection[dataKey] !== undefined ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection[dataKey] !== undefined) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);

      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      // Clear sortBy array of all non-selected keys
      sortBy.length = 0;
      sortBy.push(dataKey); // Clear sortDirection object of all non-selected keys

      var sortDirectionKeys = Object.keys(sortDirection);
      sortDirectionKeys.forEach(function (key) {
        if (key !== dataKey) delete sortDirection[key];
      }); // If key is already selected, reverse sort direction.
      // Else, set sort direction to default direction.

      if (sortDirection[dataKey] !== undefined) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    } // Notify application code


    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/types.js
var bpfrpt_proptype_CellDataGetterParams =  true ? null : undefined;
var types_bpfrpt_proptype_CellRendererParams =  true ? null : undefined;
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : undefined;
var bpfrpt_proptype_HeaderRendererParams =  true ? null : undefined;
var types_bpfrpt_proptype_RowRendererParams =  true ? null : undefined;






// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/defaultCellDataGetter.js
/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/defaultCellRenderer.js
/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/defaultHeaderRowRenderer.js

function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;
  return external_react_["createElement"]("div", {
    className: className,
    role: "row",
    style: style
  }, columns);
}
defaultHeaderRowRenderer.propTypes =  true ? null : undefined;


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/SortDirection.js
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};
/* harmony default export */ var Table_SortDirection = (SortDirection);
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/SortIndicator.js




/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */

function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;
  var classNames = clsx_m('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === Table_SortDirection.ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === Table_SortDirection.DESC
  });
  return external_react_["createElement"]("svg", {
    className: classNames,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, sortDirection === Table_SortDirection.ASC ? external_react_["createElement"]("path", {
    d: "M7 14l5-5 5 5z"
  }) : external_react_["createElement"]("path", {
    d: "M7 10l5 5 5-5z"
  }), external_react_["createElement"]("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
SortIndicator.propTypes =  false ? undefined : {};
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/defaultHeaderRenderer.js



/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;
  var showSortIndicator = sortBy === dataKey;
  var children = [external_react_["createElement"]("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof label === 'string' ? label : null
  }, label)];

  if (showSortIndicator) {
    children.push(external_react_["createElement"](SortIndicator, {
      key: "SortIndicator",
      sortDirection: sortDirection
    }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : undefined;


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/defaultRowRenderer.js



/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;
  var a11yProps = {
    'aria-rowindex': index + 1
  };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
  }

  return external_react_["createElement"]("div", extends_default()({}, a11yProps, {
    className: className,
    key: key,
    role: "row",
    style: style
  }), columns);
}
defaultRowRenderer.propTypes =  true ? null : undefined;


// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/Column.js











/**
 * Describes the header and cell contents of a table column.
 */

var Column_Column =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(Column, _React$Component);

  function Column() {
    classCallCheck_default()(this, Column);

    return possibleConstructorReturn_default()(this, getPrototypeOf_default()(Column).apply(this, arguments));
  }

  return Column;
}(external_react_["Component"]);

defineProperty_default()(Column_Column, "defaultProps", {
  cellDataGetter: defaultCellDataGetter,
  cellRenderer: defaultCellRenderer,
  defaultSortDirection: Table_SortDirection.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: defaultHeaderRenderer,
  style: {}
});


Column_Column.propTypes =  false ? undefined : {};
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/Table.js









function Table_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Table_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Table_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Table_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table_Table =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(Table, _React$PureComponent);

  function Table(props) {
    var _this;

    classCallCheck_default()(this, Table);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(Table).call(this, props));
    _this.state = {
      scrollbarWidth: 0
    };
    _this._createColumn = _this._createColumn.bind(assertThisInitialized_default()(_this));
    _this._createRow = _this._createRow.bind(assertThisInitialized_default()(_this));
    _this._onScroll = _this._onScroll.bind(assertThisInitialized_default()(_this));
    _this._onSectionRendered = _this._onSectionRendered.bind(assertThisInitialized_default()(_this));
    _this._setRef = _this._setRef.bind(assertThisInitialized_default()(_this));
    return _this;
  }

  createClass_default()(Table, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(external_react_dom_["findDOMNode"])(this.Grid);

        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }

      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disableHeader = _this$props.disableHeader,
          gridClassName = _this$props.gridClassName,
          gridStyle = _this$props.gridStyle,
          headerHeight = _this$props.headerHeight,
          headerRowRenderer = _this$props.headerRowRenderer,
          height = _this$props.height,
          id = _this$props.id,
          noRowsRenderer = _this$props.noRowsRenderer,
          rowClassName = _this$props.rowClassName,
          rowStyle = _this$props.rowStyle,
          scrollToIndex = _this$props.scrollToIndex,
          style = _this$props.style,
          width = _this$props.width;
      var scrollbarWidth = this.state.scrollbarWidth;
      var availableRowsHeight = disableHeader ? height : height - headerHeight;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: -1
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: -1
      }) : rowStyle; // Precompute and cache column styles before rendering rows and columns to speed things up

      this._cachedColumnStyles = [];
      external_react_["Children"].toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = Table_objectSpread({
          overflow: 'hidden'
        }, flexStyles);
      }); // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.

      return external_react_["createElement"]("div", {
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-colcount": external_react_["Children"].toArray(children).length,
        "aria-rowcount": this.props.rowCount,
        className: clsx_m('ReactVirtualized__Table', className),
        id: id,
        role: "grid",
        style: style
      }, !disableHeader && headerRowRenderer({
        className: clsx_m('ReactVirtualized__Table__headerRow', rowClass),
        columns: this._getHeaderColumns(),
        style: Table_objectSpread({
          height: headerHeight,
          overflow: 'hidden',
          paddingRight: scrollbarWidth,
          width: width
        }, rowStyleObject)
      }), external_react_["createElement"](es_Grid_Grid, extends_default()({}, this.props, {
        "aria-readonly": null,
        autoContainerWidth: true,
        className: clsx_m('ReactVirtualized__Table__Grid', gridClassName),
        cellRenderer: this._createRow,
        columnWidth: width,
        columnCount: 1,
        height: availableRowsHeight,
        id: undefined,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: scrollbarWidth,
        scrollToRow: scrollToIndex,
        style: Table_objectSpread({}, gridStyle, {
          overflowX: 'hidden'
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;
      var cellData = cellDataGetter({
        columnData: columnData,
        dataKey: dataKey,
        rowData: rowData
      });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({
          columnData: columnData,
          dataKey: dataKey,
          event: event
        });
      };

      var style = this._cachedColumnStyles[columnIndex];
      var title = typeof renderedCell === 'string' ? renderedCell : null; // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942

      return external_react_["createElement"]("div", {
        "aria-colindex": columnIndex + 1,
        "aria-describedby": id,
        className: clsx_m('ReactVirtualized__Table__rowColumn', className),
        key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
        onClick: onClick,
        role: "gridcell",
        style: style,
        title: title
      }, renderedCell);
    }
  }, {
    key: "_createHeader",
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _this$props2 = this.props,
          headerClassName = _this$props2.headerClassName,
          headerStyle = _this$props2.headerStyle,
          onHeaderClick = _this$props2.onHeaderClick,
          sort = _this$props2.sort,
          sortBy = _this$props2.sortBy,
          sortDirection = _this$props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;
      var sortEnabled = !disableSort && sort;
      var classNames = clsx_m('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });

      var style = this._getFlexStyleForColumn(column, Table_objectSpread({}, headerStyle, {}, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });
      var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey; // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.

        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === Table_SortDirection.DESC ? Table_SortDirection.ASC : Table_SortDirection.DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({
            columnData: columnData,
            dataKey: dataKey,
            event: event
          });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === Table_SortDirection.ASC ? 'ascending' : 'descending';
      } // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942


      return external_react_["createElement"]("div", {
        "aria-label": headerAriaLabel,
        "aria-sort": headerAriaSort,
        className: classNames,
        id: id,
        key: 'Header-Col' + index,
        onClick: headerOnClick,
        onKeyDown: headerOnKeyDown,
        role: "columnheader",
        style: style,
        tabIndex: headerTabIndex
      }, renderedHeader);
    }
  }, {
    key: "_createRow",
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _this$props3 = this.props,
          children = _this$props3.children,
          onRowClick = _this$props3.onRowClick,
          onRowDoubleClick = _this$props3.onRowDoubleClick,
          onRowRightClick = _this$props3.onRowRightClick,
          onRowMouseOver = _this$props3.onRowMouseOver,
          onRowMouseOut = _this$props3.onRowMouseOut,
          rowClassName = _this$props3.rowClassName,
          rowGetter = _this$props3.rowGetter,
          rowRenderer = _this$props3.rowRenderer,
          rowStyle = _this$props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: index
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: index
      }) : rowStyle;
      var rowData = rowGetter({
        index: index
      });
      var columns = external_react_["Children"].toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });
      var className = clsx_m('ReactVirtualized__Table__row', rowClass);

      var flattenedStyle = Table_objectSpread({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: "_getFlexStyleForColumn",
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");

      var style = Table_objectSpread({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: "_getHeaderColumns",
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          disableHeader = _this$props4.disableHeader;
      var items = disableHeader ? [] : external_react_["Children"].toArray(children);
      return items.map(function (column, index) {
        return _this4._createHeader({
          column: column,
          index: index
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;
      return typeof rowHeight === 'function' ? rowHeight({
        index: rowIndex
      }) : rowHeight;
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: "_setRef",
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: scrollbarWidth
      });
    }
  }]);

  return Table;
}(external_react_["PureComponent"]);

defineProperty_default()(Table_Table, "defaultProps", {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  rowRenderer: defaultRowRenderer,
  headerRowRenderer: defaultHeaderRowRenderer,
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});


Table_Table.propTypes =  false ? undefined : {};

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/Table/index.js










/* harmony default export */ var es_Table = (Table_Table);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/WindowScroller/utils/onScroll.js

var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    requestAnimationTimeout_cancelAnimationTimeout(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });
  disablePointerEventsTimeoutId = requestAnimationTimeout_requestAnimationTimeout(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
  }

  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }

  mountedInstances.push(component);
}
function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });

  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);

    if (disablePointerEventsTimeoutId) {
      requestAnimationTimeout_cancelAnimationTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/WindowScroller/utils/dimensions.js
/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
// TODO Move this into WindowScroller and import from there
var isWindow = function isWindow(element) {
  return element === window;
};

var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;
    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}
/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */

function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);

    var _elementRect = getBoundingBox(element);

    var _containerRect = getBoundingBox(container);

    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}
/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */

function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}
// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/WindowScroller/WindowScroller.js








var WindowScroller_class, WindowScroller_temp;

function WindowScroller_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WindowScroller_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WindowScroller_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WindowScroller_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var WindowScroller_IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller_WindowScroller = (WindowScroller_temp = WindowScroller_class =
/*#__PURE__*/
function (_React$PureComponent) {
  inherits_default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, WindowScroller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(WindowScroller)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "_window", getWindow());

    defineProperty_default()(assertThisInitialized_default()(_this), "_isMounted", false);

    defineProperty_default()(assertThisInitialized_default()(_this), "_positionFromTop", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_positionFromLeft", 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_detectElementResize", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "_child", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "state", WindowScroller_objectSpread({}, getDimensions(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }));

    defineProperty_default()(assertThisInitialized_default()(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }

      _this._child = element;

      _this.updatePosition();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onChildScroll", function (_ref) {
      var scrollTop = _ref.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_registerResizeListener", function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_unregisterResizeListener", function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "_onResize", function () {
      _this.updatePosition();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "__handleWindowScrollEvent", function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;
      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        var scrollOffset = getScrollOffset(scrollElement);
        var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        onScroll({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "__resetIsScrolling", function () {
      _this.setState({
        isScrolling: false
      });
    });

    return _this;
  }

  createClass_default()(WindowScroller, [{
    key: "updatePosition",
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width;
      var thisNode = this._child || external_react_dom_["findDOMNode"](this);

      if (thisNode instanceof Element && scrollElement) {
        var offset = getPositionOffset(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = getDimensions(scrollElement, this.props);

      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;
      this._detectElementResize = Object(detectElementResize["a" /* default */])();
      this.updatePosition(scrollElement);

      if (scrollElement) {
        registerScrollListener(this, scrollElement);

        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;

      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);
        unregisterScrollListener(this, prevScrollElement);
        registerScrollListener(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);

        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;

      if (scrollElement) {
        unregisterScrollListener(this, scrollElement);

        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state2 = this.state,
          isScrolling = _this$state2.isScrolling,
          scrollTop = _this$state2.scrollTop,
          scrollLeft = _this$state2.scrollLeft,
          height = _this$state2.height,
          width = _this$state2.width;
      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }
  }]);

  return WindowScroller;
}(external_react_["PureComponent"]), defineProperty_default()(WindowScroller_class, "propTypes",  true ? null : undefined), WindowScroller_temp);

defineProperty_default()(WindowScroller_WindowScroller, "defaultProps", {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: WindowScroller_IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
});



// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/WindowScroller/index.js

/* harmony default export */ var es_WindowScroller = (WindowScroller_WindowScroller);

// CONCATENATED MODULE: ./node_modules/react-virtualized/dist/es/index.js














/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(381);

var iterableToArray = __webpack_require__(382);

var unsupportedIterableToArray = __webpack_require__(253);

var nonIterableSpread = __webpack_require__(383);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(384);

var iterableToArrayLimit = __webpack_require__(385);

var unsupportedIterableToArray = __webpack_require__(253);

var nonIterableRest = __webpack_require__(386);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var reducer_1 = __webpack_require__(59);
var header_1 = __importDefault(__webpack_require__(275));
var FedHeaderContext = function (props) {
    var defaultData = __assign(__assign(__assign({}, context_1.initData), props), { hasProToken: false, 
        // 货币列表
        localCurrencysList: [], 
        // 当前选中货币
        localRate: '', bodyWidth: 0, passKeyVisible: false });
    var _a = (0, react_1.useReducer)(reducer_1.reducer, defaultData), globalState = _a[0], dispatch = _a[1];
    (0, react_1.useEffect)(function () {
        dispatch({
            type: 'all',
            data: props,
        });
    }, [props]);
    return (react_1.default.createElement(context_1.HeaderContext.Provider, { value: { globalState: globalState, dispatch: dispatch } },
        react_1.default.createElement(header_1.default, __assign({}, props))));
};
exports.default = FedHeaderContext;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(31));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var animationNav_1 = __webpack_require__(237);
var dataTrans_1 = __webpack_require__(276);
var httpReq_1 = __importDefault(__webpack_require__(23));
var url_js_1 = __webpack_require__(18);
var links_1 = __webpack_require__(95);
var sensors_1 = __webpack_require__(27);
var function_1 = __webpack_require__(64);
var lang_config_1 = __webpack_require__(40);
var expiresStore_1 = __webpack_require__(335);
var exchangeRate_1 = __webpack_require__(336);
var logo_svg_1 = __importDefault(__webpack_require__(141));
var logo__light_svg_1 = __importDefault(__webpack_require__(337));
var logocn_svg_1 = __importDefault(__webpack_require__(142));
var logocn__light_svg_1 = __importDefault(__webpack_require__(338));
var throttle_1 = __importDefault(__webpack_require__(238));
var common_dropdown_1 = __importDefault(__webpack_require__(339));
var menu_dropdown_1 = __importDefault(__webpack_require__(143));
var v2_1 = __importDefault(__webpack_require__(340));
var download_1 = __importDefault(__webpack_require__(343));
var search_menu_1 = __importDefault(__webpack_require__(377));
var small_search_menu_1 = __importDefault(__webpack_require__(417));
var langs_1 = __importDefault(__webpack_require__(152));
var currencys_1 = __importDefault(__webpack_require__(418));
var panel_finance_1 = __importDefault(__webpack_require__(419));
var panel_user_1 = __importDefault(__webpack_require__(422));
var panel_nav_1 = __importDefault(__webpack_require__(439));
var user_avatar_1 = __importDefault(__webpack_require__(262));
var drawer_1 = __importDefault(__webpack_require__(161));
var more_btn_1 = __importDefault(__webpack_require__(441));
var utils_1 = __importDefault(__webpack_require__(20));
var userObj = {};
var FedHeader = function (_a) {
    var onlogin = _a.onlogin, onregister = _a.onregister, onlogout = _a.onlogout, onfiat = _a.onfiat, onAssetsVisibleChange = _a.onAssetsVisibleChange, onlocale = _a.onlocale, settingPanel = _a.settingPanel, onSwitchAccount = _a.onSwitchAccount;
    var _b = (0, react_1.useContext)(context_1.HeaderContext), globalState = _b.globalState, dispatch = _b.dispatch;
    var isLogin = globalState.isLogin, active = globalState.active, hostname = globalState.hostname, _c = globalState.theme, theme = _c === void 0 ? 'dark' : _c, locale = globalState.locale, localRate = globalState.localRate, forceUpdateUserFlag = globalState.forceUpdateUserFlag;
    var localCurrencysList = globalState.localCurrencysList, passKeyVisible = globalState.passKeyVisible;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var _d = (0, react_1.useState)(0), bodyWidth = _d[0], setBodyWidth = _d[1]; // body 尺寸
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    // 当前判断是否有pro-token
    var _e = (0, react_1.useState)(false), hasProToken = _e[0], setHasProToken = _e[1];
    // 语言下拉flag
    var _f = (0, react_1.useState)(1), langFlag = _f[0], setLangFlag = _f[1];
    // 是否已经判断登录状态
    var _g = (0, react_1.useState)(false), isLoginChecked = _g[0], setIsLoginChecked = _g[1];
    // 远程记录的货币值
    var _h = (0, react_1.useState)(''), remoteConversionCurrency = _h[0], setRemoteConversionCurrency = _h[1];
    // 导航菜单列表
    var navMenu = (0, dataTrans_1.menuTrans)(links_1.NAV_MENU_V2, hostname, locale);
    var _j = (0, react_1.useState)(navMenu), navMenus = _j[0], setNavMenus = _j[1];
    var _k = (0, react_1.useState)(navMenu), menuList = _k[0], setMenuList = _k[1];
    var _l = (0, react_1.useState)(navMenu), mobileMenuList = _l[0], setMobileMenuList = _l[1];
    // 移动样式
    var _m = (0, react_1.useState)(false), headerMobile = _m[0], setHeaderMobile = _m[1];
    // 堆叠样式
    var _o = (0, react_1.useState)(false), headerStacking = _o[0], setHeaderStacking = _o[1];
    // 是否子账号
    var _p = (0, react_1.useState)(1), userType = _p[0], setUserType = _p[1];
    // logo样式
    var _q = (0, react_1.useState)(''), logoStyle = _q[0], setLogoStyle = _q[1];
    var _r = (0, react_1.useState)(true), passKeyShow = _r[0], setPassKeyShow = _r[1]; // 通行密钥是否可见
    var _s = (0, i18n_1.useTranslation)(), t = _s.t, i18n = _s.i18n;
    var _t = (0, react_1.useState)({}), userInfoData = _t[0], setUserInfoData = _t[1];
    var _u = (0, react_1.useState)(false), isSearchOpen = _u[0], setIsSearchOpen = _u[1]; // 搜索
    var _v = (0, react_1.useState)(false), isNavOpen = _v[0], setIsNavOpen = _v[1];
    var _w = (0, react_1.useState)(false), isUserOpen = _w[0], setIsUserOpen = _w[1];
    var _x = (0, react_1.useState)(false), isLangOpen = _x[0], setIsLangOpen = _x[1];
    var _y = (0, react_1.useState)(false), isCurOpen = _y[0], setIsCurOpen = _y[1];
    // 移动端三级导航
    var _z = (0, react_1.useState)(false), isThreeNavOpen = _z[0], setThreeNavOpen = _z[1];
    var _0 = (0, react_1.useState)([]), threeNavList = _0[0], setThreeNavList = _0[1];
    var iconLogo = (0, react_1.useMemo)(function () {
        if (locale === 'zh-cn') {
            setLogoStyle('header-nav-logocn');
            return theme === 'dark' ? logocn_svg_1.default : logocn__light_svg_1.default;
        }
        else {
            return theme === 'dark' ? logo_svg_1.default : logo__light_svg_1.default;
        }
    }, [theme, locale]);
    // 组件dom
    var _1 = (0, react_1.useState)(), $el = _1[0], set$El = _1[1];
    // 搜索
    var smallSearchRef = (0, react_1.useRef)();
    var smallSearchDropdownRef = (0, react_1.useRef)();
    // 查看更多按钮
    var moreBtnRef = (0, react_1.useRef)();
    // 用户头像按钮
    var userAvatarRef = (0, react_1.useRef)();
    // 消息链接
    var inmailHref = (0, react_1.useMemo)(function () {
        return (0, url_js_1.getUrl)({
            path: '/inmail',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
    }, [locale, hostname]);
    (0, react_1.useEffect)(function () {
        initPassKey();
    }, [userInfoData]);
    var initPassKey = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isSupport, isOther, isPC, isPass, _a, success, data, error_1, uIdList, uid, ucResp;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isSupport = utils_1.default.getBrowser();
                    isOther = utils_1.default.getDomainName();
                    isPC = utils_1.default.isPC();
                    // 未绑定或者浏览器不支持，则不显示
                    if (!isPC || isOther || !isSupport || userType === 2) {
                        setPassKeyShow(false);
                        return [2 /*return*/];
                    }
                    isPass = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.getSecurity()];
                case 2:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        isPass = (data === null || data === void 0 ? void 0 : data.bind_pass_key) || false;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.log('error :>> ', error_1);
                    return [3 /*break*/, 4];
                case 4:
                    // 已绑定，则不显示
                    if (isPass) {
                        setPassKeyShow(false);
                        return [2 /*return*/];
                    }
                    uIdList = [];
                    uid = utils_1.default.getCookie('htx_open_key_user_id') || '';
                    if (uid) {
                        uIdList = JSON.parse(uid);
                    }
                    ucResp = (userInfoData || {}).ucResp;
                    setPassKeyShow(uIdList.includes(ucResp === null || ucResp === void 0 ? void 0 : ucResp.uid) ? false : true);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        // 是否PC
        var isPC = utils_1.default.isPC();
        if (isPC) {
            setPassKeyShow(passKeyVisible);
        }
        else {
            setPassKeyShow(false);
        }
    }, [passKeyVisible]);
    (0, react_1.useEffect)(function () {
        var throttleFunc = (0, throttle_1.default)(200, function (width) {
            setBodyWidth(width);
            setHeaderMobile(width <= 744);
            dispatch({
                type: 'update:bodyWidth',
                bodyWidth: width,
            });
            // setHeaderStacking(menu.offsetWidth + 90 + 24 + rightEl.offsetWidth > wrapper.offsetWidth);
        });
        var ro = new ResizeObserver(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                var width = entry.contentRect.width;
                throttleFunc(width);
            }
        });
        ro.observe(document.body);
        return function () {
            ro.unobserve(document.body);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (bodyWidth === 0 || isLogin === undefined || navMenus.length === 0) {
            return;
        }
        var list = JSON.parse(JSON.stringify(navMenus));
        var menuArr = [];
        var mobileMenuArr = [];
        if (isLogin) {
            if (['ru-ru', 'pt-pt'].includes(locale)) {
                if (bodyWidth > 1700) {
                    menuArr = list;
                    mobileMenuArr = [];
                }
                else if (bodyWidth > 1470 && bodyWidth <= 1700) {
                    list = list.slice(0, 8);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 1220 && bodyWidth <= 1470) {
                    list = list.slice(0, 6);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 1085 && bodyWidth <= 1220) {
                    list = list.slice(0, 4);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 1024 && bodyWidth <= 1085) {
                    list = list.slice(0, 2);
                    menuArr = [];
                    mobileMenuArr = list;
                }
                else {
                    menuArr = [];
                    mobileMenuArr = list;
                }
            }
            else {
                if (bodyWidth > 1230) {
                    menuArr = list;
                    mobileMenuArr = [];
                }
                else if (bodyWidth > 1150 && bodyWidth <= 1230) {
                    list = list.slice(0, 8);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 1080 && bodyWidth <= 1150) {
                    list = list.slice(0, 7);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 1025 && bodyWidth <= 1080) {
                    list = list.slice(0, 6);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 980 && bodyWidth <= 1025) {
                    list = list.slice(0, 9);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 788 && bodyWidth <= 980) {
                    list = list.slice(0, 7);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth <= 788) {
                    menuArr = [];
                    mobileMenuArr = list;
                }
            }
        }
        else {
            if (['ru-ru', 'pt-pt'].includes(locale)) {
                if (bodyWidth > 1700) {
                    menuArr = list;
                    mobileMenuArr = [];
                }
                else if (bodyWidth > 1470 && bodyWidth <= 1700) {
                    list = list.slice(0, 8);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 1220 && bodyWidth <= 1470) {
                    list = list.slice(0, 6);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 910 && bodyWidth <= 1220) {
                    list = list.slice(0, 4);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth <= 910) {
                    menuArr = [];
                    mobileMenuArr = list;
                }
            }
            else {
                if (bodyWidth > 1210) {
                    menuArr = list;
                    mobileMenuArr = [];
                }
                else if (bodyWidth > 1080) {
                    list = list.slice(0, 8);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 870 && bodyWidth <= 1080) {
                    list = list.slice(0, 7);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth > 744 && bodyWidth <= 870) {
                    list = list.slice(0, 5);
                    menuArr = list;
                    mobileMenuArr = navMenus.slice(list.length);
                }
                else if (bodyWidth <= 744) {
                    menuArr = [];
                    mobileMenuArr = list;
                }
            }
        }
        setMenuList(menuArr);
        setMobileMenuList(mobileMenuArr);
    }, [bodyWidth, isLogin, navMenus]);
    (0, react_1.useEffect)(function () {
        if (url) {
            if (lang_config_1.excludeLangList.includes(locale)) {
                onlocale(null, 'en-us');
                utils_1.default.setCookie('local', 'en-us', {
                    domain: utils_1.default.getHost(1),
                    path: '/',
                    expires: 31536000,
                });
            }
            else {
                utils_1.default.setCookie('local', locale, {
                    domain: utils_1.default.getHost(1),
                    path: '/',
                    expires: 31536000,
                });
            }
            getMenuList();
        }
    }, [hostname, locale, url]);
    // 当前语言变化设置语言
    (0, react_1.useEffect)(function () {
        i18n.changeLanguage(locale, function (err, t) {
            if (err)
                return console.log('something went wrong loading', err);
            t('key');
        });
    }, [locale]);
    (0, react_1.useEffect)(function () {
        if (isLogin === undefined) {
            return;
        }
        // 登录后，查询资产
        if (isLogin) {
            var intervalId_1 = setInterval(function () {
                if (utils_1.default.getCookie('HB-PRO-TOKEN')) {
                    clearInterval(intervalId_1);
                    setProToken();
                }
            }, 100);
            return function () { return clearInterval(intervalId_1); };
        }
    }, [isLogin]);
    // 联动动画hook
    var _2 = (0, animationNav_1.useAniNav)(), isHover = _2.isHover, isAni = _2.isAni, barLeft = _2.barLeft, barWidth = _2.barWidth, disableContentInAni = _2.disableContentInAni, setEl2 = _2.setEl, setBar = _2.setBar;
    /**
     * 获取当前用户上，配置的计价币信息
     */
    var getFiatCurrency = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data, abbr, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpService.getUserInfo()];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        if (!sessionStorage.getItem('HBP_u')) {
                            sessionStorage.setItem('HBP_u', data.uid);
                        }
                        userObj = data || {};
                        // 1主账号，2子账号
                        if (data && data.user_type) {
                            setUserType(data.user_type);
                        }
                        if (data.options && data.options.conversion_currency) {
                            abbr = data.options.conversion_currency.toLowerCase();
                            setRemoteConversionCurrency(abbr);
                        }
                        else {
                            setHasProToken(false);
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    console.log('error :>> ', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var setRootLocalRate = function (rate) {
        dispatch({
            type: 'update:localRate',
            localRate: rate,
        });
    };
    var setLocalCurrencysList = function (data) {
        dispatch({
            type: 'update:localCurrencysList',
            localCurrencysList: data,
        });
    };
    // 获取远程货币列表
    var localCurrencys = function () { return __awaiter(void 0, void 0, void 0, function () {
        var localCRYS, _a, success, data, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    localCRYS = (0, expiresStore_1.get)('localCRYS');
                    if (!!localCRYS) return [3 /*break*/, 5];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.getCurrencyList()];
                case 2:
                    _a = _c.sent(), success = _a.success, data = _a.data;
                    if (success && data && data.length) {
                        setLocalCurrencysList(data);
                        // 写缓存，有效期5分钟
                        (0, expiresStore_1.set)('localCRYS', data);
                    }
                    else {
                        setLocalCurrencysList(function_1.LOCAL_CURRENCYS);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _b = _c.sent();
                    setLocalCurrencysList(function_1.LOCAL_CURRENCYS);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    setLocalCurrencysList(localCRYS);
                    _c.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // 设置默认货币
    var setDefaultLocalRate = function () {
        // 获取localStorage的值
        var localRateTmp = (0, exchangeRate_1.getDefaultRate)();
        var obj;
        // 本地写入的可能列表里没有
        if (localRateTmp) {
            obj = localCurrencysList.find(function (item) { return item.abbr.toLowerCase() === localRateTmp; });
        }
        if (!obj || !localRateTmp) {
            localRateTmp = (0, exchangeRate_1.getRateFromArr)(localCurrencysList, locale);
            obj = localCurrencysList.find(function (item) { return item.abbr.toLowerCase() === localRateTmp; });
        }
        if (obj && obj.abbr) {
            // 写入缓存
            (0, exchangeRate_1.setLocalRate)(localRateTmp);
            // 设置root
            setRootLocalRate(localRateTmp);
            obj.abbr = obj.abbr.toLocaleLowerCase();
            onfiat && onfiat(null, localRateTmp, obj);
        }
    };
    (0, react_1.useEffect)(function () {
        if (localCurrencysList.length) {
            // 如果远程数据更新
            if (remoteConversionCurrency) {
                var abbr_1 = remoteConversionCurrency;
                // 远程数据里查找
                var obj = localCurrencysList.find(function (item) { return item.abbr.toLowerCase() === abbr_1; });
                // 找不到
                if (!obj) {
                    // 获取数组数据里的默认值
                    abbr_1 = (0, exchangeRate_1.getRateFromArr)(localCurrencysList, locale);
                    obj = localCurrencysList.find(function (item) { return item.abbr.toLowerCase() === abbr_1; });
                    // 远程写入数据库，货币换算
                    setRemoteFiat(abbr_1);
                }
                // 写入缓存
                (0, exchangeRate_1.setLocalRate)(abbr_1, 'from remote');
                // 设置本地当前选中
                setRootLocalRate(abbr_1);
                obj.abbr = obj.abbr.toLocaleLowerCase();
                onfiat && onfiat(null, abbr_1, obj);
            }
            else if (!localRate) {
                // 如果本地货币未设置
                setDefaultLocalRate();
            }
        }
    }, [localCurrencysList, remoteConversionCurrency]);
    // 远程写入数据库，货币换算
    var setRemoteFiat = function (abbr) {
        if (abbr === void 0) { abbr = ''; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isLogin) return [3 /*break*/, 2];
                        return [4 /*yield*/, httpService.kvSet({
                                store_key: 'CONVERSION_CURRENCY',
                                store_value: abbr.toUpperCase(),
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // 检查登录状态
    var checkLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var success, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sessionStorage.removeItem('langList');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.checkLogin()];
                case 2:
                    success = (_a.sent()).success;
                    if (success) {
                        dispatch({
                            type: 'update:isLogin',
                            isLogin: true,
                        });
                        // 已经检查登录状态
                        setIsLoginChecked(true);
                        setProToken();
                    }
                    else {
                        if (sessionStorage.getItem('HBP_u')) {
                            sessionStorage.removeItem('HBP_u');
                        }
                        dispatch({
                            type: 'update:isLogin',
                            isLogin: false,
                        });
                        // 已经检查登录状态
                        setIsLoginChecked(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.log('error :>> ', error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // 获取pro-token
    var setProToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var dataResult, _a, success, data, error_4;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!utils_1.default.getCookie('HB-PRO-TOKEN')) return [3 /*break*/, 1];
                    setHasProToken(true);
                    dispatch({
                        type: 'update:hasProToken',
                        hasProToken: true,
                    });
                    getFiatCurrency();
                    return [3 /*break*/, 7];
                case 1:
                    _c.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, httpService.getTicket()];
                case 2:
                    dataResult = _c.sent();
                    if (!dataResult.success) return [3 /*break*/, 4];
                    return [4 /*yield*/, httpService.proLogin({
                            ticket: ((_b = dataResult.data) === null || _b === void 0 ? void 0 : _b.ticket) || '',
                        })];
                case 3:
                    _a = _c.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        // 如果存在，则先删除防止种的域名存在问题
                        utils_1.default.removeCookies('HB-PRO-TOKEN');
                        utils_1.default.setCookie('HB-PRO-TOKEN', data.token, {
                            domain: utils_1.default.getHost(1),
                            path: '/',
                        });
                        setHasProToken(true);
                        dispatch({
                            type: 'update:hasProToken',
                            hasProToken: true,
                        });
                        getFiatCurrency();
                    }
                    else {
                        setHasProToken(false);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setHasProToken(false);
                    _c.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_4 = _c.sent();
                    console.log('error :>> ', error_4);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    // 配置主动触发更新集中
    (0, react_1.useEffect)(function () {
        if (url) {
            // 不着急加载，给主进程加载留出时间
            setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localCurrencys()];
                        case 1:
                            _a.sent();
                            checkLogin();
                            return [2 /*return*/];
                    }
                });
            }); }, 1);
        }
    }, [forceUpdateUserFlag, url]);
    // 点header空白区域，关闭draw
    (0, react_1.useEffect)(function () {
        if ($el) {
            $el.addEventListener('click', function (_a) {
                var _b, _c, _d;
                var target = _a.target;
                var id = target.id;
                // 此处逻辑用于处理搜索
                if ([
                    'search_input',
                    'search_icon',
                    'search_clear',
                    'search__prompt',
                    'prompt__icon',
                    'prompt__content',
                ].includes(id)) {
                    return;
                }
                var isClickDraw = __spreadArray([], document.querySelectorAll('.HBDrawer'), true).some(function (i) { return i.contains(target); });
                if (isClickDraw) {
                    return;
                }
                if (!((_b = smallSearchRef.current) === null || _b === void 0 ? void 0 : _b.contains(target))) {
                    setIsSearchOpen(false);
                }
                if (!((_c = moreBtnRef.current) === null || _c === void 0 ? void 0 : _c.contains(target))) {
                    setIsNavOpen(false);
                }
                if (!((_d = userAvatarRef.current) === null || _d === void 0 ? void 0 : _d.contains(target))) {
                    setIsUserOpen(false);
                }
            });
        }
    }, [$el]);
    var openNavDrawer = function () {
        setIsNavOpen(!isNavOpen);
    };
    var openSearchDrawer = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'search',
            type: 'click',
        });
        setIsSearchOpen(!isSearchOpen);
    };
    var openUserDrawer = function () {
        setIsUserOpen(!isUserOpen);
    };
    var showLangs = function () {
        setIsLangOpen(true);
    };
    var hideLangs = function () {
        setIsLangOpen(false);
    };
    var showCurrencys = function () {
        setIsCurOpen(true);
    };
    var hideCurrencys = function () {
        setIsCurOpen(false);
    };
    // 获取用户信息
    var getPersonalCenterInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data_1, error_5;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpService.getPersonalCenter()];
                case 1:
                    _a = _c.sent(), success = _a.success, data_1 = _a.data;
                    if (success) {
                        // 子账号
                        if (data_1 && data_1.ucResp && userType === 2) {
                            data_1.ucResp.name = (userObj === null || userObj === void 0 ? void 0 : userObj.account_name) || '';
                        }
                        if (userType === 1 && !((_b = data_1.ucResp) === null || _b === void 0 ? void 0 : _b.name)) {
                            data_1.ucResp.name = (userObj === null || userObj === void 0 ? void 0 : userObj.phone) || (userObj === null || userObj === void 0 ? void 0 : userObj.email);
                        }
                        setUserInfoData(function (ov) { return Object.assign({}, ov, data_1); });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _c.sent();
                    console.log('error :>> ', error_5);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // 获取prime用户信息
    var getPrimeUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data_2, error_6;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpService.getWebUserInfo()];
                case 1:
                    _a = _b.sent(), success = _a.success, data_2 = _a.data;
                    if (success) {
                        setUserInfoData(function (ov) { return Object.assign({}, ov, { prime: data_2 }); });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_6 = _b.sent();
                    console.log('error :>> ', error_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getMenuList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, _a, success, data, error_7;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    params = {
                        'language': locale === 'zh-tc' ? 'zh-hk' : locale,
                        'host': hostname,
                    };
                    return [4 /*yield*/, httpService.getNavigationInfo(params)];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setNavMenus((0, dataTrans_1.remote2Local)((data && (data.levelInfos || data.firstLevel)) || []));
                    }
                    else {
                        setNavMenus((0, dataTrans_1.menuTrans)(links_1.NAV_MENU_V2, hostname, locale));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_7 = _b.sent();
                    setNavMenus((0, dataTrans_1.menuTrans)(links_1.NAV_MENU_V2, hostname, locale));
                    console.log('error :>> ', error_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // 监听pro-token
    (0, react_1.useEffect)(function () {
        if (hasProToken) {
            // 获取用户信息
            getPersonalCenterInfo();
            getPrimeUserInfo();
        }
    }, [hasProToken]);
    (0, react_1.useEffect)(function () {
        if (userType === 2) {
            // 获取用户信息
            getPersonalCenterInfo();
        }
    }, [userType]);
    // 点击登录按钮
    var onClickLogin = function (event) {
        var url = (0, url_js_1.getUrl)({
            platform: 'global',
            path: "/login/",
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'login',
            type: 'click',
        });
        onlogin(event, url);
    };
    // 点击注册按钮
    var onClickRegister = function (event) {
        var url = (0, url_js_1.getUrl)({
            platform: 'global',
            path: "/register/",
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'register',
            type: 'click',
        });
        onregister(event, url);
    };
    // 资产点击
    var onPanelFinanceClick = function (event) {
        (0, sensors_1.trackHeader)({
            button_name: 'asset',
            type: 'click',
        });
        var url = (0, url_js_1.getUrl)({
            path: '/finance/account/',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        location.href = url;
    };
    // 订单点击
    var onSelectOrder = function (event, val) {
        (0, sensors_1.trackHeader)({
            button_name: 'order',
            type: 'click',
        });
        if (val && val.path) {
            var url_1 = (0, url_js_1.getUrl)({
                path: val.path,
                platform: val.platform,
                locale: locale,
                hostname: hostname,
            });
            if (val.target === '_blank') {
                window.open(url_1);
            }
            else {
                location.href = url_1;
            }
        }
    };
    // 渲染头像
    var renderAvatar = function (point) {
        var ucResp = userInfoData.ucResp;
        return ucResp ? (react_1.default.createElement(user_avatar_1.default, { ref: userAvatarRef, uc: ucResp, size: 24, handleClick: point === 'point1' ? openUserDrawer : null })) : ('');
    };
    // 设置语言
    var onSetLang = function (event, val) {
        setLangFlag(function (n) { return n + 1; });
        setIsNavOpen(false);
        setTimeout(function () { return hideLangs(); }, 300);
        onlocale(event, val);
    };
    // 选择结算货币
    var onSetCurrencys = function (event, val) {
        setLangFlag(function (n) { return n + 1; });
        setIsNavOpen(false);
        setTimeout(function () { return hideCurrencys(); }, 300);
        var obj = localCurrencysList.find(function (item) { return item.abbr.toLowerCase() === val; });
        obj.abbr = obj.abbr.toLocaleLowerCase();
        onfiat && onfiat(event, val, obj);
    };
    // 点击logo
    var onClickLogo = function () {
        var url = (0, url_js_1.getUrl)({
            path: '/',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'logo',
        });
        location.href = url;
    };
    // 资产下拉hover
    var onPanelFinanceMouseEnter = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'asset',
            type: 'hover',
        });
    };
    // 搜索鼠标滑过
    var onSearchMouseEnter = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'search',
            type: 'hover',
        });
        smallSearchDropdownRef.current.resetData();
    };
    // 用户下拉菜单点击
    var onPanelUserClick = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'center',
            type: 'click',
        });
        var url = (0, url_js_1.getUrl)({
            path: '/user-center/security/',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        location.href = url;
    };
    // 用户下拉菜单hover
    var onPanelUserMouseEnter = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'center',
            type: 'hover',
        });
    };
    // 点击消息中心
    var onClickInmail = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'notification',
            type: 'click',
        });
        location.href = inmailHref;
    };
    // 点击prime
    var toPrimeIndex = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'vip_navBar',
            type: 'click',
        });
        var url = (0, url_js_1.getUrl)({
            path: '/member/prime/index/',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        location.href = url;
    };
    var onClickLogout = function (event, url) {
        onlogout && onlogout(event, url);
    };
    // 下载icon hover
    var onPanelDownloadMouseEnter = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'download',
            type: 'hover',
        });
    };
    // 语言下拉 hover
    var onPaneLangMouseEnter = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'language',
            type: 'hover',
        });
    };
    // 设置面板下拉 hover
    var onPanelSettingMouseEnter = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'setting',
            type: 'hover',
        });
    };
    // 未登录状态
    var renderNotLogined = function () {
        return (react_1.default.createElement("div", { className: "header-user__not-logined" },
            react_1.default.createElement("div", { className: "header-user__not-logined-item", onClick: function (event) { return onClickLogin(event); } },
                react_1.default.createElement("span", { className: "header-user__item-btn" },
                    react_1.default.createElement("span", null, t('登录')))),
            react_1.default.createElement("div", { className: "header-user__not-logined-item", onClick: function (event) { return onClickRegister(event); } },
                react_1.default.createElement("span", { className: "header-user__item-btn header-user__item-btn--primary" },
                    react_1.default.createElement("span", null, t('注册'))))));
    };
    var renderUser = function () {
        return (react_1.default.createElement("div", { className: "header__user__body__my" },
            react_1.default.createElement(common_dropdown_1.default, { className: "hbg-header-dropdown header__user__body__item", placement: "bottom-end", handleClick: onPanelFinanceClick, handleMouseEnter: onPanelFinanceMouseEnter, title: react_1.default.createElement("div", { className: "toggle" },
                    react_1.default.createElement("div", { className: "toggle__title" }, t('资产')),
                    react_1.default.createElement("i", { className: "toggle__triangle" })) },
                react_1.default.createElement(panel_finance_1.default, { onAssetEyeChange: onAssetsVisibleChange })),
            react_1.default.createElement(menu_dropdown_1.default, { className: "header__user__body__item", data: {
                    name: t('订单'),
                    children: links_1.ORDER_MENU,
                    path: '/transac/',
                    platform: 'global',
                }, onSelect: onSelectOrder, 
                // active={active}
                placement: "bottom-end" }),
            react_1.default.createElement(common_dropdown_1.default, { className: "hbg-header-dropdown header__user__body__item", placement: "bottom-end", handleClick: onPanelUserClick, handleMouseEnter: onPanelUserMouseEnter, title: react_1.default.createElement("div", { className: "header__user__avatar ".concat((0, classnames_1.default)({ 'hbg-user_key': passKeyShow })) }, renderAvatar()) },
                react_1.default.createElement(panel_user_1.default, { style: { width: '352px' }, userInfo: userInfoData, userType: userType, passKeyShow: passKeyShow })),
            react_1.default.createElement("div", { className: "header__user__avatar ".concat((0, classnames_1.default)({
                    'header__user__avatar--open': isUserOpen,
                }), " ").concat((0, classnames_1.default)({
                    'hbg-user_key': passKeyShow,
                })) }, renderAvatar('point1'))));
    };
    var renderFunctionMenu = function () {
        var _a, _b;
        var isAni = !headerMobile && (typeof window === 'undefined' ? false : bodyWidth > 743);
        return (react_1.default.createElement("div", { className: "header__user__body__extra" },
            react_1.default.createElement("div", { className: "header__user__body__item header__user__body__item--prime-entry hbg-header-dropdown-btn ".concat((0, classnames_1.default)({
                    'primeicon-default': isLoginChecked && !isLogin,
                })), "data-ani": isAni ? 'linkage' : '', "data-level": ((_a = userInfoData === null || userInfoData === void 0 ? void 0 : userInfoData.prime) === null || _a === void 0 ? void 0 : _a.level) ? ((_b = userInfoData === null || userInfoData === void 0 ? void 0 : userInfoData.prime) === null || _b === void 0 ? void 0 : _b.level) - 1 : '', onClick: toPrimeIndex },
                react_1.default.createElement("i", null)),
            react_1.default.createElement("div", { className: "header__user__body__item hbg-header-dropdown-btn", "data-ani": "linkage", onClick: onClickInmail },
                react_1.default.createElement("i", { className: "global-common-header-icon__msg" })),
            react_1.default.createElement(common_dropdown_1.default, { className: "hbg-header-dropdown", placement: "bottom-end", title: react_1.default.createElement("div", { className: "header__user__body__item" },
                    react_1.default.createElement("i", { className: "global-common-header-icon__download" })), handleMouseEnter: onPanelDownloadMouseEnter },
                react_1.default.createElement(download_1.default, { style: { minWidth: '200px' } })),
            react_1.default.createElement(common_dropdown_1.default, { className: "hbg-header-dropdown", placement: "bottom-end", title: react_1.default.createElement("div", { className: "header__user__body__item" },
                    react_1.default.createElement("i", { className: "global-common-header-icon__lang" })), handleMouseEnter: onPaneLangMouseEnter, isShowFlag: langFlag },
                react_1.default.createElement("div", { className: "hb-menu-dropdown__body--multi", style: { width: '472px' } },
                    react_1.default.createElement(langs_1.default, { active: locale, onSetLang: onSetLang }),
                    react_1.default.createElement(currencys_1.default, { active: localRate, onSetCurrencys: onSetCurrencys }))),
            settingPanel && (react_1.default.createElement(common_dropdown_1.default, { className: "hbg-header-dropdown hbg-header-setting", placement: "bottom-end", title: react_1.default.createElement("div", { className: "header__user__body__item" },
                    react_1.default.createElement("i", { className: "global-common-header-icon__seting" })), handleMouseEnter: onPanelSettingMouseEnter, isShowFlag: true, offset: [16, 0], withBottomMargin: false },
                react_1.default.createElement("div", null, settingPanel)))));
    };
    var setIsThreeNavList = function (data) {
        if (data) {
            setThreeNavOpen(true);
            setThreeNavList(data);
        }
    };
    var renderThreeMenu = function () {
        return (react_1.default.createElement("div", null, threeNavList.map(function (item, index) {
            return (react_1.default.createElement("div", { key: index, className: "hb-menu-dropdown__body__item ".concat(item.jumpUrl === location.href ? 'active' : ''), onClick: function () {
                    setIsNavOpen(false);
                    setThreeNavOpen(false);
                    if (item.track) {
                        (0, sensors_1.trackHeader)({
                            button_name: item.track,
                            type: 'click',
                        });
                    }
                    if (item.jumpUrl) {
                        location.href = item.jumpUrl;
                    }
                } },
                react_1.default.createElement("div", { className: "body__item__txt" }, item.title)));
        })));
    };
    // 搜索功能
    var searchMenuDom = function () {
        var limitSize = 0;
        if (['zh-cn', 'zh-tc'].includes(locale)) {
            limitSize = 1450;
        }
        else {
            limitSize = 1700;
        }
        if (bodyWidth === 0) {
            return '';
        }
        else if (bodyWidth > limitSize) {
            // 防止出现死循环
            if (isSearchOpen) {
                setIsSearchOpen(false);
            }
            return react_1.default.createElement(search_menu_1.default, null);
        }
        else if (bodyWidth >= 1024 && bodyWidth <= limitSize) {
            // 防止出现死循环
            if (isSearchOpen) {
                setIsSearchOpen(false);
            }
            return (react_1.default.createElement(common_dropdown_1.default, { className: "hbg-header-dropdown hbg_small_search_dropdown", placement: "bottom-end", title: react_1.default.createElement("div", { className: "header__user__body__item hbg_search_item" },
                    react_1.default.createElement("i", { className: "global-common-header-icon__search" })), handleMouseEnter: onSearchMouseEnter },
                react_1.default.createElement(small_search_menu_1.default, { ref: smallSearchDropdownRef })));
        }
        else {
            return (react_1.default.createElement("div", { ref: smallSearchRef, className: "hbg_small_search_dropdown ".concat((0, classnames_1.default)({
                    'hbg_small_search_dropdown--open': isSearchOpen,
                })), onClick: openSearchDrawer },
                react_1.default.createElement("i", { className: "global-common-header-icon__search" })));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("header", { className: "global-common-header ".concat((0, classnames_1.default)({
                'global-common-header--stacking': headerStacking,
                'global-common-header--mobile': headerMobile,
                'global-common-header--dark': theme === 'dark',
                'global-common-header--light': theme === 'light',
            })), ref: function (e) {
                set$El(e);
            }, id: "hbg-header" },
            react_1.default.createElement("section", { className: "header-wrap" },
                react_1.default.createElement("div", { className: "header-body ".concat((0, classnames_1.default)({
                        'header-body--stacking': headerStacking,
                        'header-body--mobile': headerMobile,
                    })) },
                    react_1.default.createElement("nav", { className: "header-nav" },
                        react_1.default.createElement("div", { className: 'header-nav-brand ' + logoStyle, onClick: onClickLogo },
                            react_1.default.createElement("img", { src: iconLogo, alt: t('火币网-领先的比特币交易平台') }),
                            react_1.default.createElement("i", { className: "header-nav-logo-ani" })),
                        react_1.default.createElement(v2_1.default, { menus: menuList, active: active, theme: theme })),
                    react_1.default.createElement("div", { className: "header-nav__right" },
                        searchMenuDom(),
                        react_1.default.createElement("div", { className: "header__user" },
                            isLoginChecked && !isLogin ? renderNotLogined() : '',
                            react_1.default.createElement("div", { className: "header-user__navmenu ".concat((0, classnames_1.default)({
                                    'hbg-nav-menu-v2__hover': isHover,
                                    'hbg-nav-menu-v2__disable-ani': disableContentInAni,
                                })), ref: setEl2 },
                                react_1.default.createElement("i", { className: "hbg-nav-menu-v2__activebar ".concat((0, classnames_1.default)({
                                        'hbg-nav-menu-v2__activebar--ani': isAni,
                                    })), style: { width: "".concat(barWidth, "px"), left: "".concat(barLeft, "px") }, ref: setBar }),
                                isLoginChecked && isLogin ? renderUser() : '',
                                renderFunctionMenu()),
                            react_1.default.createElement("div", { className: "header__user__hamburg" },
                                react_1.default.createElement(more_btn_1.default, { ref: moreBtnRef, value: isNavOpen, onClick: function () { return setIsNavOpen(!isNavOpen); } })))))),
            isSearchOpen && (react_1.default.createElement(drawer_1.default, { className: "hbg_drawer__search", open: isSearchOpen, handleChange: setIsSearchOpen, direction: "top", zIndex: 900 },
                react_1.default.createElement(small_search_menu_1.default, { type: "0" }))),
            react_1.default.createElement(drawer_1.default, { open: isNavOpen, handleChange: setIsNavOpen, direction: "top", zIndex: 900 },
                react_1.default.createElement(panel_nav_1.default, { menus: mobileMenuList, handleOpenThreeNav: setIsThreeNavList, handleLangs: showLangs, handleCurrencys: showCurrencys })),
            react_1.default.createElement(drawer_1.default, { open: isThreeNavOpen, handleChange: setThreeNavOpen, direction: "right", className: "hbg-drawer" }, renderThreeMenu()),
            react_1.default.createElement(drawer_1.default, { open: isUserOpen, handleChange: setIsUserOpen, direction: "top", zIndex: 900 },
                react_1.default.createElement(panel_user_1.default, { hasProToken: hasProToken, userInfo: userInfoData, userType: userType, passKeyShow: passKeyShow })),
            react_1.default.createElement(drawer_1.default, { open: isLangOpen, handleChange: setIsLangOpen, direction: "right", className: "hbg-drawer" },
                react_1.default.createElement(langs_1.default, { active: locale, onSetLang: onSetLang })),
            react_1.default.createElement(drawer_1.default, { open: isCurOpen, handleChange: setIsCurOpen, direction: "right", className: "hbg-drawer" },
                react_1.default.createElement(currencys_1.default, { active: localRate, onSetCurrencys: onSetCurrencys })))));
};
exports.default = FedHeader;


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuTrans", function() { return menuTrans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remote2Local", function() { return remote2Local; });
/* harmony import */ var _url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38);



const makeUrl = (val, hostname, locale) => {

    const {urlData={}} = val
    if (urlData.url) {
        return urlData.url
    }
    if (!urlData.platform && !urlData.path) {
        return ''
    }
    return Object(_url__WEBPACK_IMPORTED_MODULE_0__["getUrl"])({
        platform: urlData.platform,
        path: urlData.path,
        locale,
        hostname,
    })
}



const menuData = (data, hostname, locale, level) => {
    let obj = {
        // "title": getI18n(data.name, locale, 'en-us'),
        // // tag
        // "floatImg": "",
        // // icon
        // "icon": data.iconImg || "",
        // // 埋点
        // "buriedPoint": data.track || "",
        // // activeId，高亮显示
        // "locationId": data.activeId || "",
        // "description": "",
        ...data,
        "title": Object(_i18n__WEBPACK_IMPORTED_MODULE_1__["default"])(data.title, locale, 'en-us'),
        "subtitle": Object(_i18n__WEBPACK_IMPORTED_MODULE_1__["default"])(data.description, locale, 'en-us'),
        "activeId": data.locationId || "",
        "track": data.buriedPoint || '',
        // icon: () => import(data.icon),
        "jumpUrl": makeUrl(data, hostname, locale),
    }
    // console.log('make url', data.urlData, hostname, locale, obj.jumpUrl)
    if (level === 1) {
        delete obj.icon
    }
    if (data.children) {
        obj.children = data.children.map(item => {
            return menuData(item, hostname, locale, level + 1)
        })
    }

    return obj
}

/**
 * 转换配置数据
 * @param {*} list
 * @param {*} hostname
 */
function menuTrans(list, hostname, locale) {
    return list.map((item) => {
        return menuData(item, hostname, locale, 1)
    })
}


function localData(data) {
    let obj = {
        title: data.title || '',
        subtitle: data.description || '',
        // icon 图片
        icon: data.icon || '',
        nightIcon: data.nightIcon || '',
        // 标签图片
        floatImg: data.floatImg || '',
        nightFloatImg: data.nightFloatImg || '',
        // 当前状态
        activeId: data.locationId || '',
        // 埋点字段
        track: data.buriedPoint || '',
        // 跳转链接
        jumpUrl: data.jumpUrl || '',
        // 跳转类型
        jumpType: data.jumpType || 1
    }
    let _children = data.levelInfos || data.secondLevel || []
    _children = _children.filter(item => item.title !== null && item.title !== '')
    if (_children) {
        obj.children = _children.map(item => {
            return localData(item)
        })
    }
    return obj
}
/**
 * 远程数据转换为本地格式
 * @param {*} list
 */
function remote2Local(list) {
    list = (list || []).filter(item => item.title !== null && item.title !== '')
    return (list || []).map(item => {
        return localData(item)
    })
}


/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjY1MDIgMTIuODgwNkwyMC4xMiAxNy44MDc0QzE5Ljc2MTMgMTguMzA4MSAyMC4xMjU1IDE5LjAwMzggMjAuNzQxMyAxOC45OTQyTDI1LjMzNzYgMTguOTIyN0MyNS45NTU3IDE4LjkxMzEgMjYuMzE5NCAxOS42MTMzIDI1Ljk1NiAyMC4xMTM0TDIyLjU1MDkgMjQuOCIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49ImJldmVsIi8+CjxwYXRoIGQ9Ik0yNi44Mzg4IDEwLjg3NjFWNi41QzI2LjgzODggNi4yMjM4NiAyNi42MTQ5IDYgMjYuMzM4OCA2SDMuNUMzLjIyMzg2IDYgMyA2LjIyMzg2IDMgNi41VjIzLjkyMDlDMyAyNC4xOTcgMy4yMjM4NiAyNC40MjA5IDMuNSAyNC40MjA5SDE5Ljc5NTVNNi43OTI1NCAxMC44NzYxSDEyLjc1MjIiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjY1MDIgMTIuODgwNkwyMC4xMiAxNy44MDc0QzE5Ljc2MTMgMTguMzA4MSAyMC4xMjU1IDE5LjAwMzggMjAuNzQxMyAxOC45OTQyTDI1LjMzNzYgMTguOTIyN0MyNS45NTU3IDE4LjkxMzEgMjYuMzE5NCAxOS42MTMzIDI1Ljk1NiAyMC4xMTM0TDIyLjU1MDkgMjQuOCIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49ImJldmVsIi8+CjxwYXRoIGQ9Ik0yNi44Mzg4IDEwLjg3NjFWNi41QzI2LjgzODggNi4yMjM4NiAyNi42MTQ5IDYgMjYuMzM4OCA2SDMuNUMzLjIyMzg2IDYgMyA2LjIyMzg2IDMgNi41VjIzLjkyMDlDMyAyNC4xOTcgMy4yMjM4NiAyNC40MjA5IDMuNSAyNC40MjA5SDE5Ljc5NTVNNi43OTI1NCAxMC44NzYxSDEyLjc1MjIiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNDk5OTggNEwyOC41IDkuOEwyNC4xIDI2LjVMMy4wOTk5OCAyMC42TDcuNDk5OTggNFoiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MDAxIDEzLjEzNDFWMTEuNTgxMkwxNS43MDExIDExLjU3NzRMMjcuMjAxMSAxNC43Nzc0TDI2Ljc5OSAxNi4yMjI1TDE1LjcwMDEgMTMuMTM0MVpNMjIuMTk3NCAyMC4yNzYzTDE2LjY5NzQgMTguNzc2M0wxNi4zMDI3IDIwLjIyMzVMMjEuODAyNyAyMS43MjM1TDIyLjE5NzQgMjAuMjc2M1oiIGZpbGw9IiMwMDAwMDAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjA2NTM2IDcuNzk1NjZDMy4xNTgwNCA4LjIyOTkgMi42ODIyMSA4LjY0OTUgMi40NjE4OSA4Ljk4MzM5QzIuMjUxOTIgOS4zMDE2MSAyLjI1ODU4IDkuNTU2NTYgMi4zNzAyMiA5LjgwMjE2QzIuNTAyNTEgMTAuMDkzMiAyLjgxNjE4IDEwLjQyNjggMy4zMjYwNSAxMC43MjczQzMuODI1NTUgMTEuMDIxNyA0LjQ1NTYyIDExLjI0ODkgNS4xMjMyOCAxMS4zNjAyQzYuNjUzNDUgMTEuNjE1MiA4LjQxOTAzIDExLjU4NjkgOS44MzE4NSAxMS4yMTQxQzExLjI5MDMgMTAuODI5MyAxMi4xMDI0IDEwLjE2MzggMTIuMjY0NiA5LjM1MjkxTDEzLjc1IDkuNTAwMDFWMTMuNUgxMi4yNVYxMS43NzY1QzExLjY1MDkgMTIuMTg3MyAxMC45MzYzIDEyLjQ3NCAxMC4yMTQ2IDEyLjY2NDVDOC41NTk1NyAxMy4xMDEyIDYuNTc1MTggMTMuMTIyOSA0Ljg3NjY5IDEyLjgzOThDNC4wNDQzMiAxMi43MDExIDMuMjM2ODcgMTIuNDE1OSAyLjU2NDQ4IDEyLjAxOTZDMS45MDI0NiAxMS42Mjk0IDEuMzA5ODcgMTEuMDk0MyAxLjAwNDY3IDEwLjQyMjlDMC42Nzg4MDEgOS43MDU5NiAwLjcxNjcyMSA4LjkwNDY3IDEuMjA5ODkgOC4xNTcyNkMxLjY3NDExIDcuNDUzNzMgMi41MDk3IDYuODQxNjEgMy42OTUzOCA2LjMxNDY1TDMuNzM4ODggNi4yOTUzMkwzLjc4NDQ4IDYuMjgxNjRMNC41MjE0NyA2LjA2MDU1TDQuMDY1MzYgNy43OTU2NloiIGZpbGw9IiMwMDk0ZmYiLz4KPC9zdmc+Cg=="

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNDk5OTggNEwyOC41IDkuOEwyNC4xIDI2LjVMMy4wOTk5OCAyMC42TDcuNDk5OTggNFoiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MDAxIDEzLjEzNDFWMTEuNTgxMkwxNS43MDExIDExLjU3NzRMMjcuMjAxMSAxNC43Nzc0TDI2Ljc5OSAxNi4yMjI1TDE1LjcwMDEgMTMuMTM0MVpNMjIuMTk3NCAyMC4yNzYzTDE2LjY5NzQgMTguNzc2M0wxNi4zMDI3IDIwLjIyMzVMMjEuODAyNyAyMS43MjM1TDIyLjE5NzQgMjAuMjc2M1oiIGZpbGw9IiNGMEYxRjQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjA2NTM2IDcuNzk1NjZDMy4xNTgwNCA4LjIyOTkgMi42ODIyMSA4LjY0OTUgMi40NjE4OSA4Ljk4MzM5QzIuMjUxOTIgOS4zMDE2MSAyLjI1ODU4IDkuNTU2NTYgMi4zNzAyMiA5LjgwMjE2QzIuNTAyNTEgMTAuMDkzMiAyLjgxNjE4IDEwLjQyNjggMy4zMjYwNSAxMC43MjczQzMuODI1NTUgMTEuMDIxNyA0LjQ1NTYyIDExLjI0ODkgNS4xMjMyOCAxMS4zNjAyQzYuNjUzNDUgMTEuNjE1MiA4LjQxOTAzIDExLjU4NjkgOS44MzE4NSAxMS4yMTQxQzExLjI5MDMgMTAuODI5MyAxMi4xMDI0IDEwLjE2MzggMTIuMjY0NiA5LjM1MjkxTDEzLjc1IDkuNTAwMDFWMTMuNUgxMi4yNVYxMS43NzY1QzExLjY1MDkgMTIuMTg3MyAxMC45MzYzIDEyLjQ3NCAxMC4yMTQ2IDEyLjY2NDVDOC41NTk1NyAxMy4xMDEyIDYuNTc1MTggMTMuMTIyOSA0Ljg3NjY5IDEyLjgzOThDNC4wNDQzMiAxMi43MDExIDMuMjM2ODcgMTIuNDE1OSAyLjU2NDQ4IDEyLjAxOTZDMS45MDI0NiAxMS42Mjk0IDEuMzA5ODcgMTEuMDk0MyAxLjAwNDY3IDEwLjQyMjlDMC42Nzg4MDEgOS43MDU5NiAwLjcxNjcyMSA4LjkwNDY3IDEuMjA5ODkgOC4xNTcyNkMxLjY3NDExIDcuNDUzNzMgMi41MDk3IDYuODQxNjEgMy42OTUzOCA2LjMxNDY1TDMuNzM4ODggNi4yOTUzMkwzLjc4NDQ4IDYuMjgxNjRMNC41MjE0NyA2LjA2MDU1TDQuMDY1MzYgNy43OTU2NloiIGZpbGw9IiMwMDk0ZmYiLz4KPC9zdmc+Cg=="

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOC44NzE5NCIgY3k9IjguOTkzNCIgcj0iNC4yNDM0IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yIDIwLjk2MzhWMjAuODUxMkMyIDE2LjYxNDUgNS40MzQ1NSAxMy4xNzk5IDkuNjcxMjggMTMuMTc5OVYxMy4xNzk5IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxjaXJjbGUgcj0iNC4yNDM0IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyMS4zODY5IDguOTkzNCkiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTI4LjI1ODggMjAuOTYzOFYyMC44NTEyQzI4LjI1ODggMTYuNjE0NSAyNC44MjQyIDEzLjE3OTkgMjAuNTg3NSAxMy4xNzk5VjEzLjE3OTkiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTIwLjY0NzcgMTguMjE5MkwxMi4wNjc0IDE4LjIxOTJMMTUuMzY3NSAxNS41NzkxIiBzdHJva2U9IiMwMDk0ZmYiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMC4wODc1IDIxLjk3MzZMMTguMDA3OCAyMS45NzM2TDE1LjM2NzcgMjQuNTAwMyIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOC44NzE5NCIgY3k9IjguOTkzNCIgcj0iNC4yNDM0IiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yIDIwLjk2MzhWMjAuODUxMkMyIDE2LjYxNDUgNS40MzQ1NSAxMy4xNzk5IDkuNjcxMjggMTMuMTc5OVYxMy4xNzk5IiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxjaXJjbGUgcj0iNC4yNDM0IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyMS4zODY5IDguOTkzNCkiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTI4LjI1ODggMjAuOTYzOFYyMC44NTEyQzI4LjI1ODggMTYuNjE0NSAyNC44MjQyIDEzLjE3OTkgMjAuNTg3NSAxMy4xNzk5VjEzLjE3OTkiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTIwLjY0NzcgMTguMjE5MkwxMi4wNjc0IDE4LjIxOTJMMTUuMzY3NSAxNS41NzkxIiBzdHJva2U9IiMwMDk0ZmYiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMC4wODc1IDIxLjk3MzZMMTguMDA3OCAyMS45NzM2TDE1LjM2NzcgMjQuNTAwMyIgc3Ryb2tlPSIjRjBGMUY0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS40NTI0IDguNzc4ODFIM1YxMC41Nzg4SDExLjI3NDVDMTEuMTQ2NSA5Ljk3MDc0IDExLjIxNTYgOS4zNDAzNCAxMS40NTI0IDguNzc4ODFaTTEzLjk1MTkgMTQuODAzMkgzVjE2LjYwMzJIMTMuNjQzMkwxMy45NTE5IDE0LjgwMzJaTTI3LjM2OTIgMjIuNzI1OUgzVjIwLjkyNTlIMjcuMzY5MlYyMi43MjU5WiIgZmlsbD0iIzAwMDAwMCIvPgo8cGF0aCBkPSJNMjAuMjI3MSA1LjM2MzRDMjAuMzAwNSA1LjIxNDc1IDIwLjUxMjUgNS4yMTQ3NSAyMC41ODU4IDUuMzYzNEwyMi40MDYyIDkuMDUxODlDMjIuNDM1MyA5LjExMDkyIDIyLjQ5MTYgOS4xNTE4MyAyMi41NTY4IDkuMTYxM0wyNi42MjczIDkuNzUyNzhDMjYuNzkxMyA5Ljc3NjYxIDI2Ljg1NjggOS45NzgyMSAyNi43MzgxIDEwLjA5MzlMMjMuNzkyNyAxMi45NjVDMjMuNzQ1NSAxMy4wMTEgMjMuNzI0IDEzLjA3NzIgMjMuNzM1MiAxMy4xNDJMMjQuNDMwNSAxNy4xOTYxQzI0LjQ1ODUgMTcuMzU5NSAyNC4yODcgMTcuNDg0MSAyNC4xNDAzIDE3LjQwNjlMMjAuNDk5NSAxNS40OTI5QzIwLjQ0MTMgMTUuNDYyMiAyMC4zNzE3IDE1LjQ2MjIgMjAuMzEzNCAxNS40OTI5TDE2LjY3MjYgMTcuNDA2OUMxNi41MjU5IDE3LjQ4NDEgMTYuMzU0NCAxNy4zNTk1IDE2LjM4MjQgMTcuMTk2MUwxNy4wNzc4IDEzLjE0MkMxNy4wODg5IDEzLjA3NzIgMTcuMDY3NCAxMy4wMTEgMTcuMDIwMyAxMi45NjVMMTQuMDc0OCAxMC4wOTM5QzEzLjk1NjEgOS45NzgyMSAxNC4wMjE2IDkuNzc2NjEgMTQuMTg1NyA5Ljc1Mjc4TDE4LjI1NjIgOS4xNjEzQzE4LjMyMTMgOS4xNTE4MyAxOC4zNzc2IDkuMTEwOTIgMTguNDA2NyA5LjA1MTg5TDIwLjIyNzEgNS4zNjM0WiIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS40NDcgOC45Mjg3MUgzVjEwLjQyODdIMTEuMjk3N0MxMS4yMTY2IDkuOTIxNDEgMTEuMjcyMiA5LjQwMzQxIDExLjQ0NyA4LjkyODcxWk0xMy45NzY5IDE0Ljk1MzFIM1YxNi40NTMxSDEzLjcxOTdMMTMuOTc2OSAxNC45NTMxWk0yNy4zNjkyIDIyLjU3NThIM1YyMS4wNzU4SDI3LjM2OTJWMjIuNTc1OFoiIGZpbGw9IiNGMEYxRjQiLz4KPHBhdGggZD0iTTIwLjIyNzEgNS4zNjM0QzIwLjMwMDUgNS4yMTQ3NSAyMC41MTI1IDUuMjE0NzUgMjAuNTg1OCA1LjM2MzRMMjIuNDA2MiA5LjA1MTg5QzIyLjQzNTMgOS4xMTA5MiAyMi40OTE2IDkuMTUxODMgMjIuNTU2OCA5LjE2MTNMMjYuNjI3MyA5Ljc1Mjc4QzI2Ljc5MTMgOS43NzY2MSAyNi44NTY4IDkuOTc4MjEgMjYuNzM4MSAxMC4wOTM5TDIzLjc5MjcgMTIuOTY1QzIzLjc0NTUgMTMuMDExIDIzLjcyNCAxMy4wNzcyIDIzLjczNTIgMTMuMTQyTDI0LjQzMDUgMTcuMTk2MUMyNC40NTg1IDE3LjM1OTUgMjQuMjg3IDE3LjQ4NDEgMjQuMTQwMyAxNy40MDY5TDIwLjQ5OTUgMTUuNDkyOUMyMC40NDEzIDE1LjQ2MjIgMjAuMzcxNyAxNS40NjIyIDIwLjMxMzQgMTUuNDkyOUwxNi42NzI2IDE3LjQwNjlDMTYuNTI1OSAxNy40ODQxIDE2LjM1NDQgMTcuMzU5NSAxNi4zODI0IDE3LjE5NjFMMTcuMDc3OCAxMy4xNDJDMTcuMDg4OSAxMy4wNzcyIDE3LjA2NzQgMTMuMDExIDE3LjAyMDMgMTIuOTY1TDE0LjA3NDggMTAuMDkzOUMxMy45NTYxIDkuOTc4MjEgMTQuMDIxNiA5Ljc3NjYxIDE0LjE4NTcgOS43NTI3OEwxOC4yNTYyIDkuMTYxM0MxOC4zMjEzIDkuMTUxODMgMTguMzc3NiA5LjExMDkyIDE4LjQwNjcgOS4wNTE4OUwyMC4yMjcxIDUuMzYzNFoiIHN0cm9rZT0iIzAwOTRmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4zMjQ4IDkuOTIyMzlDMTAuODQ5IDYuMTUxODkgMTQuMDg1OCAzLjI0OTI1IDE4LjAwMDYgMy4yNDkyNUMyMi4yODA4IDMuMjQ5MjUgMjUuNzUwNiA2LjcxOTA1IDI1Ljc1MDYgMTAuOTk5M0MyNS43NTA2IDExLjMzMDEgMjUuNzI5OSAxMS42NTYxIDI1LjY4OTYgMTEuOTc2QzI1LjE4MDMgMTIuMDkwMyAyNC42OTcgMTIuMzQ4MiAyNC4zMDQ2IDEyLjc0OUwyMy44NDUzIDEzLjIxOEMyNC4xMDcyIDEyLjUyODUgMjQuMjUwNiAxMS43ODA2IDI0LjI1MDYgMTAuOTk5M0MyNC4yNTA2IDcuNTQ3NDggMjEuNDUyNCA0Ljc0OTI1IDE4LjAwMDYgNC43NDkyNUMxNC45OTE3IDQuNzQ5MjUgMTIuNDc5NSA2Ljg3NTQ3IDExLjg4NDMgOS43MDczOEMxMS4zNTQzIDkuNzI5NjUgMTAuODMyNCA5LjgwMjQyIDEwLjMyNDggOS45MjIzOVoiIGZpbGw9IiMwMDk0ZmYiLz4KPHBhdGggZD0iTTkuMDM1MzggMjQuMjY4M0gyMC4yMzA1QzIxLjM5MTYgMjQuMjY4MyAyMi41MDQ3IDIzLjgwNDUgMjMuMzIyMyAyMi45Nzk5TDI3LjgxNjYgMTguNDQ3M0MyOC42MzQ5IDE3LjYyMjEgMjguNjI2NCAxNi4yODg5IDI3Ljc5NzggMTUuNDc0MVYxNS40NzQxQzI2Ljk3MDMgMTQuNjYwNSAyNS42Mzk1IDE0LjY3MzEgMjQuODI3NyAxNS41MDIzTDIxLjA1NTggMTkuMzU0NkMyMS4wNDg4IDE5LjM2MTggMjEuMDM5MSAxOS4zNjU5IDIxLjAyOTEgMTkuMzY1OUgxMy41MDY5QzEyLjU1NzIgMTkuMzY1OSAxMS43ODc0IDE4LjU5NiAxMS43ODc0IDE3LjY0NjNWMTcuNjQ2M0MxMS43ODc0IDE2LjY5NjcgMTIuNTU3MiAxNS45MjY4IDEzLjUwNjkgMTUuOTI2OEgxOC4zMzAxQzE5LjQxNDUgMTUuOTI2OCAyMC4yOTM1IDE1LjA0NzggMjAuMjkzNSAxMy45NjM0VjEzLjk2MzRDMjAuMjkzNSAxMi44NzkxIDE5LjQxNDUgMTIgMTguMzMwMSAxMkgxMi4yNjYxQzEwLjI0NjggMTIgOC4zNjAwOSAxMy4wMDU3IDcuMjM0NDIgMTQuNjgyMkwxLjg2OTQ4IDIyLjY3MjNDMS40OTgyOCAyMy4yMjUxIDEuMzAwMDUgMjMuODc1OSAxLjMwMDA1IDI0LjU0MThWMjUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4zMjUgOS45MjI0M0MxMC44NDkzIDYuMTUyMTcgMTQuMDg2IDMuMjQ5NzkgMTguMDAwNyAzLjI0OTc5QzIyLjI4MDkgMy4yNDk3OSAyNS43NTA3IDYuNzE5NTkgMjUuNzUwNyAxMC45OTk4QzI1Ljc1MDcgMTEuMzMwNSAyNS43MyAxMS42NTYzIDI1LjY4OTggMTEuOTc2MUMyNS4xODA0IDEyLjA5MDMgMjQuNjk3MSAxMi4zNDgyIDI0LjMwNDcgMTIuNzQ5TDIzLjg0NTcgMTMuMjE3OEMyNC4xMDc0IDEyLjUyODUgMjQuMjUwNyAxMS43ODA5IDI0LjI1MDcgMTAuOTk5OEMyNC4yNTA3IDcuNTQ4MDEgMjEuNDUyNCA0Ljc0OTc5IDE4LjAwMDcgNC43NDk3OUMxNC45OTIgNC43NDk3OSAxMi40Nzk4IDYuODc1NzYgMTEuODg0NCA5LjcwNzQyQzExLjM1NDUgOS43Mjk3IDEwLjgzMjYgOS44MDI0NiAxMC4zMjUgOS45MjI0M1oiIGZpbGw9IiMwMDk0ZmYiLz4KPHBhdGggZD0iTTkuMDM1MzggMjQuMjY4M0gyMC4yMzA1QzIxLjM5MTYgMjQuMjY4MyAyMi41MDQ3IDIzLjgwNDUgMjMuMzIyMyAyMi45Nzk5TDI3LjgxNjYgMTguNDQ3M0MyOC42MzQ5IDE3LjYyMjEgMjguNjI2NCAxNi4yODg5IDI3Ljc5NzggMTUuNDc0MVYxNS40NzQxQzI2Ljk3MDMgMTQuNjYwNSAyNS42Mzk1IDE0LjY3MzEgMjQuODI3NyAxNS41MDIzTDIxLjA1NTggMTkuMzU0NkMyMS4wNDg4IDE5LjM2MTggMjEuMDM5MSAxOS4zNjU5IDIxLjAyOTEgMTkuMzY1OUgxMy41MDY5QzEyLjU1NzIgMTkuMzY1OSAxMS43ODc0IDE4LjU5NiAxMS43ODc0IDE3LjY0NjNWMTcuNjQ2M0MxMS43ODc0IDE2LjY5NjcgMTIuNTU3MiAxNS45MjY4IDEzLjUwNjkgMTUuOTI2OEgxOC4zMzAxQzE5LjQxNDUgMTUuOTI2OCAyMC4yOTM1IDE1LjA0NzggMjAuMjkzNSAxMy45NjM0VjEzLjk2MzRDMjAuMjkzNSAxMi44NzkxIDE5LjQxNDUgMTIgMTguMzMwMSAxMkgxMi4yNjYxQzEwLjI0NjggMTIgOC4zNjAwOSAxMy4wMDU3IDcuMjM0NDIgMTQuNjgyMkwxLjg2OTQ4IDIyLjY3MjNDMS40OTgyOCAyMy4yMjUxIDEuMzAwMDUgMjMuODc1OSAxLjMwMDA1IDI0LjU0MThWMjUiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF8yOTA2XzQyMDM1KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuMzU3MiA2LjI1QzcuMzI3NDMgNi4yNSAzLjI1IDEwLjMyNzQgMy4yNSAxNS4zNTcyQzMuMjUgMjAuMDU5IDYuODEzMDUgMjMuOTI4NiAxMS4zODY0IDI0LjQxMzJWMjUuOTIwNUM1Ljk4MzE5IDI1LjQzMDMgMS43NSAyMC44ODgxIDEuNzUgMTUuMzU3MkMxLjc1IDkuNDk5IDYuNDk5IDQuNzUgMTIuMzU3MiA0Ljc1QzEzLjEwODMgNC43NSAxMy44NDExIDQuODI4MDYgMTQuNTQ4MSA0Ljk3NjUyQzE1LjI1NTQgNC44Mjc5OCAxNS45ODgxIDQuNzUgMTYuNzM4MiA0Ljc1QzIyLjU5NjQgNC43NSAyNy4zNDU0IDkuNDk5IDI3LjM0NTQgMTUuMzU3MkMyNy4zNDU0IDE1LjU1NzcgMjcuMzM5OCAxNS43NTY5IDI3LjMyODkgMTUuOTU0NkgyNS44MjYxQzI1LjgzODkgMTUuNzU3MSAyNS44NDU0IDE1LjU1NzkgMjUuODQ1NCAxNS4zNTcyQzI1Ljg0NTQgMTAuNzI5MyAyMi4zOTM2IDYuOTA3NyAxNy45MjQxIDYuMzI2NTFDMTguODU1OSA2LjkwMjE1IDE5LjY5MiA3LjYxNzk5IDIwLjQwMjggOC40NDQ2QzIxLjk5OTQgMTAuMzAxIDIyLjk2NDQgMTIuNzE2MSAyMi45NjQ0IDE1LjM1NzJDMjIuOTY0NCAxNS41NTc3IDIyLjk1ODkgMTUuNzU2OSAyMi45NDc5IDE1Ljk1NDZIMjEuNDQ1MUMyMS40NTc5IDE1Ljc1NzEgMjEuNDY0NCAxNS41NTc5IDIxLjQ2NDQgMTUuMzU3MkMyMS40NjQ0IDE0LjUzMjEgMjEuMzU0NyAxMy43MzI3IDIxLjE0OSAxMi45NzI2QzIxLjA0MTMgMTIuNTc0NCAyMC45MDcxIDEyLjE4NjkgMjAuNzQ4NyAxMS44MTIzQzE5LjM2NjEgOC41NDM1NSAxNi4xMjk1IDYuMjUgMTIuMzU3MiA2LjI1WiIgZmlsbD0iIzAwMDAwMCIvPgo8L2c+CjxwYXRoIGQ9Ik0xMy4xNDEzIDE3LjM1NjdIMTYuNTY5VjE4LjkzODdIMTUuMTk2OVYyMC40Mzc3SDE2LjQ4MTFWMjEuOTQxN0gxNS4xOTY5VjIzLjY3OTlIMTYuNzA1N1YyNS4yNjJIMTMuMTQxM1YxNy4zNTY3Wk0yMS40NDIgMTcuMzU2N1YxOC45Mzg3SDIwLjIyMTNWMjUuMjYySDE4LjE2NTdWMTguOTM4N0gxNi45NDk5VjE3LjM1NjdIMjEuNDQyWk0yMS45MTA4IDE3LjM1NjdIMjMuOTgxMUMyNC41NDEgMTcuMzU2NyAyNC45NzA3IDE3LjQwMDYgMjUuMjcwMiAxNy40ODg1QzI1LjU3MjkgMTcuNTc2NCAyNS43OTkxIDE3LjcwMzQgMjUuOTQ4OSAxNy44Njk0QzI2LjEwMTkgMTguMDM1NCAyNi4yMDQ0IDE4LjIzNzIgMjYuMjU2NSAxOC40NzQ5QzI2LjMxMTggMTguNzA5MiAyNi4zMzk1IDE5LjA3MzggMjYuMzM5NSAxOS41Njg2VjIwLjI1NzFDMjYuMzM5NSAyMC43NjE2IDI2LjI4NzQgMjEuMTI5NSAyNi4xODMyIDIxLjM2MDZDMjYuMDc5MSAyMS41OTE3IDI1Ljg4NyAyMS43NjkxIDI1LjYwNzEgMjEuODkyOEMyNS4zMzA0IDIyLjAxNjUgMjQuOTY3NCAyMi4wNzg0IDI0LjUxODIgMjIuMDc4NEgyMy45NjY1VjI1LjI2MkgyMS45MTA4VjE3LjM1NjdaTTIzLjk2NjUgMTguNzA5MlYyMC43MjA5QzI0LjAyNSAyMC43MjQyIDI0LjA3NTUgMjAuNzI1OCAyNC4xMTc4IDIwLjcyNThDMjQuMzA2NiAyMC43MjU4IDI0LjQzNjggMjAuNjgwMyAyNC41MDg0IDIwLjU4OTFDMjQuNTgzMyAyMC40OTQ3IDI0LjYyMDcgMjAuMzAxIDI0LjYyMDcgMjAuMDA4MVYxOS4zNTg2QzI0LjYyMDcgMTkuMDg4NSAyNC41Nzg0IDE4LjkxMjcgMjQuNDkzOCAxOC44MzEzQzI0LjQwOTIgMTguNzQ5OSAyNC4yMzM0IDE4LjcwOTIgMjMuOTY2NSAxOC43MDkyWiIgZmlsbD0iIzAwOTRmZiIvPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9kXzI5MDZfNDIwMzUiIHg9IjEuNzUiIHk9IjQuNzUiIHdpZHRoPSIyNS41OTU1IiBoZWlnaHQ9IjIxLjE3MDciIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldC8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9Im91dCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwLjQxOTYwOCAwIDAgMCAwIDAuNDE5NjA4IDAgMCAwIDAgMC40MTk2MDggMCAwIDAgMSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93XzI5MDZfNDIwMzUiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfMjkwNl80MjAzNSIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTEuODI1MyIgY3k9IjEwLjgzOTkiIHI9IjEuOTU0NDUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPGNpcmNsZSBjeD0iMTcuOTc1IiBjeT0iMTguNjU3MyIgcj0iMS45NTQ0NSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMjUuNDk4OSAxNC43NTA0QzI1LjQ5ODkgMTYuNDc2MiAyNS4wOTIyIDE4LjEwNyAyNC4zNjk1IDE5LjU1MjFDMjIuNjA1OSAyMy4wNzg1IDE4Ljk2MDQgMjUuNDk5OSAxNC43NDk0IDI1LjQ5OTlDOC44MTI2OSAyNS40OTk5IDQgMjAuNjg3MiA0IDE0Ljc1MDRDNCAxMC4zODQ5IDYuNjAyMzQgNi42MjcxOCAxMC4zNDA0IDQuOTQzOTJDMTEuNjg1NyA0LjMzODA4IDEzLjE3ODIgNC4wMDA5OCAxNC43NDk0IDQuMDAwOTgiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTkuNjA5OTkgMjAuMTI5M0wyNS40OTc1IDQuMDAwOTVNMjUuNDk3NSA0LjAwMDk1TDE5LjYzNDEgNE0yNS40OTc1IDQuMDAwOTVWOS44NjQyOSIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTEuODI1MyIgY3k9IjEwLjgzOTkiIHI9IjEuOTU0NDUiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPGNpcmNsZSBjeD0iMTcuOTc1IiBjeT0iMTguNjU3MyIgcj0iMS45NTQ0NSIgc3Ryb2tlPSIjRjBGMUY0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMjUuNDk4OSAxNC43NTA0QzI1LjQ5ODkgMTYuNDc2MiAyNS4wOTIyIDE4LjEwNyAyNC4zNjk1IDE5LjU1MjFDMjIuNjA1OSAyMy4wNzg1IDE4Ljk2MDQgMjUuNDk5OSAxNC43NDk0IDI1LjQ5OTlDOC44MTI2OSAyNS40OTk5IDQgMjAuNjg3MiA0IDE0Ljc1MDRDNCAxMC4zODQ5IDYuNjAyMzQgNi42MjcxOCAxMC4zNDA0IDQuOTQzOTJDMTEuNjg1NyA0LjMzODA4IDEzLjE3ODIgNC4wMDA5OCAxNC43NDk0IDQuMDAwOTgiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTkuNjA5OTkgMjAuMTI5M0wyNS40OTc1IDQuMDAwOTVNMjUuNDk3NSA0LjAwMDk1TDE5LjYzNDEgNE0yNS40OTc1IDQuMDAwOTVWOS44NjQyOSIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMjk5OCAxMi41VjE5LjUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4yOTk4IDEzLjY0OTlIMTYuMjk5OFYxNS4xNDk5SDE3LjcxNjVMMTUuMzE0NiAxNi45NTEzTDEzLjI2ODMgMTUuMzE0M0wxMi44NDAxIDE0Ljk3MTdMMTIuMzgzOCAxNS4yNzU5TDkgMTcuNTMxN1YxOS4zMzQ1TDEyLjc1OTUgMTYuODI4MUwxNC44MzEzIDE4LjQ4NTZMMTUuMjg1IDE4Ljg0ODVMMTUuNzQ5OCAxOC40OTk5TDE5Ljc0OTggMTUuNDk5OUwyMC4wNDk4IDE1LjI3NDlWMTQuODk5OVYxNC4zOTk5VjEzLjY0OTlIMTkuMjk5OFoiIGZpbGw9IiMwMDAwMDAiLz4KPHBhdGggZD0iTTE0LjUgNC41VjguNU0xMC41IDQuNUgxOC41IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik01IDIyLjEzMzZDNSAyMi4zNTE3IDUuMTQxNDIgMjIuNTQ0NyA1LjM0OTQzIDIyLjYxMDNMMTQuMzQ5NCAyNS40NTI1QzE0LjQ0NzQgMjUuNDgzNCAxNC41NTI2IDI1LjQ4MzQgMTQuNjUwNiAyNS40NTI1TDIzLjY1MDYgMjIuNjEwM0MyMy44NTg2IDIyLjU0NDcgMjQgMjIuMzUxNyAyNCAyMi4xMzM2VjlDMjQgOC43MjM4NiAyMy43NzYxIDguNSAyMy41IDguNUgxNC41SDUuNUM1LjIyMzg2IDguNSA1IDguNzIzODYgNSA5VjIyLjEzMzZaIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0yNy4yOTM5IDEyLjVMMjkuMTA1NyAxOS4yNjE1IiBzdHJva2U9IiMwMDk0ZmYiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMjk5OCAxMi41VjE5LjUiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4yOTk4IDEzLjY0OTlIMTYuMjk5OFYxNS4xNDk5SDE3LjcxNjVMMTUuMzE0NiAxNi45NTEzTDEzLjI2ODMgMTUuMzE0M0wxMi44NDAxIDE0Ljk3MTdMMTIuMzgzOCAxNS4yNzU5TDkgMTcuNTMxN1YxOS4zMzQ1TDEyLjc1OTUgMTYuODI4MUwxNC44MzEzIDE4LjQ4NTZMMTUuMjg1IDE4Ljg0ODVMMTUuNzQ5OCAxOC40OTk5TDE5Ljc0OTggMTUuNDk5OUwyMC4wNDk4IDE1LjI3NDlWMTQuODk5OVYxNC4zOTk5VjEzLjY0OTlIMTkuMjk5OFoiIGZpbGw9IiNGMEYxRjQiLz4KPHBhdGggZD0iTTE0LjUgNC41VjguNU0xMC41IDQuNUgxOC41IiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik01IDIyLjEzMzZDNSAyMi4zNTE3IDUuMTQxNDIgMjIuNTQ0NyA1LjM0OTQzIDIyLjYxMDNMMTQuMzQ5NCAyNS40NTI1QzE0LjQ0NzQgMjUuNDgzNCAxNC41NTI2IDI1LjQ4MzQgMTQuNjUwNiAyNS40NTI1TDIzLjY1MDYgMjIuNjEwM0MyMy44NTg2IDIyLjU0NDcgMjQgMjIuMzUxNyAyNCAyMi4xMzM2VjlDMjQgOC43MjM4NiAyMy43NzYxIDguNSAyMy41IDguNUgxNC41SDUuNUM1LjIyMzg2IDguNSA1IDguNzIzODYgNSA5VjIyLjEzMzZaIiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0yNy4yOTM5IDEyLjVMMjkuMTA1NyAxOS4yNjE1IiBzdHJva2U9IiMwMDk0ZmYiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDQuNzUwMTJDMjMuMDk3NCA2LjM1MDI2IDI2IDEwLjMzNjMgMjYgMTUuMDAwMkMyNiAyMS4wNzU0IDIxLjA3NTEgMjYuMDAwMiAxNSAyNi4wMDAyTDE2IDIzLjUwMDEiIHN0cm9rZT0iIzAwOTRmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTE2LjYyNzcgMTIuOTAwMUMxNi40NzI3IDE0LjU5NzggMTQuNzI0MyAxNi4xMzM4IDE0LjEzMzIgMTcuMTAzOUMxMy41NjY0IDE4LjAzNDEgMTMuMzY5IDE4LjkxMzMgMTMuNzgzNiAyMC42MTE1QzEzLjgwNTYgMjAuNzAxNiAxMy43MTI2IDIwLjc4MDQgMTMuNjI1OCAyMC43NDE4QzEyLjg4NTEgMjAuNDEyMSAxMSAxOS40MjMgMTEgMTcuMDY1MkMxMSAxMy43MzkzIDE0Ljc5MzUgMTMuNjIwNSAxNC42MTUyIDkuMTE5MDlDMTQuNjExNiA5LjAyODYxIDE0LjcxMzcgOC45NjcxMSAxNC43OTAxIDkuMDE5MjRDMTYuMDMxMSA5Ljg2NjY1IDE2Ljc3NTQgMTEuMjgyIDE2LjYyNzcgMTIuOTAwMVoiIGZpbGw9IiMwMDAwMDAiLz4KPHBhdGggZD0iTTE0LjE1MzIgMjAuODc2MkMxNC4xMDg3IDIwLjg2MyAxNC4wNzc3IDIwLjgyMzcgMTQuMDc2IDIwLjc3ODZDMTQuMDMyOCAxOS42NzUzIDE0LjY0NDkgMTguOTU0MyAxNS4zMzEyIDE4LjQxOTRDMTYuODU0NyAxNy4yMzIgMTcuNzk0IDE1LjYyODUgMTcuNDIyMyAxMy43NzMzQzE3LjQwMDEgMTMuNjYyNiAxNy41MzM4IDEzLjU4OTUgMTcuNjA4NSAxMy42NzU5QzE3Ljk2NjkgMTQuMDkwMiAxOC4zMzE5IDE0LjY1MTggMTguNTMzOSAxNS4wNjExQzE5LjUwODQgMTcuMDkxMiAxOC45ODgzIDE5LjQxNzYgMTYuNjU2NyAyMC41OTE2QzE1LjkyNjYgMjAuOTQzMSAxNS4wNTk4IDIxLjE0NDkgMTQuMTUzMiAyMC44NzYyWiIgZmlsbD0iIzAwMDAwMCIvPgo8cGF0aCBkPSJNMTEuNSAyNS40MzE2QzcuMTQwNzkgMjMuOTY5NiA0IDE5Ljg1MTYgNCAxNS4wMDAxQzQgOC45MjQ5OSA4LjkyNDg3IDQuMDAwMTIgMTUgNC4wMDAxMkwxNCA2LjUwMDEyIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDQuNzUwMTJDMjMuMDk3NCA2LjM1MDI2IDI2IDEwLjMzNjMgMjYgMTUuMDAwMkMyNiAyMS4wNzU0IDIxLjA3NTEgMjYuMDAwMiAxNSAyNi4wMDAyTDE2IDIzLjUwMDEiIHN0cm9rZT0iIzAwOTRmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTE2LjYyNzcgMTIuOTAwMUMxNi40NzI3IDE0LjU5NzggMTQuNzI0MyAxNi4xMzM4IDE0LjEzMzIgMTcuMTAzOUMxMy41NjY0IDE4LjAzNDEgMTMuMzY5IDE4LjkxMzMgMTMuNzgzNiAyMC42MTE1QzEzLjgwNTYgMjAuNzAxNiAxMy43MTI2IDIwLjc4MDQgMTMuNjI1OCAyMC43NDE4QzEyLjg4NTEgMjAuNDEyMSAxMSAxOS40MjMgMTEgMTcuMDY1MkMxMSAxMy43MzkzIDE0Ljc5MzUgMTMuNjIwNSAxNC42MTUyIDkuMTE5MDlDMTQuNjExNiA5LjAyODYxIDE0LjcxMzcgOC45NjcxMSAxNC43OTAxIDkuMDE5MjRDMTYuMDMxMSA5Ljg2NjY1IDE2Ljc3NTQgMTEuMjgyIDE2LjYyNzcgMTIuOTAwMVoiIGZpbGw9IiNGMEYxRjQiLz4KPHBhdGggZD0iTTE0LjE1MzIgMjAuODc2MkMxNC4xMDg3IDIwLjg2MyAxNC4wNzc3IDIwLjgyMzcgMTQuMDc2IDIwLjc3ODZDMTQuMDMyOCAxOS42NzUzIDE0LjY0NDkgMTguOTU0MyAxNS4zMzEyIDE4LjQxOTRDMTYuODU0NyAxNy4yMzIgMTcuNzk0IDE1LjYyODUgMTcuNDIyMyAxMy43NzMzQzE3LjQwMDEgMTMuNjYyNiAxNy41MzM4IDEzLjU4OTUgMTcuNjA4NSAxMy42NzU5QzE3Ljk2NjkgMTQuMDkwMiAxOC4zMzE5IDE0LjY1MTggMTguNTMzOSAxNS4wNjExQzE5LjUwODQgMTcuMDkxMiAxOC45ODgzIDE5LjQxNzYgMTYuNjU2NyAyMC41OTE2QzE1LjkyNjYgMjAuOTQzMSAxNS4wNTk4IDIxLjE0NDkgMTQuMTUzMiAyMC44NzYyWiIgZmlsbD0iI0YwRjFGNCIvPgo8cGF0aCBkPSJNMTEuNSAyNS40MzE2QzcuMTQwNzkgMjMuOTY5NiA0IDE5Ljg1MTYgNCAxNS4wMDAxQzQgOC45MjQ5OSA4LjkyNDg3IDQuMDAwMTIgMTUgNC4wMDAxMkwxNCA2LjUwMDEyIiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjQwMDM5IDMuNjQ5OUM0LjcxMDA0IDMuNjQ5OSA0LjE1MDM5IDQuMjA5NTUgNC4xNTAzOSA0Ljg5OTlWMjQuOTA5OUM0LjE1MDM5IDI1LjYwMDMgNC43MTAwMyAyNi4xNTk5IDUuNDAwMzkgMjYuMTU5OUgxMy4xMjA1QzEyLjc2MTggMjUuNjkyOSAxMi40NDY0IDI1LjE5MDkgMTIuMTgwNCAyNC42NTk5SDUuNjUwMzlWNS4xNDk5SDIyLjg1NjRWMTEuNTAwOUMyMy4zNzU0IDExLjYzNjQgMjMuODc2OCAxMS44MTU3IDI0LjM1NjQgMTIuMDM0NVY0Ljg5OTlDMjQuMzU2NCA0LjIwOTU1IDIzLjc5NjcgMy42NDk5IDIzLjEwNjQgMy42NDk5SDUuNDAwMzlaTTI0LjM1NjQgMTQuMDY1N0MyMy44ODczIDEzLjc4NCAyMy4zODQ4IDEzLjU1MjEgMjIuODU2NCAxMy4zNzc0VjEzLjVWMTQuMjVIMjQuMzU2NFYxNC4wNjU3Wk0xNC4yNTg5IDI0LjY1OTlDMTQuNjMxIDI1LjIxNyAxNS4wNzU2IDI1LjcyMTUgMTUuNTc5NCAyNi4xNTk5SDE2LjI1VjI0LjY1OTlIMTUuNUgxNC4yNTg5WiIgZmlsbD0iI0YwRjFGNCIvPgo8cGF0aCBkPSJNOS41NzQyMiA5LjA3NzE1SDE4LjkyNzIiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTkuNTc0NTggMTMuNDc5SDEyLjU3NDYiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPGNpcmNsZSBjeD0iMjAuNTAwNCIgY3k9IjIwLjUiIHI9IjYuNzUiIHN0cm9rZT0iIzAwOTRmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPG1hc2sgaWQ9InBhdGgtNS1vdXRzaWRlLTFfMjkwNl80MjAzNiIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMTUuOTYzNSIgeT0iMTUuMDc1MyIgd2lkdGg9IjkuMDkwODUiIGhlaWdodD0iMTAuNTA1MSIgZmlsbD0iYmxhY2siPgo8cmVjdCBmaWxsPSJ3aGl0ZSIgeD0iMTUuOTYzNSIgeT0iMTUuMDc1MyIgd2lkdGg9IjkuMDkwODUiIGhlaWdodD0iMTAuNTA1MSIvPgo8cGF0aCBkPSJNMTkuMDY4NyAyNC4wODNDMTguODQxMiAyNC4wMjIxIDE4LjYxMzYgMjMuOTYxMSAxOC4zODYxIDIzLjkwMDFDMTguNDg3NyAyMy41MjA4IDE4LjU4OTQgMjMuMTQxNSAxOC42OTEgMjIuNzYyM0MxOC4yNDYxIDIyLjYwMjQgMTcuODI5IDIyLjQ5MDYgMTcuMzczOSAyMi4zNjg3QzE3LjU5MiAyMS44NTggMTcuNjQwMSAyMS44MzAyIDE3LjY5MDkgMjEuNjQwNkMxNy43MDExIDIxLjYwMjcgMTcuNzM5IDIxLjYxMjggMTcuNzc2OSAyMS42MjNDMTcuOTI4NiAyMS42NjM2IDE4LjA0MjQgMjEuNjk0MSAxOC4xOTQxIDIxLjczNDhDMTguNDIxNiAyMS43OTU3IDE4LjQ3OTkgMjEuNzMgMTguNTIwNSAyMS41NzgzQzE4Ljc3NDYgMjAuNjMwMSAxOS4wMTg1IDE5LjcxOTggMTkuMjcyNiAxOC43NzE2QzE5LjM0MzcgMTguNTA2MSAxOS4xODQ2IDE4LjM0MTUgMTguOTk1IDE4LjI5MDdDMTguODQzMyAxOC4yNSAxOC42OTE2IDE4LjIwOTQgMTguNTM5OSAxOC4xNjg3QzE4LjYwMDkgMTcuOTQxMiAxOC42NjE5IDE3LjcxMzYgMTguNzIyOSAxNy40ODZDMTguOTUwNCAxNy41NDcgMTkuNDQzNCAxNy42NzkxIDE5LjkzNjQgMTcuODExMkMyMC4wMTIyIDE3LjgzMTUgMjAuMDEyMiAxNy44MzE1IDIwLjAzMjUgMTcuNzU1NkMyMC4wOTM1IDE3LjUyODEgMjAuMjU2MSAxNi45MjEyIDIwLjMyNzIgMTYuNjU1N0MyMC41NTQ4IDE2LjcxNjcgMjAuNzgyMyAxNi43Nzc2IDIxLjAwOTggMTYuODM4NkMyMC45MDgyIDE3LjIxNzkgMjAuODA2NiAxNy41OTcyIDIwLjcwNDkgMTcuOTc2NUMyMC44OTQ2IDE4LjAyNzMgMjEuMDQ2MiAxOC4wNjc5IDIxLjIzNTggMTguMTE4N0MyMS4zMzc1IDE3LjczOTQgMjEuNDM5MSAxNy4zNjAxIDIxLjU0MDcgMTYuOTgwOEMyMS43NjgzIDE3LjA0MTggMjEuOTU3OSAxNy4wOTI2IDIyLjE4NTQgMTcuMTUzNkMyMi4xNTQ5IDE3LjI2NzQgMjEuOTAwOCAxOC4yMTU2IDIxLjg5MDcgMTguMjUzNUMyMS44ODA1IDE4LjI5MTQgMjEuODcwMyAxOC4zMjk0IDIxLjk0NjIgMTguMzQ5N0MyMi43MTIgMTguNjc2OSAyMy4yOTU3IDE5LjA3NzIgMjMuMTU4MiAxOS44OTRDMjMuMTI0OSAyMC4xNjk3IDIzLjAxNTkgMjAuNDI1IDIyLjc2NTMgMjAuNjAxOEMyMi42MTA5IDIwLjcyMyAyMi40Mzg5IDIwLjc1ODIgMjIuMzA0OCAyMC44MDM2QzIyLjQ3NCAyMC45MzAzIDIyLjk3NDUgMjEuMTg2MyAyMi45ODM5IDIxLjc1OEMyMi45OTg3IDIyLjAwNTkgMjIuOTM3NyAyMi4yMzM0IDIyLjg0OSAyMi40MTI5QzIyLjc1MDEgMjIuNjMwMyAyMi42MTMzIDIyLjgzNzYgMjIuNDQ4NyAyMi45OTY3QzIyLjIzNiAyMy4xODM3IDIxLjk2NzkgMjMuMjc0NCAyMS42NzE5IDIzLjMxNzFDMjEuMzM4MSAyMy4zNDk2IDIwLjk3NjQgMjMuMzM0IDIwLjYzNTIgMjMuMjQyNUMyMC41OTcyIDIzLjIzMjQgMjAuNTU5MyAyMy4yMjIyIDIwLjUzOSAyMy4yOTgxQzIwLjQ0NzUgMjMuNjM5NCAyMC4zNjYyIDIzLjk0MjkgMjAuMjQ0MyAyNC4zOThDMjAuMDE2NyAyNC4zMzcxIDE5LjgyNzEgMjQuMjg2MiAxOS41OTk2IDI0LjIyNTNDMTkuNzAxMiAyMy44NDYgMTkuODAyOSAyMy40NjY3IDE5LjkwNDUgMjMuMDg3NEMxOS43MTQ5IDIzLjAzNjYgMTkuNTYzMiAyMi45OTYgMTkuMzczNiAyMi45NDUyQzE5LjI3MiAyMy4zMjQ0IDE5LjE3MDMgMjMuNzAzNyAxOS4wNjg3IDI0LjA4M1pNMTkuOTczMiAyMC43MDczQzE5Ljg0MTEgMjEuMjAwNCAxOS43MTkxIDIxLjY1NTYgMTkuNTg3IDIyLjE0ODZDMjAuMjc5OCAyMi4yOTM2IDIwLjY0ODggMjIuNDMzMiAyMS4xMTY4IDIyLjM1NTNDMjEuMzM2OSAyMi4yOTIzIDIxLjQ5MTMgMjIuMTcxMSAyMS41OTAyIDIxLjk1MzdDMjEuNjUxMSAyMS43MjYxIDIxLjYyNjEgMjEuNTE2MSAyMS40MzkyIDIxLjMwMzRDMjEuMTIxIDIwLjk3NDIgMjAuNDI4MyAyMC44MjkzIDE5Ljk3MzIgMjAuNzA3M0MyMC4wMTExIDIwLjcxNzUgMjAuMDExMSAyMC43MTc1IDE5Ljk3MzIgMjAuNzA3M1pNMjAuNDkxNSAxOC43NzNDMjAuMzY5NiAxOS4yMjgxIDIwLjI1NzggMTkuNjQ1MyAyMC4xNDYgMjAuMDYyNUMyMC40MDEzIDIwLjE3MTYgMjAuOTA0NCAyMC4yNjU4IDIxLjE1MjMgMjAuMjUwOUMyMS44ODU3IDIwLjI0NDEgMjIuMDAyOSAxOS41MDMyIDIxLjU5ODcgMTkuMTkxNkMyMS4yNjAxIDE4LjkzODMgMjAuODMyOCAxOC44NjQ0IDIwLjQ5MTUgMTguNzczWiIvPgo8L21hc2s+CjxwYXRoIGQ9Ik0xOS4wNjg3IDI0LjA4M0MxOC44NDEyIDI0LjAyMjEgMTguNjEzNiAyMy45NjExIDE4LjM4NjEgMjMuOTAwMUMxOC40ODc3IDIzLjUyMDggMTguNTg5NCAyMy4xNDE1IDE4LjY5MSAyMi43NjIzQzE4LjI0NjEgMjIuNjAyNCAxNy44MjkgMjIuNDkwNiAxNy4zNzM5IDIyLjM2ODdDMTcuNTkyIDIxLjg1OCAxNy42NDAxIDIxLjgzMDIgMTcuNjkwOSAyMS42NDA2QzE3LjcwMTEgMjEuNjAyNyAxNy43MzkgMjEuNjEyOCAxNy43NzY5IDIxLjYyM0MxNy45Mjg2IDIxLjY2MzYgMTguMDQyNCAyMS42OTQxIDE4LjE5NDEgMjEuNzM0OEMxOC40MjE2IDIxLjc5NTcgMTguNDc5OSAyMS43MyAxOC41MjA1IDIxLjU3ODNDMTguNzc0NiAyMC42MzAxIDE5LjAxODUgMTkuNzE5OCAxOS4yNzI2IDE4Ljc3MTZDMTkuMzQzNyAxOC41MDYxIDE5LjE4NDYgMTguMzQxNSAxOC45OTUgMTguMjkwN0MxOC44NDMzIDE4LjI1IDE4LjY5MTYgMTguMjA5NCAxOC41Mzk5IDE4LjE2ODdDMTguNjAwOSAxNy45NDEyIDE4LjY2MTkgMTcuNzEzNiAxOC43MjI5IDE3LjQ4NkMxOC45NTA0IDE3LjU0NyAxOS40NDM0IDE3LjY3OTEgMTkuOTM2NCAxNy44MTEyQzIwLjAxMjIgMTcuODMxNSAyMC4wMTIyIDE3LjgzMTUgMjAuMDMyNSAxNy43NTU2QzIwLjA5MzUgMTcuNTI4MSAyMC4yNTYxIDE2LjkyMTIgMjAuMzI3MiAxNi42NTU3QzIwLjU1NDggMTYuNzE2NyAyMC43ODIzIDE2Ljc3NzYgMjEuMDA5OCAxNi44Mzg2QzIwLjkwODIgMTcuMjE3OSAyMC44MDY2IDE3LjU5NzIgMjAuNzA0OSAxNy45NzY1QzIwLjg5NDYgMTguMDI3MyAyMS4wNDYyIDE4LjA2NzkgMjEuMjM1OCAxOC4xMTg3QzIxLjMzNzUgMTcuNzM5NCAyMS40MzkxIDE3LjM2MDEgMjEuNTQwNyAxNi45ODA4QzIxLjc2ODMgMTcuMDQxOCAyMS45NTc5IDE3LjA5MjYgMjIuMTg1NCAxNy4xNTM2QzIyLjE1NDkgMTcuMjY3NCAyMS45MDA4IDE4LjIxNTYgMjEuODkwNyAxOC4yNTM1QzIxLjg4MDUgMTguMjkxNCAyMS44NzAzIDE4LjMyOTQgMjEuOTQ2MiAxOC4zNDk3QzIyLjcxMiAxOC42NzY5IDIzLjI5NTcgMTkuMDc3MiAyMy4xNTgyIDE5Ljg5NEMyMy4xMjQ5IDIwLjE2OTcgMjMuMDE1OSAyMC40MjUgMjIuNzY1MyAyMC42MDE4QzIyLjYxMDkgMjAuNzIzIDIyLjQzODkgMjAuNzU4MiAyMi4zMDQ4IDIwLjgwMzZDMjIuNDc0IDIwLjkzMDMgMjIuOTc0NSAyMS4xODYzIDIyLjk4MzkgMjEuNzU4QzIyLjk5ODcgMjIuMDA1OSAyMi45Mzc3IDIyLjIzMzQgMjIuODQ5IDIyLjQxMjlDMjIuNzUwMSAyMi42MzAzIDIyLjYxMzMgMjIuODM3NiAyMi40NDg3IDIyLjk5NjdDMjIuMjM2IDIzLjE4MzcgMjEuOTY3OSAyMy4yNzQ0IDIxLjY3MTkgMjMuMzE3MUMyMS4zMzgxIDIzLjM0OTYgMjAuOTc2NCAyMy4zMzQgMjAuNjM1MiAyMy4yNDI1QzIwLjU5NzIgMjMuMjMyNCAyMC41NTkzIDIzLjIyMjIgMjAuNTM5IDIzLjI5ODFDMjAuNDQ3NSAyMy42Mzk0IDIwLjM2NjIgMjMuOTQyOSAyMC4yNDQzIDI0LjM5OEMyMC4wMTY3IDI0LjMzNzEgMTkuODI3MSAyNC4yODYyIDE5LjU5OTYgMjQuMjI1M0MxOS43MDEyIDIzLjg0NiAxOS44MDI5IDIzLjQ2NjcgMTkuOTA0NSAyMy4wODc0QzE5LjcxNDkgMjMuMDM2NiAxOS41NjMyIDIyLjk5NiAxOS4zNzM2IDIyLjk0NTJDMTkuMjcyIDIzLjMyNDQgMTkuMTcwMyAyMy43MDM3IDE5LjA2ODcgMjQuMDgzWk0xOS45NzMyIDIwLjcwNzNDMTkuODQxMSAyMS4yMDA0IDE5LjcxOTEgMjEuNjU1NiAxOS41ODcgMjIuMTQ4NkMyMC4yNzk4IDIyLjI5MzYgMjAuNjQ4OCAyMi40MzMyIDIxLjExNjggMjIuMzU1M0MyMS4zMzY5IDIyLjI5MjMgMjEuNDkxMyAyMi4xNzExIDIxLjU5MDIgMjEuOTUzN0MyMS42NTExIDIxLjcyNjEgMjEuNjI2MSAyMS41MTYxIDIxLjQzOTIgMjEuMzAzNEMyMS4xMjEgMjAuOTc0MiAyMC40MjgzIDIwLjgyOTMgMTkuOTczMiAyMC43MDczQzIwLjAxMTEgMjAuNzE3NSAyMC4wMTExIDIwLjcxNzUgMTkuOTczMiAyMC43MDczWk0yMC40OTE1IDE4Ljc3M0MyMC4zNjk2IDE5LjIyODEgMjAuMjU3OCAxOS42NDUzIDIwLjE0NiAyMC4wNjI1QzIwLjQwMTMgMjAuMTcxNiAyMC45MDQ0IDIwLjI2NTggMjEuMTUyMyAyMC4yNTA5QzIxLjg4NTcgMjAuMjQ0MSAyMi4wMDI5IDE5LjUwMzIgMjEuNTk4NyAxOS4xOTE2QzIxLjI2MDEgMTguOTM4MyAyMC44MzI4IDE4Ljg2NDQgMjAuNDkxNSAxOC43NzNaIiBmaWxsPSIjMDA5NGZmIi8+Cgo8L3N2Zz4K"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjcwMTE3IDMuNTUwMDVDNS4wMTA4MiAzLjU1MDA1IDQuNDUxMTcgNC4xMDk2OSA0LjQ1MTE3IDQuODAwMDVWMjQuODFDNC40NTExNyAyNS41MDA0IDUuMDEwODEgMjYuMDYgNS43MDExNyAyNi4wNkgxNy43MzQ5TDE2LjMyMzEgMjQuNTZINS45NTExN1Y1LjA1MDA1SDIzLjE1NzFWMTMuNzA0OEwyNC42NTcxIDE1LjYwNTNWNC44MDAwNUMyNC42NTcxIDQuMTA5NjkgMjQuMDk3NSAzLjU1MDA1IDIzLjQwNzEgMy41NTAwNUg1LjcwMTE3WiIgZmlsbD0iIzAwMDAwMCIvPgo8cGF0aCBkPSJNOS44NzUgOC45NzcyOUgxOS4yMjgiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTkuODc1IDEzLjM3OTJIMTQuMjc2NCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMjMuOTAzMyAyNi40MDg0VjE5LjI1NjFMMjYuMTA0IDIyLjAwNyIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMjAuMDExNyAxNy42MDQ3VjI0LjIwNjhMMTcuOTA1NiAyMi4wMDYxIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjcwMTE3IDMuNTUwMDVDNS4wMTA4MiAzLjU1MDA1IDQuNDUxMTcgNC4xMDk2OSA0LjQ1MTE3IDQuODAwMDVWMjQuODFDNC40NTExNyAyNS41MDA0IDUuMDEwODEgMjYuMDYgNS43MDExNyAyNi4wNkgxNy43MzQ5TDE2LjMyMzEgMjQuNTZINS45NTExN1Y1LjA1MDA1SDIzLjE1NzFWMTMuNzA0OEwyNC42NTcxIDE1LjYwNTNWNC44MDAwNUMyNC42NTcxIDQuMTA5NjkgMjQuMDk3NSAzLjU1MDA1IDIzLjQwNzEgMy41NTAwNUg1LjcwMTE3WiIgZmlsbD0iI0YwRjFGNCIvPgo8cGF0aCBkPSJNOS44NzUgOC45NzcyOUgxOS4yMjgiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTkuODc1IDEzLjM3OTJIMTQuMjc2NCIgc3Ryb2tlPSIjRjBGMUY0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMjMuOTAzMyAyNi40MDg0VjE5LjI1NjFMMjYuMTA0IDIyLjAwNyIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMjAuMDExNyAxNy42MDQ3VjI0LjIwNjhMMTcuOTA1NiAyMi4wMDYxIiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUgMjMuOTY0N0g1LjI1MzcyQzQuNTYzMzYgMjMuOTY0NyA0LjAwMzcyIDIzLjQwNTEgNC4wMDM3MiAyMi43MTQ3VjcuMjg2MTNDNC4wMDM3MiA2LjU5NTc3IDQuNTYzMzcgNi4wMzYxMyA1LjI1MzcyIDYuMDM2MTNIOC41VjcuNTM2MTNINS41MDM3MlYyMi40NjQ3SDguNVYyMy45NjQ3WiIgZmlsbD0iIzAwOTRmZiIvPgo8cGF0aCBkPSJNMTAuODEyOSA0LjAzNjk5QzEwLjgxMjkgMy43NDY4MiAxMS4wNTkxIDMuNTE3NTggMTEuMzQ4NiAzLjUzODI2TDI1LjY4MTkgNC41NjIwN0MyNS45NDM1IDQuNTgwNzYgMjYuMTQ2MyA0Ljc5ODQ4IDI2LjE0NjMgNS4wNjA4VjI0LjkzOTJDMjYuMTQ2MyAyNS4yMDE1IDI1Ljk0MzUgMjUuNDE5MiAyNS42ODE5IDI1LjQzNzlMMTEuMzQ4NiAyNi40NjE3QzExLjA1OTEgMjYuNDgyNCAxMC44MTI5IDI2LjI1MzIgMTAuODEyOSAyNS45NjNWNC4wMzY5OVoiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTE1Ljc0MjEgMTQuNDUyMUwyMi4zMTM2IDE0LjQ1MjEiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTE5LjAyNzIgMTAuMzQxOEwxOS4wMjcyIDE4LjU1MTgiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUgMjMuOTY0N0g1LjI1MzcyQzQuNTYzMzYgMjMuOTY0NyA0LjAwMzcyIDIzLjQwNTEgNC4wMDM3MiAyMi43MTQ3VjcuMjg2MTNDNC4wMDM3MiA2LjU5NTc3IDQuNTYzMzcgNi4wMzYxMyA1LjI1MzcyIDYuMDM2MTNIOC41VjcuNTM2MTNINS41MDM3MlYyMi40NjQ3SDguNVYyMy45NjQ3WiIgZmlsbD0iIzAwOTRmZiIvPgo8cGF0aCBkPSJNMTAuODEyNSA0LjAzNjk5QzEwLjgxMjUgMy43NDY4MiAxMS4wNTg3IDMuNTE3NTggMTEuMzQ4MSAzLjUzODI2TDI1LjY4MTUgNC41NjIwN0MyNS45NDMxIDQuNTgwNzYgMjYuMTQ1OCA0Ljc5ODQ4IDI2LjE0NTggNS4wNjA4VjI0LjkzOTJDMjYuMTQ1OCAyNS4yMDE1IDI1Ljk0MzEgMjUuNDE5MiAyNS42ODE1IDI1LjQzNzlMMTEuMzQ4MSAyNi40NjE3QzExLjA1ODcgMjYuNDgyNCAxMC44MTI1IDI2LjI1MzIgMTAuODEyNSAyNS45NjNWNC4wMzY5OVoiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTE1Ljc0MjEgMTQuNDUyMUwyMi4zMTM2IDE0LjQ1MjEiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTE5LjAyNzIgMTAuMzQxOEwxOS4wMjcyIDE4LjU1MTgiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguODU3MjIgMjIuNDc3MkM4LjcyNTg1IDIyLjE0ODggOC45Njc3MyAyMS43OTE1IDkuMzIxNDYgMjEuNzkxNUgyMS4zODYyQzIxLjczOTkgMjEuNzkxNSAyMS45ODE4IDIyLjE0ODggMjEuODUwNCAyMi40NzcyTDIwLjE2NzEgMjYuNjg1NkMyMC4wOTExIDI2Ljg3NTQgMTkuOTA3MyAyNi45OTk5IDE5LjcwMjggMjYuOTk5OUgxMS4wMDQ4QzEwLjgwMDQgMjYuOTk5OSAxMC42MTY1IDI2Ljg3NTQgMTAuNTQwNiAyNi42ODU2TDguODU3MjIgMjIuNDc3MloiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTE1LjM1MzUgMjEuNzkxN1YxNC41IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxjaXJjbGUgY3g9IjE1LjM1MzYiIGN5PSI4LjI1MDA0IiByPSI2LjI1MDA0IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMC41MzM1IDE2LjY2NDZMNy45NTM0MSAxNS4xNzVDNi42MzgxMSAxNC40MTU2IDQuOTU2MjMgMTQuODY2MyA0LjE5Njg0IDE2LjE4MTZMNC4wMDkzMyAxNi41MDY0TDYuNTkzNTcgMTguMDA5M0M3Ljk2OTA0IDE4LjgwOTIgOS43MzQyNyAxOC4yNzg0IDEwLjQ0MDQgMTYuODUyNUwxMC41MzM1IDE2LjY2NDZaTTEwLjUzMzUgMTYuNjY0NkwxMi4zMzc3IDE3LjcwNjMiIHN0cm9rZT0iIzAwOTRmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTE5Ljc4OTEgMTcuMjg5NEwyMC4xOTgzIDE3Ljk5ODFDMjAuNzUyNSAxOC45NTgxIDIxLjk4MTggMTkuMjg0MiAyMi45MzkgMTguNzI1MkwyNS43ODYgMTcuMDYyNEwyNS4yNDY5IDE2LjEyODZDMjQuNjg1NiAxNS4xNTYzIDIzLjQzNDEgMTQuODM2NCAyMi40NzUxIDE1LjQyMDFMMTYuMjQ5IDE5LjIwOTNMMTQuOTMzNCAyMC4wODEzIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguODU3MjkgMjIuNDc3MkM4LjcyNTkxIDIyLjE0ODggOC45Njc3OSAyMS43OTE1IDkuMzIxNTIgMjEuNzkxNUgyMS4zODYyQzIxLjc0IDIxLjc5MTUgMjEuOTgxOSAyMi4xNDg4IDIxLjg1MDUgMjIuNDc3MkwyMC4xNjcxIDI2LjY4NTZDMjAuMDkxMiAyNi44NzU0IDE5LjkwNzQgMjYuOTk5OSAxOS43MDI5IDI2Ljk5OTlIMTEuMDA0OUMxMC44MDA0IDI2Ljk5OTkgMTAuNjE2NiAyNi44NzU0IDEwLjU0MDYgMjYuNjg1Nkw4Ljg1NzI5IDIyLjQ3NzJaIiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0xMC42MDAxIDE2LjU4MzNMOC4wMiAxNS4wOTM3QzYuNzA0NyAxNC4zMzQzIDUuMDIyODIgMTQuNzg1IDQuMjYzNDMgMTYuMTAwM0w0LjA3NTkyIDE2LjQyNTFMNi42NjAxNiAxNy45MjhDOC4wMzU2MiAxOC43Mjc5IDkuODAwODYgMTguMTk3MSAxMC41MDcgMTYuNzcxMkwxMC42MDAxIDE2LjU4MzNaTTEwLjYwMDEgMTYuNTgzM0wxMi40MDQzIDE3LjYyNSIgc3Ryb2tlPSIjMDA5NGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTUuMzUzNSAyMS43OTE3VjE0LjUiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGNpcmNsZSBjeD0iMTUuMzUzNiIgY3k9IjguMjUwMDQiIHI9IjYuMjUwMDQiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTE5Ljg1NTcgMTcuMjA4MUwyMC4yNjQ5IDE3LjkxNjhDMjAuODE5MSAxOC44NzY4IDIyLjA0ODQgMTkuMjAyOSAyMy4wMDU2IDE4LjY0MzlMMjUuODUyNiAxNi45ODExTDI1LjMxMzUgMTYuMDQ3M0MyNC43NTIyIDE1LjA3NSAyMy41MDA3IDE0Ljc1NTEgMjIuNTQxNyAxNS4zMzg4TDE2LjMxNTUgMTkuMTI4TDE1IDIwIiBzdHJva2U9IiNGMEYxRjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNC44ODA2IDE5LjE4NTJDMjUuMzA1NSAxOC45NTM3IDI1LjcwMDEgMTguNjk0OCAyNi4wNDk4IDE4LjQwNTVDMjYuMTYxMSAxOC4zMTM0IDI2LjI3MjEgMTguMjE0NCAyNi4zODA2IDE4LjEwODZWMjAuNTk5N0MyNi4zODA2IDIxLjQyMDUgMjUuOTAzNSAyMi4wOTU5IDI1LjI4MjQgMjIuNjA5OEMyNC42NTY1IDIzLjEyNzcgMjMuNzk1OSAyMy41NjA1IDIyLjc5ODUgMjMuOTA5NUMyMC43OTY5IDI0LjYwOTkgMTguMDgwNSAyNS4wMjkzIDE1LjExNTUgMjUuMDI5M0MxMi4xNTA1IDI1LjAyOTMgOS40MzQxMyAyNC42MDk5IDcuNDMyNDggMjMuOTA5NUM2LjQzNTEyIDIzLjU2MDUgNS41NzQ1NCAyMy4xMjc3IDQuOTQ4NjMgMjIuNjA5OEM0LjMyNzUxIDIyLjA5NTkgMy44NTA0IDIxLjQyMDUgMy44NTA0IDIwLjU5OTdWMTguMzM4MkMzLjg3Njk3IDE4LjM2MSAzLjkwMzU5IDE4LjM4MzUgMy45MzAyMyAxOC40MDU1QzQuMzQ3ODUgMTguNzUxIDQuODI5NjMgMTkuMDUzMSA1LjM1MDQgMTkuMzE3MlYyMC41OTk3QzUuMzUwNCAyMC43OTUgNS40NjE3NiAyMS4wODc1IDUuOTA0ODMgMjEuNDU0MUM2LjM0MzExIDIxLjgxNjcgNy4wMjI0MyAyMi4xNzY4IDcuOTI3OTMgMjIuNDkzN0M5LjczMiAyMy4xMjUgMTIuMjczMiAyMy41MjkzIDE1LjExNTUgMjMuNTI5M0MxNy45NTc4IDIzLjUyOTMgMjAuNDk5IDIzLjEyNSAyMi4zMDMxIDIyLjQ5MzdDMjMuMjA4NiAyMi4xNzY4IDIzLjg4NzkgMjEuODE2NyAyNC4zMjYyIDIxLjQ1NDFDMjQuNzY5MiAyMS4wODc1IDI0Ljg4MDYgMjAuNzk1IDI0Ljg4MDYgMjAuNTk5N1YxOS4xODUyWiIgZmlsbD0iIzAwOTRmZiIvPgo8ZWxsaXBzZSBjeD0iMTUuMjE4IiBjeT0iOS4xNzk2NyIgcng9IjEwLjUxNTEiIHJ5PSIzLjY3OTY3IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yNS43MzMxIDkuNVYxNC43Nzk4QzI1LjczMzEgMTYuODEyIDIxLjAyNTQgMTguNDU5NCAxNS4yMTggMTguNDU5NEM5LjQxMDcxIDE4LjQ1OTQgNC43MDI5NCAxNi44MTIgNC43MDI5NCAxNC43Nzk4VjkuNSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNC44ODA4IDE5LjE4NTJDMjUuMzA1NiAxOC45NTM3IDI1LjcwMDMgMTguNjk0OCAyNi4wNSAxOC40MDU1QzI2LjE2MTMgMTguMzEzNCAyNi4yNzIzIDE4LjIxNDQgMjYuMzgwOCAxOC4xMDg2VjIwLjU5OTZDMjYuMzgwOCAyMS40MjA0IDI1LjkwMzcgMjIuMDk1OSAyNS4yODI2IDIyLjYwOThDMjQuNjU2NiAyMy4xMjc2IDIzLjc5NjEgMjMuNTYwNCAyMi43OTg3IDIzLjkwOTRDMjAuNzk3MSAyNC42MDk5IDE4LjA4MDcgMjUuMDI5MyAxNS4xMTU3IDI1LjAyOTNDMTIuMTUwNyAyNS4wMjkzIDkuNDM0MzEgMjQuNjA5OSA3LjQzMjY2IDIzLjkwOTRDNi40MzUzIDIzLjU2MDQgNS41NzQ3MiAyMy4xMjc2IDQuOTQ4ODIgMjIuNjA5OEM0LjMyNzcgMjIuMDk1OSAzLjg1MDU5IDIxLjQyMDQgMy44NTA1OSAyMC41OTk2VjE4LjMzODJDMy44NzcxNiAxOC4zNjEgMy45MDM3NyAxOC4zODM1IDMuOTMwNDEgMTguNDA1NUM0LjM0ODA0IDE4Ljc1MSA0LjgyOTgxIDE5LjA1MzEgNS4zNTA1OSAxOS4zMTcyVjIwLjU5OTZDNS4zNTA1OSAyMC43OTQ5IDUuNDYxOTUgMjEuMDg3NSA1LjkwNTAxIDIxLjQ1NEM2LjM0MzI5IDIxLjgxNjcgNy4wMjI2MSAyMi4xNzY3IDcuOTI4MTEgMjIuNDkzNkM5LjczMjE4IDIzLjEyNDkgMTIuMjczMyAyMy41MjkzIDE1LjExNTcgMjMuNTI5M0MxNy45NTggMjMuNTI5MyAyMC40OTkyIDIzLjEyNDkgMjIuMzAzMyAyMi40OTM2QzIzLjIwODggMjIuMTc2NyAyMy44ODgxIDIxLjgxNjcgMjQuMzI2NCAyMS40NTRDMjQuNzY5NCAyMS4wODc1IDI0Ljg4MDggMjAuNzk0OSAyNC44ODA4IDIwLjU5OTZWMTkuMTg1MloiIGZpbGw9IiMwMDk0ZmYiLz4KPGVsbGlwc2UgY3g9IjE1LjIxODIiIGN5PSI5LjE3OTY3IiByeD0iMTAuNTE1MSIgcnk9IjMuNjc5NjciIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTI1LjczMzMgOS41VjE0Ljc3OThDMjUuNzMzMyAxNi44MTIgMjEuMDI1NiAxOC40NTk0IDE1LjIxODIgMTguNDU5NEM5LjQxMDg5IDE4LjQ1OTQgNC43MDMxMiAxNi44MTIgNC43MDMxMiAxNC43Nzk4VjkuNSIgc3Ryb2tlPSIjRjBGMUY0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02Ljg3MTA5IDExLjI4OTJDNi45ODY3NyAxMC44OTE1IDYuNzU4MTIgMTAuNDc1MyA2LjM2MDM4IDEwLjM1OTZDNS45NjI2NSAxMC4yNDM5IDUuNTQ2NDUgMTAuNDcyNiA1LjQzMDc3IDEwLjg3MDNMMi44NzIxMiAxOS42Njc3TDIuODAzNDcgMTkuOTAzOEwyLjg4Nzg2IDIwLjEzNDZMNS4yODE5NSAyNi42ODQ3SDYuODc5MDFMNi44NzUxNSAyNi42NzQxTDQuMzgxMDkgMTkuODUwNkw2Ljg3MTA5IDExLjI4OTJaIiBmaWxsPSIjMDAwMDAwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi4yOTYzOSAxNC41MTUyQzYuMjk2MzkgOS4xNTgwNSAxMC42MzkyIDQuODE1MTkgMTUuOTk2NCA0LjgxNTE5QzIxLjM1MzYgNC44MTUxOSAyNS42OTY1IDkuMTU4MDUgMjUuNjk2NSAxNC41MTUyQzI1LjY5NjUgMTguMDY4MSAyMy43ODY1IDIxLjE3NjEgMjAuOTM0NCAyMi44NjYzTDIwLjI2NTYgMjQuODcyN0MyMC41MzUzIDI0Ljc2MTQgMjAuNzk5OCAyNC42Mzk5IDIxLjA1ODUgMjQuNTA4NkMyNC42OTkgMjIuNjYxMSAyNy4xOTY1IDE4Ljg4MDUgMjcuMTk2NSAxNC41MTUyQzI3LjE5NjUgOC4zMjk2MiAyMi4xODIxIDMuMzE1MTkgMTUuOTk2NCAzLjMxNTE5QzkuODEwODIgMy4zMTUxOSA0Ljc5NjM5IDguMzI5NjIgNC43OTYzOSAxNC41MTUyQzQuNzk2MzkgMTcuODA2IDYuMjE2NiAyMC43NjYyIDguNDc1MjEgMjIuODE0M0M4LjY0MDAyIDIyLjk2MzcgOC44MDkzMSAyMy4xMDgzIDguOTgyODcgMjMuMjQ3OUw5Ljc4NDM3IDIxLjk2NTVDOS42ODIwNSAyMS44ODAxIDkuNTgxNTEgMjEuNzkyNiA5LjQ4MjgxIDIxLjcwMzFDNy41MjQ1NCAxOS45MjczIDYuMjk2MzkgMTcuMzY1MiA2LjI5NjM5IDE0LjUxNTJaIiBmaWxsPSIjMDAwMDAwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuMzQzNSAxMy42MzA0QzExLjg1NTMgMTQuMTE4NSAxMS44NTUzIDE0LjkxIDEyLjM0MzUgMTUuMzk4MkwxMy40MTAyIDE2LjQ2NDhMMTQuMjU4NyAxNS4xOTJMMTMuNTgwOSAxNC41MTQzTDE2LjQwOTEgMTEuNjg2MUwxOS4yMzczIDE0LjUxNDNMMTguMjY2MSAxNS40ODU1TDE5LjY4MDMgMTYuMTkyNkwyMC40NzQ3IDE1LjM5ODJDMjAuOTYyOSAxNC45MSAyMC45NjI5IDE0LjExODUgMjAuNDc0NyAxMy42MzA0TDE3LjI5MyAxMC40NDg2QzE2LjgwNDggOS45NjA0OCAxNi4wMTM0IDkuOTYwNDggMTUuNTI1MiAxMC40NDg2TDEyLjM0MzUgMTMuNjMwNFoiIGZpbGw9IiMwMDk0ZmYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC41MTU0IDI2LjY4NTFMMTYuMTgxNiAxOC4wMTU2TDE4Ljg0ODkgMTkuMzA4M0wxNi4xMzkyIDI2LjY4NTFIMTcuNzM3MkwyMC4zMzUgMTkuNjEzQzIwLjU1NjQgMTkuMDEgMjAuMjg0OCAxOC4zMzczIDE5LjcwNjcgMTguMDU3MUwxNi42Mzc4IDE2LjU2OTlDMTYuMDcxOSAxNi4yOTU2IDE1LjM5MDQgMTYuNDg0NSAxNS4wNDYzIDE3LjAxMDlMOC43MjM0NSAyNi42ODUxSDEwLjUxNTRaIiBmaWxsPSIjMDAwMDAwIi8+Cjwvc3ZnPgo="

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS43NDIyIDE0LjQ3MTNMMjYuMzc5NiAxNS42MzAyTDIxLjAwMzIgMjUuNDA1NUw5LjI1OTggMjUuNDA1NUwzLjg4MzQgMTUuNjMwMkw5LjI1OTggNS44NTQ5OEwxMi42MTA5IDUuODU0OThDMTIuNzc2NyA1LjMzMDA0IDEyLjk5NDMgNC44MjgwNSAxMy4yNTc1IDQuMzU0OThIOS4xMTE5OEM4LjY1NjEyIDQuMzU0OTggOC4yMzY0IDQuNjAzMTUgOC4wMTY3MSA1LjAwMjU4TDIuNTAyODEgMTUuMDI3OEMyLjI5NjUxIDE1LjQwMyAyLjI5NjUxIDE1Ljg1NzUgMi41MDI4MSAxNi4yMzI2TDguMDE2NzEgMjYuMjU3OUM4LjIzNjQgMjYuNjU3MyA4LjY1NjExIDI2LjkwNTUgOS4xMTE5OCAyNi45MDU1TDIxLjE1MSAyNi45MDU1QzIxLjYwNjkgMjYuOTA1NSAyMi4wMjY2IDI2LjY1NzMgMjIuMjQ2MyAyNi4yNTc5TDI3Ljc2MDIgMTYuMjMyNkMyNy45NjY1IDE1Ljg1NzUgMjcuOTY2NSAxNS40MDMgMjcuNzYwMiAxNS4wMjc4TDI2LjgyNTUgMTMuMzI4NUMyNi41MDE4IDEzLjc0MzQgMjYuMTM4OSAxNC4xMjYyIDI1Ljc0MjIgMTQuNDcxM1oiIGZpbGw9IiMwMDAwMDAiLz4KPHBhdGggZD0iTTcuMzI2NiAxNi45NDExQzguMDc1OTkgMTYuNDQxNSA5LjU0OTggMTUuNjI5NiAxMC45NDg3IDE1LjYyOTZDMTQuODIwNSAxNS42Mjk2IDE1LjgxOTcgMTguODE0NiAxOS4xMjk1IDE4LjgxNDZDMjEuNTY1MSAxOC44MTQ2IDIyLjkzODkgMTcuMjUzMyAyMi45Mzg5IDE3LjI1MzMiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGNpcmNsZSBjeD0iMjAuMzkyNCIgY3k9IjguMjYyNjMiIHI9IjUuMjYyNjMiIHN0cm9rZT0iIzAwOTRmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS43NDIyIDE0LjQ3MTNMMjYuMzc5NiAxNS42MzAyTDIxLjAwMzIgMjUuNDA1NUw5LjI1OTggMjUuNDA1NUwzLjg4MzQgMTUuNjMwMkw5LjI1OTggNS44NTQ5OEwxMi42MTA5IDUuODU0OThDMTIuNzc2NyA1LjMzMDA0IDEyLjk5NDMgNC44MjgwNSAxMy4yNTc1IDQuMzU0OThIOS4xMTE5OEM4LjY1NjEyIDQuMzU0OTggOC4yMzY0IDQuNjAzMTUgOC4wMTY3MSA1LjAwMjU4TDIuNTAyODEgMTUuMDI3OEMyLjI5NjUxIDE1LjQwMyAyLjI5NjUxIDE1Ljg1NzUgMi41MDI4MSAxNi4yMzI2TDguMDE2NzEgMjYuMjU3OUM4LjIzNjQgMjYuNjU3MyA4LjY1NjExIDI2LjkwNTUgOS4xMTE5OCAyNi45MDU1TDIxLjE1MSAyNi45MDU1QzIxLjYwNjkgMjYuOTA1NSAyMi4wMjY2IDI2LjY1NzMgMjIuMjQ2MyAyNi4yNTc5TDI3Ljc2MDIgMTYuMjMyNkMyNy45NjY1IDE1Ljg1NzUgMjcuOTY2NSAxNS40MDMgMjcuNzYwMiAxNS4wMjc4TDI2LjgyNTUgMTMuMzI4NUMyNi41MDE4IDEzLjc0MzQgMjYuMTM4OSAxNC4xMjYyIDI1Ljc0MjIgMTQuNDcxM1oiIGZpbGw9IiNGMEYxRjQiLz4KPHBhdGggZD0iTTcuMzI2NiAxNi45NDExQzguMDc1OTkgMTYuNDQxNSA5LjU0OTggMTUuNjI5NiAxMC45NDg3IDE1LjYyOTZDMTQuODIwNSAxNS42Mjk2IDE1LjgxOTcgMTguODE0NiAxOS4xMjk1IDE4LjgxNDZDMjEuNTY1MSAxOC44MTQ2IDIyLjkzODkgMTcuMjUzMyAyMi45Mzg5IDE3LjI1MzMiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGNpcmNsZSBjeD0iMjAuMzkyNCIgY3k9IjguMjYyNjMiIHI9IjUuMjYyNjMiIHN0cm9rZT0iIzAwOTRmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMTE5ODcgMjcuMjQ5NUwyNC44ODI2IDI3LjI0OTUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjk0MjQ3IDE1Ljk2NzRMMS40MTEwNyAxNi40OTY2TDEuOTQyNDcgMTcuMDI1OUw5LjQ0Nzg2IDI0LjUwMTJIMTEuNTczNEwzLjUzNjY1IDE2LjQ5NjZMMTUgNS4wNzkyMUwyNi40NjM0IDE2LjQ5NjZMMTguNDI2NiAyNC41MDEySDIwLjU1MjJMMjguMDU3NiAxNy4wMjU5TDI4LjU4ODkgMTYuNDk2NkwyOC4wNTc2IDE1Ljk2NzRMMTUuNTMxNCAzLjQ5MTQyTDE1IDIuOTYyMTZMMTQuNDY4NiAzLjQ5MTQyTDEuOTQyNDcgMTUuOTY3NFoiIGZpbGw9IiMwMDAwMDAiLz4KPHBhdGggZD0iTTExLjA0NTIgMTYuMzg4MkwxMy44MjQyIDE5LjE1NjFMMTguOTE5MiAxNC4wODE2IiBzdHJva2U9IiMwMDk0ZmYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMTE5ODcgMjcuMjQ5NUwyNC44ODI2IDI3LjI0OTUiIHN0cm9rZT0iI0YwRjFGNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjk0MjQ3IDE1Ljk2NzRMMS40MTEwNyAxNi40OTY2TDEuOTQyNDcgMTcuMDI1OUw5LjQ0Nzg2IDI0LjUwMTJIMTEuNTczNEwzLjUzNjY1IDE2LjQ5NjZMMTUgNS4wNzkyMUwyNi40NjM0IDE2LjQ5NjZMMTguNDI2NiAyNC41MDEySDIwLjU1MjJMMjguMDU3NiAxNy4wMjU5TDI4LjU4ODkgMTYuNDk2NkwyOC4wNTc2IDE1Ljk2NzRMMTUuNTMxNCAzLjQ5MTQyTDE1IDIuOTYyMTZMMTQuNDY4NiAzLjQ5MTQyTDEuOTQyNDcgMTUuOTY3NFoiIGZpbGw9IiNGMEYxRjQiLz4KPHBhdGggZD0iTTExLjA0NTIgMTYuMzg4MkwxMy44MjQyIDE5LjE1NjFMMTguOTE5MiAxNC4wODE2IiBzdHJva2U9IiMwMDk0ZmYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjMxNTQgMTguMDI0OEMyNC41NTUgMjAuMDM5IDIzLjA4NTkgMjEuNjk4NyAyMS4yMTY5IDIyLjY5MTlDMjEuMjA0MyAyMi42OTg2IDIxLjIxNjkgMjUuMjU0NyAyMS4yMTY5IDI1LjI1NDdIMTYuNUwxNi40OTk5IDIzLjY5ODFIMTIuNUwxMi41MDAxIDI1LjI1NDdINy43MjY0TDcuNzI2MzQgMjIuNDgzNkM2LjUzMzMzIDIxLjc0MjQgNS40NzIwOCAyMC43MTQyIDQuNjYzOTYgMTkuNTQ3MUgxLjQ5OTk0VjEyLjI4M0gzLjQ3NjE1QzMuODQxNDYgMTEuMTY2MiA0LjQzMDQxIDEwLjEyNzcgNS4xODM2NSA5LjIzMTVMNi45OTk5MyA0LjVMMTEuNjY1MSA2LjA1NjZIMTcuMTcwMkMyMS44Njk2IDYuMDU2NiAyNS43MDA0IDkuODE5OTMgMjUuODgwMSAxNC41MzA5VjE0LjUzMDlDMjUuOTA5MyAxNS4yOTQ5IDI2LjUwNjUgMTUuOTE1MSAyNy4yNzEgMTUuOTE1MUgyNy40NDMzQzI4LjMwMyAxNS45MTUxIDI4Ljk5OTkgMTUuMjE4MiAyOC45OTk5IDE0LjM1ODVWMTMuMzIwNyIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTEuMjA0NyAxMi42ODk4TDYgMTQuNjY4OVYxNi4wOTAzTDExLjIwNDcgMTguMDY5NFYxNi43MDI3TDcuNTYzNTkgMTUuMzc5NkwxMS4yMDQ3IDE0LjA0NTZWMTIuNjg5OFoiIGZpbGw9IiMwMDk0ZmYiLz4KPHBhdGggZD0iTTExLjU2MTUgMjAuM0gxMy4wODEzTDE2LjY4OTYgMTBIMTUuMTY5OEwxMS41NjE1IDIwLjNaIiBmaWxsPSIjMDA5NGZmIi8+CjxwYXRoIGQ9Ik0xNi45MzY3IDEyLjY4OThWMTQuMDQ1NkwyMC41Nzc4IDE1LjM3OTZMMTYuOTM2NyAxNi43MDI3VjE4LjA2OTRMMjIuMTQxNCAxNi4wOTAzVjE0LjY2ODlMMTYuOTM2NyAxMi42ODk4WiIgZmlsbD0iIzAwOTRmZiIvPgo8L3N2Zz4K"

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjMxNTQgMTguMDI0OEMyNC41NTUgMjAuMDM5IDIzLjA4NTkgMjEuNjk4NyAyMS4yMTY5IDIyLjY5MTlDMjEuMjA0MyAyMi42OTg2IDIxLjIxNjkgMjUuMjU0NyAyMS4yMTY5IDI1LjI1NDdIMTYuNUwxNi40OTk5IDIzLjY5ODFIMTIuNDk5OUwxMi41IDI1LjI1NDdINy43MjY0TDcuNzI2MzQgMjIuNDgzNkM2LjUzMzMzIDIxLjc0MjQgNS40NzIwOCAyMC43MTQyIDQuNjYzOTYgMTkuNTQ3MUgxLjQ5OTk0VjEyLjI4M0gzLjQ3NjE1QzMuODQxNDYgMTEuMTY2MiA0LjQzMDQxIDEwLjEyNzcgNS4xODM2NSA5LjIzMTVMNi45OTk5MyA0LjVMMTEuNjY1MSA2LjA1NjZIMTcuMTcwMkMyMS44Njk2IDYuMDU2NiAyNS43MDA0IDkuODE5OTMgMjUuODgwMSAxNC41MzA5VjE0LjUzMDlDMjUuOTA5MyAxNS4yOTQ5IDI2LjUwNjUgMTUuOTE1MSAyNy4yNzEgMTUuOTE1MUgyNy40NDMzQzI4LjMwMyAxNS45MTUxIDI4Ljk5OTkgMTUuMjE4MiAyOC45OTk5IDE0LjM1ODVWMTMuMzIwNyIgc3Ryb2tlPSIjRjBGMUY0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTEuMjA0NyAxMi42ODk4TDYgMTQuNjY4OVYxNi4wOTAzTDExLjIwNDcgMTguMDY5NFYxNi43MDI3TDcuNTYzNTkgMTUuMzc5NkwxMS4yMDQ3IDE0LjA0NTZWMTIuNjg5OFoiIGZpbGw9IiMwMDk0ZmYiLz4KPHBhdGggZD0iTTExLjU2MTUgMjAuM0gxMy4wODEzTDE2LjY4OTYgMTBIMTUuMTY5OEwxMS41NjE1IDIwLjNaIiBmaWxsPSIjMDA5NGZmIi8+CjxwYXRoIGQ9Ik0xNi45MzY3IDEyLjY4OThWMTQuMDQ1NkwyMC41Nzc4IDE1LjM3OTZMMTYuOTM2NyAxNi43MDI3VjE4LjA2OTRMMjIuMTQxNCAxNi4wOTAzVjE0LjY2ODlMMTYuOTM2NyAxMi42ODk4WiIgZmlsbD0iIzAwOTRmZiIvPgo8L3N2Zz4K"

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4xNDY1IDguMDk3OTFMMTQuNTE2MSA4LjkxMzExTDEwLjMwNjkgNi41OTgwMkwxMS4wMjk4IDUuMjgzNjlMMTYuMTQ2NSA4LjA5NzkxWk0xNC4zNzY3IDEzLjgwODZWMjUuODcyNUgxNS44NzY3VjEzLjgwODZIMTQuMzc2N1oiIGZpbGw9IiMwMDk0ZmYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41ODQgMy4yNzgyQzE1LjIzNjIgMy4xMDcxMyAxNC44Mjg2IDMuMTA3MTQgMTQuNDgwOCAzLjI3ODJMNC44NDgwMyA4LjAxNTM3QzQuNDIwNSA4LjIyNTYyIDQuMTQ5NjYgOC42NjA2MyA0LjE0OTY2IDkuMTM3MDdWMjAuODQwNkM0LjE0OTY2IDIxLjMxNzEgNC40MjA1MSAyMS43NTIxIDQuODQ4MDYgMjEuOTYyM0wxNC40ODA4IDI2LjY5OTJDMTQuODI4NiAyNi44NzAzIDE1LjIzNjEgMjYuODcwMyAxNS41ODQgMjYuNjk5MkwyNS4yMTY3IDIxLjk2MjNDMjUuNjQ0MyAyMS43NTIxIDI1LjkxNTEgMjEuMzE3MSAyNS45MTUxIDIwLjg0MDZWMTMuODA4N0gyNC40MTUxVjIwLjY4NUwxNS4wMzI0IDI1LjI5ODlMNS42NDk2NiAyMC42ODVWOS4yOTI3MkwxNS4wMzI0IDQuNjc4NUwyMy40NjU2IDguODI1NzVMMTUuMDQyMiAxMi45Njc5TDEwLjIzMDcgMTAuNDYwM0w4LjQ0OTc1IDExLjIyMzZMMTQuNDYxMiAxNC4zNTY2QzE0LjgxNDEgMTQuNTQwNSAxNS4yMzM1IDE0LjU0NTQgMTUuNTkwNiAxNC4zNjk4TDI0LjU4MzcgOS45NDc0N0MyNS41MTQ5IDkuNDg5NTYgMjUuNTE0OSA4LjE2MTk5IDI0LjU4MzcgNy43MDQwNkwxNS41ODQgMy4yNzgyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg=="

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4xNDY1IDguMDk3OTFMMTQuNTE2MSA4LjkxMzExTDEwLjMwNjkgNi41OTgwMkwxMS4wMjk3IDUuMjgzNjlMMTYuMTQ2NSA4LjA5NzkxWk0xNC4zNzY3IDEzLjgwODZWMjUuODcyNUgxNS44NzY3VjEzLjgwODZIMTQuMzc2N1oiIGZpbGw9IiMwMDk0ZmYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41ODQgMy4yNzgyQzE1LjIzNjEgMy4xMDcxMyAxNC44Mjg2IDMuMTA3MTQgMTQuNDgwNyAzLjI3ODJMNC44NDgwMiA4LjAxNTM3QzQuNDIwNDggOC4yMjU2MiA0LjE0OTY0IDguNjYwNjMgNC4xNDk2NCA5LjEzNzA3VjIwLjg0MDZDNC4xNDk2NCAyMS4zMTcxIDQuNDIwNDkgMjEuNzUyMSA0Ljg0ODA0IDIxLjk2MjNMMTQuNDgwOCAyNi42OTkyQzE0LjgyODYgMjYuODcwMyAxNS4yMzYxIDI2Ljg3MDMgMTUuNTg0IDI2LjY5OTJMMjUuMjE2NyAyMS45NjIzQzI1LjY0NDMgMjEuNzUyMSAyNS45MTUxIDIxLjMxNzEgMjUuOTE1MSAyMC44NDA2VjEzLjgwODdIMjQuNDE1MVYyMC42ODVMMTUuMDMyNCAyNS4yOTg5TDUuNjQ5NjQgMjAuNjg1VjkuMjkyNzJMMTUuMDMyNCA0LjY3ODVMMjMuNDY1NSA4LjgyNTc1TDE1LjA0MjIgMTIuOTY3OUwxMC4yMzA3IDEwLjQ2MDNMOC40NDk3MyAxMS4yMjM2TDE0LjQ2MTIgMTQuMzU2NkMxNC44MTQxIDE0LjU0MDUgMTUuMjMzNCAxNC41NDU0IDE1LjU5MDUgMTQuMzY5OEwyNC41ODM3IDkuOTQ3NDdDMjUuNTE0OCA5LjQ4OTU2IDI1LjUxNDkgOC4xNjE5OSAyNC41ODM3IDcuNzA0MDZMMTUuNTg0IDMuMjc4MloiIGZpbGw9IiNGMEYxRjQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjgxMjUgMTBWNy41QzIyLjgxMjUgNi4xMTkyOSAyMS42OTMyIDUgMjAuMzEyNSA1SDE0LjA2MjVNMjIuODEyNSAyMFYyMi41QzIyLjgxMjUgMjMuODgwNyAyMS42OTMyIDI1IDIwLjMxMjUgMjVINy44MTI1QzYuNDMxNzkgMjUgNS4zMTI1IDIzLjg4MDcgNS4zMTI1IDIyLjVWMTYuMjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik01LjMxMjUgMTVWMTBDNS4zMTI1IDcuMjM4NTggNy41NTEwOCA1IDEwLjMxMjUgNUgxNC4wNjI1IiBzdHJva2U9IiMwMTczRTUiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xNC41NTQ0IDE4LjI1SDEzLjMyMDNWMTYuMTA0SDExLjM0NjRWMTguMjVIMTAuMTA1VjEyLjkxOEgxMS4zNDY0VjE1LjE1MTlIMTMuMzIwM1YxMi45MThIMTQuNTU0NFYxOC4yNVpNMTkuMzc4OSAxMy44NzAxSDE3Ljk3MjdWMTguMjVIMTYuNzMxMlYxMy44NzAxSDE1LjMzNTlWMTIuOTE4SDE5LjM3ODlWMTMuODcwMVpNMjIuMjE0OCAxNC43MTYxTDIzLjA5MzggMTIuOTE4SDI0LjUyMkwyMi45OTQ5IDE1LjU2MkwyNC42MzkyIDE4LjI1SDIzLjEzNzdMMjIuMjI5NSAxNi40MTUzTDIxLjMyMTMgMTguMjVIMTkuODkzMUwyMS40NjA0IDE1LjU2MkwxOS45MzMzIDEyLjkxOEgyMS4zNTA2TDIyLjIxNDggMTQuNzE2MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo="

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjgxMjUgMTBWNy41QzIyLjgxMjUgNi4xMTkyOSAyMS42OTMyIDUgMjAuMzEyNSA1SDE0LjA2MjVNMjIuODEyNSAyMFYyMi41QzIyLjgxMjUgMjMuODgwNyAyMS42OTMyIDI1IDIwLjMxMjUgMjVINy44MTI1QzYuNDMxNzkgMjUgNS4zMTI1IDIzLjg4MDcgNS4zMTI1IDIyLjVWMTYuMjUiIHN0cm9rZT0iI0U2RTZFNiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTUuMzEyNSAxNVYxMEM1LjMxMjUgNy4yMzg1OCA3LjU1MTA4IDUgMTAuMzEyNSA1SDE0LjA2MjUiIHN0cm9rZT0iIzAxNzNFNSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTE0LjU1NDQgMTguMjVIMTMuMzIwM1YxNi4xMDRIMTEuMzQ2NFYxOC4yNUgxMC4xMDVWMTIuOTE4SDExLjM0NjRWMTUuMTUxOUgxMy4zMjAzVjEyLjkxOEgxNC41NTQ0VjE4LjI1Wk0xOS4zNzg5IDEzLjg3MDFIMTcuOTcyN1YxOC4yNUgxNi43MzEyVjEzLjg3MDFIMTUuMzM1OVYxMi45MThIMTkuMzc4OVYxMy44NzAxWk0yMi4yMTQ4IDE0LjcxNjFMMjMuMDkzOCAxMi45MThIMjQuNTIyTDIyLjk5NDkgMTUuNTYyTDI0LjYzOTIgMTguMjVIMjMuMTM3N0wyMi4yMjk1IDE2LjQxNTNMMjEuMzIxMyAxOC4yNUgxOS44OTMxTDIxLjQ2MDQgMTUuNTYyTDE5LjkzMzMgMTIuOTE4SDIxLjM1MDZMMjIuMjE0OCAxNC43MTYxWiIgZmlsbD0iI0U2RTZFNiIvPgo8L3N2Zz4K"

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
function makeKey(key) {
    return `header: ${key}`
}

// 字符串转换
function get(key) {
    const pKey = makeKey(key)
    let data = localStorage.getItem(pKey);
    if (data) {
        try {
            data = JSON.parse(data)
        } catch(e) {
            return null
        }
        // 未过期
        if (data.expires > Date.now()) {
            return data.value
        } else {
            // 已过期
            localStorage.removeItem(pKey);
        }
    }
    return null
}

// 存字符串
/**
 * 数据存储
 * @param {String} key 
 * @param {*} value 
 * @param {Number} expires 
 */
function set(key, value, expires = 5*60*1000) {
    const data = {
        value,
        expires: Date.now() + expires
    }
    localStorage.setItem(makeKey(key), JSON.stringify(data))
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultRate", function() { return getDefaultRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRateFromArr", function() { return getRateFromArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLocalRate", function() { return setLocalRate; });
/**
 * 从localStorage里获取rate
 */
function getDefaultRate () {
    return localStorage.getItem('exchangeRate') && localStorage.getItem('exchangeRate').split("/")[0]
}

/**
 * 从数组里获取和语言匹配的rate
 * @param {*} arr 
 */
function getRateFromArr (arr, lang) {
    if (!arr || arr.length === 0) {
        return ''
    }
    let obj = arr.find(item => {
        if (item.deviceLanguage) {
            return item.deviceLanguage.toLowerCase().split(',').includes(lang)
        } else if (item.lang) {
            return item.lang.includes(lang)
        }
    })
    if (obj) {
        return obj.abbr.toLowerCase()
    } else {
        obj = arr.find(item => {
            return item.defaultCurrency === 1
        })
        if(obj){
            return obj.abbr.toLowerCase()
        }else {
        return arr[0].abbr.toLowerCase()
        }
    }
}

/**
 * 写入localStorage
 * @param {*} rate 
 * @param {*} fromRemote 
 */
function setLocalRate(abbr, fromRemote) {
    localStorage.setItem('exchangeRate', `${abbr.toLowerCase()}/${fromRemote? '2': '0'}`);
}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * @Author       : shuaifeng.li
 * @Date         : 2022-08-01 18:50:50
 * @LastEditTime : 2022-08-08 19:55:03
 * @LastEditors  : shuaifeng.li
 * @Description  : 通用
 * @FilePath     : /fed-responsive-header/react/src/dropdown/common-dropdown.tsx
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var base_dropdown_1 = __importDefault(__webpack_require__(96));
var CommonDropdown = function (_a) {
    var _b = _a.handleClick, handleClick = _b === void 0 ? function () { } : _b, _c = _a.handleMouseEnter, handleMouseEnter = _c === void 0 ? function () { } : _c, title = _a.title, className = _a.className, children = _a.children, placement = _a.placement, isShowFlag = _a.isShowFlag, offset = _a.offset, withBottomMargin = _a.withBottomMargin;
    var renderTitle = function (_a) {
        var setReferenceElement = _a.setReferenceElement, handleClick = _a.handleClick, handleMouseEnter = _a.handleMouseEnter;
        return (react_1.default.createElement("div", { className: "hb-dropdown__trigger", "data-ani": "linkage", onMouseEnter: handleMouseEnter, onClick: handleClick, ref: setReferenceElement }, title));
    };
    return (react_1.default.createElement(base_dropdown_1.default, { title: renderTitle, showExpand: false, handleClick: handleClick, handleMouseEnter: handleMouseEnter, className: "header__menu__item hb-menu-dropdown ".concat(className), placement: placement, isShowFlag: isShowFlag, offset: offset, withBottomMargin: withBottomMargin },
        react_1.default.createElement("div", { className: "hb-menu-dropdown__body hb-menu-dropdown__body--default" }, children)));
};
exports.default = CommonDropdown;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var sensors_1 = __webpack_require__(27);
// import AnimationNav from 'root/utils/animationNav';
var menu_dropdown_v2_1 = __importDefault(__webpack_require__(341));
var classnames_1 = __importDefault(__webpack_require__(31));
var animationNav_1 = __webpack_require__(237);
var NavBar = function (_a) {
    var active = _a.active, menus = _a.menus, theme = _a.theme, _b = _a.onDomChange, onDomChange = _b === void 0 ? function () { } : _b;
    // 点击选中
    var onSelect = function (event, val) {
        if (val.track) {
            (0, sensors_1.trackHeader)({
                button_name: val.track,
                type: 'click',
            });
        }
        // this.$emit('select', val)
        // 如果有跳转链接
        if (val === null || val === void 0 ? void 0 : val.jumpUrl) {
            if (val.jumpType === 2) {
                window.open(val.jumpUrl);
            }
            else {
                location.href = val.jumpUrl;
            }
        }
        else if (val.children && val.children[0]) {
            onSelect(null, val.children[0]);
        }
    };
    var _c = (0, react_1.useState)(null), mainEl = _c[0], setEl = _c[1];
    // trigger鼠标滑过
    var onMouseenter = function (event, val) {
        if (val.track) {
            // console.log('track hover', val.track)
            (0, sensors_1.trackHeader)({
                button_name: val.track,
                type: 'hover',
            });
        }
    };
    var _d = (0, animationNav_1.useAniNav)(), isHover = _d.isHover, isAni = _d.isAni, barLeft = _d.barLeft, barWidth = _d.barWidth, disableContentInAni = _d.disableContentInAni, setEl2 = _d.setEl, setBar = _d.setBar;
    (0, react_1.useEffect)(function () {
        if (mainEl) {
            setEl2(mainEl);
        }
    }, [mainEl]);
    return (react_1.default.createElement("div", { className: "hbg-nav-menu-v2 ".concat((0, classnames_1.default)({
            'hbg-nav-menu-v2__hover': isHover,
            'hbg-nav-menu-v2__disable-ani': disableContentInAni,
        })), ref: setEl },
        react_1.default.createElement("i", { className: "hbg-nav-menu-v2__activebar ".concat((0, classnames_1.default)({
                'hbg-nav-menu-v2__activebar--ani': isAni,
            })), style: { width: "".concat(barWidth, "px"), left: "".concat(barLeft, "px") }, ref: setBar }),
        menus.map(function (obj, index) { return (react_1.default.createElement(menu_dropdown_v2_1.default, { className: "hbg-nav-menu-v2__item", key: index, data: obj, active: active, theme: theme, onSelect: onSelect, onMouseenter: onMouseenter, onDomChange: onDomChange, placement: "bottom-start" })); })));
};
exports.default = (0, react_1.memo)(NavBar);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(31));
var core_1 = __webpack_require__(103);
var react_dom_1 = __webpack_require__(60);
var hbsDropdown_1 = __importDefault(__webpack_require__(97));
var icon_arrow_right__dark_svg_1 = __importDefault(__webpack_require__(342));
var Dropdown = function (_a) {
    var data = _a.data, trigger = _a.trigger, children = _a.children, _b = _a.onSelect, onSelect = _b === void 0 ? function () { } : _b, _c = _a.onMouseenter, onMouseenter = _c === void 0 ? function () { } : _c, _d = _a.onDomChange, onDomChange = _d === void 0 ? function () { } : _d, theme = _a.theme, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.style, style = _f === void 0 ? {} : _f, active = _a.active, _g = _a.placement, placement = _g === void 0 ? 'bottom-end' : _g, isShowFlag = _a.isShowFlag;
    var _h = (0, react_1.useState)(false), isShow = _h[0], setIsShow = _h[1];
    var _j = (0, react_1.useState)(false), isHide = _j[0], setIsHide = _j[1];
    var _k = (0, react_1.useState)(isShowFlag), isShowFlagPrev = _k[0], setShowFlagPrev = _k[1];
    (0, react_1.useEffect)(function () {
        setShowFlagPrev(isShowFlag);
        // 当前值有变化
        if (isShowFlag !== isShowFlagPrev && isShow) {
            hide();
        }
    }, [isShowFlag]);
    var onMouseEnter = function () {
        show();
    };
    var onMouseLeave = function () {
        hide();
    };
    var show = function () {
        unbindAni();
        setIsHide(false);
        setIsShow(true);
    };
    var hide = function () {
        unbindAni();
        bindAni();
        // 动画启动
        setIsHide(true);
    };
    // 移除动画绑定
    var unbindAni = function () {
        if (popperElement) {
            var content = popperElement.querySelector('.hbg-dropdown-v2__body');
            if (content && content.$ffFun) {
                content.$ffFun();
            }
        }
    };
    var bindAni = function () {
        if (popperElement) {
            var content = popperElement.querySelector('.hbg-dropdown-v2__body');
            // 绑定动画事件
            var off = (0, react_dom_1.once)(content, 'animationend', function () {
                setIsHide(false);
                setIsShow(false);
            });
            if (content) {
                content.$ffFun = off;
            }
        }
    };
    var onTriggerMouseEnter = function () { };
    var _l = (0, react_1.useState)(null), popperIns = _l[0], setPopperIns = _l[1];
    var _m = (0, react_1.useState)(null), referenceElement = _m[0], setReferenceElement = _m[1];
    var _o = (0, react_1.useState)(null), popperElement = _o[0], setPopperElement = _o[1];
    var _p = (0, react_1.useState)(null), mainEl = _p[0], setEl = _p[1];
    var _q = (0, react_1.useState)([]), list = _q[0], setList = _q[1];
    var _r = (0, react_1.useState)(false), hasContent = _r[0], setHasContent = _r[1];
    (0, react_1.useEffect)(function () {
        var _a = data.children, children = _a === void 0 ? [] : _a;
        setList(children.filter(function (item) { return item === null || item === void 0 ? void 0 : item.jumpUrl; }));
    }, [data]);
    (0, react_1.useEffect)(function () {
        var a = children || list.length > 0;
        setHasContent(!!a);
    }, [list, children]);
    (0, react_1.useEffect)(function () {
        if (mainEl && popperElement) {
            new hbsDropdown_1.default(mainEl);
        }
    }, [mainEl, popperElement]);
    // 监听两个对象初始化
    (0, react_1.useEffect)(function () {
        if (referenceElement && popperElement) {
            var popperInstance = (0, core_1.createPopper)(referenceElement, popperElement, {
                placement: placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            // offset: [-20, 0],
                            offset: function (_a) {
                                var placement = _a.placement, reference = _a.reference, popper = _a.popper;
                                // if (placement === 'bottom-start') {
                                //     return [-20, 0];
                                // } else if (placement === 'bottom-end') {
                                //     return [20, 0];
                                // }
                                return [];
                            },
                        },
                    },
                    {
                        name: 'flip',
                        enabled: false,
                    },
                ],
            });
            setPopperIns(popperInstance);
        }
    }, [referenceElement, popperElement]);
    // 监听显示和poper 实例
    (0, react_1.useEffect)(function () {
        if (isShow && popperIns) {
            popperIns.update();
        }
    }, [isShow, popperIns]);
    var onHandleClickTrigger = function (event) {
        // console.log(data, 'onClickTrigger')
        var jumpUrl = data.jumpUrl, _a = data.children, children = _a === void 0 ? [] : _a;
        // 标题有数据，触发
        if (jumpUrl) {
            selectItem(event, data);
        }
        else if (children[0]) {
            // 标题没有数据，使用子数据第一条
            selectItem(event, children[0]);
        }
        else {
            // 都没有，关闭
            setIsShow(false);
        }
    };
    var onHandleMouseEnterTrigger = function (event) {
        onMouseenter(event, data);
    };
    var onTriggerImgLoad = function () {
        onDomChange();
    };
    var selectItem = function (event, item) {
        // @ts-ignore
        onSelect(null, item);
    };
    var onItemImgLoad = function () {
        onDomChange();
    };
    var renderTrigger = function () {
        var _a = data || {}, title = _a.title, floatImg = _a.floatImg, nightFloatImg = _a.nightFloatImg;
        var isActive = list.some(function (item) {
            if (item.children) {
                return item.children.some(function (c) { return c.activeId === active; });
            }
            return item.activeId === active;
        });
        var fImg = theme === 'dark' ? nightFloatImg : floatImg;
        return trigger ? (trigger) : (react_1.default.createElement("div", { className: "hbg-dropdown-v2__trigger ".concat((0, classnames_1.default)({
                active: isActive,
            })), "data-ani": "linkage", onMouseEnter: onHandleMouseEnterTrigger, onClick: onHandleClickTrigger, ref: setReferenceElement },
            react_1.default.createElement("div", { className: "hbg-dropdown-v2__trigger-title" },
                react_1.default.createElement("em", { className: "hbg-dropdown-v2__trigger-title" }, title),
                fImg ? (react_1.default.createElement("div", { className: "hbg-dropdown-v2__trigger-float" },
                    react_1.default.createElement("img", { src: fImg, onLoad: onTriggerImgLoad, className: "hbg-dropdown-v2__trigger-float-img", alt: "" }))) : ('')),
            hasContent ? react_1.default.createElement("i", { className: "hbg-dropdown-v2__trigger-triangle" }) : ''));
    };
    var navEnterHandler = function (ev, nav) {
        if (nav.children && nav.children.length !== 0) {
            var threeWrapEl = ev.target.querySelector('.hbg-dropdown-v2__body-item-three-nav-wrap');
            if (popperElement && threeWrapEl) {
                // popper宽度
                var popperWidth = popperElement.offsetWidth;
                var bodyWidth = document.body.offsetWidth;
                // 父级菜单位置和宽度
                var _a = popperElement.parentNode, pLeft = _a.offsetLeft, pWidth = _a.offsetWidth;
                // 所有菜单展开宽度，344 为单个菜单默认宽度
                var menuWidth = popperWidth + pLeft + pWidth + 344;
                // 超过2层菜单
                if (ev.target.parentNode.id) {
                    if (bodyWidth > menuWidth) {
                        threeWrapEl.style.right = '-340px';
                        threeWrapEl.style.left = 'unset';
                        var bodyDom = popperElement.querySelector('.hbg-dropdown-v2__body');
                        if (bodyDom) {
                            bodyDom.style.borderRadius = '0 0 0 8px';
                        }
                        var threeDom = ev.target.querySelector('.hbg-dropdown-v2__body-item-three-nav-wrap > div');
                        if (threeDom) {
                            threeDom.style.borderRadius = '0 0 8px 0';
                        }
                    }
                    else {
                        threeWrapEl.style.right = 'unset';
                        threeWrapEl.style.left = '0px';
                        var bodyDom = popperElement.querySelector('.hbg-dropdown-v2__body');
                        if (bodyDom) {
                            bodyDom.style.borderRadius = '0 0 8px 8px';
                        }
                        var threeDom = ev.target.querySelector('.hbg-dropdown-v2__body-item-three-nav-wrap > div');
                        if (threeDom) {
                            threeDom.style.borderRadius = '0 0 8px 8px';
                        }
                    }
                }
                var subHeight = popperElement.offsetHeight;
                var threeHeight = threeWrapEl.offsetHeight;
                if (subHeight > threeHeight) {
                    threeWrapEl.style.height = subHeight + 'px';
                }
                else if (subHeight < threeHeight) {
                    popperElement.querySelector('.hbg-dropdown-v2__body').style.height = threeHeight + 'px';
                }
            }
        }
    };
    var navOutHandler = function () {
        popperElement.querySelector('.hbg-dropdown-v2__body').style.height = 'auto';
    };
    var renderItem = function (item) {
        var title = item.title, icon = item.icon, nightIcon = item.nightIcon, activeId = item.activeId, subtitle = item.subtitle, nightFloatImg = item.nightFloatImg, floatImg = item.floatImg, children = item.children;
        var iconImg = theme === 'dark' ? nightIcon : icon;
        var fImg = theme === 'dark' ? nightFloatImg : floatImg;
        return (react_1.default.createElement("div", { key: item.title + Math.random(), onClick: function (event) {
                selectItem(event, item);
            }, onMouseEnter: function (event) { return navEnterHandler(event, item); }, onMouseMove: function (event) { return navEnterHandler(event, item); }, onMouseLeave: function () { return navOutHandler(); }, className: "hbg-dropdown-v2__body-item ".concat((0, classnames_1.default)({
                active: active === activeId,
            })) },
            react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-item-icon" }, iconImg ? (react_1.default.createElement("img", { className: "hbg-dropdown-v2__body-item-icon-img", onLoad: onItemImgLoad, src: iconImg, alt: "" })) : (react_1.default.createElement("i", { className: "hbg-dropdown-v2__body-item-icon-placeholder" }))),
            react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-item-content" },
                react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-item-title" },
                    title,
                    fImg ? (react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-item-title-sub-float" },
                        react_1.default.createElement("img", { src: fImg, onLoad: onTriggerImgLoad, className: "hbg-dropdown-v2__body-item-title-sub-float-img", alt: "" }))) : ('')),
                subtitle ? react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-item-subtitle" }, subtitle) : ''),
            children && children.length !== 0 && (react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-item-three-right-icon" },
                react_1.default.createElement("img", { src: icon_arrow_right__dark_svg_1.default }))),
            children && children.length !== 0 && (react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-item-three-nav-wrap", onClick: function (event) {
                    event.stopPropagation();
                } },
                react_1.default.createElement("div", null, children.map(function (threeItem) {
                    return (react_1.default.createElement("div", { key: threeItem.title + Math.random(), onClick: function (event) {
                            selectItem(event, threeItem);
                        }, className: "hbg-dropdown-v2__body-item-three-nav-wrap-item" },
                        react_1.default.createElement("span", null, threeItem.title)));
                }))))));
    };
    var renderItems = function () {
        var _threeNavFlag = '';
        if (popperElement) {
            var positionInfo = popperElement.getBoundingClientRect();
            if (document.querySelector('body').offsetWidth - positionInfo.right < 250) {
                _threeNavFlag = 'three-nav-left';
            }
        }
        if (list.length < 9) {
            return (react_1.default.createElement("div", { className: "hbg-dropdown-v2__body ".concat(_threeNavFlag) }, list.map(function (item) {
                return renderItem(item);
            })));
        }
        else {
            var len = Math.ceil(list.length / 2);
            var a = list.slice(0, len);
            var b = list.slice(len);
            return (react_1.default.createElement("div", { className: "hbg-dropdown-v2__body hbg-dropdown-v2__body-muti ".concat(_threeNavFlag) },
                react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-group" }, a.map(function (item) {
                    return renderItem(item);
                })),
                react_1.default.createElement("div", { className: "hbg-dropdown-v2__body-group", id: "group-last" }, b.map(function (item) {
                    return renderItem(item);
                }))));
        }
    };
    return (react_1.default.createElement("div", { className: "".concat(className, " hbg-dropdown-v2 ").concat((0, classnames_1.default)({
            'hbg-dropdown-v2--open': isShow,
            'hbg-dropdown-v2--hide': isHide,
        })), style: style, ref: setEl, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        renderTrigger(),
        hasContent ? (react_1.default.createElement("div", { className: "hbg-dropdown-v2__content js-hbs-dropdowns ".concat((0, classnames_1.default)({
                'hbg-dropdown-v2__content-muti': list.length > 8,
            })), ref: setPopperElement }, children ? children : renderItems())) : ('')));
};
exports.default = Dropdown;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjM0XzYyNjM1KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC45NTk3OTggNC4xMDI3N2UtMDVMNC45MTk2IDMuOTU5ODRMMC45NTk3OTggNy45MTk2NEwwLjExMTI3IDcuMDcxMTFMMy4yMjI1NCAzLjk1OTg0TDAuMTExMjcgMC44NDg1NjlMMC45NTk3OTggNC4xMDI3N2UtMDVaIiBmaWxsPSIjQjJCOEM3Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjM0XzYyNjM1Ij4KPHJlY3Qgd2lkdGg9IjUiIGhlaWdodD0iOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var qr_image_1 = __importDefault(__webpack_require__(344));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var url_1 = __webpack_require__(18);
var sensors_1 = __webpack_require__(27);
exports.default = (function (_a) {
    var style = _a.style;
    var _b = (0, react_1.useContext)(context_1.HeaderContext), globalState = _b.globalState, dispatch = _b.dispatch;
    var hostname = globalState.hostname, locale = globalState.locale;
    var t = (0, i18n_1.useTranslation)().t;
    var _c = (0, react_1.useState)(''), svghtml = _c[0], setSVG = _c[1];
    (0, react_1.useEffect)(function () {
        var downloadUrl = "".concat(location.protocol).concat((0, url_1.getUrl)({
            platform: 'm',
            path: '/download/',
            locale: locale,
            hostname: hostname,
        }));
        var svg = qr_image_1.default.imageSync(downloadUrl, { type: 'svg', margin: 0 });
        setSVG(svg);
    }, []);
    // 点击下载按钮
    var onClickDownload = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'download',
            type: 'click',
        });
        location.href = dHref;
    };
    var dHref = (0, react_1.useMemo)(function () {
        return (0, url_1.getUrl)({
            platform: 'global',
            path: '/download/#exchange',
            locale: locale,
            hostname: hostname,
        });
    }, [locale, hostname]);
    return (react_1.default.createElement("div", { className: "hbg-download", style: style },
        react_1.default.createElement("div", { className: "hbg-download__img", dangerouslySetInnerHTML: { __html: svghtml } }),
        react_1.default.createElement("div", { className: "hbg-download__content" },
            react_1.default.createElement("div", { className: "hbg-download__title", dangerouslySetInnerHTML: { __html: t('相机扫码下载<p>火币App</p>') } }),
            react_1.default.createElement("a", { className: "fed-btn", 
                // href={dHref}
                onClick: onClickDownload }, t('更多客户端')))));
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, Buffer) {

var Readable = __webpack_require__(239).Readable;

var QR = __webpack_require__(356).QR;
var png = __webpack_require__(360);
var vector = __webpack_require__(376);

var fn_noop = function() {};

var BITMAP_OPTIONS = {
    parse_url: false,
    ec_level: 'M',
    size: 5,
    margin: 4,
    customize: null
};

var VECTOR_OPTIONS = {
    parse_url: false,
    ec_level: 'M',
    margin: 1,
    size: 0
};

function get_options(options, force_type) {
    if (typeof options === 'string') {
        options = { 'ec_level': options }
    } else {
        options = options || {};
    }
    var _options = {
        type: String(force_type || options.type || 'png').toLowerCase()
    };

    var defaults = _options.type == 'png' ? BITMAP_OPTIONS : VECTOR_OPTIONS;

    for (var k in defaults) {
        _options[k] = k in options ? options[k] : defaults[k];
    }

    return _options;
}

function qr_image(text, options) {
    options = get_options(options);

    var matrix = QR(text, options.ec_level, options.parse_url);
    var stream = new Readable();
    stream._read = fn_noop;

    switch (options.type) {
    case 'svg':
    case 'pdf':
    case 'eps':
        process.nextTick(function() {
            vector[options.type](matrix, stream, options.margin, options.size);
        });
        break;
    case 'svgpath':
        // deprecated, use svg_object method
        process.nextTick(function() {
            var obj = vector.svg_object(matrix, options.margin, options.size);
            stream.push(obj.path);
            stream.push(null);
        });
        break;
    case 'png':
    default:
        process.nextTick(function() {
            var bitmap = png.bitmap(matrix, options.size, options.margin);
            if (options.customize) {
                options.customize(bitmap);
            }
            png.png(bitmap, stream);
        });
    }

    return stream;
}

function qr_image_sync(text, options) {
    options = get_options(options);

    var matrix = QR(text, options.ec_level, options.parse_url);
    var stream = [];
    var result;

    switch (options.type) {
    case 'svg':
    case 'pdf':
    case 'eps':
        vector[options.type](matrix, stream, options.margin, options.size);
        result = stream.filter(Boolean).join('');
        break;
    case 'png':
    default:
        var bitmap = png.bitmap(matrix, options.size, options.margin);
        if (options.customize) {
            options.customize(bitmap);
        }
        png.png(bitmap, stream);
        result = Buffer.concat(stream.filter(Boolean));
    }

    return result;
}

function svg_object(text, options) {
    options = get_options(options, 'svg');

    var matrix = QR(text, options.ec_level);
    return vector.svg_object(matrix, options.margin);
}

module.exports = {
    matrix: QR,
    image: qr_image,
    imageSync: qr_image_sync,
    svgObject: svg_object
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25), __webpack_require__(19).Buffer))

/***/ }),
/* 345 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(147).Buffer;
var util = __webpack_require__(347);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16), __webpack_require__(25)))

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(19)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(245);

/*<replacement>*/
var util = Object.create(__webpack_require__(78));
util.inherits = __webpack_require__(61);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(148);


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(146).Transform


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(146).PassThrough


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var encode = __webpack_require__(357);
var calculateEC = __webpack_require__(358);
var matrix = __webpack_require__(359);

function _deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}

var EC_LEVELS = ['L', 'M', 'Q', 'H'];

// {{{1 Versions
var versions = [
    [], // there is no version 0
    // total number of codewords, (number of ec codewords, number of blocks) * ( L, M, Q, H )
    [26, 7, 1, 10, 1, 13, 1, 17, 1],
    [44, 10, 1, 16, 1, 22, 1, 28, 1],
    [70, 15, 1, 26, 1, 36, 2, 44, 2],
    [100, 20, 1, 36, 2, 52, 2, 64, 4],
    [134, 26, 1, 48, 2, 72, 4, 88, 4], // 5
    [172, 36, 2, 64, 4, 96, 4, 112, 4],
    [196, 40, 2, 72, 4, 108, 6, 130, 5],
    [242, 48, 2, 88, 4, 132, 6, 156, 6],
    [292, 60, 2, 110, 5, 160, 8, 192, 8],
    [346, 72, 4, 130, 5, 192, 8, 224, 8], // 10
    [404, 80, 4, 150, 5, 224, 8, 264, 11],
    [466, 96, 4, 176, 8, 260, 10, 308, 11],
    [532, 104, 4, 198, 9, 288, 12, 352, 16],
    [581, 120, 4, 216, 9, 320, 16, 384, 16],
    [655, 132, 6, 240, 10, 360, 12, 432, 18], // 15
    [733, 144, 6, 280, 10, 408, 17, 480, 16],
    [815, 168, 6, 308, 11, 448, 16, 532, 19],
    [901, 180, 6, 338, 13, 504, 18, 588, 21],
    [991, 196, 7, 364, 14, 546, 21, 650, 25],
    [1085, 224, 8, 416, 16, 600, 20, 700, 25], // 20
    [1156, 224, 8, 442, 17, 644, 23, 750, 25],
    [1258, 252, 9, 476, 17, 690, 23, 816, 34],
    [1364, 270, 9, 504, 18, 750, 25, 900, 30],
    [1474, 300, 10, 560, 20, 810, 27, 960, 32],
    [1588, 312, 12, 588, 21, 870, 29, 1050, 35], // 25
    [1706, 336, 12, 644, 23, 952, 34, 1110, 37],
    [1828, 360, 12, 700, 25, 1020, 34, 1200, 40],
    [1921, 390, 13, 728, 26, 1050, 35, 1260, 42],
    [2051, 420, 14, 784, 28, 1140, 38, 1350, 45],
    [2185, 450, 15, 812, 29, 1200, 40, 1440, 48], // 30
    [2323, 480, 16, 868, 31, 1290, 43, 1530, 51],
    [2465, 510, 17, 924, 33, 1350, 45, 1620, 54],
    [2611, 540, 18, 980, 35, 1440, 48, 1710, 57],
    [2761, 570, 19, 1036, 37, 1530, 51, 1800, 60],
    [2876, 570, 19, 1064, 38, 1590, 53, 1890, 63], // 35
    [3034, 600, 20, 1120, 40, 1680, 56, 1980, 66],
    [3196, 630, 21, 1204, 43, 1770, 59, 2100, 70],
    [3362, 660, 22, 1260, 45, 1860, 62, 2220, 74],
    [3532, 720, 24, 1316, 47, 1950, 65, 2310, 77],
    [3706, 750, 25, 1372, 49, 2040, 68, 2430, 81] // 40
];

versions = versions.map(function(v, index) {
    if (!index) return {};

    var res = {
    }
    for (var i = 1; i < 8; i += 2) {
        var length = v[0] - v[i];
        var num_template = v[i+1];
        var ec_level = EC_LEVELS[(i/2)|0];
        var level = {
            version: index,
            ec_level: ec_level,
            data_len: length,
            ec_len: v[i] / num_template,
            blocks: [],
            ec: []
        }

        for (var k = num_template, n = length; k > 0; k--) {
            var block = (n / k)|0;
            level.blocks.push(block);
            n -= block;

        }
        res[ec_level] = level;
    }
    return res;
});

// {{{1 Get version template
function getTemplate(message, ec_level) {
    var i = 1;
    var len;

    if (message.data1) {
        len = Math.ceil(message.data1.length / 8);
    } else {
        i = 10;
    }
    for (/* i */; i < 10; i++) {
        var version = versions[i][ec_level];
        if (version.data_len >= len) {
            return _deepCopy(version);
        }
    }

    if (message.data10) {
        len = Math.ceil(message.data10.length / 8);
    } else {
        i = 27;
    }
    for (/* i */; i < 27; i++) {
        var version = versions[i][ec_level];
        if (version.data_len >= len) {
            return _deepCopy(version);
        }
    }

    len = Math.ceil(message.data27.length / 8);
    for (/* i */; i < 41; i++) {
        var version = versions[i][ec_level];
        if (version.data_len >= len) {
            return _deepCopy(version);
        }
    }
    throw new Error("Too much data");
}

// {{{1 Fill template
function fillTemplate(message, template) {
    var blocks = new Buffer(template.data_len);
    blocks.fill(0);

    if (template.version < 10) {
        message = message.data1;
    } else if (template.version < 27) {
        message = message.data10;
    } else {
        message = message.data27;
    }

    var len = message.length;

    for (var i = 0; i < len; i += 8) {
        var b = 0;
        for (var j = 0; j < 8; j++) {
            b = (b << 1) | (message[i + j] ? 1 : 0);
        }
        blocks[i / 8] = b;
    }

    var pad = 236;
    for (var i = Math.ceil((len + 4) / 8); i < blocks.length; i++) {
        blocks[i] = pad;
        pad = (pad == 236) ? 17 : 236;
    }

    var offset = 0;
    template.blocks = template.blocks.map(function(n) {
        var b = blocks.slice(offset, offset + n);
        offset += n;
        template.ec.push(calculateEC(b, template.ec_len));
        return b;
    });

    return template;
}

// {{{1 All-in-one
function QR(text, ec_level, parse_url) {
    ec_level = EC_LEVELS.indexOf(ec_level) > -1 ? ec_level : 'M';
    var message = encode(text, parse_url);
    var data = fillTemplate(message, getTemplate(message, ec_level));
    return matrix.getMatrix(data);
}

// {{{1 export functions
module.exports = {
    QR: QR,
    getTemplate: getTemplate,
    fillTemplate: fillTemplate,
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer))

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

function pushBits(arr, n, value) {
    for (var bit = 1 << (n - 1); bit; bit = bit >>> 1) {
        arr.push(bit & value ? 1 : 0);
    }
}

// {{{1 8bit encode
function encode_8bit(data) {
    var len = data.length;
    var bits = [];

    for (var i = 0; i < len; i++) {
        pushBits(bits, 8, data[i]);
    }

    var res = {};

    var d = [0, 1, 0, 0];
    pushBits(d, 16, len);
    res.data10 = res.data27 = d.concat(bits);

    if (len < 256) {
        var d = [0, 1, 0, 0];
        pushBits(d, 8, len);
        res.data1 = d.concat(bits);
    }

    return res;
}

// {{{1 alphanumeric encode
var ALPHANUM = (function(s) {
    var res = {};
    for (var i = 0; i < s.length; i++) {
        res[s[i]] = i;
    }
    return res;
})('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:');

function encode_alphanum(str) {
    var len = str.length;
    var bits = [];

    for (var i = 0; i < len; i += 2) {
        var b = 6;
        var n = ALPHANUM[str[i]];
        if (str[i+1]) {
            b = 11;
            n = n * 45 + ALPHANUM[str[i+1]];
        }
        pushBits(bits, b, n);
    }

    var res = {};

    var d = [0, 0, 1, 0];
    pushBits(d, 13, len);
    res.data27 = d.concat(bits);

    if (len < 2048) {
        var d = [0, 0, 1, 0];
        pushBits(d, 11, len);
        res.data10 = d.concat(bits);
    }

    if (len < 512) {
        var d = [0, 0, 1, 0];
        pushBits(d, 9, len);
        res.data1 = d.concat(bits);
    }

    return res;
}

// {{{1 numeric encode
function encode_numeric(str) {
    var len = str.length;
    var bits = [];

    for (var i = 0; i < len; i += 3) {
        var s = str.substr(i, 3);
        var b = Math.ceil(s.length * 10 / 3);
        pushBits(bits, b, parseInt(s, 10));
    }

    var res = {};

    var d = [0, 0, 0, 1];
    pushBits(d, 14, len);
    res.data27 = d.concat(bits);

    if (len < 4096) {
        var d = [0, 0, 0, 1];
        pushBits(d, 12, len);
        res.data10 = d.concat(bits);
    }

    if (len < 1024) {
        var d = [0, 0, 0, 1];
        pushBits(d, 10, len);
        res.data1 = d.concat(bits);
    }

    return res;
}

// {{{1 url encode
function encode_url(str) {
    var slash = str.indexOf('/', 8) + 1 || str.length;
    var res = encode(str.slice(0, slash).toUpperCase(), false);

    if (slash >= str.length) {
        return res;
    }

    var path_res = encode(str.slice(slash), false);

    res.data27 = res.data27.concat(path_res.data27);

    if (res.data10 && path_res.data10) {
        res.data10 = res.data10.concat(path_res.data10);
    }

    if (res.data1 && path_res.data1) {
        res.data1 = res.data1.concat(path_res.data1);
    }

    return res;
}

// {{{1 Choose encode mode and generates struct with data for different version
function encode(data, parse_url) {
    var str;
    var t = typeof data;

    if (t == 'string' || t == 'number') {
        str = '' + data;
        data = new Buffer(str);
    } else if (Buffer.isBuffer(data)) {
        str = data.toString();
    } else if (Array.isArray(data)) {
        data = new Buffer(data);
        str = data.toString();
    } else {
        throw new Error("Bad data");
    }

    if (/^[0-9]+$/.test(str)) {
        if (data.length > 7089) {
            throw new Error("Too much data");
        }
        return encode_numeric(str);
    }

    if (/^[0-9A-Z \$%\*\+\.\/\:\-]+$/.test(str)) {
        if (data.length > 4296) {
            throw new Error("Too much data");
        }
        return encode_alphanum(str);
    }

    if (parse_url && /^https?:/i.test(str)) {
        return encode_url(str);
    }

    if (data.length > 2953) {
        throw new Error("Too much data");
    }
    return encode_8bit(data);
}

// {{{1 export functions
module.exports = encode;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer))

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// {{{1 Galois Field Math
var GF256_BASE = 285;

var EXP_TABLE = [1];
var LOG_TABLE = [];

for (var i = 1; i < 256; i++) {
    var n = EXP_TABLE[i - 1] << 1;
    if (n > 255) n = n ^ GF256_BASE;
    EXP_TABLE[i] = n;
}

for (var i = 0; i < 255; i++) {
    LOG_TABLE[EXP_TABLE[i]] = i;
}

function exp(k) {
    while (k < 0) k += 255;
    while (k > 255) k -= 255;
    return EXP_TABLE[k];
}

function log(k) {
    if (k < 1 || k > 255) {
        throw Error('Bad log(' + k + ')');
    }
    return LOG_TABLE[k];
}

// {{{1 Generator Polynomials
var POLYNOMIALS = [
    [0], // a^0 x^0
    [0, 0], // a^0 x^1 + a^0 x^0
    [0, 25, 1], // a^0 x^2 + a^25 x^1 + a^1 x^0
    // and so on...
];

function generatorPolynomial(num) {
    if (POLYNOMIALS[num]) {
        return POLYNOMIALS[num];
    }
    var prev = generatorPolynomial(num - 1);
    var res = [];

    res[0] = prev[0];
    for (var i = 1; i <= num; i++) {
        res[i] = log(exp(prev[i]) ^ exp(prev[i - 1] + num - 1));
    }
    POLYNOMIALS[num] = res;
    return res;
}

// {{{1 export functions
module.exports = function calculate_ec(msg, ec_len) {
    // `msg` could be array or buffer
    // convert `msg` to array
    msg = [].slice.call(msg);

    // Generator Polynomial
    var poly = generatorPolynomial(ec_len);

    for (var i = 0; i < ec_len; i++) msg.push(0);
    while (msg.length > ec_len) {
        if (!msg[0]) {
            msg.shift();
            continue;
        }
        var log_k = log(msg[0]);
        for (var i = 0; i <= ec_len; i++) {
            msg[i] = msg[i] ^ exp(poly[i] + log_k);
        }
        msg.shift();
    }
    return new Buffer(msg);
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer))

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// {{{1 Initialize matrix with zeros
function init(version) {
    var N = version * 4 + 17;
    var matrix = [];
    var zeros = new Buffer(N);
    zeros.fill(0);
    zeros = [].slice.call(zeros);
    for (var i = 0; i < N; i++) {
        matrix[i] = zeros.slice();
    }
    return matrix;
}

// {{{1 Put finders into matrix
function fillFinders(matrix) {
    var N = matrix.length;
    for (var i = -3; i <= 3; i++) {
        for (var j = -3; j <= 3; j++) {
            var max = Math.max(i, j);
            var min = Math.min(i, j);
            var pixel = (max == 2 && min >= -2) || (min == -2 && max <= 2) ? 0x80 : 0x81;
            matrix[3 + i][3 + j] = pixel;
            matrix[3 + i][N - 4 + j] = pixel;
            matrix[N - 4 + i][3 + j] = pixel;
        }
    }
    for (var i = 0; i < 8; i++) {
        matrix[7][i] = matrix[i][7] =
        matrix[7][N - i - 1] = matrix[i][N - 8] =
        matrix[N - 8][i] = matrix[N - 1 - i][7] = 0x80;
    }
}

// {{{1 Put align and timinig
function fillAlignAndTiming(matrix) {
    var N = matrix.length;
    if (N > 21) {
        var len = N - 13;
        var delta = Math.round(len / Math.ceil(len / 28));
        if (delta % 2) delta++;
        var res = [];
        for (var p = len + 6; p > 10; p -= delta) {
            res.unshift(p);
        }
        res.unshift(6);
        for (var i = 0; i < res.length; i++) {
            for (var j = 0; j < res.length; j++) {
                var x = res[i], y = res[j];
                if (matrix[x][y]) continue;
                for (var r = -2; r <=2 ; r++) {
                    for (var c = -2; c <=2 ; c++) {
                        var max = Math.max(r, c);
                        var min = Math.min(r, c);
                        var pixel = (max == 1 && min >= -1) || (min == -1 && max <= 1) ? 0x80 : 0x81;
                        matrix[x + r][y + c] = pixel;
                    }
                }
            }
        }
    }
    for (var i = 8; i < N - 8; i++) {
        matrix[6][i] = matrix[i][6] = i % 2 ? 0x80 : 0x81;
    }
}

// {{{1 Fill reserved areas with zeroes
function fillStub(matrix) {
    var N = matrix.length;
    for (var i = 0; i < 8; i++) {
        if (i != 6) {
            matrix[8][i] = matrix[i][8] = 0x80;
        }
        matrix[8][N - 1 - i] = 0x80;
        matrix[N - 1 - i][8] = 0x80;
    }
    matrix[8][8] = 0x80;
    matrix[N - 8][8] = 0x81;

    if (N < 45) return;

    for (var i = N - 11; i < N - 8; i++) {
        for (var j = 0; j < 6; j++) {
            matrix[i][j] = matrix[j][i] = 0x80;
        }
    }
}

// {{{1 Fill reserved areas
var fillReserved = (function() {
    var FORMATS = Array(32);
    var VERSIONS = Array(40);

    var gf15 = 0x0537;
    var gf18 = 0x1f25;
    var formats_mask = 0x5412;

    for (var format = 0; format < 32; format++) {
        var res = format << 10;
        for (var i = 5; i > 0; i--) {
            if (res >>> (9 + i)) {
                res = res ^ (gf15 << (i - 1));
            }
        }
        FORMATS[format] = (res | (format << 10)) ^ formats_mask;
    }

    for (var version = 7; version <= 40; version++) {
        var res = version << 12;
        for (var i = 6; i > 0; i--) {
            if (res >>> (11 + i)) {
                res = res ^ (gf18 << (i - 1));
            }
        }
        VERSIONS[version] = (res | (version << 12));
    }

    var EC_LEVELS = { L: 1, M: 0, Q: 3, H: 2 };

    return function fillReserved(matrix, ec_level, mask) {
        var N = matrix.length;
        var format = FORMATS[EC_LEVELS[ec_level] << 3 | mask];
        function F(k) { return format >> k & 1 ? 0x81 : 0x80 };
        for (var i = 0; i < 8; i++) {
            matrix[8][N - 1 - i] = F(i);
            if (i < 6) matrix[i][8] = F(i);
        }
        for (var i = 8; i < 15; i++) {
            matrix[N - 15 + i][8] = F(i);
            if (i > 8) matrix[8][14 - i] = F(i);
        }
        matrix[7][8] = F(6);
        matrix[8][8] = F(7);
        matrix[8][7] = F(8);

        var version = VERSIONS[(N - 17)/4];
        if (!version) return;
        function V(k) { return version >> k & 1 ? 0x81 : 0x80 };
        for (var i = 0; i < 6; i++) {
            for (var j = 0; j < 3; j++) {
                matrix[N - 11 + j][i] = matrix[i][N - 11 + j] = V(i * 3 + j);
            }
        }
    }
})();

// {{{1 Fill data
var fillData = (function() {
    var MASK_FUNCTIONS = [
        function(i, j) { return (i + j) % 2 == 0 },
        function(i, j) { return i % 2 == 0 },
        function(i, j) { return j % 3 == 0 },
        function(i, j) { return (i + j) % 3 == 0 },
        function(i, j) { return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0 },
        function(i, j) { return (i * j) % 2 + (i * j) % 3 == 0 },
        function(i, j) { return ( (i * j) % 2 + (i * j) % 3) % 2 == 0 },
        function(i, j) { return ( (i * j) % 3 + (i + j) % 2) % 2 == 0 }
    ];

    return function fillData(matrix, data, mask) {
        var N = matrix.length;
        var row, col, dir = -1;
        row = col = N - 1;
        var mask_fn = MASK_FUNCTIONS[mask];
        var len = data.blocks[data.blocks.length - 1].length;

        for (var i = 0; i < len; i++) {
            for (var b = 0; b < data.blocks.length; b++) {
                if (data.blocks[b].length <= i) continue;
                put(data.blocks[b][i]);
            }
        }

        len = data.ec_len;
        for (var i = 0; i < len; i++) {
            for (var b = 0; b < data.ec.length; b++) {
                put(data.ec[b][i]);
            }
        }

        if (col > -1) {
            do {
                matrix[row][col] = mask_fn(row, col) ? 1 : 0;
            } while (next());
        }

        function put(byte) {
            for (var mask = 0x80; mask; mask = mask >> 1) {
                var pixel = !!(mask & byte);
                if (mask_fn(row, col)) pixel = !pixel;
                matrix[row][col] = pixel ? 1 : 0;
                next();
            }
        }

        function next() {
            do {
                if ((col % 2) ^ (col < 6)) {
                    if (dir < 0 && row == 0 || dir > 0 && row == N - 1) {
                        col--;
                        dir = -dir;
                    } else {
                        col++;
                        row += dir;
                    }
                } else {
                    col--;
                }
                if (col == 6) {
                    col--;
                }
                if (col < 0) {
                    return false;
                }
            } while (matrix[row][col] & 0xf0);
            return true;
        }
    }
})();

// {{{1 Calculate penalty
function calculatePenalty(matrix) {
    var N = matrix.length;
    var penalty = 0;
    // Rule 1
    for (var i = 0; i < N; i++) {
        var pixel = matrix[i][0] & 1;
        var len = 1;
        for (var j = 1; j < N; j++) {
            var p = matrix[i][j] & 1;
            if (p == pixel) {
                len++;
                continue;
            }
            if (len >= 5) {
                penalty += len - 2;
            }
            pixel = p;
            len = 1;
        }
        if (len >= 5) {
            penalty += len - 2;
        }
    }
    for (var j = 0; j < N; j++) {
        var pixel = matrix[0][j] & 1;
        var len = 1;
        for (var i = 1; i < N; i++) {
            var p = matrix[i][j] & 1;
            if (p == pixel) {
                len++;
                continue;
            }
            if (len >= 5) {
                penalty += len - 2;
            }
            pixel = p;
            len = 1;
        }
        if (len >= 5) {
            penalty += len - 2;
        }
    }

    // Rule 2
    for (var i = 0; i < N - 1; i++) {
        for (var j = 0; j < N - 1; j++) {
            var s = matrix[i][j] + matrix[i][j + 1] + matrix[i + 1][j] + matrix[i + 1][j + 1] & 7;
            if (s == 0 || s == 4) {
                penalty += 3;
            }
        }
    }

    // Rule 3
    function I(k) { return matrix[i][j + k] & 1 };
    function J(k) { return matrix[i + k][j] & 1 };
    for (var i = 0; i < N; i++) {
        for (var j = 0; j < N; j++) {
            if (j < N - 6 && I(0) && !I(1) && I(2) && I(3) && I(4) && !I(5) && I(6)) {
                if (j >= 4 && !(I(-4) || I(-3) || I(-2) || I(-1))) {
                    penalty += 40;
                }
                if (j < N - 10 && !(I(7) || I(8) || I(9) || I(10))) {
                    penalty += 40;
                }
            }

            if (i < N - 6 && J(0) && !J(1) && J(2) && J(3) && J(4) && !J(5) && J(6)) {
                if (i >= 4 && !(J(-4) || J(-3) || J(-2) || J(-1))) {
                    penalty += 40;
                }
                if (i < N - 10 && !(J(7) || J(8) || J(9) || J(10))) {
                    penalty += 40;
                }
            }
        }
    }

    // Rule 4
    var numDark = 0;
    for (var i = 0; i < N; i++) {
        for (var j = 0; j < N; j++) {
            if (matrix[i][j] & 1) numDark++;
        }
    }
    penalty += 10 * Math.floor(Math.abs(10 - 20 * numDark/(N * N)));

    return penalty;
}

// {{{1 All-in-one function
function getMatrix(data) {
    var matrix = init(data.version);
    fillFinders(matrix);
    fillAlignAndTiming(matrix);
    fillStub(matrix);

    var penalty = Infinity;
    var bestMask = 0;
    for (var mask = 0; mask < 8; mask++) {
        fillData(matrix, data, mask);
        fillReserved(matrix, data.ec_level, mask);
        var p = calculatePenalty(matrix);
        if (p < penalty) {
            penalty = p;
            bestMask = mask;
        }
    }

    fillData(matrix, data, bestMask);
    fillReserved(matrix, data.ec_level, bestMask);

    return matrix.map(function(row) {
        return row.map(function(cell) {
            return cell & 1;
        });
    });
}

// {{{1 export functions
module.exports = {
    getMatrix: getMatrix,
    init: init,
    fillFinders: fillFinders,
    fillAlignAndTiming: fillAlignAndTiming,
    fillStub: fillStub,
    fillReserved: fillReserved,
    fillData: fillData,
    calculatePenalty: calculatePenalty,
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer))

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var zlib = __webpack_require__(361);

var crc32 = __webpack_require__(374);

var PNG_HEAD = new Buffer([137,80,78,71,13,10,26,10]);
var PNG_IHDR = new Buffer([0,0,0,13,73,72,68,82,0,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0]);
var PNG_IDAT = new Buffer([0,0,0,0,73,68,65,84]);
var PNG_IEND = new Buffer([0,0,0,0,73,69,78,68,174,66,96,130]);

function png(bitmap, stream) {
    stream.push(PNG_HEAD);

    var IHDR = Buffer.concat([PNG_IHDR]);
    IHDR.writeUInt32BE(bitmap.size, 8);
    IHDR.writeUInt32BE(bitmap.size, 12);
    IHDR.writeUInt32BE(crc32(IHDR.slice(4, -4)), 21);
    stream.push(IHDR);

    var IDAT = Buffer.concat([
        PNG_IDAT,
        zlib.deflateSync(bitmap.data, { level: 9 }),
        new Buffer(4)
    ]);
    IDAT.writeUInt32BE(IDAT.length - 12, 0);
    IDAT.writeUInt32BE(crc32(IDAT.slice(4, -4)), IDAT.length - 4);
    stream.push(IDAT);

    stream.push(PNG_IEND);
    stream.push(null);
}

function bitmap(matrix, size, margin) {
    var N = matrix.length;
    var X = (N + 2 * margin) * size;
    var data = new Buffer((X + 1) * X);
    data.fill(255);
    for (var i = 0; i < X; i++) {
        data[i * (X + 1)] = 0;
    }

    for (var i = 0; i < N; i++) {
        for (var j = 0; j < N; j++) {
            if (matrix[i][j]) {
                var offset = ((margin + i) * (X + 1) + (margin + j)) * size + 1;
                data.fill(0, offset, offset + size);
                for (var c = 1; c < size; c++) {
                    data.copy(data, offset + c * (X + 1), offset, offset + size);
                }
            }
        }
    }

    return {
        data: data,
        size: X
    }
}

module.exports = {
    bitmap: bitmap,
    png: png
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer))

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var Buffer = __webpack_require__(19).Buffer;
var Transform = __webpack_require__(239).Transform;
var binding = __webpack_require__(362);
var util = __webpack_require__(247);
var assert = __webpack_require__(246).ok;
var kMaxLength = __webpack_require__(19).kMaxLength;
var kRangeErrorMessage = 'Cannot create final Buffer. It would be larger ' + 'than 0x' + kMaxLength.toString(16) + ' bytes';

// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;

// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16 * 1024;

binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;

binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

// expose all the zlib constants
var bkeys = Object.keys(binding);
for (var bk = 0; bk < bkeys.length; bk++) {
  var bkey = bkeys[bk];
  if (bkey.match(/^Z/)) {
    Object.defineProperty(exports, bkey, {
      enumerable: true, value: binding[bkey], writable: false
    });
  }
}

// translation table for return codes.
var codes = {
  Z_OK: binding.Z_OK,
  Z_STREAM_END: binding.Z_STREAM_END,
  Z_NEED_DICT: binding.Z_NEED_DICT,
  Z_ERRNO: binding.Z_ERRNO,
  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
  Z_DATA_ERROR: binding.Z_DATA_ERROR,
  Z_MEM_ERROR: binding.Z_MEM_ERROR,
  Z_BUF_ERROR: binding.Z_BUF_ERROR,
  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};

var ckeys = Object.keys(codes);
for (var ck = 0; ck < ckeys.length; ck++) {
  var ckey = ckeys[ck];
  codes[codes[ckey]] = ckey;
}

Object.defineProperty(exports, 'codes', {
  enumerable: true, value: Object.freeze(codes), writable: false
});

exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;

exports.createDeflate = function (o) {
  return new Deflate(o);
};

exports.createInflate = function (o) {
  return new Inflate(o);
};

exports.createDeflateRaw = function (o) {
  return new DeflateRaw(o);
};

exports.createInflateRaw = function (o) {
  return new InflateRaw(o);
};

exports.createGzip = function (o) {
  return new Gzip(o);
};

exports.createGunzip = function (o) {
  return new Gunzip(o);
};

exports.createUnzip = function (o) {
  return new Unzip(o);
};

// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Deflate(opts), buffer, callback);
};

exports.deflateSync = function (buffer, opts) {
  return zlibBufferSync(new Deflate(opts), buffer);
};

exports.gzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gzip(opts), buffer, callback);
};

exports.gzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gzip(opts), buffer);
};

exports.deflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};

exports.deflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new DeflateRaw(opts), buffer);
};

exports.unzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Unzip(opts), buffer, callback);
};

exports.unzipSync = function (buffer, opts) {
  return zlibBufferSync(new Unzip(opts), buffer);
};

exports.inflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Inflate(opts), buffer, callback);
};

exports.inflateSync = function (buffer, opts) {
  return zlibBufferSync(new Inflate(opts), buffer);
};

exports.gunzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gunzip(opts), buffer, callback);
};

exports.gunzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gunzip(opts), buffer);
};

exports.inflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new InflateRaw(opts), buffer, callback);
};

exports.inflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new InflateRaw(opts), buffer);
};

function zlibBuffer(engine, buffer, callback) {
  var buffers = [];
  var nread = 0;

  engine.on('error', onError);
  engine.on('end', onEnd);

  engine.end(buffer);
  flow();

  function flow() {
    var chunk;
    while (null !== (chunk = engine.read())) {
      buffers.push(chunk);
      nread += chunk.length;
    }
    engine.once('readable', flow);
  }

  function onError(err) {
    engine.removeListener('end', onEnd);
    engine.removeListener('readable', flow);
    callback(err);
  }

  function onEnd() {
    var buf;
    var err = null;

    if (nread >= kMaxLength) {
      err = new RangeError(kRangeErrorMessage);
    } else {
      buf = Buffer.concat(buffers, nread);
    }

    buffers = [];
    engine.close();
    callback(err, buf);
  }
}

function zlibBufferSync(engine, buffer) {
  if (typeof buffer === 'string') buffer = Buffer.from(buffer);

  if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');

  var flushFlag = engine._finishFlushFlag;

  return engine._processChunk(buffer, flushFlag);
}

// generic zlib
// minimal 2-byte header
function Deflate(opts) {
  if (!(this instanceof Deflate)) return new Deflate(opts);
  Zlib.call(this, opts, binding.DEFLATE);
}

function Inflate(opts) {
  if (!(this instanceof Inflate)) return new Inflate(opts);
  Zlib.call(this, opts, binding.INFLATE);
}

// gzip - bigger header, same deflate compression
function Gzip(opts) {
  if (!(this instanceof Gzip)) return new Gzip(opts);
  Zlib.call(this, opts, binding.GZIP);
}

function Gunzip(opts) {
  if (!(this instanceof Gunzip)) return new Gunzip(opts);
  Zlib.call(this, opts, binding.GUNZIP);
}

// raw - no header
function DeflateRaw(opts) {
  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
  Zlib.call(this, opts, binding.DEFLATERAW);
}

function InflateRaw(opts) {
  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
  Zlib.call(this, opts, binding.INFLATERAW);
}

// auto-detect header.
function Unzip(opts) {
  if (!(this instanceof Unzip)) return new Unzip(opts);
  Zlib.call(this, opts, binding.UNZIP);
}

function isValidFlushFlag(flag) {
  return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}

// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.

function Zlib(opts, mode) {
  var _this = this;

  this._opts = opts = opts || {};
  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

  Transform.call(this, opts);

  if (opts.flush && !isValidFlushFlag(opts.flush)) {
    throw new Error('Invalid flush flag: ' + opts.flush);
  }
  if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
    throw new Error('Invalid flush flag: ' + opts.finishFlush);
  }

  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
  this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;

  if (opts.chunkSize) {
    if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
      throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
  }

  if (opts.windowBits) {
    if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
      throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
  }

  if (opts.level) {
    if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
      throw new Error('Invalid compression level: ' + opts.level);
    }
  }

  if (opts.memLevel) {
    if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
      throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
  }

  if (opts.strategy) {
    if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
      throw new Error('Invalid strategy: ' + opts.strategy);
    }
  }

  if (opts.dictionary) {
    if (!Buffer.isBuffer(opts.dictionary)) {
      throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
  }

  this._handle = new binding.Zlib(mode);

  var self = this;
  this._hadError = false;
  this._handle.onerror = function (message, errno) {
    // there is no way to cleanly recover.
    // continuing only obscures problems.
    _close(self);
    self._hadError = true;

    var error = new Error(message);
    error.errno = errno;
    error.code = exports.codes[errno];
    self.emit('error', error);
  };

  var level = exports.Z_DEFAULT_COMPRESSION;
  if (typeof opts.level === 'number') level = opts.level;

  var strategy = exports.Z_DEFAULT_STRATEGY;
  if (typeof opts.strategy === 'number') strategy = opts.strategy;

  this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);

  this._buffer = Buffer.allocUnsafe(this._chunkSize);
  this._offset = 0;
  this._level = level;
  this._strategy = strategy;

  this.once('end', this.close);

  Object.defineProperty(this, '_closed', {
    get: function () {
      return !_this._handle;
    },
    configurable: true,
    enumerable: true
  });
}

util.inherits(Zlib, Transform);

Zlib.prototype.params = function (level, strategy, callback) {
  if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
    throw new RangeError('Invalid compression level: ' + level);
  }
  if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
    throw new TypeError('Invalid strategy: ' + strategy);
  }

  if (this._level !== level || this._strategy !== strategy) {
    var self = this;
    this.flush(binding.Z_SYNC_FLUSH, function () {
      assert(self._handle, 'zlib binding closed');
      self._handle.params(level, strategy);
      if (!self._hadError) {
        self._level = level;
        self._strategy = strategy;
        if (callback) callback();
      }
    });
  } else {
    process.nextTick(callback);
  }
};

Zlib.prototype.reset = function () {
  assert(this._handle, 'zlib binding closed');
  return this._handle.reset();
};

// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function (callback) {
  this._transform(Buffer.alloc(0), '', callback);
};

Zlib.prototype.flush = function (kind, callback) {
  var _this2 = this;

  var ws = this._writableState;

  if (typeof kind === 'function' || kind === undefined && !callback) {
    callback = kind;
    kind = binding.Z_FULL_FLUSH;
  }

  if (ws.ended) {
    if (callback) process.nextTick(callback);
  } else if (ws.ending) {
    if (callback) this.once('end', callback);
  } else if (ws.needDrain) {
    if (callback) {
      this.once('drain', function () {
        return _this2.flush(kind, callback);
      });
    }
  } else {
    this._flushFlag = kind;
    this.write(Buffer.alloc(0), '', callback);
  }
};

Zlib.prototype.close = function (callback) {
  _close(this, callback);
  process.nextTick(emitCloseNT, this);
};

function _close(engine, callback) {
  if (callback) process.nextTick(callback);

  // Caller may invoke .close after a zlib error (which will null _handle).
  if (!engine._handle) return;

  engine._handle.close();
  engine._handle = null;
}

function emitCloseNT(self) {
  self.emit('close');
}

Zlib.prototype._transform = function (chunk, encoding, cb) {
  var flushFlag;
  var ws = this._writableState;
  var ending = ws.ending || ws.ended;
  var last = ending && (!chunk || ws.length === chunk.length);

  if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));

  if (!this._handle) return cb(new Error('zlib binding closed'));

  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
  // (or whatever flag was provided using opts.finishFlush).
  // If it's explicitly flushing at some other time, then we use
  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
  // goodness.
  if (last) flushFlag = this._finishFlushFlag;else {
    flushFlag = this._flushFlag;
    // once we've flushed the last of the queue, stop flushing and
    // go back to the normal behavior.
    if (chunk.length >= ws.length) {
      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
  }

  this._processChunk(chunk, flushFlag, cb);
};

Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
  var availInBefore = chunk && chunk.length;
  var availOutBefore = this._chunkSize - this._offset;
  var inOff = 0;

  var self = this;

  var async = typeof cb === 'function';

  if (!async) {
    var buffers = [];
    var nread = 0;

    var error;
    this.on('error', function (er) {
      error = er;
    });

    assert(this._handle, 'zlib binding closed');
    do {
      var res = this._handle.writeSync(flushFlag, chunk, // in
      inOff, // in_off
      availInBefore, // in_len
      this._buffer, // out
      this._offset, //out_off
      availOutBefore); // out_len
    } while (!this._hadError && callback(res[0], res[1]));

    if (this._hadError) {
      throw error;
    }

    if (nread >= kMaxLength) {
      _close(this);
      throw new RangeError(kRangeErrorMessage);
    }

    var buf = Buffer.concat(buffers, nread);
    _close(this);

    return buf;
  }

  assert(this._handle, 'zlib binding closed');
  var req = this._handle.write(flushFlag, chunk, // in
  inOff, // in_off
  availInBefore, // in_len
  this._buffer, // out
  this._offset, //out_off
  availOutBefore); // out_len

  req.buffer = chunk;
  req.callback = callback;

  function callback(availInAfter, availOutAfter) {
    // When the callback is used in an async write, the callback's
    // context is the `req` object that was created. The req object
    // is === this._handle, and that's why it's important to null
    // out the values after they are done being used. `this._handle`
    // can stay in memory longer than the callback and buffer are needed.
    if (this) {
      this.buffer = null;
      this.callback = null;
    }

    if (self._hadError) return;

    var have = availOutBefore - availOutAfter;
    assert(have >= 0, 'have should not go down');

    if (have > 0) {
      var out = self._buffer.slice(self._offset, self._offset + have);
      self._offset += have;
      // serve some output to the consumer.
      if (async) {
        self.push(out);
      } else {
        buffers.push(out);
        nread += out.length;
      }
    }

    // exhausted the output buffer, or used all the input create a new one.
    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
      availOutBefore = self._chunkSize;
      self._offset = 0;
      self._buffer = Buffer.allocUnsafe(self._chunkSize);
    }

    if (availOutAfter === 0) {
      // Not actually done.  Need to reprocess.
      // Also, update the availInBefore to the availInAfter value,
      // so that if we have to hit it a third (fourth, etc.) time,
      // it'll have the correct byte counts.
      inOff += availInBefore - availInAfter;
      availInBefore = availInAfter;

      if (!async) return true;

      var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
      newReq.callback = callback; // this same function
      newReq.buffer = chunk;
      return;
    }

    if (!async) return false;

    // finished with the chunk.
    cb();
  }
};

util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25)))

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {
/* eslint camelcase: "off" */

var assert = __webpack_require__(246);

var Zstream = __webpack_require__(366);
var zlib_deflate = __webpack_require__(367);
var zlib_inflate = __webpack_require__(370);
var constants = __webpack_require__(373);

for (var key in constants) {
  exports[key] = constants[key];
}

// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;

var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;

/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
function Zlib(mode) {
  if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
    throw new TypeError('Bad argument');
  }

  this.dictionary = null;
  this.err = 0;
  this.flush = 0;
  this.init_done = false;
  this.level = 0;
  this.memLevel = 0;
  this.mode = mode;
  this.strategy = 0;
  this.windowBits = 0;
  this.write_in_progress = false;
  this.pending_close = false;
  this.gzip_id_bytes_read = 0;
}

Zlib.prototype.close = function () {
  if (this.write_in_progress) {
    this.pending_close = true;
    return;
  }

  this.pending_close = false;

  assert(this.init_done, 'close before init');
  assert(this.mode <= exports.UNZIP);

  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
    zlib_deflate.deflateEnd(this.strm);
  } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
    zlib_inflate.inflateEnd(this.strm);
  }

  this.mode = exports.NONE;

  this.dictionary = null;
};

Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
  assert.equal(arguments.length, 8);

  assert(this.init_done, 'write before init');
  assert(this.mode !== exports.NONE, 'already finalized');
  assert.equal(false, this.write_in_progress, 'write already in progress');
  assert.equal(false, this.pending_close, 'close is pending');

  this.write_in_progress = true;

  assert.equal(false, flush === undefined, 'must provide flush value');

  this.write_in_progress = true;

  if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
    throw new Error('Invalid flush value');
  }

  if (input == null) {
    input = Buffer.alloc(0);
    in_len = 0;
    in_off = 0;
  }

  this.strm.avail_in = in_len;
  this.strm.input = input;
  this.strm.next_in = in_off;
  this.strm.avail_out = out_len;
  this.strm.output = out;
  this.strm.next_out = out_off;
  this.flush = flush;

  if (!async) {
    // sync version
    this._process();

    if (this._checkError()) {
      return this._afterSync();
    }
    return;
  }

  // async version
  var self = this;
  process.nextTick(function () {
    self._process();
    self._after();
  });

  return this;
};

Zlib.prototype._afterSync = function () {
  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  return [avail_in, avail_out];
};

Zlib.prototype._process = function () {
  var next_expected_header_byte = null;

  // If the avail_out is left at 0, then it means that it ran out
  // of room.  If there was avail_out left over, then it means
  // that all of the input was consumed.
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflate(this.strm, this.flush);
      break;
    case exports.UNZIP:
      if (this.strm.avail_in > 0) {
        next_expected_header_byte = this.strm.next_in;
      }

      switch (this.gzip_id_bytes_read) {
        case 0:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
            this.gzip_id_bytes_read = 1;
            next_expected_header_byte++;

            if (this.strm.avail_in === 1) {
              // The only available byte was already read.
              break;
            }
          } else {
            this.mode = exports.INFLATE;
            break;
          }

        // fallthrough
        case 1:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
            this.gzip_id_bytes_read = 2;
            this.mode = exports.GUNZIP;
          } else {
            // There is no actual difference between INFLATE and INFLATERAW
            // (after initialization).
            this.mode = exports.INFLATE;
          }

          break;
        default:
          throw new Error('invalid number of gzip magic number bytes read');
      }

    // fallthrough
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
      this.err = zlib_inflate.inflate(this.strm, this.flush

      // If data was encoded with dictionary
      );if (this.err === exports.Z_NEED_DICT && this.dictionary) {
        // Load it
        this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
        if (this.err === exports.Z_OK) {
          // And try to decode again
          this.err = zlib_inflate.inflate(this.strm, this.flush);
        } else if (this.err === exports.Z_DATA_ERROR) {
          // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
          // Make it possible for After() to tell a bad dictionary from bad
          // input.
          this.err = exports.Z_NEED_DICT;
        }
      }
      while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
        // Bytes remain in input buffer. Perhaps this is another compressed
        // member in the same archive, or just trailing garbage.
        // Trailing zero bytes are okay, though, since they are frequently
        // used for padding.

        this.reset();
        this.err = zlib_inflate.inflate(this.strm, this.flush);
      }
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }
};

Zlib.prototype._checkError = function () {
  // Acceptable error states depend on the type of zlib stream.
  switch (this.err) {
    case exports.Z_OK:
    case exports.Z_BUF_ERROR:
      if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
        this._error('unexpected end of file');
        return false;
      }
      break;
    case exports.Z_STREAM_END:
      // normal statuses, not fatal
      break;
    case exports.Z_NEED_DICT:
      if (this.dictionary == null) {
        this._error('Missing dictionary');
      } else {
        this._error('Bad dictionary');
      }
      return false;
    default:
      // something else.
      this._error('Zlib error');
      return false;
  }

  return true;
};

Zlib.prototype._after = function () {
  if (!this._checkError()) {
    return;
  }

  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  // call the write() cb
  this.callback(avail_in, avail_out);

  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype._error = function (message) {
  if (this.strm.msg) {
    message = this.strm.msg;
  }
  this.onerror(message, this.err

  // no hope of rescue.
  );this.write_in_progress = false;
  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
  assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');

  assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
  assert(level >= -1 && level <= 9, 'invalid compression level');

  assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');

  assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');

  this._init(level, windowBits, memLevel, strategy, dictionary);
  this._setDictionary();
};

Zlib.prototype.params = function () {
  throw new Error('deflateParams Not supported');
};

Zlib.prototype.reset = function () {
  this._reset();
  this._setDictionary();
};

Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
  this.level = level;
  this.windowBits = windowBits;
  this.memLevel = memLevel;
  this.strategy = strategy;

  this.flush = exports.Z_NO_FLUSH;

  this.err = exports.Z_OK;

  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
    this.windowBits += 16;
  }

  if (this.mode === exports.UNZIP) {
    this.windowBits += 32;
  }

  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
    this.windowBits = -1 * this.windowBits;
  }

  this.strm = new Zstream();

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
      break;
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
    case exports.UNZIP:
      this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }

  if (this.err !== exports.Z_OK) {
    this._error('Init error');
  }

  this.dictionary = dictionary;

  this.write_in_progress = false;
  this.init_done = true;
};

Zlib.prototype._setDictionary = function () {
  if (this.dictionary == null) {
    return;
  }

  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to set dictionary');
  }
};

Zlib.prototype._reset = function () {
  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
    case exports.GZIP:
      this.err = zlib_deflate.deflateReset(this.strm);
      break;
    case exports.INFLATE:
    case exports.INFLATERAW:
    case exports.GUNZIP:
      this.err = zlib_inflate.inflateReset(this.strm);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to reset stream');
  }
};

exports.Zlib = Zlib;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer, __webpack_require__(25)))

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = __webpack_require__(99);
var trees   = __webpack_require__(368);
var adler32 = __webpack_require__(248);
var crc32   = __webpack_require__(249);
var msg     = __webpack_require__(369);

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = __webpack_require__(99);

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = __webpack_require__(99);
var adler32       = __webpack_require__(248);
var crc32         = __webpack_require__(249);
var inflate_fast  = __webpack_require__(371);
var inflate_table = __webpack_require__(372);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__(99);

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, Buffer) {

(function() {

// ARMv6 (Raspberry Pi) has bug in bitwise operations
// https://code.google.com/p/v8/issues/detail?id=3757
// https://github.com/alexeyten/qr-image/issues/13
if (process.arch === 'arm') {
    module.exports = __webpack_require__(375);
    return;
}

var crc_table = [];

(function() {
    for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) {
            if (c & 1) {
                c = 0xedb88320 ^ (c >>> 1);
            } else {
                c = c >>> 1;
            }
        }
        crc_table[n] = c >>> 0;
    }
})();

function update(c, buf) {
    var l = buf.length;
    for (var n = 0; n < l; n++) {
        c = crc_table[(c ^ buf[n]) & 0xff] ^ (c >>> 8);
    }
    return c;
}

function crc32(/* arguments */) {
    var l = arguments.length;
    var c = -1;
    for (var i = 0; i < l; i++) {
        c = update(c, new Buffer(arguments[i]));
    }
    c = (c ^ -1) >>> 0;
    return c;
}

module.exports = crc32;
    
})();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(25), __webpack_require__(19).Buffer))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var crc_table = [];

for (var n = 0; n < 256; n++) {
    var c = crc_table[n] = new Buffer(4);
    c.writeUInt32BE(n, 0);

    for (var k = 0; k < 8; k++) {
        var b0 = c[0] & 1;
        var b1 = c[1] & 1;
        var b2 = c[2] & 1;
        var b3 = c[3] & 1;

        c[0] = (c[0] >> 1) ^ (b3 ? 0xed : 0);
        c[1] = (c[1] >> 1) ^ (b3 ? 0xb8 : 0) ^ (b0 ? 0x80 : 0);
        c[2] = (c[2] >> 1) ^ (b3 ? 0x83 : 0) ^ (b1 ? 0x80 : 0);
        c[3] = (c[3] >> 1) ^ (b3 ? 0x20 : 0) ^ (b2 ? 0x80 : 0);
    }
}

function update(c, buf) {
    var l = buf.length;
    for (var n = 0; n < l; n++) {
        var e = crc_table[c[3] ^ buf[n]];
        c[3] = e[3] ^ c[2];
        c[2] = e[2] ^ c[1];
        c[1] = e[1] ^ c[0];
        c[0] = e[0];
    }
}

function crc32(/* arguments */) {
    var l = arguments.length;
    var c = new Buffer(4);
    c.fill(0xff);

    for (var i = 0; i < l; i++) {
        update(c, new Buffer(arguments[i]));
    }

    c[0] = c[0] ^ 0xff;
    c[1] = c[1] ^ 0xff;
    c[2] = c[2] ^ 0xff;
    c[3] = c[3] ^ 0xff;

    return c.readUInt32BE(0);
}

module.exports = crc32;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(19).Buffer))

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function matrix2path(matrix) {
    var N = matrix.length;
    var filled = [];
    for (var row = -1; row <= N; row++) {
        filled[row] = [];
    }

    var path = [];
    for (var row = 0; row < N; row++) {
        for (var col = 0; col < N; col++) {
            if (filled[row][col]) continue;
            filled[row][col] = 1;
            if (isDark(row, col)) {
                if (!isDark(row - 1, col)) {
                    path.push(plot(row, col, 'right'));
                }
            } else {
                if (isDark(row, col - 1)) {
                    path.push(plot(row, col, 'down'));
                }
            }
        }
    }
    return path;

    function isDark(row, col) {
        if (row < 0 || col < 0 || row >= N || col >= N) return false;
        return !!matrix[row][col];
    }

    function plot(row0, col0, dir) {
        filled[row0][col0] = 1;
        var res = [];
        res.push(['M',  col0, row0 ]);
        var row = row0;
        var col = col0;
        var len = 0;
        do {
            switch (dir) {
            case 'right':
                filled[row][col] = 1;
                if (isDark(row, col)) {
                    filled[row - 1][col] = 1;
                    if (isDark(row - 1, col)) {
                        res.push(['h', len]);
                        len = 0;
                        dir = 'up';
                    } else {
                        len++;
                        col++;
                    }
                } else {
                    res.push(['h', len]);
                    len = 0;
                    dir = 'down';
                }
                break;
            case 'left':
                filled[row - 1][col - 1] = 1;
                if (isDark(row - 1, col - 1)) {
                    filled[row][col - 1] = 1;
                    if (isDark(row, col - 1)) {
                        res.push(['h', -len]);
                        len = 0;
                        dir = 'down';
                    } else {
                        len++;
                        col--;
                    }
                } else {
                    res.push(['h', -len]);
                    len = 0;
                    dir = 'up';
                }
                break;
            case 'down':
                filled[row][col - 1] = 1;
                if (isDark(row, col - 1)) {
                    filled[row][col] = 1;
                    if (isDark(row, col)) {
                        res.push(['v', len]);
                        len = 0;
                        dir = 'right';
                    } else {
                        len++;
                        row++;
                    }
                } else {
                    res.push(['v', len]);
                    len = 0;
                    dir = 'left';
                }
                break;
            case 'up':
                filled[row - 1][col] = 1;
                if (isDark(row - 1, col)) {
                    filled[row - 1][col - 1] = 1;
                    if (isDark(row - 1, col - 1)) {
                        res.push(['v', -len]);
                        len = 0;
                        dir = 'left';
                    } else {
                        len++;
                        row--;
                    }
                } else {
                    res.push(['v', -len]);
                    len = 0;
                    dir = 'right';
                }
                break;
            }
        } while (row != row0 || col != col0);
        return res;
    }
}

function pushSVGPath(matrix, stream, margin) {
    matrix2path(matrix).forEach(function(subpath) {
        var res = '';
        for (var k = 0; k < subpath.length; k++) {
            var item = subpath[k];
            switch (item[0]) {
            case 'M':
                res += 'M' + (item[1] + margin) + ' ' + (item[2] + margin);
                break;
            default:
                res += item.join('');
            }
        }
        res += 'z';
        stream.push(res);
    });
}

function SVG_object(matrix, margin) {
    var stream = [];
    pushSVGPath(matrix, stream, margin);

    var result = {
        size: matrix.length + 2 * margin,
        path: stream.filter(Boolean).join('')
    }

    return result;
}

function SVG(matrix, stream, margin, size) {
    var X = matrix.length + 2 * margin;
    stream.push('<svg xmlns="http://www.w3.org/2000/svg" ');
    if (size > 0) {
        var XY = X * size;
        stream.push('width="' + XY + '" height="' + XY + '" ');
    }
    stream.push('viewBox="0 0 ' + X + ' ' + X + '">');
    stream.push('<path d="');
    pushSVGPath(matrix, stream, margin);
    stream.push('"/></svg>');
    stream.push(null);
}

function EPS(matrix, stream, margin) {
    var N = matrix.length;
    var scale = 9;
    var X = (N + 2 * margin) * scale;
    stream.push([
        '%!PS-Adobe-3.0 EPSF-3.0',
        '%%BoundingBox: 0 0 ' + X + ' ' + X,
        '/h { 0 rlineto } bind def',
        '/v { 0 exch neg rlineto } bind def',
        '/M { neg ' + (N + margin) + ' add moveto } bind def',
        '/z { closepath } bind def',
        scale + ' ' + scale + ' scale',
        ''
    ].join('\n'));

    matrix2path(matrix).forEach(function(subpath) {
        var res = '';
        for (var k = 0; k < subpath.length; k++) {
            var item = subpath[k];
            switch (item[0]) {
            case 'M':
                res += (item[1] + margin) + ' ' + item[2] + ' M ';
                break;
            default:
                res += item[1] + ' ' + item[0] + ' ';
            }
        }
        res += 'z\n';
        stream.push(res);
    });

    stream.push('fill\n%%EOF\n');
    stream.push(null);
}

function PDF(matrix, stream, margin) {
    // TODO deflate
    var N = matrix.length;
    var scale = 9;
    var X = (N + 2 * margin) * scale;
    var data = [
        '%PDF-1.0\n\n',
        '1 0 obj << /Type /Catalog /Pages 2 0 R >> endobj\n',
        '2 0 obj << /Type /Pages /Count 1 /Kids [ 3 0 R ] >> endobj\n',
    ];
    data.push('3 0 obj << /Type /Page /Parent 2 0 R /Resources <<>> ' +
        '/Contents 4 0 R /MediaBox [ 0 0 ' + X + ' ' + X + ' ] >> endobj\n');

    var path = scale + ' 0 0 ' + scale + ' 0 0 cm\n';
    path += matrix2path(matrix).map(function(subpath) {
        var res = '';
        var x, y;
        for (var k = 0; k < subpath.length; k++) {
            var item = subpath[k];
            switch (item[0]) {
            case 'M':
                x = item[1] + margin;
                y = N - item[2] + margin;
                res += x + ' ' + y + ' m ';
                break;
            case 'h':
                x += item[1];
                res += x + ' ' + y + ' l ';
                break;
            case 'v':
                y -= item[1];
                res += x + ' ' + y + ' l ';
                break;
            }
        }
        res += 'h';
        return res;
    }).join('\n');
    path += '\nf\n';
    data.push('4 0 obj << /Length ' + path.length + ' >> stream\n' +
        path + 'endstream\nendobj\n');

    var xref = 'xref\n0 5\n0000000000 65535 f \n';
    for (var i = 1, l = data[0].length; i < 5; i++) {
        xref += ('0000000000' + l).substr(-10) + ' 00000 n \n';
        l += data[i].length;
    }
    data.push(
        xref,
        'trailer << /Root 1 0 R /Size 5 >>\n',
        'startxref\n' + l + '\n%%EOF\n'
    );
    stream.push(data.join(''));
    stream.push(null);
}

module.exports = {
    svg: SVG,
    eps: EPS,
    pdf: PDF,
    svg_object: SVG_object
}


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var throttle_debounce_1 = __webpack_require__(149);
var list_1 = __importDefault(__webpack_require__(250));
var prompt_1 = __importDefault(__webpack_require__(260));
var hot_1 = __importDefault(__webpack_require__(261));
var sensors_1 = __webpack_require__(27);
var react_dom_1 = __webpack_require__(60);
var intervalId;
var SearchMenuComponent = function () {
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    // 热搜词
    var _a = (0, react_1.useState)(''), hotWordVal = _a[0], setHotWordVal = _a[1];
    var _b = (0, react_1.useState)([]), hotWordList = _b[0], setHotWordList = _b[1];
    // 是否聚焦
    var _c = (0, react_1.useState)(false), isFocus = _c[0], setIsFocus = _c[1];
    // 直接搜索
    var _d = (0, react_1.useState)(false), isSearch = _d[0], setIsSearch = _d[1];
    var _e = (0, react_1.useState)(''), componentType = _e[0], setComponentType = _e[1];
    // 推荐值，防抖后
    var _f = (0, react_1.useState)(''), promptVal = _f[0], setPromptVal = _f[1];
    // 搜索输入值
    var _g = (0, react_1.useState)(''), searchVal = _g[0], setSearchVal = _g[1];
    var searchRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        // 热搜词列表
        getSearch();
        // 除了点击自己，点击其他地方将自身隐藏
        document.addEventListener('click', function (e) {
            // @ts-ignore
            var id = e.target.id;
            if (['search_input', 'search_icon', 'search_clear', 'pre_page', 'next_page'].includes(id)) {
                return;
            }
            // @ts-ignore
            var isClickSearch = __spreadArray([], document.querySelectorAll('.search__box'), true).some(function (i) { return i.contains(e.target); });
            if (!isClickSearch) {
                setComponentType('');
                return;
            }
            setIsFocus(false);
        });
    }, []);
    var searchChange = (0, throttle_debounce_1.debounce)(350, function (val) {
        if (val) {
            if (isFocus) {
                setComponentType('2');
            }
            if (isSearch) {
                setComponentType('1');
            }
        }
        setPromptVal(val);
    }, false);
    (0, react_1.useEffect)(function () {
        searchChange(searchVal);
    }, [searchVal, isSearch, isFocus]);
    (0, react_1.useEffect)(function () {
        setTimer();
    }, [hotWordList]);
    var getSearch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpService.getHotWordList()];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setHotWordList((data === null || data === void 0 ? void 0 : data.hotWords) || []);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.log('error :>> ', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var setTimer = function () {
        if (hotWordList.length > 0) {
            // 默认第一个
            var hotIndex_1 = 0;
            setHotWordVal(hotWordList[hotIndex_1]);
            // 每隔6秒轮播下一个
            intervalId = setInterval(function () {
                hotIndex_1++;
                if (hotIndex_1 > hotWordList.length - 1) {
                    hotIndex_1 = 0;
                }
                setHotWordVal(hotWordList[hotIndex_1]);
            }, 6000);
        }
    };
    // 搜索
    var searchClick = function () {
        setIsSearch(true);
        if (!searchVal) {
            setSearchVal(hotWordVal);
        }
        // 回车，直接点击等操作，输入框无值时，使用推荐的值
        setPromptVal(searchVal || hotWordVal);
        setComponentType('1');
    };
    // 触发焦点
    var focusHandler = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'search',
            type: 'click',
        });
        setIsFocus(true);
        setComponentType('0');
        clearTimer();
    };
    // 离开焦点
    var blurHandler = function () {
        setTimer();
    };
    var keyDownHandler = function (e) {
        if (e.keyCode === 13) {
            searchClick();
        }
    };
    // 清空
    var clearClick = function () {
        setSearchVal('');
        setComponentType('');
        // @ts-ignore
        searchRef === null || searchRef === void 0 ? void 0 : searchRef.current.focus(); // 设置焦点
    };
    // 回调
    var inputText = function (val) {
        setIsSearch(true);
        setSearchVal(val);
    };
    var clearTimer = function () {
        if (intervalId) {
            clearInterval(intervalId);
        }
    };
    var searchDom = function () {
        var component = null;
        switch (componentType) {
            case '0':
                component = react_1.default.createElement(hot_1.default, { searchVal: promptVal });
                break;
            case '1':
                component = react_1.default.createElement(list_1.default, { searchVal: promptVal });
                break;
            case '2':
                component = react_1.default.createElement(prompt_1.default, { searchVal: promptVal, onInputText: inputText });
                break;
            default:
                component = '';
                break;
        }
        if (componentType) {
            // 禁止页面滚动
            (0, react_dom_1.addClass)(document.body, 'hgb-popup-parent--hidden');
        }
        else {
            // 移除页面滚动css
            (0, react_dom_1.removeClass)(document.body, 'hgb-popup-parent--hidden');
        }
        return component;
    };
    return (react_1.default.createElement("div", { className: "header__search-wrapper" },
        react_1.default.createElement("div", { className: "header__search-container" },
            react_1.default.createElement("div", { className: "header__search-input-container" },
                react_1.default.createElement("div", { className: "search__icon", id: "search_icon", onClick: function () {
                        searchClick();
                    } }),
                react_1.default.createElement("div", { className: "search__input" },
                    react_1.default.createElement("input", { ref: searchRef, id: "search_input", type: "text", autoCapitalize: "off", autoComplete: "off", autoCorrect: "off", placeholder: hotWordVal, value: searchVal, onChange: function (e) {
                            setIsSearch(false);
                            setSearchVal(e.target.value);
                        }, onFocus: focusHandler, onBlur: blurHandler, onKeyDown: keyDownHandler })),
                searchVal && isFocus && (react_1.default.createElement("div", { className: "clear__icon", id: "search_clear", onClick: function () {
                        clearClick();
                    } }))),
            react_1.default.createElement("div", { className: "search__box" }, searchDom()))));
};
exports.default = (0, react_1.memo)(SearchMenuComponent);


/***/ }),
/* 378 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 379 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(252);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 382 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 384 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 385 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 386 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {!function(e,t){ true?module.exports=t(__webpack_require__(39),__webpack_require__(254)):undefined}(this,(function(e,t){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=7)}([function(e,t){e.exports=function(e){return e&&e.__esModule?e:{default:e}},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(5);function o(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,r(o.key),o)}}e.exports=function(e,t,n){return t&&o(e.prototype,t),n&&o(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){function n(t){return e.exports=n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,n(t)}e.exports=n,e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(3).default,o=n(16);e.exports=function(e){var t=o(e,"string");return"symbol"==r(t)?t:String(t)},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(5);e.exports=function(e,t,n){return(t=r(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r,o,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,o=[t,n(8),n(10),n(15),n(1),n(2),n(17),n(22),n(29)],void 0===(i="function"==typeof(r=function(e,t,r,o,i,a,u,s,c){"use strict";var l=n(0);Object.defineProperty(e,"__esModule",{value:!0}),e.default=void 0,t=l(t),r=l(r),o=l(o),i=l(i),a=l(a),u=l(u),s=l(s),c=l(c);var f=function(){function e(){(0,i.default)(this,e)}var n,l;return(0,a.default)(e,[{key:"getSymbols",value:(l=(0,o.default)(t.default.mark((function e(n){var r,o,i,a,l,f,d;return t.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if("undefined"!=typeof window){e.next=2;break}return e.abrupt("return",{});case 2:return e.prev=2,e.next=5,s.default.getMeta("symbolHuobiProList");case 5:if(e.t0=e.sent,e.t0){e.next=8;break}e.t0={};case 8:if(r=e.t0,n||!r.data){e.next=13;break}return e.abrupt("return",this.handleSymbols(r.data));case 13:return e.next=15,u.default.getSymbolsList();case 15:if(o=e.sent,"ok"!==(o=(0,c.default)(o,{k:"symbols"})).status&&!o.success){e.next=27;break}return e.next=20,u.default.getSuperMarginSymbol();case 20:return i=e.sent,a=i.status,l=i.data,"ok"===a&&(f=l||[]).length&&(d=f.reduce((function(e,t){var n=t.symbol,r=t["loan-multiple"];return e[n]=r,e}),{}),o.data.forEach((function(e){var t=d[e.symbol_code];e.super_margin_leverage_ratio=t||null}))),e.abrupt("return",this.handleSymbols(o.data));case 27:if(!r.data){e.next=29;break}return e.abrupt("return",this.handleSymbols(r.data));case 29:e.next=34;break;case 31:e.prev=31,e.t1=e.catch(2),console.log("error :>> ",e.t1);case 34:case"end":return e.stop()}}),e,this,[[2,31]])}))),function(e){return l.apply(this,arguments)})},{key:"handleSymbols",value:function(e){var t=e;t.sort((function(e,t){return 1*t.weight-1*e.weight}));try{localStorage.removeItem("symbolHuobiProList"),s.default.putMeta("symbolHuobiProList",t).then((function(e){console.log("data :>> ",e)}))}catch(e){console.log("error :>> ",e)}var n=[].concat(t),o=new Set,i=new Set,a=!1,u=!1,c=!1,l=t.reduce((function(e,t){return e[t.symbol_code]=t,(t.white_enabled||"offline"!==t.state)&&((t.tags||"").includes("alts")&&!(t.tags||"").includes("hidden")?a=!0:(t.tags||"").includes("fiat")&&!(t.tags||"").includes("hidden")?u=!0:!(t.tags||"").includes("Crypto")&&!(t.tags||"").includes("crypto")||(t.tags||"").includes("hidden")?o.add(t.quote_currency):c=!0,i.add(t.quote_currency)),e}),{});return a&&o.add("alts"),u&&o.add("fiat"),c&&o.add("crypto"),{originSymbolsList:n,symbolsObj:l,quoteList:(0,r.default)(o),allQuoteList:(0,r.default)(i)}}},{key:"getCurrencys",value:(n=(0,o.default)(t.default.mark((function e(n){var r,o;return t.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if("undefined"!=typeof window){e.next=2;break}return e.abrupt("return",{});case 2:return e.next=4,s.default.getMeta("currencyHuobiProList");case 4:if(e.t0=e.sent,e.t0){e.next=7;break}e.t0={};case 7:if(r=e.t0,n||!r.data){e.next=12;break}return e.abrupt("return",this.handleCurrencys(r.data));case 12:return e.next=14,u.default.getCurrenciesList();case 14:if(o=e.sent,"ok"!==(o=(0,c.default)(o,{k:"currencies"})).status&&!o.success){e.next=18;break}return e.abrupt("return",this.handleCurrencys(o.data));case 18:return e.abrupt("return",{});case 19:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"handleCurrencys",value:function(e){var t=JSON.parse(JSON.stringify(e));t.sort((function(e,t){return 1*t.weight-1*e.weight}));try{localStorage.removeItem("currencyHuobiProList"),s.default.putMeta("currencyHuobiProList",t).then((function(e){console.log("data :>> ",e)}))}catch(e){console.log("error :>> ",e)}return{originCurrencysList:t,currencysObj:e.reduce((function(e,t){return e[t.currency_code]=t,e}),{})}}}]),e}();e.default=new f})?r.apply(t,o):r)||(e.exports=i)},function(e,t,n){var r=n(9)();e.exports=r;try{regeneratorRuntime=r}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=r:Function("r","regeneratorRuntime = r")(r)}},function(e,t,n){var r=n(3).default;function o(){"use strict";
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */e.exports=o=function(){return n},e.exports.__esModule=!0,e.exports.default=e.exports;var t,n={},i=Object.prototype,a=i.hasOwnProperty,u=Object.defineProperty||function(e,t,n){e[t]=n.value},s="function"==typeof Symbol?Symbol:{},c=s.iterator||"@@iterator",l=s.asyncIterator||"@@asyncIterator",f=s.toStringTag||"@@toStringTag";function d(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{d({},"")}catch(t){d=function(e,t,n){return e[t]=n}}function h(e,t,n,r){var o=t&&t.prototype instanceof b?t:b,i=Object.create(o.prototype),a=new T(r||[]);return u(i,"_invoke",{value:S(e,n,a)}),i}function p(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}n.wrap=h;var y="suspendedStart",v="executing",m="completed",g={};function b(){}function _(){}function w(){}var x={};d(x,c,(function(){return this}));var k=Object.getPrototypeOf,O=k&&k(k(M([])));O&&O!==i&&a.call(O,c)&&(x=O);var P=w.prototype=b.prototype=Object.create(x);function j(e){["next","throw","return"].forEach((function(t){d(e,t,(function(e){return this._invoke(t,e)}))}))}function E(e,t){function n(o,i,u,s){var c=p(e[o],e,i);if("throw"!==c.type){var l=c.arg,f=l.value;return f&&"object"==r(f)&&a.call(f,"__await")?t.resolve(f.__await).then((function(e){n("next",e,u,s)}),(function(e){n("throw",e,u,s)})):t.resolve(f).then((function(e){l.value=e,u(l)}),(function(e){return n("throw",e,u,s)}))}s(c.arg)}var o;u(this,"_invoke",{value:function(e,r){function i(){return new t((function(t,o){n(e,r,t,o)}))}return o=o?o.then(i,i):i()}})}function S(e,n,r){var o=y;return function(i,a){if(o===v)throw new Error("Generator is already running");if(o===m){if("throw"===i)throw a;return{value:t,done:!0}}for(r.method=i,r.arg=a;;){var u=r.delegate;if(u){var s=C(u,r);if(s){if(s===g)continue;return s}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(o===y)throw o=m,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);o=v;var c=p(e,n,r);if("normal"===c.type){if(o=r.done?m:"suspendedYield",c.arg===g)continue;return{value:c.arg,done:r.done}}"throw"===c.type&&(o=m,r.method="throw",r.arg=c.arg)}}}function C(e,n){var r=n.method,o=e.iterator[r];if(o===t)return n.delegate=null,"throw"===r&&e.iterator.return&&(n.method="return",n.arg=t,C(e,n),"throw"===n.method)||"return"!==r&&(n.method="throw",n.arg=new TypeError("The iterator does not provide a '"+r+"' method")),g;var i=p(o,e.iterator,n.arg);if("throw"===i.type)return n.method="throw",n.arg=i.arg,n.delegate=null,g;var a=i.arg;return a?a.done?(n[e.resultName]=a.value,n.next=e.nextLoc,"return"!==n.method&&(n.method="next",n.arg=t),n.delegate=null,g):a:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,g)}function K(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function A(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function T(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(K,this),this.reset(!0)}function M(e){if(e||""===e){var n=e[c];if(n)return n.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var o=-1,i=function n(){for(;++o<e.length;)if(a.call(e,o))return n.value=e[o],n.done=!1,n;return n.value=t,n.done=!0,n};return i.next=i}}throw new TypeError(r(e)+" is not iterable")}return _.prototype=w,u(P,"constructor",{value:w,configurable:!0}),u(w,"constructor",{value:_,configurable:!0}),_.displayName=d(w,f,"GeneratorFunction"),n.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===_||"GeneratorFunction"===(t.displayName||t.name))},n.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,w):(e.__proto__=w,d(e,f,"GeneratorFunction")),e.prototype=Object.create(P),e},n.awrap=function(e){return{__await:e}},j(E.prototype),d(E.prototype,l,(function(){return this})),n.AsyncIterator=E,n.async=function(e,t,r,o,i){void 0===i&&(i=Promise);var a=new E(h(e,t,r,o),i);return n.isGeneratorFunction(t)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},j(P),d(P,f,"Generator"),d(P,c,(function(){return this})),d(P,"toString",(function(){return"[object Generator]"})),n.keys=function(e){var t=Object(e),n=[];for(var r in t)n.push(r);return n.reverse(),function e(){for(;n.length;){var r=n.pop();if(r in t)return e.value=r,e.done=!1,e}return e.done=!0,e}},n.values=M,T.prototype={constructor:T,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=t,this.done=!1,this.delegate=null,this.method="next",this.arg=t,this.tryEntries.forEach(A),!e)for(var n in this)"t"===n.charAt(0)&&a.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=t)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var n=this;function r(r,o){return u.type="throw",u.arg=e,n.next=r,o&&(n.method="next",n.arg=t),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],u=i.completion;if("root"===i.tryLoc)return r("end");if(i.tryLoc<=this.prev){var s=a.call(i,"catchLoc"),c=a.call(i,"finallyLoc");if(s&&c){if(this.prev<i.catchLoc)return r(i.catchLoc,!0);if(this.prev<i.finallyLoc)return r(i.finallyLoc)}else if(s){if(this.prev<i.catchLoc)return r(i.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return r(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&a.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,g):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),g},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),A(n),g}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;A(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,n,r){return this.delegate={iterator:M(e),resultName:n,nextLoc:r},"next"===this.method&&(this.arg=t),g}},n}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(11),o=n(12),i=n(13),a=n(14);e.exports=function(e){return r(e)||o(e)||i(e)||a()},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(4);e.exports=function(e){if(Array.isArray(e))return r(e)},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){e.exports=function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(4);e.exports=function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){function n(e,t,n,r,o,i,a){try{var u=e[i](a),s=u.value}catch(e){return void n(e)}u.done?t(s):Promise.resolve(s).then(r,o)}e.exports=function(e){return function(){var t=this,r=arguments;return new Promise((function(o,i){var a=e.apply(t,r);function u(e){n(a,o,i,u,s,"next",e)}function s(e){n(a,o,i,u,s,"throw",e)}u(void 0)}))}},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(3).default;e.exports=function(e,t){if("object"!=r(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!=r(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r,o,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,o=[t,n(1),n(2),n(18)],void 0===(i="function"==typeof(r=function(e,t,r,o){"use strict";var i=n(0);Object.defineProperty(e,"__esModule",{value:!0}),e.default=void 0,t=i(t),r=i(r),o=i(o);var a=function(){function e(){(0,t.default)(this,e)}return(0,r.default)(e,[{key:"getSymbolsList",value:function(){return o.default.proHttpReq().get("/v2/settings/common/symbols")}},{key:"getSuperMarginSymbol",value:function(){return o.default.proHttpReq().get("/v1/hbg/super-margin/symbols")}},{key:"getCurrenciesList",value:function(){var e="zh-CN";return"undefined"!=typeof window&&localStorage.lang&&(e=(e=localStorage.lang.split("-"))[0]+"-"+(e[1]||e[0]).toUpperCase()),o.default.proHttpReq().get("/v2/settings/common/currencies",{language:e})}}]),e}();e.default=new a})?r.apply(t,o):r)||(e.exports=i)},function(e,t,n){var r,o,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,o=[t,n(1),n(2),n(19),n(20)],void 0===(i="function"==typeof(r=function(e,t,r,o,i){"use strict";var a=n(0);Object.defineProperty(e,"__esModule",{value:!0}),e.default=void 0,t=a(t),r=a(r),o=a(o);var u=new((i=a(i)).default);function s(e){if("undefined"!=typeof window){var t=window.location.origin;e=t.includes("futures")?"".concat(t.replace("www.","futures.")).concat(e):"".concat(t).concat(e)}return e}var c=function(){function e(){(0,t.default)(this,e)}return(0,r.default)(e,[{key:"getGefaultConfig",value:function(e){var t;return{pro:{baseURL:s("/-/x/pro"),headers:{"HB-API-VERSION":"1.7","Accept-Language":(t=(o.default.get("lang")||"en-us").toLowerCase(),("zh-tc"===t?"zh-hk":t).replace(/\-\w{2}/,(function(e){return e.toUpperCase()})))}}}[e]}},{key:"proHttpReq",value:function(){return u.mergeConfig(this.getGefaultConfig("pro")),u}}]),e}();e.default=new c})?r.apply(t,o):r)||(e.exports=i)},function(t,n){t.exports=e},function(e,t,n){var r,o,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,o=[t,n(6),n(1),n(2),n(21)],void 0===(i="function"==typeof(r=function(e,t,r,o,i){"use strict";var a=n(0);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function s(e){for(var n=1;n<arguments.length;n++){var r=null!=arguments[n]?arguments[n]:{};n%2?u(Object(r),!0).forEach((function(n){(0,t.default)(e,n,r[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):u(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}Object.defineProperty(e,"__esModule",{value:!0}),e.default=void 0,t=a(t),r=a(r),o=a(o),i=a(i);var c=function(){function e(){return(0,r.default)(this,e),e.singletonInstance||(this._instance=null,this._defaultConfig={baseURL:"",timeout:3e4,"Content-Type":"application/json;charset=UTF-8",withCredentials:!0},e.singletonInstance=this,this.initRequest()),e.singletonInstance}return(0,o.default)(e,[{key:"mergeConfig",value:function(e){this._instance.defaults.baseURL=e.baseURL||"",e.headers&&Object.keys(e.headers).length&&(this._instance.defaults.headers=e.headers)}},{key:"initRequest",value:function(){this._instance=i.default.create(this._defaultConfig),this._instance.interceptors.request.use((function(e){return e}),(function(e){return Promise.resolve(e)})),this._instance.interceptors.response.use((function(e){return e}),(function(e){return Promise.reject(e)}))}},{key:"get",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};try{return new Promise((function(o,i){t._instance.get(e,s({params:n},r)).then((function(e){o(e.data)}),(function(e){i(e)}))}))}catch(e){console.error(e)}}},{key:"post",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};try{return new Promise((function(o,i){t._instance.post(e,n,r).then((function(e){o(e.data)}),(function(e){i(e)}))}))}catch(e){console.error(e)}}},{key:"put",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};try{return new Promise((function(o,i){t._instance.put(e,n,r).then((function(e){o(e.data)}),(function(e){i(e)}))}))}catch(e){console.error(e)}}},{key:"del",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};try{return new Promise((function(o,i){t._instance.delete(e,{params:n},r).then((function(e){o(e.data)}),(function(e){i(e)}))}))}catch(e){console.error(e)}}}]),e}();e.default=c})?r.apply(t,o):r)||(e.exports=i)},function(e,n){e.exports=t},function(e,t,n){var r,o,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,o=[t,n(1),n(2),n(23),n(25),n(26),n(28)],void 0===(i="function"==typeof(r=function(e,t,r,o,i,a,u){"use strict";var s=n(0);function c(e,t,n){return t=(0,i.default)(t),(0,o.default)(e,function(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return!!e}()?Reflect.construct(t,n||[],(0,i.default)(e).constructor):t.apply(e,n))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=void 0,t=s(t),r=s(r),o=s(o),i=s(i),a=s(a);var l=function(e){function n(){var e;return(0,t.default)(this,n),(e=c(this,n,["Symbol_HBDB"])).version(1).stores({symbol_meta:"&name,data"}),e.symbolMeta=e.table("symbol_meta"),e}return(0,a.default)(n,e),(0,r.default)(n,[{key:"putMeta",value:function(e,t){return this.symbolMeta.put({name:e,data:t})}},{key:"getMeta",value:function(e){return this.symbolMeta.get(e)}},{key:"deleteMeta",value:function(e){return this.symbolMeta.delete(e)}},{key:"clear",value:function(){return this.symbolMeta.clear()}}]),n}((u=s(u)).default);e.default=new l})?r.apply(t,o):r)||(e.exports=i)},function(e,t,n){var r=n(3).default,o=n(24);e.exports=function(e,t){if(t&&("object"===r(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return o(e)},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){function n(t){return e.exports=n=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},e.exports.__esModule=!0,e.exports.default=e.exports,n(t)}e.exports=n,e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r=n(27);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&r(e,t)},e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t){function n(t,r){return e.exports=n=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},e.exports.__esModule=!0,e.exports.default=e.exports,n(t,r)}e.exports=n,e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){"use strict";n.r(t),n.d(t,"Dexie",(function(){return Yn})),n.d(t,"RangeSet",(function(){return Fn})),n.d(t,"default",(function(){return Yn})),n.d(t,"liveQuery",(function(){return $n})),n.d(t,"mergeRanges",(function(){return Ln})),n.d(t,"rangesOverlap",(function(){return Un}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var r=function(){return(r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function o(e,t,n){if(n||2===arguments.length)for(var r,o=0,i=t.length;o<i;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))}var i="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:"undefined"!=typeof window?window:global,a=Object.keys,u=Array.isArray;function s(e,t){return"object"!=typeof t||a(t).forEach((function(n){e[n]=t[n]})),e}"undefined"==typeof Promise||i.Promise||(i.Promise=Promise);var c=Object.getPrototypeOf,l={}.hasOwnProperty;function f(e,t){return l.call(e,t)}function d(e,t){"function"==typeof t&&(t=t(c(e))),("undefined"==typeof Reflect?a:Reflect.ownKeys)(t).forEach((function(n){p(e,n,t[n])}))}var h=Object.defineProperty;function p(e,t,n,r){h(e,t,s(n&&f(n,"get")&&"function"==typeof n.get?{get:n.get,set:n.set,configurable:!0}:{value:n,configurable:!0,writable:!0},r))}function y(e){return{from:function(t){return e.prototype=Object.create(t.prototype),p(e.prototype,"constructor",e),{extend:d.bind(null,e.prototype)}}}}var v=Object.getOwnPropertyDescriptor;function m(e,t){var n;return v(e,t)||(n=c(e))&&m(n,t)}var g=[].slice;function b(e,t,n){return g.call(e,t,n)}function _(e,t){return t(e)}function w(e){if(!e)throw new Error("Assertion Failed")}function x(e){i.setImmediate?setImmediate(e):setTimeout(e,0)}function k(e,t){return e.reduce((function(e,n,r){var o=t(n,r);return o&&(e[o[0]]=o[1]),e}),{})}function O(e,t){if("string"==typeof t&&f(e,t))return e[t];if(!t)return e;if("string"!=typeof t){for(var n=[],r=0,o=t.length;r<o;++r){var i=O(e,t[r]);n.push(i)}return n}var a=t.indexOf(".");if(-1!==a){var u=e[t.substr(0,a)];return void 0===u?void 0:O(u,t.substr(a+1))}}function P(e,t,n){if(e&&void 0!==t&&(!("isFrozen"in Object)||!Object.isFrozen(e)))if("string"!=typeof t&&"length"in t){w("string"!=typeof n&&"length"in n);for(var r=0,o=t.length;r<o;++r)P(e,t[r],n[r])}else{var i=t.indexOf(".");if(-1!==i){var a=t.substr(0,i),s=t.substr(i+1);if(""===s)void 0===n?u(e)&&!isNaN(parseInt(a))?e.splice(a,1):delete e[a]:e[a]=n;else{var c=e[a];c&&f(e,a)||(c=e[a]={}),P(c,s,n)}}else void 0===n?u(e)&&!isNaN(parseInt(t))?e.splice(t,1):delete e[t]:e[t]=n}}function j(e){var t={};for(var n in e)f(e,n)&&(t[n]=e[n]);return t}var E=[].concat;function S(e){return E.apply([],e)}var C="BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(S([8,16,32,64].map((function(e){return["Int","Uint","Float"].map((function(t){return t+e+"Array"}))})))).filter((function(e){return i[e]})),K=C.map((function(e){return i[e]}));k(C,(function(e){return[e,!0]}));var A=null;function T(e){A="undefined"!=typeof WeakMap&&new WeakMap;var t=function e(t){if(!t||"object"!=typeof t)return t;var n=A&&A.get(t);if(n)return n;if(u(t)){n=[],A&&A.set(t,n);for(var r=0,o=t.length;r<o;++r)n.push(e(t[r]))}else if(K.indexOf(t.constructor)>=0)n=t;else{var i=c(t);for(var a in n=i===Object.prototype?{}:Object.create(i),A&&A.set(t,n),t)f(t,a)&&(n[a]=e(t[a]))}return n}(e);return A=null,t}var M={}.toString;function D(e){return M.call(e).slice(8,-1)}var I="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator",R="symbol"==typeof I?function(e){var t;return null!=e&&(t=e[I])&&t.apply(e)}:function(){return null},B={};function q(e){var t,n,r,o;if(1===arguments.length){if(u(e))return e.slice();if(this===B&&"string"==typeof e)return[e];if(o=R(e)){for(n=[];!(r=o.next()).done;)n.push(r.value);return n}if(null==e)return[e];if("number"==typeof(t=e.length)){for(n=new Array(t);t--;)n[t]=e[t];return n}return[e]}for(t=arguments.length,n=new Array(t);t--;)n[t]=arguments[t];return n}var F="undefined"!=typeof Symbol?function(e){return"AsyncFunction"===e[Symbol.toStringTag]}:function(){return!1},N="undefined"!=typeof location&&/^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);function L(e,t){N=e,U=t}var U=function(){return!0},H=!new Error("").stack;function V(){if(H)try{throw V.arguments,new Error}catch(e){return e}return new Error}function G(e,t){var n=e.stack;return n?(t=t||0,0===n.indexOf(e.name)&&(t+=(e.name+e.message).split("\n").length),n.split("\n").slice(t).filter(U).map((function(e){return"\n"+e})).join("")):""}var z=["Unknown","Constraint","Data","TransactionInactive","ReadOnly","Version","NotFound","InvalidState","InvalidAccess","Abort","Timeout","QuotaExceeded","Syntax","DataClone"],W=["Modify","Bulk","OpenFailed","VersionChange","Schema","Upgrade","InvalidTable","MissingAPI","NoSuchDatabase","InvalidArgument","SubTransaction","Unsupported","Internal","DatabaseClosed","PrematureCommit","ForeignAwait"].concat(z),Y={VersionChanged:"Database version changed by other database connection",DatabaseClosed:"Database has been closed",Abort:"Transaction aborted",TransactionInactive:"Transaction has already completed or failed",MissingAPI:"IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"};function Q(e,t){this._e=V(),this.name=e,this.message=t}function X(e,t){return e+". Errors: "+Object.keys(t).map((function(e){return t[e].toString()})).filter((function(e,t,n){return n.indexOf(e)===t})).join("\n")}function J(e,t,n,r){this._e=V(),this.failures=t,this.failedKeys=r,this.successCount=n,this.message=X(e,t)}function $(e,t){this._e=V(),this.name="BulkError",this.failures=Object.keys(t).map((function(e){return t[e]})),this.failuresByPos=t,this.message=X(e,t)}y(Q).from(Error).extend({stack:{get:function(){return this._stack||(this._stack=this.name+": "+this.message+G(this._e,2))}},toString:function(){return this.name+": "+this.message}}),y(J).from(Q),y($).from(Q);var Z=W.reduce((function(e,t){return e[t]=t+"Error",e}),{}),ee=Q,te=W.reduce((function(e,t){var n=t+"Error";function r(e,r){this._e=V(),this.name=n,e?"string"==typeof e?(this.message=e+(r?"\n "+r:""),this.inner=r||null):"object"==typeof e&&(this.message=e.name+" "+e.message,this.inner=e):(this.message=Y[t]||n,this.inner=null)}return y(r).from(ee),e[t]=r,e}),{});te.Syntax=SyntaxError,te.Type=TypeError,te.Range=RangeError;var ne=z.reduce((function(e,t){return e[t+"Error"]=te[t],e}),{});var re=W.reduce((function(e,t){return-1===["Syntax","Type","Range"].indexOf(t)&&(e[t+"Error"]=te[t]),e}),{});function oe(){}function ie(e){return e}function ae(e,t){return null==e||e===ie?t:function(n){return t(e(n))}}function ue(e,t){return function(){e.apply(this,arguments),t.apply(this,arguments)}}function se(e,t){return e===oe?t:function(){var n=e.apply(this,arguments);void 0!==n&&(arguments[0]=n);var r=this.onsuccess,o=this.onerror;this.onsuccess=null,this.onerror=null;var i=t.apply(this,arguments);return r&&(this.onsuccess=this.onsuccess?ue(r,this.onsuccess):r),o&&(this.onerror=this.onerror?ue(o,this.onerror):o),void 0!==i?i:n}}function ce(e,t){return e===oe?t:function(){e.apply(this,arguments);var n=this.onsuccess,r=this.onerror;this.onsuccess=this.onerror=null,t.apply(this,arguments),n&&(this.onsuccess=this.onsuccess?ue(n,this.onsuccess):n),r&&(this.onerror=this.onerror?ue(r,this.onerror):r)}}function le(e,t){return e===oe?t:function(n){var r=e.apply(this,arguments);s(n,r);var o=this.onsuccess,i=this.onerror;this.onsuccess=null,this.onerror=null;var a=t.apply(this,arguments);return o&&(this.onsuccess=this.onsuccess?ue(o,this.onsuccess):o),i&&(this.onerror=this.onerror?ue(i,this.onerror):i),void 0===r?void 0===a?void 0:a:s(r,a)}}function fe(e,t){return e===oe?t:function(){return!1!==t.apply(this,arguments)&&e.apply(this,arguments)}}function de(e,t){return e===oe?t:function(){var n=e.apply(this,arguments);if(n&&"function"==typeof n.then){for(var r=this,o=arguments.length,i=new Array(o);o--;)i[o]=arguments[o];return n.then((function(){return t.apply(r,i)}))}return t.apply(this,arguments)}}re.ModifyError=J,re.DexieError=Q,re.BulkError=$;var he={},pe="undefined"==typeof Promise?[]:function(){var e=Promise.resolve();if("undefined"==typeof crypto||!crypto.subtle)return[e,c(e),e];var t=crypto.subtle.digest("SHA-512",new Uint8Array([0]));return[t,c(t),e]}(),ye=pe[0],ve=pe[1],me=pe[2],ge=ve&&ve.then,be=ye&&ye.constructor,_e=!!me,we=!1,xe=me?function(){me.then(Ve)}:i.setImmediate?setImmediate.bind(null,Ve):i.MutationObserver?function(){var e=document.createElement("div");new MutationObserver((function(){Ve(),e=null})).observe(e,{attributes:!0}),e.setAttribute("i","1")}:function(){setTimeout(Ve,0)},ke=function(e,t){Te.push([e,t]),Pe&&(xe(),Pe=!1)},Oe=!0,Pe=!0,je=[],Ee=[],Se=null,Ce=ie,Ke={id:"global",global:!0,ref:0,unhandleds:[],onunhandled:pt,pgp:!1,env:{},finalize:function(){this.unhandleds.forEach((function(e){try{pt(e[0],e[1])}catch(e){}}))}},Ae=Ke,Te=[],Me=0,De=[];function Ie(e){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");this._listeners=[],this.onuncatched=oe,this._lib=!1;var t=this._PSD=Ae;if(N&&(this._stackHolder=V(),this._prev=null,this._numPrev=0),"function"!=typeof e){if(e!==he)throw new TypeError("Not a function");return this._state=arguments[1],this._value=arguments[2],void(!1===this._state&&Fe(this,this._value))}this._state=null,this._value=null,++t.ref,qe(this,e)}var Re={get:function(){var e=Ae,t=et;function n(n,r){var o=this,i=!e.global&&(e!==Ae||t!==et),a=i&&!ot(),u=new Ie((function(t,u){Le(o,new Be(dt(n,e,i,a),dt(r,e,i,a),t,u,e))}));return N&&He(u,this),u}return n.prototype=he,n},set:function(e){p(this,"then",e&&e.prototype===he?Re:{get:function(){return e},set:Re.set})}};function Be(e,t,n,r,o){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.resolve=n,this.reject=r,this.psd=o}function qe(e,t){try{t((function(t){if(null===e._state){if(t===e)throw new TypeError("A promise cannot be resolved with itself.");var n=e._lib&&Ge();t&&"function"==typeof t.then?qe(e,(function(e,n){t instanceof Ie?t._then(e,n):t.then(e,n)})):(e._state=!0,e._value=t,Ne(e)),n&&ze()}}),Fe.bind(null,e))}catch(t){Fe(e,t)}}function Fe(e,t){if(Ee.push(t),null===e._state){var n=e._lib&&Ge();t=Ce(t),e._state=!1,e._value=t,N&&null!==t&&"object"==typeof t&&!t._promise&&function(e,t,n){try{e.apply(null,n)}catch(e){t&&t(e)}}((function(){var n=m(t,"stack");t._promise=e,p(t,"stack",{get:function(){return we?n&&(n.get?n.get.apply(t):n.value):e.stack}})})),function(e){je.some((function(t){return t._value===e._value}))||je.push(e)}(e),Ne(e),n&&ze()}}function Ne(e){var t=e._listeners;e._listeners=[];for(var n=0,r=t.length;n<r;++n)Le(e,t[n]);var o=e._PSD;--o.ref||o.finalize(),0===Me&&(++Me,ke((function(){0==--Me&&We()}),[]))}function Le(e,t){if(null!==e._state){var n=e._state?t.onFulfilled:t.onRejected;if(null===n)return(e._state?t.resolve:t.reject)(e._value);++t.psd.ref,++Me,ke(Ue,[n,e,t])}else e._listeners.push(t)}function Ue(e,t,n){try{Se=t;var r,o=t._value;t._state?r=e(o):(Ee.length&&(Ee=[]),r=e(o),-1===Ee.indexOf(o)&&function(e){var t=je.length;for(;t;)if(je[--t]._value===e._value)return void je.splice(t,1)}(t)),n.resolve(r)}catch(e){n.reject(e)}finally{Se=null,0==--Me&&We(),--n.psd.ref||n.psd.finalize()}}function He(e,t){var n=t?t._numPrev+1:0;n<100&&(e._prev=t,e._numPrev=n)}function Ve(){Ge()&&ze()}function Ge(){var e=Oe;return Oe=!1,Pe=!1,e}function ze(){var e,t,n;do{for(;Te.length>0;)for(e=Te,Te=[],n=e.length,t=0;t<n;++t){var r=e[t];r[0].apply(null,r[1])}}while(Te.length>0);Oe=!0,Pe=!0}function We(){var e=je;je=[],e.forEach((function(e){e._PSD.onunhandled.call(null,e._value,e)}));for(var t=De.slice(0),n=t.length;n;)t[--n]()}function Ye(e){return new Ie(he,!1,e)}function Qe(e,t){var n=Ae;return function(){var r=Ge(),o=Ae;try{return st(n,!0),e.apply(this,arguments)}catch(e){t&&t(e)}finally{st(o,!1),r&&ze()}}}d(Ie.prototype,{then:Re,_then:function(e,t){Le(this,new Be(null,null,e,t,Ae))},catch:function(e){if(1===arguments.length)return this.then(null,e);var t=arguments[0],n=arguments[1];return"function"==typeof t?this.then(null,(function(e){return e instanceof t?n(e):Ye(e)})):this.then(null,(function(e){return e&&e.name===t?n(e):Ye(e)}))},finally:function(e){return this.then((function(t){return e(),t}),(function(t){return e(),Ye(t)}))},stack:{get:function(){if(this._stack)return this._stack;try{we=!0;var e=function e(t,n,r){if(n.length===r)return n;var o="";if(!1===t._state){var i,a,u=t._value;null!=u?(i=u.name||"Error",a=u.message||u,o=G(u,0)):(i=u,a=""),n.push(i+(a?": "+a:"")+o)}N&&((o=G(t._stackHolder,2))&&-1===n.indexOf(o)&&n.push(o),t._prev&&e(t._prev,n,r));return n}(this,[],20).join("\nFrom previous: ");return null!==this._state&&(this._stack=e),e}finally{we=!1}}},timeout:function(e,t){var n=this;return e<1/0?new Ie((function(r,o){var i=setTimeout((function(){return o(new te.Timeout(t))}),e);n.then(r,o).finally(clearTimeout.bind(null,i))})):this}}),"undefined"!=typeof Symbol&&Symbol.toStringTag&&p(Ie.prototype,Symbol.toStringTag,"Dexie.Promise"),Ke.env=ct(),d(Ie,{all:function(){var e=q.apply(null,arguments).map(it);return new Ie((function(t,n){0===e.length&&t([]);var r=e.length;e.forEach((function(o,i){return Ie.resolve(o).then((function(n){e[i]=n,--r||t(e)}),n)}))}))},resolve:function(e){if(e instanceof Ie)return e;if(e&&"function"==typeof e.then)return new Ie((function(t,n){e.then(t,n)}));var t=new Ie(he,!0,e);return He(t,Se),t},reject:Ye,race:function(){var e=q.apply(null,arguments).map(it);return new Ie((function(t,n){e.map((function(e){return Ie.resolve(e).then(t,n)}))}))},PSD:{get:function(){return Ae},set:function(e){return Ae=e}},totalEchoes:{get:function(){return et}},newPSD:nt,usePSD:lt,scheduler:{get:function(){return ke},set:function(e){ke=e}},rejectionMapper:{get:function(){return Ce},set:function(e){Ce=e}},follow:function(e,t){return new Ie((function(n,r){return nt((function(t,n){var r=Ae;r.unhandleds=[],r.onunhandled=n,r.finalize=ue((function(){var e=this;!function(e){De.push((function t(){e(),De.splice(De.indexOf(t),1)})),++Me,ke((function(){0==--Me&&We()}),[])}((function(){0===e.unhandleds.length?t():n(e.unhandleds[0])}))}),r.finalize),e()}),t,n,r)}))}}),be&&(be.allSettled&&p(Ie,"allSettled",(function(){var e=q.apply(null,arguments).map(it);return new Ie((function(t){0===e.length&&t([]);var n=e.length,r=new Array(n);e.forEach((function(e,o){return Ie.resolve(e).then((function(e){return r[o]={status:"fulfilled",value:e}}),(function(e){return r[o]={status:"rejected",reason:e}})).then((function(){return--n||t(r)}))}))}))})),be.any&&"undefined"!=typeof AggregateError&&p(Ie,"any",(function(){var e=q.apply(null,arguments).map(it);return new Ie((function(t,n){0===e.length&&n(new AggregateError([]));var r=e.length,o=new Array(r);e.forEach((function(e,i){return Ie.resolve(e).then((function(e){return t(e)}),(function(e){o[i]=e,--r||n(new AggregateError(o))}))}))}))})));var Xe={awaits:0,echoes:0,id:0},Je=0,$e=[],Ze=0,et=0,tt=0;function nt(e,t,n,r){var o=Ae,i=Object.create(o);i.parent=o,i.ref=0,i.global=!1,i.id=++tt;var a=Ke.env;i.env=_e?{Promise:Ie,PromiseProp:{value:Ie,configurable:!0,writable:!0},all:Ie.all,race:Ie.race,allSettled:Ie.allSettled,any:Ie.any,resolve:Ie.resolve,reject:Ie.reject,nthen:ht(a.nthen,i),gthen:ht(a.gthen,i)}:{},t&&s(i,t),++o.ref,i.finalize=function(){--this.parent.ref||this.parent.finalize()};var u=lt(i,e,n,r);return 0===i.ref&&i.finalize(),u}function rt(){return Xe.id||(Xe.id=++Je),++Xe.awaits,Xe.echoes+=100,Xe.id}function ot(){return!!Xe.awaits&&(0==--Xe.awaits&&(Xe.id=0),Xe.echoes=100*Xe.awaits,!0)}function it(e){return Xe.echoes&&e&&e.constructor===be?(rt(),e.then((function(e){return ot(),e}),(function(e){return ot(),yt(e)}))):e}function at(e){++et,Xe.echoes&&0!=--Xe.echoes||(Xe.echoes=Xe.id=0),$e.push(Ae),st(e,!0)}function ut(){var e=$e[$e.length-1];$e.pop(),st(e,!1)}function st(e,t){var n=Ae;if((t?!Xe.echoes||Ze++&&e===Ae:!Ze||--Ze&&e===Ae)||ft(t?at.bind(null,e):ut),e!==Ae&&(Ae=e,n===Ke&&(Ke.env=ct()),_e)){var r=Ke.env.Promise,o=e.env;ve.then=o.nthen,r.prototype.then=o.gthen,(n.global||e.global)&&(Object.defineProperty(i,"Promise",o.PromiseProp),r.all=o.all,r.race=o.race,r.resolve=o.resolve,r.reject=o.reject,o.allSettled&&(r.allSettled=o.allSettled),o.any&&(r.any=o.any))}}function ct(){var e=i.Promise;return _e?{Promise:e,PromiseProp:Object.getOwnPropertyDescriptor(i,"Promise"),all:e.all,race:e.race,allSettled:e.allSettled,any:e.any,resolve:e.resolve,reject:e.reject,nthen:ve.then,gthen:e.prototype.then}:{}}function lt(e,t,n,r,o){var i=Ae;try{return st(e,!0),t(n,r,o)}finally{st(i,!1)}}function ft(e){ge.call(ye,e)}function dt(e,t,n,r){return"function"!=typeof e?e:function(){var o=Ae;n&&rt(),st(t,!0);try{return e.apply(this,arguments)}finally{st(o,!1),r&&ft(ot)}}}function ht(e,t){return function(n,r){return e.call(this,dt(n,t),dt(r,t))}}-1===(""+ge).indexOf("[native code]")&&(rt=ot=oe);function pt(e,t){var n;try{n=t.onuncatched(e)}catch(e){}if(!1!==n)try{var r,o={promise:t,reason:e};if(i.document&&document.createEvent?((r=document.createEvent("Event")).initEvent("unhandledrejection",!0,!0),s(r,o)):i.CustomEvent&&s(r=new CustomEvent("unhandledrejection",{detail:o}),o),r&&i.dispatchEvent&&(dispatchEvent(r),!i.PromiseRejectionEvent&&i.onunhandledrejection))try{i.onunhandledrejection(r)}catch(e){}N&&r&&!r.defaultPrevented&&console.warn("Unhandled rejection: "+(e.stack||e))}catch(e){}}var yt=Ie.reject;var vt=String.fromCharCode(65535),mt="Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.",gt=[],bt="undefined"!=typeof navigator&&/(MSIE|Trident|Edge)/.test(navigator.userAgent),_t=bt,wt=bt,xt=function(e){return!/(dexie\.js|dexie\.min\.js)/.test(e)};function kt(e,t){return e?t?function(){return e.apply(this,arguments)&&t.apply(this,arguments)}:e:t}var Ot={type:3,lower:-1/0,lowerOpen:!1,upper:[[]],upperOpen:!1};function Pt(e){return"string"!=typeof e||/\./.test(e)?function(e){return e}:function(t){return void 0===t[e]&&e in t&&delete(t=T(t))[e],t}}var jt=function(){function e(){}return e.prototype._trans=function(e,t,n){var r=this._tx||Ae.trans,o=this.name;function i(e,n,r){if(!r.schema[o])throw new te.NotFound("Table "+o+" not part of transaction");return t(r.idbtrans,r)}var a=Ge();try{return r&&r.db===this.db?r===Ae.trans?r._promise(e,i,n):nt((function(){return r._promise(e,i,n)}),{trans:r,transless:Ae.transless||Ae}):function e(t,n,r,o){if(t.idbdb&&(t._state.openComplete||Ae.letThrough||t._vip)){var i=t._createTransaction(n,r,t._dbSchema);try{i.create(),t._state.PR1398_maxLoop=3}catch(i){return i.name===Z.InvalidState&&t.isOpen()&&--t._state.PR1398_maxLoop>0?(console.warn("Dexie: Need to reopen db"),t._close(),t.open().then((function(){return e(t,n,r,o)}))):yt(i)}return i._promise(n,(function(e,t){return nt((function(){return Ae.trans=i,o(e,t,i)}))})).then((function(e){return i._completion.then((function(){return e}))}))}if(t._state.openComplete)return yt(new te.DatabaseClosed(t._state.dbOpenError));if(!t._state.isBeingOpened){if(!t._options.autoOpen)return yt(new te.DatabaseClosed);t.open().catch(oe)}return t._state.dbReadyPromise.then((function(){return e(t,n,r,o)}))}(this.db,e,[this.name],i)}finally{a&&ze()}},e.prototype.get=function(e,t){var n=this;return e&&e.constructor===Object?this.where(e).first(t):this._trans("readonly",(function(t){return n.core.get({trans:t,key:e}).then((function(e){return n.hook.reading.fire(e)}))})).then(t)},e.prototype.where=function(e){if("string"==typeof e)return new this.db.WhereClause(this,e);if(u(e))return new this.db.WhereClause(this,"["+e.join("+")+"]");var t=a(e);if(1===t.length)return this.where(t[0]).equals(e[t[0]]);var n=this.schema.indexes.concat(this.schema.primKey).filter((function(e){if(e.compound&&t.every((function(t){return e.keyPath.indexOf(t)>=0}))){for(var n=0;n<t.length;++n)if(-1===t.indexOf(e.keyPath[n]))return!1;return!0}return!1})).sort((function(e,t){return e.keyPath.length-t.keyPath.length}))[0];if(n&&this.db._maxKey!==vt){var r=n.keyPath.slice(0,t.length);return this.where(r).equals(r.map((function(t){return e[t]})))}!n&&N&&console.warn("The query "+JSON.stringify(e)+" on "+this.name+" would benefit of a compound index ["+t.join("+")+"]");var o=this.schema.idxByName,i=this.db._deps.indexedDB;function s(e,t){try{return 0===i.cmp(e,t)}catch(e){return!1}}var c=t.reduce((function(t,n){var r=t[0],i=t[1],a=o[n],c=e[n];return[r||a,r||!a?kt(i,a&&a.multi?function(e){var t=O(e,n);return u(t)&&t.some((function(e){return s(c,e)}))}:function(e){return s(c,O(e,n))}):i]}),[null,null]),l=c[0],f=c[1];return l?this.where(l.name).equals(e[l.keyPath]).filter(f):n?this.filter(f):this.where(t).equals("")},e.prototype.filter=function(e){return this.toCollection().and(e)},e.prototype.count=function(e){return this.toCollection().count(e)},e.prototype.offset=function(e){return this.toCollection().offset(e)},e.prototype.limit=function(e){return this.toCollection().limit(e)},e.prototype.each=function(e){return this.toCollection().each(e)},e.prototype.toArray=function(e){return this.toCollection().toArray(e)},e.prototype.toCollection=function(){return new this.db.Collection(new this.db.WhereClause(this))},e.prototype.orderBy=function(e){return new this.db.Collection(new this.db.WhereClause(this,u(e)?"["+e.join("+")+"]":e))},e.prototype.reverse=function(){return this.toCollection().reverse()},e.prototype.mapToClass=function(e){this.schema.mappedClass=e;var t=function(t){if(!t)return t;var n=Object.create(e.prototype);for(var r in t)if(f(t,r))try{n[r]=t[r]}catch(e){}return n};return this.schema.readHook&&this.hook.reading.unsubscribe(this.schema.readHook),this.schema.readHook=t,this.hook("reading",t),e},e.prototype.defineClass=function(){return this.mapToClass((function(e){s(this,e)}))},e.prototype.add=function(e,t){var n=this,r=this.schema.primKey,o=r.auto,i=r.keyPath,a=e;return i&&o&&(a=Pt(i)(e)),this._trans("readwrite",(function(e){return n.core.mutate({trans:e,type:"add",keys:null!=t?[t]:null,values:[a]})})).then((function(e){return e.numFailures?Ie.reject(e.failures[0]):e.lastResult})).then((function(t){if(i)try{P(e,i,t)}catch(e){}return t}))},e.prototype.update=function(e,t){if("object"!=typeof e||u(e))return this.where(":id").equals(e).modify(t);var n=O(e,this.schema.primKey.keyPath);if(void 0===n)return yt(new te.InvalidArgument("Given object does not contain its primary key"));try{"function"!=typeof t?a(t).forEach((function(n){P(e,n,t[n])})):t(e,{value:e,primKey:n})}catch(e){}return this.where(":id").equals(n).modify(t)},e.prototype.put=function(e,t){var n=this,r=this.schema.primKey,o=r.auto,i=r.keyPath,a=e;return i&&o&&(a=Pt(i)(e)),this._trans("readwrite",(function(e){return n.core.mutate({trans:e,type:"put",values:[a],keys:null!=t?[t]:null})})).then((function(e){return e.numFailures?Ie.reject(e.failures[0]):e.lastResult})).then((function(t){if(i)try{P(e,i,t)}catch(e){}return t}))},e.prototype.delete=function(e){var t=this;return this._trans("readwrite",(function(n){return t.core.mutate({trans:n,type:"delete",keys:[e]})})).then((function(e){return e.numFailures?Ie.reject(e.failures[0]):void 0}))},e.prototype.clear=function(){var e=this;return this._trans("readwrite",(function(t){return e.core.mutate({trans:t,type:"deleteRange",range:Ot})})).then((function(e){return e.numFailures?Ie.reject(e.failures[0]):void 0}))},e.prototype.bulkGet=function(e){var t=this;return this._trans("readonly",(function(n){return t.core.getMany({keys:e,trans:n}).then((function(e){return e.map((function(e){return t.hook.reading.fire(e)}))}))}))},e.prototype.bulkAdd=function(e,t,n){var r=this,o=Array.isArray(t)?t:void 0,i=(n=n||(o?void 0:t))?n.allKeys:void 0;return this._trans("readwrite",(function(t){var n=r.schema.primKey,a=n.auto,u=n.keyPath;if(u&&o)throw new te.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");if(o&&o.length!==e.length)throw new te.InvalidArgument("Arguments objects and keys must have the same length");var s=e.length,c=u&&a?e.map(Pt(u)):e;return r.core.mutate({trans:t,type:"add",keys:o,values:c,wantResults:i}).then((function(e){var t=e.numFailures,n=e.results,o=e.lastResult,a=e.failures;if(0===t)return i?n:o;throw new $(r.name+".bulkAdd(): "+t+" of "+s+" operations failed",a)}))}))},e.prototype.bulkPut=function(e,t,n){var r=this,o=Array.isArray(t)?t:void 0,i=(n=n||(o?void 0:t))?n.allKeys:void 0;return this._trans("readwrite",(function(t){var n=r.schema.primKey,a=n.auto,u=n.keyPath;if(u&&o)throw new te.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");if(o&&o.length!==e.length)throw new te.InvalidArgument("Arguments objects and keys must have the same length");var s=e.length,c=u&&a?e.map(Pt(u)):e;return r.core.mutate({trans:t,type:"put",keys:o,values:c,wantResults:i}).then((function(e){var t=e.numFailures,n=e.results,o=e.lastResult,a=e.failures;if(0===t)return i?n:o;throw new $(r.name+".bulkPut(): "+t+" of "+s+" operations failed",a)}))}))},e.prototype.bulkDelete=function(e){var t=this,n=e.length;return this._trans("readwrite",(function(n){return t.core.mutate({trans:n,type:"delete",keys:e})})).then((function(e){var r=e.numFailures,o=e.lastResult,i=e.failures;if(0===r)return o;throw new $(t.name+".bulkDelete(): "+r+" of "+n+" operations failed",i)}))},e}();function Et(e){var t={},n=function(n,r){if(r){for(var o=arguments.length,i=new Array(o-1);--o;)i[o-1]=arguments[o];return t[n].subscribe.apply(null,i),e}if("string"==typeof n)return t[n]};n.addEventType=i;for(var r=1,o=arguments.length;r<o;++r)i(arguments[r]);return n;function i(e,r,o){if("object"==typeof e)return s(e);r||(r=fe),o||(o=oe);var i={subscribers:[],fire:o,subscribe:function(e){-1===i.subscribers.indexOf(e)&&(i.subscribers.push(e),i.fire=r(i.fire,e))},unsubscribe:function(e){i.subscribers=i.subscribers.filter((function(t){return t!==e})),i.fire=i.subscribers.reduce(r,o)}};return t[e]=n[e]=i,i}function s(e){a(e).forEach((function(t){var n=e[t];if(u(n))i(t,e[t][0],e[t][1]);else{if("asap"!==n)throw new te.InvalidArgument("Invalid event config");var r=i(t,ie,(function(){for(var e=arguments.length,t=new Array(e);e--;)t[e]=arguments[e];r.subscribers.forEach((function(e){x((function(){e.apply(null,t)}))}))}))}}))}}function St(e,t){return y(t).from({prototype:e}),t}function Ct(e,t){return!(e.filter||e.algorithm||e.or)&&(t?e.justLimit:!e.replayFilter)}function Kt(e,t){e.filter=kt(e.filter,t)}function At(e,t,n){var r=e.replayFilter;e.replayFilter=r?function(){return kt(r(),t())}:t,e.justLimit=n&&!r}function Tt(e,t){if(e.isPrimKey)return t.primaryKey;var n=t.getIndexByKeyPath(e.index);if(!n)throw new te.Schema("KeyPath "+e.index+" on object store "+t.name+" is not indexed");return n}function Mt(e,t,n){var r=Tt(e,t.schema);return t.openCursor({trans:n,values:!e.keysOnly,reverse:"prev"===e.dir,unique:!!e.unique,query:{index:r,range:e.range}})}function Dt(e,t,n,r){var o=e.replayFilter?kt(e.filter,e.replayFilter()):e.filter;if(e.or){var i={},a=function(e,n,r){if(!o||o(n,r,(function(e){return n.stop(e)}),(function(e){return n.fail(e)}))){var a=n.primaryKey,u=""+a;"[object ArrayBuffer]"===u&&(u=""+new Uint8Array(a)),f(i,u)||(i[u]=!0,t(e,n,r))}};return Promise.all([e.or._iterate(a,n),It(Mt(e,r,n),e.algorithm,a,!e.keysOnly&&e.valueMapper)])}return It(Mt(e,r,n),kt(e.algorithm,o),t,!e.keysOnly&&e.valueMapper)}function It(e,t,n,r){var o=Qe(r?function(e,t,o){return n(r(e),t,o)}:n);return e.then((function(e){if(e)return e.start((function(){var n=function(){return e.continue()};t&&!t(e,(function(e){return n=e}),(function(t){e.stop(t),n=oe}),(function(t){e.fail(t),n=oe}))||o(e.value,e,(function(e){return n=e})),n()}))}))}function Rt(e,t){try{var n=Bt(e),r=Bt(t);if(n!==r)return"Array"===n?1:"Array"===r?-1:"binary"===n?1:"binary"===r?-1:"string"===n?1:"string"===r?-1:"Date"===n?1:"Date"!==r?NaN:-1;switch(n){case"number":case"Date":case"string":return e>t?1:e<t?-1:0;case"binary":return function(e,t){for(var n=e.length,r=t.length,o=n<r?n:r,i=0;i<o;++i)if(e[i]!==t[i])return e[i]<t[i]?-1:1;return n===r?0:n<r?-1:1}(qt(e),qt(t));case"Array":return function(e,t){for(var n=e.length,r=t.length,o=n<r?n:r,i=0;i<o;++i){var a=Rt(e[i],t[i]);if(0!==a)return a}return n===r?0:n<r?-1:1}(e,t)}}catch(e){}return NaN}function Bt(e){var t=typeof e;if("object"!==t)return t;if(ArrayBuffer.isView(e))return"binary";var n=D(e);return"ArrayBuffer"===n?"binary":n}function qt(e){return e instanceof Uint8Array?e:ArrayBuffer.isView(e)?new Uint8Array(e.buffer,e.byteOffset,e.byteLength):new Uint8Array(e)}var Ft=function(){function e(){}return e.prototype._read=function(e,t){var n=this._ctx;return n.error?n.table._trans(null,yt.bind(null,n.error)):n.table._trans("readonly",e).then(t)},e.prototype._write=function(e){var t=this._ctx;return t.error?t.table._trans(null,yt.bind(null,t.error)):t.table._trans("readwrite",e,"locked")},e.prototype._addAlgorithm=function(e){var t=this._ctx;t.algorithm=kt(t.algorithm,e)},e.prototype._iterate=function(e,t){return Dt(this._ctx,e,t,this._ctx.table.core)},e.prototype.clone=function(e){var t=Object.create(this.constructor.prototype),n=Object.create(this._ctx);return e&&s(n,e),t._ctx=n,t},e.prototype.raw=function(){return this._ctx.valueMapper=null,this},e.prototype.each=function(e){var t=this._ctx;return this._read((function(n){return Dt(t,e,n,t.table.core)}))},e.prototype.count=function(e){var t=this;return this._read((function(e){var n=t._ctx,r=n.table.core;if(Ct(n,!0))return r.count({trans:e,query:{index:Tt(n,r.schema),range:n.range}}).then((function(e){return Math.min(e,n.limit)}));var o=0;return Dt(n,(function(){return++o,!1}),e,r).then((function(){return o}))})).then(e)},e.prototype.sortBy=function(e,t){var n=e.split(".").reverse(),r=n[0],o=n.length-1;function i(e,t){return t?i(e[n[t]],t-1):e[r]}var a="next"===this._ctx.dir?1:-1;function u(e,t){var n=i(e,o),r=i(t,o);return n<r?-a:n>r?a:0}return this.toArray((function(e){return e.sort(u)})).then(t)},e.prototype.toArray=function(e){var t=this;return this._read((function(e){var n=t._ctx;if("next"===n.dir&&Ct(n,!0)&&n.limit>0){var r=n.valueMapper,o=Tt(n,n.table.core.schema);return n.table.core.query({trans:e,limit:n.limit,values:!0,query:{index:o,range:n.range}}).then((function(e){var t=e.result;return r?t.map(r):t}))}var i=[];return Dt(n,(function(e){return i.push(e)}),e,n.table.core).then((function(){return i}))}),e)},e.prototype.offset=function(e){var t=this._ctx;return e<=0||(t.offset+=e,Ct(t)?At(t,(function(){var t=e;return function(e,n){return 0===t||(1===t?(--t,!1):(n((function(){e.advance(t),t=0})),!1))}})):At(t,(function(){var t=e;return function(){return--t<0}}))),this},e.prototype.limit=function(e){return this._ctx.limit=Math.min(this._ctx.limit,e),At(this._ctx,(function(){var t=e;return function(e,n,r){return--t<=0&&n(r),t>=0}}),!0),this},e.prototype.until=function(e,t){return Kt(this._ctx,(function(n,r,o){return!e(n.value)||(r(o),t)})),this},e.prototype.first=function(e){return this.limit(1).toArray((function(e){return e[0]})).then(e)},e.prototype.last=function(e){return this.reverse().first(e)},e.prototype.filter=function(e){var t,n;return Kt(this._ctx,(function(t){return e(t.value)})),t=this._ctx,n=e,t.isMatch=kt(t.isMatch,n),this},e.prototype.and=function(e){return this.filter(e)},e.prototype.or=function(e){return new this.db.WhereClause(this._ctx.table,e,this)},e.prototype.reverse=function(){return this._ctx.dir="prev"===this._ctx.dir?"next":"prev",this._ondirectionchange&&this._ondirectionchange(this._ctx.dir),this},e.prototype.desc=function(){return this.reverse()},e.prototype.eachKey=function(e){var t=this._ctx;return t.keysOnly=!t.isMatch,this.each((function(t,n){e(n.key,n)}))},e.prototype.eachUniqueKey=function(e){return this._ctx.unique="unique",this.eachKey(e)},e.prototype.eachPrimaryKey=function(e){var t=this._ctx;return t.keysOnly=!t.isMatch,this.each((function(t,n){e(n.primaryKey,n)}))},e.prototype.keys=function(e){var t=this._ctx;t.keysOnly=!t.isMatch;var n=[];return this.each((function(e,t){n.push(t.key)})).then((function(){return n})).then(e)},e.prototype.primaryKeys=function(e){var t=this._ctx;if("next"===t.dir&&Ct(t,!0)&&t.limit>0)return this._read((function(e){var n=Tt(t,t.table.core.schema);return t.table.core.query({trans:e,values:!1,limit:t.limit,query:{index:n,range:t.range}})})).then((function(e){return e.result})).then(e);t.keysOnly=!t.isMatch;var n=[];return this.each((function(e,t){n.push(t.primaryKey)})).then((function(){return n})).then(e)},e.prototype.uniqueKeys=function(e){return this._ctx.unique="unique",this.keys(e)},e.prototype.firstKey=function(e){return this.limit(1).keys((function(e){return e[0]})).then(e)},e.prototype.lastKey=function(e){return this.reverse().firstKey(e)},e.prototype.distinct=function(){var e=this._ctx,t=e.index&&e.table.schema.idxByName[e.index];if(!t||!t.multi)return this;var n={};return Kt(this._ctx,(function(e){var t=e.primaryKey.toString(),r=f(n,t);return n[t]=!0,!r})),this},e.prototype.modify=function(e){var t=this,n=this._ctx;return this._write((function(r){var o;if("function"==typeof e)o=e;else{var i=a(e),u=i.length;o=function(t){for(var n=!1,r=0;r<u;++r){var o=i[r],a=e[o];O(t,o)!==a&&(P(t,o,a),n=!0)}return n}}var s=n.table.core,c=s.schema.primaryKey,l=c.outbound,f=c.extractKey,d=t.db._options.modifyChunkSize||200,h=[],p=0,y=[],v=function(e,t){var n=t.failures,r=t.numFailures;p+=e-r;for(var o=0,i=a(n);o<i.length;o++){var u=i[o];h.push(n[u])}};return t.clone().primaryKeys().then((function(t){var i=function(a){var u=Math.min(d,t.length-a);return s.getMany({trans:r,keys:t.slice(a,a+u),cache:"immutable"}).then((function(c){for(var h=[],p=[],y=l?[]:null,m=[],g=0;g<u;++g){var b=c[g],_={value:T(b),primKey:t[a+g]};!1!==o.call(_,_.value,_)&&(null==_.value?m.push(t[a+g]):l||0===Rt(f(b),f(_.value))?(p.push(_.value),l&&y.push(t[a+g])):(m.push(t[a+g]),h.push(_.value)))}var w=Ct(n)&&n.limit===1/0&&("function"!=typeof e||e===Nt)&&{index:n.index,range:n.range};return Promise.resolve(h.length>0&&s.mutate({trans:r,type:"add",values:h}).then((function(e){for(var t in e.failures)m.splice(parseInt(t),1);v(h.length,e)}))).then((function(){return(p.length>0||w&&"object"==typeof e)&&s.mutate({trans:r,type:"put",keys:y,values:p,criteria:w,changeSpec:"function"!=typeof e&&e}).then((function(e){return v(p.length,e)}))})).then((function(){return(m.length>0||w&&e===Nt)&&s.mutate({trans:r,type:"delete",keys:m,criteria:w}).then((function(e){return v(m.length,e)}))})).then((function(){return t.length>a+u&&i(a+d)}))}))};return i(0).then((function(){if(h.length>0)throw new J("Error modifying one or more objects",h,p,y);return t.length}))}))}))},e.prototype.delete=function(){var e=this._ctx,t=e.range;return Ct(e)&&(e.isPrimKey&&!wt||3===t.type)?this._write((function(n){var r=e.table.core.schema.primaryKey,o=t;return e.table.core.count({trans:n,query:{index:r,range:o}}).then((function(t){return e.table.core.mutate({trans:n,type:"deleteRange",range:o}).then((function(e){var n=e.failures;e.lastResult,e.results;var r=e.numFailures;if(r)throw new J("Could not delete some values",Object.keys(n).map((function(e){return n[e]})),t-r);return t-r}))}))})):this.modify(Nt)},e}(),Nt=function(e,t){return t.value=null};function Lt(e,t){return e<t?-1:e===t?0:1}function Ut(e,t){return e>t?-1:e===t?0:1}function Ht(e,t,n){var r=e instanceof Qt?new e.Collection(e):e;return r._ctx.error=n?new n(t):new TypeError(t),r}function Vt(e){return new e.Collection(e,(function(){return Yt("")})).limit(0)}function Gt(e,t,n,r,o,i){for(var a=Math.min(e.length,r.length),u=-1,s=0;s<a;++s){var c=t[s];if(c!==r[s])return o(e[s],n[s])<0?e.substr(0,s)+n[s]+n.substr(s+1):o(e[s],r[s])<0?e.substr(0,s)+r[s]+n.substr(s+1):u>=0?e.substr(0,u)+t[u]+n.substr(u+1):null;o(e[s],c)<0&&(u=s)}return a<r.length&&"next"===i?e+n.substr(e.length):a<e.length&&"prev"===i?e.substr(0,n.length):u<0?null:e.substr(0,u)+r[u]+n.substr(u+1)}function zt(e,t,n,r){var o,i,a,u,s,c,l,f=n.length;if(!n.every((function(e){return"string"==typeof e})))return Ht(e,"String expected.");function d(e){o=function(e){return"next"===e?function(e){return e.toUpperCase()}:function(e){return e.toLowerCase()}}(e),i=function(e){return"next"===e?function(e){return e.toLowerCase()}:function(e){return e.toUpperCase()}}(e),a="next"===e?Lt:Ut;var t=n.map((function(e){return{lower:i(e),upper:o(e)}})).sort((function(e,t){return a(e.lower,t.lower)}));u=t.map((function(e){return e.upper})),s=t.map((function(e){return e.lower})),c=e,l="next"===e?"":r}d("next");var h=new e.Collection(e,(function(){return Wt(u[0],s[f-1]+r)}));h._ondirectionchange=function(e){d(e)};var p=0;return h._addAlgorithm((function(e,n,r){var o=e.key;if("string"!=typeof o)return!1;var d=i(o);if(t(d,s,p))return!0;for(var h=null,y=p;y<f;++y){var v=Gt(o,d,u[y],s[y],a,c);null===v&&null===h?p=y+1:(null===h||a(h,v)>0)&&(h=v)}return n(null!==h?function(){e.continue(h+l)}:r),!1})),h}function Wt(e,t,n,r){return{type:2,lower:e,upper:t,lowerOpen:n,upperOpen:r}}function Yt(e){return{type:1,lower:e,upper:e}}var Qt=function(){function e(){}return Object.defineProperty(e.prototype,"Collection",{get:function(){return this._ctx.table.db.Collection},enumerable:!1,configurable:!0}),e.prototype.between=function(e,t,n,r){n=!1!==n,r=!0===r;try{return this._cmp(e,t)>0||0===this._cmp(e,t)&&(n||r)&&(!n||!r)?Vt(this):new this.Collection(this,(function(){return Wt(e,t,!n,!r)}))}catch(e){return Ht(this,mt)}},e.prototype.equals=function(e){return null==e?Ht(this,mt):new this.Collection(this,(function(){return Yt(e)}))},e.prototype.above=function(e){return null==e?Ht(this,mt):new this.Collection(this,(function(){return Wt(e,void 0,!0)}))},e.prototype.aboveOrEqual=function(e){return null==e?Ht(this,mt):new this.Collection(this,(function(){return Wt(e,void 0,!1)}))},e.prototype.below=function(e){return null==e?Ht(this,mt):new this.Collection(this,(function(){return Wt(void 0,e,!1,!0)}))},e.prototype.belowOrEqual=function(e){return null==e?Ht(this,mt):new this.Collection(this,(function(){return Wt(void 0,e)}))},e.prototype.startsWith=function(e){return"string"!=typeof e?Ht(this,"String expected."):this.between(e,e+vt,!0,!0)},e.prototype.startsWithIgnoreCase=function(e){return""===e?this.startsWith(e):zt(this,(function(e,t){return 0===e.indexOf(t[0])}),[e],vt)},e.prototype.equalsIgnoreCase=function(e){return zt(this,(function(e,t){return e===t[0]}),[e],"")},e.prototype.anyOfIgnoreCase=function(){var e=q.apply(B,arguments);return 0===e.length?Vt(this):zt(this,(function(e,t){return-1!==t.indexOf(e)}),e,"")},e.prototype.startsWithAnyOfIgnoreCase=function(){var e=q.apply(B,arguments);return 0===e.length?Vt(this):zt(this,(function(e,t){return t.some((function(t){return 0===e.indexOf(t)}))}),e,vt)},e.prototype.anyOf=function(){var e=this,t=q.apply(B,arguments),n=this._cmp;try{t.sort(n)}catch(e){return Ht(this,mt)}if(0===t.length)return Vt(this);var r=new this.Collection(this,(function(){return Wt(t[0],t[t.length-1])}));r._ondirectionchange=function(r){n="next"===r?e._ascending:e._descending,t.sort(n)};var o=0;return r._addAlgorithm((function(e,r,i){for(var a=e.key;n(a,t[o])>0;)if(++o===t.length)return r(i),!1;return 0===n(a,t[o])||(r((function(){e.continue(t[o])})),!1)})),r},e.prototype.notEqual=function(e){return this.inAnyRange([[-1/0,e],[e,this.db._maxKey]],{includeLowers:!1,includeUppers:!1})},e.prototype.noneOf=function(){var e=q.apply(B,arguments);if(0===e.length)return new this.Collection(this);try{e.sort(this._ascending)}catch(e){return Ht(this,mt)}var t=e.reduce((function(e,t){return e?e.concat([[e[e.length-1][1],t]]):[[-1/0,t]]}),null);return t.push([e[e.length-1],this.db._maxKey]),this.inAnyRange(t,{includeLowers:!1,includeUppers:!1})},e.prototype.inAnyRange=function(e,t){var n=this,r=this._cmp,o=this._ascending,i=this._descending,a=this._min,u=this._max;if(0===e.length)return Vt(this);if(!e.every((function(e){return void 0!==e[0]&&void 0!==e[1]&&o(e[0],e[1])<=0})))return Ht(this,"First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower",te.InvalidArgument);var s=!t||!1!==t.includeLowers,c=t&&!0===t.includeUppers;var l,f=o;function d(e,t){return f(e[0],t[0])}try{(l=e.reduce((function(e,t){for(var n=0,o=e.length;n<o;++n){var i=e[n];if(r(t[0],i[1])<0&&r(t[1],i[0])>0){i[0]=a(i[0],t[0]),i[1]=u(i[1],t[1]);break}}return n===o&&e.push(t),e}),[])).sort(d)}catch(e){return Ht(this,mt)}var h=0,p=c?function(e){return o(e,l[h][1])>0}:function(e){return o(e,l[h][1])>=0},y=s?function(e){return i(e,l[h][0])>0}:function(e){return i(e,l[h][0])>=0};var v=p,m=new this.Collection(this,(function(){return Wt(l[0][0],l[l.length-1][1],!s,!c)}));return m._ondirectionchange=function(e){"next"===e?(v=p,f=o):(v=y,f=i),l.sort(d)},m._addAlgorithm((function(e,t,r){for(var i=e.key;v(i);)if(++h===l.length)return t(r),!1;return!!function(e){return!p(e)&&!y(e)}(i)||(0===n._cmp(i,l[h][1])||0===n._cmp(i,l[h][0])||t((function(){f===o?e.continue(l[h][0]):e.continue(l[h][1])})),!1)})),m},e.prototype.startsWithAnyOf=function(){var e=q.apply(B,arguments);return e.every((function(e){return"string"==typeof e}))?0===e.length?Vt(this):this.inAnyRange(e.map((function(e){return[e,e+vt]}))):Ht(this,"startsWithAnyOf() only works with strings")},e}();function Xt(e){return Qe((function(t){return Jt(t),e(t.target.error),!1}))}function Jt(e){e.stopPropagation&&e.stopPropagation(),e.preventDefault&&e.preventDefault()}var $t=Et(null,"storagemutated"),Zt=function(){function e(){}return e.prototype._lock=function(){return w(!Ae.global),++this._reculock,1!==this._reculock||Ae.global||(Ae.lockOwnerFor=this),this},e.prototype._unlock=function(){if(w(!Ae.global),0==--this._reculock)for(Ae.global||(Ae.lockOwnerFor=null);this._blockedFuncs.length>0&&!this._locked();){var e=this._blockedFuncs.shift();try{lt(e[1],e[0])}catch(e){}}return this},e.prototype._locked=function(){return this._reculock&&Ae.lockOwnerFor!==this},e.prototype.create=function(e){var t=this;if(!this.mode)return this;var n=this.db.idbdb,r=this.db._state.dbOpenError;if(w(!this.idbtrans),!e&&!n)switch(r&&r.name){case"DatabaseClosedError":throw new te.DatabaseClosed(r);case"MissingAPIError":throw new te.MissingAPI(r.message,r);default:throw new te.OpenFailed(r)}if(!this.active)throw new te.TransactionInactive;return w(null===this._completion._state),(e=this.idbtrans=e||(this.db.core?this.db.core.transaction(this.storeNames,this.mode,{durability:this.chromeTransactionDurability}):n.transaction(this.storeNames,this.mode,{durability:this.chromeTransactionDurability}))).onerror=Qe((function(n){Jt(n),t._reject(e.error)})),e.onabort=Qe((function(n){Jt(n),t.active&&t._reject(new te.Abort(e.error)),t.active=!1,t.on("abort").fire(n)})),e.oncomplete=Qe((function(){t.active=!1,t._resolve(),"mutatedParts"in e&&$t.storagemutated.fire(e.mutatedParts)})),this},e.prototype._promise=function(e,t,n){var r=this;if("readwrite"===e&&"readwrite"!==this.mode)return yt(new te.ReadOnly("Transaction is readonly"));if(!this.active)return yt(new te.TransactionInactive);if(this._locked())return new Ie((function(o,i){r._blockedFuncs.push([function(){r._promise(e,t,n).then(o,i)},Ae])}));if(n)return nt((function(){var e=new Ie((function(e,n){r._lock();var o=t(e,n,r);o&&o.then&&o.then(e,n)}));return e.finally((function(){return r._unlock()})),e._lib=!0,e}));var o=new Ie((function(e,n){var o=t(e,n,r);o&&o.then&&o.then(e,n)}));return o._lib=!0,o},e.prototype._root=function(){return this.parent?this.parent._root():this},e.prototype.waitFor=function(e){var t=this._root(),n=Ie.resolve(e);if(t._waitingFor)t._waitingFor=t._waitingFor.then((function(){return n}));else{t._waitingFor=n,t._waitingQueue=[];var r=t.idbtrans.objectStore(t.storeNames[0]);!function e(){for(++t._spinCount;t._waitingQueue.length;)t._waitingQueue.shift()();t._waitingFor&&(r.get(-1/0).onsuccess=e)}()}var o=t._waitingFor;return new Ie((function(e,r){n.then((function(n){return t._waitingQueue.push(Qe(e.bind(null,n)))}),(function(e){return t._waitingQueue.push(Qe(r.bind(null,e)))})).finally((function(){t._waitingFor===o&&(t._waitingFor=null)}))}))},e.prototype.abort=function(){this.active&&(this.active=!1,this.idbtrans&&this.idbtrans.abort(),this._reject(new te.Abort))},e.prototype.table=function(e){var t=this._memoizedTables||(this._memoizedTables={});if(f(t,e))return t[e];var n=this.schema[e];if(!n)throw new te.NotFound("Table "+e+" not part of transaction");var r=new this.db.Table(e,n,this);return r.core=this.db.core.table(e),t[e]=r,r},e}();function en(e,t,n,r,o,i,a){return{name:e,keyPath:t,unique:n,multi:r,auto:o,compound:i,src:(n&&!a?"&":"")+(r?"*":"")+(o?"++":"")+tn(t)}}function tn(e){return"string"==typeof e?e:e?"["+[].join.call(e,"+")+"]":""}function nn(e,t,n){return{name:e,primKey:t,indexes:n,mappedClass:null,idxByName:k(n,(function(e){return[e.name,e]}))}}var rn=function(e){try{return e.only([[]]),rn=function(){return[[]]},[[]]}catch(e){return rn=function(){return vt},vt}};function on(e){return null==e?function(){}:"string"==typeof e?function(e){return 1===e.split(".").length?function(t){return t[e]}:function(t){return O(t,e)}}(e):function(t){return O(t,e)}}function an(e){return[].slice.call(e)}var un=0;function sn(e){return null==e?":id":"string"==typeof e?e:"["+e.join("+")+"]"}function cn(e,t,n){function r(e){if(3===e.type)return null;if(4===e.type)throw new Error("Cannot convert never type to IDBKeyRange");var n=e.lower,r=e.upper,o=e.lowerOpen,i=e.upperOpen;return void 0===n?void 0===r?null:t.upperBound(r,!!i):void 0===r?t.lowerBound(n,!!o):t.bound(n,r,!!o,!!i)}var o=function(e,t){var n=an(e.objectStoreNames);return{schema:{name:e.name,tables:n.map((function(e){return t.objectStore(e)})).map((function(e){var t=e.keyPath,n=e.autoIncrement,r=u(t),o=null==t,i={},a={name:e.name,primaryKey:{name:null,isPrimaryKey:!0,outbound:o,compound:r,keyPath:t,autoIncrement:n,unique:!0,extractKey:on(t)},indexes:an(e.indexNames).map((function(t){return e.index(t)})).map((function(e){var t=e.name,n=e.unique,r=e.multiEntry,o=e.keyPath,a={name:t,compound:u(o),keyPath:o,unique:n,multiEntry:r,extractKey:on(o)};return i[sn(o)]=a,a})),getIndexByKeyPath:function(e){return i[sn(e)]}};return i[":id"]=a.primaryKey,null!=t&&(i[sn(t)]=a.primaryKey),a}))},hasGetAll:n.length>0&&"getAll"in t.objectStore(n[0])&&!("undefined"!=typeof navigator&&/Safari/.test(navigator.userAgent)&&!/(Chrome\/|Edge\/)/.test(navigator.userAgent)&&[].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1]<604)}}(e,n),i=o.schema,a=o.hasGetAll,s=i.tables.map((function(e){return function(e){var t=e.name;return{name:t,schema:e,mutate:function(e){var n=e.trans,o=e.type,i=e.keys,a=e.values,u=e.range;return new Promise((function(e,s){e=Qe(e);var c=n.objectStore(t),l=null==c.keyPath,f="put"===o||"add"===o;if(!f&&"delete"!==o&&"deleteRange"!==o)throw new Error("Invalid operation type: "+o);var d,h=(i||a||{length:1}).length;if(i&&a&&i.length!==a.length)throw new Error("Given keys array must have same length as given values array.");if(0===h)return e({numFailures:0,failures:{},results:[],lastResult:void 0});var p=[],y=[],v=0,m=function(e){++v,Jt(e)};if("deleteRange"===o){if(4===u.type)return e({numFailures:v,failures:y,results:[],lastResult:void 0});3===u.type?p.push(d=c.clear()):p.push(d=c.delete(r(u)))}else{var g=f?l?[a,i]:[a,null]:[i,null],b=g[0],_=g[1];if(f)for(var w=0;w<h;++w)p.push(d=_&&void 0!==_[w]?c[o](b[w],_[w]):c[o](b[w])),d.onerror=m;else for(w=0;w<h;++w)p.push(d=c[o](b[w])),d.onerror=m}var x=function(t){var n=t.target.result;p.forEach((function(e,t){return null!=e.error&&(y[t]=e.error)})),e({numFailures:v,failures:y,results:"delete"===o?i:p.map((function(e){return e.result})),lastResult:n})};d.onerror=function(e){m(e),x(e)},d.onsuccess=x}))},getMany:function(e){var n=e.trans,r=e.keys;return new Promise((function(e,o){e=Qe(e);for(var i,a=n.objectStore(t),u=r.length,s=new Array(u),c=0,l=0,f=function(t){var n=t.target;s[n._pos]=n.result,++l===c&&e(s)},d=Xt(o),h=0;h<u;++h){null!=r[h]&&((i=a.get(r[h]))._pos=h,i.onsuccess=f,i.onerror=d,++c)}0===c&&e(s)}))},get:function(e){var n=e.trans,r=e.key;return new Promise((function(e,o){e=Qe(e);var i=n.objectStore(t).get(r);i.onsuccess=function(t){return e(t.target.result)},i.onerror=Xt(o)}))},query:function(e){return function(n){return new Promise((function(o,i){o=Qe(o);var a=n.trans,u=n.values,s=n.limit,c=n.query,l=s===1/0?void 0:s,f=c.index,d=c.range,h=a.objectStore(t),p=f.isPrimaryKey?h:h.index(f.name),y=r(d);if(0===s)return o({result:[]});if(e){var v=u?p.getAll(y,l):p.getAllKeys(y,l);v.onsuccess=function(e){return o({result:e.target.result})},v.onerror=Xt(i)}else{var m=0,g=u||!("openKeyCursor"in p)?p.openCursor(y):p.openKeyCursor(y),b=[];g.onsuccess=function(e){var t=g.result;return t?(b.push(u?t.value:t.primaryKey),++m===s?o({result:b}):void t.continue()):o({result:b})},g.onerror=Xt(i)}}))}}(a),openCursor:function(e){var n=e.trans,o=e.values,i=e.query,a=e.reverse,u=e.unique;return new Promise((function(e,s){e=Qe(e);var c=i.index,l=i.range,f=n.objectStore(t),d=c.isPrimaryKey?f:f.index(c.name),h=a?u?"prevunique":"prev":u?"nextunique":"next",p=o||!("openKeyCursor"in d)?d.openCursor(r(l),h):d.openKeyCursor(r(l),h);p.onerror=Xt(s),p.onsuccess=Qe((function(t){var r=p.result;if(r){r.___id=++un,r.done=!1;var o=r.continue.bind(r),i=r.continuePrimaryKey;i&&(i=i.bind(r));var a=r.advance.bind(r),u=function(){throw new Error("Cursor not stopped")};r.trans=n,r.stop=r.continue=r.continuePrimaryKey=r.advance=function(){throw new Error("Cursor not started")},r.fail=Qe(s),r.next=function(){var e=this,t=1;return this.start((function(){return t--?e.continue():e.stop()})).then((function(){return e}))},r.start=function(e){var t=new Promise((function(e,t){e=Qe(e),p.onerror=Xt(t),r.fail=t,r.stop=function(t){r.stop=r.continue=r.continuePrimaryKey=r.advance=u,e(t)}})),n=function(){if(p.result)try{e()}catch(e){r.fail(e)}else r.done=!0,r.start=function(){throw new Error("Cursor behind last entry")},r.stop()};return p.onsuccess=Qe((function(e){p.onsuccess=n,n()})),r.continue=o,r.continuePrimaryKey=i,r.advance=a,n(),t},e(r)}else e(null)}),s)}))},count:function(e){var n=e.query,o=e.trans,i=n.index,a=n.range;return new Promise((function(e,n){var u=o.objectStore(t),s=i.isPrimaryKey?u:u.index(i.name),c=r(a),l=c?s.count(c):s.count();l.onsuccess=Qe((function(t){return e(t.target.result)})),l.onerror=Xt(n)}))}}}(e)})),c={};return s.forEach((function(e){return c[e.name]=e})),{stack:"dbcore",transaction:e.transaction.bind(e),table:function(e){if(!c[e])throw new Error("Table '"+e+"' not found");return c[e]},MIN_KEY:-1/0,MAX_KEY:rn(t),schema:i}}function ln(e,t,n,o){var i=n.IDBKeyRange;return n.indexedDB,{dbcore:function(e,t){return t.reduce((function(e,t){var n=t.create;return r(r({},e),n(e))}),e)}(cn(t,i,o),e.dbcore)}}function fn(e,t){var n=e._novip,r=t.db,o=ln(n._middlewares,r,n._deps,t);n.core=o.dbcore,n.tables.forEach((function(e){var t=e.name;n.core.schema.tables.some((function(e){return e.name===t}))&&(e.core=n.core.table(t),n[t]instanceof n.Table&&(n[t].core=e.core))}))}function dn(e,t,n,r){var o=e._novip;n.forEach((function(e){var n=r[e];t.forEach((function(t){var r=m(t,e);(!r||"value"in r&&void 0===r.value)&&(t===o.Transaction.prototype||t instanceof o.Transaction?p(t,e,{get:function(){return this.table(e)},set:function(t){h(this,e,{value:t,writable:!0,configurable:!0,enumerable:!0})}}):t[e]=new o.Table(e,n))}))}))}function hn(e,t){var n=e._novip;t.forEach((function(e){for(var t in e)e[t]instanceof n.Table&&delete e[t]}))}function pn(e,t){return e._cfg.version-t._cfg.version}function yn(e,t,n,r){var o=e._dbSchema,i=e._createTransaction("readwrite",e._storeNames,o);i.create(n),i._completion.catch(r);var u=i._reject.bind(i),s=Ae.transless||Ae;nt((function(){Ae.trans=i,Ae.transless=s,0===t?(a(o).forEach((function(e){mn(n,e,o[e].primKey,o[e].indexes)})),fn(e,n),Ie.follow((function(){return e.on.populate.fire(i)})).catch(u)):function(e,t,n,r){var o=e._novip,i=[],u=o._versions,s=o._dbSchema=bn(o,o.idbdb,r),c=!1;function l(){return i.length?Ie.resolve(i.shift()(n.idbtrans)).then(l):Ie.resolve()}return u.filter((function(e){return e._cfg.version>=t})).forEach((function(e){i.push((function(){var i=s,u=e._cfg.dbschema;_n(o,i,r),_n(o,u,r),s=o._dbSchema=u;var l=vn(i,u);l.add.forEach((function(e){mn(r,e[0],e[1].primKey,e[1].indexes)})),l.change.forEach((function(e){if(e.recreate)throw new te.Upgrade("Not yet support for changing primary key");var t=r.objectStore(e.name);e.add.forEach((function(e){return gn(t,e)})),e.change.forEach((function(e){t.deleteIndex(e.name),gn(t,e)})),e.del.forEach((function(e){return t.deleteIndex(e)}))}));var f=e._cfg.contentUpgrade;if(f&&e._cfg.version>t){fn(o,r),n._memoizedTables={},c=!0;var d=j(u);l.del.forEach((function(e){d[e]=i[e]})),hn(o,[o.Transaction.prototype]),dn(o,[o.Transaction.prototype],a(d),d),n.schema=d;var h,p=F(f);p&&rt();var y=Ie.follow((function(){if((h=f(n))&&p){var e=ot.bind(null,null);h.then(e,e)}}));return h&&"function"==typeof h.then?Ie.resolve(h):y.then((function(){return h}))}})),i.push((function(t){c&&_t||function(e,t){[].slice.call(t.db.objectStoreNames).forEach((function(n){return null==e[n]&&t.db.deleteObjectStore(n)}))}(e._cfg.dbschema,t);hn(o,[o.Transaction.prototype]),dn(o,[o.Transaction.prototype],o._storeNames,o._dbSchema),n.schema=o._dbSchema}))})),l().then((function(){var e,t;t=r,a(e=s).forEach((function(n){t.db.objectStoreNames.contains(n)||mn(t,n,e[n].primKey,e[n].indexes)}))}))}(e,t,i,n).catch(u)}))}function vn(e,t){var n,r={del:[],add:[],change:[]};for(n in e)t[n]||r.del.push(n);for(n in t){var o=e[n],i=t[n];if(o){var a={name:n,def:i,recreate:!1,del:[],add:[],change:[]};if(""+(o.primKey.keyPath||"")!=""+(i.primKey.keyPath||"")||o.primKey.auto!==i.primKey.auto&&!bt)a.recreate=!0,r.change.push(a);else{var u=o.idxByName,s=i.idxByName,c=void 0;for(c in u)s[c]||a.del.push(c);for(c in s){var l=u[c],f=s[c];l?l.src!==f.src&&a.change.push(f):a.add.push(f)}(a.del.length>0||a.add.length>0||a.change.length>0)&&r.change.push(a)}}else r.add.push([n,i])}return r}function mn(e,t,n,r){var o=e.db.createObjectStore(t,n.keyPath?{keyPath:n.keyPath,autoIncrement:n.auto}:{autoIncrement:n.auto});return r.forEach((function(e){return gn(o,e)})),o}function gn(e,t){e.createIndex(t.name,t.keyPath,{unique:t.unique,multiEntry:t.multi})}function bn(e,t,n){var r={};return b(t.objectStoreNames,0).forEach((function(e){for(var t=n.objectStore(e),o=t.keyPath,i=en(tn(o),o||"",!1,!1,!!t.autoIncrement,o&&"string"!=typeof o,!0),a=[],u=0;u<t.indexNames.length;++u){var s=t.index(t.indexNames[u]);o=s.keyPath;var c=en(s.name,o,!!s.unique,!!s.multiEntry,!1,o&&"string"!=typeof o,!1);a.push(c)}r[e]=nn(e,i,a)})),r}function _n(e,t,n){for(var r=e._novip,o=n.db.objectStoreNames,a=0;a<o.length;++a){var u=o[a],s=n.objectStore(u);r._hasGetAll="getAll"in s;for(var c=0;c<s.indexNames.length;++c){var l=s.indexNames[c],f=s.index(l).keyPath,d="string"==typeof f?f:"["+b(f).join("+")+"]";if(t[u]){var h=t[u].idxByName[d];h&&(h.name=l,delete t[u].idxByName[d],t[u].idxByName[l]=h)}}}"undefined"!=typeof navigator&&/Safari/.test(navigator.userAgent)&&!/(Chrome\/|Edge\/)/.test(navigator.userAgent)&&i.WorkerGlobalScope&&i instanceof i.WorkerGlobalScope&&[].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1]<604&&(r._hasGetAll=!1)}var wn=function(){function e(){}return e.prototype._parseStoresSpec=function(e,t){a(e).forEach((function(n){if(null!==e[n]){var r=e[n].split(",").map((function(e,t){var n=(e=e.trim()).replace(/([&*]|\+\+)/g,""),r=/^\[/.test(n)?n.match(/^\[(.*)\]$/)[1].split("+"):n;return en(n,r||null,/\&/.test(e),/\*/.test(e),/\+\+/.test(e),u(r),0===t)})),o=r.shift();if(o.multi)throw new te.Schema("Primary key cannot be multi-valued");r.forEach((function(e){if(e.auto)throw new te.Schema("Only primary key can be marked as autoIncrement (++)");if(!e.keyPath)throw new te.Schema("Index must have a name and cannot be an empty string")})),t[n]=nn(n,o,r)}}))},e.prototype.stores=function(e){var t=this.db;this._cfg.storesSource=this._cfg.storesSource?s(this._cfg.storesSource,e):e;var n=t._versions,r={},o={};return n.forEach((function(e){s(r,e._cfg.storesSource),o=e._cfg.dbschema={},e._parseStoresSpec(r,o)})),t._dbSchema=o,hn(t,[t._allTables,t,t.Transaction.prototype]),dn(t,[t._allTables,t,t.Transaction.prototype,this._cfg.tables],a(o),o),t._storeNames=a(o),this},e.prototype.upgrade=function(e){return this._cfg.contentUpgrade=de(this._cfg.contentUpgrade||oe,e),this},e}();function xn(e,t){var n=e._dbNamesDB;return n||(n=e._dbNamesDB=new Yn("__dbnames",{addons:[],indexedDB:e,IDBKeyRange:t})).version(1).stores({dbnames:"name"}),n.table("dbnames")}function kn(e){return e&&"function"==typeof e.databases}function On(e,t){var n=e.indexedDB,r=e.IDBKeyRange;!kn(n)&&"__dbnames"!==t&&xn(n,r).delete(t).catch(oe)}function Pn(e){return nt((function(){return Ae.letThrough=!0,e()}))}function jn(){var e;return!navigator.userAgentData&&/Safari\//.test(navigator.userAgent)&&!/Chrom(e|ium)\//.test(navigator.userAgent)&&indexedDB.databases?new Promise((function(t){var n=function(){return indexedDB.databases().finally(t)};e=setInterval(n,100),n()})).finally((function(){return clearInterval(e)})):Promise.resolve()}function En(e){var t=e._state,n=e._deps.indexedDB;if(t.isBeingOpened||e.idbdb)return t.dbReadyPromise.then((function(){return t.dbOpenError?yt(t.dbOpenError):e}));N&&(t.openCanceller._stackHolder=V()),t.isBeingOpened=!0,t.dbOpenError=null,t.openComplete=!1;var r=t.openCanceller;function o(){if(t.openCanceller!==r)throw new te.DatabaseClosed("db.open() was cancelled")}var i=t.dbReadyResolve,u=null,s=!1,c=function(){return new Ie((function(r,i){if(o(),!n)throw new te.MissingAPI;var c=e.name,l=t.autoSchema?n.open(c):n.open(c,Math.round(10*e.verno));if(!l)throw new te.MissingAPI;l.onerror=Xt(i),l.onblocked=Qe(e._fireOnBlocked),l.onupgradeneeded=Qe((function(r){if(u=l.transaction,t.autoSchema&&!e._options.allowEmptyDB){l.onerror=Jt,u.abort(),l.result.close();var o=n.deleteDatabase(c);o.onsuccess=o.onerror=Qe((function(){i(new te.NoSuchDatabase("Database "+c+" doesnt exist"))}))}else{u.onerror=Xt(i);var a=r.oldVersion>Math.pow(2,62)?0:r.oldVersion;s=a<1,e._novip.idbdb=l.result,yn(e,a/10,u,i)}}),i),l.onsuccess=Qe((function(){u=null;var n,o=e._novip.idbdb=l.result,i=b(o.objectStoreNames);if(i.length>0)try{var f=o.transaction(1===(n=i).length?n[0]:n,"readonly");t.autoSchema?function(e,t,n){var r=e._novip;r.verno=t.version/10;var o=r._dbSchema=bn(0,t,n);r._storeNames=b(t.objectStoreNames,0),dn(r,[r._allTables],a(o),o)}(e,o,f):(_n(e,e._dbSchema,f),function(e,t){var n=vn(bn(0,e.idbdb,t),e._dbSchema);return!(n.add.length||n.change.some((function(e){return e.add.length||e.change.length})))}(e,f)||console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.")),fn(e,f)}catch(e){}gt.push(e),o.onversionchange=Qe((function(n){t.vcFired=!0,e.on("versionchange").fire(n)})),o.onclose=Qe((function(t){e.on("close").fire(t)})),s&&function(e,t){var n=e.indexedDB,r=e.IDBKeyRange;!kn(n)&&"__dbnames"!==t&&xn(n,r).put({name:t}).catch(oe)}(e._deps,c),r()}),i)})).catch((function(e){return e&&"UnknownError"===e.name&&t.PR1398_maxLoop>0?(t.PR1398_maxLoop--,console.warn("Dexie: Workaround for Chrome UnknownError on open()"),c()):Ie.reject(e)}))};return Ie.race([r,("undefined"==typeof navigator?Ie.resolve():jn()).then(c)]).then((function(){return o(),t.onReadyBeingFired=[],Ie.resolve(Pn((function(){return e.on.ready.fire(e.vip)}))).then((function n(){if(t.onReadyBeingFired.length>0){var r=t.onReadyBeingFired.reduce(de,oe);return t.onReadyBeingFired=[],Ie.resolve(Pn((function(){return r(e.vip)}))).then(n)}}))})).finally((function(){t.onReadyBeingFired=null,t.isBeingOpened=!1})).then((function(){return e})).catch((function(n){t.dbOpenError=n;try{u&&u.abort()}catch(e){}return r===t.openCanceller&&e._close(),yt(n)})).finally((function(){t.openComplete=!0,i()}))}function Sn(e){var t=function(t){return e.next(t)},n=o(t),r=o((function(t){return e.throw(t)}));function o(e){return function(t){var o=e(t),i=o.value;return o.done?i:i&&"function"==typeof i.then?i.then(n,r):u(i)?Promise.all(i).then(n,r):n(i)}}return o(t)()}function Cn(e,t,n){var r=arguments.length;if(r<2)throw new te.InvalidArgument("Too few arguments");for(var o=new Array(r-1);--r;)o[r-1]=arguments[r];n=o.pop();var i=S(o);return[e,i,n]}function Kn(e,t,n,r,o){return Ie.resolve().then((function(){var i=Ae.transless||Ae,a=e._createTransaction(t,n,e._dbSchema,r),u={trans:a,transless:i};if(r)a.idbtrans=r.idbtrans;else try{a.create(),e._state.PR1398_maxLoop=3}catch(r){return r.name===Z.InvalidState&&e.isOpen()&&--e._state.PR1398_maxLoop>0?(console.warn("Dexie: Need to reopen db"),e._close(),e.open().then((function(){return Kn(e,t,n,null,o)}))):yt(r)}var s,c=F(o);c&&rt();var l=Ie.follow((function(){if(s=o.call(a,a))if(c){var e=ot.bind(null,null);s.then(e,e)}else"function"==typeof s.next&&"function"==typeof s.throw&&(s=Sn(s))}),u);return(s&&"function"==typeof s.then?Ie.resolve(s).then((function(e){return a.active?e:yt(new te.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"))})):l.then((function(){return s}))).then((function(e){return r&&a._resolve(),a._completion.then((function(){return e}))})).catch((function(e){return a._reject(e),yt(e)}))}))}function An(e,t,n){for(var r=u(e)?e.slice():[e],o=0;o<n;++o)r.push(t);return r}var Tn={stack:"dbcore",name:"VirtualIndexMiddleware",level:1,create:function(e){return r(r({},e),{table:function(t){var n=e.table(t),o=n.schema,i={},a=[];function u(e,t,n){var o=sn(e),s=i[o]=i[o]||[],c=null==e?0:"string"==typeof e?1:e.length,l=t>0,f=r(r({},n),{isVirtual:l,keyTail:t,keyLength:c,extractKey:on(e),unique:!l&&n.unique});(s.push(f),f.isPrimaryKey||a.push(f),c>1)&&u(2===c?e[0]:e.slice(0,c-1),t+1,n);return s.sort((function(e,t){return e.keyTail-t.keyTail})),f}var s=u(o.primaryKey.keyPath,0,o.primaryKey);i[":id"]=[s];for(var c=0,l=o.indexes;c<l.length;c++){var f=l[c];u(f.keyPath,0,f)}function d(t){var n,o,i=t.query.index;return i.isVirtual?r(r({},t),{query:{index:i,range:(n=t.query.range,o=i.keyTail,{type:1===n.type?2:n.type,lower:An(n.lower,n.lowerOpen?e.MAX_KEY:e.MIN_KEY,o),lowerOpen:!0,upper:An(n.upper,n.upperOpen?e.MIN_KEY:e.MAX_KEY,o),upperOpen:!0})}}):t}return r(r({},n),{schema:r(r({},o),{primaryKey:s,indexes:a,getIndexByKeyPath:function(e){var t=i[sn(e)];return t&&t[0]}}),count:function(e){return n.count(d(e))},query:function(e){return n.query(d(e))},openCursor:function(t){var r=t.query.index,o=r.keyTail,i=r.isVirtual,a=r.keyLength;if(!i)return n.openCursor(t);return n.openCursor(d(t)).then((function(n){return n&&function(n){return Object.create(n,{continue:{value:function(r){null!=r?n.continue(An(r,t.reverse?e.MAX_KEY:e.MIN_KEY,o)):t.unique?n.continue(n.key.slice(0,a).concat(t.reverse?e.MIN_KEY:e.MAX_KEY,o)):n.continue()}},continuePrimaryKey:{value:function(t,r){n.continuePrimaryKey(An(t,e.MAX_KEY,o),r)}},primaryKey:{get:function(){return n.primaryKey}},key:{get:function(){var e=n.key;return 1===a?e[0]:e.slice(0,a)}},value:{get:function(){return n.value}}})}(n)}))}})}})}};function Mn(e,t,n,r){return n=n||{},r=r||"",a(e).forEach((function(o){if(f(t,o)){var i=e[o],a=t[o];if("object"==typeof i&&"object"==typeof a&&i&&a){var u=D(i);u!==D(a)?n[r+o]=t[o]:"Object"===u?Mn(i,a,n,r+o+"."):i!==a&&(n[r+o]=t[o])}else i!==a&&(n[r+o]=t[o])}else n[r+o]=void 0})),a(t).forEach((function(o){f(e,o)||(n[r+o]=t[o])})),n}var Dn={stack:"dbcore",name:"HooksMiddleware",level:2,create:function(e){return r(r({},e),{table:function(t){var n=e.table(t),i=n.schema.primaryKey;return r(r({},n),{mutate:function(e){var a=Ae.trans,u=a.table(t).hook,s=u.deleting,c=u.creating,l=u.updating;switch(e.type){case"add":if(c.fire===oe)break;return a._promise("readwrite",(function(){return d(e)}),!0);case"put":if(c.fire===oe&&l.fire===oe)break;return a._promise("readwrite",(function(){return d(e)}),!0);case"delete":if(s.fire===oe)break;return a._promise("readwrite",(function(){return d(e)}),!0);case"deleteRange":if(s.fire===oe)break;return a._promise("readwrite",(function(){return function(e){return function e(t,o,a){return n.query({trans:t,values:!1,query:{index:i,range:o},limit:a}).then((function(n){var i=n.result;return d({type:"delete",keys:i,trans:t}).then((function(n){return n.numFailures>0?Promise.reject(n.failures[0]):i.length<a?{failures:[],numFailures:0,lastResult:void 0}:e(t,r(r({},o),{lower:i[i.length-1],lowerOpen:!0}),a)}))}))}(e.trans,e.range,1e4)}(e)}),!0)}return n.mutate(e);function d(e){var t=Ae.trans,a=e.keys||function(e,t){return"delete"===t.type?t.keys:t.keys||t.values.map(e.extractKey)}(i,e);if(!a)throw new Error("Keys missing");return"delete"!==(e="add"===e.type||"put"===e.type?r(r({},e),{keys:a}):r({},e)).type&&(e.values=o([],e.values,!0)),e.keys&&(e.keys=o([],e.keys,!0)),function(e,t,n){return"add"===t.type?Promise.resolve([]):e.getMany({trans:t.trans,keys:n,cache:"immutable"})}(n,e,a).then((function(r){var o=a.map((function(n,o){var a=r[o],u={onerror:null,onsuccess:null};if("delete"===e.type)s.fire.call(u,n,a,t);else if("add"===e.type||void 0===a){var d=c.fire.call(u,n,e.values[o],t);null==n&&null!=d&&(n=d,e.keys[o]=n,i.outbound||P(e.values[o],i.keyPath,n))}else{var h=Mn(a,e.values[o]),p=l.fire.call(u,h,n,a,t);if(p){var y=e.values[o];Object.keys(p).forEach((function(e){f(y,e)?y[e]=p[e]:P(y,e,p[e])}))}}return u}));return n.mutate(e).then((function(t){for(var n=t.failures,i=t.results,u=t.numFailures,s=t.lastResult,c=0;c<a.length;++c){var l=i?i[c]:a[c],f=o[c];null==l?f.onerror&&f.onerror(n[c]):f.onsuccess&&f.onsuccess("put"===e.type&&r[c]?e.values[c]:l)}return{failures:n,results:i,numFailures:u,lastResult:s}})).catch((function(e){return o.forEach((function(t){return t.onerror&&t.onerror(e)})),Promise.reject(e)}))}))}}})}})}};function In(e,t,n){try{if(!t)return null;if(t.keys.length<e.length)return null;for(var r=[],o=0,i=0;o<t.keys.length&&i<e.length;++o)0===Rt(t.keys[o],e[i])&&(r.push(n?T(t.values[o]):t.values[o]),++i);return r.length===e.length?r:null}catch(e){return null}}var Rn,Bn={stack:"dbcore",level:-1,create:function(e){return{table:function(t){var n=e.table(t);return r(r({},n),{getMany:function(e){if(!e.cache)return n.getMany(e);var t=In(e.keys,e.trans._cache,"clone"===e.cache);return t?Ie.resolve(t):n.getMany(e).then((function(t){return e.trans._cache={keys:e.keys,values:"clone"===e.cache?T(t):t},t}))},mutate:function(e){return"add"!==e.type&&(e.trans._cache=null),n.mutate(e)}})}}}};function qn(e){return!("from"in e)}var Fn=function(e,t){if(!this){var n=new Fn;return e&&"d"in e&&s(n,e),n}s(this,arguments.length?{d:1,from:e,to:arguments.length>1?t:e}:{d:0})};function Nn(e,t,n){var r=Rt(t,n);if(!isNaN(r)){if(r>0)throw RangeError();if(qn(e))return s(e,{from:t,to:n,d:1});var o=e.l,i=e.r;if(Rt(n,e.from)<0)return o?Nn(o,t,n):e.l={from:t,to:n,d:1,l:null,r:null},Vn(e);if(Rt(t,e.to)>0)return i?Nn(i,t,n):e.r={from:t,to:n,d:1,l:null,r:null},Vn(e);Rt(t,e.from)<0&&(e.from=t,e.l=null,e.d=i?i.d+1:1),Rt(n,e.to)>0&&(e.to=n,e.r=null,e.d=e.l?e.l.d+1:1);var a=!e.r;o&&!e.l&&Ln(e,o),i&&a&&Ln(e,i)}}function Ln(e,t){qn(t)||function e(t,n){var r=n.from,o=n.to,i=n.l,a=n.r;Nn(t,r,o),i&&e(t,i),a&&e(t,a)}(e,t)}function Un(e,t){var n=Hn(t),r=n.next();if(r.done)return!1;for(var o=r.value,i=Hn(e),a=i.next(o.from),u=a.value;!r.done&&!a.done;){if(Rt(u.from,o.to)<=0&&Rt(u.to,o.from)>=0)return!0;Rt(o.from,u.from)<0?o=(r=n.next(u.from)).value:u=(a=i.next(o.from)).value}return!1}function Hn(e){var t=qn(e)?null:{s:0,n:e};return{next:function(e){for(var n=arguments.length>0;t;)switch(t.s){case 0:if(t.s=1,n)for(;t.n.l&&Rt(e,t.n.from)<0;)t={up:t,n:t.n.l,s:1};else for(;t.n.l;)t={up:t,n:t.n.l,s:1};case 1:if(t.s=2,!n||Rt(e,t.n.to)<=0)return{value:t.n,done:!1};case 2:if(t.n.r){t.s=3,t={up:t,n:t.n.r,s:0};continue}case 3:t=t.up}return{done:!0}}}}function Vn(e){var t,n,o=((null===(t=e.r)||void 0===t?void 0:t.d)||0)-((null===(n=e.l)||void 0===n?void 0:n.d)||0),i=o>1?"r":o<-1?"l":"";if(i){var a="r"===i?"l":"r",u=r({},e),s=e[i];e.from=s.from,e.to=s.to,e[i]=s[i],u[i]=s[a],e[a]=u,u.d=Gn(u)}e.d=Gn(e)}function Gn(e){var t=e.r,n=e.l;return(t?n?Math.max(t.d,n.d):t.d:n?n.d:0)+1}d(Fn.prototype,((Rn={add:function(e){return Ln(this,e),this},addKey:function(e){return Nn(this,e,e),this},addKeys:function(e){var t=this;return e.forEach((function(e){return Nn(t,e,e)})),this}})[I]=function(){return Hn(this)},Rn));var zn={stack:"dbcore",level:0,create:function(e){var t=e.schema.name,n=new Fn(e.MIN_KEY,e.MAX_KEY);return r(r({},e),{table:function(o){var i=e.table(o),s=i.schema,c=s.primaryKey,l=c.extractKey,f=c.outbound,d=r(r({},i),{mutate:function(e){var r=e.trans,a=r.mutatedParts||(r.mutatedParts={}),c=function(e){var n="idb://"+t+"/"+o+"/"+e;return a[n]||(a[n]=new Fn)},l=c(""),f=c(":dels"),d=e.type,h="deleteRange"===e.type?[e.range]:"delete"===e.type?[e.keys]:e.values.length<50?[[],e.values]:[],p=h[0],y=h[1],v=e.trans._cache;return i.mutate(e).then((function(e){if(u(p)){"delete"!==d&&(p=e.results),l.addKeys(p);var t=In(p,v);t||"add"===d||f.addKeys(p),(t||y)&&function(e,t,n,r){t.indexes.forEach((function(t){var o=e(t.name||"");function i(e){return null!=e?t.extractKey(e):null}var a=function(e){return t.multiEntry&&u(e)?e.forEach((function(e){return o.addKey(e)})):o.addKey(e)};(n||r).forEach((function(e,t){var o=n&&i(n[t]),u=r&&i(r[t]);0!==Rt(o,u)&&(null!=o&&a(o),null!=u&&a(u))}))}))}(c,s,t,y)}else if(p){var r={from:p.lower,to:p.upper};f.add(r),l.add(r)}else l.add(n),f.add(n),s.indexes.forEach((function(e){return c(e.name).add(n)}));return e}))}}),h=function(t){var n,r,o=t.query,i=o.index,a=o.range;return[i,new Fn(null!==(n=a.lower)&&void 0!==n?n:e.MIN_KEY,null!==(r=a.upper)&&void 0!==r?r:e.MAX_KEY)]},p={get:function(e){return[c,new Fn(e.key)]},getMany:function(e){return[c,(new Fn).addKeys(e.keys)]},count:h,query:h,openCursor:h};return a(p).forEach((function(e){d[e]=function(a){var u=Ae.subscr;if(u){var s=function(e){var n="idb://"+t+"/"+o+"/"+e;return u[n]||(u[n]=new Fn)},c=s(""),d=s(":dels"),h=p[e](a),y=h[0],v=h[1];if(s(y.name||"").add(v),!y.isPrimaryKey){if("count"!==e){var m="query"===e&&f&&a.values&&i.query(r(r({},a),{values:!1}));return i[e].apply(this,arguments).then((function(t){if("query"===e){if(f&&a.values)return m.then((function(e){var n=e.result;return c.addKeys(n),t}));var n=a.values?t.result.map(l):t.result;a.values?c.addKeys(n):d.addKeys(n)}else if("openCursor"===e){var r=t,o=a.values;return r&&Object.create(r,{key:{get:function(){return d.addKey(r.primaryKey),r.key}},primaryKey:{get:function(){var e=r.primaryKey;return d.addKey(e),e}},value:{get:function(){return o&&c.addKey(r.primaryKey),r.value}}})}return t}))}d.add(n)}}return i[e].apply(this,arguments)}})),d}})}};var Wn,Yn=function(){function e(t,n){var o=this;this._middlewares={},this.verno=0;var i=e.dependencies;this._options=n=r({addons:e.addons,autoOpen:!0,indexedDB:i.indexedDB,IDBKeyRange:i.IDBKeyRange},n),this._deps={indexedDB:n.indexedDB,IDBKeyRange:n.IDBKeyRange};var a=n.addons;this._dbSchema={},this._versions=[],this._storeNames=[],this._allTables={},this.idbdb=null,this._novip=this;var u,s={dbOpenError:null,isBeingOpened:!1,onReadyBeingFired:null,openComplete:!1,dbReadyResolve:oe,dbReadyPromise:null,cancelOpen:oe,openCanceller:null,autoSchema:!0,PR1398_maxLoop:3};s.dbReadyPromise=new Ie((function(e){s.dbReadyResolve=e})),s.openCanceller=new Ie((function(e,t){s.cancelOpen=t})),this._state=s,this.name=t,this.on=Et(this,"populate","blocked","versionchange","close",{ready:[de,oe]}),this.on.ready.subscribe=_(this.on.ready.subscribe,(function(t){return function(n,r){e.vip((function(){var e=o._state;if(e.openComplete)e.dbOpenError||Ie.resolve().then(n),r&&t(n);else if(e.onReadyBeingFired)e.onReadyBeingFired.push(n),r&&t(n);else{t(n);var i=o;r||t((function e(){i.on.ready.unsubscribe(n),i.on.ready.unsubscribe(e)}))}}))}})),this.Collection=(u=this,St(Ft.prototype,(function(e,t){this.db=u;var n=Ot,r=null;if(t)try{n=t()}catch(e){r=e}var o=e._ctx,i=o.table,a=i.hook.reading.fire;this._ctx={table:i,index:o.index,isPrimKey:!o.index||i.schema.primKey.keyPath&&o.index===i.schema.primKey.name,range:n,keysOnly:!1,dir:"next",unique:"",algorithm:null,filter:null,replayFilter:null,justLimit:!0,isMatch:null,offset:0,limit:1/0,error:r,or:o.or,valueMapper:a!==ie?a:null}}))),this.Table=function(e){return St(jt.prototype,(function(t,n,r){this.db=e,this._tx=r,this.name=t,this.schema=n,this.hook=e._allTables[t]?e._allTables[t].hook:Et(null,{creating:[se,oe],reading:[ae,ie],updating:[le,oe],deleting:[ce,oe]})}))}(this),this.Transaction=function(e){return St(Zt.prototype,(function(t,n,r,o,i){var a=this;this.db=e,this.mode=t,this.storeNames=n,this.schema=r,this.chromeTransactionDurability=o,this.idbtrans=null,this.on=Et(this,"complete","error","abort"),this.parent=i||null,this.active=!0,this._reculock=0,this._blockedFuncs=[],this._resolve=null,this._reject=null,this._waitingFor=null,this._waitingQueue=null,this._spinCount=0,this._completion=new Ie((function(e,t){a._resolve=e,a._reject=t})),this._completion.then((function(){a.active=!1,a.on.complete.fire()}),(function(e){var t=a.active;return a.active=!1,a.on.error.fire(e),a.parent?a.parent._reject(e):t&&a.idbtrans&&a.idbtrans.abort(),yt(e)}))}))}(this),this.Version=function(e){return St(wn.prototype,(function(t){this.db=e,this._cfg={version:t,storesSource:null,dbschema:{},tables:{},contentUpgrade:null}}))}(this),this.WhereClause=function(e){return St(Qt.prototype,(function(t,n,r){this.db=e,this._ctx={table:t,index:":id"===n?null:n,or:r};var o=e._deps.indexedDB;if(!o)throw new te.MissingAPI;this._cmp=this._ascending=o.cmp.bind(o),this._descending=function(e,t){return o.cmp(t,e)},this._max=function(e,t){return o.cmp(e,t)>0?e:t},this._min=function(e,t){return o.cmp(e,t)<0?e:t},this._IDBKeyRange=e._deps.IDBKeyRange}))}(this),this.on("versionchange",(function(e){e.newVersion>0?console.warn("Another connection wants to upgrade database '"+o.name+"'. Closing db now to resume the upgrade."):console.warn("Another connection wants to delete database '"+o.name+"'. Closing db now to resume the delete request."),o.close()})),this.on("blocked",(function(e){!e.newVersion||e.newVersion<e.oldVersion?console.warn("Dexie.delete('"+o.name+"') was blocked"):console.warn("Upgrade '"+o.name+"' blocked by other connection holding version "+e.oldVersion/10)})),this._maxKey=rn(n.IDBKeyRange),this._createTransaction=function(e,t,n,r){return new o.Transaction(e,t,n,o._options.chromeTransactionDurability,r)},this._fireOnBlocked=function(e){o.on("blocked").fire(e),gt.filter((function(e){return e.name===o.name&&e!==o&&!e._state.vcFired})).map((function(t){return t.on("versionchange").fire(e)}))},this.use(Tn),this.use(Dn),this.use(zn),this.use(Bn),this.vip=Object.create(this,{_vip:{value:!0}}),a.forEach((function(e){return e(o)}))}return e.prototype.version=function(e){if(isNaN(e)||e<.1)throw new te.Type("Given version is not a positive number");if(e=Math.round(10*e)/10,this.idbdb||this._state.isBeingOpened)throw new te.Schema("Cannot add version when database is open");this.verno=Math.max(this.verno,e);var t=this._versions,n=t.filter((function(t){return t._cfg.version===e}))[0];return n||(n=new this.Version(e),t.push(n),t.sort(pn),n.stores({}),this._state.autoSchema=!1,n)},e.prototype._whenReady=function(e){var t=this;return this.idbdb&&(this._state.openComplete||Ae.letThrough||this._vip)?e():new Ie((function(e,n){if(t._state.openComplete)return n(new te.DatabaseClosed(t._state.dbOpenError));if(!t._state.isBeingOpened){if(!t._options.autoOpen)return void n(new te.DatabaseClosed);t.open().catch(oe)}t._state.dbReadyPromise.then(e,n)})).then(e)},e.prototype.use=function(e){var t=e.stack,n=e.create,r=e.level,o=e.name;o&&this.unuse({stack:t,name:o});var i=this._middlewares[t]||(this._middlewares[t]=[]);return i.push({stack:t,create:n,level:null==r?10:r,name:o}),i.sort((function(e,t){return e.level-t.level})),this},e.prototype.unuse=function(e){var t=e.stack,n=e.name,r=e.create;return t&&this._middlewares[t]&&(this._middlewares[t]=this._middlewares[t].filter((function(e){return r?e.create!==r:!!n&&e.name!==n}))),this},e.prototype.open=function(){return En(this)},e.prototype._close=function(){var e=this._state,t=gt.indexOf(this);if(t>=0&&gt.splice(t,1),this.idbdb){try{this.idbdb.close()}catch(e){}this._novip.idbdb=null}e.dbReadyPromise=new Ie((function(t){e.dbReadyResolve=t})),e.openCanceller=new Ie((function(t,n){e.cancelOpen=n}))},e.prototype.close=function(){this._close();var e=this._state;this._options.autoOpen=!1,e.dbOpenError=new te.DatabaseClosed,e.isBeingOpened&&e.cancelOpen(e.dbOpenError)},e.prototype.delete=function(){var e=this,t=arguments.length>0,n=this._state;return new Ie((function(r,o){var i=function(){e.close();var t=e._deps.indexedDB.deleteDatabase(e.name);t.onsuccess=Qe((function(){On(e._deps,e.name),r()})),t.onerror=Xt(o),t.onblocked=e._fireOnBlocked};if(t)throw new te.InvalidArgument("Arguments not allowed in db.delete()");n.isBeingOpened?n.dbReadyPromise.then(i):i()}))},e.prototype.backendDB=function(){return this.idbdb},e.prototype.isOpen=function(){return null!==this.idbdb},e.prototype.hasBeenClosed=function(){var e=this._state.dbOpenError;return e&&"DatabaseClosed"===e.name},e.prototype.hasFailed=function(){return null!==this._state.dbOpenError},e.prototype.dynamicallyOpened=function(){return this._state.autoSchema},Object.defineProperty(e.prototype,"tables",{get:function(){var e=this;return a(this._allTables).map((function(t){return e._allTables[t]}))},enumerable:!1,configurable:!0}),e.prototype.transaction=function(){var e=Cn.apply(this,arguments);return this._transaction.apply(this,e)},e.prototype._transaction=function(e,t,n){var r=this,o=Ae.trans;o&&o.db===this&&-1===e.indexOf("!")||(o=null);var i,a,u=-1!==e.indexOf("?");e=e.replace("!","").replace("?","");try{if(a=t.map((function(e){var t=e instanceof r.Table?e.name:e;if("string"!=typeof t)throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");return t})),"r"==e||"readonly"===e)i="readonly";else{if("rw"!=e&&"readwrite"!=e)throw new te.InvalidArgument("Invalid transaction mode: "+e);i="readwrite"}if(o){if("readonly"===o.mode&&"readwrite"===i){if(!u)throw new te.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");o=null}o&&a.forEach((function(e){if(o&&-1===o.storeNames.indexOf(e)){if(!u)throw new te.SubTransaction("Table "+e+" not included in parent transaction.");o=null}})),u&&o&&!o.active&&(o=null)}}catch(e){return o?o._promise(null,(function(t,n){n(e)})):yt(e)}var s=Kn.bind(null,this,i,a,o,n);return o?o._promise(i,s,"lock"):Ae.trans?lt(Ae.transless,(function(){return r._whenReady(s)})):this._whenReady(s)},e.prototype.table=function(e){if(!f(this._allTables,e))throw new te.InvalidTable("Table "+e+" does not exist");return this._allTables[e]},e}(),Qn="undefined"!=typeof Symbol&&"observable"in Symbol?Symbol.observable:"@@observable",Xn=function(){function e(e){this._subscribe=e}return e.prototype.subscribe=function(e,t,n){return this._subscribe(e&&"function"!=typeof e?e:{next:e,error:t,complete:n})},e.prototype[Qn]=function(){return this},e}();function Jn(e,t){return a(t).forEach((function(n){Ln(e[n]||(e[n]=new Fn),t[n])})),e}function $n(e){var t=!1,n=void 0,r=new Xn((function(r){var o=F(e);var i=!1,u={},s={},c={get closed(){return i},unsubscribe:function(){i=!0,$t.storagemutated.unsubscribe(h)}};r.start&&r.start(c);var l=!1,f=!1;function d(){return a(s).some((function(e){return u[e]&&Un(u[e],s[e])}))}var h=function(e){Jn(u,e),d()&&p()},p=function(){if(!l&&!i){u={};var a={},y=function(t){o&&rt();var n=function(){return nt(e,{subscr:t,trans:null})},r=Ae.trans?lt(Ae.transless,n):n();return o&&r.then(ot,ot),r}(a);f||($t("storagemutated",h),f=!0),l=!0,Promise.resolve(y).then((function(e){t=!0,n=e,l=!1,i||(d()?p():(u={},s=a,r.next&&r.next(e)))}),(function(e){l=!1,t=!1,r.error&&r.error(e),c.unsubscribe()}))}};return p(),c}));return r.hasValue=function(){return t},r.getValue=function(){return n},r}try{Wn={indexedDB:i.indexedDB||i.mozIndexedDB||i.webkitIndexedDB||i.msIndexedDB,IDBKeyRange:i.IDBKeyRange||i.webkitIDBKeyRange}}catch(e){Wn={indexedDB:null,IDBKeyRange:null}}var Zn=Yn;function er(e){var t=tr;try{tr=!0,$t.storagemutated.fire(e)}finally{tr=t}}d(Zn,r(r({},re),{delete:function(e){return new Zn(e,{addons:[]}).delete()},exists:function(e){return new Zn(e,{addons:[]}).open().then((function(e){return e.close(),!0})).catch("NoSuchDatabaseError",(function(){return!1}))},getDatabaseNames:function(e){try{return function(e){var t=e.indexedDB,n=e.IDBKeyRange;return kn(t)?Promise.resolve(t.databases()).then((function(e){return e.map((function(e){return e.name})).filter((function(e){return"__dbnames"!==e}))})):xn(t,n).toCollection().primaryKeys()}(Zn.dependencies).then(e)}catch(e){return yt(new te.MissingAPI)}},defineClass:function(){return function(e){s(this,e)}},ignoreTransaction:function(e){return Ae.trans?lt(Ae.transless,e):e()},vip:Pn,async:function(e){return function(){try{var t=Sn(e.apply(this,arguments));return t&&"function"==typeof t.then?t:Ie.resolve(t)}catch(e){return yt(e)}}},spawn:function(e,t,n){try{var r=Sn(e.apply(n,t||[]));return r&&"function"==typeof r.then?r:Ie.resolve(r)}catch(e){return yt(e)}},currentTransaction:{get:function(){return Ae.trans||null}},waitFor:function(e,t){var n=Ie.resolve("function"==typeof e?Zn.ignoreTransaction(e):e).timeout(t||6e4);return Ae.trans?Ae.trans.waitFor(n):n},Promise:Ie,debug:{get:function(){return N},set:function(e){L(e,"dexie"===e?function(){return!0}:xt)}},derive:y,extend:s,props:d,override:_,Events:Et,on:$t,liveQuery:$n,extendObservabilitySet:Jn,getByKeyPath:O,setByKeyPath:P,delByKeyPath:function(e,t){"string"==typeof t?P(e,t,void 0):"length"in t&&[].map.call(t,(function(t){P(e,t,void 0)}))},shallowClone:j,deepClone:T,getObjectDiff:Mn,cmp:Rt,asap:x,minKey:-1/0,addons:[],connections:gt,errnames:Z,dependencies:Wn,semVer:"3.2.5",version:"3.2.5".split(".").map((function(e){return parseInt(e)})).reduce((function(e,t,n){return e+t/Math.pow(10,2*n)}))})),Zn.maxKey=rn(Zn.dependencies.IDBKeyRange),"undefined"!=typeof dispatchEvent&&"undefined"!=typeof addEventListener&&($t("storagemutated",(function(e){var t;tr||(bt?(t=document.createEvent("CustomEvent")).initCustomEvent("x-storagemutated-1",!0,!0,e):t=new CustomEvent("x-storagemutated-1",{detail:e}),tr=!0,dispatchEvent(t),tr=!1)})),addEventListener("x-storagemutated-1",(function(e){var t=e.detail;tr||er(t)})));var tr=!1;if("undefined"!=typeof BroadcastChannel){var nr=new BroadcastChannel("x-storagemutated-1");"function"==typeof nr.unref&&nr.unref(),$t("storagemutated",(function(e){tr||nr.postMessage(e)})),nr.onmessage=function(e){e.data&&er(e.data)}}else if("undefined"!=typeof self&&"undefined"!=typeof navigator){$t("storagemutated",(function(e){try{tr||("undefined"!=typeof localStorage&&localStorage.setItem("x-storagemutated-1",JSON.stringify({trig:Math.random(),changedParts:e})),"object"==typeof self.clients&&o([],self.clients.matchAll({includeUncontrolled:!0}),!0).forEach((function(t){return t.postMessage({type:"x-storagemutated-1",changedParts:e})})))}catch(e){}})),"undefined"!=typeof addEventListener&&addEventListener("storage",(function(e){if("x-storagemutated-1"===e.key){var t=JSON.parse(e.newValue);t&&er(t.changedParts)}}));var rr=self.document&&navigator.serviceWorker;rr&&rr.addEventListener("message",(function(e){var t=e.data;t&&"x-storagemutated-1"===t.type&&er(t.changedParts)}))}Ie.rejectionMapper=function(e,t){if(!e||e instanceof Q||e instanceof TypeError||e instanceof SyntaxError||!e.name||!ne[e.name])return e;var n=new ne[e.name](t||e.message,e);return"stack"in e&&p(n,"stack",{get:function(){return this.inner.stack}}),n},L(N,xt)},function(e,t,n){var r,o,i;"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self&&self,o=[t,n(6)],void 0===(i="function"==typeof(r=function(e,t){"use strict";var r=n(0);function o(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function i(e){for(var n=1;n<arguments.length;n++){var r=null!=arguments[n]?arguments[n]:{};n%2?o(Object(r),!0).forEach((function(n){(0,t.default)(e,n,r[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):o(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}Object.defineProperty(e,"__esModule",{value:!0}),e.deltaFormat=e.default=void 0,t=r(t);var a={symbols:{sc:"symbol_code",dn:"display_name",bc:"base_currency",bcdn:"base_currency_display_name",qc:"quote_currency",qcdn:"quote_currency_display_name",whe:"white_enabled",cd:"country_disabled",te:"trade_enabled",toa:"trade_open_at",sp:"symbol_partition",w:"weight",ttp:"trade_total_precision",tap:"trade_amount_precision",tpp:"trade_price_precision",fp:"fee_precision",tags:"tags",lr:"leverage_ratio",smlr:"super_margin_leverage_ratio",flr:"funding_leverage_ratio",wr:"withdraw_risk",d:"direction",elr:"etp_leverage_ratio",p1:"partitions_one",p:"partitions",kycrtr:"kycRestrictedTimeRange",kycrc:"kycRestrictedCountry",sm:"spot_margin",ca1ca:"ca1_close_at",ca1oa:"ca1_open_at",ca2ca:"ca2_close_at",ca2oa:"ca2_open_at",castate:"ca_state"},currencies:{cc:"currency_code",dn:"display_name",fn:"full_name",at:"asset_type",wp:"withdraw_precision",ft:"fee_type",dma:"deposit_min_amount",wma:"withdraw_min_amount",sp:"show_precision",w:"weight",qc:"quote_currency",v:"visible",whe:"white_enabled",cd:"country_disabled",de:"deposit_enabled",wed:"withdraw_enabled",cawt:"currency_addr_with_tag",fc:"fast_confirms",sc:"safe_confirms",swd:"suspend_withdraw_desc",wd:"withdraw_desc",sdd:"suspend_deposit_desc",dd:"deposit_desc",svd:"suspend_visible_desc"},marketSymbols:{bc:"base-currency",qc:"quote-currency",sp:"symbol-partition",lr:"leverage_ratio",smlr:"super_margin_leverage_ratio",pp:"price-precision",ap:"amount-precision",vp:"value-precision",minoa:"min-order-amt",maxoa:"max-order-amt",minov:"min-order-value",lominoa:"limit-order-min-order-amt",lomaxoa:"limit-order-max-order-amt",lomaxba:"limit-order-max-buy-amt",lomaxsa:"limit-order-max-sell-amt",smminoa:"sell-market-min-order-amt",smmaxoa:"sell-market-max-order-amt",bmmaxov:"buy-market-max-order-value",at:"api-trading",u:"underlying",mfr:"mgmt-fee-rate",ct:"charge-time",rt:"rebal-time",rthr:"rebal-threshold",in:"init-nav",maxov:"max-order-value",flr:"funding-leverage-ratio",castate:"ca-state",blmlt:"buy-limit-must-less-than",mbormlt:"market-buy-order-rate-must-less-than",msormlt:"market-sell-order-rate-must-less-than",slmgt:"sell-limit-must-greater-than",mbcms:"market-bs-calc-max-scale"},chains:{adt:"addr-deposit-tag",ac:"address-chain",ao:"addr-oneoff",awt:"addr-with-tag",ct:"chain-type",de:"deposit-enable",dma:"deposit-min-amount",dn:"display-name",fc:"fast-confirms",ft:"fee-type",default:"is-default",sc:"safe-confirms",sda:"suspend-deposit-announcement",swa:"suspend-withdraw-announcement",v:"visible",we:"withdraw-enable",wma:"withdraw-min-amount",wp:"withdraw-precision",fn:"full-name"}},u=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";return e.trim().toLowerCase().replace(/[-_]+([a-z])/g,(function(e){return e.slice(-1).toUpperCase()}))};e.default=function(e,t){var n=t.k,r=t.toHump,o=void 0!==r&&r;if("ok"===e.status||e.success){var s=a[n],c=function(e,t,n){var r=n.toHump,o=void 0!==r&&r;return e.map((function(e){var n={};for(var r in e){var i=t[r]||r;o&&(i=u(i)),n[i]=e[r]}return n}))}(e.data||[],s,{toHump:o});return i(i({},e),{},{data:c})}return e},e.deltaFormat=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.full,n=e.data,r=arguments.length>1?arguments[1]:void 0;if(!t){var o=JSON.parse(JSON.stringify(r));return n.reduce((function(e,t){var n=o.find((function(e){return e[code]===t[code]}));return n?Object.assign(n,t):e.push(t),e}),o)}return n}})?r.apply(t,o):r)||(e.exports=i)}])}));
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16), __webpack_require__(243).setImmediate))

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var bind = __webpack_require__(255);
var Axios = __webpack_require__(390);
var defaults = __webpack_require__(150);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(259);
axios.CancelToken = __webpack_require__(403);
axios.isCancel = __webpack_require__(258);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(404);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(150);
var utils = __webpack_require__(29);
var InterceptorManager = __webpack_require__(398);
var dispatchRequest = __webpack_require__(399);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(257);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var transformData = __webpack_require__(400);
var isCancel = __webpack_require__(258);
var defaults = __webpack_require__(150);
var isAbsoluteURL = __webpack_require__(401);
var combineURLs = __webpack_require__(402);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(259);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTO3t7evr6+/v7+zs7O3t7ezs7O7u7v////f39xUKKV4AAAAHdFJOUwDphCBdx6i4qc7OAAABYUlEQVQ4y3WUPU/DMBCGTQNiRWoha4ZKXVsJwVrK0BWmzIiBldCPI7+Ayy9I7t9in78udnpLlHv1+F6fz1bKx+6jhPvlWiUxq4Hj9JrkS/DxeSEPUMV8UYs8NLHOC4xiERaCJPxiq1T4sflryGLLwiYX5ixIq9B2vM2sdIv458s/Twl3WviSwi9i53wVkBAsNJlZxN7t8SZxSvbzNq4d41vtp4UjN6rtIW+XPorBmZdx1g3R3q3H0Wkp4xBzJAgZ4oUM0TVwEglCgjS6uUOCEPFRrdiuQIioNxvce8IhLbFyVLeBsIjOGuGg296iQBgg0/aZ34hFyAlbMz1DRCygi6+VsKURcsJZT8lVLILoVzrYgQtrYWc8kZv3OkV4euxQo0CMMPfXYIT0/hqYeYjGuj5cHJ73QW6/kpdTNH8Rr3PJ3TOlzVGIZ0NenqaST8PThbxSj/6RqdLnp9i9Q/OwDP//O9G3bxYrTzEAAAAASUVORK5CYII="

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var i18n_1 = __webpack_require__(14);
var httpReq_1 = __importDefault(__webpack_require__(23));
var react_virtualized_1 = __webpack_require__(269);
var loading_1 = __importDefault(__webpack_require__(62));
var coin_icon_1 = __importDefault(__webpack_require__(63));
var no_content_1 = __importDefault(__webpack_require__(37));
var math_1 = __webpack_require__(79);
var dayjs_1 = __importDefault(__webpack_require__(151));
var loadedSwapArr = [];
var SwapComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.tabType, tabType = _c === void 0 ? '' : _c, _d = _a.searchVal, searchVal = _d === void 0 ? '' : _d;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var isLogin = globalState.isLogin, hostname = globalState.hostname, locale = globalState.locale, bodyWidth = globalState.bodyWidth;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var t = (0, i18n_1.useTranslation)().t;
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var _e = (0, react_1.useState)(true), loading = _e[0], setLoading = _e[1];
    var _f = (0, react_1.useState)([]), contractList = _f[0], setContractList = _f[1];
    var _g = (0, react_1.useState)([]), swapList = _g[0], setSwapList = _g[1];
    var contractTypeMap = {
        'swap': t('永续'),
        'this_week': t('当周'),
        'next_week': t('次周'),
        'quarter': t('当季'),
        'next_quarter': t('次季'),
    };
    var _h = (0, react_1.useState)([]), newList = _h[0], setNewList = _h[1];
    (0, react_1.useEffect)(function () {
        // 获取合约相关数据
        getSwapList();
    }, []);
    var getSwapList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newList_1, contractInfo, swapContractInfo, linearContractInfo, resList, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    newList_1 = [];
                    contractInfo = httpService.getContractInfo();
                    swapContractInfo = httpService.getSwapContractInfo();
                    linearContractInfo = httpService.getLinearContractInfo({
                        business_type: 'all',
                        trade_partition: 'ALL',
                    });
                    return [4 /*yield*/, Promise.all([contractInfo, swapContractInfo, linearContractInfo])];
                case 1:
                    resList = _a.sent();
                    resList.forEach(function (item) {
                        var status = item.status, data = item.data;
                        if (status === 'ok') {
                            var cArr = data || [];
                            newList_1 = __spreadArray(__spreadArray([], newList_1, true), cArr, true);
                        }
                    });
                    setContractList(newList_1);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log('error :>> ', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getKline();
        var intervalId = setInterval(function () {
            getKline();
        }, 3000);
        return function () { return clearInterval(intervalId); };
    }, [newList]);
    var getKline = function () { return __awaiter(void 0, void 0, void 0, function () {
        var pList_1, resList, sList_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (newList.length === 0) {
                        return [2 /*return*/];
                    }
                    pList_1 = [];
                    // 查询行情数据
                    loadedSwapArr.forEach(function (item) {
                        pList_1.push(getContract(item));
                    });
                    return [4 /*yield*/, Promise.all(pList_1)];
                case 1:
                    resList = _a.sent();
                    sList_1 = __spreadArray([], newList, true);
                    resList.forEach(function (item) {
                        var _a, _b;
                        // 更新当前价格和涨幅
                        var curSymbol = sList_1.find(function (i) { return i.contractShortType === item.contractCode; });
                        if (curSymbol) {
                            curSymbol.close = ((_a = item.symbolInfo) === null || _a === void 0 ? void 0 : _a.close) || ''; // 当前价格
                            curSymbol.range = ((_b = item.symbolInfo) === null || _b === void 0 ? void 0 : _b.range) || ''; // 涨幅
                        }
                    });
                    setSwapList(sList_1);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.log('error :>> ', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        // 如果获取合约交易对失败则不在继续处理
        if (contractList.length === 0) {
            // console.log('获取合约基础数据失败 :>> ');
            return;
        }
        initData();
    }, [contractList]);
    var initData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var favList, _a, success, data, error_3, fav, oldList, swapArr;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    favList = [];
                    if (!isLogin) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.getSwapPairList()];
                case 2:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        favList = data || [];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    console.log('error 查询当前收藏失败:>> ', error_3);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    fav = localStorage.getItem('trading_pair_storage');
                    if (fav) {
                        favList = JSON.parse(fav);
                    }
                    _b.label = 6;
                case 6:
                    oldList = JSON.parse(JSON.stringify(list));
                    swapArr = [];
                    oldList.forEach(function (item) {
                        // 检索交易对中的基础信息
                        var contract = contractList.find(function (i) { return i.contract_short_type === item.contractShortType; });
                        if (contract) {
                            // U本位类型，全仓or逐仓
                            item.marginMode = (contract === null || contract === void 0 ? void 0 : contract.support_margin_mode) || '';
                            item.baseCurrency = ((contract === null || contract === void 0 ? void 0 : contract.symbol) || '').toLowerCase();
                            var type = '';
                            if (contract.contract_type) {
                                type = contractTypeMap[contract.contract_type];
                                item.contractType = contract.contract_type;
                            }
                            var date = '';
                            if (contract.delivery_date) {
                                date = (0, dayjs_1.default)(contract.delivery_date).format('MMDD');
                            }
                            item.contractTypeName = type + date;
                        }
                        // 判断是否已经收藏
                        var fav = favList.find(function (i) { return i.trading_pair === item.contractShortType; });
                        item.fav = fav ? true : false;
                        swapArr.push(item);
                    });
                    setNewList(swapArr);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var goClick = function (val) {
        var _a = val.contractShortType, contractShortType = _a === void 0 ? '' : _a, _b = val.baseCurrency, baseCurrency = _b === void 0 ? '' : _b, contractType = val.contractType, _c = val.marginMode, marginMode = _c === void 0 ? '' : _c;
        if (window.sensors) {
            window.sensors.track('webclick_search_result', {
                keyword: searchVal,
                type: 'click',
                tab: '',
                card: '合约',
                name: contractShortType,
            });
        }
        var base = baseCurrency.toUpperCase();
        var strUrl = '';
        // U本位
        if (contractShortType.includes('USDT')) {
            var cIndex = contractShortType.indexOf('USDT');
            var cCode = contractShortType.substring(0, cIndex + 4);
            // marginMode U本位类型，全仓or逐仓
            var type = marginMode || 'cross';
            strUrl = "/futures/linear_swap/exchange/#contract_code=".concat(cCode, "&contract_type=").concat(contractType, "&type=").concat(type);
        }
        else {
            switch (contractType) {
                // 当周
                case 'this_week':
                // 次周
                case 'next_week':
                // 当季
                case 'quarter':
                // 次季
                case 'next_quarter':
                    strUrl = "/futures/contract/exchange/#symbol=".concat(base, "&contract_type=").concat(contractType);
                    break;
                // 币本位永续
                default:
                    strUrl = "/futures/swap/exchange/#symbol=".concat(base);
                    break;
            }
        }
        var origin = location.origin;
        // 国内域名
        if (origin.includes('www.') && origin !== 'https://www.htx.com') {
            location.href = "".concat(origin.replace('www', 'futures'), "/").concat(locale).concat(strUrl);
        }
        else {
            location.href = "".concat(origin, "/").concat(locale).concat(strUrl);
        }
    };
    // 收藏
    var favClick = function (val) { return __awaiter(void 0, void 0, void 0, function () {
        var newSwapArr, spotObj, success, error_4, success, error_5, fav, favList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window.sensors) {
                        window.sensors.track('webclick_search_result', {
                            keyword: searchVal,
                            type: 'fav',
                            tab: '',
                            card: '合约',
                            name: val.contractShortType,
                        });
                    }
                    newSwapArr = __spreadArray([], swapList, true);
                    spotObj = newSwapArr.find(function (k) { return k.contractShortType === val.contractShortType; });
                    if (!spotObj) {
                        return [2 /*return*/];
                    }
                    if (!isLogin) return [3 /*break*/, 9];
                    if (!val.fav) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.delPair({
                            website: 'CONTRACT',
                            'trading_pair': val.contractShortType,
                        })];
                case 2:
                    success = (_a.sent()).success;
                    if (success) {
                        spotObj.fav = false;
                        // console.log('取消收藏success :>> ');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    console.log('取消收藏error :>> ', error_4);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 8];
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, httpService.addPair({
                            website: 'CONTRACT',
                            'trading_pair': val.contractShortType,
                        })];
                case 6:
                    success = (_a.sent()).success;
                    if (success) {
                        spotObj.fav = true;
                        // console.log('添加收藏success :>> ');
                    }
                    return [3 /*break*/, 8];
                case 7:
                    error_5 = _a.sent();
                    console.log('添加收藏error :>> ', error_5);
                    return [3 /*break*/, 8];
                case 8: return [3 /*break*/, 10];
                case 9:
                    fav = localStorage.getItem('trading_pair_storage');
                    favList = [];
                    if (fav) {
                        favList = JSON.parse(fav);
                    }
                    if (val.fav) {
                        // 取消收藏
                        favList.splice(favList.indexOf(val.contractShortType), 1);
                        spotObj.fav = false;
                    }
                    else {
                        // 添加收藏
                        favList.push({
                            'trading_pair': val.contractShortType,
                            website: 'CONTRACT',
                        });
                        spotObj.fav = true;
                    }
                    localStorage.setItem('trading_pair_storage', JSON.stringify(favList));
                    _a.label = 10;
                case 10:
                    setSwapList(newSwapArr);
                    return [2 /*return*/];
            }
        });
    }); };
    // 查询依据交易对情数据，用于计算涨幅
    var getContract = function (contractCode) { return __awaiter(void 0, void 0, void 0, function () {
        var resultObj, param, searchObj, list_1, _a, close_1, _b, open_1, range, error_6;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 7, , 8]);
                    resultObj = {};
                    param = {
                        period: '1day',
                        size: 1,
                    };
                    if (!contractCode.includes('USDT')) return [3 /*break*/, 2];
                    param['contract_code'] = contractCode;
                    return [4 /*yield*/, httpService.getLinearSwapKline(param)];
                case 1:
                    // U本位
                    resultObj = _c.sent();
                    return [3 /*break*/, 6];
                case 2:
                    if (!contractCode.includes('USD')) return [3 /*break*/, 4];
                    param['contract_code'] = contractCode;
                    return [4 /*yield*/, httpService.getSwapKline(param)];
                case 3:
                    resultObj = _c.sent();
                    return [3 /*break*/, 6];
                case 4:
                    param['symbol'] = contractCode;
                    return [4 /*yield*/, httpService.getCurrencyKline(param)];
                case 5:
                    // 币本位交割
                    resultObj = _c.sent();
                    _c.label = 6;
                case 6:
                    searchObj = {};
                    if (resultObj.status === 'ok' && resultObj.data) {
                        list_1 = resultObj.data || [];
                        if (list_1.length > 0) {
                            searchObj = resultObj.data[0] || {};
                            _a = searchObj.close, close_1 = _a === void 0 ? 0 : _a, _b = searchObj.open, open_1 = _b === void 0 ? 1 : _b;
                            range = 0;
                            if (Object.keys(searchObj).length > 0) {
                                range = close_1 / open_1 - 1;
                                range = (0, math_1.fix)(range * 100, 2);
                            }
                            searchObj = {
                                close: close_1,
                                range: range,
                            };
                        }
                    }
                    return [2 /*return*/, {
                            contractCode: contractCode,
                            symbolInfo: searchObj,
                        }];
                case 7:
                    error_6 = _c.sent();
                    console.log('error :>> ', error_6);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var imgUrl = function (currency) {
        if (currency === void 0) { currency = ''; }
        return "https://huobicfg.s3.amazonaws.com/currency_icon/".concat(currency.toLowerCase(), ".png");
    };
    var rateCss = function (item) {
        if (!(item === null || item === void 0 ? void 0 : item.range)) {
            return '';
        }
        if (Number(item.range) >= 0) {
            return 'up';
        }
        return 'down';
    };
    var listStyle = function () {
        if (bodyWidth < 1024) {
            return { height: '100%' };
        }
        if (swapList.length > 8) {
            // ui设计稿默认高度
            return { height: '480px' };
        }
        return { height: "".concat(swapList.length * 60, "px") };
    };
    var swapDom = function () {
        loadedSwapArr = [];
        if (tabType !== 'all' && loading) {
            return (react_1.default.createElement("div", { className: "loading-wrapper" },
                react_1.default.createElement(loading_1.default, null)));
        }
        if (swapList.length === 0) {
            return react_1.default.createElement(no_content_1.default, null);
        }
        return (react_1.default.createElement("div", { className: "swap-list", style: listStyle() },
            react_1.default.createElement(react_virtualized_1.AutoSizer, { defaultHeight: 60 }, function (_a) {
                var width = _a.width, height = _a.height;
                return (react_1.default.createElement(react_virtualized_1.List, { height: height, width: width, rowCount: swapList.length, rowHeight: 60, rowRenderer: function (_a) {
                        var index = _a.index, style = _a.style;
                        var item = swapList[index];
                        if (item) {
                            if (!loadedSwapArr.includes(item.contractShortType)) {
                                loadedSwapArr.push(item.contractShortType);
                            }
                        }
                        return (react_1.default.createElement("div", { key: index, className: "swap-item", style: style },
                            react_1.default.createElement("div", { className: "icon-symbol", onClick: function () {
                                    goClick(item);
                                } },
                                react_1.default.createElement(coin_icon_1.default, { name: item.baseCurrency, size: 20, img: imgUrl(item.baseCurrency) })),
                            react_1.default.createElement("div", { className: "content", onClick: function () {
                                    goClick(item);
                                } },
                                react_1.default.createElement("div", { className: "info" },
                                    react_1.default.createElement("span", { className: "symbol" }, item.contractCode),
                                    react_1.default.createElement("span", { className: "currency" }, item.contractTypeName)),
                                react_1.default.createElement("div", { className: "price-box" },
                                    react_1.default.createElement("span", { className: "price" }, (item === null || item === void 0 ? void 0 : item.close) || '--'),
                                    react_1.default.createElement("span", { className: "rate ".concat(rateCss(item)) }, (item === null || item === void 0 ? void 0 : item.range) ? "".concat(item.range, "%") : '--'))),
                            react_1.default.createElement("div", { className: "action ".concat(item.fav ? 'action-active' : ''), onClick: function () {
                                    favClick(item);
                                } })));
                    } }));
            })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "swap-content" }, swapDom())));
};
exports.default = (0, react_1.memo)(SwapComponent);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var no_content_1 = __importDefault(__webpack_require__(37));
var coin_icon_1 = __importDefault(__webpack_require__(63));
var FunComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.searchVal, searchVal = _c === void 0 ? '' : _c;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var locale = globalState.locale, _d = globalState.theme, theme = _d === void 0 ? 'dark' : _d;
    var goClick = function (item) {
        var webUrl = item.webUrl, name = item.name, business = item.business;
        if (window.sensors) {
            window.sensors.track('webclick_search_result', {
                keyword: searchVal,
                type: 'click',
                tab: '',
                card: '功能',
                name: name,
            });
        }
        var strUrl = webUrl;
        switch (business) {
            case 'global':
                strUrl = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale, "/").concat(webUrl);
                break;
            case 'futures':
                strUrl = "".concat(location.origin.replace('www', 'futures'), "/").concat(locale, "/").concat(webUrl);
                break;
            case 'learn':
                strUrl = "".concat(location.origin.replace('www', 'learn'), "/").concat(locale, "/").concat(webUrl);
                break;
            default:
                strUrl = webUrl;
                break;
        }
        location.href = strUrl;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, list.length === 0 ? (react_1.default.createElement(no_content_1.default, null)) : (react_1.default.createElement("div", { className: "fun-list" }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "fun-item", onClick: function () {
            goClick(item);
        } },
        react_1.default.createElement("div", { className: "icon-img" }, theme === 'dark' ? (react_1.default.createElement(coin_icon_1.default, { size: 30, img: item.iconNight })) : (react_1.default.createElement(coin_icon_1.default, { size: 30, img: item.icon }))),
        react_1.default.createElement("span", { className: "fun-name" }, (item === null || item === void 0 ? void 0 : item.name) || ''))); })))));
};
exports.default = (0, react_1.memo)(FunComponent);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var coin_icon_1 = __importDefault(__webpack_require__(63));
var no_content_1 = __importDefault(__webpack_require__(37));
var EarnComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.searchVal, searchVal = _c === void 0 ? '' : _c;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var locale = globalState.locale, bodyWidth = globalState.bodyWidth;
    var goClick = function (item) {
        var type = item.type, _a = item.projectId, projectId = _a === void 0 ? '' : _a, _b = item.currency, currency = _b === void 0 ? '' : _b, _c = item.term, term = _c === void 0 ? '' : _c;
        if (window.sensors) {
            window.sensors.track('webclick_search_result', {
                keyword: searchVal,
                type: 'click',
                tab: '',
                card: '赚币',
                name: currency,
            });
        }
        var projectType = null;
        // 0 活期、1 定期、2、新手专享、3大额活期、91 鲨鱼鳍
        switch (type) {
            //0 活期
            case 0:
                projectType = 5;
                break;
            // 1 定期
            case 1:
                projectType = 2;
                break;
            // 2 新手专享
            case 2:
                projectType = 1;
                break;
            // 3 大额活期
            case 3:
                projectType = 8;
                break;
            // 91 鲨鱼鳍
            case 91:
                projectType = 11;
                break;
            default:
                projectType = null;
                break;
        }
        var url = '';
        // PC
        if (bodyWidth > 1024) {
            url = "/financial/earn";
        }
        else {
            // h5
            url = "/financial/earn/h5";
        }
        if (projectType) {
            var origin_1 = location.origin.replace('futures', 'www');
            location.href = "".concat(origin_1, "/").concat(locale).concat(url, "?projectId=").concat(projectId, "&currentProjectType=").concat(projectType, "&day=").concat(term);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, list.length === 0 ? (react_1.default.createElement(no_content_1.default, null)) : (react_1.default.createElement("div", { className: "earn-list" }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "earn-item", onClick: function () {
            goClick(item);
        } },
        react_1.default.createElement("div", { className: "icon-symbol" },
            react_1.default.createElement(coin_icon_1.default, { name: item.currency.toLowerCase(), size: 20, img: "https://huobicfg.s3.amazonaws.com/currency_icon/".concat(item.currency.toLowerCase(), ".png") })),
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("div", { className: "info" },
                react_1.default.createElement("span", { className: "symbol" }, item.currency),
                react_1.default.createElement("span", { className: "type" },
                    item.typeName,
                    item.tagImageUrl ? react_1.default.createElement("img", { src: item.tagImageUrl, alt: "" }) : '')),
            react_1.default.createElement("div", { className: "rate" },
                react_1.default.createElement("span", { className: "value" },
                    (item === null || item === void 0 ? void 0 : item.rate) || '-',
                    react_1.default.createElement("em", null, "%")),
                react_1.default.createElement("span", { className: "txt" }, "APY"))))); })))));
};
exports.default = (0, react_1.memo)(EarnComponent);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var no_content_1 = __importDefault(__webpack_require__(37));
var dayjs_1 = __importDefault(__webpack_require__(151));
var NewsComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.searchVal, searchVal = _c === void 0 ? '' : _c;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var locale = globalState.locale;
    var goClick = function (item) {
        var id = item.id, type = item.type, title = item.title;
        if (window.sensors) {
            window.sensors.track('webclick_search_result', {
                keyword: searchVal,
                type: 'click',
                tab: '',
                card: '资讯',
                name: title,
            });
        }
        var strUrl = '';
        switch (type) {
            // 快讯
            case 2:
                strUrl = "/feed/news/".concat(id, "/");
                break;
            // 长文
            case 3:
                strUrl = "/feed/articles/".concat(id, "/");
                break;
            // 动态
            case 4:
                strUrl = "/feed/community/".concat(id, "/");
                break;
            default:
                strUrl = '';
                break;
        }
        if (strUrl) {
            location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale).concat(strUrl);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, list.length === 0 ? (react_1.default.createElement(no_content_1.default, null)) : (react_1.default.createElement("div", { className: "news-list" }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "item", onClick: function () {
            goClick(item);
        } },
        react_1.default.createElement("div", { className: "name" }, item.title),
        react_1.default.createElement("div", { className: "time" }, (0, dayjs_1.default)(item.date).format('YYYY-MM-DD HH:mm')))); })))));
};
exports.default = (0, react_1.memo)(NewsComponent);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var no_content_1 = __importDefault(__webpack_require__(37));
var dayjs_1 = __importDefault(__webpack_require__(151));
var NoticeComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.searchVal, searchVal = _c === void 0 ? '' : _c;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var locale = globalState.locale;
    var goClick = function (item) {
        var id = item.id, title = item.title;
        if (window.sensors) {
            window.sensors.track('webclick_search_result', {
                keyword: searchVal,
                type: 'click',
                tab: '',
                card: '公告',
                name: title,
            });
        }
        location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale, "/support/").concat(id);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, list.length === 0 ? (react_1.default.createElement(no_content_1.default, null)) : (react_1.default.createElement("div", { className: "news-list" }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "item", onClick: function () {
            goClick(item);
        } },
        react_1.default.createElement("div", { className: "name" }, item.title),
        react_1.default.createElement("div", { className: "time" }, (0, dayjs_1.default)(item.createdTime).format('YYYY-MM-DD HH:mm')))); })))));
};
exports.default = (0, react_1.memo)(NoticeComponent);


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var no_content_1 = __importDefault(__webpack_require__(37));
var math_1 = __webpack_require__(79);
var i18n_1 = __webpack_require__(14);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var LiveComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.searchVal, searchVal = _c === void 0 ? '' : _c;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var isLogin = globalState.isLogin, locale = globalState.locale, bodyWidth = globalState.bodyWidth, hostname = globalState.hostname;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var t = (0, i18n_1.useTranslation)().t;
    var _d = (0, react_1.useState)(list), liveList = _d[0], setLiveList = _d[1];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var goClick = function (item, type) {
        if (type === void 0) { type = ''; }
        return __awaiter(void 0, void 0, void 0, function () {
            var url, status, appointed, id, title, origin_1, newList, uObj, _a, success, data, error_1, _b, success, data, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = '';
                        status = item.status, appointed = item.appointed, id = item.id, title = item.title;
                        if (window.sensors) {
                            window.sensors.track('webclick_search_result', {
                                keyword: searchVal,
                                type: 'click',
                                tab: '',
                                card: '直播',
                                name: title,
                            });
                        }
                        if (!(status === 1)) return [3 /*break*/, 11];
                        if (!(type === 'appoint')) return [3 /*break*/, 9];
                        // 未登录，先登录
                        if (!isLogin) {
                            origin_1 = location.origin.replace('futures', 'www');
                            location.href = "".concat(origin_1, "/").concat(locale, "/login/?backUrl=").concat(location.href);
                            return [2 /*return*/];
                        }
                        newList = __spreadArray([], liveList, true);
                        uObj = newList.find(function (u) { return u.id === id; });
                        if (!(appointed === 0)) return [3 /*break*/, 5];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, httpService.setAppoint({ liveId: id })];
                    case 2:
                        _a = _c.sent(), success = _a.success, data = _a.data;
                        if (success) {
                            uObj.appointed = 1;
                            // console.log('预约success :>> ', data);
                        }
                        else {
                            console.log('预约fail :>> ');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        console.log('error :>> ', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, httpService.cancelAppoint({ liveId: id })];
                    case 6:
                        _b = _c.sent(), success = _b.success, data = _b.data;
                        if (success) {
                            uObj.appointed = 0;
                            // console.log('取消预约success :>> ', data);
                        }
                        else {
                            console.log('取消预约fail :>> ');
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        error_2 = _c.sent();
                        console.log('error :>> ', error_2);
                        return [3 /*break*/, 8];
                    case 8:
                        setLiveList(newList);
                        return [3 /*break*/, 10];
                    case 9:
                        // PC
                        if (bodyWidth > 1024) {
                            url = "/stream/".concat(id, "/"); // h5
                        }
                        else {
                            url = "/live/detail/h5?id=".concat(id, "&inviter_id=&invite_code=");
                        }
                        location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale).concat(url);
                        _c.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        // PC
                        if (bodyWidth > 1024) {
                            url = "/stream/".concat(id, "/"); // h5
                        }
                        else {
                            url = "/live/detail/h5?id=".concat(id, "&inviter_id=&invite_code=");
                        }
                        location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale).concat(url);
                        _c.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    var renderTagDom = function (item) {
        var cssTag = '';
        var strTxt = '';
        // 直播状态 1 预约中 2 直播中 3 直播结束
        switch (item.status) {
            case 1:
                cssTag = 'unstart';
                strTxt = t('#num#预约').replace('#num#', (0, math_1.numFormat)(item.appointedNum) || '--');
                break;
            case 2:
                cssTag = 'live';
                strTxt = t('#num#观看').replace('#num#', (0, math_1.numFormat)(item.onlineNum) || '--');
                break;
            case 3:
                cssTag = 'live-end';
                strTxt = t('#num#回放').replace('#num#', (0, math_1.numFormat)(item.onlineNum) || '--');
                break;
            default:
                strTxt = '';
                break;
        }
        return (react_1.default.createElement("div", { className: "tag-wrapper" },
            react_1.default.createElement("div", { className: "tag-container ".concat(cssTag) },
                react_1.default.createElement("span", { className: "tag" }),
                react_1.default.createElement("span", { className: "txt" }, strTxt))));
    };
    var renderStatusDom = function (item) {
        // 直播状态 1 预约中 2 直播中 3 直播结束
        var status = '';
        switch (item.status) {
            case 1:
                status = t('预约');
                break;
            case 2:
                status = t('看直播');
                break;
            case 3:
                status = t('看回放');
                break;
            default:
                status = '';
                break;
        }
        return status;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, liveList.length === 0 ? (react_1.default.createElement(no_content_1.default, null)) : (react_1.default.createElement("div", { className: "live-list" }, liveList.map(function (item, index) {
        var _a;
        return (react_1.default.createElement("div", { key: index, className: "live-item" },
            react_1.default.createElement("div", { className: "live-container", onClick: function () {
                    goClick(item);
                } },
                react_1.default.createElement("img", { src: item.coverImageUrl }),
                renderTagDom(item)),
            react_1.default.createElement("div", { className: "live-content" },
                react_1.default.createElement("div", { className: "title" }, item.title),
                react_1.default.createElement("div", { className: "desc" },
                    react_1.default.createElement("div", { className: "speaker" },
                        react_1.default.createElement("div", { className: "nick-name" },
                            "#",
                            ((_a = item.speakerList[0]) === null || _a === void 0 ? void 0 : _a.nickName) || '')),
                    react_1.default.createElement("div", { className: "action ".concat(item.appointed === 1 ? 'disable-action' : ''), onClick: function () {
                            goClick(item, 'appoint');
                        } },
                        react_1.default.createElement("span", null, renderStatusDom(item)),
                        react_1.default.createElement("div", { className: "action-arrow" }))))));
    })))));
};
exports.default = (0, react_1.memo)(LiveComponent);


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var no_content_1 = __importDefault(__webpack_require__(37));
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var i18n_1 = __webpack_require__(14);
var coin_icon_1 = __importDefault(__webpack_require__(63));
var utils_1 = __importDefault(__webpack_require__(20));
var UserComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.searchVal, searchVal = _c === void 0 ? '' : _c;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var isLogin = globalState.isLogin, hostname = globalState.hostname, locale = globalState.locale, bodyWidth = globalState.bodyWidth;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var t = (0, i18n_1.useTranslation)().t;
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var _d = (0, react_1.useState)(list), userList = _d[0], setUserList = _d[1];
    var goClick = function (item) {
        var _a = item.uidUnique, uidUnique = _a === void 0 ? '' : _a, _b = item.nickname, nickname = _b === void 0 ? '' : _b;
        if (window.sensors) {
            window.sensors.track('webclick_search_result', {
                keyword: searchVal,
                type: 'click',
                tab: '',
                card: '用户',
                name: nickname,
            });
        }
        var url = '';
        // PC
        if (bodyWidth > 1024) {
            url = "/views/profile/?uidUnique=".concat(uidUnique, "&invite_code=undefined");
        }
        else {
            url = "/live/community/dynamic/h5?uidUnique=".concat(uidUnique, "&inviter_id=&invite_code="); // h5
        }
        location.href = "".concat(location.origin.replace('futures', 'www'), "/").concat(locale).concat(url);
    };
    var followClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var origin_1, _a, uidUnique, _b, nickname, careState, newUserList, userObj, type, success, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // 未登录，先登录
                    if (!isLogin) {
                        origin_1 = location.origin.replace('futures', 'www');
                        location.href = "".concat(origin_1, "/").concat(locale, "/login/?backUrl=").concat(location.href);
                        return [2 /*return*/];
                    }
                    _a = item.uidUnique, uidUnique = _a === void 0 ? '' : _a, _b = item.nickname, nickname = _b === void 0 ? '' : _b, careState = item.careState;
                    if (window.sensors) {
                        window.sensors.track('webclick_search_result', {
                            keyword: searchVal,
                            type: 'follow',
                            tab: '',
                            card: '用户',
                            name: nickname,
                        });
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    newUserList = __spreadArray([], userList, true);
                    userObj = newUserList.find(function (k) { return k.uidUnique === uidUnique; });
                    if (!userObj) {
                        return [2 /*return*/];
                    }
                    type = 1;
                    // 未关注
                    if (careState === 0) {
                        type = 1;
                    }
                    else {
                        type = 0;
                    }
                    return [4 /*yield*/, httpService.followUser({
                            uidUnique: uidUnique,
                            type: type,
                        })];
                case 2:
                    success = (_c.sent()).success;
                    if (success) {
                        userObj.careState = type;
                        // 直接对粉丝数进行操作，不重新调用api
                        if (type === 1) {
                            userObj.fansNum = (userObj === null || userObj === void 0 ? void 0 : userObj.fansNum) ? userObj.fansNum + 1 : 1;
                        }
                        else {
                            userObj.fansNum = userObj.fansNum === 0 ? 0 : userObj.fansNum - 1;
                        }
                        // console.log('关注success :>> ');
                    }
                    setUserList(newUserList);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.log('关注操作error :>> ', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null, userList.length === 0 ? (react_1.default.createElement(no_content_1.default, null)) : (react_1.default.createElement("div", { className: "user-list" }, userList.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "user-item" },
        react_1.default.createElement("div", { className: "icon-user-img", onClick: function () {
                goClick(item);
            } },
            react_1.default.createElement(coin_icon_1.default, { size: 24, img: item.avatar, defaultImg: utils_1.default.getUserIcon() })),
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("div", { className: "user-desc", onClick: function () {
                    goClick(item);
                } },
                react_1.default.createElement("div", { className: "name" }, item.nickname),
                react_1.default.createElement("div", { className: "fans" }, t('#num#粉丝').replace('#num#', (item === null || item === void 0 ? void 0 : item.fansNum) || '--'))),
            react_1.default.createElement("div", { className: "action" },
                react_1.default.createElement("div", { className: "button ".concat(item.careState === 0 ? 'blue-button' : ''), onClick: function () {
                        followClick(item);
                    } },
                    react_1.default.createElement("span", null, item.careState === 0 ? t('关注') : t('已关注'))))))); })))));
};
exports.default = (0, react_1.memo)(UserComponent);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var coin_icon_1 = __importDefault(__webpack_require__(63));
var math_1 = __webpack_require__(79);
var PoloniexComponent = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, _c = _a.searchVal, searchVal = _c === void 0 ? '' : _c;
    var fixData = function (val) {
        return (0, math_1.fix)(val, 2);
    };
    var goClick = function (val) {
        var _a = val.baseCurrency, baseCurrency = _a === void 0 ? '' : _a, _b = val.quoteCurrency, quoteCurrency = _b === void 0 ? '' : _b;
        var symbolCode = "".concat(baseCurrency, "_").concat(quoteCurrency);
        if (window.sensors) {
            window.sensors.track('webclick_search_result', {
                keyword: searchVal,
                type: 'click',
                tab: '',
                card: 'poloniex',
                name: symbolCode,
            });
        }
        window.open("https://poloniex.com/trade/".concat(symbolCode.toUpperCase(), "?type=spot"), '_blank');
    };
    var imgUrl = function (currency) {
        if (currency === void 0) { currency = ''; }
        return "https://huobicfg.s3.amazonaws.com/currency_icon/".concat(currency.toLowerCase(), ".png");
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "poloniex-list" }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: "poloniex-item", onClick: function () {
                goClick(item);
            } },
            react_1.default.createElement("div", { className: "icon-symbol" },
                react_1.default.createElement(coin_icon_1.default, { name: item.symbol, size: 20, img: imgUrl(item.symbol) })),
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("div", { className: "info" },
                    react_1.default.createElement("span", { className: "symbol" }, ((item === null || item === void 0 ? void 0 : item.baseCurrency) || '').toUpperCase()),
                    react_1.default.createElement("span", { className: "currency" },
                        "/",
                        ((item === null || item === void 0 ? void 0 : item.quoteCurrency) || '').toUpperCase())),
                react_1.default.createElement("div", { className: "price-box" },
                    react_1.default.createElement("span", { className: "price" }, item.price),
                    item.upDown && (react_1.default.createElement("span", { className: "rate ".concat(Number(item.upDown) < 0 ? 'down' : '') },
                        fixData(item.upDown),
                        "%")))))); }))));
};
exports.default = (0, react_1.memo)(PoloniexComponent);


/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjgzMzQgOC4yMTY0MUMxMi44MzM0IDExLjM1MiAxMC4yMjE3IDEzLjg5NCA3LjAwMDA4IDEzLjg5NEMzLjc3ODQyIDEzLjg5NCAxLjE2Njc1IDExLjM1MiAxLjE2Njc1IDguMjE2NDFDMS4xNjY3NSAzLjczNTI5IDUuNTQxNzUgNC4zNjM5NyA3LjAwMDA4IDAuMTA1ODE3QzEwLjc0OSAxLjc4Njg4IDcuNjE2NTggNS4yMTU2MiA5LjE4NzU4IDYuMDg3MzRDMTAuMTMwOCA2LjYxMDcgMTEuMTMyNiA1LjQ2NDc0IDExLjM3NTEgNC40NjA5N0MxMi4yODI3IDUuNDYxODMgMTIuODMzNCA2Ljc3NjUyIDEyLjgzMzQgOC4yMTY0MVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl85XzMxNTgpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfOV8zMTU4IiB4MT0iMS4xNjY3NSIgeTE9IjE0LjQyNDMiIHgyPSIxLjE2Njc1IiB5Mj0iMC42MzYzODMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0ZGMzMzMyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRjc3MzMiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNTgzMjUyIDNDMC41ODMyNTIgMS4zNDMxNSAxLjkyNjQgMCAzLjU4MzI1IDBIMTAuNDE2NkMxMi4wNzM0IDAgMTMuNDE2NiAxLjM0MzE1IDEzLjQxNjYgM1Y4LjY2NjY2QzEzLjQxNjYgMTAuMzIzNSAxMi4wNzM0IDExLjY2NjcgMTAuNDE2NiAxMS42NjY3SDkuNDE5ODhMNy42OTQwMSAxMy4zMzA4QzcuMzA2NjUgMTMuNzA0MiA2LjY5MzE4IDEzLjcwNDMgNi4zMDU4MSAxMy4zMzA4TDQuNTc5ODggMTEuNjY2N0gzLjU4MzI1QzEuOTI2NCAxMS42NjY3IDAuNTgzMjUyIDEwLjMyMzUgMC41ODMyNTIgOC42NjY2N1YzWiIgZmlsbD0iIzE2Qzg2OCIvPgo8cmVjdCB4PSI0LjA4MzUiIHk9IjIuOTE2NzUiIHdpZHRoPSIxLjc1IiBoZWlnaHQ9IjUuODMzMzMiIGZpbGw9IiMxQjIwMkUiLz4KPHJlY3QgeD0iOC4xNjY3NSIgeT0iMi45MTY3NSIgd2lkdGg9IjEuNzUiIGhlaWdodD0iNS44MzMzMyIgZmlsbD0iIzFCMjAyRSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMDgzNSAyLjkxNjc1SDUuODM3OTVMOS45MTc5NyA4LjE4OTAzVjguNzUwMUg4LjEzOTM1TDQuMDgzNSAzLjUwOTA0VjIuOTE2NzVaIiBmaWxsPSIjMUIyMDJFIi8+Cjwvc3ZnPgo="

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var throttle_debounce_1 = __webpack_require__(149);
var i18n_1 = __webpack_require__(14);
var list_1 = __importDefault(__webpack_require__(250));
var prompt_1 = __importDefault(__webpack_require__(260));
var hot_1 = __importDefault(__webpack_require__(261));
var intervalId;
exports.default = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? '' : _b;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale, bodyWidth = globalState.bodyWidth;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var t = (0, i18n_1.useTranslation)().t;
    // 重置数据
    var resetData = function () {
        setSearchVal('');
        // 查询热搜词
        getSearch();
        setComponentType('0');
    };
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        resetData: resetData,
    }); });
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    // 热搜词
    var _c = (0, react_1.useState)(''), hotWordVal = _c[0], setHotWordVal = _c[1];
    var _d = (0, react_1.useState)([]), hotWordList = _d[0], setHotWordList = _d[1];
    // 是否聚焦
    var _e = (0, react_1.useState)(false), isFocus = _e[0], setIsFocus = _e[1];
    // 直接搜索
    var _f = (0, react_1.useState)(false), isSearch = _f[0], setIsSearch = _f[1];
    // 当前显示的列表
    var _g = (0, react_1.useState)(type), componentType = _g[0], setComponentType = _g[1];
    // 推荐值，防抖后
    var _h = (0, react_1.useState)(''), promptVal = _h[0], setPromptVal = _h[1];
    // 搜索输入值
    var _j = (0, react_1.useState)(''), searchVal = _j[0], setSearchVal = _j[1];
    var searchRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        // 热搜词列表
        getSearch();
        // 除了点击自己，点击其他地方将自身隐藏
        document.addEventListener('click', function (e) {
            // @ts-ignore
            var id = e.target.id;
            if (['search_input', 'search_icon', 'search_clear', 'pre_page', 'next_page'].includes(id)) {
                return;
            }
            setIsFocus(false);
        });
    }, []);
    var searchChange = (0, throttle_debounce_1.debounce)(350, function (val) {
        if (val) {
            if (isFocus) {
                setComponentType('2');
            }
            if (isSearch) {
                setComponentType('1');
            }
        }
        setPromptVal(val);
    }, false);
    (0, react_1.useEffect)(function () {
        searchChange(searchVal);
    }, [searchVal, isSearch, isFocus]);
    (0, react_1.useEffect)(function () {
        setTimer();
    }, [hotWordList]);
    var getSearch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpService.getHotWordList()];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setHotWordList((data === null || data === void 0 ? void 0 : data.hotWords) || []);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.log('error :>> ', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var setTimer = function () {
        if (hotWordList.length > 0) {
            // 默认第一个
            var hotIndex_1 = 0;
            setHotWordVal(hotWordList[hotIndex_1]);
            // 每隔6秒轮播下一个
            intervalId = setInterval(function () {
                hotIndex_1++;
                if (hotIndex_1 > hotWordList.length - 1) {
                    hotIndex_1 = 0;
                }
                setHotWordVal(hotWordList[hotIndex_1]);
            }, 6000);
        }
    };
    // 搜索
    var searchClick = function () {
        setIsSearch(true);
        if (!searchVal) {
            setSearchVal(hotWordVal);
        }
        // 回车，直接点击等操作，输入框无值时，使用推荐的值
        setPromptVal(searchVal || hotWordVal);
        setComponentType('1');
    };
    // 触发焦点
    var focusHandler = function () {
        setIsFocus(true);
        clearTimer();
    };
    // 离开焦点
    var blurHandler = function () {
        setTimer();
    };
    var keyDownHandler = function (e) {
        if (e.keyCode === 13) {
            searchClick();
        }
    };
    // 清空
    var clearClick = function () {
        setSearchVal('');
        setComponentType('0');
        // @ts-ignore
        searchRef === null || searchRef === void 0 ? void 0 : searchRef.current.focus(); // 设置焦点
    };
    // 回调
    var inputText = function (val) {
        setIsSearch(true);
        setSearchVal(val);
    };
    var clearTimer = function () {
        if (intervalId) {
            clearInterval(intervalId);
        }
    };
    var searchDom = function () {
        var component = null;
        switch (componentType) {
            case '0':
                component = react_1.default.createElement(hot_1.default, { searchVal: promptVal });
                break;
            case '1':
                component = react_1.default.createElement(list_1.default, { searchVal: promptVal });
                break;
            case '2':
                component = react_1.default.createElement(prompt_1.default, { searchVal: promptVal, onInputText: inputText });
                break;
            default:
                component = '';
                break;
        }
        return component;
    };
    return (react_1.default.createElement("div", { className: "hbg_small-search-wrapper" },
        react_1.default.createElement("div", { className: "hbg-search-container" },
            react_1.default.createElement("div", { className: "search-input-wrapper" },
                react_1.default.createElement("div", { className: "search-input-container" },
                    react_1.default.createElement("div", { className: "search__icon", id: "search_icon", onClick: function () {
                            searchClick();
                        } }),
                    react_1.default.createElement("div", { className: "search__input" },
                        react_1.default.createElement("input", { ref: searchRef, id: "search_input", type: "text", autoCapitalize: "off", autoComplete: "off", autoCorrect: "off", placeholder: hotWordVal, value: searchVal, onChange: function (e) {
                                setIsSearch(false);
                                setSearchVal(e.target.value);
                            }, onFocus: focusHandler, onBlur: blurHandler, onKeyDown: keyDownHandler })),
                    searchVal && isFocus && (react_1.default.createElement("div", { className: "clear__icon", id: "search_clear", onClick: function () {
                            clearClick();
                        } }))),
                bodyWidth < 1025 && (react_1.default.createElement("div", { className: "search__txt", onClick: function () {
                        searchClick();
                    } }, t('搜索')))),
            react_1.default.createElement("div", { className: "search__box" }, searchDom()))));
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var httpReq_1 = __importDefault(__webpack_require__(23));
var localStorage_1 = __importDefault(__webpack_require__(67));
exports.default = (function (_a) {
    var _b = _a.active, active = _b === void 0 ? '' : _b, onSetCurrencys = _a.onSetCurrencys;
    var t = (0, i18n_1.useTranslation)().t;
    var _c = (0, react_1.useContext)(context_1.HeaderContext), globalState = _c.globalState, dispatch = _c.dispatch;
    var localeRate = globalState.localeRate, hostname = globalState.hostname, locale = globalState.locale, isLogin = globalState.isLogin;
    var localCurrencysList = globalState.localCurrencysList;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var setFiat = function (event, abbr) {
        dispatch({
            type: 'update:localRate',
            localRate: abbr,
        });
        localStorage_1.default.setItem('exchangeRate', "".concat(abbr.toLowerCase(), "/2"));
        // onfiat(event, abbr);
    };
    var gotoFiat = function ($event, abbr) {
        if ($event === void 0) { $event = null; }
        if (abbr === void 0) { abbr = ''; }
        return __awaiter(void 0, void 0, void 0, function () {
            var success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof $event.preventDefault === 'function') {
                            $event.preventDefault();
                        }
                        if (localeRate === abbr) {
                            return [2 /*return*/];
                        }
                        abbr = abbr.toLowerCase();
                        if (!isLogin) return [3 /*break*/, 2];
                        return [4 /*yield*/, httpService.kvSet({
                                store_key: 'CONVERSION_CURRENCY',
                                store_value: abbr.toUpperCase(),
                            })];
                    case 1:
                        success = (_a.sent()).success;
                        if (success) {
                            setFiat($event, abbr);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        setFiat($event, abbr);
                        _a.label = 3;
                    case 3:
                        onSetCurrencys && onSetCurrencys($event, abbr);
                        return [2 /*return*/];
                }
            });
        });
    };
    return (react_1.default.createElement("div", { className: "hb-menu-dropdown__body__item--multi hbg-currencys", style: { overflow: 'auto' } },
        react_1.default.createElement("div", { className: "hb-menu-dropdown__body__item__sub" }, t('折算货币')),
        react_1.default.createElement("div", { className: "hb-menu-dropdown__body__items" }, localCurrencysList.map(function (item) {
            return (react_1.default.createElement("div", { key: item.abbr, className: "hb-menu-dropdown__body__item ".concat(active === item.abbr.toLowerCase() ? 'active' : ''), onClick: function (event) {
                    gotoFiat(event, item.abbr);
                } },
                react_1.default.createElement("div", { className: "body__item__txt" }, "".concat(item.symbol, " ").concat(item.abbr.toUpperCase()))));
        }))));
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(31));
var context_1 = __webpack_require__(7);
var hooks_1 = __webpack_require__(22);
var i18n_1 = __webpack_require__(14);
var url_1 = __webpack_require__(18);
var localStorage_1 = __importDefault(__webpack_require__(67));
var httpReq_1 = __importDefault(__webpack_require__(23));
var sensors_1 = __webpack_require__(27);
var math_1 = __webpack_require__(79);
var finance_item_1 = __importDefault(__webpack_require__(420));
var rate_1 = __webpack_require__(421);
var BalanceListDefault = [
    { distributionType: '1' },
    { distributionType: '2' },
    { distributionType: '3' },
    { distributionType: '4' },
    { distributionType: '5' },
    { distributionType: '6' },
    { distributionType: '7' },
];
exports.default = (function (_a) {
    var onAssetEyeChange = _a.onAssetEyeChange;
    var t = (0, i18n_1.useTranslation)().t;
    var _b = (0, react_1.useContext)(context_1.HeaderContext).globalState, hasProToken = _b.hasProToken, hostname = _b.hostname, locale = _b.locale, localRate = _b.localRate, localCurrencysList = _b.localCurrencysList, assetsVisible = _b.assetsVisible;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    // 资产是否可见
    var _c = (0, react_1.useState)(null), canSee = _c[0], setCanSee = _c[1];
    var _d = (0, react_1.useState)(null), detail = _d[0], setData = _d[1];
    var _e = (0, react_1.useState)([]), fiatRateList = _e[0], setFiatRateList = _e[1];
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var woodpecker, _a, success, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    woodpecker = window.woodpecker;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.getBalanceAssets()];
                case 2:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setData(data);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    woodpecker && woodpecker.metrics && woodpecker.metrics.gauge('header-finance-data', 1, error_1);
                    console.log('error :>> ', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (assetsVisible === null) {
            return;
        }
        setCanSee(assetsVisible);
        localStorage_1.default.setItem('fed-header:eye', assetsVisible ? 'open' : 'close');
    }, [assetsVisible]);
    // 获取资产数据
    (0, react_1.useEffect)(function () {
        if (hasProToken) {
            getData();
        }
    }, [hasProToken]);
    // 获取换算列表
    var getFiatList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var woodpecker, _a, success, data, error_2, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    woodpecker = window.woodpecker;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.getExchangeRate()];
                case 2:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setFiatRateList(data);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    data = rate_1.getRateList.data;
                    setFiatRateList(data || []);
                    woodpecker && woodpecker.metrics && woodpecker.metrics.gauge('header-finance-rate', 1, error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var eye = localStorage_1.default.getItem('fed-header:eye') !== 'close';
        setCanSee(eye);
        setAssetsVisible(eye);
    }, []);
    // 获取换算数据
    (0, react_1.useEffect)(function () {
        getFiatList();
    }, [localRate]);
    // 点击眼睛
    var onClickEye = function (event) {
        event.stopPropagation();
        var s = !canSee;
        setAssetsVisible(s);
        setCanSee(s);
    };
    // 点击眼睛
    var setAssetsVisible = function (data) {
        localStorage_1.default.setItem('fed-header:eye', data ? 'open' : 'close');
        onAssetEyeChange && onAssetEyeChange(data);
    };
    // 点击查看
    var onClickViewPL = function () {
        var url = (0, url_1.getUrl)({
            path: '/finance/analysis',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'asset',
            type: 'click',
        });
        location.href = url;
    };
    var fiatRate = (0, react_1.useMemo)(function () {
        if (localRate) {
            if (localRate === 'usd') {
                return 1;
            }
            var obj = fiatRateList.find(function (item) { return item.name === "usd_".concat(localRate); });
            if (obj) {
                return obj.rate;
            }
            return null;
        }
        return null;
    }, [fiatRateList, localRate]);
    // 法币显示的单位和精度
    var fixPer = (0, react_1.useMemo)(function () {
        var _a = localCurrencysList.filter(function (item) { return item.abbr.toLowerCase() === localRate; })[0], rateObj = _a === void 0 ? {} : _a;
        var _b = rateObj || {}, _c = _b.fix, fix = _c === void 0 ? 2 : _c, _d = _b.symbol, symbol = _d === void 0 ? '$' : _d, _e = _b.abbr, abbr = _e === void 0 ? 'usd' : _e;
        return { fix: fix, symbol: symbol };
    }, [localRate]);
    var fiatTrans = function (n) {
        if (!n) {
            return '--';
        }
        if (fiatRate) {
            var total = (0, math_1.mul)(n, fiatRate);
            total = (0, math_1.fix)(total, fixPer.fix);
            return (0, math_1.numHandle)(total, fixPer.symbol);
        }
        else {
            return (0, math_1.numHandle)(n, '$');
        }
    };
    // 全部资产
    var totalBalanceUsdt = (0, react_1.useMemo)(function () {
        var totalBalanceUsdt = (detail || {}).totalBalanceUsdt;
        return fiatTrans(totalBalanceUsdt);
    }, [detail, localRate, fiatRateList]);
    // 今天收益
    var todayProfit = (0, react_1.useMemo)(function () {
        var todayProfit = (detail || {}).todayProfit;
        return fiatTrans(todayProfit);
    }, [detail, localRate, fiatRateList]);
    // 点击查看账户
    var onClickViewAcc = function () {
        var url = (0, url_1.getUrl)({
            path: '/finance/account',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'asset',
            type: 'click',
        });
        location.href = url;
    };
    var onClickOtc = function (type) {
        var btnName = '';
        var urlPath = '';
        switch (type) {
            case 1:
                btnName = '充币';
                urlPath = '/finance/deposit/usdt';
                break;
            case 2:
                btnName = '提币';
                urlPath = '/finance/withdraw/';
                break;
            case 3:
                btnName = '划转';
                urlPath = '/finance/transfer/';
                break;
            default:
                btnName = '储备金证明报告';
                urlPath = '/finance/account/audit';
                break;
        }
        var url = (0, url_1.getUrl)({
            path: urlPath,
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: btnName,
            type: 'click',
        });
        location.href = url;
    };
    return (react_1.default.createElement("div", { className: "hbg-finance-dropdown", style: { width: '352px' } },
        // 合约账号维护
        detail && detail.messageList && detail.messageList.length ? (react_1.default.createElement("div", { className: "hbg-finance-tips" },
            react_1.default.createElement("div", { className: "hbg-finance-tips_val" },
                react_1.default.createElement("i", null),
                react_1.default.createElement("div", { className: "hbg-finance-tips_val-box" }, detail.messageList.map(function (item, index) {
                    return react_1.default.createElement("p", { key: index }, item);
                }))))) : null,
        react_1.default.createElement("div", { className: "hbg-finance-v2" },
            react_1.default.createElement("div", { className: "hbg-finance-v2__title-bar", onClick: onClickViewAcc },
                react_1.default.createElement("span", { className: "hbg-finance-v2__title" }, t('我的资产')),
                react_1.default.createElement("i", { className: "hbg-finance-v2__eye ".concat((0, classnames_1.default)({
                        'hbg-finance-v2__eye--close': !canSee,
                    })), onClick: onClickEye }),
                react_1.default.createElement("i", { className: "fed-icon__arrow--right" })),
            react_1.default.createElement("div", { className: "hbg-finance-v2__assets" },
                react_1.default.createElement("div", { className: "hbg-finance-v2__assets-val" }, canSee ? totalBalanceUsdt : '*****'),
                react_1.default.createElement("div", { className: "hbg-finance-v2__assets-pl" },
                    react_1.default.createElement("div", { className: "hbg-finance-v2__assets-pl-title" }, t('Today’s P/L')),
                    react_1.default.createElement("div", { className: "hbg-finance-v2__assets-pl-val" }, canSee ? todayProfit : '*****'),
                    react_1.default.createElement("div", { className: "hbg-finance-v2__assets-pl-btn", onClick: onClickViewPL },
                        react_1.default.createElement("i", { className: "hbg-finance-v2__assets-pl-icon" }),
                        react_1.default.createElement("span", null, t('P/L')))))),
        react_1.default.createElement("div", { className: "hbg-finance-v2__otc" },
            react_1.default.createElement("span", { onClick: function () {
                    onClickOtc(1);
                } }, t('充币')),
            react_1.default.createElement("span", { onClick: function () {
                    onClickOtc(2);
                } }, t('提币')),
            react_1.default.createElement("span", { onClick: function () {
                    onClickOtc(3);
                } }, t('划转'))),
        ((detail === null || detail === void 0 ? void 0 : detail.profitAccountBalanceList) || BalanceListDefault).map(function (item, index) {
            return react_1.default.createElement(finance_item_1.default, { key: index, data: item, canSee: canSee, trans: fiatTrans });
        }),
        react_1.default.createElement("div", { className: "hbg-finance-v2__audit", onClick: function () {
                onClickOtc(4);
            } },
            react_1.default.createElement("div", { className: "hbg-finance-v2__audit-content" },
                react_1.default.createElement("p", null, t('储备金证明报告')),
                react_1.default.createElement("i", { className: "fed-icon__arrow--right" })))));
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var links_1 = __webpack_require__(95);
var url_1 = __webpack_require__(18);
var DistributionTypes = {
    '1': '现货',
    '2': '合约',
    '3': '杠杆',
    '4': '赚币',
    '5': '法币',
    '6': '期权',
    '8': '交易机器人',
    '100': '其他',
};
function type2name(type) {
    var name = DistributionTypes[type];
    return name || '';
}
exports.default = (function (_a) {
    var data = _a.data, canSee = _a.canSee, trans = _a.trans;
    var t = (0, i18n_1.useTranslation)().t;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale;
    var valclassName = function () {
        return [
            'hbg-finance-cell-item__val',
            {
                'is-rise': data.a % 2 == 0,
                'is-fall': data.a % 2 == 1,
            },
        ];
    };
    var assetRatio = function () {
        var assetRatio = data.assetRatio;
        if (assetRatio === undefined || assetRatio === null) {
            return '';
        }
        return (assetRatio === null || assetRatio === void 0 ? void 0 : assetRatio.replace(/%$/, '')) + '%';
    };
    var onClickItem = function () {
        var distributionType = data.distributionType;
        var item = links_1.FinanceItem[distributionType];
        if (item && (item.path || item.url)) {
            var url = (0, url_1.getUrl)({
                path: item.path,
                platform: item.platform,
                locale: locale,
                hostname: hostname,
            });
            location.href = url;
        }
    };
    return DistributionTypes[data.distributionType] ? (react_1.default.createElement("div", { className: "hbg-finance-cell-item", onClick: onClickItem },
        react_1.default.createElement("div", { className: "hbg-finance-cell-item__title" },
            react_1.default.createElement("span", { className: "hbg-finance-cell-item__label" }, t(type2name(data.distributionType))),
            react_1.default.createElement("span", { className: "hbg-finance-cell-item__val" }, canSee ? assetRatio() : '******')),
        react_1.default.createElement("div", { className: "fed-ly-columns is-right hbg-finance-cell-item__value" },
            react_1.default.createElement("span", { className: "hbg-finance-cell-item__label" }, canSee ? trans(data.accountBalance) : '******')))) : (react_1.default.createElement(react_1.default.Fragment, null));
});


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRateList", function() { return getRateList; });
// 获取汇率数据
const getRateList = () => {
    const list = {
        code: 200,
        data: [
            {
                data_time: 1691510400000,
                name: "usd_krw",
                rate: 1318.2784175443,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_jpy",
                rate: 143.1900736284,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_gbp",
                rate: 0.7857522364,
                time: 1691514001399,
            },
            {
                data_time: 1691510400000,
                name: "usd_eur",
                rate: 0.9132192569,
                time: 1691514001398,
            },
            {
                data_time: 1691510400000,
                name: "usd_rub",
                rate: 97.1775822856,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_vnd",
                rate: 23800.2065564664,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_inr",
                rate: 82.89663011,
                time: 1691514001401,
            },
            {
                data_time: 1691510400000,
                name: "usd_sgd",
                rate: 1.3483118703,
                time: 1691514001409,
            },
            {
                data_time: 1691510400000,
                name: "usd_hkd",
                rate: 7.8134858544,
                time: 1691514001400,
            },
            {
                data_time: 1691510400000,
                name: "usd_cad",
                rate: 1.345702401,
                time: 1691514001393,
            },
            {
                data_time: 1691510400000,
                name: "usd_aud",
                rate: 1.5351946963,
                time: 1691514001391,
            },
            {
                data_time: 1691510400000,
                name: "usd_cny",
                rate: 7.2104788231,
                time: 1691514001397,
            },
            {
                data_time: 1691510400000,
                name: "usd_twd",
                rate: 31.8575092762,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "usd_ngn",
                rate: 766.283555271,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_idr",
                rate: 15204.4502191113,
                time: 1691514001401,
            },
            {
                data_time: 1691510400000,
                name: "usd_php",
                rate: 56.4793307584,
                time: 1691514001407,
            },
            {
                data_time: 1691510400000,
                name: "usd_khr",
                rate: 4124.6264143469,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_chf",
                rate: 0.8758237253,
                time: 1691514001396,
            },
            {
                data_time: 1691510400000,
                name: "usd_thb",
                rate: 35.0218392018,
                time: 1691514001409,
            },
            {
                data_time: 1691510400000,
                name: "usd_myr",
                rate: 4.5819534561,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_sar",
                rate: 3.75,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_aed",
                rate: 3.6725,
                time: 1691514001389,
            },
            {
                data_time: 1691510400000,
                name: "usd_zar",
                rate: 18.9706382712,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_nok",
                rate: 10.3000374147,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_dkk",
                rate: 6.8049233945,
                time: 1691514001397,
            },
            {
                data_time: 1691510400000,
                name: "usd_sek",
                rate: 10.7269726106,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_try",
                rate: 27.0188362471,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "usd_brl",
                rate: 4.9097650054,
                time: 1691514001392,
            },
            {
                data_time: 1691510400000,
                name: "usd_nzd",
                rate: 1.6538066726,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_mmk",
                rate: 2095.1021888671,
                time: 1691514001404,
            },
            {
                data_time: 1691510400000,
                name: "usd_ars",
                rate: 284.1964239661,
                time: 1691514001390,
            },
            {
                data_time: 1691510400000,
                name: "usd_cop",
                rate: 4073.1853806811,
                time: 1691514001397,
            },
            {
                data_time: 1691510400000,
                name: "usd_ves",
                rate: 30.9247056373,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_kes",
                rate: 143.3051898035,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_pen",
                rate: 3.7109307852,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_all",
                rate: 94.4920204036,
                time: 1691514001390,
            },
            {
                data_time: 1691510400000,
                name: "usd_bam",
                rate: 1.7861016192,
                time: 1691514001391,
            },
            {
                data_time: 1691510400000,
                name: "usd_bgn",
                rate: 1.7861016192,
                time: 1691514001391,
            },
            {
                data_time: 1691510400000,
                name: "usd_czk",
                rate: 22.171063131,
                time: 1691514001397,
            },
            {
                data_time: 1691510400000,
                name: "usd_gip",
                rate: 0.7857522364,
                time: 1691514001399,
            },
            {
                data_time: 1672502400000,
                name: "usd_hrk",
                rate: 7.0395753966,
                time: 1672506001058,
            },
            {
                data_time: 1691510400000,
                name: "usd_huf",
                rate: 356.4974580695,
                time: 1691514001400,
            },
            {
                data_time: 1691510400000,
                name: "usd_mdl",
                rate: 17.7639518683,
                time: 1691514001404,
            },
            {
                data_time: 1691510400000,
                name: "usd_mkd",
                rate: 56.1527146351,
                time: 1691514001404,
            },
            {
                data_time: 1691510400000,
                name: "usd_pln",
                rate: 4.0699494301,
                time: 1691514001407,
            },
            {
                data_time: 1691510400000,
                name: "usd_ron",
                rate: 4.5183661928,
                time: 1691514001407,
            },
            {
                data_time: 1691510400000,
                name: "usd_rsd",
                rate: 107.023100474,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_uah",
                rate: 36.7282376699,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_azn",
                rate: 1.6997864537,
                time: 1691514001391,
            },
            {
                data_time: 1691510400000,
                name: "usd_clp",
                rate: 861.1805291313,
                time: 1691514001396,
            },
            {
                data_time: 1691510400000,
                name: "usd_crc",
                rate: 541.5418139268,
                time: 1691514001397,
            },
            {
                data_time: 1691510400000,
                name: "usd_dop",
                rate: 56.2196364077,
                time: 1691514001398,
            },
            {
                data_time: 1691510400000,
                name: "usd_gel",
                rate: 2.6129215636,
                time: 1691514001399,
            },
            {
                data_time: 1691510400000,
                name: "usd_ils",
                rate: 3.7214589303,
                time: 1691514001401,
            },
            {
                data_time: 1691510400000,
                name: "usd_kzt",
                rate: 446.592466552,
                time: 1691514001403,
            },
            {
                data_time: 1691510400000,
                name: "usd_mad",
                rate: 9.7506814415,
                time: 1691514001404,
            },
            {
                data_time: 1691510400000,
                name: "usd_mxn",
                rate: 17.1551089443,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_nad",
                rate: 18.9706382712,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_qar",
                rate: 3.64,
                time: 1691514001407,
            },
            {
                data_time: 1691510400000,
                name: "usd_uyu",
                rate: 38.0781415113,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_uzs",
                rate: 11677.1293811432,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_pkr",
                rate: 287.7957887166,
                time: 1691514001407,
            },
            {
                data_time: 1691510400000,
                name: "usd_bob",
                rate: 6.8986235171,
                time: 1691514001392,
            },
            {
                data_time: 1691510400000,
                name: "usd_ang",
                rate: 1.7933170067,
                time: 1691514001390,
            },
            {
                data_time: 1691510400000,
                name: "usd_bbd",
                rate: 2.0,
                time: 1691514001391,
            },
            {
                data_time: 1691510400000,
                name: "usd_bdt",
                rate: 109.450490625,
                time: 1691514001391,
            },
            {
                data_time: 1691510400000,
                name: "usd_bmd",
                rate: 1.0,
                time: 1691514001392,
            },
            {
                data_time: 1691510400000,
                name: "usd_bnd",
                rate: 1.3483118703,
                time: 1691514001392,
            },
            {
                data_time: 1691510400000,
                name: "usd_bwp",
                rate: 13.3856134012,
                time: 1691514001393,
            },
            {
                data_time: 1691510400000,
                name: "usd_djf",
                rate: 177.8668242454,
                time: 1691514001397,
            },
            {
                data_time: 1691510400000,
                name: "usd_egp",
                rate: 30.8972206495,
                time: 1691514001398,
            },
            {
                data_time: 1691510400000,
                name: "usd_ghs",
                rate: 11.1593900764,
                time: 1691514001399,
            },
            {
                data_time: 1691510400000,
                name: "usd_gtq",
                rate: 7.8480623431,
                time: 1691514001400,
            },
            {
                data_time: 1691510400000,
                name: "usd_hnl",
                rate: 24.5444138226,
                time: 1691514001400,
            },
            {
                data_time: 1691510400000,
                name: "usd_tzs",
                rate: 2474.0877832056,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "usd_ugx",
                rate: 3620.6834676451,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_xaf",
                rate: 599.0325640771,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_xof",
                rate: 599.0325640771,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_zmw",
                rate: 19.1998247458,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_kgs",
                rate: 87.8723270911,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_byn",
                rate: 2.503471716,
                time: 1691514001393,
            },
            {
                data_time: 1691510400000,
                name: "usd_mzn",
                rate: 63.8372315375,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_mnt",
                rate: 3459.9350598914,
                time: 1691514001404,
            },
            {
                data_time: 1691510400000,
                name: "usd_amd",
                rate: 385.5123337622,
                time: 1691514001390,
            },
            {
                data_time: 1691510400000,
                name: "usd_kyd",
                rate: 0.8218153639,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_lbp",
                rate: 15023.6548754589,
                time: 1691514001403,
            },
            {
                data_time: 1691510400000,
                name: "usd_lkr",
                rate: 320.9045113578,
                time: 1691514001403,
            },
            {
                data_time: 1691510400000,
                name: "usd_pab",
                rate: 1.0,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_pgk",
                rate: 3.5834241359,
                time: 1691514001407,
            },
            {
                data_time: 1691510400000,
                name: "usd_pyg",
                rate: 7258.5324462992,
                time: 1691514001407,
            },
            {
                data_time: 1691510400000,
                name: "usd_ttd",
                rate: 6.7554177038,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "usd_mop",
                rate: 8.04789043,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_mur",
                rate: 45.2159755804,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_isk",
                rate: 131.9604567396,
                time: 1691514001401,
            },
            {
                data_time: 1691510400000,
                name: "usd_jmd",
                rate: 154.0765447578,
                time: 1691514001401,
            },
            {
                data_time: 1691510400000,
                name: "usd_tjs",
                rate: 10.9799683648,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "cny_krw",
                rate: 182.8281380327,
                time: 1691514001850,
            },
            {
                data_time: 1691510400000,
                name: "cny_jpy",
                rate: 19.8586081649,
                time: 1691514001849,
            },
            {
                data_time: 1691510400000,
                name: "cny_gbp",
                rate: 0.1089736557,
                time: 1691514001848,
            },
            {
                data_time: 1691510400000,
                name: "cny_eur",
                rate: 0.12665168,
                time: 1691514001847,
            },
            {
                data_time: 1691510400000,
                name: "cny_rub",
                rate: 13.4772717139,
                time: 1691514001854,
            },
            {
                data_time: 1691510400000,
                name: "cny_vnd",
                rate: 3300.7803143881,
                time: 1691514001856,
            },
            {
                data_time: 1691510400000,
                name: "cny_inr",
                rate: 11.4966886589,
                time: 1691514001849,
            },
            {
                data_time: 1691510400000,
                name: "cny_sgd",
                rate: 0.1869933888,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_hkd",
                rate: 1.0836292632,
                time: 1691514001848,
            },
            {
                data_time: 1691510400000,
                name: "cny_cad",
                rate: 0.1866314893,
                time: 1691514001846,
            },
            {
                data_time: 1691510400000,
                name: "cny_aud",
                rate: 0.2129116157,
                time: 1691514001844,
            },
            {
                data_time: 1691510400000,
                name: "cny_twd",
                rate: 4.4182238181,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_ngn",
                rate: 106.2736018058,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_idr",
                rate: 2108.6602696186,
                time: 1691514001849,
            },
            {
                data_time: 1691510400000,
                name: "cny_php",
                rate: 7.8329514786,
                time: 1691514001853,
            },
            {
                data_time: 1691510400000,
                name: "cny_khr",
                rate: 572.0322485597,
                time: 1691514001850,
            },
            {
                data_time: 1691510400000,
                name: "cny_chf",
                rate: 0.1214654043,
                time: 1691514001846,
            },
            {
                data_time: 1691510400000,
                name: "cny_thb",
                rate: 4.8570753845,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_myr",
                rate: 0.6354575845,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_sar",
                rate: 0.5200764182,
                time: 1691514001854,
            },
            {
                data_time: 1691510400000,
                name: "cny_aed",
                rate: 0.5093281723,
                time: 1691514001843,
            },
            {
                data_time: 1691510400000,
                name: "cny_zar",
                rate: 2.6309817609,
                time: 1691514001857,
            },
            {
                data_time: 1691510400000,
                name: "cny_nok",
                rate: 1.428481751,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_dkk",
                rate: 0.9437547161,
                time: 1691514001847,
            },
            {
                data_time: 1691510400000,
                name: "cny_sek",
                rate: 1.4876921317,
                time: 1691514001854,
            },
            {
                data_time: 1691510400000,
                name: "cny_try",
                rate: 3.7471625547,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_brl",
                rate: 0.6809207996,
                time: 1691514001846,
            },
            {
                data_time: 1691510400000,
                name: "cny_nzd",
                rate: 0.2293615602,
                time: 1691514001853,
            },
            {
                data_time: 1691510400000,
                name: "cny_mmk",
                rate: 290.563531255,
                time: 1691514001851,
            },
            {
                data_time: 1691510400000,
                name: "cny_ars",
                rate: 39.4143621998,
                time: 1691514001844,
            },
            {
                data_time: 1691510400000,
                name: "cny_cop",
                rate: 564.8980436161,
                time: 1691514001846,
            },
            {
                data_time: 1691510400000,
                name: "cny_ves",
                rate: 4.288856038,
                time: 1691514001856,
            },
            {
                data_time: 1691510400000,
                name: "cny_kes",
                rate: 19.874573287,
                time: 1691514001850,
            },
            {
                data_time: 1691510400000,
                name: "cny_pen",
                rate: 0.5146580243,
                time: 1691514001853,
            },
            {
                data_time: 1691510400000,
                name: "cny_all",
                rate: 13.1048190727,
                time: 1691514001844,
            },
            {
                data_time: 1691510400000,
                name: "cny_bam",
                rate: 0.2477091554,
                time: 1691514001845,
            },
            {
                data_time: 1691510400000,
                name: "cny_bgn",
                rate: 0.2477091554,
                time: 1691514001845,
            },
            {
                data_time: 1691510400000,
                name: "cny_czk",
                rate: 3.0748392271,
                time: 1691514001847,
            },
            {
                data_time: 1691510400000,
                name: "cny_gip",
                rate: 0.1089736557,
                time: 1691514001848,
            },
            {
                data_time: 1672502400000,
                name: "cny_hrk",
                rate: 1.0197809973,
                time: 1672506001491,
            },
            {
                data_time: 1691510400000,
                name: "cny_huf",
                rate: 49.44157896,
                time: 1691514001848,
            },
            {
                data_time: 1691510400000,
                name: "cny_mdl",
                rate: 2.4636299897,
                time: 1691514001851,
            },
            {
                data_time: 1691510400000,
                name: "cny_mkd",
                rate: 7.7876540536,
                time: 1691514001851,
            },
            {
                data_time: 1691510400000,
                name: "cny_pln",
                rate: 0.5644492592,
                time: 1691514001853,
            },
            {
                data_time: 1691510400000,
                name: "cny_ron",
                rate: 0.6266388549,
                time: 1691514001854,
            },
            {
                data_time: 1691510400000,
                name: "cny_rsd",
                rate: 14.8427175366,
                time: 1691514001854,
            },
            {
                data_time: 1691510400000,
                name: "cny_uah",
                rate: 5.0937307454,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_azn",
                rate: 0.2357383602,
                time: 1691514001844,
            },
            {
                data_time: 1691510400000,
                name: "cny_clp",
                rate: 119.4345826767,
                time: 1691514001846,
            },
            {
                data_time: 1691510400000,
                name: "cny_crc",
                rate: 75.104833842,
                time: 1691514001847,
            },
            {
                data_time: 1691510400000,
                name: "cny_dop",
                rate: 7.7969352365,
                time: 1691514001847,
            },
            {
                data_time: 1691510400000,
                name: "cny_gel",
                rate: 0.3623783701,
                time: 1691514001848,
            },
            {
                data_time: 1691510400000,
                name: "cny_ils",
                rate: 0.5161181416,
                time: 1691514001849,
            },
            {
                data_time: 1691510400000,
                name: "cny_kzt",
                rate: 61.9365894431,
                time: 1691514001850,
            },
            {
                data_time: 1691510400000,
                name: "cny_mad",
                rate: 1.3522931945,
                time: 1691514001851,
            },
            {
                data_time: 1691510400000,
                name: "cny_mxn",
                rate: 2.3791913637,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_nad",
                rate: 2.6309817609,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_qar",
                rate: 0.5048208433,
                time: 1691514001854,
            },
            {
                data_time: 1691510400000,
                name: "cny_uyu",
                rate: 5.28094492,
                time: 1691514001856,
            },
            {
                data_time: 1691510400000,
                name: "cny_uzs",
                rate: 1619.4665663256,
                time: 1691514001856,
            },
            {
                data_time: 1691510400000,
                name: "cny_pkr",
                rate: 39.9135474604,
                time: 1691514001853,
            },
            {
                data_time: 1691510400000,
                name: "cny_bob",
                rate: 0.9567497092,
                time: 1691514001845,
            },
            {
                data_time: 1691510400000,
                name: "cny_ang",
                rate: 0.2487098362,
                time: 1691514001844,
            },
            {
                data_time: 1691510400000,
                name: "cny_bbd",
                rate: 0.2773740897,
                time: 1691514001845,
            },
            {
                data_time: 1691510400000,
                name: "cny_bdt",
                rate: 15.1793651033,
                time: 1691514001845,
            },
            {
                data_time: 1691510400000,
                name: "cny_bmd",
                rate: 0.1386870449,
                time: 1691514001845,
            },
            {
                data_time: 1691510400000,
                name: "cny_bnd",
                rate: 0.1869933888,
                time: 1691514001845,
            },
            {
                data_time: 1691510400000,
                name: "cny_bwp",
                rate: 1.8564111663,
                time: 1691514001846,
            },
            {
                data_time: 1691510400000,
                name: "cny_djf",
                rate: 24.6678242333,
                time: 1691514001847,
            },
            {
                data_time: 1691510400000,
                name: "cny_egp",
                rate: 4.2850442263,
                time: 1691514001847,
            },
            {
                data_time: 1691510400000,
                name: "cny_ghs",
                rate: 1.5476628321,
                time: 1691514001848,
            },
            {
                data_time: 1691510400000,
                name: "cny_gtq",
                rate: 1.0884245743,
                time: 1691514001848,
            },
            {
                data_time: 1691510400000,
                name: "cny_hnl",
                rate: 3.4039922209,
                time: 1691514001848,
            },
            {
                data_time: 1691510400000,
                name: "cny_tzs",
                rate: 343.1239233785,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_ugx",
                rate: 502.1418905033,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_xaf",
                rate: 83.0780560871,
                time: 1691514001856,
            },
            {
                data_time: 1691510400000,
                name: "cny_xof",
                rate: 83.0780560871,
                time: 1691514001856,
            },
            {
                data_time: 1691510400000,
                name: "cny_zmw",
                rate: 2.6627669558,
                time: 1691514001857,
            },
            {
                data_time: 1691510400000,
                name: "cny_kgs",
                rate: 12.1867533693,
                time: 1691514001850,
            },
            {
                data_time: 1691510400000,
                name: "cny_byn",
                rate: 0.3471990942,
                time: 1691514001846,
            },
            {
                data_time: 1691510400000,
                name: "cny_mzn",
                rate: 8.853396994,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_mnt",
                rate: 479.8481688659,
                time: 1691514001851,
            },
            {
                data_time: 1691510400000,
                name: "cny_amd",
                rate: 53.4655663268,
                time: 1691514001844,
            },
            {
                data_time: 1691510400000,
                name: "cny_kyd",
                rate: 0.1139751442,
                time: 1691514001850,
            },
            {
                data_time: 1691510400000,
                name: "cny_lbp",
                rate: 2083.5862976829,
                time: 1691514001850,
            },
            {
                data_time: 1691510400000,
                name: "cny_lkr",
                rate: 44.5052983626,
                time: 1691514001851,
            },
            {
                data_time: 1691510400000,
                name: "cny_pab",
                rate: 0.1386870449,
                time: 1691514001853,
            },
            {
                data_time: 1691510400000,
                name: "cny_pgk",
                rate: 0.4969745039,
                time: 1691514001853,
            },
            {
                data_time: 1691510400000,
                name: "cny_pyg",
                rate: 1006.664415002,
                time: 1691514001854,
            },
            {
                data_time: 1691510400000,
                name: "cny_ttd",
                rate: 0.9368889181,
                time: 1691514001855,
            },
            {
                data_time: 1691510400000,
                name: "cny_mop",
                rate: 1.1161381411,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_mur",
                rate: 6.2708700337,
                time: 1691514001852,
            },
            {
                data_time: 1691510400000,
                name: "cny_isk",
                rate: 18.3012057837,
                time: 1691514001849,
            },
            {
                data_time: 1691510400000,
                name: "cny_jmd",
                rate: 21.3684206748,
                time: 1691514001849,
            },
            {
                data_time: 1691574240007,
                name: "usdt_cny",
                rate: 7.21,
                time: 1691574240007,
            },
            {
                data_time: 1691574240007,
                name: "btc_cny",
                rate: 214778.32,
                time: 1691574240007,
            },
            {
                data_time: 1691510400000,
                name: "usd_afn",
                rate: 84.9585611339,
                time: 1691514001390,
            },
            {
                data_time: 1691510400000,
                name: "usd_aoa",
                rate: 833.982384571,
                time: 1691514001390,
            },
            {
                data_time: 1691510400000,
                name: "usd_awg",
                rate: 1.79,
                time: 1691514001391,
            },
            {
                data_time: 1691510400000,
                name: "usd_bhd",
                rate: 0.376,
                time: 1691514001392,
            },
            {
                data_time: 1691510400000,
                name: "usd_bif",
                rate: 2830.0769470212,
                time: 1691514001392,
            },
            {
                data_time: 1691510400000,
                name: "usd_bsd",
                rate: 1.0,
                time: 1691514001392,
            },
            {
                data_time: 1691510400000,
                name: "usd_btn",
                rate: 82.89663011,
                time: 1691514001393,
            },
            {
                data_time: 1691510400000,
                name: "usd_bzd",
                rate: 2.0107493763,
                time: 1691514001393,
            },
            {
                data_time: 1691510400000,
                name: "usd_cdf",
                rate: 2455.9535244481,
                time: 1691514001395,
            },
            {
                data_time: 1691510400000,
                name: "usd_clf",
                rate: 0.02391752,
                time: 1691514001396,
            },
            {
                data_time: 1691510400000,
                name: "usd_cve",
                rate: 100.7006874548,
                time: 1691514001397,
            },
            {
                data_time: 1691510400000,
                name: "usd_dzd",
                rate: 135.9075590261,
                time: 1691514001398,
            },
            {
                data_time: 1691510400000,
                name: "usd_ern",
                rate: 15.0,
                time: 1691514001398,
            },
            {
                data_time: 1691510400000,
                name: "usd_etb",
                rate: 55.0175760908,
                time: 1691514001398,
            },
            {
                data_time: 1691510400000,
                name: "usd_fjd",
                rate: 2.2426366321,
                time: 1691514001399,
            },
            {
                data_time: 1691510400000,
                name: "usd_fkp",
                rate: 0.7857522364,
                time: 1691514001399,
            },
            {
                data_time: 1691510400000,
                name: "usd_gmd",
                rate: 60.8657047696,
                time: 1691514001399,
            },
            {
                data_time: 1691510400000,
                name: "usd_gnf",
                rate: 8581.5747572886,
                time: 1691514001399,
            },
            {
                data_time: 1691510400000,
                name: "usd_gyd",
                rate: 208.5486661414,
                time: 1691514001400,
            },
            {
                data_time: 1691510400000,
                name: "usd_htg",
                rate: 136.3764022767,
                time: 1691514001400,
            },
            {
                data_time: 1691510400000,
                name: "usd_iqd",
                rate: 1309.101649999,
                time: 1691514001401,
            },
            {
                data_time: 1691510400000,
                name: "usd_jod",
                rate: 0.709,
                time: 1691514001401,
            },
            {
                data_time: 1691510400000,
                name: "usd_kmf",
                rate: 449.2744230579,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_kwd",
                rate: 0.307724494,
                time: 1691514001402,
            },
            {
                data_time: 1691510400000,
                name: "usd_lak",
                rate: 19107.4076094161,
                time: 1691514001403,
            },
            {
                data_time: 1691510400000,
                name: "usd_lrd",
                rate: 186.6534936218,
                time: 1691514001403,
            },
            {
                data_time: 1691510400000,
                name: "usd_lsl",
                rate: 18.9706382712,
                time: 1691514001403,
            },
            {
                data_time: 1691510400000,
                name: "usd_lyd",
                rate: 4.7864655032,
                time: 1691514001403,
            },
            {
                data_time: 1691510400000,
                name: "usd_mga",
                rate: 4457.726145536,
                time: 1691514001404,
            },
            {
                data_time: 1691510400000,
                name: "usd_mvr",
                rate: 15.4324753205,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_mwk",
                rate: 1051.7396912728,
                time: 1691514001405,
            },
            {
                data_time: 1691510400000,
                name: "usd_nio",
                rate: 36.5087063116,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_npr",
                rate: 132.6967806485,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_omr",
                rate: 0.3850262049,
                time: 1691514001406,
            },
            {
                data_time: 1691510400000,
                name: "usd_rwf",
                rate: 1173.2266077069,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_sbd",
                rate: 8.4083695084,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_scr",
                rate: 13.5720078,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_shp",
                rate: 0.7857522364,
                time: 1691514001409,
            },
            {
                data_time: 1691510400000,
                name: "usd_sll",
                rate: 20970.5174117011,
                time: 1691514001409,
            },
            {
                data_time: 1691510400000,
                name: "usd_srd",
                rate: 38.4170861614,
                time: 1691514001409,
            },
            {
                data_time: 1691510400000,
                name: "usd_syp",
                rate: 13099.9190651001,
                time: 1691514001409,
            },
            {
                data_time: 1691510400000,
                name: "usd_szl",
                rate: 18.9706382712,
                time: 1691514001409,
            },
            {
                data_time: 1691510400000,
                name: "usd_tmt",
                rate: 3.4937532845,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "usd_tnd",
                rate: 3.0678117852,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "usd_top",
                rate: 2.3593388763,
                time: 1691514001410,
            },
            {
                data_time: 1691510400000,
                name: "usd_vuv",
                rate: 119.7225949154,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_wst",
                rate: 2.7466304158,
                time: 1691514001411,
            },
            {
                data_time: 1691510400000,
                name: "usd_xcd",
                rate: 2.7030389896,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_xpf",
                rate: 108.9760449719,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_yer",
                rate: 250.1595723454,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_zwl",
                rate: 4758.9832304988,
                time: 1691514001412,
            },
            {
                data_time: 1691510400000,
                name: "usd_sdg",
                rate: 601.277882791,
                time: 1691514001408,
            },
            {
                data_time: 1691510400000,
                name: "usd_cnh",
                rate: 7.2390079574,
                time: 1691514001397,
            },
        ],
        message: null,
        success: true,
    };
    return list;
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var links_1 = __webpack_require__(95);
var url_1 = __webpack_require__(18);
var sensors_1 = __webpack_require__(27);
var cell_item_1 = __importDefault(__webpack_require__(100));
var user_info_1 = __importDefault(__webpack_require__(423));
var fee_1 = __importDefault(__webpack_require__(438));
var cell_group_1 = __importDefault(__webpack_require__(102));
var PanelUser = function (_a) {
    var style = _a.style, userInfo = _a.userInfo, userType = _a.userType, passKeyShow = _a.passKeyShow;
    var t = (0, i18n_1.useTranslation)().t;
    //@ts-ignore
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale, onlogout = globalState.onlogout;
    var onClickLogout = function (event) {
        onlogout && onlogout(event, '');
    };
    var gotoUser = function () {
        var url = (0, url_1.getUrl)({
            path: '/views/profile/',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'center',
            type: 'click',
        });
        location.href = url;
    };
    var onClickUser = function (event) {
        gotoUser();
    };
    var getClassName = function (path) {
        var strClass = '';
        if (path && path.includes('/user-center/security') && passKeyShow) {
            strClass = 'hbg-cell-user_key';
        }
        return strClass;
    };
    var configUserShort = (0, react_1.useMemo)(function () {
        return links_1.USER_SHORT.map(function (item) {
            item.jumpUrl = (0, url_1.getUrl)({
                path: item.path,
                platform: item.platform,
                locale: locale,
                hostname: hostname,
            });
            return item;
        });
    }, [locale, hostname]);
    var configUserFunction = (0, react_1.useMemo)(function () {
        return links_1.USER_FUNCTION.map(function (item) {
            item.jumpUrl = (0, url_1.getUrl)({
                path: item.path,
                platform: item.platform,
                locale: locale,
                hostname: hostname,
            });
            return item;
        });
    }, [locale, hostname]);
    var configUserSettings = (0, react_1.useMemo)(function () {
        var userList = links_1.USER_SETTINGS.filter(function (item) {
            return (!(item.path.indexOf('/broker') > -1 && userInfo && userInfo.ucResp && !userInfo.ucResp.userType) &&
                !(['/subaccount/manage/', '/fiat-crypto/user-center/'].includes(item.path) && userType === 2));
        });
        return userList.map(function (item) {
            item.jumpUrl = (0, url_1.getUrl)({
                path: item.path,
                platform: item.platform,
                locale: locale,
                hostname: hostname,
            });
            return item;
        });
    }, [locale, hostname, userType, userInfo]);
    return (react_1.default.createElement("div", { className: "hbg-user-dropdown", style: style },
        react_1.default.createElement("div", { className: "hbg-user-dropdown__user" },
            userInfo ? react_1.default.createElement(user_info_1.default, { userInfo: userInfo, onClick: onClickUser }) : null,
            react_1.default.createElement(fee_1.default, { userInfo: userInfo || {} })),
        react_1.default.createElement(cell_group_1.default, { className: "hbg-user-dropdown__short" }, configUserShort.map(function (item) {
            return react_1.default.createElement(cell_item_1.default, { key: item.name, title: t(item.name), href: item.jumpUrl, isLink: true });
        })),
        react_1.default.createElement(cell_group_1.default, null, configUserFunction.map(function (item) {
            return react_1.default.createElement(cell_item_1.default, { key: item.name, title: t(item.name), href: item.jumpUrl, isLink: true });
        })),
        react_1.default.createElement(cell_group_1.default, null, configUserSettings.map(function (item) {
            return (react_1.default.createElement(cell_item_1.default, { key: item.name, title: t(item.name), href: item.jumpUrl, className: getClassName(item.path), isLink: true }));
        })),
        react_1.default.createElement("div", { className: "fed-btn-block", onClick: onClickLogout }, t('退出登录'))));
};
exports.default = PanelUser;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var clipboard_1 = __importDefault(__webpack_require__(153));
var context_1 = __webpack_require__(7);
var i18n_1 = __webpack_require__(14);
var httpReq_1 = __importDefault(__webpack_require__(23));
var hooks_1 = __webpack_require__(22);
var url_1 = __webpack_require__(18);
var sensors_1 = __webpack_require__(27);
var react_dom_1 = __webpack_require__(60);
var user_avatar_1 = __importDefault(__webpack_require__(262));
var switch_user_1 = __importDefault(__webpack_require__(426));
var utils_1 = __importDefault(__webpack_require__(20));
exports.default = (function (_a) {
    var userInfo = _a.userInfo, onClick = _a.onClick;
    var t = (0, i18n_1.useTranslation)().t;
    var _b = (0, react_1.useState)(false), copied = _b[0], setCopied = _b[1];
    var btnRef = (0, react_1.useRef)(null);
    // const kycRef = useRef(null);
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale, isLogin = globalState.isLogin;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setIsOpen = _c[1];
    // 账号切换是否开启，默认关闭
    var _d = (0, react_1.useState)(false), isSwitchShow = _d[0], setIsSwitchShow = _d[1];
    (0, react_1.useEffect)(function () {
        if (btnRef) {
            var clipboard = new clipboard_1.default(btnRef.current);
            clipboard.on('success', function (e) {
                setCopied(true);
                var toast = __webpack_require__(101);
                toast.default.success(t('复制成功'));
                setTimeout(function () {
                    setCopied(false);
                }, 1000);
            });
            clipboard.on('error', function (e) {
                console.error('Action:', e.action);
                console.error('Trigger:', e.trigger);
            });
        }
    }, [btnRef]);
    (0, react_1.useEffect)(function () {
        if (isOpen) {
            (0, react_dom_1.addClass)(document.body, 'hgb-popup-parent--hidden');
        }
        else {
            // 移除页面滚动css
            (0, react_dom_1.removeClass)(document.body, 'hgb-popup-parent--hidden');
        }
    }, [isOpen]);
    (0, react_1.useEffect)(function () {
        getSwitchAccount();
    }, []);
    var ucResp = userInfo.ucResp, _e = userInfo.medalResp, medalResp = _e === void 0 ? [] : _e;
    var gotoUser = function () {
        var url = (0, url_1.getUrl)({
            path: '/user_center/uc_auth/',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        (0, sensors_1.trackHeader)({
            button_name: 'center_kyc',
            type: 'click',
        });
        location.href = url;
    };
    var onClickUser = function (event) {
        event.stopPropagation();
        var icon = btnRef.current;
        var el = event.target;
        if ((icon && icon.contains(el)) || icon === el) {
            return false;
        }
        onClick && onClick(event);
    };
    // 获取账号切换入口，是否开启
    var getSwitchAccount = function () { return __awaiter(void 0, void 0, void 0, function () {
        var type, _a, success, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setIsSwitchShow(false);
                    type = utils_1.default.getCookie('htx_user_logintype') || '';
                    if (type === 'subaccount') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, httpService.getSwitchAccountState()];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success) {
                        setIsSwitchShow((data === null || data === void 0 ? void 0 : data.ab_test) || false);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.log('error :>> ', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // 切换账号
    var switchClick = function () {
        // 未登录，先登录
        if (!isLogin) {
            var origin_1 = location.origin.replace('futures', 'www');
            location.href = "".concat(origin_1, "/").concat(locale, "/login/?backUrl=").concat(location.href);
            return;
        }
        if (window.sensors) {
            window.sensors.track('webclick_nav', {
                button_name: '切换账号',
            });
        }
        setIsOpen(true);
    };
    return (react_1.default.createElement("div", { className: "hbg-user-info" },
        react_1.default.createElement("div", { className: "hbg-user-info__avatar", onClick: onClickUser },
            react_1.default.createElement(user_avatar_1.default, { uc: ucResp, size: 44, general: true, flag: true })),
        react_1.default.createElement("div", { className: "hbg-user-info__detail" },
            react_1.default.createElement("div", { className: "hbg-user-info__content" },
                react_1.default.createElement("div", { className: "hbg-user-info__username ".concat(isSwitchShow ? 'username_switch' : ''), onClick: onClickUser }, ucResp === null || ucResp === void 0 ? void 0 : ucResp.name),
                isSwitchShow && isLogin && (react_1.default.createElement("div", { className: "hbg-user-info__switch", onClick: switchClick },
                    react_1.default.createElement("span", { id: "switch_txt" }, t('切换账号')),
                    react_1.default.createElement("div", { className: "switch-img", id: "switch_img" })))),
            react_1.default.createElement("div", { className: "hbg-user-info__other " },
                react_1.default.createElement("div", { className: "hbg-user-info__uid" },
                    react_1.default.createElement("span", null,
                        "UID:", ucResp === null || ucResp === void 0 ? void 0 :
                        ucResp.uid),
                    react_1.default.createElement("div", { className: "icon-copy-w", ref: btnRef, "data-clipboard-text": "".concat(ucResp === null || ucResp === void 0 ? void 0 : ucResp.uid) },
                        react_1.default.createElement("i", { className: 'hbg-user-info__uid-copy ' + (copied ? ' hbg-user-info__uid-copy--success' : '') }))),
                react_1.default.createElement("div", { className: "hbg-user-info__medals" }, ((medalResp && medalResp.imgList) || []).map(function (item, index) {
                    return react_1.default.createElement("img", { key: index, src: item });
                })))),
        isOpen && react_1.default.createElement(switch_user_1.default, { isOpen: isOpen, userInfo: userInfo, setIsOpen: setIsOpen })));
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

(typeof navigator !== "undefined") && (function (global, factory) {
   true ? module.exports = factory() :
  undefined;
})(this, (function () { 'use strict';

  var svgNS = 'http://www.w3.org/2000/svg';
  var locationHref = '';
  var _useWebWorker = false;
  var initialDefaultFrame = -999999;

  var setWebWorker = function setWebWorker(flag) {
    _useWebWorker = !!flag;
  };

  var getWebWorker = function getWebWorker() {
    return _useWebWorker;
  };

  var setLocationHref = function setLocationHref(value) {
    locationHref = value;
  };

  var getLocationHref = function getLocationHref() {
    return locationHref;
  };

  function createTag(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElement(type);
  }

  function extendPrototype(sources, destination) {
    var i;
    var len = sources.length;
    var sourcePrototype;

    for (i = 0; i < len; i += 1) {
      sourcePrototype = sources[i].prototype;

      for (var attr in sourcePrototype) {
        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
      }
    }
  }

  function getDescriptor(object, prop) {
    return Object.getOwnPropertyDescriptor(object, prop);
  }

  function createProxyFunction(prototype) {
    function ProxyFunction() {}

    ProxyFunction.prototype = prototype;
    return ProxyFunction;
  }

  // import Howl from '../../3rd_party/howler';
  var audioControllerFactory = function () {
    function AudioController(audioFactory) {
      this.audios = [];
      this.audioFactory = audioFactory;
      this._volume = 1;
      this._isMuted = false;
    }

    AudioController.prototype = {
      addAudio: function addAudio(audio) {
        this.audios.push(audio);
      },
      pause: function pause() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].pause();
        }
      },
      resume: function resume() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].resume();
        }
      },
      setRate: function setRate(rateValue) {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].setRate(rateValue);
        }
      },
      createAudio: function createAudio(assetPath) {
        if (this.audioFactory) {
          return this.audioFactory(assetPath);
        }

        if (window.Howl) {
          return new window.Howl({
            src: [assetPath]
          });
        }

        return {
          isPlaying: false,
          play: function play() {
            this.isPlaying = true;
          },
          seek: function seek() {
            this.isPlaying = false;
          },
          playing: function playing() {},
          rate: function rate() {},
          setVolume: function setVolume() {}
        };
      },
      setAudioFactory: function setAudioFactory(audioFactory) {
        this.audioFactory = audioFactory;
      },
      setVolume: function setVolume(value) {
        this._volume = value;

        this._updateVolume();
      },
      mute: function mute() {
        this._isMuted = true;

        this._updateVolume();
      },
      unmute: function unmute() {
        this._isMuted = false;

        this._updateVolume();
      },
      getVolume: function getVolume() {
        return this._volume;
      },
      _updateVolume: function _updateVolume() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }
    };
    return function () {
      return new AudioController();
    };
  }();

  var createTypedArray = function () {
    function createRegularArray(type, len) {
      var i = 0;
      var arr = [];
      var value;

      switch (type) {
        case 'int16':
        case 'uint8c':
          value = 1;
          break;

        default:
          value = 1.1;
          break;
      }

      for (i = 0; i < len; i += 1) {
        arr.push(value);
      }

      return arr;
    }

    function createTypedArrayFactory(type, len) {
      if (type === 'float32') {
        return new Float32Array(len);
      }

      if (type === 'int16') {
        return new Int16Array(len);
      }

      if (type === 'uint8c') {
        return new Uint8ClampedArray(len);
      }

      return createRegularArray(type, len);
    }

    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
      return createTypedArrayFactory;
    }

    return createRegularArray;
  }();

  function createSizedArray(len) {
    return Array.apply(null, {
      length: len
    });
  }

  function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
  var subframeEnabled = true;
  var expressionsPlugin = null;
  var idPrefix$1 = '';
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var _shouldRoundValues = false;
  var bmPow = Math.pow;
  var bmSqrt = Math.sqrt;
  var bmFloor = Math.floor;
  var bmMax = Math.max;
  var bmMin = Math.min;
  var BMMath = {};

  (function () {
    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
    var i;
    var len = propertyNames.length;

    for (i = 0; i < len; i += 1) {
      BMMath[propertyNames[i]] = Math[propertyNames[i]];
    }
  })();

  function ProjectInterface$1() {
    return {};
  }

  BMMath.random = Math.random;

  BMMath.abs = function (val) {
    var tOfVal = _typeof$6(val);

    if (tOfVal === 'object' && val.length) {
      var absArr = createSizedArray(val.length);
      var i;
      var len = val.length;

      for (i = 0; i < len; i += 1) {
        absArr[i] = Math.abs(val[i]);
      }

      return absArr;
    }

    return Math.abs(val);
  };

  var defaultCurveSegments = 150;
  var degToRads = Math.PI / 180;
  var roundCorner = 0.5519;

  function roundValues(flag) {
    _shouldRoundValues = !!flag;
  }

  function bmRnd(value) {
    if (_shouldRoundValues) {
      return Math.round(value);
    }

    return value;
  }

  function styleDiv(element) {
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.display = 'block';
    element.style.transformOrigin = '0 0';
    element.style.webkitTransformOrigin = '0 0';
    element.style.backfaceVisibility = 'visible';
    element.style.webkitBackfaceVisibility = 'visible';
    element.style.transformStyle = 'preserve-3d';
    element.style.webkitTransformStyle = 'preserve-3d';
    element.style.mozTransformStyle = 'preserve-3d';
  }

  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
    this.type = type;
    this.currentTime = currentTime;
    this.totalTime = totalTime;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMCompleteEvent(type, frameMultiplier) {
    this.type = type;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
    this.type = type;
    this.currentLoop = currentLoop;
    this.totalLoops = totalLoops;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
    this.type = type;
    this.firstFrame = firstFrame;
    this.totalFrames = totalFrames;
  }

  function BMDestroyEvent(type, target) {
    this.type = type;
    this.target = target;
  }

  function BMRenderFrameErrorEvent(nativeError, currentTime) {
    this.type = 'renderFrameError';
    this.nativeError = nativeError;
    this.currentTime = currentTime;
  }

  function BMConfigErrorEvent(nativeError) {
    this.type = 'configError';
    this.nativeError = nativeError;
  }

  function BMAnimationConfigErrorEvent(type, nativeError) {
    this.type = type;
    this.nativeError = nativeError;
  }

  var createElementID = function () {
    var _count = 0;
    return function createID() {
      _count += 1;
      return idPrefix$1 + '__lottie_element_' + _count;
    };
  }();

  function HSVtoRGB(h, s, v) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0:
        r = v;
        g = t;
        b = p;
        break;

      case 1:
        r = q;
        g = v;
        b = p;
        break;

      case 2:
        r = p;
        g = v;
        b = t;
        break;

      case 3:
        r = p;
        g = q;
        b = v;
        break;

      case 4:
        r = t;
        g = p;
        b = v;
        break;

      case 5:
        r = v;
        g = p;
        b = q;
        break;

      default:
        break;
    }

    return [r, g, b];
  }

  function RGBtoHSV(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var h;
    var s = max === 0 ? 0 : d / max;
    var v = max / 255;

    switch (max) {
      case min:
        h = 0;
        break;

      case r:
        h = g - b + d * (g < b ? 6 : 0);
        h /= 6 * d;
        break;

      case g:
        h = b - r + d * 2;
        h /= 6 * d;
        break;

      case b:
        h = r - g + d * 4;
        h /= 6 * d;
        break;

      default:
        break;
    }

    return [h, s, v];
  }

  function addSaturationToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[1] += offset;

    if (hsv[1] > 1) {
      hsv[1] = 1;
    } else if (hsv[1] <= 0) {
      hsv[1] = 0;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  function addBrightnessToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[2] += offset;

    if (hsv[2] > 1) {
      hsv[2] = 1;
    } else if (hsv[2] < 0) {
      hsv[2] = 0;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  function addHueToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[0] += offset / 360;

    if (hsv[0] > 1) {
      hsv[0] -= 1;
    } else if (hsv[0] < 0) {
      hsv[0] += 1;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  var rgbToHex = function () {
    var colorMap = [];
    var i;
    var hex;

    for (i = 0; i < 256; i += 1) {
      hex = i.toString(16);
      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
    }

    return function (r, g, b) {
      if (r < 0) {
        r = 0;
      }

      if (g < 0) {
        g = 0;
      }

      if (b < 0) {
        b = 0;
      }

      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
  }();

  var setSubframeEnabled = function setSubframeEnabled(flag) {
    subframeEnabled = !!flag;
  };

  var getSubframeEnabled = function getSubframeEnabled() {
    return subframeEnabled;
  };

  var setExpressionsPlugin = function setExpressionsPlugin(value) {
    expressionsPlugin = value;
  };

  var getExpressionsPlugin = function getExpressionsPlugin() {
    return expressionsPlugin;
  };

  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
    defaultCurveSegments = value;
  };

  var getDefaultCurveSegments = function getDefaultCurveSegments() {
    return defaultCurveSegments;
  };

  var setIdPrefix = function setIdPrefix(value) {
    idPrefix$1 = value;
  };

  var getIdPrefix = function getIdPrefix() {
    return idPrefix$1;
  };

  function createNS(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElementNS(svgNS, type);
  }

  function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

  var dataManager = function () {
    var _counterId = 1;
    var processes = [];
    var workerFn;
    var workerInstance;
    var workerProxy = {
      onmessage: function onmessage() {},
      postMessage: function postMessage(path) {
        workerFn({
          data: path
        });
      }
    };
    var _workerSelf = {
      postMessage: function postMessage(data) {
        workerProxy.onmessage({
          data: data
        });
      }
    };

    function createWorker(fn) {
      if (window.Worker && window.Blob && getWebWorker()) {
        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
          type: 'text/javascript'
        }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });

        var url = URL.createObjectURL(blob);
        return new Worker(url);
      }

      workerFn = fn;
      return workerProxy;
    }

    function setupWorker() {
      if (!workerInstance) {
        workerInstance = createWorker(function workerStart(e) {
          function dataFunctionManager() {
            function completeLayers(layers, comps) {
              var layerData;
              var i;
              var len = layers.length;
              var j;
              var jLen;
              var k;
              var kLen;

              for (i = 0; i < len; i += 1) {
                layerData = layers[i];

                if ('ks' in layerData && !layerData.completed) {
                  layerData.completed = true;

                  if (layerData.tt) {
                    layers[i - 1].td = layerData.tt;
                  }

                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
                      } else {
                        kLen = maskProps[j].pt.k.length;

                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                          }

                          if (maskProps[j].pt.k[k].e) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                          }
                        }
                      }
                    }
                  }

                  if (layerData.ty === 0) {
                    layerData.layers = findCompLayers(layerData.refId, comps);
                    completeLayers(layerData.layers, comps);
                  } else if (layerData.ty === 4) {
                    completeShapes(layerData.shapes);
                  } else if (layerData.ty === 5) {
                    completeText(layerData);
                  }
                }
              }
            }

            function completeChars(chars, assets) {
              if (chars) {
                var i = 0;
                var len = chars.length;

                for (i = 0; i < len; i += 1) {
                  if (chars[i].t === 1) {
                    // var compData = findComp(chars[i].data.refId, assets);
                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                    // chars[i].data.op = 99999;
                    // chars[i].data.st = 0;
                    // chars[i].data.sr = 1;
                    // chars[i].w = compData.w;
                    // chars[i].data.ks = {
                    //   a: { k: [0, 0, 0], a: 0 },
                    //   p: { k: [0, -compData.h, 0], a: 0 },
                    //   r: { k: 0, a: 0 },
                    //   s: { k: [100, 100], a: 0 },
                    //   o: { k: 100, a: 0 },
                    // };

                    completeLayers(chars[i].data.layers, assets);
                  }
                }
              }
            }

            function findComp(id, comps) {
              var i = 0;
              var len = comps.length;

              while (i < len) {
                if (comps[i].id === id) {
                  return comps[i];
                }

                i += 1;
              }

              return null;
            }

            function findCompLayers(id, comps) {
              var comp = findComp(id, comps);

              if (comp) {
                if (!comp.layers.__used) {
                  comp.layers.__used = true;
                  return comp.layers;
                }

                return JSON.parse(JSON.stringify(comp.layers));
              }

              return null;
            }

            function completeShapes(arr) {
              var i;
              var len = arr.length;
              var j;
              var jLen;

              for (i = len - 1; i >= 0; i -= 1) {
                if (arr[i].ty === 'sh') {
                  if (arr[i].ks.k.i) {
                    convertPathsToAbsoluteValues(arr[i].ks.k);
                  } else {
                    jLen = arr[i].ks.k.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (arr[i].ks.k[j].s) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                      }

                      if (arr[i].ks.k[j].e) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                      }
                    }
                  }
                } else if (arr[i].ty === 'gr') {
                  completeShapes(arr[i].it);
                }
              }
            }

            function convertPathsToAbsoluteValues(path) {
              var i;
              var len = path.i.length;

              for (i = 0; i < len; i += 1) {
                path.i[i][0] += path.v[i][0];
                path.i[i][1] += path.v[i][1];
                path.o[i][0] += path.v[i][0];
                path.o[i][1] += path.v[i][1];
              }
            }

            function checkVersion(minimum, animVersionString) {
              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];

              if (minimum[0] > animVersion[0]) {
                return true;
              }

              if (animVersion[0] > minimum[0]) {
                return false;
              }

              if (minimum[1] > animVersion[1]) {
                return true;
              }

              if (animVersion[1] > minimum[1]) {
                return false;
              }

              if (minimum[2] > animVersion[2]) {
                return true;
              }

              if (animVersion[2] > minimum[2]) {
                return false;
              }

              return null;
            }

            var checkText = function () {
              var minimumVersion = [4, 4, 14];

              function updateTextLayer(textLayer) {
                var documentData = textLayer.t.d;
                textLayer.t.d = {
                  k: [{
                    s: documentData,
                    t: 0
                  }]
                };
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkChars = function () {
              var minimumVersion = [4, 7, 99];
              return function (animationData) {
                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                  var i;
                  var len = animationData.chars.length;

                  for (i = 0; i < len; i += 1) {
                    var charData = animationData.chars[i];

                    if (charData.data && charData.data.shapes) {
                      completeShapes(charData.data.shapes);
                      charData.data.ip = 0;
                      charData.data.op = 99999;
                      charData.data.st = 0;
                      charData.data.sr = 1;
                      charData.data.ks = {
                        p: {
                          k: [0, 0],
                          a: 0
                        },
                        s: {
                          k: [100, 100],
                          a: 0
                        },
                        a: {
                          k: [0, 0],
                          a: 0
                        },
                        r: {
                          k: 0,
                          a: 0
                        },
                        o: {
                          k: 100,
                          a: 0
                        }
                      };

                      if (!animationData.chars[i].t) {
                        charData.data.shapes.push({
                          ty: 'no'
                        });
                        charData.data.shapes[0].it.push({
                          p: {
                            k: [0, 0],
                            a: 0
                          },
                          s: {
                            k: [100, 100],
                            a: 0
                          },
                          a: {
                            k: [0, 0],
                            a: 0
                          },
                          r: {
                            k: 0,
                            a: 0
                          },
                          o: {
                            k: 100,
                            a: 0
                          },
                          sk: {
                            k: 0,
                            a: 0
                          },
                          sa: {
                            k: 0,
                            a: 0
                          },
                          ty: 'tr'
                        });
                      }
                    }
                  }
                }
              };
            }();

            var checkPathProperties = function () {
              var minimumVersion = [5, 7, 15];

              function updateTextLayer(textLayer) {
                var pathData = textLayer.t.p;

                if (typeof pathData.a === 'number') {
                  pathData.a = {
                    a: 0,
                    k: pathData.a
                  };
                }

                if (typeof pathData.p === 'number') {
                  pathData.p = {
                    a: 0,
                    k: pathData.p
                  };
                }

                if (typeof pathData.r === 'number') {
                  pathData.r = {
                    a: 0,
                    k: pathData.r
                  };
                }
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkColors = function () {
              var minimumVersion = [4, 1, 9];

              function iterateShapes(shapes) {
                var i;
                var len = shapes.length;
                var j;
                var jLen;

                for (i = 0; i < len; i += 1) {
                  if (shapes[i].ty === 'gr') {
                    iterateShapes(shapes[i].it);
                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
                      jLen = shapes[i].c.k.length;

                      for (j = 0; j < jLen; j += 1) {
                        if (shapes[i].c.k[j].s) {
                          shapes[i].c.k[j].s[0] /= 255;
                          shapes[i].c.k[j].s[1] /= 255;
                          shapes[i].c.k[j].s[2] /= 255;
                          shapes[i].c.k[j].s[3] /= 255;
                        }

                        if (shapes[i].c.k[j].e) {
                          shapes[i].c.k[j].e[0] /= 255;
                          shapes[i].c.k[j].e[1] /= 255;
                          shapes[i].c.k[j].e[2] /= 255;
                          shapes[i].c.k[j].e[3] /= 255;
                        }
                      }
                    } else {
                      shapes[i].c.k[0] /= 255;
                      shapes[i].c.k[1] /= 255;
                      shapes[i].c.k[2] /= 255;
                      shapes[i].c.k[3] /= 255;
                    }
                  }
                }
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 4) {
                    iterateShapes(layers[i].shapes);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkShapes = function () {
              var minimumVersion = [4, 4, 18];

              function completeClosingShapes(arr) {
                var i;
                var len = arr.length;
                var j;
                var jLen;

                for (i = len - 1; i >= 0; i -= 1) {
                  if (arr[i].ty === 'sh') {
                    if (arr[i].ks.k.i) {
                      arr[i].ks.k.c = arr[i].closed;
                    } else {
                      jLen = arr[i].ks.k.length;

                      for (j = 0; j < jLen; j += 1) {
                        if (arr[i].ks.k[j].s) {
                          arr[i].ks.k[j].s[0].c = arr[i].closed;
                        }

                        if (arr[i].ks.k[j].e) {
                          arr[i].ks.k[j].e[0].c = arr[i].closed;
                        }
                      }
                    }
                  } else if (arr[i].ty === 'gr') {
                    completeClosingShapes(arr[i].it);
                  }
                }
              }

              function iterateLayers(layers) {
                var layerData;
                var i;
                var len = layers.length;
                var j;
                var jLen;
                var k;
                var kLen;

                for (i = 0; i < len; i += 1) {
                  layerData = layers[i];

                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        maskProps[j].pt.k.c = maskProps[j].cl;
                      } else {
                        kLen = maskProps[j].pt.k.length;

                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                          }

                          if (maskProps[j].pt.k[k].e) {
                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                          }
                        }
                      }
                    }
                  }

                  if (layerData.ty === 4) {
                    completeClosingShapes(layerData.shapes);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            function completeData(animationData) {
              if (animationData.__complete) {
                return;
              }

              checkColors(animationData);
              checkText(animationData);
              checkChars(animationData);
              checkPathProperties(animationData);
              checkShapes(animationData);
              completeLayers(animationData.layers, animationData.assets);
              completeChars(animationData.chars, animationData.assets);
              animationData.__complete = true;
            }

            function completeText(data) {
              if (data.t.a.length === 0 && !('m' in data.t.p)) {// data.singleShape = true;
              }
            }

            var moduleOb = {};
            moduleOb.completeData = completeData;
            moduleOb.checkColors = checkColors;
            moduleOb.checkChars = checkChars;
            moduleOb.checkPathProperties = checkPathProperties;
            moduleOb.checkShapes = checkShapes;
            moduleOb.completeLayers = completeLayers;
            return moduleOb;
          }

          if (!_workerSelf.dataManager) {
            _workerSelf.dataManager = dataFunctionManager();
          }

          if (!_workerSelf.assetLoader) {
            _workerSelf.assetLoader = function () {
              function formatResponse(xhr) {
                // using typeof doubles the time of execution of this method,
                // so if available, it's better to use the header to validate the type
                var contentTypeHeader = xhr.getResponseHeader('content-type');

                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
                  return xhr.response;
                }

                if (xhr.response && _typeof$5(xhr.response) === 'object') {
                  return xhr.response;
                }

                if (xhr.response && typeof xhr.response === 'string') {
                  return JSON.parse(xhr.response);
                }

                if (xhr.responseText) {
                  return JSON.parse(xhr.responseText);
                }

                return null;
              }

              function loadAsset(path, fullPath, callback, errorCallback) {
                var response;
                var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.

                try {
                  // This crashes on Android WebView prior to KitKat
                  xhr.responseType = 'json';
                } catch (err) {} // eslint-disable-line no-empty


                xhr.onreadystatechange = function () {
                  if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                      response = formatResponse(xhr);
                      callback(response);
                    } else {
                      try {
                        response = formatResponse(xhr);
                        callback(response);
                      } catch (err) {
                        if (errorCallback) {
                          errorCallback(err);
                        }
                      }
                    }
                  }
                };

                try {
                  xhr.open('GET', path, true);
                } catch (error) {
                  xhr.open('GET', fullPath + '/' + path, true);
                }

                xhr.send();
              }

              return {
                load: loadAsset
              };
            }();
          }

          if (e.data.type === 'loadAnimation') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.dataManager.completeData(data);

              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          } else if (e.data.type === 'complete') {
            var animation = e.data.animation;

            _workerSelf.dataManager.completeData(animation);

            _workerSelf.postMessage({
              id: e.data.id,
              payload: animation,
              status: 'success'
            });
          } else if (e.data.type === 'loadData') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          }
        });

        workerInstance.onmessage = function (event) {
          var data = event.data;
          var id = data.id;
          var process = processes[id];
          processes[id] = null;

          if (data.status === 'success') {
            process.onComplete(data.payload);
          } else if (process.onError) {
            process.onError();
          }
        };
      }
    }

    function createProcess(onComplete, onError) {
      _counterId += 1;
      var id = 'processId_' + _counterId;
      processes[id] = {
        onComplete: onComplete,
        onError: onError
      };
      return id;
    }

    function loadAnimation(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadAnimation',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }

    function loadData(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadData',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }

    function completeAnimation(anim, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'complete',
        animation: anim,
        id: processId
      });
    }

    return {
      loadAnimation: loadAnimation,
      loadData: loadData,
      completeAnimation: completeAnimation
    };
  }();

  var ImagePreloader = function () {
    var proxyImage = function () {
      var canvas = createTag('canvas');
      canvas.width = 1;
      canvas.height = 1;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = 'rgba(0,0,0,0)';
      ctx.fillRect(0, 0, 1, 1);
      return canvas;
    }();

    function imageLoaded() {
      this.loadedAssets += 1;

      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }

    function footageLoaded() {
      this.loadedFootagesCount += 1;

      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }

    function getAssetsPath(assetData, assetsPath, originalPath) {
      var path = '';

      if (assetData.e) {
        path = assetData.p;
      } else if (assetsPath) {
        var imagePath = assetData.p;

        if (imagePath.indexOf('images/') !== -1) {
          imagePath = imagePath.split('/')[1];
        }

        path = assetsPath + imagePath;
      } else {
        path = originalPath;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
      }

      return path;
    }

    function testImageLoaded(img) {
      var _count = 0;
      var intervalId = setInterval(function () {
        var box = img.getBBox();

        if (box.width || _count > 500) {
          this._imageLoaded();

          clearInterval(intervalId);
        }

        _count += 1;
      }.bind(this), 50);
    }

    function createImageData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createNS('image');

      if (isSafari) {
        this.testImageLoaded(img);
      } else {
        img.addEventListener('load', this._imageLoaded, false);
      }

      img.addEventListener('error', function () {
        ob.img = proxyImage;

        this._imageLoaded();
      }.bind(this), false);
      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);

      if (this._elementHelper.append) {
        this._elementHelper.append(img);
      } else {
        this._elementHelper.appendChild(img);
      }

      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }

    function createImgData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createTag('img');
      img.crossOrigin = 'anonymous';
      img.addEventListener('load', this._imageLoaded, false);
      img.addEventListener('error', function () {
        ob.img = proxyImage;

        this._imageLoaded();
      }.bind(this), false);
      img.src = path;
      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }

    function createFootageData(data) {
      var ob = {
        assetData: data
      };
      var path = getAssetsPath(data, this.assetsPath, this.path);
      dataManager.loadData(path, function (footageData) {
        ob.img = footageData;

        this._footageLoaded();
      }.bind(this), function () {
        ob.img = {};

        this._footageLoaded();
      }.bind(this));
      return ob;
    }

    function loadAssets(assets, cb) {
      this.imagesLoadedCb = cb;
      var i;
      var len = assets.length;

      for (i = 0; i < len; i += 1) {
        if (!assets[i].layers) {
          if (!assets[i].t || assets[i].t === 'seq') {
            this.totalImages += 1;
            this.images.push(this._createImageData(assets[i]));
          } else if (assets[i].t === 3) {
            this.totalFootages += 1;
            this.images.push(this.createFootageData(assets[i]));
          }
        }
      }
    }

    function setPath(path) {
      this.path = path || '';
    }

    function setAssetsPath(path) {
      this.assetsPath = path || '';
    }

    function getAsset(assetData) {
      var i = 0;
      var len = this.images.length;

      while (i < len) {
        if (this.images[i].assetData === assetData) {
          return this.images[i].img;
        }

        i += 1;
      }

      return null;
    }

    function destroy() {
      this.imagesLoadedCb = null;
      this.images.length = 0;
    }

    function loadedImages() {
      return this.totalImages === this.loadedAssets;
    }

    function loadedFootages() {
      return this.totalFootages === this.loadedFootagesCount;
    }

    function setCacheType(type, elementHelper) {
      if (type === 'svg') {
        this._elementHelper = elementHelper;
        this._createImageData = this.createImageData.bind(this);
      } else {
        this._createImageData = this.createImgData.bind(this);
      }
    }

    function ImagePreloaderFactory() {
      this._imageLoaded = imageLoaded.bind(this);
      this._footageLoaded = footageLoaded.bind(this);
      this.testImageLoaded = testImageLoaded.bind(this);
      this.createFootageData = createFootageData.bind(this);
      this.assetsPath = '';
      this.path = '';
      this.totalImages = 0;
      this.totalFootages = 0;
      this.loadedAssets = 0;
      this.loadedFootagesCount = 0;
      this.imagesLoadedCb = null;
      this.images = [];
    }

    ImagePreloaderFactory.prototype = {
      loadAssets: loadAssets,
      setAssetsPath: setAssetsPath,
      setPath: setPath,
      loadedImages: loadedImages,
      loadedFootages: loadedFootages,
      destroy: destroy,
      getAsset: getAsset,
      createImgData: createImgData,
      createImageData: createImageData,
      imageLoaded: imageLoaded,
      footageLoaded: footageLoaded,
      setCacheType: setCacheType
    };
    return ImagePreloaderFactory;
  }();

  function BaseEvent() {}

  BaseEvent.prototype = {
    triggerEvent: function triggerEvent(eventName, args) {
      if (this._cbs[eventName]) {
        var callbacks = this._cbs[eventName];

        for (var i = 0; i < callbacks.length; i += 1) {
          callbacks[i](args);
        }
      }
    },
    addEventListener: function addEventListener(eventName, callback) {
      if (!this._cbs[eventName]) {
        this._cbs[eventName] = [];
      }

      this._cbs[eventName].push(callback);

      return function () {
        this.removeEventListener(eventName, callback);
      }.bind(this);
    },
    removeEventListener: function removeEventListener(eventName, callback) {
      if (!callback) {
        this._cbs[eventName] = null;
      } else if (this._cbs[eventName]) {
        var i = 0;
        var len = this._cbs[eventName].length;

        while (i < len) {
          if (this._cbs[eventName][i] === callback) {
            this._cbs[eventName].splice(i, 1);

            i -= 1;
            len -= 1;
          }

          i += 1;
        }

        if (!this._cbs[eventName].length) {
          this._cbs[eventName] = null;
        }
      }
    }
  };

  var markerParser = function () {
    function parsePayloadLines(payload) {
      var lines = payload.split('\r\n');
      var keys = {};
      var line;
      var keysCount = 0;

      for (var i = 0; i < lines.length; i += 1) {
        line = lines[i].split(':');

        if (line.length === 2) {
          keys[line[0]] = line[1].trim();
          keysCount += 1;
        }
      }

      if (keysCount === 0) {
        throw new Error();
      }

      return keys;
    }

    return function (_markers) {
      var markers = [];

      for (var i = 0; i < _markers.length; i += 1) {
        var _marker = _markers[i];
        var markerData = {
          time: _marker.tm,
          duration: _marker.dr
        };

        try {
          markerData.payload = JSON.parse(_markers[i].cm);
        } catch (_) {
          try {
            markerData.payload = parsePayloadLines(_markers[i].cm);
          } catch (__) {
            markerData.payload = {
              name: _markers[i].cm
            };
          }
        }

        markers.push(markerData);
      }

      return markers;
    };
  }();

  var ProjectInterface = function () {
    function registerComposition(comp) {
      this.compositions.push(comp);
    }

    return function () {
      function _thisProjectFunction(name) {
        var i = 0;
        var len = this.compositions.length;

        while (i < len) {
          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
              this.compositions[i].prepareFrame(this.currentFrame);
            }

            return this.compositions[i].compInterface;
          }

          i += 1;
        }

        return null;
      }

      _thisProjectFunction.compositions = [];
      _thisProjectFunction.currentFrame = 0;
      _thisProjectFunction.registerComposition = registerComposition;
      return _thisProjectFunction;
    };
  }();

  var renderers = {};

  var registerRenderer = function registerRenderer(key, value) {
    renderers[key] = value;
  };

  function getRenderer(key) {
    return renderers[key];
  }

  function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

  var AnimationItem = function AnimationItem() {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.firstFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.playCount = 0;
    this.animationData = {};
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = createElementID();
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.isSubframeEnabled = getSubframeEnabled();
    this.segments = [];
    this._idle = true;
    this._completedLoop = false;
    this.projectInterface = ProjectInterface();
    this.imagePreloader = new ImagePreloader();
    this.audioController = audioControllerFactory();
    this.markers = [];
    this.configAnimation = this.configAnimation.bind(this);
    this.onSetupError = this.onSetupError.bind(this);
    this.onSegmentComplete = this.onSegmentComplete.bind(this);
    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
  };

  extendPrototype([BaseEvent], AnimationItem);

  AnimationItem.prototype.setParams = function (params) {
    if (params.wrapper || params.container) {
      this.wrapper = params.wrapper || params.container;
    }

    var animType = 'svg';

    if (params.animType) {
      animType = params.animType;
    } else if (params.renderer) {
      animType = params.renderer;
    }

    var RendererClass = getRenderer(animType);
    this.renderer = new RendererClass(this, params.rendererSettings);
    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;

    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
      this.loop = true;
    } else if (params.loop === false) {
      this.loop = false;
    } else {
      this.loop = parseInt(params.loop, 10);
    }

    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name : '';
    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
    this.assetsPath = params.assetsPath;
    this.initialSegment = params.initialSegment;

    if (params.audioFactory) {
      this.audioController.setAudioFactory(params.audioFactory);
    }

    if (params.animationData) {
      this.setupAnimation(params.animationData);
    } else if (params.path) {
      if (params.path.lastIndexOf('\\') !== -1) {
        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
      } else {
        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
      }

      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
    }
  };

  AnimationItem.prototype.onSetupError = function () {
    this.trigger('data_failed');
  };

  AnimationItem.prototype.setupAnimation = function (data) {
    dataManager.completeAnimation(data, this.configAnimation);
  };

  AnimationItem.prototype.setData = function (wrapper, animationData) {
    if (animationData) {
      if (_typeof$4(animationData) !== 'object') {
        animationData = JSON.parse(animationData);
      }
    }

    var params = {
      wrapper: wrapper,
      animationData: animationData
    };
    var wrapperAttributes = wrapper.attributes;
    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';

    if (loop === 'false') {
      params.loop = false;
    } else if (loop === 'true') {
      params.loop = true;
    } else if (loop !== '') {
      params.loop = parseInt(loop, 10);
    }

    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== 'false';
    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

    if (prerender === 'false') {
      params.prerender = false;
    }

    this.setParams(params);
  };

  AnimationItem.prototype.includeLayers = function (data) {
    if (data.op > this.animationData.op) {
      this.animationData.op = data.op;
      this.totalFrames = Math.floor(data.op - this.animationData.ip);
    }

    var layers = this.animationData.layers;
    var i;
    var len = layers.length;
    var newLayers = data.layers;
    var j;
    var jLen = newLayers.length;

    for (j = 0; j < jLen; j += 1) {
      i = 0;

      while (i < len) {
        if (layers[i].id === newLayers[j].id) {
          layers[i] = newLayers[j];
          break;
        }

        i += 1;
      }
    }

    if (data.chars || data.fonts) {
      this.renderer.globalData.fontManager.addChars(data.chars);
      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }

    if (data.assets) {
      len = data.assets.length;

      for (i = 0; i < len; i += 1) {
        this.animationData.assets.push(data.assets[i]);
      }
    }

    this.animationData.__complete = false;
    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
  };

  AnimationItem.prototype.onSegmentComplete = function (data) {
    this.animationData = data;
    var expressionsPlugin = getExpressionsPlugin();

    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }

    this.loadNextSegment();
  };

  AnimationItem.prototype.loadNextSegment = function () {
    var segments = this.animationData.segments;

    if (!segments || segments.length === 0 || !this.autoloadSegments) {
      this.trigger('data_ready');
      this.timeCompleted = this.totalFrames;
      return;
    }

    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
      this.trigger('data_failed');
    }.bind(this));
  };

  AnimationItem.prototype.loadSegments = function () {
    var segments = this.animationData.segments;

    if (!segments) {
      this.timeCompleted = this.totalFrames;
    }

    this.loadNextSegment();
  };

  AnimationItem.prototype.imagesLoaded = function () {
    this.trigger('loaded_images');
    this.checkLoaded();
  };

  AnimationItem.prototype.preloadImages = function () {
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
  };

  AnimationItem.prototype.configAnimation = function (animData) {
    if (!this.renderer) {
      return;
    }

    try {
      this.animationData = animData;

      if (this.initialSegment) {
        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
        this.firstFrame = Math.round(this.initialSegment[0]);
      } else {
        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
        this.firstFrame = Math.round(this.animationData.ip);
      }

      this.renderer.configAnimation(animData);

      if (!animData.assets) {
        animData.assets = [];
      }

      this.assets = this.animationData.assets;
      this.frameRate = this.animationData.fr;
      this.frameMult = this.animationData.fr / 1000;
      this.renderer.searchExtraCompositions(animData.assets);
      this.markers = markerParser(animData.markers || []);
      this.trigger('config_ready');
      this.preloadImages();
      this.loadSegments();
      this.updaFrameModifier();
      this.waitForFontsLoaded();

      if (this.isPaused) {
        this.audioController.pause();
      }
    } catch (error) {
      this.triggerConfigError(error);
    }
  };

  AnimationItem.prototype.waitForFontsLoaded = function () {
    if (!this.renderer) {
      return;
    }

    if (this.renderer.globalData.fontManager.isLoaded) {
      this.checkLoaded();
    } else {
      setTimeout(this.waitForFontsLoaded.bind(this), 20);
    }
  };

  AnimationItem.prototype.checkLoaded = function () {
    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
      this.isLoaded = true;
      var expressionsPlugin = getExpressionsPlugin();

      if (expressionsPlugin) {
        expressionsPlugin.initExpressions(this);
      }

      this.renderer.initItems();
      setTimeout(function () {
        this.trigger('DOMLoaded');
      }.bind(this), 0);
      this.gotoFrame();

      if (this.autoplay) {
        this.play();
      }
    }
  };

  AnimationItem.prototype.resize = function () {
    this.renderer.updateContainerSize();
  };

  AnimationItem.prototype.setSubframe = function (flag) {
    this.isSubframeEnabled = !!flag;
  };

  AnimationItem.prototype.gotoFrame = function () {
    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
      this.currentFrame = this.timeCompleted;
    }

    this.trigger('enterFrame');
    this.renderFrame();
    this.trigger('drawnFrame');
  };

  AnimationItem.prototype.renderFrame = function () {
    if (this.isLoaded === false || !this.renderer) {
      return;
    }

    try {
      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    } catch (error) {
      this.triggerRenderFrameError(error);
    }
  };

  AnimationItem.prototype.play = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === true) {
      this.isPaused = false;
      this.trigger('_pause');
      this.audioController.resume();

      if (this._idle) {
        this._idle = false;
        this.trigger('_active');
      }
    }
  };

  AnimationItem.prototype.pause = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === false) {
      this.isPaused = true;
      this.trigger('_play');
      this._idle = true;
      this.trigger('_idle');
      this.audioController.pause();
    }
  };

  AnimationItem.prototype.togglePause = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === true) {
      this.play();
    } else {
      this.pause();
    }
  };

  AnimationItem.prototype.stop = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.pause();
    this.playCount = 0;
    this._completedLoop = false;
    this.setCurrentRawFrameValue(0);
  };

  AnimationItem.prototype.getMarkerData = function (markerName) {
    var marker;

    for (var i = 0; i < this.markers.length; i += 1) {
      marker = this.markers[i];

      if (marker.payload && marker.payload.name === markerName) {
        return marker;
      }
    }

    return null;
  };

  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }

    var numValue = Number(value);

    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);

      if (marker) {
        this.goToAndStop(marker.time, true);
      }
    } else if (isFrame) {
      this.setCurrentRawFrameValue(value);
    } else {
      this.setCurrentRawFrameValue(value * this.frameModifier);
    }

    this.pause();
  };

  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }

    var numValue = Number(value);

    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);

      if (marker) {
        if (!marker.duration) {
          this.goToAndStop(marker.time, true);
        } else {
          this.playSegments([marker.time, marker.time + marker.duration], true);
        }
      }
    } else {
      this.goToAndStop(numValue, isFrame, name);
    }

    this.play();
  };

  AnimationItem.prototype.advanceTime = function (value) {
    if (this.isPaused === true || this.isLoaded === false) {
      return;
    }

    var nextValue = this.currentRawFrame + value * this.frameModifier;
    var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.

    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
      if (!this.loop || this.playCount === this.loop) {
        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
          _isComplete = true;
          nextValue = this.totalFrames - 1;
        }
      } else if (nextValue >= this.totalFrames) {
        this.playCount += 1;

        if (!this.checkSegments(nextValue % this.totalFrames)) {
          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
          this._completedLoop = true;
          this.trigger('loopComplete');
        }
      } else {
        this.setCurrentRawFrameValue(nextValue);
      }
    } else if (nextValue < 0) {
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
          // eslint-disable-line no-plusplus
          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);

          if (!this._completedLoop) {
            this._completedLoop = true;
          } else {
            this.trigger('loopComplete');
          }
        } else {
          _isComplete = true;
          nextValue = 0;
        }
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }

    if (_isComplete) {
      this.setCurrentRawFrameValue(nextValue);
      this.pause();
      this.trigger('complete');
    }
  };

  AnimationItem.prototype.adjustSegment = function (arr, offset) {
    this.playCount = 0;

    if (arr[1] < arr[0]) {
      if (this.frameModifier > 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(-1);
        }
      }

      this.totalFrames = arr[0] - arr[1];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[1];
      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
    } else if (arr[1] > arr[0]) {
      if (this.frameModifier < 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(1);
        }
      }

      this.totalFrames = arr[1] - arr[0];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[0];
      this.setCurrentRawFrameValue(0.001 + offset);
    }

    this.trigger('segmentStart');
  };

  AnimationItem.prototype.setSegment = function (init, end) {
    var pendingFrame = -1;

    if (this.isPaused) {
      if (this.currentRawFrame + this.firstFrame < init) {
        pendingFrame = init;
      } else if (this.currentRawFrame + this.firstFrame > end) {
        pendingFrame = end - init;
      }
    }

    this.firstFrame = init;
    this.totalFrames = end - init;
    this.timeCompleted = this.totalFrames;

    if (pendingFrame !== -1) {
      this.goToAndStop(pendingFrame, true);
    }
  };

  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
    if (forceFlag) {
      this.segments.length = 0;
    }

    if (_typeof$4(arr[0]) === 'object') {
      var i;
      var len = arr.length;

      for (i = 0; i < len; i += 1) {
        this.segments.push(arr[i]);
      }
    } else {
      this.segments.push(arr);
    }

    if (this.segments.length && forceFlag) {
      this.adjustSegment(this.segments.shift(), 0);
    }

    if (this.isPaused) {
      this.play();
    }
  };

  AnimationItem.prototype.resetSegments = function (forceFlag) {
    this.segments.length = 0;
    this.segments.push([this.animationData.ip, this.animationData.op]);

    if (forceFlag) {
      this.checkSegments(0);
    }
  };

  AnimationItem.prototype.checkSegments = function (offset) {
    if (this.segments.length) {
      this.adjustSegment(this.segments.shift(), offset);
      return true;
    }

    return false;
  };

  AnimationItem.prototype.destroy = function (name) {
    if (name && this.name !== name || !this.renderer) {
      return;
    }

    this.renderer.destroy();
    this.imagePreloader.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = null;
    this.onLoopComplete = null;
    this.onComplete = null;
    this.onSegmentStart = null;
    this.onDestroy = null;
    this.renderer = null;
    this.renderer = null;
    this.imagePreloader = null;
    this.projectInterface = null;
  };

  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
    this.currentRawFrame = value;
    this.gotoFrame();
  };

  AnimationItem.prototype.setSpeed = function (val) {
    this.playSpeed = val;
    this.updaFrameModifier();
  };

  AnimationItem.prototype.setDirection = function (val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
  };

  AnimationItem.prototype.setVolume = function (val, name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.setVolume(val);
  };

  AnimationItem.prototype.getVolume = function () {
    return this.audioController.getVolume();
  };

  AnimationItem.prototype.mute = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.mute();
  };

  AnimationItem.prototype.unmute = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.unmute();
  };

  AnimationItem.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
    this.audioController.setRate(this.playSpeed * this.playDirection);
  };

  AnimationItem.prototype.getPath = function () {
    return this.path;
  };

  AnimationItem.prototype.getAssetsPath = function (assetData) {
    var path = '';

    if (assetData.e) {
      path = assetData.p;
    } else if (this.assetsPath) {
      var imagePath = assetData.p;

      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }

      path = this.assetsPath + imagePath;
    } else {
      path = this.path;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }

    return path;
  };

  AnimationItem.prototype.getAssetData = function (id) {
    var i = 0;
    var len = this.assets.length;

    while (i < len) {
      if (id === this.assets[i].id) {
        return this.assets[i];
      }

      i += 1;
    }

    return null;
  };

  AnimationItem.prototype.hide = function () {
    this.renderer.hide();
  };

  AnimationItem.prototype.show = function () {
    this.renderer.show();
  };

  AnimationItem.prototype.getDuration = function (isFrame) {
    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
  };

  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
    try {
      var element = this.renderer.getElementByPath(path);
      element.updateDocumentData(documentData, index);
    } catch (error) {// TODO: decide how to handle catch case
    }
  };

  AnimationItem.prototype.trigger = function (name) {
    if (this._cbs && this._cbs[name]) {
      switch (name) {
        case 'enterFrame':
          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
          break;

        case 'drawnFrame':
          this.drawnFrameEvent.currentTime = this.currentFrame;
          this.drawnFrameEvent.totalTime = this.totalFrames;
          this.drawnFrameEvent.direction = this.frameModifier;
          this.triggerEvent(name, this.drawnFrameEvent);
          break;

        case 'loopComplete':
          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
          break;

        case 'complete':
          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
          break;

        case 'segmentStart':
          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
          break;

        case 'destroy':
          this.triggerEvent(name, new BMDestroyEvent(name, this));
          break;

        default:
          this.triggerEvent(name);
      }
    }

    if (name === 'enterFrame' && this.onEnterFrame) {
      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
    }

    if (name === 'loopComplete' && this.onLoopComplete) {
      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
    }

    if (name === 'complete' && this.onComplete) {
      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
    }

    if (name === 'segmentStart' && this.onSegmentStart) {
      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
    }

    if (name === 'destroy' && this.onDestroy) {
      this.onDestroy.call(this, new BMDestroyEvent(name, this));
    }
  };

  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);

    if (this.onError) {
      this.onError.call(this, error);
    }
  };

  AnimationItem.prototype.triggerConfigError = function (nativeError) {
    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);

    if (this.onError) {
      this.onError.call(this, error);
    }
  };

  var animationManager = function () {
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var playingAnimationsNum = 0;
    var _stopped = true;
    var _isFrozen = false;

    function removeElement(ev) {
      var i = 0;
      var animItem = ev.target;

      while (i < len) {
        if (registeredAnimations[i].animation === animItem) {
          registeredAnimations.splice(i, 1);
          i -= 1;
          len -= 1;

          if (!animItem.isPaused) {
            subtractPlayingCount();
          }
        }

        i += 1;
      }
    }

    function registerAnimation(element, animationData) {
      if (!element) {
        return null;
      }

      var i = 0;

      while (i < len) {
        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
          return registeredAnimations[i].animation;
        }

        i += 1;
      }

      var animItem = new AnimationItem();
      setupAnimation(animItem, element);
      animItem.setData(element, animationData);
      return animItem;
    }

    function getRegisteredAnimations() {
      var i;
      var lenAnims = registeredAnimations.length;
      var animations = [];

      for (i = 0; i < lenAnims; i += 1) {
        animations.push(registeredAnimations[i].animation);
      }

      return animations;
    }

    function addPlayingCount() {
      playingAnimationsNum += 1;
      activate();
    }

    function subtractPlayingCount() {
      playingAnimationsNum -= 1;
    }

    function setupAnimation(animItem, element) {
      animItem.addEventListener('destroy', removeElement);
      animItem.addEventListener('_active', addPlayingCount);
      animItem.addEventListener('_idle', subtractPlayingCount);
      registeredAnimations.push({
        elem: element,
        animation: animItem
      });
      len += 1;
    }

    function loadAnimation(params) {
      var animItem = new AnimationItem();
      setupAnimation(animItem, null);
      animItem.setParams(params);
      return animItem;
    }

    function setSpeed(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setSpeed(val, animation);
      }
    }

    function setDirection(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setDirection(val, animation);
      }
    }

    function play(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.play(animation);
      }
    }

    function resume(nowTime) {
      var elapsedTime = nowTime - initTime;
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.advanceTime(elapsedTime);
      }

      initTime = nowTime;

      if (playingAnimationsNum && !_isFrozen) {
        window.requestAnimationFrame(resume);
      } else {
        _stopped = true;
      }
    }

    function first(nowTime) {
      initTime = nowTime;
      window.requestAnimationFrame(resume);
    }

    function pause(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.pause(animation);
      }
    }

    function goToAndStop(value, isFrame, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
      }
    }

    function stop(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.stop(animation);
      }
    }

    function togglePause(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.togglePause(animation);
      }
    }

    function destroy(animation) {
      var i;

      for (i = len - 1; i >= 0; i -= 1) {
        registeredAnimations[i].animation.destroy(animation);
      }
    }

    function searchAnimations(animationData, standalone, renderer) {
      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
      var i;
      var lenAnims = animElements.length;

      for (i = 0; i < lenAnims; i += 1) {
        if (renderer) {
          animElements[i].setAttribute('data-bm-type', renderer);
        }

        registerAnimation(animElements[i], animationData);
      }

      if (standalone && lenAnims === 0) {
        if (!renderer) {
          renderer = 'svg';
        }

        var body = document.getElementsByTagName('body')[0];
        body.innerText = '';
        var div = createTag('div');
        div.style.width = '100%';
        div.style.height = '100%';
        div.setAttribute('data-bm-type', renderer);
        body.appendChild(div);
        registerAnimation(div, animationData);
      }
    }

    function resize() {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.resize();
      }
    }

    function activate() {
      if (!_isFrozen && playingAnimationsNum) {
        if (_stopped) {
          window.requestAnimationFrame(first);
          _stopped = false;
        }
      }
    }

    function freeze() {
      _isFrozen = true;
    }

    function unfreeze() {
      _isFrozen = false;
      activate();
    }

    function setVolume(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setVolume(val, animation);
      }
    }

    function mute(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.mute(animation);
      }
    }

    function unmute(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.unmute(animation);
      }
    }

    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize; // moduleOb.start = start;

    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    moduleOb.freeze = freeze;
    moduleOb.unfreeze = unfreeze;
    moduleOb.setVolume = setVolume;
    moduleOb.mute = mute;
    moduleOb.unmute = unmute;
    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
    return moduleOb;
  }();

  /* eslint-disable */
  var BezierFactory = function () {
    /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */
    var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};

    function getBezierEasing(a, b, c, d, nm) {
      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');

      if (beziers[str]) {
        return beziers[str];
      }

      var bezEasing = new BezierEasing([a, b, c, d]);
      beziers[str] = bezEasing;
      return bezEasing;
    } // These values are established by empiricism with tests (tradeoff: performance VS precision)


    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    var float32ArraySupported = typeof Float32Array === 'function';

    function A(aA1, aA2) {
      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }

    function B(aA1, aA2) {
      return 3.0 * aA2 - 6.0 * aA1;
    }

    function C(aA1) {
      return 3.0 * aA1;
    } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


    function calcBezier(aT, aA1, aA2) {
      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


    function getSlope(aT, aA1, aA2) {
      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function binarySubdivide(aX, aA, aB, mX1, mX2) {
      var currentX,
          currentT,
          i = 0;

      do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;

        if (currentX > 0.0) {
          aB = currentT;
        } else {
          aA = currentT;
        }
      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

      return currentT;
    }

    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
      }

      return aGuessT;
    }
    /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */


    function BezierEasing(points) {
      this._p = points;
      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
      this._precomputed = false;
      this.get = this.get.bind(this);
    }

    BezierEasing.prototype = {
      get: function get(x) {
        var mX1 = this._p[0],
            mY1 = this._p[1],
            mX2 = this._p[2],
            mY2 = this._p[3];
        if (!this._precomputed) this._precompute();
        if (mX1 === mY1 && mX2 === mY2) return x; // linear
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.

        if (x === 0) return 0;
        if (x === 1) return 1;
        return calcBezier(this._getTForX(x), mY1, mY2);
      },
      // Private part
      _precompute: function _precompute() {
        var mX1 = this._p[0],
            mY1 = this._p[1],
            mX2 = this._p[2],
            mY2 = this._p[3];
        this._precomputed = true;

        if (mX1 !== mY1 || mX2 !== mY2) {
          this._calcSampleValues();
        }
      },
      _calcSampleValues: function _calcSampleValues() {
        var mX1 = this._p[0],
            mX2 = this._p[2];

        for (var i = 0; i < kSplineTableSize; ++i) {
          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        }
      },

      /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */
      _getTForX: function _getTForX(aX) {
        var mX1 = this._p[0],
            mX2 = this._p[2],
            mSampleValues = this._mSampleValues;
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;

        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
          intervalStart += kSampleStepSize;
        }

        --currentSample; // Interpolate to provide an initial guess for t

        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);

        if (initialSlope >= NEWTON_MIN_SLOPE) {
          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }

        if (initialSlope === 0.0) {
          return guessForT;
        }

        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    };
    return ob;
  }();

  var pooling = function () {
    function _double(arr) {
      return arr.concat(createSizedArray(arr.length));
    }

    return {
      "double": _double
    };
  }();

  var poolFactory = function () {
    return function (initialLength, _create, _release) {
      var _length = 0;
      var _maxLength = initialLength;
      var pool = createSizedArray(_maxLength);
      var ob = {
        newElement: newElement,
        release: release
      };

      function newElement() {
        var element;

        if (_length) {
          _length -= 1;
          element = pool[_length];
        } else {
          element = _create();
        }

        return element;
      }

      function release(element) {
        if (_length === _maxLength) {
          pool = pooling["double"](pool);
          _maxLength *= 2;
        }

        if (_release) {
          _release(element);
        }

        pool[_length] = element;
        _length += 1;
      }

      return ob;
    };
  }();

  var bezierLengthPool = function () {
    function create() {
      return {
        addedLength: 0,
        percents: createTypedArray('float32', getDefaultCurveSegments()),
        lengths: createTypedArray('float32', getDefaultCurveSegments())
      };
    }

    return poolFactory(8, create);
  }();

  var segmentsLengthPool = function () {
    function create() {
      return {
        lengths: [],
        totalLength: 0
      };
    }

    function release(element) {
      var i;
      var len = element.lengths.length;

      for (i = 0; i < len; i += 1) {
        bezierLengthPool.release(element.lengths[i]);
      }

      element.lengths.length = 0;
    }

    return poolFactory(8, create, release);
  }();

  function bezFunction() {
    var math = Math;

    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
      return det1 > -0.001 && det1 < 0.001;
    }

    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
      if (z1 === 0 && z2 === 0 && z3 === 0) {
        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
      }

      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
      var diffDist;

      if (dist1 > dist2) {
        if (dist1 > dist3) {
          diffDist = dist1 - dist2 - dist3;
        } else {
          diffDist = dist3 - dist2 - dist1;
        }
      } else if (dist3 > dist2) {
        diffDist = dist3 - dist2 - dist1;
      } else {
        diffDist = dist2 - dist1 - dist3;
      }

      return diffDist > -0.0001 && diffDist < 0.0001;
    }

    var getBezierLength = function () {
      return function (pt1, pt2, pt3, pt4) {
        var curveSegments = getDefaultCurveSegments();
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point = [];
        var lastPoint = [];
        var lengthData = bezierLengthPool.newElement();
        len = pt3.length;

        for (k = 0; k < curveSegments; k += 1) {
          perc = k / (curveSegments - 1);
          ptDistance = 0;

          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;

            if (lastPoint[i] !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }

            lastPoint[i] = point[i];
          }

          if (ptDistance) {
            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
          }

          lengthData.percents[k] = perc;
          lengthData.lengths[k] = addedLength;
        }

        lengthData.addedLength = addedLength;
        return lengthData;
      };
    }();

    function getSegmentsLength(shapeData) {
      var segmentsLength = segmentsLengthPool.newElement();
      var closed = shapeData.c;
      var pathV = shapeData.v;
      var pathO = shapeData.o;
      var pathI = shapeData.i;
      var i;
      var len = shapeData._length;
      var lengths = segmentsLength.lengths;
      var totalLength = 0;

      for (i = 0; i < len - 1; i += 1) {
        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
        totalLength += lengths[i].addedLength;
      }

      if (closed && len) {
        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
        totalLength += lengths[i].addedLength;
      }

      segmentsLength.totalLength = totalLength;
      return segmentsLength;
    }

    function BezierData(length) {
      this.segmentLength = 0;
      this.points = new Array(length);
    }

    function PointData(partial, point) {
      this.partialLength = partial;
      this.point = point;
    }

    var buildBezierData = function () {
      var storedData = {};
      return function (pt1, pt2, pt3, pt4) {
        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');

        if (!storedData[bezierName]) {
          var curveSegments = getDefaultCurveSegments();
          var k;
          var i;
          var len;
          var ptCoord;
          var perc;
          var addedLength = 0;
          var ptDistance;
          var point;
          var lastPoint = null;

          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
            curveSegments = 2;
          }

          var bezierData = new BezierData(curveSegments);
          len = pt3.length;

          for (k = 0; k < curveSegments; k += 1) {
            point = createSizedArray(len);
            perc = k / (curveSegments - 1);
            ptDistance = 0;

            for (i = 0; i < len; i += 1) {
              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
              point[i] = ptCoord;

              if (lastPoint !== null) {
                ptDistance += bmPow(point[i] - lastPoint[i], 2);
              }
            }

            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
            bezierData.points[k] = new PointData(ptDistance, point);
            lastPoint = point;
          }

          bezierData.segmentLength = addedLength;
          storedData[bezierName] = bezierData;
        }

        return storedData[bezierName];
      };
    }();

    function getDistancePerc(perc, bezierData) {
      var percents = bezierData.percents;
      var lengths = bezierData.lengths;
      var len = percents.length;
      var initPos = bmFloor((len - 1) * perc);
      var lengthPos = perc * bezierData.addedLength;
      var lPerc = 0;

      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
        return percents[initPos];
      }

      var dir = lengths[initPos] > lengthPos ? -1 : 1;
      var flag = true;

      while (flag) {
        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
          flag = false;
        } else {
          initPos += dir;
        }

        if (initPos < 0 || initPos >= len - 1) {
          // FIX for TypedArrays that don't store floating point values with enough accuracy
          if (initPos === len - 1) {
            return percents[initPos];
          }

          flag = false;
        }
      }

      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
    }

    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
      var t1 = getDistancePerc(percent, bezierData);
      var u1 = 1 - t1;
      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
      return [ptX, ptY];
    }

    var bezierSegmentPoints = createTypedArray('float32', 8);

    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
      if (startPerc < 0) {
        startPerc = 0;
      } else if (startPerc > 1) {
        startPerc = 1;
      }

      var t0 = getDistancePerc(startPerc, bezierData);
      endPerc = endPerc > 1 ? 1 : endPerc;
      var t1 = getDistancePerc(endPerc, bezierData);
      var i;
      var len = pt1.length;
      var u0 = 1 - t0;
      var u1 = 1 - t1;
      var u0u0u0 = u0 * u0 * u0;
      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase

      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase

      var t0t0t0 = t0 * t0 * t0; //

      var u0u0u1 = u0 * u0 * u1;
      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase

      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase

      var t0t0t1 = t0 * t0 * t1; //

      var u0u1u1 = u0 * u1 * u1;
      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase

      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase

      var t0t1t1 = t0 * t1 * t1; //

      var u1u1u1 = u1 * u1 * u1;
      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase

      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase

      var t1t1t1 = t1 * t1 * t1;

      for (i = 0; i < len; i += 1) {
        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      }

      return bezierSegmentPoints;
    }

    return {
      getSegmentsLength: getSegmentsLength,
      getNewSegment: getNewSegment,
      getPointInSegment: getPointInSegment,
      buildBezierData: buildBezierData,
      pointOnLine2D: pointOnLine2D,
      pointOnLine3D: pointOnLine3D
    };
  }

  var bez = bezFunction();

  var PropertyFactory = function () {
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;

    function interpolateValue(frameNum, caching) {
      var offsetTime = this.offsetTime;
      var newValue;

      if (this.propType === 'multidimensional') {
        newValue = createTypedArray('float32', this.pv.length);
      }

      var iterationIndex = caching.lastIndex;
      var i = iterationIndex;
      var len = this.keyframes.length - 1;
      var flag = true;
      var keyData;
      var nextKeyData;
      var keyframeMetadata;

      while (flag) {
        keyData = this.keyframes[i];
        nextKeyData = this.keyframes[i + 1];

        if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
          if (keyData.h) {
            keyData = nextKeyData;
          }

          iterationIndex = 0;
          break;
        }

        if (nextKeyData.t - offsetTime > frameNum) {
          iterationIndex = i;
          break;
        }

        if (i < len - 1) {
          i += 1;
        } else {
          iterationIndex = 0;
          flag = false;
        }
      }

      keyframeMetadata = this.keyframesMetadata[i] || {};
      var k;
      var kLen;
      var perc;
      var jLen;
      var j;
      var fnc;
      var nextKeyTime = nextKeyData.t - offsetTime;
      var keyTime = keyData.t - offsetTime;
      var endValue;

      if (keyData.to) {
        if (!keyframeMetadata.bezierData) {
          keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
        }

        var bezierData = keyframeMetadata.bezierData;

        if (frameNum >= nextKeyTime || frameNum < keyTime) {
          var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
          kLen = bezierData.points[ind].point.length;

          for (k = 0; k < kLen; k += 1) {
            newValue[k] = bezierData.points[ind].point[k];
          } // caching._lastKeyframeIndex = -1;

        } else {
          if (keyframeMetadata.__fnct) {
            fnc = keyframeMetadata.__fnct;
          } else {
            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
            keyframeMetadata.__fnct = fnc;
          }

          perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
          var distanceInLine = bezierData.segmentLength * perc;
          var segmentPerc;
          var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
          j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
          flag = true;
          jLen = bezierData.points.length;

          while (flag) {
            addedLength += bezierData.points[j].partialLength;

            if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
              kLen = bezierData.points[j].point.length;

              for (k = 0; k < kLen; k += 1) {
                newValue[k] = bezierData.points[j].point[k];
              }

              break;
            } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
              segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
              kLen = bezierData.points[j].point.length;

              for (k = 0; k < kLen; k += 1) {
                newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
              }

              break;
            }

            if (j < jLen - 1) {
              j += 1;
            } else {
              flag = false;
            }
          }

          caching._lastPoint = j;
          caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
          caching._lastKeyframeIndex = i;
        }
      } else {
        var outX;
        var outY;
        var inX;
        var inY;
        var keyValue;
        len = keyData.s.length;
        endValue = nextKeyData.s || keyData.e;

        if (this.sh && keyData.h !== 1) {
          if (frameNum >= nextKeyTime) {
            newValue[0] = endValue[0];
            newValue[1] = endValue[1];
            newValue[2] = endValue[2];
          } else if (frameNum <= keyTime) {
            newValue[0] = keyData.s[0];
            newValue[1] = keyData.s[1];
            newValue[2] = keyData.s[2];
          } else {
            var quatStart = createQuaternion(keyData.s);
            var quatEnd = createQuaternion(endValue);
            var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
            quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
          }
        } else {
          for (i = 0; i < len; i += 1) {
            if (keyData.h !== 1) {
              if (frameNum >= nextKeyTime) {
                perc = 1;
              } else if (frameNum < keyTime) {
                perc = 0;
              } else {
                if (keyData.o.x.constructor === Array) {
                  if (!keyframeMetadata.__fnct) {
                    keyframeMetadata.__fnct = [];
                  }

                  if (!keyframeMetadata.__fnct[i]) {
                    outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                    outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                    inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                    inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                    keyframeMetadata.__fnct[i] = fnc;
                  } else {
                    fnc = keyframeMetadata.__fnct[i];
                  }
                } else if (!keyframeMetadata.__fnct) {
                  outX = keyData.o.x;
                  outY = keyData.o.y;
                  inX = keyData.i.x;
                  inY = keyData.i.y;
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyData.keyframeMetadata = fnc;
                } else {
                  fnc = keyframeMetadata.__fnct;
                }

                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
              }
            }

            endValue = nextKeyData.s || keyData.e;
            keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

            if (this.propType === 'multidimensional') {
              newValue[i] = keyValue;
            } else {
              newValue = keyValue;
            }
          }
        }
      }

      caching.lastIndex = iterationIndex;
      return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/


    function slerp(a, b, t) {
      var out = [];
      var ax = a[0];
      var ay = a[1];
      var az = a[2];
      var aw = a[3];
      var bx = b[0];
      var by = b[1];
      var bz = b[2];
      var bw = b[3];
      var omega;
      var cosom;
      var sinom;
      var scale0;
      var scale1;
      cosom = ax * bx + ay * by + az * bz + aw * bw;

      if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
      }

      if (1.0 - cosom > 0.000001) {
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
      } else {
        scale0 = 1.0 - t;
        scale1 = t;
      }

      out[0] = scale0 * ax + scale1 * bx;
      out[1] = scale0 * ay + scale1 * by;
      out[2] = scale0 * az + scale1 * bz;
      out[3] = scale0 * aw + scale1 * bw;
      return out;
    }

    function quaternionToEuler(out, quat) {
      var qx = quat[0];
      var qy = quat[1];
      var qz = quat[2];
      var qw = quat[3];
      var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
      var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
      var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
      out[0] = heading / degToRads;
      out[1] = attitude / degToRads;
      out[2] = bank / degToRads;
    }

    function createQuaternion(values) {
      var heading = values[0] * degToRads;
      var attitude = values[1] * degToRads;
      var bank = values[2] * degToRads;
      var c1 = Math.cos(heading / 2);
      var c2 = Math.cos(attitude / 2);
      var c3 = Math.cos(bank / 2);
      var s1 = Math.sin(heading / 2);
      var s2 = Math.sin(attitude / 2);
      var s3 = Math.sin(bank / 2);
      var w = c1 * c2 * c3 - s1 * s2 * s3;
      var x = s1 * s2 * c3 + c1 * c2 * s3;
      var y = s1 * c2 * c3 + c1 * s2 * s3;
      var z = c1 * s2 * c3 - s1 * c2 * s3;
      return [x, y, z, w];
    }

    function getValueAtCurrentTime() {
      var frameNum = this.comp.renderedFrame - this.offsetTime;
      var initTime = this.keyframes[0].t - this.offsetTime;
      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

      if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
        if (this._caching.lastFrame >= frameNum) {
          this._caching._lastKeyframeIndex = -1;
          this._caching.lastIndex = 0;
        }

        var renderResult = this.interpolateValue(frameNum, this._caching);
        this.pv = renderResult;
      }

      this._caching.lastFrame = frameNum;
      return this.pv;
    }

    function setVValue(val) {
      var multipliedValue;

      if (this.propType === 'unidimensional') {
        multipliedValue = val * this.mult;

        if (mathAbs(this.v - multipliedValue) > 0.00001) {
          this.v = multipliedValue;
          this._mdf = true;
        }
      } else {
        var i = 0;
        var len = this.v.length;

        while (i < len) {
          multipliedValue = val[i] * this.mult;

          if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
            this.v[i] = multipliedValue;
            this._mdf = true;
          }

          i += 1;
        }
      }
    }

    function processEffectsSequence() {
      if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
        return;
      }

      if (this.lock) {
        this.setVValue(this.pv);
        return;
      }

      this.lock = true;
      this._mdf = this._isFirstFrame;
      var i;
      var len = this.effectsSequence.length;
      var finalValue = this.kf ? this.pv : this.data.k;

      for (i = 0; i < len; i += 1) {
        finalValue = this.effectsSequence[i](finalValue);
      }

      this.setVValue(finalValue);
      this._isFirstFrame = false;
      this.lock = false;
      this.frameId = this.elem.globalData.frameId;
    }

    function addEffect(effectFunction) {
      this.effectsSequence.push(effectFunction);
      this.container.addDynamicProperty(this);
    }

    function ValueProperty(elem, data, mult, container) {
      this.propType = 'unidimensional';
      this.mult = mult || 1;
      this.data = data;
      this.v = mult ? data.k * mult : data.k;
      this.pv = data.k;
      this._mdf = false;
      this.elem = elem;
      this.container = container;
      this.comp = elem.comp;
      this.k = false;
      this.kf = false;
      this.vel = 0;
      this.effectsSequence = [];
      this._isFirstFrame = true;
      this.getValue = processEffectsSequence;
      this.setVValue = setVValue;
      this.addEffect = addEffect;
    }

    function MultiDimensionalProperty(elem, data, mult, container) {
      this.propType = 'multidimensional';
      this.mult = mult || 1;
      this.data = data;
      this._mdf = false;
      this.elem = elem;
      this.container = container;
      this.comp = elem.comp;
      this.k = false;
      this.kf = false;
      this.frameId = -1;
      var i;
      var len = data.k.length;
      this.v = createTypedArray('float32', len);
      this.pv = createTypedArray('float32', len);
      this.vel = createTypedArray('float32', len);

      for (i = 0; i < len; i += 1) {
        this.v[i] = data.k[i] * this.mult;
        this.pv[i] = data.k[i];
      }

      this._isFirstFrame = true;
      this.effectsSequence = [];
      this.getValue = processEffectsSequence;
      this.setVValue = setVValue;
      this.addEffect = addEffect;
    }

    function KeyframedValueProperty(elem, data, mult, container) {
      this.propType = 'unidimensional';
      this.keyframes = data.k;
      this.keyframesMetadata = [];
      this.offsetTime = elem.data.st;
      this.frameId = -1;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      };
      this.k = true;
      this.kf = true;
      this.data = data;
      this.mult = mult || 1;
      this.elem = elem;
      this.container = container;
      this.comp = elem.comp;
      this.v = initFrame;
      this.pv = initFrame;
      this._isFirstFrame = true;
      this.getValue = processEffectsSequence;
      this.setVValue = setVValue;
      this.interpolateValue = interpolateValue;
      this.effectsSequence = [getValueAtCurrentTime.bind(this)];
      this.addEffect = addEffect;
    }

    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
      this.propType = 'multidimensional';
      var i;
      var len = data.k.length;
      var s;
      var e;
      var to;
      var ti;

      for (i = 0; i < len - 1; i += 1) {
        if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
          s = data.k[i].s;
          e = data.k[i + 1].s;
          to = data.k[i].to;
          ti = data.k[i].ti;

          if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }

          if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
            if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
              data.k[i].to = null;
              data.k[i].ti = null;
            }
          }
        }
      }

      this.effectsSequence = [getValueAtCurrentTime.bind(this)];
      this.data = data;
      this.keyframes = data.k;
      this.keyframesMetadata = [];
      this.offsetTime = elem.data.st;
      this.k = true;
      this.kf = true;
      this._isFirstFrame = true;
      this.mult = mult || 1;
      this.elem = elem;
      this.container = container;
      this.comp = elem.comp;
      this.getValue = processEffectsSequence;
      this.setVValue = setVValue;
      this.interpolateValue = interpolateValue;
      this.frameId = -1;
      var arrLen = data.k[0].s.length;
      this.v = createTypedArray('float32', arrLen);
      this.pv = createTypedArray('float32', arrLen);

      for (i = 0; i < arrLen; i += 1) {
        this.v[i] = initFrame;
        this.pv[i] = initFrame;
      }

      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray('float32', arrLen)
      };
      this.addEffect = addEffect;
    }

    function getProp(elem, data, type, mult, container) {
      var p;

      if (!data.k.length) {
        p = new ValueProperty(elem, data, mult, container);
      } else if (typeof data.k[0] === 'number') {
        p = new MultiDimensionalProperty(elem, data, mult, container);
      } else {
        switch (type) {
          case 0:
            p = new KeyframedValueProperty(elem, data, mult, container);
            break;

          case 1:
            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
            break;

          default:
            break;
        }
      }

      if (p.effectsSequence.length) {
        container.addDynamicProperty(p);
      }

      return p;
    }

    var ob = {
      getProp: getProp
    };
    return ob;
  }();

  function DynamicPropertyContainer() {}

  DynamicPropertyContainer.prototype = {
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
        this.container.addDynamicProperty(this);
        this._isAnimated = true;
      }
    },
    iterateDynamicProperties: function iterateDynamicProperties() {
      this._mdf = false;
      var i;
      var len = this.dynamicProperties.length;

      for (i = 0; i < len; i += 1) {
        this.dynamicProperties[i].getValue();

        if (this.dynamicProperties[i]._mdf) {
          this._mdf = true;
        }
      }
    },
    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
      this.container = container;
      this.dynamicProperties = [];
      this._mdf = false;
      this._isAnimated = false;
    }
  };

  var pointPool = function () {
    function create() {
      return createTypedArray('float32', 2);
    }

    return poolFactory(8, create);
  }();

  function ShapePath() {
    this.c = false;
    this._length = 0;
    this._maxLength = 8;
    this.v = createSizedArray(this._maxLength);
    this.o = createSizedArray(this._maxLength);
    this.i = createSizedArray(this._maxLength);
  }

  ShapePath.prototype.setPathData = function (closed, len) {
    this.c = closed;
    this.setLength(len);
    var i = 0;

    while (i < len) {
      this.v[i] = pointPool.newElement();
      this.o[i] = pointPool.newElement();
      this.i[i] = pointPool.newElement();
      i += 1;
    }
  };

  ShapePath.prototype.setLength = function (len) {
    while (this._maxLength < len) {
      this.doubleArrayLength();
    }

    this._length = len;
  };

  ShapePath.prototype.doubleArrayLength = function () {
    this.v = this.v.concat(createSizedArray(this._maxLength));
    this.i = this.i.concat(createSizedArray(this._maxLength));
    this.o = this.o.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  };

  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
    var arr;
    this._length = Math.max(this._length, pos + 1);

    if (this._length >= this._maxLength) {
      this.doubleArrayLength();
    }

    switch (type) {
      case 'v':
        arr = this.v;
        break;

      case 'i':
        arr = this.i;
        break;

      case 'o':
        arr = this.o;
        break;

      default:
        arr = [];
        break;
    }

    if (!arr[pos] || arr[pos] && !replace) {
      arr[pos] = pointPool.newElement();
    }

    arr[pos][0] = x;
    arr[pos][1] = y;
  };

  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
    this.setXYAt(vX, vY, 'v', pos, replace);
    this.setXYAt(oX, oY, 'o', pos, replace);
    this.setXYAt(iX, iY, 'i', pos, replace);
  };

  ShapePath.prototype.reverse = function () {
    var newPath = new ShapePath();
    newPath.setPathData(this.c, this._length);
    var vertices = this.v;
    var outPoints = this.o;
    var inPoints = this.i;
    var init = 0;

    if (this.c) {
      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
      init = 1;
    }

    var cnt = this._length - 1;
    var len = this._length;
    var i;

    for (i = init; i < len; i += 1) {
      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
      cnt -= 1;
    }

    return newPath;
  };

  var shapePool = function () {
    function create() {
      return new ShapePath();
    }

    function release(shapePath) {
      var len = shapePath._length;
      var i;

      for (i = 0; i < len; i += 1) {
        pointPool.release(shapePath.v[i]);
        pointPool.release(shapePath.i[i]);
        pointPool.release(shapePath.o[i]);
        shapePath.v[i] = null;
        shapePath.i[i] = null;
        shapePath.o[i] = null;
      }

      shapePath._length = 0;
      shapePath.c = false;
    }

    function clone(shape) {
      var cloned = factory.newElement();
      var i;
      var len = shape._length === undefined ? shape.v.length : shape._length;
      cloned.setLength(len);
      cloned.c = shape.c;

      for (i = 0; i < len; i += 1) {
        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
      }

      return cloned;
    }

    var factory = poolFactory(4, create, release);
    factory.clone = clone;
    return factory;
  }();

  function ShapeCollection() {
    this._length = 0;
    this._maxLength = 4;
    this.shapes = createSizedArray(this._maxLength);
  }

  ShapeCollection.prototype.addShape = function (shapeData) {
    if (this._length === this._maxLength) {
      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
      this._maxLength *= 2;
    }

    this.shapes[this._length] = shapeData;
    this._length += 1;
  };

  ShapeCollection.prototype.releaseShapes = function () {
    var i;

    for (i = 0; i < this._length; i += 1) {
      shapePool.release(this.shapes[i]);
    }

    this._length = 0;
  };

  var shapeCollectionPool = function () {
    var ob = {
      newShapeCollection: newShapeCollection,
      release: release
    };
    var _length = 0;
    var _maxLength = 4;
    var pool = createSizedArray(_maxLength);

    function newShapeCollection() {
      var shapeCollection;

      if (_length) {
        _length -= 1;
        shapeCollection = pool[_length];
      } else {
        shapeCollection = new ShapeCollection();
      }

      return shapeCollection;
    }

    function release(shapeCollection) {
      var i;
      var len = shapeCollection._length;

      for (i = 0; i < len; i += 1) {
        shapePool.release(shapeCollection.shapes[i]);
      }

      shapeCollection._length = 0;

      if (_length === _maxLength) {
        pool = pooling["double"](pool);
        _maxLength *= 2;
      }

      pool[_length] = shapeCollection;
      _length += 1;
    }

    return ob;
  }();

  var ShapePropertyFactory = function () {
    var initFrame = -999999;

    function interpolateShape(frameNum, previousValue, caching) {
      var iterationIndex = caching.lastIndex;
      var keyPropS;
      var keyPropE;
      var isHold;
      var j;
      var k;
      var jLen;
      var kLen;
      var perc;
      var vertexValue;
      var kf = this.keyframes;

      if (frameNum < kf[0].t - this.offsetTime) {
        keyPropS = kf[0].s[0];
        isHold = true;
        iterationIndex = 0;
      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
        /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */

        isHold = true;
      } else {
        var i = iterationIndex;
        var len = kf.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;

        while (flag) {
          keyData = kf[i];
          nextKeyData = kf[i + 1];

          if (nextKeyData.t - this.offsetTime > frameNum) {
            break;
          }

          if (i < len - 1) {
            i += 1;
          } else {
            flag = false;
          }
        }

        keyframeMetadata = this.keyframesMetadata[i] || {};
        isHold = keyData.h === 1;
        iterationIndex = i;

        if (!isHold) {
          if (frameNum >= nextKeyData.t - this.offsetTime) {
            perc = 1;
          } else if (frameNum < keyData.t - this.offsetTime) {
            perc = 0;
          } else {
            var fnc;

            if (keyframeMetadata.__fnct) {
              fnc = keyframeMetadata.__fnct;
            } else {
              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
              keyframeMetadata.__fnct = fnc;
            }

            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
          }

          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
        }

        keyPropS = keyData.s[0];
      }

      jLen = previousValue._length;
      kLen = keyPropS.i[0].length;
      caching.lastIndex = iterationIndex;

      for (j = 0; j < jLen; j += 1) {
        for (k = 0; k < kLen; k += 1) {
          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
          previousValue.i[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
          previousValue.o[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
          previousValue.v[j][k] = vertexValue;
        }
      }
    }

    function interpolateShapeCurrentTime() {
      var frameNum = this.comp.renderedFrame - this.offsetTime;
      var initTime = this.keyframes[0].t - this.offsetTime;
      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      var lastFrame = this._caching.lastFrame;

      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
        /// /
        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
        this.interpolateShape(frameNum, this.pv, this._caching); /// /
      }

      this._caching.lastFrame = frameNum;
      return this.pv;
    }

    function resetShape() {
      this.paths = this.localShapeCollection;
    }

    function shapesEqual(shape1, shape2) {
      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
        return false;
      }

      var i;
      var len = shape1._length;

      for (i = 0; i < len; i += 1) {
        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
          return false;
        }
      }

      return true;
    }

    function setVValue(newPath) {
      if (!shapesEqual(this.v, newPath)) {
        this.v = shapePool.clone(newPath);
        this.localShapeCollection.releaseShapes();
        this.localShapeCollection.addShape(this.v);
        this._mdf = true;
        this.paths = this.localShapeCollection;
      }
    }

    function processEffectsSequence() {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }

      if (!this.effectsSequence.length) {
        this._mdf = false;
        return;
      }

      if (this.lock) {
        this.setVValue(this.pv);
        return;
      }

      this.lock = true;
      this._mdf = false;
      var finalValue;

      if (this.kf) {
        finalValue = this.pv;
      } else if (this.data.ks) {
        finalValue = this.data.ks.k;
      } else {
        finalValue = this.data.pt.k;
      }

      var i;
      var len = this.effectsSequence.length;

      for (i = 0; i < len; i += 1) {
        finalValue = this.effectsSequence[i](finalValue);
      }

      this.setVValue(finalValue);
      this.lock = false;
      this.frameId = this.elem.globalData.frameId;
    }

    function ShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.container = elem;
      this.elem = elem;
      this.data = data;
      this.k = false;
      this.kf = false;
      this._mdf = false;
      var pathData = type === 3 ? data.pt.k : data.ks.k;
      this.v = shapePool.clone(pathData);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.reset = resetShape;
      this.effectsSequence = [];
    }

    function addEffect(effectFunction) {
      this.effectsSequence.push(effectFunction);
      this.container.addDynamicProperty(this);
    }

    ShapeProperty.prototype.interpolateShape = interpolateShape;
    ShapeProperty.prototype.getValue = processEffectsSequence;
    ShapeProperty.prototype.setVValue = setVValue;
    ShapeProperty.prototype.addEffect = addEffect;

    function KeyframedShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.elem = elem;
      this.container = elem;
      this.offsetTime = elem.data.st;
      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
      this.keyframesMetadata = [];
      this.k = true;
      this.kf = true;
      var len = this.keyframes[0].s[0].i.length;
      this.v = shapePool.newElement();
      this.v.setPathData(this.keyframes[0].s[0].c, len);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.lastFrame = initFrame;
      this.reset = resetShape;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0
      };
      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
    }

    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
    KeyframedShapeProperty.prototype.setVValue = setVValue;
    KeyframedShapeProperty.prototype.addEffect = addEffect;

    var EllShapeProperty = function () {
      var cPoint = roundCorner;

      function EllShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 4);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.localShapeCollection.addShape(this.v);
        this.d = data.d;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertEllToPath();
        }
      }

      EllShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertEllToPath();
          }
        },
        convertEllToPath: function convertEllToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var s0 = this.s.v[0] / 2;
          var s1 = this.s.v[1] / 2;

          var _cw = this.d !== 3;

          var _v = this.v;
          _v.v[0][0] = p0;
          _v.v[0][1] = p1 - s1;
          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.v[1][1] = p1;
          _v.v[2][0] = p0;
          _v.v[2][1] = p1 + s1;
          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.v[3][1] = p1;
          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.i[0][1] = p1 - s1;
          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.i[1][1] = p1 - s1 * cPoint;
          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.i[2][1] = p1 + s1;
          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.i[3][1] = p1 + s1 * cPoint;
          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.o[0][1] = p1 - s1;
          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.o[1][1] = p1 + s1 * cPoint;
          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.o[2][1] = p1 + s1;
          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.o[3][1] = p1 - s1 * cPoint;
        }
      };
      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
      return EllShapePropertyFactory;
    }();

    var StarShapeProperty = function () {
      function StarShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 0);
        this.elem = elem;
        this.comp = elem.comp;
        this.data = data;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);

        if (data.sy === 1) {
          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
          this.convertToPath = this.convertStarToPath;
        } else {
          this.convertToPath = this.convertPolygonToPath;
        }

        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertToPath();
        }
      }

      StarShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertToPath();
          }
        },
        convertStarToPath: function convertStarToPath() {
          var numPts = Math.floor(this.pt.v) * 2;
          var angle = Math.PI * 2 / numPts;
          /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */

          var longFlag = true;
          var longRad = this.or.v;
          var shortRad = this.ir.v;
          var longRound = this.os.v;
          var shortRound = this.is.v;
          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
          var i;
          var rad;
          var roundness;
          var perimSegment;
          var currentAng = -Math.PI / 2;
          currentAng += this.r.v;
          var dir = this.data.d === 3 ? -1 : 1;
          this.v._length = 0;

          for (i = 0; i < numPts; i += 1) {
            rad = longFlag ? longRad : shortRad;
            roundness = longFlag ? longRound : shortRound;
            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
            /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */

            longFlag = !longFlag;
            currentAng += angle * dir;
          }
        },
        convertPolygonToPath: function convertPolygonToPath() {
          var numPts = Math.floor(this.pt.v);
          var angle = Math.PI * 2 / numPts;
          var rad = this.or.v;
          var roundness = this.os.v;
          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
          var i;
          var currentAng = -Math.PI * 0.5;
          var dir = this.data.d === 3 ? -1 : 1;
          currentAng += this.r.v;
          this.v._length = 0;

          for (i = 0; i < numPts; i += 1) {
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
            currentAng += angle * dir;
          }

          this.paths.length = 0;
          this.paths[0] = this.v;
        }
      };
      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
      return StarShapePropertyFactory;
    }();

    var RectShapeProperty = function () {
      function RectShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.c = true;
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertRectToPath();
        }
      }

      RectShapePropertyFactory.prototype = {
        convertRectToPath: function convertRectToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var v0 = this.s.v[0] / 2;
          var v1 = this.s.v[1] / 2;
          var round = bmMin(v0, v1, this.r.v);
          var cPoint = round * (1 - roundCorner);
          this.v._length = 0;

          if (this.d === 2 || this.d === 1) {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);

            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
            }
          } else {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);

            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
            }
          }
        },
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertRectToPath();
          }
        },
        reset: resetShape
      };
      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
      return RectShapePropertyFactory;
    }();

    function getShapeProp(elem, data, type) {
      var prop;

      if (type === 3 || type === 4) {
        var dataProp = type === 3 ? data.pt : data.ks;
        var keys = dataProp.k;

        if (keys.length) {
          prop = new KeyframedShapeProperty(elem, data, type);
        } else {
          prop = new ShapeProperty(elem, data, type);
        }
      } else if (type === 5) {
        prop = new RectShapeProperty(elem, data);
      } else if (type === 6) {
        prop = new EllShapeProperty(elem, data);
      } else if (type === 7) {
        prop = new StarShapeProperty(elem, data);
      }

      if (prop.k) {
        elem.addDynamicProperty(prop);
      }

      return prop;
    }

    function getConstructorFunction() {
      return ShapeProperty;
    }

    function getKeyframedConstructorFunction() {
      return KeyframedShapeProperty;
    }

    var ob = {};
    ob.getShapeProp = getShapeProp;
    ob.getConstructorFunction = getConstructorFunction;
    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
    return ob;
  }();

  /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */

  /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */

  var Matrix = function () {
    var _cos = Math.cos;
    var _sin = Math.sin;
    var _tan = Math.tan;
    var _rnd = Math.round;

    function reset() {
      this.props[0] = 1;
      this.props[1] = 0;
      this.props[2] = 0;
      this.props[3] = 0;
      this.props[4] = 0;
      this.props[5] = 1;
      this.props[6] = 0;
      this.props[7] = 0;
      this.props[8] = 0;
      this.props[9] = 0;
      this.props[10] = 1;
      this.props[11] = 0;
      this.props[12] = 0;
      this.props[13] = 0;
      this.props[14] = 0;
      this.props[15] = 1;
      return this;
    }

    function rotate(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function rotateX(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
    }

    function rotateY(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
    }

    function rotateZ(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function shear(sx, sy) {
      return this._t(1, sy, sx, 1, 0, 0);
    }

    function skew(ax, ay) {
      return this.shear(_tan(ax), _tan(ay));
    }

    function skewFromAxis(ax, angle) {
      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }

    function scale(sx, sy, sz) {
      if (!sz && sz !== 0) {
        sz = 1;
      }

      if (sx === 1 && sy === 1 && sz === 1) {
        return this;
      }

      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }

    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
      this.props[0] = a;
      this.props[1] = b;
      this.props[2] = c;
      this.props[3] = d;
      this.props[4] = e;
      this.props[5] = f;
      this.props[6] = g;
      this.props[7] = h;
      this.props[8] = i;
      this.props[9] = j;
      this.props[10] = k;
      this.props[11] = l;
      this.props[12] = m;
      this.props[13] = n;
      this.props[14] = o;
      this.props[15] = p;
      return this;
    }

    function translate(tx, ty, tz) {
      tz = tz || 0;

      if (tx !== 0 || ty !== 0 || tz !== 0) {
        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
      }

      return this;
    }

    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
      var _p = this.props;

      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
        // NOTE: commenting this condition because TurboFan deoptimizes code when present
        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
        _p[12] = _p[12] * a2 + _p[15] * m2;
        _p[13] = _p[13] * f2 + _p[15] * n2;
        _p[14] = _p[14] * k2 + _p[15] * o2;
        _p[15] *= p2; // }

        this._identityCalculated = false;
        return this;
      }

      var a1 = _p[0];
      var b1 = _p[1];
      var c1 = _p[2];
      var d1 = _p[3];
      var e1 = _p[4];
      var f1 = _p[5];
      var g1 = _p[6];
      var h1 = _p[7];
      var i1 = _p[8];
      var j1 = _p[9];
      var k1 = _p[10];
      var l1 = _p[11];
      var m1 = _p[12];
      var n1 = _p[13];
      var o1 = _p[14];
      var p1 = _p[15];
      /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */

      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
      this._identityCalculated = false;
      return this;
    }

    function isIdentity() {
      if (!this._identityCalculated) {
        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
        this._identityCalculated = true;
      }

      return this._identity;
    }

    function equals(matr) {
      var i = 0;

      while (i < 16) {
        if (matr.props[i] !== this.props[i]) {
          return false;
        }

        i += 1;
      }

      return true;
    }

    function clone(matr) {
      var i;

      for (i = 0; i < 16; i += 1) {
        matr.props[i] = this.props[i];
      }

      return matr;
    }

    function cloneFromProps(props) {
      var i;

      for (i = 0; i < 16; i += 1) {
        this.props[i] = props[i];
      }
    }

    function applyToPoint(x, y, z) {
      return {
        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
      };
      /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */
    }

    function applyToX(x, y, z) {
      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }

    function applyToY(x, y, z) {
      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }

    function applyToZ(x, y, z) {
      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }

    function getInverseMatrix() {
      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
      var a = this.props[5] / determinant;
      var b = -this.props[1] / determinant;
      var c = -this.props[4] / determinant;
      var d = this.props[0] / determinant;
      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
      var inverseMatrix = new Matrix();
      inverseMatrix.props[0] = a;
      inverseMatrix.props[1] = b;
      inverseMatrix.props[4] = c;
      inverseMatrix.props[5] = d;
      inverseMatrix.props[12] = e;
      inverseMatrix.props[13] = f;
      return inverseMatrix;
    }

    function inversePoint(pt) {
      var inverseMatrix = this.getInverseMatrix();
      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
    }

    function inversePoints(pts) {
      var i;
      var len = pts.length;
      var retPts = [];

      for (i = 0; i < len; i += 1) {
        retPts[i] = inversePoint(pts[i]);
      }

      return retPts;
    }

    function applyToTriplePoints(pt1, pt2, pt3) {
      var arr = createTypedArray('float32', 6);

      if (this.isIdentity()) {
        arr[0] = pt1[0];
        arr[1] = pt1[1];
        arr[2] = pt2[0];
        arr[3] = pt2[1];
        arr[4] = pt3[0];
        arr[5] = pt3[1];
      } else {
        var p0 = this.props[0];
        var p1 = this.props[1];
        var p4 = this.props[4];
        var p5 = this.props[5];
        var p12 = this.props[12];
        var p13 = this.props[13];
        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
      }

      return arr;
    }

    function applyToPointArray(x, y, z) {
      var arr;

      if (this.isIdentity()) {
        arr = [x, y, z];
      } else {
        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
      }

      return arr;
    }

    function applyToPointStringified(x, y) {
      if (this.isIdentity()) {
        return x + ',' + y;
      }

      var _p = this.props;
      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
    }

    function toCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

      /* if(this.isIdentity()) {
              return '';
          } */
      var i = 0;
      var props = this.props;
      var cssValue = 'matrix3d(';
      var v = 10000;

      while (i < 16) {
        cssValue += _rnd(props[i] * v) / v;
        cssValue += i === 15 ? ')' : ',';
        i += 1;
      }

      return cssValue;
    }

    function roundMatrixProperty(val) {
      var v = 10000;

      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
        return _rnd(val * v) / v;
      }

      return val;
    }

    function to2dCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

      /* if(this.isIdentity()) {
              return '';
          } */
      var props = this.props;

      var _a = roundMatrixProperty(props[0]);

      var _b = roundMatrixProperty(props[1]);

      var _c = roundMatrixProperty(props[4]);

      var _d = roundMatrixProperty(props[5]);

      var _e = roundMatrixProperty(props[12]);

      var _f = roundMatrixProperty(props[13]);

      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
    }

    return function () {
      this.reset = reset;
      this.rotate = rotate;
      this.rotateX = rotateX;
      this.rotateY = rotateY;
      this.rotateZ = rotateZ;
      this.skew = skew;
      this.skewFromAxis = skewFromAxis;
      this.shear = shear;
      this.scale = scale;
      this.setTransform = setTransform;
      this.translate = translate;
      this.transform = transform;
      this.applyToPoint = applyToPoint;
      this.applyToX = applyToX;
      this.applyToY = applyToY;
      this.applyToZ = applyToZ;
      this.applyToPointArray = applyToPointArray;
      this.applyToTriplePoints = applyToTriplePoints;
      this.applyToPointStringified = applyToPointStringified;
      this.toCSS = toCSS;
      this.to2dCSS = to2dCSS;
      this.clone = clone;
      this.cloneFromProps = cloneFromProps;
      this.equals = equals;
      this.inversePoints = inversePoints;
      this.inversePoint = inversePoint;
      this.getInverseMatrix = getInverseMatrix;
      this._t = this.transform;
      this.isIdentity = isIdentity;
      this._identity = true;
      this._identityCalculated = false;
      this.props = createTypedArray('float32', 16);
      this.reset();
    };
  }();

  function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
  var lottie = {};
  var standalone = '__[STANDALONE]__';
  var animationData = '__[ANIMATIONDATA]__';
  var renderer = '';

  function setLocation(href) {
    setLocationHref(href);
  }

  function searchAnimations() {
    if (standalone === true) {
      animationManager.searchAnimations(animationData, standalone, renderer);
    } else {
      animationManager.searchAnimations();
    }
  }

  function setSubframeRendering(flag) {
    setSubframeEnabled(flag);
  }

  function setPrefix(prefix) {
    setIdPrefix(prefix);
  }

  function loadAnimation(params) {
    if (standalone === true) {
      params.animationData = JSON.parse(animationData);
    }

    return animationManager.loadAnimation(params);
  }

  function setQuality(value) {
    if (typeof value === 'string') {
      switch (value) {
        case 'high':
          setDefaultCurveSegments(200);
          break;

        default:
        case 'medium':
          setDefaultCurveSegments(50);
          break;

        case 'low':
          setDefaultCurveSegments(10);
          break;
      }
    } else if (!isNaN(value) && value > 1) {
      setDefaultCurveSegments(value);
    }

    if (getDefaultCurveSegments() >= 50) {
      roundValues(false);
    } else {
      roundValues(true);
    }
  }

  function inBrowser() {
    return typeof navigator !== 'undefined';
  }

  function installPlugin(type, plugin) {
    if (type === 'expressions') {
      setExpressionsPlugin(plugin);
    }
  }

  function getFactory(name) {
    switch (name) {
      case 'propertyFactory':
        return PropertyFactory;

      case 'shapePropertyFactory':
        return ShapePropertyFactory;

      case 'matrix':
        return Matrix;

      default:
        return null;
    }
  }

  lottie.play = animationManager.play;
  lottie.pause = animationManager.pause;
  lottie.setLocationHref = setLocation;
  lottie.togglePause = animationManager.togglePause;
  lottie.setSpeed = animationManager.setSpeed;
  lottie.setDirection = animationManager.setDirection;
  lottie.stop = animationManager.stop;
  lottie.searchAnimations = searchAnimations;
  lottie.registerAnimation = animationManager.registerAnimation;
  lottie.loadAnimation = loadAnimation;
  lottie.setSubframeRendering = setSubframeRendering;
  lottie.resize = animationManager.resize; // lottie.start = start;

  lottie.goToAndStop = animationManager.goToAndStop;
  lottie.destroy = animationManager.destroy;
  lottie.setQuality = setQuality;
  lottie.inBrowser = inBrowser;
  lottie.installPlugin = installPlugin;
  lottie.freeze = animationManager.freeze;
  lottie.unfreeze = animationManager.unfreeze;
  lottie.setVolume = animationManager.setVolume;
  lottie.mute = animationManager.mute;
  lottie.unmute = animationManager.unmute;
  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
  lottie.useWebWorker = setWebWorker;
  lottie.setIDPrefix = setPrefix;
  lottie.__getFactory = getFactory;
  lottie.version = '5.9.6';

  function checkReady() {
    if (document.readyState === 'complete') {
      clearInterval(readyStateCheckInterval);
      searchAnimations();
    }
  }

  function getQueryVariable(variable) {
    var vars = queryString.split('&');

    for (var i = 0; i < vars.length; i += 1) {
      var pair = vars[i].split('=');

      if (decodeURIComponent(pair[0]) == variable) {
        // eslint-disable-line eqeqeq
        return decodeURIComponent(pair[1]);
      }
    }

    return null;
  }

  var queryString = '';

  if (standalone) {
    var scripts = document.getElementsByTagName('script');
    var index = scripts.length - 1;
    var myScript = scripts[index] || {
      src: ''
    };
    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape

    renderer = getQueryVariable('renderer');
  }

  var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility

  try {
    if (!(( false ? undefined : _typeof$3(exports)) === 'object' && typeof module !== 'undefined') && !( true && __webpack_require__(93)) // eslint-disable-line no-undef
    ) {
      window.bodymovin = lottie;
    }
  } catch (err) {//
  }

  var ShapeModifiers = function () {
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;

    function registerModifier(nm, factory) {
      if (!modifiers[nm]) {
        modifiers[nm] = factory;
      }
    }

    function getModifier(nm, elem, data) {
      return new modifiers[nm](elem, data);
    }

    return ob;
  }();

  function ShapeModifier() {}

  ShapeModifier.prototype.initModifierProperties = function () {};

  ShapeModifier.prototype.addShapeToModifier = function () {};

  ShapeModifier.prototype.addShape = function (data) {
    if (!this.closed) {
      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
      data.sh.container.addDynamicProperty(data.sh);
      var shapeData = {
        shape: data.sh,
        data: data,
        localShapeCollection: shapeCollectionPool.newShapeCollection()
      };
      this.shapes.push(shapeData);
      this.addShapeToModifier(shapeData);

      if (this._isAnimated) {
        data.setAsAnimated();
      }
    }
  };

  ShapeModifier.prototype.init = function (elem, data) {
    this.shapes = [];
    this.elem = elem;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, data);
    this.frameId = initialDefaultFrame;
    this.closed = false;
    this.k = false;

    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };

  ShapeModifier.prototype.processKeys = function () {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }

    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
  };

  extendPrototype([DynamicPropertyContainer], ShapeModifier);

  function TrimModifier() {}

  extendPrototype([ShapeModifier], TrimModifier);

  TrimModifier.prototype.initModifierProperties = function (elem, data) {
    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
    this.sValue = 0;
    this.eValue = 0;
    this.getValue = this.processKeys;
    this.m = data.m;
    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
  };

  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
    shapeData.pathsData = [];
  };

  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = [];

    if (e <= 1) {
      segments.push({
        s: s,
        e: e
      });
    } else if (s >= 1) {
      segments.push({
        s: s - 1,
        e: e - 1
      });
    } else {
      segments.push({
        s: s,
        e: 1
      });
      segments.push({
        s: 0,
        e: e - 1
      });
    }

    var shapeSegments = [];
    var i;
    var len = segments.length;
    var segmentOb;

    for (i = 0; i < len; i += 1) {
      segmentOb = segments[i];

      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
        var shapeS;
        var shapeE;

        if (segmentOb.s * totalModifierLength <= addedLength) {
          shapeS = 0;
        } else {
          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
        }

        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
          shapeE = 1;
        } else {
          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
        }

        shapeSegments.push([shapeS, shapeE]);
      }
    }

    if (!shapeSegments.length) {
      shapeSegments.push([0, 0]);
    }

    return shapeSegments;
  };

  TrimModifier.prototype.releasePathsData = function (pathsData) {
    var i;
    var len = pathsData.length;

    for (i = 0; i < len; i += 1) {
      segmentsLengthPool.release(pathsData[i]);
    }

    pathsData.length = 0;
    return pathsData;
  };

  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
    var s;
    var e;

    if (this._mdf || _isFirstFrame) {
      var o = this.o.v % 360 / 360;

      if (o < 0) {
        o += 1;
      }

      if (this.s.v > 1) {
        s = 1 + o;
      } else if (this.s.v < 0) {
        s = 0 + o;
      } else {
        s = this.s.v + o;
      }

      if (this.e.v > 1) {
        e = 1 + o;
      } else if (this.e.v < 0) {
        e = 0 + o;
      } else {
        e = this.e.v + o;
      }

      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }

      s = Math.round(s * 10000) * 0.0001;
      e = Math.round(e * 10000) * 0.0001;
      this.sValue = s;
      this.eValue = e;
    } else {
      s = this.sValue;
      e = this.eValue;
    }

    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var pathsData;
    var pathData;
    var totalShapeLength;
    var totalModifierLength = 0;

    if (e === s) {
      for (i = 0; i < len; i += 1) {
        this.shapes[i].localShapeCollection.releaseShapes();
        this.shapes[i].shape._mdf = true;
        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;

        if (this._mdf) {
          this.shapes[i].pathsData.length = 0;
        }
      }
    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
      var segments = [];
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used

        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
          shapeData.shape.paths = shapeData.localShapeCollection;
        } else {
          shapePaths = shapeData.shape.paths;
          jLen = shapePaths._length;
          totalShapeLength = 0;

          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
            totalShapeLength = shapeData.totalShapeLength;
          } else {
            pathsData = this.releasePathsData(shapeData.pathsData);

            for (j = 0; j < jLen; j += 1) {
              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
              pathsData.push(pathData);
              totalShapeLength += pathData.totalLength;
            }

            shapeData.totalShapeLength = totalShapeLength;
            shapeData.pathsData = pathsData;
          }

          totalModifierLength += totalShapeLength;
          shapeData.shape._mdf = true;
        }
      }

      var shapeS = s;
      var shapeE = e;
      var addedLength = 0;
      var edges;

      for (i = len - 1; i >= 0; i -= 1) {
        shapeData = this.shapes[i];

        if (shapeData.shape._mdf) {
          localShapeCollection = shapeData.localShapeCollection;
          localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group

          if (this.m === 2 && len > 1) {
            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
            addedLength += shapeData.totalShapeLength;
          } else {
            edges = [[shapeS, shapeE]];
          }

          jLen = edges.length;

          for (j = 0; j < jLen; j += 1) {
            shapeS = edges[j][0];
            shapeE = edges[j][1];
            segments.length = 0;

            if (shapeE <= 1) {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength * shapeE
              });
            } else if (shapeS >= 1) {
              segments.push({
                s: shapeData.totalShapeLength * (shapeS - 1),
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            } else {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength
              });
              segments.push({
                s: 0,
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            }

            var newShapesData = this.addShapes(shapeData, segments[0]);

            if (segments[0].s !== segments[0].e) {
              if (segments.length > 1) {
                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];

                if (lastShapeInCollection.c) {
                  var lastShape = newShapesData.pop();
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                } else {
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1]);
                }
              }

              this.addPaths(newShapesData, localShapeCollection);
            }
          }

          shapeData.shape.paths = localShapeCollection;
        }
      }
    } else if (this._mdf) {
      for (i = 0; i < len; i += 1) {
        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
        // Don't remove this even if it's losing cached info.
        this.shapes[i].pathsData.length = 0;
        this.shapes[i].shape._mdf = true;
      }
    }
  };

  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
    var i;
    var len = newPaths.length;

    for (i = 0; i < len; i += 1) {
      localShapeCollection.addShape(newPaths[i]);
    }
  };

  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);

    if (newShape) {
      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
    }

    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
  };

  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
    shapePath.setXYAt(points[1], points[5], 'o', pos);
    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);

    if (newShape) {
      shapePath.setXYAt(points[0], points[4], 'v', pos);
    }

    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
  };

  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i;
    var len = shapeData.shape.paths._length;
    var j;
    var jLen;
    var addedLength = 0;
    var currentLengthData;
    var segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;

    if (!shapePath) {
      shapePath = shapePool.newElement();
      segmentCount = 0;
      initPos = 0;
    } else {
      segmentCount = shapePath._length;
      initPos = shapePath._length;
    }

    shapes.push(shapePath);

    for (i = 0; i < len; i += 1) {
      lengths = pathsData[i].lengths;
      shapePath.c = shapePaths[i].c;
      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;

      for (j = 1; j < jLen; j += 1) {
        currentLengthData = lengths[j - 1];

        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
          addedLength += currentLengthData.addedLength;
          shapePath.c = false;
        } else if (addedLength > shapeSegment.e) {
          shapePath.c = false;
          break;
        } else {
          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

            newShape = false;
            shapePath.c = false;
          }

          addedLength += currentLengthData.addedLength;
          segmentCount += 1;
        }
      }

      if (shapePaths[i].c && lengths.length) {
        currentLengthData = lengths[j - 1];

        if (addedLength <= shapeSegment.e) {
          var segmentLength = lengths[j - 1].addedLength;

          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

            newShape = false;
            shapePath.c = false;
          }
        } else {
          shapePath.c = false;
        }

        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }

      if (shapePath._length) {
        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
      }

      if (addedLength > shapeSegment.e) {
        break;
      }

      if (i < len - 1) {
        shapePath = shapePool.newElement();
        newShape = true;
        shapes.push(shapePath);
        segmentCount = 0;
      }
    }

    return shapes;
  };

  function PuckerAndBloatModifier() {}

  extendPrototype([ShapeModifier], PuckerAndBloatModifier);

  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
    this._isAnimated = !!this.amount.effectsSequence.length;
  };

  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
    var percent = amount / 100;
    var centerPoint = [0, 0];
    var pathLength = path._length;
    var i = 0;

    for (i = 0; i < pathLength; i += 1) {
      centerPoint[0] += path.v[i][0];
      centerPoint[1] += path.v[i][1];
    }

    centerPoint[0] /= pathLength;
    centerPoint[1] /= pathLength;
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;

    for (i = 0; i < pathLength; i += 1) {
      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
    }

    return clonedPath;
  };

  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;

    if (amount !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  var TransformPropertyFactory = function () {
    var defaultVector = [0, 0];

    function applyToMatrix(mat) {
      var _mdf = this._mdf;
      this.iterateDynamicProperties();
      this._mdf = this._mdf || _mdf;

      if (this.a) {
        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }

      if (this.s) {
        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }

      if (this.sk) {
        mat.skewFromAxis(-this.sk.v, this.sa.v);
      }

      if (this.r) {
        mat.rotate(-this.r.v);
      } else {
        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
      }

      if (this.data.p.s) {
        if (this.data.p.z) {
          mat.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          mat.translate(this.px.v, this.py.v, 0);
        }
      } else {
        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }

    function processKeys(forceRender) {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }

      if (this._isDirty) {
        this.precalculateMatrix();
        this._isDirty = false;
      }

      this.iterateDynamicProperties();

      if (this._mdf || forceRender) {
        var frameRate;
        this.v.cloneFromProps(this.pre.props);

        if (this.appliedTransformations < 1) {
          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        }

        if (this.appliedTransformations < 2) {
          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        }

        if (this.sk && this.appliedTransformations < 3) {
          this.v.skewFromAxis(-this.sk.v, this.sa.v);
        }

        if (this.r && this.appliedTransformations < 4) {
          this.v.rotate(-this.r.v);
        } else if (!this.r && this.appliedTransformations < 4) {
          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        }

        if (this.autoOriented) {
          var v1;
          var v2;
          frameRate = this.elem.globalData.frameRate;

          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
            } else {
              v1 = this.p.pv;
              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
            }
          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
            v1 = [];
            v2 = [];
            var px = this.px;
            var py = this.py;

            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
            } else {
              v1 = [px.pv, py.pv];
              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
            }
          } else {
            v2 = defaultVector;
            v1 = v2;
          }

          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
        }

        if (this.data.p && this.data.p.s) {
          if (this.data.p.z) {
            this.v.translate(this.px.v, this.py.v, -this.pz.v);
          } else {
            this.v.translate(this.px.v, this.py.v, 0);
          }
        } else {
          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
      }

      this.frameId = this.elem.globalData.frameId;
    }

    function precalculateMatrix() {
      if (!this.a.k) {
        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        this.appliedTransformations = 1;
      } else {
        return;
      }

      if (!this.s.effectsSequence.length) {
        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        this.appliedTransformations = 2;
      } else {
        return;
      }

      if (this.sk) {
        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
          this.appliedTransformations = 3;
        } else {
          return;
        }
      }

      if (this.r) {
        if (!this.r.effectsSequence.length) {
          this.pre.rotate(-this.r.v);
          this.appliedTransformations = 4;
        }
      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        this.appliedTransformations = 4;
      }
    }

    function autoOrient() {//
      // var prevP = this.getValueAtTime();
    }

    function addDynamicProperty(prop) {
      this._addDynamicProperty(prop);

      this.elem.addDynamicProperty(prop);
      this._isDirty = true;
    }

    function TransformProperty(elem, data, container) {
      this.elem = elem;
      this.frameId = -1;
      this.propType = 'transform';
      this.data = data;
      this.v = new Matrix(); // Precalculated matrix with non animated properties

      this.pre = new Matrix();
      this.appliedTransformations = 0;
      this.initDynamicPropertyContainer(container || elem);

      if (data.p && data.p.s) {
        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);

        if (data.p.z) {
          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
        }
      } else {
        this.p = PropertyFactory.getProp(elem, data.p || {
          k: [0, 0, 0]
        }, 1, 0, this);
      }

      if (data.rx) {
        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);

        if (data.or.k[0].ti) {
          var i;
          var len = data.or.k.length;

          for (i = 0; i < len; i += 1) {
            data.or.k[i].to = null;
            data.or.k[i].ti = null;
          }
        }

        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180

        this.or.sh = true;
      } else {
        this.r = PropertyFactory.getProp(elem, data.r || {
          k: 0
        }, 0, degToRads, this);
      }

      if (data.sk) {
        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
      }

      this.a = PropertyFactory.getProp(elem, data.a || {
        k: [0, 0, 0]
      }, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: [100, 100, 100]
      }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.

      if (data.o) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
      } else {
        this.o = {
          _mdf: false,
          v: 1
        };
      }

      this._isDirty = true;

      if (!this.dynamicProperties.length) {
        this.getValue(true);
      }
    }

    TransformProperty.prototype = {
      applyToMatrix: applyToMatrix,
      getValue: processKeys,
      precalculateMatrix: precalculateMatrix,
      autoOrient: autoOrient
    };
    extendPrototype([DynamicPropertyContainer], TransformProperty);
    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

    function getTransformProperty(elem, data, container) {
      return new TransformProperty(elem, data, container);
    }

    return {
      getTransformProperty: getTransformProperty
    };
  }();

  function RepeaterModifier() {}

  extendPrototype([ShapeModifier], RepeaterModifier);

  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
    this.data = data;

    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }

    this._isAnimated = !!this.dynamicProperties.length;
    this.pMatrix = new Matrix();
    this.rMatrix = new Matrix();
    this.sMatrix = new Matrix();
    this.tMatrix = new Matrix();
    this.matrix = new Matrix();
  };

  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  };

  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
    this.elem = elem;
    this.arr = arr;
    this.pos = pos;
    this.elemsData = elemsData;
    this._currentCopies = 0;
    this._elements = [];
    this._groups = [];
    this.frameId = -1;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, arr[pos]);

    while (pos > 0) {
      pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);

      this._elements.unshift(arr[pos]);
    }

    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };

  RepeaterModifier.prototype.resetElements = function (elements) {
    var i;
    var len = elements.length;

    for (i = 0; i < len; i += 1) {
      elements[i]._processed = false;

      if (elements[i].ty === 'gr') {
        this.resetElements(elements[i].it);
      }
    }
  };

  RepeaterModifier.prototype.cloneElements = function (elements) {
    var newElements = JSON.parse(JSON.stringify(elements));
    this.resetElements(newElements);
    return newElements;
  };

  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
    var i;
    var len = elements.length;

    for (i = 0; i < len; i += 1) {
      elements[i]._render = renderFlag;

      if (elements[i].ty === 'gr') {
        this.changeGroupRender(elements[i].it, renderFlag);
      }
    }
  };

  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
    var items;
    var itemsTransform;
    var i;
    var dir;
    var cont;
    var hasReloaded = false;

    if (this._mdf || _isFirstFrame) {
      var copies = Math.ceil(this.c.v);

      if (this._groups.length < copies) {
        while (this._groups.length < copies) {
          var group = {
            it: this.cloneElements(this._elements),
            ty: 'gr'
          };
          group.it.push({
            a: {
              a: 0,
              ix: 1,
              k: [0, 0]
            },
            nm: 'Transform',
            o: {
              a: 0,
              ix: 7,
              k: 100
            },
            p: {
              a: 0,
              ix: 2,
              k: [0, 0]
            },
            r: {
              a: 1,
              ix: 6,
              k: [{
                s: 0,
                e: 0,
                t: 0
              }, {
                s: 0,
                e: 0,
                t: 1
              }]
            },
            s: {
              a: 0,
              ix: 3,
              k: [100, 100]
            },
            sa: {
              a: 0,
              ix: 5,
              k: 0
            },
            sk: {
              a: 0,
              ix: 4,
              k: 0
            },
            ty: 'tr'
          });
          this.arr.splice(0, 0, group);

          this._groups.splice(0, 0, group);

          this._currentCopies += 1;
        }

        this.elem.reloadShapes();
        hasReloaded = true;
      }

      cont = 0;
      var renderFlag;

      for (i = 0; i <= this._groups.length - 1; i += 1) {
        renderFlag = cont < copies;
        this._groups[i]._render = renderFlag;
        this.changeGroupRender(this._groups[i].it, renderFlag);

        if (!renderFlag) {
          var elems = this.elemsData[i].it;
          var transformData = elems[elems.length - 1];

          if (transformData.transform.op.v !== 0) {
            transformData.transform.op._mdf = true;
            transformData.transform.op.v = 0;
          } else {
            transformData.transform.op._mdf = false;
          }
        }

        cont += 1;
      }

      this._currentCopies = copies; /// /

      var offset = this.o.v;
      var offsetModulo = offset % 1;
      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
      var pProps = this.pMatrix.props;
      var rProps = this.rMatrix.props;
      var sProps = this.sMatrix.props;
      this.pMatrix.reset();
      this.rMatrix.reset();
      this.sMatrix.reset();
      this.tMatrix.reset();
      this.matrix.reset();
      var iteration = 0;

      if (offset > 0) {
        while (iteration < roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          iteration += 1;
        }

        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
          iteration += offsetModulo;
        }
      } else if (offset < 0) {
        while (iteration > roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
          iteration -= 1;
        }

        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
          iteration -= offsetModulo;
        }
      }

      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
      dir = this.data.m === 1 ? 1 : -1;
      cont = this._currentCopies;
      var j;
      var jLen;

      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        jLen = itemsTransform.length;
        items[items.length - 1].transform.mProps._mdf = true;
        items[items.length - 1].transform.op._mdf = true;
        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

        if (iteration !== 0) {
          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          }

          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }

          this.matrix.reset();
        } else {
          this.matrix.reset();

          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }
        }

        iteration += 1;
        cont -= 1;
        i += dir;
      }
    } else {
      cont = this._currentCopies;
      i = 0;
      dir = 1;

      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        items[items.length - 1].transform.mProps._mdf = false;
        items[items.length - 1].transform.op._mdf = false;
        cont -= 1;
        i += dir;
      }
    }

    return hasReloaded;
  };

  RepeaterModifier.prototype.addShape = function () {};

  function RoundCornersModifier() {}

  extendPrototype([ShapeModifier], RoundCornersModifier);

  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
    this._isAnimated = !!this.rd.effectsSequence.length;
  };

  RoundCornersModifier.prototype.processPath = function (path, round) {
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var i;
    var len = path._length;
    var currentV;
    var currentI;
    var currentO;
    var closerV;
    var distance;
    var newPosPerc;
    var index = 0;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;

    for (i = 0; i < len; i += 1) {
      currentV = path.v[i];
      currentO = path.o[i];
      currentI = path.i[i];

      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
        if ((i === 0 || i === len - 1) && !path.c) {
          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
          /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */

          index += 1;
        } else {
          if (i === 0) {
            closerV = path.v[len - 1];
          } else {
            closerV = path.v[i - 1];
          }

          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = iX;
          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
          vY = iY;
          oX = vX - (vX - currentV[0]) * roundCorner;
          oY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;

          if (i === len - 1) {
            closerV = path.v[0];
          } else {
            closerV = path.v[i + 1];
          }

          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = oX;
          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
          vY = oY;
          iX = vX - (vX - currentV[0]) * roundCorner;
          iY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;
        }
      } else {
        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
        index += 1;
      }
    }

    return clonedPath;
  };

  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var rd = this.rd.v;

    if (rd !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function getFontProperties(fontData) {
    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
    var fWeight = 'normal';
    var fStyle = 'normal';
    var len = styles.length;
    var styleName;

    for (var i = 0; i < len; i += 1) {
      styleName = styles[i].toLowerCase();

      switch (styleName) {
        case 'italic':
          fStyle = 'italic';
          break;

        case 'bold':
          fWeight = '700';
          break;

        case 'black':
          fWeight = '900';
          break;

        case 'medium':
          fWeight = '500';
          break;

        case 'regular':
        case 'normal':
          fWeight = '400';
          break;

        case 'light':
        case 'thin':
          fWeight = '200';
          break;

        default:
          break;
      }
    }

    return {
      style: fStyle,
      weight: fontData.fWeight || fWeight
    };
  }

  var FontManager = function () {
    var maxWaitingTime = 5000;
    var emptyChar = {
      w: 0,
      size: 0,
      shapes: [],
      data: {
        shapes: []
      }
    };
    var combinedCharacters = []; // Hindi characters

    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];
    var zeroWidthJoiner = [65039, 8205];

    function trimFontOptions(font) {
      var familyArray = font.split(',');
      var i;
      var len = familyArray.length;
      var enabledFamilies = [];

      for (i = 0; i < len; i += 1) {
        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
          enabledFamilies.push(familyArray[i]);
        }
      }

      return enabledFamilies.join(',');
    }

    function setUpNode(font, family) {
      var parentNode = createTag('span'); // Node is invisible to screen readers.

      parentNode.setAttribute('aria-hidden', true);
      parentNode.style.fontFamily = family;
      var node = createTag('span'); // Characters that vary significantly among different fonts

      node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen

      parentNode.style.position = 'absolute';
      parentNode.style.left = '-10000px';
      parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious

      parentNode.style.fontSize = '300px'; // Reset any font properties

      parentNode.style.fontVariant = 'normal';
      parentNode.style.fontStyle = 'normal';
      parentNode.style.fontWeight = 'normal';
      parentNode.style.letterSpacing = '0';
      parentNode.appendChild(node);
      document.body.appendChild(parentNode); // Remember width with no applied web font

      var width = node.offsetWidth;
      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
      return {
        node: node,
        w: width,
        parent: parentNode
      };
    }

    function checkLoadedFonts() {
      var i;
      var len = this.fonts.length;
      var node;
      var w;
      var loadedCount = len;

      for (i = 0; i < len; i += 1) {
        if (this.fonts[i].loaded) {
          loadedCount -= 1;
        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].monoCase.node;
          w = this.fonts[i].monoCase.w;

          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          } else {
            node = this.fonts[i].sansCase.node;
            w = this.fonts[i].sansCase.w;

            if (node.offsetWidth !== w) {
              loadedCount -= 1;
              this.fonts[i].loaded = true;
            }
          }

          if (this.fonts[i].loaded) {
            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
          }
        }
      }

      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
        setTimeout(this.checkLoadedFontsBinded, 20);
      } else {
        setTimeout(this.setIsLoadedBinded, 10);
      }
    }

    function createHelper(fontData, def) {
      var engine = document.body && def ? 'svg' : 'canvas';
      var helper;
      var fontProps = getFontProperties(fontData);

      if (engine === 'svg') {
        var tHelper = createNS('text');
        tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;

        tHelper.setAttribute('font-family', fontData.fFamily);
        tHelper.setAttribute('font-style', fontProps.style);
        tHelper.setAttribute('font-weight', fontProps.weight);
        tHelper.textContent = '1';

        if (fontData.fClass) {
          tHelper.style.fontFamily = 'inherit';
          tHelper.setAttribute('class', fontData.fClass);
        } else {
          tHelper.style.fontFamily = fontData.fFamily;
        }

        def.appendChild(tHelper);
        helper = tHelper;
      } else {
        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
        helper = tCanvasHelper;
      }

      function measure(text) {
        if (engine === 'svg') {
          helper.textContent = text;
          return helper.getComputedTextLength();
        }

        return helper.measureText(text).width;
      }

      return {
        measureText: measure
      };
    }

    function addFonts(fontData, defs) {
      if (!fontData) {
        this.isLoaded = true;
        return;
      }

      if (this.chars) {
        this.isLoaded = true;
        this.fonts = fontData.list;
        return;
      }

      if (!document.body) {
        this.isLoaded = true;
        fontData.list.forEach(function (data) {
          data.helper = createHelper(data);
          data.cache = {};
        });
        this.fonts = fontData.list;
        return;
      }

      var fontArr = fontData.list;
      var i;
      var len = fontArr.length;
      var _pendingFonts = len;

      for (i = 0; i < len; i += 1) {
        var shouldLoadFont = true;
        var loadedSelector;
        var j;
        fontArr[i].loaded = false;
        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');

        if (!fontArr[i].fPath) {
          fontArr[i].loaded = true;
          _pendingFonts -= 1;
        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

          if (loadedSelector.length > 0) {
            shouldLoadFont = false;
          }

          if (shouldLoadFont) {
            var s = createTag('style');
            s.setAttribute('f-forigin', fontArr[i].fOrigin);
            s.setAttribute('f-origin', fontArr[i].origin);
            s.setAttribute('f-family', fontArr[i].fFamily);
            s.type = 'text/css';
            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
            defs.appendChild(s);
          }
        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

          for (j = 0; j < loadedSelector.length; j += 1) {
            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }

          if (shouldLoadFont) {
            var l = createTag('link');
            l.setAttribute('f-forigin', fontArr[i].fOrigin);
            l.setAttribute('f-origin', fontArr[i].origin);
            l.type = 'text/css';
            l.rel = 'stylesheet';
            l.href = fontArr[i].fPath;
            document.body.appendChild(l);
          }
        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

          for (j = 0; j < loadedSelector.length; j += 1) {
            if (fontArr[i].fPath === loadedSelector[j].src) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }

          if (shouldLoadFont) {
            var sc = createTag('link');
            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
            sc.setAttribute('f-origin', fontArr[i].origin);
            sc.setAttribute('rel', 'stylesheet');
            sc.setAttribute('href', fontArr[i].fPath);
            defs.appendChild(sc);
          }
        }

        fontArr[i].helper = createHelper(fontArr[i], defs);
        fontArr[i].cache = {};
        this.fonts.push(fontArr[i]);
      }

      if (_pendingFonts === 0) {
        this.isLoaded = true;
      } else {
        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
        // Adding this timeout seems to fix it
        setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
    }

    function addChars(chars) {
      if (!chars) {
        return;
      }

      if (!this.chars) {
        this.chars = [];
      }

      var i;
      var len = chars.length;
      var j;
      var jLen = this.chars.length;
      var found;

      for (i = 0; i < len; i += 1) {
        j = 0;
        found = false;

        while (j < jLen) {
          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
            found = true;
          }

          j += 1;
        }

        if (!found) {
          this.chars.push(chars[i]);
          jLen += 1;
        }
      }
    }

    function getCharData(_char, style, font) {
      var i = 0;
      var len = this.chars.length;

      while (i < len) {
        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
          return this.chars[i];
        }

        i += 1;
      }

      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
      && !this._warned) {
        this._warned = true;
        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
      }

      return emptyChar;
    }

    function measureText(_char2, fontName, size) {
      var fontData = this.getFontByName(fontName);

      var index = _char2.charCodeAt(0);

      if (!fontData.cache[index + 1]) {
        var tHelper = fontData.helper;

        if (_char2 === ' ') {
          var doubleSize = tHelper.measureText('|' + _char2 + '|');
          var singleSize = tHelper.measureText('||');
          fontData.cache[index + 1] = (doubleSize - singleSize) / 100;
        } else {
          fontData.cache[index + 1] = tHelper.measureText(_char2) / 100;
        }
      }

      return fontData.cache[index + 1] * size;
    }

    function getFontByName(name) {
      var i = 0;
      var len = this.fonts.length;

      while (i < len) {
        if (this.fonts[i].fName === name) {
          return this.fonts[i];
        }

        i += 1;
      }

      return this.fonts[0];
    }

    function isModifier(firstCharCode, secondCharCode) {
      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
      return surrogateModifiers.indexOf(sum) !== -1;
    }

    function isZeroWidthJoiner(firstCharCode, secondCharCode) {
      if (!secondCharCode) {
        return firstCharCode === zeroWidthJoiner[1];
      }

      return firstCharCode === zeroWidthJoiner[0] && secondCharCode === zeroWidthJoiner[1];
    }

    function isCombinedCharacter(_char3) {
      return combinedCharacters.indexOf(_char3) !== -1;
    }

    function setIsLoaded() {
      this.isLoaded = true;
    }

    var Font = function Font() {
      this.fonts = [];
      this.chars = null;
      this.typekitLoaded = 0;
      this.isLoaded = false;
      this._warned = false;
      this.initTime = Date.now();
      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
    };

    Font.isModifier = isModifier;
    Font.isZeroWidthJoiner = isZeroWidthJoiner;
    Font.isCombinedCharacter = isCombinedCharacter;
    var fontPrototype = {
      addChars: addChars,
      addFonts: addFonts,
      getCharData: getCharData,
      getFontByName: getFontByName,
      measureText: measureText,
      checkLoadedFonts: checkLoadedFonts,
      setIsLoaded: setIsLoaded
    };
    Font.prototype = fontPrototype;
    return Font;
  }();

  function RenderableElement() {}

  RenderableElement.prototype = {
    initRenderable: function initRenderable() {
      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
      this.isInRange = false; // layer's display state

      this.hidden = false; // If layer's transparency equals 0, it can be hidden

      this.isTransparent = false; // list of animated components

      this.renderableComponents = [];
    },
    addRenderableComponent: function addRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) === -1) {
        this.renderableComponents.push(component);
      }
    },
    removeRenderableComponent: function removeRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) !== -1) {
        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
      }
    },
    prepareRenderableFrame: function prepareRenderableFrame(num) {
      this.checkLayerLimits(num);
    },
    checkTransparency: function checkTransparency() {
      if (this.finalTransform.mProp.o.v <= 0) {
        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
          this.isTransparent = true;
          this.hide();
        }
      } else if (this.isTransparent) {
        this.isTransparent = false;
        this.show();
      }
    },

    /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */
    checkLayerLimits: function checkLayerLimits(num) {
      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
        if (this.isInRange !== true) {
          this.globalData._mdf = true;
          this._mdf = true;
          this.isInRange = true;
          this.show();
        }
      } else if (this.isInRange !== false) {
        this.globalData._mdf = true;
        this.isInRange = false;
        this.hide();
      }
    },
    renderRenderable: function renderRenderable() {
      var i;
      var len = this.renderableComponents.length;

      for (i = 0; i < len; i += 1) {
        this.renderableComponents[i].renderFrame(this._isFirstFrame);
      }
      /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */

    },
    sourceRectAtTime: function sourceRectAtTime() {
      return {
        top: 0,
        left: 0,
        width: 100,
        height: 100
      };
    },
    getLayerSize: function getLayerSize() {
      if (this.data.ty === 5) {
        return {
          w: this.data.textData.width,
          h: this.data.textData.height
        };
      }

      return {
        w: this.data.width,
        h: this.data.height
      };
    }
  };

  var MaskManagerInterface = function () {
    function MaskInterface(mask, data) {
      this._mask = mask;
      this._data = data;
    }

    Object.defineProperty(MaskInterface.prototype, 'maskPath', {
      get: function get() {
        if (this._mask.prop.k) {
          this._mask.prop.getValue();
        }

        return this._mask.prop;
      }
    });
    Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
      get: function get() {
        if (this._mask.op.k) {
          this._mask.op.getValue();
        }

        return this._mask.op.v * 100;
      }
    });

    var MaskManager = function MaskManager(maskManager) {
      var _masksInterfaces = createSizedArray(maskManager.viewData.length);

      var i;
      var len = maskManager.viewData.length;

      for (i = 0; i < len; i += 1) {
        _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
      }

      var maskFunction = function maskFunction(name) {
        i = 0;

        while (i < len) {
          if (maskManager.masksProperties[i].nm === name) {
            return _masksInterfaces[i];
          }

          i += 1;
        }

        return null;
      };

      return maskFunction;
    };

    return MaskManager;
  }();

  var ExpressionPropertyInterface = function () {
    var defaultUnidimensionalValue = {
      pv: 0,
      v: 0,
      mult: 1
    };
    var defaultMultidimensionalValue = {
      pv: [0, 0, 0],
      v: [0, 0, 0],
      mult: 1
    };

    function completeProperty(expressionValue, property, type) {
      Object.defineProperty(expressionValue, 'velocity', {
        get: function get() {
          return property.getVelocityAtTime(property.comp.currentFrame);
        }
      });
      expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;

      expressionValue.key = function (pos) {
        if (!expressionValue.numKeys) {
          return 0;
        }

        var value = '';

        if ('s' in property.keyframes[pos - 1]) {
          value = property.keyframes[pos - 1].s;
        } else if ('e' in property.keyframes[pos - 2]) {
          value = property.keyframes[pos - 2].e;
        } else {
          value = property.keyframes[pos - 2].s;
        }

        var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers

        valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
        valueProp.value = type === 'unidimensional' ? value[0] : value;
        return valueProp;
      };

      expressionValue.valueAtTime = property.getValueAtTime;
      expressionValue.speedAtTime = property.getSpeedAtTime;
      expressionValue.velocityAtTime = property.getVelocityAtTime;
      expressionValue.propertyGroup = property.propertyGroup;
    }

    function UnidimensionalPropertyInterface(property) {
      if (!property || !('pv' in property)) {
        property = defaultUnidimensionalValue;
      }

      var mult = 1 / property.mult;
      var val = property.pv * mult;
      var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

      expressionValue.value = val;
      completeProperty(expressionValue, property, 'unidimensional');
      return function () {
        if (property.k) {
          property.getValue();
        }

        val = property.v * mult;

        if (expressionValue.value !== val) {
          expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

          expressionValue.value = val;
          completeProperty(expressionValue, property, 'unidimensional');
        }

        return expressionValue;
      };
    }

    function MultidimensionalPropertyInterface(property) {
      if (!property || !('pv' in property)) {
        property = defaultMultidimensionalValue;
      }

      var mult = 1 / property.mult;
      var len = property.data && property.data.l || property.pv.length;
      var expressionValue = createTypedArray('float32', len);
      var arrValue = createTypedArray('float32', len);
      expressionValue.value = arrValue;
      completeProperty(expressionValue, property, 'multidimensional');
      return function () {
        if (property.k) {
          property.getValue();
        }

        for (var i = 0; i < len; i += 1) {
          arrValue[i] = property.v[i] * mult;
          expressionValue[i] = arrValue[i];
        }

        return expressionValue;
      };
    } // TODO: try to avoid using this getter


    function defaultGetter() {
      return defaultUnidimensionalValue;
    }

    return function (property) {
      if (!property) {
        return defaultGetter;
      }

      if (property.propType === 'unidimensional') {
        return UnidimensionalPropertyInterface(property);
      }

      return MultidimensionalPropertyInterface(property);
    };
  }();

  var TransformExpressionInterface = function () {
    return function (transform) {
      function _thisFunction(name) {
        switch (name) {
          case 'scale':
          case 'Scale':
          case 'ADBE Scale':
          case 6:
            return _thisFunction.scale;

          case 'rotation':
          case 'Rotation':
          case 'ADBE Rotation':
          case 'ADBE Rotate Z':
          case 10:
            return _thisFunction.rotation;

          case 'ADBE Rotate X':
            return _thisFunction.xRotation;

          case 'ADBE Rotate Y':
            return _thisFunction.yRotation;

          case 'position':
          case 'Position':
          case 'ADBE Position':
          case 2:
            return _thisFunction.position;

          case 'ADBE Position_0':
            return _thisFunction.xPosition;

          case 'ADBE Position_1':
            return _thisFunction.yPosition;

          case 'ADBE Position_2':
            return _thisFunction.zPosition;

          case 'anchorPoint':
          case 'AnchorPoint':
          case 'Anchor Point':
          case 'ADBE AnchorPoint':
          case 1:
            return _thisFunction.anchorPoint;

          case 'opacity':
          case 'Opacity':
          case 11:
            return _thisFunction.opacity;

          default:
            return null;
        }
      }

      Object.defineProperty(_thisFunction, 'rotation', {
        get: ExpressionPropertyInterface(transform.r || transform.rz)
      });
      Object.defineProperty(_thisFunction, 'zRotation', {
        get: ExpressionPropertyInterface(transform.rz || transform.r)
      });
      Object.defineProperty(_thisFunction, 'xRotation', {
        get: ExpressionPropertyInterface(transform.rx)
      });
      Object.defineProperty(_thisFunction, 'yRotation', {
        get: ExpressionPropertyInterface(transform.ry)
      });
      Object.defineProperty(_thisFunction, 'scale', {
        get: ExpressionPropertyInterface(transform.s)
      });

      var _px;

      var _py;

      var _pz;

      var _transformFactory;

      if (transform.p) {
        _transformFactory = ExpressionPropertyInterface(transform.p);
      } else {
        _px = ExpressionPropertyInterface(transform.px);
        _py = ExpressionPropertyInterface(transform.py);

        if (transform.pz) {
          _pz = ExpressionPropertyInterface(transform.pz);
        }
      }

      Object.defineProperty(_thisFunction, 'position', {
        get: function get() {
          if (transform.p) {
            return _transformFactory();
          }

          return [_px(), _py(), _pz ? _pz() : 0];
        }
      });
      Object.defineProperty(_thisFunction, 'xPosition', {
        get: ExpressionPropertyInterface(transform.px)
      });
      Object.defineProperty(_thisFunction, 'yPosition', {
        get: ExpressionPropertyInterface(transform.py)
      });
      Object.defineProperty(_thisFunction, 'zPosition', {
        get: ExpressionPropertyInterface(transform.pz)
      });
      Object.defineProperty(_thisFunction, 'anchorPoint', {
        get: ExpressionPropertyInterface(transform.a)
      });
      Object.defineProperty(_thisFunction, 'opacity', {
        get: ExpressionPropertyInterface(transform.o)
      });
      Object.defineProperty(_thisFunction, 'skew', {
        get: ExpressionPropertyInterface(transform.sk)
      });
      Object.defineProperty(_thisFunction, 'skewAxis', {
        get: ExpressionPropertyInterface(transform.sa)
      });
      Object.defineProperty(_thisFunction, 'orientation', {
        get: ExpressionPropertyInterface(transform.or)
      });
      return _thisFunction;
    };
  }();

  var LayerExpressionInterface = function () {
    function getMatrix(time) {
      var toWorldMat = new Matrix();

      if (time !== undefined) {
        var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);

        propMatrix.clone(toWorldMat);
      } else {
        var transformMat = this._elem.finalTransform.mProp;
        transformMat.applyToMatrix(toWorldMat);
      }

      return toWorldMat;
    }

    function toWorldVec(arr, time) {
      var toWorldMat = this.getMatrix(time);
      toWorldMat.props[12] = 0;
      toWorldMat.props[13] = 0;
      toWorldMat.props[14] = 0;
      return this.applyPoint(toWorldMat, arr);
    }

    function toWorld(arr, time) {
      var toWorldMat = this.getMatrix(time);
      return this.applyPoint(toWorldMat, arr);
    }

    function fromWorldVec(arr, time) {
      var toWorldMat = this.getMatrix(time);
      toWorldMat.props[12] = 0;
      toWorldMat.props[13] = 0;
      toWorldMat.props[14] = 0;
      return this.invertPoint(toWorldMat, arr);
    }

    function fromWorld(arr, time) {
      var toWorldMat = this.getMatrix(time);
      return this.invertPoint(toWorldMat, arr);
    }

    function applyPoint(matrix, arr) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;

        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
        }
      }

      return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
    }

    function invertPoint(matrix, arr) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;

        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
        }
      }

      return matrix.inversePoint(arr);
    }

    function fromComp(arr) {
      var toWorldMat = new Matrix();
      toWorldMat.reset();

      this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);

      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;

        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
        }

        return toWorldMat.inversePoint(arr);
      }

      return toWorldMat.inversePoint(arr);
    }

    function sampleImage() {
      return [1, 1, 1, 1];
    }

    return function (elem) {
      var transformInterface;

      function _registerMaskInterface(maskManager) {
        _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
      }

      function _registerEffectsInterface(effects) {
        _thisLayerFunction.effect = effects;
      }

      function _thisLayerFunction(name) {
        switch (name) {
          case 'ADBE Root Vectors Group':
          case 'Contents':
          case 2:
            return _thisLayerFunction.shapeInterface;

          case 1:
          case 6:
          case 'Transform':
          case 'transform':
          case 'ADBE Transform Group':
            return transformInterface;

          case 4:
          case 'ADBE Effect Parade':
          case 'effects':
          case 'Effects':
            return _thisLayerFunction.effect;

          case 'ADBE Text Properties':
            return _thisLayerFunction.textInterface;

          default:
            return null;
        }
      }

      _thisLayerFunction.getMatrix = getMatrix;
      _thisLayerFunction.invertPoint = invertPoint;
      _thisLayerFunction.applyPoint = applyPoint;
      _thisLayerFunction.toWorld = toWorld;
      _thisLayerFunction.toWorldVec = toWorldVec;
      _thisLayerFunction.fromWorld = fromWorld;
      _thisLayerFunction.fromWorldVec = fromWorldVec;
      _thisLayerFunction.toComp = toWorld;
      _thisLayerFunction.fromComp = fromComp;
      _thisLayerFunction.sampleImage = sampleImage;
      _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
      _thisLayerFunction._elem = elem;
      transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
      var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
      Object.defineProperties(_thisLayerFunction, {
        hasParent: {
          get: function get() {
            return elem.hierarchy.length;
          }
        },
        parent: {
          get: function get() {
            return elem.hierarchy[0].layerInterface;
          }
        },
        rotation: getDescriptor(transformInterface, 'rotation'),
        scale: getDescriptor(transformInterface, 'scale'),
        position: getDescriptor(transformInterface, 'position'),
        opacity: getDescriptor(transformInterface, 'opacity'),
        anchorPoint: anchorPointDescriptor,
        anchor_point: anchorPointDescriptor,
        transform: {
          get: function get() {
            return transformInterface;
          }
        },
        active: {
          get: function get() {
            return elem.isInRange;
          }
        }
      });
      _thisLayerFunction.startTime = elem.data.st;
      _thisLayerFunction.index = elem.data.ind;
      _thisLayerFunction.source = elem.data.refId;
      _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
      _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
      _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
      _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
      _thisLayerFunction._name = elem.data.nm;
      _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
      _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
      return _thisLayerFunction;
    };
  }();

  var propertyGroupFactory = function () {
    return function (interfaceFunction, parentPropertyGroup) {
      return function (val) {
        val = val === undefined ? 1 : val;

        if (val <= 0) {
          return interfaceFunction;
        }

        return parentPropertyGroup(val - 1);
      };
    };
  }();

  var PropertyInterface = function () {
    return function (propertyName, propertyGroup) {
      var interfaceFunction = {
        _name: propertyName
      };

      function _propertyGroup(val) {
        val = val === undefined ? 1 : val;

        if (val <= 0) {
          return interfaceFunction;
        }

        return propertyGroup(val - 1);
      }

      return _propertyGroup;
    };
  }();

  var EffectsExpressionInterface = function () {
    var ob = {
      createEffectsInterface: createEffectsInterface
    };

    function createEffectsInterface(elem, propertyGroup) {
      if (elem.effectsManager) {
        var effectElements = [];
        var effectsData = elem.data.ef;
        var i;
        var len = elem.effectsManager.effectElements.length;

        for (i = 0; i < len; i += 1) {
          effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
        }

        var effects = elem.data.ef || [];

        var groupInterface = function groupInterface(name) {
          i = 0;
          len = effects.length;

          while (i < len) {
            if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
              return effectElements[i];
            }

            i += 1;
          }

          return null;
        };

        Object.defineProperty(groupInterface, 'numProperties', {
          get: function get() {
            return effects.length;
          }
        });
        return groupInterface;
      }

      return null;
    }

    function createGroupInterface(data, elements, propertyGroup, elem) {
      function groupInterface(name) {
        var effects = data.ef;
        var i = 0;
        var len = effects.length;

        while (i < len) {
          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
            if (effects[i].ty === 5) {
              return effectElements[i];
            }

            return effectElements[i]();
          }

          i += 1;
        }

        throw new Error();
      }

      var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

      var effectElements = [];
      var i;
      var len = data.ef.length;

      for (i = 0; i < len; i += 1) {
        if (data.ef[i].ty === 5) {
          effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
        } else {
          effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
        }
      }

      if (data.mn === 'ADBE Color Control') {
        Object.defineProperty(groupInterface, 'color', {
          get: function get() {
            return effectElements[0]();
          }
        });
      }

      Object.defineProperties(groupInterface, {
        numProperties: {
          get: function get() {
            return data.np;
          }
        },
        _name: {
          value: data.nm
        },
        propertyGroup: {
          value: _propertyGroup
        }
      });
      groupInterface.enabled = data.en !== 0;
      groupInterface.active = groupInterface.enabled;
      return groupInterface;
    }

    function createValueInterface(element, type, elem, propertyGroup) {
      var expressionProperty = ExpressionPropertyInterface(element.p);

      function interfaceFunction() {
        if (type === 10) {
          return elem.comp.compInterface(element.p.v);
        }

        return expressionProperty();
      }

      if (element.p.setGroupProperty) {
        element.p.setGroupProperty(PropertyInterface('', propertyGroup));
      }

      return interfaceFunction;
    }

    return ob;
  }();

  var CompExpressionInterface = function () {
    return function (comp) {
      function _thisLayerFunction(name) {
        var i = 0;
        var len = comp.layers.length;

        while (i < len) {
          if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
            return comp.elements[i].layerInterface;
          }

          i += 1;
        }

        return null; // return {active:false};
      }

      Object.defineProperty(_thisLayerFunction, '_name', {
        value: comp.data.nm
      });
      _thisLayerFunction.layer = _thisLayerFunction;
      _thisLayerFunction.pixelAspect = 1;
      _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
      _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
      _thisLayerFunction.pixelAspect = 1;
      _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
      _thisLayerFunction.displayStartTime = 0;
      _thisLayerFunction.numLayers = comp.layers.length;
      return _thisLayerFunction;
    };
  }();

  var ShapePathInterface = function () {
    return function pathInterfaceFactory(shape, view, propertyGroup) {
      var prop = view.sh;

      function interfaceFunction(val) {
        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
          return interfaceFunction.path;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        path: {
          get: function get() {
            if (prop.k) {
              prop.getValue();
            }

            return prop;
          }
        },
        shape: {
          get: function get() {
            if (prop.k) {
              prop.getValue();
            }

            return prop;
          }
        },
        _name: {
          value: shape.nm
        },
        ix: {
          value: shape.ix
        },
        propertyIndex: {
          value: shape.ix
        },
        mn: {
          value: shape.mn
        },
        propertyGroup: {
          value: propertyGroup
        }
      });
      return interfaceFunction;
    };
  }();

  var ShapeExpressionInterface = function () {
    function iterateElements(shapes, view, propertyGroup) {
      var arr = [];
      var i;
      var len = shapes ? shapes.length : 0;

      for (i = 0; i < len; i += 1) {
        if (shapes[i].ty === 'gr') {
          arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'fl') {
          arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'st') {
          arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'tm') {
          arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'tr') {// arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
        } else if (shapes[i].ty === 'el') {
          arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'sr') {
          arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'sh') {
          arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rc') {
          arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rd') {
          arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rp') {
          arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'gf') {
          arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else {
          arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
        }
      }

      return arr;
    }

    function contentsInterfaceFactory(shape, view, propertyGroup) {
      var interfaces;

      var interfaceFunction = function _interfaceFunction(value) {
        var i = 0;
        var len = interfaces.length;

        while (i < len) {
          if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
            return interfaces[i];
          }

          i += 1;
        }

        if (typeof value === 'number') {
          return interfaces[value - 1];
        }

        return null;
      };

      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
      interfaceFunction.numProperties = interfaces.length;
      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
      interfaceFunction.transform = transformInterface;
      interfaceFunction.propertyIndex = shape.cix;
      interfaceFunction._name = shape.nm;
      return interfaceFunction;
    }

    function groupInterfaceFactory(shape, view, propertyGroup) {
      var interfaceFunction = function _interfaceFunction(value) {
        switch (value) {
          case 'ADBE Vectors Group':
          case 'Contents':
          case 2:
            return interfaceFunction.content;
          // Not necessary for now. Keeping them here in case a new case appears
          // case 'ADBE Vector Transform Group':
          // case 3:

          default:
            return interfaceFunction.transform;
        }
      };

      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
      interfaceFunction.content = content;
      interfaceFunction.transform = transformInterface;
      Object.defineProperty(interfaceFunction, '_name', {
        get: function get() {
          return shape.nm;
        }
      }); // interfaceFunction.content = interfaceFunction;

      interfaceFunction.numProperties = shape.np;
      interfaceFunction.propertyIndex = shape.ix;
      interfaceFunction.nm = shape.nm;
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function fillInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === 'Color' || val === 'color') {
          return interfaceFunction.color;
        }

        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }

        return null;
      }

      Object.defineProperties(interfaceFunction, {
        color: {
          get: ExpressionPropertyInterface(view.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
      return interfaceFunction;
    }

    function gradientFillInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === 'Start Point' || val === 'start point') {
          return interfaceFunction.startPoint;
        }

        if (val === 'End Point' || val === 'end point') {
          return interfaceFunction.endPoint;
        }

        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }

        return null;
      }

      Object.defineProperties(interfaceFunction, {
        startPoint: {
          get: ExpressionPropertyInterface(view.s)
        },
        endPoint: {
          get: ExpressionPropertyInterface(view.e)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        type: {
          get: function get() {
            return 'a';
          }
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
      view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
      return interfaceFunction;
    }

    function defaultInterfaceFactory() {
      function interfaceFunction() {
        return null;
      }

      return interfaceFunction;
    }

    function strokeInterfaceFactory(shape, view, propertyGroup) {
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);

      function addPropertyToDashOb(i) {
        Object.defineProperty(dashOb, shape.d[i].nm, {
          get: ExpressionPropertyInterface(view.d.dataProps[i].p)
        });
      }

      var i;
      var len = shape.d ? shape.d.length : 0;
      var dashOb = {};

      for (i = 0; i < len; i += 1) {
        addPropertyToDashOb(i);
        view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
      }

      function interfaceFunction(val) {
        if (val === 'Color' || val === 'color') {
          return interfaceFunction.color;
        }

        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }

        if (val === 'Stroke Width' || val === 'stroke width') {
          return interfaceFunction.strokeWidth;
        }

        return null;
      }

      Object.defineProperties(interfaceFunction, {
        color: {
          get: ExpressionPropertyInterface(view.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        strokeWidth: {
          get: ExpressionPropertyInterface(view.w)
        },
        dash: {
          get: function get() {
            return dashOb;
          }
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
      return interfaceFunction;
    }

    function trimInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === shape.e.ix || val === 'End' || val === 'end') {
          return interfaceFunction.end;
        }

        if (val === shape.s.ix) {
          return interfaceFunction.start;
        }

        if (val === shape.o.ix) {
          return interfaceFunction.offset;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      interfaceFunction.propertyIndex = shape.ix;
      view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
      view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
      interfaceFunction.propertyIndex = shape.ix;
      interfaceFunction.propertyGroup = propertyGroup;
      Object.defineProperties(interfaceFunction, {
        start: {
          get: ExpressionPropertyInterface(view.s)
        },
        end: {
          get: ExpressionPropertyInterface(view.e)
        },
        offset: {
          get: ExpressionPropertyInterface(view.o)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function transformInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.a.ix === value || value === 'Anchor Point') {
          return interfaceFunction.anchorPoint;
        }

        if (shape.o.ix === value || value === 'Opacity') {
          return interfaceFunction.opacity;
        }

        if (shape.p.ix === value || value === 'Position') {
          return interfaceFunction.position;
        }

        if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
          return interfaceFunction.rotation;
        }

        if (shape.s.ix === value || value === 'Scale') {
          return interfaceFunction.scale;
        }

        if (shape.sk && shape.sk.ix === value || value === 'Skew') {
          return interfaceFunction.skew;
        }

        if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') {
          return interfaceFunction.skewAxis;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
      view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
      view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

      if (view.transform.mProps.sk) {
        view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
        view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
      }

      view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        opacity: {
          get: ExpressionPropertyInterface(view.transform.mProps.o)
        },
        position: {
          get: ExpressionPropertyInterface(view.transform.mProps.p)
        },
        anchorPoint: {
          get: ExpressionPropertyInterface(view.transform.mProps.a)
        },
        scale: {
          get: ExpressionPropertyInterface(view.transform.mProps.s)
        },
        rotation: {
          get: ExpressionPropertyInterface(view.transform.mProps.r)
        },
        skew: {
          get: ExpressionPropertyInterface(view.transform.mProps.sk)
        },
        skewAxis: {
          get: ExpressionPropertyInterface(view.transform.mProps.sa)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.ty = 'tr';
      interfaceFunction.mn = shape.mn;
      interfaceFunction.propertyGroup = propertyGroup;
      return interfaceFunction;
    }

    function ellipseInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }

        if (shape.s.ix === value) {
          return interfaceFunction.size;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      interfaceFunction.propertyIndex = shape.ix;
      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        size: {
          get: ExpressionPropertyInterface(prop.s)
        },
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function starInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }

        if (shape.r.ix === value) {
          return interfaceFunction.rotation;
        }

        if (shape.pt.ix === value) {
          return interfaceFunction.points;
        }

        if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
          return interfaceFunction.outerRadius;
        }

        if (shape.os.ix === value) {
          return interfaceFunction.outerRoundness;
        }

        if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
          return interfaceFunction.innerRadius;
        }

        if (shape.is && shape.is.ix === value) {
          return interfaceFunction.innerRoundness;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      interfaceFunction.propertyIndex = shape.ix;
      prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
      prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
      prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

      if (shape.ir) {
        prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
        prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
      }

      Object.defineProperties(interfaceFunction, {
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        rotation: {
          get: ExpressionPropertyInterface(prop.r)
        },
        points: {
          get: ExpressionPropertyInterface(prop.pt)
        },
        outerRadius: {
          get: ExpressionPropertyInterface(prop.or)
        },
        outerRoundness: {
          get: ExpressionPropertyInterface(prop.os)
        },
        innerRadius: {
          get: ExpressionPropertyInterface(prop.ir)
        },
        innerRoundness: {
          get: ExpressionPropertyInterface(prop.is)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function rectInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }

        if (shape.r.ix === value) {
          return interfaceFunction.roundness;
        }

        if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
          return interfaceFunction.size;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      interfaceFunction.propertyIndex = shape.ix;
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        roundness: {
          get: ExpressionPropertyInterface(prop.r)
        },
        size: {
          get: ExpressionPropertyInterface(prop.s)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function roundedInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.r.ix === value || value === 'Round Corners 1') {
          return interfaceFunction.radius;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view;
      interfaceFunction.propertyIndex = shape.ix;
      prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        radius: {
          get: ExpressionPropertyInterface(prop.rd)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function repeaterInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.c.ix === value || value === 'Copies') {
          return interfaceFunction.copies;
        }

        if (shape.o.ix === value || value === 'Offset') {
          return interfaceFunction.offset;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view;
      interfaceFunction.propertyIndex = shape.ix;
      prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
      prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        copies: {
          get: ExpressionPropertyInterface(prop.c)
        },
        offset: {
          get: ExpressionPropertyInterface(prop.o)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    return function (shapes, view, propertyGroup) {
      var interfaces;

      function _interfaceFunction(value) {
        if (typeof value === 'number') {
          value = value === undefined ? 1 : value;

          if (value === 0) {
            return propertyGroup;
          }

          return interfaces[value - 1];
        }

        var i = 0;
        var len = interfaces.length;

        while (i < len) {
          if (interfaces[i]._name === value) {
            return interfaces[i];
          }

          i += 1;
        }

        return null;
      }

      function parentGroupWrapper() {
        return propertyGroup;
      }

      _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
      interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
      _interfaceFunction.numProperties = interfaces.length;
      _interfaceFunction._name = 'Contents';
      return _interfaceFunction;
    };
  }();

  var TextExpressionInterface = function () {
    return function (elem) {
      var _prevValue;

      var _sourceText;

      function _thisLayerFunction(name) {
        switch (name) {
          case 'ADBE Text Document':
            return _thisLayerFunction.sourceText;

          default:
            return null;
        }
      }

      Object.defineProperty(_thisLayerFunction, 'sourceText', {
        get: function get() {
          elem.textProperty.getValue();
          var stringValue = elem.textProperty.currentData.t;

          if (stringValue !== _prevValue) {
            elem.textProperty.currentData.t = _prevValue;
            _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
            // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive

            _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
          }

          return _sourceText;
        }
      });
      return _thisLayerFunction;
    };
  }();

  var getBlendMode = function () {
    var blendModeEnums = {
      0: 'source-over',
      1: 'multiply',
      2: 'screen',
      3: 'overlay',
      4: 'darken',
      5: 'lighten',
      6: 'color-dodge',
      7: 'color-burn',
      8: 'hard-light',
      9: 'soft-light',
      10: 'difference',
      11: 'exclusion',
      12: 'hue',
      13: 'saturation',
      14: 'color',
      15: 'luminosity'
    };
    return function (mode) {
      return blendModeEnums[mode] || '';
    };
  }();

  function SliderEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function AngleEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function ColorEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }

  function PointEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }

  function LayerIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function MaskIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function CheckboxEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function NoValueEffect() {
    this.p = {};
  }

  function EffectsManager(data, element) {
    var effects = data.ef || [];
    this.effectElements = [];
    var i;
    var len = effects.length;
    var effectItem;

    for (i = 0; i < len; i += 1) {
      effectItem = new GroupEffect(effects[i], element);
      this.effectElements.push(effectItem);
    }
  }

  function GroupEffect(data, element) {
    this.init(data, element);
  }

  extendPrototype([DynamicPropertyContainer], GroupEffect);
  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

  GroupEffect.prototype.init = function (data, element) {
    this.data = data;
    this.effectElements = [];
    this.initDynamicPropertyContainer(element);
    var i;
    var len = this.data.ef.length;
    var eff;
    var effects = this.data.ef;

    for (i = 0; i < len; i += 1) {
      eff = null;

      switch (effects[i].ty) {
        case 0:
          eff = new SliderEffect(effects[i], element, this);
          break;

        case 1:
          eff = new AngleEffect(effects[i], element, this);
          break;

        case 2:
          eff = new ColorEffect(effects[i], element, this);
          break;

        case 3:
          eff = new PointEffect(effects[i], element, this);
          break;

        case 4:
        case 7:
          eff = new CheckboxEffect(effects[i], element, this);
          break;

        case 10:
          eff = new LayerIndexEffect(effects[i], element, this);
          break;

        case 11:
          eff = new MaskIndexEffect(effects[i], element, this);
          break;

        case 5:
          eff = new EffectsManager(effects[i], element, this);
          break;
        // case 6:

        default:
          eff = new NoValueEffect(effects[i], element, this);
          break;
      }

      if (eff) {
        this.effectElements.push(eff);
      }
    }
  };

  function BaseElement() {}

  BaseElement.prototype = {
    checkMasks: function checkMasks() {
      if (!this.data.hasMask) {
        return false;
      }

      var i = 0;
      var len = this.data.masksProperties.length;

      while (i < len) {
        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
          return true;
        }

        i += 1;
      }

      return false;
    },
    initExpressions: function initExpressions() {
      this.layerInterface = LayerExpressionInterface(this);

      if (this.data.hasMask && this.maskManager) {
        this.layerInterface.registerMaskInterface(this.maskManager);
      }

      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
      this.layerInterface.registerEffectsInterface(effectsInterface);

      if (this.data.ty === 0 || this.data.xt) {
        this.compInterface = CompExpressionInterface(this);
      } else if (this.data.ty === 4) {
        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
        this.layerInterface.content = this.layerInterface.shapeInterface;
      } else if (this.data.ty === 5) {
        this.layerInterface.textInterface = TextExpressionInterface(this);
        this.layerInterface.text = this.layerInterface.textInterface;
      }
    },
    setBlendMode: function setBlendMode() {
      var blendModeValue = getBlendMode(this.data.bm);
      var elem = this.baseElement || this.layerElement;
      elem.style['mix-blend-mode'] = blendModeValue;
    },
    initBaseData: function initBaseData(data, globalData, comp) {
      this.globalData = globalData;
      this.comp = comp;
      this.data = data;
      this.layerId = createElementID(); // Stretch factor for old animations missing this property.

      if (!this.data.sr) {
        this.data.sr = 1;
      } // effects manager


      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    },
    getType: function getType() {
      return this.type;
    },
    sourceRectAtTime: function sourceRectAtTime() {}
  };

  /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */
  function FrameElement() {}

  FrameElement.prototype = {
    /**
       * @function
       * Initializes frame related properties.
       *
       */
    initFrame: function initFrame() {
      // set to true when inpoint is rendered
      this._isFirstFrame = false; // list of animated properties

      this.dynamicProperties = []; // If layer has been modified in current tick this will be true

      this._mdf = false;
    },

    /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */
    prepareProperties: function prepareProperties(num, isVisible) {
      var i;
      var len = this.dynamicProperties.length;

      for (i = 0; i < len; i += 1) {
        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
          this.dynamicProperties[i].getValue();

          if (this.dynamicProperties[i]._mdf) {
            this.globalData._mdf = true;
            this._mdf = true;
          }
        }
      }
    },
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
      }
    }
  };

  function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

  var FootageInterface = function () {
    var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
      var currentPropertyName = '';
      var currentProperty = elem.getFootageData();

      function init() {
        currentPropertyName = '';
        currentProperty = elem.getFootageData();
        return searchProperty;
      }

      function searchProperty(value) {
        if (currentProperty[value]) {
          currentPropertyName = value;
          currentProperty = currentProperty[value];

          if (_typeof$2(currentProperty) === 'object') {
            return searchProperty;
          }

          return currentProperty;
        }

        var propertyNameIndex = value.indexOf(currentPropertyName);

        if (propertyNameIndex !== -1) {
          var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
          currentProperty = currentProperty[index];

          if (_typeof$2(currentProperty) === 'object') {
            return searchProperty;
          }

          return currentProperty;
        }

        return '';
      }

      return init;
    };

    var dataInterfaceFactory = function dataInterfaceFactory(elem) {
      function interfaceFunction(value) {
        if (value === 'Outline') {
          return interfaceFunction.outlineInterface();
        }

        return null;
      }

      interfaceFunction._name = 'Outline';
      interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
      return interfaceFunction;
    };

    return function (elem) {
      function _interfaceFunction(value) {
        if (value === 'Data') {
          return _interfaceFunction.dataInterface;
        }

        return null;
      }

      _interfaceFunction._name = 'Data';
      _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
      return _interfaceFunction;
    };
  }();

  function FootageElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.footageData = globalData.imageLoader.getAsset(this.assetData);
    this.initBaseData(data, globalData, comp);
  }

  FootageElement.prototype.prepareFrame = function () {};

  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

  FootageElement.prototype.getBaseElement = function () {
    return null;
  };

  FootageElement.prototype.renderFrame = function () {};

  FootageElement.prototype.destroy = function () {};

  FootageElement.prototype.initExpressions = function () {
    this.layerInterface = FootageInterface(this);
  };

  FootageElement.prototype.getFootageData = function () {
    return this.footageData;
  };

  function AudioElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.initBaseData(data, globalData, comp);
    this._isPlaying = false;
    this._canPlay = false;
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.audio = this.globalData.audioController.createAudio(assetPath);
    this._currentTime = 0;
    this.globalData.audioController.addAudio(this);
    this._volumeMultiplier = 1;
    this._volume = 1;
    this._previousVolume = null;
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
      k: [100]
    }, 1, 0.01, this);
  }

  AudioElement.prototype.prepareFrame = function (num) {
    this.prepareRenderableFrame(num, true);
    this.prepareProperties(num, true);

    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;
      this._currentTime = timeRemapped;
    } else {
      this._currentTime = num / this.data.sr;
    }

    this._volume = this.lv.v[0];
    var totalVolume = this._volume * this._volumeMultiplier;

    if (this._previousVolume !== totalVolume) {
      this._previousVolume = totalVolume;
      this.audio.volume(totalVolume);
    }
  };

  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

  AudioElement.prototype.renderFrame = function () {
    if (this.isInRange && this._canPlay) {
      if (!this._isPlaying) {
        this.audio.play();
        this.audio.seek(this._currentTime / this.globalData.frameRate);
        this._isPlaying = true;
      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
        this.audio.seek(this._currentTime / this.globalData.frameRate);
      }
    }
  };

  AudioElement.prototype.show = function () {// this.audio.play()
  };

  AudioElement.prototype.hide = function () {
    this.audio.pause();
    this._isPlaying = false;
  };

  AudioElement.prototype.pause = function () {
    this.audio.pause();
    this._isPlaying = false;
    this._canPlay = false;
  };

  AudioElement.prototype.resume = function () {
    this._canPlay = true;
  };

  AudioElement.prototype.setRate = function (rateValue) {
    this.audio.rate(rateValue);
  };

  AudioElement.prototype.volume = function (volumeValue) {
    this._volumeMultiplier = volumeValue;
    this._previousVolume = volumeValue * this._volume;
    this.audio.volume(this._previousVolume);
  };

  AudioElement.prototype.getBaseElement = function () {
    return null;
  };

  AudioElement.prototype.destroy = function () {};

  AudioElement.prototype.sourceRectAtTime = function () {};

  AudioElement.prototype.initExpressions = function () {};

  function BaseRenderer() {}

  BaseRenderer.prototype.checkLayers = function (num) {
    var i;
    var len = this.layers.length;
    var data;
    this.completeLayers = true;

    for (i = len - 1; i >= 0; i -= 1) {
      if (!this.elements[i]) {
        data = this.layers[i];

        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
          this.buildItem(i);
        }
      }

      this.completeLayers = this.elements[i] ? this.completeLayers : false;
    }

    this.checkPendingElements();
  };

  BaseRenderer.prototype.createItem = function (layer) {
    switch (layer.ty) {
      case 2:
        return this.createImage(layer);

      case 0:
        return this.createComp(layer);

      case 1:
        return this.createSolid(layer);

      case 3:
        return this.createNull(layer);

      case 4:
        return this.createShape(layer);

      case 5:
        return this.createText(layer);

      case 6:
        return this.createAudio(layer);

      case 13:
        return this.createCamera(layer);

      case 15:
        return this.createFootage(layer);

      default:
        return this.createNull(layer);
    }
  };

  BaseRenderer.prototype.createCamera = function () {
    throw new Error('You\'re using a 3d camera. Try the html renderer.');
  };

  BaseRenderer.prototype.createAudio = function (data) {
    return new AudioElement(data, this.globalData, this);
  };

  BaseRenderer.prototype.createFootage = function (data) {
    return new FootageElement(data, this.globalData, this);
  };

  BaseRenderer.prototype.buildAllItems = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      this.buildItem(i);
    }

    this.checkPendingElements();
  };

  BaseRenderer.prototype.includeLayers = function (newLayers) {
    this.completeLayers = false;
    var i;
    var len = newLayers.length;
    var j;
    var jLen = this.layers.length;

    for (i = 0; i < len; i += 1) {
      j = 0;

      while (j < jLen) {
        if (this.layers[j].id === newLayers[i].id) {
          this.layers[j] = newLayers[i];
          break;
        }

        j += 1;
      }
    }
  };

  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
    this.globalData.projectInterface = pInterface;
  };

  BaseRenderer.prototype.initItems = function () {
    if (!this.globalData.progressiveLoad) {
      this.buildAllItems();
    }
  };

  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
    var elements = this.elements;
    var layers = this.layers;
    var i = 0;
    var len = layers.length;

    while (i < len) {
      if (layers[i].ind == parentName) {
        // eslint-disable-line eqeqeq
        if (!elements[i] || elements[i] === true) {
          this.buildItem(i);
          this.addPendingElement(element);
        } else {
          hierarchy.push(elements[i]);
          elements[i].setAsParent();

          if (layers[i].parent !== undefined) {
            this.buildElementParenting(element, layers[i].parent, hierarchy);
          } else {
            element.setHierarchy(hierarchy);
          }
        }
      }

      i += 1;
    }
  };

  BaseRenderer.prototype.addPendingElement = function (element) {
    this.pendingElements.push(element);
  };

  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
    var i;
    var len = assets.length;

    for (i = 0; i < len; i += 1) {
      if (assets[i].xt) {
        var comp = this.createComp(assets[i]);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
      }
    }
  };

  BaseRenderer.prototype.getElementByPath = function (path) {
    var pathValue = path.shift();
    var element;

    if (typeof pathValue === 'number') {
      element = this.elements[pathValue];
    } else {
      var i;
      var len = this.elements.length;

      for (i = 0; i < len; i += 1) {
        if (this.elements[i].data.nm === pathValue) {
          element = this.elements[i];
          break;
        }
      }
    }

    if (path.length === 0) {
      return element;
    }

    return element.getElementByPath(path);
  };

  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.imageLoader = this.animationItem.imagePreloader;
    this.globalData.audioController = this.animationItem.audioController;
    this.globalData.frameId = 0;
    this.globalData.frameRate = animData.fr;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
      w: animData.w,
      h: animData.h
    };
  };

  function TransformElement() {}

  TransformElement.prototype = {
    initTransform: function initTransform() {
      this.finalTransform = {
        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
          o: 0
        },
        _matMdf: false,
        _opMdf: false,
        mat: new Matrix()
      };

      if (this.data.ao) {
        this.finalTransform.mProp.autoOriented = true;
      } // TODO: check TYPE 11: Guided elements


      if (this.data.ty !== 11) {// this.createElements();
      }
    },
    renderTransform: function renderTransform() {
      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

      if (this.hierarchy) {
        var mat;
        var finalMat = this.finalTransform.mat;
        var i = 0;
        var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.

        if (!this.finalTransform._matMdf) {
          while (i < len) {
            if (this.hierarchy[i].finalTransform.mProp._mdf) {
              this.finalTransform._matMdf = true;
              break;
            }

            i += 1;
          }
        }

        if (this.finalTransform._matMdf) {
          mat = this.finalTransform.mProp.v.props;
          finalMat.cloneFromProps(mat);

          for (i = 0; i < len; i += 1) {
            mat = this.hierarchy[i].finalTransform.mProp.v.props;
            finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
          }
        }
      }
    },
    globalToLocal: function globalToLocal(pt) {
      var transforms = [];
      transforms.push(this.finalTransform);
      var flag = true;
      var comp = this.comp;

      while (flag) {
        if (comp.finalTransform) {
          if (comp.data.hasMask) {
            transforms.splice(0, 0, comp.finalTransform);
          }

          comp = comp.comp;
        } else {
          flag = false;
        }
      }

      var i;
      var len = transforms.length;
      var ptNew;

      for (i = 0; i < len; i += 1) {
        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);

        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
      }

      return pt;
    },
    mHelper: new Matrix()
  };

  function MaskElement(data, element, globalData) {
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.storedData = [];
    this.masksProperties = this.data.masksProperties || [];
    this.maskElement = null;
    var defs = this.globalData.defs;
    var i;
    var len = this.masksProperties ? this.masksProperties.length : 0;
    this.viewData = createSizedArray(len);
    this.solidPath = '';
    var path;
    var properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j;
    var jLen;
    var layerId = createElementID();
    var rect;
    var expansor;
    var feMorph;
    var x;
    var maskType = 'clipPath';
    var maskRef = 'clip-path';

    for (i = 0; i < len; i += 1) {
      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
        maskType = 'mask';
        maskRef = 'mask';
      }

      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
        rect = createNS('rect');
        rect.setAttribute('fill', '#ffffff');
        rect.setAttribute('width', this.element.comp.data.w || 0);
        rect.setAttribute('height', this.element.comp.data.h || 0);
        currentMasks.push(rect);
      } else {
        rect = null;
      }

      path = createNS('path');

      if (properties[i].mode === 'n') {
        // TODO move this to a factory or to a constructor
        this.viewData[i] = {
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          elem: path,
          lastPath: ''
        };
        defs.appendChild(path);
      } else {
        count += 1;
        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
        path.setAttribute('clip-rule', 'nonzero');
        var filterID;

        if (properties[i].x.k !== 0) {
          maskType = 'mask';
          maskRef = 'mask';
          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
          filterID = createElementID();
          expansor = createNS('filter');
          expansor.setAttribute('id', filterID);
          feMorph = createNS('feMorphology');
          feMorph.setAttribute('operator', 'erode');
          feMorph.setAttribute('in', 'SourceGraphic');
          feMorph.setAttribute('radius', '0');
          expansor.appendChild(feMorph);
          defs.appendChild(expansor);
          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
        } else {
          feMorph = null;
          x = null;
        } // TODO move this to a factory or to a constructor


        this.storedData[i] = {
          elem: path,
          x: x,
          expan: feMorph,
          lastPath: '',
          lastOperator: '',
          filterId: filterID,
          lastRadius: 0
        };

        if (properties[i].mode === 'i') {
          jLen = currentMasks.length;
          var g = createNS('g');

          for (j = 0; j < jLen; j += 1) {
            g.appendChild(currentMasks[j]);
          }

          var mask = createNS('mask');
          mask.setAttribute('mask-type', 'alpha');
          mask.setAttribute('id', layerId + '_' + count);
          mask.appendChild(path);
          defs.appendChild(mask);
          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
          currentMasks.length = 0;
          currentMasks.push(g);
        } else {
          currentMasks.push(path);
        }

        if (properties[i].inv && !this.solidPath) {
          this.solidPath = this.createLayerSolidPath();
        } // TODO move this to a factory or to a constructor


        this.viewData[i] = {
          elem: path,
          lastPath: '',
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          invRect: rect
        };

        if (!this.viewData[i].prop.k) {
          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
        }
      }
    }

    this.maskElement = createNS(maskType);
    len = currentMasks.length;

    for (i = 0; i < len; i += 1) {
      this.maskElement.appendChild(currentMasks[i]);
    }

    if (count > 0) {
      this.maskElement.setAttribute('id', layerId);
      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
      defs.appendChild(this.maskElement);
    }

    if (this.viewData.length) {
      this.element.addRenderableComponent(this);
    }
  }

  MaskElement.prototype.getMaskProperty = function (pos) {
    return this.viewData[pos].prop;
  };

  MaskElement.prototype.renderFrame = function (isFirstFrame) {
    var finalMat = this.element.finalTransform.mat;
    var i;
    var len = this.masksProperties.length;

    for (i = 0; i < len; i += 1) {
      if (this.viewData[i].prop._mdf || isFirstFrame) {
        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
      }

      if (this.viewData[i].op._mdf || isFirstFrame) {
        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
      }

      if (this.masksProperties[i].mode !== 'n') {
        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
        }

        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
          var feMorph = this.storedData[i].expan;

          if (this.storedData[i].x.v < 0) {
            if (this.storedData[i].lastOperator !== 'erode') {
              this.storedData[i].lastOperator = 'erode';
              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
            }

            feMorph.setAttribute('radius', -this.storedData[i].x.v);
          } else {
            if (this.storedData[i].lastOperator !== 'dilate') {
              this.storedData[i].lastOperator = 'dilate';
              this.storedData[i].elem.setAttribute('filter', null);
            }

            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
          }
        }
      }
    }
  };

  MaskElement.prototype.getMaskelement = function () {
    return this.maskElement;
  };

  MaskElement.prototype.createLayerSolidPath = function () {
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w;
    path += ' v' + this.globalData.compSize.h;
    path += ' h-' + this.globalData.compSize.w;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
  };

  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    var i;
    var len;
    len = pathNodes._length;

    for (i = 1; i < len; i += 1) {
      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
    } // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];


    if (pathNodes.c && len > 1) {
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    } // pathNodes.__renderedString = pathString;


    if (viewData.lastPath !== pathString) {
      var pathShapeValue = '';

      if (viewData.elem) {
        if (pathNodes.c) {
          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
        }

        viewData.elem.setAttribute('d', pathShapeValue);
      }

      viewData.lastPath = pathString;
    }
  };

  MaskElement.prototype.destroy = function () {
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.masksProperties = null;
  };

  var filtersFactory = function () {
    var ob = {};
    ob.createFilter = createFilter;
    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

    function createFilter(filId, skipCoordinates) {
      var fil = createNS('filter');
      fil.setAttribute('id', filId);

      if (skipCoordinates !== true) {
        fil.setAttribute('filterUnits', 'objectBoundingBox');
        fil.setAttribute('x', '0%');
        fil.setAttribute('y', '0%');
        fil.setAttribute('width', '100%');
        fil.setAttribute('height', '100%');
      }

      return fil;
    }

    function createAlphaToLuminanceFilter() {
      var feColorMatrix = createNS('feColorMatrix');
      feColorMatrix.setAttribute('type', 'matrix');
      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
      return feColorMatrix;
    }

    return ob;
  }();

  var featureSupport = function () {
    var ob = {
      maskType: true
    };

    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
      ob.maskType = false;
    }

    return ob;
  }();

  var registeredEffects = {};
  var idPrefix = 'filter_result_';

  function SVGEffects(elem) {
    var i;
    var source = 'SourceGraphic';
    var len = elem.data.ef ? elem.data.ef.length : 0;
    var filId = createElementID();
    var fil = filtersFactory.createFilter(filId, true);
    var count = 0;
    this.filters = [];
    var filterManager;

    for (i = 0; i < len; i += 1) {
      filterManager = null;
      var type = elem.data.ef[i].ty;

      if (registeredEffects[type]) {
        var Effect = registeredEffects[type].effect;
        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
        source = idPrefix + count;

        if (registeredEffects[type].countsAsEffect) {
          count += 1;
        }
      }

      if (filterManager) {
        this.filters.push(filterManager);
      }
    }

    if (count) {
      elem.globalData.defs.appendChild(fil);
      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
    }

    if (this.filters.length) {
      elem.addRenderableComponent(this);
    }
  }

  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
    var i;
    var len = this.filters.length;

    for (i = 0; i < len; i += 1) {
      this.filters[i].renderFrame(_isFirstFrame);
    }
  };

  function registerEffect(id, effect, countsAsEffect) {
    registeredEffects[id] = {
      effect: effect,
      countsAsEffect: countsAsEffect
    };
  }

  function SVGBaseElement() {}

  SVGBaseElement.prototype = {
    initRendererElement: function initRendererElement() {
      this.layerElement = createNS('g');
    },
    createContainerElements: function createContainerElements() {
      this.matteElement = createNS('g');
      this.transformedElement = this.layerElement;
      this.maskedElement = this.layerElement;
      this._sizeChanged = false;
      var layerElementParent = null; // If this layer acts as a mask for the following layer

      var filId;
      var fil;
      var gg;

      if (this.data.td) {
        if (this.data.td == 3 || this.data.td == 1) {
          // eslint-disable-line eqeqeq
          var masker = createNS('mask');
          masker.setAttribute('id', this.layerId);
          masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha'); // eslint-disable-line eqeqeq

          masker.appendChild(this.layerElement);
          layerElementParent = masker;
          this.globalData.defs.appendChild(masker); // This is only for IE and Edge when mask if of type alpha

          if (!featureSupport.maskType && this.data.td == 1) {
            // eslint-disable-line eqeqeq
            masker.setAttribute('mask-type', 'luminance');
            filId = createElementID();
            fil = filtersFactory.createFilter(filId);
            this.globalData.defs.appendChild(fil);
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            gg.appendChild(this.layerElement);
            layerElementParent = gg;
            masker.appendChild(gg);
            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          }
        } else if (this.data.td == 2) {
          // eslint-disable-line eqeqeq
          var maskGroup = createNS('mask');
          maskGroup.setAttribute('id', this.layerId);
          maskGroup.setAttribute('mask-type', 'alpha');
          var maskGrouper = createNS('g');
          maskGroup.appendChild(maskGrouper);
          filId = createElementID();
          fil = filtersFactory.createFilter(filId); /// /
          // This solution doesn't work on Android when meta tag with viewport attribute is set

          /* var feColorMatrix = createNS('feColorMatrix');
                  feColorMatrix.setAttribute('type', 'matrix');
                  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
                  feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
                  fil.appendChild(feColorMatrix); */
          /// /

          var feCTr = createNS('feComponentTransfer');
          feCTr.setAttribute('in', 'SourceGraphic');
          fil.appendChild(feCTr);
          var feFunc = createNS('feFuncA');
          feFunc.setAttribute('type', 'table');
          feFunc.setAttribute('tableValues', '1.0 0.0');
          feCTr.appendChild(feFunc); /// /

          this.globalData.defs.appendChild(fil);
          var alphaRect = createNS('rect');
          alphaRect.setAttribute('width', this.comp.data.w);
          alphaRect.setAttribute('height', this.comp.data.h);
          alphaRect.setAttribute('x', '0');
          alphaRect.setAttribute('y', '0');
          alphaRect.setAttribute('fill', '#ffffff');
          alphaRect.setAttribute('opacity', '0');
          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          maskGrouper.appendChild(alphaRect);
          maskGrouper.appendChild(this.layerElement);
          layerElementParent = maskGrouper;

          if (!featureSupport.maskType) {
            maskGroup.setAttribute('mask-type', 'luminance');
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            maskGrouper.appendChild(alphaRect);
            gg.appendChild(this.layerElement);
            layerElementParent = gg;
            maskGrouper.appendChild(gg);
          }

          this.globalData.defs.appendChild(maskGroup);
        }
      } else if (this.data.tt) {
        this.matteElement.appendChild(this.layerElement);
        layerElementParent = this.matteElement;
        this.baseElement = this.matteElement;
      } else {
        this.baseElement = this.layerElement;
      }

      if (this.data.ln) {
        this.layerElement.setAttribute('id', this.data.ln);
      }

      if (this.data.cl) {
        this.layerElement.setAttribute('class', this.data.cl);
      } // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped


      if (this.data.ty === 0 && !this.data.hd) {
        var cp = createNS('clipPath');
        var pt = createNS('path');
        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
        var clipId = createElementID();
        cp.setAttribute('id', clipId);
        cp.appendChild(pt);
        this.globalData.defs.appendChild(cp);

        if (this.checkMasks()) {
          var cpGroup = createNS('g');
          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
          cpGroup.appendChild(this.layerElement);
          this.transformedElement = cpGroup;

          if (layerElementParent) {
            layerElementParent.appendChild(this.transformedElement);
          } else {
            this.baseElement = this.transformedElement;
          }
        } else {
          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
        }
      }

      if (this.data.bm !== 0) {
        this.setBlendMode();
      }
    },
    renderElement: function renderElement() {
      if (this.finalTransform._matMdf) {
        this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
      }

      if (this.finalTransform._opMdf) {
        this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
      }
    },
    destroyBaseElement: function destroyBaseElement() {
      this.layerElement = null;
      this.matteElement = null;
      this.maskManager.destroy();
    },
    getBaseElement: function getBaseElement() {
      if (this.data.hd) {
        return null;
      }

      return this.baseElement;
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
      this.renderableEffectsManager = new SVGEffects(this);
    },
    setMatte: function setMatte(id) {
      if (!this.matteElement) {
        return;
      }

      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
    }
  };

  /**
   * @file
   * Handles AE's layer parenting property.
   *
   */
  function HierarchyElement() {}

  HierarchyElement.prototype = {
    /**
       * @function
       * Initializes hierarchy properties
       *
       */
    initHierarchy: function initHierarchy() {
      // element's parent list
      this.hierarchy = []; // if element is parent of another layer _isParent will be true

      this._isParent = false;
      this.checkParenting();
    },

    /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */
    setHierarchy: function setHierarchy(hierarchy) {
      this.hierarchy = hierarchy;
    },

    /**
       * @function
       * Sets layer as parent.
       *
       */
    setAsParent: function setAsParent() {
      this._isParent = true;
    },

    /**
       * @function
       * Searches layer's parenting chain
       *
       */
    checkParenting: function checkParenting() {
      if (this.data.parent !== undefined) {
        this.comp.buildElementParenting(this, this.data.parent, []);
      }
    }
  };

  function RenderableDOMElement() {}

  (function () {
    var _prototype = {
      initElement: function initElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
      },
      hide: function hide() {
        // console.log('HIDE', this);
        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'none';
          this.hidden = true;
        }
      },
      show: function show() {
        // console.log('SHOW', this);
        if (this.isInRange && !this.isTransparent) {
          if (!this.data.hd) {
            var elem = this.baseElement || this.layerElement;
            elem.style.display = 'block';
          }

          this.hidden = false;
          this._isFirstFrame = true;
        }
      },
      renderFrame: function renderFrame() {
        // If it is exported as hidden (data.hd === true) no need to render
        // If it is not visible no need to render
        if (this.data.hd || this.hidden) {
          return;
        }

        this.renderTransform();
        this.renderRenderable();
        this.renderElement();
        this.renderInnerContent();

        if (this._isFirstFrame) {
          this._isFirstFrame = false;
        }
      },
      renderInnerContent: function renderInnerContent() {},
      prepareFrame: function prepareFrame(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        this.checkTransparency();
      },
      destroy: function destroy() {
        this.innerElem = null;
        this.destroyBaseElement();
      }
    };
    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
  })();

  function IImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    this.initElement(data, globalData, comp);
    this.sourceRect = {
      top: 0,
      left: 0,
      width: this.assetData.w,
      height: this.assetData.h
    };
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

  IImageElement.prototype.createContent = function () {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.innerElem = createNS('image');
    this.innerElem.setAttribute('width', this.assetData.w + 'px');
    this.innerElem.setAttribute('height', this.assetData.h + 'px');
    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.innerElem);
  };

  IImageElement.prototype.sourceRectAtTime = function () {
    return this.sourceRect;
  };

  function ProcessedElement(element, position) {
    this.elem = element;
    this.pos = position;
  }

  function IShapeElement() {}

  IShapeElement.prototype = {
    addShapeToModifiers: function addShapeToModifiers(data) {
      var i;
      var len = this.shapeModifiers.length;

      for (i = 0; i < len; i += 1) {
        this.shapeModifiers[i].addShape(data);
      }
    },
    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
      var i = 0;
      var len = this.shapeModifiers.length;

      while (i < len) {
        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
          return true;
        }
      }

      return false;
    },
    renderModifiers: function renderModifiers() {
      if (!this.shapeModifiers.length) {
        return;
      }

      var i;
      var len = this.shapes.length;

      for (i = 0; i < len; i += 1) {
        this.shapes[i].sh.reset();
      }

      len = this.shapeModifiers.length;
      var shouldBreakProcess;

      for (i = len - 1; i >= 0; i -= 1) {
        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
        // TODO: find a better solution for this

        if (shouldBreakProcess) {
          break;
        }
      }
    },
    searchProcessedElement: function searchProcessedElement(elem) {
      var elements = this.processedElements;
      var i = 0;
      var len = elements.length;

      while (i < len) {
        if (elements[i].elem === elem) {
          return elements[i].pos;
        }

        i += 1;
      }

      return 0;
    },
    addProcessedElement: function addProcessedElement(elem, pos) {
      var elements = this.processedElements;
      var i = elements.length;

      while (i) {
        i -= 1;

        if (elements[i].elem === elem) {
          elements[i].pos = pos;
          return;
        }
      }

      elements.push(new ProcessedElement(elem, pos));
    },
    prepareFrame: function prepareFrame(num) {
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
    }
  };

  var lineCapEnum = {
    1: 'butt',
    2: 'round',
    3: 'square'
  };
  var lineJoinEnum = {
    1: 'miter',
    2: 'round',
    3: 'bevel'
  };

  function SVGShapeData(transformers, level, shape) {
    this.caches = [];
    this.styles = [];
    this.transformers = transformers;
    this.lStr = '';
    this.sh = shape;
    this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
    // For now, since shapes add up with other shapes. They have to be calculated every time.
    // One way of finding out is checking if all styles associated to this shape depend only of this shape

    this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated

    var i = 0;
    var len = transformers.length;

    while (i < len) {
      if (transformers[i].mProps.dynamicProperties.length) {
        this._isAnimated = true;
        break;
      }

      i += 1;
    }
  }

  SVGShapeData.prototype.setAsAnimated = function () {
    this._isAnimated = true;
  };

  function SVGStyleData(data, level) {
    this.data = data;
    this.type = data.ty;
    this.d = '';
    this.lvl = level;
    this._mdf = false;
    this.closed = data.hd === true;
    this.pElem = createNS('path');
    this.msElem = null;
  }

  SVGStyleData.prototype.reset = function () {
    this.d = '';
    this._mdf = false;
  };

  function DashProperty(elem, data, renderer, container) {
    this.elem = elem;
    this.frameId = -1;
    this.dataProps = createSizedArray(data.length);
    this.renderer = renderer;
    this.k = false;
    this.dashStr = '';
    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
    this.dashoffset = createTypedArray('float32', 1);
    this.initDynamicPropertyContainer(container);
    var i;
    var len = data.length || 0;
    var prop;

    for (i = 0; i < len; i += 1) {
      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
      this.k = prop.k || this.k;
      this.dataProps[i] = {
        n: data[i].n,
        p: prop
      };
    }

    if (!this.k) {
      this.getValue(true);
    }

    this._isAnimated = this.k;
  }

  DashProperty.prototype.getValue = function (forceRender) {
    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
      return;
    }

    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || forceRender;

    if (this._mdf) {
      var i = 0;
      var len = this.dataProps.length;

      if (this.renderer === 'svg') {
        this.dashStr = '';
      }

      for (i = 0; i < len; i += 1) {
        if (this.dataProps[i].n !== 'o') {
          if (this.renderer === 'svg') {
            this.dashStr += ' ' + this.dataProps[i].p.v;
          } else {
            this.dashArray[i] = this.dataProps[i].p.v;
          }
        } else {
          this.dashoffset[0] = this.dataProps[i].p.v;
        }
      }
    }
  };

  extendPrototype([DynamicPropertyContainer], DashProperty);

  function SVGStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
    this._isAnimated = !!this._isAnimated;
  }

  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

  function SVGFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
  }

  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

  function SVGNoStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.style = styleOb;
  }

  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);

  function GradientProperty(elem, data, container) {
    this.data = data;
    this.c = createTypedArray('uint8c', data.p * 4);
    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
    this.o = createTypedArray('float32', cLength);
    this._cmdf = false;
    this._omdf = false;
    this._collapsable = this.checkCollapsable();
    this._hasOpacity = cLength;
    this.initDynamicPropertyContainer(container);
    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
    this.k = this.prop.k;
    this.getValue(true);
  }

  GradientProperty.prototype.comparePoints = function (values, points) {
    var i = 0;
    var len = this.o.length / 2;
    var diff;

    while (i < len) {
      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);

      if (diff > 0.01) {
        return false;
      }

      i += 1;
    }

    return true;
  };

  GradientProperty.prototype.checkCollapsable = function () {
    if (this.o.length / 2 !== this.c.length / 4) {
      return false;
    }

    if (this.data.k.k[0].s) {
      var i = 0;
      var len = this.data.k.k.length;

      while (i < len) {
        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
          return false;
        }

        i += 1;
      }
    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
      return false;
    }

    return true;
  };

  GradientProperty.prototype.getValue = function (forceRender) {
    this.prop.getValue();
    this._mdf = false;
    this._cmdf = false;
    this._omdf = false;

    if (this.prop._mdf || forceRender) {
      var i;
      var len = this.data.p * 4;
      var mult;
      var val;

      for (i = 0; i < len; i += 1) {
        mult = i % 4 === 0 ? 100 : 255;
        val = Math.round(this.prop.v[i] * mult);

        if (this.c[i] !== val) {
          this.c[i] = val;
          this._cmdf = !forceRender;
        }
      }

      if (this.o.length) {
        len = this.prop.v.length;

        for (i = this.data.p * 4; i < len; i += 1) {
          mult = i % 2 === 0 ? 100 : 1;
          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];

          if (this.o[i - this.data.p * 4] !== val) {
            this.o[i - this.data.p * 4] = val;
            this._omdf = !forceRender;
          }
        }
      }

      this._mdf = !forceRender;
    }
  };

  extendPrototype([DynamicPropertyContainer], GradientProperty);

  function SVGGradientFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.initGradientData(elem, data, styleOb);
  }

  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
    this.h = PropertyFactory.getProp(elem, data.h || {
      k: 0
    }, 0, 0.01, this);
    this.a = PropertyFactory.getProp(elem, data.a || {
      k: 0
    }, 0, degToRads, this);
    this.g = new GradientProperty(elem, data.g, this);
    this.style = styleOb;
    this.stops = [];
    this.setGradientData(styleOb.pElem, data);
    this.setGradientOpacity(data, styleOb);
    this._isAnimated = !!this._isAnimated;
  };

  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
    var gradientId = createElementID();
    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    gfill.setAttribute('id', gradientId);
    gfill.setAttribute('spreadMethod', 'pad');
    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
    var stops = [];
    var stop;
    var j;
    var jLen;
    jLen = data.g.p * 4;

    for (j = 0; j < jLen; j += 4) {
      stop = createNS('stop');
      gfill.appendChild(stop);
      stops.push(stop);
    }

    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
    this.gf = gfill;
    this.cst = stops;
  };

  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
    if (this.g._hasOpacity && !this.g._collapsable) {
      var stop;
      var j;
      var jLen;
      var mask = createNS('mask');
      var maskElement = createNS('path');
      mask.appendChild(maskElement);
      var opacityId = createElementID();
      var maskId = createElementID();
      mask.setAttribute('id', maskId);
      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
      opFill.setAttribute('id', opacityId);
      opFill.setAttribute('spreadMethod', 'pad');
      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
      var stops = this.stops;

      for (j = data.g.p * 4; j < jLen; j += 2) {
        stop = createNS('stop');
        stop.setAttribute('stop-color', 'rgb(255,255,255)');
        opFill.appendChild(stop);
        stops.push(stop);
      }

      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');

      if (data.ty === 'gs') {
        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);

        if (data.lj === 1) {
          maskElement.setAttribute('stroke-miterlimit', data.ml);
        }
      }

      this.of = opFill;
      this.ms = mask;
      this.ost = stops;
      this.maskId = maskId;
      styleOb.msElem = maskElement;
    }
  };

  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

  function SVGGradientStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.initGradientData(elem, data, styleOb);
    this._isAnimated = !!this._isAnimated;
  }

  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

  function ShapeGroupData() {
    this.it = [];
    this.prevViewData = [];
    this.gr = createNS('g');
  }

  function SVGTransformData(mProps, op, container) {
    this.transform = {
      mProps: mProps,
      op: op,
      container: container
    };
    this.elements = [];
    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
  }

  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
    if (length === 0) {
      return '';
    }

    var _o = pathNodes.o;
    var _i = pathNodes.i;
    var _v = pathNodes.v;
    var i;
    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);

    for (i = 1; i < length; i += 1) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
    }

    if (closed && length) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
      shapeString += 'z';
    }

    return shapeString;
  };

  var SVGElementsRenderer = function () {
    var _identityMatrix = new Matrix();

    var _matrixHelper = new Matrix();

    var ob = {
      createRenderFunction: createRenderFunction
    };

    function createRenderFunction(data) {
      switch (data.ty) {
        case 'fl':
          return renderFill;

        case 'gf':
          return renderGradient;

        case 'gs':
          return renderGradientStroke;

        case 'st':
          return renderStroke;

        case 'sh':
        case 'el':
        case 'rc':
        case 'sr':
          return renderPath;

        case 'tr':
          return renderContentTransform;

        case 'no':
          return renderNoop;

        default:
          return null;
      }
    }

    function renderContentTransform(styleData, itemData, isFirstFrame) {
      if (isFirstFrame || itemData.transform.op._mdf) {
        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
      }

      if (isFirstFrame || itemData.transform.mProps._mdf) {
        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
      }
    }

    function renderNoop() {}

    function renderPath(styleData, itemData, isFirstFrame) {
      var j;
      var jLen;
      var pathStringTransformed;
      var redraw;
      var pathNodes;
      var l;
      var lLen = itemData.styles.length;
      var lvl = itemData.lvl;
      var paths;
      var mat;
      var props;
      var iterations;
      var k;

      for (l = 0; l < lLen; l += 1) {
        redraw = itemData.sh._mdf || isFirstFrame;

        if (itemData.styles[l].lvl < lvl) {
          mat = _matrixHelper.reset();
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;

          while (!redraw && iterations > 0) {
            redraw = itemData.transformers[k].mProps._mdf || redraw;
            iterations -= 1;
            k -= 1;
          }

          if (redraw) {
            iterations = lvl - itemData.styles[l].lvl;
            k = itemData.transformers.length - 1;

            while (iterations > 0) {
              props = itemData.transformers[k].mProps.v.props;
              mat.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
              iterations -= 1;
              k -= 1;
            }
          }
        } else {
          mat = _identityMatrix;
        }

        paths = itemData.sh.paths;
        jLen = paths._length;

        if (redraw) {
          pathStringTransformed = '';

          for (j = 0; j < jLen; j += 1) {
            pathNodes = paths.shapes[j];

            if (pathNodes && pathNodes._length) {
              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
            }
          }

          itemData.caches[l] = pathStringTransformed;
        } else {
          pathStringTransformed = itemData.caches[l];
        }

        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
      }
    }

    function renderFill(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;

      if (itemData.c._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }

      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
      }
    }

    function renderGradientStroke(styleData, itemData, isFirstFrame) {
      renderGradient(styleData, itemData, isFirstFrame);
      renderStroke(styleData, itemData, isFirstFrame);
    }

    function renderGradient(styleData, itemData, isFirstFrame) {
      var gfill = itemData.gf;
      var hasOpacity = itemData.g._hasOpacity;
      var pt1 = itemData.s.v;
      var pt2 = itemData.e.v;

      if (itemData.o._mdf || isFirstFrame) {
        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
        itemData.style.pElem.setAttribute(attr, itemData.o.v);
      }

      if (itemData.s._mdf || isFirstFrame) {
        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
        gfill.setAttribute(attr1, pt1[0]);
        gfill.setAttribute(attr2, pt1[1]);

        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute(attr1, pt1[0]);
          itemData.of.setAttribute(attr2, pt1[1]);
        }
      }

      var stops;
      var i;
      var len;
      var stop;

      if (itemData.g._cmdf || isFirstFrame) {
        stops = itemData.cst;
        var cValues = itemData.g.c;
        len = stops.length;

        for (i = 0; i < len; i += 1) {
          stop = stops[i];
          stop.setAttribute('offset', cValues[i * 4] + '%');
          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
        }
      }

      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
        var oValues = itemData.g.o;

        if (itemData.g._collapsable) {
          stops = itemData.cst;
        } else {
          stops = itemData.ost;
        }

        len = stops.length;

        for (i = 0; i < len; i += 1) {
          stop = stops[i];

          if (!itemData.g._collapsable) {
            stop.setAttribute('offset', oValues[i * 2] + '%');
          }

          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
        }
      }

      if (styleData.t === 1) {
        if (itemData.e._mdf || isFirstFrame) {
          gfill.setAttribute('x2', pt2[0]);
          gfill.setAttribute('y2', pt2[1]);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('x2', pt2[0]);
            itemData.of.setAttribute('y2', pt2[1]);
          }
        }
      } else {
        var rad;

        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          gfill.setAttribute('r', rad);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('r', rad);
          }
        }

        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
          if (!rad) {
            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          }

          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
          var percent = itemData.h.v;

          if (percent >= 1) {
            percent = 0.99;
          } else if (percent <= -1) {
            percent = -0.99;
          }

          var dist = rad * percent;
          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
          gfill.setAttribute('fx', x);
          gfill.setAttribute('fy', y);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('fx', x);
            itemData.of.setAttribute('fy', y);
          }
        } // gfill.setAttribute('fy','200');

      }
    }

    function renderStroke(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;
      var d = itemData.d;

      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
      }

      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }

      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
      }

      if (itemData.w._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);

        if (styleElem.msElem) {
          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
        }
      }
    }

    return ob;
  }();

  function SVGShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = []; // Full shape data

    this.shapesData = data.shapes; // List of styles that will be applied to shapes

    this.stylesList = []; // List of modifiers that will be applied to shapes

    this.shapeModifiers = []; // List of items in shape tree

    this.itemsData = []; // List of items in previous shape tree

    this.processedElements = []; // List of animated components

    this.animatedContents = [];
    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created

    this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

  SVGShapeElement.prototype.initSecondaryElement = function () {};

  SVGShapeElement.prototype.identityMatrix = new Matrix();

  SVGShapeElement.prototype.buildExpressionInterface = function () {};

  SVGShapeElement.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
  };
  /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */


  SVGShapeElement.prototype.filterUniqueShapes = function () {
    var i;
    var len = this.shapes.length;
    var shape;
    var j;
    var jLen = this.stylesList.length;
    var style;
    var tempShapes = [];
    var areAnimated = false;

    for (j = 0; j < jLen; j += 1) {
      style = this.stylesList[j];
      areAnimated = false;
      tempShapes.length = 0;

      for (i = 0; i < len; i += 1) {
        shape = this.shapes[i];

        if (shape.styles.indexOf(style) !== -1) {
          tempShapes.push(shape);
          areAnimated = shape._isAnimated || areAnimated;
        }
      }

      if (tempShapes.length > 1 && areAnimated) {
        this.setShapesAsAnimated(tempShapes);
      }
    }
  };

  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
    var i;
    var len = shapes.length;

    for (i = 0; i < len; i += 1) {
      shapes[i].setAsAnimated();
    }
  };

  SVGShapeElement.prototype.createStyleElement = function (data, level) {
    // TODO: prevent drawing of hidden styles
    var elementData;
    var styleOb = new SVGStyleData(data, level);
    var pathElement = styleOb.pElem;

    if (data.ty === 'st') {
      elementData = new SVGStrokeStyleData(this, data, styleOb);
    } else if (data.ty === 'fl') {
      elementData = new SVGFillStyleData(this, data, styleOb);
    } else if (data.ty === 'gf' || data.ty === 'gs') {
      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
      elementData = new GradientConstructor(this, data, styleOb);
      this.globalData.defs.appendChild(elementData.gf);

      if (elementData.maskId) {
        this.globalData.defs.appendChild(elementData.ms);
        this.globalData.defs.appendChild(elementData.of);
        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
      }
    } else if (data.ty === 'no') {
      elementData = new SVGNoStyleData(this, data, styleOb);
    }

    if (data.ty === 'st' || data.ty === 'gs') {
      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
      pathElement.setAttribute('fill-opacity', '0');

      if (data.lj === 1) {
        pathElement.setAttribute('stroke-miterlimit', data.ml);
      }
    }

    if (data.r === 2) {
      pathElement.setAttribute('fill-rule', 'evenodd');
    }

    if (data.ln) {
      pathElement.setAttribute('id', data.ln);
    }

    if (data.cl) {
      pathElement.setAttribute('class', data.cl);
    }

    if (data.bm) {
      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
    }

    this.stylesList.push(styleOb);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.createGroupElement = function (data) {
    var elementData = new ShapeGroupData();

    if (data.ln) {
      elementData.gr.setAttribute('id', data.ln);
    }

    if (data.cl) {
      elementData.gr.setAttribute('class', data.cl);
    }

    if (data.bm) {
      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
    }

    return elementData;
  };

  SVGShapeElement.prototype.createTransformElement = function (data, container) {
    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
    var ty = 4;

    if (data.ty === 'rc') {
      ty = 5;
    } else if (data.ty === 'el') {
      ty = 6;
    } else if (data.ty === 'sr') {
      ty = 7;
    }

    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
    var i = 0;
    var len = this.animatedContents.length;

    while (i < len) {
      if (this.animatedContents[i].element === element) {
        return;
      }

      i += 1;
    }

    this.animatedContents.push({
      fn: SVGElementsRenderer.createRenderFunction(data),
      element: element,
      data: data
    });
  };

  SVGShapeElement.prototype.setElementStyles = function (elementData) {
    var arr = elementData.styles;
    var j;
    var jLen = this.stylesList.length;

    for (j = 0; j < jLen; j += 1) {
      if (!this.stylesList[j].closed) {
        arr.push(this.stylesList[j]);
      }
    }
  };

  SVGShapeElement.prototype.reloadShapes = function () {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;

    for (i = 0; i < len; i += 1) {
      this.prevViewData[i] = this.itemsData[i];
    }

    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
    len = this.dynamicProperties.length;

    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
    }

    this.renderModifiers();
  };

  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
    var ownTransformers = [].concat(transformers);
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var currentTransform;
    var modifier;
    var processedPos;

    for (i = len; i >= 0; i -= 1) {
      processedPos = this.searchProcessedElement(arr[i]);

      if (!processedPos) {
        arr[i]._render = render;
      } else {
        itemsData[i] = prevViewData[processedPos - 1];
      }

      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
        if (!processedPos) {
          itemsData[i] = this.createStyleElement(arr[i], level);
        } else {
          itemsData[i].style.closed = false;
        }

        if (arr[i]._render) {
          if (itemsData[i].style.pElem.parentNode !== container) {
            container.appendChild(itemsData[i].style.pElem);
          }
        }

        ownStyles.push(itemsData[i].style);
      } else if (arr[i].ty === 'gr') {
        if (!processedPos) {
          itemsData[i] = this.createGroupElement(arr[i]);
        } else {
          jLen = itemsData[i].it.length;

          for (j = 0; j < jLen; j += 1) {
            itemsData[i].prevViewData[j] = itemsData[i].it[j];
          }
        }

        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);

        if (arr[i]._render) {
          if (itemsData[i].gr.parentNode !== container) {
            container.appendChild(itemsData[i].gr);
          }
        }
      } else if (arr[i].ty === 'tr') {
        if (!processedPos) {
          itemsData[i] = this.createTransformElement(arr[i], container);
        }

        currentTransform = itemsData[i].transform;
        ownTransformers.push(currentTransform);
      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
        if (!processedPos) {
          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
        }

        this.setElementStyles(itemsData[i]);
      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          modifier.init(this, arr[i]);
          itemsData[i] = modifier;
          this.shapeModifiers.push(modifier);
        } else {
          modifier = itemsData[i];
          modifier.closed = false;
        }

        ownModifiers.push(modifier);
      } else if (arr[i].ty === 'rp') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          itemsData[i] = modifier;
          modifier.init(this, arr, i, itemsData);
          this.shapeModifiers.push(modifier);
          render = false;
        } else {
          modifier = itemsData[i];
          modifier.closed = true;
        }

        ownModifiers.push(modifier);
      }

      this.addProcessedElement(arr[i], i + 1);
    }

    len = ownStyles.length;

    for (i = 0; i < len; i += 1) {
      ownStyles[i].closed = true;
    }

    len = ownModifiers.length;

    for (i = 0; i < len; i += 1) {
      ownModifiers[i].closed = true;
    }
  };

  SVGShapeElement.prototype.renderInnerContent = function () {
    this.renderModifiers();
    var i;
    var len = this.stylesList.length;

    for (i = 0; i < len; i += 1) {
      this.stylesList[i].reset();
    }

    this.renderShape();

    for (i = 0; i < len; i += 1) {
      if (this.stylesList[i]._mdf || this._isFirstFrame) {
        if (this.stylesList[i].msElem) {
          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers

          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
        }

        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
      }
    }
  };

  SVGShapeElement.prototype.renderShape = function () {
    var i;
    var len = this.animatedContents.length;
    var animatedContent;

    for (i = 0; i < len; i += 1) {
      animatedContent = this.animatedContents[i];

      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
      }
    }
  };

  SVGShapeElement.prototype.destroy = function () {
    this.destroyBaseElement();
    this.shapesData = null;
    this.itemsData = null;
  };

  function LetterProps(o, sw, sc, fc, m, p) {
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.p = p;
    this._mdf = {
      o: true,
      sw: !!sw,
      sc: !!sc,
      fc: !!fc,
      m: true,
      p: true
    };
  }

  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
    this._mdf.o = false;
    this._mdf.sw = false;
    this._mdf.sc = false;
    this._mdf.fc = false;
    this._mdf.m = false;
    this._mdf.p = false;
    var updated = false;

    if (this.o !== o) {
      this.o = o;
      this._mdf.o = true;
      updated = true;
    }

    if (this.sw !== sw) {
      this.sw = sw;
      this._mdf.sw = true;
      updated = true;
    }

    if (this.sc !== sc) {
      this.sc = sc;
      this._mdf.sc = true;
      updated = true;
    }

    if (this.fc !== fc) {
      this.fc = fc;
      this._mdf.fc = true;
      updated = true;
    }

    if (this.m !== m) {
      this.m = m;
      this._mdf.m = true;
      updated = true;
    }

    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
      this.p = p;
      this._mdf.p = true;
      updated = true;
    }

    return updated;
  };

  function TextProperty(elem, data) {
    this._frameId = initialDefaultFrame;
    this.pv = '';
    this.v = '';
    this.kf = false;
    this._isFirstFrame = true;
    this._mdf = false;
    this.data = data;
    this.elem = elem;
    this.comp = this.elem.comp;
    this.keysIndex = 0;
    this.canResize = false;
    this.minimumFontSize = 1;
    this.effectsSequence = [];
    this.currentData = {
      ascent: 0,
      boxWidth: this.defaultBoxWidth,
      f: '',
      fStyle: '',
      fWeight: '',
      fc: '',
      j: '',
      justifyOffset: '',
      l: [],
      lh: 0,
      lineWidths: [],
      ls: '',
      of: '',
      s: '',
      sc: '',
      sw: 0,
      t: 0,
      tr: 0,
      sz: 0,
      ps: null,
      fillColorAnim: false,
      strokeColorAnim: false,
      strokeWidthAnim: false,
      yOffset: 0,
      finalSize: 0,
      finalText: [],
      finalLineHeight: 0,
      __complete: false
    };
    this.copyData(this.currentData, this.data.d.k[0].s);

    if (!this.searchProperty()) {
      this.completeTextData(this.currentData);
    }
  }

  TextProperty.prototype.defaultBoxWidth = [0, 0];

  TextProperty.prototype.copyData = function (obj, data) {
    for (var s in data) {
      if (Object.prototype.hasOwnProperty.call(data, s)) {
        obj[s] = data[s];
      }
    }

    return obj;
  };

  TextProperty.prototype.setCurrentData = function (data) {
    if (!data.__complete) {
      this.completeTextData(data);
    }

    this.currentData = data;
    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
    this._mdf = true;
  };

  TextProperty.prototype.searchProperty = function () {
    return this.searchKeyframes();
  };

  TextProperty.prototype.searchKeyframes = function () {
    this.kf = this.data.d.k.length > 1;

    if (this.kf) {
      this.addEffect(this.getKeyframeValue.bind(this));
    }

    return this.kf;
  };

  TextProperty.prototype.addEffect = function (effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.getValue = function (_finalValue) {
    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
      return;
    }

    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
    var currentValue = this.currentData;
    var currentIndex = this.keysIndex;

    if (this.lock) {
      this.setCurrentData(this.currentData);
      return;
    }

    this.lock = true;
    this._mdf = false;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;

    for (i = 0; i < len; i += 1) {
      // Checking if index changed to prevent creating a new object every time the expression updates.
      if (currentIndex !== this.keysIndex) {
        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
      } else {
        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
      }
    }

    if (currentValue !== finalValue) {
      this.setCurrentData(finalValue);
    }

    this.v = this.currentData;
    this.pv = this.v;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  };

  TextProperty.prototype.getKeyframeValue = function () {
    var textKeys = this.data.d.k;
    var frameNum = this.elem.comp.renderedFrame;
    var i = 0;
    var len = textKeys.length;

    while (i <= len - 1) {
      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
        break;
      }

      i += 1;
    }

    if (this.keysIndex !== i) {
      this.keysIndex = i;
    }

    return this.data.d.k[this.keysIndex].s;
  };

  TextProperty.prototype.buildFinalText = function (text) {
    var charactersArray = [];
    var i = 0;
    var len = text.length;
    var charCode;
    var secondCharCode;
    var shouldCombine = false;

    while (i < len) {
      charCode = text.charCodeAt(i);

      if (FontManager.isCombinedCharacter(charCode)) {
        charactersArray[charactersArray.length - 1] += text.charAt(i);
      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        secondCharCode = text.charCodeAt(i + 1);

        if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
          if (shouldCombine || FontManager.isModifier(charCode, secondCharCode)) {
            charactersArray[charactersArray.length - 1] += text.substr(i, 2);
            shouldCombine = false;
          } else {
            charactersArray.push(text.substr(i, 2));
          }

          i += 1;
        } else {
          charactersArray.push(text.charAt(i));
        }
      } else if (charCode > 0xDBFF) {
        secondCharCode = text.charCodeAt(i + 1);

        if (FontManager.isZeroWidthJoiner(charCode, secondCharCode)) {
          shouldCombine = true;
          charactersArray[charactersArray.length - 1] += text.substr(i, 2);
          i += 1;
        } else {
          charactersArray.push(text.charAt(i));
        }
      } else if (FontManager.isZeroWidthJoiner(charCode)) {
        charactersArray[charactersArray.length - 1] += text.charAt(i);
        shouldCombine = true;
      } else {
        charactersArray.push(text.charAt(i));
      }

      i += 1;
    }

    return charactersArray;
  };

  TextProperty.prototype.completeTextData = function (documentData) {
    documentData.__complete = true;
    var fontManager = this.elem.globalData.fontManager;
    var data = this.data;
    var letters = [];
    var i;
    var len;
    var newLineFlag;
    var index = 0;
    var val;
    var anchorGrouping = data.m.g;
    var currentSize = 0;
    var currentPos = 0;
    var currentLine = 0;
    var lineWidths = [];
    var lineWidth = 0;
    var maxLineWidth = 0;
    var j;
    var jLen;
    var fontData = fontManager.getFontByName(documentData.f);
    var charData;
    var cLength = 0;
    var fontProps = getFontProperties(fontData);
    documentData.fWeight = fontProps.weight;
    documentData.fStyle = fontProps.style;
    documentData.finalSize = documentData.s;
    documentData.finalText = this.buildFinalText(documentData.t);
    len = documentData.finalText.length;
    documentData.finalLineHeight = documentData.lh;
    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
    var charCode;

    if (documentData.sz) {
      var flag = true;
      var boxWidth = documentData.sz[0];
      var boxHeight = documentData.sz[1];
      var currentHeight;
      var finalText;

      while (flag) {
        finalText = this.buildFinalText(documentData.t);
        currentHeight = 0;
        lineWidth = 0;
        len = finalText.length;
        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var lastSpaceIndex = -1;

        for (i = 0; i < len; i += 1) {
          charCode = finalText[i].charCodeAt(0);
          newLineFlag = false;

          if (finalText[i] === ' ') {
            lastSpaceIndex = i;
          } else if (charCode === 13 || charCode === 3) {
            lineWidth = 0;
            newLineFlag = true;
            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          }

          if (fontManager.chars) {
            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
          } else {
            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
          }

          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
            if (lastSpaceIndex === -1) {
              len += 1;
            } else {
              i = lastSpaceIndex;
            }

            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);

            lastSpaceIndex = -1;
            lineWidth = 0;
          } else {
            lineWidth += cLength;
            lineWidth += trackingOffset;
          }
        }

        currentHeight += fontData.ascent * documentData.finalSize / 100;

        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
          documentData.finalSize -= 1;
          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
        } else {
          documentData.finalText = finalText;
          len = documentData.finalText.length;
          flag = false;
        }
      }
    }

    lineWidth = -trackingOffset;
    cLength = 0;
    var uncollapsedSpaces = 0;
    var currentChar;

    for (i = 0; i < len; i += 1) {
      newLineFlag = false;
      currentChar = documentData.finalText[i];
      charCode = currentChar.charCodeAt(0);

      if (charCode === 13 || charCode === 3) {
        uncollapsedSpaces = 0;
        lineWidths.push(lineWidth);
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidth = -2 * trackingOffset;
        val = '';
        newLineFlag = true;
        currentLine += 1;
      } else {
        val = currentChar;
      }

      if (fontManager.chars) {
        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
      } else {
        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
      } //


      if (currentChar === ' ') {
        uncollapsedSpaces += cLength + trackingOffset;
      } else {
        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
        uncollapsedSpaces = 0;
      }

      letters.push({
        l: cLength,
        an: cLength,
        add: currentSize,
        n: newLineFlag,
        anIndexes: [],
        val: val,
        line: currentLine,
        animatorJustifyOffset: 0
      });

      if (anchorGrouping == 2) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;

        if (val === '' || val === ' ' || i === len - 1) {
          if (val === '' || val === ' ') {
            currentSize -= cLength;
          }

          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }

          index += 1;
          currentSize = 0;
        }
      } else if (anchorGrouping == 3) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;

        if (val === '' || i === len - 1) {
          if (val === '') {
            currentSize -= cLength;
          }

          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }

          currentSize = 0;
          index += 1;
        }
      } else {
        letters[index].ind = index;
        letters[index].extra = 0;
        index += 1;
      }
    }

    documentData.l = letters;
    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
    lineWidths.push(lineWidth);

    if (documentData.sz) {
      documentData.boxWidth = documentData.sz[0];
      documentData.justifyOffset = 0;
    } else {
      documentData.boxWidth = maxLineWidth;

      switch (documentData.j) {
        case 1:
          documentData.justifyOffset = -documentData.boxWidth;
          break;

        case 2:
          documentData.justifyOffset = -documentData.boxWidth / 2;
          break;

        default:
          documentData.justifyOffset = 0;
      }
    }

    documentData.lineWidths = lineWidths;
    var animators = data.a;
    var animatorData;
    var letterData;
    jLen = animators.length;
    var based;
    var ind;
    var indexes = [];

    for (j = 0; j < jLen; j += 1) {
      animatorData = animators[j];

      if (animatorData.a.sc) {
        documentData.strokeColorAnim = true;
      }

      if (animatorData.a.sw) {
        documentData.strokeWidthAnim = true;
      }

      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
        documentData.fillColorAnim = true;
      }

      ind = 0;
      based = animatorData.s.b;

      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        letterData.anIndexes[j] = ind;

        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
          // eslint-disable-line eqeqeq
          if (animatorData.s.rn === 1) {
            indexes.push(ind);
          }

          ind += 1;
        }
      }

      data.a[j].s.totalChars = ind;
      var currentInd = -1;
      var newInd;

      if (animatorData.s.rn === 1) {
        for (i = 0; i < len; i += 1) {
          letterData = letters[i];

          if (currentInd != letterData.anIndexes[j]) {
            // eslint-disable-line eqeqeq
            currentInd = letterData.anIndexes[j];
            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
          }

          letterData.anIndexes[j] = newInd;
        }
      }
    }

    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
    documentData.ls = documentData.ls || 0;
    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
  };

  TextProperty.prototype.updateDocumentData = function (newData, index) {
    index = index === undefined ? this.keysIndex : index;
    var dData = this.copyData({}, this.data.d.k[index].s);
    dData = this.copyData(dData, newData);
    this.data.d.k[index].s = dData;
    this.recalculate(index);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.recalculate = function (index) {
    var dData = this.data.d.k[index].s;
    dData.__complete = false;
    this.keysIndex = 0;
    this._isFirstFrame = true;
    this.getValue(dData);
  };

  TextProperty.prototype.canResizeFont = function (_canResize) {
    this.canResize = _canResize;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
    this.minimumFontSize = Math.floor(_fontValue) || 1;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };

  var TextSelectorProp = function () {
    var max = Math.max;
    var min = Math.min;
    var floor = Math.floor;

    function TextSelectorPropFactory(elem, data) {
      this._currentTextLength = -1;
      this.k = false;
      this.data = data;
      this.elem = elem;
      this.comp = elem.comp;
      this.finalS = 0;
      this.finalE = 0;
      this.initDynamicPropertyContainer(elem);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: 0
      }, 0, 0, this);

      if ('e' in data) {
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
      } else {
        this.e = {
          v: 100
        };
      }

      this.o = PropertyFactory.getProp(elem, data.o || {
        k: 0
      }, 0, 0, this);
      this.xe = PropertyFactory.getProp(elem, data.xe || {
        k: 0
      }, 0, 0, this);
      this.ne = PropertyFactory.getProp(elem, data.ne || {
        k: 0
      }, 0, 0, this);
      this.sm = PropertyFactory.getProp(elem, data.sm || {
        k: 100
      }, 0, 0, this);
      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);

      if (!this.dynamicProperties.length) {
        this.getValue();
      }
    }

    TextSelectorPropFactory.prototype = {
      getMult: function getMult(ind) {
        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
          this.getValue();
        }

        var x1 = 0;
        var y1 = 0;
        var x2 = 1;
        var y2 = 1;

        if (this.ne.v > 0) {
          x1 = this.ne.v / 100.0;
        } else {
          y1 = -this.ne.v / 100.0;
        }

        if (this.xe.v > 0) {
          x2 = 1.0 - this.xe.v / 100.0;
        } else {
          y2 = 1.0 + this.xe.v / 100.0;
        }

        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
        var mult = 0;
        var s = this.finalS;
        var e = this.finalE;
        var type = this.data.sh;

        if (type === 2) {
          if (e === s) {
            mult = ind >= e ? 1 : 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }

          mult = easer(mult);
        } else if (type === 3) {
          if (e === s) {
            mult = ind >= e ? 0 : 1;
          } else {
            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }

          mult = easer(mult);
        } else if (type === 4) {
          if (e === s) {
            mult = 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));

            if (mult < 0.5) {
              mult *= 2;
            } else {
              mult = 1 - 2 * (mult - 0.5);
            }
          }

          mult = easer(mult);
        } else if (type === 5) {
          if (e === s) {
            mult = 0;
          } else {
            var tot = e - s;
            /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */

            ind = min(max(0, ind + 0.5 - s), e - s);
            var x = -tot / 2 + ind;
            var a = tot / 2;
            mult = Math.sqrt(1 - x * x / (a * a));
          }

          mult = easer(mult);
        } else if (type === 6) {
          if (e === s) {
            mult = 0;
          } else {
            ind = min(max(0, ind + 0.5 - s), e - s);
            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
          }

          mult = easer(mult);
        } else {
          if (ind >= floor(s)) {
            if (ind - s < 0) {
              mult = max(0, min(min(e, 1) - (s - ind), 1));
            } else {
              mult = max(0, min(e - ind, 1));
            }
          }

          mult = easer(mult);
        } // Smoothness implementation.
        // The smoothness represents a reduced range of the original [0; 1] range.
        // if smoothness is 25%, the new range will be [0.375; 0.625]
        // Steps are:
        // - find the lower value of the new range (threshold)
        // - if multiplier is smaller than that value, floor it to 0
        // - if it is larger,
        //     - subtract the threshold
        //     - divide it by the smoothness (this will return the range to [0; 1])
        // Note: If it doesn't work on some scenarios, consider applying it before the easer.


        if (this.sm.v !== 100) {
          var smoothness = this.sm.v * 0.01;

          if (smoothness === 0) {
            smoothness = 0.00000001;
          }

          var threshold = 0.5 - smoothness * 0.5;

          if (mult < threshold) {
            mult = 0;
          } else {
            mult = (mult - threshold) / smoothness;

            if (mult > 1) {
              mult = 1;
            }
          }
        }

        return mult * this.a.v;
      },
      getValue: function getValue(newCharsFlag) {
        this.iterateDynamicProperties();
        this._mdf = newCharsFlag || this._mdf;
        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;

        if (newCharsFlag && this.data.r === 2) {
          this.e.v = this._currentTextLength;
        }

        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
        var o = this.o.v / divisor;
        var s = this.s.v / divisor + o;
        var e = this.e.v / divisor + o;

        if (s > e) {
          var _s = s;
          s = e;
          e = _s;
        }

        this.finalS = s;
        this.finalE = e;
      }
    };
    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

    function getTextSelectorProp(elem, data, arr) {
      return new TextSelectorPropFactory(elem, data, arr);
    }

    return {
      getTextSelectorProp: getTextSelectorProp
    };
  }();

  function TextAnimatorDataProperty(elem, animatorProps, container) {
    var defaultData = {
      propType: false
    };
    var getProp = PropertyFactory.getProp;
    var textAnimatorAnimatables = animatorProps.a;
    this.a = {
      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
    };
    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
    this.s.t = animatorProps.s.t;
  }

  function TextAnimatorProperty(textData, renderType, elem) {
    this._isFirstFrame = true;
    this._hasMaskedPath = false;
    this._frameId = -1;
    this._textData = textData;
    this._renderType = renderType;
    this._elem = elem;
    this._animatorsData = createSizedArray(this._textData.a.length);
    this._pathData = {};
    this._moreOptions = {
      alignment: {}
    };
    this.renderedLetters = [];
    this.lettersChangedFlag = false;
    this.initDynamicPropertyContainer(elem);
  }

  TextAnimatorProperty.prototype.searchProperties = function () {
    var i;
    var len = this._textData.a.length;
    var animatorProps;
    var getProp = PropertyFactory.getProp;

    for (i = 0; i < len; i += 1) {
      animatorProps = this._textData.a[i];
      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
    }

    if (this._textData.p && 'm' in this._textData.p) {
      this._pathData = {
        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      };
      this._hasMaskedPath = true;
    } else {
      this._hasMaskedPath = false;
    }

    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
  };

  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
    this.lettersChangedFlag = lettersChangedFlag;

    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
      return;
    }

    this._isFirstFrame = false;
    var alignment = this._moreOptions.alignment.v;
    var animators = this._animatorsData;
    var textData = this._textData;
    var matrixHelper = this.mHelper;
    var renderType = this._renderType;
    var renderedLettersCount = this.renderedLetters.length;
    var xPos;
    var yPos;
    var i;
    var len;
    var letters = documentData.l;
    var pathInfo;
    var currentLength;
    var currentPoint;
    var segmentLength;
    var flag;
    var pointInd;
    var segmentInd;
    var prevPoint;
    var points;
    var segments;
    var partialLength;
    var totalLength;
    var perc;
    var tanAngle;
    var mask;

    if (this._hasMaskedPath) {
      mask = this._pathData.m;

      if (!this._pathData.n || this._pathData._mdf) {
        var paths = mask.v;

        if (this._pathData.r.v) {
          paths = paths.reverse();
        } // TODO: release bezier data cached from previous pathInfo: this._pathData.pi


        pathInfo = {
          tLength: 0,
          segments: []
        };
        len = paths._length - 1;
        var bezierData;
        totalLength = 0;

        for (i = 0; i < len; i += 1) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }

        i = len;

        if (mask.v.c) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }

        this._pathData.pi = pathInfo;
      }

      pathInfo = this._pathData.pi;
      currentLength = this._pathData.f.v;
      segmentInd = 0;
      pointInd = 1;
      segmentLength = 0;
      flag = true;
      segments = pathInfo.segments;

      if (currentLength < 0 && mask.v.c) {
        if (pathInfo.tLength < Math.abs(currentLength)) {
          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
        }

        segmentInd = segments.length - 1;
        points = segments[segmentInd].points;
        pointInd = points.length - 1;

        while (currentLength < 0) {
          currentLength += points[pointInd].partialLength;
          pointInd -= 1;

          if (pointInd < 0) {
            segmentInd -= 1;
            points = segments[segmentInd].points;
            pointInd = points.length - 1;
          }
        }
      }

      points = segments[segmentInd].points;
      prevPoint = points[pointInd - 1];
      currentPoint = points[pointInd];
      partialLength = currentPoint.partialLength;
    }

    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.finalSize * 1.2 * 0.714;
    var firstLine = true;
    var animatorProps;
    var animatorSelector;
    var j;
    var jLen;
    var letterValue;
    jLen = animators.length;
    var mult;
    var ind = -1;
    var offf;
    var xPathPos;
    var yPathPos;
    var initPathPos = currentLength;
    var initSegmentInd = segmentInd;
    var initPointInd = pointInd;
    var currentLine = -1;
    var elemOpacity;
    var sc;
    var sw;
    var fc;
    var k;
    var letterSw;
    var letterSc;
    var letterFc;
    var letterM = '';
    var letterP = this.defaultPropsArray;
    var letterO; //

    if (documentData.j === 2 || documentData.j === 1) {
      var animatorJustifyOffset = 0;
      var animatorFirstCharOffset = 0;
      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
      var lastIndex = 0;
      var isNewLine = true;

      for (i = 0; i < len; i += 1) {
        if (letters[i].n) {
          if (animatorJustifyOffset) {
            animatorJustifyOffset += animatorFirstCharOffset;
          }

          while (lastIndex < i) {
            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
            lastIndex += 1;
          }

          animatorJustifyOffset = 0;
          isNewLine = true;
        } else {
          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;

            if (animatorProps.t.propType) {
              if (isNewLine && documentData.j === 2) {
                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
              }

              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
              } else {
                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
              }
            }
          }

          isNewLine = false;
        }
      }

      if (animatorJustifyOffset) {
        animatorJustifyOffset += animatorFirstCharOffset;
      }

      while (lastIndex < i) {
        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
        lastIndex += 1;
      }
    } //


    for (i = 0; i < len; i += 1) {
      matrixHelper.reset();
      elemOpacity = 1;

      if (letters[i].n) {
        xPos = 0;
        yPos += documentData.yOffset;
        yPos += firstLine ? 1 : 0;
        currentLength = initPathPos;
        firstLine = false;

        if (this._hasMaskedPath) {
          segmentInd = initSegmentInd;
          pointInd = initPointInd;
          points = segments[segmentInd].points;
          prevPoint = points[pointInd - 1];
          currentPoint = points[pointInd];
          partialLength = currentPoint.partialLength;
          segmentLength = 0;
        }

        letterM = '';
        letterFc = '';
        letterSw = '';
        letterO = '';
        letterP = this.defaultPropsArray;
      } else {
        if (this._hasMaskedPath) {
          if (currentLine !== letters[i].line) {
            switch (documentData.j) {
              case 1:
                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                break;

              case 2:
                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                break;

              default:
                break;
            }

            currentLine = letters[i].line;
          }

          if (ind !== letters[i].ind) {
            if (letters[ind]) {
              currentLength += letters[ind].extra;
            }

            currentLength += letters[i].an / 2;
            ind = letters[i].ind;
          }

          currentLength += alignment[0] * letters[i].an * 0.005;
          var animatorOffset = 0;

          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;

            if (animatorProps.p.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorOffset += animatorProps.p.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.p.v[0] * mult;
              }
            }

            if (animatorProps.a.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorOffset += animatorProps.a.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.a.v[0] * mult;
              }
            }
          }

          flag = true; // Force alignment only works with a single line for now

          if (this._pathData.a.v) {
            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
            currentLength += this._pathData.f.v;
          }

          while (flag) {
            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
              flag = false;
            } else if (points) {
              segmentLength += currentPoint.partialLength;
              pointInd += 1;

              if (pointInd >= points.length) {
                pointInd = 0;
                segmentInd += 1;

                if (!segments[segmentInd]) {
                  if (mask.v.c) {
                    pointInd = 0;
                    segmentInd = 0;
                    points = segments[segmentInd].points;
                  } else {
                    segmentLength -= currentPoint.partialLength;
                    points = null;
                  }
                } else {
                  points = segments[segmentInd].points;
                }
              }

              if (points) {
                prevPoint = currentPoint;
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
              }
            }
          }

          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0);
        } else {
          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0); // Grouping alignment

          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.t.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"

            if (xPos !== 0 || documentData.j !== 0) {
              if (this._hasMaskedPath) {
                if (mult.length) {
                  currentLength += animatorProps.t.v * mult[0];
                } else {
                  currentLength += animatorProps.t.v * mult;
                }
              } else if (mult.length) {
                xPos += animatorProps.t.v * mult[0];
              } else {
                xPos += animatorProps.t.v * mult;
              }
            }
          }
        }

        if (documentData.strokeWidthAnim) {
          sw = documentData.sw || 0;
        }

        if (documentData.strokeColorAnim) {
          if (documentData.sc) {
            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
          } else {
            sc = [0, 0, 0];
          }
        }

        if (documentData.fillColorAnim && documentData.fc) {
          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (mult.length) {
              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
            } else {
              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.s.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (mult.length) {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
            } else {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

          if (animatorProps.sk.propType) {
            if (mult.length) {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
            } else {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
            }
          }

          if (animatorProps.r.propType) {
            if (mult.length) {
              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
            } else {
              matrixHelper.rotateZ(-animatorProps.r.v * mult);
            }
          }

          if (animatorProps.ry.propType) {
            if (mult.length) {
              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
            } else {
              matrixHelper.rotateY(animatorProps.ry.v * mult);
            }
          }

          if (animatorProps.rx.propType) {
            if (mult.length) {
              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
            } else {
              matrixHelper.rotateX(animatorProps.rx.v * mult);
            }
          }

          if (animatorProps.o.propType) {
            if (mult.length) {
              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
            } else {
              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
            }
          }

          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
            if (mult.length) {
              sw += animatorProps.sw.v * mult[0];
            } else {
              sw += animatorProps.sw.v * mult;
            }
          }

          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
              } else {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
              }
            }
          }

          if (documentData.fillColorAnim && documentData.fc) {
            if (animatorProps.fc.propType) {
              for (k = 0; k < 3; k += 1) {
                if (mult.length) {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                } else {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                }
              }
            }

            if (animatorProps.fh.propType) {
              if (mult.length) {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
              } else {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
              }
            }

            if (animatorProps.fs.propType) {
              if (mult.length) {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
              } else {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
              }
            }

            if (animatorProps.fb.propType) {
              if (mult.length) {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
              } else {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
              }
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (this._hasMaskedPath) {
              if (mult.length) {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
              } else {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
              }
            } else if (mult.length) {
              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
            } else {
              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          }
        }

        if (documentData.strokeWidthAnim) {
          letterSw = sw < 0 ? 0 : sw;
        }

        if (documentData.strokeColorAnim) {
          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
        }

        if (documentData.fillColorAnim && documentData.fc) {
          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
        }

        if (this._hasMaskedPath) {
          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);

          if (this._pathData.p.v) {
            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
            var rot = Math.atan(tanAngle) * 180 / Math.PI;

            if (currentPoint.point[0] < prevPoint.point[0]) {
              rot += 180;
            }

            matrixHelper.rotate(-rot * Math.PI / 180);
          }

          matrixHelper.translate(xPathPos, yPathPos, 0);
          currentLength -= alignment[0] * letters[i].an * 0.005;

          if (letters[i + 1] && ind !== letters[i + 1].ind) {
            currentLength += letters[i].an / 2;
            currentLength += documentData.tr * 0.001 * documentData.finalSize;
          }
        } else {
          matrixHelper.translate(xPos, yPos, 0);

          if (documentData.ps) {
            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
          }

          switch (documentData.j) {
            case 1:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
              break;

            case 2:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
              break;

            default:
              break;
          }

          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(offf, 0, 0);
          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
        }

        if (renderType === 'html') {
          letterM = matrixHelper.toCSS();
        } else if (renderType === 'svg') {
          letterM = matrixHelper.to2dCSS();
        } else {
          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
        }

        letterO = elemOpacity;
      }

      if (renderedLettersCount <= i) {
        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
        this.renderedLetters.push(letterValue);
        renderedLettersCount += 1;
        this.lettersChangedFlag = true;
      } else {
        letterValue = this.renderedLetters[i];
        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
      }
    }
  };

  TextAnimatorProperty.prototype.getValue = function () {
    if (this._elem.globalData.frameId === this._frameId) {
      return;
    }

    this._frameId = this._elem.globalData.frameId;
    this.iterateDynamicProperties();
  };

  TextAnimatorProperty.prototype.mHelper = new Matrix();
  TextAnimatorProperty.prototype.defaultPropsArray = [];
  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

  function ITextElement() {}

  ITextElement.prototype.initElement = function (data, globalData, comp) {
    this.lettersChangedFlag = true;
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
    this.initRenderable();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();
    this.createContent();
    this.hide();
    this.textAnimator.searchProperties(this.dynamicProperties);
  };

  ITextElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);

    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
      this.buildNewText();
      this.textProperty._isFirstFrame = false;
      this.textProperty._mdf = false;
    }
  };

  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
    var j;
    var jLen = shapes.length;
    var pathNodes;
    var shapeStr = '';

    for (j = 0; j < jLen; j += 1) {
      if (shapes[j].ty === 'sh') {
        pathNodes = shapes[j].ks.k;
        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
      }
    }

    return shapeStr;
  };

  ITextElement.prototype.updateDocumentData = function (newData, index) {
    this.textProperty.updateDocumentData(newData, index);
  };

  ITextElement.prototype.canResizeFont = function (_canResize) {
    this.textProperty.canResizeFont(_canResize);
  };

  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
    this.textProperty.setMinimumFontSize(_fontSize);
  };

  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
    if (documentData.ps) {
      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
    }

    matrixHelper.translate(0, -documentData.ls, 0);

    switch (documentData.j) {
      case 1:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
        break;

      case 2:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
        break;

      default:
        break;
    }

    matrixHelper.translate(xPos, yPos, 0);
  };

  ITextElement.prototype.buildColor = function (colorData) {
    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
  };

  ITextElement.prototype.emptyProp = new LetterProps();

  ITextElement.prototype.destroy = function () {};

  var emptyShapeData = {
    shapes: []
  };

  function SVGTextLottieElement(data, globalData, comp) {
    this.textSpans = [];
    this.renderType = 'svg';
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

  SVGTextLottieElement.prototype.createContent = function () {
    if (this.data.singleShape && !this.globalData.fontManager.chars) {
      this.textContainer = createNS('text');
    }
  };

  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
    var i = 0;
    var len = textArray.length;
    var textContents = [];
    var currentTextContent = '';

    while (i < len) {
      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
        textContents.push(currentTextContent);
        currentTextContent = '';
      } else {
        currentTextContent += textArray[i];
      }

      i += 1;
    }

    textContents.push(currentTextContent);
    return textContents;
  };

  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
    // data should probably be cloned to apply scale separately to each instance of a text on different layers
    // but since text internal content gets only rendered once and then it's never rerendered,
    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
    // Avoiding cloning is preferred since cloning each character shape data is expensive
    if (data.shapes && data.shapes.length) {
      var shape = data.shapes[0];

      if (shape.it) {
        var shapeItem = shape.it[shape.it.length - 1];

        if (shapeItem.s) {
          shapeItem.s.k[0] = scale;
          shapeItem.s.k[1] = scale;
        }
      }
    }

    return data;
  };

  SVGTextLottieElement.prototype.buildNewText = function () {
    this.addDynamicProperty(this);
    var i;
    var len;
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);

    if (documentData.fc) {
      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
    } else {
      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    }

    if (documentData.sc) {
      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
      this.layerElement.setAttribute('stroke-width', documentData.sw);
    }

    this.layerElement.setAttribute('font-size', documentData.finalSize);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

    if (fontData.fClass) {
      this.layerElement.setAttribute('class', fontData.fClass);
    } else {
      this.layerElement.setAttribute('font-family', fontData.fFamily);
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      this.layerElement.setAttribute('font-style', fStyle);
      this.layerElement.setAttribute('font-weight', fWeight);
    }

    this.layerElement.setAttribute('aria-label', documentData.t);
    var letters = documentData.l || [];
    var usesGlyphs = !!this.globalData.fontManager.chars;
    len = letters.length;
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapeStr = '';
    var singleShape = this.data.singleShape;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;

    if (singleShape && !usesGlyphs && !documentData.sz) {
      var tElement = this.textContainer;
      var justify = 'start';

      switch (documentData.j) {
        case 1:
          justify = 'end';
          break;

        case 2:
          justify = 'middle';
          break;

        default:
          justify = 'start';
          break;
      }

      tElement.setAttribute('text-anchor', justify);
      tElement.setAttribute('letter-spacing', trackingOffset);
      var textContent = this.buildTextContents(documentData.finalText);
      len = textContent.length;
      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;

      for (i = 0; i < len; i += 1) {
        tSpan = this.textSpans[i].span || createNS('tspan');
        tSpan.textContent = textContent[i];
        tSpan.setAttribute('x', 0);
        tSpan.setAttribute('y', yPos);
        tSpan.style.display = 'inherit';
        tElement.appendChild(tSpan);

        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            glyph: null
          };
        }

        this.textSpans[i].span = tSpan;
        yPos += documentData.finalLineHeight;
      }

      this.layerElement.appendChild(tElement);
    } else {
      var cachedSpansLength = this.textSpans.length;
      var charData;

      for (i = 0; i < len; i += 1) {
        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            childSpan: null,
            glyph: null
          };
        }

        if (!usesGlyphs || !singleShape || i === 0) {
          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');

          if (cachedSpansLength <= i) {
            tSpan.setAttribute('stroke-linecap', 'butt');
            tSpan.setAttribute('stroke-linejoin', 'round');
            tSpan.setAttribute('stroke-miterlimit', '4');
            this.textSpans[i].span = tSpan;

            if (usesGlyphs) {
              var childSpan = createNS('g');
              tSpan.appendChild(childSpan);
              this.textSpans[i].childSpan = childSpan;
            }

            this.textSpans[i].span = tSpan;
            this.layerElement.appendChild(tSpan);
          }

          tSpan.style.display = 'inherit';
        }

        matrixHelper.reset();

        if (singleShape) {
          if (letters[i].n) {
            xPos = -trackingOffset;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
          }

          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
          xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;

          xPos += trackingOffset;
        }

        if (usesGlyphs) {
          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
          var glyphElement; // t === 1 means the character has been replaced with an animated shaped

          if (charData.t === 1) {
            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
          } else {
            var data = emptyShapeData;

            if (charData.data && charData.data.shapes) {
              data = this.buildShapeData(charData.data, documentData.finalSize);
            }

            glyphElement = new SVGShapeElement(data, this.globalData, this);
          }

          if (this.textSpans[i].glyph) {
            var glyph = this.textSpans[i].glyph;
            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
            glyph.destroy();
          }

          this.textSpans[i].glyph = glyphElement;
          glyphElement._debug = true;
          glyphElement.prepareFrame(0);
          glyphElement.renderFrame();
          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
          // this might have issues with strokes and might need a different solution

          if (charData.t === 1) {
            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
          }
        } else {
          if (singleShape) {
            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
          }

          tSpan.textContent = letters[i].val;
          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        } //

      }

      if (singleShape && tSpan) {
        tSpan.setAttribute('d', shapeStr);
      }
    }

    while (i < this.textSpans.length) {
      this.textSpans[i].span.style.display = 'none';
      i += 1;
    }

    this._sizeChanged = true;
  };

  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
    this.prepareFrame(this.comp.renderedFrame - this.data.st);
    this.renderInnerContent();

    if (this._sizeChanged) {
      this._sizeChanged = false;
      var textBox = this.layerElement.getBBox();
      this.bbox = {
        top: textBox.y,
        left: textBox.x,
        width: textBox.width,
        height: textBox.height
      };
    }

    return this.bbox;
  };

  SVGTextLottieElement.prototype.getValue = function () {
    var i;
    var len = this.textSpans.length;
    var glyphElement;
    this.renderedFrame = this.comp.renderedFrame;

    for (i = 0; i < len; i += 1) {
      glyphElement = this.textSpans[i].glyph;

      if (glyphElement) {
        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);

        if (glyphElement._mdf) {
          this._mdf = true;
        }
      }
    }
  };

  SVGTextLottieElement.prototype.renderInnerContent = function () {
    if (!this.data.singleShape || this._mdf) {
      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
        this._sizeChanged = true;
        var i;
        var len;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var glyphElement;

        for (i = 0; i < len; i += 1) {
          if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            textSpan = this.textSpans[i].span;
            glyphElement = this.textSpans[i].glyph;

            if (glyphElement) {
              glyphElement.renderFrame();
            }

            if (renderedLetter._mdf.m) {
              textSpan.setAttribute('transform', renderedLetter.m);
            }

            if (renderedLetter._mdf.o) {
              textSpan.setAttribute('opacity', renderedLetter.o);
            }

            if (renderedLetter._mdf.sw) {
              textSpan.setAttribute('stroke-width', renderedLetter.sw);
            }

            if (renderedLetter._mdf.sc) {
              textSpan.setAttribute('stroke', renderedLetter.sc);
            }

            if (renderedLetter._mdf.fc) {
              textSpan.setAttribute('fill', renderedLetter.fc);
            }
          }
        }
      }
    }
  };

  function ISolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }

  extendPrototype([IImageElement], ISolidElement);

  ISolidElement.prototype.createContent = function () {
    var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
    /// /rect.style.height = this.data.sh;
    /// /rect.style.fill = this.data.sc;

    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.layerElement.appendChild(rect);
  };

  function NullElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initFrame();
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
  }

  NullElement.prototype.prepareFrame = function (num) {
    this.prepareProperties(num, true);
  };

  NullElement.prototype.renderFrame = function () {};

  NullElement.prototype.getBaseElement = function () {
    return null;
  };

  NullElement.prototype.destroy = function () {};

  NullElement.prototype.sourceRectAtTime = function () {};

  NullElement.prototype.hide = function () {};

  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

  function SVGRendererBase() {}

  extendPrototype([BaseRenderer], SVGRendererBase);

  SVGRendererBase.prototype.createNull = function (data) {
    return new NullElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createShape = function (data) {
    return new SVGShapeElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createText = function (data) {
    return new SVGTextLottieElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createImage = function (data) {
    return new IImageElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createSolid = function (data) {
    return new ISolidElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.configAnimation = function (animData) {
    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    if (this.renderConfig.viewBoxSize) {
      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
    } else {
      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
    }

    if (!this.renderConfig.viewBoxOnly) {
      this.svgElement.setAttribute('width', animData.w);
      this.svgElement.setAttribute('height', animData.h);
      this.svgElement.style.width = '100%';
      this.svgElement.style.height = '100%';
      this.svgElement.style.transform = 'translate3d(0,0,0)';
      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
    }

    if (this.renderConfig.width) {
      this.svgElement.setAttribute('width', this.renderConfig.width);
    }

    if (this.renderConfig.height) {
      this.svgElement.setAttribute('height', this.renderConfig.height);
    }

    if (this.renderConfig.className) {
      this.svgElement.setAttribute('class', this.renderConfig.className);
    }

    if (this.renderConfig.id) {
      this.svgElement.setAttribute('id', this.renderConfig.id);
    }

    if (this.renderConfig.focusable !== undefined) {
      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
    }

    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";

    this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation

    var defs = this.globalData.defs;
    this.setupGlobalData(animData, defs);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.data = animData;
    var maskElement = createNS('clipPath');
    var rect = createNS('rect');
    rect.setAttribute('width', animData.w);
    rect.setAttribute('height', animData.h);
    rect.setAttribute('x', 0);
    rect.setAttribute('y', 0);
    var maskId = createElementID();
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
    defs.appendChild(maskElement);
    this.layers = animData.layers;
    this.elements = createSizedArray(animData.layers.length);
  };

  SVGRendererBase.prototype.destroy = function () {
    if (this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }

    this.layerElement = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }

    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
  };

  SVGRendererBase.prototype.updateContainerSize = function () {};

  SVGRendererBase.prototype.buildItem = function (pos) {
    var elements = this.elements;

    if (elements[pos] || this.layers[pos].ty === 99) {
      return;
    }

    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);
    elements[pos] = element;

    if (getExpressionsPlugin()) {
      if (this.layers[pos].ty === 0) {
        this.globalData.projectInterface.registerComposition(element);
      }

      element.initExpressions();
    }

    this.appendElementInPos(element, pos);

    if (this.layers[pos].tt) {
      if (!this.elements[pos - 1] || this.elements[pos - 1] === true) {
        this.buildItem(pos - 1);
        this.addPendingElement(element);
      } else {
        element.setMatte(elements[pos - 1].layerId);
      }
    }
  };

  SVGRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();

      if (element.data.tt) {
        var i = 0;
        var len = this.elements.length;

        while (i < len) {
          if (this.elements[i] === element) {
            element.setMatte(this.elements[i - 1].layerId);
            break;
          }

          i += 1;
        }
      }
    }
  };

  SVGRendererBase.prototype.renderFrame = function (num) {
    if (this.renderedFrame === num || this.destroyed) {
      return;
    }

    if (num === null) {
      num = this.renderedFrame;
    } else {
      this.renderedFrame = num;
    } // console.log('-------');
    // console.log('FRAME ',num);


    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    this.globalData._mdf = false;
    var i;
    var len = this.layers.length;

    if (!this.completeLayers) {
      this.checkLayers(num);
    }

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(num - this.layers[i].st);
      }
    }

    if (this.globalData._mdf) {
      for (i = 0; i < len; i += 1) {
        if (this.completeLayers || this.elements[i]) {
          this.elements[i].renderFrame();
        }
      }
    }
  };

  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
    var newElement = element.getBaseElement();

    if (!newElement) {
      return;
    }

    var i = 0;
    var nextElement;

    while (i < pos) {
      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
        nextElement = this.elements[i].getBaseElement();
      }

      i += 1;
    }

    if (nextElement) {
      this.layerElement.insertBefore(newElement, nextElement);
    } else {
      this.layerElement.appendChild(newElement);
    }
  };

  SVGRendererBase.prototype.hide = function () {
    this.layerElement.style.display = 'none';
  };

  SVGRendererBase.prototype.show = function () {
    this.layerElement.style.display = 'block';
  };

  function ICompElement() {}

  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

  ICompElement.prototype.initElement = function (data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initTransform(data, globalData, comp);
    this.initRenderable();
    this.initHierarchy();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();

    if (this.data.xt || !globalData.progressiveLoad) {
      this.buildAllItems();
    }

    this.hide();
  };
  /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */


  ICompElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);

    if (!this.isInRange && !this.data.xt) {
      return;
    }

    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;

      if (timeRemapped === this.data.op) {
        timeRemapped = this.data.op - 1;
      }

      this.renderedFrame = timeRemapped;
    } else {
      this.renderedFrame = num / this.data.sr;
    }

    var i;
    var len = this.elements.length;

    if (!this.completeLayers) {
      this.checkLayers(this.renderedFrame);
    } // This iteration needs to be backwards because of how expressions connect between each other


    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);

        if (this.elements[i]._mdf) {
          this._mdf = true;
        }
      }
    }
  };

  ICompElement.prototype.renderInnerContent = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  };

  ICompElement.prototype.setElements = function (elems) {
    this.elements = elems;
  };

  ICompElement.prototype.getElements = function () {
    return this.elements;
  };

  ICompElement.prototype.destroyElements = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }
  };

  ICompElement.prototype.destroy = function () {
    this.destroyElements();
    this.destroyBaseElement();
  };

  function SVGCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }

  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);

  SVGCompElement.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  function SVGRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.svgElement = createNS('svg');
    var ariaLabel = '';

    if (config && config.title) {
      var titleElement = createNS('title');
      var titleId = createElementID();
      titleElement.setAttribute('id', titleId);
      titleElement.textContent = config.title;
      this.svgElement.appendChild(titleElement);
      ariaLabel += titleId;
    }

    if (config && config.description) {
      var descElement = createNS('desc');
      var descId = createElementID();
      descElement.setAttribute('id', descId);
      descElement.textContent = config.description;
      this.svgElement.appendChild(descElement);
      ariaLabel += ' ' + descId;
    }

    if (ariaLabel) {
      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
    }

    var defs = createNS('defs');
    this.svgElement.appendChild(defs);
    var maskElement = createNS('g');
    this.svgElement.appendChild(maskElement);
    this.layerElement = maskElement;
    this.renderConfig = {
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      progressiveLoad: config && config.progressiveLoad || false,
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      viewBoxOnly: config && config.viewBoxOnly || false,
      viewBoxSize: config && config.viewBoxSize || false,
      className: config && config.className || '',
      id: config && config.id || '',
      focusable: config && config.focusable,
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '100%',
        height: config && config.filterSize && config.filterSize.height || '100%',
        x: config && config.filterSize && config.filterSize.x || '0%',
        y: config && config.filterSize && config.filterSize.y || '0%'
      },
      width: config && config.width,
      height: config && config.height
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      defs: defs,
      renderConfig: this.renderConfig
    };
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;
    this.rendererType = 'svg';
  }

  extendPrototype([SVGRendererBase], SVGRenderer);

  SVGRenderer.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  function CVContextData() {
    this.saved = [];
    this.cArrPos = 0;
    this.cTr = new Matrix();
    this.cO = 1;
    var i;
    var len = 15;
    this.savedOp = createTypedArray('float32', len);

    for (i = 0; i < len; i += 1) {
      this.saved[i] = createTypedArray('float32', 16);
    }

    this._length = len;
  }

  CVContextData.prototype.duplicate = function () {
    var newLength = this._length * 2;
    var currentSavedOp = this.savedOp;
    this.savedOp = createTypedArray('float32', newLength);
    this.savedOp.set(currentSavedOp);
    var i = 0;

    for (i = this._length; i < newLength; i += 1) {
      this.saved[i] = createTypedArray('float32', 16);
    }

    this._length = newLength;
  };

  CVContextData.prototype.reset = function () {
    this.cArrPos = 0;
    this.cTr.reset();
    this.cO = 1;
  };

  function ShapeTransformManager() {
    this.sequences = {};
    this.sequenceList = [];
    this.transform_key_count = 0;
  }

  ShapeTransformManager.prototype = {
    addTransformSequence: function addTransformSequence(transforms) {
      var i;
      var len = transforms.length;
      var key = '_';

      for (i = 0; i < len; i += 1) {
        key += transforms[i].transform.key + '_';
      }

      var sequence = this.sequences[key];

      if (!sequence) {
        sequence = {
          transforms: [].concat(transforms),
          finalTransform: new Matrix(),
          _mdf: false
        };
        this.sequences[key] = sequence;
        this.sequenceList.push(sequence);
      }

      return sequence;
    },
    processSequence: function processSequence(sequence, isFirstFrame) {
      var i = 0;
      var len = sequence.transforms.length;
      var _mdf = isFirstFrame;

      while (i < len && !isFirstFrame) {
        if (sequence.transforms[i].transform.mProps._mdf) {
          _mdf = true;
          break;
        }

        i += 1;
      }

      if (_mdf) {
        var props;
        sequence.finalTransform.reset();

        for (i = len - 1; i >= 0; i -= 1) {
          props = sequence.transforms[i].transform.mProps.v.props;
          sequence.finalTransform.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
        }
      }

      sequence._mdf = _mdf;
    },
    processSequences: function processSequences(isFirstFrame) {
      var i;
      var len = this.sequenceList.length;

      for (i = 0; i < len; i += 1) {
        this.processSequence(this.sequenceList[i], isFirstFrame);
      }
    },
    getNewKey: function getNewKey() {
      this.transform_key_count += 1;
      return '_' + this.transform_key_count;
    }
  };

  function CVEffects() {}

  CVEffects.prototype.renderFrame = function () {};

  function CVMaskElement(data, element) {
    this.data = data;
    this.element = element;
    this.masksProperties = this.data.masksProperties || [];
    this.viewData = createSizedArray(this.masksProperties.length);
    var i;
    var len = this.masksProperties.length;
    var hasMasks = false;

    for (i = 0; i < len; i += 1) {
      if (this.masksProperties[i].mode !== 'n') {
        hasMasks = true;
      }

      this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
    }

    this.hasMasks = hasMasks;

    if (hasMasks) {
      this.element.addRenderableComponent(this);
    }
  }

  CVMaskElement.prototype.renderFrame = function () {
    if (!this.hasMasks) {
      return;
    }

    var transform = this.element.finalTransform.mat;
    var ctx = this.element.canvasContext;
    var i;
    var len = this.masksProperties.length;
    var pt;
    var pts;
    var data;
    ctx.beginPath();

    for (i = 0; i < len; i += 1) {
      if (this.masksProperties[i].mode !== 'n') {
        if (this.masksProperties[i].inv) {
          ctx.moveTo(0, 0);
          ctx.lineTo(this.element.globalData.compSize.w, 0);
          ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
          ctx.lineTo(0, this.element.globalData.compSize.h);
          ctx.lineTo(0, 0);
        }

        data = this.viewData[i].v;
        pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
        ctx.moveTo(pt[0], pt[1]);
        var j;
        var jLen = data._length;

        for (j = 1; j < jLen; j += 1) {
          pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
          ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }

        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
      }
    }

    this.element.globalData.renderer.save(true);
    ctx.clip();
  };

  CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

  CVMaskElement.prototype.destroy = function () {
    this.element = null;
  };

  function CVBaseElement() {}

  CVBaseElement.prototype = {
    createElements: function createElements() {},
    initRendererElement: function initRendererElement() {},
    createContainerElements: function createContainerElements() {
      this.canvasContext = this.globalData.canvasContext;
      this.renderableEffectsManager = new CVEffects(this);
    },
    createContent: function createContent() {},
    setBlendMode: function setBlendMode() {
      var globalData = this.globalData;

      if (globalData.blendMode !== this.data.bm) {
        globalData.blendMode = this.data.bm;
        var blendModeValue = getBlendMode(this.data.bm);
        globalData.canvasContext.globalCompositeOperation = blendModeValue;
      }
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new CVMaskElement(this.data, this);
    },
    hideElement: function hideElement() {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        this.hidden = true;
      }
    },
    showElement: function showElement() {
      if (this.isInRange && !this.isTransparent) {
        this.hidden = false;
        this._isFirstFrame = true;
        this.maskManager._isFirstFrame = true;
      }
    },
    renderFrame: function renderFrame() {
      if (this.hidden || this.data.hd) {
        return;
      }

      this.renderTransform();
      this.renderRenderable();
      this.setBlendMode();
      var forceRealStack = this.data.ty === 0;
      this.globalData.renderer.save(forceRealStack);
      this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
      this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
      this.renderInnerContent();
      this.globalData.renderer.restore(forceRealStack);

      if (this.maskManager.hasMasks) {
        this.globalData.renderer.restore(true);
      }

      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    destroy: function destroy() {
      this.canvasContext = null;
      this.data = null;
      this.globalData = null;
      this.maskManager.destroy();
    },
    mHelper: new Matrix()
  };
  CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
  CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

  function CVShapeData(element, data, styles, transformsManager) {
    this.styledShapes = [];
    this.tr = [0, 0, 0, 0, 0, 0];
    var ty = 4;

    if (data.ty === 'rc') {
      ty = 5;
    } else if (data.ty === 'el') {
      ty = 6;
    } else if (data.ty === 'sr') {
      ty = 7;
    }

    this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
    var i;
    var len = styles.length;
    var styledShape;

    for (i = 0; i < len; i += 1) {
      if (!styles[i].closed) {
        styledShape = {
          transforms: transformsManager.addTransformSequence(styles[i].transforms),
          trNodes: []
        };
        this.styledShapes.push(styledShape);
        styles[i].elements.push(styledShape);
      }
    }
  }

  CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

  function CVShapeElement(data, globalData, comp) {
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.itemsData = [];
    this.prevViewData = [];
    this.shapeModifiers = [];
    this.processedElements = [];
    this.transformsManager = new ShapeTransformManager();
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
  CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
  CVShapeElement.prototype.transformHelper = {
    opacity: 1,
    _opMdf: false
  };
  CVShapeElement.prototype.dashResetter = [];

  CVShapeElement.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
  };

  CVShapeElement.prototype.createStyleElement = function (data, transforms) {
    var styleElem = {
      data: data,
      type: data.ty,
      preTransforms: this.transformsManager.addTransformSequence(transforms),
      transforms: [],
      elements: [],
      closed: data.hd === true
    };
    var elementData = {};

    if (data.ty === 'fl' || data.ty === 'st') {
      elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);

      if (!elementData.c.k) {
        styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
      }
    } else if (data.ty === 'gf' || data.ty === 'gs') {
      elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
      elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
      elementData.h = PropertyFactory.getProp(this, data.h || {
        k: 0
      }, 0, 0.01, this);
      elementData.a = PropertyFactory.getProp(this, data.a || {
        k: 0
      }, 0, degToRads, this);
      elementData.g = new GradientProperty(this, data.g, this);
    }

    elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);

    if (data.ty === 'st' || data.ty === 'gs') {
      styleElem.lc = lineCapEnum[data.lc || 2];
      styleElem.lj = lineJoinEnum[data.lj || 2];

      if (data.lj == 1) {
        // eslint-disable-line eqeqeq
        styleElem.ml = data.ml;
      }

      elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);

      if (!elementData.w.k) {
        styleElem.wi = elementData.w.v;
      }

      if (data.d) {
        var d = new DashProperty(this, data.d, 'canvas', this);
        elementData.d = d;

        if (!elementData.d.k) {
          styleElem.da = elementData.d.dashArray;
          styleElem["do"] = elementData.d.dashoffset[0];
        }
      }
    } else {
      styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
    }

    this.stylesList.push(styleElem);
    elementData.style = styleElem;
    return elementData;
  };

  CVShapeElement.prototype.createGroupElement = function () {
    var elementData = {
      it: [],
      prevViewData: []
    };
    return elementData;
  };

  CVShapeElement.prototype.createTransformElement = function (data) {
    var elementData = {
      transform: {
        opacity: 1,
        _opMdf: false,
        key: this.transformsManager.getNewKey(),
        op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
        mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
      }
    };
    return elementData;
  };

  CVShapeElement.prototype.createShapeElement = function (data) {
    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    return elementData;
  };

  CVShapeElement.prototype.reloadShapes = function () {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;

    for (i = 0; i < len; i += 1) {
      this.prevViewData[i] = this.itemsData[i];
    }

    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    len = this.dynamicProperties.length;

    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
    }

    this.renderModifiers();
    this.transformsManager.processSequences(this._isFirstFrame);
  };

  CVShapeElement.prototype.addTransformToStyleList = function (transform) {
    var i;
    var len = this.stylesList.length;

    for (i = 0; i < len; i += 1) {
      if (!this.stylesList[i].closed) {
        this.stylesList[i].transforms.push(transform);
      }
    }
  };

  CVShapeElement.prototype.removeTransformFromStyleList = function () {
    var i;
    var len = this.stylesList.length;

    for (i = 0; i < len; i += 1) {
      if (!this.stylesList[i].closed) {
        this.stylesList[i].transforms.pop();
      }
    }
  };

  CVShapeElement.prototype.closeStyles = function (styles) {
    var i;
    var len = styles.length;

    for (i = 0; i < len; i += 1) {
      styles[i].closed = true;
    }
  };

  CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var processedPos;
    var modifier;
    var currentTransform;
    var ownTransforms = [].concat(transforms);

    for (i = len; i >= 0; i -= 1) {
      processedPos = this.searchProcessedElement(arr[i]);

      if (!processedPos) {
        arr[i]._shouldRender = shouldRender;
      } else {
        itemsData[i] = prevViewData[processedPos - 1];
      }

      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
        if (!processedPos) {
          itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
        } else {
          itemsData[i].style.closed = false;
        }

        ownStyles.push(itemsData[i].style);
      } else if (arr[i].ty === 'gr') {
        if (!processedPos) {
          itemsData[i] = this.createGroupElement(arr[i]);
        } else {
          jLen = itemsData[i].it.length;

          for (j = 0; j < jLen; j += 1) {
            itemsData[i].prevViewData[j] = itemsData[i].it[j];
          }
        }

        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
      } else if (arr[i].ty === 'tr') {
        if (!processedPos) {
          currentTransform = this.createTransformElement(arr[i]);
          itemsData[i] = currentTransform;
        }

        ownTransforms.push(itemsData[i]);
        this.addTransformToStyleList(itemsData[i]);
      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
        if (!processedPos) {
          itemsData[i] = this.createShapeElement(arr[i]);
        }
      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          modifier.init(this, arr[i]);
          itemsData[i] = modifier;
          this.shapeModifiers.push(modifier);
        } else {
          modifier = itemsData[i];
          modifier.closed = false;
        }

        ownModifiers.push(modifier);
      } else if (arr[i].ty === 'rp') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          itemsData[i] = modifier;
          modifier.init(this, arr, i, itemsData);
          this.shapeModifiers.push(modifier);
          shouldRender = false;
        } else {
          modifier = itemsData[i];
          modifier.closed = true;
        }

        ownModifiers.push(modifier);
      }

      this.addProcessedElement(arr[i], i + 1);
    }

    this.removeTransformFromStyleList();
    this.closeStyles(ownStyles);
    len = ownModifiers.length;

    for (i = 0; i < len; i += 1) {
      ownModifiers[i].closed = true;
    }
  };

  CVShapeElement.prototype.renderInnerContent = function () {
    this.transformHelper.opacity = 1;
    this.transformHelper._opMdf = false;
    this.renderModifiers();
    this.transformsManager.processSequences(this._isFirstFrame);
    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
  };

  CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
    if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
      groupTransform.opacity = parentTransform.opacity;
      groupTransform.opacity *= groupTransform.op.v;
      groupTransform._opMdf = true;
    }
  };

  CVShapeElement.prototype.drawLayer = function () {
    var i;
    var len = this.stylesList.length;
    var j;
    var jLen;
    var k;
    var kLen;
    var elems;
    var nodes;
    var renderer = this.globalData.renderer;
    var ctx = this.globalData.canvasContext;
    var type;
    var currentStyle;

    for (i = 0; i < len; i += 1) {
      currentStyle = this.stylesList[i];
      type = currentStyle.type; // Skipping style when
      // Stroke width equals 0
      // style should not be rendered (extra unused repeaters)
      // current opacity equals 0
      // global opacity equals 0

      if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
        renderer.save();
        elems = currentStyle.elements;

        if (type === 'st' || type === 'gs') {
          ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
          ctx.lineWidth = currentStyle.wi;
          ctx.lineCap = currentStyle.lc;
          ctx.lineJoin = currentStyle.lj;
          ctx.miterLimit = currentStyle.ml || 0;
        } else {
          ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
        }

        renderer.ctxOpacity(currentStyle.coOp);

        if (type !== 'st' && type !== 'gs') {
          ctx.beginPath();
        }

        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
        jLen = elems.length;

        for (j = 0; j < jLen; j += 1) {
          if (type === 'st' || type === 'gs') {
            ctx.beginPath();

            if (currentStyle.da) {
              ctx.setLineDash(currentStyle.da);
              ctx.lineDashOffset = currentStyle["do"];
            }
          }

          nodes = elems[j].trNodes;
          kLen = nodes.length;

          for (k = 0; k < kLen; k += 1) {
            if (nodes[k].t === 'm') {
              ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
            } else if (nodes[k].t === 'c') {
              ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
            } else {
              ctx.closePath();
            }
          }

          if (type === 'st' || type === 'gs') {
            ctx.stroke();

            if (currentStyle.da) {
              ctx.setLineDash(this.dashResetter);
            }
          }
        }

        if (type !== 'st' && type !== 'gs') {
          ctx.fill(currentStyle.r);
        }

        renderer.restore();
      }
    }
  };

  CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
    var i;
    var len = items.length - 1;
    var groupTransform;
    groupTransform = parentTransform;

    for (i = len; i >= 0; i -= 1) {
      if (items[i].ty === 'tr') {
        groupTransform = data[i].transform;
        this.renderShapeTransform(parentTransform, groupTransform);
      } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
        this.renderPath(items[i], data[i]);
      } else if (items[i].ty === 'fl') {
        this.renderFill(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'st') {
        this.renderStroke(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
        this.renderGradientFill(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'gr') {
        this.renderShape(groupTransform, items[i].it, data[i].it);
      } else if (items[i].ty === 'tm') {//
      }
    }

    if (isMain) {
      this.drawLayer();
    }
  };

  CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
    if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
      var shapeNodes = styledShape.trNodes;
      var paths = shape.paths;
      var i;
      var len;
      var j;
      var jLen = paths._length;
      shapeNodes.length = 0;
      var groupTransformMat = styledShape.transforms.finalTransform;

      for (j = 0; j < jLen; j += 1) {
        var pathNodes = paths.shapes[j];

        if (pathNodes && pathNodes.v) {
          len = pathNodes._length;

          for (i = 1; i < len; i += 1) {
            if (i === 1) {
              shapeNodes.push({
                t: 'm',
                p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
              });
            }

            shapeNodes.push({
              t: 'c',
              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
            });
          }

          if (len === 1) {
            shapeNodes.push({
              t: 'm',
              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
            });
          }

          if (pathNodes.c && len) {
            shapeNodes.push({
              t: 'c',
              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
            });
            shapeNodes.push({
              t: 'z'
            });
          }
        }
      }

      styledShape.trNodes = shapeNodes;
    }
  };

  CVShapeElement.prototype.renderPath = function (pathData, itemData) {
    if (pathData.hd !== true && pathData._shouldRender) {
      var i;
      var len = itemData.styledShapes.length;

      for (i = 0; i < len; i += 1) {
        this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
      }
    }
  };

  CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;

    if (itemData.c._mdf || this._isFirstFrame) {
      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
    }

    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
      styleElem.coOp = itemData.o.v * groupTransform.opacity;
    }
  };

  CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;
    var grd;

    if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
      var ctx = this.globalData.canvasContext;
      var pt1 = itemData.s.v;
      var pt2 = itemData.e.v;

      if (styleData.t === 1) {
        grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
      } else {
        var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
        var percent = itemData.h.v;

        if (percent >= 1) {
          percent = 0.99;
        } else if (percent <= -1) {
          percent = -0.99;
        }

        var dist = rad * percent;
        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
        grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
      }

      var i;
      var len = styleData.g.p;
      var cValues = itemData.g.c;
      var opacity = 1;

      for (i = 0; i < len; i += 1) {
        if (itemData.g._hasOpacity && itemData.g._collapsable) {
          opacity = itemData.g.o[i * 2 + 1];
        }

        grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
      }

      styleElem.grd = grd;
    }

    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  };

  CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;
    var d = itemData.d;

    if (d && (d._mdf || this._isFirstFrame)) {
      styleElem.da = d.dashArray;
      styleElem["do"] = d.dashoffset[0];
    }

    if (itemData.c._mdf || this._isFirstFrame) {
      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
    }

    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
      styleElem.coOp = itemData.o.v * groupTransform.opacity;
    }

    if (itemData.w._mdf || this._isFirstFrame) {
      styleElem.wi = itemData.w.v;
    }
  };

  CVShapeElement.prototype.destroy = function () {
    this.shapesData = null;
    this.globalData = null;
    this.canvasContext = null;
    this.stylesList.length = 0;
    this.itemsData.length = 0;
  };

  function CVTextElement(data, globalData, comp) {
    this.textSpans = [];
    this.yOffset = 0;
    this.fillColorAnim = false;
    this.strokeColorAnim = false;
    this.strokeWidthAnim = false;
    this.stroke = false;
    this.fill = false;
    this.justifyOffset = 0;
    this.currentRender = null;
    this.renderType = 'canvas';
    this.values = {
      fill: 'rgba(0,0,0,0)',
      stroke: 'rgba(0,0,0,0)',
      sWidth: 0,
      fValue: ''
    };
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
  CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

  CVTextElement.prototype.buildNewText = function () {
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
    var hasFill = false;

    if (documentData.fc) {
      hasFill = true;
      this.values.fill = this.buildColor(documentData.fc);
    } else {
      this.values.fill = 'rgba(0,0,0,0)';
    }

    this.fill = hasFill;
    var hasStroke = false;

    if (documentData.sc) {
      hasStroke = true;
      this.values.stroke = this.buildColor(documentData.sc);
      this.values.sWidth = documentData.sw;
    }

    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    var i;
    var len;
    var letters = documentData.l;
    var matrixHelper = this.mHelper;
    this.stroke = hasStroke;
    this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
    len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;

    var charData;
    var shapeData;
    var k;
    var kLen;
    var shapes;
    var j;
    var jLen;
    var pathNodes;
    var commands;
    var pathArr;
    var singleShape = this.data.singleShape;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var cnt = 0;

    for (i = 0; i < len; i += 1) {
      charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
      shapeData = charData && charData.data || {};
      matrixHelper.reset();

      if (singleShape && letters[i].n) {
        xPos = -trackingOffset;
        yPos += documentData.yOffset;
        yPos += firstLine ? 1 : 0;
        firstLine = false;
      }

      shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
      jLen = shapes.length;
      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);

      if (singleShape) {
        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
      }

      commands = createSizedArray(jLen - 1);
      var commandsCounter = 0;

      for (j = 0; j < jLen; j += 1) {
        if (shapes[j].ty === 'sh') {
          kLen = shapes[j].ks.k.i.length;
          pathNodes = shapes[j].ks.k;
          pathArr = [];

          for (k = 1; k < kLen; k += 1) {
            if (k === 1) {
              pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
            }

            pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
          }

          pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
          commands[commandsCounter] = pathArr;
          commandsCounter += 1;
        }
      }

      if (singleShape) {
        xPos += letters[i].l;
        xPos += trackingOffset;
      }

      if (this.textSpans[cnt]) {
        this.textSpans[cnt].elem = commands;
      } else {
        this.textSpans[cnt] = {
          elem: commands
        };
      }

      cnt += 1;
    }
  };

  CVTextElement.prototype.renderInnerContent = function () {
    var ctx = this.canvasContext;
    ctx.font = this.values.fValue;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 4;

    if (!this.data.singleShape) {
      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    }

    var i;
    var len;
    var j;
    var jLen;
    var k;
    var kLen;
    var renderedLetters = this.textAnimator.renderedLetters;
    var letters = this.textProperty.currentData.l;
    len = letters.length;
    var renderedLetter;
    var lastFill = null;
    var lastStroke = null;
    var lastStrokeW = null;
    var commands;
    var pathArr;

    for (i = 0; i < len; i += 1) {
      if (!letters[i].n) {
        renderedLetter = renderedLetters[i];

        if (renderedLetter) {
          this.globalData.renderer.save();
          this.globalData.renderer.ctxTransform(renderedLetter.p);
          this.globalData.renderer.ctxOpacity(renderedLetter.o);
        }

        if (this.fill) {
          if (renderedLetter && renderedLetter.fc) {
            if (lastFill !== renderedLetter.fc) {
              lastFill = renderedLetter.fc;
              ctx.fillStyle = renderedLetter.fc;
            }
          } else if (lastFill !== this.values.fill) {
            lastFill = this.values.fill;
            ctx.fillStyle = this.values.fill;
          }

          commands = this.textSpans[i].elem;
          jLen = commands.length;
          this.globalData.canvasContext.beginPath();

          for (j = 0; j < jLen; j += 1) {
            pathArr = commands[j];
            kLen = pathArr.length;
            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

            for (k = 2; k < kLen; k += 6) {
              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
            }
          }

          this.globalData.canvasContext.closePath();
          this.globalData.canvasContext.fill(); /// ctx.fillText(this.textSpans[i].val,0,0);
        }

        if (this.stroke) {
          if (renderedLetter && renderedLetter.sw) {
            if (lastStrokeW !== renderedLetter.sw) {
              lastStrokeW = renderedLetter.sw;
              ctx.lineWidth = renderedLetter.sw;
            }
          } else if (lastStrokeW !== this.values.sWidth) {
            lastStrokeW = this.values.sWidth;
            ctx.lineWidth = this.values.sWidth;
          }

          if (renderedLetter && renderedLetter.sc) {
            if (lastStroke !== renderedLetter.sc) {
              lastStroke = renderedLetter.sc;
              ctx.strokeStyle = renderedLetter.sc;
            }
          } else if (lastStroke !== this.values.stroke) {
            lastStroke = this.values.stroke;
            ctx.strokeStyle = this.values.stroke;
          }

          commands = this.textSpans[i].elem;
          jLen = commands.length;
          this.globalData.canvasContext.beginPath();

          for (j = 0; j < jLen; j += 1) {
            pathArr = commands[j];
            kLen = pathArr.length;
            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

            for (k = 2; k < kLen; k += 6) {
              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
            }
          }

          this.globalData.canvasContext.closePath();
          this.globalData.canvasContext.stroke(); /// ctx.strokeText(letters[i].val,0,0);
        }

        if (renderedLetter) {
          this.globalData.renderer.restore();
        }
      }
    }
  };

  function CVImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    this.img = globalData.imageLoader.getAsset(this.assetData);
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
  CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
  CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

  CVImageElement.prototype.createContent = function () {
    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
      var canvas = createTag('canvas');
      canvas.width = this.assetData.w;
      canvas.height = this.assetData.h;
      var ctx = canvas.getContext('2d');
      var imgW = this.img.width;
      var imgH = this.img.height;
      var imgRel = imgW / imgH;
      var canvasRel = this.assetData.w / this.assetData.h;
      var widthCrop;
      var heightCrop;
      var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;

      if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
        heightCrop = imgH;
        widthCrop = heightCrop * canvasRel;
      } else {
        widthCrop = imgW;
        heightCrop = widthCrop / canvasRel;
      }

      ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
      this.img = canvas;
    }
  };

  CVImageElement.prototype.renderInnerContent = function () {
    this.canvasContext.drawImage(this.img, 0, 0);
  };

  CVImageElement.prototype.destroy = function () {
    this.img = null;
  };

  function CVSolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
  CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
  CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

  CVSolidElement.prototype.renderInnerContent = function () {
    var ctx = this.canvasContext;
    ctx.fillStyle = this.data.sc;
    ctx.fillRect(0, 0, this.data.sw, this.data.sh); //
  };

  function CanvasRendererBase(animationItem, config) {
    this.animationItem = animationItem;
    this.renderConfig = {
      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
      context: config && config.context || null,
      progressiveLoad: config && config.progressiveLoad || false,
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      className: config && config.className || '',
      id: config && config.id || ''
    };
    this.renderConfig.dpr = config && config.dpr || 1;

    if (this.animationItem.wrapper) {
      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
    }

    this.renderedFrame = -1;
    this.globalData = {
      frameNum: -1,
      _mdf: false,
      renderConfig: this.renderConfig,
      currentGlobalAlpha: -1
    };
    this.contextData = new CVContextData();
    this.elements = [];
    this.pendingElements = [];
    this.transformMat = new Matrix();
    this.completeLayers = false;
    this.rendererType = 'canvas';
  }

  extendPrototype([BaseRenderer], CanvasRendererBase);

  CanvasRendererBase.prototype.createShape = function (data) {
    return new CVShapeElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createText = function (data) {
    return new CVTextElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createImage = function (data) {
    return new CVImageElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createSolid = function (data) {
    return new CVSolidElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

  CanvasRendererBase.prototype.ctxTransform = function (props) {
    if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
      return;
    }

    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
      return;
    }

    this.transformMat.cloneFromProps(props);
    var cProps = this.contextData.cTr.props;
    this.transformMat.transform(cProps[0], cProps[1], cProps[2], cProps[3], cProps[4], cProps[5], cProps[6], cProps[7], cProps[8], cProps[9], cProps[10], cProps[11], cProps[12], cProps[13], cProps[14], cProps[15]); // this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);

    this.contextData.cTr.cloneFromProps(this.transformMat.props);
    var trProps = this.contextData.cTr.props;
    this.canvasContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
  };

  CanvasRendererBase.prototype.ctxOpacity = function (op) {
    /* if(op === 1){
          return;
      } */
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
      this.globalData.currentGlobalAlpha = this.contextData.cO;
      return;
    }

    this.contextData.cO *= op < 0 ? 0 : op;

    if (this.globalData.currentGlobalAlpha !== this.contextData.cO) {
      this.canvasContext.globalAlpha = this.contextData.cO;
      this.globalData.currentGlobalAlpha = this.contextData.cO;
    }
  };

  CanvasRendererBase.prototype.reset = function () {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.restore();
      return;
    }

    this.contextData.reset();
  };

  CanvasRendererBase.prototype.save = function (actionFlag) {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.save();
      return;
    }

    if (actionFlag) {
      this.canvasContext.save();
    }

    var props = this.contextData.cTr.props;

    if (this.contextData._length <= this.contextData.cArrPos) {
      this.contextData.duplicate();
    }

    var i;
    var arr = this.contextData.saved[this.contextData.cArrPos];

    for (i = 0; i < 16; i += 1) {
      arr[i] = props[i];
    }

    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
    this.contextData.cArrPos += 1;
  };

  CanvasRendererBase.prototype.restore = function (actionFlag) {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.restore();
      return;
    }

    if (actionFlag) {
      this.canvasContext.restore();
      this.globalData.blendMode = 'source-over';
    }

    this.contextData.cArrPos -= 1;
    var popped = this.contextData.saved[this.contextData.cArrPos];
    var i;
    var arr = this.contextData.cTr.props;

    for (i = 0; i < 16; i += 1) {
      arr[i] = popped[i];
    }

    this.canvasContext.setTransform(popped[0], popped[1], popped[4], popped[5], popped[12], popped[13]);
    popped = this.contextData.savedOp[this.contextData.cArrPos];
    this.contextData.cO = popped;

    if (this.globalData.currentGlobalAlpha !== popped) {
      this.canvasContext.globalAlpha = popped;
      this.globalData.currentGlobalAlpha = popped;
    }
  };

  CanvasRendererBase.prototype.configAnimation = function (animData) {
    if (this.animationItem.wrapper) {
      this.animationItem.container = createTag('canvas');
      var containerStyle = this.animationItem.container.style;
      containerStyle.width = '100%';
      containerStyle.height = '100%';
      var origin = '0px 0px 0px';
      containerStyle.transformOrigin = origin;
      containerStyle.mozTransformOrigin = origin;
      containerStyle.webkitTransformOrigin = origin;
      containerStyle['-webkit-transform'] = origin;
      containerStyle.contentVisibility = this.renderConfig.contentVisibility;
      this.animationItem.wrapper.appendChild(this.animationItem.container);
      this.canvasContext = this.animationItem.container.getContext('2d');

      if (this.renderConfig.className) {
        this.animationItem.container.setAttribute('class', this.renderConfig.className);
      }

      if (this.renderConfig.id) {
        this.animationItem.container.setAttribute('id', this.renderConfig.id);
      }
    } else {
      this.canvasContext = this.renderConfig.context;
    }

    this.data = animData;
    this.layers = animData.layers;
    this.transformCanvas = {
      w: animData.w,
      h: animData.h,
      sx: 0,
      sy: 0,
      tx: 0,
      ty: 0
    };
    this.setupGlobalData(animData, document.body);
    this.globalData.canvasContext = this.canvasContext;
    this.globalData.renderer = this;
    this.globalData.isDashed = false;
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.globalData.transformCanvas = this.transformCanvas;
    this.elements = createSizedArray(animData.layers.length);
    this.updateContainerSize();
  };

  CanvasRendererBase.prototype.updateContainerSize = function () {
    this.reset();
    var elementWidth;
    var elementHeight;

    if (this.animationItem.wrapper && this.animationItem.container) {
      elementWidth = this.animationItem.wrapper.offsetWidth;
      elementHeight = this.animationItem.wrapper.offsetHeight;
      this.animationItem.container.setAttribute('width', elementWidth * this.renderConfig.dpr);
      this.animationItem.container.setAttribute('height', elementHeight * this.renderConfig.dpr);
    } else {
      elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
      elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
    }

    var elementRel;
    var animationRel;

    if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
      var par = this.renderConfig.preserveAspectRatio.split(' ');
      var fillType = par[1] || 'meet';
      var pos = par[0] || 'xMidYMid';
      var xPos = pos.substr(0, 4);
      var yPos = pos.substr(4);
      elementRel = elementWidth / elementHeight;
      animationRel = this.transformCanvas.w / this.transformCanvas.h;

      if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
        this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
        this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      } else {
        this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
        this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      }

      if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
      } else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
      } else {
        this.transformCanvas.tx = 0;
      }

      if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
      } else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
      } else {
        this.transformCanvas.ty = 0;
      }
    } else if (this.renderConfig.preserveAspectRatio === 'none') {
      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      this.transformCanvas.tx = 0;
      this.transformCanvas.ty = 0;
    } else {
      this.transformCanvas.sx = this.renderConfig.dpr;
      this.transformCanvas.sy = this.renderConfig.dpr;
      this.transformCanvas.tx = 0;
      this.transformCanvas.ty = 0;
    }

    this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
    /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */

    this.ctxTransform(this.transformCanvas.props);
    this.canvasContext.beginPath();
    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
    this.canvasContext.closePath();
    this.canvasContext.clip();
    this.renderFrame(this.renderedFrame, true);
  };

  CanvasRendererBase.prototype.destroy = function () {
    if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }

    var i;
    var len = this.layers ? this.layers.length : 0;

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }

    this.elements.length = 0;
    this.globalData.canvasContext = null;
    this.animationItem.container = null;
    this.destroyed = true;
  };

  CanvasRendererBase.prototype.renderFrame = function (num, forceRender) {
    if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
      return;
    }

    this.renderedFrame = num;
    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
    this.globalData.frameId += 1;
    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
    this.globalData.projectInterface.currentFrame = num; // console.log('--------');
    // console.log('NEW: ',num);

    var i;
    var len = this.layers.length;

    if (!this.completeLayers) {
      this.checkLayers(num);
    }

    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(num - this.layers[i].st);
      }
    }

    if (this.globalData._mdf) {
      if (this.renderConfig.clearCanvas === true) {
        this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
      } else {
        this.save();
      }

      for (i = len - 1; i >= 0; i -= 1) {
        if (this.completeLayers || this.elements[i]) {
          this.elements[i].renderFrame();
        }
      }

      if (this.renderConfig.clearCanvas !== true) {
        this.restore();
      }
    }
  };

  CanvasRendererBase.prototype.buildItem = function (pos) {
    var elements = this.elements;

    if (elements[pos] || this.layers[pos].ty === 99) {
      return;
    }

    var element = this.createItem(this.layers[pos], this, this.globalData);
    elements[pos] = element;
    element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */
  };

  CanvasRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();
    }
  };

  CanvasRendererBase.prototype.hide = function () {
    this.animationItem.container.style.display = 'none';
  };

  CanvasRendererBase.prototype.show = function () {
    this.animationItem.container.style.display = 'block';
  };

  function CVCompElement(data, globalData, comp) {
    this.completeLayers = false;
    this.layers = data.layers;
    this.pendingElements = [];
    this.elements = createSizedArray(this.layers.length);
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }

  extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);

  CVCompElement.prototype.renderInnerContent = function () {
    var ctx = this.canvasContext;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(this.data.w, 0);
    ctx.lineTo(this.data.w, this.data.h);
    ctx.lineTo(0, this.data.h);
    ctx.lineTo(0, 0);
    ctx.clip();
    var i;
    var len = this.layers.length;

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  };

  CVCompElement.prototype.destroy = function () {
    var i;
    var len = this.layers.length;

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }

    this.layers = null;
    this.elements = null;
  };

  CVCompElement.prototype.createComp = function (data) {
    return new CVCompElement(data, this.globalData, this);
  };

  function CanvasRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.renderConfig = {
      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
      context: config && config.context || null,
      progressiveLoad: config && config.progressiveLoad || false,
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      className: config && config.className || '',
      id: config && config.id || ''
    };
    this.renderConfig.dpr = config && config.dpr || 1;

    if (this.animationItem.wrapper) {
      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
    }

    this.renderedFrame = -1;
    this.globalData = {
      frameNum: -1,
      _mdf: false,
      renderConfig: this.renderConfig,
      currentGlobalAlpha: -1
    };
    this.contextData = new CVContextData();
    this.elements = [];
    this.pendingElements = [];
    this.transformMat = new Matrix();
    this.completeLayers = false;
    this.rendererType = 'canvas';
  }

  extendPrototype([CanvasRendererBase], CanvasRenderer);

  CanvasRenderer.prototype.createComp = function (data) {
    return new CVCompElement(data, this.globalData, this);
  };

  function HBaseElement() {}

  HBaseElement.prototype = {
    checkBlendMode: function checkBlendMode() {},
    initRendererElement: function initRendererElement() {
      this.baseElement = createTag(this.data.tg || 'div');

      if (this.data.hasMask) {
        this.svgElement = createNS('svg');
        this.layerElement = createNS('g');
        this.maskedElement = this.layerElement;
        this.svgElement.appendChild(this.layerElement);
        this.baseElement.appendChild(this.svgElement);
      } else {
        this.layerElement = this.baseElement;
      }

      styleDiv(this.baseElement);
    },
    createContainerElements: function createContainerElements() {
      this.renderableEffectsManager = new CVEffects(this);
      this.transformedElement = this.baseElement;
      this.maskedElement = this.layerElement;

      if (this.data.ln) {
        this.layerElement.setAttribute('id', this.data.ln);
      }

      if (this.data.cl) {
        this.layerElement.setAttribute('class', this.data.cl);
      }

      if (this.data.bm !== 0) {
        this.setBlendMode();
      }
    },
    renderElement: function renderElement() {
      var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};

      if (this.finalTransform._matMdf) {
        var matrixValue = this.finalTransform.mat.toCSS();
        transformedElementStyle.transform = matrixValue;
        transformedElementStyle.webkitTransform = matrixValue;
      }

      if (this.finalTransform._opMdf) {
        transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
      }
    },
    renderFrame: function renderFrame() {
      // If it is exported as hidden (data.hd === true) no need to render
      // If it is not visible no need to render
      if (this.data.hd || this.hidden) {
        return;
      }

      this.renderTransform();
      this.renderRenderable();
      this.renderElement();
      this.renderInnerContent();

      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    destroy: function destroy() {
      this.layerElement = null;
      this.transformedElement = null;

      if (this.matteElement) {
        this.matteElement = null;
      }

      if (this.maskManager) {
        this.maskManager.destroy();
        this.maskManager = null;
      }
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
    },
    addEffects: function addEffects() {},
    setMatte: function setMatte() {}
  };
  HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
  HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
  HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;

  function HSolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

  HSolidElement.prototype.createContent = function () {
    var rect;

    if (this.data.hasMask) {
      rect = createNS('rect');
      rect.setAttribute('width', this.data.sw);
      rect.setAttribute('height', this.data.sh);
      rect.setAttribute('fill', this.data.sc);
      this.svgElement.setAttribute('width', this.data.sw);
      this.svgElement.setAttribute('height', this.data.sh);
    } else {
      rect = createTag('div');
      rect.style.width = this.data.sw + 'px';
      rect.style.height = this.data.sh + 'px';
      rect.style.backgroundColor = this.data.sc;
    }

    this.layerElement.appendChild(rect);
  };

  function HShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = []; // Full shape data

    this.shapesData = data.shapes; // List of styles that will be applied to shapes

    this.stylesList = []; // List of modifiers that will be applied to shapes

    this.shapeModifiers = []; // List of items in shape tree

    this.itemsData = []; // List of items in previous shape tree

    this.processedElements = []; // List of animated components

    this.animatedContents = [];
    this.shapesContainer = createNS('g');
    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created

    this.prevViewData = [];
    this.currentBBox = {
      x: 999999,
      y: -999999,
      h: 0,
      w: 0
    };
  }

  extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
  HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

  HShapeElement.prototype.createContent = function () {
    var cont;
    this.baseElement.style.fontSize = 0;

    if (this.data.hasMask) {
      this.layerElement.appendChild(this.shapesContainer);
      cont = this.svgElement;
    } else {
      cont = createNS('svg');
      var size = this.comp.data ? this.comp.data : this.globalData.compSize;
      cont.setAttribute('width', size.w);
      cont.setAttribute('height', size.h);
      cont.appendChild(this.shapesContainer);
      this.layerElement.appendChild(cont);
    }

    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
    this.filterUniqueShapes();
    this.shapeCont = cont;
  };

  HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
    var i;
    var len = transformers.length;

    for (i = 0; i < len; i += 1) {
      point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
    }

    return point;
  };

  HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
    var shape = item.sh.v;
    var transformers = item.transformers;
    var i;
    var len = shape._length;
    var vPoint;
    var oPoint;
    var nextIPoint;
    var nextVPoint;

    if (len <= 1) {
      return;
    }

    for (i = 0; i < len - 1; i += 1) {
      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
      nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
      nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
    }

    if (shape.c) {
      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
      nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
      nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
    }
  };

  HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
    var bounds = this.shapeBoundingBox;
    boundingBox.x = bmMin(bounds.left, boundingBox.x);
    boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
    boundingBox.y = bmMin(bounds.top, boundingBox.y);
    boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
  };

  HShapeElement.prototype.shapeBoundingBox = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
  HShapeElement.prototype.tempBoundingBox = {
    x: 0,
    xMax: 0,
    y: 0,
    yMax: 0,
    width: 0,
    height: 0
  };

  HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
    var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
      // eslint-disable-line no-plusplus
      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
      c = 3 * p1[i] - 3 * p0[i];
      b |= 0; // eslint-disable-line no-bitwise

      a |= 0; // eslint-disable-line no-bitwise

      c |= 0; // eslint-disable-line no-bitwise

      if (a === 0 && b === 0) {//
      } else if (a === 0) {
        t = -c / b;

        if (t > 0 && t < 1) {
          bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
        }
      } else {
        b2ac = b * b - 4 * c * a;

        if (b2ac >= 0) {
          t1 = (-b + bmSqrt(b2ac)) / (2 * a);
          if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
          t2 = (-b - bmSqrt(b2ac)) / (2 * a);
          if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
        }
      }
    }

    this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
    this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
    this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
    this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
  };

  HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
    return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
  };

  HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
    var i;
    var len = itemsData.length;

    for (i = 0; i < len; i += 1) {
      if (itemsData[i] && itemsData[i].sh) {
        this.calculateShapeBoundingBox(itemsData[i], boundingBox);
      } else if (itemsData[i] && itemsData[i].it) {
        this.calculateBoundingBox(itemsData[i].it, boundingBox);
      } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
        this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
      }
    }
  };

  HShapeElement.prototype.expandStrokeBoundingBox = function (widthProperty, boundingBox) {
    var width = 0;

    if (widthProperty.keyframes) {
      for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
        var kfw = widthProperty.keyframes[i].s;

        if (kfw > width) {
          width = kfw;
        }
      }

      width *= widthProperty.mult;
    } else {
      width = widthProperty.v * widthProperty.mult;
    }

    boundingBox.x -= width;
    boundingBox.xMax += width;
    boundingBox.y -= width;
    boundingBox.yMax += width;
  };

  HShapeElement.prototype.currentBoxContains = function (box) {
    return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
  };

  HShapeElement.prototype.renderInnerContent = function () {
    this._renderShapeFrame();

    if (!this.hidden && (this._isFirstFrame || this._mdf)) {
      var tempBoundingBox = this.tempBoundingBox;
      var max = 999999;
      tempBoundingBox.x = max;
      tempBoundingBox.xMax = -max;
      tempBoundingBox.y = max;
      tempBoundingBox.yMax = -max;
      this.calculateBoundingBox(this.itemsData, tempBoundingBox);
      tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
      tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();

      if (this.currentBoxContains(tempBoundingBox)) {
        return;
      }

      var changed = false;

      if (this.currentBBox.w !== tempBoundingBox.width) {
        this.currentBBox.w = tempBoundingBox.width;
        this.shapeCont.setAttribute('width', tempBoundingBox.width);
        changed = true;
      }

      if (this.currentBBox.h !== tempBoundingBox.height) {
        this.currentBBox.h = tempBoundingBox.height;
        this.shapeCont.setAttribute('height', tempBoundingBox.height);
        changed = true;
      }

      if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
        this.currentBBox.w = tempBoundingBox.width;
        this.currentBBox.h = tempBoundingBox.height;
        this.currentBBox.x = tempBoundingBox.x;
        this.currentBBox.y = tempBoundingBox.y;
        this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
        var shapeStyle = this.shapeCont.style;
        var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        shapeStyle.transform = shapeTransform;
        shapeStyle.webkitTransform = shapeTransform;
      }
    }
  };

  function HTextElement(data, globalData, comp) {
    this.textSpans = [];
    this.textPaths = [];
    this.currentBBox = {
      x: 999999,
      y: -999999,
      h: 0,
      w: 0
    };
    this.renderType = 'svg';
    this.isMasked = false;
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

  HTextElement.prototype.createContent = function () {
    this.isMasked = this.checkMasks();

    if (this.isMasked) {
      this.renderType = 'svg';
      this.compW = this.comp.data.w;
      this.compH = this.comp.data.h;
      this.svgElement.setAttribute('width', this.compW);
      this.svgElement.setAttribute('height', this.compH);
      var g = createNS('g');
      this.maskedElement.appendChild(g);
      this.innerElem = g;
    } else {
      this.renderType = 'html';
      this.innerElem = this.layerElement;
    }

    this.checkParenting();
  };

  HTextElement.prototype.buildNewText = function () {
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
    var innerElemStyle = this.innerElem.style;
    var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
    innerElemStyle.fill = textColor;
    innerElemStyle.color = textColor;

    if (documentData.sc) {
      innerElemStyle.stroke = this.buildColor(documentData.sc);
      innerElemStyle.strokeWidth = documentData.sw + 'px';
    }

    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

    if (!this.globalData.fontManager.chars) {
      innerElemStyle.fontSize = documentData.finalSize + 'px';
      innerElemStyle.lineHeight = documentData.finalSize + 'px';

      if (fontData.fClass) {
        this.innerElem.className = fontData.fClass;
      } else {
        innerElemStyle.fontFamily = fontData.fFamily;
        var fWeight = documentData.fWeight;
        var fStyle = documentData.fStyle;
        innerElemStyle.fontStyle = fStyle;
        innerElemStyle.fontWeight = fWeight;
      }
    }

    var i;
    var len;
    var letters = documentData.l;
    len = letters.length;
    var tSpan;
    var tParent;
    var tCont;
    var matrixHelper = this.mHelper;
    var shapes;
    var shapeStr = '';
    var cnt = 0;

    for (i = 0; i < len; i += 1) {
      if (this.globalData.fontManager.chars) {
        if (!this.textPaths[cnt]) {
          tSpan = createNS('path');
          tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
          tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
          tSpan.setAttribute('stroke-miterlimit', '4');
        } else {
          tSpan = this.textPaths[cnt];
        }

        if (!this.isMasked) {
          if (this.textSpans[cnt]) {
            tParent = this.textSpans[cnt];
            tCont = tParent.children[0];
          } else {
            tParent = createTag('div');
            tParent.style.lineHeight = 0;
            tCont = createNS('svg');
            tCont.appendChild(tSpan);
            styleDiv(tParent);
          }
        }
      } else if (!this.isMasked) {
        if (this.textSpans[cnt]) {
          tParent = this.textSpans[cnt];
          tSpan = this.textPaths[cnt];
        } else {
          tParent = createTag('span');
          styleDiv(tParent);
          tSpan = createTag('span');
          styleDiv(tSpan);
          tParent.appendChild(tSpan);
        }
      } else {
        tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
      } // tSpan.setAttribute('visibility', 'hidden');


      if (this.globalData.fontManager.chars) {
        var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        var shapeData;

        if (charData) {
          shapeData = charData.data;
        } else {
          shapeData = null;
        }

        matrixHelper.reset();

        if (shapeData && shapeData.shapes && shapeData.shapes.length) {
          shapes = shapeData.shapes[0].it;
          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
          shapeStr = this.createPathShape(matrixHelper, shapes);
          tSpan.setAttribute('d', shapeStr);
        }

        if (!this.isMasked) {
          this.innerElem.appendChild(tParent);

          if (shapeData && shapeData.shapes) {
            // document.body.appendChild is needed to get exact measure of shape
            document.body.appendChild(tCont);
            var boundingBox = tCont.getBBox();
            tCont.setAttribute('width', boundingBox.width + 2);
            tCont.setAttribute('height', boundingBox.height + 2);
            tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
            var tContStyle = tCont.style;
            var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
            tContStyle.transform = tContTranslation;
            tContStyle.webkitTransform = tContTranslation;
            letters[i].yOffset = boundingBox.y - 1;
          } else {
            tCont.setAttribute('width', 1);
            tCont.setAttribute('height', 1);
          }

          tParent.appendChild(tCont);
        } else {
          this.innerElem.appendChild(tSpan);
        }
      } else {
        tSpan.textContent = letters[i].val;
        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');

        if (!this.isMasked) {
          this.innerElem.appendChild(tParent); //

          var tStyle = tSpan.style;
          var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
          tStyle.transform = tSpanTranslation;
          tStyle.webkitTransform = tSpanTranslation;
        } else {
          this.innerElem.appendChild(tSpan);
        }
      } //


      if (!this.isMasked) {
        this.textSpans[cnt] = tParent;
      } else {
        this.textSpans[cnt] = tSpan;
      }

      this.textSpans[cnt].style.display = 'block';
      this.textPaths[cnt] = tSpan;
      cnt += 1;
    }

    while (cnt < this.textSpans.length) {
      this.textSpans[cnt].style.display = 'none';
      cnt += 1;
    }
  };

  HTextElement.prototype.renderInnerContent = function () {
    var svgStyle;

    if (this.data.singleShape) {
      if (!this._isFirstFrame && !this.lettersChangedFlag) {
        return;
      }

      if (this.isMasked && this.finalTransform._matMdf) {
        // Todo Benchmark if using this is better than getBBox
        this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
        svgStyle = this.svgElement.style;
        var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
        svgStyle.transform = translation;
        svgStyle.webkitTransform = translation;
      }
    }

    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

    if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
      return;
    }

    var i;
    var len;
    var count = 0;
    var renderedLetters = this.textAnimator.renderedLetters;
    var letters = this.textProperty.currentData.l;
    len = letters.length;
    var renderedLetter;
    var textSpan;
    var textPath;

    for (i = 0; i < len; i += 1) {
      if (letters[i].n) {
        count += 1;
      } else {
        textSpan = this.textSpans[i];
        textPath = this.textPaths[i];
        renderedLetter = renderedLetters[count];
        count += 1;

        if (renderedLetter._mdf.m) {
          if (!this.isMasked) {
            textSpan.style.webkitTransform = renderedLetter.m;
            textSpan.style.transform = renderedLetter.m;
          } else {
            textSpan.setAttribute('transform', renderedLetter.m);
          }
        } /// /textSpan.setAttribute('opacity',renderedLetter.o);


        textSpan.style.opacity = renderedLetter.o;

        if (renderedLetter.sw && renderedLetter._mdf.sw) {
          textPath.setAttribute('stroke-width', renderedLetter.sw);
        }

        if (renderedLetter.sc && renderedLetter._mdf.sc) {
          textPath.setAttribute('stroke', renderedLetter.sc);
        }

        if (renderedLetter.fc && renderedLetter._mdf.fc) {
          textPath.setAttribute('fill', renderedLetter.fc);
          textPath.style.color = renderedLetter.fc;
        }
      }
    }

    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
      var boundingBox = this.innerElem.getBBox();

      if (this.currentBBox.w !== boundingBox.width) {
        this.currentBBox.w = boundingBox.width;
        this.svgElement.setAttribute('width', boundingBox.width);
      }

      if (this.currentBBox.h !== boundingBox.height) {
        this.currentBBox.h = boundingBox.height;
        this.svgElement.setAttribute('height', boundingBox.height);
      }

      var margin = 1;

      if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
        this.currentBBox.w = boundingBox.width + margin * 2;
        this.currentBBox.h = boundingBox.height + margin * 2;
        this.currentBBox.x = boundingBox.x - margin;
        this.currentBBox.y = boundingBox.y - margin;
        this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
        svgStyle = this.svgElement.style;
        var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        svgStyle.transform = svgTransform;
        svgStyle.webkitTransform = svgTransform;
      }
    }
  };

  function HCameraElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initHierarchy();
    var getProp = PropertyFactory.getProp;
    this.pe = getProp(this, data.pe, 0, 0, this);

    if (data.ks.p.s) {
      this.px = getProp(this, data.ks.p.x, 1, 0, this);
      this.py = getProp(this, data.ks.p.y, 1, 0, this);
      this.pz = getProp(this, data.ks.p.z, 1, 0, this);
    } else {
      this.p = getProp(this, data.ks.p, 1, 0, this);
    }

    if (data.ks.a) {
      this.a = getProp(this, data.ks.a, 1, 0, this);
    }

    if (data.ks.or.k.length && data.ks.or.k[0].to) {
      var i;
      var len = data.ks.or.k.length;

      for (i = 0; i < len; i += 1) {
        data.ks.or.k[i].to = null;
        data.ks.or.k[i].ti = null;
      }
    }

    this.or = getProp(this, data.ks.or, 1, degToRads, this);
    this.or.sh = true;
    this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
    this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
    this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
    this.mat = new Matrix();
    this._prevMat = new Matrix();
    this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.

    this.finalTransform = {
      mProp: this
    };
  }

  extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

  HCameraElement.prototype.setup = function () {
    var i;
    var len = this.comp.threeDElements.length;
    var comp;
    var perspectiveStyle;
    var containerStyle;

    for (i = 0; i < len; i += 1) {
      // [perspectiveElem,container]
      comp = this.comp.threeDElements[i];

      if (comp.type === '3d') {
        perspectiveStyle = comp.perspectiveElem.style;
        containerStyle = comp.container.style;
        var perspective = this.pe.v + 'px';
        var origin = '0px 0px 0px';
        var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
        perspectiveStyle.perspective = perspective;
        perspectiveStyle.webkitPerspective = perspective;
        containerStyle.transformOrigin = origin;
        containerStyle.mozTransformOrigin = origin;
        containerStyle.webkitTransformOrigin = origin;
        perspectiveStyle.transform = matrix;
        perspectiveStyle.webkitTransform = matrix;
      }
    }
  };

  HCameraElement.prototype.createElements = function () {};

  HCameraElement.prototype.hide = function () {};

  HCameraElement.prototype.renderFrame = function () {
    var _mdf = this._isFirstFrame;
    var i;
    var len;

    if (this.hierarchy) {
      len = this.hierarchy.length;

      for (i = 0; i < len; i += 1) {
        _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
      }
    }

    if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
      this.mat.reset();

      if (this.hierarchy) {
        len = this.hierarchy.length - 1;

        for (i = len; i >= 0; i -= 1) {
          var mTransf = this.hierarchy[i].finalTransform.mProp;
          this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
          this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
          this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
          this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
          this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
        }
      }

      if (this.p) {
        this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
      } else {
        this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
      }

      if (this.a) {
        var diffVector;

        if (this.p) {
          diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
        } else {
          diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
        }

        var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));

        var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
        var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
        var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
        var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
        this.mat.rotateY(mRotationY).rotateX(-mRotationX);
      }

      this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
      this.mat.translate(0, 0, this.pe.v);
      var hasMatrixChanged = !this._prevMat.equals(this.mat);

      if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
        len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;

        for (i = 0; i < len; i += 1) {
          comp = this.comp.threeDElements[i];

          if (comp.type === '3d') {
            if (hasMatrixChanged) {
              var matValue = this.mat.toCSS();
              containerStyle = comp.container.style;
              containerStyle.transform = matValue;
              containerStyle.webkitTransform = matValue;
            }

            if (this.pe._mdf) {
              perspectiveStyle = comp.perspectiveElem.style;
              perspectiveStyle.perspective = this.pe.v + 'px';
              perspectiveStyle.webkitPerspective = this.pe.v + 'px';
            }
          }
        }

        this.mat.clone(this._prevMat);
      }
    }

    this._isFirstFrame = false;
  };

  HCameraElement.prototype.prepareFrame = function (num) {
    this.prepareProperties(num, true);
  };

  HCameraElement.prototype.destroy = function () {};

  HCameraElement.prototype.getBaseElement = function () {
    return null;
  };

  function HImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

  HImageElement.prototype.createContent = function () {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    var img = new Image();

    if (this.data.hasMask) {
      this.imageElem = createNS('image');
      this.imageElem.setAttribute('width', this.assetData.w + 'px');
      this.imageElem.setAttribute('height', this.assetData.h + 'px');
      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
      this.layerElement.appendChild(this.imageElem);
      this.baseElement.setAttribute('width', this.assetData.w);
      this.baseElement.setAttribute('height', this.assetData.h);
    } else {
      this.layerElement.appendChild(img);
    }

    img.crossOrigin = 'anonymous';
    img.src = assetPath;

    if (this.data.ln) {
      this.baseElement.setAttribute('id', this.data.ln);
    }
  };

  function HybridRendererBase(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.renderConfig = {
      className: config && config.className || '',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '400%',
        height: config && config.filterSize && config.filterSize.height || '400%',
        x: config && config.filterSize && config.filterSize.x || '-100%',
        y: config && config.filterSize && config.filterSize.y || '-100%'
      }
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      renderConfig: this.renderConfig
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;
    this.rendererType = 'html';
  }

  extendPrototype([BaseRenderer], HybridRendererBase);
  HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;

  HybridRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();
    }
  };

  HybridRendererBase.prototype.appendElementInPos = function (element, pos) {
    var newDOMElement = element.getBaseElement();

    if (!newDOMElement) {
      return;
    }

    var layer = this.layers[pos];

    if (!layer.ddd || !this.supports3d) {
      if (this.threeDElements) {
        this.addTo3dContainer(newDOMElement, pos);
      } else {
        var i = 0;
        var nextDOMElement;
        var nextLayer;
        var tmpDOMElement;

        while (i < pos) {
          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
            nextLayer = this.elements[i];
            tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
            nextDOMElement = tmpDOMElement || nextDOMElement;
          }

          i += 1;
        }

        if (nextDOMElement) {
          if (!layer.ddd || !this.supports3d) {
            this.layerElement.insertBefore(newDOMElement, nextDOMElement);
          }
        } else if (!layer.ddd || !this.supports3d) {
          this.layerElement.appendChild(newDOMElement);
        }
      }
    } else {
      this.addTo3dContainer(newDOMElement, pos);
    }
  };

  HybridRendererBase.prototype.createShape = function (data) {
    if (!this.supports3d) {
      return new SVGShapeElement(data, this.globalData, this);
    }

    return new HShapeElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createText = function (data) {
    if (!this.supports3d) {
      return new SVGTextLottieElement(data, this.globalData, this);
    }

    return new HTextElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createCamera = function (data) {
    this.camera = new HCameraElement(data, this.globalData, this);
    return this.camera;
  };

  HybridRendererBase.prototype.createImage = function (data) {
    if (!this.supports3d) {
      return new IImageElement(data, this.globalData, this);
    }

    return new HImageElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createSolid = function (data) {
    if (!this.supports3d) {
      return new ISolidElement(data, this.globalData, this);
    }

    return new HSolidElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

  HybridRendererBase.prototype.getThreeDContainerByPos = function (pos) {
    var i = 0;
    var len = this.threeDElements.length;

    while (i < len) {
      if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
        return this.threeDElements[i].perspectiveElem;
      }

      i += 1;
    }

    return null;
  };

  HybridRendererBase.prototype.createThreeDContainer = function (pos, type) {
    var perspectiveElem = createTag('div');
    var style;
    var containerStyle;
    styleDiv(perspectiveElem);
    var container = createTag('div');
    styleDiv(container);

    if (type === '3d') {
      style = perspectiveElem.style;
      style.width = this.globalData.compSize.w + 'px';
      style.height = this.globalData.compSize.h + 'px';
      var center = '50% 50%';
      style.webkitTransformOrigin = center;
      style.mozTransformOrigin = center;
      style.transformOrigin = center;
      containerStyle = container.style;
      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
      containerStyle.transform = matrix;
      containerStyle.webkitTransform = matrix;
    }

    perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);

    var threeDContainerData = {
      container: container,
      perspectiveElem: perspectiveElem,
      startPos: pos,
      endPos: pos,
      type: type
    };
    this.threeDElements.push(threeDContainerData);
    return threeDContainerData;
  };

  HybridRendererBase.prototype.build3dContainers = function () {
    var i;
    var len = this.layers.length;
    var lastThreeDContainerData;
    var currentContainer = '';

    for (i = 0; i < len; i += 1) {
      if (this.layers[i].ddd && this.layers[i].ty !== 3) {
        if (currentContainer !== '3d') {
          currentContainer = '3d';
          lastThreeDContainerData = this.createThreeDContainer(i, '3d');
        }

        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
      } else {
        if (currentContainer !== '2d') {
          currentContainer = '2d';
          lastThreeDContainerData = this.createThreeDContainer(i, '2d');
        }

        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
      }
    }

    len = this.threeDElements.length;

    for (i = len - 1; i >= 0; i -= 1) {
      this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    }
  };

  HybridRendererBase.prototype.addTo3dContainer = function (elem, pos) {
    var i = 0;
    var len = this.threeDElements.length;

    while (i < len) {
      if (pos <= this.threeDElements[i].endPos) {
        var j = this.threeDElements[i].startPos;
        var nextElement;

        while (j < pos) {
          if (this.elements[j] && this.elements[j].getBaseElement) {
            nextElement = this.elements[j].getBaseElement();
          }

          j += 1;
        }

        if (nextElement) {
          this.threeDElements[i].container.insertBefore(elem, nextElement);
        } else {
          this.threeDElements[i].container.appendChild(elem);
        }

        break;
      }

      i += 1;
    }
  };

  HybridRendererBase.prototype.configAnimation = function (animData) {
    var resizerElem = createTag('div');
    var wrapper = this.animationItem.wrapper;
    var style = resizerElem.style;
    style.width = animData.w + 'px';
    style.height = animData.h + 'px';
    this.resizerElem = resizerElem;
    styleDiv(resizerElem);
    style.transformStyle = 'flat';
    style.mozTransformStyle = 'flat';
    style.webkitTransformStyle = 'flat';

    if (this.renderConfig.className) {
      resizerElem.setAttribute('class', this.renderConfig.className);
    }

    wrapper.appendChild(resizerElem);
    style.overflow = 'hidden';
    var svg = createNS('svg');
    svg.setAttribute('width', '1');
    svg.setAttribute('height', '1');
    styleDiv(svg);
    this.resizerElem.appendChild(svg);
    var defs = createNS('defs');
    svg.appendChild(defs);
    this.data = animData; // Mask animation

    this.setupGlobalData(animData, svg);
    this.globalData.defs = defs;
    this.layers = animData.layers;
    this.layerElement = this.resizerElem;
    this.build3dContainers();
    this.updateContainerSize();
  };

  HybridRendererBase.prototype.destroy = function () {
    if (this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }

    this.animationItem.container = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;

    for (i = 0; i < len; i += 1) {
      this.elements[i].destroy();
    }

    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
  };

  HybridRendererBase.prototype.updateContainerSize = function () {
    var elementWidth = this.animationItem.wrapper.offsetWidth;
    var elementHeight = this.animationItem.wrapper.offsetHeight;
    var elementRel = elementWidth / elementHeight;
    var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
    var sx;
    var sy;
    var tx;
    var ty;

    if (animationRel > elementRel) {
      sx = elementWidth / this.globalData.compSize.w;
      sy = elementWidth / this.globalData.compSize.w;
      tx = 0;
      ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
    } else {
      sx = elementHeight / this.globalData.compSize.h;
      sy = elementHeight / this.globalData.compSize.h;
      tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
      ty = 0;
    }

    var style = this.resizerElem.style;
    style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
    style.transform = style.webkitTransform;
  };

  HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

  HybridRendererBase.prototype.hide = function () {
    this.resizerElem.style.display = 'none';
  };

  HybridRendererBase.prototype.show = function () {
    this.resizerElem.style.display = 'block';
  };

  HybridRendererBase.prototype.initItems = function () {
    this.buildAllItems();

    if (this.camera) {
      this.camera.setup();
    } else {
      var cWidth = this.globalData.compSize.w;
      var cHeight = this.globalData.compSize.h;
      var i;
      var len = this.threeDElements.length;

      for (i = 0; i < len; i += 1) {
        var style = this.threeDElements[i].perspectiveElem.style;
        style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
        style.perspective = style.webkitPerspective;
      }
    }
  };

  HybridRendererBase.prototype.searchExtraCompositions = function (assets) {
    var i;
    var len = assets.length;
    var floatingContainer = createTag('div');

    for (i = 0; i < len; i += 1) {
      if (assets[i].xt) {
        var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
      }
    }
  };

  function HCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = !data.hasMask;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }

  extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
  HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

  HCompElement.prototype.createContainerElements = function () {
    this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';


    if (this.data.hasMask) {
      this.svgElement.setAttribute('width', this.data.w);
      this.svgElement.setAttribute('height', this.data.h);
      this.transformedElement = this.baseElement;
    } else {
      this.transformedElement = this.layerElement;
    }
  };

  HCompElement.prototype.addTo3dContainer = function (elem, pos) {
    var j = 0;
    var nextElement;

    while (j < pos) {
      if (this.elements[j] && this.elements[j].getBaseElement) {
        nextElement = this.elements[j].getBaseElement();
      }

      j += 1;
    }

    if (nextElement) {
      this.layerElement.insertBefore(elem, nextElement);
    } else {
      this.layerElement.appendChild(elem);
    }
  };

  HCompElement.prototype.createComp = function (data) {
    if (!this.supports3d) {
      return new SVGCompElement(data, this.globalData, this);
    }

    return new HCompElement(data, this.globalData, this);
  };

  function HybridRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.renderConfig = {
      className: config && config.className || '',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '400%',
        height: config && config.filterSize && config.filterSize.height || '400%',
        x: config && config.filterSize && config.filterSize.x || '-100%',
        y: config && config.filterSize && config.filterSize.y || '-100%'
      }
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      renderConfig: this.renderConfig
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;
    this.rendererType = 'html';
  }

  extendPrototype([HybridRendererBase], HybridRenderer);

  HybridRenderer.prototype.createComp = function (data) {
    if (!this.supports3d) {
      return new SVGCompElement(data, this.globalData, this);
    }

    return new HCompElement(data, this.globalData, this);
  };

  var Expressions = function () {
    var ob = {};
    ob.initExpressions = initExpressions;

    function initExpressions(animation) {
      var stackCount = 0;
      var registers = [];

      function pushExpression() {
        stackCount += 1;
      }

      function popExpression() {
        stackCount -= 1;

        if (stackCount === 0) {
          releaseInstances();
        }
      }

      function registerExpressionProperty(expression) {
        if (registers.indexOf(expression) === -1) {
          registers.push(expression);
        }
      }

      function releaseInstances() {
        var i;
        var len = registers.length;

        for (i = 0; i < len; i += 1) {
          registers[i].release();
        }

        registers.length = 0;
      }

      animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
      animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
      animation.renderer.globalData.pushExpression = pushExpression;
      animation.renderer.globalData.popExpression = popExpression;
      animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
    }

    return ob;
  }();

  function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

  /* eslint-disable */

  /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */
  function seedRandom(pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var global = this,
        width = 256,
        // each RC4 output is 0 <= x < 256
    chunks = 6,
        // at least six RC4 outputs for each double
    digits = 52,
        // there are 52 significant digits in a double
    rngname = 'random',
        // rngname: name for Math.random and Math.seedrandom
    startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //

    function seedrandom(seed, options, callback) {
      var key = [];
      options = options === true ? {
        entropy: true
      } : options || {}; // Flatten the seed string or build one from local entropy if needed.

      var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.

      var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
      // randomness in every bit of the mantissa of the IEEE 754 value.

      var prng = function prng() {
        var n = arc4.g(chunks),
            // Start with a numerator n < 2 ^ 48
        d = startdenom,
            //   and denominator d = 2 ^ 48.
        x = 0; //   and no 'extra last byte'.

        while (n < significance) {
          // Fill up all significant digits by
          n = (n + x) * width; //   shifting numerator and

          d *= width; //   denominator and generating a

          x = arc4.g(1); //   new least-significant-byte.
        }

        while (n >= overflow) {
          // To avoid rounding up, before adding
          n /= 2; //   last byte, shift everything

          d /= 2; //   right using integer math until

          x >>>= 1; //   we have exactly the desired bits.
        }

        return (n + x) / d; // Form the number within [0, 1).
      };

      prng.int32 = function () {
        return arc4.g(4) | 0;
      };

      prng.quick = function () {
        return arc4.g(4) / 0x100000000;
      };

      prng["double"] = prng; // Mix the randomness into accumulated entropy.

      mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.

      return (options.pass || callback || function (prng, seed, is_math_call, state) {
        if (state) {
          // Load the arc4 state from the given state if it has an S array.
          if (state.S) {
            copy(state, arc4);
          } // Only provide the .state method if requested via options.state.


          prng.state = function () {
            return copy(arc4, {});
          };
        } // If called as a method of Math (Math.seedrandom()), mutate
        // Math.random because that is how seedrandom.js has worked since v1.0.


        if (is_math_call) {
          math[rngname] = prng;
          return seed;
        } // Otherwise, it is a newer calling convention, so return the
        // prng directly.
        else return prng;
      })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }

    math['seed' + rngname] = seedrandom; //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //

    function ARC4(key) {
      var t,
          keylen = key.length,
          me = this,
          i = 0,
          j = me.i = me.j = 0,
          s = me.S = []; // The empty key [] is treated as [0].

      if (!keylen) {
        key = [keylen++];
      } // Set up S using the standard key scheduling algorithm.


      while (i < width) {
        s[i] = i++;
      }

      for (i = 0; i < width; i++) {
        s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
        s[j] = t;
      } // The "g" method returns the next (count) outputs as one number.


      me.g = function (count) {
        // Using instance members instead of closure state nearly doubles speed.
        var t,
            r = 0,
            i = me.i,
            j = me.j,
            s = me.S;

        while (count--) {
          t = s[i = mask & i + 1];
          r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
        }

        me.i = i;
        me.j = j;
        return r; // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
      };
    } //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //


    function copy(f, t) {
      t.i = f.i;
      t.j = f.j;
      t.S = f.S.slice();
      return t;
    } //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //


    function flatten(obj, depth) {
      var result = [],
          typ = _typeof$1(obj),
          prop;

      if (depth && typ == 'object') {
        for (prop in obj) {
          try {
            result.push(flatten(obj[prop], depth - 1));
          } catch (e) {}
        }
      }

      return result.length ? result : typ == 'string' ? obj : obj + '\0';
    } //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //


    function mixkey(seed, key) {
      var stringseed = seed + '',
          smear,
          j = 0;

      while (j < stringseed.length) {
        key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
      }

      return tostring(key);
    } //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //


    function autoseed() {
      try {
        if (nodecrypto) {
          return tostring(nodecrypto.randomBytes(width));
        }

        var out = new Uint8Array(width);
        (global.crypto || global.msCrypto).getRandomValues(out);
        return tostring(out);
      } catch (e) {
        var browser = global.navigator,
            plugins = browser && browser.plugins;
        return [+new Date(), global, plugins, global.screen, tostring(pool)];
      }
    } //
    // tostring()
    // Converts an array of charcodes to a string
    //


    function tostring(a) {
      return String.fromCharCode.apply(0, a);
    } //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //


    mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
  }

  ;

  function initialize$2(BMMath) {
    seedRandom([], BMMath);
  }

  var propTypes = {
    SHAPE: 'shape'
  };

  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  var ExpressionManager = function () {
    'use strict';

    var ob = {};
    var Math = BMMath;
    var window = null;
    var document = null;
    var XMLHttpRequest = null;
    var fetch = null;
    var frames = null;
    initialize$2(BMMath);

    function $bm_isInstanceOfArray(arr) {
      return arr.constructor === Array || arr.constructor === Float32Array;
    }

    function isNumerable(tOfV, v) {
      return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
    }

    function $bm_neg(a) {
      var tOfA = _typeof(a);

      if (tOfA === 'number' || tOfA === 'boolean' || a instanceof Number) {
        return -a;
      }

      if ($bm_isInstanceOfArray(a)) {
        var i;
        var lenA = a.length;
        var retArr = [];

        for (i = 0; i < lenA; i += 1) {
          retArr[i] = -a[i];
        }

        return retArr;
      }

      if (a.propType) {
        return a.v;
      }

      return -a;
    }

    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
    var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
    var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

    function sum(a, b) {
      var tOfA = _typeof(a);

      var tOfB = _typeof(b);

      if (tOfA === 'string' || tOfB === 'string') {
        return a + b;
      }

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        return a + b;
      }

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        a = a.slice(0);
        a[0] += b;
        return a;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        b = b.slice(0);
        b[0] = a + b[0];
        return b;
      }

      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
        var i = 0;
        var lenA = a.length;
        var lenB = b.length;
        var retArr = [];

        while (i < lenA || i < lenB) {
          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
            retArr[i] = a[i] + b[i];
          } else {
            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
          }

          i += 1;
        }

        return retArr;
      }

      return 0;
    }

    var add = sum;

    function sub(a, b) {
      var tOfA = _typeof(a);

      var tOfB = _typeof(b);

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        if (tOfA === 'string') {
          a = parseInt(a, 10);
        }

        if (tOfB === 'string') {
          b = parseInt(b, 10);
        }

        return a - b;
      }

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        a = a.slice(0);
        a[0] -= b;
        return a;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        b = b.slice(0);
        b[0] = a - b[0];
        return b;
      }

      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
        var i = 0;
        var lenA = a.length;
        var lenB = b.length;
        var retArr = [];

        while (i < lenA || i < lenB) {
          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
            retArr[i] = a[i] - b[i];
          } else {
            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
          }

          i += 1;
        }

        return retArr;
      }

      return 0;
    }

    function mul(a, b) {
      var tOfA = _typeof(a);

      var tOfB = _typeof(b);

      var arr;

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        return a * b;
      }

      var i;
      var len;

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        len = a.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a[i] * b;
        }

        return arr;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        len = b.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a * b[i];
        }

        return arr;
      }

      return 0;
    }

    function div(a, b) {
      var tOfA = _typeof(a);

      var tOfB = _typeof(b);

      var arr;

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        return a / b;
      }

      var i;
      var len;

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        len = a.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a[i] / b;
        }

        return arr;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        len = b.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a / b[i];
        }

        return arr;
      }

      return 0;
    }

    function mod(a, b) {
      if (typeof a === 'string') {
        a = parseInt(a, 10);
      }

      if (typeof b === 'string') {
        b = parseInt(b, 10);
      }

      return a % b;
    }

    var $bm_sum = sum;
    var $bm_sub = sub;
    var $bm_mul = mul;
    var $bm_div = div;
    var $bm_mod = mod;

    function clamp(num, min, max) {
      if (min > max) {
        var mm = max;
        max = min;
        min = mm;
      }

      return Math.min(Math.max(num, min), max);
    }

    function radiansToDegrees(val) {
      return val / degToRads;
    }

    var radians_to_degrees = radiansToDegrees;

    function degreesToRadians(val) {
      return val * degToRads;
    }

    var degrees_to_radians = radiansToDegrees;
    var helperLengthArray = [0, 0, 0, 0, 0, 0];

    function length(arr1, arr2) {
      if (typeof arr1 === 'number' || arr1 instanceof Number) {
        arr2 = arr2 || 0;
        return Math.abs(arr1 - arr2);
      }

      if (!arr2) {
        arr2 = helperLengthArray;
      }

      var i;
      var len = Math.min(arr1.length, arr2.length);
      var addedLength = 0;

      for (i = 0; i < len; i += 1) {
        addedLength += Math.pow(arr2[i] - arr1[i], 2);
      }

      return Math.sqrt(addedLength);
    }

    function normalize(vec) {
      return div(vec, length(vec));
    }

    function rgbToHsl(val) {
      var r = val[0];
      var g = val[1];
      var b = val[2];
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var h;
      var s;
      var l = (max + min) / 2;

      if (max === min) {
        h = 0; // achromatic

        s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;

          default:
            break;
        }

        h /= 6;
      }

      return [h, s, l, val[3]];
    }

    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }

    function hslToRgb(val) {
      var h = val[0];
      var s = val[1];
      var l = val[2];
      var r;
      var g;
      var b;

      if (s === 0) {
        r = l; // achromatic

        b = l; // achromatic

        g = l; // achromatic
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      return [r, g, b, val[3]];
    }

    function linear(t, tMin, tMax, value1, value2) {
      if (value1 === undefined || value2 === undefined) {
        value1 = tMin;
        value2 = tMax;
        tMin = 0;
        tMax = 1;
      }

      if (tMax < tMin) {
        var _tMin = tMax;
        tMax = tMin;
        tMin = _tMin;
      }

      if (t <= tMin) {
        return value1;
      }

      if (t >= tMax) {
        return value2;
      }

      var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);

      if (!value1.length) {
        return value1 + (value2 - value1) * perc;
      }

      var i;
      var len = value1.length;
      var arr = createTypedArray('float32', len);

      for (i = 0; i < len; i += 1) {
        arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
      }

      return arr;
    }

    function random(min, max) {
      if (max === undefined) {
        if (min === undefined) {
          min = 0;
          max = 1;
        } else {
          max = min;
          min = undefined;
        }
      }

      if (max.length) {
        var i;
        var len = max.length;

        if (!min) {
          min = createTypedArray('float32', len);
        }

        var arr = createTypedArray('float32', len);
        var rnd = BMMath.random();

        for (i = 0; i < len; i += 1) {
          arr[i] = min[i] + rnd * (max[i] - min[i]);
        }

        return arr;
      }

      if (min === undefined) {
        min = 0;
      }

      var rndm = BMMath.random();
      return min + rndm * (max - min);
    }

    function createPath(points, inTangents, outTangents, closed) {
      var i;
      var len = points.length;
      var path = shapePool.newElement();
      path.setPathData(!!closed, len);
      var arrPlaceholder = [0, 0];
      var inVertexPoint;
      var outVertexPoint;

      for (i = 0; i < len; i += 1) {
        inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
        outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
        path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
      }

      return path;
    }

    function initiateExpression(elem, data, property) {
      var val = data.x;
      var needsVelocity = /velocity(?![\w\d])/.test(val);

      var _needsRandom = val.indexOf('random') !== -1;

      var elemType = elem.data.ty;
      var transform;
      var $bm_transform;
      var content;
      var effect;
      var thisProperty = property;
      thisProperty.valueAtTime = thisProperty.getValueAtTime;
      Object.defineProperty(thisProperty, 'value', {
        get: function get() {
          return thisProperty.v;
        }
      });
      elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
      elem.comp.displayStartTime = 0;
      var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
      var outPoint = elem.data.op / elem.comp.globalData.frameRate;
      var width = elem.data.sw ? elem.data.sw : 0;
      var height = elem.data.sh ? elem.data.sh : 0;
      var name = elem.data.nm;
      var loopIn;
      var loop_in;
      var loopOut;
      var loop_out;
      var smooth;
      var toWorld;
      var fromWorld;
      var fromComp;
      var toComp;
      var fromCompToSurface;
      var position;
      var rotation;
      var anchorPoint;
      var scale;
      var thisLayer;
      var thisComp;
      var mask;
      var valueAtTime;
      var velocityAtTime;
      var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls

      var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval

      var numKeys = property.kf ? data.k.length : 0;
      var active = !this.data || this.data.hd !== true;

      var wiggle = function wiggle(freq, amp) {
        var iWiggle;
        var j;
        var lenWiggle = this.pv.length ? this.pv.length : 1;
        var addedAmps = createTypedArray('float32', lenWiggle);
        freq = 5;
        var iterations = Math.floor(time * freq);
        iWiggle = 0;
        j = 0;

        while (iWiggle < iterations) {
          // var rnd = BMMath.random();
          for (j = 0; j < lenWiggle; j += 1) {
            addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
          }

          iWiggle += 1;
        } // var rnd2 = BMMath.random();


        var periods = time * freq;
        var perc = periods - Math.floor(periods);
        var arr = createTypedArray('float32', lenWiggle);

        if (lenWiggle > 1) {
          for (j = 0; j < lenWiggle; j += 1) {
            arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
            // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
          }

          return arr;
        }

        return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
      }.bind(this);

      if (thisProperty.loopIn) {
        loopIn = thisProperty.loopIn.bind(thisProperty);
        loop_in = loopIn;
      }

      if (thisProperty.loopOut) {
        loopOut = thisProperty.loopOut.bind(thisProperty);
        loop_out = loopOut;
      }

      if (thisProperty.smooth) {
        smooth = thisProperty.smooth.bind(thisProperty);
      }

      function loopInDuration(type, duration) {
        return loopIn(type, duration, true);
      }

      function loopOutDuration(type, duration) {
        return loopOut(type, duration, true);
      }

      if (this.getValueAtTime) {
        valueAtTime = this.getValueAtTime.bind(this);
      }

      if (this.getVelocityAtTime) {
        velocityAtTime = this.getVelocityAtTime.bind(this);
      }

      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

      function lookAt(elem1, elem2) {
        var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
        var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
        var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
        return [yaw, pitch, 0];
      }

      function easeOut(t, tMin, tMax, val1, val2) {
        return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
      }

      function easeIn(t, tMin, tMax, val1, val2) {
        return applyEase(easeInBez, t, tMin, tMax, val1, val2);
      }

      function ease(t, tMin, tMax, val1, val2) {
        return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
      }

      function applyEase(fn, t, tMin, tMax, val1, val2) {
        if (val1 === undefined) {
          val1 = tMin;
          val2 = tMax;
        } else {
          t = (t - tMin) / (tMax - tMin);
        }

        if (t > 1) {
          t = 1;
        } else if (t < 0) {
          t = 0;
        }

        var mult = fn(t);

        if ($bm_isInstanceOfArray(val1)) {
          var iKey;
          var lenKey = val1.length;
          var arr = createTypedArray('float32', lenKey);

          for (iKey = 0; iKey < lenKey; iKey += 1) {
            arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
          }

          return arr;
        }

        return (val2 - val1) * mult + val1;
      }

      function nearestKey(time) {
        var iKey;
        var lenKey = data.k.length;
        var index;
        var keyTime;

        if (!data.k.length || typeof data.k[0] === 'number') {
          index = 0;
          keyTime = 0;
        } else {
          index = -1;
          time *= elem.comp.globalData.frameRate;

          if (time < data.k[0].t) {
            index = 1;
            keyTime = data.k[0].t;
          } else {
            for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
              if (time === data.k[iKey].t) {
                index = iKey + 1;
                keyTime = data.k[iKey].t;
                break;
              } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                  index = iKey + 2;
                  keyTime = data.k[iKey + 1].t;
                } else {
                  index = iKey + 1;
                  keyTime = data.k[iKey].t;
                }

                break;
              }
            }

            if (index === -1) {
              index = iKey + 1;
              keyTime = data.k[iKey].t;
            }
          }
        }

        var obKey = {};
        obKey.index = index;
        obKey.time = keyTime / elem.comp.globalData.frameRate;
        return obKey;
      }

      function key(ind) {
        var obKey;
        var iKey;
        var lenKey;

        if (!data.k.length || typeof data.k[0] === 'number') {
          throw new Error('The property has no keyframe at index ' + ind);
        }

        ind -= 1;
        obKey = {
          time: data.k[ind].t / elem.comp.globalData.frameRate,
          value: []
        };
        var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
        lenKey = arr.length;

        for (iKey = 0; iKey < lenKey; iKey += 1) {
          obKey[iKey] = arr[iKey];
          obKey.value[iKey] = arr[iKey];
        }

        return obKey;
      }

      function framesToTime(fr, fps) {
        if (!fps) {
          fps = elem.comp.globalData.frameRate;
        }

        return fr / fps;
      }

      function timeToFrames(t, fps) {
        if (!t && t !== 0) {
          t = time;
        }

        if (!fps) {
          fps = elem.comp.globalData.frameRate;
        }

        return t * fps;
      }

      function seedRandom(seed) {
        BMMath.seedrandom(randSeed + seed);
      }

      function sourceRectAtTime() {
        return elem.sourceRectAtTime();
      }

      function substring(init, end) {
        if (typeof value === 'string') {
          if (end === undefined) {
            return value.substring(init);
          }

          return value.substring(init, end);
        }

        return '';
      }

      function substr(init, end) {
        if (typeof value === 'string') {
          if (end === undefined) {
            return value.substr(init);
          }

          return value.substr(init, end);
        }

        return '';
      }

      function posterizeTime(framesPerSecond) {
        time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
        value = valueAtTime(time);
      }

      var time;
      var velocity;
      var value;
      var text;
      var textIndex;
      var textTotal;
      var selectorValue;
      var index = elem.data.ind;
      var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
      var parent;
      var randSeed = Math.floor(Math.random() * 1000000);
      var globalData = elem.globalData;

      function executeExpression(_value) {
        // globalData.pushExpression();
        value = _value;

        if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
          return value;
        }

        if (this.propType === 'textSelector') {
          textIndex = this.textIndex;
          textTotal = this.textTotal;
          selectorValue = this.selectorValue;
        }

        if (!thisLayer) {
          text = elem.layerInterface.text;
          thisLayer = elem.layerInterface;
          thisComp = elem.comp.compInterface;
          toWorld = thisLayer.toWorld.bind(thisLayer);
          fromWorld = thisLayer.fromWorld.bind(thisLayer);
          fromComp = thisLayer.fromComp.bind(thisLayer);
          toComp = thisLayer.toComp.bind(thisLayer);
          mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
          fromCompToSurface = fromComp;
        }

        if (!transform) {
          transform = elem.layerInterface('ADBE Transform Group');
          $bm_transform = transform;

          if (transform) {
            anchorPoint = transform.anchorPoint;
            /* position = transform.position;
                      rotation = transform.rotation;
                      scale = transform.scale; */
          }
        }

        if (elemType === 4 && !content) {
          content = thisLayer('ADBE Root Vectors Group');
        }

        if (!effect) {
          effect = thisLayer(4);
        }

        hasParent = !!(elem.hierarchy && elem.hierarchy.length);

        if (hasParent && !parent) {
          parent = elem.hierarchy[0].layerInterface;
        }

        time = this.comp.renderedFrame / this.comp.globalData.frameRate;

        if (_needsRandom) {
          seedRandom(randSeed + time);
        }

        if (needsVelocity) {
          velocity = velocityAtTime(time);
        }

        expression_function();
        this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
        // Changed this to a ternary operation because Rollup failed compiling it correctly

        scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
        return scoped_bm_rt;
      } // Bundlers will see these as dead code and unless we reference them


      executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
      return executeExpression;
    }

    ob.initiateExpression = initiateExpression;
    ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath];
    return ob;
  }();

  var expressionHelpers = function () {
    function searchExpressions(elem, data, prop) {
      if (data.x) {
        prop.k = true;
        prop.x = true;
        prop.initiateExpression = ExpressionManager.initiateExpression;
        prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
      }
    }

    function getValueAtTime(frameNum) {
      frameNum *= this.elem.globalData.frameRate;
      frameNum -= this.offsetTime;

      if (frameNum !== this._cachingAtTime.lastFrame) {
        this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
        this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
        this._cachingAtTime.lastFrame = frameNum;
      }

      return this._cachingAtTime.value;
    }

    function getSpeedAtTime(frameNum) {
      var delta = -0.01;
      var v1 = this.getValueAtTime(frameNum);
      var v2 = this.getValueAtTime(frameNum + delta);
      var speed = 0;

      if (v1.length) {
        var i;

        for (i = 0; i < v1.length; i += 1) {
          speed += Math.pow(v2[i] - v1[i], 2);
        }

        speed = Math.sqrt(speed) * 100;
      } else {
        speed = 0;
      }

      return speed;
    }

    function getVelocityAtTime(frameNum) {
      if (this.vel !== undefined) {
        return this.vel;
      }

      var delta = -0.001; // frameNum += this.elem.data.st;

      var v1 = this.getValueAtTime(frameNum);
      var v2 = this.getValueAtTime(frameNum + delta);
      var velocity;

      if (v1.length) {
        velocity = createTypedArray('float32', v1.length);
        var i;

        for (i = 0; i < v1.length; i += 1) {
          // removing frameRate
          // if needed, don't add it here
          // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
          velocity[i] = (v2[i] - v1[i]) / delta;
        }
      } else {
        velocity = (v2 - v1) / delta;
      }

      return velocity;
    }

    function getStaticValueAtTime() {
      return this.pv;
    }

    function setGroupProperty(propertyGroup) {
      this.propertyGroup = propertyGroup;
    }

    return {
      searchExpressions: searchExpressions,
      getSpeedAtTime: getSpeedAtTime,
      getVelocityAtTime: getVelocityAtTime,
      getValueAtTime: getValueAtTime,
      getStaticValueAtTime: getStaticValueAtTime,
      setGroupProperty: setGroupProperty
    };
  }();

  function addPropertyDecorator() {
    function loopOut(type, duration, durationFlag) {
      if (!this.k || !this.keyframes) {
        return this.pv;
      }

      type = type ? type.toLowerCase() : '';
      var currentFrame = this.comp.renderedFrame;
      var keyframes = this.keyframes;
      var lastKeyFrame = keyframes[keyframes.length - 1].t;

      if (currentFrame <= lastKeyFrame) {
        return this.pv;
      }

      var cycleDuration;
      var firstKeyFrame;

      if (!durationFlag) {
        if (!duration || duration > keyframes.length - 1) {
          duration = keyframes.length - 1;
        }

        firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
        cycleDuration = lastKeyFrame - firstKeyFrame;
      } else {
        if (!duration) {
          cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
        } else {
          cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
        }

        firstKeyFrame = lastKeyFrame - cycleDuration;
      }

      var i;
      var len;
      var ret;

      if (type === 'pingpong') {
        var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

        if (iterations % 2 !== 0) {
          return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
      } else if (type === 'offset') {
        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line

        var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

        if (this.pv.length) {
          ret = new Array(initV.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = (endV[i] - initV[i]) * repeats + current[i];
          }

          return ret;
        }

        return (endV - initV) * repeats + current;
      } else if (type === 'continue') {
        var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);

        if (this.pv.length) {
          ret = new Array(lastValue.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
          }

          return ret;
        }

        return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
      }

      return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
    }

    function loopIn(type, duration, durationFlag) {
      if (!this.k) {
        return this.pv;
      }

      type = type ? type.toLowerCase() : '';
      var currentFrame = this.comp.renderedFrame;
      var keyframes = this.keyframes;
      var firstKeyFrame = keyframes[0].t;

      if (currentFrame >= firstKeyFrame) {
        return this.pv;
      }

      var cycleDuration;
      var lastKeyFrame;

      if (!durationFlag) {
        if (!duration || duration > keyframes.length - 1) {
          duration = keyframes.length - 1;
        }

        lastKeyFrame = keyframes[duration].t;
        cycleDuration = lastKeyFrame - firstKeyFrame;
      } else {
        if (!duration) {
          cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
        } else {
          cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
        }

        lastKeyFrame = firstKeyFrame + cycleDuration;
      }

      var i;
      var len;
      var ret;

      if (type === 'pingpong') {
        var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);

        if (iterations % 2 === 0) {
          return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
      } else if (type === 'offset') {
        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
        var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;

        if (this.pv.length) {
          ret = new Array(initV.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
          }

          return ret;
        }

        return current - (endV - initV) * repeats;
      } else if (type === 'continue') {
        var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);

        if (this.pv.length) {
          ret = new Array(firstValue.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
          }

          return ret;
        }

        return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
      }

      return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
    }

    function smooth(width, samples) {
      if (!this.k) {
        return this.pv;
      }

      width = (width || 0.4) * 0.5;
      samples = Math.floor(samples || 5);

      if (samples <= 1) {
        return this.pv;
      }

      var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
      var initFrame = currentTime - width;
      var endFrame = currentTime + width;
      var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
      var i = 0;
      var j = 0;
      var value;

      if (this.pv.length) {
        value = createTypedArray('float32', this.pv.length);
      } else {
        value = 0;
      }

      var sampleValue;

      while (i < samples) {
        sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);

        if (this.pv.length) {
          for (j = 0; j < this.pv.length; j += 1) {
            value[j] += sampleValue[j];
          }
        } else {
          value += sampleValue;
        }

        i += 1;
      }

      if (this.pv.length) {
        for (j = 0; j < this.pv.length; j += 1) {
          value[j] /= samples;
        }
      } else {
        value /= samples;
      }

      return value;
    }

    function getTransformValueAtTime(time) {
      if (!this._transformCachingAtTime) {
        this._transformCachingAtTime = {
          v: new Matrix()
        };
      } /// /


      var matrix = this._transformCachingAtTime.v;
      matrix.cloneFromProps(this.pre.props);

      if (this.appliedTransformations < 1) {
        var anchor = this.a.getValueAtTime(time);
        matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
      }

      if (this.appliedTransformations < 2) {
        var scale = this.s.getValueAtTime(time);
        matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
      }

      if (this.sk && this.appliedTransformations < 3) {
        var skew = this.sk.getValueAtTime(time);
        var skewAxis = this.sa.getValueAtTime(time);
        matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
      }

      if (this.r && this.appliedTransformations < 4) {
        var rotation = this.r.getValueAtTime(time);
        matrix.rotate(-rotation * this.r.mult);
      } else if (!this.r && this.appliedTransformations < 4) {
        var rotationZ = this.rz.getValueAtTime(time);
        var rotationY = this.ry.getValueAtTime(time);
        var rotationX = this.rx.getValueAtTime(time);
        var orientation = this.or.getValueAtTime(time);
        matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
      }

      if (this.data.p && this.data.p.s) {
        var positionX = this.px.getValueAtTime(time);
        var positionY = this.py.getValueAtTime(time);

        if (this.data.p.z) {
          var positionZ = this.pz.getValueAtTime(time);
          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
        } else {
          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
        }
      } else {
        var position = this.p.getValueAtTime(time);
        matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
      }

      return matrix; /// /
    }

    function getTransformStaticValueAtTime() {
      return this.v.clone(new Matrix());
    }

    var getTransformProperty = TransformPropertyFactory.getTransformProperty;

    TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
      var prop = getTransformProperty(elem, data, container);

      if (prop.dynamicProperties.length) {
        prop.getValueAtTime = getTransformValueAtTime.bind(prop);
      } else {
        prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
      }

      prop.setGroupProperty = expressionHelpers.setGroupProperty;
      return prop;
    };

    var propertyGetProp = PropertyFactory.getProp;

    PropertyFactory.getProp = function (elem, data, type, mult, container) {
      var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
      // prop.loopOut = loopOut;
      // prop.loopIn = loopIn;

      if (prop.kf) {
        prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
      } else {
        prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
      }

      prop.setGroupProperty = expressionHelpers.setGroupProperty;
      prop.loopOut = loopOut;
      prop.loopIn = loopIn;
      prop.smooth = smooth;
      prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
      prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
      prop.numKeys = data.a === 1 ? data.k.length : 0;
      prop.propertyIndex = data.ix;
      var value = 0;

      if (type !== 0) {
        value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
      }

      prop._cachingAtTime = {
        lastFrame: initialDefaultFrame,
        lastIndex: 0,
        value: value
      };
      expressionHelpers.searchExpressions(elem, data, prop);

      if (prop.k) {
        container.addDynamicProperty(prop);
      }

      return prop;
    };

    function getShapeValueAtTime(frameNum) {
      // For now this caching object is created only when needed instead of creating it when the shape is initialized.
      if (!this._cachingAtTime) {
        this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        };
      }

      frameNum *= this.elem.globalData.frameRate;
      frameNum -= this.offsetTime;

      if (frameNum !== this._cachingAtTime.lastTime) {
        this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
        this._cachingAtTime.lastTime = frameNum;
        this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
      }

      return this._cachingAtTime.shapeValue;
    }

    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

    function ShapeExpressions() {}

    ShapeExpressions.prototype = {
      vertices: function vertices(prop, time) {
        if (this.k) {
          this.getValue();
        }

        var shapePath = this.v;

        if (time !== undefined) {
          shapePath = this.getValueAtTime(time, 0);
        }

        var i;
        var len = shapePath._length;
        var vertices = shapePath[prop];
        var points = shapePath.v;
        var arr = createSizedArray(len);

        for (i = 0; i < len; i += 1) {
          if (prop === 'i' || prop === 'o') {
            arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
          } else {
            arr[i] = [vertices[i][0], vertices[i][1]];
          }
        }

        return arr;
      },
      points: function points(time) {
        return this.vertices('v', time);
      },
      inTangents: function inTangents(time) {
        return this.vertices('i', time);
      },
      outTangents: function outTangents(time) {
        return this.vertices('o', time);
      },
      isClosed: function isClosed() {
        return this.v.c;
      },
      pointOnPath: function pointOnPath(perc, time) {
        var shapePath = this.v;

        if (time !== undefined) {
          shapePath = this.getValueAtTime(time, 0);
        }

        if (!this._segmentsLength) {
          this._segmentsLength = bez.getSegmentsLength(shapePath);
        }

        var segmentsLength = this._segmentsLength;
        var lengths = segmentsLength.lengths;
        var lengthPos = segmentsLength.totalLength * perc;
        var i = 0;
        var len = lengths.length;
        var accumulatedLength = 0;
        var pt;

        while (i < len) {
          if (accumulatedLength + lengths[i].addedLength > lengthPos) {
            var initIndex = i;
            var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
            var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
            pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
            break;
          } else {
            accumulatedLength += lengths[i].addedLength;
          }

          i += 1;
        }

        if (!pt) {
          pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
        }

        return pt;
      },
      vectorOnPath: function vectorOnPath(perc, time, vectorType) {
        // perc doesn't use triple equality because it can be a Number object as well as a primitive.
        if (perc == 1) {
          // eslint-disable-line eqeqeq
          perc = this.v.c;
        } else if (perc == 0) {
          // eslint-disable-line eqeqeq
          perc = 0.999;
        }

        var pt1 = this.pointOnPath(perc, time);
        var pt2 = this.pointOnPath(perc + 0.001, time);
        var xLength = pt2[0] - pt1[0];
        var yLength = pt2[1] - pt1[1];
        var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));

        if (magnitude === 0) {
          return [0, 0];
        }

        var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
        return unitVector;
      },
      tangentOnPath: function tangentOnPath(perc, time) {
        return this.vectorOnPath(perc, time, 'tangent');
      },
      normalOnPath: function normalOnPath(perc, time) {
        return this.vectorOnPath(perc, time, 'normal');
      },
      setGroupProperty: expressionHelpers.setGroupProperty,
      getValueAtTime: expressionHelpers.getStaticValueAtTime
    };
    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;

    ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
      var prop = propertyGetShapeProp(elem, data, type, arr, trims);
      prop.propertyIndex = data.ix;
      prop.lock = false;

      if (type === 3) {
        expressionHelpers.searchExpressions(elem, data.pt, prop);
      } else if (type === 4) {
        expressionHelpers.searchExpressions(elem, data.ks, prop);
      }

      if (prop.k) {
        elem.addDynamicProperty(prop);
      }

      return prop;
    };
  }

  function initialize$1() {
    addPropertyDecorator();
  }

  function addDecorator() {
    function searchExpressions() {
      if (this.data.d.x) {
        this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
        this.addEffect(this.getExpressionValue.bind(this));
        return true;
      }

      return null;
    }

    TextProperty.prototype.getExpressionValue = function (currentValue, text) {
      var newValue = this.calculateExpression(text);

      if (currentValue.t !== newValue) {
        var newData = {};
        this.copyData(newData, currentValue);
        newData.t = newValue.toString();
        newData.__complete = false;
        return newData;
      }

      return currentValue;
    };

    TextProperty.prototype.searchProperty = function () {
      var isKeyframed = this.searchKeyframes();
      var hasExpressions = this.searchExpressions();
      this.kf = isKeyframed || hasExpressions;
      return this.kf;
    };

    TextProperty.prototype.searchExpressions = searchExpressions;
  }

  function initialize() {
    addDecorator();
  }

  function SVGComposableEffect() {}

  SVGComposableEffect.prototype = {
    createMergeNode: function createMergeNode(resultId, ins) {
      var feMerge = createNS('feMerge');
      feMerge.setAttribute('result', resultId);
      var feMergeNode;
      var i;

      for (i = 0; i < ins.length; i += 1) {
        feMergeNode = createNS('feMergeNode');
        feMergeNode.setAttribute('in', ins[i]);
        feMerge.appendChild(feMergeNode);
        feMerge.appendChild(feMergeNode);
      }

      return feMerge;
    }
  };

  function SVGTintFilter(filter, filterManager, elem, id, source) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result', id + '_tint_1');
    filter.appendChild(feColorMatrix);
    feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result', id + '_tint_2');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
    var feMerge = this.createMergeNode(id, [source, id + '_tint_1', id + '_tint_2']);
    filter.appendChild(feMerge);
  }

  extendPrototype([SVGComposableEffect], SVGTintFilter);

  SVGTintFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var colorBlack = this.filterManager.effectElements[0].p.v;
      var colorWhite = this.filterManager.effectElements[1].p.v;
      var opacity = this.filterManager.effectElements[2].p.v / 100;
      this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 ' + opacity + ' 0');
    }
  };

  function SVGFillFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result', id);
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
  }

  SVGFillFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var color = this.filterManager.effectElements[2].p.v;
      var opacity = this.filterManager.effectElements[6].p.v;
      this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
    }
  };

  function SVGStrokeEffect(fil, filterManager, elem) {
    this.initialized = false;
    this.filterManager = filterManager;
    this.elem = elem;
    this.paths = [];
  }

  SVGStrokeEffect.prototype.initialize = function () {
    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
    var path;
    var groupPath;
    var i;
    var len;

    if (this.filterManager.effectElements[1].p.v === 1) {
      len = this.elem.maskManager.masksProperties.length;
      i = 0;
    } else {
      i = this.filterManager.effectElements[0].p.v - 1;
      len = i + 1;
    }

    groupPath = createNS('g');
    groupPath.setAttribute('fill', 'none');
    groupPath.setAttribute('stroke-linecap', 'round');
    groupPath.setAttribute('stroke-dashoffset', 1);

    for (i; i < len; i += 1) {
      path = createNS('path');
      groupPath.appendChild(path);
      this.paths.push({
        p: path,
        m: i
      });
    }

    if (this.filterManager.effectElements[10].p.v === 3) {
      var mask = createNS('mask');
      var id = createElementID();
      mask.setAttribute('id', id);
      mask.setAttribute('mask-type', 'alpha');
      mask.appendChild(groupPath);
      this.elem.globalData.defs.appendChild(mask);
      var g = createNS('g');
      g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');

      while (elemChildren[0]) {
        g.appendChild(elemChildren[0]);
      }

      this.elem.layerElement.appendChild(g);
      this.masker = mask;
      groupPath.setAttribute('stroke', '#fff');
    } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
      if (this.filterManager.effectElements[10].p.v === 2) {
        elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;

        while (elemChildren.length) {
          this.elem.layerElement.removeChild(elemChildren[0]);
        }
      }

      this.elem.layerElement.appendChild(groupPath);
      this.elem.layerElement.removeAttribute('mask');
      groupPath.setAttribute('stroke', '#fff');
    }

    this.initialized = true;
    this.pathMasker = groupPath;
  };

  SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
    if (!this.initialized) {
      this.initialize();
    }

    var i;
    var len = this.paths.length;
    var mask;
    var path;

    for (i = 0; i < len; i += 1) {
      if (this.paths[i].m !== -1) {
        mask = this.elem.maskManager.viewData[this.paths[i].m];
        path = this.paths[i].p;

        if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
          path.setAttribute('d', mask.lastPath);
        }

        if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
          var dasharrayValue;

          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
            var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
            var l = path.getTotalLength();
            dasharrayValue = '0 0 0 ' + l * s + ' ';
            var lineLength = l * (e - s);
            var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
            var units = Math.floor(lineLength / segment);
            var j;

            for (j = 0; j < units; j += 1) {
              dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
            }

            dasharrayValue += '0 ' + l * 10 + ' 0 0';
          } else {
            dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          }

          path.setAttribute('stroke-dasharray', dasharrayValue);
        }
      }
    }

    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
      this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
    }

    if (forceRender || this.filterManager.effectElements[6].p._mdf) {
      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
    }

    if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
      if (forceRender || this.filterManager.effectElements[3].p._mdf) {
        var color = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
      }
    }
  };

  function SVGTritoneFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    filter.appendChild(feColorMatrix);
    var feComponentTransfer = createNS('feComponentTransfer');
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    feComponentTransfer.setAttribute('result', id);
    this.matrixFilter = feComponentTransfer;
    var feFuncR = createNS('feFuncR');
    feFuncR.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncR);
    this.feFuncR = feFuncR;
    var feFuncG = createNS('feFuncG');
    feFuncG.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncG);
    this.feFuncG = feFuncG;
    var feFuncB = createNS('feFuncB');
    feFuncB.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncB);
    this.feFuncB = feFuncB;
    filter.appendChild(feComponentTransfer);
  }

  SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var color1 = this.filterManager.effectElements[0].p.v;
      var color2 = this.filterManager.effectElements[1].p.v;
      var color3 = this.filterManager.effectElements[2].p.v;
      var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
      var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
      var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
      this.feFuncR.setAttribute('tableValues', tableR);
      this.feFuncG.setAttribute('tableValues', tableG);
      this.feFuncB.setAttribute('tableValues', tableB);
    }
  };

  function SVGProLevelsFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var effectElements = this.filterManager.effectElements;
    var feComponentTransfer = createNS('feComponentTransfer'); // Red

    if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
      this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
    } // Green


    if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
      this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
    } // Blue


    if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
      this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
    } // Alpha


    if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
      this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
    } // RGB


    if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
      filter.appendChild(feComponentTransfer);
    }

    if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
      feComponentTransfer = createNS('feComponentTransfer');
      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
      feComponentTransfer.setAttribute('result', id);
      filter.appendChild(feComponentTransfer);
      this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
      this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
      this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
    }
  }

  SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
    var feFunc = createNS(type);
    feFunc.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFunc);
    return feFunc;
  };

  SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
    var cnt = 0;
    var segments = 256;
    var perc;
    var min = Math.min(inputBlack, inputWhite);
    var max = Math.max(inputBlack, inputWhite);
    var table = Array.call(null, {
      length: segments
    });
    var colorValue;
    var pos = 0;
    var outputDelta = outputWhite - outputBlack;
    var inputDelta = inputWhite - inputBlack;

    while (cnt <= 256) {
      perc = cnt / 256;

      if (perc <= min) {
        colorValue = inputDelta < 0 ? outputWhite : outputBlack;
      } else if (perc >= max) {
        colorValue = inputDelta < 0 ? outputBlack : outputWhite;
      } else {
        colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
      }

      table[pos] = colorValue;
      pos += 1;
      cnt += 256 / (segments - 1);
    }

    return table.join(' ');
  };

  SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var val;
      var effectElements = this.filterManager.effectElements;

      if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
        val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
        this.feFuncRComposed.setAttribute('tableValues', val);
        this.feFuncGComposed.setAttribute('tableValues', val);
        this.feFuncBComposed.setAttribute('tableValues', val);
      }

      if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
        val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
        this.feFuncR.setAttribute('tableValues', val);
      }

      if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
        val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
        this.feFuncG.setAttribute('tableValues', val);
      }

      if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
        val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
        this.feFuncB.setAttribute('tableValues', val);
      }

      if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
        val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
        this.feFuncA.setAttribute('tableValues', val);
      }
    }
  };

  function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
    var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
    var filterSize = filterManager.data.fs || globalFilterSize;
    filter.setAttribute('x', filterSize.x || globalFilterSize.x);
    filter.setAttribute('y', filterSize.y || globalFilterSize.y);
    filter.setAttribute('width', filterSize.width || globalFilterSize.width);
    filter.setAttribute('height', filterSize.height || globalFilterSize.height);
    this.filterManager = filterManager;
    var feGaussianBlur = createNS('feGaussianBlur');
    feGaussianBlur.setAttribute('in', 'SourceAlpha');
    feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
    feGaussianBlur.setAttribute('stdDeviation', '0');
    this.feGaussianBlur = feGaussianBlur;
    filter.appendChild(feGaussianBlur);
    var feOffset = createNS('feOffset');
    feOffset.setAttribute('dx', '25');
    feOffset.setAttribute('dy', '0');
    feOffset.setAttribute('in', id + '_drop_shadow_1');
    feOffset.setAttribute('result', id + '_drop_shadow_2');
    this.feOffset = feOffset;
    filter.appendChild(feOffset);
    var feFlood = createNS('feFlood');
    feFlood.setAttribute('flood-color', '#00ff00');
    feFlood.setAttribute('flood-opacity', '1');
    feFlood.setAttribute('result', id + '_drop_shadow_3');
    this.feFlood = feFlood;
    filter.appendChild(feFlood);
    var feComposite = createNS('feComposite');
    feComposite.setAttribute('in', id + '_drop_shadow_3');
    feComposite.setAttribute('in2', id + '_drop_shadow_2');
    feComposite.setAttribute('operator', 'in');
    feComposite.setAttribute('result', id + '_drop_shadow_4');
    filter.appendChild(feComposite);
    var feMerge = this.createMergeNode(id, [id + '_drop_shadow_4', source]);
    filter.appendChild(feMerge); //
  }

  extendPrototype([SVGComposableEffect], SVGDropShadowEffect);

  SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      if (forceRender || this.filterManager.effectElements[4].p._mdf) {
        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
      }

      if (forceRender || this.filterManager.effectElements[0].p._mdf) {
        var col = this.filterManager.effectElements[0].p.v;
        this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
      }

      if (forceRender || this.filterManager.effectElements[1].p._mdf) {
        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
      }

      if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
        var distance = this.filterManager.effectElements[3].p.v;
        var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
        var x = distance * Math.cos(angle);
        var y = distance * Math.sin(angle);
        this.feOffset.setAttribute('dx', x);
        this.feOffset.setAttribute('dy', y);
      }
    }
  };

  var _svgMatteSymbols = [];

  function SVGMatte3Effect(filterElem, filterManager, elem) {
    this.initialized = false;
    this.filterManager = filterManager;
    this.filterElem = filterElem;
    this.elem = elem;
    elem.matteElement = createNS('g');
    elem.matteElement.appendChild(elem.layerElement);
    elem.matteElement.appendChild(elem.transformedElement);
    elem.baseElement = elem.matteElement;
  }

  SVGMatte3Effect.prototype.findSymbol = function (mask) {
    var i = 0;
    var len = _svgMatteSymbols.length;

    while (i < len) {
      if (_svgMatteSymbols[i] === mask) {
        return _svgMatteSymbols[i];
      }

      i += 1;
    }

    return null;
  };

  SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
    var parentNode = mask.layerElement.parentNode;

    if (!parentNode) {
      return;
    }

    var children = parentNode.children;
    var i = 0;
    var len = children.length;

    while (i < len) {
      if (children[i] === mask.layerElement) {
        break;
      }

      i += 1;
    }

    var nextChild;

    if (i <= len - 2) {
      nextChild = children[i + 1];
    }

    var useElem = createNS('use');
    useElem.setAttribute('href', '#' + symbolId);

    if (nextChild) {
      parentNode.insertBefore(useElem, nextChild);
    } else {
      parentNode.appendChild(useElem);
    }
  };

  SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
    if (!this.findSymbol(mask)) {
      var symbolId = createElementID();
      var masker = createNS('mask');
      masker.setAttribute('id', mask.layerId);
      masker.setAttribute('mask-type', 'alpha');

      _svgMatteSymbols.push(mask);

      var defs = elem.globalData.defs;
      defs.appendChild(masker);
      var symbol = createNS('symbol');
      symbol.setAttribute('id', symbolId);
      this.replaceInParent(mask, symbolId);
      symbol.appendChild(mask.layerElement);
      defs.appendChild(symbol);
      var useElem = createNS('use');
      useElem.setAttribute('href', '#' + symbolId);
      masker.appendChild(useElem);
      mask.data.hd = false;
      mask.show();
    }

    elem.setMatte(mask.layerId);
  };

  SVGMatte3Effect.prototype.initialize = function () {
    var ind = this.filterManager.effectElements[0].p.v;
    var elements = this.elem.comp.elements;
    var i = 0;
    var len = elements.length;

    while (i < len) {
      if (elements[i] && elements[i].data.ind === ind) {
        this.setElementAsMask(this.elem, elements[i]);
      }

      i += 1;
    }

    this.initialized = true;
  };

  SVGMatte3Effect.prototype.renderFrame = function () {
    if (!this.initialized) {
      this.initialize();
    }
  };

  function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
    // Outset the filter region by 100% on all sides to accommodate blur expansion.
    filter.setAttribute('x', '-100%');
    filter.setAttribute('y', '-100%');
    filter.setAttribute('width', '300%');
    filter.setAttribute('height', '300%');
    this.filterManager = filterManager;
    var feGaussianBlur = createNS('feGaussianBlur');
    feGaussianBlur.setAttribute('result', id);
    filter.appendChild(feGaussianBlur);
    this.feGaussianBlur = feGaussianBlur;
  }

  SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      // Empirical value, matching AE's blur appearance.
      var kBlurrinessToSigma = 0.3;
      var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
      //
      //   1 -> horizontal & vertical
      //   2 -> horizontal only
      //   3 -> vertical only
      //

      var dimensions = this.filterManager.effectElements[1].p.v;
      var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq

      var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq

      this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
      //
      //   0 -> off -> duplicate
      //   1 -> on  -> wrap

      var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq

      this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
    }
  };

  registerRenderer('canvas', CanvasRenderer);
  registerRenderer('html', HybridRenderer);
  registerRenderer('svg', SVGRenderer); // Registering shape modifiers

  ShapeModifiers.registerModifier('tm', TrimModifier);
  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
  ShapeModifiers.registerModifier('rp', RepeaterModifier);
  ShapeModifiers.registerModifier('rd', RoundCornersModifier); // Registering expression plugin

  setExpressionsPlugin(Expressions);
  initialize$1();
  initialize(); // Registering svg effects

  registerEffect(20, SVGTintFilter, true);
  registerEffect(21, SVGFillFilter, true);
  registerEffect(22, SVGStrokeEffect, false);
  registerEffect(23, SVGTritoneFilter, true);
  registerEffect(24, SVGProLevelsFilter, true);
  registerEffect(25, SVGDropShadowEffect, true);
  registerEffect(28, SVGMatte3Effect, false);
  registerEffect(29, SVGGaussianBlurEffect, true);

  return lottie;

}));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var NFTMask = function (_a) {
    var children = _a.children, size = _a.size;
    var styleObj = function () {
        var width = size;
        var height = (width * Math.sqrt(3)) / 2;
        return {
            width: width + 'px',
            height: height + 'px',
        };
    };
    return (react_1.default.createElement("div", { className: "fed-nft-avatar-mask", style: __assign({}, styleObj) },
        react_1.default.createElement("div", { className: "fed-nft-avatar-mask__box2" },
            react_1.default.createElement("div", { className: "fed-nft-avatar-mask__box3" }, children))));
};
exports.default = NFTMask;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var throttle_debounce_1 = __webpack_require__(149);
var react_modal_1 = __importDefault(__webpack_require__(154));
var del_dialog_1 = __importDefault(__webpack_require__(435));
var nft_avatar_1 = __importDefault(__webpack_require__(264));
var tips_dialog_1 = __importDefault(__webpack_require__(436));
var context_1 = __webpack_require__(7);
var i18n_1 = __webpack_require__(14);
var close_svg_1 = __importDefault(__webpack_require__(158));
var check_svg_1 = __importDefault(__webpack_require__(437));
var utils_1 = __importDefault(__webpack_require__(20));
var loading_1 = __importDefault(__webpack_require__(62));
var httpReq_1 = __importDefault(__webpack_require__(23));
var hooks_1 = __webpack_require__(22);
var tokens_1 = __webpack_require__(66);
var nftImg_1 = __importDefault(__webpack_require__(263));
var modalStyle = {
    overlay: {
        background: 'rgba(0, 0, 0, .2)',
        zIndex: 999999,
    },
    content: {
        width: '600px',
        height: '600px',
        inset: '50% auto auto 50%',
        left: '50%',
        top: '50%',
        right: 'initial',
        bottom: 'initial',
        transform: 'translate3d(-50%, -50%, 0)',
        borderRadius: 0,
        padding: 0,
        border: 'none',
        background: 'none',
    },
};
var SwitchUserDialog = function (props) {
    var t = (0, i18n_1.useTranslation)().t;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale;
    var url = (0, hooks_1.useBaseURL)(hostname)[0];
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)({}), curAccount = _b[0], setCurAccount = _b[1]; // 当前登录的账号
    var _c = (0, react_1.useState)({}), mainAccount = _c[0], setMainAccount = _c[1]; // 主账号
    var _d = (0, react_1.useState)(''), searchVal = _d[0], setSearchVal = _d[1]; // 搜索输入值
    var _e = (0, react_1.useState)([]), userList = _e[0], setUserList = _e[1]; // 子账号列表
    // 只有现货和合约交易依据当前主题切换
    var _f = (0, react_1.useState)(false), isModelDark = _f[0], setIsModelDark = _f[1];
    var _g = (0, react_1.useState)(false), switchLoading = _g[0], setSwitchLoading = _g[1]; // 切换账号loading
    var size = 40; // 主账号头像大小
    var smallSize = 38; // 其他母账号头像大小
    var tabList = [
        {
            label: t('子账号'),
            value: 'sub',
        },
        {
            label: t('其他账号'),
            value: 'other',
        },
    ];
    var _h = (0, react_1.useState)({}), curTabObj = _h[0], setCurTabObj = _h[1];
    var _j = (0, react_1.useState)([]), otherList = _j[0], setOtherList = _j[1]; // 其他账号列表
    var _k = (0, react_1.useState)(false), isManage = _k[0], setIsManage = _k[1]; // 是否管理操作
    var _l = (0, react_1.useState)(false), delOpen = _l[0], setDelOpen = _l[1];
    var _m = (0, react_1.useState)(false), tipsOpen = _m[0], setTipsOpen = _m[1];
    var _o = (0, react_1.useState)(''), delId = _o[0], setDelId = _o[1];
    // 实例化服务
    var httpService = new httpReq_1.default(url, locale);
    var searchChange = (0, throttle_debounce_1.debounce)(350, function (val) {
        if (val) {
            // 检索子账号
            searchSubAccount(val);
        }
        else {
            // 获取账号切换的账号列表
            getAccountList();
        }
    }, false);
    (0, react_1.useEffect)(function () {
        // 当前tab是子账号
        if (Object.keys(curTabObj).length) {
            getAccountList();
        }
    }, [curTabObj]);
    (0, react_1.useEffect)(function () {
        // 初始化tab
        initTab();
        var theme = 'light';
        // 只有现货和合约交易依据当前主题切换
        var isExchange = location.pathname.includes('/trade') || location.pathname.includes('/futures');
        if (isExchange) {
            theme = utils_1.default.getCookie('theme') || 'dark';
        }
        setIsModelDark(theme === 'dark');
    }, []);
    // 初始化tab
    var initTab = function () {
        // 设置当前激活的tab
        var cTab = utils_1.default.getCookie('htx_switch_user_tab') || 'sub';
        // 当前处于激活状态的tab
        var cTabObj = tabList.find(function (item) { return item.value === cTab; });
        setCurTabObj(cTabObj);
    };
    var showToast = function (message, type) {
        if (type === void 0) { type = 'error'; }
        var toast = __webpack_require__(101);
        if (type === 'success') {
            toast.default.success(message);
        }
        else {
            toast.default.error(message);
        }
    };
    var getOtherUser = function () {
        var otherUser = localStorage.getItem('htx_other_user_list') || '';
        var list = [];
        if (otherUser) {
            list = JSON.parse(otherUser);
        }
        return list;
    };
    // 设置母账号数据
    var setOtherArr = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var uList, curUser, imgUrl, uList_1, uList_1_1, u, _a, e_1_1, oList, mainUser, userObj, _b;
        var e_1, _c;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    uList = getOtherUser();
                    curUser = ((_d = props === null || props === void 0 ? void 0 : props.userInfo) === null || _d === void 0 ? void 0 : _d.ucResp) || {};
                    if (!(uList.length > 0)) return [3 /*break*/, 14];
                    imgUrl = (curUser === null || curUser === void 0 ? void 0 : curUser.imgUrl) || '';
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 7, 8, 13]);
                    uList_1 = __asyncValues(uList);
                    _e.label = 2;
                case 2: return [4 /*yield*/, uList_1.next()];
                case 3:
                    if (!(uList_1_1 = _e.sent(), !uList_1_1.done)) return [3 /*break*/, 6];
                    u = uList_1_1.value;
                    if (!(u.uid === (curUser === null || curUser === void 0 ? void 0 : curUser.uid))) return [3 /*break*/, 5];
                    u.image = imgUrl;
                    u.isNFT = (curUser === null || curUser === void 0 ? void 0 : curUser.isNFT) || false; // 是否nft头像
                    u.displayName = (curUser === null || curUser === void 0 ? void 0 : curUser.name) || '';
                    u.frameUrl = (curUser === null || curUser === void 0 ? void 0 : curUser.frameUrl) || ''; // nft头像动画
                    u.communityStatus = (curUser === null || curUser === void 0 ? void 0 : curUser.communityStatus) || ''; // 社区表示
                    if (!(u.isNFT && imgUrl)) return [3 /*break*/, 5];
                    _a = u;
                    return [4 /*yield*/, (0, nftImg_1.default)(imgUrl, size * 3)];
                case 4:
                    _a.nftImgUrl = _e.sent();
                    _e.label = 5;
                case 5: return [3 /*break*/, 2];
                case 6: return [3 /*break*/, 13];
                case 7:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 13];
                case 8:
                    _e.trys.push([8, , 11, 12]);
                    if (!(uList_1_1 && !uList_1_1.done && (_c = uList_1.return))) return [3 /*break*/, 10];
                    return [4 /*yield*/, _c.call(uList_1)];
                case 9:
                    _e.sent();
                    _e.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    if (e_1) throw e_1.error;
                    return [7 /*endfinally*/];
                case 12: return [7 /*endfinally*/];
                case 13:
                    localStorage.setItem('htx_other_user_list', JSON.stringify(uList));
                    oList = uList.filter(function (u) { return u.uid !== data.uid; });
                    setOtherList(oList);
                    _e.label = 14;
                case 14:
                    mainUser = {};
                    // 当前tab是主账号或当前账号与主账号一致
                    if (curTabObj.value === 'other' || data.uid === curUser.uid) {
                        mainUser = curUser;
                    }
                    else {
                        // 子账号时，特殊处理子账号对应的主账号数据
                        mainUser = uList.find(function (u) { return u.uid === data.uid; }) || {};
                    }
                    if (!(Object.keys(mainUser).length > 0)) return [3 /*break*/, 17];
                    userObj = {};
                    userObj.account_name = (mainUser === null || mainUser === void 0 ? void 0 : mainUser.name) || mainUser.displayName;
                    userObj.isNFT = (mainUser === null || mainUser === void 0 ? void 0 : mainUser.isNFT) || false; // 是否nft头像
                    userObj.frameUrl = (mainUser === null || mainUser === void 0 ? void 0 : mainUser.frameUrl) || ''; // nft头像动画
                    userObj.communityStatus = (mainUser === null || mainUser === void 0 ? void 0 : mainUser.communityStatus) || ''; // 社区表示
                    if (!(userObj.isNFT && ((mainUser === null || mainUser === void 0 ? void 0 : mainUser.imgUrl) || (mainUser === null || mainUser === void 0 ? void 0 : mainUser.image)))) return [3 /*break*/, 16];
                    _b = userObj;
                    return [4 /*yield*/, (0, nftImg_1.default)(mainUser.imgUrl || mainUser.image, size * 3)];
                case 15:
                    _b.nftImgUrl = _e.sent();
                    _e.label = 16;
                case 16:
                    data = Object.assign({}, data, userObj);
                    _e.label = 17;
                case 17:
                    setMainAccount(data);
                    return [2 /*return*/];
            }
        });
    }); };
    // 获取账号切换的账号列表
    var getAccountList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var oList_1, uIdList_1, _a, success, data, message, code, _b, accounts, req_accounts, diffList, list, cAccount, mAccount, subList, origin_1, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    setLoading(true);
                    setUserList([]);
                    oList_1 = getOtherUser();
                    uIdList_1 = oList_1.map(function (u) { return u.uid; });
                    return [4 /*yield*/, httpService.getSwitchAccountList({ uids: uIdList_1 })];
                case 1:
                    _a = _c.sent(), success = _a.success, data = _a.data, message = _a.message, code = _a.code;
                    if (success) {
                        _b = data || {}, accounts = _b.accounts, req_accounts = _b.req_accounts;
                        diffList = req_accounts.filter(function (x) { return !uIdList_1.includes(x.uid); });
                        if (diffList.length > 0) {
                            diffList.forEach(function (item) {
                                oList_1.unshift({
                                    displayName: item.account_name,
                                    email: '',
                                    phone: '',
                                    uid: item.uid,
                                    image: item.image,
                                });
                            });
                            localStorage.setItem('htx_other_user_list', JSON.stringify(oList_1));
                        }
                        list = accounts || [];
                        cAccount = list.find(function (item) { return item.current_login; }) || {};
                        setCurAccount(cAccount);
                        mAccount = list.find(function (item) { return item.use_type === 1; }) || {};
                        // 设置母账号数据
                        setOtherArr(mAccount);
                        subList = list.filter(function (item) { return item.use_type === 2; });
                        setUserList(subList);
                    }
                    else {
                        showToast(message);
                        if (code === 512) {
                            origin_1 = location.origin.replace('futures', 'www');
                            location.href = "".concat(origin_1, "/").concat(locale, "/login/?backUrl=").concat(location.href);
                            return [2 /*return*/];
                        }
                        else if (code === 11606) {
                            // 如果是无权限，则直接关闭
                            props === null || props === void 0 ? void 0 : props.setIsOpen(false);
                        }
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    setLoading(false);
                    console.log('error :>> ', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // 检索子账号
    var searchSubAccount = function (val) { return __awaiter(void 0, void 0, void 0, function () {
        var uIdList, _a, success, data, message, accounts, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    uIdList = getOtherUser().map(function (u) { return u.uid; });
                    return [4 /*yield*/, httpService.getSwitchAccountList({
                            account_name: val,
                            uids: uIdList,
                        })];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data, message = _a.message;
                    if (success) {
                        accounts = (data || {}).accounts;
                        setUserList(accounts || []);
                    }
                    else {
                        setUserList([]);
                        showToast(message);
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    setLoading(false);
                    console.log('error :>> ', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var closeClick = function (event) {
        if (window.sensors) {
            window.sensors.track('webclick_nav', {
                button_name: '切换账号关闭',
            });
        }
        event.stopPropagation();
        props === null || props === void 0 ? void 0 : props.setIsOpen(false);
    };
    // 账号切换
    var selectUserClick = function (event, item) { return __awaiter(void 0, void 0, void 0, function () {
        var buttonName, _a, success, data, message, ucToken, origin_2, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.stopPropagation();
                    setSwitchLoading(true);
                    if (window.sensors) {
                        buttonName = '其他账号';
                        // 子账号
                        if ((item === null || item === void 0 ? void 0 : item.use_type) === 1) {
                            buttonName = '主账号';
                        }
                        else if ((item === null || item === void 0 ? void 0 : item.use_type) === 2) {
                            buttonName = '子账号';
                        }
                        window.sensors.track('webclick_nav', {
                            button_name: buttonName,
                        });
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.switchAccount({ 'switch_uid': item.uid })];
                case 2:
                    _a = _b.sent(), success = _a.success, data = _a.data, message = _a.message;
                    if (success) {
                        ucToken = (data === null || data === void 0 ? void 0 : data.uc_token) || '';
                        // 设置切换的token
                        setCookies(ucToken);
                        setTimeout(function () {
                            setSwitchLoading(false);
                            // 关闭弹窗
                            props === null || props === void 0 ? void 0 : props.setIsOpen(false);
                            // 刷新页面
                            location.reload();
                        }, 500);
                    }
                    else {
                        setSwitchLoading(false);
                        showToast(message);
                        // 如果是其他账号切换
                        if (curTabObj.value === 'other') {
                            origin_2 = location.origin.replace('futures', 'www');
                            location.href = "".concat(origin_2, "/").concat(locale, "/login/?switch=main&uid=").concat(item.uid, "&backUrl=").concat(location.href);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    setSwitchLoading(false);
                    console.log('error :>> ', error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // 设置切换的token
    var setCookies = function (token) {
        // 移除cookie中的token
        utils_1.default.removeCookies(tokens_1.removeTokenList);
        utils_1.default.setCookie('HB-UC-TOKEN', token, {
            domain: utils_1.default.getHost(1),
            path: '/',
        });
        utils_1.default.removeStorageList(tokens_1.reStorageList);
    };
    // 创建子账号
    var addAccountClick = function () {
        var origin = location.origin.replace('futures', 'www');
        location.href = "".concat(origin, "/").concat(locale, "/subaccount/add");
    };
    // 管理子账号
    var manageClick = function () {
        var origin = location.origin.replace('futures', 'www');
        if (curTabObj.value === 'sub' && !isManage) {
            location.href = "".concat(origin, "/").concat(locale, "/subaccount/manage");
            return;
        }
        setIsManage(function (a) { return !a; });
    };
    // 添加其他账号
    var addOtherClick = function () {
        if (otherList.length >= 10) {
            setTipsOpen(true);
            return;
        }
        var origin = location.origin.replace('futures', 'www');
        location.href = "".concat(origin, "/").concat(locale, "/login/?switch=main&backUrl=").concat(location.href);
    };
    // tab 切换
    var tabClick = function (event, item) {
        event.stopPropagation();
        utils_1.default.setCookie('htx_switch_user_tab', item.value, {
            domain: utils_1.default.getHost(1),
            path: '/',
        });
        setIsManage(false);
        var cTabObj = tabList.find(function (tab) { return tab.value === item.value; });
        setCurTabObj(cTabObj);
        // 子账号
        if (item.value === 'sub') {
            // 清空输入框的值
            setSearchVal('');
        }
    };
    // 其他账号操作事件
    var otherUserClick = function (event, item) {
        if (isManage) {
            return;
        }
        event.stopPropagation();
        selectUserClick(event, item);
    };
    // 清除
    var clearClick = function (event, item) {
        event.stopPropagation();
        setDelId(item.uid);
        setDelOpen(true);
    };
    var onDelOpen = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, message, oList, newList, uList, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!data) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpService.clearAccount({ uid: delId })];
                case 2:
                    _a = _b.sent(), success = _a.success, message = _a.message;
                    if (success) {
                        oList = getOtherUser();
                        if (oList.length > 0) {
                            // 去掉选中的数据
                            oList = oList.filter(function (u) { return u.uid !== delId; });
                            newList = JSON.parse(JSON.stringify(oList));
                            uList = newList.filter(function (u) { return u.uid !== (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.uid); });
                            setOtherList(uList);
                            localStorage.setItem('htx_other_user_list', JSON.stringify(oList));
                            setDelId('');
                        }
                    }
                    else {
                        showToast(message);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4:
                    setDelOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var userTabRender = function () {
        // 母账号
        if ((curAccount === null || curAccount === void 0 ? void 0 : curAccount.use_type) === 1) {
            var strManage = t('管理');
            if (curTabObj.value === 'other') {
                if (otherList.length > 0) {
                    strManage = isManage ? t('完成') : t('管理');
                }
                else {
                    strManage = '';
                }
            }
            return (react_1.default.createElement("div", { className: "sub-user_header" },
                react_1.default.createElement("div", { className: "sub-user_tab user-tab_box" }, tabList.map(function (item, index) {
                    return (react_1.default.createElement("div", { key: index, className: "sub-user_title ".concat(curTabObj.value === item.value ? 'tab-active' : ''), onClick: function (event) {
                            tabClick(event, item);
                        } }, item.label));
                })),
                react_1.default.createElement("div", { className: "sub-user_operate", onClick: manageClick }, strManage)));
        }
        return (react_1.default.createElement("div", { className: "sub-user_header" },
            react_1.default.createElement("div", { className: "sub-user_tab" },
                react_1.default.createElement("div", { className: "sub-user_title" }, t('子账号')))));
    };
    var contentRender = function () {
        // 子账号
        if (curTabObj.value === 'sub') {
            return subUserRender();
        }
        return otherRender();
    };
    var subUserRender = function () {
        return (react_1.default.createElement("div", { className: "user-list-container" },
            (userList.length >= 5 || searchVal != '') && (react_1.default.createElement("div", { className: "sub-search" },
                react_1.default.createElement("div", { className: "search__input" },
                    react_1.default.createElement("input", { type: "text", autoCapitalize: "off", autoComplete: "off", autoCorrect: "off", placeholder: t('搜索子账号'), value: searchVal, onChange: function (e) {
                            var staVal = e.target.value;
                            setSearchVal(staVal);
                            searchChange(staVal);
                        } })))),
            loading && searchVal != '' ? (react_1.default.createElement("div", { className: "loading-wrapper" },
                react_1.default.createElement(loading_1.default, null))) : (react_1.default.createElement(react_1.default.Fragment, null, userList.length > 0 ? (react_1.default.createElement("div", { className: "sub-user_list" }, userList.map(function (item, index) {
                return (react_1.default.createElement("div", { key: index, className: "sub-user_item ".concat(item.current_login ? 'u-disabled' : ''), onClick: function (event) {
                        selectUserClick(event, item);
                    } },
                    react_1.default.createElement("div", { className: "u-img" },
                        react_1.default.createElement("img", { src: (item === null || item === void 0 ? void 0 : item.image) || utils_1.default.getUserIcon(), alt: "user" })),
                    react_1.default.createElement("div", { className: "u_content" },
                        react_1.default.createElement("div", { className: "u_info" },
                            react_1.default.createElement("div", { className: "u_name" }, item.account_name),
                            react_1.default.createElement("div", { className: "u_uid" },
                                "UID:",
                                react_1.default.createElement("span", null, item.uid))),
                        item.current_login && (react_1.default.createElement("div", { className: "u-check-img" },
                            react_1.default.createElement("img", { src: check_svg_1.default, alt: "check" }))))));
            }))) : (react_1.default.createElement("div", { className: "no-data-container" },
                react_1.default.createElement("div", { className: "no-data" },
                    react_1.default.createElement("div", { className: "no-data_img" }),
                    react_1.default.createElement("div", { className: "no-data_txt" }, t('暂无数据'))),
                searchVal === '' && (react_1.default.createElement("div", { className: "no-data_button", onClick: addAccountClick },
                    react_1.default.createElement("span", null, t('创建子账号'))))))))));
    };
    // 其他账号
    var otherRender = function () {
        if (otherList.length > 0) {
            return (react_1.default.createElement("div", { className: "user-list-container u-user-list" },
                react_1.default.createElement("div", { className: "sub-user_list" }, otherList.map(function (item, index) {
                    return (react_1.default.createElement("div", { key: index, className: "sub-user_item ".concat(isManage ? 'u-manage' : ''), onClick: function (event) {
                            otherUserClick(event, item);
                        } },
                        renderAvatar(item),
                        react_1.default.createElement("div", { className: "u_content" },
                            react_1.default.createElement("div", { className: "u_info" },
                                react_1.default.createElement("div", { className: "u_name" }, item.displayName),
                                react_1.default.createElement("div", { className: "u_uid" },
                                    "UID:",
                                    react_1.default.createElement("span", null, item.uid))),
                            isManage && (react_1.default.createElement("div", { className: "u-clear", onClick: function (event) {
                                    clearClick(event, item);
                                } }, t('清除'))))));
                })),
                react_1.default.createElement("div", { className: "add-button-container" },
                    react_1.default.createElement("div", { className: "add-button", onClick: addOtherClick },
                        react_1.default.createElement("span", null, t('添加其他账号'))))));
        }
        return (react_1.default.createElement("div", { className: "user-list-container" },
            react_1.default.createElement("div", { className: "no-data-container" },
                react_1.default.createElement("div", { className: "no-data" },
                    react_1.default.createElement("div", { className: "no-data_img" }),
                    react_1.default.createElement("div", { className: "no-data_txt" }, t('暂无数据'))),
                react_1.default.createElement("div", { className: "no-data_button", onClick: addOtherClick },
                    react_1.default.createElement("span", null, t('添加其他账号'))))));
    };
    // 主账号头像
    var renderMainAvatar = function () {
        if (Object.keys(mainAccount).length === 0) {
            return null;
        }
        if (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.isNFT) {
            return (react_1.default.createElement(nft_avatar_1.default, { size: size, frame: mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.frameUrl },
                react_1.default.createElement("img", { style: { width: "".concat(size, "px"), height: "".concat(size, "px") }, src: mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.nftImgUrl })));
        }
        return (react_1.default.createElement("div", { className: "user_img" },
            react_1.default.createElement("img", { src: (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.image) || utils_1.default.getUserIcon(), alt: "user" })));
    };
    // 头像标识
    var renderAvatarFlag = function () {
        if (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.communityStatus) {
            return (react_1.default.createElement("i", { className: "user_avatar_big ".concat(mainAccount.communityStatus === 'LIVE' ? 'user_avatar__live' : 'user_avatar__v') }));
        }
        return '';
    };
    // 其他母账号头像
    var renderAvatar = function (item) {
        if (item === null || item === void 0 ? void 0 : item.isNFT) {
            return (react_1.default.createElement(nft_avatar_1.default, { size: smallSize, frame: item === null || item === void 0 ? void 0 : item.frameUrl },
                react_1.default.createElement("img", { style: { width: "".concat(smallSize, "px"), height: "".concat(smallSize, "px") }, src: item === null || item === void 0 ? void 0 : item.nftImgUrl })));
        }
        return (react_1.default.createElement("div", { className: "u-img" },
            react_1.default.createElement("img", { src: (item === null || item === void 0 ? void 0 : item.image) || utils_1.default.getUserIcon(), alt: "user" })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_modal_1.default, __assign({ ariaHideApp: false, isOpen: props === null || props === void 0 ? void 0 : props.isOpen, style: modalStyle }, props),
            react_1.default.createElement("div", { className: "model-switch-user model-switch-container ".concat(isModelDark ? 'model-dark' : 'model-light') },
                react_1.default.createElement("div", { className: 'switch-user-container' },
                    switchLoading && (react_1.default.createElement("div", { className: "switch-loading" },
                        react_1.default.createElement(loading_1.default, null))),
                    react_1.default.createElement("div", { className: "switch-user-header" },
                        react_1.default.createElement("div", { className: "switch-user_title" }, t('切换账号')),
                        react_1.default.createElement("div", { className: "switch-user_close", onClick: closeClick },
                            react_1.default.createElement("img", { src: close_svg_1.default, alt: "close" }))),
                    react_1.default.createElement("div", { className: "switch-user-body" },
                        react_1.default.createElement("div", { className: "main-user" },
                            react_1.default.createElement("div", { className: "main-user_header" },
                                react_1.default.createElement("div", { className: "main-user_title" }, t('主账号'))),
                            react_1.default.createElement("div", { className: "main-user_content ".concat((mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.current_login) ? 'u-disabled' : ''), onClick: function (event) {
                                    selectUserClick(event, mainAccount);
                                } },
                                react_1.default.createElement("div", { className: "user_avatar" },
                                    renderMainAvatar(),
                                    renderAvatarFlag()),
                                react_1.default.createElement("div", { className: "user-info-container" },
                                    react_1.default.createElement("div", { className: "user_info" },
                                        react_1.default.createElement("div", { className: "user_name" }, (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.account_name) || ''),
                                        react_1.default.createElement("div", { className: "user_uid" },
                                            "UID:",
                                            react_1.default.createElement("span", null, (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.uid) || ''))),
                                    (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.current_login) && (react_1.default.createElement("div", { className: "u-check-img" },
                                        react_1.default.createElement("img", { src: check_svg_1.default, alt: "check" })))))),
                        react_1.default.createElement("div", { className: "sub-user" },
                            userTabRender(),
                            react_1.default.createElement("div", { className: "sub-user_content" }, contentRender())))))),
        delOpen && (react_1.default.createElement(del_dialog_1.default, { delOpen: delOpen, onDelOpen: function (data) {
                onDelOpen(data);
            } })),
        tipsOpen && react_1.default.createElement(tips_dialog_1.default, { tipsOpen: tipsOpen, setTipsOpen: setTipsOpen })));
};
exports.default = SwitchUserDialog;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(55);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(428);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(266);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(157);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(36);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports.default = Modal;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(429);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(430);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(266);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(433);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(157);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(267);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(434);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(265);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(265);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(267);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_modal_1 = __importDefault(__webpack_require__(154));
var i18n_1 = __webpack_require__(14);
var close_svg_1 = __importDefault(__webpack_require__(158));
var modalStyle = {
    overlay: {
        background: 'rgba(0, 0, 0, .2)',
        zIndex: 999999,
    },
    content: {
        width: '480px',
        inset: '50% auto auto 50%',
        left: '50%',
        top: '50%',
        right: 'initial',
        bottom: 'initial',
        transform: 'translate3d(-50%, -50%, 0)',
        borderRadius: 0,
        padding: 0,
        border: 'none',
        background: 'none',
    },
};
var DelDialog = function (props) {
    var t = (0, i18n_1.useTranslation)().t;
    var closeClick = function (event) {
        event.stopPropagation();
        props === null || props === void 0 ? void 0 : props.onDelOpen(false);
    };
    // 取消
    var cancelClick = function (event) {
        event.stopPropagation();
        props === null || props === void 0 ? void 0 : props.onDelOpen(false);
    };
    // 确认
    var confirmClick = function (event) {
        event.stopPropagation();
        props === null || props === void 0 ? void 0 : props.onDelOpen(true);
    };
    return (react_1.default.createElement(react_modal_1.default, __assign({ ariaHideApp: false, isOpen: props === null || props === void 0 ? void 0 : props.delOpen, style: modalStyle }, props),
        react_1.default.createElement("div", { className: "del-user-dialog" },
            react_1.default.createElement("div", { className: 'd-user-dialog-container' },
                react_1.default.createElement("div", { className: "del-user-header" },
                    react_1.default.createElement("div", { className: "del-user_title" }, t('提醒')),
                    react_1.default.createElement("div", { className: "del-user_close", onClick: closeClick },
                        react_1.default.createElement("img", { src: close_svg_1.default, alt: "close" }))),
                react_1.default.createElement("div", { className: "del-user-body" }, t('清除账号登录记录后，该账号再次登录时，需要重新输入密码')),
                react_1.default.createElement("div", { className: "del-user-footer" },
                    react_1.default.createElement("div", { className: "del-button-container" },
                        react_1.default.createElement("button", { className: "button cancel-button", onClick: cancelClick }, t('取消')),
                        react_1.default.createElement("button", { className: "button confirm-button", onClick: confirmClick }, t('确认'))))))));
};
exports.default = DelDialog;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_modal_1 = __importDefault(__webpack_require__(154));
var i18n_1 = __webpack_require__(14);
var close_svg_1 = __importDefault(__webpack_require__(158));
var modalStyle = {
    overlay: {
        background: 'rgba(0, 0, 0, .2)',
        zIndex: 999999,
    },
    content: {
        width: '480px',
        inset: '50% auto auto 50%',
        left: '50%',
        top: '50%',
        right: 'initial',
        bottom: 'initial',
        transform: 'translate3d(-50%, -50%, 0)',
        borderRadius: 0,
        padding: 0,
        border: 'none',
        background: 'none',
    },
};
var TipsDialog = function (props) {
    var t = (0, i18n_1.useTranslation)().t;
    var closeClick = function (event) {
        event.stopPropagation();
        props === null || props === void 0 ? void 0 : props.setTipsOpen(false);
    };
    return (react_1.default.createElement(react_modal_1.default, __assign({ ariaHideApp: false, isOpen: props === null || props === void 0 ? void 0 : props.tipsOpen, style: modalStyle }, props),
        react_1.default.createElement("div", { className: "del-user-dialog" },
            react_1.default.createElement("div", { className: 'd-user-dialog-container' },
                react_1.default.createElement("div", { className: "del-user-header" },
                    react_1.default.createElement("div", { className: "del-user_title" }, t('提醒')),
                    react_1.default.createElement("div", { className: "del-user_close", onClick: closeClick },
                        react_1.default.createElement("img", { src: close_svg_1.default, alt: "close" }))),
                react_1.default.createElement("div", { className: "del-user-body" }, t('最多添加10个其他账号，请清除后再添加')),
                react_1.default.createElement("div", { className: "del-user-footer" },
                    react_1.default.createElement("div", { className: "del-button-container" },
                        react_1.default.createElement("button", { className: "button confirm-button", onClick: closeClick }, t('我知道了'))))))));
};
exports.default = TipsDialog;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9IiMwMTczRTUiLz4KPHBhdGggZD0iTTYgMTAuNUw5IDE0TDE1IDciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var url_1 = __webpack_require__(18);
var sensors_1 = __webpack_require__(27);
var Fee = function (_a) {
    var userInfo = _a.userInfo;
    var t = (0, i18n_1.useTranslation)().t;
    //@ts-ignore
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var hostname = globalState.hostname, locale = globalState.locale;
    var level = (0, react_1.useMemo)(function () { var _a; return ((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.prime) === null || _a === void 0 ? void 0 : _a.level) - 1; }, [userInfo]);
    var ucResp = userInfo.ucResp, _b = userInfo.medalResp, medalResp = _b === void 0 ? [] : _b;
    var showLevel = (0, react_1.useMemo)(function () {
        if (ucResp && ucResp.kycLevel) {
            // 如果是机构账户且kyc level是C0，则返回L0
            if (ucResp.kycType === 'ORGANIZATION' && ucResp.kycLevel.toLowerCase() === 'c-2') {
                return 'L0';
            }
            var level_1 = ucResp.kycLevel.replace(/[a-zA-Z]+/, '') * 1 + 1;
            return "L".concat(level_1);
        }
        return '';
    }, [ucResp]);
    // CN地区拥有DMC数字身份的用户隐藏KYC的入口
    var isShowKyc = function () {
        return (react_1.default.createElement("div", { className: "hbg-user-info__prime-kyc ".concat(!ucResp.kycLevel ? 'nokyc' : ''), onClick: toKyc }, !ucResp.kycLevel ? (react_1.default.createElement("p", { className: "triangle" }, t('未认证'))) : (react_1.default.createElement("div", { className: "hbg-user-info__prime-kyc-level" },
            ucResp.kycType === 'PERSON' && ucResp.countryId ? (react_1.default.createElement("p", null,
                react_1.default.createElement("img", { src: "https://huobicfg.s3.amazonaws.com/country_icon/".concat(ucResp.countryId, ".png") }))) : (''),
            react_1.default.createElement("span", null,
                ucResp.kycType === 'ORGANIZATION' ? t('机构') : 'KYC',
                " ",
                showLevel)))));
    };
    var toPrime = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'vip_card',
            type: 'click',
        });
        var url = (0, url_1.getUrl)({
            path: '/member/my',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        location.href = url;
    };
    var toDmc = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'digital_dmc',
            type: 'click',
        });
        var url = (0, url_1.getUrl)({
            path: '/user_center/uc_auth/digital',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        location.href = url;
    };
    var toKyc = function () {
        (0, sensors_1.trackHeader)({
            button_name: 'center_kyc',
            type: 'click',
        });
        var url = (0, url_1.getUrl)({
            path: '/user_center/uc_auth/',
            platform: 'global',
            locale: locale,
            hostname: hostname,
        });
        location.href = url;
    };
    var renderKyc = function () {
        //  C0体验 C1正式 C2高级
        switch (ucResp && ucResp.kycLevel) {
            case 'C0':
                return react_1.default.createElement("span", null, "DMC L1");
            case 'C1':
                return react_1.default.createElement("span", null, "DMC L2");
            case 'C2':
                return react_1.default.createElement("span", null, "DMC L3");
            default:
                return react_1.default.createElement("span", null, "DMC");
        }
    };
    return (react_1.default.createElement("div", { className: "hbg-user-info__prime" },
        react_1.default.createElement("div", { className: "hbg-user-info__prime--level", "data-level": level || 0, onClick: toPrime },
            react_1.default.createElement("i", null),
            react_1.default.createElement("span", null,
                "Prime ",
                level)),
        react_1.default.createElement("div", { className: "hbg-user-info__prime--dmc", onClick: toDmc },
            react_1.default.createElement("i", null),
            renderKyc()),
        ucResp && ucResp.showOldEntrance ? isShowKyc() : null));
};
exports.default = Fee;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importStar(__webpack_require__(0));
var links_1 = __webpack_require__(95);
var i18n_1 = __webpack_require__(38);
var url_1 = __webpack_require__(18);
var i18n_2 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var cell_item_1 = __importDefault(__webpack_require__(100));
var login_1 = __importDefault(__webpack_require__(440));
var cell_group_1 = __importDefault(__webpack_require__(102));
var collapse_1 = __importDefault(__webpack_require__(159));
var NAV_MENU_PROXY = links_1.NAV_MENU.map(function (item) {
    var children = [];
    if (item.groups) {
        item.groups.forEach(function (group) {
            children = children.concat(group.children);
        });
    }
    else if (item.children) {
        children = children.concat(item.children);
    }
    return __assign(__assign({}, item), { children: children });
}).filter(function (item) { var _a; return ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) > 0; });
exports.default = (function (_a) {
    var _b = _a.handleLangs, handleLangs = _b === void 0 ? function () { } : _b, _c = _a.handleCurrencys, handleCurrencys = _c === void 0 ? function () { } : _c, _d = _a.handleOpenThreeNav, handleOpenThreeNav = _d === void 0 ? function () { } : _d, _e = _a.menus, menus = _e === void 0 ? [] : _e;
    var t = (0, i18n_2.useTranslation)().t;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var isLogin = globalState.isLogin, locale = globalState.locale, hostname = globalState.hostname, localRate = globalState.localRate;
    var _f = (0, react_1.useState)(''), downloadUrl = _f[0], SetDownloadUrl = _f[1];
    (0, react_1.useEffect)(function () {
        var url = (0, url_1.getUrl)({
            platform: 'm',
            path: '/download/',
            locale: locale,
            hostname: hostname,
        });
        SetDownloadUrl(url);
    }, [locale, hostname]);
    return (react_1.default.createElement("div", { className: "hbg-panel-function" },
        isLogin ? '' : react_1.default.createElement(login_1.default, { className: "login-panel" }),
        react_1.default.createElement("div", { className: "fed-collapes" }, menus.map(function (menu) {
            return menu.children && menu.children.length ? (react_1.default.createElement(collapse_1.default, { title: menu.title, key: menu.title },
                react_1.default.createElement(cell_group_1.default, null, menu.children.map(function (item, index) {
                    return (react_1.default.createElement(cell_item_1.default, { key: item.title + index, title: item.title, href: item.children && item.children.length !== 0 ? undefined : item.jumpUrl, handleClick: function () { return handleOpenThreeNav(item.children); } }));
                })))) : (react_1.default.createElement(cell_item_1.default, { key: menu.title, title: menu.title, href: menu.jumpUrl }));
        })),
        react_1.default.createElement(cell_group_1.default, null,
            react_1.default.createElement(cell_item_1.default, { title: t('语言'), value: (0, i18n_1.getLocaleText)(locale), isLink: true, handleClick: handleLangs }),
            react_1.default.createElement(cell_item_1.default, { title: t('折算货币'), value: localRate === null || localRate === void 0 ? void 0 : localRate.toUpperCase(), isLink: true, handleClick: handleCurrencys }),
            react_1.default.createElement(cell_item_1.default, { className: "download-link", href: downloadUrl, title: t('下载App'), isLink: true }))));
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(0));
var i18n_1 = __webpack_require__(14);
var context_1 = __webpack_require__(7);
var url_js_1 = __webpack_require__(18);
var Login = function (_a) {
    var className = _a.className;
    var globalState = (0, react_1.useContext)(context_1.HeaderContext).globalState;
    var onlogin = globalState.onlogin, onregister = globalState.onregister, locale = globalState.locale, hostname = globalState.hostname;
    var t = (0, i18n_1.useTranslation)().t;
    var onClickReg = function (event) {
        var url = (0, url_js_1.getUrl)({
            platform: 'global',
            path: "/register/",
            locale: locale,
            hostname: hostname,
        });
        onregister && onregister(event, url);
    };
    var onClickLogin = function (event) {
        var url = (0, url_js_1.getUrl)({
            platform: 'global',
            path: "/login/",
            locale: locale,
            hostname: hostname,
        });
        onlogin && onlogin(event, url);
    };
    return (react_1.default.createElement("div", { className: "hbg-login ".concat(className) },
        react_1.default.createElement("div", { className: "hbg-login__main" },
            react_1.default.createElement("div", { className: "hbg-login__title" }, t('Welcome to Huobi')),
            react_1.default.createElement("div", { className: "hbg-login__subtitle" }, t('There will be more exciting after login'))),
        react_1.default.createElement("div", { className: "hbg-login__btns" },
            react_1.default.createElement("div", { className: "fed-btn fed-btn--block", onClick: onClickReg }, t('注册')),
            react_1.default.createElement("div", { className: "fed-btn fed-btn--primary fed-btn--block", onClick: onClickLogin }, t('登录')))));
};
exports.default = Login;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(31));
exports.default = react_1.default.forwardRef(function (_a, ref) {
    var value = _a.value, onClick = _a.onClick;
    var className = (0, classnames_1.default)('hbg-more-btn', {
        'hbg-more-btn__close': value,
    });
    return (react_1.default.createElement("div", { ref: ref, className: className, onClick: onClick }, new Array(3).fill(1).map(function (_, index) { return (react_1.default.createElement("div", { className: "hbg-more-btn__line".concat(index), key: index })); })));
});


/***/ })
/******/ ]);